
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1007"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1007"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1SJ76", function(module, exports) {

$parcel$export(module.exports, "default", () => $74feaa38d64df852$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $cT3l2 = parcelRequire("cT3l2");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $64gHy = parcelRequire("64gHy");

var $hiwwY = parcelRequire("hiwwY");

var $5XQB9 = parcelRequire("5XQB9");
const $74feaa38d64df852$var$DIRECTIONS = {
    north: (0, $3MXpL.vec)(0, 1),
    south: (0, $3MXpL.vec)(0, -1),
    east: (0, $3MXpL.vec)(1, 0),
    west: (0, $3MXpL.vec)(-1, 0)
};
const $74feaa38d64df852$var$spriteSheet = (0, $3MXpL.SpriteSheet).fromImageSource({
    image: (0, $cT3l2.Characters).Human,
    grid: {
        rows: 1,
        columns: 4,
        spriteWidth: 32,
        spriteHeight: 48
    }
});
// static var for currently selected character
let $74feaa38d64df852$var$selectedCharacter = null;
class $74feaa38d64df852$var$Character extends (0, $3MXpL.Actor) {
    constructor(isoMap, config){
        super(config);
        this.moveSpeedMs = 100;
        this.hungerRate = 0.75;
        this.isoMap = isoMap;
        this.addComponent(new (0, $3MXpL.IsometricEntityComponent)(this.isoMap));
        this.addComponent(new (0, $8bz7c.LivingComponent)());
        this.addComponent(new (0, $8bz7c.BrainComponent)());
        this.addComponent(new (0, $8bz7c.CharacterComponent)());
        this.addComponent(new (0, $jXu4v.InventoryComponent)());
        this.addComponent(new (0, $8bz7c.VisionComponent)());
        this.addComponent(new (0, $8bz7c.NeighborsComponent)());
        this.graphics.use($74feaa38d64df852$var$spriteSheet.getSprite(0, 0));
        // add character name to the graphics
        const nameTag = new (0, $5XQB9.default)({
            width: 32,
            height: 4,
            pos: (0, $3MXpL.vec)(0, -20)
        }, this.get((0, $8bz7c.CharacterComponent)).first_name);
        this.addChild(nameTag);
    }
    update(engine, delta) {
        super.update(engine, delta);
        if (this.vel.x > 0) {
            if (this.vel.y > 0) this.graphics.use($74feaa38d64df852$var$spriteSheet.getSprite(1, 0));
            else this.graphics.use($74feaa38d64df852$var$spriteSheet.getSprite(3, 0));
        } else if (this.vel.x < 0) {
            if (this.vel.y > 0) this.graphics.use($74feaa38d64df852$var$spriteSheet.getSprite(0, 0));
            else this.graphics.use($74feaa38d64df852$var$spriteSheet.getSprite(2, 0));
        }
        // every second the character isn't idle, they lose 1 food
        if (this.get((0, $8bz7c.CharacterComponent)).state !== (0, $8bz7c.CharacterState).IDLE) this.get((0, $8bz7c.LivingComponent)).starve(delta / 2000 * this.hungerRate);
        // if the character is hungry, they move slower
        if (this.get((0, $8bz7c.LivingComponent)).isHungry()) this.moveSpeedMs = 500;
        else this.moveSpeedMs = 250;
        // every second the character is starving, they lose 5 health
        if (this.get((0, $8bz7c.LivingComponent)).isStarving()) this.get((0, $8bz7c.LivingComponent)).takeDamage(delta / 1000 * 5);
        // if the character is dead, remove them from the scene
        if (this.get((0, $8bz7c.LivingComponent)).isDead()) {
            // try to determine the cause of death
            let cause = "unknown";
            const food = this.get((0, $8bz7c.LivingComponent)).food;
            if (food <= 0) cause = "starvation";
            this.die(cause);
        }
    }
    die(cause) {
        // add their death to the scene
        this.scene.deaths.push({
            name: this.get((0, $8bz7c.CharacterComponent)).first_name,
            cause: `Died by ${cause}`
        });
        this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).DEAD;
        this.scene.status_table.deleteRow(this.id);
        // remove all items from inventory
        this.get((0, $jXu4v.InventoryComponent)).clearInventory();
        this.kill();
    }
    walkTo(target) {
        this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).WALKING;
        // if we currently have actions queued up, cancel them.
        this.actions.clearActions();
        // get start tile
        const start = this.isoMap.worldToTile(this.pos);
        const end = this.isoMap.worldToTile(target);
        // console.log(`Walking from ${start.x}, ${start.y} to ${end.x}, ${end.y}`);
        // check if there's a tile on the end position
        const endTile = this.isoMap.getTile(end.x, end.y);
        if (!endTile) {
            console.warn("No tile found at target position");
            this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).IDLE;
            return;
        }
        // if end isn't walkable, find the nearest walkable tile
        // searching out in the spiral pattern from the target tile
        const maxRadius = 25;
        let found = false;
        for(let radius = 1; radius < maxRadius; radius++){
            for(let x = -radius; x <= radius; x++){
                for(let y = -radius; y <= radius; y++)// check if we're on the edge
                if (Math.abs(x) === radius || Math.abs(y) === radius) {
                    const tile = this.isoMap.getTile(end.x + x, end.y + y);
                    if (tile && tile.solid === false) {
                        end.x += x;
                        end.y += y;
                        found = true;
                        break;
                    }
                }
                if (found) break;
            }
            if (found) break;
        }
        // find the path to the random tile
        // get main scene
        const scene = (0, $64gHy.game).currentScene;
        if (scene.navgrid === null) {
            console.warn("No navgrid found in scene");
            this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).IDLE;
            return;
        }
        const path = (0, $hiwwY.search)({
            cutCorners: true,
            diagonal: false,
            from: [
                start.x,
                start.y
            ],
            to: [
                end.x,
                end.y
            ],
            grid: scene.navgrid ?? []
        });
        if (path === null) {
            // console.warn(
            //   `No path found for ${
            //     this.get(CharacterComponent).first_name
            //   } going from ${start.x}, ${start.y} to ${end.x}, ${end.y}`
            // );
            this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).IDLE;
            return;
        }
        // move along the path
        for(let i = 0; i < path.length; i++){
            const next_tile_pos = path[i];
            this.actions.easeTo(this.isoMap.tileToWorld((0, $3MXpL.vec)(next_tile_pos[0], next_tile_pos[1])), this.moveSpeedMs);
        }
        this.actions.callMethod(()=>{
            this.get((0, $8bz7c.CharacterComponent)).state = (0, $8bz7c.CharacterState).IDLE;
        });
    }
    onInitialize() {}
}
var $74feaa38d64df852$export$2e2bcd8739ae039 = $74feaa38d64df852$var$Character;

});
parcelRegister("3MXpL", function(module, exports) {

$parcel$export(module.exports, "Actor", () => $2c23f148d58cd887$export$f73d3eb6fd876d80);
$parcel$export(module.exports, "Animation", () => $2c23f148d58cd887$export$c35d437ae5945fcd);
$parcel$export(module.exports, "Color", () => $2c23f148d58cd887$export$892596cec99bc70e);
$parcel$export(module.exports, "Component", () => $2c23f148d58cd887$export$16fa2f45be04daa8);
$parcel$export(module.exports, "DisplayMode", () => $2c23f148d58cd887$export$4b7264771109adb6);
$parcel$export(module.exports, "Engine", () => $2c23f148d58cd887$export$2c3b404bf3a77a1f);
$parcel$export(module.exports, "Font", () => $2c23f148d58cd887$export$89abf52a030e56ee);
$parcel$export(module.exports, "ImageSource", () => $2c23f148d58cd887$export$280e9a68c3ffd919);
$parcel$export(module.exports, "IsometricEntityComponent", () => $2c23f148d58cd887$export$ffed6a4cd9a88787);
$parcel$export(module.exports, "IsometricMap", () => $2c23f148d58cd887$export$539f65e788a82c62);
$parcel$export(module.exports, "Keys", () => $2c23f148d58cd887$export$4b0075e5ea5e1f26);
$parcel$export(module.exports, "Label", () => $2c23f148d58cd887$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Loader", () => $2c23f148d58cd887$export$3b0d6d7590275603);
$parcel$export(module.exports, "PointerScope", () => $2c23f148d58cd887$export$caed39dbb767d548);
$parcel$export(module.exports, "Random", () => $2c23f148d58cd887$export$a92776769f460054);
$parcel$export(module.exports, "Scene", () => $2c23f148d58cd887$export$38af1803e3442a7f);
$parcel$export(module.exports, "ScreenShader", () => $2c23f148d58cd887$export$2f3ac66e390c188b);
$parcel$export(module.exports, "Shape", () => $2c23f148d58cd887$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "Sound", () => $2c23f148d58cd887$export$85990f0f98a390bb);
$parcel$export(module.exports, "SpriteFont", () => $2c23f148d58cd887$export$e1896ac0c4970221);
$parcel$export(module.exports, "SpriteSheet", () => $2c23f148d58cd887$export$bd73ddfe5f8475d8);
$parcel$export(module.exports, "System", () => $2c23f148d58cd887$export$e1dae5660003ffa7);
$parcel$export(module.exports, "SystemType", () => $2c23f148d58cd887$export$c586aa7b67d94d19);
$parcel$export(module.exports, "Text", () => $2c23f148d58cd887$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Timer", () => $2c23f148d58cd887$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "TransformComponent", () => $2c23f148d58cd887$export$1def2aa75b7c7fe0);
$parcel$export(module.exports, "range", () => $2c23f148d58cd887$export$d02631cccf789723);
$parcel$export(module.exports, "vec", () => $2c23f148d58cd887$export$202e0172ed3c7be0);
/*!
 * excalibur - 0.29.3 - 2024-5-5
 * https://github.com/excaliburjs/Excalibur
 * Copyright (c) 2024 Excalibur.js <https://github.com/excaliburjs/Excalibur/graphs/contributors>
 * Licensed BSD-2-Clause
 * @preserve
 */ /******/ var $2c23f148d58cd887$var$__webpack_modules__ = {
    /***/ 8851: /***/ (module, __webpack_exports__, __webpack_require__)=>{
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
            /* harmony export */ A: ()=>__WEBPACK_DEFAULT_EXPORT__
        });
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2001);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
        // Imports
        var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
        // Module
        ___CSS_LOADER_EXPORT___.push([
            module.id,
            `/* Buttons styles start */

button#excalibur-play {
  display: inline-block;
  position: relative;
  z-index: 999;
  border-radius: 6px;
  border: none;
  /*border: 3px solid;
    border-color: white;
    box-shadow: 0 0 10px #ccc;*/
  padding: 1rem 1.5rem 1rem 4rem;
  margin: 0;
  text-decoration: none;
  background: #00b233;
  color: #ffffff;
  font-family: sans-serif;
  font-size: 2rem;
  white-space: nowrap;
  line-height: 1;
  cursor: pointer;
  text-align: center;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;

  -webkit-animation: excalibur-button-fadein 200ms; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: excalibur-button-fadein 200ms; /* Firefox < 16 */
  -ms-animation: excalibur-button-fadein 200ms; /* Internet Explorer */
  -o-animation: excalibur-button-fadein 200ms; /* Opera < 12.1 */
  animation: excalibur-button-fadein 200ms;
}

/*
button#excalibur-play {
  display: none;
}*/

button#excalibur-play:after {
  position: absolute;
  content: '';
  border: 8px solid;
  border-color: transparent transparent transparent white;
  left: 35px;
  top: 24px;
  width: 0;
  height: 0;
}

button#excalibur-play:before {
  position: absolute;
  content: '';
  border: 3px solid;
  left: 19px;
  top: 14px;
  border-radius: 20px;
  width: 30px;
  height: 30px;
}

button#excalibur-play:hover,
button#excalibur-play:focus {
  background: #00982c;
}

button#excalibur-play:focus {
  outline: 1px solid #fff;
  outline-offset: -4px;
}

button#excalibur-play:active {
  transform: scale(0.99);
}

@keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`,
            "",
            {
                "version": 3,
                "sources": [
                    "webpack://./Director/Loader.css"
                ],
                "names": [],
                "mappings": "AAAA,yBAAyB;;AAEzB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;;+BAE6B;EAC7B,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,8DAA8D;EAC9D,wBAAwB;EACxB,qBAAqB;;EAErB,gDAAgD,EAAE,oCAAoC;EACtF,6CAA6C,EAAE,iBAAiB;EAChE,4CAA4C,EAAE,sBAAsB;EACpE,2CAA2C,EAAE,iBAAiB;EAC9D,wCAAwC;AAC1C;;AAEA;;;EAGE;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,uDAAuD;EACvD,UAAU;EACV,SAAS;EACT,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF",
                "sourcesContent": [
                    "/* Buttons styles start */\r\n\r\nbutton#excalibur-play {\r\n  display: inline-block;\r\n  position: relative;\r\n  z-index: 999;\r\n  border-radius: 6px;\r\n  border: none;\r\n  /*border: 3px solid;\r\n    border-color: white;\r\n    box-shadow: 0 0 10px #ccc;*/\r\n  padding: 1rem 1.5rem 1rem 4rem;\r\n  margin: 0;\r\n  text-decoration: none;\r\n  background: #00b233;\r\n  color: #ffffff;\r\n  font-family: sans-serif;\r\n  font-size: 2rem;\r\n  white-space: nowrap;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: background 250ms ease-in-out, transform 150ms ease;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n\r\n  -webkit-animation: excalibur-button-fadein 200ms; /* Safari, Chrome and Opera > 12.1 */\r\n  -moz-animation: excalibur-button-fadein 200ms; /* Firefox < 16 */\r\n  -ms-animation: excalibur-button-fadein 200ms; /* Internet Explorer */\r\n  -o-animation: excalibur-button-fadein 200ms; /* Opera < 12.1 */\r\n  animation: excalibur-button-fadein 200ms;\r\n}\r\n\r\n/*\r\nbutton#excalibur-play {\r\n  display: none;\r\n}*/\r\n\r\nbutton#excalibur-play:after {\r\n  position: absolute;\r\n  content: '';\r\n  border: 8px solid;\r\n  border-color: transparent transparent transparent white;\r\n  left: 35px;\r\n  top: 24px;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\nbutton#excalibur-play:before {\r\n  position: absolute;\r\n  content: '';\r\n  border: 3px solid;\r\n  left: 19px;\r\n  top: 14px;\r\n  border-radius: 20px;\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\nbutton#excalibur-play:hover,\r\nbutton#excalibur-play:focus {\r\n  background: #00982c;\r\n}\r\n\r\nbutton#excalibur-play:focus {\r\n  outline: 1px solid #fff;\r\n  outline-offset: -4px;\r\n}\r\n\r\nbutton#excalibur-play:active {\r\n  transform: scale(0.99);\r\n}\r\n\r\n@keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Firefox < 16 */\r\n@-moz-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Safari, Chrome and Opera > 12.1 */\r\n@-webkit-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Internet Explorer */\r\n@-ms-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Opera < 12.1 */\r\n@-o-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n"
                ],
                "sourceRoot": ""
            }
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
    /***/ },
    /***/ 4296: /***/ (module, __webpack_exports__, __webpack_require__)=>{
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
            /* harmony export */ A: ()=>__WEBPACK_DEFAULT_EXPORT__
        });
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2001);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
        // Imports
        var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
        // Module
        ___CSS_LOADER_EXPORT___.push([
            module.id,
            `
#ex-toast-container {
  position: absolute;
  height: 0;
  min-width: 50%;
  left: 50%;
  top: 0;
}

.ex-toast-message {
  left: -50%;
  position: relative;
  display: flex;
  justify-content: space-between;


  padding: 10px;
  margin-top: 5px;
  font-size: 18px;
  font-family: sans-serif;
  border-radius: 6px;
  border: 3px solid #b7b779;
  background-color: rgb(253, 253, 192);
}


.ex-toast-message button {
  align-self: flex-start;
}`,
            "",
            {
                "version": 3,
                "sources": [
                    "webpack://./Util/Toaster.css"
                ],
                "names": [],
                "mappings": ";AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,SAAS;EACT,MAAM;AACR;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,8BAA8B;;;EAG9B,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;AACtC;;;AAGA;EACE,sBAAsB;AACxB",
                "sourcesContent": [
                    "\r\n#ex-toast-container {\r\n  position: absolute;\r\n  height: 0;\r\n  min-width: 50%;\r\n  left: 50%;\r\n  top: 0;\r\n}\r\n\r\n.ex-toast-message {\r\n  left: -50%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n\r\n  padding: 10px;\r\n  margin-top: 5px;\r\n  font-size: 18px;\r\n  font-family: sans-serif;\r\n  border-radius: 6px;\r\n  border: 3px solid #b7b779;\r\n  background-color: rgb(253, 253, 192);\r\n}\r\n\r\n\r\n.ex-toast-message button {\r\n  align-self: flex-start;\r\n}"
                ],
                "sourceRoot": ""
            }
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
    /***/ },
    /***/ 935: /***/ (module)=>{
        /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/ module.exports = function(cssWithMappingToString) {
            var list = [];
            // return the list of modules as css string
            list.toString = function toString() {
                return this.map(function(item) {
                    var content = "";
                    var needLayer = typeof item[5] !== "undefined";
                    if (item[4]) content += "@supports (".concat(item[4], ") {");
                    if (item[2]) content += "@media ".concat(item[2], " {");
                    if (needLayer) content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
                    content += cssWithMappingToString(item);
                    if (needLayer) content += "}";
                    if (item[2]) content += "}";
                    if (item[4]) content += "}";
                    return content;
                }).join("");
            };
            // import a list of modules into the list
            list.i = function i(modules, media, dedupe, supports, layer) {
                if (typeof modules === "string") modules = [
                    [
                        null,
                        modules,
                        undefined
                    ]
                ];
                var alreadyImportedModules = {};
                if (dedupe) for(var k = 0; k < this.length; k++){
                    var id = this[k][0];
                    if (id != null) alreadyImportedModules[id] = true;
                }
                for(var _k = 0; _k < modules.length; _k++){
                    var item = [].concat(modules[_k]);
                    if (dedupe && alreadyImportedModules[item[0]]) continue;
                    if (typeof layer !== "undefined") {
                        if (typeof item[5] === "undefined") item[5] = layer;
                        else {
                            item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
                            item[5] = layer;
                        }
                    }
                    if (media) {
                        if (!item[2]) item[2] = media;
                        else {
                            item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
                            item[2] = media;
                        }
                    }
                    if (supports) {
                        if (!item[4]) item[4] = "".concat(supports);
                        else {
                            item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
                            item[4] = supports;
                        }
                    }
                    list.push(item);
                }
            };
            return list;
        };
    /***/ },
    /***/ 2001: /***/ (module)=>{
        module.exports = function(item) {
            var content = item[1];
            var cssMapping = item[3];
            if (!cssMapping) return content;
            if (typeof btoa === "function") {
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
                var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
                var sourceMapping = "/*# ".concat(data, " */");
                return [
                    content
                ].concat([
                    sourceMapping
                ]).join("\n");
            }
            return [
                content
            ].join("\n");
        };
    /***/ },
    /***/ 9493: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        __webpack_require__(3975);
        var entryUnbind = __webpack_require__(2564);
        module.exports = entryUnbind("Array", "sort");
    /***/ },
    /***/ 311: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        __webpack_require__(8291);
        var path = __webpack_require__(9120);
        module.exports = path.Object.keys;
    /***/ },
    /***/ 4977: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        var tryToString = __webpack_require__(3174);
        var $TypeError = TypeError;
        // `Assert: IsCallable(argument) is true`
        module.exports = function(argument) {
            if (isCallable(argument)) return argument;
            throw new $TypeError(tryToString(argument) + " is not a function");
        };
    /***/ },
    /***/ 3770: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isObject = __webpack_require__(831);
        var $String = String;
        var $TypeError = TypeError;
        // `Assert: Type(argument) is Object`
        module.exports = function(argument) {
            if (isObject(argument)) return argument;
            throw new $TypeError($String(argument) + " is not an object");
        };
    /***/ },
    /***/ 1458: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIndexedObject = __webpack_require__(380);
        var toAbsoluteIndex = __webpack_require__(675);
        var lengthOfArrayLike = __webpack_require__(9389);
        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIndexedObject($this);
                var length = lengthOfArrayLike(O);
                if (length === 0) return !IS_INCLUDES && -1;
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare -- NaN check
                if (IS_INCLUDES && el !== el) while(length > index){
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
                }
                else for(; length > index; index++){
                    if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
        module.exports = {
            // `Array.prototype.includes` method
            // https://tc39.es/ecma262/#sec-array.prototype.includes
            includes: createMethod(true),
            // `Array.prototype.indexOf` method
            // https://tc39.es/ecma262/#sec-array.prototype.indexof
            indexOf: createMethod(false)
        };
    /***/ },
    /***/ 5397: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        module.exports = function(METHOD_NAME, argument) {
            var method = [][METHOD_NAME];
            return !!method && fails(function() {
                // eslint-disable-next-line no-useless-call -- required for testing
                method.call(null, argument || function() {
                    return 1;
                }, 1);
            });
        };
    /***/ },
    /***/ 7825: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        module.exports = uncurryThis([].slice);
    /***/ },
    /***/ 9295: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var arraySlice = __webpack_require__(7825);
        var floor = Math.floor;
        var sort = function(array, comparefn) {
            var length = array.length;
            if (length < 8) {
                // insertion sort
                var i = 1;
                var element, j;
                while(i < length){
                    j = i;
                    element = array[i];
                    while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                    if (j !== i++) array[j] = element;
                }
            } else {
                // merge sort
                var middle = floor(length / 2);
                var left = sort(arraySlice(array, 0, middle), comparefn);
                var right = sort(arraySlice(array, middle), comparefn);
                var llength = left.length;
                var rlength = right.length;
                var lindex = 0;
                var rindex = 0;
                while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
            }
            return array;
        };
        module.exports = sort;
    /***/ },
    /***/ 8689: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis("".slice);
        module.exports = function(it) {
            return stringSlice(toString(it), 8, -1);
        };
    /***/ },
    /***/ 5438: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var TO_STRING_TAG_SUPPORT = __webpack_require__(9345);
        var isCallable = __webpack_require__(4188);
        var classofRaw = __webpack_require__(8689);
        var wellKnownSymbol = __webpack_require__(4282);
        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var $Object = Object;
        // ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
        }()) === "Arguments";
        // fallback for IE11 Script Access Denied error
        var tryGet = function(it, key) {
            try {
                return it[key];
            } catch (error) {}
        };
        // getting tag from ES6+ `Object.prototype.toString`
        module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result;
            return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
        };
    /***/ },
    /***/ 8657: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var hasOwn = __webpack_require__(4418);
        var ownKeys = __webpack_require__(3168);
        var getOwnPropertyDescriptorModule = __webpack_require__(9304);
        var definePropertyModule = __webpack_require__(4466);
        module.exports = function(target, source, exceptions) {
            var keys = ownKeys(source);
            var defineProperty = definePropertyModule.f;
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        };
    /***/ },
    /***/ 8088: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var definePropertyModule = __webpack_require__(4466);
        var createPropertyDescriptor = __webpack_require__(9123);
        module.exports = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
    /***/ },
    /***/ 9123: /***/ (module)=>{
        module.exports = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
    /***/ },
    /***/ 7509: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        var definePropertyModule = __webpack_require__(4466);
        var makeBuiltIn = __webpack_require__(4530);
        var defineGlobalProperty = __webpack_require__(4798);
        module.exports = function(O, key, value, options) {
            if (!options) options = {};
            var simple = options.enumerable;
            var name = options.name !== undefined ? options.name : key;
            if (isCallable(value)) makeBuiltIn(value, name, options);
            if (options.global) {
                if (simple) O[key] = value;
                else defineGlobalProperty(key, value);
            } else {
                try {
                    if (!options.unsafe) delete O[key];
                    else if (O[key]) simple = true;
                } catch (error) {}
                if (simple) O[key] = value;
                else definePropertyModule.f(O, key, {
                    value: value,
                    enumerable: false,
                    configurable: !options.nonConfigurable,
                    writable: !options.nonWritable
                });
            }
            return O;
        };
    /***/ },
    /***/ 4798: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        module.exports = function(key, value) {
            try {
                defineProperty(global, key, {
                    value: value,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                global[key] = value;
            }
            return value;
        };
    /***/ },
    /***/ 1305: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var tryToString = __webpack_require__(3174);
        var $TypeError = TypeError;
        module.exports = function(O, P) {
            if (!delete O[P]) throw new $TypeError("Cannot delete property " + tryToString(P) + " of " + tryToString(O));
        };
    /***/ },
    /***/ 6893: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        // Detect IE8's incomplete defineProperty implementation
        module.exports = !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] !== 7;
        });
    /***/ },
    /***/ 5926: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isObject = __webpack_require__(831);
        var document1 = global.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document1) && isObject(document1.createElement);
        module.exports = function(it) {
            return EXISTS ? document1.createElement(it) : {};
        };
    /***/ },
    /***/ 8807: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var userAgent = __webpack_require__(4109);
        var firefox = userAgent.match(/firefox\/(\d+)/i);
        module.exports = !!firefox && +firefox[1];
    /***/ },
    /***/ 5661: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var UA = __webpack_require__(4109);
        module.exports = /MSIE|Trident/.test(UA);
    /***/ },
    /***/ 4109: /***/ (module)=>{
        module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";
    /***/ },
    /***/ 3749: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var userAgent = __webpack_require__(4109);
        var process = global.process;
        var Deno = global.Deno;
        var versions = process && process.versions || Deno && Deno.version;
        var v8 = versions && versions.v8;
        var match, version;
        if (v8) {
            match = v8.split(".");
            // in old Chrome, versions of V8 isn't V8 = Chrome / 10
            // but their correct versions are not interesting for us
            version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }
        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
                match = userAgent.match(/Chrome\/(\d+)/);
                if (match) version = +match[1];
            }
        }
        module.exports = version;
    /***/ },
    /***/ 3589: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var userAgent = __webpack_require__(4109);
        var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
        module.exports = !!webkit && +webkit[1];
    /***/ },
    /***/ 2564: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var uncurryThis = __webpack_require__(6881);
        module.exports = function(CONSTRUCTOR, METHOD) {
            return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
        };
    /***/ },
    /***/ 1274: /***/ (module)=>{
        // IE8- don't enum bug keys
        module.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
        ];
    /***/ },
    /***/ 5613: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var getOwnPropertyDescriptor = __webpack_require__(9304).f;
        var createNonEnumerableProperty = __webpack_require__(8088);
        var defineBuiltIn = __webpack_require__(7509);
        var defineGlobalProperty = __webpack_require__(4798);
        var copyConstructorProperties = __webpack_require__(8657);
        var isForced = __webpack_require__(8489);
        /*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) target = global;
            else if (STATIC) target = global[TARGET] || defineGlobalProperty(TARGET, {});
            else target = global[TARGET] && global[TARGET].prototype;
            if (target) for(key in source){
                sourceProperty = source[key];
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(target, key);
                    targetProperty = descriptor && descriptor.value;
                } else targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                // contained in target
                if (!FORCED && targetProperty !== undefined) {
                    if (typeof sourceProperty == typeof targetProperty) continue;
                    copyConstructorProperties(sourceProperty, targetProperty);
                }
                // add a flag to not completely full polyfills
                if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
                defineBuiltIn(target, key, sourceProperty, options);
            }
        };
    /***/ },
    /***/ 5234: /***/ (module)=>{
        module.exports = function(exec) {
            try {
                return !!exec();
            } catch (error) {
                return true;
            }
        };
    /***/ },
    /***/ 9055: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        module.exports = !fails(function() {
            // eslint-disable-next-line es/no-function-prototype-bind -- safe
            var test = (function() {}).bind();
            // eslint-disable-next-line no-prototype-builtins -- safe
            return typeof test != "function" || test.hasOwnProperty("prototype");
        });
    /***/ },
    /***/ 9944: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_BIND = __webpack_require__(9055);
        var call = Function.prototype.call;
        module.exports = NATIVE_BIND ? call.bind(call) : function() {
            return call.apply(call, arguments);
        };
    /***/ },
    /***/ 2735: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var hasOwn = __webpack_require__(4418);
        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
        var EXISTS = hasOwn(FunctionPrototype, "name");
        // additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() {}).name === "something";
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
        module.exports = {
            EXISTS: EXISTS,
            PROPER: PROPER,
            CONFIGURABLE: CONFIGURABLE
        };
    /***/ },
    /***/ 6881: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_BIND = __webpack_require__(9055);
        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
        module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
            return function() {
                return call.apply(fn, arguments);
            };
        };
    /***/ },
    /***/ 5604: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isCallable = __webpack_require__(4188);
        var aFunction = function(argument) {
            return isCallable(argument) ? argument : undefined;
        };
        module.exports = function(namespace, method) {
            return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
        };
    /***/ },
    /***/ 2913: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var aCallable = __webpack_require__(4977);
        var isNullOrUndefined = __webpack_require__(4318);
        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        module.exports = function(V, P) {
            var func = V[P];
            return isNullOrUndefined(func) ? undefined : aCallable(func);
        };
    /***/ },
    /***/ 1488: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
        var check = function(it) {
            return it && it.Math === Math && it;
        };
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == "object" && self) || check(typeof __webpack_require__.g == "object" && __webpack_require__.g) || check(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
        function() {
            return this;
        }() || Function("return this")();
    /***/ },
    /***/ 4418: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var toObject = __webpack_require__(3628);
        var hasOwnProperty = uncurryThis({}.hasOwnProperty);
        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        module.exports = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
        };
    /***/ },
    /***/ 7588: /***/ (module)=>{
        module.exports = {};
    /***/ },
    /***/ 9622: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var fails = __webpack_require__(5234);
        var createElement = __webpack_require__(5926);
        // Thanks to IE8 for its funny defineProperty
        module.exports = !DESCRIPTORS && !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(createElement("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a !== 7;
        });
    /***/ },
    /***/ 7568: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var fails = __webpack_require__(5234);
        var classof = __webpack_require__(8689);
        var $Object = Object;
        var split = uncurryThis("".split);
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        module.exports = fails(function() {
            // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
            // eslint-disable-next-line no-prototype-builtins -- safe
            return !$Object("z").propertyIsEnumerable(0);
        }) ? function(it) {
            return classof(it) === "String" ? split(it, "") : $Object(it);
        } : $Object;
    /***/ },
    /***/ 3029: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var isCallable = __webpack_require__(4188);
        var store = __webpack_require__(2694);
        var functionToString = uncurryThis(Function.toString);
        // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
            return functionToString(it);
        };
        module.exports = store.inspectSource;
    /***/ },
    /***/ 3086: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_WEAK_MAP = __webpack_require__(5945);
        var global = __webpack_require__(1488);
        var isObject = __webpack_require__(831);
        var createNonEnumerableProperty = __webpack_require__(8088);
        var hasOwn = __webpack_require__(4418);
        var shared = __webpack_require__(2694);
        var sharedKey = __webpack_require__(168);
        var hiddenKeys = __webpack_require__(7588);
        var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
        var TypeError1 = global.TypeError;
        var WeakMap1 = global.WeakMap;
        var set, get, has;
        var enforce = function(it) {
            return has(it) ? get(it) : set(it, {});
        };
        var getterFor = function(TYPE) {
            return function(it) {
                var state;
                if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1("Incompatible receiver, " + TYPE + " required");
                return state;
            };
        };
        if (NATIVE_WEAK_MAP || shared.state) {
            var store = shared.state || (shared.state = new WeakMap1());
            /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
            store.has = store.has;
            store.set = store.set;
            /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                store.set(it, metadata);
                return metadata;
            };
            get = function(it) {
                return store.get(it) || {};
            };
            has = function(it) {
                return store.has(it);
            };
        } else {
            var STATE = sharedKey("state");
            hiddenKeys[STATE] = true;
            set = function(it, metadata) {
                if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                createNonEnumerableProperty(it, STATE, metadata);
                return metadata;
            };
            get = function(it) {
                return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
                return hasOwn(it, STATE);
            };
        }
        module.exports = {
            set: set,
            get: get,
            has: has,
            enforce: enforce,
            getterFor: getterFor
        };
    /***/ },
    /***/ 4188: /***/ (module)=>{
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        var documentAll = typeof document == "object" && document.all;
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        module.exports = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
            return typeof argument == "function" || argument === documentAll;
        } : function(argument) {
            return typeof argument == "function";
        };
    /***/ },
    /***/ 8489: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        var isCallable = __webpack_require__(4188);
        var replacement = /#|\.prototype\./;
        var isForced = function(feature, detection) {
            var value = data[normalize(feature)];
            return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
        };
        var normalize = isForced.normalize = function(string) {
            return String(string).replace(replacement, ".").toLowerCase();
        };
        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = "N";
        var POLYFILL = isForced.POLYFILL = "P";
        module.exports = isForced;
    /***/ },
    /***/ 4318: /***/ (module)=>{
        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        module.exports = function(it) {
            return it === null || it === undefined;
        };
    /***/ },
    /***/ 831: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        module.exports = function(it) {
            return typeof it == "object" ? it !== null : isCallable(it);
        };
    /***/ },
    /***/ 1942: /***/ (module)=>{
        module.exports = false;
    /***/ },
    /***/ 6032: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var getBuiltIn = __webpack_require__(5604);
        var isCallable = __webpack_require__(4188);
        var isPrototypeOf = __webpack_require__(4578);
        var USE_SYMBOL_AS_UID = __webpack_require__(9809);
        var $Object = Object;
        module.exports = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == "symbol";
        } : function(it) {
            var $Symbol = getBuiltIn("Symbol");
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };
    /***/ },
    /***/ 9389: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toLength = __webpack_require__(7611);
        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        module.exports = function(obj) {
            return toLength(obj.length);
        };
    /***/ },
    /***/ 4530: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var fails = __webpack_require__(5234);
        var isCallable = __webpack_require__(4188);
        var hasOwn = __webpack_require__(4418);
        var DESCRIPTORS = __webpack_require__(6893);
        var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(2735).CONFIGURABLE;
        var inspectSource = __webpack_require__(3029);
        var InternalStateModule = __webpack_require__(3086);
        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis("".slice);
        var replace = uncurryThis("".replace);
        var join = uncurryThis([].join);
        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
            return defineProperty(function() {}, "length", {
                value: 8
            }).length !== 8;
        });
        var TEMPLATE = String(String).split("String");
        var makeBuiltIn = module.exports = function(value, name, options) {
            if (stringSlice($String(name), 0, 7) === "Symbol(") name = "[" + replace($String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
            if (options && options.getter) name = "get " + name;
            if (options && options.setter) name = "set " + name;
            if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                if (DESCRIPTORS) defineProperty(value, "name", {
                    value: name,
                    configurable: true
                });
                else value.name = name;
            }
            if (CONFIGURABLE_LENGTH && options && hasOwn(options, "arity") && value.length !== options.arity) defineProperty(value, "length", {
                value: options.arity
            });
            try {
                if (options && hasOwn(options, "constructor") && options.constructor) {
                    if (DESCRIPTORS) defineProperty(value, "prototype", {
                        writable: false
                    });
                } else if (value.prototype) value.prototype = undefined;
            } catch (error) {}
            var state = enforceInternalState(value);
            if (!hasOwn(state, "source")) state.source = join(TEMPLATE, typeof name == "string" ? name : "");
            return value;
        };
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn(function toString() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, "toString");
    /***/ },
    /***/ 142: /***/ (module)=>{
        var ceil = Math.ceil;
        var floor = Math.floor;
        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        module.exports = Math.trunc || function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
        };
    /***/ },
    /***/ 4466: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var IE8_DOM_DEFINE = __webpack_require__(9622);
        var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3315);
        var anObject = __webpack_require__(3770);
        var toPropertyKey = __webpack_require__(2344);
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = "enumerable";
        var CONFIGURABLE = "configurable";
        var WRITABLE = "writable";
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                var current = $getOwnPropertyDescriptor(O, P);
                if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                        writable: false
                    };
                }
            }
            return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return $defineProperty(O, P, Attributes);
            } catch (error) {}
            if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
            if ("value" in Attributes) O[P] = Attributes.value;
            return O;
        };
    /***/ },
    /***/ 9304: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var call = __webpack_require__(9944);
        var propertyIsEnumerableModule = __webpack_require__(4416);
        var createPropertyDescriptor = __webpack_require__(9123);
        var toIndexedObject = __webpack_require__(380);
        var toPropertyKey = __webpack_require__(2344);
        var hasOwn = __webpack_require__(4418);
        var IE8_DOM_DEFINE = __webpack_require__(9622);
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
            O = toIndexedObject(O);
            P = toPropertyKey(P);
            if (IE8_DOM_DEFINE) try {
                return $getOwnPropertyDescriptor(O, P);
            } catch (error) {}
            if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
    /***/ },
    /***/ 5629: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var internalObjectKeys = __webpack_require__(1843);
        var enumBugKeys = __webpack_require__(1274);
        var hiddenKeys = enumBugKeys.concat("length", "prototype");
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
        };
    /***/ },
    /***/ 156: /***/ (__unused_webpack_module, exports)=>{
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        exports.f = Object.getOwnPropertySymbols;
    /***/ },
    /***/ 4578: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        module.exports = uncurryThis({}.isPrototypeOf);
    /***/ },
    /***/ 1843: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var hasOwn = __webpack_require__(4418);
        var toIndexedObject = __webpack_require__(380);
        var indexOf = __webpack_require__(1458).indexOf;
        var hiddenKeys = __webpack_require__(7588);
        var push = uncurryThis([].push);
        module.exports = function(object, names) {
            var O = toIndexedObject(object);
            var i = 0;
            var result = [];
            var key;
            for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
            // Don't enum bug & hidden keys
            while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
            return result;
        };
    /***/ },
    /***/ 7137: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var internalObjectKeys = __webpack_require__(1843);
        var enumBugKeys = __webpack_require__(1274);
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        module.exports = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
        };
    /***/ },
    /***/ 4416: /***/ (__unused_webpack_module, exports)=>{
        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
            1: 2
        }, 1);
        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
            var descriptor = getOwnPropertyDescriptor(this, V);
            return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
    /***/ },
    /***/ 2287: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var call = __webpack_require__(9944);
        var isCallable = __webpack_require__(4188);
        var isObject = __webpack_require__(831);
        var $TypeError = TypeError;
        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        module.exports = function(input, pref) {
            var fn, val;
            if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
            if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            throw new $TypeError("Can't convert object to primitive value");
        };
    /***/ },
    /***/ 3168: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var getBuiltIn = __webpack_require__(5604);
        var uncurryThis = __webpack_require__(6881);
        var getOwnPropertyNamesModule = __webpack_require__(5629);
        var getOwnPropertySymbolsModule = __webpack_require__(156);
        var anObject = __webpack_require__(3770);
        var concat = uncurryThis([].concat);
        // all object keys, includes non-enumerable and symbols
        module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
    /***/ },
    /***/ 9120: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        module.exports = global;
    /***/ },
    /***/ 9509: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isNullOrUndefined = __webpack_require__(4318);
        var $TypeError = TypeError;
        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        module.exports = function(it) {
            if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
            return it;
        };
    /***/ },
    /***/ 168: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var shared = __webpack_require__(746);
        var uid = __webpack_require__(6209);
        var keys = shared("keys");
        module.exports = function(key) {
            return keys[key] || (keys[key] = uid(key));
        };
    /***/ },
    /***/ 2694: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var IS_PURE = __webpack_require__(1942);
        var globalThis1 = __webpack_require__(1488);
        var defineGlobalProperty = __webpack_require__(4798);
        var SHARED = "__core-js_shared__";
        var store = module.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
        (store.versions || (store.versions = [])).push({
            version: "3.36.1",
            mode: IS_PURE ? "pure" : "global",
            copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE",
            source: "https://github.com/zloirock/core-js"
        });
    /***/ },
    /***/ 746: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var store = __webpack_require__(2694);
        module.exports = function(key, value) {
            return store[key] || (store[key] = value || {});
        };
    /***/ },
    /***/ 8944: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = __webpack_require__(3749);
        var fails = __webpack_require__(5234);
        var global = __webpack_require__(1488);
        var $String = global.String;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol("symbol detection");
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
    /***/ },
    /***/ 675: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIntegerOrInfinity = __webpack_require__(6744);
        var max = Math.max;
        var min = Math.min;
        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        module.exports = function(index, length) {
            var integer = toIntegerOrInfinity(index);
            return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
    /***/ },
    /***/ 380: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__(7568);
        var requireObjectCoercible = __webpack_require__(9509);
        module.exports = function(it) {
            return IndexedObject(requireObjectCoercible(it));
        };
    /***/ },
    /***/ 6744: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var trunc = __webpack_require__(142);
        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        module.exports = function(argument) {
            var number = +argument;
            // eslint-disable-next-line no-self-compare -- NaN check
            return number !== number || number === 0 ? 0 : trunc(number);
        };
    /***/ },
    /***/ 7611: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIntegerOrInfinity = __webpack_require__(6744);
        var min = Math.min;
        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        module.exports = function(argument) {
            var len = toIntegerOrInfinity(argument);
            return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
    /***/ },
    /***/ 3628: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var requireObjectCoercible = __webpack_require__(9509);
        var $Object = Object;
        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        module.exports = function(argument) {
            return $Object(requireObjectCoercible(argument));
        };
    /***/ },
    /***/ 290: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var call = __webpack_require__(9944);
        var isObject = __webpack_require__(831);
        var isSymbol = __webpack_require__(6032);
        var getMethod = __webpack_require__(2913);
        var ordinaryToPrimitive = __webpack_require__(2287);
        var wellKnownSymbol = __webpack_require__(4282);
        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        module.exports = function(input, pref) {
            if (!isObject(input) || isSymbol(input)) return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result;
            if (exoticToPrim) {
                if (pref === undefined) pref = "default";
                result = call(exoticToPrim, input, pref);
                if (!isObject(result) || isSymbol(result)) return result;
                throw new $TypeError("Can't convert object to primitive value");
            }
            if (pref === undefined) pref = "number";
            return ordinaryToPrimitive(input, pref);
        };
    /***/ },
    /***/ 2344: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toPrimitive = __webpack_require__(290);
        var isSymbol = __webpack_require__(6032);
        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        module.exports = function(argument) {
            var key = toPrimitive(argument, "string");
            return isSymbol(key) ? key : key + "";
        };
    /***/ },
    /***/ 9345: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var wellKnownSymbol = __webpack_require__(4282);
        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var test = {};
        test[TO_STRING_TAG] = "z";
        module.exports = String(test) === "[object z]";
    /***/ },
    /***/ 2618: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var classof = __webpack_require__(5438);
        var $String = String;
        module.exports = function(argument) {
            if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
            return $String(argument);
        };
    /***/ },
    /***/ 3174: /***/ (module)=>{
        var $String = String;
        module.exports = function(argument) {
            try {
                return $String(argument);
            } catch (error) {
                return "Object";
            }
        };
    /***/ },
    /***/ 6209: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.0.toString);
        module.exports = function(key) {
            return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
        };
    /***/ },
    /***/ 9809: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = __webpack_require__(8944);
        module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
    /***/ },
    /***/ 3315: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var fails = __webpack_require__(5234);
        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        module.exports = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(function() {}, "prototype", {
                value: 42,
                writable: false
            }).prototype !== 42;
        });
    /***/ },
    /***/ 5945: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isCallable = __webpack_require__(4188);
        var WeakMap1 = global.WeakMap;
        module.exports = isCallable(WeakMap1) && /native code/.test(String(WeakMap1));
    /***/ },
    /***/ 4282: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var shared = __webpack_require__(746);
        var hasOwn = __webpack_require__(4418);
        var uid = __webpack_require__(6209);
        var NATIVE_SYMBOL = __webpack_require__(8944);
        var USE_SYMBOL_AS_UID = __webpack_require__(9809);
        var Symbol1 = global.Symbol;
        var WellKnownSymbolsStore = shared("wks");
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1["for"] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
        module.exports = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol("Symbol." + name);
            return WellKnownSymbolsStore[name];
        };
    /***/ },
    /***/ 3975: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
        var $ = __webpack_require__(5613);
        var uncurryThis = __webpack_require__(6881);
        var aCallable = __webpack_require__(4977);
        var toObject = __webpack_require__(3628);
        var lengthOfArrayLike = __webpack_require__(9389);
        var deletePropertyOrThrow = __webpack_require__(1305);
        var toString = __webpack_require__(2618);
        var fails = __webpack_require__(5234);
        var internalSort = __webpack_require__(9295);
        var arrayMethodIsStrict = __webpack_require__(5397);
        var FF = __webpack_require__(8807);
        var IE_OR_EDGE = __webpack_require__(5661);
        var V8 = __webpack_require__(3749);
        var WEBKIT = __webpack_require__(3589);
        var test = [];
        var nativeSort = uncurryThis(test.sort);
        var push = uncurryThis(test.push);
        // IE8-
        var FAILS_ON_UNDEFINED = fails(function() {
            test.sort(undefined);
        });
        // V8 bug
        var FAILS_ON_NULL = fails(function() {
            test.sort(null);
        });
        // Old WebKit
        var STRICT_METHOD = arrayMethodIsStrict("sort");
        var STABLE_SORT = !fails(function() {
            // feature detection can be too slow, so check engines versions
            if (V8) return V8 < 70;
            if (FF && FF > 3) return;
            if (IE_OR_EDGE) return true;
            if (WEBKIT) return WEBKIT < 603;
            var result = "";
            var code, chr, value, index;
            // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
            for(code = 65; code < 76; code++){
                chr = String.fromCharCode(code);
                switch(code){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        value = 3;
                        break;
                    case 68:
                    case 71:
                        value = 4;
                        break;
                    default:
                        value = 2;
                }
                for(index = 0; index < 47; index++)test.push({
                    k: chr + index,
                    v: value
                });
            }
            test.sort(function(a, b) {
                return b.v - a.v;
            });
            for(index = 0; index < test.length; index++){
                chr = test[index].k.charAt(0);
                if (result.charAt(result.length - 1) !== chr) result += chr;
            }
            return result !== "DGBEFHACIJK";
        });
        var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
        var getSortCompare = function(comparefn) {
            return function(x, y) {
                if (y === undefined) return -1;
                if (x === undefined) return 1;
                if (comparefn !== undefined) return +comparefn(x, y) || 0;
                return toString(x) > toString(y) ? 1 : -1;
            };
        };
        // `Array.prototype.sort` method
        // https://tc39.es/ecma262/#sec-array.prototype.sort
        $({
            target: "Array",
            proto: true,
            forced: FORCED
        }, {
            sort: function sort(comparefn) {
                if (comparefn !== undefined) aCallable(comparefn);
                var array = toObject(this);
                if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
                var items = [];
                var arrayLength = lengthOfArrayLike(array);
                var itemsLength, index;
                for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                internalSort(items, getSortCompare(comparefn));
                itemsLength = lengthOfArrayLike(items);
                index = 0;
                while(index < itemsLength)array[index] = items[index++];
                while(index < arrayLength)deletePropertyOrThrow(array, index++);
                return array;
            }
        });
    /***/ },
    /***/ 8291: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
        var $ = __webpack_require__(5613);
        var toObject = __webpack_require__(3628);
        var nativeKeys = __webpack_require__(7137);
        var fails = __webpack_require__(5234);
        var FAILS_ON_PRIMITIVES = fails(function() {
            nativeKeys(1);
        });
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        $({
            target: "Object",
            stat: true,
            forced: FAILS_ON_PRIMITIVES
        }, {
            keys: function keys(it) {
                return nativeKeys(toObject(it));
            }
        });
    /***/ }
};
/************************************************************************/ /******/ // The module cache
/******/ var $2c23f148d58cd887$var$__webpack_module_cache__ = {};
/******/ /******/ // The require function
/******/ function $2c23f148d58cd887$var$__webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = $2c23f148d58cd887$var$__webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = $2c23f148d58cd887$var$__webpack_module_cache__[moduleId] = {
        /******/ id: moduleId,
        /******/ // no module.loaded needed
        /******/ exports: {}
    };
    /******/ /******/ // Execute the module function
    /******/ $2c23f148d58cd887$var$__webpack_modules__[moduleId].call(module.exports, module, module.exports, $2c23f148d58cd887$var$__webpack_require__);
    /******/ /******/ // Return the exports of the module
    /******/ return module.exports;
/******/ }
/******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ (()=>{
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ $2c23f148d58cd887$var$__webpack_require__.n = (module)=>{
        /******/ var getter = module && module.__esModule ? /******/ ()=>module["default"] : /******/ ()=>module;
        /******/ $2c23f148d58cd887$var$__webpack_require__.d(getter, {
            a: getter
        });
        /******/ return getter;
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $2c23f148d58cd887$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($2c23f148d58cd887$var$__webpack_require__.o(definition, key) && !$2c23f148d58cd887$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/global */ /******/ (()=>{
    /******/ $2c23f148d58cd887$var$__webpack_require__.g = function() {
        /******/ if (typeof globalThis === "object") return globalThis;
        /******/ try {
            /******/ return this || new Function("return this")();
        /******/ } catch (e) {
            /******/ if (typeof window === "object") return window;
        /******/ }
    /******/ }();
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $2c23f148d58cd887$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
    /******/ // define __esModule on exports
    /******/ $2c23f148d58cd887$var$__webpack_require__.r = (exports)=>{
        /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module"
        });
        /******/ Object.defineProperty(exports, "__esModule", {
            value: true
        });
    /******/ };
/******/ })();
/******/ /************************************************************************/ var $2c23f148d58cd887$var$__webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(()=>{
    // EXPORTS
    $2c23f148d58cd887$var$__webpack_require__.d($2c23f148d58cd887$var$__webpack_exports__, {
        eKr: ()=>/* reexport */ ActionCompleteEvent,
        yVm: ()=>/* reexport */ ActionContext,
        a7j: ()=>/* reexport */ ActionQueue,
        U_w: ()=>/* reexport */ ActionSequence,
        JF2: ()=>/* reexport */ ActionStartEvent,
        htg: ()=>/* reexport */ ActionsComponent,
        HXL: ()=>/* reexport */ ActionsSystem,
        mcg: ()=>/* reexport */ ActivateEvent,
        Agj: ()=>/* reexport */ Actor,
        u6S: ()=>/* reexport */ AddedComponent,
        x7M: ()=>/* reexport */ AffineMatrix,
        X55: ()=>/* reexport */ Animation,
        m3M: ()=>/* reexport */ AnimationDirection,
        aE5: ()=>/* reexport */ AnimationEvents,
        YJU: ()=>/* reexport */ AnimationStrategy,
        eZi: ()=>/* reexport */ ArcadeSolver,
        GNv: ()=>/* reexport */ AudioContextFactory,
        Y56: ()=>/* reexport */ Axes,
        _0v: ()=>/* reexport */ Axis,
        vhs: ()=>/* reexport */ BaseAlign,
        Z8b: ()=>/* reexport */ Blink,
        Yfw: ()=>/* reexport */ BodyComponent,
        IcQ: ()=>/* reexport */ BoundingBox,
        Rl2: ()=>/* reexport */ BroadphaseStrategy,
        kgJ: ()=>/* reexport */ BrowserComponent,
        GTT: ()=>/* reexport */ BrowserEvents,
        ypY: ()=>/* reexport */ Buttons,
        i7d: ()=>/* reexport */ Camera,
        fQ3: ()=>/* reexport */ CameraEvents,
        HlI: ()=>/* reexport */ Canvas,
        jlt: ()=>/* reexport */ Circle,
        VQc: ()=>/* reexport */ CircleCollider,
        zD7: ()=>/* reexport */ Clock,
        I0I: ()=>/* reexport */ ClosestLine,
        AUF: ()=>/* reexport */ ClosestLineJumpTable,
        JoF: ()=>/* reexport */ Collider,
        MlA: ()=>/* reexport */ ColliderComponent,
        PZh: ()=>/* reexport */ CollisionContact,
        qA: ()=>/* reexport */ CollisionEndEvent,
        CrD: ()=>/* reexport */ CollisionGroup,
        dQK: ()=>/* reexport */ CollisionGroupManager,
        D3r: ()=>/* reexport */ CollisionJumpTable,
        Qpo: ()=>/* reexport */ CollisionPostSolveEvent,
        D9n: ()=>/* reexport */ CollisionPreSolveEvent,
        b6v: ()=>/* reexport */ CollisionStartEvent,
        mvh: ()=>/* reexport */ CollisionSystem,
        Bpo: ()=>/* reexport */ CollisionType,
        Q1f: ()=>/* reexport */ Color,
        IKv: ()=>/* reexport */ ColorBlindFlags,
        fcV: ()=>/* reexport */ ColorBlindnessMode,
        Glf: ()=>/* reexport */ ColorBlindnessPostProcessor,
        uAl: ()=>/* reexport */ Component,
        ElT: ()=>/* reexport */ CompositeCollider,
        MPu: ()=>/* reexport */ Configurable,
        Z8r: ()=>/* reexport */ ConsoleAppender,
        QSL: ()=>/* reexport */ ContactConstraintPoint,
        sPV: ()=>/* reexport */ ContactEndEvent,
        nAn: ()=>/* reexport */ ContactSolveBias,
        zCU: ()=>/* reexport */ ContactStartEvent,
        QrV: ()=>/* reexport */ CoordPlane,
        fF9: ()=>/* reexport */ CrossFade,
        xI8: ()=>/* reexport */ DeactivateEvent,
        yar: ()=>/* reexport */ Debug,
        SP7: ()=>/* reexport */ DebugConfig,
        oRy: ()=>/* reexport */ DebugGraphicsComponent,
        f5X: ()=>/* reexport */ DebugSystem,
        V1c: ()=>/* reexport */ DebugText,
        Mlx: ()=>/* reexport */ DefaultAntialiasOptions,
        ZCo: ()=>/* reexport */ DefaultLoader,
        Vy3: ()=>/* reexport */ DefaultPhysicsConfig,
        J5p: ()=>/* reexport */ DefaultPixelArtOptions,
        mL_: ()=>/* reexport */ DegreeOfFreedom,
        Guw: ()=>/* reexport */ Delay,
        VKx: ()=>/* reexport */ DeprecatedStaticToConfig,
        N5j: ()=>/* reexport */ Detector,
        pgY: ()=>/* reexport */ Die,
        OP3: ()=>/* reexport */ Direction,
        rl5: ()=>/* reexport */ Director,
        eod: ()=>/* reexport */ DirectorEvents,
        q5Z: ()=>/* reexport */ DisplayMode,
        YUC: ()=>/* reexport */ DynamicTree,
        saR: ()=>/* reexport */ DynamicTreeCollisionProcessor,
        hvr: ()=>/* binding */ EX_VERSION,
        Qol: ()=>/* reexport */ EaseBy,
        Wf4: ()=>/* reexport */ EaseTo,
        JCs: ()=>/* reexport */ EasingFunctions,
        gJV: ()=>/* reexport */ EdgeCollider,
        fWD: ()=>/* reexport */ ElasticToActorStrategy,
        Va_: ()=>/* reexport */ EmitterType,
        N$8: ()=>/* reexport */ Engine,
        _jQ: ()=>/* reexport */ EngineEvents,
        rxj: ()=>/* reexport */ EnterTriggerEvent,
        rhv: ()=>/* reexport */ EnterViewPortEvent,
        wCu: ()=>/* reexport */ Entity,
        HAp: ()=>/* reexport */ EntityEvents,
        Zy1: ()=>/* reexport */ EntityManager,
        Qev: ()=>/* reexport */ EventDispatcher,
        bkB: ()=>/* reexport */ EventEmitter,
        wfL: ()=>/* reexport */ EventTypes,
        sVA: ()=>/* reexport */ Events_namespaceObject,
        $Gs: ()=>/* reexport */ ExResponse,
        CJ0: ()=>/* reexport */ ExcaliburGraphicsContext2DCanvas,
        NWh: ()=>/* reexport */ ExcaliburGraphicsContextWebGL,
        tWi: ()=>/* reexport */ ExitTriggerEvent,
        xAj: ()=>/* reexport */ ExitViewPortEvent,
        zWh: ()=>/* reexport */ Fade,
        i_4: ()=>/* reexport */ FadeInOut,
        iIx: ()=>/* reexport */ Flags,
        c9e: ()=>/* reexport */ Follow,
        KQV: ()=>/* reexport */ Font,
        weH: ()=>/* reexport */ FontCache,
        jXp: ()=>/* reexport */ FontSource,
        zzY: ()=>/* reexport */ FontStyle,
        yRQ: ()=>/* reexport */ FontUnit,
        MtE: ()=>/* reexport */ FpsSampler,
        rPj: ()=>/* reexport */ FrameStats,
        KLc: ()=>/* reexport */ Future,
        Fir: ()=>/* reexport */ GameEvent,
        V5f: ()=>/* reexport */ GameStartEvent,
        Xj7: ()=>/* reexport */ GameStopEvent,
        Wud: ()=>/* reexport */ Gamepad,
        FVg: ()=>/* reexport */ GamepadAxisEvent,
        g5Y: ()=>/* reexport */ GamepadButtonEvent,
        YQB: ()=>/* reexport */ GamepadConnectEvent,
        KPb: ()=>/* reexport */ GamepadDisconnectEvent,
        nHK: ()=>/* reexport */ Gamepads,
        TX_: ()=>/* reexport */ Gif,
        r3n: ()=>/* reexport */ GlobalCoordinates,
        vYh: ()=>/* reexport */ Graphic,
        hnk: ()=>/* reexport */ GraphicsComponent,
        D2R: ()=>/* reexport */ GraphicsGroup,
        n1o: ()=>/* reexport */ GraphicsSystem,
        RLG: ()=>/* reexport */ HiddenEvent,
        fBU: ()=>/* reexport */ HorizontalFirst,
        Adb: ()=>/* reexport */ ImageFiltering,
        bEs: ()=>/* reexport */ ImageSource,
        wCy: ()=>/* reexport */ ImageSourceAttributeConstants,
        CbD: ()=>/* reexport */ ImageWrapping,
        x_C: ()=>/* reexport */ InitializeEvent,
        pde: ()=>/* reexport */ Input_Index_namespaceObject,
        pGf: ()=>/* reexport */ InputHost,
        ibQ: ()=>/* reexport */ InputMapper,
        QlN: ()=>/* reexport */ Integrator,
        shR: ()=>/* reexport */ IsometricEntityComponent,
        Yjk: ()=>/* reexport */ IsometricEntitySystem,
        _u1: ()=>/* reexport */ IsometricMap,
        OBI: ()=>/* reexport */ IsometricTile,
        klh: ()=>/* reexport */ KeyEvent,
        s3S: ()=>/* reexport */ Keyboard,
        D$R: ()=>/* reexport */ Keys,
        xth: ()=>/* reexport */ KillEvent,
        JU7: ()=>/* reexport */ Label,
        h9x: ()=>/* reexport */ LimitCameraBoundsStrategy,
        N1A: ()=>/* reexport */ Line,
        e_k: ()=>/* reexport */ LineSegment,
        aHM: ()=>/* reexport */ Loader,
        tlv: ()=>/* reexport */ LoaderEvents,
        Vi9: ()=>/* reexport */ LockCameraToActorAxisStrategy,
        ieR: ()=>/* reexport */ LockCameraToActorStrategy,
        $bb: ()=>/* reexport */ LogLevel,
        VyI: ()=>/* reexport */ Logger,
        imn: ()=>/* reexport */ Material,
        uqu: ()=>/* reexport */ Matrix,
        QnL: ()=>/* reexport */ MatrixLocations,
        vnc: ()=>/* reexport */ MediaEvent,
        wk_: ()=>/* reexport */ Meet,
        GH0: ()=>/* reexport */ MotionComponent,
        _1r: ()=>/* reexport */ MotionSystem,
        l0X: ()=>/* reexport */ MoveBy,
        HHX: ()=>/* reexport */ MoveTo,
        tjk: ()=>/* reexport */ NativePointerButton,
        rWe: ()=>/* reexport */ NativeSoundEvent,
        j9l: ()=>/* reexport */ NativeSoundProcessedEvent,
        NVp: ()=>/* reexport */ None,
        cPK: ()=>/* reexport */ Observable,
        XoL: ()=>/* reexport */ OffscreenSystem,
        RmF: ()=>/* reexport */ Pair,
        DXI: ()=>/* reexport */ ParallaxComponent,
        tCD: ()=>/* reexport */ ParallelActions,
        oGn: ()=>/* reexport */ ParseGif,
        J3D: ()=>/* reexport */ Particle,
        vCJ: ()=>/* reexport */ ParticleEmitter,
        f9l: ()=>/* reexport */ ParticleTransform,
        AQx: ()=>/* reexport */ Physics,
        v9m: ()=>/* reexport */ PhysicsStats,
        yRJ: ()=>/* reexport */ PhysicsWorld,
        EU6: ()=>/* reexport */ PointerAbstraction,
        m3O: ()=>/* reexport */ PointerButton,
        Ryz: ()=>/* reexport */ PointerComponent,
        OxP: ()=>/* reexport */ PointerEvent,
        LEs: ()=>/* reexport */ PointerEventReceiver,
        Ec: ()=>/* reexport */ PointerScope,
        Pi5: ()=>/* reexport */ PointerSystem,
        gmH: ()=>/* reexport */ PointerType,
        tS: ()=>/* reexport */ Polygon,
        XxX: ()=>/* reexport */ PolygonCollider,
        bCz: ()=>/* reexport */ Pool,
        nYS: ()=>/* reexport */ PostCollisionEvent,
        yiT: ()=>/* reexport */ PostDebugDrawEvent,
        NHl: ()=>/* reexport */ PostDrawEvent,
        mO8: ()=>/* reexport */ PostFrameEvent,
        PXI: ()=>/* reexport */ PostKillEvent,
        bn5: ()=>/* reexport */ PostTransformDrawEvent,
        Ywr: ()=>/* reexport */ PostUpdateEvent,
        cMd: ()=>/* reexport */ PreCollisionEvent,
        Bs6: ()=>/* reexport */ PreDebugDrawEvent,
        G0k: ()=>/* reexport */ PreDrawEvent,
        pyn: ()=>/* reexport */ PreFrameEvent,
        QeM: ()=>/* reexport */ PreKillEvent,
        aPX: ()=>/* reexport */ PreLoadEvent,
        ITP: ()=>/* reexport */ PreTransformDrawEvent,
        BY0: ()=>/* reexport */ PreUpdateEvent,
        MFw: ()=>/* reexport */ Projection,
        sBn: ()=>/* reexport */ QuadIndexBuffer,
        S3L: ()=>/* reexport */ QuadTree,
        XKQ: ()=>/* reexport */ Query,
        ESI: ()=>/* reexport */ QueryManager,
        uxz: ()=>/* reexport */ RadiusAroundActorStrategy,
        o8N: ()=>/* reexport */ Random,
        u_r: ()=>/* reexport */ Raster,
        RlV: ()=>/* reexport */ Ray,
        gVA: ()=>/* reexport */ RealisticSolver,
        M_G: ()=>/* reexport */ Rectangle,
        GRB: ()=>/* reexport */ RemovedComponent,
        kM6: ()=>/* reexport */ Repeat,
        dO8: ()=>/* reexport */ RepeatForever,
        jgM: ()=>/* reexport */ Resolution,
        FWq: ()=>/* reexport */ Resource,
        s3j: ()=>/* reexport */ ResourceEvents,
        hlw: ()=>/* reexport */ RotateBy,
        B7e: ()=>/* reexport */ RotateTo,
        H_X: ()=>/* reexport */ RotationType,
        S_d: ()=>/* reexport */ ScaleBy,
        U7E: ()=>/* reexport */ ScaleTo,
        Z58: ()=>/* reexport */ Scene,
        yh2: ()=>/* reexport */ SceneEvents,
        ff$: ()=>/* reexport */ Screen,
        cWi: ()=>/* reexport */ ScreenAppender,
        NBt: ()=>/* reexport */ ScreenElement,
        oNz: ()=>/* reexport */ ScreenEvents,
        QlU: ()=>/* reexport */ ScreenShader,
        Xey: ()=>/* reexport */ ScrollPreventionMode,
        jft: ()=>/* reexport */ Semaphore,
        Mtr: ()=>/* reexport */ Shader,
        ypk: ()=>/* reexport */ Shape,
        mnM: ()=>/* reexport */ Side,
        bAZ: ()=>/* reexport */ SolverStrategy,
        ABN: ()=>/* reexport */ Sound,
        VK6: ()=>/* reexport */ SoundEvents,
        kxk: ()=>/* reexport */ Sprite,
        DT1: ()=>/* reexport */ SpriteFont,
        FLG: ()=>/* reexport */ SpriteSheet,
        qN_: ()=>/* reexport */ StandardClock,
        Z37: ()=>/* reexport */ StateMachine,
        FtL: ()=>/* reexport */ StrategyContainer,
        Z6X: ()=>/* reexport */ Stream,
        iQT: ()=>/* reexport */ System,
        ziO: ()=>/* reexport */ SystemManager,
        OEF: ()=>/* reexport */ SystemPriority,
        uuE: ()=>/* reexport */ SystemType,
        tiv: ()=>/* reexport */ TagQuery,
        T$Y: ()=>/* reexport */ TestClock,
        EYj: ()=>/* reexport */ Text,
        nOB: ()=>/* reexport */ TextAlign,
        Tap: ()=>/* reexport */ TextureLoader,
        FAs: ()=>/* reexport */ Tile,
        B_P: ()=>/* reexport */ TileMap,
        aA5: ()=>/* reexport */ TileMapEvents,
        M4G: ()=>/* reexport */ Timer,
        l$l: ()=>/* reexport */ Toaster,
        dLy: ()=>/* reexport */ transform_Transform,
        WZP: ()=>/* reexport */ TransformComponent,
        eB6: ()=>/* reexport */ Transition,
        nFK: ()=>/* reexport */ TreeNode,
        l9z: ()=>/* reexport */ Trigger,
        YOF: ()=>/* reexport */ TriggerEvents,
        yhB: ()=>/* reexport */ TwoPI,
        J0N: ()=>/* reexport */ Util_Index_namespaceObject,
        Miz: ()=>/* reexport */ Vector,
        Bj4: ()=>/* reexport */ VectorView,
        Rcs: ()=>/* reexport */ VertexBuffer,
        vJ4: ()=>/* reexport */ VertexLayout,
        TqC: ()=>/* reexport */ VerticalFirst,
        nM0: ()=>/* reexport */ VisibleEvent,
        X1u: ()=>/* reexport */ WebAudio,
        SpZ: ()=>/* reexport */ WebAudioInstance,
        DX8: ()=>/* reexport */ WheelDeltaMode,
        Yx$: ()=>/* reexport */ WheelEvent,
        HK4: ()=>/* reexport */ World,
        SE$: ()=>/* reexport */ canonicalizeAngle,
        qE8: ()=>/* reexport */ clamp,
        Pz7: ()=>/* reexport */ coroutine,
        sX_: ()=>/* reexport */ createId,
        JuI: ()=>/* reexport */ frac,
        Nl$: ()=>/* reexport */ hasGraphicsTick,
        OwT: ()=>/* reexport */ hasOnInitialize,
        P$G: ()=>/* reexport */ hasOnPostUpdate,
        mHV: ()=>/* reexport */ hasOnPreUpdate,
        Fx_: ()=>/* reexport */ hasPostDraw,
        WFC: ()=>/* reexport */ hasPreDraw,
        aDq: ()=>/* reexport */ has_initialize,
        jIg: ()=>/* reexport */ has_postupdate,
        UH3: ()=>/* reexport */ has_preupdate,
        K6X: ()=>/* reexport */ isAddedComponent,
        C1Y: ()=>/* reexport */ isComponentCtor,
        Aw1: ()=>/* reexport */ isLoaderConstructor,
        A8$: ()=>/* reexport */ isRemovedComponent,
        hsx: ()=>/* reexport */ isSceneConstructor,
        l9E: ()=>/* reexport */ isScreenElement,
        aSf: ()=>/* reexport */ isSystemConstructor,
        Zex: ()=>/* reexport */ maxMessages,
        mXP: ()=>/* reexport */ obsolete,
        vt$: ()=>/* reexport */ parseImageFiltering,
        hCA: ()=>/* reexport */ parseImageWrapping,
        pjR: ()=>/* reexport */ pixelSnapEpsilon,
        U43: ()=>/* reexport */ randomInRange,
        pSZ: ()=>/* reexport */ randomIntInRange,
        y17: ()=>/* reexport */ range,
        jVr: ()=>/* reexport */ resetObsoleteCounter,
        _SZ: ()=>/* reexport */ sign,
        xWn: ()=>/* reexport */ toDegrees,
        ehJ: ()=>/* reexport */ toRadians,
        t6s: ()=>/* reexport */ vec,
        Eyn: ()=>/* reexport */ webgl_util_namespaceObject
    });
    // NAMESPACE OBJECT: ./Graphics/Context/webgl-util.ts
    var webgl_util_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(webgl_util_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(webgl_util_namespaceObject, {
        getAttributeComponentSize: ()=>getAttributeComponentSize,
        getAttributePointerType: ()=>getAttributePointerType,
        getGLTypeFromSource: ()=>getGLTypeFromSource,
        getGlTypeSizeBytes: ()=>getGlTypeSizeBytes,
        isAttributeInSource: ()=>isAttributeInSource
    });
    // NAMESPACE OBJECT: ./Events.ts
    var Events_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Events_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Events_namespaceObject, {
        ActionCompleteEvent: ()=>ActionCompleteEvent,
        ActionStartEvent: ()=>ActionStartEvent,
        ActivateEvent: ()=>ActivateEvent,
        CollisionEndEvent: ()=>CollisionEndEvent,
        CollisionPostSolveEvent: ()=>CollisionPostSolveEvent,
        CollisionPreSolveEvent: ()=>CollisionPreSolveEvent,
        CollisionStartEvent: ()=>CollisionStartEvent,
        ContactEndEvent: ()=>ContactEndEvent,
        ContactStartEvent: ()=>ContactStartEvent,
        DeactivateEvent: ()=>DeactivateEvent,
        EnterTriggerEvent: ()=>EnterTriggerEvent,
        EnterViewPortEvent: ()=>EnterViewPortEvent,
        EventTypes: ()=>EventTypes,
        ExitTriggerEvent: ()=>ExitTriggerEvent,
        ExitViewPortEvent: ()=>ExitViewPortEvent,
        GameEvent: ()=>GameEvent,
        GameStartEvent: ()=>GameStartEvent,
        GameStopEvent: ()=>GameStopEvent,
        GamepadAxisEvent: ()=>GamepadAxisEvent,
        GamepadButtonEvent: ()=>GamepadButtonEvent,
        GamepadConnectEvent: ()=>GamepadConnectEvent,
        GamepadDisconnectEvent: ()=>GamepadDisconnectEvent,
        HiddenEvent: ()=>HiddenEvent,
        InitializeEvent: ()=>InitializeEvent,
        KillEvent: ()=>KillEvent,
        PostCollisionEvent: ()=>PostCollisionEvent,
        PostDebugDrawEvent: ()=>PostDebugDrawEvent,
        PostDrawEvent: ()=>PostDrawEvent,
        PostFrameEvent: ()=>PostFrameEvent,
        PostKillEvent: ()=>PostKillEvent,
        PostTransformDrawEvent: ()=>PostTransformDrawEvent,
        PostUpdateEvent: ()=>PostUpdateEvent,
        PreCollisionEvent: ()=>PreCollisionEvent,
        PreDebugDrawEvent: ()=>PreDebugDrawEvent,
        PreDrawEvent: ()=>PreDrawEvent,
        PreFrameEvent: ()=>PreFrameEvent,
        PreKillEvent: ()=>PreKillEvent,
        PreTransformDrawEvent: ()=>PreTransformDrawEvent,
        PreUpdateEvent: ()=>PreUpdateEvent,
        VisibleEvent: ()=>VisibleEvent
    });
    // NAMESPACE OBJECT: ./Util/DrawUtil.ts
    var DrawUtil_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(DrawUtil_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(DrawUtil_namespaceObject, {
        circle: ()=>circle,
        line: ()=>line,
        point: ()=>point,
        roundRect: ()=>roundRect,
        vector: ()=>vector
    });
    // NAMESPACE OBJECT: ./Input/Index.ts
    var Input_Index_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Input_Index_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Input_Index_namespaceObject, {
        Axes: ()=>Axes,
        Buttons: ()=>Buttons,
        Gamepad: ()=>Gamepad,
        Gamepads: ()=>Gamepads,
        KeyEvent: ()=>KeyEvent,
        Keyboard: ()=>Keyboard,
        Keys: ()=>Keys,
        NativePointerButton: ()=>NativePointerButton,
        PointerButton: ()=>PointerButton,
        PointerComponent: ()=>PointerComponent,
        PointerEvent: ()=>PointerEvent,
        PointerEventReceiver: ()=>PointerEventReceiver,
        PointerScope: ()=>PointerScope,
        PointerSystem: ()=>PointerSystem,
        PointerType: ()=>PointerType,
        WheelDeltaMode: ()=>WheelDeltaMode,
        WheelEvent: ()=>WheelEvent
    });
    // NAMESPACE OBJECT: ./Util/Index.ts
    var Util_Index_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Util_Index_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Util_Index_namespaceObject, {
        ConsoleAppender: ()=>ConsoleAppender,
        DrawUtil: ()=>DrawUtil_namespaceObject,
        EasingFunctions: ()=>EasingFunctions,
        LogLevel: ()=>LogLevel,
        Logger: ()=>Logger,
        Observable: ()=>Observable,
        ScreenAppender: ()=>ScreenAppender,
        addItemToArray: ()=>addItemToArray,
        contains: ()=>contains,
        delay: ()=>delay,
        fail: ()=>fail,
        getPosition: ()=>getPosition,
        omit: ()=>omit,
        removeItemFromArray: ()=>removeItemFromArray
    });
    // EXTERNAL MODULE: ../../node_modules/core-js/es/array/sort.js
    var sort = $2c23f148d58cd887$var$__webpack_require__(9493);
    // EXTERNAL MODULE: ../../node_modules/core-js/es/object/keys.js
    var keys = $2c23f148d58cd887$var$__webpack_require__(311);
    /**
 * Polyfill adding function
 */ function polyfill() {
        /* istanbul ignore next */ if (typeof window === "undefined") window = {
            audioContext: function() {
                return;
            }
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.requestAnimationFrame) window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
            window.setInterval(callback, 1000 / 60);
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.cancelAnimationFrame) window.cancelAnimationFrame = window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || function() {
            return;
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.AudioContext) {
            if (window.webkitAudioContext) {
                const ctx = window.webkitAudioContext;
                const replaceMe = ctx.prototype.decodeAudioData;
                window.webkitAudioContext.prototype.decodeAudioData = function(arrayBuffer) {
                    return new Promise((resolve, reject)=>{
                        replaceMe.call(this, arrayBuffer, resolve, reject);
                    });
                };
            }
            window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext || window.oAudioContext;
        }
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.devicePixelRatio) window.devicePixelRatio = window.devicePixelRatio || 1;
    }
    /**
 * Flags is a feature flag implementation for Excalibur. They can only be operated **before [[Engine]] construction**
 * after which they are frozen and are read-only.
 *
 * Flags are used to enable experimental or preview features in Excalibur.
 */ class Flags {
        /**
     * Force excalibur to load the Canvas 2D graphics context fallback
     * @warning not all features of excalibur are supported in the Canvas 2D fallback
     */ static useCanvasGraphicsContext() {
            Flags.enable("use-canvas-context");
        }
        /**
     * Freeze all flag modifications making them readonly
     */ static freeze() {
            Flags._FROZEN = true;
        }
        /**
     * Resets internal flag state, not meant to be called by users. Only used for testing.
     *
     * Calling this in your game is UNSUPPORTED
     * @internal
     */ static _reset() {
            Flags._FROZEN = false;
            Flags._FLAGS = {};
        }
        /**
     * Enable a specific feature flag by name. **Note: can only be set before [[Engine]] constructor time**
     * @param flagName
     */ static enable(flagName) {
            if (this._FROZEN) throw Error("Feature flags can only be enabled before Engine constructor time");
            Flags._FLAGS[flagName] = true;
        }
        /**
     * Disable a specific feature flag by name. **Note: can only be set before [[Engine]] constructor time**
     * @param flagName
     */ static disable(flagName) {
            if (this._FROZEN) throw Error("Feature flags can only be disabled before Engine constructor time");
            Flags._FLAGS[flagName] = false;
        }
        /**
     * Check if a flag is enabled. If the flag is disabled or does not exist `false` is returned
     * @param flagName
     */ static isEnabled(flagName) {
            return !!Flags._FLAGS[flagName];
        }
        /**
     * Show a list of currently known flags
     */ static show() {
            return Object.keys(Flags._FLAGS);
        }
    }
    Flags._FROZEN = false;
    Flags._FLAGS = {};
    /**
 * Create a branded ID type from a number
 */ function createId(type, value) {
        return {
            type: type,
            value: value
        };
    }
    /**
 * Future is a wrapper around a native browser Promise to allow resolving/rejecting at any time
 */ class Future {
        constructor(){
            this._isCompleted = false;
            this.promise = new Promise((resolve, reject)=>{
                this._resolver = resolve;
                this._rejecter = reject;
            });
        }
        get isCompleted() {
            return this._isCompleted;
        }
        resolve(value) {
            if (this._isCompleted) return;
            this._isCompleted = true;
            this._resolver(value);
        }
        reject(error) {
            if (this._isCompleted) return;
            this._isCompleted = true;
            this._rejecter(error);
        }
    }
    /**
 * Excalibur's typed event emitter, this allows events to be sent with any string to Type mapping
 */ class EventEmitter {
        constructor(){
            this._paused = false;
            this._listeners = {};
            this._listenersOnce = {};
            this._pipes = [];
        }
        clear() {
            this._listeners = {};
            this._listenersOnce = {};
            this._pipes.length = 0;
        }
        on(eventName, handler) {
            var _a;
            this._listeners[eventName] = (_a = this._listeners[eventName]) !== null && _a !== void 0 ? _a : [];
            this._listeners[eventName].push(handler);
            return {
                close: ()=>this.off(eventName, handler)
            };
        }
        once(eventName, handler) {
            var _a;
            this._listenersOnce[eventName] = (_a = this._listenersOnce[eventName]) !== null && _a !== void 0 ? _a : [];
            this._listenersOnce[eventName].push(handler);
            return {
                close: ()=>this.off(eventName, handler)
            };
        }
        off(eventName, handler) {
            var _a, _b;
            if (handler) {
                const newListeners = (_a = this._listeners[eventName]) === null || _a === void 0 ? void 0 : _a.filter((h)=>h !== handler);
                this._listeners[eventName] = newListeners;
                const newOnceListeners = (_b = this._listenersOnce[eventName]) === null || _b === void 0 ? void 0 : _b.filter((h)=>h !== handler);
                this._listenersOnce[eventName] = newOnceListeners;
            } else delete this._listeners[eventName];
        }
        emit(eventName, event) {
            var _a;
            if (this._paused) return;
            (_a = this._listeners[eventName]) === null || _a === void 0 || _a.forEach((fn)=>fn(event));
            const onces = this._listenersOnce[eventName];
            this._listenersOnce[eventName] = [];
            if (onces) onces.forEach((fn)=>fn(event));
            this._pipes.forEach((pipe)=>{
                pipe.emit(eventName, event);
            });
        }
        pipe(emitter) {
            if (this === emitter) throw Error("Cannot pipe to self");
            this._pipes.push(emitter);
            return {
                close: ()=>{
                    const i = this._pipes.indexOf(emitter);
                    if (i > -1) this._pipes.splice(i, 1);
                }
            };
        }
        unpipe(emitter) {
            const i = this._pipes.indexOf(emitter);
            if (i > -1) this._pipes.splice(i, 1);
        }
        pause() {
            this._paused = true;
        }
        unpause() {
            this._paused = false;
        }
    }
    /**
 * Determines the scope of handling mouse/touch events.
 */ var PointerScope;
    (function(PointerScope) {
        /**
     * Handle events on the `canvas` element only. Events originating outside the
     * `canvas` will not be handled.
     */ PointerScope["Canvas"] = "Canvas";
        /**
     * Handles events on the entire document. All events will be handled by Excalibur.
     */ PointerScope["Document"] = "Document";
    })(PointerScope || (PointerScope = {}));
    /**
 * @module
 * Pseudo-Random Utility
 *
 * A pseudo-random utility to add seeded random support for help in
 * generating things like terrain or reproducible randomness. Uses the
 * [Mersenne Twister](https://en.wikipedia.org/wiki/Mersenne_Twister) algorithm.
 */ /**
 * 32-bit mask
 */ const BITMASK32 = 0xffffffff;
    /**
 * Pseudo-random number generator following the Mersenne_Twister algorithm. Given a seed this generator will produce the same sequence
 * of numbers each time it is called.
 * See https://en.wikipedia.org/wiki/Mersenne_Twister for more details.
 * Uses the MT19937-32 (2002) implementation documented here http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/MT2002/emt19937ar.html
 *
 * Api inspired by http://chancejs.com/# https://github.com/chancejs/chancejs
 */ class Random {
        /**
     * If no seed is specified, the Date.now() is used
     */ constructor(seed){
            this.seed = seed;
            // Separation point of one one word, the number of bits in the lower bitmask 0 <= r <= w-1
            this._lowerMask = 0x7fffffff; // 31 bits same as _r
            this._upperMask = 0x80000000; // 34 high bits
            // Word size, 64 bits
            this._w = 32;
            // Degree of recurrence
            this._n = 624;
            // Middle word, an offset used in the recurrence defining the series x, 1<=m<n
            this._m = 397;
            // coefficients of teh rational normal form twist matrix
            this._a = 0x9908b0df;
            // tempering bit shifts and masks
            this._u = 11;
            this._s = 7;
            this._b = 0x9d2c5680;
            this._t = 15;
            this._c = 0xefc60000;
            this._l = 18;
            this._f = 1812433253;
            this._mt = new Array(this._n);
            // need to mask to support higher bit machines
            this._mt[0] = (seed || Date.now()) >>> 0;
            for(let i = 1; i < this._n; i++){
                const s = this._mt[i - 1] ^ this._mt[i - 1] >>> this._w - 2;
                // numbers are bigger than the JS max safe int, add in 16-bit chunks to prevent IEEE rounding errors on high bits
                this._mt[i] = (this._f * ((s & 0xffff0000) >>> 16) << 16) + this._f * (s & 0xffff) + i >>> 0;
            }
            this._index = this._n;
        }
        /**
     * Apply the twist
     */ _twist() {
            const mag01 = [
                0x0,
                this._a
            ];
            let y = 0, i = 0;
            for(; i < this._n - this._m; i++){
                y = this._mt[i] & this._upperMask | this._mt[i + 1] & this._lowerMask;
                this._mt[i] = this._mt[i + this._m] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            }
            for(; i < this._n - 1; i++){
                y = this._mt[i] & this._upperMask | this._mt[i + 1] & this._lowerMask;
                this._mt[i] = this._mt[i + (this._m - this._n)] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            }
            y = this._mt[this._n - 1] & this._upperMask | this._mt[0] & this._lowerMask;
            this._mt[this._n - 1] = this._mt[this._m - 1] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            this._index = 0;
        }
        /**
     * Return next 32 bit integer number in sequence
     */ nextInt() {
            if (this._index >= this._n) this._twist();
            let y = this._mt[this._index++];
            y ^= y >>> this._u;
            y ^= y << this._s & this._b;
            y ^= y << this._t & this._c;
            y ^= y >>> this._l;
            return y >>> 0;
        }
        /**
     * Return a random floating point number between [0, 1)
     */ next() {
            return this.nextInt() * (1.0 / 4294967296.0); // divided by 2^32
        }
        /**
     * Return a random floating point in range [min, max) min is included, max is not included
     */ floating(min, max) {
            return (max - min) * this.next() + min;
        }
        /**
     * Return a random integer in range [min, max] min is included, max is included.
     * Implemented with rejection sampling, see https://medium.com/@betable/tifu-by-using-math-random-f1c308c4fd9d#.i13tdiu5a
     */ integer(min, max) {
            return Math.floor((max - min + 1) * this.next() + min);
        }
        /**
     * Returns true or false randomly with 50/50 odds by default.
     * By default the likelihood of returning a true is .5 (50%).
     * @param likelihood takes values between [0, 1]
     */ bool(likelihood = 0.5) {
            return this.next() <= likelihood;
        }
        /**
     * Returns one element from an array at random
     */ pickOne(array) {
            return array[this.integer(0, array.length - 1)];
        }
        /**
     * Returns a new array random picking elements from the original
     * @param array Original array to pick from
     * @param numPicks can be any positive number
     * @param allowDuplicates indicates whether the returned set is allowed duplicates (it does not mean there will always be duplicates
     * just that it is possible)
     */ pickSet(array, numPicks, allowDuplicates = false) {
            if (allowDuplicates) return this._pickSetWithDuplicates(array, numPicks);
            else return this._pickSetWithoutDuplicates(array, numPicks);
        }
        /**
     * Returns a new array randomly picking elements in the original (not reused)
     * @param array Array to pick elements out of
     * @param numPicks must be less than or equal to the number of elements in the array.
     */ _pickSetWithoutDuplicates(array, numPicks) {
            if (numPicks > array.length || numPicks < 0) throw new Error("Invalid number of elements to pick, must pick a value 0 < n <= length");
            if (numPicks === array.length) return array;
            const result = new Array(numPicks);
            let currentPick = 0;
            const tempArray = array.slice(0);
            while(currentPick < numPicks){
                const index = this.integer(0, tempArray.length - 1);
                result[currentPick++] = tempArray[index];
                tempArray.splice(index, 1);
            }
            return result;
        }
        /**
     * Returns a new array random picking elements from the original allowing duplicates
     * @param array Array to pick elements out of
     * @param numPicks can be any positive number
     */ _pickSetWithDuplicates(array, numPicks) {
            // Typescript numbers are all floating point, so do we add check for int? (or floor the input?)
            if (numPicks < 0) throw new Error("Invalid number of elements to pick, must pick a value 0 <= n < MAX_INT");
            const result = new Array(numPicks);
            for(let i = 0; i < numPicks; i++)result[i] = this.pickOne(array);
            return result;
        }
        /**
     * Returns a new array that has its elements shuffled. Using the Fisher/Yates method
     * https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
     */ shuffle(array) {
            const tempArray = array.slice(0);
            let swap = null;
            for(let i = 0; i < tempArray.length - 2; i++){
                const randomIndex = this.integer(i, tempArray.length - 1);
                swap = tempArray[i];
                tempArray[i] = tempArray[randomIndex];
                tempArray[randomIndex] = swap;
            }
            return tempArray;
        }
        /**
     * Generate a list of random integer numbers
     * @param length the length of the final array
     * @param min the minimum integer number to generate inclusive
     * @param max the maximum integer number to generate inclusive
     */ range(length, min, max) {
            const result = new Array(length);
            for(let i = 0; i < length; i++)result[i] = this.integer(min, max);
            return result;
        }
        /**
     * Returns the result of a d4 dice roll
     */ d4() {
            return this.integer(1, 4);
        }
        /**
     * Returns the result of a d6 dice roll
     */ d6() {
            return this.integer(1, 6);
        }
        /**
     * Returns the result of a d8 dice roll
     */ d8() {
            return this.integer(1, 8);
        }
        /**
     * Returns the result of a d10 dice roll
     */ d10() {
            return this.integer(1, 10);
        }
        /**
     * Returns the result of a d12 dice roll
     */ d12() {
            return this.integer(1, 12);
        }
        /**
     * Returns the result of a d20 dice roll
     */ d20() {
            return this.integer(1, 20);
        }
    }
    /**
 * Two PI constant
 */ const TwoPI = Math.PI * 2;
    /**
 * Returns the fractional part of a number
 * @param x
 */ function frac(x) {
        if (x >= 0) return x - Math.floor(x);
        else return x - Math.ceil(x);
    }
    /**
 * Returns the sign of a number, if 0 returns 0
 */ function sign(val) {
        if (val === 0) return 0;
        return val < 0 ? -1 : 1;
    }
    /**
 * Clamps a value between a min and max inclusive
 */ function clamp(val, min, max) {
        return Math.min(Math.max(min, val), max);
    }
    /**
 * Convert an angle to be the equivalent in the range [0, 2PI]
 */ function canonicalizeAngle(angle) {
        let tmpAngle = angle;
        if (angle > TwoPI) while(tmpAngle > TwoPI)tmpAngle -= TwoPI;
        if (angle < 0) while(tmpAngle < 0)tmpAngle += TwoPI;
        return tmpAngle;
    }
    /**
 * Convert radians to degrees
 */ function toDegrees(radians) {
        return 180 / Math.PI * radians;
    }
    /**
 * Convert degrees to radians
 */ function toRadians(degrees) {
        return degrees / 180 * Math.PI;
    }
    /**
 * Generate a range of numbers
 * For example: range(0, 5) -> [0, 1, 2, 3, 4, 5]
 * @param from inclusive
 * @param to inclusive
 */ const range = (from, to)=>Array.from(new Array(to - from + 1), (_x, i)=>i + from);
    /**
 * Find a random floating point number in range
 */ function randomInRange(min, max, random = new Random()) {
        return random ? random.floating(min, max) : min + Math.random() * (max - min);
    }
    /**
 * Find a random integer in a range
 */ function randomIntInRange(min, max, random = new Random()) {
        return random ? random.integer(min, max) : Math.round(randomInRange(min, max));
    }
    /**
 * A 2D vector on a plane.
 */ class Vector {
        /**
     * A (0, 0) vector
     */ static get Zero() {
            return new Vector(0, 0);
        }
        /**
     * A (1, 1) vector
     */ static get One() {
            return new Vector(1, 1);
        }
        /**
     * A (0.5, 0.5) vector
     */ static get Half() {
            return new Vector(0.5, 0.5);
        }
        /**
     * A unit vector pointing up (0, -1)
     */ static get Up() {
            return new Vector(0, -1);
        }
        /**
     * A unit vector pointing down (0, 1)
     */ static get Down() {
            return new Vector(0, 1);
        }
        /**
     * A unit vector pointing left (-1, 0)
     */ static get Left() {
            return new Vector(-1, 0);
        }
        /**
     * A unit vector pointing right (1, 0)
     */ static get Right() {
            return new Vector(1, 0);
        }
        /**
     * Returns a vector of unit length in the direction of the specified angle in Radians.
     * @param angle The angle to generate the vector
     */ static fromAngle(angle) {
            return new Vector(Math.cos(angle), Math.sin(angle));
        }
        /**
     * Checks if vector is not null, undefined, or if any of its components are NaN or Infinity.
     */ static isValid(vec) {
            if (vec === null || vec === undefined) return false;
            if (isNaN(vec.x) || isNaN(vec.y)) return false;
            if (vec.x === Infinity || vec.y === Infinity || vec.x === -Infinity || vec.y === -Infinity) return false;
            return true;
        }
        /**
     * Calculates distance between two Vectors
     * @param vec1
     * @param vec2
     */ static distance(vec1, vec2) {
            return Math.sqrt(Math.pow(vec1.x - vec2.x, 2) + Math.pow(vec1.y - vec2.y, 2));
        }
        static min(vec1, vec2) {
            return new Vector(Math.min(vec1.x, vec2.x), Math.min(vec1.y, vec2.y));
        }
        static max(vec1, vec2) {
            return new Vector(Math.max(vec1.x, vec2.x), Math.max(vec1.y, vec2.y));
        }
        /**
     * @param x  X component of the Vector
     * @param y  Y component of the Vector
     */ constructor(x, y){
            this._x = 0;
            this._y = 0;
            this._x = x;
            this._y = y;
        }
        /**
     * Get the x component of the vector
     */ get x() {
            return this._x;
        }
        /**
     * Set the x component, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful setting components on shared vectors, mutating shared vectors can cause hard to find bugs**
     */ set x(val) {
            this._x = val;
        }
        /**
     * Get the y component of the vector
     */ get y() {
            return this._y;
        }
        /**
     * Set the y component, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful setting components on shared vectors, mutating shared vectors can cause hard to find bugs**
     */ set y(val) {
            this._y = val;
        }
        /**
     * Sets the x and y components at once, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful using this, mutating vectors can cause hard to find bugs**
     */ setTo(x, y) {
            this.x = x;
            this.y = y;
        }
        /**
     * Compares this point against another and tests for equality
     * @param vector The other point to compare to
     * @param tolerance Amount of euclidean distance off we are willing to tolerate
     */ equals(vector, tolerance = Vector.EQUALS_EPSILON) {
            return Math.abs(this.x - vector.x) <= tolerance && Math.abs(this.y - vector.y) <= tolerance;
        }
        /**
     * The distance to another vector. If no other Vector is specified, this will return the [[magnitude]].
     * @param v  The other vector. Leave blank to use origin vector.
     */ distance(v) {
            if (!v) return Math.sqrt(this.x * this.x + this.y * this.y);
            const deltaX = this.x - v.x;
            const deltaY = this.y - v.y;
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
        squareDistance(v) {
            if (!v) v = Vector.Zero;
            const deltaX = this.x - v.x;
            const deltaY = this.y - v.y;
            return deltaX * deltaX + deltaY * deltaY;
        }
        /**
     * Clamps the current vector's magnitude mutating it
     * @param magnitude
     */ clampMagnitude(magnitude) {
            const size = this.size;
            const newSize = clamp(size, 0, magnitude);
            this.size = newSize;
            return this;
        }
        /**
     * The size (magnitude) of the Vector
     */ get size() {
            return this.distance();
        }
        /**
     * Setting the size mutates the current vector
     * @warning Can be used to set the size of the vector, **be very careful using this, mutating vectors can cause hard to find bugs**
     */ set size(newLength) {
            const v = this.normalize().scale(newLength);
            this.setTo(v.x, v.y);
        }
        /**
     * Normalizes a vector to have a magnitude of 1.
     */ normalize() {
            const d = this.distance();
            if (d > 0) return new Vector(this.x / d, this.y / d);
            else return new Vector(0, 1);
        }
        /**
     * Returns the average (midpoint) between the current point and the specified
     */ average(vec) {
            return this.add(vec).scale(0.5);
        }
        scale(sizeOrScale, dest) {
            const result = dest || new Vector(0, 0);
            if (sizeOrScale instanceof Vector) {
                result.x = this.x * sizeOrScale.x;
                result.y = this.y * sizeOrScale.y;
            } else {
                result.x = this.x * sizeOrScale;
                result.y = this.y * sizeOrScale;
            }
            return result;
        }
        /**
     * Adds one vector to another
     * @param v The vector to add
     * @param dest Optionally copy the result into a provided vector
     */ add(v, dest) {
            if (dest) {
                dest.x = this.x + v.x;
                dest.y = this.y + v.y;
                return dest;
            }
            return new Vector(this.x + v.x, this.y + v.y);
        }
        /**
     * Subtracts a vector from another, if you subtract vector `B.sub(A)` the resulting vector points from A -> B
     * @param v The vector to subtract
     */ sub(v) {
            return new Vector(this.x - v.x, this.y - v.y);
        }
        /**
     * Adds one vector to this one modifying the original
     * @param v The vector to add
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ addEqual(v) {
            this.setTo(this.x + v.x, this.y + v.y);
            return this;
        }
        /**
     * Subtracts a vector from this one modifying the original
     * @param v The vector to subtract
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ subEqual(v) {
            this.setTo(this.x - v.x, this.y - v.y);
            return this;
        }
        /**
     * Scales this vector by a factor of size and modifies the original
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ scaleEqual(size) {
            this.setTo(this.x * size, this.y * size);
            return this;
        }
        /**
     * Performs a dot product with another vector
     * @param v  The vector to dot
     */ dot(v) {
            return this.x * v.x + this.y * v.y;
        }
        cross(v) {
            if (v instanceof Vector) return this.x * v.y - this.y * v.x;
            else if (typeof v === "number") return new Vector(v * this.y, -v * this.x);
        }
        static cross(num, vec) {
            return new Vector(-num * vec.y, num * vec.x);
        }
        /**
     * Returns the perpendicular vector to this one
     */ perpendicular() {
            return new Vector(this.y, -this.x);
        }
        /**
     * Returns the normal vector to this one, same as the perpendicular of length 1
     */ normal() {
            return this.perpendicular().normalize();
        }
        /**
     * Negate the current vector
     */ negate() {
            return this.scale(-1);
        }
        /**
     * Returns the angle of this vector.
     */ toAngle() {
            return canonicalizeAngle(Math.atan2(this.y, this.x));
        }
        /**
     * Rotates the current vector around a point by a certain angle in radians.
     */ rotate(angle, anchor) {
            if (!anchor) anchor = new Vector(0, 0);
            const sinAngle = Math.sin(angle);
            const cosAngle = Math.cos(angle);
            const x = cosAngle * (this.x - anchor.x) - sinAngle * (this.y - anchor.y) + anchor.x;
            const y = sinAngle * (this.x - anchor.x) + cosAngle * (this.y - anchor.y) + anchor.y;
            return new Vector(x, y);
        }
        /**
     * Creates new vector that has the same values as the previous.
     */ clone(dest) {
            const v = dest !== null && dest !== void 0 ? dest : new Vector(0, 0);
            v.x = this.x;
            v.y = this.y;
            return v;
        }
        /**
     * Returns a string representation of the vector.
     */ toString(fixed) {
            if (fixed) return `(${this.x.toFixed(fixed)}, ${this.y.toFixed(fixed)})`;
            return `(${this.x}, ${this.y})`;
        }
    }
    /**
 * Get or set the vector equals epsilon, by default 0.001 meaning vectors within that tolerance on x or y will be considered equal.
 */ Vector.EQUALS_EPSILON = .001;
    /**
 * Shorthand for creating new Vectors - returns a new Vector instance with the
 * provided X and Y components.
 * @param x  X component of the Vector
 * @param y  Y component of the Vector
 */ function vec(x, y) {
        return new Vector(x, y);
    }
    /**
 * Provides standard colors (e.g. [[Color.Black]])
 * but you can also create custom colors using RGB, HSL, or Hex. Also provides
 * useful color operations like [[Color.lighten]], [[Color.darken]], and more.
 */ class Color {
        /**
     * Creates a new instance of Color from an r, g, b, a
     * @param r  The red component of color (0-255)
     * @param g  The green component of color (0-255)
     * @param b  The blue component of color (0-255)
     * @param a  The alpha component of color (0-1.0)
     */ constructor(r, g, b, a){
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a != null ? a : 1;
        }
        /**
     * Creates a new instance of Color from an r, g, b, a
     * @param r  The red component of color (0-255)
     * @param g  The green component of color (0-255)
     * @param b  The blue component of color (0-255)
     * @param a  The alpha component of color (0-1.0)
     */ static fromRGB(r, g, b, a) {
            return new Color(r, g, b, a);
        }
        /**
     * Creates a new instance of Color from a rgb string
     * @param string  CSS color string of the form rgba(255, 255, 255, 1) or rgb(255, 255, 255)
     */ static fromRGBString(string) {
            const rgbaRegEx = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/i;
            let match = null;
            if (match = string.match(rgbaRegEx)) {
                const r = parseInt(match[1], 10);
                const g = parseInt(match[2], 10);
                const b = parseInt(match[3], 10);
                let a = 1;
                if (match[4]) a = parseFloat(match[4]);
                return new Color(r, g, b, a);
            } else throw new Error("Invalid rgb/a string: " + string);
        }
        /**
     * Creates a new instance of Color from a hex string
     * @param hex  CSS color string of the form #ffffff, the alpha component is optional
     */ static fromHex(hex) {
            const hexRegEx = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i;
            let match = null;
            if (match = hex.match(hexRegEx)) {
                const r = parseInt(match[1], 16);
                const g = parseInt(match[2], 16);
                const b = parseInt(match[3], 16);
                let a = 1;
                if (match[4]) a = parseInt(match[4], 16) / 255;
                return new Color(r, g, b, a);
            } else throw new Error("Invalid hex string: " + hex);
        }
        /**
     * Creates a new instance of Color from hsla values
     * @param h  Hue is represented [0-1]
     * @param s  Saturation is represented [0-1]
     * @param l  Luminance is represented [0-1]
     * @param a  Alpha is represented [0-1]
     */ static fromHSL(h, s, l, a = 1.0) {
            const temp = new HSLColor(h, s, l, a);
            return temp.toRGBA();
        }
        /**
     * Lightens the current color by a specified amount
     * @param factor  The amount to lighten by [0-1]
     */ lighten(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.l += (1 - temp.l) * factor;
            return temp.toRGBA();
        }
        /**
     * Darkens the current color by a specified amount
     * @param factor  The amount to darken by [0-1]
     */ darken(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.l -= temp.l * factor;
            return temp.toRGBA();
        }
        /**
     * Saturates the current color by a specified amount
     * @param factor  The amount to saturate by [0-1]
     */ saturate(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.s += temp.s * factor;
            return temp.toRGBA();
        }
        /**
     * Desaturates the current color by a specified amount
     * @param factor  The amount to desaturate by [0-1]
     */ desaturate(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.s -= temp.s * factor;
            return temp.toRGBA();
        }
        /**
     * Multiplies a color by another, results in a darker color
     * @param color  The other color
     */ multiply(color) {
            const newR = color.r / 255 * this.r / 255 * 255;
            const newG = color.g / 255 * this.g / 255 * 255;
            const newB = color.b / 255 * this.b / 255 * 255;
            const newA = color.a * this.a;
            return new Color(newR, newG, newB, newA);
        }
        /**
     * Screens a color by another, results in a lighter color
     * @param color  The other color
     */ screen(color) {
            const color1 = color.invert();
            const color2 = color.invert();
            return color1.multiply(color2).invert();
        }
        /**
     * Inverts the current color
     */ invert() {
            return new Color(255 - this.r, 255 - this.g, 255 - this.b, 1.0 - this.a);
        }
        /**
     * Averages the current color with another
     * @param color  The other color
     */ average(color) {
            const newR = (color.r + this.r) / 2;
            const newG = (color.g + this.g) / 2;
            const newB = (color.b + this.b) / 2;
            const newA = (color.a + this.a) / 2;
            return new Color(newR, newG, newB, newA);
        }
        equal(color) {
            return this.toString() === color.toString();
        }
        /**
     * Returns a CSS string representation of a color.
     * @param format Color representation, accepts: rgb, hsl, or hex
     */ toString(format = "rgb") {
            switch(format){
                case "rgb":
                    return this.toRGBA();
                case "hsl":
                    return this.toHSLA();
                case "hex":
                    return this.toHex();
                default:
                    throw new Error("Invalid Color format");
            }
        }
        /**
     * Returns Hex Value of a color component
     * @param c color component
     * @see https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
     */ _componentToHex(c) {
            // Handle negative and fractional numbers
            const hex = Math.max(Math.round(c), 0).toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }
        /**
     * Return Hex representation of a color.
     */ toHex() {
            let hexRepresentation = "#" + this._componentToHex(this.r) + this._componentToHex(this.g) + this._componentToHex(this.b);
            if (this.a !== 1) hexRepresentation += this._componentToHex(this.a * 255);
            return hexRepresentation;
        }
        /**
     * Return RGBA representation of a color.
     */ toRGBA() {
            const result = String(this.r.toFixed(0)) + ", " + String(this.g.toFixed(0)) + ", " + String(this.b.toFixed(0));
            if (this.a !== undefined || this.a !== null) return "rgba(" + result + ", " + String(this.a) + ")";
            return "rgb(" + result + ")";
        }
        /**
     * Return HSLA representation of a color.
     */ toHSLA() {
            return HSLColor.fromRGBA(this.r, this.g, this.b, this.a).toString();
        }
        /**
     * Returns a CSS string representation of a color.
     */ fillStyle() {
            return this.toString();
        }
        /**
     * Returns a clone of the current color.
     */ clone() {
            return new Color(this.r, this.g, this.b, this.a);
        }
        /**
     * Black (#000000)
     */ static get Black() {
            return Color.fromHex("#000000");
        }
        /**
     * White (#FFFFFF)
     */ static get White() {
            return Color.fromHex("#FFFFFF");
        }
        /**
     * Gray (#808080)
     */ static get Gray() {
            return Color.fromHex("#808080");
        }
        /**
     * Light gray (#D3D3D3)
     */ static get LightGray() {
            return Color.fromHex("#D3D3D3");
        }
        /**
     * Dark gray (#A9A9A9)
     */ static get DarkGray() {
            return Color.fromHex("#A9A9A9");
        }
        /**
     * Yellow (#FFFF00)
     */ static get Yellow() {
            return Color.fromHex("#FFFF00");
        }
        /**
     * Orange (#FFA500)
     */ static get Orange() {
            return Color.fromHex("#FFA500");
        }
        /**
     * Red (#FF0000)
     */ static get Red() {
            return Color.fromHex("#FF0000");
        }
        /**
     * Vermilion (#FF5B31)
     */ static get Vermilion() {
            return Color.fromHex("#FF5B31");
        }
        /**
     * Rose (#FF007F)
     */ static get Rose() {
            return Color.fromHex("#FF007F");
        }
        /**
     * Magenta (#FF00FF)
     */ static get Magenta() {
            return Color.fromHex("#FF00FF");
        }
        /**
     * Violet (#7F00FF)
     */ static get Violet() {
            return Color.fromHex("#7F00FF");
        }
        /**
     * Blue (#0000FF)
     */ static get Blue() {
            return Color.fromHex("#0000FF");
        }
        /**
     * Azure (#007FFF)
     */ static get Azure() {
            return Color.fromHex("#007FFF");
        }
        /**
     * Cyan (#00FFFF)
     */ static get Cyan() {
            return Color.fromHex("#00FFFF");
        }
        /**
     * Viridian (#59978F)
     */ static get Viridian() {
            return Color.fromHex("#59978F");
        }
        /**
     * Green (#00FF00)
     */ static get Green() {
            return Color.fromHex("#00FF00");
        }
        /**
     * Chartreuse (#7FFF00)
     */ static get Chartreuse() {
            return Color.fromHex("#7FFF00");
        }
        /**
     * Transparent (#FFFFFF00)
     */ static get Transparent() {
            return Color.fromHex("#FFFFFF00");
        }
        /**
     * ExcaliburBlue (#176BAA)
     */ static get ExcaliburBlue() {
            return Color.fromHex("#176BAA");
        }
    }
    /**
 * Internal HSL Color representation
 *
 * http://en.wikipedia.org/wiki/HSL_and_HSV
 * http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c
 */ class HSLColor {
        constructor(h, s, l, a){
            this.h = h;
            this.s = s;
            this.l = l;
            this.a = a;
        }
        static hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        static fromRGBA(r, g, b, a) {
            r /= 255;
            g /= 255;
            b /= 255;
            const max = Math.max(r, g, b), min = Math.min(r, g, b);
            let h, s;
            const l = (max + min) / 2;
            if (max === min) h = s = 0; // achromatic
            else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return new HSLColor(h, s, l, a);
        }
        toRGBA() {
            let r, g, b;
            if (this.s === 0) r = g = b = this.l; // achromatic
            else {
                const q = this.l < 0.5 ? this.l * (1 + this.s) : this.l + this.s - this.l * this.s;
                const p = 2 * this.l - q;
                r = HSLColor.hue2rgb(p, q, this.h + 1 / 3);
                g = HSLColor.hue2rgb(p, q, this.h);
                b = HSLColor.hue2rgb(p, q, this.h - 1 / 3);
            }
            return new Color(r * 255, g * 255, b * 255, this.a);
        }
        toString() {
            const h = this.h.toFixed(0), s = this.s.toFixed(0), l = this.l.toFixed(0), a = this.a.toFixed(0);
            return `hsla(${h}, ${s}, ${l}, ${a})`;
        }
    }
    /* eslint-disable no-console */ /**
 * Logging level that Excalibur will tag
 */ var LogLevel;
    (function(LogLevel) {
        LogLevel[LogLevel["Debug"] = 0] = "Debug";
        LogLevel[LogLevel["Info"] = 1] = "Info";
        LogLevel[LogLevel["Warn"] = 2] = "Warn";
        LogLevel[LogLevel["Error"] = 3] = "Error";
        LogLevel[LogLevel["Fatal"] = 4] = "Fatal";
    })(LogLevel || (LogLevel = {}));
    /**
 * Static singleton that represents the logging facility for Excalibur.
 * Excalibur comes built-in with a [[ConsoleAppender]] and [[ScreenAppender]].
 * Derive from [[Appender]] to create your own logging appenders.
 */ class Logger {
        constructor(){
            this._appenders = [];
            /**
         * Gets or sets the default logging level. Excalibur will only log
         * messages if equal to or above this level. Default: [[LogLevel.Info]]
         */ this.defaultLevel = LogLevel.Info;
            this._logOnceSet = new Set();
            if (Logger._INSTANCE) throw new Error("Logger is a singleton");
            Logger._INSTANCE = this;
            // Default console appender
            Logger._INSTANCE.addAppender(new ConsoleAppender());
            return Logger._INSTANCE;
        }
        /**
     * Gets the current static instance of Logger
     */ static getInstance() {
            if (Logger._INSTANCE == null) Logger._INSTANCE = new Logger();
            return Logger._INSTANCE;
        }
        /**
     * Adds a new [[Appender]] to the list of appenders to write to
     */ addAppender(appender) {
            this._appenders.push(appender);
        }
        /**
     * Clears all appenders from the logger
     */ clearAppenders() {
            this._appenders.length = 0;
        }
        /**
     * Logs a message at a given LogLevel
     * @param level  The LogLevel`to log the message at
     * @param args   An array of arguments to write to an appender
     */ _log(level, args) {
            if (level == null) level = this.defaultLevel;
            const len = this._appenders.length;
            for(let i = 0; i < len; i++)if (level >= this.defaultLevel) this._appenders[i].log(level, args);
        }
        _logOnce(level, args) {
            const serialized = level + args.join("+");
            if (this._logOnceSet.has(serialized)) return;
            else {
                this._logOnceSet.add(serialized);
                this._log(level, args);
            }
        }
        /**
     * Writes a log message at the [[LogLevel.Debug]] level
     * @param args  Accepts any number of arguments
     */ debug(...args) {
            this._log(LogLevel.Debug, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Fatal]] level, if it sees the same args again it wont log
     * @param args  Accepts any number of arguments
     */ debugOnce(...args) {
            this._logOnce(LogLevel.Debug, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Info]] level
     * @param args  Accepts any number of arguments
     */ info(...args) {
            this._log(LogLevel.Info, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Info]] level, if it sees the same args again it wont log
     * @param args  Accepts any number of arguments
     */ infoOnce(...args) {
            this._logOnce(LogLevel.Info, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Warn]] level
     * @param args  Accepts any number of arguments
     */ warn(...args) {
            this._log(LogLevel.Warn, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Warn]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ warnOnce(...args) {
            this._logOnce(LogLevel.Warn, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Error]] level
     * @param args  Accepts any number of arguments
     */ error(...args) {
            this._log(LogLevel.Error, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Error]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ errorOnce(...args) {
            this._logOnce(LogLevel.Error, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Fatal]] level
     * @param args  Accepts any number of arguments
     */ fatal(...args) {
            this._log(LogLevel.Fatal, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Fatal]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ fatalOnce(...args) {
            this._logOnce(LogLevel.Fatal, args);
        }
    }
    Logger._INSTANCE = null;
    /**
 * Console appender for browsers (i.e. `console.log`)
 */ class ConsoleAppender {
        /**
     * Logs a message at the given [[LogLevel]]
     * @param level  Level to log at
     * @param args   Arguments to log
     */ log(level, args) {
            // Check for console support
            if (!console && !console.log && console.warn && console.error) // todo maybe do something better than nothing
            return;
            // Create a new console args array
            const consoleArgs = [];
            consoleArgs.unshift.apply(consoleArgs, args);
            consoleArgs.unshift("[" + LogLevel[level] + "] : ");
            if (level < LogLevel.Warn) {
                // Call .log for Debug/Info
                if (console.log.apply) // this is required on some older browsers that don't support apply on console.log :(
                console.log.apply(console, consoleArgs);
                else console.log(consoleArgs.join(" "));
            } else if (level < LogLevel.Error) {
                // Call .warn for Warn
                if (console.warn.apply) console.warn.apply(console, consoleArgs);
                else console.warn(consoleArgs.join(" "));
            } else // Call .error for Error/Fatal
            if (console.error.apply) console.error.apply(console, consoleArgs);
            else console.error(consoleArgs.join(" "));
        }
    }
    /**
 * On-screen (canvas) appender
 */ class ScreenAppender {
        constructor(options){
            var _a, _b;
            this._messages = [];
            this._pos = 10;
            this._color = Color.Black;
            this._options = options;
            this.canvas = document.createElement("canvas");
            this._ctx = this.canvas.getContext("2d");
            this.canvas.style.position = "absolute";
            this.canvas.style.zIndex = (_b = (_a = options.zIndex) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "99";
            document.body.appendChild(this.canvas);
            this._positionScreenAppenderCanvas();
            options.engine.screen.events.on("resize", ()=>{
                this._positionScreenAppenderCanvas();
            });
        }
        _positionScreenAppenderCanvas() {
            var _a, _b, _c, _d;
            const options = this._options;
            this.canvas.width = (_a = options.width) !== null && _a !== void 0 ? _a : options.engine.screen.resolution.width;
            this.canvas.height = (_b = options.height) !== null && _b !== void 0 ? _b : options.engine.screen.resolution.height;
            this.canvas.style.position = "absolute";
            const pagePos = options.engine.screen.screenToPageCoordinates(vec(0, 0));
            this.canvas.style.left = pagePos.x + "px";
            this.canvas.style.top = pagePos.y + "px";
            this._pos = (_c = options.xPos) !== null && _c !== void 0 ? _c : this._pos;
            this._color = (_d = options.color) !== null && _d !== void 0 ? _d : this._color;
        }
        /**
     * Logs a message at the given [[LogLevel]]
     * @param level  Level to log at
     * @param args   Arguments to log
     */ log(level, args) {
            const message = args.join(",");
            this._ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this._messages.unshift("[" + LogLevel[level] + "] : " + message);
            let pos = 10;
            this._messages = this._messages.slice(0, 1000);
            for(let i = 0; i < this._messages.length; i++){
                this._ctx.fillStyle = this._color.toRGBA();
                this._ctx.fillText(this._messages[i], this._pos, pos);
                pos += 10;
            }
        }
    }
    /**
 * An enum that describes the sides of an axis aligned box for collision
 */ var Side;
    (function(Side) {
        Side["None"] = "None";
        Side["Top"] = "Top";
        Side["Bottom"] = "Bottom";
        Side["Left"] = "Left";
        Side["Right"] = "Right";
    })(Side || (Side = {}));
    (function(Side) {
        /**
     * Returns the opposite side from the current
     */ function getOpposite(side) {
            if (side === Side.Top) return Side.Bottom;
            if (side === Side.Bottom) return Side.Top;
            if (side === Side.Left) return Side.Right;
            if (side === Side.Right) return Side.Left;
            return Side.None;
        }
        Side.getOpposite = getOpposite;
        /**
     * Given a vector, return the Side most in that direction (via dot product)
     */ function fromDirection(direction) {
            const directions = [
                Vector.Left,
                Vector.Right,
                Vector.Up,
                Vector.Down
            ];
            const directionEnum = [
                Side.Left,
                Side.Right,
                Side.Top,
                Side.Bottom
            ];
            let max = -Number.MAX_VALUE;
            let maxIndex = -1;
            for(let i = 0; i < directions.length; i++)if (directions[i].dot(direction) > max) {
                max = directions[i].dot(direction);
                maxIndex = i;
            }
            return directionEnum[maxIndex];
        }
        Side.fromDirection = fromDirection;
    })(Side || (Side = {}));
    /**
 * Axis Aligned collision primitive for Excalibur.
 */ class BoundingBox {
        /**
     * Constructor allows passing of either an object with all coordinate components,
     * or the coordinate components passed separately.
     * @param leftOrOptions    Either x coordinate of the left edge or an options object
     * containing the four coordinate components.
     * @param top     y coordinate of the top edge
     * @param right   x coordinate of the right edge
     * @param bottom  y coordinate of the bottom edge
     */ constructor(leftOrOptions = 0, top = 0, right = 0, bottom = 0){
            // Cache bounding box point returns
            this._points = [];
            if (typeof leftOrOptions === "object") {
                this.left = leftOrOptions.left;
                this.top = leftOrOptions.top;
                this.right = leftOrOptions.right;
                this.bottom = leftOrOptions.bottom;
            } else if (typeof leftOrOptions === "number") {
                this.left = leftOrOptions;
                this.top = top;
                this.right = right;
                this.bottom = bottom;
            }
        }
        /**
     * Returns a new instance of [[BoundingBox]] that is a copy of the current instance
     */ clone() {
            return new BoundingBox(this.left, this.top, this.right, this.bottom);
        }
        /**
     * Given bounding box A & B, returns the side relative to A when intersection is performed.
     * @param intersection Intersection vector between 2 bounding boxes
     */ static getSideFromIntersection(intersection) {
            if (!intersection) return Side.None;
            if (intersection) {
                if (Math.abs(intersection.x) > Math.abs(intersection.y)) {
                    if (intersection.x < 0) return Side.Right;
                    return Side.Left;
                } else {
                    if (intersection.y < 0) return Side.Bottom;
                    return Side.Top;
                }
            }
            return Side.None;
        }
        static fromPoints(points) {
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for(let i = 0; i < points.length; i++){
                if (points[i].x < minX) minX = points[i].x;
                if (points[i].x > maxX) maxX = points[i].x;
                if (points[i].y < minY) minY = points[i].y;
                if (points[i].y > maxY) maxY = points[i].y;
            }
            return new BoundingBox(minX, minY, maxX, maxY);
        }
        /**
     * Creates a bounding box from a width and height
     * @param width
     * @param height
     * @param anchor Default Vector.Half
     * @param pos Default Vector.Zero
     */ static fromDimension(width, height, anchor = Vector.Half, pos = Vector.Zero) {
            return new BoundingBox(-width * anchor.x + pos.x, -height * anchor.y + pos.y, width - width * anchor.x + pos.x, height - height * anchor.y + pos.y);
        }
        /**
     * Returns the calculated width of the bounding box
     */ get width() {
            return this.right - this.left;
        }
        /**
     * Returns the calculated height of the bounding box
     */ get height() {
            return this.bottom - this.top;
        }
        /**
     * Return whether the bounding box has zero dimensions in height,width or both
     */ hasZeroDimensions() {
            return this.width === 0 || this.height === 0;
        }
        /**
     * Returns the center of the bounding box
     */ get center() {
            return new Vector((this.left + this.right) / 2, (this.top + this.bottom) / 2);
        }
        get topLeft() {
            return new Vector(this.left, this.top);
        }
        get bottomRight() {
            return new Vector(this.right, this.bottom);
        }
        get topRight() {
            return new Vector(this.right, this.top);
        }
        get bottomLeft() {
            return new Vector(this.left, this.bottom);
        }
        translate(pos) {
            return new BoundingBox(this.left + pos.x, this.top + pos.y, this.right + pos.x, this.bottom + pos.y);
        }
        /**
     * Rotates a bounding box by and angle and around a point, if no point is specified (0, 0) is used by default. The resulting bounding
     * box is also axis-align. This is useful when a new axis-aligned bounding box is needed for rotated geometry.
     */ rotate(angle, point = Vector.Zero) {
            const points = this.getPoints().map((p)=>p.rotate(angle, point));
            return BoundingBox.fromPoints(points);
        }
        /**
     * Scale a bounding box by a scale factor, optionally provide a point
     * @param scale
     * @param point
     */ scale(scale, point = Vector.Zero) {
            const shifted = this.translate(point);
            return new BoundingBox(shifted.left * scale.x, shifted.top * scale.y, shifted.right * scale.x, shifted.bottom * scale.y);
        }
        /**
     * Transform the axis aligned bounding box by a [[Matrix]], producing a new axis aligned bounding box
     * @param matrix
     */ transform(matrix) {
            // inlined these calculations to not use vectors would speed it up slightly
            // const matFirstColumn = vec(matrix.data[0], matrix.data[1]);
            // const xa = matFirstColumn.scale(this.left);
            const xa1 = matrix.data[0] * this.left;
            const xa2 = matrix.data[1] * this.left;
            // const xb = matFirstColumn.scale(this.right);
            const xb1 = matrix.data[0] * this.right;
            const xb2 = matrix.data[1] * this.right;
            // const matSecondColumn = vec(matrix.data[2], matrix.data[3]);
            // const ya = matSecondColumn.scale(this.top);
            const ya1 = matrix.data[2] * this.top;
            const ya2 = matrix.data[3] * this.top;
            // const yb = matSecondColumn.scale(this.bottom);
            const yb1 = matrix.data[2] * this.bottom;
            const yb2 = matrix.data[3] * this.bottom;
            const matrixPos = matrix.getPosition();
            // const topLeft = Vector.min(xa, xb).add(Vector.min(ya, yb)).add(matrixPos);
            // const bottomRight = Vector.max(xa, xb).add(Vector.max(ya, yb)).add(matrixPos);
            const left = Math.min(xa1, xb1) + Math.min(ya1, yb1) + matrixPos.x;
            const top = Math.min(xa2, xb2) + Math.min(ya2, yb2) + matrixPos.y;
            const right = Math.max(xa1, xb1) + Math.max(ya1, yb1) + matrixPos.x;
            const bottom = Math.max(xa2, xb2) + Math.max(ya2, yb2) + matrixPos.y;
            return new BoundingBox({
                left: left,
                top: top,
                right: right,
                bottom: bottom //: bottomRight.y
            });
        }
        /**
     * Returns the perimeter of the bounding box
     */ getPerimeter() {
            const wx = this.width;
            const wy = this.height;
            return 2 * (wx + wy);
        }
        /**
     * Returns the world space points that make up the corners of the bounding box as a polygon
     */ getPoints() {
            if (this._left !== this.left || this._right !== this.right || this._top !== this.top || this._bottom !== this.bottom) {
                this._points.length = 0;
                this._points.push(new Vector(this.left, this.top));
                this._points.push(new Vector(this.right, this.top));
                this._points.push(new Vector(this.right, this.bottom));
                this._points.push(new Vector(this.left, this.bottom));
                this._left = this.left;
                this._right = this.right;
                this._top = this.top;
                this._bottom = this.bottom;
            }
            return this._points;
        }
        /**
     * Determines whether a ray intersects with a bounding box
     */ rayCast(ray, farClipDistance = Infinity) {
            // algorithm from https://tavianator.com/fast-branchless-raybounding-box-intersections/
            let tmin = -Infinity;
            let tmax = Infinity;
            const xinv = ray.dir.x === 0 ? Number.MAX_VALUE : 1 / ray.dir.x;
            const yinv = ray.dir.y === 0 ? Number.MAX_VALUE : 1 / ray.dir.y;
            const tx1 = (this.left - ray.pos.x) * xinv;
            const tx2 = (this.right - ray.pos.x) * xinv;
            tmin = Math.min(tx1, tx2);
            tmax = Math.max(tx1, tx2);
            const ty1 = (this.top - ray.pos.y) * yinv;
            const ty2 = (this.bottom - ray.pos.y) * yinv;
            tmin = Math.max(tmin, Math.min(ty1, ty2));
            tmax = Math.min(tmax, Math.max(ty1, ty2));
            return tmax >= Math.max(0, tmin) && tmin < farClipDistance;
        }
        rayCastTime(ray, farClipDistance = Infinity) {
            // algorithm from https://tavianator.com/fast-branchless-raybounding-box-intersections/
            let tmin = -Infinity;
            let tmax = Infinity;
            const xinv = ray.dir.x === 0 ? Number.MAX_VALUE : 1 / ray.dir.x;
            const yinv = ray.dir.y === 0 ? Number.MAX_VALUE : 1 / ray.dir.y;
            const tx1 = (this.left - ray.pos.x) * xinv;
            const tx2 = (this.right - ray.pos.x) * xinv;
            tmin = Math.min(tx1, tx2);
            tmax = Math.max(tx1, tx2);
            const ty1 = (this.top - ray.pos.y) * yinv;
            const ty2 = (this.bottom - ray.pos.y) * yinv;
            tmin = Math.max(tmin, Math.min(ty1, ty2));
            tmax = Math.min(tmax, Math.max(ty1, ty2));
            if (tmax >= Math.max(0, tmin) && tmin < farClipDistance) return tmin;
            return -1;
        }
        contains(val) {
            if (val instanceof Vector) return this.left <= val.x && this.top <= val.y && this.bottom >= val.y && this.right >= val.x;
            else if (val instanceof BoundingBox) {
                if (this.left <= val.left && this.top <= val.top && val.bottom <= this.bottom && val.right <= this.right) return true;
                return false;
            }
            return false;
        }
        /**
     * Combines this bounding box and another together returning a new bounding box
     * @param other  The bounding box to combine
     */ combine(other) {
            const compositeBB = new BoundingBox(Math.min(this.left, other.left), Math.min(this.top, other.top), Math.max(this.right, other.right), Math.max(this.bottom, other.bottom));
            return compositeBB;
        }
        get dimensions() {
            return new Vector(this.width, this.height);
        }
        /**
     * Returns true if the bounding boxes overlap.
     * @param other
     * @param epsilon Optionally specify a small epsilon (default 0) as amount of overlap to ignore as overlap.
     * This epsilon is useful in stable collision simulations.
     */ overlaps(other, epsilon) {
            const e = epsilon || 0;
            if (other.hasZeroDimensions()) return this.contains(other);
            if (this.hasZeroDimensions()) return other.contains(this);
            const totalBoundingBox = this.combine(other);
            return totalBoundingBox.width + e < other.width + this.width && totalBoundingBox.height + e < other.height + this.height;
        }
        /**
     * Test wether this bounding box intersects with another returning
     * the intersection vector that can be used to resolve the collision. If there
     * is no intersection null is returned.
     * @param other  Other [[BoundingBox]] to test intersection with
     * @returns A Vector in the direction of the current BoundingBox, this <- other
     */ intersect(other) {
            const totalBoundingBox = this.combine(other);
            // If the total bounding box is less than or equal the sum of the 2 bounds then there is collision
            if (totalBoundingBox.width < other.width + this.width && totalBoundingBox.height < other.height + this.height && !totalBoundingBox.dimensions.equals(other.dimensions) && !totalBoundingBox.dimensions.equals(this.dimensions)) {
                // collision
                let overlapX = 0;
                // right edge is between the other's left and right edge
                /**
             *     +-this-+
             *     |      |
             *     |    +-other-+
             *     +----|-+     |
             *          |       |
             *          +-------+
             *         <---
             *          ^ overlap
             */ if (this.right >= other.left && this.right <= other.right) overlapX = other.left - this.right;
                else overlapX = other.right - this.left;
                let overlapY = 0;
                // top edge is between the other's top and bottom edge
                /**
             *     +-other-+
             *     |       |
             *     |    +-this-+   | <- overlap
             *     +----|--+   |   |
             *          |      |  \ /
             *          +------+   '
             */ if (this.top <= other.bottom && this.top >= other.top) overlapY = other.bottom - this.top;
                else overlapY = other.top - this.bottom;
                if (Math.abs(overlapX) < Math.abs(overlapY)) return new Vector(overlapX, 0);
                else return new Vector(0, overlapY);
            // Case of total containment of one bounding box by another
            } else if (totalBoundingBox.dimensions.equals(other.dimensions) || totalBoundingBox.dimensions.equals(this.dimensions)) {
                let overlapX = 0;
                // this is wider than the other
                if (this.width - other.width >= 0) {
                    // This right edge is closest to the others right edge
                    if (this.right - other.right <= other.left - this.left) overlapX = other.left - this.right;
                    else overlapX = other.right - this.left;
                } else // This right edge is closest to the others right edge
                if (other.right - this.right <= this.left - other.left) overlapX = this.left - other.right;
                else overlapX = this.right - other.left;
                let overlapY = 0;
                // this is taller than other
                if (this.height - other.height >= 0) {
                    // The bottom edge is closest to the others bottom edge
                    if (this.bottom - other.bottom <= other.top - this.top) overlapY = other.top - this.bottom;
                    else overlapY = other.bottom - this.top;
                } else // The bottom edge is closest to the others bottom edge
                if (other.bottom - this.bottom <= this.top - other.top) overlapY = this.top - other.bottom;
                else overlapY = this.bottom - other.top;
                if (Math.abs(overlapX) < Math.abs(overlapY)) return new Vector(overlapX, 0);
                else return new Vector(0, overlapY);
            } else return null;
        }
        /**
     * Test whether the bounding box has intersected with another bounding box, returns the side of the current bb that intersected.
     * @param bb The other actor to test
     */ intersectWithSide(bb) {
            const intersect = this.intersect(bb);
            return BoundingBox.getSideFromIntersection(intersect);
        }
        /**
     * Draw a debug bounding box
     * @param ex
     * @param color
     */ draw(ex, color = Color.Yellow) {
            ex.debug.drawRect(this.left, this.top, this.width, this.height, {
                color: color
            });
        }
    }
    /**
 * Find the screen position of an HTML element
 */ function getPosition(el) {
        // do we need the scroll too? technically the offset method before did that
        if (el) {
            const rect = el.getBoundingClientRect();
            return vec(rect.x + window.scrollX, rect.y + window.scrollY);
        }
        return Vector.Zero;
    }
    /**
 * Add an item to an array list if it doesn't already exist. Returns true if added, false if not and already exists in the array.
 * @deprecated Will be removed in v0.26.0
 */ function addItemToArray(item, array) {
        if (array.indexOf(item) === -1) {
            array.push(item);
            return true;
        }
        return false;
    }
    /**
 * Remove an item from an list
 * @deprecated Will be removed in v0.26.0
 */ function removeItemFromArray(item, array) {
        let index = -1;
        if ((index = array.indexOf(item)) > -1) {
            array.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
 * See if an array contains something
 */ function contains(array, obj) {
        for(let i = 0; i < array.length; i++){
            if (array[i] === obj) return true;
        }
        return false;
    }
    /**
 * Used for exhaustive checks at compile time
 */ function fail(message) {
        throw new Error(message);
    }
    /**
 * Create a promise that resolves after a certain number of milliseconds
 *
 * It is strongly recommended you pass the excalibur clock so delays are bound to the
 * excalibur clock which would be unaffected by stop/pause.
 * @param milliseconds
 * @param clock
 */ function delay(milliseconds, clock) {
        var _a;
        const future = new Future();
        const schedule = (_a = clock === null || clock === void 0 ? void 0 : clock.schedule.bind(clock)) !== null && _a !== void 0 ? _a : setTimeout;
        schedule(()=>{
            future.resolve();
        }, milliseconds);
        return future.promise;
    }
    /**
 * Remove keys from object literals
 * @param object
 * @param keys
 */ function omit(object, keys) {
        const newObj = {};
        for(const key in object)if (!keys.includes(key)) newObj[key] = object[key];
        return newObj;
    }
    var MatrixLocations;
    (function(MatrixLocations) {
        MatrixLocations[MatrixLocations["X"] = 12] = "X";
        MatrixLocations[MatrixLocations["Y"] = 13] = "Y";
    })(MatrixLocations || (MatrixLocations = {}));
    /**
 * Excalibur Matrix helper for 4x4 matrices
 *
 * Useful for webgl 4x4 matrices
 */ class Matrix {
        constructor(){
            /**
         *  4x4 matrix in column major order
         *
         * |         |         |          |          |
         * | ------- | ------- | -------- | -------- |
         * | data[0] | data[4] | data[8]  | data[12] |
         * | data[1] | data[5] | data[9]  | data[13] |
         * | data[2] | data[6] | data[10] | data[14] |
         * | data[3] | data[7] | data[11] | data[15] |
         *
         */ this.data = new Float32Array(16);
            this._scaleX = 1;
            this._scaleSignX = 1;
            this._scaleY = 1;
            this._scaleSignY = 1;
        }
        /**
     * Creates an orthographic (flat non-perspective) projection
     * https://en.wikipedia.org/wiki/Orthographic_projection
     * @param left
     * @param right
     * @param bottom
     * @param top
     * @param near
     * @param far
     */ static ortho(left, right, bottom, top, near, far) {
            const mat = new Matrix();
            mat.data[0] = 2 / (right - left);
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 2 / (top - bottom);
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = -2 / (far - near);
            mat.data[11] = 0;
            mat.data[12] = -(right + left) / (right - left);
            mat.data[13] = -(top + bottom) / (top - bottom);
            mat.data[14] = -(far + near) / (far - near);
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a new Matrix with the same data as the current 4x4
     */ clone(dest) {
            const mat = dest || new Matrix();
            mat.data[0] = this.data[0];
            mat.data[1] = this.data[1];
            mat.data[2] = this.data[2];
            mat.data[3] = this.data[3];
            mat.data[4] = this.data[4];
            mat.data[5] = this.data[5];
            mat.data[6] = this.data[6];
            mat.data[7] = this.data[7];
            mat.data[8] = this.data[8];
            mat.data[9] = this.data[9];
            mat.data[10] = this.data[10];
            mat.data[11] = this.data[11];
            mat.data[12] = this.data[12];
            mat.data[13] = this.data[13];
            mat.data[14] = this.data[14];
            mat.data[15] = this.data[15];
            return mat;
        }
        /**
     * Converts the current matrix into a DOMMatrix
     *
     * This is useful when working with the browser Canvas context
     * @returns {DOMMatrix} DOMMatrix
     */ toDOMMatrix() {
            return new DOMMatrix([
                ...this.data
            ]);
        }
        static fromFloat32Array(data) {
            const matrix = new Matrix();
            matrix.data = data;
            return matrix;
        }
        /**
     * Creates a new identity matrix (a matrix that when applied does nothing)
     */ static identity() {
            const mat = new Matrix();
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 1;
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = 0;
            mat.data[13] = 0;
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Resets the current matrix to the identity matrix, mutating it
     * @returns {Matrix} Current matrix as identity
     */ reset() {
            const mat = this;
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 1;
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = 0;
            mat.data[13] = 0;
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a brand new translation matrix at the specified 3d point
     * @param x
     * @param y
     */ static translation(x, y) {
            const mat = Matrix.identity();
            mat.data[12] = x;
            mat.data[13] = y;
            return mat;
        }
        /**
     * Creates a brand new scaling matrix with the specified scaling factor
     * @param sx
     * @param sy
     */ static scale(sx, sy) {
            const mat = Matrix.identity();
            mat.data[0] = sx;
            mat.data[5] = sy;
            mat.data[10] = 1;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a brand new rotation matrix with the specified angle
     * @param angleRadians
     */ static rotation(angleRadians) {
            const mat = Matrix.identity();
            mat.data[0] = Math.cos(angleRadians);
            mat.data[4] = -Math.sin(angleRadians);
            mat.data[1] = Math.sin(angleRadians);
            mat.data[5] = Math.cos(angleRadians);
            return mat;
        }
        multiply(vectorOrMatrix, dest) {
            if (vectorOrMatrix instanceof Vector) {
                const result = dest || new Vector(0, 0);
                const vector = vectorOrMatrix;
                // these shenanigans are to allow dest and vector to be the same instance
                const resultX = vector.x * this.data[0] + vector.y * this.data[4] + this.data[12];
                const resultY = vector.x * this.data[1] + vector.y * this.data[5] + this.data[13];
                result.x = resultX;
                result.y = resultY;
                return result;
            } else {
                const result = dest || new Matrix();
                const other = vectorOrMatrix;
                const a11 = this.data[0];
                const a21 = this.data[1];
                const a31 = this.data[2];
                const a41 = this.data[3];
                const a12 = this.data[4];
                const a22 = this.data[5];
                const a32 = this.data[6];
                const a42 = this.data[7];
                const a13 = this.data[8];
                const a23 = this.data[9];
                const a33 = this.data[10];
                const a43 = this.data[11];
                const a14 = this.data[12];
                const a24 = this.data[13];
                const a34 = this.data[14];
                const a44 = this.data[15];
                const b11 = other.data[0];
                const b21 = other.data[1];
                const b31 = other.data[2];
                const b41 = other.data[3];
                const b12 = other.data[4];
                const b22 = other.data[5];
                const b32 = other.data[6];
                const b42 = other.data[7];
                const b13 = other.data[8];
                const b23 = other.data[9];
                const b33 = other.data[10];
                const b43 = other.data[11];
                const b14 = other.data[12];
                const b24 = other.data[13];
                const b34 = other.data[14];
                const b44 = other.data[15];
                result.data[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                result.data[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                result.data[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                result.data[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                result.data[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                result.data[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                result.data[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                result.data[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                result.data[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                result.data[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                result.data[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                result.data[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                result.data[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                result.data[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                result.data[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                result.data[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                const s = this.getScale();
                result._scaleSignX = sign(s.x) * sign(result._scaleSignX);
                result._scaleSignY = sign(s.y) * sign(result._scaleSignY);
                return result;
            }
        }
        /**
     * Applies translation to the current matrix mutating it
     * @param x
     * @param y
     */ translate(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            const a13 = this.data[8];
            const a23 = this.data[9];
            const a33 = this.data[10];
            const a43 = this.data[11];
            const a14 = this.data[12];
            const a24 = this.data[13];
            const a34 = this.data[14];
            const a44 = this.data[15];
            // Doesn't change z
            const z = 0;
            const w = 1;
            this.data[12] = a11 * x + a12 * y + a13 * z + a14 * w;
            this.data[13] = a21 * x + a22 * y + a23 * z + a24 * w;
            this.data[14] = a31 * x + a32 * y + a33 * z + a34 * w;
            this.data[15] = a41 * x + a42 * y + a43 * z + a44 * w;
            return this;
        }
        setPosition(x, y) {
            this.data[12] = x;
            this.data[13] = y;
        }
        getPosition() {
            return vec(this.data[12], this.data[13]);
        }
        /**
     * Applies rotation to the current matrix mutating it
     * @param angle in Radians
     */ rotate(angle) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * a11 + sine * a12;
            this.data[1] = cosine * a21 + sine * a22;
            this.data[2] = cosine * a31 + sine * a32;
            this.data[3] = cosine * a41 + sine * a42;
            this.data[4] = cosine * a12 - sine * a11;
            this.data[5] = cosine * a22 - sine * a21;
            this.data[6] = cosine * a32 - sine * a31;
            this.data[7] = cosine * a42 - sine * a41;
            return this;
        }
        /**
     * Applies scaling to the current matrix mutating it
     * @param x
     * @param y
     */ scale(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            this.data[0] = a11 * x;
            this.data[1] = a21 * x;
            this.data[2] = a31 * x;
            this.data[3] = a41 * x;
            this.data[4] = a12 * y;
            this.data[5] = a22 * y;
            this.data[6] = a32 * y;
            this.data[7] = a42 * y;
            return this;
        }
        setRotation(angle) {
            const currentScale = this.getScale();
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * currentScale.x;
            this.data[1] = sine * currentScale.y;
            this.data[4] = -sine * currentScale.x;
            this.data[5] = cosine * currentScale.y;
        }
        getRotation() {
            const angle = Math.atan2(this.data[1] / this.getScaleY(), this.data[0] / this.getScaleX());
            return canonicalizeAngle(angle);
        }
        getScaleX() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const xscale = vec(this.data[0], this.data[4]).size;
            return this._scaleSignX * xscale;
        }
        getScaleY() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const yscale = vec(this.data[1], this.data[5]).size;
            return this._scaleSignY * yscale;
        }
        /**
     * Get the scale of the matrix
     */ getScale() {
            return vec(this.getScaleX(), this.getScaleY());
        }
        setScaleX(val) {
            if (this._scaleX === val) return;
            this._scaleSignX = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const xscale = vec(this.data[0] * this._scaleSignX, this.data[4] * this._scaleSignX).normalize();
            this.data[0] = xscale.x * val;
            this.data[4] = xscale.y * val;
            this._scaleX = val;
        }
        setScaleY(val) {
            if (this._scaleY === val) return;
            this._scaleSignY = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const yscale = vec(this.data[1] * this._scaleSignY, this.data[5] * this._scaleSignY).normalize();
            this.data[1] = yscale.x * val;
            this.data[5] = yscale.y * val;
            this._scaleY = val;
        }
        setScale(scale) {
            this.setScaleX(scale.x);
            this.setScaleY(scale.y);
        }
        /**
     * Determinant of the upper left 2x2 matrix
     */ getBasisDeterminant() {
            return this.data[0] * this.data[5] - this.data[1] * this.data[4];
        }
        /**
     * Return the affine inverse, optionally store it in a target matrix.
     *
     * It's recommended you call .reset() the target unless you know what you're doing
     * @param target
     */ getAffineInverse(target) {
            // See http://negativeprobability.blogspot.com/2011/11/affine-transformations-and-their.html
            // See https://www.mathsisfun.com/algebra/matrix-inverse.html
            // Since we are actually only doing 2D transformations we can use this hack
            // We don't actually use the 3rd or 4th dimension
            const det = this.getBasisDeterminant();
            const inverseDet = 1 / det; // todo zero check
            const a = this.data[0];
            const b = this.data[4];
            const c = this.data[1];
            const d = this.data[5];
            const m = target || Matrix.identity();
            // inverts rotation and scale
            m.data[0] = d * inverseDet;
            m.data[1] = -c * inverseDet;
            m.data[4] = -b * inverseDet;
            m.data[5] = a * inverseDet;
            const tx = this.data[12];
            const ty = this.data[13];
            // invert translation
            // transform translation into the matrix basis created by rot/scale
            m.data[12] = -(tx * m.data[0] + ty * m.data[4]);
            m.data[13] = -(tx * m.data[1] + ty * m.data[5]);
            return m;
        }
        isIdentity() {
            return this.data[0] === 1 && this.data[1] === 0 && this.data[2] === 0 && this.data[3] === 0 && this.data[4] === 0 && this.data[5] === 1 && this.data[6] === 0 && this.data[7] === 0 && this.data[8] === 0 && this.data[9] === 0 && this.data[10] === 1 && this.data[11] === 0 && this.data[12] === 0 && this.data[13] === 0 && this.data[14] === 0 && this.data[15] === 1;
        }
        toString() {
            return `
[${this.data[0]} ${this.data[4]} ${this.data[8]} ${this.data[12]}]
[${this.data[1]} ${this.data[5]} ${this.data[9]} ${this.data[13]}]
[${this.data[2]} ${this.data[6]} ${this.data[10]} ${this.data[14]}]
[${this.data[3]} ${this.data[7]} ${this.data[11]} ${this.data[15]}]
`;
        }
    }
    class AffineMatrix {
        constructor(){
            /**
         * |         |         |          |
         * | ------- | ------- | -------- |
         * | data[0] | data[2] | data[4]  |
         * | data[1] | data[3] | data[5]  |
         * |   0     |    0    |    1     |
         */ this.data = new Float64Array(6);
            this._scale = new Float64Array([
                1,
                1
            ]);
            this._scaleSignX = 1;
            this._scaleSignY = 1;
        }
        /**
     * Converts the current matrix into a DOMMatrix
     *
     * This is useful when working with the browser Canvas context
     * @returns {DOMMatrix} DOMMatrix
     */ toDOMMatrix() {
            return new DOMMatrix([
                ...this.data
            ]);
        }
        static identity() {
            const mat = new AffineMatrix();
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 1;
            mat.data[4] = 0;
            mat.data[5] = 0;
            return mat;
        }
        /**
     * Creates a brand new translation matrix at the specified 3d point
     * @param x
     * @param y
     */ static translation(x, y) {
            const mat = AffineMatrix.identity();
            mat.data[4] = x;
            mat.data[5] = y;
            return mat;
        }
        /**
     * Creates a brand new scaling matrix with the specified scaling factor
     * @param sx
     * @param sy
     */ static scale(sx, sy) {
            const mat = AffineMatrix.identity();
            mat.data[0] = sx;
            mat.data[3] = sy;
            mat._scale[0] = sx;
            mat._scale[1] = sy;
            return mat;
        }
        /**
     * Creates a brand new rotation matrix with the specified angle
     * @param angleRadians
     */ static rotation(angleRadians) {
            const mat = AffineMatrix.identity();
            mat.data[0] = Math.cos(angleRadians);
            mat.data[1] = Math.sin(angleRadians);
            mat.data[2] = -Math.sin(angleRadians);
            mat.data[3] = Math.cos(angleRadians);
            return mat;
        }
        setPosition(x, y) {
            this.data[4] = x;
            this.data[5] = y;
        }
        getPosition() {
            return vec(this.data[4], this.data[5]);
        }
        /**
     * Applies rotation to the current matrix mutating it
     * @param angle in Radians
     */ rotate(angle) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a12 = this.data[2];
            const a22 = this.data[3];
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * a11 + sine * a12;
            this.data[1] = cosine * a21 + sine * a22;
            this.data[2] = cosine * a12 - sine * a11;
            this.data[3] = cosine * a22 - sine * a21;
            return this;
        }
        /**
     * Applies translation to the current matrix mutating it
     * @param x
     * @param y
     */ translate(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            // const a31 = 0;
            const a12 = this.data[2];
            const a22 = this.data[3];
            // const a32 = 0;
            const a13 = this.data[4];
            const a23 = this.data[5];
            // const a33 = 1;
            // Doesn't change z
            this.data[4] = a11 * x + a12 * y + a13;
            this.data[5] = a21 * x + a22 * y + a23;
            return this;
        }
        /**
     * Applies scaling to the current matrix mutating it
     * @param x
     * @param y
     */ scale(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a12 = this.data[2];
            const a22 = this.data[3];
            this.data[0] = a11 * x;
            this.data[1] = a21 * x;
            this.data[2] = a12 * y;
            this.data[3] = a22 * y;
            this._scale[0] = x;
            this._scale[1] = y;
            return this;
        }
        determinant() {
            return this.data[0] * this.data[3] - this.data[1] * this.data[2];
        }
        /**
     * Return the affine inverse, optionally store it in a target matrix.
     *
     * It's recommended you call .reset() the target unless you know what you're doing
     * @param target
     */ inverse(target) {
            // See http://negativeprobability.blogspot.com/2011/11/affine-transformations-and-their.html
            // See https://www.mathsisfun.com/algebra/matrix-inverse.html
            // Since we are actually only doing 2D transformations we can use this hack
            // We don't actually use the 3rd or 4th dimension
            const det = this.determinant();
            const inverseDet = 1 / det; // TODO zero check
            const a = this.data[0];
            const b = this.data[2];
            const c = this.data[1];
            const d = this.data[3];
            const m = target || AffineMatrix.identity();
            // inverts rotation and scale
            m.data[0] = d * inverseDet;
            m.data[1] = -c * inverseDet;
            m.data[2] = -b * inverseDet;
            m.data[3] = a * inverseDet;
            const tx = this.data[4];
            const ty = this.data[5];
            // invert translation
            // transform translation into the matrix basis created by rot/scale
            m.data[4] = -(tx * m.data[0] + ty * m.data[2]);
            m.data[5] = -(tx * m.data[1] + ty * m.data[3]);
            return m;
        }
        multiply(vectorOrMatrix, dest) {
            if (vectorOrMatrix instanceof Vector) {
                const result = dest || new Vector(0, 0);
                const vector = vectorOrMatrix;
                // these shenanigans are to allow dest and vector to be the same instance
                const resultX = vector.x * this.data[0] + vector.y * this.data[2] + this.data[4];
                const resultY = vector.x * this.data[1] + vector.y * this.data[3] + this.data[5];
                result.x = resultX;
                result.y = resultY;
                return result;
            } else {
                const result = dest || new AffineMatrix();
                const other = vectorOrMatrix;
                const a11 = this.data[0];
                const a21 = this.data[1];
                //  const a31 = 0;
                const a12 = this.data[2];
                const a22 = this.data[3];
                //  const a32 = 0;
                const a13 = this.data[4];
                const a23 = this.data[5];
                //  const a33 = 1;
                const b11 = other.data[0];
                const b21 = other.data[1];
                //  const b31 = 0;
                const b12 = other.data[2];
                const b22 = other.data[3];
                //  const b32 = 0;
                const b13 = other.data[4];
                const b23 = other.data[5];
                //  const b33 = 1;
                result.data[0] = a11 * b11 + a12 * b21; // + a13 * b31; // zero
                result.data[1] = a21 * b11 + a22 * b21; // + a23 * b31; // zero
                result.data[2] = a11 * b12 + a12 * b22; // + a13 * b32; // zero
                result.data[3] = a21 * b12 + a22 * b22; // + a23 * b32; // zero
                result.data[4] = a11 * b13 + a12 * b23 + a13; // * b33; // one
                result.data[5] = a21 * b13 + a22 * b23 + a23; // * b33; // one
                const s = this.getScale();
                result._scaleSignX = sign(s.x) * sign(result._scaleSignX);
                result._scaleSignY = sign(s.y) * sign(result._scaleSignY);
                return result;
            }
        }
        /**
     * Packed array of length 8, that contains 4 vertices, with 2 components each
     * So: [x0, y0, x1, y1, x2, y2, x3, y3]
     * @param quad
     */ multiplyQuadInPlace(quad) {
            const resultTopLeftX = quad[0] * this.data[0] + quad[1] * this.data[2] + this.data[4];
            const resultTopLeftY = quad[0] * this.data[1] + quad[1] * this.data[3] + this.data[5];
            quad[0] = resultTopLeftX;
            quad[1] = resultTopLeftY;
            const resultTopRightX = quad[2] * this.data[0] + quad[3] * this.data[2] + this.data[4];
            const resultTopRightY = quad[2] * this.data[1] + quad[3] * this.data[3] + this.data[5];
            quad[2] = resultTopRightX;
            quad[3] = resultTopRightY;
            const resultBottomLeftX = quad[4] * this.data[0] + quad[5] * this.data[2] + this.data[4];
            const resultBottomLeftY = quad[4] * this.data[1] + quad[5] * this.data[3] + this.data[5];
            quad[4] = resultBottomLeftX;
            quad[5] = resultBottomLeftY;
            const resultBottomRightX = quad[6] * this.data[0] + quad[7] * this.data[2] + this.data[4];
            const resultBottomRightY = quad[6] * this.data[1] + quad[7] * this.data[3] + this.data[5];
            quad[6] = resultBottomRightX;
            quad[7] = resultBottomRightY;
        }
        to4x4() {
            const mat = new Matrix();
            mat.data[0] = this.data[0];
            mat.data[1] = this.data[1];
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = this.data[2];
            mat.data[5] = this.data[3];
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = this.data[4];
            mat.data[13] = this.data[5];
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        setRotation(angle) {
            const currentScale = this.getScale();
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * currentScale.x;
            this.data[1] = sine * currentScale.y;
            this.data[2] = -sine * currentScale.x;
            this.data[3] = cosine * currentScale.y;
        }
        getRotation() {
            const angle = Math.atan2(this.data[1] / this.getScaleY(), this.data[0] / this.getScaleX());
            return canonicalizeAngle(angle);
        }
        getScaleX() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const xscale = vec(this.data[0], this.data[2]).distance();
            return this._scaleSignX * xscale;
        }
        getScaleY() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const yscale = vec(this.data[1], this.data[3]).distance();
            return this._scaleSignY * yscale;
        }
        /**
     * Get the scale of the matrix
     */ getScale() {
            return vec(this.getScaleX(), this.getScaleY());
        }
        setScaleX(val) {
            if (val === this._scale[0]) return;
            this._scaleSignX = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const xscale = vec(this.data[0] * this._scaleSignX, this.data[2] * this._scaleSignX).normalize();
            this.data[0] = xscale.x * val;
            this.data[2] = xscale.y * val;
            this._scale[0] = val;
        }
        setScaleY(val) {
            if (val === this._scale[1]) return;
            this._scaleSignY = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const yscale = vec(this.data[1] * this._scaleSignY, this.data[3] * this._scaleSignY).normalize();
            this.data[1] = yscale.x * val;
            this.data[3] = yscale.y * val;
            this._scale[1] = val;
        }
        setScale(scale) {
            this.setScaleX(scale.x);
            this.setScaleY(scale.y);
        }
        isIdentity() {
            return this.data[0] === 1 && this.data[1] === 0 && this.data[2] === 0 && this.data[3] === 1 && this.data[4] === 0 && this.data[5] === 0;
        }
        /**
     * Resets the current matrix to the identity matrix, mutating it
     * @returns {AffineMatrix} Current matrix as identity
     */ reset() {
            const mat = this;
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 1;
            mat.data[4] = 0;
            mat.data[5] = 0;
            return mat;
        }
        /**
     * Creates a new Matrix with the same data as the current [[AffineMatrix]]
     */ clone(dest) {
            const mat = dest || new AffineMatrix();
            mat.data.set(this.data);
            return mat;
        }
        toString() {
            return `
[${this.data[0]} ${this.data[2]} ${this.data[4]}]
[${this.data[1]} ${this.data[3]} ${this.data[5]}]
[0 0 1]
`;
        }
    }
    class TransformStack {
        constructor(){
            this._transforms = [];
            this._currentTransform = AffineMatrix.identity();
        }
        save() {
            this._transforms.push(this._currentTransform);
            this._currentTransform = this._currentTransform.clone();
        }
        restore() {
            this._currentTransform = this._transforms.pop();
        }
        translate(x, y) {
            return this._currentTransform.translate(x, y);
        }
        rotate(angle) {
            return this._currentTransform.rotate(angle);
        }
        scale(x, y) {
            return this._currentTransform.scale(x, y);
        }
        set current(matrix) {
            this._currentTransform = matrix;
        }
        get current() {
            return this._currentTransform;
        }
    }
    class StateStack {
        constructor(){
            this.current = this._getDefaultState();
            this._states = [];
        }
        _getDefaultState() {
            return {
                opacity: 1,
                z: 0,
                tint: Color.White,
                material: null
            };
        }
        _cloneState() {
            return {
                opacity: this.current.opacity,
                z: this.current.z,
                tint: this.current.tint.clone(),
                material: this.current.material // TODO is this going to cause problems when cloning
            };
        }
        save() {
            this._states.push(this.current);
            this.current = this._cloneState();
        }
        restore() {
            this.current = this._states.pop();
        }
    }
    const ResourceEvents = {
        Complete: "complete",
        Load: "load",
        LoadStart: "loadstart",
        Progress: "progress",
        Error: "error"
    };
    /**
 * The [[Resource]] type allows games built in Excalibur to load generic resources.
 * For any type of remote resource it is recommended to use [[Resource]] for preloading.
 */ class Resource {
        /**
     * @param path          Path to the remote resource
     * @param responseType  The type to expect as a response: "" | "arraybuffer" | "blob" | "document" | "json" | "text";
     * @param bustCache     Whether or not to cache-bust requests
     */ constructor(path, responseType, bustCache = false){
            this.path = path;
            this.responseType = responseType;
            this.bustCache = bustCache;
            this.data = null;
            this.logger = Logger.getInstance();
            this.events = new EventEmitter();
        }
        /**
     * Returns true if the Resource is completely loaded and is ready
     * to be drawn.
     */ isLoaded() {
            return this.data !== null;
        }
        _cacheBust(uri) {
            const query = /\?\w*=\w*/;
            if (query.test(uri)) uri += "&__=" + Date.now();
            else uri += "?__=" + Date.now();
            return uri;
        }
        /**
     * Begin loading the resource and returns a promise to be resolved on completion
     */ load() {
            return new Promise((resolve, reject)=>{
                // Exit early if we already have data
                if (this.data !== null) {
                    this.logger.debug("Already have data for resource", this.path);
                    this.events.emit("complete", this.data);
                    resolve(this.data);
                    return;
                }
                const request = new XMLHttpRequest();
                request.open("GET", this.bustCache ? this._cacheBust(this.path) : this.path, true);
                request.responseType = this.responseType;
                request.addEventListener("loadstart", (e)=>this.events.emit("loadstart", e));
                request.addEventListener("progress", (e)=>this.events.emit("progress", e));
                request.addEventListener("error", (e)=>this.events.emit("error", e));
                request.addEventListener("load", (e)=>this.events.emit("load", e));
                request.addEventListener("load", ()=>{
                    // XHR on file:// success status is 0, such as with PhantomJS
                    if (request.status !== 0 && request.status !== 200) {
                        this.logger.error("Failed to load resource ", this.path, " server responded with error code", request.status);
                        this.events.emit("error", request.response);
                        reject(new Error(request.statusText));
                        return;
                    }
                    this.data = request.response;
                    this.events.emit("complete", this.data);
                    this.logger.debug("Completed loading resource", this.path);
                    resolve(this.data);
                });
                request.send();
            });
        }
    }
    /**
 * Watch an object with a proxy, only fires if property value is different
 */ function watch(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, {
            set: (obj, prop, value)=>{
                // The default behavior to store the value
                if (obj[prop] !== value) {
                    obj[prop] = value;
                    // Avoid watching private junk
                    if (typeof prop === "string") {
                        if (prop[0] !== "_") change(obj);
                    }
                }
                // Indicate success
                return true;
            },
            get: (obj, prop)=>{
                if (prop !== "__isProxy") return obj[prop];
                return true;
            }
        });
        return type;
    }
    const createHandler = (path = [], change, typeType)=>({
            get: (target, key)=>{
                if (key === "__isProxy") return true;
                if (typeof target[key] === "object" && target[key] != null) return new Proxy(target[key], createHandler([
                    ...path,
                    key
                ], change, typeType));
                return target[key];
            },
            set: (target, key, value)=>{
                if (typeof key === "string") {
                    if (key[0] !== "_") change(typeType);
                }
                target[key] = value;
                return true;
            }
        });
    /**
 *
 */ function watchDeep(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, createHandler([], change, type));
        return type;
    }
    /**
 * Watch an object with a proxy, fires change on any property value change
 */ function watchAny(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, {
            set: (obj, prop, value)=>{
                // The default behavior to store the value
                obj[prop] = value;
                // Avoid watching private junk
                if (typeof prop === "string") {
                    if (prop[0] !== "_") change(obj);
                }
                // Indicate success
                return true;
            },
            get: (obj, prop)=>{
                if (prop !== "__isProxy") return obj[prop];
                return true;
            }
        });
        return type;
    }
    /**
 * A Graphic is the base Excalibur primitive for something that can be drawn to the [[ExcaliburGraphicsContext]].
 * [[Sprite]], [[Animation]], [[GraphicsGroup]], [[Canvas]], [[Rectangle]], [[Circle]], and [[Polygon]] all derive from the
 * [[Graphic]] abstract class.
 *
 * Implementors of a Graphic must override the abstract [[Graphic._drawImage]] method to render an image to the graphics context. Graphic
 * handles all the position, rotation, and scale transformations in [[Graphic._preDraw]] and [[Graphic._postDraw]]
 */ class Graphic {
        isStale() {
            return this._transformStale;
        }
        /**
     * Gets or sets the flipHorizontal, which will flip the graphic horizontally (across the y axis)
     */ get flipHorizontal() {
            return this._flipHorizontal;
        }
        set flipHorizontal(value) {
            this._flipHorizontal = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the flipVertical, which will flip the graphic vertically (across the x axis)
     */ get flipVertical() {
            return this._flipVertical;
        }
        set flipVertical(value) {
            this._flipVertical = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the rotation of the graphic
     */ get rotation() {
            return this._rotation;
        }
        set rotation(value) {
            this._rotation = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the scale of the graphic, this affects the width and
     */ get scale() {
            return this._scale;
        }
        set scale(value) {
            this._scale = watch(value, ()=>{
                this._transformStale = true;
            });
            this._transformStale = true;
        }
        /**
     * Gets or sets the origin of the graphic, if not set the center of the graphic is the origin
     */ get origin() {
            return this._origin;
        }
        set origin(value) {
            this._origin = watch(value, ()=>{
                this._transformStale = true;
            });
            this._transformStale = true;
        }
        constructor(options){
            var _a, _b, _c, _d, _e, _f, _g;
            this.id = Graphic._ID++;
            this.transform = AffineMatrix.identity();
            this.tint = null;
            this._transformStale = true;
            /**
         * Gets or sets wether to show debug information about the graphic
         */ this.showDebug = false;
            this._flipHorizontal = false;
            this._flipVertical = false;
            this._rotation = 0;
            /**
         * Gets or sets the opacity of the graphic, 0 is transparent, 1 is solid (opaque).
         */ this.opacity = 1;
            this._scale = Vector.One;
            this._origin = null;
            this._width = 0;
            this._height = 0;
            if (options) {
                this.origin = (_a = options.origin) !== null && _a !== void 0 ? _a : this.origin;
                this.flipHorizontal = (_b = options.flipHorizontal) !== null && _b !== void 0 ? _b : this.flipHorizontal;
                this.flipVertical = (_c = options.flipVertical) !== null && _c !== void 0 ? _c : this.flipVertical;
                this.rotation = (_d = options.rotation) !== null && _d !== void 0 ? _d : this.rotation;
                this.opacity = (_e = options.opacity) !== null && _e !== void 0 ? _e : this.opacity;
                this.scale = (_f = options.scale) !== null && _f !== void 0 ? _f : this.scale;
                this.tint = (_g = options.tint) !== null && _g !== void 0 ? _g : this.tint;
            }
        }
        cloneGraphicOptions() {
            return {
                width: this.width / this.scale.x,
                height: this.height / this.scale.y,
                origin: this.origin ? this.origin.clone() : null,
                flipHorizontal: this.flipHorizontal,
                flipVertical: this.flipVertical,
                rotation: this.rotation,
                opacity: this.opacity,
                scale: this.scale ? this.scale.clone() : null,
                tint: this.tint ? this.tint.clone() : null
            };
        }
        /**
     * Gets or sets the width of the graphic (always positive)
     */ get width() {
            return Math.abs(this._width * this.scale.x);
        }
        /**
     * Gets or sets the height of the graphic (always positive)
     */ get height() {
            return Math.abs(this._height * this.scale.y);
        }
        set width(value) {
            this._width = value;
            this._transformStale = true;
        }
        set height(value) {
            this._height = value;
            this._transformStale = true;
        }
        /**
     * Gets a copy of the bounds in pixels occupied by the graphic on the the screen. This includes scale.
     */ get localBounds() {
            return BoundingBox.fromDimension(this.width, this.height, Vector.Zero);
        }
        /**
     * Draw the whole graphic to the context including transform
     * @param ex The excalibur graphics context
     * @param x
     * @param y
     */ draw(ex, x, y) {
            this._preDraw(ex, x, y);
            this._drawImage(ex, 0, 0);
            this._postDraw(ex);
        }
        /**
     * Apply affine transformations to the graphics context to manipulate the graphic before [[Graphic._drawImage]]
     * @param ex
     * @param x
     * @param y
     */ _preDraw(ex, x, y) {
            ex.save();
            ex.translate(x, y);
            if (this._transformStale) {
                this.transform.reset();
                this.transform.scale(Math.abs(this.scale.x), Math.abs(this.scale.y));
                this._rotate(this.transform);
                this._flip(this.transform);
                this._transformStale = false;
            }
            ex.multiply(this.transform);
            // it is important to multiply alphas so graphics respect the current context
            ex.opacity = ex.opacity * this.opacity;
            if (this.tint) ex.tint = this.tint;
        }
        _rotate(ex) {
            var _a;
            const scaleDirX = this.scale.x > 0 ? 1 : -1;
            const scaleDirY = this.scale.y > 0 ? 1 : -1;
            const origin = (_a = this.origin) !== null && _a !== void 0 ? _a : vec(this.width / 2, this.height / 2);
            ex.translate(origin.x, origin.y);
            ex.rotate(this.rotation);
            // This is for handling direction changes 1 or -1, that way we don't have mismatched translates()
            ex.scale(scaleDirX, scaleDirY);
            ex.translate(-origin.x, -origin.y);
        }
        _flip(ex) {
            if (this.flipHorizontal) {
                ex.translate(this.width / this.scale.x, 0);
                ex.scale(-1, 1);
            }
            if (this.flipVertical) {
                ex.translate(0, this.height / this.scale.y);
                ex.scale(1, -1);
            }
        }
        /**
     * Apply any additional work after [[Graphic._drawImage]] and restore the context state.
     * @param ex
     */ _postDraw(ex) {
            if (this.showDebug) ex.debug.drawRect(0, 0, this.width, this.height);
            ex.restore();
        }
    }
    Graphic._ID = 0;
    class Sprite extends Graphic {
        static from(image) {
            return new Sprite({
                image: image
            });
        }
        constructor(options){
            var _a, _b;
            super(options);
            this._logger = Logger.getInstance();
            this._dirty = true;
            this.image = options.image;
            const { width: width, height: height } = options;
            this.sourceView = (_a = options.sourceView) !== null && _a !== void 0 ? _a : {
                x: 0,
                y: 0,
                width: width !== null && width !== void 0 ? width : 0,
                height: height !== null && height !== void 0 ? height : 0
            };
            this.destSize = (_b = options.destSize) !== null && _b !== void 0 ? _b : {
                width: width !== null && width !== void 0 ? width : 0,
                height: height !== null && height !== void 0 ? height : 0
            };
            this._updateSpriteDimensions();
            // Fire when loaded
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.image.ready.then(()=>{
                this._updateSpriteDimensions();
            });
        }
        get width() {
            return Math.abs(this.destSize.width * this.scale.x);
        }
        get height() {
            return Math.abs(this.destSize.height * this.scale.y);
        }
        set width(newWidth) {
            newWidth /= Math.abs(this.scale.x);
            this.destSize.width = newWidth;
            super.width = Math.ceil(this.destSize.width);
        }
        set height(newHeight) {
            newHeight /= Math.abs(this.scale.y);
            this.destSize.height = newHeight;
            super.height = Math.ceil(this.destSize.height);
        }
        _updateSpriteDimensions() {
            var _a, _b, _c, _d, _e, _f;
            const { width: nativeWidth, height: nativeHeight } = this.image;
            // This code uses || to avoid 0's
            // If the source is not specified, use the native dimension
            this.sourceView.width = ((_a = this.sourceView) === null || _a === void 0 ? void 0 : _a.width) || nativeWidth;
            this.sourceView.height = ((_b = this.sourceView) === null || _b === void 0 ? void 0 : _b.height) || nativeHeight;
            // If the destination is not specified, use the source if specified, then native
            this.destSize.width = ((_c = this.destSize) === null || _c === void 0 ? void 0 : _c.width) || ((_d = this.sourceView) === null || _d === void 0 ? void 0 : _d.width) || nativeWidth;
            this.destSize.height = ((_e = this.destSize) === null || _e === void 0 ? void 0 : _e.height) || ((_f = this.sourceView) === null || _f === void 0 ? void 0 : _f.height) || nativeHeight;
            this.width = Math.ceil(this.destSize.width) * this.scale.x;
            this.height = Math.ceil(this.destSize.height) * this.scale.y;
        }
        _preDraw(ex, x, y) {
            if (this.image.isLoaded() && this._dirty) {
                this._dirty = false;
                this._updateSpriteDimensions();
            }
            super._preDraw(ex, x, y);
        }
        _drawImage(ex, x, y) {
            if (this.image.isLoaded()) ex.drawImage(this.image.image, this.sourceView.x, this.sourceView.y, this.sourceView.width, this.sourceView.height, x, y, this.destSize.width, this.destSize.height);
            else this._logger.warnOnce(`ImageSource ${this.image.path}` + ` is not yet loaded and won't be drawn. Please call .load() or include in a Loader.\n\n` + `Read https://excaliburjs.com/docs/imagesource for more information.`);
        }
        clone() {
            return new Sprite({
                image: this.image,
                sourceView: {
                    ...this.sourceView
                },
                destSize: {
                    ...this.destSize
                },
                ...this.cloneGraphicOptions()
            });
        }
    }
    /**
 * Describes the different image filtering modes
 */ var ImageFiltering;
    (function(ImageFiltering) {
        /**
     * Pixel is useful when you do not want smoothing aka antialiasing applied to your graphics.
     *
     * Useful for Pixel art aesthetics.
     */ ImageFiltering["Pixel"] = "Pixel";
        /**
     * Blended is useful when you have high resolution artwork and would like it blended and smoothed
     */ ImageFiltering["Blended"] = "Blended";
    })(ImageFiltering || (ImageFiltering = {}));
    /**
 * Parse the image filtering attribute value, if it doesn't match returns null
 */ function parseImageFiltering(val) {
        switch(val){
            case ImageFiltering.Pixel:
                return ImageFiltering.Pixel;
            case ImageFiltering.Blended:
                return ImageFiltering.Blended;
            default:
                return null;
        }
    }
    /**
 * Describes the different image wrapping modes
 */ var ImageWrapping;
    (function(ImageWrapping) {
        ImageWrapping["Clamp"] = "Clamp";
        ImageWrapping["Repeat"] = "Repeat";
        ImageWrapping["Mirror"] = "Mirror";
    })(ImageWrapping || (ImageWrapping = {}));
    /**
 *
 */ function parseImageWrapping(val) {
        switch(val){
            case ImageWrapping.Clamp:
                return ImageWrapping.Clamp;
            case ImageWrapping.Repeat:
                return ImageWrapping.Repeat;
            case ImageWrapping.Mirror:
                return ImageWrapping.Mirror;
            default:
                return ImageWrapping.Clamp;
        }
    }
    /**
 * Manages loading image sources into webgl textures, a unique id is associated with all sources
 */ class TextureLoader {
        constructor(gl){
            this._textureMap = new Map();
            this._gl = gl;
            TextureLoader._MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        }
        dispose() {
            for (const [image] of this._textureMap)this.delete(image);
            this._textureMap.clear();
            this._gl = null;
        }
        /**
     * Get the WebGL Texture from a source image
     * @param image
     */ get(image) {
            return this._textureMap.get(image);
        }
        /**
     * Returns whether a source image has been loaded as a texture
     * @param image
     */ has(image) {
            return this._textureMap.has(image);
        }
        /**
     * Loads a graphic into webgl and returns it's texture info, a webgl context must be previously registered
     * @param image Source graphic
     * @param options {ImageSourceOptions} Optionally configure the ImageFiltering and ImageWrapping mode to apply to the loaded texture
     * @param forceUpdate Optionally force a texture to be reloaded, useful if the source graphic has changed
     */ load(image, options, forceUpdate = false) {
            // Ignore loading if webgl is not registered
            const gl = this._gl;
            if (!gl) return null;
            const { filtering: filtering, wrapping: wrapping } = {
                ...options
            };
            let tex = null;
            // If reuse the texture if it's from the same source
            if (this.has(image)) tex = this.get(image);
            // Update existing webgl texture and return early
            if (tex) {
                if (forceUpdate) {
                    gl.bindTexture(gl.TEXTURE_2D, tex);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                }
                return tex;
            }
            // No texture exists create a new one
            tex = gl.createTexture();
            // TODO implement texture gc with weakmap and timer
            TextureLoader.checkImageSizeSupportedAndLog(image);
            gl.bindTexture(gl.TEXTURE_2D, tex);
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
            let wrappingConfig;
            if (wrapping) {
                if (typeof wrapping === "string") wrappingConfig = {
                    x: wrapping,
                    y: wrapping
                };
                else wrappingConfig = {
                    x: wrapping.x,
                    y: wrapping.y
                };
            }
            const { x: xWrap, y: yWrap } = wrappingConfig !== null && wrappingConfig !== void 0 ? wrappingConfig : TextureLoader.wrapping;
            switch(xWrap){
                case ImageWrapping.Clamp:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    break;
                case ImageWrapping.Repeat:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
                    break;
                case ImageWrapping.Mirror:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
                    break;
                default:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            }
            switch(yWrap){
                case ImageWrapping.Clamp:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    break;
                case ImageWrapping.Repeat:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
                    break;
                case ImageWrapping.Mirror:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
                    break;
                default:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            }
            // NEAREST for pixel art, LINEAR for hi-res
            const filterMode = filtering !== null && filtering !== void 0 ? filtering : TextureLoader.filtering;
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filterMode === ImageFiltering.Pixel ? gl.NEAREST : gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filterMode === ImageFiltering.Pixel ? gl.NEAREST : gl.LINEAR);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
            this._textureMap.set(image, tex);
            return tex;
        }
        delete(image) {
            // Ignore loading if webgl is not registered
            const gl = this._gl;
            if (!gl) return null;
            let tex = null;
            if (this.has(image)) {
                tex = this.get(image);
                gl.deleteTexture(tex);
            }
        }
        /**
     * Takes an image and returns if it meets size criteria for hardware
     * @param image
     * @returns if the image will be supported at runtime
     */ static checkImageSizeSupportedAndLog(image) {
            var _a;
            const originalSrc = (_a = image.dataset.originalSrc) !== null && _a !== void 0 ? _a : "internal canvas bitmap";
            if (image.width > TextureLoader._MAX_TEXTURE_SIZE || image.height > TextureLoader._MAX_TEXTURE_SIZE) {
                TextureLoader._LOGGER.error(`The image [${originalSrc}] provided to Excalibur is too large for the device's maximum texture size of ` + `(${TextureLoader._MAX_TEXTURE_SIZE}x${TextureLoader._MAX_TEXTURE_SIZE}) please resize to an image ` + `for excalibur to render properly.\n\nImages will likely render as black rectangles.\n\n` + `Read more here: https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits`);
                return false;
            } else if (image.width > 4096 || image.height > 4096) // https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits
            TextureLoader._LOGGER.warn(`The image [${originalSrc}] provided to excalibur is too large may not work on all mobile devices, ` + `it is recommended you resize images to a maximum (4096x4096).\n\n` + `Images will likely render as black rectangles on some mobile platforms.\n\n` + `Read more here: https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits`);
            return true;
        }
    }
    TextureLoader._LOGGER = Logger.getInstance();
    /**
 * Sets the default filtering for the Excalibur texture loader, default [[ImageFiltering.Blended]]
 */ TextureLoader.filtering = ImageFiltering.Blended;
    TextureLoader.wrapping = {
        x: ImageWrapping.Clamp,
        y: ImageWrapping.Clamp
    };
    TextureLoader._MAX_TEXTURE_SIZE = 4096;
    const ImageSourceAttributeConstants = {
        Filtering: "filtering",
        WrappingX: "wrapping-x",
        WrappingY: "wrapping-y"
    };
    class ImageSource {
        /**
     * The original size of the source image in pixels
     */ get width() {
            return this.image.naturalWidth;
        }
        /**
     * The original height of the source image in pixels
     */ get height() {
            return this.image.naturalHeight;
        }
        /**
     * Returns true if the Texture is completely loaded and is ready
     * to be drawn.
     */ isLoaded() {
            if (!this._src) // this boosts speed of access
            this._src = this.data.src;
            return !!this._src;
        }
        get image() {
            return this.data;
        }
        constructor(path, bustCacheOrOptions, filtering){
            this._logger = Logger.getInstance();
            /**
         * Access to the underlying html image element
         */ this.data = new Image();
            this._readyFuture = new Future();
            /**
         * Promise the resolves when the image is loaded and ready for use, does not initiate loading
         */ this.ready = this._readyFuture.promise;
            this.path = path;
            let bustCache = false;
            let wrapping;
            if (typeof bustCacheOrOptions === "boolean") bustCache = bustCacheOrOptions;
            else ({ filtering: filtering, wrapping: wrapping, bustCache: bustCache } = {
                ...bustCacheOrOptions
            });
            this._resource = new Resource(path, "blob", bustCache);
            this.filtering = filtering !== null && filtering !== void 0 ? filtering : this.filtering;
            if (typeof wrapping === "string") this.wrapping = {
                x: wrapping,
                y: wrapping
            };
            else this.wrapping = wrapping !== null && wrapping !== void 0 ? wrapping : this.wrapping;
            if (path.endsWith(".svg") || path.endsWith(".gif")) this._logger.warn(`Image type is not fully supported, you may have mixed results ${path}. Fully supported: jpg, bmp, and png`);
        }
        /**
     * Create an ImageSource from and HTML <image> tag element
     * @param image
     */ static fromHtmlImageElement(image, options) {
            const imageSource = new ImageSource("");
            imageSource._src = "image-element";
            imageSource.data = image;
            imageSource.data.setAttribute("data-original-src", "image-element");
            if (options === null || options === void 0 ? void 0 : options.filtering) imageSource.data.setAttribute(ImageSourceAttributeConstants.Filtering, options === null || options === void 0 ? void 0 : options.filtering);
            else imageSource.data.setAttribute(ImageSourceAttributeConstants.Filtering, ImageFiltering.Blended);
            if (options === null || options === void 0 ? void 0 : options.wrapping) {
                let wrapping;
                if (typeof options.wrapping === "string") wrapping = {
                    x: options.wrapping,
                    y: options.wrapping
                };
                else wrapping = {
                    x: options.wrapping.x,
                    y: options.wrapping.y
                };
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingX, wrapping.x);
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingY, wrapping.y);
            } else {
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingX, ImageWrapping.Clamp);
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingY, ImageWrapping.Clamp);
            }
            TextureLoader.checkImageSizeSupportedAndLog(image);
            imageSource._readyFuture.resolve(image);
            return imageSource;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * Begins loading the image and returns a promise that resolves when the image is loaded
     */ async load() {
            var _a, _b, _c, _d;
            if (this.isLoaded()) return this.data;
            try {
                // Load base64 or blob if needed
                let url;
                if (!this.path.includes("data:image/")) {
                    const blob = await this._resource.load();
                    url = URL.createObjectURL(blob);
                } else url = this.path;
                // Decode the image
                const image = new Image();
                // Use Image.onload over Image.decode()
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1055828#c7
                // Otherwise chrome will throw still Image.decode() failures for large textures
                const loadedFuture = new Future();
                image.onload = ()=>loadedFuture.resolve();
                image.src = url;
                image.setAttribute("data-original-src", this.path);
                await loadedFuture.promise;
                // Set results
                // We defer loading the texture into webgl until the first draw that way we avoid a singleton
                // and for the multi-engine case the texture needs to be created in EACH webgl context to work
                // See image-renderer.ts draw()
                this.data = image;
                // emit warning if potentially too big
                TextureLoader.checkImageSizeSupportedAndLog(this.data);
            } catch (error) {
                throw `Error loading ImageSource from path '${this.path}' with error [${error.message}]`;
            }
            // Do a bad thing to pass the filtering as an attribute
            this.data.setAttribute(ImageSourceAttributeConstants.Filtering, this.filtering);
            this.data.setAttribute(ImageSourceAttributeConstants.WrappingX, (_b = (_a = this.wrapping) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : ImageWrapping.Clamp);
            this.data.setAttribute(ImageSourceAttributeConstants.WrappingY, (_d = (_c = this.wrapping) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : ImageWrapping.Clamp);
            // todo emit complete
            this._readyFuture.resolve(this.data);
            return this.data;
        }
        /**
     * Build a sprite from this ImageSource
     */ toSprite() {
            return Sprite.from(this);
        }
        /**
     * Unload images from memory
     */ unload() {
            this.data = new Image();
        }
    }
    class SpriteFont extends Graphic {
        constructor(options){
            super(options);
            this._text = "";
            this.alphabet = "";
            this.shadow = null;
            this.caseInsensitive = false;
            this.spacing = 0;
            this.lineHeight = undefined;
            this._logger = Logger.getInstance();
            const { alphabet: alphabet, spriteSheet: spriteSheet, caseInsensitive: caseInsensitive, spacing: spacing, shadow: shadow, lineHeight: lineHeight } = options;
            this.alphabet = alphabet;
            this.spriteSheet = spriteSheet;
            this.caseInsensitive = caseInsensitive !== null && caseInsensitive !== void 0 ? caseInsensitive : this.caseInsensitive;
            this.spacing = spacing !== null && spacing !== void 0 ? spacing : this.spacing;
            this.shadow = shadow !== null && shadow !== void 0 ? shadow : this.shadow;
            this.lineHeight = lineHeight !== null && lineHeight !== void 0 ? lineHeight : this.lineHeight;
        }
        _getCharacterSprites(text) {
            const results = [];
            // handle case insensitive
            const textToRender = this.caseInsensitive ? text.toLocaleLowerCase() : text;
            const alphabet = this.caseInsensitive ? this.alphabet.toLocaleLowerCase() : this.alphabet;
            // for each letter in text
            for(let letterIndex = 0; letterIndex < textToRender.length; letterIndex++){
                // find the sprite index in alphabet , if there is an error pick the first
                const letter = textToRender[letterIndex];
                let spriteIndex = alphabet.indexOf(letter);
                if (spriteIndex === -1) {
                    spriteIndex = 0;
                    this._logger.warnOnce(`SpriteFont - Cannot find letter '${letter}' in configured alphabet '${alphabet}'.`);
                    this._logger.warnOnce("There maybe be more issues in the SpriteFont configuration. No additional warnings will be logged.");
                }
                const letterSprite = this.spriteSheet.sprites[spriteIndex];
                if (letterSprite) results.push(letterSprite);
                else {
                    this._logger.warnOnce(`SpriteFont - Cannot find sprite for '${letter}' at index '${spriteIndex}' in configured SpriteSheet`);
                    this._logger.warnOnce("There maybe be more issues in the SpriteFont configuration. No additional warnings will be logged.");
                }
            }
            return results;
        }
        measureText(text, maxWidth) {
            const lines = this._getLinesFromText(text, maxWidth);
            const maxWidthLine = lines.reduce((a, b)=>{
                return a.length > b.length ? a : b;
            });
            const sprites = this._getCharacterSprites(maxWidthLine);
            let width = 0;
            let height = 0;
            for (const sprite of sprites){
                width += sprite.width + this.spacing;
                height = Math.max(height, sprite.height);
            }
            return BoundingBox.fromDimension(width, height * lines.length, Vector.Zero);
        }
        _drawImage(ex, x, y, maxWidth) {
            var _a;
            let xCursor = 0;
            let yCursor = 0;
            let height = 0;
            const lines = this._getLinesFromText(this._text, maxWidth);
            for (const line of lines){
                for (const sprite of this._getCharacterSprites(line)){
                    // draw it in the right spot and increase the cursor by sprite width
                    sprite.draw(ex, x + xCursor, y + yCursor);
                    xCursor += sprite.width + this.spacing;
                    height = Math.max(height, sprite.height);
                }
                xCursor = 0;
                yCursor += (_a = this.lineHeight) !== null && _a !== void 0 ? _a : height;
            }
        }
        render(ex, text, _color, x, y, maxWidth) {
            // SpriteFont doesn't support _color, yet...
            this._text = text;
            const bounds = this.measureText(text, maxWidth);
            this.width = bounds.width;
            this.height = bounds.height;
            if (this.shadow) {
                ex.save();
                ex.translate(this.shadow.offset.x, this.shadow.offset.y);
                this._preDraw(ex, x, y);
                this._drawImage(ex, 0, 0, maxWidth);
                this._postDraw(ex);
                ex.restore();
            }
            this._preDraw(ex, x, y);
            this._drawImage(ex, 0, 0, maxWidth);
            this._postDraw(ex);
        }
        clone() {
            return new SpriteFont({
                alphabet: this.alphabet,
                spriteSheet: this.spriteSheet,
                spacing: this.spacing
            });
        }
        _getLinesFromText(text, maxWidth) {
            if (this._cachedText === text && this._cachedRenderWidth === maxWidth) return this._cachedLines;
            const lines = text.split("\n");
            if (maxWidth == null) return lines;
            // If the current line goes past the maxWidth, append a new line without modifying the underlying text.
            for(let i = 0; i < lines.length; i++){
                let line = lines[i];
                let newLine = "";
                // Note: we subtract the spacing to counter the initial padding on the left side.
                if (this.measureText(line).width > maxWidth) {
                    while(this.measureText(line).width > maxWidth){
                        newLine = line[line.length - 1] + newLine;
                        line = line.slice(0, -1); // Remove last character from line
                    }
                    // Update the array with our new values
                    lines[i] = line;
                    lines[i + 1] = newLine;
                }
            }
            this._cachedText = text;
            this._cachedLines = lines;
            this._cachedRenderWidth = maxWidth;
            return lines;
        }
    }
    /**
 * Represents a collection of sprites from a source image with some organization in a grid
 */ class SpriteSheet {
        /**
     * Build a new sprite sheet from a list of sprites
     *
     * Use [[SpriteSheet.fromImageSource]] to create a SpriteSheet from an [[ImageSource]] organized in a grid
     * @param options
     */ constructor(options){
            this.sprites = [];
            const { sprites: sprites, rows: rows, columns: columns } = options;
            this.sprites = sprites;
            this.rows = rows !== null && rows !== void 0 ? rows : 1;
            this.columns = columns !== null && columns !== void 0 ? columns : this.sprites.length;
        }
        /**
     * Find a sprite by their x/y integer coordinates in the SpriteSheet, for example `getSprite(0, 0)` is the [[Sprite]] in the top-left
     * and `getSprite(1, 0)` is the sprite one to the right.
     * @param x
     * @param y
     */ getSprite(x, y, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (x >= this.columns || x < 0) throw Error(`No sprite exists in the SpriteSheet at (${x}, ${y}), x: ${x} should be between 0 and ${this.columns - 1}`);
            if (y >= this.rows || y < 0) throw Error(`No sprite exists in the SpriteSheet at (${x}, ${y}), y: ${y} should be between 0 and ${this.rows - 1}`);
            const spriteIndex = x + y * this.columns;
            const sprite = this.sprites[spriteIndex];
            if (sprite) {
                if (options) {
                    const spriteWithOptions = sprite.clone();
                    spriteWithOptions.flipHorizontal = (_a = options.flipHorizontal) !== null && _a !== void 0 ? _a : spriteWithOptions.flipHorizontal;
                    spriteWithOptions.flipVertical = (_b = options.flipVertical) !== null && _b !== void 0 ? _b : spriteWithOptions.flipVertical;
                    spriteWithOptions.width = (_c = options.width) !== null && _c !== void 0 ? _c : spriteWithOptions.width;
                    spriteWithOptions.height = (_d = options.height) !== null && _d !== void 0 ? _d : spriteWithOptions.height;
                    spriteWithOptions.rotation = (_e = options.rotation) !== null && _e !== void 0 ? _e : spriteWithOptions.rotation;
                    spriteWithOptions.scale = (_f = options.scale) !== null && _f !== void 0 ? _f : spriteWithOptions.scale;
                    spriteWithOptions.opacity = (_g = options.opacity) !== null && _g !== void 0 ? _g : spriteWithOptions.opacity;
                    spriteWithOptions.tint = (_h = options.tint) !== null && _h !== void 0 ? _h : spriteWithOptions.tint;
                    spriteWithOptions.origin = (_j = options.origin) !== null && _j !== void 0 ? _j : spriteWithOptions.origin;
                    return spriteWithOptions;
                }
                return sprite;
            }
            throw Error(`Invalid sprite coordinates (${x}, ${y}`);
        }
        /**
     * Create a sprite sheet from a sparse set of [[SourceView]] rectangles
     * @param options
     */ static fromImageSourceWithSourceViews(options) {
            const sprites = options.sourceViews.map((sourceView)=>{
                return new Sprite({
                    image: options.image,
                    sourceView: sourceView
                });
            });
            return new SpriteSheet({
                sprites: sprites
            });
        }
        /**
     * Create a SpriteSheet from an [[ImageSource]] organized in a grid
     *
     * Example:
     * ```
     * const spriteSheet = SpriteSheet.fromImageSource({
     *   image: imageSource,
     *   grid: {
     *     rows: 5,
     *     columns: 2,
     *     spriteWidth: 32, // pixels
     *     spriteHeight: 32 // pixels
     *   },
     *   // Optionally specify spacing
     *   spacing: {
     *     // pixels from the top left to start the sprite parsing
     *     originOffset: {
     *       x: 5,
     *       y: 5
     *     },
     *     // pixels between each sprite while parsing
     *     margin: {
     *       x: 1,
     *       y: 1
     *     }
     *   }
     * })
     * ```
     * @param options
     */ static fromImageSource(options) {
            var _a;
            const sprites = [];
            options.spacing = (_a = options.spacing) !== null && _a !== void 0 ? _a : {};
            const { image: image, grid: { rows: rows, columns: cols, spriteWidth: spriteWidth, spriteHeight: spriteHeight }, spacing: { originOffset: originOffset, margin: margin } } = options;
            const offsetDefaults = {
                x: 0,
                y: 0,
                ...originOffset
            };
            const marginDefaults = {
                x: 0,
                y: 0,
                ...margin
            };
            for(let x = 0; x < cols; x++)for(let y = 0; y < rows; y++)sprites[x + y * cols] = new Sprite({
                image: image,
                sourceView: {
                    x: x * spriteWidth + marginDefaults.x * x + offsetDefaults.x,
                    y: y * spriteHeight + marginDefaults.y * y + offsetDefaults.y,
                    width: spriteWidth,
                    height: spriteHeight
                },
                destSize: {
                    height: spriteHeight,
                    width: spriteWidth
                }
            });
            return new SpriteSheet({
                sprites: sprites,
                rows: rows,
                columns: cols
            });
        }
        clone() {
            return new SpriteSheet({
                sprites: this.sprites.map((sprite)=>sprite.clone()),
                rows: this.rows,
                columns: this.columns
            });
        }
    }
    /* harmony default export */ const debug_font = "data:image/png;base64,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";
    /**
 * Internal debugtext helper
 */ class DebugText {
        constructor(){
            /**
         * base64 font
         */ this.fontSheet = debug_font;
            this.size = 16;
            // We fire and forget, we don't care if it's loaded or not
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.load();
        }
        load() {
            this._imageSource = new ImageSource(this.fontSheet);
            return this._imageSource.load().then(()=>{
                this._spriteSheet = SpriteSheet.fromImageSource({
                    image: this._imageSource,
                    grid: {
                        rows: 4,
                        columns: 16,
                        spriteWidth: 16,
                        spriteHeight: 16
                    }
                });
                this._spriteFont = new SpriteFont({
                    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ,!'&.\"?-()+# ",
                    caseInsensitive: true,
                    spriteSheet: this._spriteSheet,
                    spacing: -6
                });
            });
        }
        /**
     * Writes debug text using the built in sprint font
     * @param ctx
     * @param text
     * @param pos
     */ write(ctx, text, pos) {
            if (this._imageSource.isLoaded()) this._spriteFont.render(ctx, text, null, pos.x, pos.y);
        }
    }
    class RenderSource {
        constructor(_gl, _texture){
            this._gl = _gl;
            this._texture = _texture;
        }
        use() {
            const gl = this._gl;
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, this._texture);
        }
        disable() {
            const gl = this._gl;
            gl.bindTexture(gl.TEXTURE_2D, null);
        }
    }
    class RenderTarget {
        constructor(options){
            var _a, _b;
            this.antialias = false;
            this.samples = 1;
            this._gl = options.gl;
            this.width = options.width;
            this.height = options.height;
            this.transparency = options.transparency;
            this.antialias = (_a = options.antialias) !== null && _a !== void 0 ? _a : this.antialias;
            this.samples = (_b = options.samples) !== null && _b !== void 0 ? _b : this._gl.getParameter(this._gl.MAX_SAMPLES);
            const gl = this._gl;
            // Determine current context format for blitting later needs to match
            if (gl.drawingBufferFormat) this.bufferFormat = gl.drawingBufferFormat;
            else // Documented in webgl spec
            // https://registry.khronos.org/webgl/specs/latest/1.0/
            if (this.transparency) this.bufferFormat = gl.RGBA8;
            else this.bufferFormat = gl.RGB8;
            this._setupRenderBuffer();
            this._setupFramebuffer();
        }
        setResolution(width, height) {
            const gl = this._gl;
            this.width = width;
            this.height = height;
            // update backing texture size
            gl.bindTexture(gl.TEXTURE_2D, this._frameTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            // update render buffer size
            if (this._renderBuffer) {
                gl.bindRenderbuffer(gl.RENDERBUFFER, this._renderBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, Math.min(this.samples, gl.getParameter(gl.MAX_SAMPLES)), this.bufferFormat, this.width, this.height);
            }
        }
        get renderBuffer() {
            return this._renderBuffer;
        }
        get renderFrameBuffer() {
            return this._renderFrameBuffer;
        }
        get frameBuffer() {
            return this._frameBuffer;
        }
        get frameTexture() {
            return this._frameTexture;
        }
        _setupRenderBuffer() {
            if (this.antialias) {
                const gl = this._gl;
                // Render buffers can be used as an input to a shader
                this._renderBuffer = gl.createRenderbuffer();
                this._renderFrameBuffer = gl.createFramebuffer();
                gl.bindRenderbuffer(gl.RENDERBUFFER, this._renderBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, Math.min(this.samples, gl.getParameter(gl.MAX_SAMPLES)), this.bufferFormat, this.width, this.height);
                gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderFrameBuffer);
                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, this._renderBuffer);
            }
        }
        _setupFramebuffer() {
            // Allocates frame buffer
            const gl = this._gl;
            this._frameTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this._frameTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            // set the filtering so we don't need mips
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // attach the texture as the first color attachment
            const attachmentPoint = gl.COLOR_ATTACHMENT0;
            // After this bind all draw calls will draw to this framebuffer texture
            this._frameBuffer = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachmentPoint, gl.TEXTURE_2D, this._frameTexture, 0);
            // Reset after initialized
            this.disable();
        }
        toRenderSource() {
            if (this.renderBuffer) this.blitRenderBufferToFrameBuffer();
            const source = new RenderSource(this._gl, this._frameTexture);
            return source;
        }
        blitToScreen() {
            const gl = this._gl;
            // set to size of canvas's drawingBuffer
            if (this._renderBuffer) {
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.renderFrameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            } else {
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.frameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            }
        }
        blitRenderBufferToFrameBuffer() {
            if (this._renderBuffer) {
                const gl = this._gl;
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.renderFrameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.frameBuffer);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            }
        }
        copyToTexture(texture) {
            const gl = this._gl;
            if (this._renderBuffer) this.blitRenderBufferToFrameBuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.copyTexImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 0, 0, this.width, this.height, 0);
        }
        /**
     * When called, all drawing gets redirected to this render target
     */ use() {
            const gl = this._gl;
            if (this.antialias) gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderFrameBuffer);
            else gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            // very important to set the viewport to the size of the framebuffer texture
            gl.viewport(0, 0, this.width, this.height);
        }
        /**
     * When called, all drawing is sent back to the canvas
     */ disable() {
            const gl = this._gl;
            // passing null switches rendering back to the canvas
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.bindTexture(gl.TEXTURE_2D, null);
        }
    }
    /* harmony default export */ const line_vertex = "#version 300 es\r\nin vec2 a_position;\r\nin vec4 a_color;\r\n\r\nout lowp vec4 v_color;\r\n\r\nuniform mat4 u_matrix;\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Passthrough the color\r\n   v_color = a_color;\r\n}";
    /* harmony default export */ const line_fragment = "#version 300 es\r\nprecision mediump float;\r\n\r\n// Color\r\nin lowp vec4 v_color;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  fragColor = v_color;\r\n}";
    /**
 * Return the size of the GlType in bytes
 * @param gl
 * @param type
 */ function getGlTypeSizeBytes(gl, type) {
        switch(type){
            case gl.FLOAT:
                return 4;
            case gl.SHORT:
                return 2;
            case gl.UNSIGNED_SHORT:
                return 2;
            case gl.BYTE:
                return 1;
            case gl.UNSIGNED_BYTE:
                return 1;
            default:
                return 1;
        }
    }
    /**
 * Checks if an attribute is present in vertex source
 */ function isAttributeInSource(source, variable) {
        const attributeRegexTemplate = `(?<type>[a-z0-9]+)\\s+${variable};`;
        const regex = new RegExp(attributeRegexTemplate, "g");
        const matches = regex.exec(source);
        return (matches === null || matches === void 0 ? void 0 : matches.length) > 0;
    }
    /**
 * Attempt to discern the glType of an attribute from vertex source
 * @param gl
 * @param source
 * @param variable
 */ function getGLTypeFromSource(gl, source, variable) {
        var _a;
        const attributeRegexTemplate = `(?<type>[a-z0-9]+)\\s+${variable};`;
        const regex = new RegExp(attributeRegexTemplate, "g");
        const matches = regex.exec(source);
        const type = (_a = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _a === void 0 ? void 0 : _a.type;
        switch(type){
            case "float":
            case "vec2":
            case "vec3":
            case "vec4":
                return gl.FLOAT;
            case "int":
            case "ivec2":
            case "ivec3":
            case "ivec4":
                return gl.INT;
            case "uint":
            case "uvec2":
            case "uvec3":
            case "uvec4":
                return gl.UNSIGNED_INT;
            case "bool":
            case "bvec2":
            case "bvec3":
            case "bvec4":
                return gl.BOOL;
            case "short":
                return gl.SHORT;
            case "ushort":
                return gl.UNSIGNED_SHORT;
            case "ubyte":
                return gl.UNSIGNED_BYTE;
            case "byte":
                return gl.BYTE;
            default:
                return gl.FLOAT;
        }
    }
    /**
 * Based on the type return the number of attribute components
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
 * @param gl
 * @param type
 */ function getAttributeComponentSize(gl, type) {
        switch(type){
            case gl.LOW_FLOAT:
            case gl.HIGH_FLOAT:
            case gl.FLOAT:
                return 1;
            case gl.FLOAT_VEC2:
                return 2;
            case gl.FLOAT_VEC3:
                return 3;
            case gl.FLOAT_VEC4:
                return 4;
            case gl.BYTE:
                return 1;
            case gl.UNSIGNED_BYTE:
                return 1;
            case gl.UNSIGNED_SHORT:
            case gl.SHORT:
                return 1;
            default:
                return 1;
        }
    }
    /**
 * Based on the attribute return the corresponding supported attrib pointer type
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
 * @param gl
 * @param type
 */ function getAttributePointerType(gl, type) {
        switch(type){
            case gl.LOW_FLOAT:
            case gl.HIGH_FLOAT:
            case gl.FLOAT:
            case gl.FLOAT_VEC2:
            case gl.FLOAT_VEC3:
            case gl.FLOAT_VEC4:
                return gl.FLOAT;
            case gl.BYTE:
                return gl.BYTE;
            case gl.UNSIGNED_BYTE:
                return gl.UNSIGNED_BYTE;
            case gl.SHORT:
                return gl.SHORT;
            case gl.UNSIGNED_SHORT:
                return gl.UNSIGNED_SHORT;
            default:
                return gl.FLOAT;
        }
    }
    class Shader {
        get compiled() {
            return this._compiled;
        }
        /**
     * Create a shader program in excalibur
     * @param options specify shader vertex and fragment source
     */ constructor(options){
            this._logger = Logger.getInstance();
            this.uniforms = {};
            this.attributes = {};
            this._compiled = false;
            const { gl: gl, vertexSource: vertexSource, fragmentSource: fragmentSource } = options;
            this._gl = gl;
            this.vertexSource = vertexSource;
            this.fragmentSource = fragmentSource;
        }
        dispose() {
            const gl = this._gl;
            gl.deleteProgram(this.program);
            this._gl = null;
        }
        /**
     * Binds the shader program
     */ use() {
            const gl = this._gl;
            gl.useProgram(this.program);
            Shader._ACTIVE_SHADER_INSTANCE = this;
        }
        isCurrentlyBound() {
            return Shader._ACTIVE_SHADER_INSTANCE === this;
        }
        /**
     * Compile the current shader against a webgl context
     */ compile() {
            const gl = this._gl;
            const vertexShader = this._compileShader(gl, this.vertexSource, gl.VERTEX_SHADER);
            const fragmentShader = this._compileShader(gl, this.fragmentSource, gl.FRAGMENT_SHADER);
            this.program = this._createProgram(gl, vertexShader, fragmentShader);
            const attributes = this.getAttributes();
            for (const attribute of attributes)this.attributes[attribute.name] = attribute;
            const uniforms = this.getUniforms();
            for (const uniform of uniforms)this.uniforms[uniform.name] = uniform;
            this._compiled = true;
            return this.program;
        }
        getUniforms() {
            const gl = this._gl;
            const uniformCount = gl.getProgramParameter(this.program, gl.ACTIVE_UNIFORMS);
            const uniforms = [];
            for(let i = 0; i < uniformCount; i++){
                const uniform = gl.getActiveUniform(this.program, i);
                const uniformLocation = gl.getUniformLocation(this.program, uniform.name);
                uniforms.push({
                    name: uniform.name,
                    glType: uniform.type,
                    location: uniformLocation
                });
            }
            return uniforms;
        }
        getAttributes() {
            const gl = this._gl;
            const attributeCount = gl.getProgramParameter(this.program, gl.ACTIVE_ATTRIBUTES);
            const attributes = [];
            for(let i = 0; i < attributeCount; i++){
                const attribute = gl.getActiveAttrib(this.program, i);
                const attributeLocation = gl.getAttribLocation(this.program, attribute.name);
                attributes.push({
                    name: attribute.name,
                    glType: getAttributePointerType(gl, attribute.type),
                    size: getAttributeComponentSize(gl, attribute.type),
                    location: attributeLocation,
                    normalized: false
                });
            }
            return attributes;
        }
        /**
     * Set a texture in a gpu texture slot
     * @param slotNumber
     * @param texture
     */ setTexture(slotNumber, texture) {
            const gl = this._gl;
            gl.activeTexture(gl.TEXTURE0 + slotNumber);
            gl.bindTexture(gl.TEXTURE_2D, texture);
        }
        /**
     * Set an integer uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformInt(name, value) {
            this.setUniform("uniform1i", name, ~~value);
        }
        /**
     * Set an integer uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformInt(name, value) {
            return this.trySetUniform("uniform1i", name, ~~value);
        }
        /**
     * Set an integer array uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformIntArray(name, value) {
            this.setUniform("uniform1iv", name, value);
        }
        /**
     * Set an integer array uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformIntArray(name, value) {
            return this.trySetUniform("uniform1iv", name, value);
        }
        /**
     * Set a boolean uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformBoolean(name, value) {
            this.setUniform("uniform1i", name, value ? 1 : 0);
        }
        /**
     * Set a boolean uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformBoolean(name, value) {
            return this.trySetUniform("uniform1i", name, value ? 1 : 0);
        }
        /**
     * Set a float uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloat(name, value) {
            this.setUniform("uniform1f", name, value);
        }
        /**
     * Set a float uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloat(name, value) {
            return this.trySetUniform("uniform1f", name, value);
        }
        /**
     * Set a float array uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatArray(name, value) {
            this.setUniform("uniform1fv", name, value);
        }
        /**
     * Set a float array uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatArray(name, value) {
            return this.trySetUniform("uniform1fv", name, value);
        }
        /**
     * Set a [[Vector]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatVector(name, value) {
            this.setUniform("uniform2f", name, value.x, value.y);
        }
        /**
     * Set a [[Vector]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatVector(name, value) {
            return this.trySetUniform("uniform2f", name, value.x, value.y);
        }
        /**
     * Set a [[Color]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatColor(name, value) {
            this.setUniform("uniform4f", name, value.r / 255, value.g / 255, value.b / 255, value.a);
        }
        /**
     * Set a [[Color]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatColor(name, value) {
            return this.trySetUniform("uniform4f", name, value.r / 255, value.g / 255, value.b / 255, value.a);
        }
        /**
     * Set an [[Matrix]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformMatrix(name, value) {
            this.setUniform("uniformMatrix4fv", name, false, value.data);
        }
        /**
     * Set an [[Matrix]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformMatrix(name, value) {
            return this.trySetUniform("uniformMatrix4fv", name, false, value.data);
        }
        /**
     * Set any available uniform type in webgl
     *
     * For example setUniform('uniformMatrix2fv', 'u_my2x2_mat`, ...);
     */ setUniform(uniformType, name, ...value) {
            if (!this._compiled) throw Error(`Must compile shader before setting a uniform ${uniformType}:${name}`);
            if (!this.isCurrentlyBound()) throw Error("Currently accessed shader instance is not the current active shader in WebGL, must call `shader.use()` before setting uniforms");
            const gl = this._gl;
            const location1 = gl.getUniformLocation(this.program, name);
            if (location1) {
                const args = [
                    location1,
                    ...value
                ];
                this._gl[uniformType].apply(this._gl, args);
            } else throw Error(`Uniform ${uniformType}:${name} doesn\'t exist or is not used in the shader source code,` + " unused uniforms are optimized away by most browsers");
        }
        /**
     * Set any available uniform type in webgl. Will try to set the uniform, will return false if the uniform didn't exist,
     * true if it was set.
     *
     * WILL NOT THROW on error
     *
     * For example setUniform('uniformMatrix2fv', 'u_my2x2_mat`, ...);
     *
     */ trySetUniform(uniformType, name, ...value) {
            if (!this._compiled) {
                this._logger.warn(`Must compile shader before setting a uniform ${uniformType}:${name}`);
                return false;
            }
            if (!this.isCurrentlyBound()) {
                this._logger.warn("Currently accessed shader instance is not the current active shader in WebGL, must call `shader.use()` before setting uniforms");
                return false;
            }
            const gl = this._gl;
            const location1 = gl.getUniformLocation(this.program, name);
            if (location1) {
                const args = [
                    location1,
                    ...value
                ];
                this._gl[uniformType].apply(this._gl, args);
            } else return false;
            return true;
        }
        _createProgram(gl, vertexShader, fragmentShader) {
            const program = gl.createProgram();
            if (program === null) throw Error("Could not create graphics shader program");
            // attach the shaders.
            gl.attachShader(program, vertexShader);
            gl.attachShader(program, fragmentShader);
            // link the program.
            gl.linkProgram(program);
            const success = gl.getProgramParameter(program, gl.LINK_STATUS);
            if (!success) throw Error(`Could not link the program: [${gl.getProgramInfoLog(program)}]`);
            return program;
        }
        _compileShader(gl, source, type) {
            const typeName = gl.VERTEX_SHADER === type ? "vertex" : "fragment";
            const shader = gl.createShader(type);
            if (shader === null) throw Error(`Could not build shader: [${source}]`);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            const success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
            if (!success) {
                const errorInfo = gl.getShaderInfoLog(shader);
                throw Error(`Could not compile ${typeName} shader:\n\n${errorInfo}${this._processSourceForError(source, errorInfo)}`);
            }
            return shader;
        }
        _processSourceForError(source, errorInfo) {
            if (!source) return errorInfo;
            const lines = source.split("\n");
            const errorLineStart = errorInfo.search(/\d:\d/);
            const errorLineEnd = errorInfo.indexOf(" ", errorLineStart);
            const [_, error2] = errorInfo.slice(errorLineStart, errorLineEnd).split(":").map((v)=>Number(v));
            for(let i = 0; i < lines.length; i++)lines[i] = `${i + 1}: ${lines[i]}${error2 === i + 1 ? " <----- ERROR!" : ""}`;
            return "\n\nSource:\n" + lines.join("\n");
        }
    }
    Shader._ACTIVE_SHADER_INSTANCE = null;
    /**
 * Helper around vertex buffer to simplify creating and uploading geometry
 *
 * Under the hood uses Float32Array
 */ class VertexBuffer {
        constructor(options){
            /**
         * If the vertices never change switching 'static' can be more efficient on the gpu
         *
         * Default is 'dynamic'
         */ this.type = "dynamic";
            const { gl: gl, size: size, type: type, data: data } = options;
            this._gl = gl;
            this.buffer = this._gl.createBuffer();
            if (!data && !size) throw Error("Must either provide data or a size to the VertexBuffer");
            if (!data) this.bufferData = new Float32Array(size);
            else this.bufferData = data;
            this.type = type !== null && type !== void 0 ? type : this.type;
            // Allocate buffer
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
            gl.bufferData(gl.ARRAY_BUFFER, this.bufferData, this.type === "static" ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW);
        }
        /**
     * Bind this vertex buffer
     */ bind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        }
        unbind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, null);
        }
        /**
     * Upload vertex buffer geometry to the GPU
     */ upload(count) {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
            if (count) gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bufferData, 0, count);
            else // TODO always use bufferSubData? need to perf test it
            gl.bufferData(gl.ARRAY_BUFFER, this.bufferData, this.type === "static" ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW);
        }
        dispose() {
            const gl = this._gl;
            gl.deleteBuffer(this.buffer);
            this._gl = null;
        }
    }
    /**
 * Helper around creating vertex attributes in a given [[VertexBuffer]], this is useful for describing
 * the memory layout for your vertices inside a particular buffer
 *
 * Note: This helper assumes interleaved attributes in one [[VertexBuffer]], not many.
 *
 * Working with `gl.vertexAttribPointer` can be tricky, and this attempts to double check you
 */ class VertexLayout {
        get vertexBuffer() {
            return this._vertexBuffer;
        }
        get attributes() {
            return this._attributes;
        }
        constructor(options){
            this._logger = Logger.getInstance();
            this._suppressWarnings = false;
            this._layout = [];
            this._attributes = [];
            this._vertexTotalSizeBytes = 0;
            this._initialized = false;
            const { gl: gl, shader: shader, vertexBuffer: vertexBuffer, attributes: attributes, suppressWarnings: suppressWarnings } = options;
            this._gl = gl;
            this._vertexBuffer = vertexBuffer;
            this._attributes = attributes;
            this._shader = shader;
            this._suppressWarnings = suppressWarnings;
            if (shader) this.initialize();
        }
        /**
     * Total number of bytes that the vertex will take up
     */ get totalVertexSizeBytes() {
            return this._vertexTotalSizeBytes;
        }
        set shader(shader) {
            if (shader && this._shader !== shader) {
                this._shader = shader;
                this.initialize();
            }
        }
        get shader() {
            return this._shader;
        }
        /**
     * Layouts need shader locations and must be bound to a shader
     */ initialize() {
            if (this._initialized) return;
            if (!this._shader) return;
            if (!this._shader.compiled) throw Error("Shader not compiled, shader must be compiled before defining a vertex layout");
            this._vertexTotalSizeBytes = 0;
            this._layout.length = 0;
            const shaderAttributes = this._shader.attributes;
            for (const attribute of this._attributes){
                const attrib = shaderAttributes[attribute[0]];
                if (!attrib) {
                    if (!isAttributeInSource(this._shader.vertexSource, attribute[0])) throw Error(`The attribute named: ${attribute[0]} size ${attribute[1]}` + ` not found in the shader source code:\n ${this._shader.vertexSource}`);
                    if (!this._suppressWarnings) this._logger.warn(`The attribute named: ${attribute[0]} size ${attribute[1]}` + ` not found in the compiled shader. This is possibly a bug:\n` + ` 1. Not a bug, but should remove unused code - attribute "${attribute[0]}" is unused in` + ` vertex/fragment and has been automatically removed by glsl compiler.\n` + ` 2. Definitely a bug, attribute "${attribute[0]}" in layout has been mistyped or is missing` + ` in shader, check vertex/fragment source.`);
                    const glType = getGLTypeFromSource(this._gl, this._shader.vertexSource, attribute[0]);
                    // Unused attribute placeholder
                    this._layout.push({
                        name: attribute[0],
                        glType: glType,
                        size: attribute[1],
                        location: -1,
                        normalized: false
                    });
                }
                if (attrib) {
                    if (attrib.size !== attribute[1]) throw Error(`VertexLayout size definition for attribute: [${attribute[0]}, ${attribute[1]}],` + ` doesn\'t match shader source size ${attrib.size}:\n ${this._shader.vertexSource}`);
                    this._layout.push(attrib);
                }
            }
            // calc size
            let componentsPerVertex = 0;
            for (const vertAttribute of this._layout){
                const typeSize = getGlTypeSizeBytes(this._gl, vertAttribute.glType);
                this._vertexTotalSizeBytes += typeSize * vertAttribute.size;
                componentsPerVertex += vertAttribute.size;
            }
            if (this._vertexBuffer.bufferData.length % componentsPerVertex !== 0) this._logger.warn(`The vertex component size (${componentsPerVertex})  does NOT divide evenly into the specified vertex buffer` + ` (${this._vertexBuffer.bufferData.length})`);
            // create VAO
            const gl = this._gl;
            this._vao = gl.createVertexArray();
            gl.bindVertexArray(this._vao);
            this._vertexBuffer.bind();
            let offset = 0;
            for (const vert of this._layout){
                if (vert.location !== -1) {
                    gl.vertexAttribPointer(vert.location, vert.size, vert.glType, vert.normalized, this.totalVertexSizeBytes, offset);
                    gl.enableVertexAttribArray(vert.location);
                }
                offset += getGlTypeSizeBytes(gl, vert.glType) * vert.size;
            }
            gl.bindVertexArray(null);
            this._vertexBuffer.unbind();
            this._initialized = true;
        }
        /**
     * Bind this layout with it's associated vertex buffer
     * @param uploadBuffer Optionally indicate you wish to upload the buffer to the GPU associated with this layout
     */ use(uploadBuffer = false, count) {
            if (!this._shader) throw Error("No shader is associated with this vertex layout, a shader must be set");
            const gl = this._gl;
            if (!this._shader.isCurrentlyBound()) throw Error("Shader associated with this vertex layout is not active! Call shader.use() before layout.use()");
            this._vertexBuffer.bind();
            if (uploadBuffer) this._vertexBuffer.upload(count);
            gl.bindVertexArray(this._vao);
        }
    }
    class GraphicsDiagnostics {
        static clear() {
            GraphicsDiagnostics.DrawCallCount = 0;
            GraphicsDiagnostics.DrawnImagesCount = 0;
        }
    }
    GraphicsDiagnostics.DrawCallCount = 0;
    GraphicsDiagnostics.DrawnImagesCount = 0;
    class LineRenderer {
        constructor(){
            this.type = "ex.line";
            this.priority = 0;
            this._maxLines = 10922;
            this._vertexIndex = 0;
            this._lineCount = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                vertexSource: line_vertex,
                fragmentSource: line_fragment
            });
            this._shader.compile();
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            this._vertexBuffer = new VertexBuffer({
                gl: gl,
                size: 12 * this._maxLines,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                vertexBuffer: this._vertexBuffer,
                shader: this._shader,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_color",
                        4
                    ]
                ]
            });
        }
        dispose() {
            this._vertexBuffer.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        draw(start, end, color) {
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._lineCount++;
            const transform = this._context.getTransform();
            const finalStart = transform.multiply(start);
            const finalEnd = transform.multiply(end);
            const vertexBuffer = this._vertexBuffer.bufferData;
            // Start
            vertexBuffer[this._vertexIndex++] = finalStart.x;
            vertexBuffer[this._vertexIndex++] = finalStart.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            // End
            vertexBuffer[this._vertexIndex++] = finalEnd.x;
            vertexBuffer[this._vertexIndex++] = finalEnd.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
        }
        _isFull() {
            if (this._lineCount >= this._maxLines) return true;
            return false;
        }
        hasPendingDraws() {
            return this._lineCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._lineCount === 0) return;
            const gl = this._gl;
            this._shader.use();
            this._layout.use(true);
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            gl.drawArrays(gl.LINES, 0, this._lineCount * 2); // 2 verts per line
            GraphicsDiagnostics.DrawnImagesCount += this._lineCount;
            GraphicsDiagnostics.DrawCallCount++;
            // reset
            this._vertexIndex = 0;
            this._lineCount = 0;
        }
    }
    /* harmony default export */ const point_vertex = "#version 300 es\r\nin vec2 a_position;\r\nin vec4 a_color;\r\nin float a_size;\r\nout lowp vec4 v_color;\r\nuniform mat4 u_matrix;\r\n\r\nvoid main() {\r\n  gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n  gl_PointSize = a_size * 2.0;\r\n  v_color = a_color;\r\n}";
    /* harmony default export */ const point_fragment = '#version 300 es\r\n\r\nprecision mediump float;\r\nin lowp vec4 v_color;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  float r = 0.0, delta = 0.0, alpha = 1.0;\r\n  vec2 cxy = 2.0 * gl_PointCoord - 1.0;\r\n  r = dot(cxy, cxy);\r\n\r\n  delta = fwidth(r);\r\n  alpha = 1.0 - smoothstep(1.0 - delta, 1.0 + delta, r);\r\n  // "premultiply" the color by alpha\r\n  vec4 color = v_color;\r\n  color.a = color.a * alpha;\r\n  color.rgb = color.rgb * color.a;\r\n  fragColor = color;\r\n}';
    class PointRenderer {
        constructor(){
            this.type = "ex.point";
            this.priority = 0;
            this._maxPoints = 10922;
            this._pointCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                vertexSource: point_vertex,
                fragmentSource: point_fragment
            });
            this._shader.compile();
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 7 * this._maxPoints,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_size",
                        1
                    ]
                ]
            });
        }
        dispose() {
            this._buffer.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        draw(point, color, size) {
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._pointCount++;
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const finalPoint = transform.multiply(point);
            if (snapToPixel) {
                finalPoint.x = ~~(finalPoint.x + pixelSnapEpsilon);
                finalPoint.y = ~~(finalPoint.y + pixelSnapEpsilon);
            }
            const vertexBuffer = this._buffer.bufferData;
            vertexBuffer[this._vertexIndex++] = finalPoint.x;
            vertexBuffer[this._vertexIndex++] = finalPoint.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a * opacity;
            vertexBuffer[this._vertexIndex++] = size * Math.max(transform.getScaleX(), transform.getScaleY());
        }
        _isFull() {
            if (this._pointCount >= this._maxPoints) return true;
            return false;
        }
        hasPendingDraws() {
            return this._pointCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._pointCount === 0) return;
            const gl = this._gl;
            this._shader.use();
            this._layout.use(true);
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            gl.drawArrays(gl.POINTS, 0, this._pointCount);
            GraphicsDiagnostics.DrawnImagesCount += this._pointCount;
            GraphicsDiagnostics.DrawCallCount++;
            this._pointCount = 0;
            this._vertexIndex = 0;
        }
    }
    /* harmony default export */ const screen_vertex = "#version 300 es\r\nin vec2 a_position;\r\n\r\nin vec2 a_texcoord;\r\nout vec2 v_texcoord;\r\n\r\nvoid main() {\r\n  gl_Position = vec4(a_position, 0.0, 1.0);\r\n\r\n  // Pass the texcoord to the fragment shader.\r\n  v_texcoord = a_texcoord;\r\n}";
    /* harmony default export */ const screen_fragment = "#version 300 es\r\nprecision mediump float;\r\n\r\n// Passed in from the vertex shader.\r\nin vec2 v_texcoord;\r\n\r\n// The texture.\r\nuniform sampler2D u_texture;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n   fragColor = texture(u_texture, v_texcoord);\r\n}";
    /**
 * This is responsible for painting the entire screen during the render passes
 */ class ScreenPassPainter {
        constructor(gl){
            this._gl = gl;
            this._shader = new Shader({
                gl: gl,
                vertexSource: screen_vertex,
                fragmentSource: screen_fragment
            });
            this._shader.compile();
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                type: "static",
                // clip space quad + uv since we don't need a camera
                data: new Float32Array([
                    -1,
                    -1,
                    0,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    -1,
                    1,
                    0,
                    1,
                    -1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ])
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ]
                ]
            });
            this._buffer.upload();
        }
        renderWithPostProcessor(postprocessor) {
            const gl = this._gl;
            postprocessor.getShader().use();
            postprocessor.getLayout().use();
            gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
        renderToScreen() {
            const gl = this._gl;
            this._shader.use();
            this._layout.use();
            gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
    }
    /**
 * Helper that defines and index buffer for quad geometry
 *
 * Index buffers allow you to save space in vertex buffers when you share vertices in geometry
 * it is almost always worth it in terms of performance to use an index buffer.
 */ class QuadIndexBuffer {
        /**
     * @param gl WebGL2RenderingContext this layout will be attached to, these cannot be reused across contexts.
     * @param numberOfQuads Specify the max number of quads you want to draw
     * @param useUint16 Optionally force a uint16 buffer
     */ constructor(gl, numberOfQuads, useUint16){
            this._logger = Logger.getInstance();
            this._gl = gl;
            this.buffer = gl.createBuffer();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
            const totalVertices = numberOfQuads * 6;
            if (!useUint16) this.bufferData = new Uint32Array(totalVertices);
            else {
                // fall back to using gl.UNSIGNED_SHORT or tell the user they are out of luck
                const maxUint16 = 65535;
                const maxUint16Index = Math.floor((maxUint16 - 1) / 4); // max quads
                this.bufferGlType = gl.UNSIGNED_SHORT;
                this.bufferData = new Uint16Array(totalVertices);
                // TODO Should we error if this happens?? maybe not might crash mid game
                if (numberOfQuads > maxUint16Index) this._logger.warn(`Total quads exceeds hardware index buffer limit (uint16), max(${maxUint16Index}) requested quads(${numberOfQuads})`);
            }
            let currentQuad = 0;
            for(let i = 0; i < totalVertices; i += 6){
                // first triangle
                this.bufferData[i + 0] = currentQuad + 0;
                this.bufferData[i + 1] = currentQuad + 1;
                this.bufferData[i + 2] = currentQuad + 2;
                // second triangle
                this.bufferData[i + 3] = currentQuad + 2;
                this.bufferData[i + 4] = currentQuad + 1;
                this.bufferData[i + 5] = currentQuad + 3;
                currentQuad += 4;
            }
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.bufferData, gl.STATIC_DRAW);
        }
        get size() {
            return this.bufferData.length;
        }
        /**
     * Upload data to the GPU
     */ upload() {
            const gl = this._gl;
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.bufferData, gl.STATIC_DRAW);
        }
        /**
     * Bind this index buffer
     */ bind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
        }
        dispose() {
            const gl = this._gl;
            gl.deleteBuffer(this.buffer);
            this._gl = null;
        }
    }
    /* harmony default export */ const image_renderer_frag = "#version 300 es\r\nprecision mediump float;\r\n\r\n// UV coord\r\nin vec2 v_texcoord;\r\n\r\n// Texture index\r\nin lowp float v_textureIndex;\r\n\r\n// Textures in the current draw\r\nuniform sampler2D u_textures[%%count%%];\r\n\r\nuniform bool u_pixelart;\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nin vec4 v_tint;\r\n\r\nin vec2 v_res;\r\n\r\nout vec4 fragColor;\r\n\r\n// Inigo Quilez pixel art filter https://jorenjoestar.github.io/post/pixel_art_filtering/\r\nvec2 uv_iq(in vec2 uv, in vec2 texture_size) {\r\n  vec2 pixel = uv * texture_size;\r\n  \r\n  vec2 seam=floor(pixel+.5);\r\n  vec2 dudv=fwidth(pixel);\r\n  pixel=seam+clamp((pixel-seam)/dudv,-.5,.5);\r\n  \r\n  return pixel/texture_size;\r\n}\r\n\r\nvoid main(){\r\n  // In order to support the most efficient sprite batching, we have multiple\r\n  // textures loaded into the gpu (usually 8) this picker logic skips over textures\r\n  // that do not apply to a particular sprite.\r\n  \r\n  vec4 color=vec4(1.,0,0,1.);\r\n  \r\n  // GLSL is templated out to pick the right texture and set the vec4 color\r\n  %%texture_picker%%\r\n  \r\n  color.rgb=color.rgb*v_opacity;\r\n  color.a=color.a*v_opacity;\r\n  fragColor=color*v_tint;\r\n}";
    /* harmony default export */ const image_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// Opacity\r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\n// UV coordinate\r\nin vec2 a_texcoord;\r\nout vec2 v_texcoord;\r\n\r\n// Texture res\r\nin vec2 a_res;\r\nout vec2 v_res;\r\n\r\n// Texture number\r\nin lowp float a_textureIndex;\r\nout lowp float v_textureIndex;\r\n\r\nin vec4 a_tint;\r\nout vec4 v_tint;\r\n\r\nuniform mat4 u_matrix;\r\n\r\nvoid main(){\r\n  // Set the vertex position using the ortho transform matrix\r\n  gl_Position=u_matrix*vec4(a_position,0.,1.);\r\n  \r\n  // Pass through the Opacity to the fragment shader\r\n  v_opacity=a_opacity;\r\n  // Pass through the UV coord to the fragment shader\r\n  v_texcoord=a_texcoord;\r\n\r\n  v_res = a_res;\r\n\r\n  // Pass through the texture number to the fragment shader\r\n  v_textureIndex=a_textureIndex;\r\n  // Pass through the tint\r\n  v_tint=a_tint;\r\n}";
    class ImageRenderer {
        constructor(options){
            this.type = "ex.image";
            this.priority = 0;
            this._maxImages = 10922; // max(uint16) / 6 verts
            this._maxTextures = 0;
            // Per flush vars
            this._imageCount = 0;
            this._textures = [];
            this._textureIndex = 0;
            this._textureToIndex = new Map();
            this._images = new Set();
            this._vertexIndex = 0;
            this._imageToWidth = new Map();
            this._imageToHeight = new Map();
            this._view = [
                0,
                0,
                0,
                0
            ];
            this._dest = [
                0,
                0
            ];
            this._quad = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            this.pixelArtSampler = options.pixelArtSampler;
            this.uvPadding = options.uvPadding;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // Transform shader source
            // FIXME: PIXEL 6 complains `ERROR: Expression too complex.` if we use it's reported max texture units, 125 seems to work for now...
            this._maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), 125);
            const transformedFrag = this._transformFragmentSource(image_renderer_frag, this._maxTextures);
            // Compile shader
            this._shader = new Shader({
                gl: gl,
                fragmentSource: transformedFrag,
                vertexSource: image_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            // Initialize texture slots to [0, 1, 2, 3, 4, .... maxGPUTextures]
            this._shader.setUniformIntArray("u_textures", [
                ...Array(this._maxTextures)
            ].map((_, i)=>i));
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 48 * this._maxImages,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_res",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ],
                    [
                        "a_textureIndex",
                        1
                    ],
                    [
                        "a_tint",
                        4
                    ]
                ]
            });
            // Setup index buffer
            this._quads = new QuadIndexBuffer(gl, this._maxImages, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._textures.length = 0;
            this._context = null;
            this._gl = null;
        }
        _transformFragmentSource(source, maxTextures) {
            let newSource = source.replace("%%count%%", maxTextures.toString());
            let texturePickerBuilder = "";
            for(let i = 0; i < maxTextures; i++){
                if (i === 0) texturePickerBuilder += `if (v_textureIndex <= ${i}.5) {\n`;
                else texturePickerBuilder += `   else if (v_textureIndex <= ${i}.5) {\n`;
                texturePickerBuilder += `      vec2 uv = u_pixelart ? uv_iq(v_texcoord, v_res) : v_texcoord;\n`;
                texturePickerBuilder += `      color = texture(u_textures[${i}], uv);\n`;
                texturePickerBuilder += `   }\n`;
            }
            newSource = newSource.replace("%%texture_picker%%", texturePickerBuilder);
            return newSource;
        }
        _addImageAsTexture(image) {
            if (this._images.has(image)) return;
            const maybeFiltering = image.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = image.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._context.textureLoader.load(image, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            image.removeAttribute("forceUpload");
            if (this._textures.indexOf(texture) === -1) {
                this._textures.push(texture);
                this._textureToIndex.set(texture, this._textureIndex++);
                this._images.add(image);
            }
        }
        _bindTextures(gl) {
            // Bind textures in the correct order
            for(let i = 0; i < this._maxTextures; i++){
                gl.activeTexture(gl.TEXTURE0 + i);
                gl.bindTexture(gl.TEXTURE_2D, this._textures[i] || this._textures[0]);
            }
        }
        _getTextureIdForImage(image) {
            var _a;
            if (image) {
                const maybeTexture = this._context.textureLoader.get(image);
                return (_a = this._textureToIndex.get(maybeTexture)) !== null && _a !== void 0 ? _a : -1; //this._textures.indexOf(maybeTexture);
            }
            return -1;
        }
        _isFull() {
            if (this._imageCount >= this._maxImages) return true;
            if (this._textures.length >= this._maxTextures) return true;
            return false;
        }
        _getImageWidth(image) {
            let maybeWidth = this._imageToWidth.get(image);
            if (maybeWidth === undefined) {
                maybeWidth = image.width;
                this._imageToWidth.set(image, maybeWidth);
            }
            return maybeWidth;
        }
        _getImageHeight(image) {
            let maybeHeight = this._imageToHeight.get(image);
            if (maybeHeight === undefined) {
                maybeHeight = image.height;
                this._imageToHeight.set(image, maybeHeight);
            }
            return maybeHeight;
        }
        draw(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            var _a, _b, _c, _d;
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._imageCount++;
            // This creates and uploads the texture if not already done
            this._addImageAsTexture(image);
            const maybeImageWidth = this._getImageWidth(image);
            const maybeImageHeight = this._getImageHeight(image);
            let width = maybeImageWidth || swidth || 0;
            let height = maybeImageHeight || sheight || 0;
            this._view[0] = 0;
            this._view[1] = 0;
            this._view[2] = (_a = swidth !== null && swidth !== void 0 ? swidth : maybeImageWidth) !== null && _a !== void 0 ? _a : 0;
            this._view[3] = (_b = sheight !== null && sheight !== void 0 ? sheight : maybeImageHeight) !== null && _b !== void 0 ? _b : 0;
            this._dest[0] = sx !== null && sx !== void 0 ? sx : 1;
            this._dest[1] = sy !== null && sy !== void 0 ? sy : 1;
            // If destination is specified, update view and dest
            if (dx !== undefined && dy !== undefined && dwidth !== undefined && dheight !== undefined) {
                this._view[0] = sx !== null && sx !== void 0 ? sx : 1;
                this._view[1] = sy !== null && sy !== void 0 ? sy : 1;
                this._view[2] = (_c = swidth !== null && swidth !== void 0 ? swidth : maybeImageWidth) !== null && _c !== void 0 ? _c : 0;
                this._view[3] = (_d = sheight !== null && sheight !== void 0 ? sheight : maybeImageHeight) !== null && _d !== void 0 ? _d : 0;
                this._dest[0] = dx;
                this._dest[1] = dy;
                width = dwidth;
                height = dheight;
            }
            sx = this._view[0];
            sy = this._view[1];
            const sw = this._view[2];
            const sh = this._view[3];
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            // top left
            this._quad[0] = this._dest[0];
            this._quad[1] = this._dest[1];
            // top right
            this._quad[2] = this._dest[0] + width;
            this._quad[3] = this._dest[1];
            // bottom left
            this._quad[4] = this._dest[0];
            this._quad[5] = this._dest[1] + height;
            // bottom right
            this._quad[6] = this._dest[0] + width;
            this._quad[7] = this._dest[1] + height;
            transform.multiplyQuadInPlace(this._quad);
            if (snapToPixel) {
                this._quad[0] = ~~(this._quad[0] + sign(this._quad[0]) * pixelSnapEpsilon);
                this._quad[1] = ~~(this._quad[1] + sign(this._quad[1]) * pixelSnapEpsilon);
                this._quad[2] = ~~(this._quad[2] + sign(this._quad[2]) * pixelSnapEpsilon);
                this._quad[3] = ~~(this._quad[3] + sign(this._quad[3]) * pixelSnapEpsilon);
                this._quad[4] = ~~(this._quad[4] + sign(this._quad[4]) * pixelSnapEpsilon);
                this._quad[5] = ~~(this._quad[5] + sign(this._quad[5]) * pixelSnapEpsilon);
                this._quad[6] = ~~(this._quad[6] + sign(this._quad[6]) * pixelSnapEpsilon);
                this._quad[7] = ~~(this._quad[7] + sign(this._quad[7]) * pixelSnapEpsilon);
            }
            const tint = this._context.tint;
            const textureId = this._getTextureIdForImage(image);
            const imageWidth = maybeImageWidth || width;
            const imageHeight = maybeImageHeight || height;
            const uvx0 = (sx + this.uvPadding) / imageWidth;
            const uvy0 = (sy + this.uvPadding) / imageHeight;
            const uvx1 = (sx + sw - this.uvPadding) / imageWidth;
            const uvy1 = (sy + sh - this.uvPadding) / imageHeight;
            const txWidth = maybeImageWidth;
            const txHeight = maybeImageHeight;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = this._quad[0];
            vertexBuffer[this._vertexIndex++] = this._quad[1];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = this._quad[4];
            vertexBuffer[this._vertexIndex++] = this._quad[5];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = this._quad[2];
            vertexBuffer[this._vertexIndex++] = this._quad[3];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = this._quad[6];
            vertexBuffer[this._vertexIndex++] = this._quad[7];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
        }
        hasPendingDraws() {
            return this._imageCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._imageCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true, 48 * this._imageCount); // 4 verts * 12 components
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Turn on pixel art aa sampler
            this._shader.setUniformBoolean("u_pixelart", this.pixelArtSampler);
            // Bind textures to
            this._bindTextures(gl);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._imageCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._imageCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._imageCount = 0;
            this._vertexIndex = 0;
            this._textures.length = 0;
            this._textureIndex = 0;
            this._textureToIndex.clear();
            this._images.clear();
            this._imageToWidth.clear();
            this._imageToHeight.clear();
        }
    }
    /* harmony default export */ const rectangle_renderer_frag = "#version 300 es\r\n\r\nprecision mediump float;\r\n\r\n// UV coord\r\nin vec2 v_uv;\r\n\r\nin vec2 v_size; // in pixels\r\n\r\n// Color coord to blend with image\r\nin lowp vec4 v_color;\r\n\r\n// Stroke color if used\r\nin lowp vec4 v_strokeColor;\r\n\r\n// Stroke thickness if used\r\nin lowp float v_strokeThickness; // in pixels\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n    // modified from https://stackoverflow.com/questions/59197671/glsl-rounded-rectangle-with-variable-border\r\n    vec2 uv = v_uv;\r\n    vec2 fragCoord = uv * v_size;\r\n    float maxX = v_size.x - v_strokeThickness;\r\n    float minX = v_strokeThickness;\r\n    float maxY = v_size.y - v_strokeThickness;\r\n    float minY = v_strokeThickness;\r\n\r\n    if (fragCoord.x < maxX && fragCoord.x > minX &&\r\n        fragCoord.y < maxY && fragCoord.y > minY) {\r\n      fragColor = v_color;\r\n    } else {\r\n      fragColor = v_strokeColor;\r\n    }\r\n    fragColor.a *= v_opacity;\r\n    fragColor.rgb *= fragColor.a;\r\n\r\n    // vec2 v2CenteredPos     = abs(fragCoord - v_size.xy / 2.0);\r\n    // vec2 v2HalfShapeSizePx = v_size.xy/2.0 - v_strokeThickness/2.0;\r\n\r\n    // float fHalfBorderDist      = 0.0;\r\n    // float fHalfBorderThickness = 0.0;\r\n\r\n    // if (fragCoord.x > max(v_radius, v_strokeThickness) && \r\n    //     fragCoord.x < v_size.x - max(v_radius, v_strokeThickness))\r\n    // {\r\n    //     fHalfBorderDist      = v2CenteredPos.y - v2HalfShapeSizePx.y;\r\n    //     fHalfBorderThickness = v_strokeThickness / 2.0;\r\n    // }\r\n    // else if (fragCoord.y > max(v_radius, v_strokeThickness) && \r\n    //          fragCoord.y < v_size.y - max(v_radius, v_strokeThickness))\r\n    // {\r\n    //     fHalfBorderDist      = v2CenteredPos.x - v2HalfShapeSizePx.x;\r\n    //     fHalfBorderThickness = v_strokeThickness / 2.0;\r\n    // }\r\n    // else\r\n    // {\r\n    //     vec2 edgeVec = max(vec2(0.0), v_radius - vec2(\r\n    //         uv.x > 0.5 ? v_size.x - fragCoord.x : fragCoord.x,\r\n    //         uv.y > 0.5 ? v_size.y - fragCoord.y : fragCoord.y));\r\n        \r\n    //     float ellipse_ab    = v_radius-v_strokeThickness;\r\n    //     vec2 ellipse_isect = (v_strokeThickness > v_radius || v_strokeThickness > v_radius) ? vec2(0.0) :\r\n    //                             edgeVec.xy * ellipse_ab*ellipse_ab / length(ellipse_ab*edgeVec.yx); \r\n            \r\n    //     fHalfBorderThickness = (v_radius - length(ellipse_isect)) / 2.0;\r\n    //     fHalfBorderDist      = length(edgeVec) - (v_radius - fHalfBorderThickness);\r\n    // }\r\n\r\n    // vec4 v4FromColor = v_strokeColor;\r\n    // v4FromColor.rgb *= v4FromColor.a;\r\n    // vec4 v4ToColor   = vec4(0.0); // background color is transparent\r\n    // if (fHalfBorderDist < 0.0) {\r\n    //     v4ToColor = v_color;\r\n    //     v4ToColor.rgb *= v4ToColor.a;\r\n    // }\r\n\r\n    // float mixPct = abs(fHalfBorderDist) - fHalfBorderThickness;\r\n\r\n    // vec4 finalColor = mix(v4FromColor, v4ToColor, mixPct);\r\n    // gl_FragColor = finalColor;\r\n}";
    /* harmony default export */ const rectangle_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// UV coordinate\r\nin vec2 a_uv;\r\nout vec2 v_uv;\r\n\r\nin vec2 a_size;\r\nout vec2 v_size;\r\n\r\n// Opacity \r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\nin vec4 a_color;\r\nout vec4 v_color;\r\n\r\nin vec4 a_strokeColor;\r\nout vec4 v_strokeColor;\r\n\r\nin float a_strokeThickness;\r\nout float v_strokeThickness;\r\n\r\nuniform mat4 u_matrix;\r\n\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Pass through UV coords\r\n   v_uv = a_uv;\r\n   // Pass through size\r\n   v_size = a_size;\r\n   // Pass through the Opacity to the fragment shader\r\n   v_opacity = a_opacity;\r\n   // Pass through the color to the fragment shader\r\n   v_color = a_color;\r\n   // Pass through the stroke color to the fragment shader\r\n   v_strokeColor = a_strokeColor;\r\n   // Pass through the stroke thickenss to the fragment shader\r\n   v_strokeThickness = a_strokeThickness;\r\n}";
    class RectangleRenderer {
        constructor(){
            this.type = "ex.rectangle";
            this.priority = 0;
            this._maxRectangles = 10922; // max(uint16) / 6 verts
            this._rectangleCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // https://stackoverflow.com/questions/59197671/glsl-rounded-rectangle-with-variable-border
            this._shader = new Shader({
                gl: gl,
                fragmentSource: rectangle_renderer_frag,
                vertexSource: rectangle_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 64 * this._maxRectangles,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_size",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_strokeColor",
                        4
                    ],
                    [
                        "a_strokeThickness",
                        1
                    ]
                ]
            });
            this._quads = new QuadIndexBuffer(gl, this._maxRectangles, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        _isFull() {
            if (this._rectangleCount >= this._maxRectangles) return true;
            return false;
        }
        draw(...args) {
            if (args[0] instanceof Vector && args[1] instanceof Vector) this.drawLine.apply(this, args);
            else this.drawRectangle.apply(this, args);
        }
        drawLine(start, end, color, thickness = 1) {
            if (this._isFull()) this.flush();
            this._rectangleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const dir = end.sub(start);
            const length = dir.size;
            const normal = dir.normalize().perpendicular();
            const halfThick = thickness / 2;
            /**
         *    +---------------------^----------------------+
         *    |                     | (normal)             |
         *   (startx, starty)------------------>(endx, endy)
         *    |                                            |
         *    + -------------------------------------------+
         */ const startTop = transform.multiply(normal.scale(halfThick).add(start));
            const startBottom = transform.multiply(normal.scale(-halfThick).add(start));
            const endTop = transform.multiply(normal.scale(halfThick).add(end));
            const endBottom = transform.multiply(normal.scale(-halfThick).add(end));
            if (snapToPixel) {
                startTop.x = ~~(startTop.x + pixelSnapEpsilon);
                startTop.y = ~~(startTop.y + pixelSnapEpsilon);
                endTop.x = ~~(endTop.x + pixelSnapEpsilon);
                endTop.y = ~~(endTop.y + pixelSnapEpsilon);
                startBottom.x = ~~(startBottom.x + pixelSnapEpsilon);
                startBottom.y = ~~(startBottom.y + pixelSnapEpsilon);
                endBottom.x = ~~(endBottom.x + pixelSnapEpsilon);
                endBottom.y = ~~(endBottom.y + pixelSnapEpsilon);
            }
            // TODO uv could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            const stroke = Color.Transparent;
            const strokeThickness = 0;
            const width = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = startTop.x;
            vertexBuffer[this._vertexIndex++] = startTop.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = startBottom.x;
            vertexBuffer[this._vertexIndex++] = startBottom.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = endTop.x;
            vertexBuffer[this._vertexIndex++] = endTop.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = endBottom.x;
            vertexBuffer[this._vertexIndex++] = endBottom.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
        }
        drawRectangle(pos, width, height, color, stroke = Color.Transparent, strokeThickness = 0) {
            if (this._isFull()) this.flush();
            this._rectangleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const topLeft = transform.multiply(pos.add(vec(0, 0)));
            const topRight = transform.multiply(pos.add(vec(width, 0)));
            const bottomRight = transform.multiply(pos.add(vec(width, height)));
            const bottomLeft = transform.multiply(pos.add(vec(0, height)));
            if (snapToPixel) {
                topLeft.x = ~~(topLeft.x + pixelSnapEpsilon);
                topLeft.y = ~~(topLeft.y + pixelSnapEpsilon);
                topRight.x = ~~(topRight.x + pixelSnapEpsilon);
                topRight.y = ~~(topRight.y + pixelSnapEpsilon);
                bottomLeft.x = ~~(bottomLeft.x + pixelSnapEpsilon);
                bottomLeft.y = ~~(bottomLeft.y + pixelSnapEpsilon);
                bottomRight.x = ~~(bottomRight.x + pixelSnapEpsilon);
                bottomRight.y = ~~(bottomRight.y + pixelSnapEpsilon);
            }
            // TODO uv could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = topLeft.x;
            vertexBuffer[this._vertexIndex++] = topLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = bottomLeft.x;
            vertexBuffer[this._vertexIndex++] = bottomLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = topRight.x;
            vertexBuffer[this._vertexIndex++] = topRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = bottomRight.x;
            vertexBuffer[this._vertexIndex++] = bottomRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
        }
        hasPendingDraws() {
            return this._rectangleCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._rectangleCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true);
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._rectangleCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._rectangleCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._rectangleCount = 0;
            this._vertexIndex = 0;
        }
    }
    /* harmony default export */ const circle_renderer_frag = "#version 300 es\r\nprecision highp float;\r\n\r\n// UV coord\r\nin vec2 v_uv;\r\n\r\n// Color coord to blend with image\r\nin lowp vec4 v_color;\r\n\r\n// Stroke color if used\r\nin lowp vec4 v_strokeColor;\r\n\r\n// Stroke thickness if used\r\nin lowp float v_strokeThickness;\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  // make (0, 0) the center the uv \r\n  vec2 uv = v_uv * 2.0 - 1.0;\r\n\r\n  vec4 color = v_color;\r\n  vec4 strokeColor = v_strokeColor;\r\n\r\n  // circle border is at radius 1.0 \r\n  // dist is > 0 when inside the circle \r\n  float d = length(uv);\r\n  float dist = 1.0 - length(uv);\r\n\r\n  // Fade based on fwidth\r\n  float fade = fwidth(dot(uv, uv));\r\n\r\n  // if dist is greater than 0 step to 1;\r\n  // when we cross this 0 threshold add a smooth fade\r\n  float fill = smoothstep(-fade/2.0, fade/2.0, dist);\r\n\r\n  // if dist is greater than the stroke thickness step to 1\r\n  float stroke = 1.0 - smoothstep(v_strokeThickness, v_strokeThickness + fade, dist);\r\n\r\n  strokeColor.a *= fill * stroke;\r\n  strokeColor.rgb *= strokeColor.a;\r\n\r\n  color.a *= fill * (1.0 - stroke);\r\n  color.rgb *= color.a;\r\n\r\n  vec4 finalColor = mix(vec4(0.0), (color + strokeColor), fill);\r\n  finalColor.rgb = finalColor.rgb * v_opacity;\r\n  finalColor.a = finalColor.a * v_opacity;\r\n  fragColor = finalColor;\r\n}";
    /* harmony default export */ const circle_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// UV coordinate\r\nin vec2 a_uv;\r\nout vec2 v_uv;\r\n\r\n// Opacity \r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\nin vec4 a_color;\r\nout vec4 v_color;\r\n\r\nin vec4 a_strokeColor;\r\nout vec4 v_strokeColor;\r\n\r\nin float a_strokeThickness;\r\nout float v_strokeThickness;\r\n\r\nuniform mat4 u_matrix;\r\n\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Pass through UV coords\r\n   v_uv = a_uv;\r\n   // Pass through the Opacity to the fragment shader\r\n   v_opacity = a_opacity;\r\n   // Pass through the color to the fragment shader\r\n   v_color = a_color;\r\n   // Pass through the stroke color to the fragment shader\r\n   v_strokeColor = a_strokeColor;\r\n   // Pass through the stroke thickenss to the fragment shader\r\n   v_strokeThickness = a_strokeThickness;\r\n}";
    class CircleRenderer {
        constructor(){
            this.type = "ex.circle";
            this.priority = 0;
            this._maxCircles = 10922; // max(uint16) / 6 verts
            this._circleCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                fragmentSource: circle_renderer_frag,
                vertexSource: circle_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 56 * this._maxCircles,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_strokeColor",
                        4
                    ],
                    [
                        "a_strokeThickness",
                        1
                    ]
                ]
            });
            this._quads = new QuadIndexBuffer(gl, this._maxCircles, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        _isFull() {
            if (this._circleCount >= this._maxCircles) return true;
            return false;
        }
        draw(pos, radius, color, stroke = Color.Transparent, strokeThickness = 0) {
            if (this._isFull()) this.flush();
            this._circleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const topLeft = transform.multiply(pos.add(vec(-radius, -radius)));
            const topRight = transform.multiply(pos.add(vec(radius, -radius)));
            const bottomRight = transform.multiply(pos.add(vec(radius, radius)));
            const bottomLeft = transform.multiply(pos.add(vec(-radius, radius)));
            if (snapToPixel) {
                topLeft.x = ~~(topLeft.x + pixelSnapEpsilon);
                topLeft.y = ~~(topLeft.y + pixelSnapEpsilon);
                topRight.x = ~~(topRight.x + pixelSnapEpsilon);
                topRight.y = ~~(topRight.y + pixelSnapEpsilon);
                bottomLeft.x = ~~(bottomLeft.x + pixelSnapEpsilon);
                bottomLeft.y = ~~(bottomLeft.y + pixelSnapEpsilon);
                bottomRight.x = ~~(bottomRight.x + pixelSnapEpsilon);
                bottomRight.y = ~~(bottomRight.y + pixelSnapEpsilon);
            }
            // TODO UV could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = topLeft.x;
            vertexBuffer[this._vertexIndex++] = topLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = bottomLeft.x;
            vertexBuffer[this._vertexIndex++] = bottomLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = topRight.x;
            vertexBuffer[this._vertexIndex++] = topRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = bottomRight.x;
            vertexBuffer[this._vertexIndex++] = bottomRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
        }
        hasPendingDraws() {
            return this._circleCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._circleCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true);
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._circleCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._circleCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._circleCount = 0;
            this._vertexIndex = 0;
        }
    }
    class Pool {
        constructor(builder, recycler, maxObjects = 100){
            this.builder = builder;
            this.recycler = recycler;
            this.maxObjects = maxObjects;
            this.totalAllocations = 0;
            this.index = 0;
            this.objects = [];
            this.disableWarnings = false;
            this._logger = Logger.getInstance();
        }
        dispose() {
            this.objects.length = 0;
        }
        preallocate() {
            for(let i = 0; i < this.maxObjects; i++)this.objects[i] = this.builder();
        }
        /**
     * Use many instances out of the in the context and return all to the pool.
     *
     * By returning values out of the context they will be un-hooked from the pool and are free to be passed to consumers
     * @param context
     */ using(context) {
            const result = context(this);
            if (result) return this.done(...result);
            return this.done();
        }
        /**
     * Use a single instance out of th pool and immediately return it to the pool
     * @param context
     */ borrow(context) {
            const object = this.get();
            context(object);
            this.index--;
        }
        /**
     * Retrieve a value from the pool, will allocate a new instance if necessary or recycle from the pool
     */ get() {
            if (this.index === this.maxObjects) {
                if (!this.disableWarnings) this._logger.warn("Max pooled objects reached, possible memory leak? Doubling");
                this.maxObjects = this.maxObjects * 2;
            }
            if (this.objects[this.index]) // Pool has an available object already constructed
            return this.recycler(this.objects[this.index++]);
            else {
                // New allocation
                this.totalAllocations++;
                const object = this.objects[this.index++] = this.builder();
                return object;
            }
        }
        done(...objects) {
            // All objects in pool now considered "free"
            this.index = 0;
            for (const object of objects){
                const poolIndex = this.objects.indexOf(object);
                // Build a new object to take the pool place
                this.objects[poolIndex] = this.builder();
                this.totalAllocations++;
            }
            return objects;
        }
    }
    class DrawCall {
        constructor(){
            this.z = 0;
            this.priority = 0;
            this.transform = AffineMatrix.identity();
            this.state = {
                z: 0,
                opacity: 1,
                tint: Color.White,
                material: null
            };
        }
    }
    const defaultVertexSource = `#version 300 es
in vec2 a_position;

in vec2 a_uv;
out vec2 v_uv;

in vec2 a_screenuv;
out vec2 v_screenuv;

uniform mat4 u_matrix;
uniform mat4 u_transform;

void main() {
  // Set the vertex position using the ortho & transform matrix
  gl_Position = u_matrix * u_transform * vec4(a_position, 0.0, 1.0);

  // Pass through the UV coord to the fragment shader
  v_uv = a_uv;
  v_screenuv = a_screenuv;
}
`;
    class Material {
        constructor(options){
            this._logger = Logger.getInstance();
            this._color = Color.Transparent;
            this._initialized = false;
            this._images = new Map();
            this._textures = new Map();
            const { color: color, name: name, vertexSource: vertexSource, fragmentSource: fragmentSource, graphicsContext: graphicsContext, images: images } = options;
            this._name = name !== null && name !== void 0 ? name : "anonymous material";
            this._vertexSource = vertexSource !== null && vertexSource !== void 0 ? vertexSource : defaultVertexSource;
            this._fragmentSource = fragmentSource;
            this._color = color !== null && color !== void 0 ? color : this._color;
            if (!graphicsContext) throw Error(`Material ${name} must be provided an excalibur webgl graphics context`);
            if (graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this._graphicsContext = graphicsContext;
                this._initialize(graphicsContext);
            } else this._logger.warn(`Material ${name} was created in 2D Canvas mode, currently only WebGL is supported`);
            if (images) for(const key in images)this.addImageSource(key, images[key]);
        }
        _initialize(graphicsContextWebGL) {
            if (this._initialized) return;
            const gl = graphicsContextWebGL.__gl;
            // max texture slots - 2 for the graphic texture and screen texture
            this._maxTextureSlots = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 2;
            this._shader = graphicsContextWebGL.createShader({
                vertexSource: this._vertexSource,
                fragmentSource: this._fragmentSource
            });
            this._shader.compile();
            this._initialized = true;
        }
        get name() {
            var _a;
            return (_a = this._name) !== null && _a !== void 0 ? _a : "anonymous material";
        }
        get isUsingScreenTexture() {
            return this._fragmentSource.includes("u_screen_texture");
        }
        update(callback) {
            if (this._shader) {
                this._shader.use();
                callback(this._shader);
            }
        }
        getShader() {
            return this._shader;
        }
        addImageSource(textureUniformName, image) {
            if (this._images.size < this._maxTextureSlots) this._images.set(textureUniformName, image);
            else this._logger.warn(`Max number texture slots ${this._maxTextureSlots} have been reached for material "${this.name}", ` + `no more textures will be uploaded due to hardware constraints.`);
        }
        removeImageSource(textureName) {
            const image = this._images.get(textureName);
            this._graphicsContext.textureLoader.delete(image.image);
            this._images.delete(textureName);
        }
        _loadImageSource(image) {
            const imageElement = image.image;
            const maybeFiltering = imageElement.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(imageElement.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(imageElement.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = imageElement.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._graphicsContext.textureLoader.load(imageElement, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            imageElement.removeAttribute("forceUpload");
            if (!this._textures.has(image)) this._textures.set(image, texture);
            return texture;
        }
        uploadAndBind(gl, startingTextureSlot = 2) {
            let textureSlot = startingTextureSlot;
            for (const [textureName, image] of this._images.entries()){
                if (!image.isLoaded()) {
                    this._logger.warnOnce(`Image named ${textureName} in material ${this.name} not loaded, nothing will be uploaded to the shader.` + ` Did you forget to add this to a loader? https://excaliburjs.com/docs/loaders/`);
                    continue;
                } // skip unloaded images, maybe warn
                const texture = this._loadImageSource(image);
                gl.activeTexture(gl.TEXTURE0 + textureSlot);
                gl.bindTexture(gl.TEXTURE_2D, texture);
                this._shader.trySetUniformInt(textureName, textureSlot);
                textureSlot++;
            }
        }
        use() {
            if (this._initialized) {
                // bind the shader
                this._shader.use();
                // Apply standard uniforms
                this._shader.trySetUniformFloatColor("u_color", this._color);
            } else throw Error(`Material ${this.name} not yet initialized, use the ExcaliburGraphicsContext.createMaterial() to work around this.`);
        }
    }
    class MaterialRenderer {
        constructor(){
            this.type = "ex.material";
            this.priority = 0;
            this._textures = [];
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 24,
                type: "dynamic"
            });
            // Setup a vertex layout/buffer to the material
            this._layout = new VertexLayout({
                gl: gl,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_screenuv",
                        2
                    ]
                ],
                suppressWarnings: true
            });
            // Setup index buffer
            this._quads = new QuadIndexBuffer(gl, 1, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._textures.length = 0;
            this._context = null;
            this._gl = null;
        }
        draw(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            var _a, _b, _c, _d;
            const gl = this._gl;
            // Extract context info
            const material = this._context.material;
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            // material shader
            const shader = material.getShader();
            // construct geometry, or hold on to it in the material?
            // geometry primitive for drawing rectangles?
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            let vertexIndex = 0;
            let width = (image === null || image === void 0 ? void 0 : image.width) || swidth || 0;
            let height = (image === null || image === void 0 ? void 0 : image.height) || sheight || 0;
            let view = [
                0,
                0,
                (_a = swidth !== null && swidth !== void 0 ? swidth : image === null || image === void 0 ? void 0 : image.width) !== null && _a !== void 0 ? _a : 0,
                (_b = sheight !== null && sheight !== void 0 ? sheight : image === null || image === void 0 ? void 0 : image.height) !== null && _b !== void 0 ? _b : 0
            ];
            let dest = [
                sx !== null && sx !== void 0 ? sx : 1,
                sy !== null && sy !== void 0 ? sy : 1
            ];
            // If destination is specified, update view and dest
            if (dx !== undefined && dy !== undefined && dwidth !== undefined && dheight !== undefined) {
                view = [
                    sx !== null && sx !== void 0 ? sx : 1,
                    sy !== null && sy !== void 0 ? sy : 1,
                    (_c = swidth !== null && swidth !== void 0 ? swidth : image === null || image === void 0 ? void 0 : image.width) !== null && _c !== void 0 ? _c : 0,
                    (_d = sheight !== null && sheight !== void 0 ? sheight : image === null || image === void 0 ? void 0 : image.height) !== null && _d !== void 0 ? _d : 0
                ];
                dest = [
                    dx,
                    dy
                ];
                width = dwidth;
                height = dheight;
            }
            sx = view[0];
            sy = view[1];
            const sw = view[2];
            const sh = view[3];
            const topLeft = vec(dest[0], dest[1]);
            const topRight = vec(dest[0] + width, dest[1]);
            const bottomLeft = vec(dest[0], dest[1] + height);
            const bottomRight = vec(dest[0] + width, dest[1] + height);
            const imageWidth = image.width || width;
            const imageHeight = image.height || height;
            const uvx0 = sx / imageWidth;
            const uvy0 = sy / imageHeight;
            const uvx1 = (sx + sw - 0.01) / imageWidth;
            const uvy1 = (sy + sh - 0.01) / imageHeight;
            const topLeftScreen = transform.getPosition();
            const bottomRightScreen = topLeftScreen.add(bottomRight);
            const screenUVX0 = topLeftScreen.x / this._context.width;
            const screenUVY0 = topLeftScreen.y / this._context.height;
            const screenUVX1 = bottomRightScreen.x / this._context.width;
            const screenUVY1 = bottomRightScreen.y / this._context.height;
            // (0, 0) - 0
            vertexBuffer[vertexIndex++] = topLeft.x;
            vertexBuffer[vertexIndex++] = topLeft.y;
            vertexBuffer[vertexIndex++] = uvx0;
            vertexBuffer[vertexIndex++] = uvy0;
            vertexBuffer[vertexIndex++] = screenUVX0;
            vertexBuffer[vertexIndex++] = screenUVY0;
            // (0, 1) - 1
            vertexBuffer[vertexIndex++] = bottomLeft.x;
            vertexBuffer[vertexIndex++] = bottomLeft.y;
            vertexBuffer[vertexIndex++] = uvx0;
            vertexBuffer[vertexIndex++] = uvy1;
            vertexBuffer[vertexIndex++] = screenUVX0;
            vertexBuffer[vertexIndex++] = screenUVY1;
            // (1, 0) - 2
            vertexBuffer[vertexIndex++] = topRight.x;
            vertexBuffer[vertexIndex++] = topRight.y;
            vertexBuffer[vertexIndex++] = uvx1;
            vertexBuffer[vertexIndex++] = uvy0;
            vertexBuffer[vertexIndex++] = screenUVX1;
            vertexBuffer[vertexIndex++] = screenUVY0;
            // (1, 1) - 3
            vertexBuffer[vertexIndex++] = bottomRight.x;
            vertexBuffer[vertexIndex++] = bottomRight.y;
            vertexBuffer[vertexIndex++] = uvx1;
            vertexBuffer[vertexIndex++] = uvy1;
            vertexBuffer[vertexIndex++] = screenUVX1;
            vertexBuffer[vertexIndex++] = screenUVY1;
            // This creates and uploads the texture if not already done
            const texture = this._addImageAsTexture(image);
            // apply material
            material.use();
            this._layout.shader = shader;
            // apply layout and geometry
            this._layout.use(true);
            // apply time in ms since the page (performance.now())
            shader.trySetUniformFloat("u_time_ms", performance.now());
            // apply opacity
            shader.trySetUniformFloat("u_opacity", opacity);
            // apply resolution
            shader.trySetUniformFloatVector("u_resolution", vec(this._context.width, this._context.height));
            // apply graphic resolution
            shader.trySetUniformFloatVector("u_graphic_resolution", vec(imageWidth, imageHeight));
            // apply size
            shader.trySetUniformFloatVector("u_size", vec(sw, sh));
            // apply orthographic projection
            shader.trySetUniformMatrix("u_matrix", this._context.ortho);
            // apply geometry transform
            shader.trySetUniformMatrix("u_transform", transform.to4x4());
            // bind graphic image texture 'uniform sampler2D u_graphic;'
            gl.activeTexture(gl.TEXTURE0 + 0);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            shader.trySetUniformInt("u_graphic", 0);
            // bind the screen texture
            gl.activeTexture(gl.TEXTURE0 + 1);
            gl.bindTexture(gl.TEXTURE_2D, this._context.materialScreenTexture);
            shader.trySetUniformInt("u_screen_texture", 1);
            // bind any additional textures in the material
            material.uploadAndBind(gl);
            // bind quad index buffer
            this._quads.bind();
            // Draw a single quad
            gl.drawElements(gl.TRIANGLES, 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount++;
            GraphicsDiagnostics.DrawCallCount++;
        }
        _addImageAsTexture(image) {
            const maybeFiltering = image.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = image.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._context.textureLoader.load(image, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            image.removeAttribute("forceUpload");
            if (this._textures.indexOf(texture) === -1) this._textures.push(texture);
            return texture;
        }
        hasPendingDraws() {
            return false;
        }
        flush() {
        // flush does not do anything, material renderer renders immediately per draw
        }
    }
    // renderers
    const pixelSnapEpsilon = 0.0001;
    class ExcaliburGraphicsContextWebGLDebug {
        constructor(_webglCtx){
            this._webglCtx = _webglCtx;
            this._debugText = new DebugText();
        }
        /**
     * Draw a debugging rectangle to the context
     * @param x
     * @param y
     * @param width
     * @param height
     */ drawRect(x, y, width, height, rectOptions = {
            color: Color.Black
        }) {
            this.drawLine(vec(x, y), vec(x + width, y), {
                ...rectOptions
            });
            this.drawLine(vec(x + width, y), vec(x + width, y + height), {
                ...rectOptions
            });
            this.drawLine(vec(x + width, y + height), vec(x, y + height), {
                ...rectOptions
            });
            this.drawLine(vec(x, y + height), vec(x, y), {
                ...rectOptions
            });
        }
        /**
     * Draw a debugging line to the context
     * @param start
     * @param end
     * @param lineOptions
     */ drawLine(start, end, lineOptions = {
            color: Color.Black
        }) {
            this._webglCtx.draw("ex.line", start, end, lineOptions.color);
        }
        /**
     * Draw a debugging point to the context
     * @param point
     * @param pointOptions
     */ drawPoint(point, pointOptions = {
            color: Color.Black,
            size: 5
        }) {
            this._webglCtx.draw("ex.point", point, pointOptions.color, pointOptions.size);
        }
        drawText(text, pos) {
            this._debugText.write(this._webglCtx, text, pos);
        }
    }
    class ExcaliburGraphicsContextWebGL {
        get z() {
            return this._state.current.z;
        }
        set z(value) {
            this._state.current.z = value;
        }
        get opacity() {
            return this._state.current.opacity;
        }
        set opacity(value) {
            this._state.current.opacity = value;
        }
        get tint() {
            return this._state.current.tint;
        }
        set tint(color) {
            this._state.current.tint = color;
        }
        get width() {
            return this.__gl.canvas.width;
        }
        get height() {
            return this.__gl.canvas.height;
        }
        get ortho() {
            return this._ortho;
        }
        /**
     * Checks the underlying webgl implementation if the requested internal resolution is supported
     * @param dim
     */ checkIfResolutionSupported(dim) {
            // Slight hack based on this thread https://groups.google.com/g/webgl-dev-list/c/AHONvz3oQTo
            let supported = true;
            if (dim.width > 4096 || dim.height > 4096) supported = false;
            return supported;
        }
        constructor(options){
            this._logger = Logger.getInstance();
            this._renderers = new Map();
            this._isDrawLifecycle = false;
            this.useDrawSorting = true;
            this._drawCallPool = new Pool(()=>new DrawCall(), (instance)=>{
                instance.priority = 0;
                instance.z = 0;
                instance.renderer = undefined;
                instance.args = undefined;
                return instance;
            }, 4000);
            this._drawCallIndex = 0;
            this._drawCalls = new Array(4000).fill(null);
            // Postprocessing is a tuple with 2 render targets, these are flip-flopped during the postprocessing process
            this._postProcessTargets = [];
            this._postprocessors = [];
            this._transform = new TransformStack();
            this._state = new StateStack();
            /**
         * Snaps the drawing x/y coordinate to the nearest whole pixel
         */ this.snapToPixel = false;
            /**
         * Native context smoothing
         */ this.smoothing = false;
            /**
         * Whether the pixel art sampler is enabled for smooth sub pixel anti-aliasing
         */ this.pixelArtSampler = false;
            /**
         * UV padding in pixels to use in internal image rendering to prevent texture bleed
         *
         */ this.uvPadding = .01;
            this.backgroundColor = Color.ExcaliburBlue;
            this.multiSampleAntialiasing = true;
            this.transparency = true;
            this._isContextLost = false;
            this._disposed = false;
            this._imageToWidth = new Map();
            this._imageToHeight = new Map();
            this.debug = new ExcaliburGraphicsContextWebGLDebug(this);
            this._totalPostProcessorTime = 0;
            const { canvasElement: canvasElement, context: context, enableTransparency: enableTransparency, antialiasing: antialiasing, uvPadding: uvPadding, multiSampleAntialiasing: multiSampleAntialiasing, pixelArtSampler: pixelArtSampler, powerPreference: powerPreference, snapToPixel: snapToPixel, backgroundColor: backgroundColor, useDrawSorting: useDrawSorting, handleContextLost: handleContextLost, handleContextRestored: handleContextRestored } = options;
            this.__gl = context !== null && context !== void 0 ? context : canvasElement.getContext("webgl2", {
                antialias: antialiasing !== null && antialiasing !== void 0 ? antialiasing : this.smoothing,
                premultipliedAlpha: false,
                alpha: enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : this.transparency,
                depth: false,
                powerPreference: powerPreference !== null && powerPreference !== void 0 ? powerPreference : "high-performance"
            });
            if (!this.__gl) throw Error("Failed to retrieve webgl context from browser");
            if (handleContextLost) this.__gl.canvas.addEventListener("webglcontextlost", handleContextLost, false);
            if (handleContextRestored) this.__gl.canvas.addEventListener("webglcontextrestored", handleContextRestored, false);
            this.__gl.canvas.addEventListener("webglcontextlost", ()=>{
                this._isContextLost = true;
            });
            this.__gl.canvas.addEventListener("webglcontextrestored", ()=>{
                this._isContextLost = false;
            });
            this.textureLoader = new TextureLoader(this.__gl);
            this.snapToPixel = snapToPixel !== null && snapToPixel !== void 0 ? snapToPixel : this.snapToPixel;
            this.smoothing = antialiasing !== null && antialiasing !== void 0 ? antialiasing : this.smoothing;
            this.transparency = enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : this.transparency;
            this.pixelArtSampler = pixelArtSampler !== null && pixelArtSampler !== void 0 ? pixelArtSampler : this.pixelArtSampler;
            this.uvPadding = uvPadding !== null && uvPadding !== void 0 ? uvPadding : this.uvPadding;
            this.multiSampleAntialiasing = typeof multiSampleAntialiasing === "boolean" ? multiSampleAntialiasing : this.multiSampleAntialiasing;
            this.samples = typeof multiSampleAntialiasing === "object" ? multiSampleAntialiasing.samples : undefined;
            this.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : this.backgroundColor;
            this.useDrawSorting = useDrawSorting !== null && useDrawSorting !== void 0 ? useDrawSorting : this.useDrawSorting;
            this._drawCallPool.disableWarnings = true;
            this._drawCallPool.preallocate();
            this._init();
        }
        dispose() {
            if (!this._disposed) {
                this._disposed = true;
                this.textureLoader.dispose();
                for (const renderer of this._renderers.values())renderer.dispose();
                this._renderers.clear();
                this._drawCallPool.dispose();
                this._drawCalls.length = 0;
                this.__gl = null;
            }
        }
        _init() {
            const gl = this.__gl;
            // Setup viewport and view matrix
            this._ortho = Matrix.ortho(0, gl.canvas.width, gl.canvas.height, 0, 400, -400);
            gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
            // Clear background
            gl.clearColor(this.backgroundColor.r / 255, this.backgroundColor.g / 255, this.backgroundColor.b / 255, this.backgroundColor.a);
            gl.clear(gl.COLOR_BUFFER_BIT);
            // Enable alpha blending
            // https://www.realtimerendering.com/blog/gpus-prefer-premultiplication/
            gl.enable(gl.BLEND);
            gl.blendEquation(gl.FUNC_ADD);
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
            gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            // Setup builtin renderers
            this.register(new ImageRenderer({
                uvPadding: this.uvPadding,
                pixelArtSampler: this.pixelArtSampler
            }));
            this.register(new MaterialRenderer());
            this.register(new RectangleRenderer());
            this.register(new CircleRenderer());
            this.register(new PointRenderer());
            this.register(new LineRenderer());
            this.materialScreenTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this.materialScreenTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
            gl.bindTexture(gl.TEXTURE_2D, null);
            this._screenRenderer = new ScreenPassPainter(gl);
            this._renderTarget = new RenderTarget({
                gl: gl,
                transparency: this.transparency,
                width: gl.canvas.width,
                height: gl.canvas.height
            });
            this._postProcessTargets = [
                new RenderTarget({
                    gl: gl,
                    transparency: this.transparency,
                    width: gl.canvas.width,
                    height: gl.canvas.height
                }),
                new RenderTarget({
                    gl: gl,
                    transparency: this.transparency,
                    width: gl.canvas.width,
                    height: gl.canvas.height
                })
            ];
            this._msaaTarget = new RenderTarget({
                gl: gl,
                transparency: this.transparency,
                width: gl.canvas.width,
                height: gl.canvas.height,
                antialias: this.multiSampleAntialiasing,
                samples: this.samples
            });
        }
        register(renderer) {
            this._renderers.set(renderer.type, renderer);
            renderer.initialize(this.__gl, this);
        }
        get(rendererName) {
            return this._renderers.get(rendererName);
        }
        _isCurrentRenderer(renderer) {
            if (!this._currentRenderer || this._currentRenderer === renderer) return true;
            return false;
        }
        beginDrawLifecycle() {
            this._isDrawLifecycle = true;
        }
        endDrawLifecycle() {
            this._isDrawLifecycle = false;
        }
        draw(rendererName, ...args) {
            if (!this._isDrawLifecycle) this._logger.warnOnce(`Attempting to draw outside the the drawing lifecycle (preDraw/postDraw) is not supported and is a source of bugs/errors.\n` + `If you want to do custom drawing, use Actor.graphics, or any onPreDraw or onPostDraw handler.`);
            if (this._isContextLost) {
                this._logger.errorOnce(`Unable to draw ${rendererName}, the webgl context is lost`);
                return;
            }
            const renderer = this._renderers.get(rendererName);
            if (renderer) {
                if (this.useDrawSorting) {
                    const drawCall = this._drawCallPool.get();
                    drawCall.z = this._state.current.z;
                    drawCall.priority = renderer.priority;
                    drawCall.renderer = rendererName;
                    this.getTransform().clone(drawCall.transform);
                    drawCall.state.z = this._state.current.z;
                    drawCall.state.opacity = this._state.current.opacity;
                    drawCall.state.tint = this._state.current.tint;
                    drawCall.state.material = this._state.current.material;
                    drawCall.args = args;
                    this._drawCalls[this._drawCallIndex++] = drawCall;
                } else {
                    // Set the current renderer if not defined
                    if (!this._currentRenderer) this._currentRenderer = renderer;
                    if (!this._isCurrentRenderer(renderer)) // switching graphics means we must flush the previous
                    this._currentRenderer.flush();
                    // If we are still using the same renderer we can add to the current batch
                    renderer.draw(...args);
                    this._currentRenderer = renderer;
                }
            } else throw Error(`No renderer with name ${rendererName} has been registered`);
        }
        resetTransform() {
            this._transform.current = AffineMatrix.identity();
        }
        updateViewport(resolution) {
            const gl = this.__gl;
            this._ortho = this._ortho = Matrix.ortho(0, resolution.width, resolution.height, 0, 400, -400);
            this._renderTarget.setResolution(gl.canvas.width, gl.canvas.height);
            this._msaaTarget.setResolution(gl.canvas.width, gl.canvas.height);
            this._postProcessTargets[0].setResolution(gl.canvas.width, gl.canvas.height);
            this._postProcessTargets[1].setResolution(gl.canvas.width, gl.canvas.height);
        }
        _getImageWidth(image) {
            let maybeWidth = this._imageToWidth.get(image);
            if (maybeWidth === undefined) {
                maybeWidth = image.width;
                this._imageToWidth.set(image, maybeWidth);
            }
            return maybeWidth;
        }
        _getImageHeight(image) {
            let maybeHeight = this._imageToHeight.get(image);
            if (maybeHeight === undefined) {
                maybeHeight = image.height;
                this._imageToHeight.set(image, maybeHeight);
            }
            return maybeHeight;
        }
        drawImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            if (swidth === 0 || sheight === 0) return; // zero dimension dest exit early
            else if (dwidth === 0 || dheight === 0) return; // zero dimension dest exit early
            else if (this._getImageWidth(image) === 0 || this._getImageHeight(image) === 0) return; // zero dimension source exit early
            if (!image) {
                Logger.getInstance().warn("Cannot draw a null or undefined image");
                // tslint:disable-next-line: no-console
                if (console.trace) // tslint:disable-next-line: no-console
                console.trace();
                return;
            }
            if (this._state.current.material) this.draw("ex.material", image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight);
            else this.draw("ex.image", image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight);
        }
        drawLine(start, end, color, thickness = 1) {
            this.draw("ex.rectangle", start, end, color, thickness);
        }
        drawRectangle(pos, width, height, color, stroke, strokeThickness) {
            this.draw("ex.rectangle", pos, width, height, color, stroke, strokeThickness);
        }
        drawCircle(pos, radius, color, stroke, thickness) {
            this.draw("ex.circle", pos, radius, color, stroke, thickness);
        }
        save() {
            this._transform.save();
            this._state.save();
        }
        restore() {
            this._transform.restore();
            this._state.restore();
        }
        translate(x, y) {
            this._transform.translate(this.snapToPixel ? ~~(x + pixelSnapEpsilon) : x, this.snapToPixel ? ~~(y + pixelSnapEpsilon) : y);
        }
        rotate(angle) {
            this._transform.rotate(angle);
        }
        scale(x, y) {
            this._transform.scale(x, y);
        }
        transform(matrix) {
            this._transform.current = matrix;
        }
        getTransform() {
            return this._transform.current;
        }
        multiply(m) {
            this._transform.current.multiply(m, this._transform.current);
        }
        addPostProcessor(postprocessor) {
            this._postprocessors.push(postprocessor);
            postprocessor.initialize(this.__gl);
        }
        removePostProcessor(postprocessor) {
            const index = this._postprocessors.indexOf(postprocessor);
            if (index !== -1) this._postprocessors.splice(index, 1);
        }
        clearPostProcessors() {
            this._postprocessors.length = 0;
        }
        updatePostProcessors(delta) {
            for (const postprocessor of this._postprocessors){
                const shader = postprocessor.getShader();
                shader.use();
                const uniforms = shader.getUniforms();
                this._totalPostProcessorTime += delta;
                if (uniforms.find((u)=>u.name === "u_time_ms")) shader.setUniformFloat("u_time_ms", this._totalPostProcessorTime);
                if (uniforms.find((u)=>u.name === "u_elapsed_ms")) shader.setUniformFloat("u_elapsed_ms", delta);
                if (uniforms.find((u)=>u.name === "u_resolution")) shader.setUniformFloatVector("u_resolution", vec(this.width, this.height));
                if (postprocessor.onUpdate) postprocessor.onUpdate(delta);
            }
        }
        set material(material) {
            this._state.current.material = material;
        }
        get material() {
            return this._state.current.material;
        }
        /**
     * Creates and initializes the material which compiles the internal shader
     * @param options
     * @returns Material
     */ createMaterial(options) {
            const material = new Material({
                ...options,
                graphicsContext: this
            });
            return material;
        }
        createShader(options) {
            const gl = this.__gl;
            const { vertexSource: vertexSource, fragmentSource: fragmentSource } = options;
            const shader = new Shader({
                gl: gl,
                vertexSource: vertexSource,
                fragmentSource: fragmentSource
            });
            shader.compile();
            return shader;
        }
        clear() {
            const gl = this.__gl;
            const currentTarget = this.multiSampleAntialiasing ? this._msaaTarget : this._renderTarget;
            currentTarget.use();
            gl.clearColor(this.backgroundColor.r / 255, this.backgroundColor.g / 255, this.backgroundColor.b / 255, this.backgroundColor.a);
            // Clear the context with the newly set color. This is
            // the function call that actually does the drawing.
            gl.clear(gl.COLOR_BUFFER_BIT);
        }
        /**
     * Flushes all batched rendering to the screen
     */ flush() {
            if (this._isContextLost) {
                this._logger.errorOnce(`Unable to flush the webgl context is lost`);
                return;
            }
            // render target captures all draws and redirects to the render target
            let currentTarget = this.multiSampleAntialiasing ? this._msaaTarget : this._renderTarget;
            currentTarget.use();
            if (this.useDrawSorting) {
                // null out unused draw calls
                for(let i = this._drawCallIndex; i < this._drawCalls.length; i++)this._drawCalls[i] = null;
                // sort draw calls
                // Find the original order of the first instance of the draw call
                const originalSort = new Map();
                for (const [name] of this._renderers){
                    let firstIndex = 0;
                    for(firstIndex = 0; firstIndex < this._drawCallIndex; firstIndex++){
                        if (this._drawCalls[firstIndex].renderer === name) break;
                    }
                    originalSort.set(name, firstIndex);
                }
                this._drawCalls.sort((a, b)=>{
                    if (a === null || b === null) return 0;
                    const zIndex = a.z - b.z;
                    const originalSortOrder = originalSort.get(a.renderer) - originalSort.get(b.renderer);
                    const priority = a.priority - b.priority;
                    if (zIndex === 0) {
                        if (priority === 0) return originalSortOrder; // use the original order to inform draw call packing to maximally preserve painter order
                        return priority;
                    }
                    return zIndex;
                });
                const oldTransform = this._transform.current;
                const oldState = this._state.current;
                if (this._drawCalls.length && this._drawCallIndex) {
                    let currentRendererName = this._drawCalls[0].renderer;
                    let currentRenderer = this._renderers.get(currentRendererName);
                    for(let i = 0; i < this._drawCallIndex; i++){
                        // hydrate the state for renderers
                        this._transform.current = this._drawCalls[i].transform;
                        this._state.current = this._drawCalls[i].state;
                        if (this._drawCalls[i].renderer !== currentRendererName) {
                            // switching graphics renderer means we must flush the previous
                            currentRenderer.flush();
                            currentRendererName = this._drawCalls[i].renderer;
                            currentRenderer = this._renderers.get(currentRendererName);
                        }
                        // ! hack to grab screen texture before materials run because they might want it
                        if (currentRenderer instanceof MaterialRenderer && this.material.isUsingScreenTexture) {
                            currentTarget.copyToTexture(this.materialScreenTexture);
                            currentTarget.use();
                        }
                        // If we are still using the same renderer we can add to the current batch
                        currentRenderer.draw(...this._drawCalls[i].args);
                    }
                    if (currentRenderer.hasPendingDraws()) currentRenderer.flush();
                }
                // reset state
                this._transform.current = oldTransform;
                this._state.current = oldState;
                // reclaim draw calls
                this._drawCallPool.done();
                this._drawCallIndex = 0;
                this._imageToHeight.clear();
                this._imageToWidth.clear();
            } else {
                // This is the final flush at the moment to draw any leftover pending draw
                for (const renderer of this._renderers.values())if (renderer.hasPendingDraws()) renderer.flush();
            }
            currentTarget.disable();
            // post process step
            if (this._postprocessors.length > 0) {
                const source = currentTarget.toRenderSource();
                source.use();
            }
            // flip flop render targets for post processing
            for(let i = 0; i < this._postprocessors.length; i++){
                currentTarget = this._postProcessTargets[i % 2];
                this._postProcessTargets[i % 2].use();
                this._screenRenderer.renderWithPostProcessor(this._postprocessors[i]);
                this._postProcessTargets[i % 2].toRenderSource().use();
            }
            // Final blit to the screen
            currentTarget.blitToScreen();
        }
    }
    const ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon = 0.0001;
    class ExcaliburGraphicsContext2DCanvasDebug {
        constructor(_ex){
            this._ex = _ex;
            this._debugText = new DebugText();
        }
        /**
     * Draw a debug rectangle to the context
     * @param x
     * @param y
     * @param width
     * @param height
     */ drawRect(x, y, width, height) {
            this._ex.__ctx.save();
            this._ex.__ctx.strokeStyle = "red";
            this._ex.__ctx.strokeRect(this._ex.snapToPixel ? ~~(x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : x, this._ex.snapToPixel ? ~~(y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : y, this._ex.snapToPixel ? ~~(width + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : width, this._ex.snapToPixel ? ~~(height + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : height);
            this._ex.__ctx.restore();
        }
        drawLine(start, end, lineOptions = {
            color: Color.Black
        }) {
            this._ex.__ctx.save();
            this._ex.__ctx.beginPath();
            this._ex.__ctx.strokeStyle = lineOptions.color.toString();
            this._ex.__ctx.moveTo(this._ex.snapToPixel ? ~~(start.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.x, this._ex.snapToPixel ? ~~(start.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.y);
            this._ex.__ctx.lineTo(this._ex.snapToPixel ? ~~(end.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.x, this._ex.snapToPixel ? ~~(end.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.y);
            this._ex.__ctx.lineWidth = 2;
            this._ex.__ctx.stroke();
            this._ex.__ctx.closePath();
            this._ex.__ctx.restore();
        }
        drawPoint(point, pointOptions = {
            color: Color.Black,
            size: 5
        }) {
            this._ex.__ctx.save();
            this._ex.__ctx.beginPath();
            this._ex.__ctx.fillStyle = pointOptions.color.toString();
            this._ex.__ctx.arc(this._ex.snapToPixel ? ~~(point.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : point.x, this._ex.snapToPixel ? ~~(point.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : point.y, pointOptions.size, 0, Math.PI * 2);
            this._ex.__ctx.fill();
            this._ex.__ctx.closePath();
            this._ex.__ctx.restore();
        }
        drawText(text, pos) {
            this._debugText.write(this._ex, text, pos);
        }
    }
    class ExcaliburGraphicsContext2DCanvas {
        get width() {
            return this.__ctx.canvas.width;
        }
        get height() {
            return this.__ctx.canvas.height;
        }
        get opacity() {
            return this._state.current.opacity;
        }
        set opacity(value) {
            this._state.current.opacity = value;
        }
        get tint() {
            return this._state.current.tint;
        }
        set tint(color) {
            this._state.current.tint = color;
        }
        get smoothing() {
            return this.__ctx.imageSmoothingEnabled;
        }
        set smoothing(value) {
            this.__ctx.imageSmoothingEnabled = value;
        }
        constructor(options){
            /**
         * Unused in Canvas implementation
         */ this.useDrawSorting = false;
            /**
         * Unused in Canvas implementation
         */ this.z = 0;
            this.backgroundColor = Color.ExcaliburBlue;
            this._state = new StateStack();
            this.snapToPixel = false;
            this.debug = new ExcaliburGraphicsContext2DCanvasDebug(this);
            const { canvasElement: canvasElement, context: context, enableTransparency: enableTransparency, snapToPixel: snapToPixel, antialiasing: smoothing, backgroundColor: backgroundColor } = options;
            this.__ctx = context !== null && context !== void 0 ? context : canvasElement.getContext("2d", {
                alpha: enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : true
            });
            if (!this.__ctx) throw new Error("Cannot build new ExcaliburGraphicsContext2D for some reason!");
            this.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : this.backgroundColor;
            this.snapToPixel = snapToPixel !== null && snapToPixel !== void 0 ? snapToPixel : this.snapToPixel;
            this.smoothing = smoothing !== null && smoothing !== void 0 ? smoothing : this.smoothing;
        }
        resetTransform() {
            this.__ctx.resetTransform();
        }
        updateViewport(_resolution) {
        // pass
        }
        drawImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            if (swidth === 0 || sheight === 0) return; // zero dimension dest exit early
            else if (dwidth === 0 || dheight === 0) return; // zero dimension dest exit early
            else if (image.width === 0 || image.height === 0) return; // zero dimension source exit early
            this.__ctx.globalAlpha = this.opacity;
            const args = [
                image,
                sx,
                sy,
                swidth,
                sheight,
                dx,
                dy,
                dwidth,
                dheight
            ].filter((a)=>a !== undefined).map((a)=>typeof a === "number" && this.snapToPixel ? ~~a : a);
            this.__ctx.drawImage.apply(this.__ctx, args);
            GraphicsDiagnostics.DrawCallCount++;
            GraphicsDiagnostics.DrawnImagesCount = 1;
        }
        drawLine(start, end, color, thickness = 1) {
            this.__ctx.save();
            this.__ctx.beginPath();
            this.__ctx.strokeStyle = color.toString();
            this.__ctx.moveTo(this.snapToPixel ? ~~(start.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.x, this.snapToPixel ? ~~(start.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.y);
            this.__ctx.lineTo(this.snapToPixel ? ~~(end.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.x, this.snapToPixel ? ~~(end.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.y);
            this.__ctx.lineWidth = thickness;
            this.__ctx.stroke();
            this.__ctx.closePath();
            this.__ctx.restore();
        }
        drawRectangle(pos, width, height, color) {
            this.__ctx.save();
            this.__ctx.fillStyle = color.toString();
            this.__ctx.fillRect(this.snapToPixel ? ~~(pos.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.x, this.snapToPixel ? ~~(pos.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.y, this.snapToPixel ? ~~(width + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : width, this.snapToPixel ? ~~(height + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : height);
            this.__ctx.restore();
        }
        drawCircle(pos, radius, color, stroke, thickness) {
            this.__ctx.save();
            this.__ctx.beginPath();
            if (stroke) this.__ctx.strokeStyle = stroke.toString();
            if (thickness) this.__ctx.lineWidth = thickness;
            this.__ctx.fillStyle = color.toString();
            this.__ctx.arc(this.snapToPixel ? ~~(pos.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.x, this.snapToPixel ? ~~(pos.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.y, radius, 0, Math.PI * 2);
            this.__ctx.fill();
            if (stroke) this.__ctx.stroke();
            this.__ctx.closePath();
            this.__ctx.restore();
        }
        /**
     * Save the current state of the canvas to the stack (transforms and opacity)
     */ save() {
            this.__ctx.save();
            this._state.save();
        }
        /**
     * Restore the state of the canvas from the stack
     */ restore() {
            this.__ctx.restore();
            this._state.restore();
        }
        /**
     * Translate the origin of the context by an x and y
     * @param x
     * @param y
     */ translate(x, y) {
            this.__ctx.translate(this.snapToPixel ? ~~(x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : x, this.snapToPixel ? ~~(y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : y);
        }
        /**
     * Rotate the context about the current origin
     */ rotate(angle) {
            this.__ctx.rotate(angle);
        }
        /**
     * Scale the context by an x and y factor
     * @param x
     * @param y
     */ scale(x, y) {
            this.__ctx.scale(x, y);
        }
        getTransform() {
            throw new Error("Not implemented");
        }
        multiply(_m) {
            this.__ctx.setTransform(this.__ctx.getTransform().multiply(_m.toDOMMatrix()));
        }
        addPostProcessor(_postprocessor) {
        // pass
        }
        removePostProcessor(_postprocessor) {
        // pass
        }
        clearPostProcessors() {
        // pass
        }
        updatePostProcessors(delta) {
        // pass
        }
        beginDrawLifecycle() {
        // pass
        }
        endDrawLifecycle() {
        // pass
        }
        set material(material) {
            this._state.current.material = material;
        }
        get material() {
            return this._state.current.material;
        }
        createMaterial(options) {
            // pass
            return null;
        }
        clear() {
            // Clear frame
            this.__ctx.clearRect(0, 0, this.width, this.height);
            this.__ctx.fillStyle = this.backgroundColor.toString();
            this.__ctx.fillRect(0, 0, this.width, this.height);
            GraphicsDiagnostics.clear();
        }
        /**
     * Flushes the batched draw calls to the screen
     */ flush() {
        // pass
        }
        dispose() {
            this.__ctx = null;
        }
    }
    /**
 * Enum representing the different display modes available to Excalibur.
 */ var DisplayMode;
    (function(DisplayMode) {
        /**
     * Default, use a specified resolution for the game. Like 800x600 pixels for example.
     */ DisplayMode["Fixed"] = "Fixed";
        /**
     * Fit the aspect ratio given by the game resolution within the container at all times will fill any gaps with canvas.
     * The displayed area outside the aspect ratio is not guaranteed to be on the screen, only the [[Screen.contentArea]]
     * is guaranteed to be on screen.
     */ DisplayMode["FitContainerAndFill"] = "FitContainerAndFill";
        /**
     * Fit the aspect ratio given by the game resolution the screen at all times will fill the screen.
     * This displayed area outside the aspect ratio is not guaranteed to be on the screen, only the [[Screen.contentArea]]
     * is guaranteed to be on screen.
     */ DisplayMode["FitScreenAndFill"] = "FitScreenAndFill";
        /**
     * Fit the viewport to the parent element maintaining aspect ratio given by the game resolution, but zooms in to avoid the black bars
     * (letterbox) that would otherwise be present in [[FitContainer]].
     *
     * **warning** This will clip some drawable area from the user because of the zoom,
     * use [[Screen.contentArea]] to know the safe to draw area.
     */ DisplayMode["FitContainerAndZoom"] = "FitContainerAndZoom";
        /**
     * Fit the viewport to the device screen maintaining aspect ratio given by the game resolution, but zooms in to avoid the black bars
     * (letterbox) that would otherwise be present in [[FitScreen]].
     *
     * **warning** This will clip some drawable area from the user because of the zoom,
     * use [[Screen.contentArea]] to know the safe to draw area.
     */ DisplayMode["FitScreenAndZoom"] = "FitScreenAndZoom";
        /**
     * Fit to screen using as much space as possible while maintaining aspect ratio and resolution.
     * This is not the same as [[Screen.goFullScreen]] but behaves in a similar way maintaining aspect ratio.
     *
     * You may want to center your game here is an example
     * ```html
     * <!-- html -->
     * <body>
     * <main>
     *   <canvas id="game"></canvas>
     * </main>
     * </body>
     * ```
     *
     * ```css
     * // css
     * main {
     *   display: flex;
     *   align-items: center;
     *   justify-content: center;
     *   height: 100%;
     *   width: 100%;
     * }
     * ```
     */ DisplayMode["FitScreen"] = "FitScreen";
        /**
     * Fill the entire screen's css width/height for the game resolution dynamically. This means the resolution of the game will
     * change dynamically as the window is resized. This is not the same as [[Screen.goFullScreen]]
     */ DisplayMode["FillScreen"] = "FillScreen";
        /**
     * Fit to parent element width/height using as much space as possible while maintaining aspect ratio and resolution.
     */ DisplayMode["FitContainer"] = "FitContainer";
        /**
     * Use the parent DOM container's css width/height for the game resolution dynamically
     */ DisplayMode["FillContainer"] = "FillContainer";
    })(DisplayMode || (DisplayMode = {}));
    /**
 * Convenience class for quick resolutions
 * Mostly sourced from https://emulation.gametechwiki.com/index.php/Resolution
 */ class Resolution {
        /* istanbul ignore next */ static get SVGA() {
            return {
                width: 800,
                height: 600
            };
        }
        /* istanbul ignore next */ static get Standard() {
            return {
                width: 1920,
                height: 1080
            };
        }
        /* istanbul ignore next */ static get Atari2600() {
            return {
                width: 160,
                height: 192
            };
        }
        /* istanbul ignore next */ static get GameBoy() {
            return {
                width: 160,
                height: 144
            };
        }
        /* istanbul ignore next */ static get GameBoyAdvance() {
            return {
                width: 240,
                height: 160
            };
        }
        /* istanbul ignore next */ static get NintendoDS() {
            return {
                width: 256,
                height: 192
            };
        }
        /* istanbul ignore next */ static get NES() {
            return {
                width: 256,
                height: 224
            };
        }
        /* istanbul ignore next */ static get SNES() {
            return {
                width: 256,
                height: 244
            };
        }
    }
    const ScreenEvents = {
        ScreenResize: "resize",
        PixelRatioChange: "pixelratio",
        FullScreenChange: "fullscreen"
    };
    /**
 * The Screen handles all aspects of interacting with the screen for Excalibur.
 */ class Screen {
        constructor(options){
            var _a, _b, _c, _d;
            /**
         * Listen to screen events [[ScreenEvents]]
         */ this.events = new EventEmitter();
            this._antialiasing = true;
            this._canvasImageRendering = "auto";
            this._resolutionStack = [];
            this._viewportStack = [];
            this._pixelRatioOverride = null;
            this._isFullScreen = false;
            this._isDisposed = false;
            this._logger = Logger.getInstance();
            this._fullscreenChangeHandler = ()=>{
                if (this._isDisposed) return;
                this._isFullScreen = !this._isFullScreen;
                this._logger.debug("Fullscreen Change", this._isFullScreen);
                this.events.emit("fullscreen", {
                    fullscreen: this.isFullScreen
                });
            };
            this._pixelRatioChangeHandler = ()=>{
                if (this._isDisposed) return;
                this._logger.debug("Pixel Ratio Change", window.devicePixelRatio);
                this._listenForPixelRatio();
                this._devicePixelRatio = this._calculateDevicePixelRatio();
                this.applyResolutionAndViewport();
                this.events.emit("pixelratio", {
                    pixelRatio: this.pixelRatio
                });
            };
            this._resizeHandler = ()=>{
                if (this._isDisposed) return;
                const parent = this.parent;
                this._logger.debug("View port resized");
                this._setResolutionAndViewportByDisplayMode(parent);
                this.applyResolutionAndViewport();
                // Emit resize event
                this.events.emit("resize", {
                    resolution: this.resolution,
                    viewport: this.viewport
                });
            };
            // Asking the window.devicePixelRatio is expensive we do it once
            this._devicePixelRatio = this._calculateDevicePixelRatio();
            this._contentArea = new BoundingBox();
            this._unsafeArea = new BoundingBox();
            this.viewport = options.viewport;
            this.resolution = (_a = options.resolution) !== null && _a !== void 0 ? _a : {
                ...this.viewport
            };
            this._contentResolution = this.resolution;
            this._displayMode = (_b = options.displayMode) !== null && _b !== void 0 ? _b : DisplayMode.Fixed;
            this._canvas = options.canvas;
            this.graphicsContext = options.context;
            this._antialiasing = (_c = options.antialiasing) !== null && _c !== void 0 ? _c : this._antialiasing;
            this._canvasImageRendering = (_d = options.canvasImageRendering) !== null && _d !== void 0 ? _d : this._canvasImageRendering;
            this._browser = options.browser;
            this._pixelRatioOverride = options.pixelRatio;
            this._applyDisplayMode();
            this._listenForPixelRatio();
            this._canvas.addEventListener("fullscreenchange", this._fullscreenChangeHandler);
            this.applyResolutionAndViewport();
        }
        _listenForPixelRatio() {
            if (this._mediaQueryList && !this._mediaQueryList.addEventListener) // Safari <=13.1 workaround, remove any existing handlers
            this._mediaQueryList.removeListener(this._pixelRatioChangeHandler);
            this._mediaQueryList = this._browser.window.nativeComponent.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            // Safari <=13.1 workaround
            if (this._mediaQueryList.addEventListener) this._mediaQueryList.addEventListener("change", this._pixelRatioChangeHandler, {
                once: true
            });
            else this._mediaQueryList.addListener(this._pixelRatioChangeHandler);
        }
        dispose() {
            if (!this._isDisposed) {
                // Clean up handlers
                this._isDisposed = true;
                this.events.clear();
                this._browser.window.off("resize", this._resizeHandler);
                this._browser.window.clear();
                if (this._resizeObserver) this._resizeObserver.disconnect();
                this.parent.removeEventListener("resize", this._resizeHandler);
                // Safari <=13.1 workaround
                if (this._mediaQueryList.removeEventListener) this._mediaQueryList.removeEventListener("change", this._pixelRatioChangeHandler);
                else this._mediaQueryList.removeListener(this._pixelRatioChangeHandler);
                this._canvas.removeEventListener("fullscreenchange", this._fullscreenChangeHandler);
                this._canvas = null;
            }
        }
        _calculateDevicePixelRatio() {
            if (window.devicePixelRatio < 1) return 1;
            const devicePixelRatio = window.devicePixelRatio || 1;
            return devicePixelRatio;
        }
        /**
     * Returns the computed pixel ratio, first using any override, then the device pixel ratio
     */ get pixelRatio() {
            if (this._pixelRatioOverride) return this._pixelRatioOverride;
            return this._devicePixelRatio;
        }
        /**
     * Get or set the pixel ratio override
     *
     * You will need to call applyResolutionAndViewport() affect change on the screen
     */ get pixelRatioOverride() {
            return this._pixelRatioOverride;
        }
        set pixelRatioOverride(value) {
            this._pixelRatioOverride = value;
        }
        get isHiDpi() {
            return this.pixelRatio !== 1;
        }
        get displayMode() {
            return this._displayMode;
        }
        get canvas() {
            return this._canvas;
        }
        get parent() {
            switch(this.displayMode){
                case DisplayMode.FillContainer:
                case DisplayMode.FitContainer:
                case DisplayMode.FitContainerAndFill:
                case DisplayMode.FitContainerAndZoom:
                    return this.canvas.parentElement || document.body;
                default:
                    return window;
            }
        }
        get resolution() {
            return this._resolution;
        }
        set resolution(resolution) {
            this._resolution = resolution;
        }
        /**
     * Returns screen dimensions in pixels or percentage
     */ get viewport() {
            if (this._viewport) return this._viewport;
            return this._resolution;
        }
        set viewport(viewport) {
            this._viewport = viewport;
        }
        get aspectRatio() {
            return this._resolution.width / this._resolution.height;
        }
        get scaledWidth() {
            return this._resolution.width * this.pixelRatio;
        }
        get scaledHeight() {
            return this._resolution.height * this.pixelRatio;
        }
        setCurrentCamera(camera) {
            this._camera = camera;
        }
        pushResolutionAndViewport() {
            this._resolutionStack.push(this.resolution);
            this._viewportStack.push(this.viewport);
            this.resolution = {
                ...this.resolution
            };
            this.viewport = {
                ...this.viewport
            };
        }
        peekViewport() {
            return this._viewportStack[this._viewportStack.length - 1];
        }
        peekResolution() {
            return this._resolutionStack[this._resolutionStack.length - 1];
        }
        popResolutionAndViewport() {
            if (this._resolutionStack.length && this._viewportStack.length) {
                this.resolution = this._resolutionStack.pop();
                this.viewport = this._viewportStack.pop();
            }
        }
        applyResolutionAndViewport() {
            if (this.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                const scaledResolutionSupported = this.graphicsContext.checkIfResolutionSupported({
                    width: this.scaledWidth,
                    height: this.scaledHeight
                });
                if (!scaledResolutionSupported) {
                    this._logger.warnOnce(`The currently configured resolution (${this.resolution.width}x${this.resolution.height}) and pixel ratio (${this.pixelRatio})` + " are too large for the platform WebGL implementation, this may work but cause WebGL rendering to behave oddly." + " Try reducing the resolution or disabling Hi DPI scaling to avoid this" + " (read more here https://excaliburjs.com/docs/screens#understanding-viewport--resolution).");
                    // Attempt to recover if the user hasn't configured a specific ratio for up scaling
                    if (!this.pixelRatioOverride) {
                        let currentPixelRatio = Math.max(1, this.pixelRatio - .5);
                        let newResolutionSupported = false;
                        while(currentPixelRatio > 1 && !newResolutionSupported){
                            currentPixelRatio = Math.max(1, currentPixelRatio - .5);
                            const width = this._resolution.width * currentPixelRatio;
                            const height = this._resolution.height * currentPixelRatio;
                            newResolutionSupported = this.graphicsContext.checkIfResolutionSupported({
                                width: width,
                                height: height
                            });
                        }
                        this.pixelRatioOverride = currentPixelRatio;
                        this._logger.warnOnce("Scaled resolution too big attempted recovery!" + ` Pixel ratio was automatically reduced to (${this.pixelRatio}) to avoid 4k texture limit.` + " Setting `ex.Engine({pixelRatio: ...}) will override any automatic recalculation, do so at your own risk.` " + " (read more here https://excaliburjs.com/docs/screens#understanding-viewport--resolution).");
                    }
                }
            }
            this._canvas.width = this.scaledWidth;
            this._canvas.height = this.scaledHeight;
            if (this._canvasImageRendering === "auto") this._canvas.style.imageRendering = "auto";
            else {
                this._canvas.style.imageRendering = "pixelated";
                // Fall back to 'crisp-edges' if 'pixelated' is not supported
                // Currently for firefox https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering
                if (this._canvas.style.imageRendering === "") this._canvas.style.imageRendering = "crisp-edges";
            }
            const widthUnit = this.viewport.widthUnit === "percent" ? "%" : "px";
            const heightUnit = this.viewport.heightUnit === "percent" ? "%" : "px";
            this._canvas.style.width = this.viewport.width + widthUnit;
            this._canvas.style.height = this.viewport.height + heightUnit;
            // After messing with the canvas width/height the graphics context is invalidated and needs to have some properties reset
            this.graphicsContext.updateViewport(this.resolution);
            this.graphicsContext.resetTransform();
            this.graphicsContext.smoothing = this._antialiasing;
            if (this.graphicsContext instanceof ExcaliburGraphicsContext2DCanvas) this.graphicsContext.scale(this.pixelRatio, this.pixelRatio);
        }
        get antialiasing() {
            return this._antialiasing;
        }
        set antialiasing(isSmooth) {
            this._antialiasing = isSmooth;
            this.graphicsContext.smoothing = this._antialiasing;
        }
        /**
     * Returns true if excalibur is fullscreen using the browser fullscreen api
     */ get isFullScreen() {
            return this._isFullScreen;
        }
        /**
     * Requests to go fullscreen using the browser fullscreen api, requires user interaction to be successful.
     * For example, wire this to a user click handler.
     *
     * Optionally specify a target element id to go fullscreen, by default the game canvas is used
     * @param elementId
     */ goFullScreen(elementId) {
            if (elementId) {
                const maybeElement = document.getElementById(elementId);
                if (maybeElement) {
                    if (!maybeElement.getAttribute("ex-fullscreen-listener")) {
                        maybeElement.setAttribute("ex-fullscreen-listener", "true");
                        maybeElement.addEventListener("fullscreenchange", this._fullscreenChangeHandler);
                    }
                    const fullscreenPromise = maybeElement.requestFullscreen();
                    return fullscreenPromise;
                }
            }
            return this._canvas.requestFullscreen();
        }
        /**
     * Requests to exit fullscreen using the browser fullscreen api
     */ exitFullScreen() {
            return document.exitFullscreen();
        }
        _viewportToPixels(viewport) {
            return {
                width: viewport.widthUnit === "percent" ? this.canvas.offsetWidth : viewport.width,
                height: viewport.heightUnit === "percent" ? this.canvas.offsetHeight : viewport.height
            };
        }
        /**
     * Takes a coordinate in normal html page space, for example from a pointer move event, and translates it to
     * Excalibur screen space.
     *
     * Excalibur screen space starts at the top left (0, 0) corner of the viewport, and extends to the
     * bottom right corner (resolutionX, resolutionY). When using *AndFill suffixed display modes screen space
     * (0, 0) is the top left of the safe content area bounding box not the viewport.
     * @param point
     */ pageToScreenCoordinates(point) {
            let newX = point.x;
            let newY = point.y;
            if (!this._isFullScreen) {
                newX -= getPosition(this._canvas).x;
                newY -= getPosition(this._canvas).y;
            }
            const viewport = this._viewportToPixels(this.viewport);
            // if fullscreen api on it centers with black bars
            // we need to adjust the screen to world coordinates in this case
            if (this._isFullScreen) {
                if (window.innerWidth / this.aspectRatio < window.innerHeight) {
                    const screenHeight = window.innerWidth / this.aspectRatio;
                    const screenMarginY = (window.innerHeight - screenHeight) / 2;
                    newY = (newY - screenMarginY) / screenHeight * viewport.height;
                    newX = newX / window.innerWidth * viewport.width;
                } else {
                    const screenWidth = window.innerHeight * this.aspectRatio;
                    const screenMarginX = (window.innerWidth - screenWidth) / 2;
                    newX = (newX - screenMarginX) / screenWidth * viewport.width;
                    newY = newY / window.innerHeight * viewport.height;
                }
            }
            newX = newX / viewport.width * this.resolution.width;
            newY = newY / viewport.height * this.resolution.height;
            // offset by content area
            newX = newX - this.contentArea.left;
            newY = newY - this.contentArea.top;
            return new Vector(newX, newY);
        }
        /**
     * Takes a coordinate in Excalibur screen space, and translates it to normal html page space. For example,
     * this is where html elements might live if you want to position them relative to Excalibur.
     *
     * Excalibur screen space starts at the top left (0, 0) corner of the viewport, and extends to the
     * bottom right corner (resolutionX, resolutionY)
     * @param point
     */ screenToPageCoordinates(point) {
            let newX = point.x;
            let newY = point.y;
            // no need to offset by content area, drawing is already offset by this
            const viewport = this._viewportToPixels(this.viewport);
            newX = newX / this.resolution.width * viewport.width;
            newY = newY / this.resolution.height * viewport.height;
            if (this._isFullScreen) {
                if (window.innerWidth / this.aspectRatio < window.innerHeight) {
                    const screenHeight = window.innerWidth / this.aspectRatio;
                    const screenMarginY = (window.innerHeight - screenHeight) / 2;
                    newY = newY / viewport.height * screenHeight + screenMarginY;
                    newX = newX / viewport.width * window.innerWidth;
                } else {
                    const screenWidth = window.innerHeight * this.aspectRatio;
                    const screenMarginX = (window.innerWidth - screenWidth) / 2;
                    newX = newX / viewport.width * screenWidth + screenMarginX;
                    newY = newY / viewport.height * window.innerHeight;
                }
            }
            if (!this._isFullScreen) {
                newX += getPosition(this._canvas).x;
                newY += getPosition(this._canvas).y;
            }
            return new Vector(newX, newY);
        }
        /**
     * Takes a coordinate in Excalibur screen space, and translates it to Excalibur world space.
     *
     * World space is where [[Entity|entities]] in Excalibur live by default [[CoordPlane.World]]
     * and extends infinitely out relative from the [[Camera]].
     * @param point  Screen coordinate to convert
     */ screenToWorldCoordinates(point) {
            // offset by content area
            point = point.add(vec(this.contentArea.left, this.contentArea.top));
            // the only difference between screen & world is the camera transform
            if (this._camera) return this._camera.inverse.multiply(point);
            return point.sub(vec(this.resolution.width / 2, this.resolution.height / 2));
        }
        /**
     * Takes a coordinate in Excalibur world space, and translates it to Excalibur screen space.
     *
     * Screen space is where [[ScreenElement|screen elements]] and [[Entity|entities]] with [[CoordPlane.Screen]] live.
     * @param point  World coordinate to convert
     */ worldToScreenCoordinates(point) {
            if (this._camera) return this._camera.transform.multiply(point);
            return point.add(vec(this.resolution.width / 2, this.resolution.height / 2));
        }
        pageToWorldCoordinates(point) {
            const screen = this.pageToScreenCoordinates(point);
            return this.screenToWorldCoordinates(screen);
        }
        worldToPageCoordinates(point) {
            const screen = this.worldToScreenCoordinates(point);
            return this.screenToPageCoordinates(screen);
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen
     * and the bottom right corner of the screen.
     *
     * World bounds are in world coordinates, useful for culling objects offscreen that are in world space
     */ getWorldBounds() {
            const bounds = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Half).scale(vec(1 / this._camera.zoom, 1 / this._camera.zoom)).rotate(this._camera.rotation).translate(this._camera.drawPos);
            return bounds;
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen and the bottom right corner of the screen.
     *
     * Screen bounds are in screen coordinates, useful for culling objects offscreen that are in screen space
     */ getScreenBounds() {
            const bounds = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero, Vector.Zero);
            return bounds;
        }
        /**
     * The width of the game canvas in pixels (physical width component of the
     * resolution of the canvas element)
     */ get canvasWidth() {
            return this.canvas.width;
        }
        /**
     * Returns half width of the game canvas in pixels (half physical width component)
     */ get halfCanvasWidth() {
            return this.canvas.width / 2;
        }
        /**
     * The height of the game canvas in pixels, (physical height component of
     * the resolution of the canvas element)
     */ get canvasHeight() {
            return this.canvas.height;
        }
        /**
     * Returns half height of the game canvas in pixels (half physical height component)
     */ get halfCanvasHeight() {
            return this.canvas.height / 2;
        }
        /**
     * Returns the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawWidth() {
            if (this._camera) return this.resolution.width / this._camera.zoom;
            return this.resolution.width;
        }
        /**
     * Returns half the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawWidth() {
            return this.drawWidth / 2;
        }
        /**
     * Returns the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawHeight() {
            if (this._camera) return this.resolution.height / this._camera.zoom;
            return this.resolution.height;
        }
        /**
     * Returns half the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawHeight() {
            return this.drawHeight / 2;
        }
        /**
     * Returns screen center coordinates including zoom and device pixel ratio.
     */ get center() {
            return vec(this.halfDrawWidth, this.halfDrawHeight);
        }
        /**
     * Returns the content area in screen space where it is safe to place content
     */ get contentArea() {
            return this._contentArea;
        }
        /**
     * Returns the unsafe area in screen space, this is the full screen and some space may not be onscreen.
     */ get unsafeArea() {
            return this._unsafeArea;
        }
        _computeFit() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            if (window.innerWidth / aspect < window.innerHeight) {
                adjustedWidth = window.innerWidth;
                adjustedHeight = window.innerWidth / aspect;
            } else {
                adjustedWidth = window.innerHeight * aspect;
                adjustedHeight = window.innerHeight;
            }
            this.viewport = {
                width: adjustedWidth,
                height: adjustedHeight
            };
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this._unsafeArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitScreenAndFill() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            this._computeFitAndFill(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitContainerAndFill() {
            this.canvas.style.width = "100%";
            this.canvas.style.height = "100%";
            this._computeFitAndFill(this.canvas.offsetWidth, this.canvas.offsetHeight, {
                width: 100,
                widthUnit: "percent",
                height: 100,
                heightUnit: "percent"
            });
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitAndFill(vw, vh, viewport) {
            this.viewport = viewport !== null && viewport !== void 0 ? viewport : {
                width: vw,
                height: vh
            };
            // if the current screen aspectRatio is less than the original aspectRatio
            if (vw / vh <= this._contentResolution.width / this._contentResolution.height) {
                // compute new resolution to match the original aspect ratio
                this.resolution = {
                    width: vw * this._contentResolution.width / vw,
                    height: vw * this._contentResolution.width / vw * vh / vw
                };
                const clip = (this.resolution.height - this._contentResolution.height) / 2;
                this._contentArea = new BoundingBox({
                    top: clip,
                    left: 0,
                    right: this._contentResolution.width,
                    bottom: this.resolution.height - clip
                });
                this._unsafeArea = new BoundingBox({
                    top: -clip,
                    left: 0,
                    right: this._contentResolution.width,
                    bottom: this.resolution.height + clip
                });
            } else {
                this.resolution = {
                    width: vh * this._contentResolution.height / vh * vw / vh,
                    height: vh * this._contentResolution.height / vh
                };
                const clip = (this.resolution.width - this._contentResolution.width) / 2;
                this._contentArea = new BoundingBox({
                    top: 0,
                    left: clip,
                    right: this.resolution.width - clip,
                    bottom: this._contentResolution.height
                });
                this._unsafeArea = new BoundingBox({
                    top: 0,
                    left: -clip,
                    right: this.resolution.width + clip,
                    bottom: this._contentResolution.height
                });
            }
        }
        _computeFitScreenAndZoom() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            this.canvas.style.position = "absolute";
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            this._computeFitAndZoom(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitContainerAndZoom() {
            this.canvas.style.width = "100%";
            this.canvas.style.height = "100%";
            this.canvas.style.position = "relative";
            const parent = this.canvas.parentElement;
            parent.style.overflow = "hidden";
            const { offsetWidth: vw, offsetHeight: vh } = this.canvas;
            this._computeFitAndZoom(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitAndZoom(vw, vh) {
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            if (vw / aspect < vh) {
                adjustedWidth = vw;
                adjustedHeight = vw / aspect;
            } else {
                adjustedWidth = vh * aspect;
                adjustedHeight = vh;
            }
            const scaleX = vw / adjustedWidth;
            const scaleY = vh / adjustedHeight;
            const maxScaleFactor = Math.max(scaleX, scaleY);
            const zoomedWidth = adjustedWidth * maxScaleFactor;
            const zoomedHeight = adjustedHeight * maxScaleFactor;
            // Center zoomed dimension if bigger than the screen
            if (zoomedWidth > vw) this.canvas.style.left = -(zoomedWidth - vw) / 2 + "px";
            else this.canvas.style.left = "";
            if (zoomedHeight > vh) this.canvas.style.top = -(zoomedHeight - vh) / 2 + "px";
            else this.canvas.style.top = "";
            this.viewport = {
                width: zoomedWidth,
                height: zoomedHeight
            };
            const bounds = BoundingBox.fromDimension(this.viewport.width, this.viewport.height, Vector.Zero);
            // return safe area
            if (this.viewport.width > vw) {
                const clip = (this.viewport.width - vw) / this.viewport.width * this.resolution.width;
                bounds.top = 0;
                bounds.left = clip / 2;
                bounds.right = this.resolution.width - clip / 2;
                bounds.bottom = this.resolution.height;
            }
            if (this.viewport.height > vh) {
                const clip = (this.viewport.height - vh) / this.viewport.height * this.resolution.height;
                bounds.top = clip / 2;
                bounds.left = 0;
                bounds.bottom = this.resolution.height - clip / 2;
                bounds.right = this.resolution.width;
            }
            this._contentArea = bounds;
        }
        _computeFitContainer() {
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            let widthUnit = "pixel";
            let heightUnit = "pixel";
            const parent = this.canvas.parentElement;
            if (parent.clientWidth / aspect < parent.clientHeight) {
                this.canvas.style.width = "100%";
                adjustedWidth = 100;
                widthUnit = "percent";
                adjustedHeight = this.canvas.offsetWidth / aspect;
            } else {
                this.canvas.style.height = "100%";
                adjustedHeight = 100;
                heightUnit = "percent";
                adjustedWidth = this.canvas.offsetHeight * aspect;
            }
            this.viewport = {
                width: adjustedWidth,
                widthUnit: widthUnit,
                height: adjustedHeight,
                heightUnit: heightUnit
            };
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _applyDisplayMode() {
            this._setResolutionAndViewportByDisplayMode(this.parent);
            // watch resizing
            if (this.parent instanceof Window) this._browser.window.on("resize", this._resizeHandler);
            else {
                this._resizeObserver = new ResizeObserver(()=>{
                    this._resizeHandler();
                });
                this._resizeObserver.observe(this.parent);
            }
            this.parent.addEventListener("resize", this._resizeHandler);
        }
        /**
     * Sets the resolution and viewport based on the selected display mode.
     */ _setResolutionAndViewportByDisplayMode(parent) {
            if (this.displayMode === DisplayMode.FillContainer) {
                this.canvas.style.width = "100%";
                this.canvas.style.height = "100%";
                this.viewport = {
                    width: 100,
                    widthUnit: "percent",
                    height: 100,
                    heightUnit: "percent"
                };
                this.resolution = {
                    width: this.canvas.offsetWidth,
                    height: this.canvas.offsetHeight
                };
            }
            if (this.displayMode === DisplayMode.FillScreen) {
                document.body.style.margin = "0px";
                document.body.style.overflow = "hidden";
                this.resolution = {
                    width: parent.innerWidth,
                    height: parent.innerHeight
                };
                this.viewport = this.resolution;
            }
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            if (this.displayMode === DisplayMode.FitScreen) this._computeFit();
            if (this.displayMode === DisplayMode.FitContainer) this._computeFitContainer();
            if (this.displayMode === DisplayMode.FitScreenAndFill) this._computeFitScreenAndFill();
            if (this.displayMode === DisplayMode.FitContainerAndFill) this._computeFitContainerAndFill();
            if (this.displayMode === DisplayMode.FitScreenAndZoom) this._computeFitScreenAndZoom();
            if (this.displayMode === DisplayMode.FitContainerAndZoom) this._computeFitContainerAndZoom();
        }
    }
    /**
 * Internal class used to build instances of AudioContext
 */ /* istanbul ignore next */ class AudioContextFactory {
        static create() {
            if (!this._INSTANCE) {
                if (window.AudioContext || window.webkitAudioContext) this._INSTANCE = new AudioContext();
            }
            return this._INSTANCE;
        }
    }
    AudioContextFactory._INSTANCE = null;
    /**
 * Patch for detecting legacy web audio in browsers
 * @internal
 * @param source
 */ function isLegacyWebAudioSource(source) {
        return !!source.playbackState;
    }
    class WebAudio {
        /**
     * Play an empty sound to unlock Safari WebAudio context. Call this function
     * right after a user interaction event.
     * @source https://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     */ static unlock() {
            const promise = new Promise((resolve, reject)=>{
                if (WebAudio._UNLOCKED || !AudioContextFactory.create()) return resolve(true);
                const unlockTimeoutTimer = setTimeout(()=>{
                    Logger.getInstance().warn("Excalibur was unable to unlock the audio context, audio probably will not play in this browser.");
                    resolve(false);
                }, 200);
                const audioContext = AudioContextFactory.create();
                audioContext.resume().then(()=>{
                    // create empty buffer and play it
                    const buffer = audioContext.createBuffer(1, 1, 22050);
                    const source = audioContext.createBufferSource();
                    let ended = false;
                    source.buffer = buffer;
                    source.connect(audioContext.destination);
                    source.onended = ()=>ended = true;
                    source.start(0);
                    // by checking the play state after some time, we know if we're really unlocked
                    setTimeout(()=>{
                        if (isLegacyWebAudioSource(source)) {
                            if (source.playbackState === source.PLAYING_STATE || source.playbackState === source.FINISHED_STATE) WebAudio._UNLOCKED = true;
                        } else if (audioContext.currentTime > 0 || ended) WebAudio._UNLOCKED = true;
                    }, 0);
                    clearTimeout(unlockTimeoutTimer);
                    resolve(true);
                }, ()=>{
                    reject();
                });
            });
            return promise;
        }
        static isUnlocked() {
            return this._UNLOCKED;
        }
    }
    WebAudio._UNLOCKED = false;
    /**
 * A Raster is a Graphic that needs to be first painted to a HTMLCanvasElement before it can be drawn to the
 * [[ExcaliburGraphicsContext]]. This is useful for generating custom images using the 2D canvas api.
 *
 * Implementors must implement the [[Raster.execute]] method to rasterize their drawing.
 */ class Raster extends Graphic {
        constructor(options){
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            super(omit(options, [
                "width",
                "height"
            ])); // rasters do some special sauce with width/height
            this.filtering = null;
            this.lineCap = "butt";
            this.quality = 1;
            this._dirty = true;
            this._smoothing = false;
            this._color = watch(Color.Black, ()=>this.flagDirty());
            this._lineWidth = 1;
            this._lineDash = [];
            this._padding = 0;
            if (options) {
                this.quality = (_a = options.quality) !== null && _a !== void 0 ? _a : this.quality;
                this.color = (_b = options.color) !== null && _b !== void 0 ? _b : Color.Black;
                this.strokeColor = options === null || options === void 0 ? void 0 : options.strokeColor;
                this.smoothing = (_c = options.smoothing) !== null && _c !== void 0 ? _c : this.smoothing;
                this.lineWidth = (_d = options.lineWidth) !== null && _d !== void 0 ? _d : this.lineWidth;
                this.lineDash = (_e = options.lineDash) !== null && _e !== void 0 ? _e : this.lineDash;
                this.lineCap = (_f = options.lineCap) !== null && _f !== void 0 ? _f : this.lineCap;
                this.padding = (_g = options.padding) !== null && _g !== void 0 ? _g : this.padding;
                this.filtering = (_h = options.filtering) !== null && _h !== void 0 ? _h : this.filtering;
            }
            this._bitmap = document.createElement("canvas");
            // get the default canvas width/height as a fallback
            const bitmapWidth = (_j = options === null || options === void 0 ? void 0 : options.width) !== null && _j !== void 0 ? _j : this._bitmap.width;
            const bitmapHeight = (_k = options === null || options === void 0 ? void 0 : options.height) !== null && _k !== void 0 ? _k : this._bitmap.height;
            this.width = bitmapWidth;
            this.height = bitmapHeight;
            const maybeCtx = this._bitmap.getContext("2d");
            if (!maybeCtx) /* istanbul ignore next */ throw new Error("Browser does not support 2d canvas drawing, cannot create Raster graphic");
            else this._ctx = maybeCtx;
        }
        cloneRasterOptions() {
            return {
                color: this.color ? this.color.clone() : null,
                strokeColor: this.strokeColor ? this.strokeColor.clone() : null,
                smoothing: this.smoothing,
                lineWidth: this.lineWidth,
                lineDash: this.lineDash,
                lineCap: this.lineCap,
                quality: this.quality,
                padding: this.padding
            };
        }
        /**
     * Gets whether the graphic is dirty, this means there are changes that haven't been re-rasterized
     */ get dirty() {
            return this._dirty;
        }
        /**
     * Flags the graphic as dirty, meaning it must be re-rasterized before draw.
     * This should be called any time the graphics state changes such that it affects the outputted drawing
     */ flagDirty() {
            this._dirty = true;
        }
        /**
     * Gets or sets the current width of the Raster graphic. Setting the width will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     *
     * Any `padding`s or `quality` set will be factored into the width
     */ get width() {
            return Math.abs(this._getTotalWidth() * this.scale.x);
        }
        set width(value) {
            value /= Math.abs(this.scale.x);
            this._bitmap.width = value;
            this._originalWidth = value;
            this.flagDirty();
        }
        /**
     * Gets or sets the current height of the Raster graphic. Setting the height will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     *
     * Any `padding` or `quality` set will be factored into the height
     */ get height() {
            return Math.abs(this._getTotalHeight() * this.scale.y);
        }
        set height(value) {
            value /= Math.abs(this.scale.y);
            this._bitmap.height = value;
            this._originalHeight = value;
            this.flagDirty();
        }
        _getTotalWidth() {
            var _a;
            return (((_a = this._originalWidth) !== null && _a !== void 0 ? _a : this._bitmap.width) + this.padding * 2) * 1;
        }
        _getTotalHeight() {
            var _a;
            return (((_a = this._originalHeight) !== null && _a !== void 0 ? _a : this._bitmap.height) + this.padding * 2) * 1;
        }
        /**
     * Returns the local bounds of the Raster including the padding
     */ get localBounds() {
            return BoundingBox.fromDimension(this._getTotalWidth() * this.scale.x, this._getTotalHeight() * this.scale.y, Vector.Zero);
        }
        /**
     * Gets or sets the smoothing (anti-aliasing of the graphic). Setting the height will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     */ get smoothing() {
            return this._smoothing;
        }
        set smoothing(value) {
            this._smoothing = value;
            this.flagDirty();
        }
        /**
     * Gets or sets the fillStyle of the Raster graphic. Setting the fillStyle will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get color() {
            return this._color;
        }
        set color(value) {
            this.flagDirty();
            this._color = watch(value, ()=>this.flagDirty());
        }
        /**
     * Gets or sets the strokeStyle of the Raster graphic. Setting the strokeStyle will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get strokeColor() {
            return this._strokeColor;
        }
        set strokeColor(value) {
            this.flagDirty();
            this._strokeColor = watch(value, ()=>this.flagDirty());
        }
        /**
     * Gets or sets the line width of the Raster graphic. Setting the lineWidth will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get lineWidth() {
            return this._lineWidth;
        }
        set lineWidth(value) {
            this._lineWidth = value;
            this.flagDirty();
        }
        get lineDash() {
            return this._lineDash;
        }
        set lineDash(value) {
            this._lineDash = value;
            this.flagDirty();
        }
        get padding() {
            return this._padding;
        }
        set padding(value) {
            this._padding = value;
            this.flagDirty();
        }
        /**
     * Rasterize the graphic to a bitmap making it usable as in excalibur. Rasterize is called automatically if
     * the graphic is [[Raster.dirty]] on the next [[Graphic.draw]] call
     */ rasterize() {
            this._dirty = false;
            this._ctx.clearRect(0, 0, this._getTotalWidth(), this._getTotalHeight());
            this._ctx.save();
            this._applyRasterProperties(this._ctx);
            this.execute(this._ctx);
            this._ctx.restore();
        }
        _applyRasterProperties(ctx) {
            var _a, _b, _c;
            this._bitmap.width = this._getTotalWidth() * this.quality;
            this._bitmap.height = this._getTotalHeight() * this.quality;
            // Do a bad thing to pass the filtering as an attribute
            this._bitmap.setAttribute("filtering", this.filtering);
            this._bitmap.setAttribute("forceUpload", "true");
            ctx.scale(this.quality, this.quality);
            ctx.translate(this.padding, this.padding);
            ctx.imageSmoothingEnabled = this.smoothing;
            ctx.lineWidth = this.lineWidth;
            ctx.setLineDash((_a = this.lineDash) !== null && _a !== void 0 ? _a : ctx.getLineDash());
            ctx.lineCap = this.lineCap;
            ctx.strokeStyle = (_b = this.strokeColor) === null || _b === void 0 ? void 0 : _b.toString();
            ctx.fillStyle = (_c = this.color) === null || _c === void 0 ? void 0 : _c.toString();
        }
        _drawImage(ex, x, y) {
            if (this._dirty) this.rasterize();
            ex.scale(1 / this.quality, 1 / this.quality);
            ex.drawImage(this._bitmap, x, y);
        }
    }
    /**
 * A canvas [[Graphic]] to provide an adapter between the 2D Canvas API and the [[ExcaliburGraphicsContext]].
 *
 * The [[Canvas]] works by re-rastering a draw handler to a HTMLCanvasElement for every draw which is then passed
 * to the [[ExcaliburGraphicsContext]] implementation as a rendered image.
 *
 * **Low performance API**
 */ class Canvas extends Raster {
        /**
     * Return the 2D graphics context of this canvas
     */ get ctx() {
            return this._ctx;
        }
        constructor(_options){
            super(_options);
            this._options = _options;
        }
        clone() {
            return new Canvas({
                ...this._options,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            var _a, _b;
            if ((_a = this._options) === null || _a === void 0 ? void 0 : _a.draw) (_b = this._options) === null || _b === void 0 || _b.draw(ctx);
            if (!this._options.cache) this.flagDirty();
        }
    }
    class ExResponse {
    }
    ExResponse.type = {
        any: "",
        blob: "blob",
        json: "json",
        text: "text",
        document: "document",
        arraybuffer: "arraybuffer"
    };
    class StateMachine {
        constructor(){
            this.states = new Map();
        }
        get currentState() {
            return this._currentState;
        }
        set currentState(state) {
            this._currentState = state;
        }
        static create(machineDescription, data) {
            const machine = new StateMachine();
            machine.data = data;
            for(const stateName in machineDescription.states)machine.states.set(stateName, {
                name: stateName,
                ...machineDescription.states[stateName]
            });
            // validate transitions are states
            for (const state of machine.states.values())for (const transitionState of state.transitions){
                if (transitionState === "*") continue;
                if (!machine.states.has(transitionState)) throw Error(`Invalid state machine, state [${state.name}] has a transition to another state that doesn't exist [${transitionState}]`);
            }
            machine.currentState = machine.startState = machine.states.get(machineDescription.start);
            return machine;
        }
        in(state) {
            return this.currentState.name === state;
        }
        go(stateName, eventData) {
            var _a, _b;
            if (this.currentState.transitions.includes(stateName) || this.currentState.transitions.includes("*")) {
                const potentialNewState = this.states.get(stateName);
                if (this.currentState.onExit) {
                    const canExit = (_a = this.currentState) === null || _a === void 0 ? void 0 : _a.onExit({
                        to: potentialNewState.name,
                        data: this.data
                    });
                    if (canExit === false) return false;
                }
                if (potentialNewState === null || potentialNewState === void 0 ? void 0 : potentialNewState.onEnter) {
                    const canEnter = potentialNewState === null || potentialNewState === void 0 ? void 0 : potentialNewState.onEnter({
                        from: this.currentState.name,
                        eventData: eventData,
                        data: this.data
                    });
                    if (canEnter === false) return false;
                }
                // console.log(`${this.currentState.name} => ${potentialNewState.name} (${eventData})`);
                this.currentState = potentialNewState;
                if ((_b = this.currentState) === null || _b === void 0 ? void 0 : _b.onState) this.currentState.onState();
                return true;
            }
            return false;
        }
        update(elapsedMs) {
            if (this.currentState.onUpdate) this.currentState.onUpdate(this.data, elapsedMs);
        }
        save(saveKey) {
            localStorage.setItem(saveKey, JSON.stringify({
                currentState: this.currentState.name,
                data: this.data
            }));
        }
        restore(saveKey) {
            const state = JSON.parse(localStorage.getItem(saveKey));
            this.currentState = this.states.get(state.currentState);
            this.data = state.data;
        }
    }
    /**
 * Internal class representing a Web Audio AudioBufferSourceNode instance
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API
 */ class WebAudioInstance {
        _createNewBufferSource() {
            this._instance = this._audioContext.createBufferSource();
            this._instance.buffer = this._src;
            this._instance.loop = this.loop;
            this._instance.playbackRate.value = this._playbackRate;
            this._instance.connect(this._volumeNode);
            this._volumeNode.connect(this._audioContext.destination);
        }
        _handleEnd() {
            if (!this.loop) this._instance.onended = ()=>{
                this._playingFuture.resolve(true);
            };
        }
        set loop(value) {
            this._loop = value;
            if (this._instance) {
                this._instance.loop = value;
                if (!this.loop) this._instance.onended = ()=>{
                    this._playingFuture.resolve(true);
                };
            }
        }
        get loop() {
            return this._loop;
        }
        set volume(value) {
            value = clamp(value, 0, 1.0);
            this._volume = value;
            if (this._stateMachine.in("PLAYING") && this._volumeNode.gain.setTargetAtTime) // https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/setTargetAtTime
            // After each .1 seconds timestep, the target value will ~63.2% closer to the target value.
            // This exponential ramp provides a more pleasant transition in gain
            this._volumeNode.gain.setTargetAtTime(value, this._audioContext.currentTime, 0.1);
            else this._volumeNode.gain.value = value;
        }
        get volume() {
            return this._volume;
        }
        /**
     * Returns the set duration to play, otherwise returns the total duration if unset
     */ get duration() {
            var _a;
            return (_a = this._duration) !== null && _a !== void 0 ? _a : this.getTotalPlaybackDuration();
        }
        /**
     * Set the duration that this audio should play.
     *
     * Note: if you seek to a specific point the duration will start from that point, for example
     *
     * If you have a 10 second clip, seek to 5 seconds, then set the duration to 2, it will play the clip from 5-7 seconds.
     */ set duration(duration) {
            this._duration = duration;
        }
        constructor(_src){
            this._src = _src;
            this._audioContext = AudioContextFactory.create();
            this._volumeNode = this._audioContext.createGain();
            this._playingFuture = new Future();
            this._stateMachine = StateMachine.create({
                start: "STOPPED",
                states: {
                    PLAYING: {
                        onEnter: ({ data: data })=>{
                            // Buffer nodes are single use
                            this._createNewBufferSource();
                            this._handleEnd();
                            if (this.loop) // when looping don't set a duration
                            this._instance.start(0, data.pausedAt * this._playbackRate);
                            else this._instance.start(0, data.pausedAt * this._playbackRate, this.duration);
                            data.startedAt = this._audioContext.currentTime - data.pausedAt;
                            data.pausedAt = 0;
                        },
                        onState: ()=>this._playStarted(),
                        onExit: ({ to: to })=>{
                            // If you've exited early only resolve if explicitly STOPPED
                            if (to === "STOPPED") this._playingFuture.resolve(true);
                            // Whenever you're not playing... you stop!
                            this._instance.onended = null; // disconnect the wired on-end handler
                            this._instance.disconnect();
                            this._instance.stop(0);
                            this._instance = null;
                        },
                        transitions: [
                            "STOPPED",
                            "PAUSED",
                            "SEEK"
                        ]
                    },
                    SEEK: {
                        onEnter: ({ eventData: position, data: data })=>{
                            data.pausedAt = (position !== null && position !== void 0 ? position : 0) / this._playbackRate;
                            data.startedAt = 0;
                        },
                        transitions: [
                            "*"
                        ]
                    },
                    STOPPED: {
                        onEnter: ({ data: data })=>{
                            data.pausedAt = 0;
                            data.startedAt = 0;
                            this._playingFuture.resolve(true);
                        },
                        transitions: [
                            "PLAYING",
                            "PAUSED",
                            "SEEK"
                        ]
                    },
                    PAUSED: {
                        onEnter: ({ data: data })=>{
                            // Playback rate will be a scale factor of how fast/slow the audio is being played
                            // default is 1.0
                            // we need to invert it to get the time scale
                            data.pausedAt = this._audioContext.currentTime - data.startedAt;
                        },
                        transitions: [
                            "PLAYING",
                            "STOPPED",
                            "SEEK"
                        ]
                    }
                }
            }, {
                startedAt: 0,
                pausedAt: 0
            });
            this._volume = 1;
            this._loop = false;
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this._playStarted = ()=>{};
            this._playbackRate = 1.0;
            this._createNewBufferSource();
        }
        isPlaying() {
            return this._stateMachine.in("PLAYING");
        }
        isPaused() {
            return this._stateMachine.in("PAUSED") || this._stateMachine.in("SEEK");
        }
        isStopped() {
            return this._stateMachine.in("STOPPED");
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        play(playStarted = ()=>{}) {
            this._playStarted = playStarted;
            this._stateMachine.go("PLAYING");
            return this._playingFuture.promise;
        }
        pause() {
            this._stateMachine.go("PAUSED");
        }
        stop() {
            this._stateMachine.go("STOPPED");
        }
        seek(position) {
            this._stateMachine.go("PAUSED");
            this._stateMachine.go("SEEK", position);
        }
        getTotalPlaybackDuration() {
            return this._src.duration;
        }
        getPlaybackPosition() {
            const { pausedAt: pausedAt, startedAt: startedAt } = this._stateMachine.data;
            if (pausedAt) return pausedAt * this._playbackRate;
            if (startedAt) return (this._audioContext.currentTime - startedAt) * this._playbackRate;
            return 0;
        }
        set playbackRate(playbackRate) {
            this._instance.playbackRate.value = this._playbackRate = playbackRate;
        }
        get playbackRate() {
            return this._instance.playbackRate.value;
        }
    }
    var EventTypes;
    (function(EventTypes) {
        EventTypes["Kill"] = "kill";
        EventTypes["PreKill"] = "prekill";
        EventTypes["PostKill"] = "postkill";
        EventTypes["PreDraw"] = "predraw";
        EventTypes["PostDraw"] = "postdraw";
        EventTypes["PreDebugDraw"] = "predebugdraw";
        EventTypes["PostDebugDraw"] = "postdebugdraw";
        EventTypes["PreUpdate"] = "preupdate";
        EventTypes["PostUpdate"] = "postupdate";
        EventTypes["PreFrame"] = "preframe";
        EventTypes["PostFrame"] = "postframe";
        EventTypes["PreCollision"] = "precollision";
        EventTypes["CollisionStart"] = "collisionstart";
        EventTypes["CollisionEnd"] = "collisionend";
        EventTypes["PostCollision"] = "postcollision";
        EventTypes["Initialize"] = "initialize";
        EventTypes["Activate"] = "activate";
        EventTypes["Deactivate"] = "deactivate";
        EventTypes["ExitViewport"] = "exitviewport";
        EventTypes["EnterViewport"] = "enterviewport";
        EventTypes["ExitTrigger"] = "exit";
        EventTypes["EnterTrigger"] = "enter";
        EventTypes["Connect"] = "connect";
        EventTypes["Disconnect"] = "disconnect";
        EventTypes["Button"] = "button";
        EventTypes["Axis"] = "axis";
        EventTypes["Visible"] = "visible";
        EventTypes["Hidden"] = "hidden";
        EventTypes["Start"] = "start";
        EventTypes["Stop"] = "stop";
        EventTypes["PointerUp"] = "pointerup";
        EventTypes["PointerDown"] = "pointerdown";
        EventTypes["PointerMove"] = "pointermove";
        EventTypes["PointerEnter"] = "pointerenter";
        EventTypes["PointerLeave"] = "pointerleave";
        EventTypes["PointerCancel"] = "pointercancel";
        EventTypes["PointerWheel"] = "pointerwheel";
        EventTypes["Up"] = "up";
        EventTypes["Down"] = "down";
        EventTypes["Move"] = "move";
        EventTypes["Enter"] = "enter";
        EventTypes["Leave"] = "leave";
        EventTypes["Cancel"] = "cancel";
        EventTypes["Wheel"] = "wheel";
        EventTypes["Press"] = "press";
        EventTypes["Release"] = "release";
        EventTypes["Hold"] = "hold";
        EventTypes["PointerDragStart"] = "pointerdragstart";
        EventTypes["PointerDragEnd"] = "pointerdragend";
        EventTypes["PointerDragEnter"] = "pointerdragenter";
        EventTypes["PointerDragLeave"] = "pointerdragleave";
        EventTypes["PointerDragMove"] = "pointerdragmove";
        EventTypes["ActionStart"] = "actionstart";
        EventTypes["ActionComplete"] = "actioncomplete";
    })(EventTypes || (EventTypes = {}));
    /**
 * Base event type in Excalibur that all other event types derive from. Not all event types are thrown on all Excalibur game objects,
 * some events are unique to a type, others are not.
 *
 */ class GameEvent {
        constructor(){
            this._bubbles = true;
        }
        /**
     * If set to false, prevents event from propagating to other actors. If true it will be propagated
     * to all actors that apply.
     */ get bubbles() {
            return this._bubbles;
        }
        set bubbles(value) {
            this._bubbles = value;
        }
        /**
     * Prevents event from bubbling
     */ stopPropagation() {
            this.bubbles = false;
        }
    }
    /**
 * The 'kill' event is emitted on actors when it is killed. The target is the actor that was killed.
 */ class KillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'prekill' event is emitted directly before an actor is killed.
 */ class PreKillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'postkill' event is emitted directly after the actor is killed.
 */ class PostKillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'start' event is emitted on engine when has started and is ready for interaction.
 */ class GameStartEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'stop' event is emitted on engine when has been stopped and will no longer take input, update or draw.
 */ class GameStopEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'predraw' event is emitted on actors, scenes, and engine before drawing starts. Actors' predraw happens inside their graphics
 * transform so that all drawing takes place with the actor as the origin.
 *
 */ class PreDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'postdraw' event is emitted on actors, scenes, and engine after drawing finishes. Actors' postdraw happens inside their graphics
 * transform so that all drawing takes place with the actor as the origin.
 *
 */ class PostDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'pretransformdraw' event is emitted on actors/entities before any graphics transforms have taken place.
 * Useful if you need to completely customize the draw or modify the transform before drawing in the draw step (for example needing
 * latest camera positions)
 *
 */ class PreTransformDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'posttransformdraw' event is emitted on actors/entities after all graphics have been draw and transforms reset.
 * Useful if you need to completely custom the draw after everything is done.
 *
 */ class PostTransformDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'predebugdraw' event is emitted on actors, scenes, and engine before debug drawing starts.
 */ class PreDebugDrawEvent extends GameEvent {
        constructor(ctx, target){
            super();
            this.ctx = ctx;
            this.target = target;
        }
    }
    /**
 * The 'postdebugdraw' event is emitted on actors, scenes, and engine after debug drawing starts.
 */ class PostDebugDrawEvent extends GameEvent {
        constructor(ctx, target){
            super();
            this.ctx = ctx;
            this.target = target;
        }
    }
    /**
 * The 'preupdate' event is emitted on actors, scenes, camera, and engine before the update starts.
 */ class PreUpdateEvent extends GameEvent {
        constructor(engine, delta, target){
            super();
            this.engine = engine;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'postupdate' event is emitted on actors, scenes, camera, and engine after the update ends.
 */ class PostUpdateEvent extends GameEvent {
        constructor(engine, delta, target){
            super();
            this.engine = engine;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'preframe' event is emitted on the engine, before the frame begins.
 */ class PreFrameEvent extends GameEvent {
        constructor(engine, prevStats){
            super();
            this.engine = engine;
            this.prevStats = prevStats;
            this.target = engine;
        }
    }
    /**
 * The 'postframe' event is emitted on the engine, after a frame ends.
 */ class PostFrameEvent extends GameEvent {
        constructor(engine, stats){
            super();
            this.engine = engine;
            this.stats = stats;
            this.target = engine;
        }
    }
    /**
 * Event received when a gamepad is connected to Excalibur. [[Gamepads]] receives this event.
 */ class GamepadConnectEvent extends GameEvent {
        constructor(index, gamepad){
            super();
            this.index = index;
            this.gamepad = gamepad;
            this.target = gamepad;
        }
    }
    /**
 * Event received when a gamepad is disconnected from Excalibur. [[Gamepads]] receives this event.
 */ class GamepadDisconnectEvent extends GameEvent {
        constructor(index, gamepad){
            super();
            this.index = index;
            this.gamepad = gamepad;
            this.target = gamepad;
        }
    }
    /**
 * Gamepad button event. See [[Gamepads]] for information on responding to controller input. [[Gamepad]] instances receive this event;
 */ class GamepadButtonEvent extends GameEvent {
        /**
     * @param button  The Gamepad button
     * @param value   A numeric value between 0 and 1
     */ constructor(button, value, target){
            super();
            this.button = button;
            this.value = value;
            this.target = target;
        }
    }
    /**
 * Gamepad axis event. See [[Gamepads]] for information on responding to controller input. [[Gamepad]] instances receive this event;
 */ class GamepadAxisEvent extends GameEvent {
        /**
     * @param axis  The Gamepad axis
     * @param value A numeric value between -1 and 1
     */ constructor(axis, value, target){
            super();
            this.axis = axis;
            this.value = value;
            this.target = target;
        }
    }
    /**
 * Event received by the [[Engine]] when the browser window is visible on a screen.
 */ class VisibleEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event received by the [[Engine]] when the browser window is hidden from all screens.
 */ class HiddenEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor|actor]] when a collision will occur this frame if it resolves
 */ class PreCollisionEvent extends GameEvent {
        /**
     * @param actor         The actor the event was thrown on
     * @param other         The actor that will collided with the current actor
     * @param side          The side that will be collided with the current actor
     * @param intersection  Intersection vector
     */ constructor(actor, other, side, intersection, contact){
            super();
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
            this.target = actor;
        }
    }
    /**
 * Event thrown on an [[Actor|actor]] when a collision has been resolved (body reacted) this frame
 */ class PostCollisionEvent extends GameEvent {
        /**
     * @param actor         The actor the event was thrown on
     * @param other         The actor that did collide with the current actor
     * @param side          The side that did collide with the current actor
     * @param intersection  Intersection vector
     */ constructor(actor, other, side, intersection, contact){
            super();
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    class ContactStartEvent {
        constructor(target, other, side, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.contact = contact;
        }
    }
    class ContactEndEvent {
        constructor(target, other, side, lastContact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.lastContact = lastContact;
        }
    }
    class CollisionPreSolveEvent {
        constructor(target, other, side, intersection, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
        }
    }
    class CollisionPostSolveEvent {
        constructor(target, other, side, intersection, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
        }
    }
    /**
 * Event thrown the first time an [[Actor|actor]] collides with another, after an actor is in contact normal collision events are fired.
 */ class CollisionStartEvent extends GameEvent {
        /**
     *
     * @param actor
     * @param other
     * @param side
     * @param contact
     */ constructor(actor, other, side, contact){
            super();
            this.other = other;
            this.side = side;
            this.contact = contact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    /**
 * Event thrown when the [[Actor|actor]] is no longer colliding with another
 */ class CollisionEndEvent extends GameEvent {
        /**
     *
     */ constructor(actor, other, side, lastContact){
            super();
            this.other = other;
            this.side = side;
            this.lastContact = lastContact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    /**
 * Event thrown on an [[Actor]], [[Scene]], and [[Engine]] only once before the first update call
 */ class InitializeEvent extends GameEvent {
        /**
     * @param engine  The reference to the current engine
     */ constructor(engine, target){
            super();
            this.engine = engine;
            this.target = target;
        }
    }
    /**
 * Event thrown on a [[Scene]] on activation
 */ class ActivateEvent extends GameEvent {
        /**
     * @param context  The context for the scene activation
     */ constructor(context, target){
            super();
            this.context = context;
            this.target = target;
        }
    }
    /**
 * Event thrown on a [[Scene]] on deactivation
 */ class DeactivateEvent extends GameEvent {
        /**
     * @param context  The context for the scene deactivation
     */ constructor(context, target){
            super();
            this.context = context;
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when the graphics bounds completely leaves the screen.
 */ class ExitViewPortEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when any part of the graphics bounds are on screen.
 */ class EnterViewPortEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    class EnterTriggerEvent extends GameEvent {
        constructor(target, actor){
            super();
            this.target = target;
            this.actor = actor;
        }
    }
    class ExitTriggerEvent extends GameEvent {
        constructor(target, actor){
            super();
            this.target = target;
            this.actor = actor;
        }
    }
    /**
 * Event thrown on an [[Actor]] when an action starts.
 */ class ActionStartEvent extends GameEvent {
        constructor(action, target){
            super();
            this.action = action;
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when an action completes.
 */ class ActionCompleteEvent extends GameEvent {
        constructor(action, target){
            super();
            this.action = action;
            this.target = target;
        }
    }
    class MediaEvent extends GameEvent {
        /**
     * Media event cannot bubble
     */ set bubbles(_value) {
        // stubbed
        }
        /**
     * Media event cannot bubble
     */ get bubbles() {
            return false;
        }
        /**
     * Media event cannot bubble, so they have no path
     */ get _path() {
            return null;
        }
        /**
     * Media event cannot bubble, so they have no path
     */ set _path(_val) {
        // stubbed
        }
        constructor(target, _name = "MediaEvent"){
            super();
            this.target = target;
            this._name = _name;
        }
        /**
     * Prevents event from bubbling
     */ stopPropagation() {
        /**
         * Stub
         */ }
        /**
     * Action, that calls when event happens
     */ action() {
        /**
         * Stub
         */ }
        /**
     * Propagate event further through event path
     */ propagate() {
        /**
         * Stub
         */ }
        layPath(_actor) {
        /**
         * Stub
         */ }
    }
    class NativeSoundEvent extends MediaEvent {
        constructor(target, track){
            super(target, "NativeSoundEvent");
            this.track = track;
        }
    }
    class NativeSoundProcessedEvent extends MediaEvent {
        constructor(target, _processedData){
            super(target, "NativeSoundProcessedEvent");
            this._processedData = _processedData;
            this.data = this._processedData;
        }
    }
    /**
 * Whether or not the browser can play this file as HTML5 Audio
 */ function canPlayFile(file) {
        try {
            const a = new Audio();
            const filetype = /.*\.([A-Za-z0-9]+)(?:(?:\?|\#).*)*$/;
            const type = file.match(filetype)[1];
            if (a.canPlayType("audio/" + type)) return true;
            else return false;
        } catch (e) {
            Logger.getInstance().warn("Cannot determine audio support, assuming no support for the Audio Tag", e);
            return false;
        }
    }
    const SoundEvents = {
        VolumeChange: "volumechange",
        Processed: "processed",
        Pause: "pause",
        Stop: "stop",
        PlaybackEnd: "playbackend",
        Resume: "resume",
        PlaybackStart: "playbackstart"
    };
    /**
 * The [[Sound]] object allows games built in Excalibur to load audio
 * components, from soundtracks to sound effects. [[Sound]] is an [[Loadable]]
 * which means it can be passed to a [[Loader]] to pre-load before a game or level.
 */ class Sound {
        /**
     * Indicates whether the clip should loop when complete
     * @param value  Set the looping flag
     */ set loop(value) {
            this._loop = value;
            for (const track of this._tracks)track.loop = this._loop;
            this.logger.debug("Set loop for all instances of sound", this.path, "to", this._loop);
        }
        get loop() {
            return this._loop;
        }
        set volume(value) {
            this._volume = value;
            for (const track of this._tracks)track.volume = this._volume;
            this.events.emit("volumechange", new NativeSoundEvent(this));
            this.logger.debug("Set loop for all instances of sound", this.path, "to", this._volume);
        }
        get volume() {
            return this._volume;
        }
        /**
     * Get the duration that this audio should play. If unset the total natural playback duration will be used.
     */ get duration() {
            return this._duration;
        }
        /**
     * Set the duration that this audio should play. If unset the total natural playback duration will be used.
     *
     * Note: if you seek to a specific point the duration will start from that point, for example
     *
     * If you have a 10 second clip, seek to 5 seconds, then set the duration to 2, it will play the clip from 5-7 seconds.
     */ set duration(duration) {
            this._duration = duration;
        }
        /**
     * Return array of Current AudioInstances playing or being paused
     */ get instances() {
            return this._tracks;
        }
        get path() {
            return this._resource.path;
        }
        set path(val) {
            this._resource.path = val;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * @param paths A list of audio sources (clip.wav, clip.mp3, clip.ogg) for this audio clip. This is done for browser compatibility.
     */ constructor(...paths){
            this.events = new EventEmitter();
            this.logger = Logger.getInstance();
            this._loop = false;
            this._volume = 1;
            this._isStopped = false;
            // private _isPaused = false;
            this._tracks = [];
            this._wasPlayingOnHidden = false;
            this._playbackRate = 1.0;
            this._audioContext = AudioContextFactory.create();
            this._resource = new Resource("", ExResponse.type.arraybuffer);
            /**
         * Chrome : MP3, WAV, Ogg
         * Firefox : WAV, Ogg,
         * IE : MP3, WAV coming soon
         * Safari MP3, WAV, Ogg
         */ for (const path of paths)if (canPlayFile(path)) {
                this.path = path;
                break;
            }
            if (!this.path) {
                this.logger.warn("This browser does not support any of the audio files specified:", paths.join(", "));
                this.logger.warn("Attempting to use", paths[0]);
                this.path = paths[0]; // select the first specified
            }
        }
        isLoaded() {
            return !!this.data;
        }
        async load() {
            var _a, _b;
            if (this.data) return this.data;
            const arraybuffer = await this._resource.load();
            const audiobuffer = await this.decodeAudio(arraybuffer.slice(0));
            this._duration = (_b = (_a = this._duration) !== null && _a !== void 0 ? _a : audiobuffer === null || audiobuffer === void 0 ? void 0 : audiobuffer.duration) !== null && _b !== void 0 ? _b : undefined;
            this.events.emit("processed", new NativeSoundProcessedEvent(this, audiobuffer));
            return this.data = audiobuffer;
        }
        async decodeAudio(data) {
            try {
                return await this._audioContext.decodeAudioData(data.slice(0));
            } catch (e) {
                this.logger.error("Unable to decode  this browser may not fully support this format, or the file may be corrupt, if this is an mp3 try removing id3 tags and album art from the file.");
                return await Promise.reject();
            }
        }
        wireEngine(engine) {
            if (engine) {
                this._engine = engine;
                this._engine.on("hidden", ()=>{
                    if (engine.pauseAudioWhenHidden && this.isPlaying()) {
                        this._wasPlayingOnHidden = true;
                        this.pause();
                    }
                });
                this._engine.on("visible", ()=>{
                    if (engine.pauseAudioWhenHidden && this._wasPlayingOnHidden) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        this.play();
                        this._wasPlayingOnHidden = false;
                    }
                });
                this._engine.on("start", ()=>{
                    this._isStopped = false;
                });
                this._engine.on("stop", ()=>{
                    this.stop();
                    this._isStopped = true;
                });
            }
        }
        /**
     * Returns how many instances of the sound are currently playing
     */ instanceCount() {
            return this._tracks.length;
        }
        /**
     * Whether or not the sound is playing right now
     */ isPlaying() {
            return this._tracks.some((t)=>t.isPlaying());
        }
        isPaused() {
            return this._tracks.some((t)=>t.isPaused());
        }
        isStopped() {
            return this._tracks.some((t)=>t.isStopped());
        }
        /**
     * Play the sound, returns a promise that resolves when the sound is done playing
     * An optional volume argument can be passed in to play the sound. Max volume is 1.0
     */ play(volume) {
            if (!this.isLoaded()) {
                this.logger.warn("Cannot start playing. Resource", this.path, "is not loaded yet");
                return Promise.resolve(true);
            }
            if (this._isStopped) {
                this.logger.warn("Cannot start playing. Engine is in a stopped state.");
                return Promise.resolve(false);
            }
            this.volume = volume || this.volume;
            if (this.isPaused()) return this._resumePlayback();
            else return this._startPlayback();
        }
        /**
     * Stop the sound, and do not rewind
     */ pause() {
            if (!this.isPlaying()) return;
            for (const track of this._tracks)track.pause();
            this.events.emit("pause", new NativeSoundEvent(this));
            this.logger.debug("Paused all instances of sound", this.path);
        }
        /**
     * Stop the sound if it is currently playing and rewind the track. If the sound is not playing, rewinds the track.
     */ stop() {
            for (const track of this._tracks)track.stop();
            this.events.emit("stop", new NativeSoundEvent(this));
            this._tracks.length = 0;
            this.logger.debug("Stopped all instances of sound", this.path);
        }
        get playbackRate() {
            return this._playbackRate;
        }
        set playbackRate(playbackRate) {
            this._playbackRate = playbackRate;
            this._tracks.forEach((t)=>{
                t.playbackRate = this._playbackRate;
            });
        }
        seek(position, trackId = 0) {
            if (this._tracks.length === 0) this._getTrackInstance(this.data);
            this._tracks[trackId].seek(position);
        }
        getTotalPlaybackDuration() {
            if (!this.isLoaded()) {
                this.logger.warnOnce(`Sound from ${this.path} is not loaded, cannot return total playback duration.` + `Did you forget to add Sound to a loader? https://excaliburjs.com/docs/loaders/`);
                return 0;
            }
            return this.data.duration;
        }
        /**
     * Return the current playback time of the playing track in seconds from the start.
     *
     * Optionally specify the track to query if multiple are playing at once.
     * @param trackId
     */ getPlaybackPosition(trackId = 0) {
            if (this._tracks.length) return this._tracks[trackId].getPlaybackPosition();
            return 0;
        }
        /**
     * Get Id of provided AudioInstance in current trackList
     * @param track [[Audio]] which Id is to be given
     */ getTrackId(track) {
            return this._tracks.indexOf(track);
        }
        async _resumePlayback() {
            if (this.isPaused) {
                const resumed = [];
                // ensure we resume *current* tracks (if paused)
                for (const track of this._tracks)resumed.push(track.play().then(()=>{
                    this._tracks.splice(this.getTrackId(track), 1);
                    return true;
                }));
                this.events.emit("resume", new NativeSoundEvent(this));
                this.logger.debug("Resuming paused instances for sound", this.path, this._tracks);
                // resolve when resumed tracks are done
                await Promise.all(resumed);
            }
            return true;
        }
        /**
     * Starts playback, returns a promise that resolves when playback is complete
     */ async _startPlayback() {
            const track = this._getTrackInstance(this.data);
            const complete = await track.play(()=>{
                this.events.emit("playbackstart", new NativeSoundEvent(this, track));
                this.logger.debug("Playing new instance for sound", this.path);
            });
            this.events.emit("playbackend", new NativeSoundEvent(this, track));
            // cleanup any done tracks
            const trackId = this.getTrackId(track);
            if (trackId !== -1) this._tracks.splice(trackId, 1);
            return complete;
        }
        _getTrackInstance(data) {
            const newTrack = new WebAudioInstance(data);
            newTrack.loop = this.loop;
            newTrack.volume = this.volume;
            newTrack.duration = this.duration;
            newTrack.playbackRate = this._playbackRate;
            this._tracks.push(newTrack);
            return newTrack;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    const LoaderEvents = {
        // Add event types here
        BeforeLoad: "beforeload",
        AfterLoad: "afterload",
        UserAction: "useraction",
        LoadResourceStart: "loadresourcestart",
        LoadResourceEnd: "loadresourceend"
    };
    /**
 * Returns true if the constructor is for an Excalibur Loader
 */ function isLoaderConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    class DefaultLoader {
        get resources() {
            return this._resources;
        }
        /**
     * @param options Optionally provide the list of resources you want to load at constructor time
     */ constructor(options){
            var _a;
            this.events = new EventEmitter();
            this.canvas = new Canvas({
                filtering: ImageFiltering.Blended,
                smoothing: true,
                cache: false,
                draw: this.onDraw.bind(this)
            });
            this._resources = [];
            this._numLoaded = 0;
            this._totalTimeMs = 0;
            this._loadingFuture = new Future();
            if (options && ((_a = options.loadables) === null || _a === void 0 ? void 0 : _a.length)) this.addResources(options.loadables);
        }
        /**
     * Called by the engine before loading
     * @param engine
     */ onInitialize(engine) {
            this.engine = engine;
            this.canvas.width = this.engine.screen.resolution.width;
            this.canvas.height = this.engine.screen.resolution.height;
        }
        /**
     * Return a promise that resolves when the user interacts with the loading screen in some way, usually a click.
     *
     * It's important to implement this in order to unlock the audio context in the browser. Browsers automatically prevent
     * audio from playing until the user performs an action.
     *
     */ async onUserAction() {
            return await Promise.resolve();
        }
        /**
     * Overridable lifecycle method, called directly before loading starts
     */ async onBeforeLoad() {
        // override me
        }
        /**
     * Overridable lifecycle method, called after loading has completed
     */ async onAfterLoad() {
            // override me
            await delay(500, this.engine.clock); // avoid a flicker
        }
        /**
     * Add a resource to the loader to load
     * @param loadable  Resource to add
     */ addResource(loadable) {
            this._resources.push(loadable);
        }
        /**
     * Add a list of resources to the loader to load
     * @param loadables  The list of resources to load
     */ addResources(loadables) {
            let i = 0;
            const len = loadables.length;
            for(i; i < len; i++)this.addResource(loadables[i]);
        }
        markResourceComplete() {
            this._numLoaded++;
        }
        /**
     * Returns the progress of the loader as a number between [0, 1] inclusive.
     */ get progress() {
            const total = this._resources.length;
            return total > 0 ? clamp(this._numLoaded, 0, total) / total : 1;
        }
        /**
     * Returns true if the loader has completely loaded all resources
     */ isLoaded() {
            return this._numLoaded === this._resources.length;
        }
        /**
     * Optionally override the onUpdate
     * @param engine
     * @param elapsedMilliseconds
     */ onUpdate(engine, elapsedMilliseconds) {
            this._totalTimeMs += elapsedMilliseconds;
        // override me
        }
        /**
     * Optionally override the onDraw
     */ onDraw(ctx) {
            const seconds = this._totalTimeMs / 1000;
            ctx.fillStyle = Color.Black.toRGBA();
            ctx.fillRect(0, 0, this.engine.screen.resolution.width, this.engine.screen.resolution.height);
            ctx.save();
            ctx.translate(this.engine.screen.resolution.width / 2, this.engine.screen.resolution.height / 2);
            const speed = seconds * 10;
            ctx.strokeStyle = "white";
            ctx.lineWidth = 10;
            ctx.lineCap = "round";
            ctx.arc(0, 0, 40, speed, speed + Math.PI * 3 / 2);
            ctx.stroke();
            ctx.fillStyle = "white";
            ctx.font = "16px sans-serif";
            const text = (this.progress * 100).toFixed(0) + "%";
            const textbox = ctx.measureText(text);
            const width = Math.abs(textbox.actualBoundingBoxLeft) + Math.abs(textbox.actualBoundingBoxRight);
            const height = Math.abs(textbox.actualBoundingBoxAscent) + Math.abs(textbox.actualBoundingBoxDescent);
            ctx.fillText(text, -width / 2, height / 2); // center
            ctx.restore();
        }
        areResourcesLoaded() {
            return this._loadingFuture.promise;
        }
        /**
     * Not meant to be overridden
     *
     * Begin loading all of the supplied resources, returning a promise
     * that resolves when loading of all is complete AND the user has interacted with the loading screen
     */ async load() {
            await this.onBeforeLoad();
            this.events.emit("beforeload");
            this.canvas.flagDirty();
            await Promise.all(this._resources.map(async (r)=>{
                this.events.emit("loadresourcestart", r);
                await r.load().finally(()=>{
                    // capture progress
                    this._numLoaded++;
                    this.canvas.flagDirty();
                    this.events.emit("loadresourceend", r);
                });
            }));
            // Wire all sound to the engine
            for (const resource of this._resources)if (resource instanceof Sound) resource.wireEngine(this.engine);
            this._loadingFuture.resolve();
            this.canvas.flagDirty();
            // Unlock browser AudioContext in after user gesture
            // See: https://github.com/excaliburjs/Excalibur/issues/262
            // See: https://github.com/excaliburjs/Excalibur/issues/1031
            await this.onUserAction();
            this.events.emit("useraction");
            await WebAudio.unlock();
            await this.onAfterLoad();
            this.events.emit("afterload");
            return this.data = this._resources;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    /* istanbul ignore next */ /**
 * Draw a line on canvas context
 * @param ctx The canvas context
 * @param color The color of the line
 * @param x1 The start x coordinate
 * @param y1 The start y coordinate
 * @param x2 The ending x coordinate
 * @param y2 The ending y coordinate
 * @param thickness The line thickness
 * @param cap The [[LineCapStyle]] (butt, round, or square)
 */ function line(ctx, color = Color.Red, x1, y1, x2, y2, thickness = 1, cap = "butt") {
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = thickness;
        ctx.lineCap = cap;
        ctx.strokeStyle = color.toString();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    /* istanbul ignore next */ /**
 * Draw the vector as a point onto the canvas.
 */ function point(ctx, color = Color.Red, point) {
        ctx.beginPath();
        ctx.strokeStyle = color.toString();
        ctx.arc(point.x, point.y, 5, 0, Math.PI * 2);
        ctx.closePath();
        ctx.stroke();
    }
    /**
 * Draw the vector as a line onto the canvas starting a origin point.
 */ /* istanbul ignore next */ /**
 *
 */ function vector(ctx, color, origin, vector, scale = 1.0) {
        const c = color ? color.toString() : "blue";
        const v = vector.scale(scale);
        ctx.beginPath();
        ctx.strokeStyle = c;
        ctx.moveTo(origin.x, origin.y);
        ctx.lineTo(origin.x + v.x, origin.y + v.y);
        ctx.closePath();
        ctx.stroke();
    }
    /**
 * Draw a round rectangle on a canvas context
 * @param ctx The canvas context
 * @param x The top-left x coordinate
 * @param y The top-left y coordinate
 * @param width The width of the rectangle
 * @param height The height of the rectangle
 * @param radius The border radius of the rectangle
 * @param stroke The [[Color]] to stroke rectangle with
 * @param fill The [[Color]] to fill rectangle with
 */ function roundRect(ctx, x, y, width, height, radius = 5, stroke = Color.White, fill = null) {
        let br;
        if (typeof radius === "number") br = {
            tl: radius,
            tr: radius,
            br: radius,
            bl: radius
        };
        else {
            const defaultRadius = {
                tl: 0,
                tr: 0,
                br: 0,
                bl: 0
            };
            for(const prop in defaultRadius)if (defaultRadius.hasOwnProperty(prop)) {
                const side = prop;
                br[side] = radius[side] || defaultRadius[side];
            }
        }
        ctx.beginPath();
        ctx.moveTo(x + br.tl, y);
        ctx.lineTo(x + width - br.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + br.tr);
        ctx.lineTo(x + width, y + height - br.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - br.br, y + height);
        ctx.lineTo(x + br.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - br.bl);
        ctx.lineTo(x, y + br.tl);
        ctx.quadraticCurveTo(x, y, x + br.tl, y);
        ctx.closePath();
        if (fill) {
            ctx.fillStyle = fill.toString();
            ctx.fill();
        }
        if (stroke) {
            ctx.strokeStyle = stroke.toString();
            ctx.stroke();
        }
    }
    /**
 *
 */ function circle(ctx, x, y, radius, stroke = Color.White, fill = null) {
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.closePath();
        if (fill) {
            ctx.fillStyle = fill.toString();
            ctx.fill();
        }
        if (stroke) {
            ctx.strokeStyle = stroke.toString();
            ctx.stroke();
        }
    }
    /* harmony default export */ const Loader_logo = "data:image/png;base64,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";
    // EXTERNAL MODULE: ./Director/Loader.css
    var Director_Loader = $2c23f148d58cd887$var$__webpack_require__(8851);
    /**
 * Pre-loading assets
 *
 * The loader provides a mechanism to preload multiple resources at
 * one time. The loader must be passed to the engine in order to
 * trigger the loading progress bar.
 *
 * The [[Loader]] itself implements [[Loadable]] so you can load loaders.
 *
 * ## Example: Pre-loading resources for a game
 *
 * ```js
 * // create a loader
 * var loader = new ex.Loader();
 *
 * // create a resource dictionary (best practice is to keep a separate file)
 * var resources = {
 *   TextureGround: new ex.Texture("/images/textures/ground.png"),
 *   SoundDeath: new ex.Sound("/sound/death.wav", "/sound/death.mp3")
 * };
 *
 * // loop through dictionary and add to loader
 * for (var loadable in resources) {
 *   if (resources.hasOwnProperty(loadable)) {
 *     loader.addResource(resources[loadable]);
 *   }
 * }
 *
 * // start game
 * game.start(loader).then(function () {
 *   console.log("Game started!");
 * });
 * ```
 *
 * ## Customize the Loader
 *
 * The loader can be customized to show different, text, logo, background color, and button.
 *
 * ```typescript
 * const loader = new ex.Loader([playerTexture]);
 *
 * // The loaders button text can simply modified using this
 * loader.playButtonText = 'Start the best game ever';
 *
 * // The logo can be changed by inserting a base64 image string here
 *
 * loader.logo = 'data:image/png;base64,iVBORw...';
 * loader.logoWidth = 15;
 * loader.logoHeight = 14;
 *
 * // The background color can be changed like so by supplying a valid CSS color string
 *
 * loader.backgroundColor = 'red'
 * loader.backgroundColor = '#176BAA'
 *
 * // To build a completely new button
 * loader.startButtonFactory = () => {
 *     let myButton = document.createElement('button');
 *     myButton.textContent = 'The best button';
 *     return myButton;
 * };
 *
 * engine.start(loader).then(() => {});
 * ```
 */ class Loader extends DefaultLoader {
        get _image() {
            if (!this._imageElement) {
                this._imageElement = new Image();
                this._imageElement.onload = ()=>this._imageLoaded.resolve();
                this._imageElement.src = this.logo;
            }
            return this._imageElement;
        }
        get playButtonRootElement() {
            return this._playButtonRootElement;
        }
        get playButtonElement() {
            return this._playButtonElement;
        }
        get _playButton() {
            const existingRoot = document.getElementById("excalibur-play-root");
            if (existingRoot) this._playButtonRootElement = existingRoot;
            if (!this._playButtonRootElement) {
                this._playButtonRootElement = document.createElement("div");
                this._playButtonRootElement.id = "excalibur-play-root";
                this._playButtonRootElement.style.position = "absolute";
                document.body.appendChild(this._playButtonRootElement);
            }
            if (!this._styleBlock) {
                this._styleBlock = document.createElement("style");
                this._styleBlock.textContent = this._playButtonStyles;
                document.head.appendChild(this._styleBlock);
            }
            if (!this._playButtonElement) {
                this._playButtonElement = this.startButtonFactory();
                this._playButtonRootElement.appendChild(this._playButtonElement);
            }
            return this._playButtonElement;
        }
        constructor(loadablesOrOptions){
            const options = Array.isArray(loadablesOrOptions) ? {
                loadables: loadablesOrOptions
            } : loadablesOrOptions;
            super(options);
            this._logger = Logger.getInstance();
            this._originalOptions = {
                loadables: []
            };
            this.events = new EventEmitter();
            this._playButtonShown = false;
            // logo drawing stuff
            // base64 string encoding of the excalibur logo (logo-white.png)
            this.logo = Loader_logo;
            this.logoWidth = 468;
            this.logoHeight = 118;
            /**
         * Gets or sets the color of the loading bar, default is [[Color.White]]
         */ this.loadingBarColor = Color.White;
            /**
         * Gets or sets the background color of the loader as a hex string
         */ this.backgroundColor = "#176BAA";
            this._imageLoaded = new Future();
            this.suppressPlayButton = false;
            /** Loads the css from Loader.css */ this._playButtonStyles = Director_Loader /* default */ .A.toString();
            /**
         * Get/set play button text
         */ this.playButtonText = "Play game";
            /**
         * Return a html button element for excalibur to use as a play button
         */ this.startButtonFactory = ()=>{
                let buttonElement = document.getElementById("excalibur-play");
                if (!buttonElement) buttonElement = document.createElement("button");
                buttonElement.id = "excalibur-play";
                buttonElement.textContent = this.playButtonText;
                buttonElement.style.display = "none";
                return buttonElement;
            };
            this._configuredPixelRatio = null;
            this._originalOptions = {
                ...Loader._DEFAULT_LOADER_OPTIONS,
                ...options
            };
        }
        onInitialize(engine) {
            this.engine = engine;
            this.screen = engine.screen;
            this.canvas.width = this.engine.canvas.width;
            this.canvas.height = this.engine.canvas.height;
            this.screen.events.on("resize", ()=>{
                this.canvas.width = this.engine.canvas.width;
                this.canvas.height = this.engine.canvas.height;
            });
        }
        /**
     * Shows the play button and returns a promise that resolves when clicked
     */ async showPlayButton() {
            var _a, _b;
            if (this.suppressPlayButton) {
                this.hidePlayButton();
                // Delay is to give the logo a chance to show, otherwise don't delay
                await delay(500, (_a = this.engine) === null || _a === void 0 ? void 0 : _a.clock);
            } else {
                const resizeHandler = ()=>{
                    try {
                        this._positionPlayButton();
                    } catch (_a) {
                    // swallow if can't position
                    }
                };
                if ((_b = this.engine) === null || _b === void 0 ? void 0 : _b.browser) this.engine.browser.window.on("resize", resizeHandler);
                this._playButtonShown = true;
                this._playButton.style.display = "block";
                document.body.addEventListener("keyup", (evt)=>{
                    if (evt.key === "Enter") this._playButton.click();
                });
                this._positionPlayButton();
                const playButtonClicked = new Promise((resolve)=>{
                    const startButtonHandler = (e)=>{
                        var _a;
                        // We want to stop propagation to keep bubbling to the engine pointer handlers
                        e.stopPropagation();
                        // Hide Button after click
                        this.hidePlayButton();
                        if ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.browser) this.engine.browser.window.off("resize", resizeHandler);
                        if (this._originalOptions.fullscreenAfterLoad) try {
                            this._logger.info("requesting fullscreen");
                            if (this._originalOptions.fullscreenContainer instanceof HTMLElement) this._originalOptions.fullscreenContainer.requestFullscreen();
                            else this.engine.screen.goFullScreen(this._originalOptions.fullscreenContainer);
                        } catch (error) {
                            this._logger.error("could not go fullscreen", error);
                        }
                        resolve();
                    };
                    this._playButton.addEventListener("click", startButtonHandler);
                    this._playButton.addEventListener("touchend", startButtonHandler);
                    this._playButton.addEventListener("pointerup", startButtonHandler);
                });
                return await playButtonClicked;
            }
        }
        hidePlayButton() {
            this._playButtonShown = false;
            this._playButton.style.display = "none";
        }
        /**
     * Clean up generated elements for the loader
     */ dispose() {
            if (this._playButtonRootElement.parentElement) {
                this._playButtonRootElement.removeChild(this._playButtonElement);
                document.body.removeChild(this._playButtonRootElement);
                document.head.removeChild(this._styleBlock);
                this._playButtonRootElement = null;
                this._playButtonElement = null;
                this._styleBlock = null;
            }
        }
        async onUserAction() {
            var _a;
            // short delay in showing the button for aesthetics
            await delay(200, (_a = this.engine) === null || _a === void 0 ? void 0 : _a.clock);
            this.canvas.flagDirty();
            // show play button
            await this.showPlayButton();
        }
        async onBeforeLoad() {
            const image = this._image;
            await this._imageLoaded.promise;
            await (image === null || image === void 0 ? void 0 : image.decode()); // decode logo if it exists
        }
        // eslint-disable-next-line require-await
        async onAfterLoad() {
            this.screen.pixelRatioOverride = this._configuredPixelRatio;
            this.screen.popResolutionAndViewport();
            this.screen.applyResolutionAndViewport();
            this.dispose();
        }
        _positionPlayButton() {
            if (this.engine) {
                const { x: left, y: top, width: screenWidth, height: screenHeight } = this.engine.canvas.getBoundingClientRect();
                if (this._playButtonRootElement) {
                    const buttonWidth = this._playButton.clientWidth;
                    const buttonHeight = this._playButton.clientHeight;
                    if (this.playButtonPosition) {
                        this._playButtonRootElement.style.left = `${this.playButtonPosition.x}px`;
                        this._playButtonRootElement.style.top = `${this.playButtonPosition.y}px`;
                    } else {
                        this._playButtonRootElement.style.left = `${left + screenWidth / 2 - buttonWidth / 2}px`;
                        this._playButtonRootElement.style.top = `${top + screenHeight / 2 - buttonHeight / 2 + 100}px`;
                    }
                }
            }
        }
        /**
     * Loader draw function. Draws the default Excalibur loading screen.
     * Override `logo`, `logoWidth`, `logoHeight` and `backgroundColor` properties
     * to customize the drawing, or just override entire method.
     */ onDraw(ctx) {
            const canvasHeight = this.engine.canvasHeight / this.engine.pixelRatio;
            const canvasWidth = this.engine.canvasWidth / this.engine.pixelRatio;
            this._positionPlayButton();
            ctx.fillStyle = this.backgroundColor;
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
            let logoY = canvasHeight / 2;
            const width = Math.min(this.logoWidth, canvasWidth * 0.75);
            let logoX = canvasWidth / 2 - width / 2;
            if (this.logoPosition) {
                logoX = this.logoPosition.x;
                logoY = this.logoPosition.y;
            }
            const imageHeight = Math.floor(width * (this.logoHeight / this.logoWidth)); // OG height/width factor
            const oldAntialias = this.engine.getAntialiasing();
            this.engine.setAntialiasing(true);
            if (!this.logoPosition) ctx.drawImage(this._image, 0, 0, this.logoWidth, this.logoHeight, logoX, logoY - imageHeight - 20, width, imageHeight);
            else ctx.drawImage(this._image, 0, 0, this.logoWidth, this.logoHeight, logoX, logoY, width, imageHeight);
            // loading box
            if (!this.suppressPlayButton && this._playButtonShown) {
                this.engine.setAntialiasing(oldAntialias);
                return;
            }
            let loadingX = logoX;
            let loadingY = logoY;
            if (this.loadingBarPosition) {
                loadingX = this.loadingBarPosition.x;
                loadingY = this.loadingBarPosition.y;
            }
            ctx.lineWidth = 2;
            roundRect(ctx, loadingX, loadingY, width, 20, 10, this.loadingBarColor);
            const progress = width * this.progress;
            const margin = 5;
            const progressWidth = progress - margin * 2;
            const height = 20 - margin * 2;
            roundRect(ctx, loadingX + margin, loadingY + margin, progressWidth > 10 ? progressWidth : 10, height, 5, null, this.loadingBarColor);
            this.engine.setAntialiasing(oldAntialias);
        }
    }
    Loader._DEFAULT_LOADER_OPTIONS = {
        loadables: [],
        fullscreenAfterLoad: false,
        fullscreenContainer: undefined
    };
    /**
 * This is the list of features that will be used to log the supported
 * features to the console when Detector.logBrowserFeatures() is called.
 */ const REPORTED_FEATURES = {
        webgl: "WebGL",
        webaudio: "WebAudio",
        gamepadapi: "Gamepad API"
    };
    /**
 * Excalibur internal feature detection helper class
 */ class Detector {
        constructor(){
            this._features = null;
            this.failedTests = [];
            // critical browser features required for ex to run
            this._criticalTests = {
                // Test canvas/2d context support
                canvasSupport: function() {
                    const elem = document.createElement("canvas");
                    return !!(elem.getContext && elem.getContext("2d"));
                },
                // Test array buffer support ex uses for downloading binary data
                arrayBufferSupport: function() {
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", "/");
                    try {
                        xhr.responseType = "arraybuffer";
                    } catch (e) {
                        return false;
                    }
                    return xhr.responseType === "arraybuffer";
                },
                // Test data urls ex uses for sprites
                dataUrlSupport: function() {
                    const canvas = document.createElement("canvas");
                    return canvas.toDataURL("image/png").indexOf("data:image/png") === 0;
                },
                // Test object url support for loading
                objectUrlSupport: function() {
                    return "URL" in window && "revokeObjectURL" in URL && "createObjectURL" in URL;
                },
                // RGBA support for colors
                rgbaSupport: function() {
                    const style = document.createElement("a").style;
                    style.cssText = "background-color:rgba(150,255,150,.5)";
                    return ("" + style.backgroundColor).indexOf("rgba") > -1;
                }
            };
            // warnings excalibur performance will be degraded
            this._warningTest = {
                webAudioSupport: function() {
                    return !!(window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext || window.oAudioContext);
                },
                webglSupport: function() {
                    const elem = document.createElement("canvas");
                    return !!(elem.getContext && elem.getContext("webgl"));
                }
            };
            this._features = this._loadBrowserFeatures();
        }
        /**
     * Returns a map of currently supported browser features. This method
     * treats the features as a singleton and will only calculate feature
     * support if it has not previously been done.
     */ getBrowserFeatures() {
            if (this._features === null) this._features = this._loadBrowserFeatures();
            return this._features;
        }
        /**
     * Report on non-critical browser support for debugging purposes.
     * Use native browser console colors for visibility.
     */ logBrowserFeatures() {
            let msg = "%cSUPPORTED BROWSER FEATURES\n==========================%c\n";
            const args = [
                "font-weight: bold; color: navy",
                "font-weight: normal; color: inherit"
            ];
            const supported = this.getBrowserFeatures();
            for (const feature of Object.keys(REPORTED_FEATURES)){
                if (supported[feature]) {
                    msg += "(%c\u2713%c)"; // (✓)
                    args.push("font-weight: bold; color: green");
                    args.push("font-weight: normal; color: inherit");
                } else {
                    msg += "(%c\u2717%c)"; // (✗)
                    args.push("font-weight: bold; color: red");
                    args.push("font-weight: normal; color: inherit");
                }
                msg += " " + REPORTED_FEATURES[feature] + "\n";
            }
            args.unshift(msg);
            // eslint-disable-next-line no-console
            console.log.apply(console, args);
        }
        /**
     * Executes several IIFE's to get a constant reference to supported
     * features within the current execution context.
     */ _loadBrowserFeatures() {
            return {
                // IIFE to check canvas support
                canvas: (()=>{
                    return this._criticalTests.canvasSupport();
                })(),
                // IIFE to check arraybuffer support
                arraybuffer: (()=>{
                    return this._criticalTests.arrayBufferSupport();
                })(),
                // IIFE to check dataurl support
                dataurl: (()=>{
                    return this._criticalTests.dataUrlSupport();
                })(),
                // IIFE to check objecturl support
                objecturl: (()=>{
                    return this._criticalTests.objectUrlSupport();
                })(),
                // IIFE to check rgba support
                rgba: (()=>{
                    return this._criticalTests.rgbaSupport();
                })(),
                // IIFE to check webaudio support
                webaudio: (()=>{
                    return this._warningTest.webAudioSupport();
                })(),
                // IIFE to check webgl support
                webgl: (()=>{
                    return this._warningTest.webglSupport();
                })(),
                // IIFE to check gamepadapi support
                gamepadapi: (()=>{
                    return !!navigator.getGamepads;
                })()
            };
        }
        test() {
            // Critical test will for ex not to run
            let failedCritical = false;
            for(const test in this._criticalTests)if (!this._criticalTests[test].call(this)) {
                this.failedTests.push(test);
                Logger.getInstance().error("Critical browser feature missing, Excalibur requires:", test);
                failedCritical = true;
            }
            if (failedCritical) return false;
            // Warning tests do not for ex to return false to compatibility
            for(const warning in this._warningTest)if (!this._warningTest[warning]()) Logger.getInstance().warn("Warning browser feature missing, Excalibur will have reduced performance:", warning);
            return true;
        }
    }
    /**
 * An enum that describes the types of collisions bodies can participate in
 */ var CollisionType;
    (function(CollisionType) {
        /**
     * Bodies with the `PreventCollision` setting do not participate in any
     * collisions and do not raise collision events.
     */ CollisionType["PreventCollision"] = "PreventCollision";
        /**
     * Bodies with the `Passive` setting only raise collision events, but are not
     * influenced or moved by other bodies and do not influence or move other bodies.
     * This is useful for use in trigger type behavior.
     */ CollisionType["Passive"] = "Passive";
        /**
     * Bodies with the `Active` setting raise collision events and participate
     * in collisions with other bodies and will be push or moved by bodies sharing
     * the `Active` or `Fixed` setting.
     */ CollisionType["Active"] = "Active";
        /**
     * Bodies with the `Fixed` setting raise collision events and participate in
     * collisions with other bodies. Actors with the `Fixed` setting will not be
     * pushed or moved by other bodies sharing the `Fixed`. Think of Fixed
     * bodies as "immovable/unstoppable" objects. If two `Fixed` bodies meet they will
     * not be pushed or moved by each other, they will not interact except to throw
     * collision events.
     */ CollisionType["Fixed"] = "Fixed";
    })(CollisionType || (CollisionType = {}));
    /**
 * Enum representing the coordinate plane for the position 2D vector in the [[TransformComponent]]
 */ var CoordPlane;
    (function(CoordPlane) {
        /**
     * The world coordinate plane (default) represents world space, any entities drawn with world
     * space move when the camera moves.
     */ CoordPlane["World"] = "world";
        /**
     * The screen coordinate plane represents screen space, entities drawn in screen space are pinned
     * to screen coordinates ignoring the camera.
     */ CoordPlane["Screen"] = "screen";
    })(CoordPlane || (CoordPlane = {}));
    class VectorView extends Vector {
        constructor(options){
            super(0, 0);
            this._getX = options.getX;
            this._getY = options.getY;
            this._setX = options.setX;
            this._setY = options.setY;
        }
        get x() {
            return this._x = this._getX();
        }
        set x(val) {
            this._setX(val);
            this._x = val;
        }
        get y() {
            return this._y = this._getY();
        }
        set y(val) {
            this._setY(val);
            this._y = val;
        }
    }
    /**
 * Wraps a vector and watches for changes in the x/y, modifies the original vector.
 */ class WatchVector extends Vector {
        constructor(original, change){
            super(original.x, original.y);
            this.original = original;
            this.change = change;
        }
        get x() {
            return this._x = this.original.x;
        }
        set x(newX) {
            this.change(newX, this._y);
            this._x = this.original.x = newX;
        }
        get y() {
            return this._y = this.original.y;
        }
        set y(newY) {
            this.change(this._x, newY);
            this._y = this.original.y = newY;
        }
    }
    class transform_Transform {
        constructor(){
            this._parent = null;
            this._children = [];
            this._pos = vec(0, 0);
            this._rotation = 0;
            this._scale = vec(1, 1);
            this._isDirty = false;
            this._isInverseDirty = false;
            this._matrix = AffineMatrix.identity();
            this._inverse = AffineMatrix.identity();
        }
        get parent() {
            return this._parent;
        }
        set parent(transform) {
            if (this._parent) {
                const index = this._parent._children.indexOf(this);
                if (index > -1) this._parent._children.splice(index, 1);
            }
            this._parent = transform;
            if (this._parent) this._parent._children.push(this);
            this.flagDirty();
        }
        get children() {
            return this._children;
        }
        set pos(v) {
            if (!v.equals(this._pos)) {
                this._pos.x = v.x;
                this._pos.y = v.y;
                this.flagDirty();
            }
        }
        get pos() {
            return new WatchVector(this._pos, (x, y)=>{
                if (x !== this._pos.x || y !== this._pos.y) this.flagDirty();
            });
        }
        set globalPos(v) {
            let localPos = v.clone();
            if (this.parent) localPos = this.parent.inverse.multiply(v);
            if (!localPos.equals(this._pos)) {
                this._pos = localPos;
                this.flagDirty();
            }
        }
        get globalPos() {
            return new VectorView({
                getX: ()=>this.matrix.data[4],
                getY: ()=>this.matrix.data[5],
                setX: (x)=>{
                    if (this.parent) {
                        const { x: newX } = this.parent.inverse.multiply(vec(x, this.pos.y));
                        this.pos.x = newX;
                    } else this.pos.x = x;
                    if (x !== this.matrix.data[4]) this.flagDirty();
                },
                setY: (y)=>{
                    if (this.parent) {
                        const { y: newY } = this.parent.inverse.multiply(vec(this.pos.x, y));
                        this.pos.y = newY;
                    } else this.pos.y = y;
                    if (y !== this.matrix.data[5]) this.flagDirty();
                }
            });
        }
        set rotation(rotation) {
            const canonRotation = canonicalizeAngle(rotation);
            if (canonRotation !== this._rotation) this.flagDirty();
            this._rotation = canonRotation;
        }
        get rotation() {
            return this._rotation;
        }
        set globalRotation(rotation) {
            let inverseRotation = 0;
            if (this.parent) inverseRotation = this.parent.globalRotation;
            const canonRotation = canonicalizeAngle(rotation + inverseRotation);
            if (canonRotation !== this._rotation) this.flagDirty();
            this._rotation = canonRotation;
        }
        get globalRotation() {
            if (this.parent) return this.matrix.getRotation();
            return this.rotation;
        }
        set scale(v) {
            if (v.x !== this._scale.x || v.y !== this._scale.y) {
                this._scale.x = v.x;
                this._scale.y = v.y;
                this.flagDirty();
            }
        }
        get scale() {
            return new WatchVector(this._scale, (x, y)=>{
                if (x !== this._scale.x || y !== this._scale.y) this.flagDirty();
            });
        }
        set globalScale(v) {
            let inverseScale = vec(1, 1);
            if (this.parent) inverseScale = this.parent.globalScale;
            this.scale = v.scale(vec(1 / inverseScale.x, 1 / inverseScale.y));
        }
        get globalScale() {
            return new VectorView({
                getX: ()=>this.parent ? this.matrix.getScaleX() : this.scale.x,
                getY: ()=>this.parent ? this.matrix.getScaleY() : this.scale.y,
                setX: (x)=>{
                    if (this.parent) {
                        const globalScaleX = this.parent.globalScale.x;
                        this.scale.x = x / globalScaleX;
                    } else this.scale.x = x;
                },
                setY: (y)=>{
                    if (this.parent) {
                        const globalScaleY = this.parent.globalScale.y;
                        this.scale.y = y / globalScaleY;
                    } else this.scale.y = y;
                }
            });
        }
        get matrix() {
            if (this._isDirty) {
                if (this.parent === null) this._matrix = this._calculateMatrix();
                else this._matrix = this.parent.matrix.multiply(this._calculateMatrix());
                this._isDirty = false;
            }
            return this._matrix;
        }
        get inverse() {
            if (this._isInverseDirty) {
                this._inverse = this.matrix.inverse();
                this._isInverseDirty = false;
            }
            return this._inverse;
        }
        _calculateMatrix() {
            const matrix = AffineMatrix.identity().translate(this.pos.x, this.pos.y).rotate(this.rotation).scale(this.scale.x, this.scale.y);
            return matrix;
        }
        flagDirty() {
            this._isDirty = true;
            this._isInverseDirty = true;
            for(let i = 0; i < this._children.length; i++)this._children[i].flagDirty();
        }
        apply(point) {
            return this.matrix.multiply(point);
        }
        applyInverse(point) {
            return this.inverse.multiply(point);
        }
        setTransform(pos, rotation, scale) {
            this._pos.x = pos.x;
            this._pos.y = pos.y;
            this._rotation = canonicalizeAngle(rotation);
            this._scale.x = scale.x;
            this._scale.y = scale.y;
            this.flagDirty();
        }
        /**
     * Clones the current transform
     * **Warning does not clone the parent**
     * @param dest
     */ clone(dest) {
            const target = dest !== null && dest !== void 0 ? dest : new transform_Transform();
            this._pos.clone(target._pos);
            target._rotation = this._rotation;
            this._scale.clone(target._scale);
            target.flagDirty();
            return target;
        }
    }
    /**
 *
 */ function isComponentCtor(value) {
        return !!value && !!value.prototype && !!value.prototype.constructor;
    }
    /**
 * Type guard to check if a component implements clone
 * @param x
 */ function hasClone(x) {
        return !!(x === null || x === void 0 ? void 0 : x.clone);
    }
    /**
 * Components are containers for state in Excalibur, the are meant to convey capabilities that an Entity possesses
 *
 * Implementations of Component must have a zero-arg constructor to support dependencies
 *
 * ```typescript
 * class MyComponent extends ex.Component {
 *   // zero arg support required if you want to use component dependencies
 *   constructor(public optionalPos?: ex.Vector) {}
 * }
 * ```
 */ class Component {
        constructor(){
            // TODO maybe generate a unique id?
            /**
         * Current owning [[Entity]], if any, of this component. Null if not added to any [[Entity]]
         */ this.owner = undefined;
        }
        /**
     * Clones any properties on this component, if that property value has a `clone()` method it will be called
     */ clone() {
            const newComponent = new this.constructor();
            for(const prop in this)if (this.hasOwnProperty(prop)) {
                const val = this[prop];
                if (hasClone(val) && prop !== "owner" && prop !== "clone") newComponent[prop] = val.clone();
                else newComponent[prop] = val;
            }
            return newComponent;
        }
    }
    /**
 * Simple Observable implementation
 * @template T is the typescript Type that defines the data being observed
 */ class Observable {
        constructor(){
            this.observers = [];
            this.subscriptions = [];
        }
        /**
     * Register an observer to listen to this observable
     * @param observer
     */ register(observer) {
            this.observers.push(observer);
        }
        /**
     * Register a callback to listen to this observable
     * @param func
     */ subscribe(func) {
            this.subscriptions.push(func);
        }
        /**
     * Remove an observer from the observable
     * @param observer
     */ unregister(observer) {
            const i = this.observers.indexOf(observer);
            if (i !== -1) this.observers.splice(i, 1);
        }
        /**
     * Remove a callback that is listening to this observable
     * @param func
     */ unsubscribe(func) {
            const i = this.subscriptions.indexOf(func);
            if (i !== -1) this.subscriptions.splice(i, 1);
        }
        /**
     * Broadcasts a message to all observers and callbacks
     * @param message
     */ notifyAll(message) {
            const observersLength = this.observers.length;
            for(let i = 0; i < observersLength; i++)this.observers[i].notify(message);
            const subscriptionsLength = this.subscriptions.length;
            for(let i = 0; i < subscriptionsLength; i++)this.subscriptions[i](message);
        }
        /**
     * Removes all observers and callbacks
     */ clear() {
            this.observers.length = 0;
            this.subscriptions.length = 0;
        }
    }
    class TransformComponent extends Component {
        constructor(){
            super(...arguments);
            this._logger = Logger.getInstance();
            this._parentComponent = null;
            this._transform = new transform_Transform();
            this._addChildTransform = (child)=>{
                const childTxComponent = child.get(TransformComponent);
                if (childTxComponent) {
                    childTxComponent._transform.parent = this._transform;
                    childTxComponent._parentComponent = this;
                }
            };
            /**
         * Observable that emits when the z index changes on this component
         */ this.zIndexChanged$ = new Observable();
            this._z = 0;
            this._coordPlane = CoordPlane.World;
        }
        get() {
            return this._transform;
        }
        onAdd(owner) {
            for (const child of owner.children)this._addChildTransform(child);
            owner.childrenAdded$.subscribe((child)=>this._addChildTransform(child));
            owner.childrenRemoved$.subscribe((child)=>{
                const childTxComponent = child.get(TransformComponent);
                if (childTxComponent) {
                    childTxComponent._transform.parent = null;
                    childTxComponent._parentComponent = null;
                }
            });
        }
        onRemove(_previousOwner) {
            this._transform.parent = null;
            this._parentComponent = null;
        }
        /**
     * The z-index ordering of the entity, a higher values are drawn on top of lower values.
     * For example z=99 would be drawn on top of z=0.
     */ get z() {
            return this._z;
        }
        set z(val) {
            const oldz = this._z;
            this._z = val;
            if (oldz !== val) this.zIndexChanged$.notifyAll(val);
        }
        /**
     * The [[CoordPlane|coordinate plane|]] for this transform for the entity.
     */ get coordPlane() {
            if (this._parentComponent) return this._parentComponent.coordPlane;
            return this._coordPlane;
        }
        set coordPlane(value) {
            var _a;
            if (!this._parentComponent) this._coordPlane = value;
            else this._logger.warn(`Cannot set coordinate plane on child entity ${(_a = this.owner) === null || _a === void 0 ? void 0 : _a.name}, children inherit their coordinate plane from their parents.`);
        }
        get pos() {
            return this._transform.pos;
        }
        set pos(v) {
            this._transform.pos = v;
        }
        get globalPos() {
            return this._transform.globalPos;
        }
        set globalPos(v) {
            this._transform.globalPos = v;
        }
        get rotation() {
            return this._transform.rotation;
        }
        set rotation(rotation) {
            this._transform.rotation = rotation;
        }
        get globalRotation() {
            return this._transform.globalRotation;
        }
        set globalRotation(rotation) {
            this._transform.globalRotation = rotation;
        }
        get scale() {
            return this._transform.scale;
        }
        set scale(v) {
            this._transform.scale = v;
        }
        get globalScale() {
            return this._transform.globalScale;
        }
        set globalScale(v) {
            this._transform.globalScale = v;
        }
        applyInverse(v) {
            return this._transform.applyInverse(v);
        }
        apply(v) {
            return this._transform.apply(v);
        }
        clone() {
            const component = new TransformComponent();
            component._transform = this._transform.clone();
            component._z = this._z;
            return component;
        }
    }
    class MotionComponent extends Component {
        constructor(){
            super(...arguments);
            /**
         * The velocity of an entity in pixels per second
         */ this.vel = Vector.Zero;
            /**
         * The acceleration of entity in pixels per second^2
         */ this.acc = Vector.Zero;
            /**
         * The scale rate of change in scale units per second
         */ this.scaleFactor = Vector.Zero;
            /**
         * The angular velocity which is how quickly the entity is rotating in radians per second
         */ this.angularVelocity = 0;
            /**
         * The amount of torque applied to the entity, angular acceleration is torque * inertia
         */ this.torque = 0;
            /**
         * Inertia can be thought of as the resistance to motion
         */ this.inertia = 1;
        }
    }
    /**
 * Static class for managing collision groups in excalibur, there is a maximum of 32 collision groups possible in excalibur
 */ class CollisionGroupManager {
        /**
     * Create a new named collision group up to a max of 32.
     * @param name Name for the collision group
     * @param mask Optionally provide your own 32-bit mask, if none is provide the manager will generate one
     */ static create(name, mask) {
            if (this._CURRENT_GROUP > this._MAX_GROUPS) throw new Error(`Cannot have more than ${this._MAX_GROUPS} collision groups`);
            if (this._GROUPS.get(name)) {
                const existingGroup = this._GROUPS.get(name);
                if (existingGroup.mask === mask) return existingGroup;
                throw new Error(`Collision group ${name} already exists with a different mask!`);
            }
            const group = new CollisionGroup(name, this._CURRENT_BIT, mask !== undefined ? mask : ~this._CURRENT_BIT);
            this._CURRENT_BIT = this._CURRENT_BIT << 1 | 0;
            this._CURRENT_GROUP++;
            this._GROUPS.set(name, group);
            return group;
        }
        /**
     * Get all collision groups currently tracked by excalibur
     */ static get groups() {
            return Array.from(this._GROUPS.values());
        }
        /**
     * Get a collision group by it's name
     * @param name
     */ static groupByName(name) {
            return this._GROUPS.get(name);
        }
        /**
     * Resets the managers internal group management state
     */ static reset() {
            this._GROUPS = new Map();
            this._CURRENT_BIT = this._STARTING_BIT;
            this._CURRENT_GROUP = 1;
        }
    }
    // using bitmasking the maximum number of groups is 32, because that is the highest 32bit integer that JS can present.
    CollisionGroupManager._STARTING_BIT = 1;
    CollisionGroupManager._MAX_GROUPS = 32;
    CollisionGroupManager._CURRENT_GROUP = 1;
    CollisionGroupManager._CURRENT_BIT = CollisionGroupManager._STARTING_BIT;
    CollisionGroupManager._GROUPS = new Map();
    /**
 * CollisionGroups indicate like members that do not collide with each other. Use [[CollisionGroupManager]] to create [[CollisionGroup]]s
 *
 * For example:
 *
 * Players have collision group "player"
 *
 * ![Player Collision Group](/assets/images/docs/CollisionGroupsPlayer.png)
 *
 * Enemies have collision group "enemy"
 *
 * ![Enemy Collision Group](/assets/images/docs/CollisionGroupsEnemy.png)
 *
 * Blocks have collision group "ground"
 *
 * ![Ground collision group](/assets/images/docs/CollisionGroupsGround.png)
 *
 * Players don't collide with each other, but enemies and blocks. Likewise, enemies don't collide with each other but collide
 * with players and blocks.
 *
 * This is done with bitmasking, see the following pseudo-code
 *
 * PlayerGroup = `0b001`
 * PlayerGroupMask = `0b110`
 *
 * EnemyGroup = `0b010`
 * EnemyGroupMask = `0b101`
 *
 * BlockGroup = `0b100`
 * BlockGroupMask = `0b011`
 *
 * Should Players collide? No because the bitwise mask evaluates to 0
 * `(player1.group & player2.mask) === 0`
 * `(0b001 & 0b110) === 0`
 *
 * Should Players and Enemies collide? Yes because the bitwise mask is non-zero
 * `(player1.group & enemy1.mask) === 1`
 * `(0b001 & 0b101) === 1`
 *
 * Should Players and Blocks collide? Yes because the bitwise mask is non-zero
 * `(player1.group & blocks1.mask) === 1`
 * `(0b001 & 0b011) === 1`
 */ class CollisionGroup {
        /**
     * STOP!!** It is preferred that [[CollisionGroupManager.create]] is used to create collision groups
     *  unless you know how to construct the proper bitmasks. See https://github.com/excaliburjs/Excalibur/issues/1091 for more info.
     * @param name Name of the collision group
     * @param category 32 bit category for the group, should be a unique power of 2. For example `0b001` or `0b010`
     * @param mask 32 bit mask of category, or `~category` generally. For a category of `0b001`, the mask would be `0b110`
     */ constructor(name, category, mask){
            this._name = name;
            this._category = category;
            this._mask = mask;
        }
        /**
     * Get the name of the collision group
     */ get name() {
            return this._name;
        }
        /**
     * Get the category of the collision group, a 32 bit number which should be a unique power of 2
     */ get category() {
            return this._category;
        }
        /**
     * Get the mask for this collision group
     */ get mask() {
            return this._mask;
        }
        /**
     * Evaluates whether 2 collision groups can collide
     *
     * This means the mask has the same bit set the other category and vice versa
     * @param other  CollisionGroup
     */ canCollide(other) {
            const overlap1 = this.category & other.mask;
            const overlap2 = this.mask & other.category;
            return overlap1 !== 0 && overlap2 !== 0;
        }
        /**
     * Inverts the collision group. For example, if before the group specified "players",
     * inverting would specify all groups except players
     * @returns CollisionGroup
     */ invert() {
            const group = CollisionGroupManager.create("~(" + this.name + ")", ~this.mask | 0);
            group._category = ~this.category;
            return group;
        }
        /**
     * Combine collision groups with each other. The new group includes all of the previous groups.
     * @param collisionGroups
     */ static combine(collisionGroups) {
            const combinedName = collisionGroups.map((c)=>c.name).join("+");
            const combinedCategory = collisionGroups.reduce((current, g)=>g.category | current, 0);
            const combinedMask = ~combinedCategory;
            return CollisionGroupManager.create(combinedName, combinedMask);
        }
        /**
     * Creates a collision group that collides with the listed groups
     * @param collisionGroups
     */ static collidesWith(collisionGroups) {
            const combinedName = `collidesWith(${collisionGroups.map((c)=>c.name).join("+")})`;
            const combinedMask = collisionGroups.reduce((current, g)=>g.category | current, 0);
            return CollisionGroupManager.create(combinedName, combinedMask);
        }
        toString() {
            return `
category: ${this.category.toString(2).padStart(32, "0")}
mask:     ${(this.mask >>> 0).toString(2).padStart(32, "0")}
    `;
        }
    }
    /**
 * The `All` [[CollisionGroup]] is a special group that collides with all other groups including itself,
 * it is the default collision group on colliders.
 */ CollisionGroup.All = new CollisionGroup("Collide with all groups", -1, -1);
    /**
 * Models a potential collision between 2 colliders
 */ class Pair {
        constructor(colliderA, colliderB){
            this.colliderA = colliderA;
            this.colliderB = colliderB;
            this.id = null;
            this.id = Pair.calculatePairHash(colliderA.id, colliderB.id);
        }
        /**
     * Returns whether a it is allowed for 2 colliders in a Pair to collide
     * @param colliderA
     * @param colliderB
     */ static canCollide(colliderA, colliderB) {
            var _a, _b;
            const bodyA = (_a = colliderA === null || colliderA === void 0 ? void 0 : colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB === null || colliderB === void 0 ? void 0 : colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            // Prevent self collision
            if (colliderA.id === colliderB.id) return false;
            // Colliders with the same owner do not collide (composite colliders)
            if (colliderA.owner && colliderB.owner && colliderA.owner.id === colliderB.owner.id) return false;
            // if the pair has a member with zero dimension don't collide
            if (colliderA.localBounds.hasZeroDimensions() || colliderB.localBounds.hasZeroDimensions()) return false;
            // Body's needed for collision in the current state
            // TODO can we collide without a body?
            if (!bodyA || !bodyB) return false;
            // If both are in the same collision group short circuit
            if (!bodyA.group.canCollide(bodyB.group)) return false;
            // if both are fixed short circuit
            if (bodyA.collisionType === CollisionType.Fixed && bodyB.collisionType === CollisionType.Fixed) return false;
            // if the either is prevent collision short circuit
            if (bodyB.collisionType === CollisionType.PreventCollision || bodyA.collisionType === CollisionType.PreventCollision) return false;
            // if either is dead short circuit
            if (!bodyA.active || !bodyB.active) return false;
            return true;
        }
        /**
     * Returns whether or not it is possible for the pairs to collide
     */ get canCollide() {
            const colliderA = this.colliderA;
            const colliderB = this.colliderB;
            return Pair.canCollide(colliderA, colliderB);
        }
        /**
     * Runs the collision intersection logic on the members of this pair
     */ collide() {
            return this.colliderA.collide(this.colliderB);
        }
        /**
     * Check if the collider is part of the pair
     * @param collider
     */ hasCollider(collider) {
            return collider === this.colliderA || collider === this.colliderB;
        }
        /**
     * Calculates the unique pair hash id for this collision pair (owning id)
     */ static calculatePairHash(idA, idB) {
            if (idA.value < idB.value) return `#${idA.value}+${idB.value}`;
            else return `#${idB.value}+${idA.value}`;
        }
    }
    /**
 * A 1 dimensional projection on an axis, used to test overlaps
 */ class Projection {
        constructor(min, max){
            this.min = min;
            this.max = max;
        }
        overlaps(projection) {
            return this.max > projection.min && projection.max > this.min;
        }
        getOverlap(projection) {
            if (this.overlaps(projection)) {
                if (this.max > projection.max) return projection.max - this.min;
                else return this.max - projection.min;
            }
            return 0;
        }
    }
    /**
 * Dynamic Tree Node used for tracking bounds within the tree
 */ class TreeNode {
        constructor(parent){
            this.parent = parent;
            this.parent = parent || null;
            this.data = null;
            this.bounds = new BoundingBox();
            this.left = null;
            this.right = null;
            this.height = 0;
        }
        isLeaf() {
            return !this.left && !this.right;
        }
    }
    /**
 * The DynamicTrees provides a spatial partitioning data structure for quickly querying for overlapping bounding boxes for
 * all tracked bodies. The worst case performance of this is O(n*log(n)) where n is the number of bodies in the tree.
 *
 * Internally the bounding boxes are organized as a balanced binary tree of bounding boxes, where the leaf nodes are tracked bodies.
 * Every non-leaf node is a bounding box that contains child bounding boxes.
 */ class DynamicTree {
        constructor(_config, worldBounds = new BoundingBox(-Number.MAX_VALUE, -Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE)){
            this._config = _config;
            this.worldBounds = worldBounds;
            this.root = null;
            this.nodes = {};
        }
        /**
     * Inserts a node into the dynamic tree
     */ _insert(leaf) {
            // If there are no nodes in the tree, make this the root leaf
            if (this.root === null) {
                this.root = leaf;
                this.root.parent = null;
                return;
            }
            // Search the tree for a node that is not a leaf and find the best place to insert
            const leafAABB = leaf.bounds;
            let currentRoot = this.root;
            while(!currentRoot.isLeaf()){
                const left = currentRoot.left;
                const right = currentRoot.right;
                const area = currentRoot.bounds.getPerimeter();
                const combinedAABB = currentRoot.bounds.combine(leafAABB);
                const combinedArea = combinedAABB.getPerimeter();
                // Calculate cost heuristic for creating a new parent and leaf
                const cost = 2 * combinedArea;
                // Minimum cost of pushing the leaf down the tree
                const inheritanceCost = 2 * (combinedArea - area);
                // Cost of descending
                let leftCost = 0;
                const leftCombined = leafAABB.combine(left.bounds);
                let newArea;
                let oldArea;
                if (left.isLeaf()) leftCost = leftCombined.getPerimeter() + inheritanceCost;
                else {
                    oldArea = left.bounds.getPerimeter();
                    newArea = leftCombined.getPerimeter();
                    leftCost = newArea - oldArea + inheritanceCost;
                }
                let rightCost = 0;
                const rightCombined = leafAABB.combine(right.bounds);
                if (right.isLeaf()) rightCost = rightCombined.getPerimeter() + inheritanceCost;
                else {
                    oldArea = right.bounds.getPerimeter();
                    newArea = rightCombined.getPerimeter();
                    rightCost = newArea - oldArea + inheritanceCost;
                }
                // cost is acceptable
                if (cost < leftCost && cost < rightCost) break;
                // Descend to the depths
                if (leftCost < rightCost) currentRoot = left;
                else currentRoot = right;
            }
            // Create the new parent node and insert into the tree
            const oldParent = currentRoot.parent;
            const newParent = new TreeNode(oldParent);
            newParent.bounds = leafAABB.combine(currentRoot.bounds);
            newParent.height = currentRoot.height + 1;
            if (oldParent !== null) {
                // The sibling node was not the root
                if (oldParent.left === currentRoot) oldParent.left = newParent;
                else oldParent.right = newParent;
                newParent.left = currentRoot;
                newParent.right = leaf;
                currentRoot.parent = newParent;
                leaf.parent = newParent;
            } else {
                // The sibling node was the root
                newParent.left = currentRoot;
                newParent.right = leaf;
                currentRoot.parent = newParent;
                leaf.parent = newParent;
                this.root = newParent;
            }
            // Walk up the tree fixing heights and AABBs
            let currentNode = leaf.parent;
            while(currentNode){
                currentNode = this._balance(currentNode);
                if (!currentNode.left) throw new Error("Parent of current leaf cannot have a null left child" + currentNode);
                if (!currentNode.right) throw new Error("Parent of current leaf cannot have a null right child" + currentNode);
                currentNode.height = 1 + Math.max(currentNode.left.height, currentNode.right.height);
                currentNode.bounds = currentNode.left.bounds.combine(currentNode.right.bounds);
                currentNode = currentNode.parent;
            }
        }
        /**
     * Removes a node from the dynamic tree
     */ _remove(leaf) {
            if (leaf === this.root) {
                this.root = null;
                return;
            }
            const parent = leaf.parent;
            const grandParent = parent.parent;
            let sibling;
            if (parent.left === leaf) sibling = parent.right;
            else sibling = parent.left;
            if (grandParent) {
                if (grandParent.left === parent) grandParent.left = sibling;
                else grandParent.right = sibling;
                sibling.parent = grandParent;
                let currentNode = grandParent;
                while(currentNode){
                    currentNode = this._balance(currentNode);
                    currentNode.bounds = currentNode.left.bounds.combine(currentNode.right.bounds);
                    currentNode.height = 1 + Math.max(currentNode.left.height, currentNode.right.height);
                    currentNode = currentNode.parent;
                }
            } else {
                this.root = sibling;
                sibling.parent = null;
            }
        }
        /**
     * Tracks a body in the dynamic tree
     */ trackCollider(collider) {
            const node = new TreeNode();
            node.data = collider;
            node.bounds = collider.bounds;
            node.bounds.left -= 2;
            node.bounds.top -= 2;
            node.bounds.right += 2;
            node.bounds.bottom += 2;
            this.nodes[collider.id.value] = node;
            this._insert(node);
        }
        /**
     * Updates the dynamic tree given the current bounds of each body being tracked
     */ updateCollider(collider) {
            var _a;
            const node = this.nodes[collider.id.value];
            if (!node) return false;
            const b = collider.bounds;
            // if the body is outside the world no longer update it
            if (!this.worldBounds.contains(b)) {
                Logger.getInstance().warn("Collider with id " + collider.id.value + " is outside the world bounds and will no longer be tracked for physics");
                this.untrackCollider(collider);
                return false;
            }
            if (node.bounds.contains(b)) return false;
            this._remove(node);
            b.left -= this._config.boundsPadding;
            b.top -= this._config.boundsPadding;
            b.right += this._config.boundsPadding;
            b.bottom += this._config.boundsPadding;
            // THIS IS CAUSING UNNECESSARY CHECKS
            if (collider.owner) {
                const body = (_a = collider.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                if (body) {
                    const multdx = body.vel.x * 32 / 1000 * this._config.velocityMultiplier;
                    const multdy = body.vel.y * 32 / 1000 * this._config.velocityMultiplier;
                    if (multdx < 0) b.left += multdx;
                    else b.right += multdx;
                    if (multdy < 0) b.top += multdy;
                    else b.bottom += multdy;
                }
            }
            node.bounds = b;
            this._insert(node);
            return true;
        }
        /**
     * Untracks a body from the dynamic tree
     */ untrackCollider(collider) {
            const node = this.nodes[collider.id.value];
            if (!node) return;
            this._remove(node);
            this.nodes[collider.id.value] = null;
            delete this.nodes[collider.id.value];
        }
        /**
     * Balances the tree about a node
     */ _balance(node) {
            if (node === null) throw new Error("Cannot balance at null node");
            if (node.isLeaf() || node.height < 2) return node;
            const left = node.left;
            const right = node.right;
            const a = node;
            const b = left;
            const c = right;
            const d = left.left;
            const e = left.right;
            const f = right.left;
            const g = right.right;
            const balance = c.height - b.height;
            // Rotate c node up
            if (balance > 1) {
                // Swap the right node with it's parent
                c.left = a;
                c.parent = a.parent;
                a.parent = c;
                // The original node's old parent should point to the right node
                // this is mega confusing
                if (c.parent) {
                    if (c.parent.left === a) c.parent.left = c;
                    else c.parent.right = c;
                } else this.root = c;
                // Rotate
                if (f.height > g.height) {
                    c.right = f;
                    a.right = g;
                    g.parent = a;
                    a.bounds = b.bounds.combine(g.bounds);
                    c.bounds = a.bounds.combine(f.bounds);
                    a.height = 1 + Math.max(b.height, g.height);
                    c.height = 1 + Math.max(a.height, f.height);
                } else {
                    c.right = g;
                    a.right = f;
                    f.parent = a;
                    a.bounds = b.bounds.combine(f.bounds);
                    c.bounds = a.bounds.combine(g.bounds);
                    a.height = 1 + Math.max(b.height, f.height);
                    c.height = 1 + Math.max(a.height, g.height);
                }
                return c;
            }
            // Rotate left node up
            if (balance < -1) {
                // swap
                b.left = a;
                b.parent = a.parent;
                a.parent = b;
                // node's old parent should point to b
                if (b.parent) {
                    if (b.parent.left === a) b.parent.left = b;
                    else {
                        if (b.parent.right !== a) throw "Error rotating Dynamic Tree";
                        b.parent.right = b;
                    }
                } else this.root = b;
                // rotate
                if (d.height > e.height) {
                    b.right = d;
                    a.left = e;
                    e.parent = a;
                    a.bounds = c.bounds.combine(e.bounds);
                    b.bounds = a.bounds.combine(d.bounds);
                    a.height = 1 + Math.max(c.height, e.height);
                    b.height = 1 + Math.max(a.height, d.height);
                } else {
                    b.right = e;
                    a.left = d;
                    d.parent = a;
                    a.bounds = c.bounds.combine(d.bounds);
                    b.bounds = a.bounds.combine(e.bounds);
                    a.height = 1 + Math.max(c.height, d.height);
                    b.height = 1 + Math.max(a.height, e.height);
                }
                return b;
            }
            return node;
        }
        /**
     * Returns the internal height of the tree, shorter trees are better. Performance drops as the tree grows
     */ getHeight() {
            if (this.root === null) return 0;
            return this.root.height;
        }
        /**
     * Queries the Dynamic Axis Aligned Tree for bodies that could be colliding with the provided body.
     *
     * In the query callback, it will be passed a potential collider. Returning true from this callback indicates
     * that you are complete with your query and you do not want to continue. Returning false will continue searching
     * the tree until all possible colliders have been returned.
     */ query(collider, callback) {
            const bounds = collider.bounds;
            const helper = (currentNode)=>{
                if (currentNode && currentNode.bounds.overlaps(bounds)) {
                    if (currentNode.isLeaf() && currentNode.data !== collider) {
                        if (callback.call(collider, currentNode.data)) return true;
                    } else return helper(currentNode.left) || helper(currentNode.right);
                }
                return false;
            };
            helper(this.root);
        }
        /**
     * Queries the Dynamic Axis Aligned Tree for bodies that could be intersecting. By default the raycast query uses an infinitely
     * long ray to test the tree specified by `max`.
     *
     * In the query callback, it will be passed a potential body that intersects with the raycast. Returning true from this
     * callback indicates that your are complete with your query and do not want to continue. Return false will continue searching
     * the tree until all possible bodies that would intersect with the ray have been returned.
     */ rayCastQuery(ray, max = Infinity, callback) {
            const helper = (currentNode)=>{
                if (currentNode && currentNode.bounds.rayCast(ray, max)) {
                    if (currentNode.isLeaf()) {
                        if (callback.call(ray, currentNode.data)) // ray hit a leaf! return the body
                        return true;
                    } else // ray hit but not at a leaf, recurse deeper
                    return helper(currentNode.left) || helper(currentNode.right);
                }
                return false; // ray missed
            };
            helper(this.root);
        }
        getNodes() {
            const helper = (currentNode)=>{
                if (currentNode) return [
                    currentNode
                ].concat(helper(currentNode.left), helper(currentNode.right));
                else return [];
            };
            return helper(this.root);
        }
        debug(ex) {
            // draw all the nodes in the Dynamic Tree
            const helper = (currentNode)=>{
                if (currentNode) {
                    if (currentNode.isLeaf()) currentNode.bounds.draw(ex, Color.Green);
                    else currentNode.bounds.draw(ex, Color.White);
                    if (currentNode.left) helper(currentNode.left);
                    if (currentNode.right) helper(currentNode.right);
                }
            };
            helper(this.root);
        }
    }
    /**
 * A 2D ray that can be cast into the scene to do collision detection
 */ class Ray {
        /**
     * @param pos The starting position for the ray
     * @param dir The vector indicating the direction of the ray
     */ constructor(pos, dir){
            this.pos = pos;
            this.dir = dir.normalize();
        }
        /**
     * Tests a whether this ray intersects with a line segment. Returns a number greater than or equal to 0 on success.
     * This number indicates the mathematical intersection time.
     * @param line  The line to test
     */ intersect(line) {
            const numerator = line.begin.sub(this.pos);
            // Test is line and ray are parallel and non intersecting
            if (this.dir.cross(line.getSlope()) === 0 && numerator.cross(this.dir) !== 0) return -1;
            // Lines are parallel
            const divisor = this.dir.cross(line.getSlope());
            if (divisor === 0) return -1;
            const t = numerator.cross(line.getSlope()) / divisor;
            if (t >= 0) {
                const u = numerator.cross(this.dir) / divisor / line.getLength();
                if (u >= 0 && u <= 1) return t;
            }
            return -1;
        }
        intersectPoint(line) {
            const time = this.intersect(line);
            if (time < 0) return null;
            return this.getPoint(time);
        }
        /**
     * Returns the point of intersection given the intersection time
     */ getPoint(time) {
            return this.pos.add(this.dir.scale(time));
        }
    }
    /**
 * Responsible for performing the collision broadphase (locating potential collisions) and
 * the narrowphase (actual collision contacts)
 */ class DynamicTreeCollisionProcessor {
        constructor(_config){
            this._config = _config;
            this._pairs = new Set();
            this._collisionPairCache = [];
            this._colliders = [];
            this._dynamicCollisionTree = new DynamicTree(_config.dynamicTree);
        }
        getColliders() {
            return this._colliders;
        }
        rayCast(ray, options) {
            var _a, _b, _c;
            const results = [];
            const maxDistance = (_a = options === null || options === void 0 ? void 0 : options.maxDistance) !== null && _a !== void 0 ? _a : Infinity;
            const collisionGroup = options === null || options === void 0 ? void 0 : options.collisionGroup;
            const collisionMask = !collisionGroup ? (_b = options === null || options === void 0 ? void 0 : options.collisionMask) !== null && _b !== void 0 ? _b : CollisionGroup.All.category : collisionGroup.category;
            const searchAllColliders = (_c = options === null || options === void 0 ? void 0 : options.searchAllColliders) !== null && _c !== void 0 ? _c : false;
            this._dynamicCollisionTree.rayCastQuery(ray, maxDistance, (collider)=>{
                const owner = collider.owner;
                const maybeBody = owner.get(BodyComponent);
                if ((options === null || options === void 0 ? void 0 : options.ignoreCollisionGroupAll) && maybeBody.group === CollisionGroup.All) return false;
                const canCollide = (collisionMask & maybeBody.group.category) !== 0;
                // Early exit if not the right group
                if ((maybeBody === null || maybeBody === void 0 ? void 0 : maybeBody.group) && !canCollide) return false;
                const hit = collider.rayCast(ray, maxDistance);
                if (hit) {
                    if (options === null || options === void 0 ? void 0 : options.filter) {
                        if (options.filter(hit)) {
                            results.push(hit);
                            if (!searchAllColliders) // returning true exits the search
                            return true;
                        }
                    } else {
                        results.push(hit);
                        if (!searchAllColliders) // returning true exits the search
                        return true;
                    }
                }
                return false;
            });
            return results;
        }
        /**
     * Tracks a physics body for collisions
     */ track(target) {
            if (!target) {
                Logger.getInstance().warn("Cannot track null collider");
                return;
            }
            if (target instanceof CompositeCollider) {
                const colliders = target.getColliders();
                for (const c of colliders){
                    c.owner = target.owner;
                    this._colliders.push(c);
                    this._dynamicCollisionTree.trackCollider(c);
                }
            } else {
                this._colliders.push(target);
                this._dynamicCollisionTree.trackCollider(target);
            }
        }
        /**
     * Untracks a physics body
     */ untrack(target) {
            if (!target) {
                Logger.getInstance().warn("Cannot untrack a null collider");
                return;
            }
            if (target instanceof CompositeCollider) {
                const colliders = target.getColliders();
                for (const c of colliders){
                    const index = this._colliders.indexOf(c);
                    if (index !== -1) this._colliders.splice(index, 1);
                    this._dynamicCollisionTree.untrackCollider(c);
                }
            } else {
                const index = this._colliders.indexOf(target);
                if (index !== -1) this._colliders.splice(index, 1);
                this._dynamicCollisionTree.untrackCollider(target);
            }
        }
        _pairExists(colliderA, colliderB) {
            // if the collision pair has been calculated already short circuit
            const hash = Pair.calculatePairHash(colliderA.id, colliderB.id);
            return this._pairs.has(hash);
        }
        /**
     * Detects potential collision pairs in a broadphase approach with the dynamic AABB tree strategy
     */ broadphase(targets, delta, stats) {
            const seconds = delta / 1000;
            // Retrieve the list of potential colliders, exclude killed, prevented, and self
            const potentialColliders = targets.filter((other)=>{
                var _a, _b;
                const body = (_a = other.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                return ((_b = other.owner) === null || _b === void 0 ? void 0 : _b.active) && body.collisionType !== CollisionType.PreventCollision;
            });
            // clear old list of collision pairs
            this._collisionPairCache = [];
            this._pairs.clear();
            // check for normal collision pairs
            let collider;
            for(let j = 0, l = potentialColliders.length; j < l; j++){
                collider = potentialColliders[j];
                // Query the collision tree for potential colliders
                this._dynamicCollisionTree.query(collider, (other)=>{
                    if (!this._pairExists(collider, other) && Pair.canCollide(collider, other)) {
                        const pair = new Pair(collider, other);
                        this._pairs.add(pair.id);
                        this._collisionPairCache.push(pair);
                    }
                    // Always return false, to query whole tree. Returning true in the query method stops searching
                    return false;
                });
            }
            if (stats) stats.physics.pairs = this._collisionPairCache.length;
            // Check dynamic tree for fast moving objects
            // Fast moving objects are those moving at least there smallest bound per frame
            if (this._config.continuous.checkForFastBodies) for (const collider of potentialColliders){
                const body = collider.owner.get(BodyComponent);
                // Skip non-active objects. Does not make sense on other collision types
                if (body.collisionType !== CollisionType.Active) continue;
                // Maximum travel distance next frame
                const updateDistance = body.vel.size * seconds + // velocity term
                body.acc.size * 0.5 * seconds * seconds; // acc term
                // Find the minimum dimension
                const minDimension = Math.min(collider.bounds.height, collider.bounds.width);
                if (this._config.continuous.disableMinimumSpeedForFastBody || updateDistance > minDimension / 2) {
                    if (stats) stats.physics.fastBodies++;
                    // start with the oldPos because the integration for actors has already happened
                    // objects resting on a surface may be slightly penetrating in the current position
                    const updateVec = body.globalPos.sub(body.oldPos);
                    const centerPoint = collider.center;
                    const furthestPoint = collider.getFurthestPoint(body.vel);
                    const origin = furthestPoint.sub(updateVec);
                    const ray = new Ray(origin, body.vel);
                    // back the ray up by -2x surfaceEpsilon to account for fast moving objects starting on the surface
                    ray.pos = ray.pos.add(ray.dir.scale(-2 * this._config.continuous.surfaceEpsilon));
                    let minCollider;
                    let minTranslate = new Vector(Infinity, Infinity);
                    this._dynamicCollisionTree.rayCastQuery(ray, updateDistance + this._config.continuous.surfaceEpsilon * 2, (other)=>{
                        if (!this._pairExists(collider, other) && Pair.canCollide(collider, other)) {
                            const hit = other.rayCast(ray, updateDistance + this._config.continuous.surfaceEpsilon * 10);
                            if (hit) {
                                const translate = hit.point.sub(origin);
                                if (translate.size < minTranslate.size) {
                                    minTranslate = translate;
                                    minCollider = other;
                                }
                            }
                        }
                        return false;
                    });
                    if (minCollider && Vector.isValid(minTranslate)) {
                        const pair = new Pair(collider, minCollider);
                        if (!this._pairs.has(pair.id)) {
                            this._pairs.add(pair.id);
                            this._collisionPairCache.push(pair);
                        }
                        // move the fast moving object to the other body
                        // need to push into the surface by ex.Physics.surfaceEpsilon
                        const shift = centerPoint.sub(furthestPoint);
                        body.globalPos = origin.add(shift).add(minTranslate).add(ray.dir.scale(10 * this._config.continuous.surfaceEpsilon)); // needed to push the shape slightly into contact
                        collider.update(body.transform.get());
                        if (stats) stats.physics.fastBodyCollisions++;
                    }
                }
            }
            // return cache
            return this._collisionPairCache;
        }
        /**
     * Applies narrow phase on collision pairs to find actual area intersections
     * Adds actual colliding pairs to stats' Frame data
     */ narrowphase(pairs, stats) {
            let contacts = [];
            for(let i = 0; i < pairs.length; i++){
                const newContacts = pairs[i].collide();
                contacts = contacts.concat(newContacts);
                if (stats && newContacts.length > 0) for (const c of newContacts)stats.physics.contacts.set(c.id, c);
            }
            if (stats) stats.physics.collisions += contacts.length;
            return contacts;
        }
        /**
     * Update the dynamic tree positions
     */ update(targets) {
            let updated = 0;
            const len = targets.length;
            for(let i = 0; i < len; i++)if (this._dynamicCollisionTree.updateCollider(targets[i])) updated++;
            return updated;
        }
        debug(ex) {
            this._dynamicCollisionTree.debug(ex);
        }
    }
    /**
 * A collision collider specifies the geometry that can detect when other collision colliders intersect
 * for the purposes of colliding 2 objects in excalibur.
 */ class Collider {
        constructor(){
            this.id = createId("collider", Collider._ID++);
            /**
         * Composite collider if any this collider is attached to
         *
         * **WARNING** do not tamper with this property
         */ this.composite = null;
            this.events = new EventEmitter();
            /**
         * Pixel offset of the collision collider relative to the collider, by default (0, 0) meaning the collider is positioned
         * on top of the collider.
         */ this.offset = Vector.Zero;
        }
        /**
     * Returns a boolean indicating whether this body collided with
     * or was in stationary contact with
     * the body of the other [[Collider]]
     */ touching(other) {
            const contact = this.collide(other);
            if (contact) return true;
            return false;
        }
    }
    Collider._ID = 0;
    /**
 * Possible collision resolution strategies
 *
 * The default is [[SolverStrategy.Arcade]] which performs simple axis aligned arcade style physics. This is useful for things
 * like platformers or top down games.
 *
 * More advanced rigid body physics are enabled by setting [[SolverStrategy.Realistic]] which allows for complicated
 * simulated physical interactions.
 */ var SolverStrategy;
    (function(SolverStrategy) {
        SolverStrategy["Arcade"] = "arcade";
        SolverStrategy["Realistic"] = "realistic";
    })(SolverStrategy || (SolverStrategy = {}));
    /**
 * Possible broadphase collision pair identification strategies
 *
 * The default strategy is [[BroadphaseStrategy.DynamicAABBTree]] which uses a binary tree of axis-aligned bounding boxes to identify
 * potential collision pairs which is O(nlog(n)) faster.
 * @deprecated Unused in Excalibur, will be removed in v0.30
 */ var BroadphaseStrategy;
    (function(BroadphaseStrategy) {
        BroadphaseStrategy[BroadphaseStrategy["DynamicAABBTree"] = 0] = "DynamicAABBTree";
    })(BroadphaseStrategy || (BroadphaseStrategy = {}));
    /**
 * Possible numerical integrators for position and velocity
 * @deprecated Unused in Excalibur, will be removed in v0.30
 */ var Integrator;
    (function(Integrator) {
        Integrator[Integrator["Euler"] = 0] = "Euler";
    })(Integrator || (Integrator = {}));
    /**
 * The [[Physics]] object is the global configuration object for all Excalibur physics.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ /* istanbul ignore next */ class Physics {
        /**
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static get gravity() {
            return Physics.acc;
        }
        static set gravity(v) {
            Physics.acc = v;
        }
        /**
     * Configures Excalibur to use "arcade" physics. Arcade physics which performs simple axis aligned arcade style physics.
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static useArcadePhysics() {
            Physics.collisionResolutionStrategy = SolverStrategy.Arcade;
        }
        /**
     * Configures Excalibur to use rigid body physics. Rigid body physics allows for complicated
     * simulated physical interactions.
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static useRealisticPhysics() {
            Physics.collisionResolutionStrategy = SolverStrategy.Realistic;
        }
    }
    /**
 * Global acceleration that is applied to all vanilla actors that have a [[CollisionType.Active|active]] collision type.
 * Global acceleration won't effect [[Label|labels]], [[ScreenElement|ui actors]], or [[Trigger|triggers]] in Excalibur.
 *
 * This is a great way to globally simulate effects like gravity.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.acc = new Vector(0, 0);
    /**
 * Globally switches all Excalibur physics behavior on or off.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.enabled = true;
    /**
 * Gets or sets the broadphase pair identification strategy.
 *
 * The default strategy is [[BroadphaseStrategy.DynamicAABBTree]] which uses a binary tree of axis-aligned bounding boxes to identify
 * potential collision pairs which is O(nlog(n)) faster.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.broadphaseStrategy = BroadphaseStrategy.DynamicAABBTree;
    /**
 * Gets or sets the global collision resolution strategy (narrowphase).
 *
 * The default is [[SolverStrategy.Arcade]] which performs simple axis aligned arcade style physics.
 *
 * More advanced rigid body physics are enabled by setting [[SolverStrategy.Realistic]] which allows for complicated
 * simulated physical interactions.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.collisionResolutionStrategy = SolverStrategy.Arcade;
    /**
 * The default mass to use if none is specified
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.defaultMass = 10;
    /**
 * Gets or sets the position and velocity positional integrator, currently only Euler is supported.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.integrator = Integrator.Euler;
    /**
 * Factor to add to the RigidBody BoundingBox, bounding box (dimensions += vel * dynamicTreeVelocityMultiplier);
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.dynamicTreeVelocityMultiplier = 2;
    /**
 * Pad RigidBody BoundingBox by a constant amount
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.boundsPadding = 5;
    /**
 * Number of position iterations (overlap) to run in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.positionIterations = 3;
    /**
 * Number of velocity iteration (response) to run in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.velocityIterations = 8;
    /**
 * Amount of overlap to tolerate in pixels
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.slop = 1;
    /**
 * Amount of positional overlap correction to apply each position iteration of the solver
 * O - meaning no correction, 1 - meaning correct all overlap
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.steeringFactor = 0.2;
    /**
 * Warm start set to true re-uses impulses from previous frames back in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.warmStart = true;
    /**
 * By default bodies do not sleep
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.bodiesCanSleepByDefault = false;
    /**
 * Surface epsilon is used to help deal with surface penetration
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.surfaceEpsilon = 0.1;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.sleepEpsilon = 0.07;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.wakeThreshold = Physics.sleepEpsilon * 3;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.sleepBias = 0.9;
    /**
 * Enable fast moving body checking, this enables checking for collision pairs via raycast for fast moving objects to prevent
 * bodies from tunneling through one another.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.checkForFastBodies = true;
    /**
 * Disable minimum fast moving body raycast, by default if ex.Physics.checkForFastBodies = true Excalibur will only check if the
 * body is moving at least half of its minimum dimension in an update. If ex.Physics.disableMinimumSpeedForFastBody is set to true,
 * Excalibur will always perform the fast body raycast regardless of speed.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.disableMinimumSpeedForFastBody = false;
    /**
 * Tells the Arcade collision solver to prefer certain contacts over others
 */ var ContactSolveBias;
    (function(ContactSolveBias) {
        ContactSolveBias["None"] = "none";
        ContactSolveBias["VerticalFirst"] = "vertical-first";
        ContactSolveBias["HorizontalFirst"] = "horizontal-first";
    })(ContactSolveBias || (ContactSolveBias = {}));
    /**
 * Vertical First contact solve bias Used by the [[ArcadeSolver]] to sort contacts
 */ const VerticalFirst = {
        "vertical": 1,
        "horizontal": 2
    };
    /**
 * Horizontal First contact solve bias Used by the [[ArcadeSolver]] to sort contacts
 */ const HorizontalFirst = {
        "horizontal": 1,
        "vertical": 2
    };
    /**
 * None value, [[ArcadeSolver]] sorts contacts using distance by default
 */ const None = {
        "horizontal": 0,
        "vertical": 0
    };
    const DefaultPhysicsConfig = {
        enabled: true,
        gravity: vec(0, 0),
        solver: SolverStrategy.Arcade,
        colliders: {
            compositeStrategy: "together"
        },
        continuous: {
            checkForFastBodies: true,
            disableMinimumSpeedForFastBody: false,
            surfaceEpsilon: 0.1
        },
        bodies: {
            canSleepByDefault: false,
            sleepEpsilon: 0.07,
            wakeThreshold: 0.07 * 3,
            sleepBias: 0.9,
            defaultMass: 10
        },
        dynamicTree: {
            boundsPadding: 5,
            velocityMultiplier: 2
        },
        arcade: {
            contactSolveBias: ContactSolveBias.None
        },
        realistic: {
            positionIterations: 3,
            velocityIterations: 8,
            slop: 1,
            steeringFactor: 0.2,
            warmStart: true
        }
    };
    /**
 * @deprecated will be removed in v0.30
 */ function DeprecatedStaticToConfig() {
        return {
            enabled: Physics.enabled,
            gravity: Physics.gravity,
            solver: Physics.collisionResolutionStrategy,
            continuous: {
                checkForFastBodies: Physics.checkForFastBodies,
                disableMinimumSpeedForFastBody: Physics.disableMinimumSpeedForFastBody,
                surfaceEpsilon: Physics.surfaceEpsilon
            },
            colliders: {
                compositeStrategy: "together"
            },
            bodies: {
                canSleepByDefault: Physics.bodiesCanSleepByDefault,
                sleepEpsilon: Physics.sleepEpsilon,
                wakeThreshold: Physics.wakeThreshold,
                sleepBias: Physics.sleepBias,
                defaultMass: Physics.defaultMass
            },
            dynamicTree: {
                boundsPadding: Physics.boundsPadding,
                velocityMultiplier: Physics.dynamicTreeVelocityMultiplier
            },
            arcade: {
                contactSolveBias: ContactSolveBias.None
            },
            realistic: {
                positionIterations: Physics.positionIterations,
                velocityIterations: Physics.velocityIterations,
                slop: Physics.slop,
                steeringFactor: Physics.steeringFactor,
                warmStart: Physics.warmStart
            }
        };
    }
    class CompositeCollider extends Collider {
        /**
     * Treat composite collider's member colliders as either separate colliders for the purposes of onCollisionStart/onCollision
     * or as a single collider together.
     *
     * This property can be overridden on individual [[CompositeColliders]].
     *
     * For composites without gaps or small groups of colliders, you probably want 'together'
     *
     * For composites with deliberate gaps, like a platforming level layout, you probably want 'separate'
     *
     * Default is 'together' if unset
     */ set compositeStrategy(value) {
            this._compositeStrategy = value;
        }
        get compositeStrategy() {
            return this._compositeStrategy;
        }
        constructor(colliders){
            super();
            this._collisionProcessor = new DynamicTreeCollisionProcessor(DefaultPhysicsConfig);
            this._dynamicAABBTree = new DynamicTree(DefaultPhysicsConfig.dynamicTree);
            this._colliders = [];
            for (const c of colliders)this.addCollider(c);
        }
        clearColliders() {
            this._colliders = [];
        }
        addCollider(collider) {
            let colliders;
            if (collider instanceof CompositeCollider) {
                colliders = collider.getColliders();
                colliders.forEach((c)=>c.offset.addEqual(collider.offset));
            } else colliders = [
                collider
            ];
            // Flatten composites
            for (const c of colliders){
                c.events.pipe(this.events);
                c.composite = this;
                this._colliders.push(c);
                this._collisionProcessor.track(c);
                this._dynamicAABBTree.trackCollider(c);
            }
        }
        removeCollider(collider) {
            collider.events.pipe(this.events);
            collider.composite = null;
            removeItemFromArray(collider, this._colliders);
            this._collisionProcessor.untrack(collider);
            this._dynamicAABBTree.untrackCollider(collider);
        }
        getColliders() {
            return this._colliders;
        }
        get worldPos() {
            var _a, _b;
            return ((_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : Vector.Zero).add(this.offset);
        }
        get center() {
            var _a, _b;
            return ((_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : Vector.Zero).add(this.offset);
        }
        get bounds() {
            var _a, _b;
            // TODO cache this
            const colliders = this.getColliders();
            const results = colliders.reduce((acc, collider)=>acc.combine(collider.bounds), (_b = (_a = colliders[0]) === null || _a === void 0 ? void 0 : _a.bounds) !== null && _b !== void 0 ? _b : new BoundingBox().translate(this.worldPos));
            return results.translate(this.offset);
        }
        get localBounds() {
            var _a, _b;
            // TODO cache this
            const colliders = this.getColliders();
            const results = colliders.reduce((acc, collider)=>acc.combine(collider.localBounds), (_b = (_a = colliders[0]) === null || _a === void 0 ? void 0 : _a.localBounds) !== null && _b !== void 0 ? _b : new BoundingBox());
            return results;
        }
        get axes() {
            // TODO cache this
            const colliders = this.getColliders();
            let axes = [];
            for (const collider of colliders)axes = axes.concat(collider.axes);
            return axes;
        }
        getFurthestPoint(direction) {
            const colliders = this.getColliders();
            const furthestPoints = [];
            for (const collider of colliders)furthestPoints.push(collider.getFurthestPoint(direction));
            // Pick best point from all colliders
            let bestPoint = furthestPoints[0];
            let maxDistance = -Number.MAX_VALUE;
            for (const point of furthestPoints){
                const distance = point.dot(direction);
                if (distance > maxDistance) {
                    bestPoint = point;
                    maxDistance = distance;
                }
            }
            return bestPoint;
        }
        getInertia(mass) {
            const colliders = this.getColliders();
            let totalInertia = 0;
            for (const collider of colliders)totalInertia += collider.getInertia(mass);
            return totalInertia;
        }
        collide(other) {
            let otherColliders = [
                other
            ];
            if (other instanceof CompositeCollider) otherColliders = other.getColliders();
            const pairs = [];
            for (const c of otherColliders)this._dynamicAABBTree.query(c, (potentialCollider)=>{
                pairs.push(new Pair(c, potentialCollider));
                return false;
            });
            let contacts = [];
            for (const p of pairs)contacts = contacts.concat(p.collide());
            return contacts;
        }
        getClosestLineBetween(other) {
            const colliders = this.getColliders();
            const lines = [];
            if (other instanceof CompositeCollider) {
                const otherColliders = other.getColliders();
                for (const colliderA of colliders)for (const colliderB of otherColliders){
                    const maybeLine = colliderA.getClosestLineBetween(colliderB);
                    if (maybeLine) lines.push(maybeLine);
                }
            } else for (const collider of colliders){
                const maybeLine = other.getClosestLineBetween(collider);
                if (maybeLine) lines.push(maybeLine);
            }
            if (lines.length) {
                let minLength = lines[0].getLength();
                let minLine = lines[0];
                for (const line of lines){
                    const length = line.getLength();
                    if (length < minLength) {
                        minLength = length;
                        minLine = line;
                    }
                }
                return minLine;
            }
            return null;
        }
        contains(point) {
            const colliders = this.getColliders();
            for (const collider of colliders){
                if (collider.contains(point)) return true;
            }
            return false;
        }
        rayCast(ray, max) {
            const colliders = this.getColliders();
            const hits = [];
            for (const collider of colliders){
                const hit = collider.rayCast(ray, max);
                if (hit) hits.push(hit);
            }
            if (hits.length) {
                let minHit = hits[0];
                let minDistance = minHit.point.dot(ray.dir);
                for (const hit of hits){
                    const distance = ray.dir.dot(hit.point);
                    if (distance < minDistance) {
                        minHit = hit;
                        minDistance = distance;
                    }
                }
                return minHit;
            }
            return null;
        }
        project(axis) {
            const colliders = this.getColliders();
            const projections = [];
            for (const collider of colliders){
                const proj = collider.project(axis);
                if (proj) projections.push(proj);
            }
            // Merge all proj's on the same axis
            if (projections.length) {
                const newProjection = new Projection(projections[0].min, projections[0].max);
                for (const proj of projections){
                    newProjection.min = Math.min(proj.min, newProjection.min);
                    newProjection.max = Math.max(proj.max, newProjection.max);
                }
                return newProjection;
            }
            return null;
        }
        update(transform) {
            if (transform) {
                const colliders = this.getColliders();
                for (const collider of colliders){
                    collider.owner = this.owner;
                    collider.update(transform);
                }
            }
        }
        debug(ex, color, options) {
            const colliders = this.getColliders();
            ex.save();
            ex.translate(this.offset.x, this.offset.y);
            for (const collider of colliders)collider.debug(ex, color, options);
            ex.restore();
        }
        clone() {
            const result = new CompositeCollider(this._colliders.map((c)=>c.clone()));
            result.offset = this.offset.clone();
            return result;
        }
    }
    /**
 * A 2D line segment
 */ class LineSegment {
        /**
     * @param begin  The starting point of the line segment
     * @param end  The ending point of the line segment
     */ constructor(begin, end){
            this.begin = begin;
            this.end = end;
        }
        /**
     * Gets the raw slope (m) of the line. Will return (+/-)Infinity for vertical lines.
     */ get slope() {
            return (this.end.y - this.begin.y) / (this.end.x - this.begin.x);
        }
        /**
     * Gets the Y-intercept (b) of the line. Will return (+/-)Infinity if there is no intercept.
     */ get intercept() {
            return this.begin.y - this.slope * this.begin.x;
        }
        /**
     * Gets the normal of the line
     */ normal() {
            if (this._normal) return this._normal;
            return this._normal = this.end.sub(this.begin).normal();
        }
        dir() {
            if (this._dir) return this._dir;
            return this._dir = this.end.sub(this.begin);
        }
        getPoints() {
            return [
                this.begin,
                this.end
            ];
        }
        /**
     * Returns the slope of the line in the form of a vector of length 1
     */ getSlope() {
            if (this._slope) return this._slope;
            const begin = this.begin;
            const end = this.end;
            const distance = begin.distance(end);
            return this._slope = end.sub(begin).scale(1 / distance);
        }
        /**
     * Returns the edge of the line as vector, the length of the vector is the length of the edge
     */ getEdge() {
            const begin = this.begin;
            const end = this.end;
            return end.sub(begin);
        }
        /**
     * Returns the length of the line segment in pixels
     */ getLength() {
            if (this._length) return this._length;
            const begin = this.begin;
            const end = this.end;
            const distance = begin.distance(end);
            return this._length = distance;
        }
        /**
     * Returns the midpoint of the edge
     */ get midpoint() {
            return this.begin.add(this.end).scale(0.5);
        }
        /**
     * Flips the direction of the line segment
     */ flip() {
            return new LineSegment(this.end, this.begin);
        }
        /**
     * Tests if a given point is below the line, points in the normal direction above the line are considered above.
     * @param point
     */ below(point) {
            const above2 = (this.end.x - this.begin.x) * (point.y - this.begin.y) - (this.end.y - this.begin.y) * (point.x - this.begin.x);
            return above2 >= 0;
        }
        /**
     * Returns the clip point
     * @param sideVector Vector that traces the line
     * @param length Length to clip along side
     */ clip(sideVector, length) {
            let dir = sideVector;
            dir = dir.normalize();
            const near = dir.dot(this.begin) - length;
            const far = dir.dot(this.end) - length;
            const results = [];
            if (near <= 0) results.push(this.begin);
            if (far <= 0) results.push(this.end);
            if (near * far < 0) {
                const clipTime = near / (near - far);
                results.push(this.begin.add(this.end.sub(this.begin).scale(clipTime)));
            }
            if (results.length !== 2) return null;
            return new LineSegment(results[0], results[1]);
        }
        /**
     * Find the perpendicular distance from the line to a point
     * https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
     * @param point
     */ distanceToPoint(point, signed = false) {
            const x0 = point.x;
            const y0 = point.y;
            const l = this.getLength();
            const dy = this.end.y - this.begin.y;
            const dx = this.end.x - this.begin.x;
            const distance = (dy * x0 - dx * y0 + this.end.x * this.begin.y - this.end.y * this.begin.x) / l;
            return signed ? distance : Math.abs(distance);
        }
        /**
     * Find the perpendicular line from the line to a point
     * https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
     * (a - p) - ((a - p) * n)n
     * a is a point on the line
     * p is the arbitrary point above the line
     * n is a unit vector in direction of the line
     * @param point
     */ findVectorToPoint(point) {
            const aMinusP = this.begin.sub(point);
            const n = this.getSlope();
            return aMinusP.sub(n.scale(aMinusP.dot(n)));
        }
        /**
     * Finds a point on the line given only an X or a Y value. Given an X value, the function returns
     * a new point with the calculated Y value and vice-versa.
     * @param x The known X value of the target point
     * @param y The known Y value of the target point
     * @returns A new point with the other calculated axis value
     */ findPoint(x = null, y = null) {
            const m = this.slope;
            const b = this.intercept;
            if (x !== null) return new Vector(x, m * x + b);
            else if (y !== null) return new Vector((y - b) / m, y);
            else throw new Error("You must provide an X or a Y value");
        }
        /**
     * @see http://stackoverflow.com/a/11908158/109458
     */ hasPoint() {
            let currPoint;
            let threshold = 0;
            if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
                currPoint = new Vector(arguments[0], arguments[1]);
                threshold = arguments[2] || 0;
            } else if (arguments[0] instanceof Vector) {
                currPoint = arguments[0];
                threshold = arguments[1] || 0;
            } else throw "Could not determine the arguments for Vector.hasPoint";
            const dxc = currPoint.x - this.begin.x;
            const dyc = currPoint.y - this.begin.y;
            const dx1 = this.end.x - this.begin.x;
            const dy1 = this.end.y - this.begin.y;
            const cross = dxc * dy1 - dyc * dx1;
            // check whether point lines on the line
            if (Math.abs(cross) > threshold) return false;
            // check whether point lies in-between start and end
            if (Math.abs(dx1) >= Math.abs(dy1)) return dx1 > 0 ? this.begin.x <= currPoint.x && currPoint.x <= this.end.x : this.end.x <= currPoint.x && currPoint.x <= this.begin.x;
            else return dy1 > 0 ? this.begin.y <= currPoint.y && currPoint.y <= this.end.y : this.end.y <= currPoint.y && currPoint.y <= this.begin.y;
        }
    }
    /**
 * Finds the closes line between 2 line segments, were the magnitude of u, v are the lengths of each segment
 * L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
 * L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
 * @param p0 Point where L1 begins
 * @param u Direction and length of L1
 * @param q0 Point were L2 begins
 * @param v Direction and length of L2
 */ function ClosestLine(p0, u, q0, v) {
        // Distance between 2 lines http://geomalgorithms.com/a07-_distance.html
        // w(s, t) = P(s) - Q(t)
        // The w(s, t) that has the minimum distance we will say is w(sClosest, tClosest) = wClosest
        //
        // wClosest is the vector that is uniquely perpendicular to the 2 line directions u & v.
        // wClosest = w0 + sClosest * u - tClosest * v, where w0 is p0 - q0
        //
        // The closest point between 2 lines then satisfies this pair of equations
        // 1: u * wClosest = 0
        // 2: v * wClosest = 0
        //
        // Substituting wClosest into the equations we get
        //
        // 1: (u * u) * sClosest - (u * v) tClosest = -u * w0
        // 2: (v * u) * sClosest - (v * v) tClosest = -v * w0
        // simplify w0
        const w0 = p0.sub(q0);
        // simplify (u * u);
        const a = u.dot(u);
        // simplify (u * v);
        const b = u.dot(v);
        // simplify (v * v)
        const c = v.dot(v);
        // simplify (u * w0)
        const d = u.dot(w0);
        // simplify (v * w0)
        const e = v.dot(w0);
        // denominator ac - b^2
        const denom = a * c - b * b;
        let sDenom = denom;
        let tDenom = denom;
        // if denom is 0 they are parallel, use any point from either as the start in this case p0
        if (denom === 0 || denom <= 0.01) {
            const tClosestParallel = d / b;
            return new LineSegment(p0, q0.add(v.scale(tClosestParallel)));
        }
        // Solve for sClosest for infinite line
        let sClosest = b * e - c * d; // / denom;
        // Solve for tClosest for infinite line
        let tClosest = a * e - b * d; // / denom;
        // Solve for segments candidate edges, if sClosest and tClosest are outside their segments
        if (sClosest < 0) {
            sClosest = 0;
            tClosest = e;
            tDenom = c;
        } else if (sClosest > sDenom) {
            sClosest = sDenom;
            tClosest = e + b;
            tDenom = c;
        }
        if (tClosest < 0) {
            tClosest = 0;
            if (-d < 0) sClosest = 0;
            else if (-d > a) sClosest = sDenom;
            else {
                sClosest = -d;
                sDenom = a;
            }
        } else if (tClosest > tDenom) {
            tClosest = tDenom;
            if (-d + b < 0) sClosest = 0;
            else if (-d + b > a) sClosest = sDenom;
            else {
                sClosest = -d + b;
                sDenom = a;
            }
        }
        sClosest = Math.abs(sClosest) < 0.001 ? 0 : sClosest / sDenom;
        tClosest = Math.abs(tClosest) < 0.001 ? 0 : tClosest / tDenom;
        return new LineSegment(p0.add(u.scale(sClosest)), q0.add(v.scale(tClosest)));
    }
    const ClosestLineJumpTable = {
        PolygonPolygonClosestLine (polygonA, polygonB) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = polygonB.worldPos;
            const otherDirection = otherWorldPos.sub(polygonA.worldPos);
            const thisDirection = otherDirection.negate();
            const rayTowardsOther = new Ray(polygonA.worldPos, otherDirection);
            const rayTowardsThis = new Ray(otherWorldPos, thisDirection);
            const thisPoint = polygonA.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const otherPoint = polygonB.rayCast(rayTowardsThis).point.add(rayTowardsThis.dir.scale(0.1));
            const thisFace = polygonA.getClosestFace(thisPoint);
            const otherFace = polygonB.getClosestFace(otherPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const q0 = otherFace.face.begin;
            const v = otherFace.face.getEdge();
            return ClosestLine(p0, u, q0, v);
        },
        PolygonEdgeClosestLine (polygon, edge) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = edge.worldPos;
            const otherDirection = otherWorldPos.sub(polygon.worldPos);
            const rayTowardsOther = new Ray(polygon.worldPos, otherDirection);
            const thisPoint = polygon.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const thisFace = polygon.getClosestFace(thisPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const edgeLine = edge.asLine();
            const edgeStart = edgeLine.begin;
            const edgeVector = edgeLine.getEdge();
            const q0 = edgeStart;
            const v = edgeVector;
            return ClosestLine(p0, u, q0, v);
        },
        PolygonCircleClosestLine (polygon, circle) {
            // https://math.stackexchange.com/questions/1919177/how-to-find-point-on-line-closest-to-sphere
            // Find the 2 closest faces on each polygon
            const otherWorldPos = circle.worldPos;
            const otherDirection = otherWorldPos.sub(polygon.worldPos);
            const rayTowardsOther = new Ray(polygon.worldPos, otherDirection.normalize());
            const thisPoint = polygon.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const thisFace = polygon.getClosestFace(thisPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // Time of minimum distance
            let t = (u.x * (otherWorldPos.x - p0.x) + u.y * (otherWorldPos.y - p0.y)) / (u.x * u.x + u.y * u.y);
            // If time of minimum is past the edge clamp
            if (t > 1) t = 1;
            else if (t < 0) t = 0;
            // Minimum distance
            const d = Math.sqrt(Math.pow(p0.x + u.x * t - otherWorldPos.x, 2) + Math.pow(p0.y + u.y * t - otherWorldPos.y, 2)) - circle.radius;
            const circlex = (p0.x + u.x * t - otherWorldPos.x) * circle.radius / (circle.radius + d);
            const circley = (p0.y + u.y * t - otherWorldPos.y) * circle.radius / (circle.radius + d);
            return new LineSegment(u.scale(t).add(p0), new Vector(otherWorldPos.x + circlex, otherWorldPos.y + circley));
        },
        CircleCircleClosestLine (circleA, circleB) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = circleB.worldPos;
            const otherDirection = otherWorldPos.sub(circleA.worldPos);
            const thisWorldPos = circleA.worldPos;
            const thisDirection = thisWorldPos.sub(circleB.worldPos);
            const rayTowardsOther = new Ray(circleA.worldPos, otherDirection);
            const rayTowardsThis = new Ray(circleB.worldPos, thisDirection);
            const thisPoint = circleA.rayCast(rayTowardsOther);
            const otherPoint = circleB.rayCast(rayTowardsThis);
            return new LineSegment(thisPoint.point, otherPoint.point);
        },
        CircleEdgeClosestLine (circle, edge) {
            // https://math.stackexchange.com/questions/1919177/how-to-find-point-on-line-closest-to-sphere
            const circleWorldPos = circle.worldPos;
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const edgeLine = edge.asLine();
            const edgeStart = edgeLine.begin;
            const edgeVector = edgeLine.getEdge();
            const p0 = edgeStart;
            const u = edgeVector;
            // Time of minimum distance
            let t = (u.x * (circleWorldPos.x - p0.x) + u.y * (circleWorldPos.y - p0.y)) / (u.x * u.x + u.y * u.y);
            // If time of minimum is past the edge clamp to edge
            if (t > 1) t = 1;
            else if (t < 0) t = 0;
            // Minimum distance
            const d = Math.sqrt(Math.pow(p0.x + u.x * t - circleWorldPos.x, 2) + Math.pow(p0.y + u.y * t - circleWorldPos.y, 2)) - circle.radius;
            const circlex = (p0.x + u.x * t - circleWorldPos.x) * circle.radius / (circle.radius + d);
            const circley = (p0.y + u.y * t - circleWorldPos.y) * circle.radius / (circle.radius + d);
            return new LineSegment(u.scale(t).add(p0), new Vector(circleWorldPos.x + circlex, circleWorldPos.y + circley));
        },
        EdgeEdgeClosestLine (edgeA, edgeB) {
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const edgeLineA = edgeA.asLine();
            const edgeStartA = edgeLineA.begin;
            const edgeVectorA = edgeLineA.getEdge();
            const p0 = edgeStartA;
            const u = edgeVectorA;
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const edgeLineB = edgeB.asLine();
            const edgeStartB = edgeLineB.begin;
            const edgeVectorB = edgeLineB.getEdge();
            const q0 = edgeStartB;
            const v = edgeVectorB;
            return ClosestLine(p0, u, q0, v);
        }
    };
    /**
 * This is a circle collider for the excalibur rigid body physics simulation
 */ class CircleCollider extends Collider {
        get worldPos() {
            return this._globalMatrix.getPosition();
        }
        /**
     * Get the radius of the circle
     */ get radius() {
            var _a;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            // This is a trade off, the alternative is retooling circles to support ellipse collisions
            return this._naturalRadius * Math.min(scale.x, scale.y);
        }
        /**
     * Set the radius of the circle
     */ set radius(val) {
            var _a;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            // This is a trade off, the alternative is retooling circles to support ellipse collisions
            this._naturalRadius = val / Math.min(scale.x, scale.y);
        }
        constructor(options){
            super();
            /**
         * Position of the circle relative to the collider, by default (0, 0).
         */ this.offset = Vector.Zero;
            this._globalMatrix = AffineMatrix.identity();
            this.offset = options.offset || Vector.Zero;
            this.radius = options.radius || 0;
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Returns a clone of this shape, not associated with any collider
     */ clone() {
            return new CircleCollider({
                offset: this.offset.clone(),
                radius: this.radius
            });
        }
        /**
     * Get the center of the collider in world coordinates
     */ get center() {
            return this._globalMatrix.getPosition();
        }
        /**
     * Tests if a point is contained in this collider
     */ contains(point) {
            var _a, _b;
            const pos = (_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : this.offset;
            const distance = pos.distance(point);
            if (distance <= this.radius) return true;
            return false;
        }
        /**
     * Casts a ray at the Circle collider and returns the nearest point of collision
     * @param ray
     */ rayCast(ray, max = Infinity) {
            var _a, _b;
            //https://en.wikipedia.org/wiki/Line%E2%80%93sphere_intersection
            const c = this.center;
            const dir = ray.dir;
            const orig = ray.pos;
            const discriminant = Math.sqrt(Math.pow(dir.dot(orig.sub(c)), 2) - Math.pow(orig.sub(c).distance(), 2) + Math.pow(this.radius, 2));
            if (discriminant < 0) // no intersection
            return null;
            else {
                let toi = 0;
                // tangent case
                if (discriminant === 0) {
                    toi = -dir.dot(orig.sub(c));
                    if (toi > 0 && toi < max) {
                        const point = ray.getPoint(toi);
                        return {
                            point: point,
                            normal: point.sub(c).normalize(),
                            collider: this,
                            body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                            distance: toi
                        };
                    }
                    return null;
                } else {
                    const toi1 = -dir.dot(orig.sub(c)) + discriminant;
                    const toi2 = -dir.dot(orig.sub(c)) - discriminant;
                    const positiveToi = [];
                    if (toi1 >= 0) positiveToi.push(toi1);
                    if (toi2 >= 0) positiveToi.push(toi2);
                    const minToi = Math.min(...positiveToi);
                    if (minToi <= max) {
                        const point = ray.getPoint(minToi);
                        return {
                            point: point,
                            normal: point.sub(c).normalize(),
                            collider: this,
                            body: (_b = this.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent),
                            distance: minToi
                        };
                    }
                    return null;
                }
            }
        }
        getClosestLineBetween(shape) {
            if (shape instanceof CircleCollider) return ClosestLineJumpTable.CircleCircleClosestLine(this, shape);
            else if (shape instanceof PolygonCollider) return ClosestLineJumpTable.PolygonCircleClosestLine(shape, this).flip();
            else if (shape instanceof EdgeCollider) return ClosestLineJumpTable.CircleEdgeClosestLine(this, shape).flip();
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * @inheritdoc
     */ collide(collider) {
            if (collider instanceof CircleCollider) return CollisionJumpTable.CollideCircleCircle(this, collider);
            else if (collider instanceof PolygonCollider) return CollisionJumpTable.CollideCirclePolygon(this, collider);
            else if (collider instanceof EdgeCollider) return CollisionJumpTable.CollideCircleEdge(this, collider);
            else throw new Error(`Circle could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            return this.center.add(direction.normalize().scale(this.radius));
        }
        /**
     * Find the local point on the shape in the direction specified
     * @param direction
     */ getFurthestLocalPoint(direction) {
            const dir = direction.normalize();
            return dir.scale(this.radius);
        }
        /**
     * Get the axis aligned bounding box for the circle collider in world coordinates
     */ get bounds() {
            var _a, _b, _c;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            const rotation = (_b = tx === null || tx === void 0 ? void 0 : tx.globalRotation) !== null && _b !== void 0 ? _b : 0;
            const pos = (_c = tx === null || tx === void 0 ? void 0 : tx.globalPos) !== null && _c !== void 0 ? _c : Vector.Zero;
            return new BoundingBox(this.offset.x - this._naturalRadius, this.offset.y - this._naturalRadius, this.offset.x + this._naturalRadius, this.offset.y + this._naturalRadius).rotate(rotation).scale(scale).translate(pos);
        }
        /**
     * Get the axis aligned bounding box for the circle collider in local coordinates
     */ get localBounds() {
            return new BoundingBox(this.offset.x - this._naturalRadius, this.offset.y - this._naturalRadius, this.offset.x + this._naturalRadius, this.offset.y + this._naturalRadius);
        }
        /**
     * Get axis not implemented on circles, since there are infinite axis in a circle
     */ get axes() {
            return [];
        }
        /**
     * Returns the moment of inertia of a circle given it's mass
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            return mass * this.radius * this.radius / 2;
        }
        /* istanbul ignore next */ update(transform) {
            var _a;
            this._transform = transform;
            const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
            globalMat.clone(this._globalMatrix);
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Project the circle along a specified axis
     */ project(axis) {
            const scalars = [];
            const point = this.center;
            const dotProduct = point.dot(axis);
            scalars.push(dotProduct);
            scalars.push(dotProduct + this.radius);
            scalars.push(dotProduct - this.radius);
            return new Projection(Math.min.apply(Math, scalars), Math.max.apply(Math, scalars));
        }
        debug(ex, color, options) {
            var _a, _b, _c, _d;
            const { lineWidth: lineWidth } = {
                lineWidth: 1,
                ...options
            };
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            const rotation = (_b = tx === null || tx === void 0 ? void 0 : tx.globalRotation) !== null && _b !== void 0 ? _b : 0;
            const pos = (_c = tx === null || tx === void 0 ? void 0 : tx.globalPos) !== null && _c !== void 0 ? _c : Vector.Zero;
            ex.save();
            ex.translate(pos.x, pos.y);
            ex.rotate(rotation);
            ex.scale(scale.x, scale.y);
            ex.drawCircle((_d = this.offset) !== null && _d !== void 0 ? _d : Vector.Zero, this._naturalRadius, Color.Transparent, color, lineWidth);
            ex.restore();
        }
    }
    /**
 * Collision contacts are used internally by Excalibur to resolve collision between colliders. This
 * Pair prevents collisions from being evaluated more than one time
 */ class CollisionContact {
        constructor(colliderA, colliderB, mtv, normal, tangent, points, localPoints, info){
            var _a, _b, _c, _d, _e, _f;
            this._canceled = false;
            this.colliderA = colliderA;
            this.colliderB = colliderB;
            this.mtv = mtv;
            this.normal = normal;
            this.tangent = tangent;
            this.points = points;
            this.localPoints = localPoints;
            this.info = info;
            this.id = Pair.calculatePairHash(colliderA.id, colliderB.id);
            if (colliderA.composite || colliderB.composite) {
                // Add on the parent composite pair for start/end contact if 'together
                const colliderAId = ((_a = colliderA.composite) === null || _a === void 0 ? void 0 : _a.compositeStrategy) === "separate" ? colliderA.id : (_c = (_b = colliderA.composite) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : colliderA.id;
                const colliderBId = ((_d = colliderB.composite) === null || _d === void 0 ? void 0 : _d.compositeStrategy) === "separate" ? colliderB.id : (_f = (_e = colliderB.composite) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : colliderB.id;
                this.id += "|" + Pair.calculatePairHash(colliderAId, colliderBId);
            }
        }
        /**
     * Match contact awake state, except if body's are Fixed
     */ matchAwake() {
            const bodyA = this.colliderA.owner.get(BodyComponent);
            const bodyB = this.colliderB.owner.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.sleeping !== bodyB.sleeping) {
                    if (bodyA.sleeping && bodyA.collisionType !== CollisionType.Fixed && bodyB.sleepMotion >= bodyA.wakeThreshold) bodyA.setSleeping(false);
                    if (bodyB.sleeping && bodyB.collisionType !== CollisionType.Fixed && bodyA.sleepMotion >= bodyB.wakeThreshold) bodyB.setSleeping(false);
                }
            }
        }
        isCanceled() {
            return this._canceled;
        }
        cancel() {
            this._canceled = true;
        }
    }
    class SeparatingAxis {
        static findPolygonPolygonSeparation(polyA, polyB) {
            let bestSeparation = -Number.MAX_VALUE;
            let bestSide = null;
            let bestAxis = null;
            let bestSideIndex = -1;
            let bestOtherPoint = null;
            const sides = polyA.getSides();
            const localSides = polyA.getLocalSides();
            for(let i = 0; i < sides.length; i++){
                const side = sides[i];
                const axis = side.normal();
                const vertB = polyB.getFurthestPoint(axis.negate());
                // Separation on side i's axis
                // We are looking for the largest separation between poly A's sides
                const vertSeparation = side.distanceToPoint(vertB, true);
                if (vertSeparation > bestSeparation) {
                    bestSeparation = vertSeparation;
                    bestSide = side;
                    bestAxis = axis;
                    bestSideIndex = i;
                    bestOtherPoint = vertB;
                }
            }
            return {
                collider: polyA,
                separation: bestAxis ? bestSeparation : 99,
                axis: bestAxis,
                side: bestSide,
                localSide: localSides[bestSideIndex],
                sideId: bestSideIndex,
                point: bestOtherPoint,
                localPoint: bestAxis ? polyB.getFurthestLocalPoint(bestAxis.negate()) : null
            };
        }
        static findCirclePolygonSeparation(circle, polygon) {
            const axes = polygon.axes;
            const pc = polygon.center;
            // Special SAT with circles
            const polyDir = pc.sub(circle.worldPos);
            const closestPointOnPoly = polygon.getFurthestPoint(polyDir.negate());
            axes.push(closestPointOnPoly.sub(circle.worldPos).normalize());
            let minOverlap = Number.MAX_VALUE;
            let minAxis = null;
            let minIndex = -1;
            for(let i = 0; i < axes.length; i++){
                const proj1 = polygon.project(axes[i]);
                const proj2 = circle.project(axes[i]);
                const overlap = proj1.getOverlap(proj2);
                if (overlap <= 0) return null;
                else if (overlap < minOverlap) {
                    minOverlap = overlap;
                    minAxis = axes[i];
                    minIndex = i;
                }
            }
            if (minIndex < 0) return null;
            return minAxis.normalize().scale(minOverlap);
        }
    }
    const CollisionJumpTable = {
        CollideCircleCircle (circleA, circleB) {
            const circleAPos = circleA.worldPos;
            const circleBPos = circleB.worldPos;
            const combinedRadius = circleA.radius + circleB.radius;
            const distance = circleAPos.distance(circleBPos);
            if (distance > combinedRadius) return [];
            // negative means overlap
            const separation = combinedRadius - distance;
            // Normal points from A -> B
            const normal = circleBPos.sub(circleAPos).normalize();
            const tangent = normal.perpendicular();
            const mvt = normal.scale(separation);
            const point = circleA.getFurthestPoint(normal);
            const local = circleA.getFurthestLocalPoint(normal);
            const info = {
                collider: circleA,
                separation: separation,
                axis: normal,
                point: point
            };
            return [
                new CollisionContact(circleA, circleB, mvt, normal, tangent, [
                    point
                ], [
                    local
                ], info)
            ];
        },
        CollideCirclePolygon (circle, polygon) {
            var _a, _b;
            let minAxis = SeparatingAxis.findCirclePolygonSeparation(circle, polygon);
            if (!minAxis) return [];
            // make sure that the minAxis is pointing away from circle
            const samedir = minAxis.dot(polygon.center.sub(circle.center));
            minAxis = samedir < 0 ? minAxis.negate() : minAxis;
            const point = circle.getFurthestPoint(minAxis);
            const xf = (_b = (_a = circle.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
            const local = xf.applyInverse(point);
            const normal = minAxis.normalize();
            const info = {
                collider: circle,
                separation: -minAxis.size,
                axis: normal,
                point: point,
                localPoint: local,
                side: polygon.findSide(normal.negate()),
                localSide: polygon.findLocalSide(normal.negate())
            };
            return [
                new CollisionContact(circle, polygon, minAxis, normal, normal.perpendicular(), [
                    point
                ], [
                    local
                ], info)
            ];
        },
        CollideCircleEdge (circle, edge) {
            // TODO not sure this actually abides by local/world collisions
            // Are edge.begin and edge.end local space or world space? I think they should be local
            // center of the circle in world pos
            const cc = circle.center;
            // vector in the direction of the edge
            const edgeWorld = edge.asLine();
            const e = edgeWorld.end.sub(edgeWorld.begin);
            // amount of overlap with the circle's center along the edge direction
            const u = e.dot(edgeWorld.end.sub(cc));
            const v = e.dot(cc.sub(edgeWorld.begin));
            const side = edge.asLine();
            const localSide = edge.asLocalLine();
            // Potential region A collision (circle is on the left side of the edge, before the beginning)
            if (v <= 0) {
                const da = edgeWorld.begin.sub(cc);
                const dda = da.dot(da); // quick and dirty way of calc'n distance in r^2 terms saves some sqrts
                // save some sqrts
                if (dda > circle.radius * circle.radius) return []; // no collision
                const normal = da.normalize();
                const separation = circle.radius - Math.sqrt(dda);
                const info = {
                    collider: circle,
                    separation: separation,
                    axis: normal,
                    point: side.begin,
                    side: side,
                    localSide: localSide
                };
                return [
                    new CollisionContact(circle, edge, normal.scale(separation), normal, normal.perpendicular(), [
                        side.begin
                    ], [
                        localSide.begin
                    ], info)
                ];
            }
            // Potential region B collision (circle is on the right side of the edge, after the end)
            if (u <= 0) {
                const db = edgeWorld.end.sub(cc);
                const ddb = db.dot(db);
                if (ddb > circle.radius * circle.radius) return [];
                const normal = db.normalize();
                const separation = circle.radius - Math.sqrt(ddb);
                const info = {
                    collider: circle,
                    separation: separation,
                    axis: normal,
                    point: side.end,
                    side: side,
                    localSide: localSide
                };
                return [
                    new CollisionContact(circle, edge, normal.scale(separation), normal, normal.perpendicular(), [
                        side.end
                    ], [
                        localSide.end
                    ], info)
                ];
            }
            // Otherwise potential region AB collision (circle is in the middle of the edge between the beginning and end)
            const den = e.dot(e);
            const pointOnEdge = edgeWorld.begin.scale(u).add(edgeWorld.end.scale(v)).scale(1 / den);
            const d = cc.sub(pointOnEdge);
            const dd = d.dot(d);
            if (dd > circle.radius * circle.radius) return []; // no collision
            let normal = e.perpendicular();
            // flip correct direction
            if (normal.dot(cc.sub(edgeWorld.begin)) < 0) {
                normal.x = -normal.x;
                normal.y = -normal.y;
            }
            normal = normal.normalize();
            const separation = circle.radius - Math.sqrt(dd);
            const mvt = normal.scale(separation);
            const info = {
                collider: circle,
                separation: separation,
                axis: normal,
                point: pointOnEdge,
                side: side,
                localSide: localSide
            };
            return [
                new CollisionContact(circle, edge, mvt, normal.negate(), normal.negate().perpendicular(), [
                    pointOnEdge
                ], [
                    pointOnEdge.sub(edge.worldPos)
                ], info)
            ];
        },
        CollideEdgeEdge () {
            // Edge-edge collision doesn't make sense
            return [];
        },
        CollidePolygonEdge (polygon, edge) {
            var _a;
            const pc = polygon.center;
            const ec = edge.center;
            const dir = ec.sub(pc).normalize();
            // build a temporary polygon from the edge to use SAT
            const linePoly = new PolygonCollider({
                points: [
                    edge.begin,
                    edge.end,
                    edge.end.add(dir.scale(100)),
                    edge.begin.add(dir.scale(100))
                ],
                offset: edge.offset
            });
            linePoly.owner = edge.owner;
            const tx = (_a = edge.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
            if (tx) linePoly.update(edge.owner.get(TransformComponent).get());
            // Gross hack but poly-poly works well
            const contact = this.CollidePolygonPolygon(polygon, linePoly);
            if (contact.length) {
                // Fudge the contact back to edge
                contact[0].colliderB = edge;
                contact[0].id = Pair.calculatePairHash(polygon.id, edge.id);
            }
            return contact;
        },
        CollidePolygonPolygon (polyA, polyB) {
            var _a, _b, _c, _d;
            // Multi contact from SAT
            // https://gamedev.stackexchange.com/questions/111390/multiple-contacts-for-sat-collision-detection
            // do a SAT test to find a min axis if it exists
            const separationA = SeparatingAxis.findPolygonPolygonSeparation(polyA, polyB);
            // If there is no overlap from boxA's perspective we can end early
            if (separationA.separation > 0) return [];
            const separationB = SeparatingAxis.findPolygonPolygonSeparation(polyB, polyA);
            // If there is no overlap from boxB's perspective exit now
            if (separationB.separation > 0) return [];
            // Separations are both negative, we want to pick the least negative (minimal movement)
            const separation = separationA.separation > separationB.separation ? separationA : separationB;
            // The incident side is the most opposite from the axes of collision on the other collider
            const other = separation.collider === polyA ? polyB : polyA;
            const incident = other.findSide(separation.axis.negate());
            // Clip incident side by the perpendicular lines at each end of the reference side
            // https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm
            const reference = separation.side;
            const refDir = reference.dir().normalize();
            // Find our contact points by clipping the incident by the collision side
            const clipRight = incident.clip(refDir.negate(), -refDir.dot(reference.begin));
            let clipLeft = null;
            if (clipRight) clipLeft = clipRight.clip(refDir, refDir.dot(reference.end));
            // If there is no left there is no collision
            if (clipLeft) {
                // We only want clip points below the reference edge, discard the others
                const points = clipLeft.getPoints().filter((p)=>{
                    return reference.below(p);
                });
                let normal = separation.axis;
                let tangent = normal.perpendicular();
                // Point Contact A -> B
                if (polyB.center.sub(polyA.center).dot(normal) < 0) {
                    normal = normal.negate();
                    tangent = normal.perpendicular();
                }
                // Points are clipped from incident which is the other collider
                // Store those as locals
                let localPoints = [];
                if (separation.collider === polyA) {
                    const xf = (_b = (_a = polyB.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
                    localPoints = points.map((p)=>xf.applyInverse(p));
                } else {
                    const xf = (_d = (_c = polyA.owner) === null || _c === void 0 ? void 0 : _c.get(TransformComponent)) !== null && _d !== void 0 ? _d : new TransformComponent();
                    localPoints = points.map((p)=>xf.applyInverse(p));
                }
                return [
                    new CollisionContact(polyA, polyB, normal.scale(-separation.separation), normal, tangent, points, localPoints, separation)
                ];
            }
            return [];
        },
        FindContactSeparation (contact, localPoint) {
            var _a, _b, _c, _d;
            const shapeA = contact.colliderA;
            const txA = (_b = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
            const shapeB = contact.colliderB;
            const txB = (_d = (_c = contact.colliderB.owner) === null || _c === void 0 ? void 0 : _c.get(TransformComponent)) !== null && _d !== void 0 ? _d : new TransformComponent();
            // both are circles
            if (shapeA instanceof CircleCollider && shapeB instanceof CircleCollider) {
                const combinedRadius = shapeA.radius + shapeB.radius;
                const distance = txA.pos.distance(txB.pos);
                const separation = combinedRadius - distance;
                return -separation;
            }
            // both are polygons
            if (shapeA instanceof PolygonCollider && shapeB instanceof PolygonCollider) {
                if (contact.info.localSide) {
                    let side;
                    let worldPoint;
                    if (contact.info.collider === shapeA) {
                        side = new LineSegment(txA.apply(contact.info.localSide.begin), txA.apply(contact.info.localSide.end));
                        worldPoint = txB.apply(localPoint);
                    } else {
                        side = new LineSegment(txB.apply(contact.info.localSide.begin), txB.apply(contact.info.localSide.end));
                        worldPoint = txA.apply(localPoint);
                    }
                    return side.distanceToPoint(worldPoint, true);
                }
            }
            // polygon v circle
            if (shapeA instanceof PolygonCollider && shapeB instanceof CircleCollider || shapeB instanceof PolygonCollider && shapeA instanceof CircleCollider) {
                const worldPoint = txA.apply(localPoint);
                if (contact.info.side) return contact.info.side.distanceToPoint(worldPoint, true);
            }
            // polygon v edge
            if (shapeA instanceof EdgeCollider && shapeB instanceof PolygonCollider || shapeB instanceof EdgeCollider && shapeA instanceof PolygonCollider) {
                let worldPoint;
                if (contact.info.collider === shapeA) worldPoint = txB.apply(localPoint);
                else worldPoint = txA.apply(localPoint);
                if (contact.info.side) return contact.info.side.distanceToPoint(worldPoint, true);
            }
            // circle v edge
            if (shapeA instanceof CircleCollider && shapeB instanceof EdgeCollider || shapeB instanceof CircleCollider && shapeA instanceof EdgeCollider) {
                // Local point is always on the edge which is always shapeB
                const worldPoint = txB.apply(localPoint);
                let circlePoint;
                if (shapeA instanceof CircleCollider) circlePoint = shapeA.getFurthestPoint(contact.normal);
                const dist = worldPoint.distance(circlePoint);
                if (contact.info.side) return dist > 0 ? -dist : 0;
            }
            return 0;
        }
    };
    /**
 * Edge is a single line collider to create collisions with a single line.
 */ class EdgeCollider extends Collider {
        constructor(options){
            var _a;
            super();
            this._globalMatrix = AffineMatrix.identity();
            this.begin = options.begin || Vector.Zero;
            this.end = options.end || Vector.Zero;
            this.offset = (_a = options.offset) !== null && _a !== void 0 ? _a : Vector.Zero;
        }
        /**
     * Returns a clone of this Edge, not associated with any collider
     */ clone() {
            return new EdgeCollider({
                begin: this.begin.clone(),
                end: this.end.clone()
            });
        }
        get worldPos() {
            var _a;
            const tx = this._transform;
            return (_a = tx === null || tx === void 0 ? void 0 : tx.globalPos.add(this.offset)) !== null && _a !== void 0 ? _a : this.offset;
        }
        /**
     * Get the center of the collision area in world coordinates
     */ get center() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const pos = begin.average(end);
            return pos;
        }
        _getTransformedBegin() {
            return this._globalMatrix.multiply(this.begin);
        }
        _getTransformedEnd() {
            return this._globalMatrix.multiply(this.end);
        }
        /**
     * Returns the slope of the line in the form of a vector
     */ getSlope() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const distance = begin.distance(end);
            return end.sub(begin).scale(1 / distance);
        }
        /**
     * Returns the length of the line segment in pixels
     */ getLength() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const distance = begin.distance(end);
            return distance;
        }
        /**
     * Tests if a point is contained in this collision area
     */ contains() {
            return false;
        }
        /**
     * @inheritdoc
     */ rayCast(ray, max = Infinity) {
            var _a;
            const numerator = this._getTransformedBegin().sub(ray.pos);
            // Test is line and ray are parallel and non intersecting
            if (ray.dir.cross(this.getSlope()) === 0 && numerator.cross(ray.dir) !== 0) return null;
            // Lines are parallel
            const divisor = ray.dir.cross(this.getSlope());
            if (divisor === 0) return null;
            const t = numerator.cross(this.getSlope()) / divisor;
            if (t >= 0 && t <= max) {
                const u = numerator.cross(ray.dir) / divisor / this.getLength();
                if (u >= 0 && u <= 1) return {
                    distance: t,
                    normal: this.asLine().normal(),
                    collider: this,
                    body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                    point: ray.getPoint(t)
                };
            }
            return null;
        }
        /**
     * Returns the closes line between this and another collider, from this -> collider
     * @param shape
     */ getClosestLineBetween(shape) {
            if (shape instanceof CircleCollider) return ClosestLineJumpTable.CircleEdgeClosestLine(shape, this);
            else if (shape instanceof PolygonCollider) return ClosestLineJumpTable.PolygonEdgeClosestLine(shape, this).flip();
            else if (shape instanceof EdgeCollider) return ClosestLineJumpTable.EdgeEdgeClosestLine(this, shape);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * @inheritdoc
     */ collide(shape) {
            if (shape instanceof CircleCollider) return CollisionJumpTable.CollideCircleEdge(shape, this);
            else if (shape instanceof PolygonCollider) return CollisionJumpTable.CollidePolygonEdge(shape, this);
            else if (shape instanceof EdgeCollider) return CollisionJumpTable.CollideEdgeEdge();
            else throw new Error(`Edge could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            const transformedBegin = this._getTransformedBegin();
            const transformedEnd = this._getTransformedEnd();
            if (direction.dot(transformedBegin) > 0) return transformedBegin;
            else return transformedEnd;
        }
        _boundsFromBeginEnd(begin, end, padding = 10) {
            // A perfectly vertical or horizontal edge would have a bounds 0 width or height
            // this causes problems for the collision system so we give them some padding
            return new BoundingBox(Math.min(begin.x, end.x) - padding, Math.min(begin.y, end.y) - padding, Math.max(begin.x, end.x) + padding, Math.max(begin.y, end.y) + padding);
        }
        /**
     * Get the axis aligned bounding box for the edge collider in world space
     */ get bounds() {
            const transformedBegin = this._getTransformedBegin();
            const transformedEnd = this._getTransformedEnd();
            return this._boundsFromBeginEnd(transformedBegin, transformedEnd);
        }
        /**
     * Get the axis aligned bounding box for the edge collider in local space
     */ get localBounds() {
            return this._boundsFromBeginEnd(this.begin, this.end);
        }
        /**
     * Returns this edge represented as a line in world coordinates
     */ asLine() {
            return new LineSegment(this._getTransformedBegin(), this._getTransformedEnd());
        }
        /**
     * Return this edge as a line in local line coordinates (relative to the position)
     */ asLocalLine() {
            return new LineSegment(this.begin, this.end);
        }
        /**
     * Get the axis associated with the edge
     */ get axes() {
            const e = this._getTransformedEnd().sub(this._getTransformedBegin());
            const edgeNormal = e.normal();
            const axes = [];
            axes.push(edgeNormal);
            axes.push(edgeNormal.negate());
            axes.push(edgeNormal.normal());
            axes.push(edgeNormal.normal().negate());
            return axes;
        }
        /**
     * Get the moment of inertia for an edge
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            const length = this.end.sub(this.begin).distance() / 2;
            return mass * length * length;
        }
        /**
     * @inheritdoc
     */ update(transform) {
            var _a;
            this._transform = transform;
            const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
            globalMat.clone(this._globalMatrix);
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Project the edge along a specified axis
     */ project(axis) {
            const scalars = [];
            const points = [
                this._getTransformedBegin(),
                this._getTransformedEnd()
            ];
            const len = points.length;
            for(let i = 0; i < len; i++)scalars.push(points[i].dot(axis));
            return new Projection(Math.min.apply(Math, scalars), Math.max.apply(Math, scalars));
        }
        debug(ex, color) {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            ex.drawLine(begin, end, color, 2);
            ex.drawCircle(begin, 2, color);
            ex.drawCircle(end, 2, color);
        }
    }
    class Debug {
        static registerGraphicsContext(ctx) {
            Debug._ctx = ctx;
        }
        static draw(debugDrawCall) {
            this._drawCalls.push(debugDrawCall);
        }
        static drawPoint(point, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawPoint(point, options);
            });
        }
        static drawLine(start, end, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawLine(start, end, options);
            });
        }
        static drawLines(points, options) {
            if (points.length > 1) Debug.draw((ctx)=>{
                for(let i = 0; i < points.length - 1; i++)ctx.debug.drawLine(points[i], points[i + 1], options);
            });
        }
        static drawText(text, pos) {
            Debug.draw((ctx)=>{
                ctx.debug.drawText(text, pos);
            });
        }
        static drawPolygon(points, options) {
            if (points.length > 1) Debug.draw((ctx)=>{
                const firstPoint = points[0];
                const polygon = [
                    ...points,
                    firstPoint
                ];
                for(let i = 0; i < polygon.length - 1; i++)ctx.debug.drawLine(polygon[i], polygon[i + 1], options);
            });
        }
        static drawCircle(center, radius, options) {
            const { color: color, strokeColor: strokeColor, width: width } = {
                color: Color.Black,
                strokeColor: undefined,
                width: undefined,
                ...options
            };
            Debug.draw((ctx)=>{
                ctx.drawCircle(center, radius, color, strokeColor, width);
            });
        }
        static drawBounds(boundingBox, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawRect(boundingBox.left, boundingBox.top, boundingBox.width, boundingBox.height, options);
            });
        }
        static drawRay(ray, options) {
            const { distance: distance, color: color } = {
                color: Color.Blue,
                distance: 10,
                ...options
            };
            Debug.draw((ctx)=>{
                const start = ray.pos;
                const end = ray.pos.add(ray.dir.scale(distance));
                ctx.debug.drawLine(start, end, {
                    color: color
                });
            });
        }
        static flush(ctx) {
            ctx.save();
            ctx.z = Debug.z;
            for (const drawCall of Debug._drawCalls)drawCall(ctx);
            ctx.restore();
            Debug.clear();
        }
        static clear() {
            Debug._drawCalls.length = 0;
        }
    }
    Debug._drawCalls = [];
    Debug.z = Infinity;
    /**
 * Polygon collider for detecting collisions
 */ class PolygonCollider extends Collider {
        flagDirty() {
            this._localBoundsDirty = true;
            this._localSidesDirty = true;
            this._transformedPointsDirty = true;
            this._sidesDirty = true;
        }
        /**
     * Points in the polygon in order around the perimeter in local coordinates. These are relative from the body transform position.
     * Excalibur stores these in counter-clockwise order
     */ set points(points) {
            this._points = points;
            this.flagDirty();
        }
        /**
     * Points in the polygon in order around the perimeter in local coordinates. These are relative from the body transform position.
     * Excalibur stores these in counter-clockwise order
     */ get points() {
            return this._points;
        }
        constructor(options){
            var _a, _b;
            super();
            this._logger = Logger.getInstance();
            this._transformedPoints = [];
            this._sides = [];
            this._localSides = [];
            this._globalMatrix = AffineMatrix.identity();
            this._transformedPointsDirty = true;
            this._sidesDirty = true;
            this._localSidesDirty = true;
            this._localBoundsDirty = true;
            this.offset = (_a = options.offset) !== null && _a !== void 0 ? _a : Vector.Zero;
            this._globalMatrix.translate(this.offset.x, this.offset.y);
            this.points = (_b = options.points) !== null && _b !== void 0 ? _b : [];
            const counterClockwise = this._isCounterClockwiseWinding(this.points);
            if (!counterClockwise) this.points.reverse();
            if (!this.isConvex()) {
                if (!options.suppressConvexWarning) this._logger.warn("Excalibur only supports convex polygon colliders and will not behave properly.Call PolygonCollider.triangulate() to build a new collider composed of smaller convex triangles");
            }
            // calculate initial transformation
            this._calculateTransformation();
        }
        _isCounterClockwiseWinding(points) {
            // https://stackoverflow.com/a/1165943
            let sum = 0;
            for(let i = 0; i < points.length; i++)sum += (points[(i + 1) % points.length].x - points[i].x) * (points[(i + 1) % points.length].y + points[i].y);
            return sum < 0;
        }
        /**
     * Returns if the polygon collider is convex, Excalibur does not handle non-convex collision shapes.
     * Call [[Polygon.triangulate]] to generate a [[CompositeCollider]] from this non-convex shape
     */ isConvex() {
            // From SO: https://stackoverflow.com/a/45372025
            if (this.points.length < 3) return false;
            let oldPoint = this.points[this.points.length - 2];
            let newPoint = this.points[this.points.length - 1];
            let direction = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);
            let oldDirection = 0;
            let orientation = 0;
            let angleSum = 0;
            for (const [i, point] of this.points.entries()){
                oldPoint = newPoint;
                oldDirection = direction;
                newPoint = point;
                direction = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);
                if (oldPoint.equals(newPoint)) return false; // repeat point
                let angle = direction - oldDirection;
                if (angle <= -Math.PI) angle += Math.PI * 2;
                else if (angle > Math.PI) angle -= Math.PI * 2;
                if (i === 0) {
                    if (angle === 0.0) return false;
                    orientation = angle > 0 ? 1 : -1;
                } else {
                    if (orientation * angle <= 0) return false;
                }
                angleSum += angle;
            }
            return Math.abs(Math.round(angleSum / (Math.PI * 2))) === 1;
        }
        /**
     * Tessellates the polygon into a triangle fan as a [[CompositeCollider]] of triangle polygons
     */ tessellate() {
            const polygons = [];
            for(let i = 1; i < this.points.length - 2; i++)polygons.push([
                this.points[0],
                this.points[i + 1],
                this.points[i + 2]
            ]);
            polygons.push([
                this.points[0],
                this.points[1],
                this.points[2]
            ]);
            return new CompositeCollider(polygons.map((points)=>Shape.Polygon(points)));
        }
        /**
     * Triangulate the polygon collider using the "Ear Clipping" algorithm.
     * Returns a new [[CompositeCollider]] made up of smaller triangles.
     */ triangulate() {
            // https://www.youtube.com/watch?v=hTJFcHutls8
            if (this.points.length < 3) throw Error("Invalid polygon");
            const triangles = [];
            // algorithm likes clockwise
            const vertices = [
                ...this.points
            ].reverse();
            let vertexCount = vertices.length;
            /**
         * Returns the previous index based on the current vertex
         */ function getPrevIndex(index) {
                return index === 0 ? vertexCount - 1 : index - 1;
            }
            /**
         * Retrieves the next index based on the current vertex
         */ function getNextIndex(index) {
                return index === vertexCount - 1 ? 0 : index + 1;
            }
            /**
         * Whether or not the angle at this vertex index is convex
         */ function isConvex(index) {
                const prev = getPrevIndex(index);
                const next = getNextIndex(index);
                const va = vertices[prev];
                const vb = vertices[index];
                const vc = vertices[next];
                // Check convexity
                const leftArm = va.sub(vb);
                const rightArm = vc.sub(vb);
                // Positive cross product is convex
                if (leftArm.cross(rightArm) < 0) return false;
                return true;
            }
            const convexVertices = vertices.map((_, i)=>isConvex(i));
            /**
         * Quick test for point in triangle
         */ function isPointInTriangle(point, a, b, c) {
                const ab = b.sub(a);
                const bc = c.sub(b);
                const ca = a.sub(c);
                const ap = point.sub(a);
                const bp = point.sub(b);
                const cp = point.sub(c);
                const cross1 = ab.cross(ap);
                const cross2 = bc.cross(bp);
                const cross3 = ca.cross(cp);
                if (cross1 > 0 || cross2 > 0 || cross3 > 0) return false;
                return true;
            }
            /**
         * Calculate the area of the triangle
         */ // function triangleArea(a: Vector, b: Vector, c: Vector) {
            //   return Math.abs(a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - c.y))/2;
            // }
            /**
         * Find the next suitable ear tip
         */ function findEarTip() {
                for(let i = 0; i < vertexCount; i++)if (convexVertices[i]) {
                    const prev = getPrevIndex(i);
                    const next = getNextIndex(i);
                    const va = vertices[prev];
                    const vb = vertices[i];
                    const vc = vertices[next];
                    let isEar = true;
                    // Check that if any vertices are in the triangle a, b, c
                    for(let j = 0; j < vertexCount; j++){
                        // We can skip these verts because they are the triangle we are testing
                        if (j === i || j === prev || j === next) continue;
                        const point = vertices[j];
                        if (isPointInTriangle(point, va, vb, vc)) {
                            isEar = false;
                            break;
                        }
                    }
                    // Add ear to polygon list and remove from list
                    if (isEar) return i;
                }
                // Fall back to any convex vertex
                for(let i = 0; i < vertexCount; i++){
                    if (convexVertices[i]) return i;
                }
                // bail and return the first one?
                return 0;
            }
            /**
         * Cut the ear and produce a triangle, update internal state
         */ function cutEarTip(index) {
                const prev = getPrevIndex(index);
                const next = getNextIndex(index);
                const va = vertices[prev];
                const vb = vertices[index];
                const vc = vertices[next];
                // Clockwise winding
                // if (triangleArea(va, vb, vc) > 0) {
                triangles.push([
                    va,
                    vb,
                    vc
                ]);
                // }
                vertices.splice(index, 1);
                convexVertices.splice(index, 1);
                vertexCount--;
            }
            // Loop over all the vertices finding ears
            while(vertexCount > 3){
                const earIndex = findEarTip();
                cutEarTip(earIndex);
                // reclassify vertices
                for(let i = 0; i < vertexCount; i++)convexVertices[i] = isConvex(i);
            }
            // Last triangle after the loop
            triangles.push([
                vertices[0],
                vertices[1],
                vertices[2]
            ]);
            // FIXME: there is a colinear triangle that sneaks in here sometimes
            return new CompositeCollider(triangles.map((points)=>Shape.Polygon(points, Vector.Zero, true)));
        }
        /**
     * Returns a clone of this ConvexPolygon, not associated with any collider
     */ clone() {
            return new PolygonCollider({
                offset: this.offset.clone(),
                points: this.points.map((p)=>p.clone())
            });
        }
        /**
     * Returns the world position of the collider, which is the current body transform plus any defined offset
     */ get worldPos() {
            if (this._transform) return this._transform.pos.add(this.offset);
            return this.offset;
        }
        /**
     * Get the center of the collider in world coordinates
     */ get center() {
            return this.bounds.center;
        }
        /**
     * Calculates the underlying transformation from the body relative space to world space
     */ _calculateTransformation() {
            const points = this.points;
            const len = points.length;
            this._transformedPoints.length = 0; // clear out old transform
            for(let i = 0; i < len; i++)this._transformedPoints[i] = this._globalMatrix.multiply(points[i].clone());
        }
        /**
     * Gets the points that make up the polygon in world space, from actor relative space (if specified)
     */ getTransformedPoints() {
            if (this._transformedPointsDirty) {
                this._calculateTransformation();
                this._transformedPointsDirty = false;
            }
            return this._transformedPoints;
        }
        /**
     * Gets the sides of the polygon in world space
     */ getSides() {
            if (this._sidesDirty) {
                const lines = [];
                const points = this.getTransformedPoints();
                const len = points.length;
                for(let i = 0; i < len; i++)// This winding is important
                lines.push(new LineSegment(points[i], points[(i + 1) % len]));
                this._sides = lines;
                this._sidesDirty = false;
            }
            return this._sides;
        }
        /**
     * Returns the local coordinate space sides
     */ getLocalSides() {
            if (this._localSidesDirty) {
                const lines = [];
                const points = this.points;
                const len = points.length;
                for(let i = 0; i < len; i++)// This winding is important
                lines.push(new LineSegment(points[i], points[(i + 1) % len]));
                this._localSides = lines;
                this._localSidesDirty = false;
            }
            return this._localSides;
        }
        /**
     * Given a direction vector find the world space side that is most in that direction
     * @param direction
     */ findSide(direction) {
            const sides = this.getSides();
            let bestSide = sides[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let side = 0; side < sides.length; side++){
                const currentSide = sides[side];
                const sideNormal = currentSide.normal();
                const mostDirection = sideNormal.dot(direction);
                if (mostDirection > maxDistance) {
                    bestSide = currentSide;
                    maxDistance = mostDirection;
                }
            }
            return bestSide;
        }
        /**
     * Given a direction vector find the local space side that is most in that direction
     * @param direction
     */ findLocalSide(direction) {
            const sides = this.getLocalSides();
            let bestSide = sides[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let side = 0; side < sides.length; side++){
                const currentSide = sides[side];
                const sideNormal = currentSide.normal();
                const mostDirection = sideNormal.dot(direction);
                if (mostDirection > maxDistance) {
                    bestSide = currentSide;
                    maxDistance = mostDirection;
                }
            }
            return bestSide;
        }
        /**
     * Get the axis associated with the convex polygon
     */ get axes() {
            const axes = [];
            const sides = this.getSides();
            for(let i = 0; i < sides.length; i++)axes.push(sides[i].normal());
            return axes;
        }
        /**
     * Updates the transform for the collision geometry
     *
     * Collision geometry (points/bounds) will not change until this is called.
     * @param transform
     */ update(transform) {
            var _a;
            if (transform) {
                this._transform = transform;
                this._transformedPointsDirty = true;
                this._sidesDirty = true;
                // This change means an update must be performed in order for geometry to update
                const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
                globalMat.clone(this._globalMatrix);
                this._globalMatrix.translate(this.offset.x, this.offset.y);
            }
        }
        /**
     * Tests if a point is contained in this collider in world space
     */ contains(point) {
            // Always cast to the right, as long as we cast in a consistent fixed direction we
            // will be fine
            const testRay = new Ray(point, new Vector(1, 0));
            const intersectCount = this.getSides().reduce(function(accum, side) {
                if (testRay.intersect(side) >= 0) return accum + 1;
                return accum;
            }, 0);
            if (intersectCount % 2 === 0) return false;
            return true;
        }
        getClosestLineBetween(collider) {
            if (collider instanceof CircleCollider) return ClosestLineJumpTable.PolygonCircleClosestLine(this, collider);
            else if (collider instanceof PolygonCollider) return ClosestLineJumpTable.PolygonPolygonClosestLine(this, collider);
            else if (collider instanceof EdgeCollider) return ClosestLineJumpTable.PolygonEdgeClosestLine(this, collider);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Returns a collision contact if the 2 colliders collide, otherwise collide will
     * return null.
     * @param collider
     */ collide(collider) {
            if (collider instanceof CircleCollider) return CollisionJumpTable.CollideCirclePolygon(collider, this);
            else if (collider instanceof PolygonCollider) return CollisionJumpTable.CollidePolygonPolygon(this, collider);
            else if (collider instanceof EdgeCollider) return CollisionJumpTable.CollidePolygonEdge(this, collider);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            const pts = this.getTransformedPoints();
            let furthestPoint = null;
            let maxDistance = -Number.MAX_VALUE;
            for(let i = 0; i < pts.length; i++){
                const distance = direction.dot(pts[i]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    furthestPoint = pts[i];
                }
            }
            return furthestPoint;
        }
        /**
     * Find the local point on the collider furthest in the direction specified
     * @param direction
     */ getFurthestLocalPoint(direction) {
            const pts = this.points;
            let furthestPoint = pts[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let i = 0; i < pts.length; i++){
                const distance = direction.dot(pts[i]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    furthestPoint = pts[i];
                }
            }
            return furthestPoint;
        }
        /**
     * Finds the closes face to the point using perpendicular distance
     * @param point point to test against polygon
     */ getClosestFace(point) {
            const sides = this.getSides();
            let min = Number.POSITIVE_INFINITY;
            let faceIndex = -1;
            let distance = -1;
            for(let i = 0; i < sides.length; i++){
                const dist = sides[i].distanceToPoint(point);
                if (dist < min) {
                    min = dist;
                    faceIndex = i;
                    distance = dist;
                }
            }
            if (faceIndex !== -1) return {
                distance: sides[faceIndex].normal().scale(distance),
                face: sides[faceIndex]
            };
            return null;
        }
        /**
     * Get the axis aligned bounding box for the polygon collider in world coordinates
     */ get bounds() {
            return this.localBounds.transform(this._globalMatrix);
        }
        /**
     * Get the axis aligned bounding box for the polygon collider in local coordinates
     */ get localBounds() {
            if (this._localBoundsDirty) {
                this._localBounds = BoundingBox.fromPoints(this.points);
                this._localBoundsDirty = false;
            }
            return this._localBounds;
        }
        /**
     * Get the moment of inertia for an arbitrary polygon
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            if (this._cachedMass === mass && this._cachedInertia) return this._cachedInertia;
            let numerator = 0;
            let denominator = 0;
            const points = this.points;
            for(let i = 0; i < points.length; i++){
                const iplusone = (i + 1) % points.length;
                const crossTerm = points[iplusone].cross(points[i]);
                numerator += crossTerm * (points[i].dot(points[i]) + points[i].dot(points[iplusone]) + points[iplusone].dot(points[iplusone]));
                denominator += crossTerm;
            }
            this._cachedMass = mass;
            return this._cachedInertia = mass / 6 * (numerator / denominator);
        }
        /**
     * Casts a ray into the polygon and returns a vector representing the point of contact (in world space) or null if no collision.
     */ rayCast(ray, max = Infinity) {
            var _a;
            // find the minimum contact time greater than 0
            // contact times less than 0 are behind the ray and we don't want those
            const sides = this.getSides();
            const len = sides.length;
            let minContactTime = Number.MAX_VALUE;
            let contactSide;
            let contactIndex = -1;
            for(let i = 0; i < len; i++){
                const contactTime = ray.intersect(sides[i]);
                if (contactTime >= 0 && contactTime < minContactTime && contactTime <= max) {
                    minContactTime = contactTime;
                    contactSide = sides[i];
                    contactIndex = i;
                }
            }
            // contact was found
            if (contactIndex >= 0) return {
                collider: this,
                distance: minContactTime,
                body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                point: ray.getPoint(minContactTime),
                normal: contactSide.normal()
            };
            // no contact found
            return null;
        }
        /**
     * Project the edges of the polygon along a specified axis
     */ project(axis) {
            const points = this.getTransformedPoints();
            const len = points.length;
            let min = Number.MAX_VALUE;
            let max = -Number.MAX_VALUE;
            for(let i = 0; i < len; i++){
                const scalar = points[i].dot(axis);
                min = Math.min(min, scalar);
                max = Math.max(max, scalar);
            }
            return new Projection(min, max);
        }
        debug(ex, color, options) {
            const points = this.getTransformedPoints();
            Debug.drawPolygon(points, {
                color: color
            });
        }
    }
    /**
 * Excalibur helper for defining colliders quickly
 */ class Shape {
        /**
     * Creates a box collider, under the hood defines a [[PolygonCollider]] collider
     * @param width Width of the box
     * @param height Height of the box
     * @param anchor Anchor of the box (default (.5, .5)) which positions the box relative to the center of the collider's position
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Box(width, height, anchor = Vector.Half, offset = Vector.Zero) {
            return new PolygonCollider({
                points: new BoundingBox(-width * anchor.x, -height * anchor.y, width - width * anchor.x, height - height * anchor.y).getPoints(),
                offset: offset
            });
        }
        /**
     * Creates a new [[PolygonCollider|arbitrary polygon]] collider
     *
     * PolygonColliders are useful for creating convex polygon shapes
     * @param points Points specified in counter clockwise
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Polygon(points, offset = Vector.Zero, suppressConvexWarning = false) {
            return new PolygonCollider({
                points: points,
                offset: offset,
                suppressConvexWarning: suppressConvexWarning
            });
        }
        /**
     * Creates a new [[CircleCollider|circle]] collider
     *
     * Circle colliders are useful for balls, or to make collisions more forgiving on sharp edges
     * @param radius Radius of the circle collider
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Circle(radius, offset = Vector.Zero) {
            return new CircleCollider({
                radius: radius,
                offset: offset
            });
        }
        /**
     * Creates a new [[EdgeCollider|edge]] collider
     *
     * Edge colliders are useful for  floors, walls, and other barriers
     * @param begin Beginning of the edge in local coordinates to the collider
     * @param end Ending of the edge in local coordinates to the collider
     */ static Edge(begin, end) {
            return new EdgeCollider({
                begin: begin,
                end: end
            });
        }
        /**
     * Creates a new capsule shaped [[CompositeCollider]] using 2 circles and a box
     *
     * Capsule colliders are useful for platformers with incline or jagged floors to have a smooth
     * player experience.
     * @param width
     * @param height
     * @param offset Optional offset
     */ static Capsule(width, height, offset = Vector.Zero) {
            const logger = Logger.getInstance();
            if (width === height) logger.warn("A capsule collider with equal width and height is a circle, consider using a ex.Shape.Circle or ex.CircleCollider");
            const vertical = height >= width;
            if (vertical) {
                // height > width, if equal maybe use a circle
                const capsule = new CompositeCollider([
                    Shape.Circle(width / 2, vec(0, -height / 2 + width / 2).add(offset)),
                    Shape.Box(width, height - width, Vector.Half, offset),
                    Shape.Circle(width / 2, vec(0, height / 2 - width / 2).add(offset))
                ]);
                return capsule;
            } else {
                // width > height, if equal maybe use a circle
                const capsule = new CompositeCollider([
                    Shape.Circle(height / 2, vec(-width / 2 + height / 2, 0).add(offset)),
                    Shape.Box(width - height, height, Vector.Half, offset),
                    Shape.Circle(height / 2, vec(width / 2 - height / 2, 0).add(offset))
                ]);
                return capsule;
            }
        }
    }
    class ColliderComponent extends Component {
        constructor(collider){
            super();
            this.events = new EventEmitter();
            /**
         * Observable that notifies when a collider is added to the body
         */ this.$colliderAdded = new Observable();
            /**
         * Observable that notifies when a collider is removed from the body
         */ this.$colliderRemoved = new Observable();
            this._collidersToRemove = [];
            this.set(collider);
        }
        /**
     * Get the current collider geometry
     */ get() {
            return this._collider;
        }
        /**
     * Set the collider geometry
     * @param collider
     * @returns the collider you set
     */ set(collider) {
            this.clear();
            if (collider) {
                this._collider = collider;
                this._collider.owner = this.owner;
                collider.events.pipe(this.events);
                this.$colliderAdded.notifyAll(collider);
                this.update();
            }
            return collider;
        }
        /**
     * Remove collider geometry from collider component
     */ clear() {
            if (this._collider) {
                this._collidersToRemove.push(this._collider);
                this._collider = null;
            }
        }
        processColliderRemoval() {
            for (const collider of this._collidersToRemove){
                collider.events.unpipe(this.events);
                this.$colliderRemoved.notifyAll(collider);
                collider.owner = null;
            }
        }
        clone() {
            const clone = new ColliderComponent(this._collider.clone());
            return clone;
        }
        /**
     * Return world space bounds
     */ get bounds() {
            var _a, _b;
            return (_b = (_a = this._collider) === null || _a === void 0 ? void 0 : _a.bounds) !== null && _b !== void 0 ? _b : new BoundingBox();
        }
        /**
     * Return local space bounds
     */ get localBounds() {
            var _a, _b;
            return (_b = (_a = this._collider) === null || _a === void 0 ? void 0 : _a.localBounds) !== null && _b !== void 0 ? _b : new BoundingBox();
        }
        /**
     * Update the collider's transformed geometry
     */ update() {
            var _a;
            const tx = (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
            if (this._collider) {
                this._collider.owner = this.owner;
                if (tx) this._collider.update(tx.get());
            }
        }
        /**
     * Collide component with another
     * @param other
     */ collide(other) {
            let colliderA = this._collider;
            let colliderB = other._collider;
            if (!colliderA || !colliderB) return [];
            // If we have a composite left hand side :(
            // Might bite us, but to avoid updating all the handlers make composite always left side
            let flipped = false;
            if (colliderB instanceof CompositeCollider) {
                colliderA = colliderB;
                colliderB = this._collider;
                flipped = true;
            }
            if (this._collider) {
                const contacts = colliderA.collide(colliderB);
                if (contacts) {
                    if (flipped) contacts.forEach((contact)=>{
                        contact.mtv = contact.mtv.negate();
                        contact.normal = contact.normal.negate();
                        contact.tangent = contact.normal.perpendicular();
                        contact.colliderA = this._collider;
                        contact.colliderB = other._collider;
                    });
                    return contacts;
                }
                return [];
            }
            return [];
        }
        onAdd(entity) {
            if (this._collider) this.update();
            // Wire up the collider events to the owning entity
            this.events.on("precollision", (evt)=>{
                const precollision = evt;
                entity.events.emit("precollision", new PreCollisionEvent(precollision.target.owner, precollision.other.owner, precollision.side, precollision.intersection, precollision.contact));
                if (entity instanceof Actor) entity.onPreCollisionResolve(precollision.target, precollision.other, precollision.side, precollision.contact);
            });
            this.events.on("postcollision", (evt)=>{
                const postcollision = evt;
                entity.events.emit("postcollision", new PostCollisionEvent(postcollision.target.owner, postcollision.other.owner, postcollision.side, postcollision.intersection, postcollision.contact));
                if (entity instanceof Actor) entity.onPostCollisionResolve(postcollision.target, postcollision.other, postcollision.side, postcollision.contact);
            });
            this.events.on("collisionstart", (evt)=>{
                const start = evt;
                entity.events.emit("collisionstart", new CollisionStartEvent(start.target.owner, start.other.owner, start.side, start.contact));
                if (entity instanceof Actor) entity.onCollisionStart(start.target, start.other, start.side, start.contact);
            });
            this.events.on("collisionend", (evt)=>{
                const end = evt;
                entity.events.emit("collisionend", new CollisionEndEvent(end.target.owner, end.other.owner, end.side, end.lastContact));
                if (entity instanceof Actor) entity.onCollisionEnd(end.target, end.other, end.side, end.lastContact);
            });
        }
        onRemove() {
            this.events.clear();
            this.$colliderRemoved.notifyAll(this._collider);
        }
        /**
     * Sets up a box geometry based on the current bounds of the associated actor of this physics body.
     *
     * If no width/height are specified the body will attempt to use the associated actor's width/height.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useBoxCollider(width, height, anchor = Vector.Half, center = Vector.Zero) {
            const collider = Shape.Box(width, height, anchor, center);
            return this.set(collider);
        }
        /**
     * Sets up a [[PolygonCollider|polygon]] collision geometry based on a list of of points relative
     *  to the anchor of the associated actor
     * of this physics body.
     *
     * Only [convex polygon](https://en.wikipedia.org/wiki/Convex_polygon) definitions are supported.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ usePolygonCollider(points, center = Vector.Zero) {
            const poly = Shape.Polygon(points, center);
            return this.set(poly);
        }
        /**
     * Sets up a [[Circle|circle collision geometry]] as the only collider with a specified radius in pixels.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useCircleCollider(radius, center = Vector.Zero) {
            const collider = Shape.Circle(radius, center);
            return this.set(collider);
        }
        /**
     * Sets up an [[Edge|edge collision geometry]] with a start point and an end point relative to the anchor of the associated actor
     * of this physics body.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useEdgeCollider(begin, end) {
            const collider = Shape.Edge(begin, end);
            return this.set(collider);
        }
        /**
     * Setups up a [[CompositeCollider]] which can define any arbitrary set of excalibur colliders
     * @param colliders
     */ useCompositeCollider(colliders) {
            return this.set(new CompositeCollider(colliders));
        }
    }
    var DegreeOfFreedom;
    (function(DegreeOfFreedom) {
        DegreeOfFreedom["Rotation"] = "rotation";
        DegreeOfFreedom["X"] = "x";
        DegreeOfFreedom["Y"] = "y";
    })(DegreeOfFreedom || (DegreeOfFreedom = {}));
    /**
 * Body describes all the physical properties pos, vel, acc, rotation, angular velocity for the purpose of
 * of physics simulation.
 */ class BodyComponent extends Component {
        constructor(options){
            var _a, _b, _c;
            super();
            this.dependencies = [
                TransformComponent,
                MotionComponent
            ];
            this.id = createId("body", BodyComponent._ID++);
            this.events = new EventEmitter();
            this.oldTransform = new transform_Transform();
            /**
         * Indicates whether the old transform has been captured at least once for interpolation
         * @internal
         */ this.__oldTransformCaptured = false;
            /**
         * Enable or disabled the fixed update interpolation, by default interpolation is on.
         */ this.enableFixedUpdateInterpolate = true;
            /**
         * Collision type for the rigidbody physics simulation, by default [[CollisionType.PreventCollision]]
         */ this.collisionType = CollisionType.PreventCollision;
            /**
         * The collision group for the body's colliders, by default body colliders collide with everything
         */ this.group = CollisionGroup.All;
            this._sleeping = false;
            /**
         * The also known as coefficient of restitution of this actor, represents the amount of energy preserved after collision or the
         * bounciness. If 1, it is 100% bouncy, 0 it completely absorbs.
         */ this.bounciness = 0.2;
            /**
         * The coefficient of friction on this actor
         */ this.friction = 0.99;
            /**
         * Should use global gravity [[Physics.gravity]] in it's physics simulation, default is true
         */ this.useGravity = true;
            /**
         * Degrees of freedom to limit
         *
         * Note: this only limits responses in the realistic solver, if velocity/angularVelocity is set the actor will still respond
         */ this.limitDegreeOfFreedom = [];
            /**
         * The velocity of the actor last frame (vx, vy) in pixels/second
         */ this.oldVel = new Vector(0, 0);
            /**
         * Gets/sets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
         */ this.oldAcc = Vector.Zero;
            if (options) {
                this.collisionType = (_a = options.type) !== null && _a !== void 0 ? _a : this.collisionType;
                this.group = (_b = options.group) !== null && _b !== void 0 ? _b : this.group;
                this.useGravity = (_c = options.useGravity) !== null && _c !== void 0 ? _c : this.useGravity;
                this._bodyConfig = {
                    ...DefaultPhysicsConfig.bodies,
                    ...options.config
                };
            } else this._bodyConfig = {
                ...DefaultPhysicsConfig.bodies
            };
            this.updatePhysicsConfig(this._bodyConfig);
            this._mass = BodyComponent._DEFAULT_CONFIG.defaultMass;
        }
        get matrix() {
            return this.transform.get().matrix;
        }
        /**
     * Called by excalibur to update physics config defaults if they change
     * @param config
     */ updatePhysicsConfig(config) {
            this._bodyConfig = {
                ...DefaultPhysicsConfig.bodies,
                ...config
            };
            this.canSleep = this._bodyConfig.canSleepByDefault;
            this.sleepMotion = this._bodyConfig.sleepEpsilon * 5;
            this.wakeThreshold = this._bodyConfig.wakeThreshold;
        }
        /**
     * Called by excalibur to update defaults
     * @param config
     */ static updateDefaultPhysicsConfig(config) {
            BodyComponent._DEFAULT_CONFIG = config;
        }
        get mass() {
            return this._mass;
        }
        set mass(newMass) {
            this._mass = newMass;
            this._cachedInertia = undefined;
            this._cachedInverseInertia = undefined;
        }
        /**
     * The inverse mass (1/mass) of the body. If [[CollisionType.Fixed]] this is 0, meaning "infinite" mass
     */ get inverseMass() {
            return this.collisionType === CollisionType.Fixed ? 0 : 1 / this.mass;
        }
        /**
     * Whether this body is sleeping or not
     */ get sleeping() {
            return this._sleeping;
        }
        /**
     * Set the sleep state of the body
     * @param sleeping
     */ setSleeping(sleeping) {
            this._sleeping = sleeping;
            if (!sleeping) // Give it a kick to keep it from falling asleep immediately
            this.sleepMotion = this._bodyConfig.sleepEpsilon * 5;
            else {
                this.vel = Vector.Zero;
                this.acc = Vector.Zero;
                this.angularVelocity = 0;
                this.sleepMotion = 0;
            }
        }
        /**
     * Update body's [[BodyComponent.sleepMotion]] for the purpose of sleeping
     */ updateMotion() {
            if (this._sleeping) this.setSleeping(true);
            const currentMotion = this.vel.size * this.vel.size + Math.abs(this.angularVelocity * this.angularVelocity);
            const bias = this._bodyConfig.sleepBias;
            this.sleepMotion = bias * this.sleepMotion + (1 - bias) * currentMotion;
            this.sleepMotion = clamp(this.sleepMotion, 0, 10 * this._bodyConfig.sleepEpsilon);
            if (this.canSleep && this.sleepMotion < this._bodyConfig.sleepEpsilon) this.setSleeping(true);
        }
        /**
     * Get the moment of inertia from the [[ColliderComponent]]
     */ get inertia() {
            if (this._cachedInertia) return this._cachedInertia;
            // Inertia is a property of the geometry, so this is a little goofy but seems to be okay?
            const collider = this.owner.get(ColliderComponent);
            if (collider) {
                collider.$colliderAdded.subscribe(()=>{
                    this._cachedInertia = null;
                });
                collider.$colliderRemoved.subscribe(()=>{
                    this._cachedInertia = null;
                });
                const maybeCollider = collider.get();
                if (maybeCollider) return this._cachedInertia = maybeCollider.getInertia(this.mass);
            }
            return 0;
        }
        /**
     * Get the inverse moment of inertial from the [[ColliderComponent]]. If [[CollisionType.Fixed]] this is 0, meaning "infinite" mass
     */ get inverseInertia() {
            if (this._cachedInverseInertia) return this._cachedInverseInertia;
            return this._cachedInverseInertia = this.collisionType === CollisionType.Fixed ? 0 : 1 / this.inertia;
        }
        /**
     * Returns if the owner is active
     */ get active() {
            var _a;
            return !!((_a = this.owner) === null || _a === void 0 ? void 0 : _a.active);
        }
        /**
     * @deprecated Use globalP0s
     */ get center() {
            return this.globalPos;
        }
        get transform() {
            var _a;
            return (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
        }
        get motion() {
            var _a;
            return (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(MotionComponent);
        }
        get pos() {
            return this.transform.pos;
        }
        set pos(val) {
            this.transform.pos = val;
        }
        /**
     * The (x, y) position of the actor this will be in the middle of the actor if the
     * [[Actor.anchor]] is set to (0.5, 0.5) which is default.
     * If you want the (x, y) position to be the top left of the actor specify an anchor of (0, 0).
     */ get globalPos() {
            return this.transform.globalPos;
        }
        set globalPos(val) {
            this.transform.globalPos = val;
        }
        /**
     * The position of the actor last frame (x, y) in pixels
     */ get oldPos() {
            return this.oldTransform.pos;
        }
        /**
     * The current velocity vector (vx, vy) of the actor in pixels/second
     */ get vel() {
            return this.motion.vel;
        }
        set vel(val) {
            this.motion.vel = val;
        }
        /**
     * The current acceleration vector (ax, ay) of the actor in pixels/second/second. An acceleration pointing down such as (0, 100) may
     * be useful to simulate a gravitational effect.
     */ get acc() {
            return this.motion.acc;
        }
        set acc(val) {
            this.motion.acc = val;
        }
        /**
     * The current torque applied to the actor
     */ get torque() {
            return this.motion.torque;
        }
        set torque(val) {
            this.motion.torque = val;
        }
        /**
     * Gets/sets the rotation of the body from the last frame.
     */ get oldRotation() {
            return this.oldTransform.rotation;
        }
        /**
     * The rotation of the body in radians
     */ get rotation() {
            return this.transform.globalRotation;
        }
        set rotation(val) {
            this.transform.globalRotation = val;
        }
        /**
     * The scale vector of the actor
     */ get scale() {
            return this.transform.globalScale;
        }
        set scale(val) {
            this.transform.globalScale = val;
        }
        /**
     * The scale of the actor last frame
     */ get oldScale() {
            return this.oldTransform.scale;
        }
        /**
     * The scale rate of change of the actor in scale/second
     */ get scaleFactor() {
            return this.motion.scaleFactor;
        }
        set scaleFactor(scaleFactor) {
            this.motion.scaleFactor = scaleFactor;
        }
        /**
     * Get the angular velocity in radians/second
     */ get angularVelocity() {
            return this.motion.angularVelocity;
        }
        /**
     * Set the angular velocity in radians/second
     */ set angularVelocity(value) {
            this.motion.angularVelocity = value;
        }
        /**
     * Apply a specific impulse to the body
     * @param point
     * @param impulse
     */ applyImpulse(point, impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            const finalImpulse = impulse.scale(this.inverseMass);
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) finalImpulse.x = 0;
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) finalImpulse.y = 0;
            this.vel.addEqual(finalImpulse);
            if (!this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) {
                const distanceFromCenter = point.sub(this.globalPos);
                this.angularVelocity += this.inverseInertia * distanceFromCenter.cross(impulse);
            }
        }
        /**
     * Apply only linear impulse to the body
     * @param impulse
     */ applyLinearImpulse(impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            const finalImpulse = impulse.scale(this.inverseMass);
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) finalImpulse.x = 0;
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) finalImpulse.y = 0;
            this.vel = this.vel.add(finalImpulse);
        }
        /**
     * Apply only angular impulse to the body
     * @param point
     * @param impulse
     */ applyAngularImpulse(point, impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            if (!this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) {
                const distanceFromCenter = point.sub(this.globalPos);
                this.angularVelocity += this.inverseInertia * distanceFromCenter.cross(impulse);
            }
        }
        /**
     * Sets the old versions of pos, vel, acc, and scale.
     */ captureOldTransform() {
            // Capture old values before integration step updates them
            this.__oldTransformCaptured = true;
            const tx = this.transform.get();
            tx.clone(this.oldTransform);
            this.oldTransform.parent = tx.parent; // also grab parent
            this.oldVel.setTo(this.vel.x, this.vel.y);
            this.oldAcc.setTo(this.acc.x, this.acc.y);
        }
        clone() {
            const component = super.clone();
            return component;
        }
    }
    BodyComponent._ID = 0;
    BodyComponent._DEFAULT_CONFIG = {
        ...DefaultPhysicsConfig.bodies
    };
    /**
 * AddedComponent message
 */ class AddedComponent {
        constructor(data){
            this.data = data;
            this.type = "Component Added";
        }
    }
    /**
 * Type guard to know if message is f an Added Component
 */ function isAddedComponent(x) {
        return !!x && x.type === "Component Added";
    }
    /**
 * RemovedComponent message
 */ class RemovedComponent {
        constructor(data){
            this.data = data;
            this.type = "Component Removed";
        }
    }
    /**
 * Type guard to know if message is for a Removed Component
 */ function isRemovedComponent(x) {
        return !!x && x.type === "Component Removed";
    }
    const EntityEvents = {
        Initialize: "initialize",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        Kill: "kill"
    };
    /**
 * An Entity is the base type of anything that can have behavior in Excalibur, they are part of the built in entity component system
 *
 * Entities can be strongly typed with the components they contain
 *
 * ```typescript
 * const entity = new Entity<ComponentA | ComponentB>();
 * entity.components.a; // Type ComponentA
 * entity.components.b; // Type ComponentB
 * ```
 */ class Entity {
        constructor(componentsOrOptions, name){
            /**
         * The unique identifier for the entity
         */ this.id = Entity._ID++;
            this.name = `Entity#${this.id}`;
            /**
         * Listen to or emit events for an entity
         */ this.events = new EventEmitter();
            this._tags = new Set();
            this.componentAdded$ = new Observable;
            this.componentRemoved$ = new Observable;
            this.tagAdded$ = new Observable;
            this.tagRemoved$ = new Observable;
            /**
         * Current components on the entity
         *
         * **Do not modify**
         *
         * Use addComponent/removeComponent otherwise the ECS will not be notified of changes.
         */ this.components = new Map();
            this._componentsToRemove = [];
            this._instanceOfComponentCacheDirty = true;
            this._instanceOfComponentCache = new Map();
            /**
         * The current scene that the entity is in, if any
         */ this.scene = null;
            /**
         * Whether this entity is active, if set to false it will be reclaimed
         */ this.active = true;
            this._parent = null;
            this.childrenAdded$ = new Observable();
            this.childrenRemoved$ = new Observable();
            this._children = [];
            this._isInitialized = false;
            let componentsToAdd;
            let nameToAdd;
            if (Array.isArray(componentsOrOptions)) {
                componentsToAdd = componentsOrOptions;
                nameToAdd = name;
            } else if (componentsOrOptions && typeof componentsOrOptions === "object") {
                const { components: components, name: name } = componentsOrOptions;
                componentsToAdd = components !== null && components !== void 0 ? components : [];
                nameToAdd = name;
            }
            if (nameToAdd) this.name = nameToAdd;
            if (componentsToAdd) for (const component of componentsToAdd)this.addComponent(component);
        // this.addComponent(this.tagsComponent);
        }
        /**
     * Kill the entity, means it will no longer be updated. Kills are deferred to the end of the update.
     * If parented it will be removed from the parent when killed.
     */ kill() {
            if (this.active) {
                this.active = false;
                this.unparent();
            }
            this.emit("kill", new KillEvent(this));
        }
        isKilled() {
            return !this.active;
        }
        /**
     * Specifically get the tags on the entity from [[TagsComponent]]
     */ get tags() {
            return this._tags;
        }
        /**
     * Check if a tag exists on the entity
     * @param tag name to check for
     */ hasTag(tag) {
            return this._tags.has(tag);
        }
        /**
     * Adds a tag to an entity
     * @param tag
     */ addTag(tag) {
            this._tags.add(tag);
            this.tagAdded$.notifyAll(tag);
            return this;
        }
        /**
     * Removes a tag on the entity
     *
     * Removals are deferred until the end of update
     * @param tag
     */ removeTag(tag) {
            this._tags.delete(tag);
            this.tagRemoved$.notifyAll(tag);
            return this;
        }
        /**
     * The types of the components on the Entity
     */ get types() {
            return Array.from(this.components.keys());
        }
        /**
     * Returns all component instances on entity
     */ getComponents() {
            return Array.from(this.components.values());
        }
        /**
     * Verifies that an entity has all the required types
     * @param requiredTypes
     */ hasAll(requiredTypes) {
            for(let i = 0; i < requiredTypes.length; i++){
                if (!this.components.has(requiredTypes[i])) return false;
            }
            return true;
        }
        /**
     * Verifies that an entity has all the required tags
     * @param requiredTags
     */ hasAllTags(requiredTags) {
            for(let i = 0; i < requiredTags.length; i++){
                if (!this.tags.has(requiredTags[i])) return false;
            }
            return true;
        }
        _getCachedInstanceOfType(type) {
            if (this._instanceOfComponentCacheDirty) {
                this._instanceOfComponentCacheDirty = false;
                this._instanceOfComponentCache.clear();
            }
            if (this._instanceOfComponentCache.has(type)) return this._instanceOfComponentCache.get(type);
            for (const instance of this.components.values())if (instance instanceof type) {
                this._instanceOfComponentCache.set(type, instance);
                return instance;
            }
            return undefined;
        }
        get(type) {
            const maybeComponent = this._getCachedInstanceOfType(type);
            return maybeComponent !== null && maybeComponent !== void 0 ? maybeComponent : this.components.get(type);
        }
        get parent() {
            return this._parent;
        }
        /**
     * Get the direct children of this entity
     */ get children() {
            return this._children;
        }
        /**
     * Unparents this entity, if there is a parent. Otherwise it does nothing.
     */ unparent() {
            if (this._parent) {
                this._parent.removeChild(this);
                this._parent = null;
            }
        }
        /**
     * Adds an entity to be a child of this entity
     * @param entity
     */ addChild(entity) {
            if (entity.parent === null) {
                if (this.getAncestors().includes(entity)) throw new Error("Cycle detected, cannot add entity");
                this._children.push(entity);
                entity._parent = this;
                this.childrenAdded$.notifyAll(entity);
            } else throw new Error("Entity already has a parent, cannot add without unparenting");
            return this;
        }
        /**
     * Remove an entity from children if it exists
     * @param entity
     */ removeChild(entity) {
            if (entity.parent === this) {
                removeItemFromArray(entity, this._children);
                entity._parent = null;
                this.childrenRemoved$.notifyAll(entity);
            }
            return this;
        }
        /**
     * Removes all children from this entity
     */ removeAllChildren() {
            // Avoid modifying the array issue by walking backwards
            for(let i = this.children.length - 1; i >= 0; i--)this.removeChild(this.children[i]);
            return this;
        }
        /**
     * Returns a list of parent entities starting with the topmost parent. Includes the current entity.
     */ getAncestors() {
            const result = [
                this
            ];
            let current = this.parent;
            while(current){
                result.push(current);
                current = current.parent;
            }
            return result.reverse();
        }
        /**
     * Returns a list of all the entities that descend from this entity. Includes the current entity.
     */ getDescendants() {
            let result = [
                this
            ];
            let queue = [
                this
            ];
            while(queue.length > 0){
                const curr = queue.pop();
                if (curr) {
                    queue = queue.concat(curr.children);
                    result = result.concat(curr.children);
                }
            }
            return result;
        }
        /**
     * Creates a deep copy of the entity and a copy of all its components
     */ clone() {
            const newEntity = new Entity();
            for (const c of this.types){
                const componentInstance = this.get(c);
                if (componentInstance) newEntity.addComponent(componentInstance.clone());
            }
            for (const child of this.children)newEntity.addChild(child.clone());
            return newEntity;
        }
        /**
     * Adds a copy of all the components from another template entity as a "prefab"
     * @param templateEntity Entity to use as a template
     * @param force Force component replacement if it already exists on the target entity
     */ addTemplate(templateEntity, force = false) {
            for (const c of templateEntity.getComponents())this.addComponent(c.clone(), force);
            for (const child of templateEntity.children)this.addChild(child.clone().addTemplate(child));
            return this;
        }
        /**
     * Adds a component to the entity
     * @param component Component or Entity to add copy of components from
     * @param force Optionally overwrite any existing components of the same type
     */ addComponent(component, force = false) {
            this._instanceOfComponentCacheDirty = true;
            // if component already exists, skip if not forced
            if (this.has(component.constructor)) {
                if (force) // Remove existing component type if exists when forced
                this.removeComponent(component.constructor, true);
                else // early exit component exits
                return this;
            }
            // TODO circular dependencies will be a problem
            if (component.dependencies && component.dependencies.length) for (const ctor of component.dependencies)this.addComponent(new ctor());
            component.owner = this;
            this.components.set(component.constructor, component);
            if (component.onAdd) component.onAdd(this);
            this.componentAdded$.notifyAll(component);
            return this;
        }
        /**
     * Removes a component from the entity, by default removals are deferred to the end of entity update to avoid consistency issues
     *
     * Components can be force removed with the `force` flag, the removal is not deferred and happens immediately
     * @param typeOrInstance
     * @param force
     */ removeComponent(typeOrInstance, force = false) {
            let type;
            if (isComponentCtor(typeOrInstance)) type = typeOrInstance;
            else type = typeOrInstance.constructor;
            if (force) {
                const componentToRemove = this.components.get(type);
                if (componentToRemove) {
                    this.componentRemoved$.notifyAll(componentToRemove);
                    componentToRemove.owner = undefined;
                    if (componentToRemove.onRemove) componentToRemove.onRemove(this);
                }
                this.components.delete(type); // remove after the notify to preserve typing
                this._instanceOfComponentCacheDirty = true;
            } else this._componentsToRemove.push(type);
            return this;
        }
        clearComponents() {
            const components = this.types;
            for (const c of components)this.removeComponent(c);
        }
        /**
     * @hidden
     * @internal
     */ processComponentRemoval() {
            for (const type of this._componentsToRemove)this.removeComponent(type, true);
            this._componentsToRemove.length = 0;
        }
        /**
     * Check if a component type exists
     * @param type
     */ has(type) {
            return this.components.has(type);
        }
        /**
     * Gets whether the actor is Initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        /**
     * Initializes this entity, meant to be called by the Scene before first update not by users of Excalibur.
     *
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     * @internal
     */ _initialize(engine) {
            if (!this.isInitialized) {
                this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * `onInitialize` is called before the first update of the entity. This method is meant to be
     * overridden.
     *
     * Synonymous with the event handler `.on('initialize', (evt) => {...})`
     */ onInitialize(engine) {
        // Override me
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before an entity is updated.
     */ onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('postupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after an entity is updated.
     */ onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     *
     * Entity update lifecycle, called internally
     * @internal
     * @param engine
     * @param delta
     */ update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            for (const child of this.children)child.update(engine, delta);
            this._postupdate(engine, delta);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            if (handler) this.events.off(eventName, handler);
            else this.events.off(eventName);
        }
    }
    Entity._ID = 0;
    var AnimationDirection;
    (function(AnimationDirection) {
        /**
     * Animation is playing forwards
     */ AnimationDirection["Forward"] = "forward";
        /**
     * Animation is playing backwards
     */ AnimationDirection["Backward"] = "backward";
    })(AnimationDirection || (AnimationDirection = {}));
    var AnimationStrategy;
    (function(AnimationStrategy) {
        /**
     * Animation ends without displaying anything
     */ AnimationStrategy["End"] = "end";
        /**
     * Animation loops to the first frame after the last frame
     */ AnimationStrategy["Loop"] = "loop";
        /**
     * Animation plays to the last frame, then backwards to the first frame, then repeats
     */ AnimationStrategy["PingPong"] = "pingpong";
        /**
     * Animation ends stopping on the last frame
     */ AnimationStrategy["Freeze"] = "freeze";
    })(AnimationStrategy || (AnimationStrategy = {}));
    const AnimationEvents = {
        Frame: "frame",
        Loop: "loop",
        End: "end"
    };
    /**
 * Create an Animation given a list of [[Frame|frames]] in [[AnimationOptions]]
 *
 * To create an Animation from a [[SpriteSheet]], use [[Animation.fromSpriteSheet]]
 */ class Animation extends Graphic {
        constructor(options){
            var _a, _b, _c;
            super(options);
            this.events = new EventEmitter();
            this.frames = [];
            this.strategy = AnimationStrategy.Loop;
            this.frameDuration = 100;
            this._idempotencyToken = -1;
            this._firstTick = true;
            this._currentFrame = 0;
            this._timeLeftInFrame = 0;
            this._pingPongDirection = 1;
            this._done = false;
            this._playing = true;
            this._speed = 1;
            this._reversed = false;
            this.frames = options.frames;
            this.speed = (_a = options.speed) !== null && _a !== void 0 ? _a : this.speed;
            this.strategy = (_b = options.strategy) !== null && _b !== void 0 ? _b : this.strategy;
            this.frameDuration = options.totalDuration ? options.totalDuration / this.frames.length : (_c = options.frameDuration) !== null && _c !== void 0 ? _c : this.frameDuration;
            if (options.reverse) this.reverse();
            this.goToFrame(0);
        }
        clone() {
            return new Animation({
                frames: this.frames.map((f)=>({
                        ...f
                    })),
                frameDuration: this.frameDuration,
                speed: this.speed,
                reverse: this._reversed,
                strategy: this.strategy,
                ...this.cloneGraphicOptions()
            });
        }
        get width() {
            const maybeFrame = this.currentFrame;
            if (maybeFrame) return Math.abs(maybeFrame.graphic.width * this.scale.x);
            return 0;
        }
        get height() {
            const maybeFrame = this.currentFrame;
            if (maybeFrame) return Math.abs(maybeFrame.graphic.height * this.scale.y);
            return 0;
        }
        /**
     * Create an Animation from a [[SpriteSheet]], a list of indices into the sprite sheet, a duration per frame
     * and optional [[AnimationStrategy]]
     *
     * Example:
     * ```typescript
     * const spriteSheet = SpriteSheet.fromImageSource({...});
     *
     * const anim = Animation.fromSpriteSheet(spriteSheet, range(0, 5), 200, AnimationStrategy.Loop);
     * ```
     * @param spriteSheet
     * @param frameIndices
     * @param durationPerFrameMs
     * @param strategy
     */ static fromSpriteSheet(spriteSheet, frameIndices, durationPerFrameMs, strategy = AnimationStrategy.Loop) {
            const maxIndex = spriteSheet.sprites.length - 1;
            const invalidIndices = frameIndices.filter((index)=>index < 0 || index > maxIndex);
            if (invalidIndices.length) Animation._LOGGER.warn(`Indices into SpriteSheet were provided that don\'t exist: ${invalidIndices.join(",")} no frame will be shown`);
            return new Animation({
                frames: spriteSheet.sprites.filter((_, index)=>frameIndices.indexOf(index) > -1).map((f)=>({
                        graphic: f,
                        duration: durationPerFrameMs
                    })),
                strategy: strategy
            });
        }
        /**
     * Create an [[Animation]] from a [[SpriteSheet]] given a list of coordinates
     *
     * Example:
     * ```typescript
     * const spriteSheet = SpriteSheet.fromImageSource({...});
     *
     * const anim = Animation.fromSpriteSheetCoordinates({
     *  spriteSheet,
     *  frameCoordinates: [
     *    {x: 0, y: 5, duration: 100, options { flipHorizontal: true }},
     *    {x: 1, y: 5, duration: 200},
     *    {x: 2, y: 5, duration: 100},
     *    {x: 3, y: 5, duration: 500}
     *  ],
     *  strategy: AnimationStrategy.PingPong
     * });
     * ```
     * @param options
     * @returns Animation
     */ static fromSpriteSheetCoordinates(options) {
            const { spriteSheet: spriteSheet, frameCoordinates: frameCoordinates, durationPerFrameMs: durationPerFrameMs, speed: speed, strategy: strategy, reverse: reverse } = options;
            const defaultDuration = durationPerFrameMs !== null && durationPerFrameMs !== void 0 ? durationPerFrameMs : 100;
            const frames = [];
            for (const coord of frameCoordinates){
                const { x: x, y: y, duration: duration, options: options } = coord;
                const sprite = spriteSheet.getSprite(x, y, options);
                if (sprite) frames.push({
                    graphic: sprite,
                    duration: duration !== null && duration !== void 0 ? duration : defaultDuration
                });
                else Animation._LOGGER.warn(`Skipping frame! SpriteSheet does not have coordinate (${x}, ${y}), please check your SpriteSheet to confirm that sprite exists`);
            }
            return new Animation({
                frames: frames,
                strategy: strategy,
                speed: speed,
                reverse: reverse
            });
        }
        /**
     * Current animation speed
     *
     * 1 meaning normal 1x speed.
     * 2 meaning 2x speed and so on.
     */ get speed() {
            return this._speed;
        }
        /**
     * Current animation speed
     *
     * 1 meaning normal 1x speed.
     * 2 meaning 2x speed and so on.
     */ set speed(val) {
            this._speed = clamp(Math.abs(val), 0, Infinity);
        }
        /**
     * Returns the current Frame of the animation
     *
     * Use [[Animation.currentFrameIndex]] to get the frame number and
     * [[Animation.goToFrame]] to set the current frame index
     */ get currentFrame() {
            if (this._currentFrame >= 0 && this._currentFrame < this.frames.length) return this.frames[this._currentFrame];
            return null;
        }
        /**
     * Returns the current frame index of the animation
     *
     * Use [[Animation.currentFrame]] to grab the current [[Frame]] object
     */ get currentFrameIndex() {
            return this._currentFrame;
        }
        /**
     * Returns the amount of time in milliseconds left in the current frame
     */ get currentFrameTimeLeft() {
            return this._timeLeftInFrame;
        }
        /**
     * Returns `true` if the animation is playing
     */ get isPlaying() {
            return this._playing;
        }
        /**
     * Reverses the play direction of the Animation, this preserves the current frame
     */ reverse() {
            // Don't mutate with the original frame list, create a copy
            this.frames = this.frames.slice().reverse();
            this._reversed = !this._reversed;
        }
        /**
     * Returns the current play direction of the animation
     */ get direction() {
            // Keep logically consistent with ping-pong direction
            // If ping-pong is forward = 1 and reversed is true then we are logically reversed
            const reversed = this._reversed && this._pingPongDirection === 1 ? true : false;
            return reversed ? AnimationDirection.Backward : AnimationDirection.Forward;
        }
        /**
     * Plays or resumes the animation from the current frame
     */ play() {
            this._playing = true;
        }
        /**
     * Pauses the animation on the current frame
     */ pause() {
            this._playing = false;
            this._firstTick = true; // firstTick must be set to emit the proper frame event
        }
        /**
     * Reset the animation back to the beginning, including if the animation were done
     */ reset() {
            this._done = false;
            this._firstTick = true;
            this._currentFrame = 0;
            this._timeLeftInFrame = this.frameDuration;
            const maybeFrame = this.frames[this._currentFrame];
            if (maybeFrame) this._timeLeftInFrame = (maybeFrame === null || maybeFrame === void 0 ? void 0 : maybeFrame.duration) || this.frameDuration;
        }
        /**
     * Returns `true` if the animation can end
     */ get canFinish() {
            switch(this.strategy){
                case AnimationStrategy.End:
                case AnimationStrategy.Freeze:
                    return true;
                default:
                    return false;
            }
        }
        /**
     * Returns `true` if the animation is done, for looping type animations
     * `ex.AnimationStrategy.PingPong` and `ex.AnimationStrategy.Loop` this will always return `false`
     *
     * See the `ex.Animation.canFinish()` method to know if an animation type can end
     */ get done() {
            return this._done;
        }
        /**
     * Jump the animation immediately to a specific frame if it exists
     *
     * Optionally specify an override for the duration of the frame, useful for
     * keeping multiple animations in sync with one another.
     * @param frameNumber
     * @param duration
     */ goToFrame(frameNumber, duration) {
            this._currentFrame = frameNumber;
            this._timeLeftInFrame = duration !== null && duration !== void 0 ? duration : this.frameDuration;
            const maybeFrame = this.frames[this._currentFrame];
            if (maybeFrame && !this._done) {
                this._timeLeftInFrame = duration !== null && duration !== void 0 ? duration : (maybeFrame === null || maybeFrame === void 0 ? void 0 : maybeFrame.duration) || this.frameDuration;
                this.events.emit("frame", {
                    ...maybeFrame,
                    frameIndex: this.currentFrameIndex
                });
            }
        }
        _nextFrame() {
            const currentFrame = this._currentFrame;
            if (this._done) return currentFrame;
            let next = -1;
            switch(this.strategy){
                case AnimationStrategy.Loop:
                    next = (currentFrame + 1) % this.frames.length;
                    if (next === 0) this.events.emit("loop", this);
                    break;
                case AnimationStrategy.End:
                    next = currentFrame + 1;
                    if (next >= this.frames.length) {
                        this._done = true;
                        this._currentFrame = this.frames.length;
                        this.events.emit("end", this);
                    }
                    break;
                case AnimationStrategy.Freeze:
                    next = clamp(currentFrame + 1, 0, this.frames.length - 1);
                    if (next >= this.frames.length - 1) {
                        this._done = true;
                        this.events.emit("end", this);
                    }
                    break;
                case AnimationStrategy.PingPong:
                    if (currentFrame + this._pingPongDirection >= this.frames.length) {
                        this._pingPongDirection = -1;
                        this.events.emit("loop", this);
                    }
                    if (currentFrame + this._pingPongDirection < 0) {
                        this._pingPongDirection = 1;
                        this.events.emit("loop", this);
                    }
                    next = currentFrame + this._pingPongDirection % this.frames.length;
                    break;
            }
            return next;
        }
        /**
     * Called internally by Excalibur to update the state of the animation potential update the current frame
     * @param elapsedMilliseconds Milliseconds elapsed
     * @param idempotencyToken Prevents double ticking in a frame by passing a unique token to the frame
     */ tick(elapsedMilliseconds, idempotencyToken = 0) {
            if (this._idempotencyToken === idempotencyToken) return;
            this._idempotencyToken = idempotencyToken;
            if (!this._playing) return;
            // if it's the first frame emit frame event
            if (this._firstTick) {
                this._firstTick = false;
                this.events.emit("frame", {
                    ...this.currentFrame,
                    frameIndex: this.currentFrameIndex
                });
            }
            this._timeLeftInFrame -= elapsedMilliseconds * this._speed;
            if (this._timeLeftInFrame <= 0) this.goToFrame(this._nextFrame());
        }
        _drawImage(ctx, x, y) {
            if (this.currentFrame) this.currentFrame.graphic.draw(ctx, x, y);
        }
    }
    Animation._LOGGER = Logger.getInstance();
    class GraphicsGroup extends Graphic {
        constructor(options){
            var _a;
            super(options);
            this._logger = Logger.getInstance();
            this.useAnchor = true;
            this.members = [];
            this.members = options.members;
            this.useAnchor = (_a = options.useAnchor) !== null && _a !== void 0 ? _a : this.useAnchor;
            this._updateDimensions();
        }
        clone() {
            return new GraphicsGroup({
                members: [
                    ...this.members
                ],
                ...this.cloneGraphicOptions()
            });
        }
        _updateDimensions() {
            const bb = this.localBounds;
            this.width = bb.width;
            this.height = bb.height;
            return bb;
        }
        get localBounds() {
            let bb = new BoundingBox();
            for (const member of this.members)if (member instanceof Graphic) bb = member.localBounds.combine(bb);
            else {
                const { graphic: graphic, offset: pos, useBounds: useBounds } = member;
                const shouldUseBounds = useBounds === undefined ? true : useBounds;
                if (graphic) {
                    if (shouldUseBounds) bb = graphic.localBounds.translate(pos).combine(bb);
                } else this._logger.warnOnce(`Graphics group member has an null or undefined graphic, member definition: ${JSON.stringify(member)}.`);
            }
            return bb;
        }
        _isAnimationOrGroup(graphic) {
            return graphic instanceof Animation || graphic instanceof GraphicsGroup;
        }
        tick(elapsedMilliseconds, idempotencyToken) {
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else graphic = member.graphic;
                if (this._isAnimationOrGroup(graphic)) graphic.tick(elapsedMilliseconds, idempotencyToken);
            }
        }
        reset() {
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else graphic = member.graphic;
                if (this._isAnimationOrGroup(graphic)) graphic.reset();
            }
        }
        _preDraw(ex, x, y) {
            this._updateDimensions();
            super._preDraw(ex, this.useAnchor ? x : 0, this.useAnchor ? y : 0);
        }
        _drawImage(ex, x, y) {
            const pos = Vector.Zero;
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else {
                    graphic = member.graphic;
                    member.offset.clone(pos);
                }
                if (!graphic) continue;
                ex.save();
                ex.translate(x, y);
                graphic.draw(ex, pos.x, pos.y);
                if (this.showDebug) /* istanbul ignore next */ ex.debug.drawRect(0, 0, this.width, this.height);
                ex.restore();
            }
        }
    }
    /**
 * Type guard for checking if a Graphic HasTick (used for graphics that change over time like animations)
 * @param graphic
 */ function hasGraphicsTick(graphic) {
        return !!graphic.tick;
    }
    /**
 * Component to manage drawings, using with the position component
 */ class GraphicsComponent extends Component {
        /**
     * Offset to apply to graphics by default
     */ get offset() {
            return new WatchVector(this._offset, ()=>{
                this.recalculateBounds();
            });
        }
        set offset(value) {
            this._offset = value;
            this.recalculateBounds();
        }
        /**
     * Anchor to apply to graphics by default
     */ get anchor() {
            return new WatchVector(this._anchor, ()=>{
                this.recalculateBounds();
            });
        }
        set anchor(value) {
            this._anchor = value;
            this.recalculateBounds();
        }
        constructor(options){
            super();
            this._logger = Logger.getInstance();
            this._current = "default";
            this._graphics = {};
            this._options = {};
            this.material = null;
            /**
         * Sets or gets wether any drawing should be visible in this component
         */ this.visible = true;
            /**
         * Sets or gets wither all drawings should have an opacity applied
         */ this.opacity = 1;
            this._offset = Vector.Zero;
            this._anchor = Vector.Half;
            /**
         * Flip all graphics horizontally along the y-axis
         */ this.flipHorizontal = false;
            /**
         * Flip all graphics vertically along the x-axis
         */ this.flipVertical = false;
            /**
         * If set to true graphics added to the component will be copied. This can effect performance, but is useful if you don't want
         * changes to a graphic to effect all the places it is used.
         */ this.copyGraphics = false;
            this._localBounds = null;
            // Defaults
            options = {
                visible: this.visible,
                graphics: {},
                ...options
            };
            const { current: current, anchor: anchor, opacity: opacity, visible: visible, graphics: graphics, offset: offset, copyGraphics: copyGraphics, onPreDraw: onPreDraw, onPostDraw: onPostDraw, onPreTransformDraw: onPreTransformDraw, onPostTransformDraw: onPostTransformDraw } = options;
            for (const [key, graphicOrOptions] of Object.entries(graphics))if (graphicOrOptions instanceof Graphic) this._graphics[key] = graphicOrOptions;
            else {
                this._graphics[key] = graphicOrOptions.graphic;
                this._options[key] = graphicOrOptions.options;
            }
            this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
            this.opacity = opacity !== null && opacity !== void 0 ? opacity : this.opacity;
            this.anchor = anchor !== null && anchor !== void 0 ? anchor : this.anchor;
            this.copyGraphics = copyGraphics !== null && copyGraphics !== void 0 ? copyGraphics : this.copyGraphics;
            this.onPreDraw = onPreDraw !== null && onPreDraw !== void 0 ? onPreDraw : this.onPreDraw;
            this.onPostDraw = onPostDraw !== null && onPostDraw !== void 0 ? onPostDraw : this.onPostDraw;
            this.onPreDraw = onPreTransformDraw !== null && onPreTransformDraw !== void 0 ? onPreTransformDraw : this.onPreTransformDraw;
            this.onPostTransformDraw = onPostTransformDraw !== null && onPostTransformDraw !== void 0 ? onPostTransformDraw : this.onPostTransformDraw;
            this.visible = !!visible;
            this._current = current !== null && current !== void 0 ? current : this._current;
            if (current && this._graphics[current]) this.use(current);
        }
        getGraphic(name) {
            return this._graphics[name];
        }
        getOptions(name) {
            return this._options[name];
        }
        /**
     * Get registered graphics names
     */ getNames() {
            return Object.keys(this._graphics);
        }
        /**
     * Returns the currently displayed graphic
     */ get current() {
            return this._graphics[this._current];
        }
        /**
     * Returns the currently displayed graphic offsets
     */ get currentOptions() {
            return this._options[this._current];
        }
        /**
     * Returns all graphics associated with this component
     */ get graphics() {
            return this._graphics;
        }
        /**
     * Returns all graphics options associated with this component
     */ get options() {
            return this._options;
        }
        add(nameOrGraphic, graphicOrOptions, options) {
            let name = "default";
            let graphicToSet = null;
            let optionsToSet = undefined;
            if (typeof nameOrGraphic === "string" && graphicOrOptions instanceof Graphic) {
                name = nameOrGraphic;
                graphicToSet = graphicOrOptions;
                optionsToSet = options;
            }
            if (nameOrGraphic instanceof Graphic && !(graphicOrOptions instanceof Graphic)) {
                graphicToSet = nameOrGraphic;
                optionsToSet = graphicOrOptions;
            }
            this._graphics[name] = this.copyGraphics ? graphicToSet.clone() : graphicToSet;
            this._options[name] = this.copyGraphics ? {
                ...optionsToSet
            } : optionsToSet;
            if (name === "default") this.use("default");
            return graphicToSet;
        }
        /**
     * Removes a registered graphic, if the removed graphic is the current it will switch to the default
     * @param name
     */ remove(name) {
            delete this._graphics[name];
            delete this._options[name];
            if (this._current === name) {
                this._current = "default";
                this.recalculateBounds();
            }
        }
        /**
     * Shows a graphic, will be removed
     * @param nameOrGraphic
     * @param options
     * @deprecated will be removed in v0.30.0, use `graphics.use(...)`
     */ show(nameOrGraphic, options) {
            return this.use(nameOrGraphic, options);
        }
        /**
     * Use a graphic only, will set the default graphic. Returns the new [[Graphic]]
     *
     * Optionally override the stored options
     * @param nameOrGraphic
     * @param options
     */ use(nameOrGraphic, options) {
            var _a;
            if (nameOrGraphic instanceof Graphic) {
                let graphic = nameOrGraphic;
                if (this.copyGraphics) graphic = nameOrGraphic.clone();
                this._current = "default";
                this._graphics[this._current] = graphic;
                this._options[this._current] = options;
            } else {
                this._current = nameOrGraphic;
                this._options[this._current] = options;
                if (!(this._current in this._graphics)) this._logger.warn(`Graphic ${this._current} is not registered with the graphics component owned by ${(_a = this.owner) === null || _a === void 0 ? void 0 : _a.name}. Nothing will be drawn.`);
            }
            this.recalculateBounds();
            return this.current;
        }
        /**
     * Hide currently shown graphic
     */ hide() {
            this._current = "ex.none";
        }
        set localBounds(bounds) {
            this._localBounds = bounds;
        }
        recalculateBounds() {
            let bb = new BoundingBox();
            const graphic = this._graphics[this._current];
            const options = this._options[this._current];
            if (!graphic) {
                this._localBounds = bb;
                return;
            }
            let anchor = this.anchor;
            let offset = this.offset;
            if (options === null || options === void 0 ? void 0 : options.anchor) anchor = options.anchor;
            if (options === null || options === void 0 ? void 0 : options.offset) offset = options.offset;
            const bounds = graphic.localBounds;
            const offsetX = -bounds.width * anchor.x + offset.x;
            const offsetY = -bounds.height * anchor.y + offset.y;
            if (graphic instanceof GraphicsGroup && !graphic.useAnchor) bb = graphic === null || graphic === void 0 ? void 0 : graphic.localBounds.combine(bb);
            else bb = graphic === null || graphic === void 0 ? void 0 : graphic.localBounds.translate(vec(offsetX, offsetY)).combine(bb);
            this._localBounds = bb;
        }
        /**
     * Get local bounds of graphics component
     */ get localBounds() {
            if (!this._localBounds || this._localBounds.hasZeroDimensions()) this.recalculateBounds();
            return this._localBounds;
        }
        /**
     * Get world bounds of graphics component
     */ get bounds() {
            let bounds = this.localBounds;
            if (this.owner) {
                const tx = this.owner.get(TransformComponent);
                if (tx) bounds = bounds.transform(tx.get().matrix);
            }
            return bounds;
        }
        /**
     * Update underlying graphics if necessary, called internally
     * @param elapsed
     * @internal
     */ update(elapsed, idempotencyToken = 0) {
            const graphic = this.current;
            if (graphic && hasGraphicsTick(graphic)) graphic.tick(elapsed, idempotencyToken);
        }
        clone() {
            const graphics = new GraphicsComponent();
            graphics._graphics = {
                ...this._graphics
            };
            graphics._options = {
                ...this._options
            };
            graphics.offset = this.offset.clone();
            graphics.opacity = this.opacity;
            graphics.anchor = this.anchor.clone();
            graphics.copyGraphics = this.copyGraphics;
            graphics.onPreDraw = this.onPreDraw;
            graphics.onPostDraw = this.onPostDraw;
            graphics.visible = this.visible;
            return graphics;
        }
    }
    /**
 * A Rectangle [[Graphic]] for drawing rectangles to the [[ExcaliburGraphicsContext]]
 */ class Rectangle extends Raster {
        constructor(options){
            super(options);
            this.width = options.width;
            this.height = options.height;
            this.rasterize();
        }
        clone() {
            return new Rectangle({
                width: this.width,
                height: this.height,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.color) ctx.fillRect(0, 0, this.width, this.height);
            if (this.strokeColor) ctx.strokeRect(0, 0, this.width, this.height);
        }
    }
    /**
 * A circle [[Graphic]] for drawing circles to the [[ExcaliburGraphicsContext]]
 *
 * Circles default to [[ImageFiltering.Blended]]
 */ class Circle extends Raster {
        get radius() {
            return this._radius;
        }
        set radius(value) {
            this._radius = value;
            this.width = this._radius * 2;
            this.height = this._radius * 2;
            this.flagDirty();
        }
        constructor(options){
            var _a, _b, _c;
            super(options);
            this._radius = 0;
            const lineWidth = (_a = options.lineWidth) !== null && _a !== void 0 ? _a : options.strokeColor ? 1 : 0; // default lineWidth in canvas is 1px
            this.padding = (_b = options.padding) !== null && _b !== void 0 ? _b : 2 + lineWidth / 2; // default 2 padding for circles looks nice
            this.radius = options.radius;
            this.filtering = (_c = options.filtering) !== null && _c !== void 0 ? _c : ImageFiltering.Blended;
            this.rasterize();
        }
        clone() {
            return new Circle({
                radius: this.radius,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.radius > 0) {
                ctx.beginPath();
                ctx.arc(this.radius, this.radius, this.radius, 0, Math.PI * 2);
                if (this.color) ctx.fill();
                if (this.strokeColor) ctx.stroke();
            }
        }
    }
    /**
 * Add this component to optionally configure how the pointer
 * system detects pointer events.
 *
 * By default the collider shape is used and graphics bounds is not.
 *
 * If both collider shape and graphics bounds are enabled it will fire events if either or
 * are intersecting the pointer.
 */ class PointerComponent extends Component {
        constructor(options){
            var _a, _b;
            super();
            /**
         * Use any existing Collider component geometry for pointer events. This is useful if you want
         * user pointer events only to trigger on the same collision geometry used in the collider component
         * for collision resolution. Default is `true`.
         */ this.useColliderShape = true;
            /**
         * Use any existing Graphics component bounds for pointers. This is useful if you want the axis aligned
         * bounds around the graphic to trigger pointer events. Default is `true`.
         */ this.useGraphicsBounds = true;
            this.useColliderShape = (_a = options === null || options === void 0 ? void 0 : options.useColliderShape) !== null && _a !== void 0 ? _a : this.useColliderShape;
            this.useGraphicsBounds = (_b = options === null || options === void 0 ? void 0 : options.useGraphicsBounds) !== null && _b !== void 0 ? _b : this.useGraphicsBounds;
            this.localBounds = options === null || options === void 0 ? void 0 : options.localBounds;
        }
    }
    /**
 * Standard easing functions for motion in Excalibur, defined on a domain of [0, duration] and a range from [+startValue,+endValue]
 * Given a time, the function will return a value from positive startValue to positive endValue.
 *
 * ```js
 * function Linear (t) {
 *    return t * t;
 * }
 *
 * // accelerating from zero velocity
 * function EaseInQuad (t) {
 *    return t * t;
 * }
 *
 * // decelerating to zero velocity
 * function EaseOutQuad (t) {
 *    return t * (2 - t);
 * }
 *
 * // acceleration until halfway, then deceleration
 * function EaseInOutQuad (t) {
 *    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
 * }
 *
 * // accelerating from zero velocity
 * function EaseInCubic (t) {
 *    return t * t * t;
 * }
 *
 * // decelerating to zero velocity
 * function EaseOutCubic (t) {
 *    return (--t) * t * t + 1;
 * }
 *
 * // acceleration until halfway, then deceleration
 * function EaseInOutCubic (t) {
 *    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
 * }
 * ```
 */ class EasingFunctions {
        static CreateReversibleEasingFunction(easing) {
            return (time, start, end, duration)=>{
                if (end < start) return start - (easing(time, end, start, duration) - end);
                else return easing(time, start, end, duration);
            };
        }
        static CreateVectorEasingFunction(easing) {
            return (time, start, end, duration)=>{
                return new Vector(easing(time, start.x, end.x, duration), easing(time, start.y, end.y, duration));
            };
        }
    }
    EasingFunctions.Linear = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        return endValue * currentTime / duration + startValue;
    });
    EasingFunctions.EaseInQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return endValue * currentTime * currentTime + startValue;
    });
    EasingFunctions.EaseOutQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return -endValue * currentTime * (currentTime - 2) + startValue;
    });
    EasingFunctions.EaseInOutQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration / 2;
        if (currentTime < 1) return endValue / 2 * currentTime * currentTime + startValue;
        currentTime--;
        return -endValue / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
    });
    EasingFunctions.EaseInCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return endValue * currentTime * currentTime * currentTime + startValue;
    });
    EasingFunctions.EaseOutCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        currentTime--;
        return endValue * (currentTime * currentTime * currentTime + 1) + startValue;
    });
    EasingFunctions.EaseInOutCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration / 2;
        if (currentTime < 1) return endValue / 2 * currentTime * currentTime * currentTime + startValue;
        currentTime -= 2;
        return endValue / 2 * (currentTime * currentTime * currentTime + 2) + startValue;
    });
    /**
 * Action Queues represent an ordered sequence of actions
 *
 * Action queues are part of the [[ActionContext|Action API]] and
 * store the list of actions to be executed for an [[Actor]].
 *
 * Actors implement [[Actor.actions]] which can be manipulated by
 * advanced users to adjust the actions currently being executed in the
 * queue.
 */ class ActionQueue {
        constructor(entity){
            this._actions = [];
            this._currentAction = null;
            this._completedActions = [];
            this._entity = entity;
        }
        /**
     * Add an action to the sequence
     * @param action
     */ add(action) {
            this._actions.push(action);
        }
        /**
     * Remove an action by reference from the sequence
     * @param action
     */ remove(action) {
            const index = this._actions.indexOf(action);
            this._actions.splice(index, 1);
        }
        /**
     * Removes all actions from this sequence
     */ clearActions() {
            this._actions.length = 0;
            this._completedActions.length = 0;
            if (this._currentAction) this._currentAction.stop();
        }
        /**
     *
     * @returns The total list of actions in this sequence complete or not
     */ getActions() {
            return this._actions.concat(this._completedActions);
        }
        /**
     *
     * @returns `true` if there are more actions to process in the sequence
     */ hasNext() {
            return this._actions.length > 0;
        }
        /**
     * @returns `true` if the current sequence of actions is done
     */ isComplete() {
            return this._actions.length === 0;
        }
        /**
     * Resets the sequence of actions, this is used to restart a sequence from the beginning
     */ reset() {
            this._actions = this.getActions();
            const len = this._actions.length;
            for(let i = 0; i < len; i++)this._actions[i].reset();
            this._completedActions = [];
        }
        /**
     * Update the queue which updates actions and handles completing actions
     * @param elapsedMs
     */ update(elapsedMs) {
            if (this._actions.length > 0) {
                if (this._currentAction !== this._actions[0]) {
                    this._currentAction = this._actions[0];
                    this._entity.emit("actionstart", new ActionStartEvent(this._currentAction, this._entity));
                }
                this._currentAction.update(elapsedMs);
                if (this._currentAction.isComplete(this._entity)) {
                    this._entity.emit("actioncomplete", new ActionCompleteEvent(this._currentAction, this._entity));
                    const complete = this._actions.shift();
                    if (complete) this._completedActions.push(complete);
                }
            }
        }
    }
    class Repeat {
        constructor(entity, repeatBuilder, repeat){
            this._stopped = false;
            this._repeatBuilder = repeatBuilder;
            this._repeatContext = new ActionContext(entity);
            this._actionQueue = this._repeatContext.getQueue();
            this._repeat = repeat;
            this._originalRepeat = repeat;
            this._repeatBuilder(this._repeatContext);
            this._repeat--; // current execution is the first repeat
        }
        update(delta) {
            if (this._actionQueue.isComplete()) {
                this._actionQueue.clearActions();
                this._repeatBuilder(this._repeatContext);
                this._repeat--;
            }
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped || this._repeat <= 0 && this._actionQueue.isComplete();
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._repeat = this._originalRepeat;
        }
    }
    /**
 * RepeatForever Action implementation, it is recommended you use the fluent action
 * context API.
 *
 *
 */ class RepeatForever {
        constructor(entity, repeatBuilder){
            this._stopped = false;
            this._repeatBuilder = repeatBuilder;
            this._repeatContext = new ActionContext(entity);
            this._actionQueue = this._repeatContext.getQueue();
            this._repeatBuilder(this._repeatContext);
        }
        update(delta) {
            if (this._stopped) return;
            if (this._actionQueue.isComplete()) {
                this._actionQueue.clearActions();
                this._repeatBuilder(this._repeatContext);
            }
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped;
        }
        stop() {
            this._stopped = true;
            this._actionQueue.clearActions();
        }
        reset() {
            return;
        }
    }
    class MoveBy {
        constructor(entity, offsetX, offsetY, speed){
            this._started = false;
            this._stopped = false;
            this._entity = entity;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._speed = speed;
            this._offset = new Vector(offsetX, offsetY);
            if (speed <= 0) {
                Logger.getInstance().error("Attempted to moveBy with speed less than or equal to zero : " + speed);
                throw new Error("Speed must be greater than 0 pixels per second");
            }
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = new Vector(this._tx.pos.x, this._tx.pos.y);
                this._end = this._start.add(this._offset);
                this._distance = this._offset.size;
                this._dir = this._end.sub(this._start).normalize();
            }
            if (this.isComplete(this._entity)) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            } else this._motion.vel = this._dir.scale(this._speed);
        }
        isComplete(entity) {
            const tx = entity.get(TransformComponent);
            return this._stopped || tx.pos.distance(this._start) >= this._distance;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class MoveTo {
        constructor(entity, destx, desty, speed){
            this.entity = entity;
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._end = new Vector(destx, desty);
            this._speed = speed;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = new Vector(this._tx.pos.x, this._tx.pos.y);
                this._distance = this._start.distance(this._end);
                this._dir = this._end.sub(this._start).normalize();
            }
            const m = this._dir.scale(this._speed);
            this._motion.vel = vec(m.x, m.y);
            if (this.isComplete(this.entity)) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        isComplete(entity) {
            const tx = entity.get(TransformComponent);
            return this._stopped || new Vector(tx.pos.x, tx.pos.y).distance(this._start) >= this._distance;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    /**
 * An enum that describes the strategies that rotation actions can use
 */ var RotationType;
    (function(RotationType) {
        /**
     * Rotation via `ShortestPath` will use the smallest angle
     * between the starting and ending points. This strategy is the default behavior.
     */ RotationType[RotationType["ShortestPath"] = 0] = "ShortestPath";
        /**
     * Rotation via `LongestPath` will use the largest angle
     * between the starting and ending points.
     */ RotationType[RotationType["LongestPath"] = 1] = "LongestPath";
        /**
     * Rotation via `Clockwise` will travel in a clockwise direction,
     * regardless of the starting and ending points.
     */ RotationType[RotationType["Clockwise"] = 2] = "Clockwise";
        /**
     * Rotation via `CounterClockwise` will travel in a counterclockwise direction,
     * regardless of the starting and ending points.
     */ RotationType[RotationType["CounterClockwise"] = 3] = "CounterClockwise";
    })(RotationType || (RotationType = {}));
    class RotateTo {
        constructor(entity, angleRadians, speed, rotationType){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._end = angleRadians;
            this._speed = speed;
            this._rotationType = rotationType || RotationType.ShortestPath;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = this._tx.rotation;
                this._currentNonCannonAngle = this._tx.rotation;
                const distance1 = Math.abs(this._end - this._start);
                const distance2 = TwoPI - distance1;
                if (distance1 > distance2) {
                    this._shortDistance = distance2;
                    this._longDistance = distance1;
                } else {
                    this._shortDistance = distance1;
                    this._longDistance = distance2;
                }
                this._shortestPathIsPositive = (this._start - this._end + TwoPI) % TwoPI >= Math.PI;
                switch(this._rotationType){
                    case RotationType.ShortestPath:
                        this._distance = this._shortDistance;
                        if (this._shortestPathIsPositive) this._direction = 1;
                        else this._direction = -1;
                        break;
                    case RotationType.LongestPath:
                        this._distance = this._longDistance;
                        if (this._shortestPathIsPositive) this._direction = -1;
                        else this._direction = 1;
                        break;
                    case RotationType.Clockwise:
                        this._direction = 1;
                        if (this._shortestPathIsPositive) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                    case RotationType.CounterClockwise:
                        this._direction = -1;
                        if (!this._shortestPathIsPositive) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                }
            }
            this._motion.angularVelocity = this._direction * this._speed;
            this._currentNonCannonAngle += this._direction * this._speed * (_delta / 1000);
            if (this.isComplete()) {
                this._tx.rotation = this._end;
                this._motion.angularVelocity = 0;
                this._stopped = true;
            }
        }
        isComplete() {
            const distanceTraveled = Math.abs(this._currentNonCannonAngle - this._start);
            return this._stopped || distanceTraveled >= Math.abs(this._distance);
        }
        stop() {
            this._motion.angularVelocity = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class RotateBy {
        constructor(entity, angleRadiansOffset, speed, rotationType){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._speed = speed;
            this._offset = angleRadiansOffset;
            this._rotationType = rotationType || RotationType.ShortestPath;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = this._tx.rotation;
                this._currentNonCannonAngle = this._tx.rotation;
                this._end = this._start + this._offset;
                const distance1 = Math.abs(this._end - this._start);
                const distance2 = TwoPI - distance1;
                if (distance1 > distance2) {
                    this._shortDistance = distance2;
                    this._longDistance = distance1;
                } else {
                    this._shortDistance = distance1;
                    this._longDistance = distance2;
                }
                this._shortestPathIsPositive = (this._start - this._end + TwoPI) % TwoPI >= Math.PI;
                switch(this._rotationType){
                    case RotationType.ShortestPath:
                        this._distance = this._shortDistance;
                        if (this._shortestPathIsPositive) this._direction = 1;
                        else this._direction = -1;
                        break;
                    case RotationType.LongestPath:
                        this._distance = this._longDistance;
                        if (this._shortestPathIsPositive) this._direction = -1;
                        else this._direction = 1;
                        break;
                    case RotationType.Clockwise:
                        this._direction = 1;
                        if (this._shortDistance >= 0) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                    case RotationType.CounterClockwise:
                        this._direction = -1;
                        if (this._shortDistance <= 0) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                }
            }
            this._motion.angularVelocity = this._direction * this._speed;
            this._currentNonCannonAngle += this._direction * this._speed * (_delta / 1000);
            if (this.isComplete()) {
                this._tx.rotation = this._end;
                this._motion.angularVelocity = 0;
                this._stopped = true;
            }
        }
        isComplete() {
            const distanceTraveled = Math.abs(this._currentNonCannonAngle - this._start);
            return this._stopped || distanceTraveled >= Math.abs(this._distance);
        }
        stop() {
            this._motion.angularVelocity = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._start = undefined;
            this._currentNonCannonAngle = undefined;
            this._distance = undefined;
        }
    }
    class ScaleTo {
        constructor(entity, scaleX, scaleY, speedX, speedY){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._endX = scaleX;
            this._endY = scaleY;
            this._speedX = speedX;
            this._speedY = speedY;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._startX = this._tx.scale.x;
                this._startY = this._tx.scale.y;
                this._distanceX = Math.abs(this._endX - this._startX);
                this._distanceY = Math.abs(this._endY - this._startY);
            }
            if (!(Math.abs(this._tx.scale.x - this._startX) >= this._distanceX)) {
                const directionX = this._endY < this._startY ? -1 : 1;
                this._motion.scaleFactor.x = this._speedX * directionX;
            } else this._motion.scaleFactor.x = 0;
            if (!(Math.abs(this._tx.scale.y - this._startY) >= this._distanceY)) {
                const directionY = this._endY < this._startY ? -1 : 1;
                this._motion.scaleFactor.y = this._speedY * directionY;
            } else this._motion.scaleFactor.y = 0;
            if (this.isComplete()) {
                this._tx.scale = vec(this._endX, this._endY);
                this._motion.scaleFactor.x = 0;
                this._motion.scaleFactor.y = 0;
            }
        }
        isComplete() {
            return this._stopped || Math.abs(this._tx.scale.x - this._startX) >= this._distanceX - 0.01 && Math.abs(this._tx.scale.y - this._startY) >= this._distanceY - 0.01;
        }
        stop() {
            this._motion.scaleFactor.x = 0;
            this._motion.scaleFactor.y = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class ScaleBy {
        constructor(entity, scaleOffsetX, scaleOffsetY, speed){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._offset = new Vector(scaleOffsetX, scaleOffsetY);
            this._speedX = this._speedY = speed;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._startScale = this._tx.scale.clone();
                this._endScale = this._startScale.add(this._offset);
                this._distanceX = Math.abs(this._endScale.x - this._startScale.x);
                this._distanceY = Math.abs(this._endScale.y - this._startScale.y);
                this._directionX = this._endScale.x < this._startScale.x ? -1 : 1;
                this._directionY = this._endScale.y < this._startScale.y ? -1 : 1;
            }
            this._motion.scaleFactor.x = this._speedX * this._directionX;
            this._motion.scaleFactor.y = this._speedY * this._directionY;
            if (this.isComplete()) {
                this._tx.scale = this._endScale;
                this._motion.scaleFactor.x = 0;
                this._motion.scaleFactor.y = 0;
            }
        }
        isComplete() {
            return this._stopped || Math.abs(this._tx.scale.x - this._startScale.x) >= this._distanceX - 0.01 && Math.abs(this._tx.scale.y - this._startScale.y) >= this._distanceY - 0.01;
        }
        stop() {
            this._motion.scaleFactor.x = 0;
            this._motion.scaleFactor.y = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class CallMethod {
        constructor(method){
            this._method = null;
            this._hasBeenCalled = false;
            this._method = method;
        }
        update(_delta) {
            this._method();
            this._hasBeenCalled = true;
        }
        isComplete() {
            return this._hasBeenCalled;
        }
        reset() {
            this._hasBeenCalled = false;
        }
        stop() {
            this._hasBeenCalled = true;
        }
    }
    class EaseTo {
        constructor(entity, x, y, duration, easingFcn){
            this.easingFcn = easingFcn;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = new Vector(0, 0);
            this._lerpEnd = new Vector(0, 0);
            this._initialized = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._lerpDuration = duration;
            this._lerpEnd = new Vector(x, y);
        }
        _initialize() {
            this._lerpStart = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._currentLerpTime = 0;
        }
        update(delta) {
            if (!this._initialized) {
                this._initialize();
                this._initialized = true;
            }
            // Need to update lerp time first, otherwise the first update will always be zero
            this._currentLerpTime += delta;
            let newX = this._tx.pos.x;
            let newY = this._tx.pos.y;
            if (this._currentLerpTime < this._lerpDuration) {
                if (this._lerpEnd.x < this._lerpStart.x) newX = this._lerpStart.x - (this.easingFcn(this._currentLerpTime, this._lerpEnd.x, this._lerpStart.x, this._lerpDuration) - this._lerpEnd.x);
                else newX = this.easingFcn(this._currentLerpTime, this._lerpStart.x, this._lerpEnd.x, this._lerpDuration);
                if (this._lerpEnd.y < this._lerpStart.y) newY = this._lerpStart.y - (this.easingFcn(this._currentLerpTime, this._lerpEnd.y, this._lerpStart.y, this._lerpDuration) - this._lerpEnd.y);
                else newY = this.easingFcn(this._currentLerpTime, this._lerpStart.y, this._lerpEnd.y, this._lerpDuration);
                // Given the lerp position figure out the velocity in pixels per second
                this._motion.vel = vec((newX - this._tx.pos.x) / (delta / 1000), (newY - this._tx.pos.y) / (delta / 1000));
            } else {
                this._tx.pos = vec(this._lerpEnd.x, this._lerpEnd.y);
                this._motion.vel = Vector.Zero;
            }
        }
        isComplete() {
            return this._stopped || this._currentLerpTime >= this._lerpDuration;
        }
        reset() {
            this._initialized = false;
            this._stopped = false;
            this._currentLerpTime = 0;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
    }
    class EaseBy {
        constructor(entity, offsetX, offsetY, duration, easingFcn){
            this.easingFcn = easingFcn;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = new Vector(0, 0);
            this._lerpEnd = new Vector(0, 0);
            this._initialized = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._lerpDuration = duration;
            this._offset = new Vector(offsetX, offsetY);
        }
        _initialize() {
            this._lerpStart = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._currentLerpTime = 0;
            this._lerpEnd = this._lerpStart.add(this._offset);
        }
        update(delta) {
            if (!this._initialized) {
                this._initialize();
                this._initialized = true;
            }
            // Need to update lerp time first, otherwise the first update will always be zero
            this._currentLerpTime += delta;
            let newX = this._tx.pos.x;
            let newY = this._tx.pos.y;
            if (this._currentLerpTime < this._lerpDuration) {
                if (this._lerpEnd.x < this._lerpStart.x) newX = this._lerpStart.x - (this.easingFcn(this._currentLerpTime, this._lerpEnd.x, this._lerpStart.x, this._lerpDuration) - this._lerpEnd.x);
                else newX = this.easingFcn(this._currentLerpTime, this._lerpStart.x, this._lerpEnd.x, this._lerpDuration);
                if (this._lerpEnd.y < this._lerpStart.y) newY = this._lerpStart.y - (this.easingFcn(this._currentLerpTime, this._lerpEnd.y, this._lerpStart.y, this._lerpDuration) - this._lerpEnd.y);
                else newY = this.easingFcn(this._currentLerpTime, this._lerpStart.y, this._lerpEnd.y, this._lerpDuration);
                // Given the lerp position figure out the velocity in pixels per second
                this._motion.vel = vec((newX - this._tx.pos.x) / (delta / 1000), (newY - this._tx.pos.y) / (delta / 1000));
            } else {
                this._tx.pos = vec(this._lerpEnd.x, this._lerpEnd.y);
                this._motion.vel = Vector.Zero;
            }
        }
        isComplete() {
            return this._stopped || this._currentLerpTime >= this._lerpDuration;
        }
        reset() {
            this._initialized = false;
            this._stopped = false;
            this._currentLerpTime = 0;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
    }
    class Blink {
        constructor(entity, timeVisible, timeNotVisible, numBlinks = 1){
            this._timeVisible = 0;
            this._timeNotVisible = 0;
            this._elapsedTime = 0;
            this._totalTime = 0;
            this._stopped = false;
            this._started = false;
            this._graphics = entity.get(GraphicsComponent);
            this._timeVisible = timeVisible;
            this._timeNotVisible = timeNotVisible;
            this._duration = (timeVisible + timeNotVisible) * numBlinks;
        }
        update(delta) {
            if (!this._started) {
                this._started = true;
                this._elapsedTime = 0;
                this._totalTime = 0;
            }
            if (!this._graphics) return;
            this._elapsedTime += delta;
            this._totalTime += delta;
            if (this._graphics.visible && this._elapsedTime >= this._timeVisible) {
                this._graphics.visible = false;
                this._elapsedTime = 0;
            }
            if (!this._graphics.visible && this._elapsedTime >= this._timeNotVisible) {
                this._graphics.visible = true;
                this._elapsedTime = 0;
            }
            if (this.isComplete()) this._graphics.visible = true;
        }
        isComplete() {
            return this._stopped || this._totalTime >= this._duration;
        }
        stop() {
            if (this._graphics) this._graphics.visible = true;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._elapsedTime = 0;
            this._totalTime = 0;
        }
    }
    class Fade {
        constructor(entity, endOpacity, speed){
            this._multiplier = 1;
            this._started = false;
            this._stopped = false;
            this._graphics = entity.get(GraphicsComponent);
            this._endOpacity = endOpacity;
            this._speed = this._ogspeed = speed;
        }
        update(delta) {
            if (!this._graphics) return;
            if (!this._started) {
                this._started = true;
                this._speed = this._ogspeed;
                // determine direction when we start
                if (this._endOpacity < this._graphics.opacity) this._multiplier = -1;
                else this._multiplier = 1;
            }
            if (this._speed > 0) this._graphics.opacity += this._multiplier * (Math.abs(this._graphics.opacity - this._endOpacity) * delta) / this._speed;
            this._speed -= delta;
            if (this.isComplete()) this._graphics.opacity = this._endOpacity;
            Logger.getInstance().debug("[Action fade] Actor opacity:", this._graphics.opacity);
        }
        isComplete() {
            return this._stopped || Math.abs(this._graphics.opacity - this._endOpacity) < 0.05;
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class Delay {
        constructor(delay){
            this._elapsedTime = 0;
            this._started = false;
            this._stopped = false;
            this._delay = delay;
        }
        update(delta) {
            if (!this._started) this._started = true;
            this._elapsedTime += delta;
        }
        isComplete() {
            return this._stopped || this._elapsedTime >= this._delay;
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._elapsedTime = 0;
            this._started = false;
            this._stopped = false;
        }
    }
    class Die {
        constructor(entity){
            this._stopped = false;
            this._entity = entity;
        }
        update(_delta) {
            this._entity.get(ActionsComponent).clearActions();
            this._entity.kill();
            this._stopped = true;
        }
        isComplete() {
            return this._stopped;
        }
        stop() {
            return;
        }
        reset() {
            return;
        }
    }
    class Follow {
        constructor(entity, entityToFollow, followDistance){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._followTx = entityToFollow.get(TransformComponent);
            this._followMotion = entityToFollow.get(MotionComponent);
            this._current = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._end = new Vector(this._followTx.pos.x, this._followTx.pos.y);
            this._maximumDistance = followDistance !== undefined ? followDistance : this._current.distance(this._end);
            this._speed = 0;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._distanceBetween = this._current.distance(this._end);
                this._dir = this._end.sub(this._current).normalize();
            }
            const actorToFollowSpeed = Math.sqrt(Math.pow(this._followMotion.vel.x, 2) + Math.pow(this._followMotion.vel.y, 2));
            if (actorToFollowSpeed !== 0) this._speed = actorToFollowSpeed;
            this._current = vec(this._tx.pos.x, this._tx.pos.y);
            this._end = vec(this._followTx.pos.x, this._followTx.pos.y);
            this._distanceBetween = this._current.distance(this._end);
            this._dir = this._end.sub(this._current).normalize();
            if (this._distanceBetween >= this._maximumDistance) {
                const m = this._dir.scale(this._speed);
                this._motion.vel = vec(m.x, m.y);
            } else this._motion.vel = vec(0, 0);
            if (this.isComplete()) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        isComplete() {
            // the actor following should never stop unless specified to do so
            return this._stopped;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class Meet {
        constructor(actor, actorToMeet, speed){
            this._started = false;
            this._stopped = false;
            this._speedWasSpecified = false;
            this._tx = actor.get(TransformComponent);
            this._motion = actor.get(MotionComponent);
            this._meetTx = actorToMeet.get(TransformComponent);
            this._meetMotion = actorToMeet.get(MotionComponent);
            this._current = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._end = new Vector(this._meetTx.pos.x, this._meetTx.pos.y);
            this._speed = speed || 0;
            if (speed !== undefined) this._speedWasSpecified = true;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._distanceBetween = this._current.distance(this._end);
                this._dir = this._end.sub(this._current).normalize();
            }
            const actorToMeetSpeed = Math.sqrt(Math.pow(this._meetMotion.vel.x, 2) + Math.pow(this._meetMotion.vel.y, 2));
            if (actorToMeetSpeed !== 0 && !this._speedWasSpecified) this._speed = actorToMeetSpeed;
            this._current = vec(this._tx.pos.x, this._tx.pos.y);
            this._end = vec(this._meetTx.pos.x, this._meetTx.pos.y);
            this._distanceBetween = this._current.distance(this._end);
            this._dir = this._end.sub(this._current).normalize();
            const m = this._dir.scale(this._speed);
            this._motion.vel = vec(m.x, m.y);
            if (this.isComplete()) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        isComplete() {
            return this._stopped || this._distanceBetween <= 1;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._distanceBetween = undefined;
        }
    }
    /**
 * The fluent Action API allows you to perform "actions" on
 * [[Actor|Actors]] such as following, moving, rotating, and
 * more. You can implement your own actions by implementing
 * the [[Action]] interface.
 */ class ActionContext {
        constructor(entity){
            this._entity = entity;
            this._queue = new ActionQueue(entity);
        }
        getQueue() {
            return this._queue;
        }
        update(elapsedMs) {
            this._queue.update(elapsedMs);
        }
        /**
     * Clears all queued actions from the Actor
     */ clearActions() {
            this._queue.clearActions();
        }
        runAction(action) {
            action.reset();
            this._queue.add(action);
            return this;
        }
        easeTo(...args) {
            var _a, _b;
            let x = 0;
            let y = 0;
            let duration = 0;
            let easingFcn = EasingFunctions.Linear;
            if (args[0] instanceof Vector) {
                x = args[0].x;
                y = args[0].y;
                duration = args[1];
                easingFcn = (_a = args[2]) !== null && _a !== void 0 ? _a : easingFcn;
            } else {
                x = args[0];
                y = args[1];
                duration = args[2];
                easingFcn = (_b = args[3]) !== null && _b !== void 0 ? _b : easingFcn;
            }
            this._queue.add(new EaseTo(this._entity, x, y, duration, easingFcn));
            return this;
        }
        easeBy(...args) {
            var _a, _b;
            let offsetX = 0;
            let offsetY = 0;
            let duration = 0;
            let easingFcn = EasingFunctions.Linear;
            if (args[0] instanceof Vector) {
                offsetX = args[0].x;
                offsetY = args[0].y;
                duration = args[1];
                easingFcn = (_a = args[2]) !== null && _a !== void 0 ? _a : easingFcn;
            } else {
                offsetX = args[0];
                offsetY = args[1];
                duration = args[2];
                easingFcn = (_b = args[3]) !== null && _b !== void 0 ? _b : easingFcn;
            }
            this._queue.add(new EaseBy(this._entity, offsetX, offsetY, duration, easingFcn));
            return this;
        }
        moveTo(xOrPos, yOrSpeed, speedOrUndefined) {
            let x = 0;
            let y = 0;
            let speed = 0;
            if (xOrPos instanceof Vector) {
                x = xOrPos.x;
                y = xOrPos.y;
                speed = yOrSpeed;
            } else {
                x = xOrPos;
                y = yOrSpeed;
                speed = speedOrUndefined;
            }
            this._queue.add(new MoveTo(this._entity, x, y, speed));
            return this;
        }
        moveBy(xOffsetOrVector, yOffsetOrSpeed, speedOrUndefined) {
            let xOffset = 0;
            let yOffset = 0;
            let speed = 0;
            if (xOffsetOrVector instanceof Vector) {
                xOffset = xOffsetOrVector.x;
                yOffset = xOffsetOrVector.y;
                speed = yOffsetOrSpeed;
            } else {
                xOffset = xOffsetOrVector;
                yOffset = yOffsetOrSpeed;
                speed = speedOrUndefined;
            }
            this._queue.add(new MoveBy(this._entity, xOffset, yOffset, speed));
            return this;
        }
        /**
     * This method will rotate an actor to the specified angle at the speed
     * specified (in radians per second) and return back the actor. This
     * method is part of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadians  The angle to rotate to in radians
     * @param speed         The angular velocity of the rotation specified in radians per second
     * @param rotationType  The [[RotationType]] to use for this rotation
     */ rotateTo(angleRadians, speed, rotationType) {
            this._queue.add(new RotateTo(this._entity, angleRadians, speed, rotationType));
            return this;
        }
        /**
     * This method will rotate an actor by the specified angle offset, from it's current rotation given a certain speed
     * in radians/sec and return back the actor. This method is part
     * of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadiansOffset  The angle to rotate to in radians relative to the current rotation
     * @param speed          The speed in radians/sec the actor should rotate at
     * @param rotationType  The [[RotationType]] to use for this rotation, default is shortest path
     */ rotateBy(angleRadiansOffset, speed, rotationType) {
            this._queue.add(new RotateBy(this._entity, angleRadiansOffset, speed, rotationType));
            return this;
        }
        scaleTo(sizeXOrVector, sizeYOrSpeed, speedXOrUndefined, speedYOrUndefined) {
            let sizeX = 1;
            let sizeY = 1;
            let speedX = 0;
            let speedY = 0;
            if (sizeXOrVector instanceof Vector && sizeYOrSpeed instanceof Vector) {
                sizeX = sizeXOrVector.x;
                sizeY = sizeXOrVector.y;
                speedX = sizeYOrSpeed.x;
                speedY = sizeYOrSpeed.y;
            }
            if (typeof sizeXOrVector === "number" && typeof sizeYOrSpeed === "number") {
                sizeX = sizeXOrVector;
                sizeY = sizeYOrSpeed;
                speedX = speedXOrUndefined;
                speedY = speedYOrUndefined;
            }
            this._queue.add(new ScaleTo(this._entity, sizeX, sizeY, speedX, speedY));
            return this;
        }
        scaleBy(sizeOffsetXOrVector, sizeOffsetYOrSpeed, speed) {
            let sizeOffsetX = 1;
            let sizeOffsetY = 1;
            if (sizeOffsetXOrVector instanceof Vector) {
                sizeOffsetX = sizeOffsetXOrVector.x;
                sizeOffsetY = sizeOffsetXOrVector.y;
                speed = sizeOffsetYOrSpeed;
            }
            if (typeof sizeOffsetXOrVector === "number" && typeof sizeOffsetYOrSpeed === "number") {
                sizeOffsetX = sizeOffsetXOrVector;
                sizeOffsetY = sizeOffsetYOrSpeed;
            }
            this._queue.add(new ScaleBy(this._entity, sizeOffsetX, sizeOffsetY, speed));
            return this;
        }
        /**
     * This method will cause an actor to blink (become visible and not
     * visible). Optionally, you may specify the number of blinks. Specify the amount of time
     * the actor should be visible per blink, and the amount of time not visible.
     * This method is part of the actor 'Action' fluent API allowing action chaining.
     * @param timeVisible     The amount of time to stay visible per blink in milliseconds
     * @param timeNotVisible  The amount of time to stay not visible per blink in milliseconds
     * @param numBlinks       The number of times to blink
     */ blink(timeVisible, timeNotVisible, numBlinks = 1) {
            this._queue.add(new Blink(this._entity, timeVisible, timeNotVisible, numBlinks));
            return this;
        }
        /**
     * This method will cause an actor's opacity to change from its current value
     * to the provided value by a specified time (in milliseconds). This method is
     * part of the actor 'Action' fluent API allowing action chaining.
     * @param opacity  The ending opacity
     * @param time     The time it should take to fade the actor (in milliseconds)
     */ fade(opacity, time) {
            this._queue.add(new Fade(this._entity, opacity, time));
            return this;
        }
        /**
     * This method will delay the next action from executing for a certain
     * amount of time (in milliseconds). This method is part of the actor
     * 'Action' fluent API allowing action chaining.
     * @param time  The amount of time to delay the next action in the queue from executing in milliseconds
     */ delay(time) {
            this._queue.add(new Delay(time));
            return this;
        }
        /**
     * This method will add an action to the queue that will remove the actor from the
     * scene once it has completed its previous  Any actions on the
     * action queue after this action will not be executed.
     */ die() {
            this._queue.add(new Die(this._entity));
            return this;
        }
        /**
     * This method allows you to call an arbitrary method as the next action in the
     * action queue. This is useful if you want to execute code in after a specific
     * action, i.e An actor arrives at a destination after traversing a path
     */ callMethod(method) {
            this._queue.add(new CallMethod(method));
            return this;
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     * @param times  The number of times to repeat all the previous actions in the action queue. If nothing is specified the actions
     * will repeat forever
     */ repeat(repeatBuilder, times) {
            if (!times) {
                this.repeatForever(repeatBuilder);
                return this;
            }
            this._queue.add(new Repeat(this._entity, repeatBuilder, times));
            return this;
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     */ repeatForever(repeatBuilder) {
            this._queue.add(new RepeatForever(this._entity, repeatBuilder));
            return this;
        }
        /**
     * This method will cause the entity to follow another at a specified distance
     * @param entity           The entity to follow
     * @param followDistance  The distance to maintain when following, if not specified the actor will follow at the current distance.
     */ follow(entity, followDistance) {
            if (followDistance === undefined) this._queue.add(new Follow(this._entity, entity));
            else this._queue.add(new Follow(this._entity, entity, followDistance));
            return this;
        }
        /**
     * This method will cause the entity to move towards another until they
     * collide "meet" at a specified speed.
     * @param entity  The entity to meet
     * @param speed  The speed in pixels per second to move, if not specified it will match the speed of the other actor
     */ meet(entity, speed) {
            if (speed === undefined) this._queue.add(new Meet(this._entity, entity));
            else this._queue.add(new Meet(this._entity, entity, speed));
            return this;
        }
        /**
     * Returns a promise that resolves when the current action queue up to now
     * is finished.
     */ toPromise() {
            const temp = new Promise((resolve)=>{
                this._queue.add(new CallMethod(()=>{
                    resolve();
                }));
            });
            return temp;
        }
    }
    class ActionsComponent extends Component {
        constructor(){
            super(...arguments);
            this.dependencies = [
                TransformComponent,
                MotionComponent
            ];
            this._ctx = null;
        }
        onAdd(entity) {
            this._ctx = new ActionContext(entity);
        }
        onRemove() {
            this._ctx = null;
        }
        _getCtx() {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, no context available");
            return this._ctx;
        }
        /**
     * Returns the internal action queue
     * @returns action queue
     */ getQueue() {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, no queue available");
            return this._ctx.getQueue();
        }
        runAction(action) {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, cannot run action");
            return this._ctx.runAction(action);
        }
        /**
     * Updates the internal action context, performing action and moving through the internal queue
     * @param elapsedMs
     */ update(elapsedMs) {
            var _a;
            return (_a = this._ctx) === null || _a === void 0 ? void 0 : _a.update(elapsedMs);
        }
        /**
     * Clears all queued actions from the Actor
     */ clearActions() {
            var _a;
            (_a = this._ctx) === null || _a === void 0 || _a.clearActions();
        }
        easeTo(...args) {
            return this._getCtx().easeTo.apply(this._ctx, args);
        }
        easeBy(...args) {
            return this._getCtx().easeBy.apply(this._ctx, args);
        }
        moveTo(xOrPos, yOrSpeed, speedOrUndefined) {
            return this._getCtx().moveTo.apply(this._ctx, [
                xOrPos,
                yOrSpeed,
                speedOrUndefined
            ]);
        }
        moveBy(xOffsetOrVector, yOffsetOrSpeed, speedOrUndefined) {
            return this._getCtx().moveBy.apply(this._ctx, [
                xOffsetOrVector,
                yOffsetOrSpeed,
                speedOrUndefined
            ]);
        }
        /**
     * This method will rotate an actor to the specified angle at the speed
     * specified (in radians per second) and return back the actor. This
     * method is part of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadians  The angle to rotate to in radians
     * @param speed         The angular velocity of the rotation specified in radians per second
     * @param rotationType  The [[RotationType]] to use for this rotation
     */ rotateTo(angleRadians, speed, rotationType) {
            return this._getCtx().rotateTo(angleRadians, speed, rotationType);
        }
        /**
     * This method will rotate an actor by the specified angle offset, from it's current rotation given a certain speed
     * in radians/sec and return back the actor. This method is part
     * of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadiansOffset  The angle to rotate to in radians relative to the current rotation
     * @param speed          The speed in radians/sec the actor should rotate at
     * @param rotationType  The [[RotationType]] to use for this rotation, default is shortest path
     */ rotateBy(angleRadiansOffset, speed, rotationType) {
            return this._getCtx().rotateBy(angleRadiansOffset, speed, rotationType);
        }
        scaleTo(sizeXOrVector, sizeYOrSpeed, speedXOrUndefined, speedYOrUndefined) {
            return this._getCtx().scaleTo.apply(this._ctx, [
                sizeXOrVector,
                sizeYOrSpeed,
                speedXOrUndefined,
                speedYOrUndefined
            ]);
        }
        scaleBy(sizeOffsetXOrVector, sizeOffsetYOrSpeed, speed) {
            return this._getCtx().scaleBy.apply(this._ctx, [
                sizeOffsetXOrVector,
                sizeOffsetYOrSpeed,
                speed
            ]);
        }
        /**
     * This method will cause an actor to blink (become visible and not
     * visible). Optionally, you may specify the number of blinks. Specify the amount of time
     * the actor should be visible per blink, and the amount of time not visible.
     * This method is part of the actor 'Action' fluent API allowing action chaining.
     * @param timeVisible     The amount of time to stay visible per blink in milliseconds
     * @param timeNotVisible  The amount of time to stay not visible per blink in milliseconds
     * @param numBlinks       The number of times to blink
     */ blink(timeVisible, timeNotVisible, numBlinks) {
            return this._getCtx().blink(timeVisible, timeNotVisible, numBlinks);
        }
        /**
     * This method will cause an actor's opacity to change from its current value
     * to the provided value by a specified time (in milliseconds). This method is
     * part of the actor 'Action' fluent API allowing action chaining.
     * @param opacity  The ending opacity
     * @param time     The time it should take to fade the actor (in milliseconds)
     */ fade(opacity, time) {
            return this._getCtx().fade(opacity, time);
        }
        /**
     * This method will delay the next action from executing for a certain
     * amount of time (in milliseconds). This method is part of the actor
     * 'Action' fluent API allowing action chaining.
     * @param time  The amount of time to delay the next action in the queue from executing in milliseconds
     */ delay(time) {
            return this._getCtx().delay(time);
        }
        /**
     * This method will add an action to the queue that will remove the actor from the
     * scene once it has completed its previous  Any actions on the
     * action queue after this action will not be executed.
     */ die() {
            return this._getCtx().die();
        }
        /**
     * This method allows you to call an arbitrary method as the next action in the
     * action queue. This is useful if you want to execute code in after a specific
     * action, i.e An actor arrives at a destination after traversing a path
     */ callMethod(method) {
            return this._getCtx().callMethod(method);
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     * @param times  The number of times to repeat all the previous actions in the action queue. If nothing is specified the actions
     * will repeat forever
     */ repeat(repeatBuilder, times) {
            return this._getCtx().repeat(repeatBuilder, times);
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     */ repeatForever(repeatBuilder) {
            return this._getCtx().repeatForever(repeatBuilder);
        }
        /**
     * This method will cause the entity to follow another at a specified distance
     * @param entity           The entity to follow
     * @param followDistance  The distance to maintain when following, if not specified the actor will follow at the current distance.
     */ follow(entity, followDistance) {
            return this._getCtx().follow(entity, followDistance);
        }
        /**
     * This method will cause the entity to move towards another until they
     * collide "meet" at a specified speed.
     * @param entity  The entity to meet
     * @param speed  The speed in pixels per second to move, if not specified it will match the speed of the other actor
     */ meet(entity, speed) {
            return this._getCtx().meet(entity, speed);
        }
        /**
     * Returns a promise that resolves when the current action queue up to now
     * is finished.
     */ toPromise() {
            return this._getCtx().toPromise();
        }
    }
    /**
 * Enum representing the different font size units
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-size
 */ var FontUnit;
    (function(FontUnit) {
        /**
     * Em is a scalable unit, 1 em is equal to the current font size of the current element, parent elements can effect em values
     */ FontUnit["Em"] = "em";
        /**
     * Rem is similar to the Em, it is a scalable unit. 1 rem is equal to the font size of the root element
     */ FontUnit["Rem"] = "rem";
        /**
     * Pixel is a unit of length in screen pixels
     */ FontUnit["Px"] = "px";
        /**
     * Point is a physical unit length (1/72 of an inch)
     */ FontUnit["Pt"] = "pt";
        /**
     * Percent is a scalable unit similar to Em, the only difference is the Em units scale faster when Text-Size stuff
     */ FontUnit["Percent"] = "%";
    })(FontUnit || (FontUnit = {}));
    /**
 * Enum representing the different horizontal text alignments
 */ var TextAlign;
    (function(TextAlign) {
        /**
     * The text is left-aligned.
     */ TextAlign["Left"] = "left";
        /**
     * The text is right-aligned.
     */ TextAlign["Right"] = "right";
        /**
     * The text is centered.
     */ TextAlign["Center"] = "center";
        /**
     * The text is aligned at the normal start of the line (left-aligned for left-to-right locales,
     * right-aligned for right-to-left locales).
     */ TextAlign["Start"] = "start";
        /**
     * The text is aligned at the normal end of the line (right-aligned for left-to-right locales,
     * left-aligned for right-to-left locales).
     */ TextAlign["End"] = "end";
    })(TextAlign || (TextAlign = {}));
    /**
 * Enum representing the different baseline text alignments
 */ var BaseAlign;
    (function(BaseAlign) {
        /**
     * The text baseline is the top of the em square.
     */ BaseAlign["Top"] = "top";
        /**
     * The text baseline is the hanging baseline.  Currently unsupported; this will act like
     * alphabetic.
     */ BaseAlign["Hanging"] = "hanging";
        /**
     * The text baseline is the middle of the em square.
     */ BaseAlign["Middle"] = "middle";
        /**
     * The text baseline is the normal alphabetic baseline.
     */ BaseAlign["Alphabetic"] = "alphabetic";
        /**
     * The text baseline is the ideographic baseline; this is the bottom of
     * the body of the characters, if the main body of characters protrudes
     * beneath the alphabetic baseline.  Currently unsupported; this will
     * act like alphabetic.
     */ BaseAlign["Ideographic"] = "ideographic";
        /**
     * The text baseline is the bottom of the bounding box.  This differs
     * from the ideographic baseline in that the ideographic baseline
     * doesn't consider descenders.
     */ BaseAlign["Bottom"] = "bottom";
    })(BaseAlign || (BaseAlign = {}));
    /**
 * Enum representing the different possible font styles
 */ var FontStyle;
    (function(FontStyle) {
        FontStyle["Normal"] = "normal";
        FontStyle["Italic"] = "italic";
        FontStyle["Oblique"] = "oblique";
    })(FontStyle || (FontStyle = {}));
    /**
 * Enum representing the text direction, useful for other languages, or writing text in reverse
 */ var Direction;
    (function(Direction) {
        Direction["LeftToRight"] = "ltr";
        Direction["RightToLeft"] = "rtl";
    })(Direction || (Direction = {}));
    class FontTextInstance {
        constructor(font, text, color, maxWidth){
            this.font = font;
            this.text = text;
            this.color = color;
            this.maxWidth = maxWidth;
            this._textFragments = [];
            this.disposed = false;
            this._dirty = true;
            this.canvas = document.createElement("canvas");
            this.ctx = this.canvas.getContext("2d");
            this.dimensions = this.measureText(text);
            this._setDimension(this.dimensions, this.ctx);
            this._lastHashCode = this.getHashCode();
        }
        measureText(text, maxWidth) {
            if (this.disposed) throw Error("Accessing disposed text instance! " + this.text);
            let lines = null;
            if (maxWidth != null) lines = this._getLinesFromText(text, maxWidth);
            else lines = text.split("\n");
            const maxWidthLine = lines.reduce((a, b)=>{
                return a.length > b.length ? a : b;
            });
            this._applyFont(this.ctx); // font must be applied to the context to measure it
            const metrics = this.ctx.measureText(maxWidthLine);
            let textHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent);
            // TODO line height makes the text bounds wonky
            const lineAdjustedHeight = textHeight * lines.length;
            textHeight = lineAdjustedHeight;
            const bottomBounds = lineAdjustedHeight - Math.abs(metrics.actualBoundingBoxAscent);
            const x = 0;
            const y = 0;
            const measurement = new BoundingBox({
                left: x - Math.abs(metrics.actualBoundingBoxLeft) - this.font.padding,
                top: y - Math.abs(metrics.actualBoundingBoxAscent) - this.font.padding,
                bottom: y + bottomBounds + this.font.padding,
                right: x + Math.abs(metrics.actualBoundingBoxRight) + this.font.padding
            });
            return measurement;
        }
        _setDimension(textBounds, bitmap) {
            let lineHeightRatio = 1;
            if (this.font.lineHeight) lineHeightRatio = this.font.lineHeight / this.font.size;
            // Changing the width and height clears the context properties
            // We double the bitmap width to account for all possible alignment
            // We scale by "quality" so we render text without jaggies
            bitmap.canvas.width = (textBounds.width + this.font.padding * 2) * 2 * this.font.quality;
            bitmap.canvas.height = (textBounds.height + this.font.padding * 2) * 2 * this.font.quality * lineHeightRatio;
        }
        static getHashCode(font, text, color) {
            var _a;
            const hash = text + "__hashcode__" + font.fontString + font.showDebug + font.textAlign + font.baseAlign + font.direction + font.lineHeight + JSON.stringify(font.shadow) + (font.padding.toString() + font.smoothing.toString() + font.lineWidth.toString() + font.lineDash.toString() + ((_a = font.strokeColor) === null || _a === void 0 ? void 0 : _a.toString()) + (color ? color.toString() : font.color.toString()));
            return hash;
        }
        getHashCode(includeColor = true) {
            return FontTextInstance.getHashCode(this.font, this.text, includeColor ? this.color : undefined);
        }
        _applyRasterProperties(ctx) {
            var _a, _b;
            ctx.translate(this.font.padding, this.font.padding);
            ctx.imageSmoothingEnabled = this.font.smoothing;
            ctx.lineWidth = this.font.lineWidth;
            ctx.setLineDash((_a = this.font.lineDash) !== null && _a !== void 0 ? _a : ctx.getLineDash());
            ctx.strokeStyle = (_b = this.font.strokeColor) === null || _b === void 0 ? void 0 : _b.toString();
            ctx.fillStyle = this.color.toString();
        }
        _applyFont(ctx) {
            ctx.resetTransform();
            ctx.translate(this.font.padding + ctx.canvas.width / 2, this.font.padding + ctx.canvas.height / 2);
            ctx.scale(this.font.quality, this.font.quality);
            ctx.textAlign = this.font.textAlign;
            ctx.textBaseline = this.font.baseAlign;
            ctx.font = this.font.fontString;
            ctx.direction = this.font.direction;
            if (this.font.shadow) {
                ctx.shadowColor = this.font.shadow.color.toString();
                ctx.shadowBlur = this.font.shadow.blur;
                ctx.shadowOffsetX = this.font.shadow.offset.x;
                ctx.shadowOffsetY = this.font.shadow.offset.y;
            }
        }
        _drawText(ctx, lines, lineHeight) {
            this._applyRasterProperties(ctx);
            this._applyFont(ctx);
            for(let i = 0; i < lines.length; i++){
                const line = lines[i];
                if (this.color) ctx.fillText(line, 0, i * lineHeight);
                if (this.font.strokeColor) ctx.strokeText(line, 0, i * lineHeight);
            }
            if (this.font.showDebug) {
                // Horizontal line
                /* istanbul ignore next */ line(ctx, Color.Green, -ctx.canvas.width / 2, 0, ctx.canvas.width / 2, 0, 2);
                // Vertical line
                /* istanbul ignore next */ line(ctx, Color.Red, 0, -ctx.canvas.height / 2, 0, ctx.canvas.height / 2, 2);
            }
        }
        _splitTextBitmap(bitmap) {
            const textImages = [];
            let currentX = 0;
            let currentY = 0;
            // 4k is the max for mobile devices
            const width = Math.min(4096, bitmap.canvas.width);
            const height = Math.min(4096, bitmap.canvas.height);
            // Splits the original bitmap into 4k max chunks
            while(currentX < bitmap.canvas.width){
                while(currentY < bitmap.canvas.height){
                    // create new bitmap
                    const canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    // draw current slice to new bitmap in < 4k chunks
                    ctx.drawImage(bitmap.canvas, currentX, currentY, width, height, 0, 0, width, height);
                    textImages.push({
                        x: currentX,
                        y: currentY,
                        canvas: canvas
                    });
                    currentY += height;
                }
                currentX += width;
                currentY = 0;
            }
            return textImages;
        }
        flagDirty() {
            this._dirty = true;
        }
        render(ex, x, y, maxWidth) {
            var _a;
            if (this.disposed) throw Error("Accessing disposed text instance! " + this.text);
            this._ex = ex;
            const hashCode = this.getHashCode();
            if (this._lastHashCode !== hashCode) this._dirty = true;
            // Calculate image chunks
            if (this._dirty) {
                this.dimensions = this.measureText(this.text, maxWidth);
                this._setDimension(this.dimensions, this.ctx);
                const lines = this._getLinesFromText(this.text, maxWidth);
                const lineHeight = (_a = this.font.lineHeight) !== null && _a !== void 0 ? _a : this.dimensions.height / lines.length;
                // draws the text to the main bitmap
                this._drawText(this.ctx, lines, lineHeight);
                // clear any out old fragments
                if (ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)ex.textureLoader.delete(frag.canvas);
                // splits to < 4k fragments for large text
                this._textFragments = this._splitTextBitmap(this.ctx);
                if (ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)ex.textureLoader.load(frag.canvas, {
                    filtering: this.font.filtering
                }, true);
                this._lastHashCode = hashCode;
                this._dirty = false;
            }
            // draws the bitmap fragments to excalibur graphics context
            for (const frag of this._textFragments)ex.drawImage(frag.canvas, 0, 0, frag.canvas.width, frag.canvas.height, frag.x / this.font.quality + x - this.ctx.canvas.width / this.font.quality / 2, frag.y / this.font.quality + y - this.ctx.canvas.height / this.font.quality / 2, frag.canvas.width / this.font.quality, frag.canvas.height / this.font.quality);
        }
        dispose() {
            this.disposed = true;
            this.dimensions = undefined;
            this.canvas = undefined;
            this.ctx = undefined;
            if (this._ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)this._ex.textureLoader.delete(frag.canvas);
            this._textFragments.length = 0;
        }
        _getLinesFromText(text, maxWidth) {
            if (this._cachedText === text && this._cachedRenderWidth === maxWidth) return this._cachedLines;
            const lines = text.split("\n");
            if (maxWidth == null) return lines;
            // If the current line goes past the maxWidth, append a new line without modifying the underlying text.
            for(let i = 0; i < lines.length; i++){
                let line = lines[i];
                let newLine = "";
                if (this.measureText(line).width > maxWidth) {
                    while(this.measureText(line).width > maxWidth){
                        newLine = line[line.length - 1] + newLine;
                        line = line.slice(0, -1); // Remove last character from line
                    }
                    // Update the array with our new values
                    lines[i] = line;
                    lines[i + 1] = newLine;
                }
            }
            this._cachedText = text;
            this._cachedLines = lines;
            this._cachedRenderWidth = maxWidth;
            return lines;
        }
    }
    class FontCache {
        static measureText(text, font, maxWidth) {
            const hash = FontTextInstance.getHashCode(font, text);
            if (FontCache._MEASURE_CACHE.has(hash)) return FontCache._MEASURE_CACHE.get(hash);
            FontCache._LOGGER.debug("Font text measurement cache miss");
            const measurement = font.measureTextWithoutCache(text, maxWidth);
            FontCache._MEASURE_CACHE.set(hash, measurement);
            return measurement;
        }
        static getTextInstance(text, font, color) {
            const hash = FontTextInstance.getHashCode(font, text, color);
            let textInstance = FontCache._TEXT_CACHE.get(hash);
            if (!textInstance) {
                textInstance = new FontTextInstance(font, text, color);
                FontCache._TEXT_CACHE.set(hash, textInstance);
                FontCache._LOGGER.debug("Font text instance cache miss");
            }
            // Cache the bitmap for certain amount of time
            FontCache._TEXT_USAGE.set(textInstance, performance.now());
            return textInstance;
        }
        static checkAndClearCache() {
            const deferred = [];
            const currentHashCodes = new Set();
            for (const [textInstance, time] of FontCache._TEXT_USAGE.entries())// if bitmap hasn't been used in 100 ms clear it
            if (time + FontCache.FONT_TIMEOUT < performance.now()) {
                FontCache._LOGGER.debug(`Text cache entry timed out ${textInstance.text}`);
                deferred.push(textInstance);
                textInstance.dispose();
            } else {
                const hash = textInstance.getHashCode(false);
                currentHashCodes.add(hash);
            }
            // Deferred removal of text instances
            deferred.forEach((t)=>{
                FontCache._TEXT_USAGE.delete(t);
            });
            // Regenerate text instance cache
            this._TEXT_CACHE.clear();
            for (const [textInstance] of this._TEXT_USAGE.entries())this._TEXT_CACHE.set(textInstance.getHashCode(), textInstance);
            // Regenerated measurement cache
            const newTextMeasurementCache = new Map();
            for (const current of currentHashCodes)if (FontCache._MEASURE_CACHE.has(current)) newTextMeasurementCache.set(current, FontCache._MEASURE_CACHE.get(current));
            this._MEASURE_CACHE.clear();
            this._MEASURE_CACHE = newTextMeasurementCache;
        }
        static get cacheSize() {
            return FontCache._TEXT_USAGE.size;
        }
        /**
     * Force clear all cached text bitmaps
     */ static clearCache() {
            for (const [textInstance] of FontCache._TEXT_USAGE.entries())textInstance.dispose();
            FontCache._TEXT_USAGE.clear();
            FontCache._TEXT_CACHE.clear();
            FontCache._MEASURE_CACHE.clear();
        }
    }
    FontCache.FONT_TIMEOUT = 500;
    FontCache._LOGGER = Logger.getInstance();
    FontCache._TEXT_USAGE = new Map();
    FontCache._TEXT_CACHE = new Map();
    FontCache._MEASURE_CACHE = new Map();
    /**
 * Represents a system or web font in Excalibur
 *
 * If no options specified, the system sans-serif 10 pixel is used
 *
 * If loading a custom web font be sure to have the font loaded before you use it https://erikonarheim.com/posts/dont-test-fonts/
 */ class Font extends Graphic {
        constructor(options = {}){
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            super(options); // <- Graphics properties
            /**
         * Set the font filtering mode, by default set to [[ImageFiltering.Blended]] regardless of the engine default smoothing
         *
         * If you have a pixel style font that may be a reason to switch this to [[ImageFiltering.Pixel]]
         */ this.filtering = ImageFiltering.Blended;
            /**
         * Font quality determines the size of the underlying raster text, higher quality means less jagged edges.
         * If quality is set to 1, then just enough raster bitmap is generated to render the text.
         *
         * You can think of quality as how zoomed in to the text you can get before seeing jagged edges.
         *
         * (Default 2)
         */ this.quality = 2;
            // Raster properties for fonts
            this.padding = 2;
            this.smoothing = false;
            this.lineWidth = 1;
            this.lineDash = [];
            this.color = Color.Black;
            this.family = "sans-serif";
            this.style = FontStyle.Normal;
            this.bold = false;
            this.unit = FontUnit.Px;
            this.textAlign = TextAlign.Left;
            this.baseAlign = BaseAlign.Top;
            this.direction = Direction.LeftToRight;
            /**
         * Font line height in pixels, default line height if unset
         */ this.lineHeight = undefined;
            this.size = 10;
            this.shadow = null;
            this._textBounds = new BoundingBox();
            this._textMeasurement = new FontTextInstance(this, "", Color.Black);
            // Raster properties
            this.smoothing = (_a = options === null || options === void 0 ? void 0 : options.smoothing) !== null && _a !== void 0 ? _a : this.smoothing;
            this.padding = (_b = options === null || options === void 0 ? void 0 : options.padding) !== null && _b !== void 0 ? _b : this.padding;
            this.color = (_c = options === null || options === void 0 ? void 0 : options.color) !== null && _c !== void 0 ? _c : this.color;
            this.strokeColor = (_d = options === null || options === void 0 ? void 0 : options.strokeColor) !== null && _d !== void 0 ? _d : this.strokeColor;
            this.lineDash = (_e = options === null || options === void 0 ? void 0 : options.lineDash) !== null && _e !== void 0 ? _e : this.lineDash;
            this.lineWidth = (_f = options === null || options === void 0 ? void 0 : options.lineWidth) !== null && _f !== void 0 ? _f : this.lineWidth;
            this.filtering = (_g = options === null || options === void 0 ? void 0 : options.filtering) !== null && _g !== void 0 ? _g : this.filtering;
            // Font specific properties
            this.family = (_h = options === null || options === void 0 ? void 0 : options.family) !== null && _h !== void 0 ? _h : this.family;
            this.style = (_j = options === null || options === void 0 ? void 0 : options.style) !== null && _j !== void 0 ? _j : this.style;
            this.bold = (_k = options === null || options === void 0 ? void 0 : options.bold) !== null && _k !== void 0 ? _k : this.bold;
            this.size = (_l = options === null || options === void 0 ? void 0 : options.size) !== null && _l !== void 0 ? _l : this.size;
            this.unit = (_m = options === null || options === void 0 ? void 0 : options.unit) !== null && _m !== void 0 ? _m : this.unit;
            this.textAlign = (_o = options === null || options === void 0 ? void 0 : options.textAlign) !== null && _o !== void 0 ? _o : this.textAlign;
            this.baseAlign = (_p = options === null || options === void 0 ? void 0 : options.baseAlign) !== null && _p !== void 0 ? _p : this.baseAlign;
            this.direction = (_q = options === null || options === void 0 ? void 0 : options.direction) !== null && _q !== void 0 ? _q : this.direction;
            this.lineHeight = (_r = options === null || options === void 0 ? void 0 : options.lineHeight) !== null && _r !== void 0 ? _r : this.lineHeight;
            this.quality = (_s = options === null || options === void 0 ? void 0 : options.quality) !== null && _s !== void 0 ? _s : this.quality;
            if (options === null || options === void 0 ? void 0 : options.shadow) {
                this.shadow = {};
                this.shadow.blur = (_t = options.shadow.blur) !== null && _t !== void 0 ? _t : this.shadow.blur;
                this.shadow.offset = (_u = options.shadow.offset) !== null && _u !== void 0 ? _u : this.shadow.offset;
                this.shadow.color = (_v = options.shadow.color) !== null && _v !== void 0 ? _v : this.shadow.color;
            }
        }
        clone() {
            return new Font({
                ...this.cloneGraphicOptions(),
                size: this.size,
                unit: this.unit,
                family: this.family,
                style: this.style,
                bold: this.bold,
                textAlign: this.textAlign,
                baseAlign: this.baseAlign,
                direction: this.direction,
                shadow: this.shadow ? {
                    blur: this.shadow.blur,
                    offset: this.shadow.offset,
                    color: this.shadow.color
                } : null
            });
        }
        get fontString() {
            return `${this.style} ${this.bold ? "bold" : ""} ${this.size}${this.unit} ${this.family}`;
        }
        get localBounds() {
            return this._textBounds;
        }
        _drawImage(_ex, _x, _y) {
        // TODO weird vestigial drawimage
        }
        _rotate(ex) {
            var _a;
            // TODO this needs to change depending on the bounding box...
            const origin = (_a = this.origin) !== null && _a !== void 0 ? _a : this._textBounds.center;
            ex.translate(origin.x, origin.y);
            ex.rotate(this.rotation);
            ex.translate(-origin.x, -origin.y);
        }
        _flip(ex) {
            if (this.flipHorizontal) {
                ex.translate(this._textBounds.width / this.scale.x, 0);
                ex.scale(-1, 1);
            }
            if (this.flipVertical) {
                ex.translate(0, -this._textBounds.height / 2 / this.scale.y);
                ex.scale(1, -1);
            }
        }
        measureTextWithoutCache(text, maxWidth) {
            return this._textMeasurement.measureText(text, maxWidth);
        }
        /**
     * Returns a BoundingBox that is the total size of the text including multiple lines
     *
     * Does not include any padding or adjustment
     * @param text
     * @returns BoundingBox
     */ measureText(text, maxWidth) {
            return FontCache.measureText(text, this, maxWidth);
        }
        _postDraw(ex) {
            ex.restore();
        }
        render(ex, text, colorOverride, x, y, maxWidth) {
            const textInstance = FontCache.getTextInstance(text, this, colorOverride);
            // Apply affine transformations
            this._textBounds = textInstance.dimensions;
            this._preDraw(ex, x, y);
            textInstance.render(ex, x, y, maxWidth);
            this._postDraw(ex);
        }
    }
    /**
 * Represent Text graphics in excalibur
 *
 * Useful for in game labels, ui, or overlays
 */ class Text extends Graphic {
        constructor(options){
            var _a, _b;
            super(options);
            this._text = "";
            this._textWidth = 0;
            this._textHeight = 0;
            // This order is important font, color, then text
            this.font = (_a = options.font) !== null && _a !== void 0 ? _a : new Font();
            this.color = (_b = options.color) !== null && _b !== void 0 ? _b : this.color;
            this.text = options.text;
            this.maxWidth = options.maxWidth;
        }
        clone() {
            var _a, _b;
            return new Text({
                text: this.text.slice(),
                color: (_b = (_a = this.color) === null || _a === void 0 ? void 0 : _a.clone()) !== null && _b !== void 0 ? _b : Color.Black,
                font: this.font.clone(),
                maxWidth: this.maxWidth
            });
        }
        get text() {
            return this._text;
        }
        set text(value) {
            this._text = value;
            this._calculateDimension();
        }
        get font() {
            return this._font;
        }
        set font(font) {
            this._font = font;
        }
        get width() {
            if (this._textWidth === 0) this._calculateDimension();
            return this._textWidth * this.scale.x;
        }
        get height() {
            if (this._textHeight === 0) this._calculateDimension();
            return this._textHeight * this.scale.y;
        }
        _calculateDimension() {
            const { width: width, height: height } = this.font.measureText(this._text, this.maxWidth);
            this._textWidth = width;
            this._textHeight = height;
        }
        get localBounds() {
            return this.font.measureText(this._text, this.maxWidth).scale(this.scale);
        }
        _rotate(_ex) {
        // None this is delegated to font
        // This override erases the default behavior
        }
        _flip(_ex) {
        // None this is delegated to font
        // This override erases the default behavior
        }
        _preDraw(ex, x, y) {
            if (this.isStale() || this.font.isStale()) {
                this.font.flipHorizontal = this.flipHorizontal;
                this.font.flipVertical = this.flipVertical;
                this.font.rotation = this.rotation;
                this.font.origin = this.origin;
                this.font.opacity = this.opacity;
            }
            this.font.tint = this.tint;
            super._preDraw(ex, x, y);
        }
        _drawImage(ex, x, y) {
            var _a;
            let color = Color.Black;
            if (this.font instanceof Font) color = (_a = this.color) !== null && _a !== void 0 ? _a : this.font.color;
            const { width: width, height: height } = this.font.measureText(this._text, this.maxWidth);
            this._textWidth = width;
            this._textHeight = height;
            this.font.render(ex, this._text, color, x, y, this.maxWidth);
            if (this.font.showDebug) {
                ex.debug.drawRect(x - width, y - height, width * 2, height * 2);
                if (this.maxWidth != null) ex.debug.drawRect(x, y, this.maxWidth, this.height, {
                    color: Color.Yellow
                });
            }
        }
    }
    /**
 * Type guard for checking if something is an Actor
 * @param x
 */ function isActor(x) {
        return x instanceof Actor;
    }
    const ActorEvents = {
        CollisionStart: "collisionstart",
        CollisionEnd: "collisionend",
        PreCollision: "precollision",
        PostCollision: "postcollision",
        Kill: "kill",
        PreKill: "prekill",
        PostKill: "postkill",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PreTransformDraw: "pretransformdraw",
        PostTransformDraw: "posttransformdraw",
        PreDebugDraw: "predebugdraw",
        PostDebugDraw: "postdebugdraw",
        PointerUp: "pointerup",
        PointerDown: "pointerdown",
        PointerEnter: "pointerenter",
        PointerLeave: "pointerleave",
        PointerMove: "pointermove",
        PointerCancel: "pointercancel",
        Wheel: "pointerwheel",
        PointerDrag: "pointerdragstart",
        PointerDragEnd: "pointerdragend",
        PointerDragEnter: "pointerdragenter",
        PointerDragLeave: "pointerdragleave",
        PointerDragMove: "pointerdragmove",
        EnterViewPort: "enterviewport",
        ExitViewPort: "exitviewport",
        ActionStart: "actionstart",
        ActionComplete: "actioncomplete"
    };
    /**
 * The most important primitive in Excalibur is an `Actor`. Anything that
 * can move on the screen, collide with another `Actor`, respond to events,
 * or interact with the current scene, must be an actor. An `Actor` **must**
 * be part of a [[Scene]] for it to be drawn to the screen.
 */ class Actor extends Entity {
        /**
     * Gets the position vector of the actor in pixels
     */ get pos() {
            return this.transform.pos;
        }
        /**
     * Sets the position vector of the actor in pixels
     */ set pos(thePos) {
            this.transform.pos = thePos.clone();
        }
        /**
     * Gets the position vector of the actor from the last frame
     */ get oldPos() {
            return this.body.oldPos;
        }
        /**
     * Sets the position vector of the actor in the last frame
     */ set oldPos(thePos) {
            this.body.oldPos.setTo(thePos.x, thePos.y);
        }
        /**
     * Gets the velocity vector of the actor in pixels/sec
     */ get vel() {
            return this.motion.vel;
        }
        /**
     * Sets the velocity vector of the actor in pixels/sec
     */ set vel(theVel) {
            this.motion.vel = theVel.clone();
        }
        /**
     * Gets the velocity vector of the actor from the last frame
     */ get oldVel() {
            return this.body.oldVel;
        }
        /**
     * Sets the velocity vector of the actor from the last frame
     */ set oldVel(theVel) {
            this.body.oldVel.setTo(theVel.x, theVel.y);
        }
        /**
     * Gets the acceleration vector of the actor in pixels/second/second. An acceleration pointing down such as (0, 100) may be
     * useful to simulate a gravitational effect.
     */ get acc() {
            return this.motion.acc;
        }
        /**
     * Sets the acceleration vector of teh actor in pixels/second/second
     */ set acc(theAcc) {
            this.motion.acc = theAcc.clone();
        }
        /**
     * Sets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
     */ set oldAcc(theAcc) {
            this.body.oldAcc.setTo(theAcc.x, theAcc.y);
        }
        /**
     * Gets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
     */ get oldAcc() {
            return this.body.oldAcc;
        }
        /**
     * Gets the rotation of the actor in radians. 1 radian = 180/PI Degrees.
     */ get rotation() {
            return this.transform.rotation;
        }
        /**
     * Sets the rotation of the actor in radians. 1 radian = 180/PI Degrees.
     */ set rotation(theAngle) {
            this.transform.rotation = theAngle;
        }
        /**
     * Gets the rotational velocity of the actor in radians/second
     */ get angularVelocity() {
            return this.motion.angularVelocity;
        }
        /**
     * Sets the rotational velocity of the actor in radians/sec
     */ set angularVelocity(angularVelocity) {
            this.motion.angularVelocity = angularVelocity;
        }
        get scale() {
            return this.get(TransformComponent).scale;
        }
        set scale(scale) {
            this.get(TransformComponent).scale = scale;
        }
        /**
     * The anchor to apply all actor related transformations like rotation,
     * translation, and scaling. By default the anchor is in the center of
     * the actor. By default it is set to the center of the actor (.5, .5)
     *
     * An anchor of (.5, .5) will ensure that drawings are centered.
     *
     * Use `anchor.setTo` to set the anchor to a different point using
     * values between 0 and 1. For example, anchoring to the top-left would be
     * `Actor.anchor.setTo(0, 0)` and top-right would be `Actor.anchor.setTo(0, 1)`.
     */ get anchor() {
            return this._anchor;
        }
        set anchor(vec) {
            this._anchor = watch(vec, (v)=>this._handleAnchorChange(v));
            this._handleAnchorChange(vec);
        }
        _handleAnchorChange(v) {
            if (this.graphics) this.graphics.anchor = v;
        }
        /**
     * The offset in pixels to apply to all actor graphics
     *
     * Default offset of (0, 0)
     */ get offset() {
            return this._offset;
        }
        set offset(vec) {
            this._offset = watch(vec, (v)=>this._handleOffsetChange(v));
            this._handleOffsetChange(vec);
        }
        _handleOffsetChange(v) {
            if (this.graphics) this.graphics.offset = v;
        }
        /**
     * Indicates whether the actor is physically in the viewport
     */ get isOffScreen() {
            return this.hasTag("ex.offscreen");
        }
        get draggable() {
            return this._draggable;
        }
        set draggable(isDraggable) {
            if (isDraggable) {
                if (isDraggable && !this._draggable) {
                    this.events.on("pointerdragstart", this._pointerDragStartHandler);
                    this.events.on("pointerdragend", this._pointerDragEndHandler);
                    this.events.on("pointerdragmove", this._pointerDragMoveHandler);
                    this.events.on("pointerdragleave", this._pointerDragLeaveHandler);
                } else if (!isDraggable && this._draggable) {
                    this.events.off("pointerdragstart", this._pointerDragStartHandler);
                    this.events.off("pointerdragend", this._pointerDragEndHandler);
                    this.events.off("pointerdragmove", this._pointerDragMoveHandler);
                    this.events.off("pointerdragleave", this._pointerDragLeaveHandler);
                }
                this._draggable = isDraggable;
            }
        }
        /**
     * Sets the color of the actor's current graphic
     */ get color() {
            return this._color;
        }
        set color(v) {
            this._color = v.clone();
            const currentGraphic = this.graphics.current;
            if (currentGraphic instanceof Raster || currentGraphic instanceof Text) currentGraphic.color = this._color;
        }
        // #endregion
        /**
     *
     * @param config
     */ constructor(config){
            super();
            this.events = new EventEmitter();
            this._anchor = watch(Vector.Half, (v)=>this._handleAnchorChange(v));
            this._offset = watch(Vector.Zero, (v)=>this._handleOffsetChange(v));
            /**
         * Convenience reference to the global logger
         */ this.logger = Logger.getInstance();
            /**
         * Draggable helper
         */ this._draggable = false;
            this._dragging = false;
            this._pointerDragStartHandler = ()=>{
                this._dragging = true;
            };
            this._pointerDragEndHandler = ()=>{
                this._dragging = false;
            };
            this._pointerDragMoveHandler = (pe)=>{
                if (this._dragging) this.pos = pe.worldPos;
            };
            this._pointerDragLeaveHandler = (pe)=>{
                if (this._dragging) this.pos = pe.worldPos;
            };
            const { name: name, x: x, y: y, pos: pos, coordPlane: coordPlane, scale: scale, width: width, height: height, radius: radius, collider: collider, vel: vel, acc: acc, rotation: rotation, angularVelocity: angularVelocity, z: z, color: color, visible: visible, opacity: opacity, anchor: anchor, offset: offset, collisionType: collisionType, collisionGroup: collisionGroup } = {
                ...config
            };
            this.name = name !== null && name !== void 0 ? name : this.name;
            this.anchor = anchor !== null && anchor !== void 0 ? anchor : Actor.defaults.anchor.clone();
            this.offset = offset !== null && offset !== void 0 ? offset : Vector.Zero;
            this.transform = new TransformComponent();
            this.addComponent(this.transform);
            this.pos = pos !== null && pos !== void 0 ? pos : vec(x !== null && x !== void 0 ? x : 0, y !== null && y !== void 0 ? y : 0);
            this.rotation = rotation !== null && rotation !== void 0 ? rotation : 0;
            this.scale = scale !== null && scale !== void 0 ? scale : vec(1, 1);
            this.z = z !== null && z !== void 0 ? z : 0;
            this.transform.coordPlane = coordPlane !== null && coordPlane !== void 0 ? coordPlane : CoordPlane.World;
            this.pointer = new PointerComponent;
            this.addComponent(this.pointer);
            this.graphics = new GraphicsComponent({
                anchor: this.anchor,
                offset: this.offset,
                opacity: opacity
            });
            this.addComponent(this.graphics);
            this.motion = new MotionComponent;
            this.addComponent(this.motion);
            this.vel = vel !== null && vel !== void 0 ? vel : Vector.Zero;
            this.acc = acc !== null && acc !== void 0 ? acc : Vector.Zero;
            this.angularVelocity = angularVelocity !== null && angularVelocity !== void 0 ? angularVelocity : 0;
            this.actions = new ActionsComponent;
            this.addComponent(this.actions);
            this.body = new BodyComponent;
            this.addComponent(this.body);
            this.body.collisionType = collisionType !== null && collisionType !== void 0 ? collisionType : CollisionType.Passive;
            if (collisionGroup) this.body.group = collisionGroup;
            if (collider) {
                this.collider = new ColliderComponent(collider);
                this.addComponent(this.collider);
            } else if (radius) {
                this.collider = new ColliderComponent(Shape.Circle(radius));
                this.addComponent(this.collider);
            } else if (width > 0 && height > 0) {
                this.collider = new ColliderComponent(Shape.Box(width, height, this.anchor));
                this.addComponent(this.collider);
            } else {
                this.collider = new ColliderComponent();
                this.addComponent(this.collider); // no collider
            }
            this.graphics.visible = visible !== null && visible !== void 0 ? visible : true;
            if (color) {
                this.color = color;
                if (width && height) this.graphics.add(new Rectangle({
                    color: color,
                    width: width,
                    height: height
                }));
                else if (radius) this.graphics.add(new Circle({
                    color: color,
                    radius: radius
                }));
            }
        }
        clone() {
            const clone = new Actor({
                color: this.color.clone(),
                anchor: this.anchor.clone(),
                offset: this.offset.clone()
            });
            clone.clearComponents();
            clone.processComponentRemoval();
            // Clone builtins, order is important, same as ctor
            clone.addComponent(clone.transform = this.transform.clone(), true);
            clone.addComponent(clone.pointer = this.pointer.clone(), true);
            clone.addComponent(clone.graphics = this.graphics.clone(), true);
            clone.addComponent(clone.motion = this.motion.clone(), true);
            clone.addComponent(clone.actions = this.actions.clone(), true);
            clone.addComponent(clone.body = this.body.clone(), true);
            clone.addComponent(clone.collider = this.collider.clone(), true);
            const builtInComponents = [
                this.transform,
                this.pointer,
                this.graphics,
                this.motion,
                this.actions,
                this.body,
                this.collider
            ];
            // Clone non-builtin the current actors components
            const components = this.getComponents();
            for (const c of components)if (!builtInComponents.includes(c)) clone.addComponent(c.clone(), true);
            return clone;
        }
        /**
     * `onInitialize` is called before the first update of the actor. This method is meant to be
     * overridden. This is where initialization of child actors should take place.
     *
     * Synonymous with the event handler `.on('initialize', (evt) => {...})`
     */ onInitialize(engine) {
        // Override me
        }
        /**
     * Initializes this actor and all it's child actors, meant to be called by the Scene before first update not by users of Excalibur.
     *
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     * @internal
     */ _initialize(engine) {
            super._initialize(engine);
            for (const child of this.children)child._initialize(engine);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        // #endregion
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _prekill handler for [[onPreKill]] lifecycle event
     * @internal
     */ _prekill(scene) {
            this.events.emit("prekill", new PreKillEvent(this));
            this.onPreKill(scene);
        }
        /**
     * Safe to override onPreKill lifecycle event handler. Synonymous with `.on('prekill', (evt) =>{...})`
     *
     * `onPreKill` is called directly before an actor is killed and removed from its current [[Scene]].
     */ onPreKill(scene) {
        // Override me
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _prekill handler for [[onPostKill]] lifecycle event
     * @internal
     */ _postkill(scene) {
            this.events.emit("postkill", new PostKillEvent(this));
            this.onPostKill(scene);
        }
        /**
     * Safe to override onPostKill lifecycle event handler. Synonymous with `.on('postkill', (evt) => {...})`
     *
     * `onPostKill` is called directly after an actor is killed and remove from its current [[Scene]].
     */ onPostKill(scene) {
        // Override me
        }
        /**
     * If the current actor is a member of the scene, this will remove
     * it from the scene graph. It will no longer be drawn or updated.
     */ kill() {
            if (this.scene) {
                this._prekill(this.scene);
                this.events.emit("kill", new KillEvent(this));
                super.kill();
                this._postkill(this.scene);
            } else this.logger.warn(`Cannot kill actor named "${this.name}", it was never added to the Scene`);
        }
        /**
     * If the current actor is killed, it will now not be killed.
     */ unkill() {
            this.active = true;
        }
        /**
     * Indicates wether the actor has been killed.
     */ isKilled() {
            return !this.active;
        }
        /**
     * Gets the z-index of an actor. The z-index determines the relative order an actor is drawn in.
     * Actors with a higher z-index are drawn on top of actors with a lower z-index
     */ get z() {
            return this.get(TransformComponent).z;
        }
        /**
     * Sets the z-index of an actor and updates it in the drawing list for the scene.
     * The z-index determines the relative order an actor is drawn in.
     * Actors with a higher z-index are drawn on top of actors with a lower z-index
     * @param newZ new z-index to assign
     */ set z(newZ) {
            this.get(TransformComponent).z = newZ;
        }
        /**
     * Get the center point of an actor (global position)
     */ get center() {
            const globalPos = this.getGlobalPos();
            return new Vector(globalPos.x + this.width / 2 - this.anchor.x * this.width, globalPos.y + this.height / 2 - this.anchor.y * this.height);
        }
        /**
     * Get the local center point of an actor
     */ get localCenter() {
            return new Vector(this.pos.x + this.width / 2 - this.anchor.x * this.width, this.pos.y + this.height / 2 - this.anchor.y * this.height);
        }
        get width() {
            return this.collider.localBounds.width * this.getGlobalScale().x;
        }
        get height() {
            return this.collider.localBounds.height * this.getGlobalScale().y;
        }
        /**
     * Gets this actor's rotation taking into account any parent relationships
     * @returns Rotation angle in radians
     */ getGlobalRotation() {
            return this.get(TransformComponent).globalRotation;
        }
        /**
     * Gets an actor's world position taking into account parent relationships, scaling, rotation, and translation
     * @returns Position in world coordinates
     */ getGlobalPos() {
            return this.get(TransformComponent).globalPos;
        }
        /**
     * Gets the global scale of the Actor
     */ getGlobalScale() {
            return this.get(TransformComponent).globalScale;
        }
        // #region Collision
        /**
     * Tests whether the x/y specified are contained in the actor
     * @param x  X coordinate to test (in world coordinates)
     * @param y  Y coordinate to test (in world coordinates)
     * @param recurse checks whether the x/y are contained in any child actors (if they exist).
     */ contains(x, y, recurse = false) {
            const point = vec(x, y);
            const collider = this.get(ColliderComponent);
            collider.update();
            const geom = collider.get();
            if (!geom) return false;
            const containment = geom.contains(point);
            if (recurse) return containment || this.children.some((child)=>{
                return child.contains(x, y, true);
            });
            return containment;
        }
        /**
     * Returns true if the two actor.collider's surfaces are less than or equal to the distance specified from each other
     * @param actor     Actor to test
     * @param distance  Distance in pixels to test
     */ within(actor, distance) {
            const collider = this.get(ColliderComponent);
            const otherCollider = actor.get(ColliderComponent);
            const me = collider.get();
            const other = otherCollider.get();
            if (me && other) return me.getClosestLineBetween(other).getLength() <= distance;
            return false;
        }
        // #endregion
        // #region Update
        /**
     * Called by the Engine, updates the state of the actor
     * @internal
     * @param engine The reference to the current game engine
     * @param delta  The time elapsed since the last update in milliseconds
     */ update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            this._postupdate(engine, delta);
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before an actor is updated.
     */ onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('postupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after an actor is updated.
     */ onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     * Fires before every collision resolution for a confirmed contact
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onPreCollisionResolve(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires after every resolution for a confirmed contact.
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onPostCollisionResolve(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires once when 2 entities with a ColliderComponent first start colliding or touching, if the Colliders stay in contact this
     * does not continue firing until they separate and re-collide.
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onCollisionStart(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires once when 2 entities with a ColliderComponent separate after having been in contact.
     * @param self
     * @param other
     * @param side
     * @param lastContact
     */ onCollisionEnd(self1, other, side, lastContact) {
        // Override me
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
    }
    // #region Properties
    /**
 * Set defaults for all Actors
 */ Actor.defaults = {
        anchor: Vector.Half
    };
    /**
 * Type guard to detect a screen element
 */ function isScreenElement(actor) {
        return actor instanceof ScreenElement;
    }
    /**
 * Helper [[Actor]] primitive for drawing UI's, optimized for UI drawing. Does
 * not participate in collisions. Drawn on top of all other actors.
 */ class ScreenElement extends Actor {
        constructor(config){
            var _a, _b;
            super({
                ...config
            });
            this.get(TransformComponent).coordPlane = CoordPlane.Screen;
            this.anchor = (_a = config === null || config === void 0 ? void 0 : config.anchor) !== null && _a !== void 0 ? _a : vec(0, 0);
            this.body.collisionType = (_b = config === null || config === void 0 ? void 0 : config.collisionType) !== null && _b !== void 0 ? _b : CollisionType.PreventCollision;
            this.pointer.useGraphicsBounds = true;
            this.pointer.useColliderShape = false;
            if (!(config === null || config === void 0 ? void 0 : config.collider) && (config === null || config === void 0 ? void 0 : config.width) > 0 && (config === null || config === void 0 ? void 0 : config.height) > 0) this.collider.useBoxCollider(this.width, this.height, this.anchor);
        }
        _initialize(engine) {
            this._engine = engine;
            super._initialize(engine);
        }
        contains(x, y, useWorld = true) {
            if (useWorld) return super.contains(x, y);
            const coords = this._engine.worldToScreenCoordinates(new Vector(x, y));
            return super.contains(coords.x, coords.y);
        }
    }
    /**
 * The Excalibur timer hooks into the internal timer and fires callbacks,
 * after a certain interval, optionally repeating.
 */ class Timer {
        get complete() {
            return this._complete;
        }
        constructor(fcn, interval, repeats, numberOfRepeats, randomRange, random){
            this._logger = Logger.getInstance();
            this.id = 0;
            this._elapsedTime = 0;
            this._totalTimeAlive = 0;
            this._running = false;
            this._numberOfTicks = 0;
            this.interval = 10;
            this.repeats = false;
            this.maxNumberOfRepeats = -1;
            this.randomRange = [
                0,
                0
            ];
            this._baseInterval = 10;
            this._generateRandomInterval = ()=>{
                return this._baseInterval + this.random.integer(this.randomRange[0], this.randomRange[1]);
            };
            this._complete = false;
            this.scene = null;
            if (typeof fcn !== "function") {
                const options = fcn;
                fcn = options.fcn;
                interval = options.interval;
                repeats = options.repeats;
                numberOfRepeats = options.numberOfRepeats;
                randomRange = options.randomRange;
                random = options.random;
            }
            if (!!numberOfRepeats && numberOfRepeats >= 0) {
                this.maxNumberOfRepeats = numberOfRepeats;
                if (!repeats) throw new Error("repeats must be set to true if numberOfRepeats is set");
            }
            this.id = Timer._MAX_ID++;
            this._callbacks = [];
            this._baseInterval = this.interval = interval;
            if (!!randomRange) {
                if (randomRange[0] > randomRange[1]) throw new Error("min value must be lower than max value for range");
                //We use the instance of ex.Random to generate the range
                this.random = random !== null && random !== void 0 ? random : new Random();
                this.randomRange = randomRange;
                this.interval = this._generateRandomInterval();
                this.on(()=>{
                    this.interval = this._generateRandomInterval();
                });
            }
            this.repeats = repeats || this.repeats;
            if (fcn) this.on(fcn);
        }
        /**
     * Adds a new callback to be fired after the interval is complete
     * @param fcn The callback to be added to the callback list, to be fired after the interval is complete.
     */ on(fcn) {
            this._callbacks.push(fcn);
        }
        /**
     * Removes a callback from the callback list to be fired after the interval is complete.
     * @param fcn The callback to be removed from the callback list, to be fired after the interval is complete.
     */ off(fcn) {
            const index = this._callbacks.indexOf(fcn);
            this._callbacks.splice(index, 1);
        }
        /**
     * Updates the timer after a certain number of milliseconds have elapsed. This is used internally by the engine.
     * @param delta  Number of elapsed milliseconds since the last update.
     */ update(delta) {
            if (this._running) {
                this._totalTimeAlive += delta;
                this._elapsedTime += delta;
                if (this.maxNumberOfRepeats > -1 && this._numberOfTicks >= this.maxNumberOfRepeats) {
                    this._complete = true;
                    this._running = false;
                    this._elapsedTime = 0;
                }
                if (!this.complete && this._elapsedTime >= this.interval) {
                    this._callbacks.forEach((c)=>{
                        c.call(this);
                    });
                    this._numberOfTicks++;
                    if (this.repeats) this._elapsedTime = 0;
                    else {
                        this._complete = true;
                        this._running = false;
                        this._elapsedTime = 0;
                    }
                }
            }
        }
        /**
     * Resets the timer so that it can be reused, and optionally reconfigure the timers interval.
     *
     * Warning** you may need to call `timer.start()` again if the timer had completed
     * @param newInterval If specified, sets a new non-negative interval in milliseconds to refire the callback
     * @param newNumberOfRepeats If specified, sets a new non-negative upper limit to the number of time this timer executes
     */ reset(newInterval, newNumberOfRepeats) {
            if (!!newInterval && newInterval >= 0) this._baseInterval = this.interval = newInterval;
            if (!!this.maxNumberOfRepeats && this.maxNumberOfRepeats >= 0) {
                this.maxNumberOfRepeats = newNumberOfRepeats;
                if (!this.repeats) throw new Error("repeats must be set to true if numberOfRepeats is set");
            }
            this._complete = false;
            this._elapsedTime = 0;
            this._numberOfTicks = 0;
        }
        get timesRepeated() {
            return this._numberOfTicks;
        }
        getTimeRunning() {
            return this._totalTimeAlive;
        }
        /**
     * @returns milliseconds until the next action callback, if complete will return 0
     */ get timeToNextAction() {
            if (this.complete) return 0;
            return this.interval - this._elapsedTime;
        }
        /**
     * @returns milliseconds elapsed toward the next action
     */ get timeElapsedTowardNextAction() {
            return this._elapsedTime;
        }
        get isRunning() {
            return this._running;
        }
        /**
     * Pauses the timer, time will no longer increment towards the next call
     */ pause() {
            this._running = false;
            return this;
        }
        /**
     * Resumes the timer, time will now increment towards the next call.
     */ resume() {
            this._running = true;
            return this;
        }
        /**
     * Starts the timer, if the timer was complete it will restart the timer and reset the elapsed time counter
     */ start() {
            if (!this.scene) this._logger.warn("Cannot start a timer not part of a scene, timer wont start until added");
            this._running = true;
            if (this.complete) {
                this._complete = false;
                this._elapsedTime = 0;
                this._numberOfTicks = 0;
            }
            return this;
        }
        /**
     * Stops the timer and resets the elapsed time counter towards the next action invocation
     */ stop() {
            this._running = false;
            this._elapsedTime = 0;
            this._numberOfTicks = 0;
            return this;
        }
        /**
     * Cancels the timer, preventing any further executions.
     */ cancel() {
            this.pause();
            if (this.scene) this.scene.cancelTimer(this);
        }
    }
    Timer._MAX_ID = 0;
    class ParallaxComponent extends Component {
        constructor(parallaxFactor){
            super();
            this.parallaxFactor = vec(1.0, 1.0);
            this.parallaxFactor = parallaxFactor !== null && parallaxFactor !== void 0 ? parallaxFactor : this.parallaxFactor;
        }
    }
    /**
 * Provide arbitrary drawing for the purposes of debugging your game
 *
 * Will only show when the Engine is set to debug mode [[Engine.showDebug]] or [[Engine.toggleDebug]]
 *
 */ class DebugGraphicsComponent extends Component {
        constructor(draw, useTransform = true){
            super();
            this.draw = draw;
            this.useTransform = useTransform;
        }
    }
    const TileMapEvents = {
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PointerUp: "pointerup",
        PointerDown: "pointerdown",
        PointerMove: "pointermove",
        PointerCancel: "pointercancel"
    };
    /**
 * The TileMap provides a mechanism for doing flat 2D tiles rendered in a grid.
 *
 * TileMaps are useful for top down or side scrolling grid oriented games.
 */ class TileMap extends Entity {
        flagCollidersDirty() {
            this._collidersDirty = true;
        }
        flagTilesDirty() {
            for(let i = 0; i < this.tiles.length; i++)if (this.tiles[i]) this.tiles[i].flagDirty();
        }
        get x() {
            var _a;
            return (_a = this.transform.pos.x) !== null && _a !== void 0 ? _a : 0;
        }
        set x(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos) this.get(TransformComponent).pos = vec(val, this.y);
        }
        get y() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos.y) !== null && _b !== void 0 ? _b : 0;
        }
        set y(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos) this.transform.pos = vec(this.x, val);
        }
        get z() {
            var _a;
            return (_a = this.transform.z) !== null && _a !== void 0 ? _a : 0;
        }
        set z(val) {
            if (this.transform) this.transform.z = val;
        }
        get rotation() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.rotation) !== null && _b !== void 0 ? _b : 0;
        }
        set rotation(val) {
            if (this.transform) this.transform.rotation = val;
        }
        get scale() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : Vector.One;
        }
        set scale(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.scale) this.transform.scale = val;
        }
        get pos() {
            return this.transform.pos;
        }
        set pos(val) {
            this.transform.pos = val;
        }
        get vel() {
            return this._motion.vel;
        }
        set vel(val) {
            this._motion.vel = val;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * @param options
     */ constructor(options){
            var _a, _b, _c;
            super([], options.name);
            this.events = new EventEmitter();
            this._token = 0;
            this.logger = Logger.getInstance();
            this.tiles = [];
            this._rows = [];
            this._cols = [];
            this.renderFromTopOfGraphic = false;
            this.meshingLookBehind = 10;
            this._collidersDirty = true;
            this._forwardPointerEventToTile = (eventType)=>(evt)=>{
                    const tile = this.getTileByPoint(evt.worldPos);
                    if (tile) tile.events.emit(eventType, evt);
                };
            this._originalOffsets = new WeakMap();
            this.meshingLookBehind = (_a = options.meshingLookBehind) !== null && _a !== void 0 ? _a : this.meshingLookBehind;
            this.addComponent(new TransformComponent());
            this.addComponent(new MotionComponent());
            this.addComponent(new BodyComponent({
                type: CollisionType.Fixed
            }));
            this.addComponent(new GraphicsComponent({
                onPostDraw: (ctx, delta)=>this.draw(ctx, delta)
            }));
            this.addComponent(new DebugGraphicsComponent((ctx, debugFlags)=>this.debug(ctx, debugFlags), false));
            this.addComponent(new ColliderComponent());
            this.addComponent(new PointerComponent);
            this.pointer = this.get(PointerComponent);
            this._graphics = this.get(GraphicsComponent);
            this.transform = this.get(TransformComponent);
            this._motion = this.get(MotionComponent);
            this.collider = this.get(ColliderComponent);
            this._composite = this.collider.useCompositeCollider([]);
            this.transform.pos = (_b = options.pos) !== null && _b !== void 0 ? _b : Vector.Zero;
            this._oldPos = this.transform.pos.clone();
            this._oldScale = this.transform.scale.clone();
            this.renderFromTopOfGraphic = (_c = options.renderFromTopOfGraphic) !== null && _c !== void 0 ? _c : this.renderFromTopOfGraphic;
            this.tileWidth = options.tileWidth;
            this.tileHeight = options.tileHeight;
            this.rows = options.rows;
            this.columns = options.columns;
            this.tiles = new Array(this.rows * this.columns);
            this._rows = new Array(this.rows);
            this._cols = new Array(this.columns);
            let currentCol = [];
            for(let i = 0; i < this.columns; i++){
                for(let j = 0; j < this.rows; j++){
                    const tile = new Tile({
                        x: i,
                        y: j,
                        map: this
                    });
                    tile.map = this;
                    this.tiles[i + j * this.columns] = tile;
                    currentCol.push(tile);
                    if (!this._rows[j]) this._rows[j] = [];
                    this._rows[j].push(tile);
                }
                this._cols[i] = currentCol;
                currentCol = [];
            }
            this._setupPointerToTile();
            this._graphics.localBounds = new BoundingBox({
                left: 0,
                top: 0,
                right: this.columns * this.tileWidth * this.scale.x,
                bottom: this.rows * this.tileHeight * this.scale.y
            });
        }
        _initialize(engine) {
            super._initialize(engine);
            this._engine = engine;
        }
        _setupPointerToTile() {
            this.events.on("pointerup", this._forwardPointerEventToTile("pointerup"));
            this.events.on("pointerdown", this._forwardPointerEventToTile("pointerdown"));
            this.events.on("pointermove", this._forwardPointerEventToTile("pointermove"));
            this.events.on("pointercancel", this._forwardPointerEventToTile("pointercancel"));
        }
        _getOrSetColliderOriginalOffset(collider) {
            if (!this._originalOffsets.has(collider)) {
                const originalOffset = collider.offset;
                this._originalOffsets.set(collider, originalOffset);
                return originalOffset;
            } else return this._originalOffsets.get(collider);
        }
        /**
     * Tiles colliders based on the solid tiles in the tilemap.
     */ _updateColliders() {
            this.collider.$colliderRemoved.notifyAll(this._composite);
            this._composite.clearColliders();
            const colliders = [];
            this._composite = this.collider.useCompositeCollider([]);
            let current;
            /**
         * Returns wether or not the 2 boxes share an edge and are the same height
         * @param prev
         * @param next
         * @returns true if they share and edge, false if not
         */ const shareEdges = (prev, next)=>{
                if (prev && next) // same top/bottom
                return prev.top === next.top && prev.bottom === next.bottom && // Shared right/left edge
                prev.right === next.left;
                return false;
            };
            /**
         * Potentially merges the current collider into a list of previous ones, mutating the list
         * If checkAndCombine returns true, the collider was successfully merged and should be thrown away
         * @param current current collider to test
         * @param colliders List of colliders to consider merging with
         * @param maxLookBack The amount of colliders to look back for combination
         * @returns false when no combination found, true when successfully combined
         */ const checkAndCombine = (current, colliders, maxLookBack = this.meshingLookBehind)=>{
                if (!current) return false;
                // walk backwards through the list of colliders and combine with the first that shares an edge
                for(let i = colliders.length - 1; i >= 0; i--){
                    if (maxLookBack-- < 0) // blunt the O(n^2) algorithm a bit
                    return false;
                    const prev = colliders[i];
                    if (shareEdges(prev, current)) {
                        colliders[i] = prev.combine(current);
                        return true;
                    }
                }
                return false;
            };
            // ? configurable bias perhaps, horizontal strips vs. vertical ones
            // Bad tile collider packing algorithm
            for(let i = 0; i < this.columns; i++){
                // Scan column for colliders
                for(let j = 0; j < this.rows; j++){
                    const tile = this.tiles[i + j * this.columns];
                    // Current tile in column is solid build up current collider
                    if (tile.solid) {
                        // Use custom collider otherwise bounding box
                        if (tile.getColliders().length > 0) {
                            // tile with custom collider interrupting the current run
                            for (const collider of tile.getColliders()){
                                const originalOffset = this._getOrSetColliderOriginalOffset(collider);
                                collider.offset = vec(tile.x * this.tileWidth * this.scale.x, tile.y * this.tileHeight * this.scale.y).add(originalOffset);
                                collider.owner = this;
                                this._composite.addCollider(collider);
                            }
                            //we push any current collider before nulling the current run
                            if (current && !checkAndCombine(current, colliders)) colliders.push(current);
                            current = null;
                        // Use the bounding box
                        } else if (!current) // no current run, start one
                        current = tile.defaultGeometry;
                        else // combine with current run
                        current = current.combine(tile.defaultGeometry);
                    } else {
                        // Not solid skip and cut off the current collider
                        // End of run check and combine
                        if (current && !checkAndCombine(current, colliders)) colliders.push(current);
                        current = null;
                    }
                }
                // After a column is complete check to see if it can be merged into the last one
                // Eno of run check and combine
                if (current && !checkAndCombine(current, colliders)) // else new collider if no combination
                colliders.push(current);
                current = null;
            }
            for (const c of colliders){
                const collider = Shape.Box(c.width, c.height, Vector.Zero, vec(c.left - this.pos.x, c.top - this.pos.y));
                collider.owner = this;
                this._composite.addCollider(collider);
            }
            this.collider.update();
            // Notify that colliders have been updated
            this.collider.$colliderAdded.notifyAll(this._composite);
        }
        /**
     * Returns the [[Tile]] by index (row major order)
     */ getTileByIndex(index) {
            return this.tiles[index];
        }
        /**
     * Returns the [[Tile]] by its x and y integer coordinates
     *
     * For example, if I want the tile in fifth column (x), and second row (y):
     * `getTile(4, 1)` 0 based, so 0 is the first in row/column
     */ getTile(x, y) {
            if (x < 0 || y < 0 || x >= this.columns || y >= this.rows) return null;
            return this.tiles[x + y * this.columns];
        }
        /**
     * Returns the [[Tile]] by testing a point in world coordinates,
     * returns `null` if no Tile was found.
     */ getTileByPoint(point) {
            const { x: x, y: y } = this._getTileCoordinates(point);
            const tile = this.getTile(x, y);
            if (x >= 0 && y >= 0 && x < this.columns && y < this.rows && tile) return tile;
            return null;
        }
        _getTileCoordinates(point) {
            // Convert to Tile Space point
            point = this.transform.applyInverse(point);
            const x = Math.floor(point.x / this.tileWidth);
            const y = Math.floor(point.y / this.tileHeight);
            return {
                x: x,
                y: y
            };
        }
        getRows() {
            return this._rows;
        }
        getColumns() {
            return this._cols;
        }
        /**
     * Returns the on screen tiles for a tilemap, this will overshoot by a small amount because of the internal quad tree data structure.
     *
     * Useful if you need to perform specific logic on onscreen tiles
     */ getOnScreenTiles() {
            let worldBounds = this._engine.screen.getWorldBounds();
            const maybeParallax = this.get(ParallaxComponent);
            if (maybeParallax && this.isInitialized) {
                let pos = this.pos;
                const oneMinusFactor = Vector.One.sub(maybeParallax.parallaxFactor);
                const parallaxOffset = this._engine.currentScene.camera.pos.scale(oneMinusFactor);
                pos = pos.sub(parallaxOffset);
                // adjust world bounds by parallax factor
                worldBounds = worldBounds.translate(pos);
            }
            const bounds = this.transform.coordPlane === CoordPlane.Screen ? this._engine.screen.getScreenBounds() : worldBounds;
            const topLeft = this._getTileCoordinates(bounds.topLeft);
            const topRight = this._getTileCoordinates(bounds.topRight);
            const bottomRight = this._getTileCoordinates(bounds.bottomRight);
            const bottomLeft = this._getTileCoordinates(bounds.bottomLeft);
            const tileStartX = Math.min(clamp(topLeft.x, 0, this.columns - 1), clamp(topRight.x, 0, this.columns - 1));
            const tileStartY = Math.min(clamp(topLeft.y, 0, this.rows - 1), clamp(topRight.y, 0, this.rows - 1));
            const tileEndX = Math.max(clamp(bottomRight.x, 0, this.columns - 1), clamp(bottomLeft.x, 0, this.columns - 1));
            const tileEndY = Math.max(clamp(bottomRight.y, 0, this.rows - 1), clamp(bottomLeft.y, 0, this.rows - 1));
            const tiles = [];
            for(let x = tileStartX; x <= tileEndX; x++)for(let y = tileStartY; y <= tileEndY; y++)tiles.push(this.getTile(x, y));
            return tiles;
        }
        update(engine, delta) {
            this._initialize(engine);
            this.onPreUpdate(engine, delta);
            this.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            if (!this._oldPos.equals(this.pos) || this._oldRotation !== this.rotation || !this._oldScale.equals(this.scale)) {
                this.flagCollidersDirty();
                this.flagTilesDirty();
            }
            if (this._collidersDirty) {
                this._collidersDirty = false;
                this._updateColliders();
            }
            this._token++;
            this.pos.clone(this._oldPos);
            this._oldRotation = this.rotation;
            this.scale.clone(this._oldScale);
            this.transform.pos = this.pos;
            this.onPostUpdate(engine, delta);
            this.emit("postupdate", new PostUpdateEvent(engine, delta, this));
        }
        /**
     * Draws the tile map to the screen. Called by the [[Scene]].
     * @param ctx ExcaliburGraphicsContext
     * @param delta  The number of milliseconds since the last draw
     */ draw(ctx, delta) {
            if (!this.isInitialized) return;
            this.emit("predraw", new PreDrawEvent(ctx, delta, this)); // TODO fix event
            let graphics, graphicsIndex, graphicsLen;
            const tiles = this.getOnScreenTiles();
            for(let i = 0; i < tiles.length; i++){
                const tile = tiles[i];
                // get non-negative tile sprites
                const offsets = tile.getGraphicsOffsets();
                graphics = tile.getGraphics();
                for(graphicsIndex = 0, graphicsLen = graphics.length; graphicsIndex < graphicsLen; graphicsIndex++){
                    // draw sprite, warning if sprite doesn't exist
                    const graphic = graphics[graphicsIndex];
                    const offset = offsets[graphicsIndex];
                    if (graphic) {
                        if (hasGraphicsTick(graphic)) graphic === null || graphic === void 0 || graphic.tick(delta, this._token);
                        const offsetY = this.renderFromTopOfGraphic ? 0 : graphic.height - this.tileHeight;
                        graphic.draw(ctx, tile.x * this.tileWidth + offset.x, tile.y * this.tileHeight - offsetY + offset.y);
                    }
                }
            }
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
        }
        debug(gfx, debugFlags) {
            const { showAll: showAll, showGrid: showGrid, gridColor: gridColor, gridWidth: gridWidth, showSolidBounds: showColliderBounds, solidBoundsColor: colliderBoundsColor, showColliderGeometry: showColliderGeometry } = debugFlags.tilemap;
            const { geometryColor: geometryColor, geometryLineWidth: geometryLineWidth, geometryPointSize: geometryPointSize } = debugFlags.collider;
            const width = this.tileWidth * this.columns * this.scale.x;
            const height = this.tileHeight * this.rows * this.scale.y;
            const pos = this.pos;
            if (showGrid || showAll) {
                for(let r = 0; r < this.rows + 1; r++){
                    const yOffset = vec(0, r * this.tileHeight * this.scale.y);
                    gfx.drawLine(pos.add(yOffset), pos.add(vec(width, yOffset.y)), gridColor, gridWidth);
                }
                for(let c = 0; c < this.columns + 1; c++){
                    const xOffset = vec(c * this.tileWidth * this.scale.x, 0);
                    gfx.drawLine(pos.add(xOffset), pos.add(vec(xOffset.x, height)), gridColor, gridWidth);
                }
            }
            if (showAll || showColliderBounds || showColliderGeometry) {
                const colliders = this._composite.getColliders();
                gfx.save();
                gfx.translate(this.pos.x, this.pos.y);
                gfx.scale(this.scale.x, this.scale.y);
                for (const collider of colliders){
                    const bounds = collider.localBounds;
                    const pos = collider.worldPos.sub(this.pos);
                    if (showColliderBounds) gfx.drawRectangle(pos, bounds.width, bounds.height, colliderBoundsColor);
                }
                gfx.restore();
                if (showColliderGeometry) for (const collider of colliders)collider.debug(gfx, geometryColor, {
                    lineWidth: geometryLineWidth,
                    pointSize: geometryPointSize
                });
            }
            if (showAll || showColliderBounds) {
                gfx.save();
                gfx.z = 999;
                if (showColliderBounds) for(let i = 0; i < this.tiles.length; i++)this.tiles[i].bounds.draw(gfx);
                gfx.restore();
            }
        }
    }
    /**
 * TileMap Tile
 *
 * A light-weight object that occupies a space in a collision map. Generally
 * created by a [[TileMap]].
 *
 * Tiles can draw multiple sprites. Note that the order of drawing is the order
 * of the sprites in the array so the last one will be drawn on top. You can
 * use transparency to create layers this way.
 */ class Tile {
        /**
     * Return the world position of the top left corner of the tile
     */ get pos() {
            if (this._posDirty) {
                this._recalculate();
                this._posDirty = false;
            }
            return this._pos;
        }
        /**
     * Width of the tile in pixels
     */ get width() {
            return this._width;
        }
        /**
     * Height of the tile in pixels
     */ get height() {
            return this._height;
        }
        /**
     * Wether this tile should be treated as solid by the tilemap
     */ get solid() {
            return this._solid;
        }
        /**
     * Wether this tile should be treated as solid by the tilemap
     */ set solid(val) {
            var _a;
            (_a = this.map) === null || _a === void 0 || _a.flagCollidersDirty();
            this._solid = val;
        }
        /**
     * Current list of graphics for this tile
     */ getGraphics() {
            return this._graphics;
        }
        /**
     * Current list of offsets for this tile's graphics
     */ getGraphicsOffsets() {
            return this._offsets;
        }
        /**
     * Add another [[Graphic]] to this TileMap tile
     * @param graphic
     */ addGraphic(graphic, options) {
            this._graphics.push(graphic);
            if (options === null || options === void 0 ? void 0 : options.offset) this._offsets.push(options.offset);
            else this._offsets.push(Vector.Zero);
        }
        /**
     * Remove an instance of a [[Graphic]] from this tile
     */ removeGraphic(graphic) {
            const index = this._graphics.indexOf(graphic);
            if (index > -1) {
                this._graphics.splice(index, 1);
                this._offsets.splice(index, 1);
            }
        }
        /**
     * Clear all graphics from this tile
     */ clearGraphics() {
            this._graphics.length = 0;
            this._offsets.length = 0;
        }
        /**
     * Returns the list of colliders
     */ getColliders() {
            return this._colliders;
        }
        /**
     * Adds a custom collider to the [[Tile]] to use instead of it's bounds
     *
     * If no collider is set but [[Tile.solid]] is set, the tile bounds are used as a collider.
     *
     * **Note!** the [[Tile.solid]] must be set to true for it to act as a "fixed" collider
     * @param collider
     */ addCollider(collider) {
            this._colliders.push(collider);
            this.map.flagCollidersDirty();
        }
        /**
     * Removes a collider from the [[Tile]]
     * @param collider
     */ removeCollider(collider) {
            const index = this._colliders.indexOf(collider);
            if (index > -1) this._colliders.splice(index, 1);
            this.map.flagCollidersDirty();
        }
        /**
     * Clears all colliders from the [[Tile]]
     */ clearColliders() {
            this._colliders.length = 0;
            this.map.flagCollidersDirty();
        }
        constructor(options){
            var _a, _b;
            this._posDirty = false;
            this.events = new EventEmitter();
            this._solid = false;
            this._graphics = [];
            this._offsets = [];
            /**
         * Current list of colliders for this tile
         */ this._colliders = [];
            /**
         * Arbitrary data storage per tile, useful for any game specific data
         */ this.data = new Map();
            this.x = options.x;
            this.y = options.y;
            this.map = options.map;
            this._width = options.map.tileWidth * this.map.scale.x;
            this._height = options.map.tileHeight * this.map.scale.y;
            this.solid = (_a = options.solid) !== null && _a !== void 0 ? _a : this.solid;
            this._graphics = (_b = options.graphics) !== null && _b !== void 0 ? _b : [];
            this._recalculate();
        }
        flagDirty() {
            return this._posDirty = true;
        }
        _recalculate() {
            const geometryPos = this.map.pos.add(vec(this.x * this.map.tileWidth, this.y * this.map.tileHeight));
            this._geometry = new BoundingBox(geometryPos.x, geometryPos.y, geometryPos.x + this.map.tileWidth, geometryPos.y + this.map.tileHeight);
            this._width = this.map.tileWidth * this.map.scale.x;
            this._height = this.map.tileHeight * this.map.scale.y;
            this._pos = this.map.pos.add(vec(this.x * this._width, this.y * this._height));
            this._bounds = new BoundingBox(this._pos.x, this._pos.y, this._pos.x + this._width, this._pos.y + this._height);
            if (this.map.rotation) this._bounds = this._bounds.rotate(this.map.rotation, this.map.pos);
            this._posDirty = false;
        }
        /**
     * Tile bounds in world space
     */ get bounds() {
            if (this._posDirty) this._recalculate();
            return this._bounds;
        }
        get defaultGeometry() {
            return this._geometry;
        }
        /**
     * Tile position in world space
     */ get center() {
            if (this._posDirty) this._recalculate();
            return new Vector(this._pos.x + this._width / 2, this._pos.y + this._height / 2);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            if (handler) this.events.off(eventName, handler);
            else this.events.off(eventName);
        }
    }
    /**
 * Container to house convenience strategy methods
 * @internal
 */ class StrategyContainer {
        constructor(camera){
            this.camera = camera;
        }
        /**
     * Creates and adds the [[LockCameraToActorStrategy]] on the current camera.
     * @param actor The actor to lock the camera to
     */ lockToActor(actor) {
            this.camera.addStrategy(new LockCameraToActorStrategy(actor));
        }
        /**
     * Creates and adds the [[LockCameraToActorAxisStrategy]] on the current camera
     * @param actor The actor to lock the camera to
     * @param axis The axis to follow the actor on
     */ lockToActorAxis(actor, axis) {
            this.camera.addStrategy(new LockCameraToActorAxisStrategy(actor, axis));
        }
        /**
     * Creates and adds the [[ElasticToActorStrategy]] on the current camera
     * If cameraElasticity < cameraFriction < 1.0, the behavior will be a dampened spring that will slowly end at the target without bouncing
     * If cameraFriction < cameraElasticity < 1.0, the behavior will be an oscillating spring that will over
     * correct and bounce around the target
     * @param actor Target actor to elastically follow
     * @param cameraElasticity [0 - 1.0] The higher the elasticity the more force that will drive the camera towards the target
     * @param cameraFriction [0 - 1.0] The higher the friction the more that the camera will resist motion towards the target
     */ elasticToActor(actor, cameraElasticity, cameraFriction) {
            this.camera.addStrategy(new ElasticToActorStrategy(actor, cameraElasticity, cameraFriction));
        }
        /**
     * Creates and adds the [[RadiusAroundActorStrategy]] on the current camera
     * @param actor Target actor to follow when it is "radius" pixels away
     * @param radius Number of pixels away before the camera will follow
     */ radiusAroundActor(actor, radius) {
            this.camera.addStrategy(new RadiusAroundActorStrategy(actor, radius));
        }
        /**
     * Creates and adds the [[LimitCameraBoundsStrategy]] on the current camera
     * @param box The bounding box to limit the camera to.
     */ limitCameraBounds(box) {
            this.camera.addStrategy(new LimitCameraBoundsStrategy(box));
        }
    }
    /**
 * Camera axis enum
 */ var Axis;
    (function(Axis) {
        Axis[Axis["X"] = 0] = "X";
        Axis[Axis["Y"] = 1] = "Y";
    })(Axis || (Axis = {}));
    /**
 * Lock a camera to the exact x/y position of an actor.
 */ class LockCameraToActorStrategy {
        constructor(target){
            this.target = target;
            this.action = (target, camera, engine, delta)=>{
                const center = target.center;
                return center;
            };
        }
    }
    /**
 * Lock a camera to a specific axis around an actor.
 */ class LockCameraToActorAxisStrategy {
        constructor(target, axis){
            this.target = target;
            this.axis = axis;
            this.action = (target, cam, _eng, _delta)=>{
                const center = target.center;
                const currentFocus = cam.getFocus();
                if (this.axis === Axis.X) return new Vector(center.x, currentFocus.y);
                else return new Vector(currentFocus.x, center.y);
            };
        }
    }
    /**
 * Using [Hook's law](https://en.wikipedia.org/wiki/Hooke's_law), elastically move the camera towards the target actor.
 */ class ElasticToActorStrategy {
        /**
     * If cameraElasticity < cameraFriction < 1.0, the behavior will be a dampened spring that will slowly end at the target without bouncing
     * If cameraFriction < cameraElasticity < 1.0, the behavior will be an oscillating spring that will over
     * correct and bounce around the target
     * @param target Target actor to elastically follow
     * @param cameraElasticity [0 - 1.0] The higher the elasticity the more force that will drive the camera towards the target
     * @param cameraFriction [0 - 1.0] The higher the friction the more that the camera will resist motion towards the target
     */ constructor(target, cameraElasticity, cameraFriction){
            this.target = target;
            this.cameraElasticity = cameraElasticity;
            this.cameraFriction = cameraFriction;
            this.action = (target, cam, _eng, _delta)=>{
                const position = target.center;
                let focus = cam.getFocus();
                let cameraVel = cam.vel.clone();
                // Calculate the stretch vector, using the spring equation
                // F = kX
                // https://en.wikipedia.org/wiki/Hooke's_law
                // Apply to the current camera velocity
                const stretch = position.sub(focus).scale(this.cameraElasticity); // stretch is X
                cameraVel = cameraVel.add(stretch);
                // Calculate the friction (-1 to apply a force in the opposition of motion)
                // Apply to the current camera velocity
                const friction = cameraVel.scale(-1).scale(this.cameraFriction);
                cameraVel = cameraVel.add(friction);
                // Update position by velocity deltas
                focus = focus.add(cameraVel);
                return focus;
            };
        }
    }
    class RadiusAroundActorStrategy {
        /**
     *
     * @param target Target actor to follow when it is "radius" pixels away
     * @param radius Number of pixels away before the camera will follow
     */ constructor(target, radius){
            this.target = target;
            this.radius = radius;
            this.action = (target, cam, _eng, _delta)=>{
                const position = target.center;
                const focus = cam.getFocus();
                const direction = position.sub(focus);
                const distance = direction.size;
                if (distance >= this.radius) {
                    const offset = distance - this.radius;
                    return focus.add(direction.normalize().scale(offset));
                }
                return focus;
            };
        }
    }
    /**
 * Prevent a camera from going beyond the given camera dimensions.
 */ class LimitCameraBoundsStrategy {
        constructor(target){
            this.target = target;
            /**
         * Useful for limiting the camera to a [[TileMap]]'s dimensions, or a specific area inside the map.
         *
         * Note that this strategy does not perform any movement by itself.
         * It only sets the camera position to within the given bounds when the camera has gone beyond them.
         * Thus, it is a good idea to combine it with other camera strategies and set this strategy as the last one.
         *
         * Make sure that the camera bounds are at least as large as the viewport size.
         * @param target The bounding box to limit the camera to
         */ this.boundSizeChecked = false; // Check and warn only once
            this.action = (target, cam, _eng, _delta)=>{
                const focus = cam.getFocus();
                if (!this.boundSizeChecked) {
                    if (target.bottom - target.top < _eng.drawHeight || target.right - target.left < _eng.drawWidth) Logger.getInstance().warn("Camera bounds should not be smaller than the engine viewport");
                    this.boundSizeChecked = true;
                }
                let focusX = focus.x;
                let focusY = focus.y;
                if (focus.x < target.left + _eng.halfDrawWidth) focusX = target.left + _eng.halfDrawWidth;
                else if (focus.x > target.right - _eng.halfDrawWidth) focusX = target.right - _eng.halfDrawWidth;
                if (focus.y < target.top + _eng.halfDrawHeight) focusY = target.top + _eng.halfDrawHeight;
                else if (focus.y > target.bottom - _eng.halfDrawHeight) focusY = target.bottom - _eng.halfDrawHeight;
                return vec(focusX, focusY);
            };
        }
    }
    const CameraEvents = {
        Initialize: "initialize",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate"
    };
    /**
 * Cameras
 *
 * [[Camera]] is the base class for all Excalibur cameras. Cameras are used
 * to move around your game and set focus. They are used to determine
 * what is "off screen" and can be used to scale the game.
 *
 */ class Camera {
        constructor(){
            this.events = new EventEmitter();
            this.transform = AffineMatrix.identity();
            this.inverse = AffineMatrix.identity();
            this._cameraStrategies = [];
            this.strategy = new StrategyContainer(this);
            /**
         * Get or set current zoom of the camera, defaults to 1
         */ this._z = 1;
            /**
         * Get or set rate of change in zoom, defaults to 0
         */ this.dz = 0;
            /**
         * Get or set zoom acceleration
         */ this.az = 0;
            /**
         * Current rotation of the camera
         */ this.rotation = 0;
            this._angularVelocity = 0;
            /**
         * Get or set the camera's position
         */ this._posChanged = false;
            this._pos = watchAny(Vector.Zero, ()=>this._posChanged = true);
            /**
         * Interpolated camera position if more draws are running than updates
         *
         * Enabled when `Engine.fixedUpdateFps` is enabled, in all other cases this will be the same as pos
         */ this.drawPos = this.pos.clone();
            this._oldPos = this.pos.clone();
            /**
         * Get or set the camera's velocity
         */ this.vel = Vector.Zero;
            /**
         * Get or set the camera's acceleration
         */ this.acc = Vector.Zero;
            this._cameraMoving = false;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = null;
            this._lerpEnd = null;
            //camera effects
            this._isShaking = false;
            this._shakeMagnitudeX = 0;
            this._shakeMagnitudeY = 0;
            this._shakeDuration = 0;
            this._elapsedShakeTime = 0;
            this._xShake = 0;
            this._yShake = 0;
            this._isZooming = false;
            this._zoomStart = 1;
            this._zoomEnd = 1;
            this._currentZoomTime = 0;
            this._zoomDuration = 0;
            this._zoomEasing = EasingFunctions.EaseInOutCubic;
            this._easing = EasingFunctions.EaseInOutCubic;
            this._halfWidth = 0;
            this._halfHeight = 0;
            this._viewport = null;
            this._isInitialized = false;
            this._snapPos = vec(0, 0);
        }
        get zoom() {
            return this._z;
        }
        set zoom(val) {
            this._z = val;
            if (this._engine) {
                this._halfWidth = this._engine.halfDrawWidth;
                this._halfHeight = this._engine.halfDrawHeight;
            }
        }
        /**
     * Get or set the camera's angular velocity
     */ get angularVelocity() {
            return this._angularVelocity;
        }
        set angularVelocity(value) {
            this._angularVelocity = value;
        }
        get pos() {
            return this._pos;
        }
        set pos(vec) {
            this._pos = watchAny(vec, ()=>this._posChanged = true);
            this._posChanged = true;
        }
        /**
     * Get the camera's x position
     */ get x() {
            return this.pos.x;
        }
        /**
     * Set the camera's x position (cannot be set when following an [[Actor]] or when moving)
     */ set x(value) {
            if (!this._follow && !this._cameraMoving) this.pos = vec(value, this.pos.y);
        }
        /**
     * Get the camera's y position
     */ get y() {
            return this.pos.y;
        }
        /**
     * Set the camera's y position (cannot be set when following an [[Actor]] or when moving)
     */ set y(value) {
            if (!this._follow && !this._cameraMoving) this.pos = vec(this.pos.x, value);
        }
        /**
     * Get or set the camera's x velocity
     */ get dx() {
            return this.vel.x;
        }
        set dx(value) {
            this.vel = vec(value, this.vel.y);
        }
        /**
     * Get or set the camera's y velocity
     */ get dy() {
            return this.vel.y;
        }
        set dy(value) {
            this.vel = vec(this.vel.x, value);
        }
        /**
     * Get or set the camera's x acceleration
     */ get ax() {
            return this.acc.x;
        }
        set ax(value) {
            this.acc = vec(value, this.acc.y);
        }
        /**
     * Get or set the camera's y acceleration
     */ get ay() {
            return this.acc.y;
        }
        set ay(value) {
            this.acc = vec(this.acc.x, value);
        }
        /**
     * Returns the focal point of the camera, a new point giving the x and y position of the camera
     */ getFocus() {
            return this.pos;
        }
        /**
     * This moves the camera focal point to the specified position using specified easing function. Cannot move when following an Actor.
     * @param pos The target position to move to
     * @param duration The duration in milliseconds the move should last
     * @param [easingFn] An optional easing function ([[ex.EasingFunctions.EaseInOutCubic]] by default)
     * @returns A [[Promise]] that resolves when movement is finished, including if it's interrupted.
     *          The [[Promise]] value is the [[Vector]] of the target position. It will be rejected if a move cannot be made.
     */ move(pos, duration, easingFn = EasingFunctions.EaseInOutCubic) {
            if (typeof easingFn !== "function") throw "Please specify an EasingFunction";
            // cannot move when following an actor
            if (this._follow) return Promise.reject(pos);
            // resolve existing promise, if any
            if (this._lerpPromise && this._lerpResolve) this._lerpResolve(pos);
            this._lerpPromise = new Promise((resolve)=>{
                this._lerpResolve = resolve;
            });
            this._lerpStart = this.getFocus().clone();
            this._lerpDuration = duration;
            this._lerpEnd = pos;
            this._currentLerpTime = 0;
            this._cameraMoving = true;
            this._easing = easingFn;
            return this._lerpPromise;
        }
        /**
     * Sets the camera to shake at the specified magnitudes for the specified duration
     * @param magnitudeX  The x magnitude of the shake
     * @param magnitudeY  The y magnitude of the shake
     * @param duration    The duration of the shake in milliseconds
     */ shake(magnitudeX, magnitudeY, duration) {
            this._isShaking = true;
            this._shakeMagnitudeX = magnitudeX;
            this._shakeMagnitudeY = magnitudeY;
            this._shakeDuration = duration;
        }
        /**
     * Zooms the camera in or out by the specified scale over the specified duration.
     * If no duration is specified, it take effect immediately.
     * @param scale    The scale of the zoom
     * @param duration The duration of the zoom in milliseconds
     */ zoomOverTime(scale, duration = 0, easingFn = EasingFunctions.EaseInOutCubic) {
            this._zoomPromise = new Promise((resolve)=>{
                this._zoomResolve = resolve;
            });
            if (duration) {
                this._isZooming = true;
                this._zoomEasing = easingFn;
                this._currentZoomTime = 0;
                this._zoomDuration = duration;
                this._zoomStart = this.zoom;
                this._zoomEnd = scale;
            } else {
                this._isZooming = false;
                this.zoom = scale;
                return Promise.resolve(true);
            }
            return this._zoomPromise;
        }
        /**
     * Gets the bounding box of the viewport of this camera in world coordinates
     */ get viewport() {
            if (this._viewport) return this._viewport;
            return new BoundingBox(0, 0, 0, 0);
        }
        /**
     * Adds a new camera strategy to this camera
     * @param cameraStrategy Instance of an [[CameraStrategy]]
     */ addStrategy(cameraStrategy) {
            this._cameraStrategies.push(cameraStrategy);
        }
        /**
     * Removes a camera strategy by reference
     * @param cameraStrategy Instance of an [[CameraStrategy]]
     */ removeStrategy(cameraStrategy) {
            removeItemFromArray(cameraStrategy, this._cameraStrategies);
        }
        /**
     * Clears all camera strategies from the camera
     */ clearAllStrategies() {
            this._cameraStrategies.length = 0;
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before a scene is updated.
     */ onPreUpdate(engine, delta) {
        // Overridable
        }
        /**
     *  It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onPostUpdate(engine, delta) {
        // Overridable
        }
        get isInitialized() {
            return this._isInitialized;
        }
        _initialize(engine) {
            if (!this.isInitialized) {
                this._engine = engine;
                this._screen = engine.screen;
                const currentRes = this._screen.contentArea;
                let center = vec(currentRes.width / 2, currentRes.height / 2);
                if (!this._engine.loadingComplete) {
                    // If there was a loading screen, we peek the configured resolution
                    const res = this._screen.peekResolution();
                    if (res) center = vec(res.width / 2, res.height / 2);
                }
                this._halfWidth = center.x;
                this._halfHeight = center.y;
                // If the user has not set the camera pos, apply default center screen position
                if (!this._posChanged) this.pos = center;
                this.pos.clone(this.drawPos);
                // First frame bootstrap
                // Ensure camera tx is correct
                // Run update twice to ensure properties are init'd
                this.updateTransform(this.pos);
                // Run strategies for first frame
                this.runStrategies(engine, engine.clock.elapsed());
                // Setup the first frame viewport
                this.updateViewport();
                // It's important to update the camera after strategies
                // This prevents jitter
                this.updateTransform(this.pos);
                this.pos.clone(this._oldPos);
                this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onInitialize(engine) {
        // Overridable
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        runStrategies(engine, delta) {
            for (const s of this._cameraStrategies)this.pos = s.action.call(s, s.target, this, engine, delta);
        }
        updateViewport() {
            // recalculate viewport
            this._viewport = new BoundingBox(this.x - this._halfWidth, this.y - this._halfHeight, this.x + this._halfWidth, this.y + this._halfHeight);
        }
        update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            this.pos.clone(this._oldPos);
            // Update placements based on linear algebra
            this.pos = this.pos.add(this.vel.scale(delta / 1000));
            this.zoom += this.dz * delta / 1000;
            this.vel = this.vel.add(this.acc.scale(delta / 1000));
            this.dz += this.az * delta / 1000;
            this.rotation += this.angularVelocity * delta / 1000;
            if (this._isZooming) {
                if (this._currentZoomTime < this._zoomDuration) {
                    const zoomEasing = this._zoomEasing;
                    const newZoom = zoomEasing(this._currentZoomTime, this._zoomStart, this._zoomEnd, this._zoomDuration);
                    this.zoom = newZoom;
                    this._currentZoomTime += delta;
                } else {
                    this._isZooming = false;
                    this.zoom = this._zoomEnd;
                    this._currentZoomTime = 0;
                    this._zoomResolve(true);
                }
            }
            if (this._cameraMoving) {
                if (this._currentLerpTime < this._lerpDuration) {
                    const moveEasing = EasingFunctions.CreateVectorEasingFunction(this._easing);
                    const lerpPoint = moveEasing(this._currentLerpTime, this._lerpStart, this._lerpEnd, this._lerpDuration);
                    this.pos = lerpPoint;
                    this._currentLerpTime += delta;
                } else {
                    this.pos = this._lerpEnd;
                    const end = this._lerpEnd.clone();
                    this._lerpStart = null;
                    this._lerpEnd = null;
                    this._currentLerpTime = 0;
                    this._cameraMoving = false;
                    // Order matters here, resolve should be last so any chain promises have a clean slate
                    this._lerpResolve(end);
                }
            }
            if (this._isDoneShaking()) {
                this._isShaking = false;
                this._elapsedShakeTime = 0;
                this._shakeMagnitudeX = 0;
                this._shakeMagnitudeY = 0;
                this._shakeDuration = 0;
                this._xShake = 0;
                this._yShake = 0;
            } else {
                this._elapsedShakeTime += delta;
                this._xShake = (Math.random() * this._shakeMagnitudeX | 0) + 1;
                this._yShake = (Math.random() * this._shakeMagnitudeY | 0) + 1;
            }
            this.runStrategies(engine, delta);
            this.updateViewport();
            // It's important to update the camera after strategies
            // This prevents jitter
            this.updateTransform(this.pos);
            this._postupdate(engine, delta);
        }
        /**
     * Applies the relevant transformations to the game canvas to "move" or apply effects to the Camera
     * @param ctx Canvas context to apply transformations
     */ draw(ctx) {
            // default to the current position
            this.pos.clone(this.drawPos);
            // interpolation if fixed update is on
            // must happen on the draw, because more draws are potentially happening than updates
            if (this._engine.fixedUpdateFps) {
                const blend = this._engine.currentFrameLagMs / (1000 / this._engine.fixedUpdateFps);
                const interpolatedPos = this.pos.scale(blend).add(this._oldPos.scale(1.0 - blend));
                interpolatedPos.clone(this.drawPos);
                this.updateTransform(interpolatedPos);
            }
            // Snap camera to pixel
            if (ctx.snapToPixel) {
                const snapPos = this.drawPos.clone(this._snapPos);
                snapPos.x = ~~(snapPos.x + pixelSnapEpsilon * sign(snapPos.x));
                snapPos.y = ~~(snapPos.y + pixelSnapEpsilon * sign(snapPos.y));
                snapPos.clone(this.drawPos);
                this.updateTransform(snapPos);
            }
            ctx.multiply(this.transform);
        }
        updateTransform(pos) {
            // center the camera
            const newCanvasWidth = this._screen.resolution.width / this.zoom;
            const newCanvasHeight = this._screen.resolution.height / this.zoom;
            const cameraPos = vec(-pos.x + newCanvasWidth / 2 + this._xShake, -pos.y + newCanvasHeight / 2 + this._yShake);
            // Calculate camera transform
            this.transform.reset();
            this.transform.scale(this.zoom, this.zoom);
            // rotate about the focus
            this.transform.translate(newCanvasWidth / 2, newCanvasHeight / 2);
            this.transform.rotate(this.rotation);
            this.transform.translate(-newCanvasWidth / 2, -newCanvasHeight / 2);
            this.transform.translate(cameraPos.x, cameraPos.y);
            this.transform.inverse(this.inverse);
        }
        _isDoneShaking() {
            return !this._isShaking || this._elapsedShakeTime >= this._shakeDuration;
        }
    }
    const TriggerEvents = {
        ExitTrigger: "exit",
        EnterTrigger: "enter"
    };
    const triggerDefaults = {
        pos: Vector.Zero,
        width: 10,
        height: 10,
        visible: false,
        action: ()=>{
            return;
        },
        filter: ()=>true,
        repeat: -1
    };
    /**
 * Triggers are a method of firing arbitrary code on collision. These are useful
 * as 'buttons', 'switches', or to trigger effects in a game. By default triggers
 * are invisible, and can only be seen when [[Trigger.visible]] is set to `true`.
 */ class Trigger extends Actor {
        /**
     *
     * @param opts Trigger options
     */ constructor(opts){
            super({
                x: opts.pos.x,
                y: opts.pos.y,
                width: opts.width,
                height: opts.height
            });
            this.events = new EventEmitter();
            /**
         * Action to fire when triggered by collision
         */ this.action = ()=>{
                return;
            };
            /**
         * Filter to add additional granularity to action dispatch, if a filter is specified the action will only fire when
         * filter return true for the collided actor.
         */ this.filter = ()=>true;
            /**
         * Number of times to repeat before killing the trigger,
         */ this.repeat = -1;
            opts = {
                ...triggerDefaults,
                ...opts
            };
            this.filter = opts.filter || this.filter;
            this.repeat = opts.repeat || this.repeat;
            this.action = opts.action || this.action;
            if (opts.target) this.target = opts.target;
            this.graphics.visible = opts.visible;
            this.body.collisionType = CollisionType.Passive;
            this.events.on("collisionstart", (evt)=>{
                if (this.filter(evt.other)) {
                    this.events.emit("enter", new EnterTriggerEvent(this, evt.other));
                    this._dispatchAction();
                    // remove trigger if its done, -1 repeat forever
                    if (this.repeat === 0) this.kill();
                }
            });
            this.events.on("collisionend", (evt)=>{
                if (this.filter(evt.other)) this.events.emit("exit", new ExitTriggerEvent(this, evt.other));
            });
        }
        set target(target) {
            this._target = target;
            this.filter = (actor)=>actor === target;
        }
        get target() {
            return this._target;
        }
        _initialize(engine) {
            super._initialize(engine);
        }
        _dispatchAction() {
            if (this.repeat !== 0) {
                this.action.call(this);
                this.repeat--;
            }
        }
    }
    /**
 * Higher priorities run earlier than others in the system update
 */ const SystemPriority = {
        Highest: -Infinity,
        Higher: -5,
        Average: 0,
        Lower: 5,
        Lowest: Infinity
    };
    /**
 * Enum that determines whether to run the system in the update or draw phase
 */ var SystemType;
    (function(SystemType) {
        SystemType["Update"] = "update";
        SystemType["Draw"] = "draw";
    })(SystemType || (SystemType = {}));
    /**
 * An Excalibur [[System]] that updates entities of certain types.
 * Systems are scene specific
 *
 *
 *
 * Excalibur Systems currently require at least 1 Component type to operated
 *
 * Multiple types are declared as a type union
 * For example:
 *
 * ```typescript
 * class MySystem extends System<ComponentA | ComponentB> {
 *   public readonly types = ['a', 'b'] as const;
 *   public readonly systemType = SystemType.Update;
 *   public update(entities: Entity<ComponentA | ComponentB>) {
 *      ...
 *   }
 * }
 * ```
 */ class System {
        constructor(){
            /**
         * System can execute in priority order, by default all systems are priority 0. Lower values indicated higher priority.
         * For a system to execute before all other a lower priority value (-1 for example) must be set.
         * For a system to execute after all other a higher priority value (10 for example) must be set.
         */ this.priority = SystemPriority.Average;
        }
    }
    // Add/Remove entities and components
    class EntityManager {
        constructor(_world){
            this._world = _world;
            this.entities = [];
            this._entityIndex = {};
            this._entitiesToRemove = [];
        }
        /**
     * Runs the entity lifecycle
     * @param scene
     * @param elapsed
     */ updateEntities(scene, elapsed) {
            for (const entity of this.entities){
                entity.update(scene.engine, elapsed);
                if (!entity.active) this.removeEntity(entity);
            }
        }
        findEntitiesForRemoval() {
            for (const entity of this.entities)if (!entity.active) this.removeEntity(entity);
        }
        /**
     * Adds an entity to be tracked by the EntityManager
     * @param entity
     */ addEntity(entity) {
            entity.active = true;
            entity.scene = this._world.scene;
            if (entity && !this._entityIndex[entity.id]) {
                this._entityIndex[entity.id] = entity;
                this.entities.push(entity);
                this._world.queryManager.addEntity(entity);
                // if entity has children
                entity.children.forEach((c)=>{
                    c.scene = entity.scene;
                    this.addEntity(c);
                });
                entity.childrenAdded$.register({
                    notify: (e)=>{
                        this.addEntity(e);
                    }
                });
                entity.childrenRemoved$.register({
                    notify: (e)=>{
                        this.removeEntity(e, false);
                    }
                });
            }
        }
        removeEntity(idOrEntity, deferred = true) {
            var _a, _b;
            let id = 0;
            if (idOrEntity instanceof Entity) id = idOrEntity.id;
            else id = idOrEntity;
            const entity = this._entityIndex[id];
            if (entity && entity.active) entity.active = false;
            if (entity && deferred) {
                this._entitiesToRemove.push(entity);
                return;
            }
            delete this._entityIndex[id];
            if (entity) {
                entity.scene = null;
                removeItemFromArray(entity, this.entities);
                this._world.queryManager.removeEntity(entity);
                // if entity has children
                entity.children.forEach((c)=>{
                    c.scene = null;
                    this.removeEntity(c, deferred);
                });
                entity.childrenAdded$.clear();
                entity.childrenRemoved$.clear();
                // stats
                if ((_b = (_a = this._world) === null || _a === void 0 ? void 0 : _a.scene) === null || _b === void 0 ? void 0 : _b.engine) this._world.scene.engine.stats.currFrame.actors.killed++;
            }
        }
        processEntityRemovals() {
            for (const entity of this._entitiesToRemove){
                if (entity.active) continue;
                this.removeEntity(entity, false);
            }
            this._entitiesToRemove.length = 0;
        }
        processComponentRemovals() {
            for (const entity of this.entities)entity.processComponentRemoval();
        }
        getById(id) {
            return this._entityIndex[id];
        }
        getByName(name) {
            return this.entities.filter((e)=>e.name === name);
        }
        clear() {
            for(let i = this.entities.length - 1; i >= 0; i--)this.removeEntity(this.entities[i]);
        }
    }
    /**
 * Represents query for entities that match a list of types that is cached and observable
 *
 * Queries can be strongly typed by supplying a type union in the optional type parameter
 * ```typescript
 * const queryAB = new ex.Query<ComponentTypeA | ComponentTypeB>(['A', 'B']);
 * ```
 */ class Query {
        constructor(requiredComponents){
            this.requiredComponents = requiredComponents;
            this.components = new Set();
            this.entities = [];
            /**
         * This fires right after the component is added
         */ this.entityAdded$ = new Observable();
            /**
         * This fires right before the component is actually removed from the entity, it will still be available for cleanup purposes
         */ this.entityRemoved$ = new Observable();
            if (requiredComponents.length === 0) throw new Error("Cannot create query without components");
            for (const type of requiredComponents)this.components.add(type);
            this.id = Query.createId(requiredComponents);
        }
        static createId(requiredComponents) {
            // TODO what happens if a user defines the same type name as a built in type
            // ! TODO this could be dangerous depending on the bundler's settings for names
            // Maybe some kind of hash function is better here?
            return requiredComponents.slice().map((c)=>c.name).sort().join("-");
        }
        /**
     * Potentially adds an entity to a query index, returns true if added, false if not
     * @param entity
     */ checkAndAdd(entity) {
            if (!this.entities.includes(entity) && entity.hasAll(Array.from(this.components))) {
                this.entities.push(entity);
                this.entityAdded$.notifyAll(entity);
                return true;
            }
            return false;
        }
        removeEntity(entity) {
            const index = this.entities.indexOf(entity);
            if (index > -1) {
                this.entities.splice(index, 1);
                this.entityRemoved$.notifyAll(entity);
            }
        }
        /**
     * Returns a list of entities that match the query
     * @param sort Optional sorting function to sort entities returned from the query
     */ getEntities(sort) {
            if (sort) this.entities.sort(sort);
            return this.entities;
        }
    }
    class TagQuery {
        constructor(requiredTags){
            this.requiredTags = requiredTags;
            this.tags = new Set();
            this.entities = [];
            /**
         * This fires right after the component is added
         */ this.entityAdded$ = new Observable();
            /**
         * This fires right before the component is actually removed from the entity, it will still be available for cleanup purposes
         */ this.entityRemoved$ = new Observable();
            if (requiredTags.length === 0) throw new Error("Cannot create tag query without tags");
            for (const tag of requiredTags)this.tags.add(tag);
            this.id = TagQuery.createId(requiredTags);
        }
        static createId(requiredComponents) {
            return requiredComponents.slice().sort().join("-");
        }
        checkAndAdd(entity) {
            if (!this.entities.includes(entity) && entity.hasAllTags(Array.from(this.tags))) {
                this.entities.push(entity);
                this.entityAdded$.notifyAll(entity);
                return true;
            }
            return false;
        }
        removeEntity(entity) {
            const index = this.entities.indexOf(entity);
            if (index > -1) {
                this.entities.splice(index, 1);
                this.entityRemoved$.notifyAll(entity);
            }
        }
        /**
     * Returns a list of entities that match the query
     * @param sort Optional sorting function to sort entities returned from the query
     */ getEntities(sort) {
            if (sort) this.entities.sort(sort);
            return this.entities;
        }
    }
    /**
 * The query manager is responsible for updating all queries when entities/components change
 */ class QueryManager {
        constructor(_world){
            this._world = _world;
            this._queries = new Map();
            this._addComponentHandlers = new Map();
            this._removeComponentHandlers = new Map();
            this._componentToQueriesIndex = new Map();
            this._tagQueries = new Map();
            this._addTagHandlers = new Map();
            this._removeTagHandlers = new Map();
            this._tagToQueriesIndex = new Map();
            this._createAddComponentHandler = (entity)=>(c)=>{
                    this.addComponent(entity, c);
                };
            this._createRemoveComponentHandler = (entity)=>(c)=>{
                    this.removeComponent(entity, c);
                };
            this._createAddTagHandler = (entity)=>(tag)=>{
                    this.addTag(entity, tag);
                };
            this._createRemoveTagHandler = (entity)=>(tag)=>{
                    this.removeTag(entity, tag);
                };
        }
        createQuery(requiredComponents) {
            const id = Query.createId(requiredComponents);
            if (this._queries.has(id)) // short circuit if query is already created
            return this._queries.get(id);
            const query = new Query(requiredComponents);
            this._queries.set(query.id, query);
            // index maintenance
            for (const component of requiredComponents){
                const queries = this._componentToQueriesIndex.get(component);
                if (!queries) this._componentToQueriesIndex.set(component, [
                    query
                ]);
                else queries.push(query);
            }
            for (const entity of this._world.entities)this.addEntity(entity);
            return query;
        }
        createTagQuery(requiredTags) {
            const id = TagQuery.createId(requiredTags);
            if (this._tagQueries.has(id)) // short circuit if query is already created
            return this._tagQueries.get(id);
            const query = new TagQuery(requiredTags);
            this._tagQueries.set(query.id, query);
            // index maintenance
            for (const tag of requiredTags){
                const queries = this._tagToQueriesIndex.get(tag);
                if (!queries) this._tagToQueriesIndex.set(tag, [
                    query
                ]);
                else queries.push(query);
            }
            for (const entity of this._world.entities)this.addEntity(entity);
            return query;
        }
        /**
     * Scans queries and locates any that need this entity added
     * @param entity
     */ addEntity(entity) {
            const maybeAddComponent = this._addComponentHandlers.get(entity);
            const maybeRemoveComponent = this._removeComponentHandlers.get(entity);
            const addComponent = maybeAddComponent !== null && maybeAddComponent !== void 0 ? maybeAddComponent : this._createAddComponentHandler(entity);
            const removeComponent = maybeRemoveComponent !== null && maybeRemoveComponent !== void 0 ? maybeRemoveComponent : this._createRemoveComponentHandler(entity);
            this._addComponentHandlers.set(entity, addComponent);
            this._removeComponentHandlers.set(entity, removeComponent);
            const maybeAddTag = this._addTagHandlers.get(entity);
            const maybeRemoveTag = this._removeTagHandlers.get(entity);
            const addTag = maybeAddTag !== null && maybeAddTag !== void 0 ? maybeAddTag : this._createAddTagHandler(entity);
            const removeTag = maybeRemoveTag !== null && maybeRemoveTag !== void 0 ? maybeRemoveTag : this._createRemoveTagHandler(entity);
            this._addTagHandlers.set(entity, addTag);
            this._removeTagHandlers.set(entity, removeTag);
            for (const query of this._queries.values())query.checkAndAdd(entity);
            for (const tagQuery of this._tagQueries.values())tagQuery.checkAndAdd(entity);
            entity.componentAdded$.subscribe(addComponent);
            entity.componentRemoved$.subscribe(removeComponent);
            entity.tagAdded$.subscribe(addTag);
            entity.tagRemoved$.subscribe(removeTag);
        }
        /**
     * Scans queries and locates any that need this entity removed
     * @param entity
     */ removeEntity(entity) {
            // Handle components
            const addComponent = this._addComponentHandlers.get(entity);
            const removeComponent = this._removeComponentHandlers.get(entity);
            for (const query of this._queries.values())query.removeEntity(entity);
            if (addComponent) entity.componentAdded$.unsubscribe(addComponent);
            if (removeComponent) entity.componentRemoved$.unsubscribe(removeComponent);
            // Handle tags
            const addTag = this._addTagHandlers.get(entity);
            const removeTag = this._removeTagHandlers.get(entity);
            for (const tagQuery of this._tagQueries.values())tagQuery.removeEntity(entity);
            if (addTag) entity.tagAdded$.unsubscribe(addTag);
            if (removeTag) entity.tagRemoved$.unsubscribe(removeTag);
        }
        /**
     * Updates any queries when a component is added to an entity
     * @param entity
     * @param component
     */ addComponent(entity, component) {
            var _a;
            const queries = (_a = this._componentToQueriesIndex.get(component.constructor)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.checkAndAdd(entity);
        }
        /**
     * Updates any queries when a component is removed from an entity
     * @param entity
     * @param component
     */ removeComponent(entity, component) {
            var _a;
            const queries = (_a = this._componentToQueriesIndex.get(component.constructor)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.removeEntity(entity);
        }
        /**
     * Updates any queries when a tag is added to an entity
     * @param entity
     * @param tag
     */ addTag(entity, tag) {
            var _a;
            const queries = (_a = this._tagToQueriesIndex.get(tag)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.checkAndAdd(entity);
        }
        /**
     * Updates any queries when a component is removed from an entity
     * @param entity
     * @param tag
     */ removeTag(entity, tag) {
            var _a;
            const queries = (_a = this._tagToQueriesIndex.get(tag)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.removeEntity(entity);
        }
    }
    /**
 *
 */ function isSystemConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    /**
 * The SystemManager is responsible for keeping track of all systems in a scene.
 * Systems are scene specific
 */ class SystemManager {
        constructor(_world){
            this._world = _world;
            /**
         * List of systems, to add a new system call [[SystemManager.addSystem]]
         */ this.systems = [];
            this.initialized = false;
        }
        /**
     * Get a system registered in the manager by type
     * @param systemType
     */ get(systemType) {
            return this.systems.find((s)=>s instanceof systemType);
        }
        /**
     * Adds a system to the manager, it will now be updated every frame
     * @param systemOrCtor
     */ addSystem(systemOrCtor) {
            let system;
            if (systemOrCtor instanceof System) system = systemOrCtor;
            else system = new systemOrCtor(this._world);
            this.systems.push(system);
            this.systems.sort((a, b)=>a.priority - b.priority);
            // If systems are added and the manager has already been init'd
            // then immediately init the system
            if (this.initialized && system.initialize) system.initialize(this._world, this._world.scene);
        }
        /**
     * Removes a system from the manager, it will no longer be updated
     * @param system
     */ removeSystem(system) {
            removeItemFromArray(system, this.systems);
        }
        /**
     * Initialize all systems in the manager
     *
     * Systems added after initialize() will be initialized on add
     */ initialize() {
            if (!this.initialized) {
                this.initialized = true;
                for (const s of this.systems)if (s.initialize) s.initialize(this._world, this._world.scene);
            }
        }
        /**
     * Updates all systems
     * @param type whether this is an update or draw system
     * @param scene context reference
     * @param delta time in milliseconds
     */ updateSystems(type, scene, delta) {
            const systems = this.systems.filter((s)=>s.systemType === type);
            for (const s of systems)if (s.preupdate) s.preupdate(scene, delta);
            for (const s of systems)s.update(delta);
            for (const s of systems)if (s.postupdate) s.postupdate(scene, delta);
        }
        clear() {
            for(let i = this.systems.length - 1; i >= 0; i--)this.removeSystem(this.systems[i]);
        }
    }
    /**
 * The World is a self-contained entity component system for a particular context.
 */ class World {
        /**
     * The context type is passed to the system updates
     * @param scene
     */ constructor(scene){
            this.scene = scene;
            this.queryManager = new QueryManager(this);
            this.entityManager = new EntityManager(this);
            this.systemManager = new SystemManager(this);
        }
        /**
     * Query the ECS world for entities that match your components
     * @param requiredTypes
     */ query(requiredTypes) {
            return this.queryManager.createQuery(requiredTypes);
        }
        queryTags(requiredTags) {
            return this.queryManager.createTagQuery(requiredTags);
        }
        /**
     * Update systems by type and time elapsed in milliseconds
     */ update(type, delta) {
            if (type === SystemType.Update) this.entityManager.updateEntities(this.scene, delta);
            this.systemManager.updateSystems(type, this.scene, delta);
            this.entityManager.findEntitiesForRemoval();
            this.entityManager.processComponentRemovals();
            this.entityManager.processEntityRemovals();
        }
        add(entityOrSystem) {
            if (entityOrSystem instanceof Entity) this.entityManager.addEntity(entityOrSystem);
            if (entityOrSystem instanceof System || isSystemConstructor(entityOrSystem)) this.systemManager.addSystem(entityOrSystem);
        }
        /**
     * Get a system out of the ECS world
     */ get(system) {
            return this.systemManager.get(system);
        }
        remove(entityOrSystem, deferred = true) {
            if (entityOrSystem instanceof Entity) this.entityManager.removeEntity(entityOrSystem, deferred);
            if (entityOrSystem instanceof System) this.systemManager.removeSystem(entityOrSystem);
        }
        get entities() {
            return this.entityManager.entities;
        }
        clearEntities() {
            this.entityManager.clear();
        }
        clearSystems() {
            this.systemManager.clear();
        }
    }
    class EulerIntegrator {
        static integrate(transform, motion, totalAcc, elapsedMs) {
            const seconds = elapsedMs / 1000;
            // This code looks a little wild, but it's to avoid creating any new Vector instances
            // integration is done in a tight loop so this is key to avoid GC'ing
            motion.vel.addEqual(totalAcc.scale(seconds, EulerIntegrator._ACC));
            transform.pos.add(motion.vel.scale(seconds, EulerIntegrator._VEL), EulerIntegrator._POS).addEqual(totalAcc.scale(0.5 * seconds * seconds, EulerIntegrator._VEL_ACC));
            motion.angularVelocity += motion.torque * (1.0 / motion.inertia) * seconds;
            const rotation = transform.rotation + motion.angularVelocity * seconds;
            transform.scale.add(motion.scaleFactor.scale(seconds, this._SCALE_FACTOR), EulerIntegrator._SCALE);
            const tx = transform.get();
            tx.setTransform(EulerIntegrator._POS, rotation, EulerIntegrator._SCALE);
        }
    }
    // Scratch vectors to avoid allocation
    EulerIntegrator._POS = new Vector(0, 0);
    EulerIntegrator._SCALE = new Vector(1, 1);
    EulerIntegrator._ACC = new Vector(0, 0);
    EulerIntegrator._VEL = new Vector(0, 0);
    EulerIntegrator._VEL_ACC = new Vector(0, 0);
    EulerIntegrator._SCALE_FACTOR = new Vector(0, 0);
    class MotionSystem extends System {
        constructor(world, physics){
            super();
            this.world = world;
            this.physics = physics;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._physicsConfigDirty = false;
            physics.$configUpdate.subscribe(()=>this._physicsConfigDirty = true);
            this.query = this.world.query([
                TransformComponent,
                MotionComponent
            ]);
        }
        update(elapsedMs) {
            let transform;
            let motion;
            const entities = this.query.entities;
            for(let i = 0; i < entities.length; i++){
                transform = entities[i].get(TransformComponent);
                motion = entities[i].get(MotionComponent);
                const optionalBody = entities[i].get(BodyComponent);
                if (this._physicsConfigDirty && optionalBody) optionalBody.updatePhysicsConfig(this.physics.config.bodies);
                if (optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.sleeping) continue;
                const totalAcc = motion.acc.clone();
                if ((optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.collisionType) === CollisionType.Active && (optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.useGravity)) totalAcc.addEqual(this.physics.config.gravity);
                optionalBody === null || optionalBody === void 0 || optionalBody.captureOldTransform();
                // Update transform and motion based on Euler linear algebra
                EulerIntegrator.integrate(transform, motion, totalAcc, elapsedMs);
            }
            this._physicsConfigDirty = false;
        }
    }
    /**
 * ArcadeSolver is the default in Excalibur. It solves collisions so that there is no overlap between contacts,
 * and negates velocity along the collision normal.
 *
 * This is usually the type of collisions used for 2D games that don't need a more realistic collision simulation.
 *
 */ class ArcadeSolver {
        constructor(config){
            this.config = config;
            this.directionMap = new Map();
            this.distanceMap = new Map();
        }
        solve(contacts) {
            // Events and init
            this.preSolve(contacts);
            // Remove any canceled contacts
            contacts = contacts.filter((c)=>!c.isCanceled());
            // Locate collision bias order
            let bias;
            switch(this.config.contactSolveBias){
                case ContactSolveBias.HorizontalFirst:
                    bias = HorizontalFirst;
                    break;
                case ContactSolveBias.VerticalFirst:
                    bias = VerticalFirst;
                    break;
                default:
                    bias = None;
            }
            // Sort by bias (None, VerticalFirst, HorizontalFirst) to avoid artifacts with seams
            // Sort contacts by distance to avoid artifacts with seams
            // It's important to solve in a specific order
            contacts.sort((a, b)=>{
                const aDir = this.directionMap.get(a.id);
                const bDir = this.directionMap.get(b.id);
                const aDist = this.distanceMap.get(a.id);
                const bDist = this.distanceMap.get(b.id);
                return bias[aDir] - bias[bDir] || aDist - bDist;
            });
            for (const contact of contacts){
                // Solve position first in arcade
                this.solvePosition(contact);
                // Solve velocity second in arcade
                this.solveVelocity(contact);
            }
            // Events and any contact house-keeping the solver needs
            this.postSolve(contacts);
            return contacts;
        }
        preSolve(contacts) {
            const epsilon = .0001;
            for (const contact of contacts){
                if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                    // Cancel near 0 mtv collisions
                    contact.cancel();
                    continue;
                }
                const side = Side.fromDirection(contact.mtv);
                const mtv = contact.mtv.negate();
                const distance = contact.colliderA.worldPos.squareDistance(contact.colliderB.worldPos);
                this.distanceMap.set(contact.id, distance);
                this.directionMap.set(contact.id, side === Side.Left || side === Side.Right ? "horizontal" : "vertical");
                // Publish collision events on both participants
                contact.colliderA.events.emit("precollision", new PreCollisionEvent(contact.colliderA, contact.colliderB, side, mtv, contact));
                contact.colliderB.events.emit("precollision", new PreCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), mtv.negate(), contact));
            }
        }
        postSolve(contacts) {
            var _a, _b;
            for (const contact of contacts){
                if (contact.isCanceled()) continue;
                const colliderA = contact.colliderA;
                const colliderB = contact.colliderB;
                const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                }
                const side = Side.fromDirection(contact.mtv);
                const mtv = contact.mtv.negate();
                // Publish collision events on both participants
                contact.colliderA.events.emit("postcollision", new PostCollisionEvent(contact.colliderA, contact.colliderB, side, mtv, contact));
                contact.colliderB.events.emit("postcollision", new PostCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), mtv.negate(), contact));
            }
        }
        solvePosition(contact) {
            var _a, _b;
            const epsilon = .0001;
            // if bounds no longer intersect skip to the next
            // this removes jitter from overlapping/stacked solid tiles or a wall of solid tiles
            if (!contact.colliderA.bounds.overlaps(contact.colliderB.bounds, epsilon)) {
                // Cancel the contact to prevent and solving
                contact.cancel();
                return;
            }
            if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                // Cancel near 0 mtv collisions
                contact.cancel();
                return;
            }
            let mtv = contact.mtv;
            const colliderA = contact.colliderA;
            const colliderB = contact.colliderB;
            const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) return;
                if (bodyA.collisionType === CollisionType.Active && bodyB.collisionType === CollisionType.Active) // split overlaps if both are Active
                mtv = mtv.scale(0.5);
                // Resolve overlaps
                if (bodyA.collisionType === CollisionType.Active) {
                    bodyA.globalPos.x -= mtv.x;
                    bodyA.globalPos.y -= mtv.y;
                    colliderA.update(bodyA.transform.get());
                }
                if (bodyB.collisionType === CollisionType.Active) {
                    bodyB.globalPos.x += mtv.x;
                    bodyB.globalPos.y += mtv.y;
                    colliderB.update(bodyB.transform.get());
                }
            }
        }
        solveVelocity(contact) {
            var _a, _b;
            if (contact.isCanceled()) return;
            const colliderA = contact.colliderA;
            const colliderB = contact.colliderB;
            const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) return;
                const normal = contact.normal;
                const opposite = normal.negate();
                if (bodyA.collisionType === CollisionType.Active) // only adjust velocity if the contact normal is opposite to the current velocity
                // this avoids catching edges on a platform when sliding off
                {
                    if (bodyA.vel.normalize().dot(opposite) < 0) {
                        // Cancel out velocity opposite direction of collision normal
                        const velAdj = normal.scale(normal.dot(bodyA.vel.negate()));
                        bodyA.vel = bodyA.vel.add(velAdj);
                    }
                }
                if (bodyB.collisionType === CollisionType.Active) // only adjust velocity if the contact normal is opposite to the current velocity
                // this avoids catching edges on a platform
                {
                    if (bodyB.vel.normalize().dot(normal) < 0) {
                        const velAdj = opposite.scale(opposite.dot(bodyB.vel.negate()));
                        bodyB.vel = bodyB.vel.add(velAdj);
                    }
                }
            }
        }
    }
    /**
 * Holds information about contact points, meant to be reused over multiple frames of contact
 */ class ContactConstraintPoint {
        constructor(point, local, contact){
            this.point = point;
            this.local = local;
            this.contact = contact;
            /**
         * Impulse accumulated over time in normal direction
         */ this.normalImpulse = 0;
            /**
         * Impulse accumulated over time in the tangent direction
         */ this.tangentImpulse = 0;
            /**
         * Effective mass seen in the normal direction
         */ this.normalMass = 0;
            /**
         * Effective mass seen in the tangent direction
         */ this.tangentMass = 0;
            /**
         * Direction from center of mass of bodyA to contact point
         */ this.aToContact = new Vector(0, 0);
            /**
         * Direction from center of mass of bodyB to contact point
         */ this.bToContact = new Vector(0, 0);
            /**
         * Original contact velocity combined with bounciness
         */ this.originalVelocityAndRestitution = 0;
            this.update();
        }
        /**
     * Updates the contact information
     */ update() {
            var _a, _b;
            const bodyA = (_a = this.contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = this.contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                const normal = this.contact.normal;
                const tangent = this.contact.tangent;
                this.aToContact = this.point.sub(bodyA.globalPos);
                this.bToContact = this.point.sub(bodyB.globalPos);
                const aToContactNormal = this.aToContact.cross(normal);
                const bToContactNormal = this.bToContact.cross(normal);
                this.normalMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactNormal * aToContactNormal + bodyB.inverseInertia * bToContactNormal * bToContactNormal;
                const aToContactTangent = this.aToContact.cross(tangent);
                const bToContactTangent = this.bToContact.cross(tangent);
                this.tangentMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactTangent * aToContactTangent + bodyB.inverseInertia * bToContactTangent * bToContactTangent;
            }
            return this;
        }
        /**
     * Returns the relative velocity between bodyA and bodyB
     */ getRelativeVelocity() {
            var _a, _b;
            const bodyA = (_a = this.contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = this.contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                // Relative velocity in linear terms
                // Angular to linear velocity formula -> omega = velocity/radius so omega x radius = velocity
                const velA = bodyA.vel.add(Vector.cross(bodyA.angularVelocity, this.aToContact));
                const velB = bodyB.vel.add(Vector.cross(bodyB.angularVelocity, this.bToContact));
                return velB.sub(velA);
            }
            return Vector.Zero;
        }
    }
    class RealisticSolver {
        constructor(config){
            this.config = config;
            this.lastFrameContacts = new Map();
            // map contact id to contact points
            this.idToContactConstraint = new Map();
        }
        getContactConstraints(id) {
            var _a;
            return (_a = this.idToContactConstraint.get(id)) !== null && _a !== void 0 ? _a : [];
        }
        solve(contacts) {
            // Events and init
            this.preSolve(contacts);
            // Remove any canceled contacts
            contacts = contacts.filter((c)=>!c.isCanceled());
            // Solve velocity first
            this.solveVelocity(contacts);
            // Solve position last because non-overlap is the most important
            this.solvePosition(contacts);
            // Events and any contact house-keeping the solver needs
            this.postSolve(contacts);
            return contacts;
        }
        preSolve(contacts) {
            var _a, _b, _c;
            const epsilon = .0001;
            for (const contact of contacts){
                if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                    // Cancel near 0 mtv collisions
                    contact.cancel();
                    continue;
                }
                // Publish collision events on both participants
                const side = Side.fromDirection(contact.mtv);
                contact.colliderA.events.emit("precollision", new PreCollisionEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderA.events.emit("beforecollisionresolve", new CollisionPreSolveEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderB.events.emit("precollision", new PreCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                contact.colliderB.events.emit("beforecollisionresolve", new CollisionPreSolveEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                // Match awake state for sleeping
                contact.matchAwake();
            }
            // Keep track of contacts that done
            const finishedContactIds = Array.from(this.idToContactConstraint.keys());
            for (const contact of contacts){
                // Remove all current contacts that are not done
                const index = finishedContactIds.indexOf(contact.id);
                if (index > -1) finishedContactIds.splice(index, 1);
                const contactPoints = (_a = this.idToContactConstraint.get(contact.id)) !== null && _a !== void 0 ? _a : [];
                let pointIndex = 0;
                const bodyA = contact.colliderA.owner.get(BodyComponent);
                const bodyB = contact.colliderB.owner.get(BodyComponent);
                if (bodyA && bodyB) for (const point of contact.points){
                    const normal = contact.normal;
                    const tangent = contact.tangent;
                    const aToContact = point.sub(bodyA.globalPos);
                    const bToContact = point.sub(bodyB.globalPos);
                    const aToContactNormal = aToContact.cross(normal);
                    const bToContactNormal = bToContact.cross(normal);
                    const normalMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactNormal * aToContactNormal + bodyB.inverseInertia * bToContactNormal * bToContactNormal;
                    const aToContactTangent = aToContact.cross(tangent);
                    const bToContactTangent = bToContact.cross(tangent);
                    const tangentMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactTangent * aToContactTangent + bodyB.inverseInertia * bToContactTangent * bToContactTangent;
                    // Preserve normal/tangent impulse by re-using the contact point if it's close
                    if (contactPoints[pointIndex] && ((_c = (_b = contactPoints[pointIndex]) === null || _b === void 0 ? void 0 : _b.point) === null || _c === void 0 ? void 0 : _c.squareDistance(point)) < 4) {
                        contactPoints[pointIndex].point = point;
                        contactPoints[pointIndex].local = contact.localPoints[pointIndex];
                    } else // new contact if it's not close or doesn't exist
                    contactPoints[pointIndex] = new ContactConstraintPoint(point, contact.localPoints[pointIndex], contact);
                    // Update contact point calculations
                    contactPoints[pointIndex].aToContact = aToContact;
                    contactPoints[pointIndex].bToContact = bToContact;
                    contactPoints[pointIndex].normalMass = 1.0 / normalMass;
                    contactPoints[pointIndex].tangentMass = 1.0 / tangentMass;
                    // Calculate relative velocity before solving to accurately do restitution
                    const restitution = bodyA.bounciness > bodyB.bounciness ? bodyA.bounciness : bodyB.bounciness;
                    const relativeVelocity = contact.normal.dot(contactPoints[pointIndex].getRelativeVelocity());
                    contactPoints[pointIndex].originalVelocityAndRestitution = 0;
                    if (relativeVelocity < -0.1) contactPoints[pointIndex].originalVelocityAndRestitution = -restitution * relativeVelocity;
                    pointIndex++;
                }
                this.idToContactConstraint.set(contact.id, contactPoints);
            }
            // Clean up any contacts that did not occur last frame
            for (const id of finishedContactIds)this.idToContactConstraint.delete(id);
            // Warm contacts with accumulated impulse
            // Useful for tall stacks
            if (this.config.warmStart) this.warmStart(contacts);
            else for (const contact of contacts){
                const contactPoints = this.getContactConstraints(contact.id);
                for (const point of contactPoints){
                    point.normalImpulse = 0;
                    point.tangentImpulse = 0;
                }
            }
        }
        postSolve(contacts) {
            for (const contact of contacts){
                const bodyA = contact.colliderA.owner.get(BodyComponent);
                const bodyB = contact.colliderB.owner.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip post solve for active+passive collisions
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    // Update motion values for sleeping
                    bodyA.updateMotion();
                    bodyB.updateMotion();
                }
                // Publish collision events on both participants
                const side = Side.fromDirection(contact.mtv);
                contact.colliderA.events.emit("postcollision", new PostCollisionEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderA.events.emit("aftercollisionresolve", new CollisionPostSolveEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderB.events.emit("postcollision", new PostCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                contact.colliderB.events.emit("aftercollisionresolve", new CollisionPostSolveEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
            }
            // Store contacts
            this.lastFrameContacts.clear();
            for (const c of contacts)this.lastFrameContacts.set(c.id, c);
        }
        /**
     * Warm up body's based on previous frame contact points
     * @param contacts
     */ warmStart(contacts) {
            var _a, _b, _c;
            for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    const contactPoints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    for (const point of contactPoints)if (this.config.warmStart) {
                        const normalImpulse = contact.normal.scale(point.normalImpulse);
                        const tangentImpulse = contact.tangent.scale(point.tangentImpulse);
                        const impulse = normalImpulse.add(tangentImpulse);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    } else {
                        point.normalImpulse = 0;
                        point.tangentImpulse = 0;
                    }
                }
            }
        }
        /**
     * Iteratively solve the position overlap constraint
     * @param contacts
     */ solvePosition(contacts) {
            var _a, _b, _c;
            for(let i = 0; i < this.config.positionIterations; i++)for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip solving active+passive
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    const constraints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    for (const point of constraints){
                        const normal = contact.normal;
                        const separation = CollisionJumpTable.FindContactSeparation(contact, point.local);
                        const steeringConstant = this.config.steeringFactor; //0.2;
                        const maxCorrection = -5;
                        const slop = this.config.slop; //1;
                        // Clamp to avoid over-correction
                        // Remember that we are shooting for 0 overlap in the end
                        const steeringForce = clamp(steeringConstant * (separation + slop), maxCorrection, 0);
                        const impulse = normal.scale(-steeringForce * point.normalMass);
                        // This is a pseudo impulse, meaning we aren't doing a real impulse calculation
                        // We adjust position and rotation instead of doing the velocity
                        if (bodyA.collisionType === CollisionType.Active) {
                            // TODO make applyPseudoImpulse function?
                            const impulseForce = impulse.negate().scale(bodyA.inverseMass);
                            if (bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) impulseForce.x = 0;
                            if (bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) impulseForce.y = 0;
                            bodyA.globalPos = bodyA.globalPos.add(impulseForce);
                            if (!bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) bodyA.rotation -= point.aToContact.cross(impulse) * bodyA.inverseInertia;
                        }
                        if (bodyB.collisionType === CollisionType.Active) {
                            const impulseForce = impulse.scale(bodyB.inverseMass);
                            if (bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) impulseForce.x = 0;
                            if (bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) impulseForce.y = 0;
                            bodyB.globalPos = bodyB.globalPos.add(impulseForce);
                            if (!bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) bodyB.rotation += point.bToContact.cross(impulse) * bodyB.inverseInertia;
                        }
                    }
                }
            }
        }
        solveVelocity(contacts) {
            var _a, _b, _c;
            for(let i = 0; i < this.config.velocityIterations; i++)for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip solving active+passive
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    const friction = Math.min(bodyA.friction, bodyB.friction);
                    const constraints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    // Friction constraint
                    for (const point of constraints){
                        const relativeVelocity = point.getRelativeVelocity();
                        // Negate velocity in tangent direction to simulate friction
                        const tangentVelocity = -relativeVelocity.dot(contact.tangent);
                        let impulseDelta = tangentVelocity * point.tangentMass;
                        // Clamping based in Erin Catto's GDC 2006 talk
                        // Correct clamping https://github.com/erincatto/box2d-lite/blob/master/docs/GDC2006_Catto_Erin_PhysicsTutorial.pdf
                        // Accumulated fiction impulse is always between -uMaxFriction < dT < uMaxFriction
                        // But deltas can vary
                        const maxFriction = friction * point.normalImpulse;
                        const newImpulse = clamp(point.tangentImpulse + impulseDelta, -maxFriction, maxFriction);
                        impulseDelta = newImpulse - point.tangentImpulse;
                        point.tangentImpulse = newImpulse;
                        const impulse = contact.tangent.scale(impulseDelta);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    }
                    // Bounce constraint
                    for (const point of constraints){
                        // Need to recalc relative velocity because the previous step could have changed vel
                        const relativeVelocity = point.getRelativeVelocity();
                        // Compute impulse in normal direction
                        const normalVelocity = relativeVelocity.dot(contact.normal);
                        // Per Erin it is a mistake to apply the restitution inside the iteration
                        // From Erin Catto's Box2D we keep original contact velocity and adjust by small impulses
                        let impulseDelta = -point.normalMass * (normalVelocity - point.originalVelocityAndRestitution);
                        // Clamping based in Erin Catto's GDC 2014 talk
                        // Accumulated impulse stored in the contact is always positive (dV > 0)
                        // But deltas can be negative
                        const newImpulse = Math.max(point.normalImpulse + impulseDelta, 0);
                        impulseDelta = newImpulse - point.normalImpulse;
                        point.normalImpulse = newImpulse;
                        const impulse = contact.normal.scale(impulseDelta);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    }
                }
            }
        }
    }
    class CollisionSystem extends System {
        get _processor() {
            return this._physics.collisionProcessor;
        }
        constructor(world, _physics){
            super();
            this._physics = _physics;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._configDirty = false;
            this._lastFrameContacts = new Map();
            this._currentFrameContacts = new Map();
            this._arcadeSolver = new ArcadeSolver(_physics.config.arcade);
            this._realisticSolver = new RealisticSolver(_physics.config.realistic);
            this._physics.$configUpdate.subscribe(()=>this._configDirty = true);
            this._trackCollider = (c)=>this._processor.track(c);
            this._untrackCollider = (c)=>this._processor.untrack(c);
            this.query = world.query([
                TransformComponent,
                MotionComponent,
                ColliderComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const colliderComponent = e.get(ColliderComponent);
                colliderComponent.$colliderAdded.subscribe(this._trackCollider);
                colliderComponent.$colliderRemoved.subscribe(this._untrackCollider);
                const collider = colliderComponent.get();
                if (collider) this._processor.track(collider);
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const colliderComponent = e.get(ColliderComponent);
                const collider = colliderComponent.get();
                if (colliderComponent && collider) this._processor.untrack(collider);
            });
        }
        initialize(world, scene) {
            this._engine = scene.engine;
        }
        update(elapsedMs) {
            var _a, _b, _c, _d;
            if (!this._physics.config.enabled) return;
            // Collect up all the colliders and update them
            let colliders = [];
            for (const entity of this.query.entities){
                const colliderComp = entity.get(ColliderComponent);
                const collider = colliderComp === null || colliderComp === void 0 ? void 0 : colliderComp.get();
                if (colliderComp && ((_a = colliderComp.owner) === null || _a === void 0 ? void 0 : _a.active) && collider) {
                    colliderComp.update();
                    if (collider instanceof CompositeCollider) {
                        const compositeColliders = collider.getColliders();
                        if (!collider.compositeStrategy) collider.compositeStrategy = this._physics.config.colliders.compositeStrategy;
                        colliders = colliders.concat(compositeColliders);
                    } else colliders.push(collider);
                }
            }
            // Update the spatial partitioning data structures
            // TODO if collider invalid it will break the processor
            // TODO rename "update" to something more specific
            this._processor.update(colliders);
            // Run broadphase on all colliders and locates potential collisions
            const pairs = this._processor.broadphase(colliders, elapsedMs);
            this._currentFrameContacts.clear();
            // Given possible pairs find actual contacts
            let contacts = this._processor.narrowphase(pairs, (_d = (_c = (_b = this._engine) === null || _b === void 0 ? void 0 : _b.debug) === null || _c === void 0 ? void 0 : _c.stats) === null || _d === void 0 ? void 0 : _d.currFrame);
            const solver = this.getSolver();
            // Solve, this resolves the position/velocity so entities aren't overlapping
            contacts = solver.solve(contacts);
            // Record contacts for start/end
            for (const contact of contacts){
                if (contact.isCanceled()) continue;
                // Process composite ids, things with the same composite id are treated as the same collider for start/end
                const index = contact.id.indexOf("|");
                if (index > 0) {
                    const compositeId = contact.id.substring(index + 1);
                    this._currentFrameContacts.set(compositeId, contact);
                } else this._currentFrameContacts.set(contact.id, contact);
            }
            // Emit contact start/end events
            this.runContactStartEnd();
            // reset the last frame cache
            this._lastFrameContacts.clear();
            // Keep track of collisions contacts that have started or ended
            this._lastFrameContacts = new Map(this._currentFrameContacts);
            // Process deferred collider removals
            for (const entity of this.query.entities){
                const collider = entity.get(ColliderComponent);
                if (collider) collider.processColliderRemoval();
            }
        }
        getSolver() {
            if (this._configDirty) {
                this._configDirty = false;
                this._arcadeSolver = new ArcadeSolver(this._physics.config.arcade);
                this._realisticSolver = new RealisticSolver(this._physics.config.realistic);
            }
            return this._physics.config.solver === SolverStrategy.Realistic ? this._realisticSolver : this._arcadeSolver;
        }
        debug(ex) {
            this._processor.debug(ex);
        }
        runContactStartEnd() {
            // If composite colliders are 'together' collisions may have a duplicate id because we want to treat those as a singular start/end
            for (const [id, c] of this._currentFrameContacts)// find all new contacts
            if (!this._lastFrameContacts.has(id)) {
                const colliderA = c.colliderA;
                const colliderB = c.colliderB;
                const side = Side.fromDirection(c.mtv);
                const opposite = Side.getOpposite(side);
                colliderA.events.emit("collisionstart", new CollisionStartEvent(colliderA, colliderB, side, c));
                colliderA.events.emit("contactstart", new ContactStartEvent(colliderA, colliderB, side, c));
                colliderB.events.emit("collisionstart", new CollisionStartEvent(colliderB, colliderA, opposite, c));
                colliderB.events.emit("contactstart", new ContactStartEvent(colliderB, colliderA, opposite, c));
            }
            // find all contacts that have ceased
            for (const [id, c] of this._lastFrameContacts)if (!this._currentFrameContacts.has(id)) {
                const colliderA = c.colliderA;
                const colliderB = c.colliderB;
                const side = Side.fromDirection(c.mtv);
                const opposite = Side.getOpposite(side);
                colliderA.events.emit("collisionend", new CollisionEndEvent(colliderA, colliderB, side, c));
                colliderA.events.emit("contactend", new ContactEndEvent(colliderA, colliderB, side, c));
                colliderB.events.emit("collisionend", new CollisionEndEvent(colliderB, colliderA, opposite, c));
                colliderB.events.emit("contactend", new ContactEndEvent(colliderB, colliderA, opposite, c));
            }
        }
    }
    /**
 * Configurable helper extends base type and makes all properties available as option bag arguments
 * @internal
 * @param base
 */ function Configurable(base) {
        return class extends base {
            assign(props) {
                //set the value of every property that was passed in,
                //if the constructor previously set this value, it will be overridden here
                for(const k in props)// eslint-disable-next-line
                if (typeof this[k] !== "function") // eslint-disable-next-line
                this[k] = props[k];
            }
            constructor(...args){
                super(...args);
                //get the number of arguments that aren't undefined. TS passes a value to all parameters
                //of whatever ctor is the implementation, so args.length doesn't work here.
                const size = args.filter(function(value) {
                    return value !== undefined;
                }).length;
                if (size === 1 && args[0] && typeof args[0] === "object" && !(args[0] instanceof Array)) this.assign(args[0]);
            }
        };
    }
    /**
 * An enum that represents the types of emitter nozzles
 */ var EmitterType;
    (function(EmitterType) {
        /**
     * Constant for the circular emitter type
     */ EmitterType[EmitterType["Circle"] = 0] = "Circle";
        /**
     * Constant for the rectangular emitter type
     */ EmitterType[EmitterType["Rectangle"] = 1] = "Rectangle";
    })(EmitterType || (EmitterType = {}));
    /**
 * @hidden
 */ class ParticleImpl extends Entity {
        constructor(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite){
            super();
            this.position = new Vector(0, 0);
            this.velocity = new Vector(0, 0);
            this.acceleration = new Vector(0, 0);
            this.particleRotationalVelocity = 0;
            this.currentRotation = 0;
            this.focus = null;
            this.focusAccel = 0;
            this.opacity = 1;
            this.beginColor = Color.White;
            this.endColor = Color.White;
            // Life is counted in ms
            this.life = 300;
            this.fadeFlag = false;
            // Color transitions
            this._rRate = 1;
            this._gRate = 1;
            this._bRate = 1;
            this._aRate = 0;
            this._currentColor = Color.White;
            this.emitter = null;
            this.particleSize = 5;
            this.particleSprite = null;
            this.sizeRate = 0;
            this.elapsedMultiplier = 0;
            this.visible = true;
            this.isOffscreen = false;
            let emitter = emitterOrConfig;
            if (emitter && !(emitterOrConfig instanceof ParticleEmitter)) {
                const config = emitterOrConfig;
                emitter = config.emitter;
                life = config.life;
                opacity = config.opacity;
                endColor = config.endColor;
                beginColor = config.beginColor;
                position = config.position;
                velocity = config.velocity;
                acceleration = config.acceleration;
                startSize = config.startSize;
                endSize = config.endSize;
                particleSprite = config.particleSprite;
            }
            this.emitter = emitter;
            this.life = life || this.life;
            this.opacity = opacity || this.opacity;
            this.endColor = endColor || this.endColor.clone();
            this.beginColor = beginColor || this.beginColor.clone();
            this._currentColor = this.beginColor.clone();
            this.particleSprite = particleSprite;
            if (this.emitter.particleTransform === ParticleTransform.Global) {
                const globalPos = this.emitter.transform.globalPos;
                this.position = (position || this.position).add(globalPos);
                this.velocity = (velocity || this.velocity).rotate(this.emitter.transform.globalRotation);
            } else {
                this.velocity = velocity || this.velocity;
                this.position = position || this.position;
            }
            this.acceleration = acceleration || this.acceleration;
            this._rRate = (this.endColor.r - this.beginColor.r) / this.life;
            this._gRate = (this.endColor.g - this.beginColor.g) / this.life;
            this._bRate = (this.endColor.b - this.beginColor.b) / this.life;
            this._aRate = this.opacity / this.life;
            this.startSize = startSize || 0;
            this.endSize = endSize || 0;
            if (this.endSize > 0 && this.startSize > 0) {
                this.sizeRate = (this.endSize - this.startSize) / this.life;
                this.particleSize = this.startSize;
            }
            this.addComponent(this.transform = new TransformComponent());
            this.addComponent(this.graphics = new GraphicsComponent());
            this.transform.pos = this.position;
            this.transform.rotation = this.currentRotation;
            this.transform.scale = vec(1, 1); // TODO wut
            this.transform.z = this.emitter.z;
            if (this.particleSprite) {
                this.graphics.opacity = this.opacity;
                this.graphics.use(this.particleSprite);
            } else {
                this.graphics.localBounds = BoundingBox.fromDimension(this.particleSize, this.particleSize, Vector.Half);
                this.graphics.onPostDraw = (ctx)=>{
                    ctx.save();
                    this.graphics.opacity = this.opacity;
                    const tmpColor = this._currentColor.clone();
                    tmpColor.a = 1;
                    ctx.debug.drawPoint(vec(0, 0), {
                        color: tmpColor,
                        size: this.particleSize
                    });
                    ctx.restore();
                };
            }
        }
        kill() {
            this.emitter.removeParticle(this);
        }
        update(engine, delta) {
            this.life = this.life - delta;
            this.elapsedMultiplier = this.elapsedMultiplier + delta;
            if (this.life < 0) this.kill();
            if (this.fadeFlag) this.opacity = clamp(this._aRate * this.life, 0.0001, 1);
            if (this.startSize > 0 && this.endSize > 0) this.particleSize = clamp(this.sizeRate * delta + this.particleSize, Math.min(this.startSize, this.endSize), Math.max(this.startSize, this.endSize));
            this._currentColor.r = clamp(this._currentColor.r + this._rRate * delta, 0, 255);
            this._currentColor.g = clamp(this._currentColor.g + this._gRate * delta, 0, 255);
            this._currentColor.b = clamp(this._currentColor.b + this._bRate * delta, 0, 255);
            this._currentColor.a = clamp(this.opacity, 0.0001, 1);
            if (this.focus) {
                const accel = this.focus.sub(this.position).normalize().scale(this.focusAccel).scale(delta / 1000);
                this.velocity = this.velocity.add(accel);
            } else this.velocity = this.velocity.add(this.acceleration.scale(delta / 1000));
            this.position = this.position.add(this.velocity.scale(delta / 1000));
            if (this.particleRotationalVelocity) this.currentRotation = (this.currentRotation + this.particleRotationalVelocity * delta / 1000) % (2 * Math.PI);
            this.transform.pos = this.position;
            this.transform.rotation = this.currentRotation;
            this.transform.scale = vec(1, 1); // todo wut
            this.graphics.opacity = this.opacity;
        }
    }
    /**
 * Particle is used in a [[ParticleEmitter]]
 */ class Particle extends Configurable(ParticleImpl) {
        constructor(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite){
            super(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite);
        }
    }
    var ParticleTransform;
    (function(ParticleTransform) {
        /**
     * [[ParticleTransform.Global]] is the default and emits particles as if
     * they were world space objects, useful for most effects.
     */ ParticleTransform["Global"] = "global";
        /**
     * [[ParticleTransform.Local]] particles are children of the emitter and move relative to the emitter
     * as they would in a parent/child actor relationship.
     */ ParticleTransform["Local"] = "local";
    })(ParticleTransform || (ParticleTransform = {}));
    /**
 * Using a particle emitter is a great way to create interesting effects
 * in your game, like smoke, fire, water, explosions, etc. `ParticleEmitter`
 * extend [[Actor]] allowing you to use all of the features that come with.
 */ class ParticleEmitter extends Actor {
        /**
     * Gets the opacity of each particle from 0 to 1.0
     */ get opacity() {
            return this.graphics.opacity;
        }
        /**
     * Gets the opacity of each particle from 0 to 1.0
     */ set opacity(opacity) {
            this.graphics.opacity = opacity;
        }
        /**
     * Gets or sets the sprite that a particle should use
     */ get particleSprite() {
            return this._sprite;
        }
        set particleSprite(val) {
            if (val) this._sprite = val;
        }
        /**
     * @param config particle emitter options bag
     */ constructor(config){
            var _a, _b;
            super({
                width: (_a = config.width) !== null && _a !== void 0 ? _a : 0,
                height: (_b = config.height) !== null && _b !== void 0 ? _b : 0
            });
            this._particlesToEmit = 0;
            this.numParticles = 0;
            /**
         * Gets or sets the isEmitting flag
         */ this.isEmitting = true;
            /**
         * Gets or sets the backing particle collection
         */ this.particles = [];
            /**
         * Gets or sets the backing deadParticle collection
         */ this.deadParticles = [];
            /**
         * Gets or sets the minimum particle velocity
         */ this.minVel = 0;
            /**
         * Gets or sets the maximum particle velocity
         */ this.maxVel = 0;
            /**
         * Gets or sets the acceleration vector for all particles
         */ this.acceleration = new Vector(0, 0);
            /**
         * Gets or sets the minimum angle in radians
         */ this.minAngle = 0;
            /**
         * Gets or sets the maximum angle in radians
         */ this.maxAngle = 0;
            /**
         * Gets or sets the emission rate for particles (particles/sec)
         */ this.emitRate = 1; //particles/sec
            /**
         * Gets or sets the life of each particle in milliseconds
         */ this.particleLife = 2000;
            /**
         * Gets or sets the fade flag which causes particles to gradually fade out over the course of their life.
         */ this.fadeFlag = false;
            /**
         * Gets or sets the optional focus where all particles should accelerate towards
         */ this.focus = null;
            /**
         * Gets or sets the acceleration for focusing particles if a focus has been specified
         */ this.focusAccel = null;
            /**
         * Gets or sets the optional starting size for the particles
         */ this.startSize = null;
            /**
         * Gets or sets the optional ending size for the particles
         */ this.endSize = null;
            /**
         * Gets or sets the minimum size of all particles
         */ this.minSize = 5;
            /**
         * Gets or sets the maximum size of all particles
         */ this.maxSize = 5;
            /**
         * Gets or sets the beginning color of all particles
         */ this.beginColor = Color.White;
            /**
         * Gets or sets the ending color of all particles
         */ this.endColor = Color.White;
            this._sprite = null;
            /**
         * Gets or sets the emitter type for the particle emitter
         */ this.emitterType = EmitterType.Rectangle;
            /**
         * Gets or sets the emitter radius, only takes effect when the [[emitterType]] is [[EmitterType.Circle]]
         */ this.radius = 0;
            /**
         * Gets or sets the particle rotational speed velocity
         */ this.particleRotationalVelocity = 0;
            /**
         * Indicates whether particles should start with a random rotation
         */ this.randomRotation = false;
            /**
         * Gets or sets the emitted particle transform style, [[ParticleTransform.Global]] is the default and emits particles as if
         * they were world space objects, useful for most effects.
         *
         * If set to [[ParticleTransform.Local]] particles are children of the emitter and move relative to the emitter
         * as they would in a parent/child actor relationship.
         */ this.particleTransform = ParticleTransform.Global;
            const { x: x, y: y, z: z, pos: pos, isEmitting: isEmitting, minVel: minVel, maxVel: maxVel, acceleration: acceleration, minAngle: minAngle, maxAngle: maxAngle, emitRate: emitRate, particleLife: particleLife, opacity: opacity, fadeFlag: fadeFlag, focus: focus, focusAccel: focusAccel, startSize: startSize, endSize: endSize, minSize: minSize, maxSize: maxSize, beginColor: beginColor, endColor: endColor, particleSprite: particleSprite, emitterType: emitterType, radius: radius, particleRotationalVelocity: particleRotationalVelocity, particleTransform: particleTransform, randomRotation: randomRotation, random: random } = {
                ...config
            };
            this.pos = pos !== null && pos !== void 0 ? pos : vec(x !== null && x !== void 0 ? x : 0, y !== null && y !== void 0 ? y : 0);
            this.z = z !== null && z !== void 0 ? z : 0;
            this.isEmitting = isEmitting !== null && isEmitting !== void 0 ? isEmitting : this.isEmitting;
            this.minVel = minVel !== null && minVel !== void 0 ? minVel : this.minVel;
            this.maxVel = maxVel !== null && maxVel !== void 0 ? maxVel : this.maxVel;
            this.acceleration = acceleration !== null && acceleration !== void 0 ? acceleration : this.acceleration;
            this.minAngle = minAngle !== null && minAngle !== void 0 ? minAngle : this.minAngle;
            this.maxAngle = maxAngle !== null && maxAngle !== void 0 ? maxAngle : this.maxAngle;
            this.emitRate = emitRate !== null && emitRate !== void 0 ? emitRate : this.emitRate;
            this.particleLife = particleLife !== null && particleLife !== void 0 ? particleLife : this.particleLife;
            this.opacity = opacity !== null && opacity !== void 0 ? opacity : this.opacity;
            this.fadeFlag = fadeFlag !== null && fadeFlag !== void 0 ? fadeFlag : this.fadeFlag;
            this.focus = focus !== null && focus !== void 0 ? focus : this.focus;
            this.focusAccel = focusAccel !== null && focusAccel !== void 0 ? focusAccel : this.focusAccel;
            this.startSize = startSize !== null && startSize !== void 0 ? startSize : this.startSize;
            this.endSize = endSize !== null && endSize !== void 0 ? endSize : this.endSize;
            this.minSize = minSize !== null && minSize !== void 0 ? minSize : this.minSize;
            this.maxSize = maxSize !== null && maxSize !== void 0 ? maxSize : this.maxSize;
            this.beginColor = beginColor !== null && beginColor !== void 0 ? beginColor : this.beginColor;
            this.endColor = endColor !== null && endColor !== void 0 ? endColor : this.endColor;
            this.particleSprite = particleSprite !== null && particleSprite !== void 0 ? particleSprite : this.particleSprite;
            this.emitterType = emitterType !== null && emitterType !== void 0 ? emitterType : this.emitterType;
            this.radius = radius !== null && radius !== void 0 ? radius : this.radius;
            this.particleRotationalVelocity = particleRotationalVelocity !== null && particleRotationalVelocity !== void 0 ? particleRotationalVelocity : this.particleRotationalVelocity;
            this.randomRotation = randomRotation !== null && randomRotation !== void 0 ? randomRotation : this.randomRotation;
            this.particleTransform = particleTransform !== null && particleTransform !== void 0 ? particleTransform : this.particleTransform;
            this.body.collisionType = CollisionType.PreventCollision;
            this.random = random !== null && random !== void 0 ? random : new Random();
        }
        removeParticle(particle) {
            this.deadParticles.push(particle);
        }
        /**
     * Causes the emitter to emit particles
     * @param particleCount  Number of particles to emit right now
     */ emitParticles(particleCount) {
            var _a;
            for(let i = 0; i < particleCount; i++){
                const p = this._createParticle();
                this.particles.push(p);
                if ((_a = this === null || this === void 0 ? void 0 : this.scene) === null || _a === void 0 ? void 0 : _a.world) {
                    if (this.particleTransform === ParticleTransform.Global) this.scene.world.add(p);
                    else this.addChild(p);
                }
            }
        }
        clearParticles() {
            this.particles.length = 0;
        }
        // Creates a new particle given the constraints of the emitter
        _createParticle() {
            // todo implement emitter constraints;
            let ranX = 0;
            let ranY = 0;
            const angle = randomInRange(this.minAngle, this.maxAngle, this.random);
            const vel = randomInRange(this.minVel, this.maxVel, this.random);
            const size = this.startSize || randomInRange(this.minSize, this.maxSize, this.random);
            const dx = vel * Math.cos(angle);
            const dy = vel * Math.sin(angle);
            if (this.emitterType === EmitterType.Rectangle) {
                ranX = randomInRange(0, this.width, this.random);
                ranY = randomInRange(0, this.height, this.random);
            } else if (this.emitterType === EmitterType.Circle) {
                const radius = randomInRange(0, this.radius, this.random);
                ranX = radius * Math.cos(angle);
                ranY = radius * Math.sin(angle);
            }
            const p = new Particle(this, this.particleLife, this.opacity, this.beginColor, this.endColor, new Vector(ranX, ranY), new Vector(dx, dy), this.acceleration, this.startSize, this.endSize, this.particleSprite);
            p.fadeFlag = this.fadeFlag;
            p.particleSize = size;
            p.particleRotationalVelocity = this.particleRotationalVelocity;
            if (this.randomRotation) p.currentRotation = randomInRange(0, Math.PI * 2, this.random);
            if (this.focus) {
                p.focus = this.focus.add(new Vector(this.pos.x, this.pos.y));
                p.focusAccel = this.focusAccel;
            }
            return p;
        }
        update(engine, delta) {
            var _a;
            super.update(engine, delta);
            if (this.isEmitting) {
                this._particlesToEmit += this.emitRate * (delta / 1000);
                if (this._particlesToEmit > 1.0) {
                    this.emitParticles(Math.floor(this._particlesToEmit));
                    this._particlesToEmit = this._particlesToEmit - Math.floor(this._particlesToEmit);
                }
            }
            // deferred removal
            for(let i = 0; i < this.deadParticles.length; i++){
                removeItemFromArray(this.deadParticles[i], this.particles);
                if ((_a = this === null || this === void 0 ? void 0 : this.scene) === null || _a === void 0 ? void 0 : _a.world) this.scene.world.remove(this.deadParticles[i], false);
            }
            this.deadParticles.length = 0;
        }
    }
    /**
 * Blend 2 transforms for interpolation, will interpolate from the context of newTx's parent if it exists
 */ function blendTransform(oldTx, newTx, blend, target) {
        if (oldTx.parent !== newTx.parent) {
            // Caller expects a local transform
            // Adjust old tx to be local to the new parent whatever that is
            const oldTxWithNewParent = oldTx.clone();
            const oldGlobalPos = oldTx.globalPos.clone();
            const oldGlobalScale = oldTx.globalScale.clone();
            const oldGlobalRotation = oldTx.globalRotation;
            oldTxWithNewParent.parent = newTx.parent;
            oldTxWithNewParent.globalPos = oldGlobalPos;
            oldTxWithNewParent.globalScale = oldGlobalScale;
            oldTxWithNewParent.globalRotation = oldGlobalRotation;
            oldTx = oldTxWithNewParent;
        }
        let interpolatedPos = newTx.pos;
        let interpolatedScale = newTx.scale;
        let interpolatedRotation = newTx.rotation;
        interpolatedPos = newTx.pos.scale(blend).add(oldTx.pos.scale(1.0 - blend));
        interpolatedScale = newTx.scale.scale(blend).add(oldTx.scale.scale(1.0 - blend));
        // Rotational lerp https://stackoverflow.com/a/30129248
        const cosine = (1.0 - blend) * Math.cos(oldTx.rotation) + blend * Math.cos(newTx.rotation);
        const sine = (1.0 - blend) * Math.sin(oldTx.rotation) + blend * Math.sin(newTx.rotation);
        interpolatedRotation = Math.atan2(sine, cosine);
        const tx = target !== null && target !== void 0 ? target : new transform_Transform();
        tx.setTransform(interpolatedPos, interpolatedRotation, interpolatedScale);
        return tx;
    }
    /**
 *
 */ function blendGlobalTransform(oldTx, newTx, blend, target) {
        let interpolatedPos = newTx.globalPos;
        let interpolatedScale = newTx.globalScale;
        let interpolatedRotation = newTx.globalRotation;
        interpolatedPos = newTx.globalPos.scale(blend).add(oldTx.globalPos.scale(1.0 - blend));
        interpolatedScale = newTx.globalScale.scale(blend).add(oldTx.globalScale.scale(1.0 - blend));
        // Rotational lerp https://stackoverflow.com/a/30129248
        const cosine = (1.0 - blend) * Math.cos(oldTx.globalRotation) + blend * Math.cos(newTx.globalRotation);
        const sine = (1.0 - blend) * Math.sin(oldTx.globalRotation) + blend * Math.sin(newTx.globalRotation);
        interpolatedRotation = Math.atan2(sine, cosine);
        const tx = target !== null && target !== void 0 ? target : new Transform();
        tx.setTransform(interpolatedPos, interpolatedRotation, interpolatedScale);
        return tx;
    }
    // this import seems to bomb wallaby
    class GraphicsSystem extends System {
        get sortedTransforms() {
            return this._sortedTransforms;
        }
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Average;
            this._token = 0;
            this._sortedTransforms = [];
            this._zHasChanged = false;
            this._zIndexUpdate = ()=>{
                this._zHasChanged = true;
            };
            this._targetInterpolationTransform = new transform_Transform();
            this.query = this.world.query([
                TransformComponent,
                GraphicsComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                this._sortedTransforms.push(tx);
                tx.zIndexChanged$.subscribe(this._zIndexUpdate);
                this._zHasChanged = true;
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                tx.zIndexChanged$.unsubscribe(this._zIndexUpdate);
                const index = this._sortedTransforms.indexOf(tx);
                if (index > -1) this._sortedTransforms.splice(index, 1);
            });
        }
        initialize(world, scene) {
            this._camera = scene.camera;
            this._engine = scene.engine;
        }
        preupdate() {
            // Graphics context could be switched to fallback in a new frame
            this._graphicsContext = this._engine.graphicsContext;
            if (this._zHasChanged) {
                this._sortedTransforms.sort((a, b)=>{
                    return a.z - b.z;
                });
                this._zHasChanged = false;
            }
        }
        update(delta) {
            this._token++;
            let graphics;
            FontCache.checkAndClearCache();
            // This is a performance enhancement, most things are in world space
            // so if we can only do this once saves a ton of transform updates
            this._graphicsContext.save();
            if (this._camera) this._camera.draw(this._graphicsContext);
            for (const transform of this._sortedTransforms){
                const entity = transform.owner;
                // If the entity is offscreen skip
                if (entity.hasTag("ex.offscreen")) continue;
                graphics = entity.get(GraphicsComponent);
                // Exit if graphics set to not visible
                if (!graphics.visible) continue;
                // Optionally run the onPreTransformDraw graphics lifecycle draw
                if (graphics.onPreTransformDraw) graphics.onPreTransformDraw(this._graphicsContext, delta);
                entity.events.emit("pretransformdraw", new PreTransformDrawEvent(this._graphicsContext, delta, entity));
                // This optionally sets our camera based on the entity coord plan (world vs. screen)
                if (transform.coordPlane === CoordPlane.Screen) this._graphicsContext.restore();
                this._graphicsContext.save();
                if (transform.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                // Tick any graphics state (but only once) for animations and graphics groups
                graphics.update(delta, this._token);
                // Apply parallax
                const parallax = entity.get(ParallaxComponent);
                if (parallax) {
                    // We use the Tiled formula
                    // https://doc.mapeditor.org/en/latest/manual/layers/#parallax-scrolling-factor
                    // cameraPos * (1 - parallaxFactor)
                    const oneMinusFactor = Vector.One.sub(parallax.parallaxFactor);
                    const parallaxOffset = this._camera.drawPos.scale(oneMinusFactor);
                    this._graphicsContext.translate(parallaxOffset.x, parallaxOffset.y);
                }
                // Position the entity + estimate lag
                this._applyTransform(entity);
                // If there is a material enable it on the context
                if (graphics.material) this._graphicsContext.material = graphics.material;
                // Optionally run the onPreDraw graphics lifecycle draw
                if (graphics.onPreDraw) graphics.onPreDraw(this._graphicsContext, delta);
                entity.events.emit("predraw", new PreDrawEvent(this._graphicsContext, delta, entity));
                // TODO remove this hack on the particle redo
                // Remove this line after removing the wallaby import
                const particleOpacity = entity instanceof Particle ? entity.opacity : 1;
                this._graphicsContext.opacity *= graphics.opacity * particleOpacity;
                // Draw the graphics component
                this._drawGraphicsComponent(graphics, transform);
                // Optionally run the onPostDraw graphics lifecycle draw
                if (graphics.onPostDraw) graphics.onPostDraw(this._graphicsContext, delta);
                entity.events.emit("postdraw", new PostDrawEvent(this._graphicsContext, delta, entity));
                this._graphicsContext.restore();
                // Reset the transform back to the original world space
                if (transform.coordPlane === CoordPlane.Screen) {
                    this._graphicsContext.save();
                    if (this._camera) this._camera.draw(this._graphicsContext);
                }
                // Optionally run the onPreTransformDraw graphics lifecycle draw
                if (graphics.onPostTransformDraw) graphics.onPostTransformDraw(this._graphicsContext, delta);
                entity.events.emit("posttransformdraw", new PostTransformDrawEvent(this._graphicsContext, delta, entity));
            }
            this._graphicsContext.restore();
        }
        _drawGraphicsComponent(graphicsComponent, transformComponent) {
            var _a, _b;
            if (graphicsComponent.visible) {
                const flipHorizontal = graphicsComponent.flipHorizontal;
                const flipVertical = graphicsComponent.flipVertical;
                const graphic = graphicsComponent.current;
                const options = (_a = graphicsComponent.currentOptions) !== null && _a !== void 0 ? _a : {};
                if (graphic) {
                    let anchor = graphicsComponent.anchor;
                    let offset = graphicsComponent.offset;
                    let scaleX = 1;
                    let scaleY = 1;
                    // handle specific overrides
                    if (options === null || options === void 0 ? void 0 : options.anchor) anchor = options.anchor;
                    if (options === null || options === void 0 ? void 0 : options.offset) offset = options.offset;
                    const globalScale = transformComponent.globalScale;
                    scaleX *= graphic.scale.x * globalScale.x;
                    scaleY *= graphic.scale.y * globalScale.y;
                    // See https://github.com/excaliburjs/Excalibur/pull/619 for discussion on this formula
                    const offsetX = -graphic.width * anchor.x + offset.x * scaleX;
                    const offsetY = -graphic.height * anchor.y + offset.y * scaleY;
                    const oldFlipHorizontal = graphic.flipHorizontal;
                    const oldFlipVertical = graphic.flipVertical;
                    if (flipHorizontal || flipVertical) {
                        // flip any currently flipped graphics
                        graphic.flipHorizontal = flipHorizontal ? !oldFlipHorizontal : oldFlipHorizontal;
                        graphic.flipVertical = flipVertical ? !oldFlipVertical : oldFlipVertical;
                    }
                    graphic === null || graphic === void 0 || graphic.draw(this._graphicsContext, offsetX, offsetY);
                    if (flipHorizontal || flipVertical) {
                        graphic.flipHorizontal = oldFlipHorizontal;
                        graphic.flipVertical = oldFlipVertical;
                    }
                    // TODO move debug code out?
                    if (((_b = this._engine) === null || _b === void 0 ? void 0 : _b.isDebug) && this._engine.debug.graphics.showBounds) {
                        const offset = vec(offsetX, offsetY);
                        if (graphic instanceof GraphicsGroup) for (const member of graphic.members){
                            let g;
                            let pos = Vector.Zero;
                            if (member instanceof Graphic) g = member;
                            else {
                                g = member.graphic;
                                pos = member.offset;
                            }
                            if (graphic.useAnchor) g === null || g === void 0 || g.localBounds.translate(offset.add(pos)).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                            else g === null || g === void 0 || g.localBounds.translate(pos).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                        }
                        else /* istanbul ignore next */ graphic === null || graphic === void 0 || graphic.localBounds.translate(offset).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                    }
                }
            }
        }
        /**
     * This applies the current entity transform to the graphics context
     * @param entity
     */ _applyTransform(entity) {
            const ancestors = entity.getAncestors();
            for (const ancestor of ancestors){
                const transform = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(TransformComponent);
                const optionalBody = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(BodyComponent);
                let tx = transform.get();
                if (optionalBody) {
                    if (this._engine.fixedUpdateFps && optionalBody.__oldTransformCaptured && optionalBody.enableFixedUpdateInterpolate) {
                        // Interpolate graphics if needed
                        const blend = this._engine.currentFrameLagMs / (1000 / this._engine.fixedUpdateFps);
                        tx = blendTransform(optionalBody.oldTransform, transform.get(), blend, this._targetInterpolationTransform);
                    }
                }
                if (transform) {
                    this._graphicsContext.z = transform.z;
                    this._graphicsContext.translate(tx.pos.x, tx.pos.y);
                    this._graphicsContext.scale(tx.scale.x, tx.scale.y);
                    this._graphicsContext.rotate(tx.rotation);
                }
            }
        }
    }
    class DebugSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Lowest;
            this.query = this.world.query([
                TransformComponent
            ]);
        }
        initialize(world, scene) {
            this._graphicsContext = scene.engine.graphicsContext;
            this._camera = scene.camera;
            this._engine = scene.engine;
            this._collisionSystem = world.systemManager.get(CollisionSystem);
        }
        update() {
            var _a;
            if (!this._engine.isDebug) return;
            const filterSettings = this._engine.debug.filter;
            let id;
            let name;
            const entitySettings = this._engine.debug.entity;
            let tx;
            const txSettings = this._engine.debug.transform;
            let motion;
            const motionSettings = this._engine.debug.motion;
            let colliderComp;
            const colliderSettings = this._engine.debug.collider;
            const physicsSettings = this._engine.debug.physics;
            let graphics;
            const graphicsSettings = this._engine.debug.graphics;
            let debugDraw;
            let body;
            const bodySettings = this._engine.debug.body;
            const cameraSettings = this._engine.debug.camera;
            for (const entity of this.query.entities){
                if (entity.hasTag("offscreen")) continue;
                if (entity instanceof Particle) continue;
                if (filterSettings.useFilter) {
                    const allIds = filterSettings.ids.length === 0;
                    const idMatch = allIds || filterSettings.ids.includes(entity.id);
                    if (!idMatch) continue;
                    const allNames = filterSettings.nameQuery === "";
                    const nameMatch = allNames || entity.name.includes(filterSettings.nameQuery);
                    if (!nameMatch) continue;
                }
                let cursor = Vector.Zero;
                const lineHeight = vec(0, 16);
                id = entity.id;
                name = entity.name;
                tx = entity.get(TransformComponent);
                // This optionally sets our camera based on the entity coord plan (world vs. screen)
                this._pushCameraTransform(tx);
                this._graphicsContext.save();
                if (tx.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                this._graphicsContext.z = txSettings.debugZIndex;
                this._applyTransform(entity);
                if (tx) {
                    if (txSettings.showAll || txSettings.showPosition) this._graphicsContext.debug.drawPoint(Vector.Zero, {
                        size: 4,
                        color: txSettings.positionColor
                    });
                    if (txSettings.showAll || txSettings.showPositionLabel) {
                        this._graphicsContext.debug.drawText(`pos${tx.pos.toString(2)}`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showZIndex) {
                        this._graphicsContext.debug.drawText(`z(${tx.z.toFixed(1)})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (entitySettings.showAll || entitySettings.showId) {
                        this._graphicsContext.debug.drawText(`id(${id}) ${entity.parent ? "child of id(" + ((_a = entity.parent) === null || _a === void 0 ? void 0 : _a.id) + ")" : ""}`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (entitySettings.showAll || entitySettings.showName) {
                        this._graphicsContext.debug.drawText(`name(${name})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showRotation) {
                        this._graphicsContext.drawLine(Vector.Zero, Vector.fromAngle(tx.rotation).scale(50).add(Vector.Zero), txSettings.rotationColor, 2);
                        this._graphicsContext.debug.drawText(`rot deg(${toDegrees(tx.rotation).toFixed(2)})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showScale) this._graphicsContext.drawLine(Vector.Zero, tx.scale.add(Vector.Zero), txSettings.scaleColor, 2);
                }
                graphics = entity.get(GraphicsComponent);
                if (graphics) {
                    if (graphicsSettings.showAll || graphicsSettings.showBounds) {
                        const bounds = graphics.localBounds;
                        bounds.draw(this._graphicsContext, graphicsSettings.boundsColor);
                    }
                }
                debugDraw = entity.get(DebugGraphicsComponent);
                if (debugDraw) {
                    if (!debugDraw.useTransform) this._graphicsContext.restore();
                    debugDraw.draw(this._graphicsContext, this._engine.debug);
                    if (!debugDraw.useTransform) {
                        this._graphicsContext.save();
                        this._applyTransform(entity);
                    }
                }
                body = entity.get(BodyComponent);
                if (body) {
                    if (bodySettings.showAll || bodySettings.showCollisionGroup) {
                        this._graphicsContext.debug.drawText(`collision group(${body.group.name})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showCollisionType) {
                        this._graphicsContext.debug.drawText(`collision type(${body.collisionType})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showMass) {
                        this._graphicsContext.debug.drawText(`mass(${body.mass})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showMotion) {
                        this._graphicsContext.debug.drawText(`motion(${body.sleepMotion})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showSleeping) {
                        this._graphicsContext.debug.drawText(`sleeping(${body.canSleep ? body.sleeping : "cant sleep"})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                }
                this._graphicsContext.restore();
                // World space
                this._graphicsContext.save();
                if (tx.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                this._graphicsContext.z = txSettings.debugZIndex;
                motion = entity.get(MotionComponent);
                if (motion) {
                    if (motionSettings.showAll || motionSettings.showVelocity) {
                        this._graphicsContext.debug.drawText(`vel${motion.vel.toString(2)}`, cursor.add(tx.globalPos));
                        this._graphicsContext.drawLine(tx.globalPos, tx.globalPos.add(motion.vel), motionSettings.velocityColor, 2);
                        cursor = cursor.add(lineHeight);
                    }
                    if (motionSettings.showAll || motionSettings.showAcceleration) this._graphicsContext.drawLine(tx.globalPos, tx.globalPos.add(motion.acc), motionSettings.accelerationColor, 2);
                }
                // Colliders live in world space already so after the restore()
                colliderComp = entity.get(ColliderComponent);
                if (colliderComp) {
                    const collider = colliderComp.get();
                    if ((colliderSettings.showAll || colliderSettings.showGeometry) && collider) collider.debug(this._graphicsContext, colliderSettings.geometryColor, {
                        lineWidth: colliderSettings.geometryLineWidth,
                        pointSize: colliderSettings.geometryPointSize
                    });
                    if (colliderSettings.showAll || colliderSettings.showBounds) {
                        if (collider instanceof CompositeCollider) {
                            const colliders = collider.getColliders();
                            for (const collider of colliders){
                                const bounds = collider.bounds;
                                const pos = vec(bounds.left, bounds.top);
                                this._graphicsContext.debug.drawRect(pos.x, pos.y, bounds.width, bounds.height, {
                                    color: colliderSettings.boundsColor
                                });
                                if (colliderSettings.showAll || colliderSettings.showOwner) this._graphicsContext.debug.drawText(`owner id(${collider.owner.id})`, pos);
                            }
                            colliderComp.bounds.draw(this._graphicsContext, colliderSettings.boundsColor);
                        } else if (collider) {
                            const bounds = colliderComp.bounds;
                            const pos = vec(bounds.left, bounds.top);
                            this._graphicsContext.debug.drawRect(pos.x, pos.y, bounds.width, bounds.height, {
                                color: colliderSettings.boundsColor
                            });
                            if (colliderSettings.showAll || colliderSettings.showOwner) this._graphicsContext.debug.drawText(`owner id(${colliderComp.owner.id})`, pos);
                        }
                    }
                }
                this._graphicsContext.restore();
                this._popCameraTransform(tx);
            }
            this._graphicsContext.save();
            this._camera.draw(this._graphicsContext);
            if (physicsSettings.showAll || physicsSettings.showBroadphaseSpacePartitionDebug) this._collisionSystem.debug(this._graphicsContext);
            if (physicsSettings.showAll || physicsSettings.showCollisionContacts || physicsSettings.showCollisionNormals) for (const [_, contact] of this._engine.debug.stats.currFrame.physics.contacts){
                if (physicsSettings.showAll || physicsSettings.showCollisionContacts) for (const point of contact.points)this._graphicsContext.debug.drawPoint(point, {
                    size: physicsSettings.contactSize,
                    color: physicsSettings.collisionContactColor
                });
                if (physicsSettings.showAll || physicsSettings.showCollisionNormals) for (const point of contact.points)this._graphicsContext.debug.drawLine(point, contact.normal.scale(30).add(point), {
                    color: physicsSettings.collisionNormalColor
                });
            }
            this._graphicsContext.restore();
            if (cameraSettings) {
                this._graphicsContext.save();
                this._camera.draw(this._graphicsContext);
                if (cameraSettings.showAll || cameraSettings.showFocus) this._graphicsContext.drawCircle(this._camera.pos, 4, cameraSettings.focusColor);
                if (cameraSettings.showAll || cameraSettings.showZoom) this._graphicsContext.debug.drawText(`zoom(${this._camera.zoom})`, this._camera.pos);
                this._graphicsContext.restore();
            }
            this._graphicsContext.flush();
        }
        postupdate(engine, elapsedMs) {
            if (this._engine.isDebug) {
                this._graphicsContext.save();
                if (this._camera) this._camera.draw(this._graphicsContext);
                Debug.flush(this._graphicsContext);
                this._graphicsContext.restore();
            }
        }
        /**
     * This applies the current entity transform to the graphics context
     * @param entity
     */ _applyTransform(entity) {
            const ancestors = entity.getAncestors();
            for (const ancestor of ancestors){
                const transform = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(TransformComponent);
                if (transform) {
                    this._graphicsContext.translate(transform.pos.x, transform.pos.y);
                    this._graphicsContext.scale(transform.scale.x, transform.scale.y);
                    this._graphicsContext.rotate(transform.rotation);
                }
            }
        }
        /**
     * Applies the current camera transform if in world coordinates
     * @param transform
     */ _pushCameraTransform(transform) {
            // Establish camera offset per entity
            if (transform.coordPlane === CoordPlane.World) {
                this._graphicsContext.save();
                if (this._camera) this._camera.draw(this._graphicsContext);
            }
        }
        /**
     * Resets the current camera transform if in world coordinates
     * @param transform
     */ _popCameraTransform(transform) {
            if (transform.coordPlane === CoordPlane.World) // Apply camera world offset
            this._graphicsContext.restore();
        }
    }
    /**
 * The PointerSystem is responsible for dispatching pointer events to entities
 * that need them.
 *
 * The PointerSystem can be optionally configured by the [[PointerComponent]], by default Entities use
 * the [[Collider]]'s shape for pointer events.
 */ class PointerSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            /**
         * Optionally override component configuration for all entities
         */ this.overrideUseColliderShape = false;
            /**
         * Optionally override component configuration for all entities
         */ this.overrideUseGraphicsBounds = false;
            this.lastFrameEntityToPointers = new Map();
            this.currentFrameEntityToPointers = new Map();
            this._sortedTransforms = [];
            this._sortedEntities = [];
            this._zHasChanged = false;
            this._zIndexUpdate = ()=>{
                this._zHasChanged = true;
            };
            this.query = this.world.query([
                TransformComponent,
                PointerComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                this._sortedTransforms.push(tx);
                this._sortedEntities.push(tx.owner);
                tx.zIndexChanged$.subscribe(this._zIndexUpdate);
                this._zHasChanged = true;
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                tx.zIndexChanged$.unsubscribe(this._zIndexUpdate);
                const index = this._sortedTransforms.indexOf(tx);
                if (index > -1) {
                    this._sortedTransforms.splice(index, 1);
                    this._sortedEntities.splice(index, 1);
                }
            });
        }
        initialize(world, scene) {
            this._engine = scene.engine;
            this._scene = scene;
        }
        preupdate() {
            // event receiver might change per frame
            this._receivers = [
                this._engine.input.pointers,
                this._scene.input.pointers
            ];
            this._engineReceiver = this._engine.input.pointers;
            if (this._zHasChanged) {
                this._sortedTransforms.sort((a, b)=>{
                    return b.z - a.z;
                });
                this._sortedEntities = this._sortedTransforms.map((t)=>t.owner);
                this._zHasChanged = false;
            }
        }
        entityCurrentlyUnderPointer(entity, pointerId) {
            return this.currentFrameEntityToPointers.has(entity.id) && this.currentFrameEntityToPointers.get(entity.id).includes(pointerId);
        }
        entityWasUnderPointer(entity, pointerId) {
            return this.lastFrameEntityToPointers.has(entity.id) && this.lastFrameEntityToPointers.get(entity.id).includes(pointerId);
        }
        entered(entity, pointerId) {
            return this.entityCurrentlyUnderPointer(entity, pointerId) && !this.lastFrameEntityToPointers.has(entity.id);
        }
        left(entity, pointerId) {
            return !this.currentFrameEntityToPointers.has(entity.id) && this.entityWasUnderPointer(entity, pointerId);
        }
        addPointerToEntity(entity, pointerId) {
            if (!this.currentFrameEntityToPointers.has(entity.id)) {
                this.currentFrameEntityToPointers.set(entity.id, [
                    pointerId
                ]);
                return;
            }
            const pointers = this.currentFrameEntityToPointers.get(entity.id);
            this.currentFrameEntityToPointers.set(entity.id, pointers.concat(pointerId));
        }
        update() {
            // Locate all the pointer/entity mappings
            this._processPointerToEntity(this._sortedEntities);
            // Dispatch pointer events on entities
            this._dispatchEvents(this._sortedEntities);
            // Clear last frame's events
            this._receivers.forEach((r)=>r.update());
            this.lastFrameEntityToPointers.clear();
            this.lastFrameEntityToPointers = new Map(this.currentFrameEntityToPointers);
            this.currentFrameEntityToPointers.clear();
            this._receivers.forEach((r)=>r.clear());
        }
        _processPointerToEntity(entities) {
            var _a;
            let transform;
            let collider;
            let graphics;
            let pointer;
            const receiver = this._engineReceiver;
            // TODO probably a spatial partition optimization here to quickly query bounds for pointer
            // doesn't seem to cause issues tho for perf
            // Pre-process find entities under pointers
            for (const entity of entities){
                transform = entity.get(TransformComponent);
                pointer = (_a = entity.get(PointerComponent)) !== null && _a !== void 0 ? _a : new PointerComponent;
                // If pointer bounds defined
                if (pointer.localBounds) {
                    const pointerBounds = pointer.localBounds.transform(transform.get().matrix);
                    for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (pointerBounds.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                }
                // Check collider contains pointer
                collider = entity.get(ColliderComponent);
                if (collider && (pointer.useColliderShape || this.overrideUseColliderShape)) {
                    collider.update();
                    const geom = collider.get();
                    if (geom) {
                        for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (geom.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                    }
                }
                // Check graphics contains pointer
                graphics = entity.get(GraphicsComponent);
                if (graphics && (pointer.useGraphicsBounds || this.overrideUseGraphicsBounds)) {
                    const graphicBounds = graphics.localBounds.transform(transform.get().matrix);
                    for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (graphicBounds.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                }
            }
        }
        _processDownAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastDownPerPointer = new Map(); // TODO will this get confused between receivers?
            // Loop through down and dispatch to entities
            for (const event of receiver.currentFrameDown){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    entity.events.emit("pointerdown", event);
                    if (receiver.isDragStart(event.pointerId)) entity.events.emit("pointerdragstart", event);
                }
                lastDownPerPointer.set(event.pointerId, event);
            }
            return lastDownPerPointer;
        }
        _processUpAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastUpPerPointer = new Map();
            // Loop through up and dispatch to entities
            for (const event of receiver.currentFrameUp){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    entity.events.emit("pointerup", event);
                    if (receiver.isDragEnd(event.pointerId)) entity.events.emit("pointerdragend", event);
                }
                lastUpPerPointer.set(event.pointerId, event);
            }
            return lastUpPerPointer;
        }
        _processMoveAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastMovePerPointer = new Map();
            // Loop through move and dispatch to entities
            for (const event of receiver.currentFrameMove){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    // move
                    entity.events.emit("pointermove", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragmove", event);
                }
                lastMovePerPointer.set(event.pointerId, event);
            }
            return lastMovePerPointer;
        }
        _processEnterLeaveAndEmit(entity, lastUpDownMoveEvents) {
            const receiver = this._engineReceiver;
            // up, down, and move are considered for enter and leave
            for (const event of lastUpDownMoveEvents){
                // enter
                if (event.active && entity.active && this.entered(entity, event.pointerId)) {
                    entity.events.emit("pointerenter", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragenter", event);
                    break;
                }
                if (event.active && entity.active && // leave can happen on move
                (this.left(entity, event.pointerId) || // or leave can happen on pointer up
                this.entityCurrentlyUnderPointer(entity, event.pointerId) && event.type === "up")) {
                    entity.events.emit("pointerleave", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragleave", event);
                    break;
                }
            }
        }
        _processCancelAndEmit(entity) {
            const receiver = this._engineReceiver;
            // cancel
            for (const event of receiver.currentFrameCancel)if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) entity.events.emit("pointercancel", event);
        }
        _processWheelAndEmit(entity) {
            const receiver = this._engineReceiver;
            // wheel
            for (const event of receiver.currentFrameWheel)// Currently the wheel only fires under the primary pointer '0'
            if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, 0)) entity.events.emit("pointerwheel", event);
        }
        _dispatchEvents(entities) {
            const lastFrameEntities = new Set(this.lastFrameEntityToPointers.keys());
            const currentFrameEntities = new Set(this.currentFrameEntityToPointers.keys());
            // Filter preserves z order
            const entitiesWithEvents = entities.filter((e)=>lastFrameEntities.has(e.id) || currentFrameEntities.has(e.id));
            let lastMovePerPointer;
            let lastUpPerPointer;
            let lastDownPerPointer;
            // Dispatch events in entity z order
            for (const entity of entitiesWithEvents){
                lastDownPerPointer = this._processDownAndEmit(entity);
                lastUpPerPointer = this._processUpAndEmit(entity);
                lastMovePerPointer = this._processMoveAndEmit(entity);
                const lastUpDownMoveEvents = [
                    ...lastMovePerPointer.values(),
                    ...lastDownPerPointer.values(),
                    ...lastUpPerPointer.values()
                ];
                this._processEnterLeaveAndEmit(entity, lastUpDownMoveEvents);
                this._processCancelAndEmit(entity);
                this._processWheelAndEmit(entity);
            }
        }
    }
    class ActionsSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._actions = [];
            this.query = this.world.query([
                ActionsComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>this._actions.push(e.get(ActionsComponent)));
            this.query.entityRemoved$.subscribe((e)=>{
                const action = e.get(ActionsComponent);
                const index = this._actions.indexOf(action);
                if (index > -1) this._actions.splice(index, 1);
            });
        }
        update(delta) {
            for (const actions of this._actions)actions.update(delta);
        }
    }
    class IsometricEntityComponent extends Component {
        /**
     * Specify the isometric map to use to position this entity's z-index
     * @param mapOrOptions
     */ constructor(mapOrOptions){
            super();
            /**
         * Vertical "height" in the isometric world
         */ this.elevation = 0;
            this.columns = mapOrOptions.columns;
            this.rows = mapOrOptions.rows;
            this.tileWidth = mapOrOptions.tileWidth;
            this.tileHeight = mapOrOptions.tileHeight;
        }
    }
    class IsometricEntitySystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Lower;
            this.query = this.world.query([
                TransformComponent,
                IsometricEntityComponent
            ]);
        }
        update() {
            let transform;
            let iso;
            for (const entity of this.query.entities){
                transform = entity.get(TransformComponent);
                iso = entity.get(IsometricEntityComponent);
                const maxZindexPerElevation = Math.max(iso.columns * iso.tileWidth, iso.rows * iso.tileHeight);
                const newZ = maxZindexPerElevation * iso.elevation + transform.pos.y;
                transform.z = newZ;
            }
        }
    }
    class OffscreenSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Higher;
            this.query = this.world.query([
                TransformComponent,
                GraphicsComponent
            ]);
        }
        initialize(world, scene) {
            this._camera = scene.camera;
            this._screen = scene.engine.screen;
        }
        update() {
            this._worldBounds = this._screen.getWorldBounds();
            let transform;
            let graphics;
            let maybeParallax;
            for (const entity of this.query.entities){
                graphics = entity.get(GraphicsComponent);
                transform = entity.get(TransformComponent);
                maybeParallax = entity.get(ParallaxComponent);
                let parallaxOffset;
                if (maybeParallax) {
                    // We use the Tiled formula
                    // https://doc.mapeditor.org/en/latest/manual/layers/#parallax-scrolling-factor
                    // cameraPos * (1 - parallaxFactor)
                    const oneMinusFactor = Vector.One.sub(maybeParallax.parallaxFactor);
                    parallaxOffset = this._camera.pos.scale(oneMinusFactor);
                }
                // Figure out if entities are offscreen
                const entityOffscreen = this._isOffscreen(transform, graphics, parallaxOffset);
                if (entityOffscreen && !entity.hasTag("ex.offscreen")) {
                    entity.events.emit("exitviewport", new ExitViewPortEvent(entity));
                    entity.addTag("ex.offscreen");
                }
                if (!entityOffscreen && entity.hasTag("ex.offscreen")) {
                    entity.events.emit("enterviewport", new EnterViewPortEvent(entity));
                    entity.removeTag("ex.offscreen");
                }
            }
        }
        _isOffscreen(transform, graphics, parallaxOffset) {
            if (transform.coordPlane === CoordPlane.World) {
                let bounds = graphics.localBounds;
                if (parallaxOffset) bounds = bounds.translate(parallaxOffset);
                const transformedBounds = bounds.transform(transform.get().matrix);
                const graphicsOffscreen = !this._worldBounds.overlaps(transformedBounds);
                return graphicsOffscreen;
            } else // TODO screen coordinates
            return false;
        }
    }
    class PhysicsWorld {
        get config() {
            return watchDeep(this._config, (change)=>{
                this.$configUpdate.notifyAll(change);
            });
        }
        set config(newConfig) {
            this._config = newConfig;
            this.$configUpdate.notifyAll(newConfig);
        }
        /**
     * Spatial data structure for locating potential collision pairs and ray casts
     */ get collisionProcessor() {
            if (this._configDirty) {
                this._configDirty = false;
                // preserve tracked colliders if config updates
                const colliders = this._collisionProcessor.getColliders();
                this._collisionProcessor = new DynamicTreeCollisionProcessor(this._config);
                for (const collider of colliders)this._collisionProcessor.track(collider);
            }
            return this._collisionProcessor;
        }
        constructor(config){
            this.$configUpdate = new Observable;
            this._configDirty = false;
            this.config = config;
            this.$configUpdate.subscribe((config)=>{
                this._configDirty = true;
                BodyComponent.updateDefaultPhysicsConfig(config.bodies);
            });
            this._collisionProcessor = new DynamicTreeCollisionProcessor(this.config);
        }
        /**
     * Raycast into the scene's physics world
     * @param ray
     * @param options
     */ rayCast(ray, options) {
            return this.collisionProcessor.rayCast(ray, options);
        }
    }
    const GamepadEvents = {
        GamepadConnect: "connect",
        GamepadDisconnect: "disconnect",
        GamepadButton: "button",
        GamepadAxis: "axis"
    };
    /**
 * Excalibur leverages the HTML5 Gamepad API [where it is supported](http://caniuse.com/#feat=gamepad)
 * to provide controller support for your games.
 */ class Gamepads {
        constructor(){
            this.events = new EventEmitter();
            /**
         * Whether or not to poll for Gamepad input (default: `false`)
         */ this.enabled = false;
            /**
         * Whether or not Gamepad API is supported
         */ this.supported = !!navigator.getGamepads;
            this._gamePadTimeStamps = [
                0,
                0,
                0,
                0
            ];
            this._oldPads = [];
            this._pads = [];
            this._initSuccess = false;
            this._navigator = navigator;
            this._minimumConfiguration = null;
            this._enabled = true;
        }
        init() {
            if (!this.supported) return;
            if (this._initSuccess) return;
            // In Chrome, this will return 4 undefined items until a button is pressed
            // In FF, this will not return any items until a button is pressed
            this._oldPads = this._clonePads(this._navigator.getGamepads());
            if (this._oldPads.length && this._oldPads[0]) this._initSuccess = true;
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        /**
     * Sets the minimum gamepad configuration, for example {axis: 4, buttons: 4} means
     * this game requires at minimum 4 axis inputs and 4 buttons, this is not restrictive
     * all other controllers with more axis or buttons are valid as well. If no minimum
     * configuration is set all pads are valid.
     */ setMinimumGamepadConfiguration(config) {
            this._enableAndUpdate(); // if config is used, implicitly enable
            this._minimumConfiguration = config;
        }
        /**
     * When implicitly enabled, set the enabled flag and run an update so information is updated
     */ _enableAndUpdate() {
            if (!this.enabled) {
                this.enabled = true;
                this.update();
            }
        }
        /**
     * Checks a navigator gamepad against the minimum configuration if present.
     */ _isGamepadValid(pad) {
            if (!this._minimumConfiguration) return true;
            if (!pad) return false;
            const axesLength = pad.axes.filter((value)=>{
                return true;
            }).length;
            const buttonLength = pad.buttons.filter((value)=>{
                return true;
            }).length;
            return axesLength >= this._minimumConfiguration.axis && buttonLength >= this._minimumConfiguration.buttons && pad.connected;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            this._enableAndUpdate(); // implicitly enable
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this._enableAndUpdate(); // implicitly enable
            this.events.off(eventName, handler);
        }
        /**
     * Updates Gamepad state and publishes Gamepad events
     */ update() {
            if (!this.enabled || !this.supported) return;
            if (!this._enabled) return;
            this.init();
            const gamepads = this._navigator.getGamepads();
            for(let i = 0; i < gamepads.length; i++){
                if (!gamepads[i]) {
                    const gamepad = this.at(i);
                    // If was connected, but now isn't emit the disconnect event
                    if (gamepad.connected) this.events.emit("disconnect", new GamepadDisconnectEvent(i, gamepad));
                    // Reset connection status
                    gamepad.connected = false;
                    continue;
                } else {
                    if (!this.at(i).connected && this._isGamepadValid(gamepads[i])) this.events.emit("connect", new GamepadConnectEvent(i, this.at(i)));
                    // Set connection status
                    this.at(i).connected = true;
                }
                this.at(i).update();
                // Only supported in Chrome
                if (gamepads[i].timestamp && gamepads[i].timestamp === this._gamePadTimeStamps[i]) continue;
                this._gamePadTimeStamps[i] = gamepads[i].timestamp;
                // Add reference to navigator gamepad
                this.at(i).navigatorGamepad = gamepads[i];
                // Buttons
                let b, bi, a, ai, value;
                for(b in Buttons){
                    bi = Buttons[b];
                    if (typeof bi === "number") {
                        if (gamepads[i].buttons[bi]) {
                            value = gamepads[i].buttons[bi].value;
                            if (value !== this._oldPads[i].getButton(bi)) {
                                if (gamepads[i].buttons[bi].pressed) {
                                    this.at(i).updateButton(bi, value);
                                    this.at(i).events.emit("button", new GamepadButtonEvent(bi, value, this.at(i)));
                                } else this.at(i).updateButton(bi, 0);
                            }
                        }
                    }
                }
                // Axes
                for(a in Axes){
                    ai = Axes[a];
                    if (typeof ai === "number") {
                        value = gamepads[i].axes[ai];
                        if (value !== this._oldPads[i].getAxes(ai)) {
                            this.at(i).updateAxes(ai, value);
                            this.at(i).events.emit("axis", new GamepadAxisEvent(ai, value, this.at(i)));
                        }
                    }
                }
                this._oldPads[i] = this._clonePad(gamepads[i]);
            }
        }
        /**
     * Safely retrieves a Gamepad at a specific index and creates one if it doesn't yet exist
     */ at(index) {
            this._enableAndUpdate(); // implicitly enable gamepads when at() is called
            if (index >= this._pads.length) // Ensure there is a pad to retrieve
            for(let i = this._pads.length - 1, max = index; i < max; i++){
                this._pads.push(new Gamepad());
                this._oldPads.push(new Gamepad());
            }
            return this._pads[index];
        }
        /**
     * Returns a list of all valid gamepads that meet the minimum configuration requirement.
     */ getValidGamepads() {
            this._enableAndUpdate();
            const result = [];
            for(let i = 0; i < this._pads.length; i++)if (this._isGamepadValid(this.at(i).navigatorGamepad) && this.at(i).connected) result.push(this.at(i));
            return result;
        }
        /**
     * Gets the number of connected gamepads
     */ count() {
            return this._pads.filter((p)=>p.connected).length;
        }
        _clonePads(pads) {
            const arr = [];
            for(let i = 0, len = pads.length; i < len; i++)arr.push(this._clonePad(pads[i]));
            return arr;
        }
        /**
     * Fastest way to clone a known object is to do it yourself
     */ _clonePad(pad) {
            let i, len;
            const clonedPad = new Gamepad();
            if (!pad) return clonedPad;
            for(i = 0, len = pad.buttons.length; i < len; i++)if (pad.buttons[i]) clonedPad.updateButton(i, pad.buttons[i].value);
            for(i = 0, len = pad.axes.length; i < len; i++)clonedPad.updateAxes(i, pad.axes[i]);
            return clonedPad;
        }
    }
    /**
 * The minimum value an axis has to move before considering it a change
 */ Gamepads.MinAxisMoveThreshold = 0.05;
    /**
 * Gamepad holds state information for a connected controller. See [[Gamepads]]
 * for more information on handling controller input.
 */ class Gamepad {
        constructor(){
            this.events = new EventEmitter();
            this.connected = false;
            this._axes = new Array(4);
            this._buttons = new Array(16);
            this._buttonsUp = new Array(16);
            this._buttonsDown = new Array(16);
            for(let i = 0; i < this._buttons.length; i++)this._buttons[i] = 0;
            for(let i = 0; i < this._axes.length; i++)this._axes[i] = 0;
        }
        update() {
            // Reset buttonsDown and buttonsUp after update is complete
            this._buttonsDown = new Array(16);
            this._buttonsUp = new Array(16);
        }
        /**
     * Whether or not the given button is pressed
     * @deprecated will be removed in v0.28.0. Use isButtonHeld instead
     * @param button     The button to query
     * @param threshold  The threshold over which the button is considered to be pressed
     */ isButtonPressed(button, threshold = 1) {
            return this._buttons[button] >= threshold;
        }
        /**
     * Tests if a certain button is held down. This is persisted between frames.
     * @param button     The button to query
     * @param threshold  The threshold over which the button is considered to be pressed
     */ isButtonHeld(button, threshold = 1) {
            return this._buttons[button] >= threshold;
        }
        /**
     * Tests if a certain button was just pressed this frame. This is cleared at the end of the update frame.
     * @param button Test whether a button was just pressed
     * @param threshold  The threshold over which the button is considered to be pressed
     */ wasButtonPressed(button, threshold = 1) {
            return this._buttonsDown[button] >= threshold;
        }
        /**
     * Tests if a certain button was just released this frame. This is cleared at the end of the update frame.
     * @param button  Test whether a button was just released
     */ wasButtonReleased(button) {
            return Boolean(this._buttonsUp[button]);
        }
        /**
     * Gets the given button value between 0 and 1
     */ getButton(button) {
            return this._buttons[button];
        }
        /**
     * Gets the given axis value between -1 and 1. Values below
     * [[MinAxisMoveThreshold]] are considered 0.
     */ getAxes(axes) {
            const value = this._axes[axes];
            if (Math.abs(value) < Gamepads.MinAxisMoveThreshold) return 0;
            else return value;
        }
        updateButton(buttonIndex, value) {
            // button was just released
            if (value === 0 && this._buttons[buttonIndex]) this._buttonsUp[buttonIndex] = 1;
            else this._buttonsDown[buttonIndex] = value;
            this._buttons[buttonIndex] = value;
        }
        updateAxes(axesIndex, value) {
            this._axes[axesIndex] = value;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    /**
 * Gamepad Buttons enumeration
 */ var Buttons;
    (function(Buttons) {
        /**
     * Face 1 button (e.g. A)
     */ Buttons[Buttons["Face1"] = 0] = "Face1";
        /**
     * Face 2 button (e.g. B)
     */ Buttons[Buttons["Face2"] = 1] = "Face2";
        /**
     * Face 3 button (e.g. X)
     */ Buttons[Buttons["Face3"] = 2] = "Face3";
        /**
     * Face 4 button (e.g. Y)
     */ Buttons[Buttons["Face4"] = 3] = "Face4";
        /**
     * Left bumper button
     */ Buttons[Buttons["LeftBumper"] = 4] = "LeftBumper";
        /**
     * Right bumper button
     */ Buttons[Buttons["RightBumper"] = 5] = "RightBumper";
        /**
     * Left trigger button
     */ Buttons[Buttons["LeftTrigger"] = 6] = "LeftTrigger";
        /**
     * Right trigger button
     */ Buttons[Buttons["RightTrigger"] = 7] = "RightTrigger";
        /**
     * Select button
     */ Buttons[Buttons["Select"] = 8] = "Select";
        /**
     * Start button
     */ Buttons[Buttons["Start"] = 9] = "Start";
        /**
     * Left analog stick press (e.g. L3)
     */ Buttons[Buttons["LeftStick"] = 10] = "LeftStick";
        /**
     * Right analog stick press (e.g. R3)
     */ Buttons[Buttons["RightStick"] = 11] = "RightStick";
        /**
     * D-pad up
     */ Buttons[Buttons["DpadUp"] = 12] = "DpadUp";
        /**
     * D-pad down
     */ Buttons[Buttons["DpadDown"] = 13] = "DpadDown";
        /**
     * D-pad left
     */ Buttons[Buttons["DpadLeft"] = 14] = "DpadLeft";
        /**
     * D-pad right
     */ Buttons[Buttons["DpadRight"] = 15] = "DpadRight";
    })(Buttons || (Buttons = {}));
    /**
 * Gamepad Axes enumeration
 */ var Axes;
    (function(Axes) {
        /**
     * Left analogue stick X direction
     */ Axes[Axes["LeftStickX"] = 0] = "LeftStickX";
        /**
     * Left analogue stick Y direction
     */ Axes[Axes["LeftStickY"] = 1] = "LeftStickY";
        /**
     * Right analogue stick X direction
     */ Axes[Axes["RightStickX"] = 2] = "RightStickX";
        /**
     * Right analogue stick Y direction
     */ Axes[Axes["RightStickY"] = 3] = "RightStickY";
    })(Axes || (Axes = {}));
    /**
 * This allows you to map multiple inputs to specific commands! This is especially useful when
 * you need to allow multiple input sources to control a specific action.
 */ class InputMapper {
        constructor(inputs){
            this.inputs = inputs;
            this._handlers = new Map();
        }
        /**
     * Executes the input map, called internally by Excalibur
     */ execute() {
            for (const [input, command] of this._handlers.entries()){
                const results = input(this.inputs);
                if (results) command(results);
            }
        }
        /**
     * This allows you to map multiple inputs to specific commands! This is useful
     *
     * The inputHandler should return a truthy value if you wish the commandHandler to fire.
     *
     * Example:
     * ```typescript
     * const moveRight = (amount: number) => { actor.vel.x = 100 * amount }
     * const moveLeft = (amount: number) => { actor.vel.x = -100 * amount }
     * const moveUp = (amount: number) => { actor.vel.y = -100 * amount }
     * const moveDown = (amount: number) => { actor.vel.y = 100 * amount }
     *
     * engine.inputMapper.on(({keyboard}) => keyboard.isHeld(ex.Keys.ArrowRight) ? 1 : 0, moveRight);
     * engine.inputMapper.on(({gamepads}) => gamepads.at(0).isButtonPressed(ex.Buttons.DpadRight) ? 1 : 0, moveRight);
     * engine.inputMapper.on(({gamepads}) => gamepads.at(0).getAxes(ex.Axes.LeftStickX) > 0 ?
     *  gamepads.at(0).getAxes(ex.Axes.LeftStickX) : 0, moveRight);
     * ```
     * @param inputHandler
     * @param commandHandler
     */ on(inputHandler, commandHandler) {
            this._handlers.set(inputHandler, commandHandler);
        }
    }
    /**
 * Checks if excalibur is in a x-origin iframe
 */ function isCrossOriginIframe() {
        try {
            // Try and listen to events on top window frame if within an iframe.
            //
            // See https://github.com/excaliburjs/Excalibur/issues/1294
            //
            // Attempt to add an event listener, which triggers a DOMException on
            // cross-origin iframes
            const noop = ()=>{
                return;
            };
            window.top.addEventListener("blur", noop);
            window.top.removeEventListener("blur", noop);
        } catch (_a) {
            return true;
        }
        return false;
    }
    /**
 * Enum representing physical input key codes
 */ var Keys;
    (function(Keys) {
        // NUMPAD
        Keys["Num0"] = "Numpad0";
        Keys["Num1"] = "Numpad1";
        Keys["Num2"] = "Numpad2";
        Keys["Num3"] = "Numpad3";
        Keys["Num4"] = "Numpad4";
        Keys["Num5"] = "Numpad5";
        Keys["Num6"] = "Numpad6";
        Keys["Num7"] = "Numpad7";
        Keys["Num8"] = "Numpad8";
        Keys["Num9"] = "Numpad9";
        Keys["NumAdd"] = "NumpadAdd";
        Keys["NumSubtract"] = "NumpadSubtract";
        Keys["NumMultiply"] = "NumpadMultiply";
        Keys["NumDivide"] = "NumpadDivide";
        // NumComma = 'NumpadComma', // not x-browser
        Keys["NumDecimal"] = "NumpadDecimal";
        Keys["Numpad0"] = "Numpad0";
        Keys["Numpad1"] = "Numpad1";
        Keys["Numpad2"] = "Numpad2";
        Keys["Numpad3"] = "Numpad3";
        Keys["Numpad4"] = "Numpad4";
        Keys["Numpad5"] = "Numpad5";
        Keys["Numpad6"] = "Numpad6";
        Keys["Numpad7"] = "Numpad7";
        Keys["Numpad8"] = "Numpad8";
        Keys["Numpad9"] = "Numpad9";
        Keys["NumpadAdd"] = "NumpadAdd";
        Keys["NumpadSubtract"] = "NumpadSubtract";
        Keys["NumpadMultiply"] = "NumpadMultiply";
        Keys["NumpadDivide"] = "NumpadDivide";
        // NumpadComma = 'NumpadComma', // not x-browser
        Keys["NumpadDecimal"] = "NumpadDecimal";
        // MODIFIERS
        Keys["NumLock"] = "NumLock";
        Keys["ShiftLeft"] = "ShiftLeft";
        Keys["ShiftRight"] = "ShiftRight";
        Keys["AltLeft"] = "AltLeft";
        Keys["AltRight"] = "AltRight";
        Keys["ControlLeft"] = "ControlLeft";
        Keys["ControlRight"] = "ControlRight";
        Keys["MetaLeft"] = "MetaLeft";
        Keys["MetaRight"] = "MetaRight";
        // NUMBERS
        Keys["Key0"] = "Digit0";
        Keys["Key1"] = "Digit1";
        Keys["Key2"] = "Digit2";
        Keys["Key3"] = "Digit3";
        Keys["Key4"] = "Digit4";
        Keys["Key5"] = "Digit5";
        Keys["Key6"] = "Digit6";
        Keys["Key7"] = "Digit7";
        Keys["Key8"] = "Digit8";
        Keys["Key9"] = "Digit9";
        Keys["Digit0"] = "Digit0";
        Keys["Digit1"] = "Digit1";
        Keys["Digit2"] = "Digit2";
        Keys["Digit3"] = "Digit3";
        Keys["Digit4"] = "Digit4";
        Keys["Digit5"] = "Digit5";
        Keys["Digit6"] = "Digit6";
        Keys["Digit7"] = "Digit7";
        Keys["Digit8"] = "Digit8";
        Keys["Digit9"] = "Digit9";
        // FUNCTION KEYS
        Keys["F1"] = "F1";
        Keys["F2"] = "F2";
        Keys["F3"] = "F3";
        Keys["F4"] = "F4";
        Keys["F5"] = "F5";
        Keys["F6"] = "F6";
        Keys["F7"] = "F7";
        Keys["F8"] = "F8";
        Keys["F9"] = "F9";
        Keys["F10"] = "F10";
        Keys["F11"] = "F11";
        Keys["F12"] = "F12";
        // LETTERS
        Keys["A"] = "KeyA";
        Keys["B"] = "KeyB";
        Keys["C"] = "KeyC";
        Keys["D"] = "KeyD";
        Keys["E"] = "KeyE";
        Keys["F"] = "KeyF";
        Keys["G"] = "KeyG";
        Keys["H"] = "KeyH";
        Keys["I"] = "KeyI";
        Keys["J"] = "KeyJ";
        Keys["K"] = "KeyK";
        Keys["L"] = "KeyL";
        Keys["M"] = "KeyM";
        Keys["N"] = "KeyN";
        Keys["O"] = "KeyO";
        Keys["P"] = "KeyP";
        Keys["Q"] = "KeyQ";
        Keys["R"] = "KeyR";
        Keys["S"] = "KeyS";
        Keys["T"] = "KeyT";
        Keys["U"] = "KeyU";
        Keys["V"] = "KeyV";
        Keys["W"] = "KeyW";
        Keys["X"] = "KeyX";
        Keys["Y"] = "KeyY";
        Keys["Z"] = "KeyZ";
        Keys["KeyA"] = "KeyA";
        Keys["KeyB"] = "KeyB";
        Keys["KeyC"] = "KeyC";
        Keys["KeyD"] = "KeyD";
        Keys["KeyE"] = "KeyE";
        Keys["KeyF"] = "KeyF";
        Keys["KeyG"] = "KeyG";
        Keys["KeyH"] = "KeyH";
        Keys["KeyI"] = "KeyI";
        Keys["KeyJ"] = "KeyJ";
        Keys["KeyK"] = "KeyK";
        Keys["KeyL"] = "KeyL";
        Keys["KeyM"] = "KeyM";
        Keys["KeyN"] = "KeyN";
        Keys["KeyO"] = "KeyO";
        Keys["KeyP"] = "KeyP";
        Keys["KeyQ"] = "KeyQ";
        Keys["KeyR"] = "KeyR";
        Keys["KeyS"] = "KeyS";
        Keys["KeyT"] = "KeyT";
        Keys["KeyU"] = "KeyU";
        Keys["KeyV"] = "KeyV";
        Keys["KeyW"] = "KeyW";
        Keys["KeyX"] = "KeyX";
        Keys["KeyY"] = "KeyY";
        Keys["KeyZ"] = "KeyZ";
        // SYMBOLS
        Keys["Semicolon"] = "Semicolon";
        Keys["Quote"] = "Quote";
        Keys["Comma"] = "Comma";
        Keys["Minus"] = "Minus";
        Keys["Period"] = "Period";
        Keys["Slash"] = "Slash";
        Keys["Equal"] = "Equal";
        Keys["BracketLeft"] = "BracketLeft";
        Keys["Backslash"] = "Backslash";
        Keys["BracketRight"] = "BracketRight";
        Keys["Backquote"] = "Backquote";
        // DIRECTIONS
        Keys["Up"] = "ArrowUp";
        Keys["Down"] = "ArrowDown";
        Keys["Left"] = "ArrowLeft";
        Keys["Right"] = "ArrowRight";
        Keys["ArrowUp"] = "ArrowUp";
        Keys["ArrowDown"] = "ArrowDown";
        Keys["ArrowLeft"] = "ArrowLeft";
        Keys["ArrowRight"] = "ArrowRight";
        // OTHER
        Keys["Space"] = "Space";
        Keys["Backspace"] = "Backspace";
        Keys["Delete"] = "Delete";
        Keys["Esc"] = "Escape";
        Keys["Escape"] = "Escape";
        Keys["Enter"] = "Enter";
        Keys["NumpadEnter"] = "NumpadEnter";
        Keys["ContextMenu"] = "ContextMenu";
    })(Keys || (Keys = {}));
    /**
 * Event thrown on a game object for a key event
 */ class KeyEvent extends GameEvent {
        /**
     * @param key  The key responsible for throwing the event
     * @param value The key's typed value the browser detected
     * @param originalEvent The original keyboard event that Excalibur handled
     */ constructor(key, value, originalEvent){
            super();
            this.key = key;
            this.value = value;
            this.originalEvent = originalEvent;
        }
    }
    const KeyEvents = {
        Press: "press",
        Hold: "hold",
        Release: "release"
    };
    /**
 * Provides keyboard support for Excalibur.
 */ class Keyboard {
        constructor(){
            this.events = new EventEmitter();
            this._enabled = true;
            /**
         * Keys that are currently held down
         */ this._keys = [];
            /**
         * Keys up in the current frame
         */ this._keysUp = [];
            /**
         * Keys down in the current frame
         */ this._keysDown = [];
            this._releaseAllKeys = (ev)=>{
                for (const code of this._keys){
                    const keyEvent = new KeyEvent(code, ev.key, ev);
                    this.events.emit("up", keyEvent);
                    this.events.emit("release", keyEvent);
                }
                this._keysUp = Array.from(new Set(this._keys.concat(this._keysUp)));
                this._keys.length = 0;
            };
            this._handleKeyDown = (ev)=>{
                if (!this._enabled) return;
                // handle macos meta key issue
                // https://github.com/excaliburjs/Excalibur/issues/2608
                if (!ev.metaKey && (this._keys.includes(Keys.MetaLeft) || this._keys.includes(Keys.MetaRight))) this._releaseAllKeys(ev);
                const code = ev.code;
                if (this._keys.indexOf(code) === -1) {
                    this._keys.push(code);
                    this._keysDown.push(code);
                    const keyEvent = new KeyEvent(code, ev.key, ev);
                    this.events.emit("down", keyEvent);
                    this.events.emit("press", keyEvent);
                }
            };
            this._handleKeyUp = (ev)=>{
                if (!this._enabled) return;
                const code = ev.code;
                const key = this._keys.indexOf(code);
                this._keys.splice(key, 1);
                this._keysUp.push(code);
                const keyEvent = new KeyEvent(code, ev.key, ev);
                // alias the old api, we may want to deprecate this in the future
                this.events.emit("up", keyEvent);
                this.events.emit("release", keyEvent);
                // handle macos meta key issue
                // https://github.com/excaliburjs/Excalibur/issues/2608
                if (ev.key === "Meta") this._releaseAllKeys(ev);
            };
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Initialize Keyboard event listeners
     */ init(keyboardOptions) {
            let { global: global } = keyboardOptions;
            const { grabWindowFocus: grabWindowFocus } = keyboardOptions;
            if (!global) {
                if (isCrossOriginIframe()) {
                    global = window;
                    // Workaround for iframes like for itch.io or codesandbox
                    // https://www.reddit.com/r/gamemaker/comments/kfs5cs/keyboard_inputs_no_longer_working_in_html5_game/
                    // https://forum.gamemaker.io/index.php?threads/solved-keyboard-issue-on-itch-io.87336/
                    if (grabWindowFocus) window.focus();
                    Logger.getInstance().warn("Excalibur might be in a cross-origin iframe, in order to receive keyboard events it must be in focus");
                } else global = window.top;
            }
            global.addEventListener("blur", ()=>{
                this._keys.length = 0; // empties array efficiently
            });
            // key up is on window because canvas cannot have focus
            global.addEventListener("keyup", this._handleKeyUp);
            // key down is on window because canvas cannot have focus
            global.addEventListener("keydown", this._handleKeyDown);
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        update() {
            // Reset keysDown and keysUp after update is complete
            this._keysDown.length = 0;
            this._keysUp.length = 0;
            // Emit synthetic "hold" event
            for(let i = 0; i < this._keys.length; i++)this.events.emit("hold", new KeyEvent(this._keys[i]));
        }
        /**
     * Gets list of keys being pressed down
     */ getKeys() {
            return this._keys;
        }
        /**
     * Tests if a certain key was just pressed this frame. This is cleared at the end of the update frame.
     * @param key Test whether a key was just pressed
     */ wasPressed(key) {
            return this._keysDown.indexOf(key) > -1;
        }
        /**
     * Tests if a certain key is held down. This is persisted between frames.
     * @param key  Test whether a key is held down
     */ isHeld(key) {
            return this._keys.indexOf(key) > -1;
        }
        /**
     * Tests if a certain key was just released this frame. This is cleared at the end of the update frame.
     * @param key  Test whether a key was just released
     */ wasReleased(key) {
            return this._keysUp.indexOf(key) > -1;
        }
        /**
     * Trigger a manual key event
     * @param type
     * @param key
     * @param character
     */ triggerEvent(type, key, character) {
            if (type === "down") this._handleKeyDown(new KeyboardEvent("keydown", {
                code: key,
                key: character !== null && character !== void 0 ? character : null
            }));
            if (type === "up") this._handleKeyUp(new KeyboardEvent("keyup", {
                code: key,
                key: character !== null && character !== void 0 ? character : null
            }));
        }
    }
    class GlobalCoordinates {
        static fromPagePosition(xOrPos, yOrEngine, engineOrUndefined) {
            let pageX;
            let pageY;
            let pagePos;
            let engine;
            if (arguments.length === 3) {
                pageX = xOrPos;
                pageY = yOrEngine;
                pagePos = new Vector(pageX, pageY);
                engine = engineOrUndefined;
            } else {
                pagePos = xOrPos;
                pageX = pagePos.x;
                pageY = pagePos.y;
                engine = yOrEngine;
            }
            const screenPos = engine.screen.pageToScreenCoordinates(pagePos);
            const worldPos = engine.screen.screenToWorldCoordinates(screenPos);
            return new GlobalCoordinates(worldPos, pagePos, screenPos);
        }
        constructor(worldPos, pagePos, screenPos){
            this.worldPos = worldPos;
            this.pagePos = pagePos;
            this.screenPos = screenPos;
        }
    }
    class PointerEvent {
        cancel() {
            this.active = false;
        }
        get pagePos() {
            return this.coordinates.pagePos;
        }
        get screenPos() {
            return this.coordinates.screenPos;
        }
        get worldPos() {
            return this.coordinates.worldPos;
        }
        constructor(type, pointerId, button, pointerType, coordinates, nativeEvent){
            this.type = type;
            this.pointerId = pointerId;
            this.button = button;
            this.pointerType = pointerType;
            this.coordinates = coordinates;
            this.nativeEvent = nativeEvent;
            this.active = true;
        }
    }
    class WheelEvent {
        cancel() {
            this.active = false;
        }
        constructor(x, y, pageX, pageY, screenX, screenY, index, deltaX, deltaY, deltaZ, deltaMode, ev){
            this.x = x;
            this.y = y;
            this.pageX = pageX;
            this.pageY = pageY;
            this.screenX = screenX;
            this.screenY = screenY;
            this.index = index;
            this.deltaX = deltaX;
            this.deltaY = deltaY;
            this.deltaZ = deltaZ;
            this.deltaMode = deltaMode;
            this.ev = ev;
            this.active = true;
        }
    }
    class PointerAbstraction {
        constructor(){
            this.events = new EventEmitter();
            /**
         * The last position on the document this pointer was at. Can be `null` if pointer was never active.
         */ this.lastPagePos = Vector.Zero;
            /**
         * The last position on the screen this pointer was at. Can be `null` if pointer was never active.
         */ this.lastScreenPos = Vector.Zero;
            /**
         * The last position in the game world coordinates this pointer was at. Can be `null` if pointer was never active.
         */ this.lastWorldPos = Vector.Zero;
            this._onPointerMove = (ev)=>{
                this.lastPagePos = new Vector(ev.pagePos.x, ev.pagePos.y);
                this.lastScreenPos = new Vector(ev.screenPos.x, ev.screenPos.y);
                this.lastWorldPos = new Vector(ev.worldPos.x, ev.worldPos.y);
            };
            this._onPointerDown = (ev)=>{
                this.lastPagePos = new Vector(ev.pagePos.x, ev.pagePos.y);
                this.lastScreenPos = new Vector(ev.screenPos.x, ev.screenPos.y);
                this.lastWorldPos = new Vector(ev.worldPos.x, ev.worldPos.y);
            };
            this.on("move", this._onPointerMove);
            this.on("down", this._onPointerDown);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    var WheelDeltaMode;
    (function(WheelDeltaMode) {
        WheelDeltaMode["Pixel"] = "Pixel";
        WheelDeltaMode["Line"] = "Line";
        WheelDeltaMode["Page"] = "Page";
    })(WheelDeltaMode || (WheelDeltaMode = {}));
    /**
 * Native browser button enumeration
 */ var NativePointerButton;
    (function(NativePointerButton) {
        NativePointerButton[NativePointerButton["NoButton"] = -1] = "NoButton";
        NativePointerButton[NativePointerButton["Left"] = 0] = "Left";
        NativePointerButton[NativePointerButton["Middle"] = 1] = "Middle";
        NativePointerButton[NativePointerButton["Right"] = 2] = "Right";
        NativePointerButton[NativePointerButton["Unknown"] = 3] = "Unknown";
    })(NativePointerButton || (NativePointerButton = {}));
    /**
 * The mouse button being pressed.
 */ var PointerButton;
    (function(PointerButton) {
        PointerButton["Left"] = "Left";
        PointerButton["Middle"] = "Middle";
        PointerButton["Right"] = "Right";
        PointerButton["Unknown"] = "Unknown";
        PointerButton["NoButton"] = "NoButton";
    })(PointerButton || (PointerButton = {}));
    /**
 * The type of pointer for a [[PointerEvent]].
 */ var PointerType;
    (function(PointerType) {
        PointerType["Touch"] = "Touch";
        PointerType["Mouse"] = "Mouse";
        PointerType["Pen"] = "Pen";
        PointerType["Unknown"] = "Unknown";
    })(PointerType || (PointerType = {}));
    const PointerEvents = {
        Move: "move",
        Down: "down",
        Up: "up",
        Wheel: "wheel"
    };
    /**
 * Is this event a native touch event?
 */ function isTouchEvent(value) {
        // Guard for Safari <= 13.1
        return globalThis.TouchEvent && value instanceof globalThis.TouchEvent;
    }
    /**
 * Is this event a native pointer event
 */ function isPointerEvent(value) {
        // Guard for Safari <= 13.1
        return globalThis.PointerEvent && value instanceof globalThis.PointerEvent;
    }
    /**
 * The PointerEventProcessor is responsible for collecting all the events from the canvas and transforming them into GlobalCoordinates
 */ class PointerEventReceiver {
        constructor(target, engine){
            this.target = target;
            this.engine = engine;
            this.events = new EventEmitter();
            this.primary = new PointerAbstraction();
            this._activeNativePointerIdsToNormalized = new Map();
            this.lastFramePointerCoords = new Map();
            this.currentFramePointerCoords = new Map();
            this.currentFramePointerDown = new Map();
            this.lastFramePointerDown = new Map();
            this.currentFrameDown = [];
            this.currentFrameUp = [];
            this.currentFrameMove = [];
            this.currentFrameCancel = [];
            this.currentFrameWheel = [];
            this._enabled = true;
            this._pointers = [
                this.primary
            ];
            this._boundHandle = this._handle.bind(this);
            this._boundWheel = this._handleWheel.bind(this);
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        /**
     * Creates a new PointerEventReceiver with a new target and engine while preserving existing pointer event
     * handlers.
     * @param target
     * @param engine
     */ recreate(target, engine) {
            const eventReceiver = new PointerEventReceiver(target, engine);
            eventReceiver.primary = this.primary;
            eventReceiver._pointers = this._pointers;
            return eventReceiver;
        }
        /**
     * Locates a specific pointer by id, creates it if it doesn't exist
     * @param index
     */ at(index) {
            if (index >= this._pointers.length) // Ensure there is a pointer to retrieve
            for(let i = this._pointers.length - 1, max = index; i < max; i++)this._pointers.push(new PointerAbstraction());
            return this._pointers[index];
        }
        /**
     * The number of pointers currently being tracked by excalibur
     */ count() {
            return this._pointers.length;
        }
        /**
     * Is the specified pointer id down this frame
     * @param pointerId
     */ isDown(pointerId) {
            var _a;
            return (_a = this.currentFramePointerDown.get(pointerId)) !== null && _a !== void 0 ? _a : false;
        }
        /**
     * Was the specified pointer id down last frame
     * @param pointerId
     */ wasDown(pointerId) {
            var _a;
            return (_a = this.lastFramePointerDown.get(pointerId)) !== null && _a !== void 0 ? _a : false;
        }
        /**
     * Whether the Pointer is currently dragging.
     */ isDragging(pointerId) {
            return this.isDown(pointerId);
        }
        /**
     * Whether the Pointer just started dragging.
     */ isDragStart(pointerId) {
            return this.isDown(pointerId) && !this.wasDown(pointerId);
        }
        /**
     * Whether the Pointer just ended dragging.
     */ isDragEnd(pointerId) {
            return !this.isDown(pointerId) && this.wasDown(pointerId);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Called internally by excalibur
     *
     * Updates the current frame pointer info and emits raw pointer events
     *
     * This does not emit events to entities, see PointerSystem
     */ update() {
            this.lastFramePointerDown = new Map(this.currentFramePointerDown);
            this.lastFramePointerCoords = new Map(this.currentFramePointerCoords);
            for (const event of this.currentFrameDown){
                this.emit("down", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("down", event);
                this.primary.emit("pointerdown", event);
            }
            for (const event of this.currentFrameUp){
                this.emit("up", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("up", event);
            }
            for (const event of this.currentFrameMove){
                this.emit("move", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("move", event);
            }
            for (const event of this.currentFrameCancel){
                this.emit("cancel", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("cancel", event);
            }
            for (const event of this.currentFrameWheel){
                this.emit("wheel", event);
                this.primary.emit("pointerwheel", event);
                this.primary.emit("wheel", event);
            }
        }
        /**
     * Clears the current frame event and pointer data
     */ clear() {
            for (const event of this.currentFrameUp){
                this.currentFramePointerCoords.delete(event.pointerId);
                const ids = this._activeNativePointerIdsToNormalized.entries();
                for (const [native, normalized] of ids)if (normalized === event.pointerId) this._activeNativePointerIdsToNormalized.delete(native);
            }
            this.currentFrameDown.length = 0;
            this.currentFrameUp.length = 0;
            this.currentFrameMove.length = 0;
            this.currentFrameCancel.length = 0;
            this.currentFrameWheel.length = 0;
        }
        /**
     * Initializes the pointer event receiver so that it can start listening to native
     * browser events.
     */ init(options) {
            var _a;
            if (this.engine.isDisposed()) return;
            // Disabling the touch action avoids browser/platform gestures from firing on the canvas
            // It is important on mobile to have touch action 'none'
            // https://stackoverflow.com/questions/48124372/pointermove-event-not-working-with-touch-why-not
            if (this.target === this.engine.canvas) this.engine.canvas.style.touchAction = "none";
            else document.body.style.touchAction = "none";
            // Preferred pointer events
            if (window.PointerEvent) {
                this.target.addEventListener("pointerdown", this._boundHandle);
                this.target.addEventListener("pointerup", this._boundHandle);
                this.target.addEventListener("pointermove", this._boundHandle);
                this.target.addEventListener("pointercancel", this._boundHandle);
            } else {
                // Touch Events
                this.target.addEventListener("touchstart", this._boundHandle);
                this.target.addEventListener("touchend", this._boundHandle);
                this.target.addEventListener("touchmove", this._boundHandle);
                this.target.addEventListener("touchcancel", this._boundHandle);
                // Mouse Events
                this.target.addEventListener("mousedown", this._boundHandle);
                this.target.addEventListener("mouseup", this._boundHandle);
                this.target.addEventListener("mousemove", this._boundHandle);
            }
            // MDN MouseWheelEvent
            const wheelOptions = {
                passive: !(this.engine.pageScrollPreventionMode === ScrollPreventionMode.All || this.engine.pageScrollPreventionMode === ScrollPreventionMode.Canvas)
            };
            if ("onwheel" in document.createElement("div")) // Modern Browsers
            this.target.addEventListener("wheel", this._boundWheel, wheelOptions);
            else if (document.onmousewheel !== undefined) // Webkit and IE
            this.target.addEventListener("mousewheel", this._boundWheel, wheelOptions);
            else // Remaining browser and older Firefox
            this.target.addEventListener("MozMousePixelScroll", this._boundWheel, wheelOptions);
            const grabWindowFocus = (_a = options === null || options === void 0 ? void 0 : options.grabWindowFocus) !== null && _a !== void 0 ? _a : true;
            // Handle cross origin iframe
            if (grabWindowFocus && isCrossOriginIframe()) {
                const grabFocus = ()=>{
                    window.focus();
                };
                // Preferred pointer events
                if (window.PointerEvent) this.target.addEventListener("pointerdown", grabFocus);
                else {
                    // Touch Events
                    this.target.addEventListener("touchstart", grabFocus);
                    // Mouse Events
                    this.target.addEventListener("mousedown", grabFocus);
                }
            }
        }
        detach() {
            // Preferred pointer events
            if (window.PointerEvent) {
                this.target.removeEventListener("pointerdown", this._boundHandle);
                this.target.removeEventListener("pointerup", this._boundHandle);
                this.target.removeEventListener("pointermove", this._boundHandle);
                this.target.removeEventListener("pointercancel", this._boundHandle);
            } else {
                // Touch Events
                this.target.removeEventListener("touchstart", this._boundHandle);
                this.target.removeEventListener("touchend", this._boundHandle);
                this.target.removeEventListener("touchmove", this._boundHandle);
                this.target.removeEventListener("touchcancel", this._boundHandle);
                // Mouse Events
                this.target.removeEventListener("mousedown", this._boundHandle);
                this.target.removeEventListener("mouseup", this._boundHandle);
                this.target.removeEventListener("mousemove", this._boundHandle);
            }
            if ("onwheel" in document.createElement("div")) // Modern Browsers
            this.target.removeEventListener("wheel", this._boundWheel);
            else if (document.onmousewheel !== undefined) // Webkit and IE
            this.target.addEventListener("mousewheel", this._boundWheel);
            else // Remaining browser and older Firefox
            this.target.addEventListener("MozMousePixelScroll", this._boundWheel);
        }
        /**
     * Take native pointer id and map it to index in active pointers
     * @param nativePointerId
     */ _normalizePointerId(nativePointerId) {
            // Add to the the native pointer set id
            this._activeNativePointerIdsToNormalized.set(nativePointerId, -1);
            // Native pointer ids in ascending order
            const currentPointerIds = Array.from(this._activeNativePointerIdsToNormalized.keys()).sort((a, b)=>a - b);
            // The index into sorted ids will be the new id, will always have an id
            const id = currentPointerIds.findIndex((p)=>p === nativePointerId);
            // Save the mapping so we can reverse it later
            this._activeNativePointerIdsToNormalized.set(nativePointerId, id);
            // ignore pointer because game isn't watching
            return id;
        }
        /**
     * Responsible for handling and parsing pointer events
     */ _handle(ev) {
            if (!this._enabled) return;
            ev.preventDefault();
            const eventCoords = new Map();
            let button;
            let pointerType;
            if (isTouchEvent(ev)) {
                button = PointerButton.Unknown;
                pointerType = PointerType.Touch;
                // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
                for(let i = 0; i < ev.changedTouches.length; i++){
                    const touch = ev.changedTouches[i];
                    const coordinates = GlobalCoordinates.fromPagePosition(touch.pageX, touch.pageY, this.engine);
                    const nativePointerId = i + 1;
                    const pointerId = this._normalizePointerId(nativePointerId);
                    this.currentFramePointerCoords.set(pointerId, coordinates);
                    eventCoords.set(pointerId, coordinates);
                }
            } else {
                button = this._nativeButtonToPointerButton(ev.button);
                pointerType = PointerType.Mouse;
                const coordinates = GlobalCoordinates.fromPagePosition(ev.pageX, ev.pageY, this.engine);
                let nativePointerId = 1;
                if (isPointerEvent(ev)) {
                    nativePointerId = ev.pointerId;
                    pointerType = this._stringToPointerType(ev.pointerType);
                }
                const pointerId = this._normalizePointerId(nativePointerId);
                this.currentFramePointerCoords.set(pointerId, coordinates);
                eventCoords.set(pointerId, coordinates);
            }
            for (const [pointerId, coord] of eventCoords.entries())switch(ev.type){
                case "mousedown":
                case "pointerdown":
                case "touchstart":
                    this.currentFrameDown.push(new PointerEvent("down", pointerId, button, pointerType, coord, ev));
                    this.currentFramePointerDown.set(pointerId, true);
                    break;
                case "mouseup":
                case "pointerup":
                case "touchend":
                    this.currentFrameUp.push(new PointerEvent("up", pointerId, button, pointerType, coord, ev));
                    this.currentFramePointerDown.set(pointerId, false);
                    break;
                case "mousemove":
                case "pointermove":
                case "touchmove":
                    this.currentFrameMove.push(new PointerEvent("move", pointerId, button, pointerType, coord, ev));
                    break;
                case "touchcancel":
                case "pointercancel":
                    this.currentFrameCancel.push(new PointerEvent("cancel", pointerId, button, pointerType, coord, ev));
                    break;
            }
        }
        _handleWheel(ev) {
            if (!this._enabled) return;
            // Should we prevent page scroll because of this event
            if (this.engine.pageScrollPreventionMode === ScrollPreventionMode.All || this.engine.pageScrollPreventionMode === ScrollPreventionMode.Canvas && ev.target === this.engine.canvas) ev.preventDefault();
            const screen = this.engine.screen.pageToScreenCoordinates(vec(ev.pageX, ev.pageY));
            const world = this.engine.screen.screenToWorldCoordinates(screen);
            /**
         * A constant used to normalize wheel events across different browsers
         *
         * This normalization factor is pulled from
         * https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Listening_to_this_event_across_browser
         */ const ScrollWheelNormalizationFactor = -1 / 40;
            const deltaX = ev.deltaX || ev.wheelDeltaX * ScrollWheelNormalizationFactor || 0;
            const deltaY = ev.deltaY || ev.wheelDeltaY * ScrollWheelNormalizationFactor || ev.wheelDelta * ScrollWheelNormalizationFactor || ev.detail || 0;
            const deltaZ = ev.deltaZ || 0;
            let deltaMode = WheelDeltaMode.Pixel;
            if (ev.deltaMode) {
                if (ev.deltaMode === 1) deltaMode = WheelDeltaMode.Line;
                else if (ev.deltaMode === 2) deltaMode = WheelDeltaMode.Page;
            }
            const we = new WheelEvent(world.x, world.y, ev.pageX, ev.pageY, screen.x, screen.y, 0, deltaX, deltaY, deltaZ, deltaMode, ev);
            this.currentFrameWheel.push(we);
        }
        /**
     * Triggers an excalibur pointer event in a world space pos
     *
     * Useful for testing pointers in excalibur
     * @param type
     * @param pos
     */ triggerEvent(type, pos) {
            const page = this.engine.screen.worldToPageCoordinates(pos);
            // Send an event to the event receiver
            if (window.PointerEvent) this._handle(new window.PointerEvent("pointer" + type, {
                pointerId: 0,
                clientX: page.x,
                clientY: page.y
            }));
            else // Safari hack
            this._handle(new window.MouseEvent("mouse" + type, {
                clientX: page.x,
                clientY: page.y
            }));
            // Force update pointer system
            const pointerSystem = this.engine.currentScene.world.get(PointerSystem);
            pointerSystem.preupdate(this.engine.currentScene, 1);
            pointerSystem.update(1);
        }
        _nativeButtonToPointerButton(s) {
            switch(s){
                case NativePointerButton.NoButton:
                    return PointerButton.NoButton;
                case NativePointerButton.Left:
                    return PointerButton.Left;
                case NativePointerButton.Middle:
                    return PointerButton.Middle;
                case NativePointerButton.Right:
                    return PointerButton.Right;
                case NativePointerButton.Unknown:
                    return PointerButton.Unknown;
                default:
                    return fail(s);
            }
        }
        _stringToPointerType(s) {
            switch(s){
                case "touch":
                    return PointerType.Touch;
                case "mouse":
                    return PointerType.Mouse;
                case "pen":
                    return PointerType.Pen;
                default:
                    return PointerType.Unknown;
            }
        }
    }
    class InputHost {
        constructor(options){
            this._enabled = true;
            const { pointerTarget: pointerTarget, grabWindowFocus: grabWindowFocus, engine: engine } = options;
            this.keyboard = new Keyboard();
            this.pointers = new PointerEventReceiver(pointerTarget, engine);
            this.gamepads = new Gamepads();
            this.keyboard.init({
                grabWindowFocus: grabWindowFocus
            });
            this.pointers.init({
                grabWindowFocus: grabWindowFocus
            });
            this.gamepads.init();
            this.inputMapper = new InputMapper({
                keyboard: this.keyboard,
                pointers: this.pointers,
                gamepads: this.gamepads
            });
        }
        get enabled() {
            return this._enabled;
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
            this.keyboard.toggleEnabled(this._enabled);
            this.pointers.toggleEnabled(this._enabled);
            this.gamepads.toggleEnabled(this._enabled);
        }
        update() {
            if (this._enabled) {
                this.inputMapper.execute();
                this.keyboard.update();
                this.gamepads.update();
            }
        }
    }
    class PreLoadEvent {
    }
    const SceneEvents = {
        Initialize: "initialize",
        Activate: "activate",
        Deactivate: "deactivate",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PreDebugDraw: "predebugdraw",
        PostDebugDraw: "postdebugdraw",
        PreLoad: "preload"
    };
    /**
 *
 */ function isSceneConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    /**
 * [[Actor|Actors]] are composed together into groupings called Scenes in
 * Excalibur. The metaphor models the same idea behind real world
 * actors in a scene. Only actors in scenes will be updated and drawn.
 *
 * Typical usages of a scene include: levels, menus, loading screens, etc.
 */ class Scene {
        /**
     * The actors in the current scene
     */ get actors() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof Actor;
            });
        }
        /**
     * The entities in the current scene
     */ get entities() {
            return this.world.entityManager.entities;
        }
        /**
     * The triggers in the current scene
     */ get triggers() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof Trigger;
            });
        }
        /**
     * The [[TileMap]]s in the scene, if any
     */ get tileMaps() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof TileMap;
            });
        }
        get timers() {
            return this._timers;
        }
        constructor(){
            // Initialize systems
            this._logger = Logger.getInstance();
            this.events = new EventEmitter();
            /**
         * Gets or sets the current camera for the scene
         */ this.camera = new Camera();
            /**
         * The ECS world for the scene
         */ this.world = new World(this);
            /**
         * The Excalibur physics world for the scene. Used to interact
         * with colliders included in the scene.
         *
         * Can be used to perform scene ray casts, track colliders, broadphase, and narrowphase.
         */ this.physics = new PhysicsWorld(DefaultPhysicsConfig);
            this._isInitialized = false;
            this._timers = [];
            this._cancelQueue = [];
            // Update
            this.world.add(ActionsSystem);
            this.world.add(new MotionSystem(this.world, this.physics));
            this.world.add(new CollisionSystem(this.world, this.physics));
            this.world.add(PointerSystem);
            this.world.add(IsometricEntitySystem);
            // Draw
            this.world.add(OffscreenSystem);
            this.world.add(GraphicsSystem);
            this.world.add(DebugSystem);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Event hook to provide Scenes a way of loading scene specific resources.
     *
     * This is called before the Scene.onInitialize during scene transition. It will only ever fire once for a scene.
     * @param loader
     */ onPreLoad(loader) {
        // will be overridden
        }
        /**
     * Event hook fired directly before transition, either "in" or "out" of the scene
     *
     * This overrides the Engine scene definition. However transitions specified in goToScene take highest precedence
     *
     * ```typescript
     * // Overrides all
     * Engine.goToScene('scene', { destinationIn: ..., sourceOut: ... });
     * ```
     *
     * This can be used to configure custom transitions for a scene dynamically
     */ onTransition(direction) {
            // will be overridden
            return undefined;
        }
        /**
     * This is called before the first update of the [[Scene]]. Initializes scene members like the camera. This method is meant to be
     * overridden. This is where initialization of child actors should take place.
     */ onInitialize(engine) {
        // will be overridden
        }
        /**
     * This is called when the scene is made active and started. It is meant to be overridden,
     * this is where you should setup any DOM UI or event handlers needed for the scene.
     */ onActivate(context) {
        // will be overridden
        }
        /**
     * This is called when the scene is made transitioned away from and stopped. It is meant to be overridden,
     * this is where you should cleanup any DOM UI or event handlers needed for the scene.
     */ onDeactivate(context) {
        // will be overridden
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before a scene is updated.
     */ onPreUpdate(engine, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onPostUpdate(engine, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPreDraw lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreDraw` is called directly before a scene is drawn.
     *
     */ onPreDraw(ctx, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPostDraw lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostDraw` is called directly after a scene is drawn.
     *
     */ onPostDraw(ctx, delta) {
        // will be overridden
        }
        /**
     * Initializes actors in the scene
     */ _initializeChildren() {
            for (const child of this.entities)child._initialize(this.engine);
        }
        /**
     * Gets whether or not the [[Scene]] has been initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Initializes the scene before the first update, meant to be called by engine not by users of
     * Excalibur
     * @internal
     */ async _initialize(engine) {
            var _a;
            if (!this.isInitialized) {
                try {
                    this.engine = engine;
                    // PhysicsWorld config is watched so things will automagically update
                    this.physics.config = this.engine.physics;
                    this.input = new InputHost({
                        pointerTarget: engine.pointerScope === PointerScope.Canvas ? engine.canvas : document,
                        grabWindowFocus: engine.grabWindowFocus,
                        engine: engine
                    });
                    // Initialize camera first
                    this.camera._initialize(engine);
                    this.world.systemManager.initialize();
                    // This order is important! we want to be sure any custom init that add actors
                    // fire before the actor init
                    await this.onInitialize(engine);
                    this._initializeChildren();
                    this._logger.debug("Scene.onInitialize", this, engine);
                    this.events.emit("initialize", new InitializeEvent(engine, this));
                } catch (e) {
                    this._logger.error(`Error during scene initialization for scene ${(_a = engine.director) === null || _a === void 0 ? void 0 : _a.getSceneName(this)}!`);
                    throw e;
                }
                this._isInitialized = true;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Activates the scene with the base behavior, then calls the overridable `onActivate` implementation.
     * @internal
     */ async _activate(context) {
            var _a, _b;
            try {
                this._logger.debug("Scene.onActivate", this);
                this.input.toggleEnabled(true);
                await this.onActivate(context);
            } catch (e) {
                this._logger.error(`Error during scene activation for scene ${(_b = (_a = this.engine) === null || _a === void 0 ? void 0 : _a.director) === null || _b === void 0 ? void 0 : _b.getSceneName(this)}!`);
                throw e;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Deactivates the scene with the base behavior, then calls the overridable `onDeactivate` implementation.
     * @internal
     */ async _deactivate(context) {
            this._logger.debug("Scene.onDeactivate", this);
            this.input.toggleEnabled(false);
            await this.onDeactivate(context);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     *  It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _predraw handler for [[onPreDraw]] lifecycle event
     * @internal
     */ _predraw(ctx, delta) {
            this.emit("predraw", new PreDrawEvent(ctx, delta, this));
            this.onPreDraw(ctx, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _postdraw handler for [[onPostDraw]] lifecycle event
     * @internal
     */ _postdraw(ctx, delta) {
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
            this.onPostDraw(ctx, delta);
        }
        /**
     * Updates all the actors and timers in the scene. Called by the [[Engine]].
     * @param engine  Reference to the current Engine
     * @param delta   The number of milliseconds since the last update
     */ update(engine, delta) {
            var _a;
            if (!this.isInitialized) {
                this._logger.warnOnce(`Scene update called before initialize for scene ${(_a = engine.director) === null || _a === void 0 ? void 0 : _a.getSceneName(this)}!`);
                return;
            }
            this._preupdate(engine, delta);
            // TODO differed entity removal for timers
            let i, len;
            // Remove timers in the cancel queue before updating them
            for(i = 0, len = this._cancelQueue.length; i < len; i++)this.removeTimer(this._cancelQueue[i]);
            this._cancelQueue.length = 0;
            // Cycle through timers updating timers
            for (const timer of this._timers)timer.update(delta);
            this.world.update(SystemType.Update, delta);
            // Camera last keeps renders smooth that are based on entity/actor
            if (this.camera) this.camera.update(engine, delta);
            this._collectActorStats(engine);
            this._postupdate(engine, delta);
            this.input.update();
        }
        /**
     * Draws all the actors in the Scene. Called by the [[Engine]].
     * @param ctx    The current rendering context
     * @param delta  The number of milliseconds since the last draw
     */ draw(ctx, delta) {
            var _a;
            if (!this.isInitialized) {
                this._logger.warnOnce(`Scene draw called before initialize!`);
                return;
            }
            this._predraw(ctx, delta);
            this.world.update(SystemType.Draw, delta);
            if ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.isDebug) this.debugDraw(ctx);
            this._postdraw(ctx, delta);
        }
        /**
     * Draws all the actors' debug information in the Scene. Called by the [[Engine]].
     * @param ctx  The current rendering context
     */ /* istanbul ignore next */ debugDraw(ctx) {
            this.emit("predebugdraw", new PreDebugDrawEvent(ctx, this));
            // pass
            this.emit("postdebugdraw", new PostDebugDrawEvent(ctx, this));
        }
        /**
     * Checks whether an actor is contained in this scene or not
     */ contains(actor) {
            return this.actors.indexOf(actor) > -1;
        }
        add(entity) {
            this.emit("entityadded", {
                target: entity
            });
            this.world.add(entity);
            entity.scene = this;
            if (entity instanceof Timer) {
                if (!contains(this._timers, entity)) this.addTimer(entity);
                return;
            }
        }
        /**
     * Removes an [[Entity]] (Actor, TileMap, Trigger, etc) or [[Timer]] from it's current scene
     * and adds it to this scene.
     *
     * Useful if you want to have an object be present in only 1 scene at a time.
     * @param entity
     */ transfer(entity) {
            let scene;
            if (entity instanceof Entity && entity.scene && entity.scene !== this) {
                scene = entity.scene;
                entity.scene.world.remove(entity, false);
            }
            if (entity instanceof Timer && entity.scene) {
                scene = entity.scene;
                entity.scene.removeTimer(entity);
            }
            scene === null || scene === void 0 || scene.emit("entityremoved", {
                target: entity
            });
            this.add(entity);
        }
        remove(entity) {
            if (entity instanceof Entity) {
                this.emit("entityremoved", {
                    target: entity
                });
                if (entity.active) entity.kill();
                this.world.remove(entity);
            }
            if (entity instanceof Timer) this.removeTimer(entity);
        }
        /**
     * Removes all entities and timers from the scene, optionally indicate whether deferred should or shouldn't be used.
     *
     * By default entities use deferred removal
     * @param deferred
     */ clear(deferred = true) {
            for(let i = this.entities.length - 1; i >= 0; i--)this.world.remove(this.entities[i], deferred);
            for(let i = this.timers.length - 1; i >= 0; i--)this.removeTimer(this.timers[i]);
        }
        /**
     * Adds a [[Timer]] to the scene
     * @param timer  The timer to add
     */ addTimer(timer) {
            this._timers.push(timer);
            timer.scene = this;
            return timer;
        }
        /**
     * Removes a [[Timer]] from the scene.
     * @warning Can be dangerous, use [[cancelTimer]] instead
     * @param timer  The timer to remove
     */ removeTimer(timer) {
            const i = this._timers.indexOf(timer);
            if (i !== -1) this._timers.splice(i, 1);
            return timer;
        }
        /**
     * Cancels a [[Timer]], removing it from the scene nicely
     * @param timer  The timer to cancel
     */ cancelTimer(timer) {
            this._cancelQueue.push(timer);
            return timer;
        }
        /**
     * Tests whether a [[Timer]] is active in the scene
     */ isTimerActive(timer) {
            return this._timers.indexOf(timer) > -1 && !timer.complete;
        }
        isCurrentScene() {
            if (this.engine) return this.engine.currentScene === this;
            return false;
        }
        _collectActorStats(engine) {
            const screenElements = this.actors.filter((a)=>a instanceof ScreenElement);
            for (const _ui of screenElements)engine.stats.currFrame.actors.ui++;
            for (const actor of this.actors){
                engine.stats.currFrame.actors.alive++;
                for (const child of actor.children)if (isScreenElement(child)) // TODO not true
                engine.stats.currFrame.actors.ui++;
                else engine.stats.currFrame.actors.alive++;
            }
        }
    }
    var ColorBlindnessMode;
    (function(ColorBlindnessMode) {
        ColorBlindnessMode["Protanope"] = "Protanope";
        ColorBlindnessMode["Deuteranope"] = "Deuteranope";
        ColorBlindnessMode["Tritanope"] = "Tritanope";
    })(ColorBlindnessMode || (ColorBlindnessMode = {}));
    /* harmony default export */ const color_blind_fragment = "#version 300 es\r\nprecision mediump float;\r\n// our texture\r\nuniform sampler2D u_image;\r\n// the texCoords passed in from the vertex shader.\r\nin vec2 v_texcoord;\r\n\r\n// color blind type\r\nuniform int u_type;\r\n\r\n// simulation?\r\nuniform bool u_simulate;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  vec4 o =  texture(u_image, v_texcoord);\r\n  // RGB to LMS matrix conversion\r\n  float L = (17.8824 * o.r) + (43.5161 * o.g) + (4.11935 * o.b);\r\n  float M = (3.45565 * o.r) + (27.1554 * o.g) + (3.86714 * o.b);\r\n  float S = (0.0299566 * o.r) + (0.184309 * o.g) + (1.46709 * o.b);\r\n  // Simulate color blindness\r\n  float l;\r\n  float m;\r\n  float s;\r\n  //MODE CODE//\r\n  if (u_type == 0) {\r\n    // Protanope\r\n    l = 0.0 * L + 2.02344 * M + -2.52581 * S;\r\n    m = 0.0 * L + 1.0 * M + 0.0 * S;\r\n    s = 0.0 * L + 0.0 * M + 1.0 * S;;\r\n  } else if (u_type == 1) {\r\n    // Deuteranope\r\n    l = 1.0 * L + 0.0 * M + 0.0 * S;\r\n    m = 0.494207 * L + 0.0 * M + 1.24827 * S;\r\n    s = 0.0 * L + 0.0 * M + 1.0 * S;\r\n  } else if (u_type == 2) {\r\n    // Tritanope\r\n    l = 1.0 * L + 0.0 * M + 0.0 * S;\r\n    m = 0.0 * L + 1.0 * M + 0.0 * S;\r\n    s = -0.395913 * L + 0.801109 * M + 0.0 * S;\r\n  }\r\n\r\n  // LMS to RGB matrix conversion\r\n  vec4 error; // simulate the colors\r\n  error.r = (0.0809444479 * l) + (-0.130504409 * m) + (0.116721066 * s);\r\n  error.g = (-0.0102485335 * l) + (0.0540193266 * m) + (-0.113614708 * s);\r\n  error.b = (-0.000365296938 * l) + (-0.00412161469 * m) + (0.693511405 * s);\r\n  error.a = 1.0;\r\n  vec4 diff = o - error;\r\n  vec4 correction; // correct the colors\r\n  correction.r = 0.0;\r\n  correction.g =  (diff.r * 0.7) + (diff.g * 1.0);\r\n  correction.b =  (diff.r * 0.7) + (diff.b * 1.0);\r\n  correction = o + correction;\r\n  correction.a = o.a;\r\n  //SIMULATE//\r\n\r\n  // sim \r\n  if (u_simulate) {\r\n    fragColor = error.rgba;\r\n  } else {\r\n    fragColor = correction.rgba;\r\n  }\r\n}";
    /**
 * Helper that defines a whole screen renderer, just provide a fragment source!
 *
 * Currently supports 1 varying
 * - vec2 a_texcoord between 0-1 which corresponds to screen position
 */ class ScreenShader {
        constructor(gl, fragmentSource){
            this._shader = new Shader({
                gl: gl,
                vertexSource: `#version 300 es
      in vec2 a_position;
      in vec2 a_texcoord;
      out vec2 v_texcoord;

      void main() {
        gl_Position = vec4(a_position, 0.0, 1.0);
        // Pass the texcoord to the fragment shader.
        v_texcoord = a_texcoord;
      }`,
                fragmentSource: fragmentSource
            });
            this._shader.compile();
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                type: "static",
                // clip space quad + uv since we don't need a camera
                data: new Float32Array([
                    -1,
                    -1,
                    0,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    -1,
                    1,
                    0,
                    1,
                    -1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ])
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ]
                ]
            });
            this._buffer.upload();
        }
        getShader() {
            return this._shader;
        }
        getLayout() {
            return this._layout;
        }
    }
    class ColorBlindnessPostProcessor {
        constructor(_colorBlindnessMode, simulate = false){
            this._colorBlindnessMode = _colorBlindnessMode;
            this._simulate = false;
            this._simulate = simulate;
        }
        initialize(gl) {
            this._shader = new ScreenShader(gl, color_blind_fragment);
            this.simulate = this._simulate;
            this.colorBlindnessMode = this._colorBlindnessMode;
        }
        getShader() {
            return this._shader.getShader();
        }
        getLayout() {
            return this._shader.getLayout();
        }
        set colorBlindnessMode(colorBlindMode) {
            this._colorBlindnessMode = colorBlindMode;
            if (this._shader) {
                const shader = this._shader.getShader();
                shader.use();
                if (this._colorBlindnessMode === ColorBlindnessMode.Protanope) shader.setUniformInt("u_type", 0);
                else if (this._colorBlindnessMode === ColorBlindnessMode.Deuteranope) shader.setUniformInt("u_type", 1);
                else if (this._colorBlindnessMode === ColorBlindnessMode.Tritanope) shader.setUniformInt("u_type", 2);
            }
        }
        get colorBlindnessMode() {
            return this._colorBlindnessMode;
        }
        set simulate(value) {
            this._simulate = value;
            if (this._shader) {
                const shader = this._shader.getShader();
                shader.use();
                shader.setUniformBoolean("u_simulate", value);
            }
        }
        get simulate() {
            return this._simulate;
        }
    }
    class ColorBlindFlags {
        constructor(engine){
            this._engine = engine;
            this._colorBlindPostProcessor = new ColorBlindnessPostProcessor(ColorBlindnessMode.Protanope);
        }
        /**
     * Correct colors for a specified color blindness
     * @param colorBlindness
     */ correct(colorBlindness) {
            if (this._engine.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this.clear();
                this._colorBlindPostProcessor.colorBlindnessMode = colorBlindness;
                this._colorBlindPostProcessor.simulate = false;
                this._engine.graphicsContext.addPostProcessor(this._colorBlindPostProcessor);
            }
        }
        /**
     * Simulate colors for a specified color blindness
     * @param colorBlindness
     */ simulate(colorBlindness) {
            if (this._engine.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this.clear();
                this._colorBlindPostProcessor.colorBlindnessMode = colorBlindness;
                this._colorBlindPostProcessor.simulate = true;
                this._engine.graphicsContext.addPostProcessor(this._colorBlindPostProcessor);
            }
        }
        /**
     * Remove color blindness post processor
     */ clear() {
            this._engine.graphicsContext.removePostProcessor(this._colorBlindPostProcessor);
        }
    }
    /**
 * Debug statistics and flags for Excalibur. If polling these values, it would be
 * best to do so on the `postupdate` event for [[Engine]], after all values have been
 * updated during a frame.
 */ class DebugConfig {
        constructor(engine){
            /**
         * Performance statistics
         */ this.stats = {
                /**
             * Current frame statistics. Engine reuses this instance, use [[FrameStats.clone]] to copy frame stats.
             * Best accessed on [[postframe]] event. See [[FrameStats]]
             */ currFrame: new FrameStats(),
                /**
             * Previous frame statistics. Engine reuses this instance, use [[FrameStats.clone]] to copy frame stats.
             * Best accessed on [[preframe]] event. Best inspected on engine event `preframe`. See [[FrameStats]]
             */ prevFrame: new FrameStats()
            };
            /**
         * Filter debug context to named entities or entity ids
         */ this.filter = {
                /**
             * Toggle filter on or off (default off) must be on for DebugDraw to use filters
             */ useFilter: false,
                /**
             * Query for entities by name, if the entity name contains `nameQuery` it will be included
             */ nameQuery: "",
                /**
             * Query for Entity ids, if the id matches it will be included
             */ ids: []
            };
            /**
         * Entity debug settings
         */ this.entity = {
                showAll: false,
                showId: false,
                showName: false
            };
            /**
         * Transform component debug settings
         */ this.transform = {
                showAll: false,
                debugZIndex: 10000000,
                showPosition: false,
                showPositionLabel: false,
                positionColor: Color.Yellow,
                showZIndex: false,
                showScale: false,
                scaleColor: Color.Green,
                showRotation: false,
                rotationColor: Color.Blue
            };
            /**
         * Graphics component debug settings
         */ this.graphics = {
                showAll: false,
                showBounds: false,
                boundsColor: Color.Yellow
            };
            /**
         * Collider component debug settings
         */ this.collider = {
                showAll: false,
                showBounds: false,
                boundsColor: Color.Blue,
                showOwner: false,
                showGeometry: true,
                geometryColor: Color.Green,
                geometryLineWidth: 1,
                geometryPointSize: .5
            };
            /**
         * Physics simulation debug settings
         */ this.physics = {
                showAll: false,
                showBroadphaseSpacePartitionDebug: false,
                showCollisionNormals: false,
                collisionNormalColor: Color.Cyan,
                showCollisionContacts: true,
                contactSize: 2,
                collisionContactColor: Color.Red
            };
            /**
         * Motion component debug settings
         */ this.motion = {
                showAll: false,
                showVelocity: false,
                velocityColor: Color.Yellow,
                showAcceleration: false,
                accelerationColor: Color.Red
            };
            /**
         * Body component debug settings
         */ this.body = {
                showAll: false,
                showCollisionGroup: false,
                showCollisionType: false,
                showSleeping: false,
                showMotion: false,
                showMass: false
            };
            /**
         * Camera debug settings
         */ this.camera = {
                showAll: false,
                showFocus: false,
                focusColor: Color.Red,
                showZoom: false
            };
            this.tilemap = {
                showAll: false,
                showGrid: false,
                gridColor: Color.Red,
                gridWidth: .5,
                showSolidBounds: false,
                solidBoundsColor: Color.fromHex("#8080807F"),
                showColliderGeometry: true
            };
            this.isometric = {
                showAll: false,
                showPosition: false,
                positionColor: Color.Yellow,
                positionSize: 1,
                showGrid: false,
                gridColor: Color.Red,
                gridWidth: 1,
                showColliderGeometry: true
            };
            this._engine = engine;
            this.colorBlindMode = new ColorBlindFlags(this._engine);
        }
        /**
     * Switch the current excalibur clock with the [[TestClock]] and return
     * it in the same running state.
     *
     * This is useful when you need to debug frame by frame.
     */ useTestClock() {
            const clock = this._engine.clock;
            const wasRunning = clock.isRunning();
            clock.stop();
            const testClock = clock.toTestClock();
            if (wasRunning) testClock.start();
            this._engine.clock = testClock;
            return testClock;
        }
        /**
     * Switch the current excalibur clock with the [[StandardClock]] and
     * return it in the same running state.
     *
     * This is useful when you need to switch back to normal mode after
     * debugging.
     */ useStandardClock() {
            const currentClock = this._engine.clock;
            const wasRunning = currentClock.isRunning();
            currentClock.stop();
            const standardClock = currentClock.toStandardClock();
            if (wasRunning) standardClock.start();
            this._engine.clock = standardClock;
            return standardClock;
        }
    }
    /**
 * Implementation of a frame's stats. Meant to have values copied via [[FrameStats.reset]], avoid
 * creating instances of this every frame.
 */ class FrameStats {
        constructor(){
            this._id = 0;
            this._delta = 0;
            this._fps = 0;
            this._actorStats = {
                alive: 0,
                killed: 0,
                ui: 0,
                get remaining () {
                    return this.alive - this.killed;
                },
                get total () {
                    return this.remaining + this.ui;
                }
            };
            this._durationStats = {
                update: 0,
                draw: 0,
                get total () {
                    return this.update + this.draw;
                }
            };
            this._physicsStats = new PhysicsStats();
            this._graphicsStats = {
                drawCalls: 0,
                drawnImages: 0
            };
        }
        /**
     * Zero out values or clone other IFrameStat stats. Allows instance reuse.
     * @param [otherStats] Optional stats to clone
     */ reset(otherStats) {
            if (otherStats) {
                this.id = otherStats.id;
                this.delta = otherStats.delta;
                this.fps = otherStats.fps;
                this.actors.alive = otherStats.actors.alive;
                this.actors.killed = otherStats.actors.killed;
                this.actors.ui = otherStats.actors.ui;
                this.duration.update = otherStats.duration.update;
                this.duration.draw = otherStats.duration.draw;
                this._physicsStats.reset(otherStats.physics);
                this.graphics.drawCalls = otherStats.graphics.drawCalls;
                this.graphics.drawnImages = otherStats.graphics.drawnImages;
            } else {
                this.id = this.delta = this.fps = 0;
                this.actors.alive = this.actors.killed = this.actors.ui = 0;
                this.duration.update = this.duration.draw = 0;
                this._physicsStats.reset();
                this.graphics.drawnImages = this.graphics.drawCalls = 0;
            }
        }
        /**
     * Provides a clone of this instance.
     */ clone() {
            const fs = new FrameStats();
            fs.reset(this);
            return fs;
        }
        /**
     * Gets the frame's id
     */ get id() {
            return this._id;
        }
        /**
     * Sets the frame's id
     */ set id(value) {
            this._id = value;
        }
        /**
     * Gets the frame's delta (time since last frame)
     */ get delta() {
            return this._delta;
        }
        /**
     * Sets the frame's delta (time since last frame). Internal use only.
     * @internal
     */ set delta(value) {
            this._delta = value;
        }
        /**
     * Gets the frame's frames-per-second (FPS)
     */ get fps() {
            return this._fps;
        }
        /**
     * Sets the frame's frames-per-second (FPS). Internal use only.
     * @internal
     */ set fps(value) {
            this._fps = value;
        }
        /**
     * Gets the frame's actor statistics
     */ get actors() {
            return this._actorStats;
        }
        /**
     * Gets the frame's duration statistics
     */ get duration() {
            return this._durationStats;
        }
        /**
     * Gets the frame's physics statistics
     */ get physics() {
            return this._physicsStats;
        }
        /**
     * Gets the frame's graphics statistics
     */ get graphics() {
            return this._graphicsStats;
        }
    }
    class PhysicsStats {
        constructor(){
            this._pairs = 0;
            this._collisions = 0;
            this._contacts = new Map();
            this._fastBodies = 0;
            this._fastBodyCollisions = 0;
            this._broadphase = 0;
            this._narrowphase = 0;
        }
        /**
     * Zero out values or clone other IPhysicsStats stats. Allows instance reuse.
     * @param [otherStats] Optional stats to clone
     */ reset(otherStats) {
            if (otherStats) {
                this.pairs = otherStats.pairs;
                this.collisions = otherStats.collisions;
                this.contacts = otherStats.contacts;
                this.fastBodies = otherStats.fastBodies;
                this.fastBodyCollisions = otherStats.fastBodyCollisions;
                this.broadphase = otherStats.broadphase;
                this.narrowphase = otherStats.narrowphase;
            } else {
                this.pairs = this.collisions = this.fastBodies = 0;
                this.fastBodyCollisions = this.broadphase = this.narrowphase = 0;
                this.contacts.clear();
            }
        }
        /**
     * Provides a clone of this instance.
     */ clone() {
            const ps = new PhysicsStats();
            ps.reset(this);
            return ps;
        }
        get pairs() {
            return this._pairs;
        }
        set pairs(value) {
            this._pairs = value;
        }
        get collisions() {
            return this._collisions;
        }
        set collisions(value) {
            this._collisions = value;
        }
        get contacts() {
            return this._contacts;
        }
        set contacts(contacts) {
            this._contacts = contacts;
        }
        get fastBodies() {
            return this._fastBodies;
        }
        set fastBodies(value) {
            this._fastBodies = value;
        }
        get fastBodyCollisions() {
            return this._fastBodyCollisions;
        }
        set fastBodyCollisions(value) {
            this._fastBodyCollisions = value;
        }
        get broadphase() {
            return this._broadphase;
        }
        set broadphase(value) {
            this._broadphase = value;
        }
        get narrowphase() {
            return this._narrowphase;
        }
        set narrowphase(value) {
            this._narrowphase = value;
        }
    }
    class BrowserComponent {
        on(eventName, handler) {
            if (this._nativeHandlers[eventName]) this.off(eventName, this._nativeHandlers[eventName]);
            this._nativeHandlers[eventName] = this._decorate(handler);
            this.nativeComponent.addEventListener(eventName, this._nativeHandlers[eventName]);
        }
        off(eventName, handler) {
            if (!handler) handler = this._nativeHandlers[eventName];
            this.nativeComponent.removeEventListener(eventName, handler);
            this._nativeHandlers[eventName] = null;
        }
        _decorate(handler) {
            return (evt)=>{
                if (!this._paused) handler(evt);
            };
        }
        pause() {
            this._paused = true;
        }
        resume() {
            this._paused = false;
        }
        clear() {
            for(const event in this._nativeHandlers)this.off(event);
        }
        constructor(nativeComponent){
            this.nativeComponent = nativeComponent;
            this._paused = false;
            this._nativeHandlers = {};
        }
    }
    class BrowserEvents {
        constructor(_windowGlobal, _documentGlobal){
            this._windowGlobal = _windowGlobal;
            this._documentGlobal = _documentGlobal;
            this._windowComponent = new BrowserComponent(this._windowGlobal);
            this._documentComponent = new BrowserComponent(this._documentGlobal);
        }
        get window() {
            return this._windowComponent;
        }
        get document() {
            return this._documentComponent;
        }
        pause() {
            this.window.pause();
            this.document.pause();
        }
        resume() {
            this.window.resume();
            this.document.resume();
        }
        clear() {
            this.window.clear();
            this.document.clear();
        }
    }
    const DefaultAntialiasOptions = {
        pixelArtSampler: false,
        nativeContextAntialiasing: false,
        multiSampleAntialiasing: true,
        filtering: ImageFiltering.Blended,
        canvasImageRendering: "auto"
    };
    const DefaultPixelArtOptions = {
        pixelArtSampler: true,
        nativeContextAntialiasing: false,
        multiSampleAntialiasing: true,
        filtering: ImageFiltering.Blended,
        canvasImageRendering: "auto"
    };
    class FpsSampler {
        constructor(options){
            var _a;
            this._samplePeriod = 100;
            this._currentFrameTime = 0;
            this._frames = 0;
            this._previousSampleTime = 0;
            this._beginFrameTime = 0;
            this._fps = options.initialFps;
            this._samplePeriod = (_a = options.samplePeriod) !== null && _a !== void 0 ? _a : this._samplePeriod;
            this._currentFrameTime = 1000 / options.initialFps;
            this._nowFn = options.nowFn;
            this._previousSampleTime = this._nowFn();
        }
        /**
     * Start of code block to sample FPS for
     */ start() {
            this._beginFrameTime = this._nowFn();
        }
        /**
     * End of code block to sample FPS for
     */ end() {
            this._frames++;
            const time = this._nowFn();
            this._currentFrameTime = time - this._beginFrameTime;
            if (time >= this._previousSampleTime + this._samplePeriod) {
                this._fps = this._frames * 1000 / (time - this._previousSampleTime);
                this._previousSampleTime = time;
                this._frames = 0;
            }
        }
        /**
     * Return the currently sampled fps over the last sample period, by default every 100ms
     */ get fps() {
            return this._fps;
        }
        /**
     * Return the instantaneous fps, this can be less useful because it will fluctuate given the current frames time
     */ get instant() {
            return 1000 / this._currentFrameTime;
        }
    }
    /**
 * Abstract Clock is the base type of all Clocks
 *
 * It has a few opinions
 * 1. It manages the calculation of what "elapsed" time means and thus maximum fps
 * 2. The default timing api is implemented in now()
 *
 * To implement your own clock, extend Clock and override start/stop to start and stop the clock, then call update() with whatever
 * method is unique to your clock implementation.
 */ class Clock {
        constructor(options){
            var _a, _b, _c;
            this._onFatalException = ()=>{};
            this._maxFps = Infinity;
            this._lastTime = 0;
            this._elapsed = 1;
            this._scheduledCbs = [];
            this._totalElapsed = 0;
            this._options = options;
            this.tick = options.tick;
            this._lastTime = (_a = this.now()) !== null && _a !== void 0 ? _a : 0;
            this._maxFps = (_b = options.maxFps) !== null && _b !== void 0 ? _b : this._maxFps;
            this._onFatalException = (_c = options.onFatalException) !== null && _c !== void 0 ? _c : this._onFatalException;
            this.fpsSampler = new FpsSampler({
                initialFps: 60,
                nowFn: ()=>this.now()
            });
        }
        /**
     * Get the elapsed time for the last completed frame
     */ elapsed() {
            return this._elapsed;
        }
        /**
     * Get the current time in milliseconds
     */ now() {
            return performance.now();
        }
        toTestClock() {
            const testClock = new TestClock({
                ...this._options,
                defaultUpdateMs: 16.6
            });
            return testClock;
        }
        toStandardClock() {
            const clock = new StandardClock({
                ...this._options
            });
            return clock;
        }
        setFatalExceptionHandler(handler) {
            this._onFatalException = handler;
        }
        /**
     * Schedule a callback to fire given a timeout in milliseconds using the excalibur [[Clock]]
     *
     * This is useful to use over the built in browser `setTimeout` because callbacks will be tied to the
     * excalibur update clock, instead of browser time, this means that callbacks wont fire if the game is
     * stopped or paused.
     * @param cb callback to fire
     * @param timeoutMs Optionally specify a timeout in milliseconds from now, default is 0ms which means the next possible tick
     * @param timing Optionally specify a timeout in milliseconds from now, default is 0ms which means the next possible tick
     */ schedule(cb, timeoutMs = 0, timing = "preframe") {
            // Scheduled based on internal elapsed time
            const scheduledTime = this._totalElapsed + timeoutMs;
            this._scheduledCbs.push([
                cb,
                scheduledTime,
                timing
            ]);
        }
        /**
     * Called internally to trigger scheduled callbacks in the clock
     * @param timing
     * @internal
     */ __runScheduledCbs(timing = "preframe") {
            // walk backwards to delete items as we loop
            for(let i = this._scheduledCbs.length - 1; i > -1; i--)if (timing === this._scheduledCbs[i][2] && this._scheduledCbs[i][1] <= this._totalElapsed) {
                this._scheduledCbs[i][0](this._elapsed);
                this._scheduledCbs.splice(i, 1);
            }
        }
        update(overrideUpdateMs) {
            try {
                this.fpsSampler.start();
                // Get the time to calculate time-elapsed
                const now = this.now();
                let elapsed = now - this._lastTime || 1; // first frame
                // Constrain fps
                const fpsInterval = 1000 / this._maxFps;
                // only run frame if enough time has elapsed
                if (elapsed >= fpsInterval) {
                    let leftover = 0;
                    if (fpsInterval !== 0) {
                        leftover = elapsed % fpsInterval;
                        elapsed = elapsed - leftover; // shift elapsed to be "in phase" with the current loop fps
                    }
                    // Resolves issue #138 if the game has been paused, or blurred for
                    // more than a 200 milliseconds, reset elapsed time to 1. This improves reliability
                    // and provides more expected behavior when the engine comes back
                    // into focus
                    if (elapsed > 200) elapsed = 1;
                    // tick the mainloop and run scheduled callbacks
                    this._elapsed = overrideUpdateMs || elapsed;
                    this._totalElapsed += this._elapsed;
                    this.__runScheduledCbs("preframe");
                    this.tick(overrideUpdateMs || elapsed);
                    this.__runScheduledCbs("postframe");
                    if (fpsInterval !== 0) this._lastTime = now - leftover;
                    else this._lastTime = now;
                    this.fpsSampler.end();
                }
            } catch (e) {
                this._onFatalException(e);
                this.stop();
            }
        }
    }
    /**
 * The [[StandardClock]] implements the requestAnimationFrame browser api to run the tick()
 */ class StandardClock extends Clock {
        constructor(options){
            super(options);
            this._running = false;
        }
        isRunning() {
            return this._running;
        }
        start() {
            if (this._running) return;
            this._running = true;
            const mainloop = ()=>{
                // stop the loop
                if (!this._running) return;
                try {
                    // request next loop
                    this._requestId = window.requestAnimationFrame(mainloop);
                    this.update();
                } catch (e) {
                    window.cancelAnimationFrame(this._requestId);
                    throw e;
                }
            };
            // begin the first frame
            mainloop();
        }
        stop() {
            window.cancelAnimationFrame(this._requestId);
            this._running = false;
        }
    }
    /**
 * The TestClock is meant for debugging interactions in excalibur that require precise timing to replicate or test
 */ class TestClock extends Clock {
        constructor(options){
            super({
                ...options
            });
            this._logger = Logger.getInstance();
            this._running = false;
            this._currentTime = 0;
            this._updateMs = options.defaultUpdateMs;
        }
        /**
     * Get the current time in milliseconds
     */ now() {
            var _a;
            return (_a = this._currentTime) !== null && _a !== void 0 ? _a : 0;
        }
        isRunning() {
            return this._running;
        }
        start() {
            this._running = true;
        }
        stop() {
            this._running = false;
        }
        /**
     * Manually step the clock forward 1 tick, optionally specify an elapsed time in milliseconds
     * @param overrideUpdateMs
     */ step(overrideUpdateMs) {
            const time = overrideUpdateMs !== null && overrideUpdateMs !== void 0 ? overrideUpdateMs : this._updateMs;
            if (this._running) {
                // to be comparable to RAF this needs to be a full blown Task
                // For example, images cannot decode synchronously in a single step
                this.update(time);
                this._currentTime += time;
            } else this._logger.warn("The clock is not running, no step will be performed");
        }
        /**
     * Run a number of steps that tick the clock, optionally specify an elapsed time in milliseconds
     * @param numberOfSteps
     * @param overrideUpdateMs
     */ run(numberOfSteps, overrideUpdateMs) {
            for(let i = 0; i < numberOfSteps; i++)this.step(overrideUpdateMs !== null && overrideUpdateMs !== void 0 ? overrideUpdateMs : this._updateMs);
        }
    }
    // EXTERNAL MODULE: ./Util/Toaster.css
    var Util_Toaster = $2c23f148d58cd887$var$__webpack_require__(4296);
    /**
 * The Toaster is only meant to be called from inside Excalibur to display messages to players
 */ class Toaster {
        constructor(){
            this._toasterCss = Util_Toaster /* default */ .A.toString();
            this._isInitialized = false;
        }
        _initialize() {
            if (!this._isInitialized) {
                this._container = document.createElement("div");
                this._container.id = "ex-toast-container";
                document.body.appendChild(this._container);
                this._isInitialized = true;
                this._styleBlock = document.createElement("style");
                this._styleBlock.textContent = this._toasterCss;
                document.head.appendChild(this._styleBlock);
            }
        }
        dispose() {
            this._container.parentElement.removeChild(this._container);
            this._styleBlock.parentElement.removeChild(this._styleBlock);
            this._isInitialized = false;
        }
        _createFragment(message) {
            const toastMessage = document.createElement("span");
            toastMessage.innerText = message;
            return toastMessage;
        }
        /**
     * Display a toast message to a player
     * @param message Text of the message, messages may have a single "[LINK]" to influence placement
     * @param linkTarget Optionally specify a link location
     * @param linkName Optionally specify a name for that link location
     */ toast(message, linkTarget, linkName) {
            this._initialize();
            const toast = document.createElement("div");
            toast.className = "ex-toast-message";
            const messageFragments = message.split("[LINK]").map((message)=>this._createFragment(message));
            if (linkTarget) {
                const link = document.createElement("a");
                link.href = linkTarget;
                if (linkName) link.innerText = linkName;
                else link.innerText = linkTarget;
                messageFragments.splice(1, 0, link);
            }
            // Assembly message
            const finalMessage = document.createElement("div");
            messageFragments.forEach((message)=>{
                finalMessage.appendChild(message);
            });
            toast.appendChild(finalMessage);
            // Dismiss button
            const dismissBtn = document.createElement("button");
            dismissBtn.innerText = "x";
            dismissBtn.addEventListener("click", ()=>{
                this._container.removeChild(toast);
            });
            toast.appendChild(dismissBtn);
            // Escape to dismiss
            const keydownHandler = (evt)=>{
                if (evt.key === "Escape") try {
                    this._container.removeChild(toast);
                } catch (_a) {
                // pass
                }
                document.removeEventListener("keydown", keydownHandler);
            };
            document.addEventListener("keydown", keydownHandler);
            // Insert into container
            const first = this._container.firstChild;
            this._container.insertBefore(toast, first);
        }
    }
    const DirectorEvents = {
        NavigationStart: "navigationstart",
        Navigation: "navigation",
        NavigationEnd: "navigationend"
    };
    /**
 * The Director is responsible for managing scenes and changing scenes in Excalibur.
 *
 * It deals with transitions, scene loaders, switching scenes
 *
 * This is used internally by Excalibur, generally not mean to
 * be instantiated end users directly.
 */ class Director {
        /**
     * Gets whether the director currently transitioning between scenes
     *
     * Useful if you need to block behavior during transition
     */ get isTransitioning() {
            return this._isTransitioning;
        }
        constructor(_engine, scenes){
            this._engine = _engine;
            this.events = new EventEmitter();
            this._logger = Logger.getInstance();
            this._initialized = false;
            /**
         * All registered scenes in Excalibur
         */ this.scenes = {};
            /**
         * Holds all instantiated scenes
         */ this._sceneToInstance = new Map();
            this._sceneToLoader = new Map();
            this._sceneToTransition = new Map();
            /**
         * Used to keep track of scenes that have already been loaded so we don't load multiple times
         */ this._loadedScenes = new Set();
            this._isTransitioning = false;
            this.rootScene = this.currentScene = new Scene();
            this.add("root", this.rootScene);
            this.currentScene = this.rootScene;
            this.currentSceneName = "root";
            for(const sceneKey in scenes){
                const sceneOrOptions = scenes[sceneKey];
                this.add(sceneKey, sceneOrOptions);
                if (sceneKey === "root") {
                    this.rootScene = this.getSceneInstance("root");
                    this.currentScene = this.rootScene;
                }
            }
        }
        /**
     * Initialize the director's internal state
     */ async onInitialize() {
            if (!this._initialized) {
                this._initialized = true;
                if (this._deferredGoto) {
                    const deferredScene = this._deferredGoto;
                    const deferredTransition = this._deferredTransition;
                    this._deferredGoto = null;
                    this._deferredTransition = null;
                    await this.swapScene(deferredScene);
                    if (deferredTransition) await this.playTransition(deferredTransition);
                } else await this.swapScene("root");
            }
        }
        get isInitialized() {
            return this._initialized;
        }
        /**
     * Configures the start scene, and optionally the transition & loader for the director
     *
     * Typically this is called at the beginning of the game to the start scene and transition and never again.
     * @param startScene
     * @param options
     */ configureStart(startScene, options) {
            const maybeLoaderOrCtor = options === null || options === void 0 ? void 0 : options.loader;
            if (maybeLoaderOrCtor instanceof DefaultLoader) this.mainLoader = maybeLoaderOrCtor;
            else if (isLoaderConstructor(maybeLoaderOrCtor)) this.mainLoader = new maybeLoaderOrCtor();
            else this.mainLoader = new Loader();
            let maybeStartTransition;
            if (options) {
                const { inTransition: inTransition } = options;
                maybeStartTransition = inTransition;
            }
            this.startScene = startScene;
            // Fire and forget promise for the initial scene
            if (maybeStartTransition) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.swapScene(this.startScene).then(()=>{
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.playTransition(maybeStartTransition);
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.swapScene(this.startScene);
            this.currentSceneName = this.startScene;
        }
        _getLoader(sceneName) {
            return this._sceneToLoader.get(sceneName);
        }
        _getInTransition(sceneName) {
            var _a;
            const sceneOrRoute = this.scenes[sceneName];
            if (sceneOrRoute instanceof Scene || isSceneConstructor(sceneOrRoute)) return null;
            return (_a = sceneOrRoute === null || sceneOrRoute === void 0 ? void 0 : sceneOrRoute.transitions) === null || _a === void 0 ? void 0 : _a.in;
        }
        _getOutTransition(sceneName) {
            var _a;
            const sceneOrRoute = this.scenes[sceneName];
            if (sceneOrRoute instanceof Scene || isSceneConstructor(sceneOrRoute)) return null;
            return (_a = sceneOrRoute === null || sceneOrRoute === void 0 ? void 0 : sceneOrRoute.transitions) === null || _a === void 0 ? void 0 : _a.out;
        }
        getDeferredScene() {
            const maybeDeferred = this.getSceneDefinition(this._deferredGoto);
            if (this._deferredGoto && maybeDeferred) return maybeDeferred;
            return null;
        }
        /**
     * Returns a scene by name if it exists, might be the constructor and not the instance of a scene
     * @param name
     */ getSceneDefinition(name) {
            const maybeScene = this.scenes[name];
            if (maybeScene instanceof Scene || isSceneConstructor(maybeScene)) return maybeScene;
            else if (maybeScene) return maybeScene.scene;
            return undefined;
        }
        /**
     * Returns the name of the registered scene, null if none can be found
     * @param scene
     */ getSceneName(scene) {
            for (const [name, maybeScene] of Object.entries(this.scenes)){
                if (maybeScene instanceof Scene) {
                    if (scene === maybeScene) return name;
                } else if (!isSceneConstructor(maybeScene)) {
                    if (scene === maybeScene.scene) return name;
                }
            }
            for (const [name, maybeScene] of Object.entries(this.scenes)){
                if (isSceneConstructor(maybeScene)) {
                    if (scene.constructor === maybeScene) return name;
                } else if (!(maybeScene instanceof Scene)) {
                    if (scene.constructor === maybeScene.scene) return name;
                }
            }
            return null;
        }
        /**
     * Returns the same Director, but asserts a scene DOES exist to the type system
     * @param name
     */ assertAdded(name) {
            return this;
        }
        /**
     * Returns the same Director, but asserts a scene DOES NOT exist to the type system
     * @param name
     */ assertRemoved(name) {
            return this;
        }
        /**
     * Adds additional Scenes to the game!
     * @param name
     * @param sceneOrRoute
     */ add(name, sceneOrRoute) {
            if (!(sceneOrRoute instanceof Scene) && !isSceneConstructor(sceneOrRoute)) {
                const { loader: loader, transitions: transitions } = sceneOrRoute;
                const { in: inTransition, out: outTransition } = transitions !== null && transitions !== void 0 ? transitions : {};
                this._sceneToTransition.set(name, {
                    in: inTransition,
                    out: outTransition
                });
                if (isLoaderConstructor(loader)) this._sceneToLoader.set(name, new loader());
                else this._sceneToLoader.set(name, loader);
            }
            if (this.scenes[name]) this._logger.warn("Scene", name, "already exists overwriting");
            this.scenes[name] = sceneOrRoute;
            return this.assertAdded(name);
        }
        remove(nameOrScene) {
            if (nameOrScene instanceof Scene || isSceneConstructor(nameOrScene)) {
                const sceneOrCtor = nameOrScene;
                // remove scene
                for(const key in this.scenes)if (this.scenes.hasOwnProperty(key)) {
                    const potentialSceneOrOptions = this.scenes[key];
                    let scene;
                    if (potentialSceneOrOptions instanceof Scene || isSceneConstructor(potentialSceneOrOptions)) scene = potentialSceneOrOptions;
                    else scene = potentialSceneOrOptions.scene;
                    if (scene === sceneOrCtor) {
                        if (key === this.currentSceneName) throw new Error(`Cannot remove a currently active scene: ${key}`);
                        this._sceneToInstance.delete(key);
                        this._sceneToTransition.delete(key);
                        this._sceneToLoader.delete(key);
                        delete this.scenes[key];
                    }
                }
            }
            if (typeof nameOrScene === "string") {
                if (nameOrScene === this.currentSceneName) throw new Error(`Cannot remove a currently active scene: ${nameOrScene}`);
                // remove scene
                this._sceneToInstance.delete(nameOrScene);
                this._sceneToTransition.delete(nameOrScene);
                this._sceneToLoader.delete(nameOrScene);
                delete this.scenes[nameOrScene];
            }
        }
        /**
     * Go to a specific scene, and optionally override loaders and transitions
     * @param destinationScene
     * @param options
     */ async goto(destinationScene, options) {
            var _a, _b, _c, _d, _e, _f;
            const maybeDest = this.getSceneInstance(destinationScene);
            if (!maybeDest) {
                this._logger.warn(`Scene ${destinationScene} does not exist! Check the name, are you sure you added it?`);
                return;
            }
            const sourceScene = this.currentSceneName;
            const engineInputEnabled = (_b = (_a = this._engine.input) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : true;
            this._isTransitioning = true;
            const maybeSourceOut = (_c = this.getSceneInstance(sourceScene)) === null || _c === void 0 ? void 0 : _c.onTransition("out");
            const maybeDestinationIn = maybeDest === null || maybeDest === void 0 ? void 0 : maybeDest.onTransition("in");
            options = {
                sourceOut: (_d = this._getOutTransition(this.currentSceneName)) !== null && _d !== void 0 ? _d : maybeSourceOut,
                destinationIn: (_e = this._getInTransition(destinationScene)) !== null && _e !== void 0 ? _e : maybeDestinationIn,
                // Goto options
                ...options
            };
            const { sourceOut: sourceOut, destinationIn: destinationIn, sceneActivationData: sceneActivationData } = options;
            const outTransition = sourceOut !== null && sourceOut !== void 0 ? sourceOut : this._getOutTransition(this.currentSceneName);
            const inTransition = destinationIn !== null && destinationIn !== void 0 ? destinationIn : this._getInTransition(destinationScene);
            const hideLoader = (outTransition === null || outTransition === void 0 ? void 0 : outTransition.hideLoader) || (inTransition === null || inTransition === void 0 ? void 0 : inTransition.hideLoader);
            if (hideLoader) // Start hidden loader early and take advantage of the transition
            // Don't await and block on a hidden loader
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.maybeLoadScene(destinationScene, hideLoader);
            this._emitEvent("navigationstart", sourceScene, destinationScene);
            // Run the out transition on the current scene if present
            await this.playTransition(outTransition);
            // Run the loader if present
            await this.maybeLoadScene(destinationScene, hideLoader);
            // Give incoming transition a chance to grab info from previous
            await (inTransition === null || inTransition === void 0 ? void 0 : inTransition.onPreviousSceneDeactivate(this.currentScene));
            // Swap to the new scene
            await this.swapScene(destinationScene, sceneActivationData);
            this._emitEvent("navigation", sourceScene, destinationScene);
            // Run the in transition on the new scene if present
            await this.playTransition(inTransition);
            this._emitEvent("navigationend", sourceScene, destinationScene);
            (_f = this._engine.input) === null || _f === void 0 || _f.toggleEnabled(engineInputEnabled);
            this._isTransitioning = false;
        }
        /**
     * Retrieves a scene instance by key if it's registered.
     *
     * This will call any constructors that were given as a definition
     * @param scene
     */ getSceneInstance(scene) {
            const sceneDefinition = this.getSceneDefinition(scene);
            if (!sceneDefinition) return undefined;
            if (this._sceneToInstance.has(scene)) return this._sceneToInstance.get(scene);
            if (sceneDefinition instanceof Scene) {
                this._sceneToInstance.set(scene, sceneDefinition);
                return sceneDefinition;
            }
            const newScene = new sceneDefinition();
            this._sceneToInstance.set(scene, newScene);
            return newScene;
        }
        /**
     * Triggers scene loading if has not already been loaded
     * @param scene
     * @param hideLoader
     */ async maybeLoadScene(scene, hideLoader = false) {
            var _a;
            const loader = (_a = this._getLoader(scene)) !== null && _a !== void 0 ? _a : new DefaultLoader();
            const sceneToLoad = this.getSceneDefinition(scene);
            const sceneToLoadInstance = this.getSceneInstance(scene);
            if (sceneToLoad && sceneToLoadInstance && !this._loadedScenes.has(sceneToLoadInstance)) {
                sceneToLoadInstance.onPreLoad(loader);
                sceneToLoadInstance.events.emit("preload", {
                    loader: loader
                });
                if (hideLoader) // Don't await a hidden loader
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._engine.load(loader, hideLoader);
                else await this._engine.load(loader);
                this._loadedScenes.add(sceneToLoadInstance);
            }
        }
        /**
     * Plays a transition in the current scene
     * @param transition
     */ async playTransition(transition) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!this.isInitialized) {
                this._deferredTransition = transition;
                return;
            }
            if (transition) {
                this.currentTransition = transition;
                const currentScene = this._engine.currentScene;
                const sceneInputEnabled = (_b = (_a = currentScene.input) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : true;
                (_c = currentScene.input) === null || _c === void 0 || _c.toggleEnabled(!transition.blockInput);
                (_d = this._engine.input) === null || _d === void 0 || _d.toggleEnabled(!transition.blockInput);
                await this.currentTransition.play(this._engine);
                (_e = currentScene.input) === null || _e === void 0 || _e.toggleEnabled(sceneInputEnabled);
            }
            (_f = this.currentTransition) === null || _f === void 0 || _f.kill();
            (_g = this.currentTransition) === null || _g === void 0 || _g.reset();
            this.currentTransition = null;
        }
        /**
     * Swaps the current and destination scene after performing required lifecycle events
     * @param destinationScene
     * @param data
     */ async swapScene(destinationScene, data) {
            const engine = this._engine;
            // if not yet initialized defer goToScene
            if (!this.isInitialized) {
                this._deferredGoto = destinationScene;
                return;
            }
            const maybeDest = this.getSceneInstance(destinationScene);
            if (maybeDest) {
                const previousScene = this.currentScene;
                const nextScene = maybeDest;
                this._logger.debug("Going to scene:", destinationScene);
                // only deactivate when initialized
                if (this.currentScene.isInitialized) {
                    const context = {
                        engine: engine,
                        previousScene: previousScene,
                        nextScene: nextScene
                    };
                    await this.currentScene._deactivate(context);
                    this.currentScene.events.emit("deactivate", new DeactivateEvent(context, this.currentScene));
                }
                // wait for the scene to be loaded if needed
                const destLoader = this._sceneToLoader.get(destinationScene);
                await (destLoader === null || destLoader === void 0 ? void 0 : destLoader.areResourcesLoaded());
                // set current scene to new one
                this.currentScene = nextScene;
                this.currentSceneName = destinationScene;
                engine.screen.setCurrentCamera(nextScene.camera);
                // initialize the current scene if has not been already
                await this.currentScene._initialize(engine);
                const context = {
                    engine: engine,
                    previousScene: previousScene,
                    nextScene: nextScene,
                    data: data
                };
                await this.currentScene._activate(context);
                this.currentScene.events.emit("activate", new ActivateEvent(context, this.currentScene));
            } else this._logger.error("Scene", destinationScene, "does not exist!");
        }
        _emitEvent(eventName, sourceScene, destinationScene) {
            const source = this.getSceneDefinition(sourceScene);
            const dest = this.getSceneDefinition(destinationScene);
            this.events.emit(eventName, {
                sourceScene: source,
                sourceName: sourceScene,
                destinationScene: dest,
                destinationName: destinationScene
            });
        }
    }
    /**
 * Creates a injectable context that can be retrieved later with `useContext(context)`
 *
 * Example
 * ```typescript
 *
 * const AppContext = createContext({some: 'value'});
 * context.scope(val, () => {
 *    const value = useContext(AppContext);
 * })
 *
 * ```
 */ function createContext() {
        const ctx = {
            scope: (value, cb)=>{
                ctx.value = value;
                return cb();
            },
            value: undefined
        };
        return ctx;
    }
    /**
 * Retrieves the value from the current context
 */ function useContext(context) {
        return context.value;
    }
    polyfill();
    const EngineEvents = {
        FallbackGraphicsContext: "fallbackgraphicscontext",
        Initialize: "initialize",
        Visible: "visible",
        Hidden: "hidden",
        Start: "start",
        Stop: "stop",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreFrame: "preframe",
        PostFrame: "postframe",
        PreDraw: "predraw",
        PostDraw: "postdraw"
    };
    /**
 * Enum representing the different mousewheel event bubble prevention
 */ var ScrollPreventionMode;
    (function(ScrollPreventionMode) {
        /**
     * Do not prevent any page scrolling
     */ ScrollPreventionMode[ScrollPreventionMode["None"] = 0] = "None";
        /**
     * Prevent page scroll if mouse is over the game canvas
     */ ScrollPreventionMode[ScrollPreventionMode["Canvas"] = 1] = "Canvas";
        /**
     * Prevent all page scrolling via mouse wheel
     */ ScrollPreventionMode[ScrollPreventionMode["All"] = 2] = "All";
    })(ScrollPreventionMode || (ScrollPreventionMode = {}));
    /**
 * The Excalibur Engine
 *
 * The [[Engine]] is the main driver for a game. It is responsible for
 * starting/stopping the game, maintaining state, transmitting events,
 * loading resources, and managing the scene.
 */ class Engine {
        static useEngine() {
            const value = useContext(Engine.Context);
            if (!value) throw new Error("Cannot inject engine with `useEngine()`, `useEngine()` was called outside of Engine lifecycle scope.");
            return value;
        }
        /**
     * The width of the game canvas in pixels (physical width component of the
     * resolution of the canvas element)
     */ get canvasWidth() {
            return this.screen.canvasWidth;
        }
        /**
     * Returns half width of the game canvas in pixels (half physical width component)
     */ get halfCanvasWidth() {
            return this.screen.halfCanvasWidth;
        }
        /**
     * The height of the game canvas in pixels, (physical height component of
     * the resolution of the canvas element)
     */ get canvasHeight() {
            return this.screen.canvasHeight;
        }
        /**
     * Returns half height of the game canvas in pixels (half physical height component)
     */ get halfCanvasHeight() {
            return this.screen.halfCanvasHeight;
        }
        /**
     * Returns the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawWidth() {
            return this.screen.drawWidth;
        }
        /**
     * Returns half the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawWidth() {
            return this.screen.halfDrawWidth;
        }
        /**
     * Returns the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawHeight() {
            return this.screen.drawHeight;
        }
        /**
     * Returns half the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawHeight() {
            return this.screen.halfDrawHeight;
        }
        /**
     * Returns whether excalibur detects the current screen to be HiDPI
     */ get isHiDpi() {
            return this.screen.isHiDpi;
        }
        /**
     * Access [[stats]] that holds frame statistics.
     */ get stats() {
            return this.debug.stats;
        }
        /**
     * The current [[Scene]] being drawn and updated on screen
     */ get currentScene() {
            return this.director.currentScene;
        }
        /**
     * The current [[Scene]] being drawn and updated on screen
     */ get currentSceneName() {
            return this.director.currentSceneName;
        }
        /**
     * The default [[Scene]] of the game, use [[Engine.goToScene]] to transition to different scenes.
     */ get rootScene() {
            return this.director.rootScene;
        }
        /**
     * Contains all the scenes currently registered with Excalibur
     */ get scenes() {
            return this.director.scenes;
        }
        /**
     * Indicates whether the engine is set to fullscreen or not
     */ get isFullscreen() {
            return this.screen.isFullScreen;
        }
        /**
     * Indicates the current [[DisplayMode]] of the engine.
     */ get displayMode() {
            return this.screen.displayMode;
        }
        /**
     * Returns the calculated pixel ration for use in rendering
     */ get pixelRatio() {
            return this.screen.pixelRatio;
        }
        get isDebug() {
            return this._isDebug;
        }
        /**
     * Hints the graphics context to truncate fractional world space coordinates
     */ get snapToPixel() {
            return this.graphicsContext.snapToPixel;
        }
        set snapToPixel(shouldSnapToPixel) {
            this.graphicsContext.snapToPixel = shouldSnapToPixel;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Creates a new game using the given [[EngineOptions]]. By default, if no options are provided,
     * the game will be rendered full screen (taking up all available browser window space).
     * You can customize the game rendering through [[EngineOptions]].
     *
     * Example:
     *
     * ```js
     * var game = new ex.Engine({
     *   width: 0, // the width of the canvas
     *   height: 0, // the height of the canvas
     *   enableCanvasTransparency: true, // the transparencySection of the canvas
     *   canvasElementId: '', // the DOM canvas element ID, if you are providing your own
     *   displayMode: ex.DisplayMode.FullScreen, // the display mode
     *   pointerScope: ex.PointerScope.Document, // the scope of capturing pointer (mouse/touch) events
     *   backgroundColor: ex.Color.fromHex('#2185d0') // background color of the engine
     * });
     *
     * // call game.start, which is a Promise
     * game.start().then(function () {
     *   // ready, set, go!
     * });
     * ```
     */ constructor(options){
            var _a, _b, _c, _d, _e, _f, _g, _h;
            /**
         * Anything run under scope can use `useEngine()` to inject the current engine
         * @param cb
         */ this.scope = (cb)=>Engine.Context.scope(this, cb);
            /**
         * Current Excalibur version string
         *
         * Useful for plugins or other tools that need to know what features are available
         */ this.version = EX_VERSION;
            /**
         * Listen to and emit events on the Engine
         */ this.events = new EventEmitter();
            /**
         * Optionally set the maximum fps if not set Excalibur will go as fast as the device allows.
         *
         * You may want to constrain max fps if your game cannot maintain fps consistently, it can look and feel better to have a 30fps game than
         * one that bounces between 30fps and 60fps
         */ this.maxFps = Number.POSITIVE_INFINITY;
            this._inputEnabled = true;
            this._suppressPlayButton = false;
            /**
         * Indicates whether audio should be paused when the game is no longer visible.
         */ this.pauseAudioWhenHidden = true;
            /**
         * Indicates whether the engine should draw with debug information
         */ this._isDebug = false;
            /**
         * Sets the Transparency for the engine.
         */ this.enableCanvasTransparency = true;
            /**
         * The action to take when a fatal exception is thrown
         */ this.onFatalException = (e)=>{
                Logger.getInstance().fatal(e, e.stack);
            };
            this._toaster = new Toaster();
            this._timescale = 1.0;
            this._isInitialized = false;
            this._originalOptions = {};
            this._handleWebGLContextLost = (e)=>{
                var _a;
                e.preventDefault();
                this.clock.stop();
                this._logger.fatalOnce("WebGL Graphics Lost", e);
                const container = document.createElement("div");
                container.id = "ex-webgl-graphics-context-lost";
                container.style.position = "absolute";
                container.style.zIndex = "99";
                container.style.left = "50%";
                container.style.top = "50%";
                container.style.display = "flex";
                container.style.flexDirection = "column";
                container.style.transform = "translate(-50%, -50%)";
                container.style.backgroundColor = "white";
                container.style.padding = "10px";
                container.style.borderStyle = "solid 1px";
                const div = document.createElement("div");
                div.innerHTML = `
      <h1>There was an issue rendering, please refresh the page.</h1>
      <div>
        <p>WebGL Graphics Context Lost</p>

        <button id="ex-webgl-graphics-reload">Refresh Page</button>

        <p>There are a few reasons this might happen:</p>
        <ul>
          <li>Two or more pages are placing a high demand on the GPU</li>
          <li>Another page or operation has stalled the GPU and the browser has decided to reset the GPU</li>
          <li>The computer has multiple GPUs and the user has switched between them</li>
          <li>Graphics driver has crashed or restarted</li>
          <li>Graphics driver was updated</li>
        </ul>
      </div>
    `;
                container.appendChild(div);
                if ((_a = this.canvas) === null || _a === void 0 ? void 0 : _a.parentElement) {
                    this.canvas.parentElement.appendChild(container);
                    const button = div.querySelector("#ex-webgl-graphics-reload");
                    button === null || button === void 0 || button.addEventListener("click", ()=>location.reload());
                }
            };
            this._performanceThresholdTriggered = false;
            this._fpsSamples = [];
            this._disposed = false;
            this._isLoading = false;
            this._hideLoader = false;
            this._isReadyFuture = new Future();
            /**
         * Returns the current frames elapsed milliseconds
         */ this.currentFrameElapsedMs = 0;
            /**
         * Returns the current frame lag when in fixed update mode
         */ this.currentFrameLagMs = 0;
            this._lagMs = 0;
            this._screenShotRequests = [];
            options = {
                ...Engine._DEFAULT_ENGINE_OPTIONS,
                ...options
            };
            this._originalOptions = options;
            Flags.freeze();
            // Initialize browser events facade
            this.browser = new BrowserEvents(window, document);
            // Check compatibility
            const detector = new Detector();
            if (!options.suppressMinimumBrowserFeatureDetection && !(this._compatible = detector.test())) {
                const message = document.createElement("div");
                message.innerText = "Sorry, your browser does not support all the features needed for Excalibur";
                document.body.appendChild(message);
                detector.failedTests.forEach(function(test) {
                    const testMessage = document.createElement("div");
                    testMessage.innerText = "Browser feature missing " + test;
                    document.body.appendChild(testMessage);
                });
                if (options.canvasElementId) {
                    const canvas = document.getElementById(options.canvasElementId);
                    if (canvas) canvas.parentElement.removeChild(canvas);
                }
                return;
            } else this._compatible = true;
            // Use native console API for color fun
            // eslint-disable-next-line no-console
            if (console.log && !options.suppressConsoleBootMessage) {
                // eslint-disable-next-line no-console
                console.log(`%cPowered by Excalibur.js (v${EX_VERSION})`, "background: #176BAA; color: white; border-radius: 5px; padding: 15px; font-size: 1.5em; line-height: 80px;");
                // eslint-disable-next-line no-console
                console.log("\n      /| ________________\nO|===|* >________________>\n      \\|");
                // eslint-disable-next-line no-console
                console.log("Visit", "http://excaliburjs.com", "for more information");
            }
            // Suppress play button
            if (options.suppressPlayButton) this._suppressPlayButton = true;
            this._logger = Logger.getInstance();
            // If debug is enabled, let's log browser features to the console.
            if (this._logger.defaultLevel === LogLevel.Debug) detector.logBrowserFeatures();
            this._logger.debug("Building engine...");
            this.canvasElementId = options.canvasElementId;
            if (options.canvasElementId) {
                this._logger.debug("Using Canvas element specified: " + options.canvasElementId);
                //test for existence of element
                if (document.getElementById(options.canvasElementId) === null) throw new Error("Cannot find existing element in the DOM, please ensure element is created prior to engine creation.");
                this.canvas = document.getElementById(options.canvasElementId);
            } else if (options.canvasElement) {
                this._logger.debug("Using Canvas element specified:", options.canvasElement);
                this.canvas = options.canvasElement;
            } else {
                this._logger.debug("Using generated canvas element");
                this.canvas = document.createElement("canvas");
            }
            let displayMode = (_a = options.displayMode) !== null && _a !== void 0 ? _a : DisplayMode.Fixed;
            if (options.width && options.height || options.viewport) {
                if (options.displayMode === undefined) displayMode = DisplayMode.Fixed;
                this._logger.debug("Engine viewport is size " + options.width + " x " + options.height);
            } else if (!options.displayMode) {
                this._logger.debug("Engine viewport is fit");
                displayMode = DisplayMode.FitScreen;
            }
            this._originalDisplayMode = displayMode;
            let pixelArtSampler;
            let uvPadding;
            let nativeContextAntialiasing;
            let canvasImageRendering;
            let filtering;
            let multiSampleAntialiasing;
            if (typeof options.antialiasing === "object") ({ pixelArtSampler: pixelArtSampler, nativeContextAntialiasing: nativeContextAntialiasing, multiSampleAntialiasing: multiSampleAntialiasing, filtering: filtering, canvasImageRendering: canvasImageRendering } = {
                ...options.pixelArt ? DefaultPixelArtOptions : DefaultAntialiasOptions,
                ...options.antialiasing
            });
            else {
                pixelArtSampler = !!options.pixelArt;
                nativeContextAntialiasing = false;
                multiSampleAntialiasing = options.antialiasing;
                canvasImageRendering = options.antialiasing ? "auto" : "pixelated";
                filtering = options.antialiasing ? ImageFiltering.Blended : ImageFiltering.Pixel;
            }
            if (nativeContextAntialiasing && multiSampleAntialiasing) this._logger.warnOnce(`Cannot use antialias setting nativeContextAntialiasing and multiSampleAntialiasing` + ` at the same time, they are incompatible settings. If you aren\'t sure use multiSampleAntialiasing`);
            if (options.pixelArt) uvPadding = .25;
            if (!options.antialiasing || filtering === ImageFiltering.Pixel) uvPadding = 0;
            // Override with any user option, if non default to .25 for pixel art, 0.01 for everything else
            uvPadding = (_c = (_b = options.uvPadding) !== null && _b !== void 0 ? _b : uvPadding) !== null && _c !== void 0 ? _c : 0.01;
            // Canvas 2D fallback can be flagged on
            let useCanvasGraphicsContext = Flags.isEnabled("use-canvas-context");
            if (!useCanvasGraphicsContext) // Attempt webgl first
            try {
                this.graphicsContext = new ExcaliburGraphicsContextWebGL({
                    canvasElement: this.canvas,
                    enableTransparency: this.enableCanvasTransparency,
                    pixelArtSampler: pixelArtSampler,
                    antialiasing: nativeContextAntialiasing,
                    multiSampleAntialiasing: multiSampleAntialiasing,
                    uvPadding: uvPadding,
                    powerPreference: options.powerPreference,
                    backgroundColor: options.backgroundColor,
                    snapToPixel: options.snapToPixel,
                    useDrawSorting: options.useDrawSorting,
                    handleContextLost: (_d = options.handleContextLost) !== null && _d !== void 0 ? _d : this._handleWebGLContextLost,
                    handleContextRestored: options.handleContextRestored
                });
            } catch (e) {
                this._logger.warn(`Excalibur could not load webgl for some reason (${e.message}) and loaded a Canvas 2D fallback. ` + `Some features of Excalibur will not work in this mode. \n\n` + "Read more about this issue at https://excaliburjs.com/docs/performance");
                // fallback to canvas in case of failure
                useCanvasGraphicsContext = true;
            }
            if (useCanvasGraphicsContext) this.graphicsContext = new ExcaliburGraphicsContext2DCanvas({
                canvasElement: this.canvas,
                enableTransparency: this.enableCanvasTransparency,
                antialiasing: nativeContextAntialiasing,
                backgroundColor: options.backgroundColor,
                snapToPixel: options.snapToPixel,
                useDrawSorting: options.useDrawSorting
            });
            this.screen = new Screen({
                canvas: this.canvas,
                context: this.graphicsContext,
                antialiasing: nativeContextAntialiasing,
                canvasImageRendering: canvasImageRendering,
                browser: this.browser,
                viewport: (_e = options.viewport) !== null && _e !== void 0 ? _e : options.width && options.height ? {
                    width: options.width,
                    height: options.height
                } : Resolution.SVGA,
                resolution: options.resolution,
                displayMode: displayMode,
                pixelRatio: options.suppressHiDPIScaling ? 1 : (_f = options.pixelRatio) !== null && _f !== void 0 ? _f : null
            });
            // TODO REMOVE STATIC!!!
            // Set default filtering based on antialiasing
            TextureLoader.filtering = filtering;
            if (options.backgroundColor) this.backgroundColor = options.backgroundColor.clone();
            this.grabWindowFocus = options.grabWindowFocus;
            this.pointerScope = options.pointerScope;
            this.maxFps = (_g = options.maxFps) !== null && _g !== void 0 ? _g : this.maxFps;
            this.fixedUpdateFps = (_h = options.fixedUpdateFps) !== null && _h !== void 0 ? _h : this.fixedUpdateFps;
            this.clock = new StandardClock({
                maxFps: this.maxFps,
                tick: this._mainloop.bind(this),
                onFatalException: (e)=>this.onFatalException(e)
            });
            this.enableCanvasTransparency = options.enableCanvasTransparency;
            if (typeof options.physics === "boolean") this.physics = {
                ...DefaultPhysicsConfig,
                ...DeprecatedStaticToConfig(),
                enabled: options.physics
            };
            else this.physics = {
                ...DefaultPhysicsConfig,
                ...DeprecatedStaticToConfig(),
                ...options.physics
            };
            this.debug = new DebugConfig(this);
            this.director = new Director(this, options.scenes);
            this._initialize(options);
            window.___EXCALIBUR_DEVTOOL = this;
            Engine.InstanceCount++;
        }
        _monitorPerformanceThresholdAndTriggerFallback() {
            const { allow: allow } = this._originalOptions.configurePerformanceCanvas2DFallback;
            let { threshold: threshold, showPlayerMessage: showPlayerMessage } = this._originalOptions.configurePerformanceCanvas2DFallback;
            if (threshold === undefined) threshold = Engine._DEFAULT_ENGINE_OPTIONS.configurePerformanceCanvas2DFallback.threshold;
            if (showPlayerMessage === undefined) showPlayerMessage = Engine._DEFAULT_ENGINE_OPTIONS.configurePerformanceCanvas2DFallback.showPlayerMessage;
            if (!Flags.isEnabled("use-canvas-context") && allow && this.ready && !this._performanceThresholdTriggered) {
                // Calculate Average fps for last X number of frames after start
                if (this._fpsSamples.length === threshold.numberOfFrames) this._fpsSamples.splice(0, 1);
                this._fpsSamples.push(this.clock.fpsSampler.fps);
                let total = 0;
                for(let i = 0; i < this._fpsSamples.length; i++)total += this._fpsSamples[i];
                const average = total / this._fpsSamples.length;
                if (this._fpsSamples.length === threshold.numberOfFrames) {
                    if (average <= threshold.fps) {
                        this._performanceThresholdTriggered = true;
                        this._logger.warn(`Switching to browser 2D Canvas fallback due to performance. Some features of Excalibur will not work in this mode.\n` + "this might mean your browser doesn't have webgl enabled or hardware acceleration is unavailable.\n\n" + "If in Chrome:\n" + '  * Visit Settings > Advanced > System, and ensure "Use Hardware Acceleration" is checked.\n' + '  * Visit chrome://flags/#ignore-gpu-blocklist and ensure "Override software rendering list" is "enabled"\n' + "If in Firefox, visit about:config\n" + "  * Ensure webgl.disabled = false\n" + "  * Ensure webgl.force-enabled = true\n" + "  * Ensure layers.acceleration.force-enabled = true\n\n" + "Read more about this issue at https://excaliburjs.com/docs/performance");
                        if (showPlayerMessage) this._toaster.toast("Excalibur is encountering performance issues. It's possible that your browser doesn't have hardware acceleration enabled. Visit [LINK] for more information and potential solutions.", "https://excaliburjs.com/docs/performance");
                        this.useCanvas2DFallback();
                        this.emit("fallbackgraphicscontext", this.graphicsContext);
                    }
                }
            }
        }
        /**
     * Switches the engine's graphics context to the 2D Canvas.
     * @warning Some features of Excalibur will not work in this mode.
     */ useCanvas2DFallback() {
            var _a, _b, _c;
            // Swap out the canvas
            const newCanvas = this.canvas.cloneNode(false);
            this.canvas.parentNode.replaceChild(newCanvas, this.canvas);
            this.canvas = newCanvas;
            const options = {
                ...this._originalOptions,
                antialiasing: this.getAntialiasing()
            };
            const displayMode = this._originalDisplayMode;
            // New graphics context
            this.graphicsContext = new ExcaliburGraphicsContext2DCanvas({
                canvasElement: this.canvas,
                enableTransparency: this.enableCanvasTransparency,
                antialiasing: options.antialiasing,
                backgroundColor: options.backgroundColor,
                snapToPixel: options.snapToPixel,
                useDrawSorting: options.useDrawSorting
            });
            // Reset screen
            if (this.screen) this.screen.dispose();
            this.screen = new Screen({
                canvas: this.canvas,
                context: this.graphicsContext,
                antialiasing: (_a = options.antialiasing) !== null && _a !== void 0 ? _a : true,
                browser: this.browser,
                viewport: (_b = options.viewport) !== null && _b !== void 0 ? _b : options.width && options.height ? {
                    width: options.width,
                    height: options.height
                } : Resolution.SVGA,
                resolution: options.resolution,
                displayMode: displayMode,
                pixelRatio: options.suppressHiDPIScaling ? 1 : (_c = options.pixelRatio) !== null && _c !== void 0 ? _c : null
            });
            this.screen.setCurrentCamera(this.currentScene.camera);
            // Reset pointers
            this.input.pointers.detach();
            const pointerTarget = options && options.pointerScope === PointerScope.Document ? document : this.canvas;
            this.input.pointers = this.input.pointers.recreate(pointerTarget, this);
            this.input.pointers.init();
        }
        /**
     * Attempts to completely clean up excalibur resources, including removing the canvas from the dom.
     *
     * To start again you will need to new up an Engine.
     */ dispose() {
            if (!this._disposed) {
                this._disposed = true;
                this.stop();
                this.input.toggleEnabled(false);
                this.canvas.parentNode.removeChild(this.canvas);
                this.canvas = null;
                this.screen.dispose();
                this.graphicsContext.dispose();
                this.graphicsContext = null;
                Engine.InstanceCount--;
            }
        }
        isDisposed() {
            return this._disposed;
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen
     * and the bottom right corner of the screen.
     */ getWorldBounds() {
            return this.screen.getWorldBounds();
        }
        /**
     * Gets the current engine timescale factor (default is 1.0 which is 1:1 time)
     */ get timescale() {
            return this._timescale;
        }
        /**
     * Sets the current engine timescale factor. Useful for creating slow-motion effects or fast-forward effects
     * when using time-based movement.
     */ set timescale(value) {
            if (value <= 0) {
                Logger.getInstance().error("Cannot set engine.timescale to a value of 0 or less than 0.");
                return;
            }
            this._timescale = value;
        }
        /**
     * Adds a [[Timer]] to the [[currentScene]].
     * @param timer  The timer to add to the [[currentScene]].
     */ addTimer(timer) {
            return this.currentScene.addTimer(timer);
        }
        /**
     * Removes a [[Timer]] from the [[currentScene]].
     * @param timer  The timer to remove to the [[currentScene]].
     */ removeTimer(timer) {
            return this.currentScene.removeTimer(timer);
        }
        /**
     * Adds a [[Scene]] to the engine, think of scenes in Excalibur as you
     * would levels or menus.
     * @param key  The name of the scene, must be unique
     * @param scene The scene to add to the engine
     */ addScene(key, scene) {
            this.director.add(key, scene);
            return this;
        }
        /**
     * @internal
     */ removeScene(entity) {
            this.director.remove(entity);
        }
        add(entity) {
            if (arguments.length === 2) {
                this.director.add(arguments[0], arguments[1]);
                return;
            }
            const maybeDeferred = this.director.getDeferredScene();
            if (maybeDeferred instanceof Scene) maybeDeferred.add(entity);
            else this.currentScene.add(entity);
        }
        remove(entity) {
            if (entity instanceof Entity) this.currentScene.remove(entity);
            if (entity instanceof Scene || isSceneConstructor(entity)) this.removeScene(entity);
            if (typeof entity === "string") this.removeScene(entity);
        }
        /**
     * Changes the current scene with optionally supplied:
     * * Activation data
     * * Transitions
     * * Loaders
     *
     * Example:
     * ```typescript
     * game.goToScene('myScene', {
     *   sceneActivationData: {any: 'thing at all'},
     *   destinationIn: new FadeInOut({duration: 1000, direction: 'in'}),
     *   sourceOut: new FadeInOut({duration: 1000, direction: 'out'}),
     *   loader: MyLoader
     * });
     * ```
     *
     * Scenes are defined in the Engine constructor
     * ```typescript
     * const engine = new ex.Engine({
        scenes: {...}
      });
     * ```
     * Or by adding dynamically
     *
     * ```typescript
     * engine.addScene('myScene', new ex.Scene());
     * ```
     * @param destinationScene
     * @param options
     * @deprecated use goToScene, it now behaves the same as goto
     */ async goto(destinationScene, options) {
            await this.scope(async ()=>{
                await this.director.goto(destinationScene, options);
            });
        }
        /**
     * Changes the current scene with optionally supplied:
     * * Activation data
     * * Transitions
     * * Loaders
     *
     * Example:
     * ```typescript
     * game.goToScene('myScene', {
     *   sceneActivationData: {any: 'thing at all'},
     *   destinationIn: new FadeInOut({duration: 1000, direction: 'in'}),
     *   sourceOut: new FadeInOut({duration: 1000, direction: 'out'}),
     *   loader: MyLoader
     * });
     * ```
     *
     * Scenes are defined in the Engine constructor
     * ```typescript
     * const engine = new ex.Engine({
        scenes: {...}
      });
     * ```
     * Or by adding dynamically
     *
     * ```typescript
     * engine.addScene('myScene', new ex.Scene());
     * ```
     * @param destinationScene
     * @param options
     */ async goToScene(destinationScene, options) {
            await this.scope(async ()=>{
                await this.director.goto(destinationScene, options);
            });
        }
        /**
     * Transforms the current x, y from screen coordinates to world coordinates
     * @param point  Screen coordinate to convert
     */ screenToWorldCoordinates(point) {
            return this.screen.screenToWorldCoordinates(point);
        }
        /**
     * Transforms a world coordinate, to a screen coordinate
     * @param point  World coordinate to convert
     */ worldToScreenCoordinates(point) {
            return this.screen.worldToScreenCoordinates(point);
        }
        /**
     * Initializes the internal canvas, rendering context, display mode, and native event listeners
     */ _initialize(options) {
            var _a, _b;
            this.pageScrollPreventionMode = options.scrollPreventionMode;
            // initialize inputs
            const pointerTarget = options && options.pointerScope === PointerScope.Document ? document : this.canvas;
            const grabWindowFocus = (_b = (_a = this._originalOptions) === null || _a === void 0 ? void 0 : _a.grabWindowFocus) !== null && _b !== void 0 ? _b : true;
            this.input = new InputHost({
                pointerTarget: pointerTarget,
                grabWindowFocus: grabWindowFocus,
                engine: this
            });
            this.inputMapper = this.input.inputMapper;
            // Issue #385 make use of the visibility api
            // https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API
            this.browser.document.on("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") {
                    this.events.emit("hidden", new HiddenEvent(this));
                    this._logger.debug("Window hidden");
                } else if (document.visibilityState === "visible") {
                    this.events.emit("visible", new VisibleEvent(this));
                    this._logger.debug("Window visible");
                }
            });
            if (!this.canvasElementId && !options.canvasElement) document.body.appendChild(this.canvas);
        }
        toggleInputEnabled(enabled) {
            this._inputEnabled = enabled;
            this.input.toggleEnabled(this._inputEnabled);
        }
        onInitialize(engine) {
        // Override me
        }
        /**
     * If supported by the browser, this will set the antialiasing flag on the
     * canvas. Set this to `false` if you want a 'jagged' pixel art look to your
     * image resources.
     * @param isSmooth  Set smoothing to true or false
     * @deprecated Set in engine constructor, will be removed in v0.30
     */ setAntialiasing(isSmooth) {
            this.screen.antialiasing = isSmooth;
        }
        /**
     * Return the current smoothing status of the canvas
     * @deprecated Set in engine constructor, will be removed in v0.30
     */ getAntialiasing() {
            return this.screen.antialiasing;
        }
        /**
     * Gets whether the actor is Initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        async _overrideInitialize(engine) {
            if (!this.isInitialized) {
                await this.director.onInitialize();
                await this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * Updates the entire state of the game
     * @param delta  Number of milliseconds elapsed since the last update.
     */ _update(delta) {
            var _a;
            if (this._isLoading) {
                // suspend updates until loading is finished
                (_a = this._loader) === null || _a === void 0 || _a.onUpdate(this, delta);
                // Update input listeners
                this.input.update();
                return;
            }
            // Publish preupdate events
            this.clock.__runScheduledCbs("preupdate");
            this._preupdate(delta);
            // process engine level events
            this.currentScene.update(this, delta);
            // Update graphics postprocessors
            this.graphicsContext.updatePostProcessors(delta);
            // Publish update event
            this.clock.__runScheduledCbs("postupdate");
            this._postupdate(delta);
            // Update input listeners
            this.input.update();
        }
        /**
     * @internal
     */ _preupdate(delta) {
            this.emit("preupdate", new PreUpdateEvent(this, delta, this));
            this.onPreUpdate(this, delta);
        }
        onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * @internal
     */ _postupdate(delta) {
            this.emit("postupdate", new PostUpdateEvent(this, delta, this));
            this.onPostUpdate(this, delta);
        }
        onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     * Draws the entire game
     * @param delta  Number of milliseconds elapsed since the last draw.
     */ _draw(delta) {
            var _a, _b;
            this.graphicsContext.beginDrawLifecycle();
            this.graphicsContext.clear();
            this.clock.__runScheduledCbs("predraw");
            this._predraw(this.graphicsContext, delta);
            // Drawing nothing else while loading
            if (this._isLoading) {
                if (!this._hideLoader) {
                    (_a = this._loader) === null || _a === void 0 || _a.canvas.draw(this.graphicsContext, 0, 0);
                    this.clock.__runScheduledCbs("postdraw");
                    this.graphicsContext.flush();
                    this.graphicsContext.endDrawLifecycle();
                }
                return;
            }
            // Use scene background color if present, fallback to engine
            this.graphicsContext.backgroundColor = (_b = this.currentScene.backgroundColor) !== null && _b !== void 0 ? _b : this.backgroundColor;
            this.currentScene.draw(this.graphicsContext, delta);
            this.clock.__runScheduledCbs("postdraw");
            this._postdraw(this.graphicsContext, delta);
            // Flush any pending drawings
            this.graphicsContext.flush();
            this.graphicsContext.endDrawLifecycle();
            this._checkForScreenShots();
        }
        /**
     * @internal
     */ _predraw(ctx, delta) {
            this.emit("predraw", new PreDrawEvent(ctx, delta, this));
            this.onPreDraw(ctx, delta);
        }
        onPreDraw(ctx, delta) {
        // Override me
        }
        /**
     * @internal
     */ _postdraw(ctx, delta) {
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
            this.onPostDraw(ctx, delta);
        }
        onPostDraw(ctx, delta) {
        // Override me
        }
        /**
     * Enable or disable Excalibur debugging functionality.
     * @param toggle a value that debug drawing will be changed to
     */ showDebug(toggle) {
            this._isDebug = toggle;
        }
        /**
     * Toggle Excalibur debugging functionality.
     */ toggleDebug() {
            this._isDebug = !this._isDebug;
            return this._isDebug;
        }
        /**
     * Returns true when loading is totally complete and the player has clicked start
     */ get loadingComplete() {
            return !this._isLoading;
        }
        get ready() {
            return this._isReadyFuture.isCompleted;
        }
        isReady() {
            return this._isReadyFuture.promise;
        }
        async start(sceneNameOrLoader, options) {
            await this.scope(async ()=>{
                if (!this._compatible) throw new Error("Excalibur is incompatible with your browser");
                this._isLoading = true;
                let loader;
                if (sceneNameOrLoader instanceof DefaultLoader) loader = sceneNameOrLoader;
                else if (typeof sceneNameOrLoader === "string") {
                    this.director.configureStart(sceneNameOrLoader, options);
                    loader = this.director.mainLoader;
                }
                // Start the excalibur clock which drives the mainloop
                this._logger.debug("Starting game clock...");
                this.browser.resume();
                this.clock.start();
                this._logger.debug("Game clock started");
                await this.load(loader !== null && loader !== void 0 ? loader : new Loader());
                // Initialize before ready
                await this._overrideInitialize(this);
                this._isReadyFuture.resolve();
                this.emit("start", new GameStartEvent(this));
                return this._isReadyFuture.promise;
            });
        }
        _mainloop(elapsed) {
            this.scope(()=>{
                this.emit("preframe", new PreFrameEvent(this, this.stats.prevFrame));
                const delta = elapsed * this.timescale;
                this.currentFrameElapsedMs = delta;
                // reset frame stats (reuse existing instances)
                const frameId = this.stats.prevFrame.id + 1;
                this.stats.currFrame.reset();
                this.stats.currFrame.id = frameId;
                this.stats.currFrame.delta = delta;
                this.stats.currFrame.fps = this.clock.fpsSampler.fps;
                GraphicsDiagnostics.clear();
                const beforeUpdate = this.clock.now();
                const fixedTimestepMs = 1000 / this.fixedUpdateFps;
                if (this.fixedUpdateFps) {
                    this._lagMs += delta;
                    while(this._lagMs >= fixedTimestepMs){
                        this._update(fixedTimestepMs);
                        this._lagMs -= fixedTimestepMs;
                    }
                } else this._update(delta);
                const afterUpdate = this.clock.now();
                this.currentFrameLagMs = this._lagMs;
                this._draw(delta);
                const afterDraw = this.clock.now();
                this.stats.currFrame.duration.update = afterUpdate - beforeUpdate;
                this.stats.currFrame.duration.draw = afterDraw - afterUpdate;
                this.stats.currFrame.graphics.drawnImages = GraphicsDiagnostics.DrawnImagesCount;
                this.stats.currFrame.graphics.drawCalls = GraphicsDiagnostics.DrawCallCount;
                this.emit("postframe", new PostFrameEvent(this, this.stats.currFrame));
                this.stats.prevFrame.reset(this.stats.currFrame);
                this._monitorPerformanceThresholdAndTriggerFallback();
            });
        }
        /**
     * Stops Excalibur's main loop, useful for pausing the game.
     */ stop() {
            if (this.clock.isRunning()) {
                this.emit("stop", new GameStopEvent(this));
                this.browser.pause();
                this.clock.stop();
                this._logger.debug("Game stopped");
            }
        }
        /**
     * Returns the Engine's running status, Useful for checking whether engine is running or paused.
     */ isRunning() {
            return this.clock.isRunning();
        }
        /**
     * Takes a screen shot of the current viewport and returns it as an
     * HTML Image Element.
     * @param preserveHiDPIResolution in the case of HiDPI return the full scaled backing image, by default false
     */ screenshot(preserveHiDPIResolution = false) {
            const screenShotPromise = new Promise((resolve)=>{
                this._screenShotRequests.push({
                    preserveHiDPIResolution: preserveHiDPIResolution,
                    resolve: resolve
                });
            });
            return screenShotPromise;
        }
        _checkForScreenShots() {
            // We must grab the draw buffer before we yield to the browser
            // the draw buffer is cleared after compositing
            // the reason for the asynchrony is setting `preserveDrawingBuffer: true`
            // forces the browser to copy buffers which can have a mass perf impact on mobile
            for (const request of this._screenShotRequests){
                const finalWidth = request.preserveHiDPIResolution ? this.canvas.width : this.screen.resolution.width;
                const finalHeight = request.preserveHiDPIResolution ? this.canvas.height : this.screen.resolution.height;
                const screenshot = document.createElement("canvas");
                screenshot.width = finalWidth;
                screenshot.height = finalHeight;
                const ctx = screenshot.getContext("2d");
                ctx.imageSmoothingEnabled = this.screen.antialiasing;
                ctx.drawImage(this.canvas, 0, 0, finalWidth, finalHeight);
                const result = new Image();
                const raw = screenshot.toDataURL("image/png");
                result.src = raw;
                request.resolve(result);
            }
            // Reset state
            this._screenShotRequests.length = 0;
        }
        /**
     * Another option available to you to load resources into the game.
     * Immediately after calling this the game will pause and the loading screen
     * will appear.
     * @param loader  Some [[Loadable]] such as a [[Loader]] collection, [[Sound]], or [[Texture]].
     */ async load(loader, hideLoader = false) {
            await this.scope(async ()=>{
                try {
                    // early exit if loaded
                    if (loader.isLoaded()) return;
                    this._loader = loader;
                    this._isLoading = true;
                    this._hideLoader = hideLoader;
                    if (loader instanceof Loader) loader.suppressPlayButton = loader.suppressPlayButton || this._suppressPlayButton;
                    this._loader.onInitialize(this);
                    await loader.load();
                } catch (e) {
                    this._logger.error("Error loading resources, things may not behave properly", e);
                    await Promise.resolve();
                } finally{
                    this._isLoading = false;
                    this._hideLoader = false;
                    this._loader = null;
                }
            });
        }
    }
    Engine.Context = createContext();
    Engine.InstanceCount = 0;
    /**
 * Default [[EngineOptions]]
 */ Engine._DEFAULT_ENGINE_OPTIONS = {
        width: 0,
        height: 0,
        enableCanvasTransparency: true,
        useDrawSorting: true,
        configurePerformanceCanvas2DFallback: {
            allow: false,
            showPlayerMessage: false,
            threshold: {
                fps: 20,
                numberOfFrames: 100
            }
        },
        canvasElementId: "",
        canvasElement: undefined,
        snapToPixel: false,
        antialiasing: true,
        pixelArt: false,
        powerPreference: "high-performance",
        pointerScope: PointerScope.Canvas,
        suppressConsoleBootMessage: null,
        suppressMinimumBrowserFeatureDetection: null,
        suppressHiDPIScaling: null,
        suppressPlayButton: null,
        grabWindowFocus: true,
        scrollPreventionMode: ScrollPreventionMode.Canvas,
        backgroundColor: Color.fromHex("#2185d0") // Excalibur blue
    };
    /**
 * @deprecated Use [[EventEmitter]] will be removed in v0.29.0
 */ class EventDispatcher {
        constructor(){
            this._handlers = {};
            this._wiredEventDispatchers = [];
            this._deferedHandlerRemovals = [];
        }
        /**
     * Clears any existing handlers or wired event dispatchers on this event dispatcher
     */ clear() {
            this._handlers = {};
            this._wiredEventDispatchers = [];
        }
        _processDeferredHandlerRemovals() {
            for (const eventHandler of this._deferedHandlerRemovals)this._removeHandler(eventHandler.name, eventHandler.handler);
            this._deferedHandlerRemovals.length = 0;
        }
        /**
     * Emits an event for target
     * @param eventName  The name of the event to publish
     * @param event      Optionally pass an event data object to the handler
     */ emit(eventName, event) {
            this._processDeferredHandlerRemovals();
            if (!eventName) // key not mapped
            return;
            eventName = eventName.toLowerCase();
            if (typeof event === "undefined" || event === null) event = new GameEvent();
            let i, len;
            if (this._handlers[eventName]) {
                i = 0;
                len = this._handlers[eventName].length;
                for(i; i < len; i++)this._handlers[eventName][i](event);
            }
            i = 0;
            len = this._wiredEventDispatchers.length;
            for(i; i < len; i++)this._wiredEventDispatchers[i].emit(eventName, event);
        }
        /**
     * Subscribe an event handler to a particular event name, multiple handlers per event name are allowed.
     * @param eventName  The name of the event to subscribe to
     * @param handler    The handler callback to fire on this event
     */ on(eventName, handler) {
            this._processDeferredHandlerRemovals();
            eventName = eventName.toLowerCase();
            if (!this._handlers[eventName]) this._handlers[eventName] = [];
            this._handlers[eventName].push(handler);
        }
        /**
     * Unsubscribe an event handler(s) from an event. If a specific handler
     * is specified for an event, only that handler will be unsubscribed.
     * Otherwise all handlers will be unsubscribed for that event.
     * @param eventName  The name of the event to unsubscribe
     * @param handler    Optionally the specific handler to unsubscribe
     */ off(eventName, handler) {
            this._deferedHandlerRemovals.push({
                name: eventName,
                handler: handler
            });
        }
        _removeHandler(eventName, handler) {
            eventName = eventName.toLowerCase();
            const eventHandlers = this._handlers[eventName];
            if (eventHandlers) {
                // if no explicit handler is give with the event name clear all handlers
                if (!handler) this._handlers[eventName].length = 0;
                else {
                    const index = eventHandlers.indexOf(handler);
                    if (index > -1) this._handlers[eventName].splice(index, 1);
                }
            }
        }
        /**
     * Once listens to an event one time, then unsubscribes from that event
     * @param eventName The name of the event to subscribe to once
     * @param handler   The handler of the event that will be auto unsubscribed
     */ once(eventName, handler) {
            this._processDeferredHandlerRemovals();
            const metaHandler = (event)=>{
                const ev = event || new GameEvent();
                this.off(eventName, metaHandler);
                handler(ev);
            };
            this.on(eventName, metaHandler);
        }
        /**
     * Wires this event dispatcher to also receive events from another
     */ wire(eventDispatcher) {
            eventDispatcher._wiredEventDispatchers.push(this);
        }
        /**
     * Unwires this event dispatcher from another
     */ unwire(eventDispatcher) {
            const index = eventDispatcher._wiredEventDispatchers.indexOf(this);
            if (index > -1) eventDispatcher._wiredEventDispatchers.splice(index, 1);
        }
    }
    /**
 * Labels are the way to draw small amounts of text to the screen. They are
 * actors and inherit all of the benefits and capabilities.
 */ class Label extends Actor {
        get font() {
            return this._font;
        }
        set font(newFont) {
            this._font = newFont;
            this._text.font = newFont;
        }
        /**
     * The text to draw.
     */ get text() {
            return this._text.text;
        }
        set text(text) {
            this._text.text = text;
        }
        get color() {
            return this._text.color;
        }
        set color(color) {
            if (this._text) this._text.color = color;
        }
        get opacity() {
            return this._text.opacity;
        }
        set opacity(opacity) {
            this._text.opacity = opacity;
        }
        /**
     * The [[SpriteFont]] to use, if any. Overrides [[Font|font]] if present.
     */ get spriteFont() {
            return this._spriteFont;
        }
        set spriteFont(sf) {
            if (sf) {
                this._spriteFont = sf;
                this._text.font = this._spriteFont;
            }
        }
        /**
     * Build a new label
     * @param options
     */ constructor(options){
            super(options);
            this._font = new Font();
            this._text = new Text({
                text: "",
                font: this._font
            });
            const { text: text, pos: pos, x: x, y: y, spriteFont: spriteFont, font: font, color: color } = {
                text: "",
                ...options
            };
            this.pos = pos !== null && pos !== void 0 ? pos : x && y ? vec(x, y) : this.pos;
            this.text = text !== null && text !== void 0 ? text : this.text;
            this.font = font !== null && font !== void 0 ? font : this.font;
            this.spriteFont = spriteFont !== null && spriteFont !== void 0 ? spriteFont : this.spriteFont;
            this._text.color = color !== null && color !== void 0 ? color : this.color;
            const gfx = this.get(GraphicsComponent);
            gfx.anchor = Vector.Zero;
            gfx.use(this._text);
        }
        _initialize(engine) {
            super._initialize(engine);
        }
        /**
     * Returns the width of the text in the label (in pixels);
     */ getTextWidth() {
            return this._text.width;
        }
    }
    class IsometricTile extends Entity {
        getGraphics() {
            return this._graphics;
        }
        /**
     * Tile graphics
     */ addGraphic(graphic, options) {
            this._graphics.push(graphic);
            this._gfx.visible = this.map.visible;
            this._gfx.opacity = this.map.opacity;
            if (options === null || options === void 0 ? void 0 : options.offset) this._gfx.offset = options.offset;
            // TODO detect when this changes on the map and apply to all tiles
            this._gfx.localBounds = this._recalculateBounds();
        }
        _recalculateBounds() {
            let bounds = this._tileBounds.clone();
            for (const graphic of this._graphics){
                const offset = vec(this.map.graphicsOffset.x - this.map.tileWidth / 2, this.map.graphicsOffset.y - (this.map.renderFromTopOfGraphic ? 0 : graphic.height - this.map.tileHeight));
                bounds = bounds.combine(graphic.localBounds.translate(offset));
            }
            return bounds;
        }
        removeGraphic(graphic) {
            const index = this._graphics.indexOf(graphic);
            if (index > -1) this._graphics.splice(index, 1);
            this._gfx.localBounds = this._recalculateBounds();
        }
        clearGraphics() {
            this._graphics.length = 0;
            this._gfx.visible = false;
            this._gfx.localBounds = this._recalculateBounds();
        }
        getColliders() {
            return this._colliders;
        }
        /**
     * Adds a collider to the IsometricTile
     *
     * **Note!** the [[Tile.solid]] must be set to true for it to act as a "fixed" collider
     * @param collider
     */ addCollider(collider) {
            this._colliders.push(collider);
            this.map.flagCollidersDirty();
        }
        /**
     * Removes a collider from the IsometricTile
     * @param collider
     */ removeCollider(collider) {
            const index = this._colliders.indexOf(collider);
            if (index > -1) this._colliders.splice(index, 1);
            this.map.flagCollidersDirty();
        }
        /**
     * Clears all colliders from the IsometricTile
     */ clearColliders() {
            this._colliders.length = 0;
            this.map.flagCollidersDirty();
        }
        /**
     * Returns the top left corner of the [[IsometricTile]] in world space
     */ get pos() {
            return this.map.tileToWorld(vec(this.x, this.y));
        }
        /**
     * Returns the center of the [[IsometricTile]]
     */ get center() {
            return this.pos.add(vec(0, this.map.tileHeight / 2));
        }
        /**
     * Construct a new IsometricTile
     * @param x tile coordinate in x (not world position)
     * @param y tile coordinate in y (not world position)
     * @param graphicsOffset offset that tile should be shifted by (default (0, 0))
     * @param map reference to owning IsometricMap
     */ constructor(x, y, graphicsOffset, map){
            super([
                new TransformComponent(),
                new GraphicsComponent({
                    offset: graphicsOffset !== null && graphicsOffset !== void 0 ? graphicsOffset : Vector.Zero,
                    onPostDraw: (gfx, elapsed)=>this.draw(gfx, elapsed)
                }),
                new IsometricEntityComponent(map)
            ]);
            /**
         * Indicates whether this tile is solid
         */ this.solid = false;
            this.events = new EventEmitter();
            this._tileBounds = new BoundingBox();
            this._graphics = [];
            /**
         * Tile colliders
         */ this._colliders = [];
            /**
         * Arbitrary data storage per tile, useful for any game specific data
         */ this.data = new Map();
            this.x = x;
            this.y = y;
            this.map = map;
            this._transform = this.get(TransformComponent);
            this._isometricEntityComponent = this.get(IsometricEntityComponent);
            const halfTileWidth = this.map.tileWidth / 2;
            const halfTileHeight = this.map.tileHeight / 2;
            // See https://clintbellanger.net/articles/isometric_math/ for formula
            // The x position shifts left with every y step
            const xPos = (this.x - this.y) * halfTileWidth;
            // The y position needs to go down with every x step
            const yPos = (this.x + this.y) * halfTileHeight;
            this._transform.pos = vec(xPos, yPos);
            this._isometricEntityComponent.elevation = map.elevation;
            this._gfx = this.get(GraphicsComponent);
            this._gfx.visible = false; // start not visible
            const totalWidth = this.map.tileWidth;
            const totalHeight = this.map.tileHeight;
            // initial guess at gfx bounds based on the tile
            const offset = vec(0, this.map.renderFromTopOfGraphic ? totalHeight : 0);
            this._gfx.localBounds = this._tileBounds = new BoundingBox({
                left: -totalWidth / 2,
                top: -totalHeight,
                right: totalWidth / 2,
                bottom: totalHeight
            }).translate(offset);
        }
        draw(gfx, _elapsed) {
            const halfTileWidth = this.map.tileWidth / 2;
            gfx.save();
            // shift left origin to corner of map, not the left corner of the first sprite
            gfx.translate(-halfTileWidth, 0);
            for (const graphic of this._graphics)graphic.draw(gfx, this.map.graphicsOffset.x, this.map.graphicsOffset.y - (this.map.renderFromTopOfGraphic ? 0 : graphic.height - this.map.tileHeight));
            gfx.restore();
        }
    }
    /**
 * The IsometricMap is a special tile map that provides isometric rendering support to Excalibur
 *
 * The tileWidth and tileHeight should be the height and width in pixels of the parallelogram of the base of the tile art asset.
 * The tileWidth and tileHeight is not necessarily the same as your graphic pixel width and height.
 *
 * Please refer to the docs https://excaliburjs.com for more details calculating what your tile width and height should be given
 * your art assets.
 */ class IsometricMap extends Entity {
        constructor(options){
            super([
                new TransformComponent(),
                new BodyComponent({
                    type: CollisionType.Fixed
                }),
                new ColliderComponent(),
                new PointerComponent(),
                new DebugGraphicsComponent((ctx, debugFlags)=>this.debug(ctx, debugFlags), false)
            ], options.name);
            this.elevation = 0;
            /**
         * Whether tiles should be visible
         */ this.visible = true;
            /**
         * Opacity of tiles
         */ this.opacity = 1.0;
            /**
         * Render the tile graphic from the top instead of the bottom
         *
         * default is `false` meaning rendering from the bottom
         */ this.renderFromTopOfGraphic = false;
            this.graphicsOffset = vec(0, 0);
            this._forwardPointerEventToTile = (eventType)=>(evt)=>{
                    const tile = this.getTileByPoint(evt.worldPos);
                    if (tile) tile.events.emit(eventType, evt);
                };
            this._collidersDirty = false;
            this._originalOffsets = new WeakMap();
            const { pos: pos, tileWidth: tileWidth, tileHeight: tileHeight, columns: width, rows: height, renderFromTopOfGraphic: renderFromTopOfGraphic, graphicsOffset: graphicsOffset, elevation: elevation } = options;
            this.transform = this.get(TransformComponent);
            if (pos) this.transform.pos = pos;
            this.collider = this.get(ColliderComponent);
            if (this.collider) this.collider.set(this._composite = new CompositeCollider([]));
            this.pointer = this.get(PointerComponent);
            this.renderFromTopOfGraphic = renderFromTopOfGraphic !== null && renderFromTopOfGraphic !== void 0 ? renderFromTopOfGraphic : this.renderFromTopOfGraphic;
            this.graphicsOffset = graphicsOffset !== null && graphicsOffset !== void 0 ? graphicsOffset : this.graphicsOffset;
            this.elevation = elevation !== null && elevation !== void 0 ? elevation : this.elevation;
            this.tileWidth = tileWidth;
            this.tileHeight = tileHeight;
            this.columns = width;
            this.rows = height;
            this.tiles = new Array(width * height);
            // build up tile representation
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const tile = new IsometricTile(x, y, this.graphicsOffset, this);
                this.tiles[x + y * width] = tile;
                this.addChild(tile);
            }
            this.pointer.localBounds = BoundingBox.fromDimension(tileWidth * width * this.transform.scale.x, tileHeight * height * this.transform.scale.y, vec(.5, 0));
            this._setupPointerToTile();
        }
        _setupPointerToTile() {
            this.events.on("pointerup", this._forwardPointerEventToTile("pointerup"));
            this.events.on("pointerdown", this._forwardPointerEventToTile("pointerdown"));
            this.events.on("pointermove", this._forwardPointerEventToTile("pointermove"));
            this.events.on("pointercancel", this._forwardPointerEventToTile("pointercancel"));
        }
        update() {
            if (this._collidersDirty) {
                this.updateColliders();
                this._collidersDirty = false;
            }
        }
        flagCollidersDirty() {
            this._collidersDirty = true;
        }
        _getOrSetColliderOriginalOffset(collider) {
            if (!this._originalOffsets.has(collider)) {
                const originalOffset = collider.offset;
                this._originalOffsets.set(collider, originalOffset);
                return originalOffset;
            } else return this._originalOffsets.get(collider);
        }
        updateColliders() {
            this._composite.clearColliders();
            const pos = this.get(TransformComponent).pos;
            for (const tile of this.tiles){
                if (tile.solid) for (const collider of tile.getColliders()){
                    const originalOffset = this._getOrSetColliderOriginalOffset(collider);
                    collider.offset = this.tileToWorld(vec(tile.x, tile.y)).sub(pos).add(originalOffset).sub(vec(this.tileWidth / 2, this.tileHeight)); // We need to unshift height based on drawing
                    collider.owner = this;
                    this._composite.addCollider(collider);
                }
            }
            this.collider.update();
        }
        /**
     * Convert world space coordinates to the tile x, y coordinate
     * @param worldCoordinate
     */ worldToTile(worldCoordinate) {
            // TODO I don't think this handles parent transform see TileMap
            worldCoordinate = worldCoordinate.sub(this.transform.globalPos);
            const halfTileWidth = this.tileWidth / 2;
            const halfTileHeight = this.tileHeight / 2;
            // See https://clintbellanger.net/articles/isometric_math/ for formula
            return vec(~~((worldCoordinate.x / halfTileWidth + worldCoordinate.y / halfTileHeight) / 2), ~~((worldCoordinate.y / halfTileHeight - worldCoordinate.x / halfTileWidth) / 2));
        }
        /**
     * Given a tile coordinate, return the top left corner in world space
     * @param tileCoordinate
     */ tileToWorld(tileCoordinate) {
            const halfTileWidth = this.tileWidth / 2;
            const halfTileHeight = this.tileHeight / 2;
            // The x position shifts left with every y step
            const xPos = (tileCoordinate.x - tileCoordinate.y) * halfTileWidth;
            // The y position needs to go down with every x step
            const yPos = (tileCoordinate.x + tileCoordinate.y) * halfTileHeight;
            return vec(xPos, yPos).add(this.transform.pos);
        }
        /**
     * Returns the [[IsometricTile]] by its x and y coordinates
     */ getTile(x, y) {
            if (x < 0 || y < 0 || x >= this.columns || y >= this.rows) return null;
            return this.tiles[x + y * this.columns];
        }
        /**
     * Returns the [[IsometricTile]] by testing a point in world coordinates,
     * returns `null` if no Tile was found.
     */ getTileByPoint(point) {
            const tileCoord = this.worldToTile(point);
            const tile = this.getTile(tileCoord.x, tileCoord.y);
            return tile;
        }
        _getMaxZIndex() {
            let maxZ = Number.NEGATIVE_INFINITY;
            for (const tile of this.tiles){
                const currentZ = tile.get(TransformComponent).z;
                if (currentZ > maxZ) maxZ = currentZ;
            }
            return maxZ;
        }
        /**
     * Debug draw for IsometricMap, called internally by excalibur when debug mode is toggled on
     * @param gfx
     */ debug(gfx, debugFlags) {
            const { showAll: showAll, showPosition: showPosition, positionColor: positionColor, positionSize: positionSize, showGrid: showGrid, gridColor: gridColor, gridWidth: gridWidth, showColliderGeometry: showColliderGeometry } = debugFlags.isometric;
            const { geometryColor: geometryColor, geometryLineWidth: geometryLineWidth, geometryPointSize: geometryPointSize } = debugFlags.collider;
            gfx.save();
            gfx.z = this._getMaxZIndex() + 0.5;
            if (showAll || showGrid) {
                for(let y = 0; y < this.rows + 1; y++){
                    const left = this.tileToWorld(vec(0, y));
                    const right = this.tileToWorld(vec(this.columns, y));
                    gfx.drawLine(left, right, gridColor, gridWidth);
                }
                for(let x = 0; x < this.columns + 1; x++){
                    const top = this.tileToWorld(vec(x, 0));
                    const bottom = this.tileToWorld(vec(x, this.rows));
                    gfx.drawLine(top, bottom, gridColor, gridWidth);
                }
            }
            if (showAll || showPosition) for (const tile of this.tiles)gfx.drawCircle(this.tileToWorld(vec(tile.x, tile.y)), positionSize, positionColor);
            if (showAll || showColliderGeometry) for (const tile of this.tiles){
                if (tile.solid) for (const collider of tile.getColliders())collider.debug(gfx, geometryColor, {
                    lineWidth: geometryLineWidth,
                    pointSize: geometryPointSize
                });
            }
            gfx.restore();
        }
    }
    /**
 * Action that can represent a sequence of actions, this can be useful in conjunction with
 * [[ParallelActions]] to run multiple sequences in parallel.
 */ class ActionSequence {
        constructor(entity, actionBuilder){
            this._stopped = false;
            this._sequenceBuilder = actionBuilder;
            this._sequenceContext = new ActionContext(entity);
            this._actionQueue = this._sequenceContext.getQueue();
            this._sequenceBuilder(this._sequenceContext);
        }
        update(delta) {
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped || this._actionQueue.isComplete();
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._stopped = false;
            this._actionQueue.reset();
        }
        clone(entity) {
            return new ActionSequence(entity, this._sequenceBuilder);
        }
    }
    /**
 * Action that can run multiple [[Action]]s or [[ActionSequence]]s at the same time
 */ class ParallelActions {
        constructor(parallelActions){
            this._actions = parallelActions;
        }
        update(delta) {
            for(let i = 0; i < this._actions.length; i++)this._actions[i].update(delta);
        }
        isComplete(entity) {
            return this._actions.every((a)=>a.isComplete(entity));
        }
        reset() {
            this._actions.forEach((a)=>a.reset());
        }
        stop() {
            this._actions.forEach((a)=>a.stop());
        }
    }
    /**
 * QuadTree spatial data structure. Useful for quickly retrieving all objects that might
 * be in a specific location.
 */ class QuadTree {
        constructor(bounds, options){
            this.bounds = bounds;
            this.options = options;
            this._defaultOptions = {
                maxDepth: 10,
                capacity: 10,
                level: 0
            };
            this.items = [];
            this._isDivided = false;
            this.topLeft = null;
            this.topRight = null;
            this.bottomLeft = null;
            this.bottomRight = null;
            this.options = {
                ...this._defaultOptions,
                ...options
            };
            this.halfWidth = bounds.width / 2;
            this.halfHeight = bounds.height / 2;
        }
        /**
     * Splits the quad tree one level deeper
     */ _split() {
            this._isDivided = true;
            const newLevelOptions = {
                maxDepth: this.options.maxDepth,
                capacity: this.options.capacity,
                level: this.options.level + 1
            };
            this.topLeft = new QuadTree(new BoundingBox({
                left: this.bounds.left,
                top: this.bounds.top,
                right: this.bounds.left + this.halfWidth,
                bottom: this.bounds.top + this.halfHeight
            }), newLevelOptions);
            this.topRight = new QuadTree(new BoundingBox({
                left: this.bounds.left + this.halfWidth,
                top: this.bounds.top,
                right: this.bounds.right,
                bottom: this.bounds.top + this.halfHeight
            }), newLevelOptions);
            this.bottomLeft = new QuadTree(new BoundingBox({
                left: this.bounds.left,
                top: this.bounds.top + this.halfHeight,
                right: this.bounds.left + this.halfWidth,
                bottom: this.bounds.bottom
            }), newLevelOptions);
            this.bottomRight = new QuadTree(new BoundingBox({
                left: this.bounds.left + this.halfWidth,
                top: this.bounds.top + this.halfHeight,
                right: this.bounds.right,
                bottom: this.bounds.bottom
            }), newLevelOptions);
        }
        _insertIntoSubNodes(item) {
            var _a, _b, _c, _d;
            if ((_a = this.topLeft) === null || _a === void 0 ? void 0 : _a.bounds.overlaps(item.bounds)) this.topLeft.insert(item);
            if ((_b = this.topRight) === null || _b === void 0 ? void 0 : _b.bounds.overlaps(item.bounds)) this.topRight.insert(item);
            if ((_c = this.bottomLeft) === null || _c === void 0 ? void 0 : _c.bounds.overlaps(item.bounds)) this.bottomLeft.insert(item);
            if ((_d = this.bottomRight) === null || _d === void 0 ? void 0 : _d.bounds.overlaps(item.bounds)) this.bottomRight.insert(item);
        }
        /**
     * Insert an item to be tracked in the QuadTree
     * @param item
     */ insert(item) {
            // add to subnodes if it matches
            if (this._isDivided) {
                this._insertIntoSubNodes(item);
                return;
            }
            // leaf case
            this.items.push(item);
            // capacity
            if (this.items.length > this.options.capacity && this.options.level < this.options.maxDepth) {
                if (!this._isDivided) this._split();
                // divide this level's items into it's subnodes
                for (const item of this.items)this._insertIntoSubNodes(item);
                // clear this level
                this.items.length = 0;
            }
        }
        /**
     * Remove a tracked item in the QuadTree
     * @param item
     */ remove(item) {
            var _a, _b, _c, _d;
            if (!this.bounds.overlaps(item.bounds)) return;
            if (!this._isDivided) {
                const index = this.items.indexOf(item);
                if (index > -1) this.items.splice(index, 1);
                return;
            }
            if ((_a = this.topLeft) === null || _a === void 0 ? void 0 : _a.bounds.overlaps(item.bounds)) this.topLeft.remove(item);
            if ((_b = this.topRight) === null || _b === void 0 ? void 0 : _b.bounds.overlaps(item.bounds)) this.topRight.remove(item);
            if ((_c = this.bottomLeft) === null || _c === void 0 ? void 0 : _c.bounds.overlaps(item.bounds)) this.bottomLeft.remove(item);
            if ((_d = this.bottomRight) === null || _d === void 0 ? void 0 : _d.bounds.overlaps(item.bounds)) this.bottomRight.remove(item);
        }
        /**
     * Query the structure for all objects that intersect the bounding box
     * @param boundingBox
     * @returns items
     */ query(boundingBox) {
            let results = this.items;
            if (this._isDivided) {
                if (this.topLeft.bounds.overlaps(boundingBox)) results = results.concat(this.topLeft.query(boundingBox));
                if (this.topRight.bounds.overlaps(boundingBox)) results = results.concat(this.topRight.query(boundingBox));
                if (this.bottomLeft.bounds.overlaps(boundingBox)) results = results.concat(this.bottomLeft.query(boundingBox));
                if (this.bottomRight.bounds.overlaps(boundingBox)) results = results.concat(this.bottomRight.query(boundingBox));
            }
            results = results.filter((item, index)=>{
                return results.indexOf(item) >= index;
            });
            return results;
        }
        clear() {
            this.items = [];
            this._isDivided = false;
            this.topLeft = null;
            this.topRight = null;
            this.bottomLeft = null;
            this.bottomRight = null;
        }
        getAllItems() {
            let results = this.items;
            if (this._isDivided) {
                results = results.concat(this.topLeft.getAllItems());
                results = results.concat(this.topRight.getAllItems());
                results = results.concat(this.bottomLeft.getAllItems());
                results = results.concat(this.bottomRight.getAllItems());
            }
            results = results.filter((item, index)=>{
                return results.indexOf(item) >= index;
            });
            return results;
        }
        getTreeDepth() {
            if (!this._isDivided) return 0;
            return 1 + Math.max(this.topLeft.getTreeDepth(), this.topRight.getTreeDepth(), this.bottomLeft.getTreeDepth(), this.bottomRight.getTreeDepth());
        }
        debug(ctx) {
            this.bounds.draw(ctx, Color.Yellow);
            if (this._isDivided) {
                this.topLeft.bounds.draw(ctx, Color.Yellow);
                this.topRight.bounds.draw(ctx, Color.Yellow);
                this.bottomLeft.bounds.draw(ctx, Color.Yellow);
                this.bottomRight.bounds.draw(ctx, Color.Yellow);
            }
        }
    }
    /**
 * Type guard checking for internal initialize method
 * @internal
 * @param a
 */ function has_initialize(a) {
        return !!a._initialize;
    }
    /**
 *
 */ function hasOnInitialize(a) {
        return !!a.onInitialize;
    }
    /**
 *
 */ function has_preupdate(a) {
        return !!a._preupdate;
    }
    /**
 *
 */ function hasOnPreUpdate(a) {
        return !!a.onPreUpdate;
    }
    /**
 *
 */ function has_postupdate(a) {
        return !!a.onPostUpdate;
    }
    /**
 *
 */ function hasOnPostUpdate(a) {
        return !!a.onPostUpdate;
    }
    /**
 *
 */ function hasPreDraw(a) {
        return !!a.onPreDraw;
    }
    /**
 *
 */ function hasPostDraw(a) {
        return !!a.onPostDraw;
    }
    /**
 * The [[Texture]] object allows games built in Excalibur to load image resources.
 * [[Texture]] is an [[Loadable]] which means it can be passed to a [[Loader]]
 * to pre-load before starting a level or game.
 */ class Gif {
        /**
     * @param path       Path to the image resource
     * @param color      Optionally set the color to treat as transparent the gif, by default [[Color.Magenta]]
     * @param bustCache  Optionally load texture with cache busting
     */ constructor(path, color = Color.Magenta, bustCache = false){
            this.path = path;
            this.color = color;
            this._stream = null;
            this._gif = null;
            this._textures = [];
            this._animation = null;
            this._transparentColor = null;
            this._resource = new Resource(path, "arraybuffer", bustCache);
            this._transparentColor = color;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * Begins loading the texture and returns a promise to be resolved on completion
     */ async load() {
            const arraybuffer = await this._resource.load();
            this._stream = new Stream(arraybuffer);
            this._gif = new ParseGif(this._stream, this._transparentColor);
            const images = this._gif.images.map((i)=>new ImageSource(i.src, false));
            // Load all textures
            await Promise.all(images.map((t)=>t.load()));
            return this.data = this._textures = images;
        }
        isLoaded() {
            return !!this.data;
        }
        /**
     * Return a frame of the gif as a sprite by id
     * @param id
     */ toSprite(id = 0) {
            const sprite = this._textures[id].toSprite();
            return sprite;
        }
        /**
     * Return the gif as a spritesheet
     */ toSpriteSheet() {
            const sprites = this._textures.map((image)=>{
                return image.toSprite();
            });
            return new SpriteSheet({
                sprites: sprites
            });
        }
        /**
     * Transform the GIF into an animation with duration per frame
     */ toAnimation(durationPerFrameMs) {
            const spriteSheet = this.toSpriteSheet();
            const length = spriteSheet.sprites.length;
            this._animation = Animation.fromSpriteSheet(spriteSheet, range(0, length), durationPerFrameMs);
            return this._animation;
        }
        get readCheckBytes() {
            return this._gif.checkBytes;
        }
    }
    const bitsToNum = (ba)=>{
        return ba.reduce(function(s, n) {
            return s * 2 + n;
        }, 0);
    };
    const byteToBitArr = (bite)=>{
        const a = [];
        for(let i = 7; i >= 0; i--)a.push(!!(bite & 1 << i));
        return a;
    };
    class Stream {
        constructor(dataArray){
            this.data = null;
            this.len = 0;
            this.position = 0;
            this.readByte = ()=>{
                if (this.position >= this.data.byteLength) throw new Error("Attempted to read past end of stream.");
                return this.data[this.position++];
            };
            this.readBytes = (n)=>{
                const bytes = [];
                for(let i = 0; i < n; i++)bytes.push(this.readByte());
                return bytes;
            };
            this.read = (n)=>{
                let s = "";
                for(let i = 0; i < n; i++)s += String.fromCharCode(this.readByte());
                return s;
            };
            this.readUnsigned = ()=>{
                // Little-endian.
                const a = this.readBytes(2);
                return (a[1] << 8) + a[0];
            };
            this.data = new Uint8Array(dataArray);
            this.len = this.data.byteLength;
            if (this.len === 0) throw new Error("No data loaded from file");
        }
    }
    const lzwDecode = function(minCodeSize, data) {
        // TODO: Now that the GIF parser is a bit different, maybe this should get an array of bytes instead of a String?
        let pos = 0; // Maybe this streaming thing should be merged with the Stream?
        const readCode = function(size) {
            let code = 0;
            for(let i = 0; i < size; i++){
                if (data.charCodeAt(pos >> 3) & 1 << (pos & 7)) code |= 1 << i;
                pos++;
            }
            return code;
        };
        const output = [];
        const clearCode = 1 << minCodeSize;
        const eoiCode = clearCode + 1;
        let codeSize = minCodeSize + 1;
        let dict = [];
        const clear = function() {
            dict = [];
            codeSize = minCodeSize + 1;
            for(let i = 0; i < clearCode; i++)dict[i] = [
                i
            ];
            dict[clearCode] = [];
            dict[eoiCode] = null;
        };
        let code;
        let last;
        while(true){
            last = code;
            code = readCode(codeSize);
            if (code === clearCode) {
                clear();
                continue;
            }
            if (code === eoiCode) break;
            if (code < dict.length) {
                if (last !== clearCode) dict.push(dict[last].concat(dict[code][0]));
            } else {
                if (code !== dict.length) throw new Error("Invalid LZW code.");
                dict.push(dict[last].concat(dict[last][0]));
            }
            output.push.apply(output, dict[code]);
            if (dict.length === 1 << codeSize && codeSize < 12) // If we're at the last code and codeSize is 12, the next code will be a clearCode, and it'll be 12 bits long.
            codeSize++;
        }
        // I don't know if this is technically an error, but some GIFs do it.
        //if (Math.ceil(pos / 8) !== data.length) throw new Error('Extraneous LZW bytes.');
        return output;
    };
    // The actual parsing; returns an object with properties.
    class ParseGif {
        constructor(stream, color = Color.Magenta){
            this._st = null;
            this._handler = {};
            this._transparentColor = null;
            this.frames = [];
            this.images = [];
            this.globalColorTable = [];
            this.checkBytes = [];
            // LZW (GIF-specific)
            this.parseColorTable = (entries)=>{
                // Each entry is 3 bytes, for RGB.
                const ct = [];
                for(let i = 0; i < entries; i++){
                    const rgb = this._st.readBytes(3);
                    const rgba = "#" + rgb.map((x)=>{
                        const hex = x.toString(16);
                        return hex.length === 1 ? "0" + hex : hex;
                    }).join("");
                    ct.push(rgba);
                }
                return ct;
            };
            this.readSubBlocks = ()=>{
                let size, data;
                data = "";
                do {
                    size = this._st.readByte();
                    data += this._st.read(size);
                }while (size !== 0);
                return data;
            };
            this.parseHeader = ()=>{
                const hdr = {
                    sig: null,
                    ver: null,
                    width: null,
                    height: null,
                    colorRes: null,
                    globalColorTableSize: null,
                    gctFlag: null,
                    sorted: null,
                    globalColorTable: [],
                    bgColor: null,
                    pixelAspectRatio: null // if not 0, aspectRatio = (pixelAspectRatio + 15) / 64
                };
                hdr.sig = this._st.read(3);
                hdr.ver = this._st.read(3);
                if (hdr.sig !== "GIF") throw new Error("Not a GIF file."); // XXX: This should probably be handled more nicely.
                hdr.width = this._st.readUnsigned();
                hdr.height = this._st.readUnsigned();
                const bits = byteToBitArr(this._st.readByte());
                hdr.gctFlag = bits.shift();
                hdr.colorRes = bitsToNum(bits.splice(0, 3));
                hdr.sorted = bits.shift();
                hdr.globalColorTableSize = bitsToNum(bits.splice(0, 3));
                hdr.bgColor = this._st.readByte();
                hdr.pixelAspectRatio = this._st.readByte(); // if not 0, aspectRatio = (pixelAspectRatio + 15) / 64
                if (hdr.gctFlag) {
                    hdr.globalColorTable = this.parseColorTable(1 << hdr.globalColorTableSize + 1);
                    this.globalColorTable = hdr.globalColorTable;
                }
                if (this._handler.hdr && this._handler.hdr(hdr)) this.checkBytes.push(this._handler.hdr);
            };
            this.parseExt = (block)=>{
                const parseGCExt = (block)=>{
                    this.checkBytes.push(this._st.readByte()); // Always 4
                    const bits = byteToBitArr(this._st.readByte());
                    block.reserved = bits.splice(0, 3); // Reserved; should be 000.
                    block.disposalMethod = bitsToNum(bits.splice(0, 3));
                    block.userInput = bits.shift();
                    block.transparencyGiven = bits.shift();
                    block.delayTime = this._st.readUnsigned();
                    block.transparencyIndex = this._st.readByte();
                    block.terminator = this._st.readByte();
                    if (this._handler.gce && this._handler.gce(block)) this.checkBytes.push(this._handler.gce);
                };
                const parseComExt = (block)=>{
                    block.comment = this.readSubBlocks();
                    if (this._handler.com && this._handler.com(block)) this.checkBytes.push(this._handler.com);
                };
                const parsePTExt = (block)=>{
                    this.checkBytes.push(this._st.readByte()); // Always 12
                    block.ptHeader = this._st.readBytes(12);
                    block.ptData = this.readSubBlocks();
                    if (this._handler.pte && this._handler.pte(block)) this.checkBytes.push(this._handler.pte);
                };
                const parseAppExt = (block)=>{
                    const parseNetscapeExt = (block)=>{
                        this.checkBytes.push(this._st.readByte()); // Always 3
                        block.unknown = this._st.readByte(); // Q: Always 1? What is this?
                        block.iterations = this._st.readUnsigned();
                        block.terminator = this._st.readByte();
                        if (this._handler.app && this._handler.app.NETSCAPE && this._handler.app.NETSCAPE(block)) this.checkBytes.push(this._handler.app);
                    };
                    const parseUnknownAppExt = (block)=>{
                        block.appData = this.readSubBlocks();
                        // FIXME: This won't work if a handler wants to match on any identifier.
                        if (this._handler.app && this._handler.app[block.identifier] && this._handler.app[block.identifier](block)) this.checkBytes.push(this._handler.app[block.identifier]);
                    };
                    this.checkBytes.push(this._st.readByte()); // Always 11
                    block.identifier = this._st.read(8);
                    block.authCode = this._st.read(3);
                    switch(block.identifier){
                        case "NETSCAPE":
                            parseNetscapeExt(block);
                            break;
                        default:
                            parseUnknownAppExt(block);
                            break;
                    }
                };
                const parseUnknownExt = (block)=>{
                    block.data = this.readSubBlocks();
                    if (this._handler.unknown && this._handler.unknown(block)) this.checkBytes.push(this._handler.unknown);
                };
                block.label = this._st.readByte();
                switch(block.label){
                    case 0xf9:
                        block.extType = "gce";
                        parseGCExt(block);
                        break;
                    case 0xfe:
                        block.extType = "com";
                        parseComExt(block);
                        break;
                    case 0x01:
                        block.extType = "pte";
                        parsePTExt(block);
                        break;
                    case 0xff:
                        block.extType = "app";
                        parseAppExt(block);
                        break;
                    default:
                        block.extType = "unknown";
                        parseUnknownExt(block);
                        break;
                }
            };
            this.parseImg = (img)=>{
                const deinterlace = (pixels, width)=>{
                    // Of course this defeats the purpose of interlacing. And it's *probably*
                    // the least efficient way it's ever been implemented. But nevertheless...
                    const newPixels = new Array(pixels.length);
                    const rows = pixels.length / width;
                    const cpRow = (toRow, fromRow)=>{
                        const fromPixels = pixels.slice(fromRow * width, (fromRow + 1) * width);
                        newPixels.splice.apply(newPixels, [
                            toRow * width,
                            width
                        ].concat(fromPixels));
                    };
                    const offsets = [
                        0,
                        4,
                        2,
                        1
                    ];
                    const steps = [
                        8,
                        8,
                        4,
                        2
                    ];
                    let fromRow = 0;
                    for(let pass = 0; pass < 4; pass++)for(let toRow = offsets[pass]; toRow < rows; toRow += steps[pass]){
                        cpRow(toRow, fromRow);
                        fromRow++;
                    }
                    return newPixels;
                };
                img.leftPos = this._st.readUnsigned();
                img.topPos = this._st.readUnsigned();
                img.width = this._st.readUnsigned();
                img.height = this._st.readUnsigned();
                const bits = byteToBitArr(this._st.readByte());
                img.lctFlag = bits.shift();
                img.interlaced = bits.shift();
                img.sorted = bits.shift();
                img.reserved = bits.splice(0, 2);
                img.lctSize = bitsToNum(bits.splice(0, 3));
                if (img.lctFlag) img.lct = this.parseColorTable(1 << img.lctSize + 1);
                img.lzwMinCodeSize = this._st.readByte();
                const lzwData = this.readSubBlocks();
                img.pixels = lzwDecode(img.lzwMinCodeSize, lzwData);
                if (img.interlaced) // Move
                img.pixels = deinterlace(img.pixels, img.width);
                this.frames.push(img);
                this.arrayToImage(img);
                if (this._handler.img && this._handler.img(img)) this.checkBytes.push(this._handler);
            };
            this.parseBlock = ()=>{
                const block = {
                    sentinel: this._st.readByte(),
                    type: ""
                };
                const blockChar = String.fromCharCode(block.sentinel);
                switch(blockChar){
                    case "!":
                        block.type = "ext";
                        this.parseExt(block);
                        break;
                    case ",":
                        block.type = "img";
                        this.parseImg(block);
                        break;
                    case ";":
                        block.type = "eof";
                        if (this._handler.eof && this._handler.eof(block)) this.checkBytes.push(this._handler.eof);
                        break;
                    default:
                        throw new Error("Unknown block: 0x" + block.sentinel.toString(16));
                }
                if (block.type !== "eof") this.parseBlock();
            };
            this.arrayToImage = (frame)=>{
                let count = 0;
                const c = document.createElement("canvas");
                c.id = count.toString();
                c.width = frame.width;
                c.height = frame.height;
                count++;
                const context = c.getContext("2d");
                const pixSize = 1;
                let y = 0;
                let x = 0;
                for(let i = 0; i < frame.pixels.length; i++){
                    if (x % frame.width === 0) {
                        y++;
                        x = 0;
                    }
                    if (this.globalColorTable[frame.pixels[i]] === this._transparentColor.toHex()) context.fillStyle = `rgba(0, 0, 0, 0)`;
                    else context.fillStyle = this.globalColorTable[frame.pixels[i]];
                    context.fillRect(x, y, pixSize, pixSize);
                    x++;
                }
                const img = new Image();
                img.src = c.toDataURL();
                this.images.push(img);
            };
            this._st = stream;
            this._handler = {};
            this._transparentColor = color;
            this.parseHeader();
            this.parseBlock();
        }
    }
    class FontSource {
        constructor(/**
     * Path to the font resource relative from the HTML document hosting the game, or absolute
     */ path, /**
     * The font family name
     */ family, { bustCache: bustCache, ...options } = {}){
            this.path = path;
            this.family = family;
            this._isLoaded = false;
            this._resource = new Resource(path, "blob", bustCache);
            this._options = options;
        }
        async load() {
            if (this.isLoaded()) return this.data;
            try {
                const blob = await this._resource.load();
                const url = URL.createObjectURL(blob);
                if (!this.data) {
                    this.data = new FontFace(this.family, `url(${url})`);
                    document.fonts.add(this.data);
                }
                await this.data.load();
                this._isLoaded = true;
            } catch (error) {
                throw `Error loading FontSource from path '${this.path}' with error [${error.message}]`;
            }
            return this.data;
        }
        isLoaded() {
            return this._isLoaded;
        }
        /**
     * Build a font from this FontSource.
     * @param options {FontOptions} Override the font options
     */ toFont(options) {
            return new Font({
                family: this.family,
                ...this._options,
                ...options
            });
        }
    }
    const generatorFunctionDeclaration = /^\s*(?:function)?\*/;
    /**
 *
 */ function isCoroutineGenerator(x) {
        if (typeof x !== "function") return false;
        if (generatorFunctionDeclaration.test(Function.prototype.toString.call(x))) return true;
        if (!Object.getPrototypeOf) return false;
        return Object.getPrototypeOf(x) === Object.getPrototypeOf(new Function("return function * () {}")());
    }
    /**
 *
 */ function coroutine(...args) {
        let coroutineGenerator;
        let thisArg;
        let options;
        let passedEngine;
        // coroutine(coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (isCoroutineGenerator(args[0])) {
            thisArg = globalThis;
            coroutineGenerator = args[0];
            options = args[1];
        }
        // coroutine(thisArg: any, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (isCoroutineGenerator(args[1])) {
            thisArg = args[0];
            coroutineGenerator = args[1];
            options = args[2];
        }
        // coroutine(thisArg: any, engine: Engine, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (args[1] instanceof Engine) {
            thisArg = args[0];
            passedEngine = args[1];
            coroutineGenerator = args[2];
            options = args[3];
        }
        // coroutine(engine: Engine, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (args[0] instanceof Engine) {
            thisArg = globalThis;
            passedEngine = args[0];
            coroutineGenerator = args[1];
            options = args[2];
        }
        const schedule = options === null || options === void 0 ? void 0 : options.timing;
        let engine;
        try {
            engine = passedEngine !== null && passedEngine !== void 0 ? passedEngine : Engine.useEngine();
        } catch (_) {
            throw Error("Cannot run coroutine without engine parameter outside of an excalibur lifecycle method.\nPass an engine parameter to ex.coroutine(engine, function * {...})");
        }
        const generatorFcn = coroutineGenerator.bind(thisArg);
        return new Promise((resolve, reject)=>{
            const generator = generatorFcn();
            const loop = (elapsedMs)=>{
                try {
                    const { done: done, value: value } = generator.next(elapsedMs);
                    if (done) resolve();
                    if (value instanceof Promise) value.then(()=>{
                        // schedule next loop
                        engine.clock.schedule(loop, 0, schedule);
                    });
                    else if (value === undefined || value === void 0) // schedule next frame
                    engine.clock.schedule(loop, 0, schedule);
                    else // schedule value milliseconds from now
                    engine.clock.schedule(loop, value || 0, schedule);
                } catch (e) {
                    reject(e);
                }
            };
            loop(engine.clock.elapsed()); // run first frame immediately
        });
    }
    /**
 * Base Transition that can be extended to provide custom scene transitions in Excalibur.
 */ class Transition extends Entity {
        /**
     * Returns a number between [0, 1] indicating what state the transition is in.
     *
     * * For 'out' direction transitions start at 0 and end at 1
     * * For 'in' direction transitions start at 1 and end at 0
     */ get progress() {
            return this._currentProgress;
        }
        get complete() {
            if (this.direction === "out") return this.progress >= 1;
            else return this.progress <= 0;
        }
        constructor(options){
            var _a, _b, _c, _d;
            super();
            this._logger = Logger.getInstance();
            this.transform = new TransformComponent();
            this.graphics = new GraphicsComponent();
            this._completeFuture = new Future();
            // State needs to be reset between uses
            this.started = false;
            this._currentDistance = 0;
            this._currentProgress = 0;
            this.done = this._completeFuture.promise;
            this.name = `Transition#${this.id}`;
            this.duration = options.duration;
            this.easing = (_a = options.easing) !== null && _a !== void 0 ? _a : EasingFunctions.Linear;
            this.direction = (_b = options.direction) !== null && _b !== void 0 ? _b : "out";
            this.hideLoader = (_c = options.hideLoader) !== null && _c !== void 0 ? _c : false;
            this.blockInput = (_d = options.blockInput) !== null && _d !== void 0 ? _d : false;
            this.transform.coordPlane = CoordPlane.Screen;
            this.transform.pos = Vector.Zero;
            this.transform.z = Infinity; // Transitions sit on top of everything
            this.graphics.anchor = Vector.Zero;
            this.addComponent(this.transform);
            this.addComponent(this.graphics);
            if (this.direction === "out") this._currentProgress = 0;
            else this._currentProgress = 1;
        }
        /**
     * Overridable lifecycle method, called before each update.
     *
     * **WARNING BE SURE** to call `super.updateTransition()` if overriding in your own custom implementation
     * @param engine
     * @param delta
     */ updateTransition(engine, delta) {
            if (this.complete) return;
            this._currentDistance += clamp(delta / this.duration, 0, 1);
            if (this._currentDistance >= 1) this._currentDistance = 1;
            if (this.direction === "out") this._currentProgress = clamp(this.easing(this._currentDistance, 0, 1, 1), 0, 1);
            else this._currentProgress = clamp(this.easing(this._currentDistance, 1, 0, 1), 0, 1);
        }
        /**
     * Overridable lifecycle method, called right before the previous scene has deactivated.
     *
     * This gives incoming transition a chance to grab info from previous scene if desired
     * @param scene
     */ async onPreviousSceneDeactivate(scene) {
        // override me
        }
        /**
     * Overridable lifecycle method, called once at the beginning of the transition
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onStart(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called every frame of the transition
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onUpdate(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called at the end of the transition,
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onEnd(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called when the transition is reset
     *
     * Use this to override and provide your own reset logic for internal state in custom transition implementations
     */ onReset() {
        // override me
        }
        /**
     * reset() is called by the engine to reset transitions
     */ reset() {
            this.started = false;
            this._completeFuture = new Future();
            this.done = this._completeFuture.promise;
            this._currentDistance = 0;
            if (this.direction === "out") this._currentProgress = 0;
            else this._currentProgress = 1;
            this.onReset();
        }
        play(engine, targetScene) {
            if (this.started) {
                this.reset();
                this._logger.warn(`Attempted to play a transition ${this.name} that is already playing, reset transition.`);
            }
            const currentScene = targetScene !== null && targetScene !== void 0 ? targetScene : engine.currentScene;
            currentScene.add(this);
            const self1 = this;
            return coroutine(engine, function*() {
                while(!self1.complete){
                    const elapsed = yield; // per frame
                    self1.updateTransition(engine, elapsed);
                    self1.execute();
                }
            });
        }
        /**
     * execute() is called by the engine every frame to update the Transition lifecycle onStart/onUpdate/onEnd
     */ execute() {
            if (!this.isInitialized) return;
            if (!this.started) {
                this.started = true;
                this.onStart(this.progress);
            }
            this.onUpdate(this.progress);
            if (this.complete && !this._completeFuture.isCompleted) {
                this.onEnd(this.progress);
                this._completeFuture.resolve();
            }
        }
    }
    class FadeInOut extends Transition {
        constructor(options){
            var _a, _b;
            super({
                ...options,
                duration: (_a = options.duration) !== null && _a !== void 0 ? _a : 2000
            });
            this.name = `FadeInOut#${this.id}`;
            this.color = (_b = options.color) !== null && _b !== void 0 ? _b : Color.Black;
        }
        onInitialize(engine) {
            this.transform.pos = engine.screen.unsafeArea.topLeft;
            this.screenCover = new Rectangle({
                width: engine.screen.resolution.width,
                height: engine.screen.resolution.height,
                color: this.color
            });
            this.graphics.add(this.screenCover);
            this.graphics.opacity = this.progress;
        }
        onReset() {
            this.graphics.opacity = this.progress;
        }
        onStart(progress) {
            this.graphics.opacity = progress;
        }
        onEnd(progress) {
            this.graphics.opacity = progress;
        }
        onUpdate(progress) {
            this.graphics.opacity = progress;
        }
    }
    /**
 * CrossFades between the previous scene and the destination scene
 *
 * Note: CrossFade only works as an "in" transition
 */ class CrossFade extends Transition {
        constructor(options){
            super({
                direction: "in",
                ...options
            }); // default the correct direction
            this.name = `CrossFade#${this.id}`;
        }
        async onPreviousSceneDeactivate(scene) {
            this.image = await scene.engine.screenshot(true);
            // Firefox is particularly slow
            // needed in case the image isn't ready yet
            await this.image.decode();
        }
        onInitialize(engine) {
            this.engine = engine;
            this.transform.pos = engine.screen.unsafeArea.topLeft;
            this.screenCover = ImageSource.fromHtmlImageElement(this.image).toSprite();
            this.graphics.add(this.screenCover);
            this.transform.scale = vec(1 / engine.screen.pixelRatio, 1 / engine.screen.pixelRatio);
            this.graphics.opacity = this.progress;
        }
        onStart(_progress) {
            this.graphics.opacity = this.progress;
        }
        onReset() {
            this.graphics.opacity = this.progress;
        }
        onEnd(progress) {
            this.graphics.opacity = progress;
        }
        onUpdate(progress) {
            this.graphics.opacity = progress;
        }
    }
    class Line extends Graphic {
        constructor(options){
            super();
            this.color = Color.Black;
            this.thickness = 1;
            const { start: start, end: end, color: color, thickness: thickness } = options;
            this.start = start;
            this.end = end;
            this.color = color !== null && color !== void 0 ? color : this.color;
            this.thickness = thickness !== null && thickness !== void 0 ? thickness : this.thickness;
            this._localBounds = this._calculateBounds();
            const { width: width, height: height } = this._localBounds;
            this.width = width;
            this.height = height;
        }
        get localBounds() {
            return this._localBounds;
        }
        _calculateBounds() {
            const lineNormal = this.end.sub(this.start).normal();
            const halfThickness = this.thickness / 2;
            const points = [
                this.start.add(lineNormal.scale(halfThickness)),
                this.end.add(lineNormal.scale(halfThickness)),
                this.end.add(lineNormal.scale(-halfThickness)),
                this.start.add(lineNormal.scale(-halfThickness))
            ];
            return BoundingBox.fromPoints(points);
        }
        _drawImage(ctx, _x, _y) {
            ctx.drawLine(this.start, this.end, this.color, this.thickness);
        }
        clone() {
            return new Line({
                start: this.start,
                end: this.end,
                color: this.color,
                thickness: this.thickness
            });
        }
    }
    /**
 * A polygon [[Graphic]] for drawing arbitrary polygons to the [[ExcaliburGraphicsContext]]
 *
 * Polygons default to [[ImageFiltering.Blended]]
 */ class Polygon extends Raster {
        get points() {
            return this._points;
        }
        set points(points) {
            this._points = points;
            const min = this.minPoint;
            this.width = this._points.reduce((max, p)=>Math.max(p.x, max), 0) - min.x;
            this.height = this._points.reduce((max, p)=>Math.max(p.y, max), 0) - min.y;
            this.flagDirty();
        }
        get minPoint() {
            const minX = this._points.reduce((min, p)=>Math.min(p.x, min), Infinity);
            const minY = this._points.reduce((min, p)=>Math.min(p.y, min), Infinity);
            return vec(minX, minY);
        }
        constructor(options){
            super(options);
            this.points = options.points;
            this.filtering = ImageFiltering.Blended;
            this.rasterize();
        }
        clone() {
            return new Polygon({
                points: this.points.map((p)=>p.clone()),
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.points && this.points.length) {
                ctx.beginPath();
                // Iterate through the supplied points and construct a 'polygon'
                const min = this.minPoint.negate();
                const firstPoint = this.points[0].add(min);
                ctx.moveTo(firstPoint.x, firstPoint.y);
                this.points.forEach((point)=>{
                    ctx.lineTo(point.x + min.x, point.y + min.y);
                });
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                if (this.color) ctx.fill();
                if (this.strokeColor) ctx.stroke();
            }
        }
    }
    const maxMessages = 5;
    const obsoleteMessage = {};
    const resetObsoleteCounter = ()=>{
        for(const message in obsoleteMessage)obsoleteMessage[message] = 0;
    };
    const logMessage = (message, options)=>{
        const suppressObsoleteMessages = Flags.isEnabled("suppress-obsolete-message");
        if (obsoleteMessage[message] < maxMessages && !suppressObsoleteMessages) {
            Logger.getInstance().warn(message);
            // tslint:disable-next-line: no-console
            if (console.trace && options.showStackTrace) // tslint:disable-next-line: no-console
            console.trace();
        }
        obsoleteMessage[message]++;
    };
    /**
 * Obsolete decorator for marking Excalibur methods obsolete, you can optionally specify a custom message and/or alternate replacement
 * method do the deprecated one. Inspired by https://github.com/jayphelps/core-decorators.js
 */ function obsolete(options) {
        options = {
            message: "This feature will be removed in future versions of Excalibur.",
            alternateMethod: null,
            showStackTrace: false,
            ...options
        };
        return function(target, property, descriptor) {
            if (descriptor && !(typeof descriptor.value === "function" || typeof descriptor.get === "function" || typeof descriptor.set === "function")) throw new SyntaxError("Only classes/functions/getters/setters can be marked as obsolete");
            const methodSignature = `${target.name || ""}${target.name && property ? "." : ""}${property ? property : ""}`;
            const message = `${methodSignature} is marked obsolete: ${options.message}` + (options.alternateMethod ? ` Use ${options.alternateMethod} instead` : "");
            if (!obsoleteMessage[message]) obsoleteMessage[message] = 0;
            // If descriptor is null it is a class
            const method = descriptor ? {
                ...descriptor
            } : target;
            if (!descriptor) {
                // with es2015 classes we need to change our decoration tactic
                class DecoratedClass extends method {
                    constructor(...args){
                        logMessage(message, options);
                        super(...args);
                    }
                }
                return DecoratedClass;
            }
            if (descriptor && descriptor.value) {
                method.value = function() {
                    logMessage(message, options);
                    return descriptor.value.apply(this, arguments);
                };
                return method;
            }
            if (descriptor && descriptor.get) method.get = function() {
                logMessage(message, options);
                return descriptor.get.apply(this, arguments);
            };
            if (descriptor && descriptor.set) method.set = function() {
                logMessage(message, options);
                return descriptor.set.apply(this, arguments);
            };
            return method;
        };
    }
    class AsyncWaitQueue {
        constructor(){
            // Code from StephenCleary https://gist.github.com/StephenCleary/ba50b2da419c03b9cba1d20cb4654d5e
            this._queue = [];
        }
        get length() {
            return this._queue.length;
        }
        enqueue() {
            const future = new Future();
            this._queue.push(future);
            return future.promise;
        }
        dequeue(value) {
            const future = this._queue.shift();
            future.resolve(value);
        }
    }
    /**
 * Semaphore allows you to limit the amount of async calls happening between `enter()` and `exit()`
 *
 * This can be useful when limiting the number of http calls, browser api calls, etc either for performance or to work
 * around browser limitations like max Image.decode() calls in chromium being 256.
 */ class Semaphore {
        constructor(_count){
            this._count = _count;
            this._waitQueue = new AsyncWaitQueue();
        }
        get count() {
            return this._count;
        }
        get waiting() {
            return this._waitQueue.length;
        }
        // eslint-disable-next-line require-await
        async enter() {
            if (this._count !== 0) {
                this._count--;
                return Promise.resolve();
            }
            return this._waitQueue.enqueue();
        }
        exit(count = 1) {
            if (count === 0) return;
            while(count !== 0 && this._waitQueue.length !== 0){
                this._waitQueue.dequeue(null);
                count--;
            }
            this._count += count;
        }
    }
    /**
 * The current Excalibur version string
 * @description `process.env.__EX_VERSION` gets replaced by Webpack on build
 */ const EX_VERSION = "0.29.3";
    polyfill();
// This file is used as the bundle entry point and exports everything
// that will be exposed as the `ex` global variable.
// ex.Events namespace
// ex.Input namespace
// TODO deprecated import site remove in v0.29.0
// ex.Util namespaces
// ex.Deprecated
// import * as deprecated from './Deprecated';
// export { deprecated as Deprecated };
// export * from './Deprecated';
})();
var $2c23f148d58cd887$export$f05c91211c084e80 = $2c23f148d58cd887$var$__webpack_exports__.eKr;
var $2c23f148d58cd887$export$e04e17a44f37debc = $2c23f148d58cd887$var$__webpack_exports__.yVm;
var $2c23f148d58cd887$export$dfcd1bb88f6d711b = $2c23f148d58cd887$var$__webpack_exports__.a7j;
var $2c23f148d58cd887$export$89f31cec7c284d42 = $2c23f148d58cd887$var$__webpack_exports__.U_w;
var $2c23f148d58cd887$export$a3f070f3e473c3b = $2c23f148d58cd887$var$__webpack_exports__.JF2;
var $2c23f148d58cd887$export$856e7d6d9d698871 = $2c23f148d58cd887$var$__webpack_exports__.htg;
var $2c23f148d58cd887$export$caffe607ed29fca1 = $2c23f148d58cd887$var$__webpack_exports__.HXL;
var $2c23f148d58cd887$export$adc62e83dbcda319 = $2c23f148d58cd887$var$__webpack_exports__.mcg;
var $2c23f148d58cd887$export$f73d3eb6fd876d80 = $2c23f148d58cd887$var$__webpack_exports__.Agj;
var $2c23f148d58cd887$export$da248c61eea53296 = $2c23f148d58cd887$var$__webpack_exports__.u6S;
var $2c23f148d58cd887$export$f0455ab08e3fbd0e = $2c23f148d58cd887$var$__webpack_exports__.x7M;
var $2c23f148d58cd887$export$c35d437ae5945fcd = $2c23f148d58cd887$var$__webpack_exports__.X55;
var $2c23f148d58cd887$export$67ee29bab3792d4c = $2c23f148d58cd887$var$__webpack_exports__.m3M;
var $2c23f148d58cd887$export$d230853e97069d46 = $2c23f148d58cd887$var$__webpack_exports__.aE5;
var $2c23f148d58cd887$export$6cfd78ddb48c90c6 = $2c23f148d58cd887$var$__webpack_exports__.YJU;
var $2c23f148d58cd887$export$3769e64eb87b5ecc = $2c23f148d58cd887$var$__webpack_exports__.eZi;
var $2c23f148d58cd887$export$54dc36bc2fac5425 = $2c23f148d58cd887$var$__webpack_exports__.GNv;
var $2c23f148d58cd887$export$387a78ab20784494 = $2c23f148d58cd887$var$__webpack_exports__.Y56;
var $2c23f148d58cd887$export$d06866a9fb0606da = $2c23f148d58cd887$var$__webpack_exports__._0v;
var $2c23f148d58cd887$export$83c931ba0d3bbaf5 = $2c23f148d58cd887$var$__webpack_exports__.vhs;
var $2c23f148d58cd887$export$1a553341cd0b8415 = $2c23f148d58cd887$var$__webpack_exports__.Z8b;
var $2c23f148d58cd887$export$43416332cf06b1f = $2c23f148d58cd887$var$__webpack_exports__.Yfw;
var $2c23f148d58cd887$export$63080c4de6cfc362 = $2c23f148d58cd887$var$__webpack_exports__.IcQ;
var $2c23f148d58cd887$export$fa45ecb18b97ae89 = $2c23f148d58cd887$var$__webpack_exports__.Rl2;
var $2c23f148d58cd887$export$c24f8f35353a1e26 = $2c23f148d58cd887$var$__webpack_exports__.kgJ;
var $2c23f148d58cd887$export$8688def55452cbca = $2c23f148d58cd887$var$__webpack_exports__.GTT;
var $2c23f148d58cd887$export$665d5a662b7213f3 = $2c23f148d58cd887$var$__webpack_exports__.ypY;
var $2c23f148d58cd887$export$79f141de891a5fed = $2c23f148d58cd887$var$__webpack_exports__.i7d;
var $2c23f148d58cd887$export$41606648ac8a293c = $2c23f148d58cd887$var$__webpack_exports__.fQ3;
var $2c23f148d58cd887$export$8d01c972ee8b14a9 = $2c23f148d58cd887$var$__webpack_exports__.HlI;
var $2c23f148d58cd887$export$c89a927ffc67e6fa = $2c23f148d58cd887$var$__webpack_exports__.jlt;
var $2c23f148d58cd887$export$e2395b697f5a931f = $2c23f148d58cd887$var$__webpack_exports__.VQc;
var $2c23f148d58cd887$export$9735c82c4bae3302 = $2c23f148d58cd887$var$__webpack_exports__.zD7;
var $2c23f148d58cd887$export$44e6803d1d57f89a = $2c23f148d58cd887$var$__webpack_exports__.I0I;
var $2c23f148d58cd887$export$1ed419d47673a225 = $2c23f148d58cd887$var$__webpack_exports__.AUF;
var $2c23f148d58cd887$export$b7c6eef0ebb06133 = $2c23f148d58cd887$var$__webpack_exports__.JoF;
var $2c23f148d58cd887$export$3c9e91dc1b611d2e = $2c23f148d58cd887$var$__webpack_exports__.MlA;
var $2c23f148d58cd887$export$ce0ca64520c7bfd2 = $2c23f148d58cd887$var$__webpack_exports__.PZh;
var $2c23f148d58cd887$export$83caf30c40e9d4b8 = $2c23f148d58cd887$var$__webpack_exports__.qA;
var $2c23f148d58cd887$export$4df0464d8c812c98 = $2c23f148d58cd887$var$__webpack_exports__.CrD;
var $2c23f148d58cd887$export$55e924fc640a8405 = $2c23f148d58cd887$var$__webpack_exports__.dQK;
var $2c23f148d58cd887$export$fbd6eb86d6a3f08 = $2c23f148d58cd887$var$__webpack_exports__.D3r;
var $2c23f148d58cd887$export$7cd2649c3408da6c = $2c23f148d58cd887$var$__webpack_exports__.Qpo;
var $2c23f148d58cd887$export$897cd666d936ac4c = $2c23f148d58cd887$var$__webpack_exports__.D9n;
var $2c23f148d58cd887$export$cf976780b3106589 = $2c23f148d58cd887$var$__webpack_exports__.b6v;
var $2c23f148d58cd887$export$5dcfde0f6b96512b = $2c23f148d58cd887$var$__webpack_exports__.mvh;
var $2c23f148d58cd887$export$ddb2ed749236e720 = $2c23f148d58cd887$var$__webpack_exports__.Bpo;
var $2c23f148d58cd887$export$892596cec99bc70e = $2c23f148d58cd887$var$__webpack_exports__.Q1f;
var $2c23f148d58cd887$export$8ed4b5bb5352fe14 = $2c23f148d58cd887$var$__webpack_exports__.IKv;
var $2c23f148d58cd887$export$c46090c9df657074 = $2c23f148d58cd887$var$__webpack_exports__.fcV;
var $2c23f148d58cd887$export$b3bf2ffaa538264b = $2c23f148d58cd887$var$__webpack_exports__.Glf;
var $2c23f148d58cd887$export$16fa2f45be04daa8 = $2c23f148d58cd887$var$__webpack_exports__.uAl;
var $2c23f148d58cd887$export$d16a7c95008e315d = $2c23f148d58cd887$var$__webpack_exports__.ElT;
var $2c23f148d58cd887$export$abda45806f5adbae = $2c23f148d58cd887$var$__webpack_exports__.MPu;
var $2c23f148d58cd887$export$e5a30aa3d28b26e2 = $2c23f148d58cd887$var$__webpack_exports__.Z8r;
var $2c23f148d58cd887$export$de7807bd8bd828df = $2c23f148d58cd887$var$__webpack_exports__.QSL;
var $2c23f148d58cd887$export$1bdfb0c7c42d632d = $2c23f148d58cd887$var$__webpack_exports__.sPV;
var $2c23f148d58cd887$export$bf92f329076cd7a3 = $2c23f148d58cd887$var$__webpack_exports__.nAn;
var $2c23f148d58cd887$export$71de6146fb6d69d2 = $2c23f148d58cd887$var$__webpack_exports__.zCU;
var $2c23f148d58cd887$export$71efaa2be447940c = $2c23f148d58cd887$var$__webpack_exports__.QrV;
var $2c23f148d58cd887$export$d78c8c6074541cf2 = $2c23f148d58cd887$var$__webpack_exports__.fF9;
var $2c23f148d58cd887$export$7d34ad93c25aa8e7 = $2c23f148d58cd887$var$__webpack_exports__.xI8;
var $2c23f148d58cd887$export$153e5dc2c098b35c = $2c23f148d58cd887$var$__webpack_exports__.yar;
var $2c23f148d58cd887$export$f7c1896972d6c454 = $2c23f148d58cd887$var$__webpack_exports__.SP7;
var $2c23f148d58cd887$export$c3e6e677dda8521a = $2c23f148d58cd887$var$__webpack_exports__.oRy;
var $2c23f148d58cd887$export$e52858e61b0ea117 = $2c23f148d58cd887$var$__webpack_exports__.f5X;
var $2c23f148d58cd887$export$3d1f12550a40f54d = $2c23f148d58cd887$var$__webpack_exports__.V1c;
var $2c23f148d58cd887$export$4544b2d7eff33859 = $2c23f148d58cd887$var$__webpack_exports__.Mlx;
var $2c23f148d58cd887$export$dd6b48f99ee8a36 = $2c23f148d58cd887$var$__webpack_exports__.ZCo;
var $2c23f148d58cd887$export$aafe01318a900193 = $2c23f148d58cd887$var$__webpack_exports__.Vy3;
var $2c23f148d58cd887$export$fd69b6a3b7f47e29 = $2c23f148d58cd887$var$__webpack_exports__.J5p;
var $2c23f148d58cd887$export$e1545123b54f6785 = $2c23f148d58cd887$var$__webpack_exports__.mL_;
var $2c23f148d58cd887$export$7419ff430885d61c = $2c23f148d58cd887$var$__webpack_exports__.Guw;
var $2c23f148d58cd887$export$a340d4e5571cbd07 = $2c23f148d58cd887$var$__webpack_exports__.VKx;
var $2c23f148d58cd887$export$e695250628cde35 = $2c23f148d58cd887$var$__webpack_exports__.N5j;
var $2c23f148d58cd887$export$c5e124f7bab3d492 = $2c23f148d58cd887$var$__webpack_exports__.pgY;
var $2c23f148d58cd887$export$cacd6541cfeeb6c1 = $2c23f148d58cd887$var$__webpack_exports__.OP3;
var $2c23f148d58cd887$export$a74d557191881f82 = $2c23f148d58cd887$var$__webpack_exports__.rl5;
var $2c23f148d58cd887$export$99bf88c530739783 = $2c23f148d58cd887$var$__webpack_exports__.eod;
var $2c23f148d58cd887$export$4b7264771109adb6 = $2c23f148d58cd887$var$__webpack_exports__.q5Z;
var $2c23f148d58cd887$export$62053d374d83dfb1 = $2c23f148d58cd887$var$__webpack_exports__.YUC;
var $2c23f148d58cd887$export$d7078bb1ea3ba3f2 = $2c23f148d58cd887$var$__webpack_exports__.saR;
var $2c23f148d58cd887$export$86ae8da356d53161 = $2c23f148d58cd887$var$__webpack_exports__.hvr;
var $2c23f148d58cd887$export$62230588c4867d28 = $2c23f148d58cd887$var$__webpack_exports__.Qol;
var $2c23f148d58cd887$export$df007b1d5b86e25a = $2c23f148d58cd887$var$__webpack_exports__.Wf4;
var $2c23f148d58cd887$export$6ff391a2049fdf40 = $2c23f148d58cd887$var$__webpack_exports__.JCs;
var $2c23f148d58cd887$export$89e5ccdc4c19a8f6 = $2c23f148d58cd887$var$__webpack_exports__.gJV;
var $2c23f148d58cd887$export$2cbc8fe61dd10773 = $2c23f148d58cd887$var$__webpack_exports__.fWD;
var $2c23f148d58cd887$export$d45269226a4bbdc1 = $2c23f148d58cd887$var$__webpack_exports__.Va_;
var $2c23f148d58cd887$export$2c3b404bf3a77a1f = $2c23f148d58cd887$var$__webpack_exports__.N$8;
var $2c23f148d58cd887$export$20434e7e042d306a = $2c23f148d58cd887$var$__webpack_exports__._jQ;
var $2c23f148d58cd887$export$462adefbb095232e = $2c23f148d58cd887$var$__webpack_exports__.rxj;
var $2c23f148d58cd887$export$83f8212621739c1f = $2c23f148d58cd887$var$__webpack_exports__.rhv;
var $2c23f148d58cd887$export$bc644a473284d944 = $2c23f148d58cd887$var$__webpack_exports__.wCu;
var $2c23f148d58cd887$export$66b8a9cb33a156c = $2c23f148d58cd887$var$__webpack_exports__.HAp;
var $2c23f148d58cd887$export$c7b7134fd828a5 = $2c23f148d58cd887$var$__webpack_exports__.Zy1;
var $2c23f148d58cd887$export$ec8b666c5fe2c75a = $2c23f148d58cd887$var$__webpack_exports__.Qev;
var $2c23f148d58cd887$export$4fae95256245c8c0 = $2c23f148d58cd887$var$__webpack_exports__.bkB;
var $2c23f148d58cd887$export$86d9a347f2bf71d6 = $2c23f148d58cd887$var$__webpack_exports__.wfL;
var $2c23f148d58cd887$export$ada873a34909da65 = $2c23f148d58cd887$var$__webpack_exports__.sVA;
var $2c23f148d58cd887$export$afee3afd6be961ec = $2c23f148d58cd887$var$__webpack_exports__.$Gs;
var $2c23f148d58cd887$export$c03216fb3a7a2f87 = $2c23f148d58cd887$var$__webpack_exports__.CJ0;
var $2c23f148d58cd887$export$81940238f313e11f = $2c23f148d58cd887$var$__webpack_exports__.NWh;
var $2c23f148d58cd887$export$40f8f9a8f94db930 = $2c23f148d58cd887$var$__webpack_exports__.tWi;
var $2c23f148d58cd887$export$c579e21b95165414 = $2c23f148d58cd887$var$__webpack_exports__.xAj;
var $2c23f148d58cd887$export$c983850c6c9d8b0e = $2c23f148d58cd887$var$__webpack_exports__.zWh;
var $2c23f148d58cd887$export$be5b6c6ac24b4683 = $2c23f148d58cd887$var$__webpack_exports__.i_4;
var $2c23f148d58cd887$export$434ba092ed0eee4e = $2c23f148d58cd887$var$__webpack_exports__.iIx;
var $2c23f148d58cd887$export$455f05776f1ba8ba = $2c23f148d58cd887$var$__webpack_exports__.c9e;
var $2c23f148d58cd887$export$89abf52a030e56ee = $2c23f148d58cd887$var$__webpack_exports__.KQV;
var $2c23f148d58cd887$export$549c899505235621 = $2c23f148d58cd887$var$__webpack_exports__.weH;
var $2c23f148d58cd887$export$1f6d1255105a925c = $2c23f148d58cd887$var$__webpack_exports__.jXp;
var $2c23f148d58cd887$export$23b468d4ca3f8c96 = $2c23f148d58cd887$var$__webpack_exports__.zzY;
var $2c23f148d58cd887$export$6976e674e6d5804c = $2c23f148d58cd887$var$__webpack_exports__.yRQ;
var $2c23f148d58cd887$export$420acfc1740638d3 = $2c23f148d58cd887$var$__webpack_exports__.MtE;
var $2c23f148d58cd887$export$e84927905accfe51 = $2c23f148d58cd887$var$__webpack_exports__.rPj;
var $2c23f148d58cd887$export$c9d7bf589772a8ce = $2c23f148d58cd887$var$__webpack_exports__.KLc;
var $2c23f148d58cd887$export$d5011a4647754c9b = $2c23f148d58cd887$var$__webpack_exports__.Fir;
var $2c23f148d58cd887$export$b8c6aa234afa01bc = $2c23f148d58cd887$var$__webpack_exports__.V5f;
var $2c23f148d58cd887$export$6c3776220abeb931 = $2c23f148d58cd887$var$__webpack_exports__.Xj7;
var $2c23f148d58cd887$export$27a9cd7ebdd38262 = $2c23f148d58cd887$var$__webpack_exports__.Wud;
var $2c23f148d58cd887$export$fb1b94e06ba8ebc8 = $2c23f148d58cd887$var$__webpack_exports__.FVg;
var $2c23f148d58cd887$export$3d953a2d86354b5f = $2c23f148d58cd887$var$__webpack_exports__.g5Y;
var $2c23f148d58cd887$export$88528019d270f582 = $2c23f148d58cd887$var$__webpack_exports__.YQB;
var $2c23f148d58cd887$export$402da60b1c009e43 = $2c23f148d58cd887$var$__webpack_exports__.KPb;
var $2c23f148d58cd887$export$757ccd1717b77f48 = $2c23f148d58cd887$var$__webpack_exports__.nHK;
var $2c23f148d58cd887$export$48ebf29bc7cb1dd7 = $2c23f148d58cd887$var$__webpack_exports__.TX_;
var $2c23f148d58cd887$export$3c8c04bde7eed7cb = $2c23f148d58cd887$var$__webpack_exports__.r3n;
var $2c23f148d58cd887$export$adfa9d260876eca5 = $2c23f148d58cd887$var$__webpack_exports__.vYh;
var $2c23f148d58cd887$export$6c043ed3a716859a = $2c23f148d58cd887$var$__webpack_exports__.hnk;
var $2c23f148d58cd887$export$9f9afb456a8bef30 = $2c23f148d58cd887$var$__webpack_exports__.D2R;
var $2c23f148d58cd887$export$1033a6fa0779f4f5 = $2c23f148d58cd887$var$__webpack_exports__.n1o;
var $2c23f148d58cd887$export$38f8109d2b8f43ef = $2c23f148d58cd887$var$__webpack_exports__.RLG;
var $2c23f148d58cd887$export$b5aa7fe3676b74a9 = $2c23f148d58cd887$var$__webpack_exports__.fBU;
var $2c23f148d58cd887$export$5213deb2877a09f2 = $2c23f148d58cd887$var$__webpack_exports__.Adb;
var $2c23f148d58cd887$export$280e9a68c3ffd919 = $2c23f148d58cd887$var$__webpack_exports__.bEs;
var $2c23f148d58cd887$export$33e0492c95e498b6 = $2c23f148d58cd887$var$__webpack_exports__.wCy;
var $2c23f148d58cd887$export$79acae2c80dc546e = $2c23f148d58cd887$var$__webpack_exports__.CbD;
var $2c23f148d58cd887$export$49a1ecce8d203 = $2c23f148d58cd887$var$__webpack_exports__.x_C;
var $2c23f148d58cd887$export$f5b8910cec6cf069 = $2c23f148d58cd887$var$__webpack_exports__.pde;
var $2c23f148d58cd887$export$99f13cbf742a0580 = $2c23f148d58cd887$var$__webpack_exports__.pGf;
var $2c23f148d58cd887$export$2ae6ec0f10d96242 = $2c23f148d58cd887$var$__webpack_exports__.ibQ;
var $2c23f148d58cd887$export$d379657aa3df1705 = $2c23f148d58cd887$var$__webpack_exports__.QlN;
var $2c23f148d58cd887$export$ffed6a4cd9a88787 = $2c23f148d58cd887$var$__webpack_exports__.shR;
var $2c23f148d58cd887$export$7705889256a9371a = $2c23f148d58cd887$var$__webpack_exports__.Yjk;
var $2c23f148d58cd887$export$539f65e788a82c62 = $2c23f148d58cd887$var$__webpack_exports__._u1;
var $2c23f148d58cd887$export$851e6d93385b6ad2 = $2c23f148d58cd887$var$__webpack_exports__.OBI;
var $2c23f148d58cd887$export$4b0c1c390bf9a356 = $2c23f148d58cd887$var$__webpack_exports__.klh;
var $2c23f148d58cd887$export$16e4d70cc375e707 = $2c23f148d58cd887$var$__webpack_exports__.s3S;
var $2c23f148d58cd887$export$4b0075e5ea5e1f26 = $2c23f148d58cd887$var$__webpack_exports__.D$R;
var $2c23f148d58cd887$export$f3a6c1ca682fd40f = $2c23f148d58cd887$var$__webpack_exports__.xth;
var $2c23f148d58cd887$export$b04be29aa201d4f5 = $2c23f148d58cd887$var$__webpack_exports__.JU7;
var $2c23f148d58cd887$export$b3509fba7d85d294 = $2c23f148d58cd887$var$__webpack_exports__.h9x;
var $2c23f148d58cd887$export$17d680238e50603e = $2c23f148d58cd887$var$__webpack_exports__.N1A;
var $2c23f148d58cd887$export$8b98feb4a2766c75 = $2c23f148d58cd887$var$__webpack_exports__.e_k;
var $2c23f148d58cd887$export$3b0d6d7590275603 = $2c23f148d58cd887$var$__webpack_exports__.aHM;
var $2c23f148d58cd887$export$38d47553764a3d88 = $2c23f148d58cd887$var$__webpack_exports__.tlv;
var $2c23f148d58cd887$export$1c4c6d3f8d56581 = $2c23f148d58cd887$var$__webpack_exports__.Vi9;
var $2c23f148d58cd887$export$fc869739b2177284 = $2c23f148d58cd887$var$__webpack_exports__.ieR;
var $2c23f148d58cd887$export$243e62d78d3b544d = $2c23f148d58cd887$var$__webpack_exports__.$bb;
var $2c23f148d58cd887$export$efa9a398d6368992 = $2c23f148d58cd887$var$__webpack_exports__.VyI;
var $2c23f148d58cd887$export$a2d8b23205c25948 = $2c23f148d58cd887$var$__webpack_exports__.imn;
var $2c23f148d58cd887$export$5b12bf1653c0dd85 = $2c23f148d58cd887$var$__webpack_exports__.uqu;
var $2c23f148d58cd887$export$9f9b2346169b00c0 = $2c23f148d58cd887$var$__webpack_exports__.QnL;
var $2c23f148d58cd887$export$8c37b217b84d3f89 = $2c23f148d58cd887$var$__webpack_exports__.vnc;
var $2c23f148d58cd887$export$35624b13e79b24a9 = $2c23f148d58cd887$var$__webpack_exports__.wk_;
var $2c23f148d58cd887$export$f75e7304717c9cbc = $2c23f148d58cd887$var$__webpack_exports__.GH0;
var $2c23f148d58cd887$export$ec1251c88c8bd5c9 = $2c23f148d58cd887$var$__webpack_exports__._1r;
var $2c23f148d58cd887$export$d17844835b0fe8a8 = $2c23f148d58cd887$var$__webpack_exports__.l0X;
var $2c23f148d58cd887$export$d1d8cb3d5c2a5671 = $2c23f148d58cd887$var$__webpack_exports__.HHX;
var $2c23f148d58cd887$export$4d607ef791645d6 = $2c23f148d58cd887$var$__webpack_exports__.tjk;
var $2c23f148d58cd887$export$f0b55daf9f154b55 = $2c23f148d58cd887$var$__webpack_exports__.rWe;
var $2c23f148d58cd887$export$fa9699e41ba6faff = $2c23f148d58cd887$var$__webpack_exports__.j9l;
var $2c23f148d58cd887$export$57ca7e07b341709d = $2c23f148d58cd887$var$__webpack_exports__.NVp;
var $2c23f148d58cd887$export$77cea355fa80b5f4 = $2c23f148d58cd887$var$__webpack_exports__.cPK;
var $2c23f148d58cd887$export$8844adde4348f85c = $2c23f148d58cd887$var$__webpack_exports__.XoL;
var $2c23f148d58cd887$export$d63d7cff08fe4dc9 = $2c23f148d58cd887$var$__webpack_exports__.RmF;
var $2c23f148d58cd887$export$a960801e47624f4f = $2c23f148d58cd887$var$__webpack_exports__.DXI;
var $2c23f148d58cd887$export$ed6a63ee685a4d78 = $2c23f148d58cd887$var$__webpack_exports__.tCD;
var $2c23f148d58cd887$export$4fe52ae24ae61d51 = $2c23f148d58cd887$var$__webpack_exports__.oGn;
var $2c23f148d58cd887$export$c36c68baa13912a5 = $2c23f148d58cd887$var$__webpack_exports__.J3D;
var $2c23f148d58cd887$export$616c632b282478dd = $2c23f148d58cd887$var$__webpack_exports__.vCJ;
var $2c23f148d58cd887$export$459b1801e3134a24 = $2c23f148d58cd887$var$__webpack_exports__.f9l;
var $2c23f148d58cd887$export$2f09efa5b67124a7 = $2c23f148d58cd887$var$__webpack_exports__.AQx;
var $2c23f148d58cd887$export$618424ba3f30cd41 = $2c23f148d58cd887$var$__webpack_exports__.v9m;
var $2c23f148d58cd887$export$4a963ea7a16edf21 = $2c23f148d58cd887$var$__webpack_exports__.yRJ;
var $2c23f148d58cd887$export$a4017560efebe97d = $2c23f148d58cd887$var$__webpack_exports__.EU6;
var $2c23f148d58cd887$export$982e5de016bedff1 = $2c23f148d58cd887$var$__webpack_exports__.m3O;
var $2c23f148d58cd887$export$6860c0696b73f79b = $2c23f148d58cd887$var$__webpack_exports__.Ryz;
var $2c23f148d58cd887$export$94806efd9890932f = $2c23f148d58cd887$var$__webpack_exports__.OxP;
var $2c23f148d58cd887$export$3bee0b2628b43478 = $2c23f148d58cd887$var$__webpack_exports__.LEs;
var $2c23f148d58cd887$export$caed39dbb767d548 = $2c23f148d58cd887$var$__webpack_exports__.Ec;
var $2c23f148d58cd887$export$7e5ab4f7f9fd407 = $2c23f148d58cd887$var$__webpack_exports__.Pi5;
var $2c23f148d58cd887$export$330520496d871ecf = $2c23f148d58cd887$var$__webpack_exports__.gmH;
var $2c23f148d58cd887$export$7d31b617c820d435 = $2c23f148d58cd887$var$__webpack_exports__.tS;
var $2c23f148d58cd887$export$f23a2a272a8df60 = $2c23f148d58cd887$var$__webpack_exports__.XxX;
var $2c23f148d58cd887$export$14963ee5c8637e11 = $2c23f148d58cd887$var$__webpack_exports__.bCz;
var $2c23f148d58cd887$export$1d2c184034fc4cc2 = $2c23f148d58cd887$var$__webpack_exports__.nYS;
var $2c23f148d58cd887$export$fea21a521a6360c1 = $2c23f148d58cd887$var$__webpack_exports__.yiT;
var $2c23f148d58cd887$export$8c15bdf7e3727f73 = $2c23f148d58cd887$var$__webpack_exports__.NHl;
var $2c23f148d58cd887$export$6eb043bf81d89752 = $2c23f148d58cd887$var$__webpack_exports__.mO8;
var $2c23f148d58cd887$export$e390b859365a3d5b = $2c23f148d58cd887$var$__webpack_exports__.PXI;
var $2c23f148d58cd887$export$82a33120f6a0d987 = $2c23f148d58cd887$var$__webpack_exports__.bn5;
var $2c23f148d58cd887$export$1ec85152758537e0 = $2c23f148d58cd887$var$__webpack_exports__.Ywr;
var $2c23f148d58cd887$export$a8584993858a18df = $2c23f148d58cd887$var$__webpack_exports__.cMd;
var $2c23f148d58cd887$export$906049a3747337a6 = $2c23f148d58cd887$var$__webpack_exports__.Bs6;
var $2c23f148d58cd887$export$dbd8a6303ac26a42 = $2c23f148d58cd887$var$__webpack_exports__.G0k;
var $2c23f148d58cd887$export$9f68b6f37a444556 = $2c23f148d58cd887$var$__webpack_exports__.pyn;
var $2c23f148d58cd887$export$fe2b6ac465da985d = $2c23f148d58cd887$var$__webpack_exports__.QeM;
var $2c23f148d58cd887$export$4c3c82f4dcd79fcc = $2c23f148d58cd887$var$__webpack_exports__.aPX;
var $2c23f148d58cd887$export$e4ce43ec0499fb8f = $2c23f148d58cd887$var$__webpack_exports__.ITP;
var $2c23f148d58cd887$export$e44279b5c44add28 = $2c23f148d58cd887$var$__webpack_exports__.BY0;
var $2c23f148d58cd887$export$dfa3a012bb2ef2e1 = $2c23f148d58cd887$var$__webpack_exports__.MFw;
var $2c23f148d58cd887$export$8201b979875baf73 = $2c23f148d58cd887$var$__webpack_exports__.sBn;
var $2c23f148d58cd887$export$b82688eb02220411 = $2c23f148d58cd887$var$__webpack_exports__.S3L;
var $2c23f148d58cd887$export$62297b13309008b2 = $2c23f148d58cd887$var$__webpack_exports__.XKQ;
var $2c23f148d58cd887$export$b986383a50b53ea4 = $2c23f148d58cd887$var$__webpack_exports__.ESI;
var $2c23f148d58cd887$export$ad5b3d166367714c = $2c23f148d58cd887$var$__webpack_exports__.uxz;
var $2c23f148d58cd887$export$a92776769f460054 = $2c23f148d58cd887$var$__webpack_exports__.o8N;
var $2c23f148d58cd887$export$eeb71495ca594706 = $2c23f148d58cd887$var$__webpack_exports__.u_r;
var $2c23f148d58cd887$export$a186db52eed6d40e = $2c23f148d58cd887$var$__webpack_exports__.RlV;
var $2c23f148d58cd887$export$c07ce6d13c46df49 = $2c23f148d58cd887$var$__webpack_exports__.gVA;
var $2c23f148d58cd887$export$4617fb02663045ef = $2c23f148d58cd887$var$__webpack_exports__.M_G;
var $2c23f148d58cd887$export$32437fc39ad02208 = $2c23f148d58cd887$var$__webpack_exports__.GRB;
var $2c23f148d58cd887$export$f9d61a2a6155ab51 = $2c23f148d58cd887$var$__webpack_exports__.kM6;
var $2c23f148d58cd887$export$9bd81f7d9b69ccb3 = $2c23f148d58cd887$var$__webpack_exports__.dO8;
var $2c23f148d58cd887$export$3e4ff2216a90b8a4 = $2c23f148d58cd887$var$__webpack_exports__.jgM;
var $2c23f148d58cd887$export$39a853cfb5a94a63 = $2c23f148d58cd887$var$__webpack_exports__.FWq;
var $2c23f148d58cd887$export$62833702c6700187 = $2c23f148d58cd887$var$__webpack_exports__.s3j;
var $2c23f148d58cd887$export$a43177620e7a9310 = $2c23f148d58cd887$var$__webpack_exports__.hlw;
var $2c23f148d58cd887$export$a16b6ef1fd362a19 = $2c23f148d58cd887$var$__webpack_exports__.B7e;
var $2c23f148d58cd887$export$91397be43fc980cc = $2c23f148d58cd887$var$__webpack_exports__.H_X;
var $2c23f148d58cd887$export$23b9d128e61caefd = $2c23f148d58cd887$var$__webpack_exports__.S_d;
var $2c23f148d58cd887$export$ab681471d41eeddc = $2c23f148d58cd887$var$__webpack_exports__.U7E;
var $2c23f148d58cd887$export$38af1803e3442a7f = $2c23f148d58cd887$var$__webpack_exports__.Z58;
var $2c23f148d58cd887$export$c1825d965cf69ea3 = $2c23f148d58cd887$var$__webpack_exports__.yh2;
var $2c23f148d58cd887$export$a98515d67472a41f = $2c23f148d58cd887$var$__webpack_exports__.ff$;
var $2c23f148d58cd887$export$57486627f01aaaf3 = $2c23f148d58cd887$var$__webpack_exports__.cWi;
var $2c23f148d58cd887$export$77630fcd7c3f2eb6 = $2c23f148d58cd887$var$__webpack_exports__.NBt;
var $2c23f148d58cd887$export$3bf088dd0bb7575 = $2c23f148d58cd887$var$__webpack_exports__.oNz;
var $2c23f148d58cd887$export$2f3ac66e390c188b = $2c23f148d58cd887$var$__webpack_exports__.QlU;
var $2c23f148d58cd887$export$d160a188872e1e4e = $2c23f148d58cd887$var$__webpack_exports__.Xey;
var $2c23f148d58cd887$export$5c7bd08c630c970c = $2c23f148d58cd887$var$__webpack_exports__.jft;
var $2c23f148d58cd887$export$462bb059fed9d9e5 = $2c23f148d58cd887$var$__webpack_exports__.Mtr;
var $2c23f148d58cd887$export$6428a7f2611ef1fa = $2c23f148d58cd887$var$__webpack_exports__.ypk;
var $2c23f148d58cd887$export$80a00690bda7f17e = $2c23f148d58cd887$var$__webpack_exports__.mnM;
var $2c23f148d58cd887$export$50994fad4c4676f4 = $2c23f148d58cd887$var$__webpack_exports__.bAZ;
var $2c23f148d58cd887$export$85990f0f98a390bb = $2c23f148d58cd887$var$__webpack_exports__.ABN;
var $2c23f148d58cd887$export$5bff0d6cc6200d64 = $2c23f148d58cd887$var$__webpack_exports__.VK6;
var $2c23f148d58cd887$export$3075603db8e6204c = $2c23f148d58cd887$var$__webpack_exports__.kxk;
var $2c23f148d58cd887$export$e1896ac0c4970221 = $2c23f148d58cd887$var$__webpack_exports__.DT1;
var $2c23f148d58cd887$export$bd73ddfe5f8475d8 = $2c23f148d58cd887$var$__webpack_exports__.FLG;
var $2c23f148d58cd887$export$f62bb2892382b3dd = $2c23f148d58cd887$var$__webpack_exports__.qN_;
var $2c23f148d58cd887$export$cbf2d83d1eab018a = $2c23f148d58cd887$var$__webpack_exports__.Z37;
var $2c23f148d58cd887$export$9ad53eded130cce4 = $2c23f148d58cd887$var$__webpack_exports__.FtL;
var $2c23f148d58cd887$export$6a4eb2e7fc9e8903 = $2c23f148d58cd887$var$__webpack_exports__.Z6X;
var $2c23f148d58cd887$export$e1dae5660003ffa7 = $2c23f148d58cd887$var$__webpack_exports__.iQT;
var $2c23f148d58cd887$export$a12e67a4b4590901 = $2c23f148d58cd887$var$__webpack_exports__.ziO;
var $2c23f148d58cd887$export$7c88eb83095afadd = $2c23f148d58cd887$var$__webpack_exports__.OEF;
var $2c23f148d58cd887$export$c586aa7b67d94d19 = $2c23f148d58cd887$var$__webpack_exports__.uuE;
var $2c23f148d58cd887$export$47b45ce774071a36 = $2c23f148d58cd887$var$__webpack_exports__.tiv;
var $2c23f148d58cd887$export$9440a22058545f9a = $2c23f148d58cd887$var$__webpack_exports__.T$Y;
var $2c23f148d58cd887$export$5f1af8db9871e1d6 = $2c23f148d58cd887$var$__webpack_exports__.EYj;
var $2c23f148d58cd887$export$3720eb13f948f394 = $2c23f148d58cd887$var$__webpack_exports__.nOB;
var $2c23f148d58cd887$export$fd1bfc71f64c538c = $2c23f148d58cd887$var$__webpack_exports__.Tap;
var $2c23f148d58cd887$export$235cb65c20ad2b7 = $2c23f148d58cd887$var$__webpack_exports__.FAs;
var $2c23f148d58cd887$export$16ec26812de3ce7a = $2c23f148d58cd887$var$__webpack_exports__.B_P;
var $2c23f148d58cd887$export$dac3abbdc575ce73 = $2c23f148d58cd887$var$__webpack_exports__.aA5;
var $2c23f148d58cd887$export$c57e9b2d8b9e4de = $2c23f148d58cd887$var$__webpack_exports__.M4G;
var $2c23f148d58cd887$export$fb98e3a2a4cd92d7 = $2c23f148d58cd887$var$__webpack_exports__.l$l;
var $2c23f148d58cd887$export$563a914cafbdc389 = $2c23f148d58cd887$var$__webpack_exports__.dLy;
var $2c23f148d58cd887$export$1def2aa75b7c7fe0 = $2c23f148d58cd887$var$__webpack_exports__.WZP;
var $2c23f148d58cd887$export$be58926105124dd4 = $2c23f148d58cd887$var$__webpack_exports__.eB6;
var $2c23f148d58cd887$export$2eba8ec3a333fdbb = $2c23f148d58cd887$var$__webpack_exports__.nFK;
var $2c23f148d58cd887$export$41fb9f06171c75f4 = $2c23f148d58cd887$var$__webpack_exports__.l9z;
var $2c23f148d58cd887$export$14963f945d6d59f0 = $2c23f148d58cd887$var$__webpack_exports__.YOF;
var $2c23f148d58cd887$export$ba8651401a8a2b84 = $2c23f148d58cd887$var$__webpack_exports__.yhB;
var $2c23f148d58cd887$export$f8f26dd395d7e1bd = $2c23f148d58cd887$var$__webpack_exports__.J0N;
var $2c23f148d58cd887$export$9b781de7bf37bf48 = $2c23f148d58cd887$var$__webpack_exports__.Miz;
var $2c23f148d58cd887$export$ab650c8e5b9b9f2c = $2c23f148d58cd887$var$__webpack_exports__.Bj4;
var $2c23f148d58cd887$export$41825a1ed6473903 = $2c23f148d58cd887$var$__webpack_exports__.Rcs;
var $2c23f148d58cd887$export$f5ae2f144b95ebf4 = $2c23f148d58cd887$var$__webpack_exports__.vJ4;
var $2c23f148d58cd887$export$31ac8f65680039dd = $2c23f148d58cd887$var$__webpack_exports__.TqC;
var $2c23f148d58cd887$export$d5c6f73f7a77b9d = $2c23f148d58cd887$var$__webpack_exports__.nM0;
var $2c23f148d58cd887$export$8bfbf00b5dba81f6 = $2c23f148d58cd887$var$__webpack_exports__.X1u;
var $2c23f148d58cd887$export$2af5ef044257da25 = $2c23f148d58cd887$var$__webpack_exports__.SpZ;
var $2c23f148d58cd887$export$8c3375c231593a9d = $2c23f148d58cd887$var$__webpack_exports__.DX8;
var $2c23f148d58cd887$export$9a4eae43f302c46e = $2c23f148d58cd887$var$__webpack_exports__.Yx$;
var $2c23f148d58cd887$export$812cd9544993280d = $2c23f148d58cd887$var$__webpack_exports__.HK4;
var $2c23f148d58cd887$export$a4913eafbb02ceb4 = $2c23f148d58cd887$var$__webpack_exports__.SE$;
var $2c23f148d58cd887$export$7d15b64cf5a3a4c4 = $2c23f148d58cd887$var$__webpack_exports__.qE8;
var $2c23f148d58cd887$export$c372a5d5a3996cbf = $2c23f148d58cd887$var$__webpack_exports__.Pz7;
var $2c23f148d58cd887$export$7149c6ffc9994c32 = $2c23f148d58cd887$var$__webpack_exports__.sX_;
var $2c23f148d58cd887$export$d436988b04cb99a5 = $2c23f148d58cd887$var$__webpack_exports__.JuI;
var $2c23f148d58cd887$export$3ba9f2e94585ecc6 = $2c23f148d58cd887$var$__webpack_exports__.Nl$;
var $2c23f148d58cd887$export$25dac40984956196 = $2c23f148d58cd887$var$__webpack_exports__.OwT;
var $2c23f148d58cd887$export$57932b71da6538b7 = $2c23f148d58cd887$var$__webpack_exports__.P$G;
var $2c23f148d58cd887$export$a17402ef5f32064d = $2c23f148d58cd887$var$__webpack_exports__.mHV;
var $2c23f148d58cd887$export$d5dea09620a858fd = $2c23f148d58cd887$var$__webpack_exports__.Fx_;
var $2c23f148d58cd887$export$1377812d73ae3cab = $2c23f148d58cd887$var$__webpack_exports__.WFC;
var $2c23f148d58cd887$export$331f4c7ef74a9752 = $2c23f148d58cd887$var$__webpack_exports__.aDq;
var $2c23f148d58cd887$export$5f4e18965661d41f = $2c23f148d58cd887$var$__webpack_exports__.jIg;
var $2c23f148d58cd887$export$817667946f51142b = $2c23f148d58cd887$var$__webpack_exports__.UH3;
var $2c23f148d58cd887$export$adc479603c39b28 = $2c23f148d58cd887$var$__webpack_exports__.K6X;
var $2c23f148d58cd887$export$ba30ba18962891e7 = $2c23f148d58cd887$var$__webpack_exports__.C1Y;
var $2c23f148d58cd887$export$bcf8f1355133000b = $2c23f148d58cd887$var$__webpack_exports__.Aw1;
var $2c23f148d58cd887$export$256576ea924e6c90 = $2c23f148d58cd887$var$__webpack_exports__.A8$;
var $2c23f148d58cd887$export$786d9ab531bddbaa = $2c23f148d58cd887$var$__webpack_exports__.hsx;
var $2c23f148d58cd887$export$e87630d8ef35465d = $2c23f148d58cd887$var$__webpack_exports__.l9E;
var $2c23f148d58cd887$export$c3cedacda2d7ce48 = $2c23f148d58cd887$var$__webpack_exports__.aSf;
var $2c23f148d58cd887$export$5a62d8eea226ddc = $2c23f148d58cd887$var$__webpack_exports__.Zex;
var $2c23f148d58cd887$export$640d107500a3202a = $2c23f148d58cd887$var$__webpack_exports__.mXP;
var $2c23f148d58cd887$export$c6ab03c33733124a = $2c23f148d58cd887$var$__webpack_exports__.vt$;
var $2c23f148d58cd887$export$64a4b86c523eb0e1 = $2c23f148d58cd887$var$__webpack_exports__.hCA;
var $2c23f148d58cd887$export$506bf22710a79182 = $2c23f148d58cd887$var$__webpack_exports__.pjR;
var $2c23f148d58cd887$export$8b958c8ecd94a804 = $2c23f148d58cd887$var$__webpack_exports__.U43;
var $2c23f148d58cd887$export$816343276f749e02 = $2c23f148d58cd887$var$__webpack_exports__.pSZ;
var $2c23f148d58cd887$export$d02631cccf789723 = $2c23f148d58cd887$var$__webpack_exports__.y17;
var $2c23f148d58cd887$export$5dc5812d8b390c43 = $2c23f148d58cd887$var$__webpack_exports__.jVr;
var $2c23f148d58cd887$export$c5552dfdbc7cec71 = $2c23f148d58cd887$var$__webpack_exports__._SZ;
var $2c23f148d58cd887$export$56cb859c01fa134d = $2c23f148d58cd887$var$__webpack_exports__.xWn;
var $2c23f148d58cd887$export$cba01ba138429a1d = $2c23f148d58cd887$var$__webpack_exports__.ehJ;
var $2c23f148d58cd887$export$202e0172ed3c7be0 = $2c23f148d58cd887$var$__webpack_exports__.t6s;
var $2c23f148d58cd887$export$d55298c9efc5ed14 = $2c23f148d58cd887$var$__webpack_exports__.Eyn;

});

parcelRegister("cT3l2", function(module, exports) {

$parcel$export(module.exports, "Tiles", () => $7c4c300842bd4cf2$export$a6ce39bd9a106ca6);
$parcel$export(module.exports, "Harvestables", () => $7c4c300842bd4cf2$export$37d9b53b59a08454);
$parcel$export(module.exports, "Characters", () => $7c4c300842bd4cf2$export$a3168656a78efa21);
$parcel$export(module.exports, "Effects", () => $7c4c300842bd4cf2$export$af73ab700e00763e);
$parcel$export(module.exports, "Music", () => $7c4c300842bd4cf2$export$8336555462a952f6);
$parcel$export(module.exports, "Buildings", () => $7c4c300842bd4cf2$export$b3315802e6a8361c);
$parcel$export(module.exports, "spriteFont", () => $7c4c300842bd4cf2$export$7220ba373ff0e418);
$parcel$export(module.exports, "loader", () => $7c4c300842bd4cf2$export$f4c5de44377d2946);

var $3MXpL = parcelRequire("3MXpL");

var $5OWvW = parcelRequire("5OWvW");

var $xDOAK = parcelRequire("xDOAK");

var $dydUV = parcelRequire("dydUV");

var $5av6h = parcelRequire("5av6h");

var $j3z9A = parcelRequire("j3z9A");

var $HlcbL = parcelRequire("HlcbL");

var $g2N9S = parcelRequire("g2N9S");

var $b7KqF = parcelRequire("b7KqF");

var $jSmv3 = parcelRequire("jSmv3");

var $dzRwg = parcelRequire("dzRwg");

var $l9IO2 = parcelRequire("l9IO2");

var $6TwoO = parcelRequire("6TwoO");

var $jHlgG = parcelRequire("jHlgG");

var $brx6X = parcelRequire("brx6X");

var $fiaHJ = parcelRequire("fiaHJ");

var $7PB80 = parcelRequire("7PB80");

var $bFb2o = parcelRequire("bFb2o");

var $453ot = parcelRequire("453ot");

var $kTvut = parcelRequire("kTvut");

var $7Hvm6 = parcelRequire("7Hvm6");

var $ao44X = parcelRequire("ao44X");

var $fux0z = parcelRequire("fux0z");

var $ibe6T = parcelRequire("ibe6T");

var $8wp8m = parcelRequire("8wp8m");

var $k99GN = parcelRequire("k99GN");
const $7c4c300842bd4cf2$export$a6ce39bd9a106ca6 = {
    Dirt: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($5OWvW)))),
    Grass: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($xDOAK)))),
    Water: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($dydUV)))),
    Sand: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($5av6h)))),
    Red: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($j3z9A)))),
    Green: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($HlcbL)))),
    Forest: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($g2N9S))))
};
const $7c4c300842bd4cf2$export$20f257fc407da7a3 = {
    main: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($bFb2o))))
};
const $7c4c300842bd4cf2$export$36eb894561320b07 = {};
const $7c4c300842bd4cf2$export$37d9b53b59a08454 = {
    rock1: {
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($7PB80)))),
        type: (0, $ao44X.default),
        spawnTags: [
            "dirt"
        ],
        resourceType: "\uD83E\uDEA8",
        spawnNum: 5
    },
    tree1: {
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($fiaHJ)))),
        type: (0, $fux0z.default),
        spawnTags: [
            "grass"
        ],
        resourceType: "\uD83E\uDEB5",
        spawnNum: 15
    }
};
const $7c4c300842bd4cf2$export$a3168656a78efa21 = {
    Human: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($453ot))))
};
const $7c4c300842bd4cf2$export$af73ab700e00763e = {
    Lightning: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($brx6X))))
};
const $7c4c300842bd4cf2$export$8336555462a952f6 = {
    music1: new (0, $3MXpL.Sound)((0, (/*@__PURE__*/$parcel$interopDefault($jHlgG))))
};
const $7c4c300842bd4cf2$export$b3315802e6a8361c = {
    House1: {
        name: "House",
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($b7KqF)))),
        type: (0, $kTvut.default),
        walkability: -1,
        description: "Stores resources",
        cost: new Map([
            [
                "\uD83E\uDEB5",
                2
            ],
            [
                "\uD83E\uDEA8",
                2
            ]
        ])
    },
    Blacksmith: {
        name: "Blacksmith",
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($jSmv3)))),
        type: (0, $7Hvm6.default),
        walkability: -1,
        description: "Speeds up gathering",
        cost: new Map([
            [
                "\uD83E\uDEA8",
                4
            ]
        ])
    },
    Bridge: {
        name: "Bridge",
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($dzRwg)))),
        type: (0, $k99GN.default),
        walkability: 0,
        description: "Allows crossing rivers",
        cost: new Map([
            [
                "\uD83E\uDEB5",
                1
            ]
        ])
    },
    Farm: {
        name: "Farm",
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($l9IO2)))),
        type: (0, $ibe6T.default),
        walkability: 0,
        description: "Food source for farmers",
        cost: new Map([
            [
                "\uD83E\uDEB5",
                4
            ]
        ])
    },
    Church: {
        name: "Church",
        img: new (0, $3MXpL.ImageSource)((0, (/*@__PURE__*/$parcel$interopDefault($6TwoO)))),
        type: (0, $8wp8m.default),
        walkability: -1,
        description: "Recruit new followers",
        cost: new Map([
            [
                "\uD83E\uDEB5",
                6
            ],
            [
                "\uD83E\uDEA8",
                6
            ]
        ])
    }
};
const $7c4c300842bd4cf2$var$spriteFontSheet = (0, $3MXpL.SpriteSheet).fromImageSource({
    image: $7c4c300842bd4cf2$export$20f257fc407da7a3.main,
    grid: {
        rows: 3,
        columns: 16,
        spriteWidth: 16,
        spriteHeight: 16
    }
});
const $7c4c300842bd4cf2$export$7220ba373ff0e418 = new (0, $3MXpL.SpriteFont)({
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz,!'&.\"?- ",
    caseInsensitive: true,
    spriteSheet: $7c4c300842bd4cf2$var$spriteFontSheet,
    spacing: -6
});
const $7c4c300842bd4cf2$export$f4c5de44377d2946 = new (0, $3MXpL.Loader)();
// TODO: set loader.logo
for (const res of [
    Object.values($7c4c300842bd4cf2$export$a6ce39bd9a106ca6),
    Object.values($7c4c300842bd4cf2$export$20f257fc407da7a3),
    Object.values($7c4c300842bd4cf2$export$a3168656a78efa21),
    Object.values($7c4c300842bd4cf2$export$b3315802e6a8361c).map((b)=>b.img),
    Object.values($7c4c300842bd4cf2$export$37d9b53b59a08454).map((h)=>h.img),
    Object.values($7c4c300842bd4cf2$export$af73ab700e00763e),
    Object.values($7c4c300842bd4cf2$export$8336555462a952f6)
].flat())$7c4c300842bd4cf2$export$f4c5de44377d2946.addResource(res);

});
parcelRegister("5OWvW", function(module, exports) {
module.exports = new URL("dirt.da79c8c9.png", import.meta.url).toString();

});

parcelRegister("xDOAK", function(module, exports) {
module.exports = new URL("grass.855e10db.png", import.meta.url).toString();

});

parcelRegister("dydUV", function(module, exports) {
module.exports = new URL("water.a3e21d3c.png", import.meta.url).toString();

});

parcelRegister("5av6h", function(module, exports) {
module.exports = new URL("sand.b9ac2e04.png", import.meta.url).toString();

});

parcelRegister("j3z9A", function(module, exports) {
module.exports = new URL("red.99b8e618.png", import.meta.url).toString();

});

parcelRegister("HlcbL", function(module, exports) {
module.exports = new URL("green.c8fb0f7f.png", import.meta.url).toString();

});

parcelRegister("g2N9S", function(module, exports) {
module.exports = new URL("forest.41b1b19c.png", import.meta.url).toString();

});

parcelRegister("b7KqF", function(module, exports) {
module.exports = new URL("house1.41e514ef.png", import.meta.url).toString();

});

parcelRegister("jSmv3", function(module, exports) {
module.exports = new URL("blacksmith.3ffe1623.png", import.meta.url).toString();

});

parcelRegister("dzRwg", function(module, exports) {
module.exports = new URL("bridge.0eefba60.png", import.meta.url).toString();

});

parcelRegister("l9IO2", function(module, exports) {
module.exports = new URL("farm_healthy.1948560f.png", import.meta.url).toString();

});

parcelRegister("6TwoO", function(module, exports) {
module.exports = new URL("church.c23cb050.png", import.meta.url).toString();

});

parcelRegister("jHlgG", function(module, exports) {
module.exports = new URL("music_loop1.7791a4b7.mp3", import.meta.url).toString();

});

parcelRegister("brx6X", function(module, exports) {
module.exports = new URL("lightning.76aa3d8d.png", import.meta.url).toString();

});

parcelRegister("fiaHJ", function(module, exports) {
module.exports = new URL("tree1.4a0f8af3.png", import.meta.url).toString();

});

parcelRegister("7PB80", function(module, exports) {
module.exports = new URL("rock1.b4249491.png", import.meta.url).toString();

});

parcelRegister("bFb2o", function(module, exports) {
module.exports = new URL("font.6580b156.png", import.meta.url).toString();

});

parcelRegister("453ot", function(module, exports) {
module.exports = new URL("human.59524406.png", import.meta.url).toString();

});

parcelRegister("kTvut", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c9ae76c7ac1c2f6$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $jXu4v = parcelRequire("jXu4v");

var $7Hvm6 = parcelRequire("7Hvm6");
class $9c9ae76c7ac1c2f6$var$Depot extends (0, $7Hvm6.default) {
    constructor(isoMap, pos, img, walkability, cost){
        super(isoMap, pos, img, walkability, cost);
    }
    update(engine, delta) {
        super.update(engine, delta);
        if (this.label) {
            // update label
            const inventory = this.get((0, $jXu4v.InventoryComponent));
            this.label.text = `${inventory.getNumItems()}/${inventory.capacity}`;
        }
    }
    onConstructionDone() {
        super.onConstructionDone();
        // add inventory component
        this.addComponent(new (0, $jXu4v.InventoryComponent)());
        this.get((0, $jXu4v.InventoryComponent)).capacity = 10;
        // add label showing the building inventory capacity
        const label = new (0, $3MXpL.Label)({
            text: "0/0",
            pos: (0, $3MXpL.vec)(-10, 0),
            color: (0, $3MXpL.Color).fromHex("#ffa618"),
            font: new (0, $3MXpL.Font)({
                size: 15,
                family: "Alagard"
            }),
            z: 1000
        });
        this.addChild(label);
        this.label = label;
    }
}
var $9c9ae76c7ac1c2f6$export$2e2bcd8739ae039 = $9c9ae76c7ac1c2f6$var$Depot;

});
parcelRegister("jXu4v", function(module, exports) {

$parcel$export(module.exports, "InventoryComponent", () => $8d3498737fd94a18$export$6c13bcde38f46341);

var $3MXpL = parcelRequire("3MXpL");

var $h4y3h = parcelRequire("h4y3h");
class $8d3498737fd94a18$export$6c13bcde38f46341 extends (0, $3MXpL.Component) {
    onAdd() {}
    addItem(item) {
        if (this.hasCapacity()) {
            this.items.set(item, (this.items.get(item) ?? 0) + 1);
            (0, $h4y3h.Storage).addResource(item, 1);
            return true;
        } else return false;
    }
    getNumItems() {
        return Array.from(this.items.values()).reduce((a, b)=>a + b, 0) ?? 0;
    }
    clearInventory() {
        console.log("Clearing inventory");
        for (const [item, count] of this.items.entries())(0, $h4y3h.Storage).removeResource(item, count);
        this.items.clear();
    }
    removeItem(item) {
        // if no item is specified, remove any item
        if (!item) item = Array.from(this.items.keys())[0];
        // if there is no item to remove, return
        if (this.items.has(item) === false) return null;
        // remove one of this item from the inventory
        this.items.set(item, this.items.get(item) - 1);
        // if the item count is 0, remove it from the inventory
        if (this.items.get(item) === 0) this.items.delete(item);
        (0, $h4y3h.Storage).removeResource(item, 1);
        return item;
    }
    hasCapacity() {
        return this.getNumItems() < this.capacity;
    }
    constructor(...args){
        super(...args);
        this.items = new Map();
        this.capacity = 3;
    }
}

});
parcelRegister("h4y3h", function(module, exports) {

$parcel$export(module.exports, "Storage", () => $372d9dcfc71c4a48$export$bf2a15d34f3c441c);

var $jXu4v = parcelRequire("jXu4v");
class $372d9dcfc71c4a48$export$bf2a15d34f3c441c {
    static{
        this.storage = new Map();
    }
    static canAfford(cost) {
        for (const [resource, amount] of cost.entries()){
            if (($372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.get(resource) ?? 0) < amount) return false;
        }
        return true;
    }
    static addResource(resource, amount) {
        $372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.set(resource, ($372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.get(resource) ?? 0) + amount);
    }
    static removeResource(resource, amount) {
        $372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.set(resource, ($372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.get(resource) ?? 0) - amount);
        // if it's less than 0, set it to 0
        if ($372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.get(resource) < 0) $372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.set(resource, 0);
    }
    // clear all inventories in the world and reset storage
    static clearInventories(world) {
        const inventoryQuery = world.query([
            (0, $jXu4v.InventoryComponent)
        ]);
        for (let entity of inventoryQuery.entities)entity.get((0, $jXu4v.InventoryComponent)).items.clear();
        $372d9dcfc71c4a48$export$bf2a15d34f3c441c.storage.clear();
    }
    static pay(cost, world) {
        // query all inventory + building components
        const inventoryQuery = world.query([
            (0, $jXu4v.InventoryComponent)
        ]);
        const tempCost = new Map(cost);
        for (let entity of inventoryQuery.entities){
            const inventory = entity.get((0, $jXu4v.InventoryComponent));
            // remove resources from this inventory until we've paid
            // the cost or run out of resources of this type
            for (const resourceType of cost.keys())// start removing resources from this inventory
            while((inventory.items.get(resourceType) ?? 0) > 0 && // we have this resource
            tempCost.get(resourceType) > 0 // we still need to pay for this resource
            ){
                inventory.removeItem(resourceType);
                tempCost.set(resourceType, tempCost.get(resourceType) - 1);
            }
        }
    }
}

});


parcelRegister("7Hvm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1e94ad3a2616be$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $64gHy = parcelRequire("64gHy");

var $4TRBa = parcelRequire("4TRBa");

var $1U10Z = parcelRequire("1U10Z");

var $eikyf = parcelRequire("eikyf");

var $h4y3h = parcelRequire("h4y3h");
/**
 * Building actor
 */ class $6c1e94ad3a2616be$var$Building extends (0, $3MXpL.Actor) {
    constructor(isoMap, pos, img, walkability, cost){
        super({
            x: pos.x,
            y: pos.y
        });
        this.radius = 1;
        this.construction_progress = 0;
        this.placed = false;
        this.walkability = -1;
        this.cost = new Map();
        this.isoMap = isoMap;
        this.cost = cost;
        this.addComponent(new (0, $3MXpL.IsometricEntityComponent)(this.isoMap));
        this.graphics.use(img.toSprite());
        // building initially has an opacity of 0.5 and follows the mouse
        this.graphics.opacity = 0.25;
        this.on("pointerup", (evt)=>{
            // make sure the building is placed on a tile
            if (this.isoMap.getTile(this.isoMap.worldToTile(this.pos).x, this.isoMap.worldToTile(this.pos).y) && evt.nativeEvent.target === (0, $64gHy.game).canvas) this.place();
        });
        this.walkability = walkability;
    }
    onConstructionDone() {
        console.log("Adding building component");
        this.addComponent(new (0, $eikyf.BuildingComponent)());
        this.addTag("buildingObject");
        this.children.find((child)=>child instanceof (0, $4TRBa.default)).kill();
    }
    // update
    update(engine, delta) {
        super.update(engine, delta);
        if (!this.placed) {
            const pointerWorldPos = engine.input.pointers.primary.lastWorldPos;
            this.pos = this.isoMap.tileToWorld(this.isoMap.worldToTile(pointerWorldPos));
        }
        // update construction progress
        if (this.placed && this.construction_progress < 1) {
            this.construction_progress += delta / 5000;
            this.children.find((child)=>child instanceof (0, $4TRBa.default)).setPercent(Math.round(this.construction_progress * 100));
            this.graphics.opacity = 0.25 + this.construction_progress * 0.75;
            if (this.construction_progress >= 1) this.onConstructionDone();
        }
    }
    die() {
        // if the building actor is in the harvestables array, remove it
        if ((0, $64gHy.game).currentScene) {
            const scene = (0, $64gHy.game).currentScene;
            scene.harvestables = scene.harvestables.filter((h)=>h.id !== this.id);
        }
        this.kill();
    }
    place() {
        // check storage to see if we have enough resources
        if (!(0, $h4y3h.Storage).canAfford(this.cost)) {
            console.log("Not enough resources");
            this.die();
            return;
        }
        // remove event subscriptions
        this.off("pointermove");
        this.off("pointerup");
        // add child progress bar
        const progressBar = new (0, $4TRBa.default)({
            width: 32,
            height: 4
        });
        this.addChild(progressBar);
        this.placed = true;
        this.collider.set((0, $1U10Z.compute_iso_collider)(this.graphics.current));
        // mark tiles as solid
        const canPlace = (0, $1U10Z.mark_tile_solid_single)(this.isoMap, this, this.walkability);
        if (!canPlace) {
            console.log("Cannot place building here");
            this.die();
            return;
        }
        (0, $h4y3h.Storage).pay(this.cost, this.scene.world);
    }
}
var $6c1e94ad3a2616be$export$2e2bcd8739ae039 = $6c1e94ad3a2616be$var$Building;

});
parcelRegister("64gHy", function(module, exports) {

$parcel$export(module.exports, "game", () => $ad2bcec7a0192558$export$119d2a93e2780362);

var $3MXpL = parcelRequire("3MXpL");

var $cT3l2 = parcelRequire("cT3l2");

var $gnhCa = parcelRequire("gnhCa");

var $fARY1 = parcelRequire("fARY1");
class $ad2bcec7a0192558$var$Game extends (0, $3MXpL.Engine) {
    constructor(){
        super({
            canvasElementId: "game",
            viewport: {
                width: 1920,
                height: 600
            },
            resolution: {
                width: 1920,
                height: 600
            },
            pixelArt: true,
            maxFps: 60,
            scenes: {
                mainScene: (0, $gnhCa.default)
            },
            displayMode: (0, $3MXpL.DisplayMode).FitContainer,
            backgroundColor: (0, $3MXpL.Color).Black,
            pointerScope: (0, $3MXpL.PointerScope).Canvas
        });
    }
    initialize() {
        this.start((0, $cT3l2.loader));
        console.log(this.currentSceneName);
        this.goToScene("mainScene");
        this.graphicsContext.addPostProcessor(new (0, $fARY1.default)());
    }
}
const $ad2bcec7a0192558$export$119d2a93e2780362 = new $ad2bcec7a0192558$var$Game();
$ad2bcec7a0192558$export$119d2a93e2780362.graphicsContext.smoothing = false;
$ad2bcec7a0192558$export$119d2a93e2780362.initialize();

});
parcelRegister("gnhCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ed0a60d92e6d2e$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $hi3S8 = parcelRequire("hi3S8");

var $cT3l2 = parcelRequire("cT3l2");

var $dMkvN = parcelRequire("dMkvN");

var $298SR = parcelRequire("298SR");

var $1SJ76 = parcelRequire("1SJ76");

var $1U10Z = parcelRequire("1U10Z");

var $e3Jww = parcelRequire("e3Jww");

var $bkNL1 = parcelRequire("bkNL1");

var $hNuoF = parcelRequire("hNuoF");

var $aOdfL = parcelRequire("aOdfL");

var $gQ5iS = parcelRequire("gQ5iS");

var $ciCQE = parcelRequire("ciCQE");

var $ci50R = parcelRequire("ci50R");

var $jo53f = parcelRequire("jo53f");

var $8bz7c = parcelRequire("8bz7c");

var $h4y3h = parcelRequire("h4y3h");

var $8DYOc = parcelRequire("8DYOc");
class $d9ed0a60d92e6d2e$var$MainScene extends (0, $3MXpL.Scene) {
    update(engine, delta) {
        super.update(engine, delta);
        // increment game time on document
        const timeElement = document.getElementById("time");
        timeElement.innerText = this.gameTime.toFixed(2);
        // increment game time
        this.gameTime += delta / 1000;
    }
    /**
   * Start-up logic, called once
   */ onInitialize(engine) {
        // first, add camera controller
        this.add(new (0, $298SR.default)());
        // initialize status table
        this.status_table = new (0, $hi3S8.TabulatorFull)("#status-table", {
            height: 205,
            data: [],
            layout: "fitColumns",
            columns: [
                //Define Table Columns
                {
                    title: "ID",
                    field: "id",
                    width: 50
                },
                {
                    title: "Name",
                    field: "name",
                    width: 150
                },
                {
                    title: "State",
                    field: "state"
                },
                {
                    title: "Health",
                    field: "health",
                    formatter: "progress",
                    formatterParams: {
                        color: "#FF0000",
                        legend: function(value) {
                            // round to 2 decimal places
                            return parseFloat(value).toFixed(2) + "/100";
                        }
                    }
                },
                {
                    title: "Food",
                    field: "food",
                    formatter: "progress",
                    formatterParams: {
                        color: "#f4FF00",
                        legend: function(value) {
                            // round to 2 decimal places
                            return parseFloat(value).toFixed(2) + "/100";
                        }
                    }
                },
                {
                    title: "Visible Objects",
                    field: "vision"
                },
                {
                    title: "Inventory",
                    field: "inventory"
                },
                {
                    title: "Role (Click to change)",
                    field: "role",
                    editor: "list",
                    cellEdited: function(cell) {
                        console.log(`Changing role for ${cell.getData().id}`);
                        const entity = engine.currentScene.world.entityManager.getById(cell.getData().id);
                        const character = entity;
                        const characterComponent = character.get((0, $8bz7c.CharacterComponent));
                        characterComponent.role = cell.getData().role;
                    },
                    editorParams: {
                        multiSelect: true,
                        values: {
                            miner: "Miner",
                            farmer: "Farmer",
                            woodcutter: "Woodcutter",
                            idle: "Idle"
                        }
                    }
                }
            ]
        });
        this.status_table.on("tableBuilt", ()=>{
            console.log("Table built");
            (0, $ciCQE.default).table_built = true;
        });
        // initialize scene actors
        this.isoMap = new (0, $3MXpL.IsometricMap)({
            pos: (0, $3MXpL.vec)(500, 200),
            tileWidth: 32,
            tileHeight: 16,
            columns: 48,
            rows: 48
        });
        this.navgrid = (0, $1U10Z.init_navgrid)(this.isoMap);
        this.noiseGen = (0, $dMkvN.createNoise2D)();
        // generate rivers
        // pick a random start point on the edge of the map
        const start = (0, $3MXpL.vec)(0, Math.floor(Math.random() * this.isoMap.rows));
        // make sure the start point is not too close to the edge
        if (start.y < 5 || start.y > this.isoMap.rows - 5) start.y = 5;
        for(let i = 0; i < 200; i++){
            const tile = this.isoMap.getTile(start.x, start.y);
            tile?.addTag("water");
            // add a bunch of sand tiles around the water
            for(let x = -1; x < 2; x++)for(let y = -1; y < 2; y++){
                const sandTile = this.isoMap.getTile(start.x + x, start.y + y);
                if (sandTile && !sandTile.tags.has("water")) {
                    sandTile.addGraphic((0, $cT3l2.Tiles).Sand.toSprite());
                    sandTile.addTag("sand");
                }
            }
            // randomly change direction
            if (i % 2 === 0) {
                const dir = Math.random();
                if (dir < 0.5) start.y--;
                else if (dir > 0.5) start.y++;
            } else start.x++;
            if (tile) tile.addGraphic((0, $cT3l2.Tiles).Water.toSprite());
        }
        // generate base terrain
        for (let tile of this.isoMap.tiles){
            if (tile.tags.has("water") || tile.tags.has("sand")) continue;
            // get perlin noise to determine tile type
            const noise = this.noiseGen(tile.x / 16, tile.y / 16);
            if (noise < -0.2) {
                tile.addGraphic((0, $cT3l2.Tiles).Dirt.toSprite());
                tile.addTag("dirt");
            } else {
                tile.addGraphic((0, $cT3l2.Tiles).Grass.toSprite());
                tile.addTag("grass");
            }
        }
        // spawn harvestables
        for (let harvestable of Object.values((0, $cT3l2.Harvestables))){
            console.log(`Spawning ${harvestable.type.name}`);
            (0, $1U10Z.spawner)(5, harvestable.spawnNum, this.isoMap, harvestable.spawnTags).forEach((pos)=>{
                const obj = new harvestable.type(this.isoMap, {
                    pos: pos
                }, harvestable.img, harvestable.resourceType);
                this.add(obj);
                this.harvestables.push(obj);
            });
        }
        // initialize pathfinding
        (0, $1U10Z.mark_tiles_as_solid)(this.isoMap);
        // spawn humans in random locations
        Array.from((0, $1U10Z.spawner)(1, 4, this.isoMap, "grass")).forEach((pos, idx)=>{
            const human = new (0, $1SJ76.default)(this.isoMap, {
                pos: pos
            });
            console.log(idx);
            switch(idx){
                case 0:
                    human.get((0, $8bz7c.CharacterComponent)).role = (0, $8bz7c.CharacterRole).WOODCUTTER;
                    break;
                case 1:
                    human.get((0, $8bz7c.CharacterComponent)).role = (0, $8bz7c.CharacterRole).WOODCUTTER;
                    break;
                case 2:
                    human.get((0, $8bz7c.CharacterComponent)).role = (0, $8bz7c.CharacterRole).MINER;
                    break;
                case 3:
                    human.get((0, $8bz7c.CharacterComponent)).role = (0, $8bz7c.CharacterRole).MINER;
                    break;
            }
            this.add(human);
        });
        // add the map to the scene
        this.add(this.isoMap);
        // initialize building palette
        const palette = document.getElementById("palette");
        // iterate through all buildings and add them as images to the palette
        for (const building of Object.values((0, $cT3l2.Buildings))){
            const div = document.createElement("div");
            div.className = "palette-item";
            const img = document.createElement("img");
            div.appendChild(img);
            // create label for image
            const label = document.createElement("label");
            // repeat keys the number of times the value is
            const costString = Array.from(building.cost.keys()).map((key)=>key.repeat(building.cost.get(key))).join("");
            label.innerHTML = `${building.name} <br> ${building.description} <br> ${costString}`;
            label.className = "palette-label";
            div.appendChild(label);
            img.src = building.img.path;
            img.width = 64;
            img.height = 64;
            img.style.cursor = "pointer";
            div.onclick = ()=>{
                const pos = engine.input.pointers.primary.lastWorldPos;
                // create object depending on what buliding.type is
                const buildingObj = new building.type(this.isoMap, pos, building.img, building.walkability, building.cost);
                this.add(buildingObj);
            };
            this.buildingDefinitions.push({
                definition: building,
                element: div
            });
            palette?.appendChild(div);
        }
        document.getElementById("clear-storage").onclick = ()=>{
            (0, $h4y3h.Storage).clearInventories(this.world);
        };
        this.world.add((0, $e3Jww.default));
        this.world.add((0, $bkNL1.default));
        this.world.add((0, $hNuoF.default));
        this.world.add((0, $aOdfL.default));
        this.world.add((0, $gQ5iS.default));
        this.world.add((0, $ci50R.default));
        this.world.add((0, $8DYOc.default));
        this.world.add((0, $jo53f.default));
        this.uiUpdateSystem = new (0, $ciCQE.default)(this.world);
        const uiUpdateTimer = new (0, $3MXpL.Timer)({
            fcn: ()=>this.uiUpdateSystem?.update(0),
            repeats: true,
            interval: 500
        });
        engine.currentScene.add(uiUpdateTimer);
        uiUpdateTimer.start();
        (0, $cT3l2.Music).music1.play(0.5);
        (0, $cT3l2.Music).music1.loop = true;
    }
    constructor(...args){
        super(...args);
        this.draggingEntity = null;
        // grid of integers for pathfinding
        this.navgrid = null;
        this.harvestables = [];
        this.status_table = null;
        this.gameTime = 0;
        this.buildingDefinitions = [];
        this.uiUpdateSystem = null;
        this.deaths = [];
    }
}
var $d9ed0a60d92e6d2e$export$2e2bcd8739ae039 = $d9ed0a60d92e6d2e$var$MainScene;

});
parcelRegister("hi3S8", function(module, exports) {

$parcel$export(module.exports, "TabulatorFull", () => $c2a9788f40f9c90a$export$62676a0a2827a643);
/* Tabulator v6.3.0 (c) Oliver Folkerd 2024 */ class $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        this.table = table;
    }
    //////////////////////////////////////////
    /////////////// DataLoad /////////////////
    //////////////////////////////////////////
    reloadData(data, silent, columnsChanged) {
        return this.table.dataLoader.load(data, undefined, undefined, undefined, silent, columnsChanged);
    }
    //////////////////////////////////////////
    ///////////// Localization ///////////////
    //////////////////////////////////////////
    langText() {
        return this.table.modules.localize.getText(...arguments);
    }
    langBind() {
        return this.table.modules.localize.bind(...arguments);
    }
    langLocale() {
        return this.table.modules.localize.getLocale(...arguments);
    }
    //////////////////////////////////////////
    ////////// Inter Table Comms /////////////
    //////////////////////////////////////////
    commsConnections() {
        return this.table.modules.comms.getConnections(...arguments);
    }
    commsSend() {
        return this.table.modules.comms.send(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Layout  /////////////////
    //////////////////////////////////////////
    layoutMode() {
        return this.table.modules.layout.getMode();
    }
    layoutRefresh(force) {
        return this.table.modules.layout.layout(force);
    }
    //////////////////////////////////////////
    /////////////// Event Bus ////////////////
    //////////////////////////////////////////
    subscribe() {
        return this.table.eventBus.subscribe(...arguments);
    }
    unsubscribe() {
        return this.table.eventBus.unsubscribe(...arguments);
    }
    subscribed(key) {
        return this.table.eventBus.subscribed(key);
    }
    subscriptionChange() {
        return this.table.eventBus.subscriptionChange(...arguments);
    }
    dispatch() {
        return this.table.eventBus.dispatch(...arguments);
    }
    chain() {
        return this.table.eventBus.chain(...arguments);
    }
    confirm() {
        return this.table.eventBus.confirm(...arguments);
    }
    dispatchExternal() {
        return this.table.externalEvents.dispatch(...arguments);
    }
    subscribedExternal(key) {
        return this.table.externalEvents.subscribed(key);
    }
    subscriptionChangeExternal() {
        return this.table.externalEvents.subscriptionChange(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Options /////////////////
    //////////////////////////////////////////
    options(key) {
        return this.table.options[key];
    }
    setOption(key, value) {
        if (typeof value !== "undefined") this.table.options[key] = value;
        return this.table.options[key];
    }
    //////////////////////////////////////////
    /////////// Deprecation Checks ///////////
    //////////////////////////////////////////
    deprecationCheck(oldOption, newOption, convert) {
        return this.table.deprecationAdvisor.check(oldOption, newOption, convert);
    }
    deprecationCheckMsg(oldOption, msg) {
        return this.table.deprecationAdvisor.checkMsg(oldOption, msg);
    }
    deprecationMsg(msg) {
        return this.table.deprecationAdvisor.msg(msg);
    }
    //////////////////////////////////////////
    //////////////// Modules /////////////////
    //////////////////////////////////////////
    module(key) {
        return this.table.module(key);
    }
}
class $c2a9788f40f9c90a$var$Helpers {
    static elVisible(el) {
        return !(el.offsetWidth <= 0 && el.offsetHeight <= 0);
    }
    static elOffset(el) {
        var box = el.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        };
    }
    static retrieveNestedData(separator, field, data) {
        var structure = separator ? field.split(separator) : [
            field
        ], length = structure.length, output;
        for(let i = 0; i < length; i++){
            data = data[structure[i]];
            output = data;
            if (!data) break;
        }
        return output;
    }
    static deepClone(obj, clone, list = []) {
        var objectProto = {}.__proto__, arrayProto = [].__proto__;
        if (!clone) clone = Object.assign(Array.isArray(obj) ? [] : {}, obj);
        for(var i in obj){
            let subject = obj[i], match, copy;
            if (subject != null && typeof subject === "object" && (subject.__proto__ === objectProto || subject.__proto__ === arrayProto)) {
                match = list.findIndex((item)=>{
                    return item.subject === subject;
                });
                if (match > -1) clone[i] = list[match].copy;
                else {
                    copy = Object.assign(Array.isArray(subject) ? [] : {}, subject);
                    list.unshift({
                        subject: subject,
                        copy: copy
                    });
                    clone[i] = this.deepClone(subject, copy, list);
                }
            }
        }
        return clone;
    }
}
let $c2a9788f40f9c90a$var$Popup$1 = class Popup extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, element, parent){
        super(table);
        this.element = element;
        this.container = this._lookupContainer();
        this.parent = parent;
        this.reversedX = false;
        this.childPopup = null;
        this.blurable = false;
        this.blurCallback = null;
        this.blurEventsBound = false;
        this.renderedCallback = null;
        this.visible = false;
        this.hideable = true;
        this.element.classList.add("tabulator-popup-container");
        this.blurEvent = this.hide.bind(this, false);
        this.escEvent = this._escapeCheck.bind(this);
        this.destroyBinding = this.tableDestroyed.bind(this);
        this.destroyed = false;
    }
    tableDestroyed() {
        this.destroyed = true;
        this.hide(true);
    }
    _lookupContainer() {
        var container = this.table.options.popupContainer;
        if (typeof container === "string") {
            container = document.querySelector(container);
            if (!container) console.warn("Menu Error - no container element found matching selector:", this.table.options.popupContainer, "(defaulting to document body)");
        } else if (container === true) container = this.table.element;
        if (container && !this._checkContainerIsParent(container)) {
            container = false;
            console.warn("Menu Error - container element does not contain this table:", this.table.options.popupContainer, "(defaulting to document body)");
        }
        if (!container) container = document.body;
        return container;
    }
    _checkContainerIsParent(container, element = this.table.element) {
        if (container === element) return true;
        else return element.parentNode ? this._checkContainerIsParent(container, element.parentNode) : false;
    }
    renderCallback(callback) {
        this.renderedCallback = callback;
    }
    containerEventCoords(e) {
        var touch = !(e instanceof MouseEvent);
        var x = touch ? e.touches[0].pageX : e.pageX;
        var y = touch ? e.touches[0].pageY : e.pageY;
        if (this.container !== document.body) {
            let parentOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            x -= parentOffset.left;
            y -= parentOffset.top;
        }
        return {
            x: x,
            y: y
        };
    }
    elementPositionCoords(element, position = "right") {
        var offset = $c2a9788f40f9c90a$var$Helpers.elOffset(element), containerOffset, x, y;
        if (this.container !== document.body) {
            containerOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            offset.left -= containerOffset.left;
            offset.top -= containerOffset.top;
        }
        switch(position){
            case "right":
                x = offset.left + element.offsetWidth;
                y = offset.top - 1;
                break;
            case "bottom":
                x = offset.left;
                y = offset.top + element.offsetHeight;
                break;
            case "left":
                x = offset.left;
                y = offset.top - 1;
                break;
            case "top":
                x = offset.left;
                y = offset.top;
                break;
            case "center":
                x = offset.left + element.offsetWidth / 2;
                y = offset.top + element.offsetHeight / 2;
                break;
        }
        return {
            x: x,
            y: y,
            offset: offset
        };
    }
    show(origin, position) {
        var x, y, parentEl, parentOffset, coords;
        if (this.destroyed || this.table.destroyed) return this;
        if (origin instanceof HTMLElement) {
            parentEl = origin;
            coords = this.elementPositionCoords(origin, position);
            parentOffset = coords.offset;
            x = coords.x;
            y = coords.y;
        } else if (typeof origin === "number") {
            parentOffset = {
                top: 0,
                left: 0
            };
            x = origin;
            y = position;
        } else {
            coords = this.containerEventCoords(origin);
            x = coords.x;
            y = coords.y;
            this.reversedX = false;
        }
        this.element.style.top = y + "px";
        this.element.style.left = x + "px";
        this.container.appendChild(this.element);
        if (typeof this.renderedCallback === "function") this.renderedCallback();
        this._fitToScreen(x, y, parentEl, parentOffset, position);
        this.visible = true;
        this.subscribe("table-destroy", this.destroyBinding);
        this.element.addEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        return this;
    }
    _fitToScreen(x, y, parentEl, parentOffset, position) {
        var scrollTop = this.container === document.body ? document.documentElement.scrollTop : this.container.scrollTop;
        //move menu to start on right edge if it is too close to the edge of the screen
        if (x + this.element.offsetWidth >= this.container.offsetWidth || this.reversedX) {
            this.element.style.left = "";
            if (parentEl) this.element.style.right = this.container.offsetWidth - parentOffset.left + "px";
            else this.element.style.right = this.container.offsetWidth - x + "px";
            this.reversedX = true;
        }
        //move menu to start on bottom edge if it is too close to the edge of the screen
        let offsetHeight = Math.max(this.container.offsetHeight, scrollTop ? this.container.scrollHeight : 0);
        if (y + this.element.offsetHeight > offsetHeight) {
            if (parentEl) switch(position){
                case "bottom":
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight - parentEl.offsetHeight - 1 + "px";
                    break;
                default:
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + parentEl.offsetHeight + 1 + "px";
            }
            else this.element.style.height = offsetHeight + "px";
        }
    }
    isVisible() {
        return this.visible;
    }
    hideOnBlur(callback) {
        this.blurable = true;
        if (this.visible) {
            setTimeout(()=>{
                if (this.visible) {
                    this.table.rowManager.element.addEventListener("scroll", this.blurEvent);
                    this.subscribe("cell-editing", this.blurEvent);
                    document.body.addEventListener("click", this.blurEvent);
                    document.body.addEventListener("contextmenu", this.blurEvent);
                    document.body.addEventListener("mousedown", this.blurEvent);
                    window.addEventListener("resize", this.blurEvent);
                    document.body.addEventListener("keydown", this.escEvent);
                    this.blurEventsBound = true;
                }
            }, 100);
            this.blurCallback = callback;
        }
        return this;
    }
    _escapeCheck(e) {
        if (e.keyCode == 27) this.hide();
    }
    blockHide() {
        this.hideable = false;
    }
    restoreHide() {
        this.hideable = true;
    }
    hide(silent = false) {
        if (this.visible && this.hideable) {
            if (this.blurable && this.blurEventsBound) {
                document.body.removeEventListener("keydown", this.escEvent);
                document.body.removeEventListener("click", this.blurEvent);
                document.body.removeEventListener("contextmenu", this.blurEvent);
                document.body.removeEventListener("mousedown", this.blurEvent);
                window.removeEventListener("resize", this.blurEvent);
                this.table.rowManager.element.removeEventListener("scroll", this.blurEvent);
                this.unsubscribe("cell-editing", this.blurEvent);
                this.blurEventsBound = false;
            }
            if (this.childPopup) this.childPopup.hide();
            if (this.parent) this.parent.childPopup = null;
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.visible = false;
            if (this.blurCallback && !silent) this.blurCallback();
            this.unsubscribe("table-destroy", this.destroyBinding);
        }
        return this;
    }
    child(element) {
        if (this.childPopup) this.childPopup.hide();
        this.childPopup = new Popup(this.table, element, this);
        return this.childPopup;
    }
};
class $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, name){
        super(table);
        this._handler = null;
    }
    initialize() {
    // setup module when table is initialized, to be overridden in module
    }
    ///////////////////////////////////
    ////// Options Registration ///////
    ///////////////////////////////////
    registerTableOption(key, value) {
        this.table.optionsList.register(key, value);
    }
    registerColumnOption(key, value) {
        this.table.columnManager.optionsList.register(key, value);
    }
    ///////////////////////////////////
    /// Public Function Registration ///
    ///////////////////////////////////
    registerTableFunction(name, func) {
        if (typeof this.table[name] === "undefined") this.table[name] = (...args)=>{
            this.table.initGuard(name);
            return func(...args);
        };
        else console.warn("Unable to bind table function, name already in use", name);
    }
    registerComponentFunction(component, func, handler) {
        return this.table.componentFunctionBinder.bind(component, func, handler);
    }
    ///////////////////////////////////
    ////////// Data Pipeline //////////
    ///////////////////////////////////
    registerDataHandler(handler, priority) {
        this.table.rowManager.registerDataPipelineHandler(handler, priority);
        this._handler = handler;
    }
    registerDisplayHandler(handler, priority) {
        this.table.rowManager.registerDisplayPipelineHandler(handler, priority);
        this._handler = handler;
    }
    displayRows(adjust) {
        var index = this.table.rowManager.displayRows.length - 1, lookupIndex;
        if (this._handler) {
            lookupIndex = this.table.rowManager.displayPipeline.findIndex((item)=>{
                return item.handler === this._handler;
            });
            if (lookupIndex > -1) index = lookupIndex;
        }
        if (adjust) index = index + adjust;
        if (this._handler) {
            if (index > -1) return this.table.rowManager.getDisplayRows(index);
            else return this.activeRows();
        }
    }
    activeRows() {
        return this.table.rowManager.activeRows;
    }
    refreshData(renderInPosition, handler) {
        if (!handler) handler = this._handler;
        if (handler) this.table.rowManager.refreshActiveData(handler, false, renderInPosition);
    }
    ///////////////////////////////////
    //////// Footer Management ////////
    ///////////////////////////////////
    footerAppend(element) {
        return this.table.footerManager.append(element);
    }
    footerPrepend(element) {
        return this.table.footerManager.prepend(element);
    }
    footerRemove(element) {
        return this.table.footerManager.remove(element);
    }
    ///////////////////////////////////
    //////// Popups Management ////////
    ///////////////////////////////////
    popup(menuEl, menuContainer) {
        return new $c2a9788f40f9c90a$var$Popup$1(this.table, menuEl, menuContainer);
    }
    ///////////////////////////////////
    //////// Alert Management ////////
    ///////////////////////////////////
    alert(content, type) {
        return this.table.alertManager.alert(content, type);
    }
    clearAlert() {
        return this.table.alertManager.clear();
    }
}
var $c2a9788f40f9c90a$var$defaultAccessors = {
    rownum: function(value, data, type, params, column, row) {
        return row.getPosition();
    }
};
class $c2a9788f40f9c90a$export$bf9f5472bce61c69 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "accessor";
    //load defaults
    static accessors = $c2a9788f40f9c90a$var$defaultAccessors;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "download",
            "clipboard",
            "print",
            "htmlOutput"
        ]; //list of accessor types
        this.registerColumnOption("accessor");
        this.registerColumnOption("accessorParams");
        this.registerColumnOption("accessorData");
        this.registerColumnOption("accessorDataParams");
        this.registerColumnOption("accessorDownload");
        this.registerColumnOption("accessorDownloadParams");
        this.registerColumnOption("accessorClipboard");
        this.registerColumnOption("accessorClipboardParams");
        this.registerColumnOption("accessorPrint");
        this.registerColumnOption("accessorPrintParams");
        this.registerColumnOption("accessorHtmlOutput");
        this.registerColumnOption("accessorHtmlOutputParams");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-retrieve", this.transformRow.bind(this));
    }
    //initialize column accessor
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), accessor;
            if (column.definition[key]) {
                accessor = this.lookupAccessor(column.definition[key]);
                if (accessor) {
                    match = true;
                    config[key] = {
                        accessor: accessor,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.accessor = config;
    }
    lookupAccessor(value) {
        var accessor = false;
        //set column accessor
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value]) accessor = $c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value];
                else console.warn("Accessor Error - No such accessor found, ignoring: ", value);
                break;
            case "function":
                accessor = value;
                break;
        }
        return accessor;
    }
    //apply accessor to row
    transformRow(row, type) {
        var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), rowComponent = row.getComponent();
        //clone data object with deep copy to isolate internal data from returned result
        var data = $c2a9788f40f9c90a$var$Helpers.deepClone(row.data || {});
        this.table.columnManager.traverse(function(column) {
            var value, accessor, params, colComponent;
            if (column.modules.accessor) {
                accessor = column.modules.accessor[key] || column.modules.accessor.accessor || false;
                if (accessor) {
                    value = column.getFieldValue(data);
                    if (value != "undefined") {
                        colComponent = column.getComponent();
                        params = typeof accessor.params === "function" ? accessor.params(value, data, type, colComponent, rowComponent) : accessor.params;
                        column.setFieldValue(data, accessor.accessor(value, data, type, params, colComponent, rowComponent));
                    }
                }
            }
        });
        return data;
    }
}
var $c2a9788f40f9c90a$var$defaultConfig = {
    method: "GET"
};
function $c2a9788f40f9c90a$var$generateParamsList$1(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
function $c2a9788f40f9c90a$var$serializeParams(params) {
    var output = $c2a9788f40f9c90a$var$generateParamsList$1(params), encoded = [];
    output.forEach(function(item) {
        encoded.push(encodeURIComponent(item.key) + "=" + encodeURIComponent(item.value));
    });
    return encoded.join("&");
}
function $c2a9788f40f9c90a$var$urlBuilder(url, config, params) {
    if (url) {
        if (params && Object.keys(params).length) {
            if (!config.method || config.method.toLowerCase() == "get") {
                config.method = "get";
                url += (url.includes("?") ? "&" : "?") + $c2a9788f40f9c90a$var$serializeParams(params);
            }
        }
    }
    return url;
}
function $c2a9788f40f9c90a$var$defaultLoaderPromise(url, config, params) {
    var contentType;
    return new Promise((resolve, reject)=>{
        //set url
        url = this.urlGenerator.call(this.table, url, config, params);
        //set body content if not GET request
        if (config.method.toUpperCase() != "GET") {
            contentType = typeof this.table.options.ajaxContentType === "object" ? this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType];
            if (contentType) {
                for(var key in contentType.headers){
                    if (!config.headers) config.headers = {};
                    if (typeof config.headers[key] === "undefined") config.headers[key] = contentType.headers[key];
                }
                config.body = contentType.body.call(this, url, config, params);
            } else console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
        }
        if (url) {
            //configure headers
            if (typeof config.headers === "undefined") config.headers = {};
            if (typeof config.headers.Accept === "undefined") config.headers.Accept = "application/json";
            if (typeof config.headers["X-Requested-With"] === "undefined") config.headers["X-Requested-With"] = "XMLHttpRequest";
            if (typeof config.mode === "undefined") config.mode = "cors";
            if (config.mode == "cors") {
                if (typeof config.headers["Origin"] === "undefined") config.headers["Origin"] = window.location.origin;
                if (typeof config.credentials === "undefined") config.credentials = "same-origin";
            } else if (typeof config.credentials === "undefined") config.credentials = "include";
            //send request
            fetch(url, config).then((response)=>{
                if (response.ok) response.json().then((data)=>{
                    resolve(data);
                }).catch((error)=>{
                    reject(error);
                    console.warn("Ajax Load Error - Invalid JSON returned", error);
                });
                else {
                    console.error("Ajax Load Error - Connection Error: " + response.status, response.statusText);
                    reject(response);
                }
            }).catch((error)=>{
                console.error("Ajax Load Error - Connection Error: ", error);
                reject(error);
            });
        } else {
            console.warn("Ajax Load Error - No URL Set");
            resolve([]);
        }
    });
}
function $c2a9788f40f9c90a$var$generateParamsList(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
var $c2a9788f40f9c90a$var$defaultContentTypeFormatters = {
    "json": {
        headers: {
            "Content-Type": "application/json"
        },
        body: function(url, config, params) {
            return JSON.stringify(params);
        }
    },
    "form": {
        headers: {},
        body: function(url, config, params) {
            var output = $c2a9788f40f9c90a$var$generateParamsList(params), form = new FormData();
            output.forEach(function(item) {
                form.append(item.key, item.value);
            });
            return form;
        }
    }
};
class $c2a9788f40f9c90a$export$b25c9f93be571d3a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "ajax";
    //load defaults
    static defaultConfig = $c2a9788f40f9c90a$var$defaultConfig;
    static defaultURLGenerator = $c2a9788f40f9c90a$var$urlBuilder;
    static defaultLoaderPromise = $c2a9788f40f9c90a$var$defaultLoaderPromise;
    static contentTypeFormatters = $c2a9788f40f9c90a$var$defaultContentTypeFormatters;
    constructor(table){
        super(table);
        this.config = {}; //hold config object for ajax request
        this.url = ""; //request URL
        this.urlGenerator = false;
        this.params = false; //request parameters
        this.loaderPromise = false;
        this.registerTableOption("ajaxURL", false); //url for ajax loading
        this.registerTableOption("ajaxURLGenerator", false);
        this.registerTableOption("ajaxParams", {}); //params for ajax loading
        this.registerTableOption("ajaxConfig", "get"); //ajax request type
        this.registerTableOption("ajaxContentType", "form"); //ajax request type
        this.registerTableOption("ajaxRequestFunc", false); //promise function
        this.registerTableOption("ajaxRequesting", function() {});
        this.registerTableOption("ajaxResponse", false);
        this.contentTypeFormatters = $c2a9788f40f9c90a$export$b25c9f93be571d3a.contentTypeFormatters;
    }
    //initialize setup options
    initialize() {
        this.loaderPromise = this.table.options.ajaxRequestFunc || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultLoaderPromise;
        this.urlGenerator = this.table.options.ajaxURLGenerator || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultURLGenerator;
        if (this.table.options.ajaxURL) this.setUrl(this.table.options.ajaxURL);
        this.setDefaultConfig(this.table.options.ajaxConfig);
        this.registerTableFunction("getAjaxUrl", this.getUrl.bind(this));
        this.subscribe("data-loading", this.requestDataCheck.bind(this));
        this.subscribe("data-params", this.requestParams.bind(this));
        this.subscribe("data-load", this.requestData.bind(this));
    }
    requestParams(data, config, silent, params) {
        var ajaxParams = this.table.options.ajaxParams;
        if (ajaxParams) {
            if (typeof ajaxParams === "function") ajaxParams = ajaxParams.call(this.table);
            params = Object.assign(Object.assign({}, ajaxParams), params);
        }
        return params;
    }
    requestDataCheck(data, params, config, silent) {
        return !!(!data && this.url || typeof data === "string");
    }
    requestData(url, params, config, silent, previousData) {
        var ajaxConfig;
        if (!previousData && this.requestDataCheck(url)) {
            if (url) this.setUrl(url);
            ajaxConfig = this.generateConfig(config);
            return this.sendRequest(this.url, params, ajaxConfig);
        } else return previousData;
    }
    setDefaultConfig(config = {}) {
        this.config = Object.assign({}, $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultConfig);
        if (typeof config == "string") this.config.method = config;
        else Object.assign(this.config, config);
    }
    //load config object
    generateConfig(config = {}) {
        var ajaxConfig = Object.assign({}, this.config);
        if (typeof config == "string") ajaxConfig.method = config;
        else Object.assign(ajaxConfig, config);
        return ajaxConfig;
    }
    //set request url
    setUrl(url) {
        this.url = url;
    }
    //get request url
    getUrl() {
        return this.url;
    }
    //send ajax request
    sendRequest(url, params, config) {
        if (this.table.options.ajaxRequesting.call(this.table, url, params) !== false) return this.loaderPromise(url, config, params).then((data)=>{
            if (this.table.options.ajaxResponse) data = this.table.options.ajaxResponse.call(this.table, url, params, data);
            return data;
        });
        else return Promise.reject();
    }
}
var $c2a9788f40f9c90a$var$defaultPasteActions = {
    replace: function(data) {
        return this.table.setData(data);
    },
    update: function(data) {
        return this.table.updateOrAddData(data);
    },
    insert: function(data) {
        return this.table.addData(data);
    }
};
var $c2a9788f40f9c90a$var$defaultPasteParsers = {
    table: function(clipboard) {
        var data = [], headerFindSuccess = true, columns = this.table.columnManager.columns, columnMap = [], rows = [];
        //get data from clipboard into array of columns and rows.
        clipboard = clipboard.split("\n");
        clipboard.forEach(function(row) {
            data.push(row.split("	"));
        });
        if (data.length && !(data.length === 1 && data[0].length < 2)) {
            //check if headers are present by title
            data[0].forEach(function(value) {
                var column = columns.find(function(column) {
                    return value && column.definition.title && value.trim() && column.definition.title.trim() === value.trim();
                });
                if (column) columnMap.push(column);
                else headerFindSuccess = false;
            });
            //check if column headers are present by field
            if (!headerFindSuccess) {
                headerFindSuccess = true;
                columnMap = [];
                data[0].forEach(function(value) {
                    var column = columns.find(function(column) {
                        return value && column.field && value.trim() && column.field.trim() === value.trim();
                    });
                    if (column) columnMap.push(column);
                    else headerFindSuccess = false;
                });
                if (!headerFindSuccess) columnMap = this.table.columnManager.columnsByIndex;
            }
            //remove header row if found
            if (headerFindSuccess) data.shift();
            data.forEach(function(item) {
                var row = {};
                item.forEach(function(value, i) {
                    if (columnMap[i]) row[columnMap[i].field] = value;
                });
                rows.push(row);
            });
            return rows;
        } else return false;
    }
};
var $c2a9788f40f9c90a$var$bindings$2 = {
    copyToClipboard: [
        "ctrl + 67",
        "meta + 67"
    ]
};
var $c2a9788f40f9c90a$var$actions$2 = {
    copyToClipboard: function(e) {
        if (!this.table.modules.edit.currentCell) {
            if (this.table.modExists("clipboard", true)) this.table.modules.clipboard.copy(false, true);
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$4 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$2,
        actions: $c2a9788f40f9c90a$var$actions$2
    }
};
class $c2a9788f40f9c90a$export$3a36bd45ca02edda extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "clipboard";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$4;
    //load defaults
    static pasteActions = $c2a9788f40f9c90a$var$defaultPasteActions;
    static pasteParsers = $c2a9788f40f9c90a$var$defaultPasteParsers;
    constructor(table){
        super(table);
        this.mode = true;
        this.pasteParser = function() {};
        this.pasteAction = function() {};
        this.customSelection = false;
        this.rowRange = false;
        this.blocked = true; //block copy actions not originating from this command
        this.registerTableOption("clipboard", false); //enable clipboard
        this.registerTableOption("clipboardCopyStyled", true); //formatted table data
        this.registerTableOption("clipboardCopyConfig", false); //clipboard config
        this.registerTableOption("clipboardCopyFormatter", false); //DEPRECATED - REMOVE in 5.0
        this.registerTableOption("clipboardCopyRowRange", "active"); //restrict clipboard to visible rows only
        this.registerTableOption("clipboardPasteParser", "table"); //convert pasted clipboard data to rows
        this.registerTableOption("clipboardPasteAction", "insert"); //how to insert pasted data into the table
        this.registerColumnOption("clipboard");
        this.registerColumnOption("titleClipboard");
    }
    initialize() {
        this.mode = this.table.options.clipboard;
        this.rowRange = this.table.options.clipboardCopyRowRange;
        if (this.mode === true || this.mode === "copy") this.table.element.addEventListener("copy", (e)=>{
            var plain, html, list;
            if (!this.blocked) {
                e.preventDefault();
                if (this.customSelection) {
                    plain = this.customSelection;
                    if (this.table.options.clipboardCopyFormatter) plain = this.table.options.clipboardCopyFormatter("plain", plain);
                } else {
                    list = this.table.modules.export.generateExportList(this.table.options.clipboardCopyConfig, this.table.options.clipboardCopyStyled, this.rowRange, "clipboard");
                    html = this.table.modules.export.generateHTMLTable(list);
                    plain = html ? this.generatePlainContent(list) : "";
                    if (this.table.options.clipboardCopyFormatter) {
                        plain = this.table.options.clipboardCopyFormatter("plain", plain);
                        html = this.table.options.clipboardCopyFormatter("html", html);
                    }
                }
                if (window.clipboardData && window.clipboardData.setData) window.clipboardData.setData("Text", plain);
                else if (e.clipboardData && e.clipboardData.setData) {
                    e.clipboardData.setData("text/plain", plain);
                    if (html) e.clipboardData.setData("text/html", html);
                } else if (e.originalEvent && e.originalEvent.clipboardData.setData) {
                    e.originalEvent.clipboardData.setData("text/plain", plain);
                    if (html) e.originalEvent.clipboardData.setData("text/html", html);
                }
                this.dispatchExternal("clipboardCopied", plain, html);
                this.reset();
            }
        });
        if (this.mode === true || this.mode === "paste") this.table.element.addEventListener("paste", (e)=>{
            this.paste(e);
        });
        this.setPasteParser(this.table.options.clipboardPasteParser);
        this.setPasteAction(this.table.options.clipboardPasteAction);
        this.registerTableFunction("copyToClipboard", this.copy.bind(this));
    }
    reset() {
        this.blocked = true;
        this.customSelection = false;
    }
    generatePlainContent(list) {
        var output = [];
        list.forEach((row)=>{
            var rowData = [];
            row.columns.forEach((col)=>{
                var value = "";
                if (col) {
                    if (row.type === "group") col.value = col.component.getKey();
                    if (col.value === null) value = "";
                    else switch(typeof col.value){
                        case "object":
                            value = JSON.stringify(col.value);
                            break;
                        case "undefined":
                            value = "";
                            break;
                        default:
                            value = col.value;
                    }
                }
                rowData.push(value);
            });
            output.push(rowData.join("	"));
        });
        return output.join("\n");
    }
    copy(range, internal) {
        var sel, textRange;
        this.blocked = false;
        this.customSelection = false;
        if (this.mode === true || this.mode === "copy") {
            this.rowRange = range || this.table.options.clipboardCopyRowRange;
            if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
                range = document.createRange();
                range.selectNodeContents(this.table.element);
                sel = window.getSelection();
                if (sel.toString() && internal) this.customSelection = sel.toString();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.selection != "undefined" && typeof document.body.createTextRange != "undefined") {
                textRange = document.body.createTextRange();
                textRange.moveToElementText(this.table.element);
                textRange.select();
            }
            document.execCommand("copy");
            if (sel) sel.removeAllRanges();
        }
    }
    //PASTE EVENT HANDLING
    setPasteAction(action) {
        switch(typeof action){
            case "string":
                this.pasteAction = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteActions[action];
                if (!this.pasteAction) console.warn("Clipboard Error - No such paste action found:", action);
                break;
            case "function":
                this.pasteAction = action;
                break;
        }
    }
    setPasteParser(parser) {
        switch(typeof parser){
            case "string":
                this.pasteParser = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteParsers[parser];
                if (!this.pasteParser) console.warn("Clipboard Error - No such paste parser found:", parser);
                break;
            case "function":
                this.pasteParser = parser;
                break;
        }
    }
    paste(e) {
        var data, rowData, rows;
        if (this.checkPasteOrigin(e)) {
            data = this.getPasteData(e);
            rowData = this.pasteParser.call(this, data);
            if (rowData) {
                e.preventDefault();
                if (this.table.modExists("mutator")) rowData = this.mutateData(rowData);
                rows = this.pasteAction.call(this, rowData);
                this.dispatchExternal("clipboardPasted", data, rowData, rows);
            } else this.dispatchExternal("clipboardPasteError", data);
        }
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "clipboard"));
        });
        else output = data;
        return output;
    }
    checkPasteOrigin(e) {
        var valid = true;
        var blocked = this.confirm("clipboard-paste", [
            e
        ]);
        if (blocked || ![
            "DIV",
            "SPAN"
        ].includes(e.target.tagName)) valid = false;
        return valid;
    }
    getPasteData(e) {
        var data;
        if (window.clipboardData && window.clipboardData.getData) data = window.clipboardData.getData("Text");
        else if (e.clipboardData && e.clipboardData.getData) data = e.clipboardData.getData("text/plain");
        else if (e.originalEvent && e.originalEvent.clipboardData.getData) data = e.originalEvent.clipboardData.getData("text/plain");
        return data;
    }
}
class $c2a9788f40f9c90a$export$3ef2519bf7055551 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getTable() {
        return this._row.table;
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    _getSelf() {
        return this._row;
    }
}
//public cell object
class $c2a9788f40f9c90a$export$1919f52c249c72c9 {
    constructor(cell){
        this._cell = cell;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._cell.table.componentFunctionBinder.handle("cell", target._cell, name);
            }
        });
    }
    getValue() {
        return this._cell.getValue();
    }
    getOldValue() {
        return this._cell.getOldValue();
    }
    getInitialValue() {
        return this._cell.initialValue;
    }
    getElement() {
        return this._cell.getElement();
    }
    getRow() {
        return this._cell.row.getComponent();
    }
    getData(transform) {
        return this._cell.row.getData(transform);
    }
    getType() {
        return "cell";
    }
    getField() {
        return this._cell.column.getField();
    }
    getColumn() {
        return this._cell.column.getComponent();
    }
    setValue(value, mutate) {
        if (typeof mutate == "undefined") mutate = true;
        this._cell.setValue(value, mutate);
    }
    restoreOldValue() {
        this._cell.setValueActual(this._cell.getOldValue());
    }
    restoreInitialValue() {
        this._cell.setValueActual(this._cell.initialValue);
    }
    checkHeight() {
        this._cell.checkHeight();
    }
    getTable() {
        return this._cell.table;
    }
    _getSelf() {
        return this._cell;
    }
}
class $c2a9788f40f9c90a$var$Cell extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(column, row){
        super(column.table);
        this.table = column.table;
        this.column = column;
        this.row = row;
        this.element = null;
        this.value = null;
        this.initialValue;
        this.oldValue = null;
        this.modules = {};
        this.height = null;
        this.width = null;
        this.minWidth = null;
        this.component = null;
        this.loaded = false; //track if the cell has been added to the DOM yet
        this.build();
    }
    //////////////// Setup Functions /////////////////
    //generate element
    build() {
        this.generateElement();
        this.setWidth();
        this._configureCell();
        this.setValueActual(this.column.getFieldValue(this.row.data));
        this.initialValue = this.value;
    }
    generateElement() {
        this.element = document.createElement("div");
        this.element.className = "tabulator-cell";
        this.element.setAttribute("role", "gridcell");
        if (this.column.isRowHeader) this.element.classList.add("tabulator-row-header");
    }
    _configureCell() {
        var element = this.element, field = this.column.getField(), vertAligns = {
            top: "flex-start",
            bottom: "flex-end",
            middle: "center"
        }, hozAligns = {
            left: "flex-start",
            right: "flex-end",
            center: "center"
        };
        //set text alignment
        element.style.textAlign = this.column.hozAlign;
        if (this.column.vertAlign) {
            element.style.display = "inline-flex";
            element.style.alignItems = vertAligns[this.column.vertAlign] || "";
            if (this.column.hozAlign) element.style.justifyContent = hozAligns[this.column.hozAlign] || "";
        }
        if (field) element.setAttribute("tabulator-field", field);
        //add class to cell if needed
        if (this.column.definition.cssClass) {
            var classNames = this.column.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                element.classList.add(className);
            });
        }
        this.dispatch("cell-init", this);
        //hide cell if not visible
        if (!this.column.visible) this.hide();
    }
    //generate cell contents
    _generateContents() {
        var val;
        val = this.chain("cell-format", this, null, ()=>{
            return this.element.innerHTML = this.value;
        });
        switch(typeof val){
            case "object":
                if (val instanceof Node) {
                    //clear previous cell contents
                    while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
                    this.element.appendChild(val);
                } else {
                    this.element.innerHTML = "";
                    if (val != null) console.warn("Format Error - Formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", val);
                }
                break;
            case "undefined":
                this.element.innerHTML = "";
                break;
            default:
                this.element.innerHTML = val;
        }
    }
    cellRendered() {
        this.dispatch("cell-rendered", this);
    }
    //////////////////// Getters ////////////////////
    getElement(containerOnly) {
        if (!this.loaded) {
            this.loaded = true;
            if (!containerOnly) this.layoutElement();
        }
        return this.element;
    }
    getValue() {
        return this.value;
    }
    getOldValue() {
        return this.oldValue;
    }
    //////////////////// Actions ////////////////////
    setValue(value, mutate, force) {
        var changed = this.setValueProcessData(value, mutate, force);
        if (changed) {
            this.dispatch("cell-value-updated", this);
            this.cellRendered();
            if (this.column.definition.cellEdited) this.column.definition.cellEdited.call(this.table, this.getComponent());
            this.dispatchExternal("cellEdited", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        }
    }
    setValueProcessData(value, mutate, force) {
        var changed = false;
        if (this.value !== value || force) {
            changed = true;
            if (mutate) value = this.chain("cell-value-changing", [
                this,
                value
            ], null, value);
        }
        this.setValueActual(value);
        if (changed) this.dispatch("cell-value-changed", this);
        return changed;
    }
    setValueActual(value) {
        this.oldValue = this.value;
        this.value = value;
        this.dispatch("cell-value-save-before", this);
        this.column.setFieldValue(this.row.data, value);
        this.dispatch("cell-value-save-after", this);
        if (this.loaded) this.layoutElement();
    }
    layoutElement() {
        this._generateContents();
        this.dispatch("cell-layout", this);
    }
    setWidth() {
        this.width = this.column.width;
        this.element.style.width = this.column.widthStyled;
    }
    clearWidth() {
        this.width = "";
        this.element.style.width = "";
    }
    getWidth() {
        return this.width || this.element.offsetWidth;
    }
    setMinWidth() {
        this.minWidth = this.column.minWidth;
        this.element.style.minWidth = this.column.minWidthStyled;
    }
    setMaxWidth() {
        this.maxWidth = this.column.maxWidth;
        this.element.style.maxWidth = this.column.maxWidthStyled;
    }
    checkHeight() {
        // var height = this.element.css("height");
        this.row.reinitializeHeight();
    }
    clearHeight() {
        this.element.style.height = "";
        this.height = null;
        this.dispatch("cell-height", this, "");
    }
    setHeight() {
        this.height = this.row.height;
        this.element.style.height = this.row.heightStyled;
        this.dispatch("cell-height", this, this.row.heightStyled);
    }
    getHeight() {
        return this.height || this.element.offsetHeight;
    }
    show() {
        this.element.style.display = this.column.vertAlign ? "inline-flex" : "";
    }
    hide() {
        this.element.style.display = "none";
    }
    delete() {
        this.dispatch("cell-delete", this);
        if (!this.table.rowManager.redrawBlock && this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.element = false;
        this.column.deleteCell(this);
        this.row.deleteCell(this);
        this.calcs = {};
    }
    getIndex() {
        return this.row.getCellIndex(this);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$1919f52c249c72c9(this);
        return this.component;
    }
}
//public column object
class $c2a9788f40f9c90a$export$11bb209ad3a8e411 {
    constructor(column){
        this._column = column;
        this.type = "ColumnComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._column.table.componentFunctionBinder.handle("column", target._column, name);
            }
        });
    }
    getElement() {
        return this._column.getElement();
    }
    getDefinition() {
        return this._column.getDefinition();
    }
    getField() {
        return this._column.getField();
    }
    getTitleDownload() {
        return this._column.getTitleDownload();
    }
    getCells() {
        var cells = [];
        this._column.cells.forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    isVisible() {
        return this._column.visible;
    }
    show() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.show();
        });
        else this._column.show();
    }
    hide() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.hide();
        });
        else this._column.hide();
    }
    toggle() {
        if (this._column.visible) this.hide();
        else this.show();
    }
    delete() {
        return this._column.delete();
    }
    getSubColumns() {
        var output = [];
        if (this._column.columns.length) this._column.columns.forEach(function(column) {
            output.push(column.getComponent());
        });
        return output;
    }
    getParentColumn() {
        return this._column.getParentComponent();
    }
    _getSelf() {
        return this._column;
    }
    scrollTo(position, ifVisible) {
        return this._column.table.columnManager.scrollToColumn(this._column, position, ifVisible);
    }
    getTable() {
        return this._column.table;
    }
    move(to, after) {
        var toColumn = this._column.table.columnManager.findColumn(to);
        if (toColumn) this._column.table.columnManager.moveColumn(this._column, toColumn, after);
        else console.warn("Move Error - No matching column found:", toColumn);
    }
    getNextColumn() {
        var nextCol = this._column.nextColumn();
        return nextCol ? nextCol.getComponent() : false;
    }
    getPrevColumn() {
        var prevCol = this._column.prevColumn();
        return prevCol ? prevCol.getComponent() : false;
    }
    updateDefinition(updates) {
        return this._column.updateDefinition(updates);
    }
    getWidth() {
        return this._column.getWidth();
    }
    setWidth(width) {
        var result;
        if (width === true) result = this._column.reinitializeWidth(true);
        else result = this._column.setWidth(width);
        this._column.table.columnManager.rerenderColumns(true);
        return result;
    }
}
var $c2a9788f40f9c90a$var$defaultColumnOptions = {
    "title": undefined,
    "field": undefined,
    "columns": undefined,
    "visible": undefined,
    "hozAlign": undefined,
    "vertAlign": undefined,
    "width": undefined,
    "minWidth": 40,
    "maxWidth": undefined,
    "maxInitialWidth": undefined,
    "cssClass": undefined,
    "variableHeight": undefined,
    "headerVertical": undefined,
    "headerHozAlign": undefined,
    "headerWordWrap": false,
    "editableTitle": undefined
};
class $c2a9788f40f9c90a$var$Column extends $c2a9788f40f9c90a$var$CoreFeature {
    static defaultOptionList = $c2a9788f40f9c90a$var$defaultColumnOptions;
    constructor(def, parent, rowHeader){
        super(parent.table);
        this.definition = def; //column definition
        this.parent = parent; //hold parent object
        this.type = "column"; //type of element
        this.columns = []; //child columns
        this.cells = []; //cells bound to this column
        this.isGroup = false;
        this.isRowHeader = rowHeader;
        this.element = this.createElement(); //column header element
        this.contentElement = false;
        this.titleHolderElement = false;
        this.titleElement = false;
        this.groupElement = this.createGroupElement(); //column group holder element
        this.hozAlign = ""; //horizontal text alignment
        this.vertAlign = ""; //vert text alignment
        //multi dimensional filed handling
        this.field = "";
        this.fieldStructure = "";
        this.getFieldValue = "";
        this.setFieldValue = "";
        this.titleDownload = null;
        this.titleFormatterRendered = false;
        this.mapDefinitions();
        this.setField(this.definition.field);
        this.modules = {}; //hold module variables;
        this.width = null; //column width
        this.widthStyled = ""; //column width pre-styled to improve render efficiency
        this.maxWidth = null; //column maximum width
        this.maxWidthStyled = ""; //column maximum pre-styled to improve render efficiency
        this.maxInitialWidth = null;
        this.minWidth = null; //column minimum width
        this.minWidthStyled = ""; //column minimum pre-styled to improve render efficiency
        this.widthFixed = false; //user has specified a width for this column
        this.visible = true; //default visible state
        this.component = null;
        //initialize column
        if (this.definition.columns) {
            this.isGroup = true;
            this.definition.columns.forEach((def, i)=>{
                var newCol = new $c2a9788f40f9c90a$var$Column(def, this);
                this.attachColumn(newCol);
            });
            this.checkColumnVisibility();
        } else parent.registerColumnField(this);
        this._initialize();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.setAttribute("role", "columnheader");
        el.setAttribute("aria-sort", "none");
        if (this.isRowHeader) el.classList.add("tabulator-row-header");
        switch(this.table.options.columnHeaderVertAlign){
            case "middle":
                el.style.justifyContent = "center";
                break;
            case "bottom":
                el.style.justifyContent = "flex-end";
                break;
        }
        return el;
    }
    createGroupElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col-group-cols");
        return el;
    }
    mapDefinitions() {
        var defaults = this.table.options.columnDefaults;
        //map columnDefaults onto column definitions
        if (defaults) {
            for(let key in defaults)if (typeof this.definition[key] === "undefined") this.definition[key] = defaults[key];
        }
        this.definition = this.table.columnManager.optionsList.generate($c2a9788f40f9c90a$var$Column.defaultOptionList, this.definition);
    }
    checkDefinition() {
        Object.keys(this.definition).forEach((key)=>{
            if ($c2a9788f40f9c90a$var$Column.defaultOptionList.indexOf(key) === -1) console.warn("Invalid column definition option in '" + (this.field || this.definition.title) + "' column:", key);
        });
    }
    setField(field) {
        this.field = field;
        this.fieldStructure = field ? this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator) : [
            field
        ] : [];
        this.getFieldValue = this.fieldStructure.length > 1 ? this._getNestedData : this._getFlatData;
        this.setFieldValue = this.fieldStructure.length > 1 ? this._setNestedData : this._setFlatData;
    }
    //register column position with column manager
    registerColumnPosition(column) {
        this.parent.registerColumnPosition(column);
    }
    //register column position with column manager
    registerColumnField(column) {
        this.parent.registerColumnField(column);
    }
    //trigger position registration
    reRegisterPosition() {
        if (this.isGroup) this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
        else this.registerColumnPosition(this);
    }
    //build header element
    _initialize() {
        var def = this.definition;
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (def.headerVertical) {
            this.element.classList.add("tabulator-col-vertical");
            if (def.headerVertical === "flip") this.element.classList.add("tabulator-col-vertical-flip");
        }
        this.contentElement = this._buildColumnHeaderContent();
        this.element.appendChild(this.contentElement);
        if (this.isGroup) this._buildGroupHeader();
        else this._buildColumnHeader();
        this.dispatch("column-init", this);
    }
    //build header element for header
    _buildColumnHeader() {
        var def = this.definition;
        this.dispatch("column-layout", this);
        //set column visibility
        if (typeof def.visible != "undefined") {
            if (def.visible) this.show(true);
            else this.hide(true);
        }
        //assign additional css classes to column header
        if (def.cssClass) {
            var classNames = def.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        if (def.field) this.element.setAttribute("tabulator-field", def.field);
        //set min width if present
        this.setMinWidth(parseInt(def.minWidth));
        if (def.maxInitialWidth) this.maxInitialWidth = parseInt(def.maxInitialWidth);
        if (def.maxWidth) this.setMaxWidth(parseInt(def.maxWidth));
        this.reinitializeWidth();
        //set horizontal text alignment
        this.hozAlign = this.definition.hozAlign;
        this.vertAlign = this.definition.vertAlign;
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
    }
    _buildColumnHeaderContent() {
        var contentElement = document.createElement("div");
        contentElement.classList.add("tabulator-col-content");
        this.titleHolderElement = document.createElement("div");
        this.titleHolderElement.classList.add("tabulator-col-title-holder");
        contentElement.appendChild(this.titleHolderElement);
        this.titleElement = this._buildColumnHeaderTitle();
        this.titleHolderElement.appendChild(this.titleElement);
        return contentElement;
    }
    //build title element of column
    _buildColumnHeaderTitle() {
        var def = this.definition;
        var titleHolderElement = document.createElement("div");
        titleHolderElement.classList.add("tabulator-col-title");
        if (def.headerWordWrap) titleHolderElement.classList.add("tabulator-col-title-wrap");
        if (def.editableTitle) {
            var titleElement = document.createElement("input");
            titleElement.classList.add("tabulator-title-editor");
            titleElement.addEventListener("click", (e)=>{
                e.stopPropagation();
                titleElement.focus();
            });
            titleElement.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            titleElement.addEventListener("change", ()=>{
                def.title = titleElement.value;
                this.dispatchExternal("columnTitleChanged", this.getComponent());
            });
            titleHolderElement.appendChild(titleElement);
            if (def.field) this.langBind("columns|" + def.field, (text)=>{
                titleElement.value = text || def.title || "&nbsp;";
            });
            else titleElement.value = def.title || "&nbsp;";
        } else if (def.field) this.langBind("columns|" + def.field, (text)=>{
            this._formatColumnHeaderTitle(titleHolderElement, text || def.title || "&nbsp;");
        });
        else this._formatColumnHeaderTitle(titleHolderElement, def.title || "&nbsp;");
        return titleHolderElement;
    }
    _formatColumnHeaderTitle(el, title) {
        var contents = this.chain("column-format", [
            this,
            title,
            el
        ], null, ()=>{
            return title;
        });
        switch(typeof contents){
            case "object":
                if (contents instanceof Node) el.appendChild(contents);
                else {
                    el.innerHTML = "";
                    console.warn("Format Error - Title formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", contents);
                }
                break;
            case "undefined":
                el.innerHTML = "";
                break;
            default:
                el.innerHTML = contents;
        }
    }
    //build header element for column group
    _buildGroupHeader() {
        this.element.classList.add("tabulator-col-group");
        this.element.setAttribute("role", "columngroup");
        this.element.setAttribute("aria-title", this.definition.title);
        //asign additional css classes to column header
        if (this.definition.cssClass) {
            var classNames = this.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
        this.element.appendChild(this.groupElement);
    }
    //flat field lookup
    _getFlatData(data) {
        return data[this.field];
    }
    //nested field lookup
    _getNestedData(data) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length, output;
        for(let i = 0; i < length; i++){
            dataObj = dataObj[structure[i]];
            output = dataObj;
            if (!dataObj) break;
        }
        return output;
    }
    //flat field set
    _setFlatData(data, value) {
        if (this.field) data[this.field] = value;
    }
    //nested field set
    _setNestedData(data, value) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length;
        for(let i = 0; i < length; i++)if (i == length - 1) dataObj[structure[i]] = value;
        else {
            if (!dataObj[structure[i]]) {
                if (typeof value !== "undefined") dataObj[structure[i]] = {};
                else break;
            }
            dataObj = dataObj[structure[i]];
        }
    }
    //attach column to this group
    attachColumn(column) {
        if (this.groupElement) {
            this.columns.push(column);
            this.groupElement.appendChild(column.getElement());
            column.columnRendered();
        } else console.warn("Column Warning - Column being attached to another column instead of column group");
    }
    //vertically align header in column
    verticalAlign(alignment, height) {
        //calculate height of column header and group holder element
        var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : height || this.parent.getHeadersElement().clientHeight;
        // var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : this.parent.getHeadersElement().clientHeight;
        this.element.style.height = parentHeight + "px";
        this.dispatch("column-height", this, this.element.style.height);
        if (this.isGroup) this.groupElement.style.minHeight = parentHeight - this.contentElement.offsetHeight + "px";
        //vertically align cell contents
        // if(!this.isGroup && alignment !== "top"){
        // 	if(alignment === "bottom"){
        // 		this.element.style.paddingTop = (this.element.clientHeight - this.contentElement.offsetHeight) + "px";
        // 	}else{
        // 		this.element.style.paddingTop = ((this.element.clientHeight - this.contentElement.offsetHeight) / 2) + "px";
        // 	}
        // }
        this.columns.forEach(function(column) {
            column.verticalAlign(alignment);
        });
    }
    //clear vertical alignment
    clearVerticalAlign() {
        this.element.style.paddingTop = "";
        this.element.style.height = "";
        this.element.style.minHeight = "";
        this.groupElement.style.minHeight = "";
        this.columns.forEach(function(column) {
            column.clearVerticalAlign();
        });
        this.dispatch("column-height", this, "");
    }
    //// Retrieve Column Information ////
    //return column header element
    getElement() {
        return this.element;
    }
    //return column group element
    getGroupElement() {
        return this.groupElement;
    }
    //return field name
    getField() {
        return this.field;
    }
    getTitleDownload() {
        return this.titleDownload;
    }
    //return the first column in a group
    getFirstColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[0].getFirstColumn();
            else return false;
        }
    }
    //return the last column in a group
    getLastColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[this.columns.length - 1].getLastColumn();
            else return false;
        }
    }
    //return all columns in a group
    getColumns(traverse) {
        var columns = [];
        if (traverse) this.columns.forEach((column)=>{
            columns.push(column);
            columns = columns.concat(column.getColumns(true));
        });
        else columns = this.columns;
        return columns;
    }
    //return all columns in a group
    getCells() {
        return this.cells;
    }
    //retrieve the top column in a group of columns
    getTopColumn() {
        if (this.parent.isGroup) return this.parent.getTopColumn();
        else return this;
    }
    //return column definition object
    getDefinition(updateBranches) {
        var colDefs = [];
        if (this.isGroup && updateBranches) {
            this.columns.forEach(function(column) {
                colDefs.push(column.getDefinition(true));
            });
            this.definition.columns = colDefs;
        }
        return this.definition;
    }
    //////////////////// Actions ////////////////////
    checkColumnVisibility() {
        var visible = false;
        this.columns.forEach(function(column) {
            if (column.visible) visible = true;
        });
        if (visible) {
            this.show();
            this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
        } else this.hide();
    }
    //show column
    show(silent, responsiveToggle) {
        if (!this.visible) {
            this.visible = true;
            this.element.style.display = "";
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.show();
            });
            if (!this.isGroup && this.width === null) this.reinitializeWidth();
            this.table.columnManager.verticalAlignHeaders();
            this.dispatch("column-show", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), true);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    //hide column
    hide(silent, responsiveToggle) {
        if (this.visible) {
            this.visible = false;
            this.element.style.display = "none";
            this.table.columnManager.verticalAlignHeaders();
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.hide();
            });
            this.dispatch("column-hide", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    matchChildWidths() {
        var childWidth = 0;
        if (this.contentElement && this.columns.length) {
            this.columns.forEach(function(column) {
                if (column.visible) childWidth += column.getWidth();
            });
            this.contentElement.style.maxWidth = childWidth - 1 + "px";
            if (this.table.initialized) this.element.style.width = childWidth + "px";
            if (this.parent.isGroup) this.parent.matchChildWidths();
        }
    }
    removeChild(child) {
        var index = this.columns.indexOf(child);
        if (index > -1) this.columns.splice(index, 1);
        if (!this.columns.length) this.delete();
    }
    setWidth(width) {
        this.widthFixed = true;
        this.setWidthActual(width);
    }
    setWidthActual(width) {
        if (isNaN(width)) width = Math.floor(this.table.element.clientWidth / 100 * parseInt(width));
        width = Math.max(this.minWidth, width);
        if (this.maxWidth) width = Math.min(this.maxWidth, width);
        this.width = width;
        this.widthStyled = width ? width + "px" : "";
        this.element.style.width = this.widthStyled;
        if (!this.isGroup) this.cells.forEach(function(cell) {
            cell.setWidth();
        });
        if (this.parent.isGroup) this.parent.matchChildWidths();
        this.dispatch("column-width", this);
        if (this.subscribedExternal("columnWidth")) this.dispatchExternal("columnWidth", this.getComponent());
    }
    checkCellHeights() {
        var rows = [];
        this.cells.forEach(function(cell) {
            if (cell.row.heightInitialized) {
                if (cell.row.getElement().offsetParent !== null) {
                    rows.push(cell.row);
                    cell.row.clearCellHeight();
                } else cell.row.heightInitialized = false;
            }
        });
        rows.forEach(function(row) {
            row.calcHeight();
        });
        rows.forEach(function(row) {
            row.setCellHeight();
        });
    }
    getWidth() {
        var width = 0;
        if (this.isGroup) this.columns.forEach(function(column) {
            if (column.visible) width += column.getWidth();
        });
        else width = this.width;
        return width;
    }
    getLeftOffset() {
        var offset = this.element.offsetLeft;
        if (this.parent.isGroup) offset += this.parent.getLeftOffset();
        return offset;
    }
    getHeight() {
        return Math.ceil(this.element.getBoundingClientRect().height);
    }
    setMinWidth(minWidth) {
        if (this.maxWidth && minWidth > this.maxWidth) {
            minWidth = this.maxWidth;
            console.warn("the minWidth (" + minWidth + "px) for column '" + this.field + "' cannot be bigger that its maxWidth (" + this.maxWidthStyled + ")");
        }
        this.minWidth = minWidth;
        this.minWidthStyled = minWidth ? minWidth + "px" : "";
        this.element.style.minWidth = this.minWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMinWidth();
        });
    }
    setMaxWidth(maxWidth) {
        if (this.minWidth && maxWidth < this.minWidth) {
            maxWidth = this.minWidth;
            console.warn("the maxWidth (" + maxWidth + "px) for column '" + this.field + "' cannot be smaller that its minWidth (" + this.minWidthStyled + ")");
        }
        this.maxWidth = maxWidth;
        this.maxWidthStyled = maxWidth ? maxWidth + "px" : "";
        this.element.style.maxWidth = this.maxWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMaxWidth();
        });
    }
    delete() {
        return new Promise((resolve, reject)=>{
            if (this.isGroup) this.columns.forEach(function(column) {
                column.delete();
            });
            this.dispatch("column-delete", this);
            var cellCount = this.cells.length;
            for(let i = 0; i < cellCount; i++)this.cells[0].delete();
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.element = false;
            this.contentElement = false;
            this.titleElement = false;
            this.groupElement = false;
            if (this.parent.isGroup) this.parent.removeChild(this);
            this.table.columnManager.deregisterColumn(this);
            this.table.columnManager.rerenderColumns(true);
            this.dispatch("column-deleted", this);
            resolve();
        });
    }
    columnRendered() {
        if (this.titleFormatterRendered) this.titleFormatterRendered();
        this.dispatch("column-rendered", this);
    }
    //////////////// Cell Management /////////////////
    //generate cell for this column
    generateCell(row) {
        var cell = new $c2a9788f40f9c90a$var$Cell(this, row);
        this.cells.push(cell);
        return cell;
    }
    nextColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._nextVisibleColumn(index + 1) : false;
    }
    _nextVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._nextVisibleColumn(index + 1);
    }
    prevColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._prevVisibleColumn(index - 1) : false;
    }
    _prevVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._prevVisibleColumn(index - 1);
    }
    reinitializeWidth(force) {
        this.widthFixed = false;
        //set width if present
        if (typeof this.definition.width !== "undefined" && !force) // maxInitialWidth ignored here as width specified
        this.setWidth(this.definition.width);
        this.dispatch("column-width-fit-before", this);
        this.fitToData(force);
        this.dispatch("column-width-fit-after", this);
    }
    //set column width to maximum cell width for non group columns
    fitToData(force) {
        if (this.isGroup) return;
        if (!this.widthFixed) {
            this.element.style.width = "";
            this.cells.forEach((cell)=>{
                cell.clearWidth();
            });
        }
        var maxWidth = this.element.offsetWidth;
        if (!this.width || !this.widthFixed) {
            this.cells.forEach((cell)=>{
                var width = cell.getWidth();
                if (width > maxWidth) maxWidth = width;
            });
            if (maxWidth) {
                var setTo = maxWidth + 1;
                if (this.maxInitialWidth && !force) setTo = Math.min(setTo, this.maxInitialWidth);
                this.setWidthActual(setTo);
            }
        }
    }
    updateDefinition(updates) {
        var definition;
        if (!this.isGroup) {
            if (!this.parent.isGroup) {
                definition = Object.assign({}, this.getDefinition());
                definition = Object.assign(definition, updates);
                return this.table.columnManager.addColumn(definition, false, this).then((column)=>{
                    if (definition.field == this.field) this.field = false; //clear field name to prevent deletion of duplicate column from arrays
                    return this.delete().then(()=>{
                        return column.getComponent();
                    });
                });
            } else {
                console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
                return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
            }
        } else {
            console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
            return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
        }
    }
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$11bb209ad3a8e411(this);
        return this.component;
    }
    getPosition() {
        return this.table.columnManager.getVisibleColumnsByIndex().indexOf(this) + 1;
    }
    getParentComponent() {
        return this.parent instanceof $c2a9788f40f9c90a$var$Column ? this.parent.getComponent() : false;
    }
}
//public row object
class $c2a9788f40f9c90a$export$5df91075f5ba4651 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    getIndex() {
        return this._row.getData("data")[this._row.table.options.index];
    }
    getPosition() {
        return this._row.getPosition();
    }
    watchPosition(callback) {
        return this._row.watchPosition(callback);
    }
    delete() {
        return this._row.delete();
    }
    scrollTo(position, ifVisible) {
        return this._row.table.rowManager.scrollToRow(this._row, position, ifVisible);
    }
    move(to, after) {
        this._row.moveToRow(to, after);
    }
    update(data) {
        return this._row.updateData(data);
    }
    normalizeHeight() {
        this._row.normalizeHeight(true);
    }
    _getSelf() {
        return this._row;
    }
    reformat() {
        return this._row.reinitialize();
    }
    getTable() {
        return this._row.table;
    }
    getNextRow() {
        var row = this._row.nextRow();
        return row ? row.getComponent() : row;
    }
    getPrevRow() {
        var row = this._row.prevRow();
        return row ? row.getComponent() : row;
    }
}
class $c2a9788f40f9c90a$var$Row extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(data, parent, type = "row"){
        super(parent.table);
        this.parent = parent;
        this.data = {};
        this.type = type; //type of element
        this.element = false;
        this.modules = {}; //hold module variables;
        this.cells = [];
        this.height = 0; //hold element height
        this.heightStyled = ""; //hold element height pre-styled to improve render efficiency
        this.manualHeight = false; //user has manually set row height
        this.outerHeight = 0; //hold elements outer height
        this.initialized = false; //element has been rendered
        this.heightInitialized = false; //element has resized cells to fit
        this.position = 0; //store position of element in row list
        this.positionWatchers = [];
        this.component = null;
        this.created = false;
        this.setData(data);
    }
    create() {
        if (!this.created) {
            this.created = true;
            this.generateElement();
        }
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.setAttribute("role", "row");
        this.element = el;
    }
    getElement() {
        this.create();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    generateElement() {
        this.createElement();
        this.dispatch("row-init", this);
    }
    generateCells() {
        this.cells = this.table.columnManager.generateCells(this);
    }
    //functions to setup on first render
    initialize(force, inFragment) {
        this.create();
        if (!this.initialized || force) {
            this.deleteCells();
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            this.dispatch("row-layout-before", this);
            this.generateCells();
            this.initialized = true;
            this.table.columnManager.renderer.renderRowCells(this, inFragment);
            if (force) this.normalizeHeight();
            this.dispatch("row-layout", this);
            if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            this.dispatch("row-layout-after", this);
        } else this.table.columnManager.renderer.rerenderRowCells(this, inFragment);
    }
    rendered() {
        this.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeHeight() {
        this.heightInitialized = false;
        if (this.element && this.element.offsetParent !== null) this.normalizeHeight(true);
    }
    deinitialize() {
        this.initialized = false;
    }
    deinitializeHeight() {
        this.heightInitialized = false;
    }
    reinitialize(children) {
        this.initialized = false;
        this.heightInitialized = false;
        if (!this.manualHeight) {
            this.height = 0;
            this.heightStyled = "";
        }
        if (this.element && this.element.offsetParent !== null) this.initialize(true);
        this.dispatch("row-relayout", this);
    }
    //get heights when doing bulk row style calcs in virtual DOM
    calcHeight(force) {
        var maxHeight = 0, minHeight = 0;
        if (this.table.options.rowHeight) this.height = this.table.options.rowHeight;
        else {
            minHeight = this.calcMinHeight();
            maxHeight = this.calcMaxHeight();
            if (force) this.height = Math.max(maxHeight, minHeight);
            else this.height = this.manualHeight ? this.height : Math.max(maxHeight, minHeight);
        }
        this.heightStyled = this.height ? this.height + "px" : "";
        this.outerHeight = this.element.offsetHeight;
    }
    calcMinHeight() {
        return this.table.options.resizableRows ? this.element.clientHeight : 0;
    }
    calcMaxHeight() {
        var maxHeight = 0;
        this.cells.forEach(function(cell) {
            var height = cell.getHeight();
            if (height > maxHeight) maxHeight = height;
        });
        return maxHeight;
    }
    //set of cells
    setCellHeight() {
        this.cells.forEach(function(cell) {
            cell.setHeight();
        });
        this.heightInitialized = true;
    }
    clearCellHeight() {
        this.cells.forEach(function(cell) {
            cell.clearHeight();
        });
    }
    //normalize the height of elements in the row
    normalizeHeight(force) {
        if (force && !this.table.options.rowHeight) this.clearCellHeight();
        this.calcHeight(force);
        this.setCellHeight();
    }
    //set height of rows
    setHeight(height, force) {
        if (this.height != height || force) {
            this.manualHeight = true;
            this.height = height;
            this.heightStyled = height ? height + "px" : "";
            this.setCellHeight();
            // this.outerHeight = this.element.outerHeight();
            this.outerHeight = this.element.offsetHeight;
            if (this.subscribedExternal("rowHeight")) this.dispatchExternal("rowHeight", this.getComponent());
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    //return rows outer Width
    getWidth() {
        return this.element.offsetWidth;
    }
    //////////////// Cell Management /////////////////
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Data Management /////////////////
    setData(data) {
        this.data = this.chain("row-data-init-before", [
            this,
            data
        ], undefined, data);
        this.dispatch("row-data-init-after", this);
    }
    //update the rows data
    updateData(updatedData) {
        var visible = this.element && $c2a9788f40f9c90a$var$Helpers.elVisible(this.element), tempData = {}, newRowData;
        return new Promise((resolve, reject)=>{
            if (typeof updatedData === "string") updatedData = JSON.parse(updatedData);
            this.dispatch("row-data-save-before", this);
            if (this.subscribed("row-data-changing")) {
                tempData = Object.assign(tempData, this.data);
                tempData = Object.assign(tempData, updatedData);
            }
            newRowData = this.chain("row-data-changing", [
                this,
                tempData,
                updatedData
            ], null, updatedData);
            //set data
            for(let attrname in newRowData)this.data[attrname] = newRowData[attrname];
            this.dispatch("row-data-save-after", this);
            //update affected cells only
            for(let attrname in updatedData){
                let columns = this.table.columnManager.getColumnsByFieldRoot(attrname);
                columns.forEach((column)=>{
                    let cell = this.getCell(column.getField());
                    if (cell) {
                        let value = column.getFieldValue(newRowData);
                        if (cell.getValue() !== value) {
                            cell.setValueProcessData(value);
                            if (visible) cell.cellRendered();
                        }
                    }
                });
            }
            //Partial reinitialization if visible
            if (visible) {
                this.normalizeHeight(true);
                if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            } else {
                this.initialized = false;
                this.height = 0;
                this.heightStyled = "";
            }
            this.dispatch("row-data-changed", this, visible, updatedData);
            //this.reinitialize();
            this.dispatchExternal("rowUpdated", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
            resolve();
        });
    }
    getData(transform) {
        if (transform) return this.chain("row-data-retrieve", [
            this,
            transform
        ], null, this.data);
        return this.data;
    }
    getCell(column) {
        var match = false;
        column = this.table.columnManager.findColumn(column);
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        match = this.cells.find(function(cell) {
            return cell.column === column;
        });
        return match;
    }
    getCellIndex(findCell) {
        return this.cells.findIndex(function(cell) {
            return cell === findCell;
        });
    }
    findCell(subject) {
        return this.cells.find((cell)=>{
            return cell.element === subject;
        });
    }
    getCells() {
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        return this.cells;
    }
    nextRow() {
        var row = this.table.rowManager.nextDisplayRow(this, true);
        return row || false;
    }
    prevRow() {
        var row = this.table.rowManager.prevDisplayRow(this, true);
        return row || false;
    }
    moveToRow(to, before) {
        var toRow = this.table.rowManager.findRow(to);
        if (toRow) {
            this.table.rowManager.moveRowActual(this, toRow, !before);
            this.table.rowManager.refreshActiveData("display", false, true);
        } else console.warn("Move Error - No matching row found:", to);
    }
    ///////////////////// Actions  /////////////////////
    delete() {
        this.dispatch("row-delete", this);
        this.deleteActual();
        return Promise.resolve();
    }
    deleteActual(blockRedraw) {
        this.detachModules();
        this.table.rowManager.deleteRow(this, blockRedraw);
        this.deleteCells();
        this.initialized = false;
        this.heightInitialized = false;
        this.element = false;
        this.dispatch("row-deleted", this);
    }
    detachModules() {
        this.dispatch("row-deleting", this);
    }
    deleteCells() {
        var cellCount = this.cells.length;
        for(let i = 0; i < cellCount; i++)this.cells[0].delete();
    }
    wipe() {
        this.detachModules();
        this.deleteCells();
        if (this.element) {
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.element = false;
        this.modules = {};
    }
    isDisplayed() {
        return this.table.rowManager.getDisplayRows().includes(this);
    }
    getPosition() {
        return this.isDisplayed() ? this.position : false;
    }
    setPosition(position) {
        if (position != this.position) {
            this.position = position;
            this.positionWatchers.forEach((callback)=>{
                callback(this.position);
            });
        }
    }
    watchPosition(callback) {
        this.positionWatchers.push(callback);
        callback(this.position);
    }
    getGroup() {
        return this.modules.group || false;
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$5df91075f5ba4651(this);
        return this.component;
    }
}
var $c2a9788f40f9c90a$var$defaultCalculations = {
    "avg": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : 2;
        if (values.length) {
            output = values.reduce(function(sum, value) {
                return Number(sum) + Number(value);
            });
            output = output / values.length;
            output = precision !== false ? output.toFixed(precision) : output;
        }
        return parseFloat(output).toString();
    },
    "max": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value > output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "min": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value < output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "sum": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        if (values.length) values.forEach(function(value) {
            value = Number(value);
            output += !isNaN(value) ? Number(value) : 0;
        });
        return precision !== false ? output.toFixed(precision) : output;
    },
    "concat": function(values, data, calcParams) {
        var output = 0;
        if (values.length) output = values.reduce(function(sum, value) {
            return String(sum) + String(value);
        });
        return output;
    },
    "count": function(values, data, calcParams) {
        var output = 0;
        if (values.length) values.forEach(function(value) {
            if (value) output++;
        });
        return output;
    },
    "unique": function(values, data, calcParams) {
        var unique = values.filter((value, index)=>{
            return (values || value === 0) && values.indexOf(value) === index;
        });
        return unique.length;
    }
};
class $c2a9788f40f9c90a$export$840b3bc55b30dec6 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "columnCalcs";
    //load defaults
    static calculations = $c2a9788f40f9c90a$var$defaultCalculations;
    constructor(table){
        super(table);
        this.topCalcs = [];
        this.botCalcs = [];
        this.genColumn = false;
        this.topElement = this.createElement();
        this.botElement = this.createElement();
        this.topRow = false;
        this.botRow = false;
        this.topInitialized = false;
        this.botInitialized = false;
        this.blocked = false;
        this.recalcAfterBlock = false;
        this.registerTableOption("columnCalcs", true);
        this.registerColumnOption("topCalc");
        this.registerColumnOption("topCalcParams");
        this.registerColumnOption("topCalcFormatter");
        this.registerColumnOption("topCalcFormatterParams");
        this.registerColumnOption("bottomCalc");
        this.registerColumnOption("bottomCalcParams");
        this.registerColumnOption("bottomCalcFormatter");
        this.registerColumnOption("bottomCalcFormatterParams");
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-calcs-holder");
        return el;
    }
    initialize() {
        this.genColumn = new $c2a9788f40f9c90a$var$Column({
            field: "value"
        }, this);
        this.subscribe("cell-value-changed", this.cellValueChanged.bind(this));
        this.subscribe("column-init", this.initializeColumnCheck.bind(this));
        this.subscribe("row-deleted", this.rowsUpdated.bind(this));
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("row-added", this.rowsUpdated.bind(this));
        this.subscribe("column-moved", this.recalcActiveRows.bind(this));
        this.subscribe("column-add", this.recalcActiveRows.bind(this));
        this.subscribe("data-refreshed", this.recalcActiveRowsRefresh.bind(this));
        this.subscribe("table-redraw", this.tableRedraw.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
        this.subscribe("redraw-blocked", this.blockRedraw.bind(this));
        this.subscribe("redraw-restored", this.restoreRedraw.bind(this));
        this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
        this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
        this.subscribe("column-show", this.resizeHolderWidth.bind(this));
        this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        this.registerTableFunction("getCalcResults", this.getResults.bind(this));
        this.registerTableFunction("recalc", this.userRecalc.bind(this));
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    tableRedraw(force) {
        this.recalc(this.table.rowManager.activeRows);
        if (force) this.redraw();
    }
    blockRedraw() {
        this.blocked = true;
        this.recalcAfterBlock = false;
    }
    restoreRedraw() {
        this.blocked = false;
        if (this.recalcAfterBlock) {
            this.recalcAfterBlock = false;
            this.recalcActiveRowsRefresh();
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userRecalc() {
        this.recalc(this.table.rowManager.activeRows);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    blockCheck() {
        if (this.blocked) this.recalcAfterBlock = true;
        return this.blocked;
    }
    visibleRows(viewable, rows) {
        if (this.topRow) rows.unshift(this.topRow);
        if (this.botRow) rows.push(this.botRow);
        return rows;
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.recalcRowGroup(row);
        else this.recalcActiveRows();
    }
    recalcActiveRowsRefresh() {
        if (this.table.options.groupBy && this.table.options.dataTreeStartExpanded && this.table.options.dataTree) this.recalcAll();
        else this.recalcActiveRows();
    }
    recalcActiveRows() {
        this.recalc(this.table.rowManager.activeRows);
    }
    cellValueChanged(cell) {
        if (cell.column.definition.topCalc || cell.column.definition.bottomCalc) {
            if (this.table.options.groupBy) {
                if (this.table.options.columnCalcs == "table" || this.table.options.columnCalcs == "both") this.recalcActiveRows();
                if (this.table.options.columnCalcs != "table") this.recalcRowGroup(cell.row);
            } else this.recalcActiveRows();
        }
    }
    initializeColumnCheck(column) {
        if (column.definition.topCalc || column.definition.bottomCalc) this.initializeColumn(column);
    }
    //initialize column calcs
    initializeColumn(column) {
        var def = column.definition;
        var config = {
            topCalcParams: def.topCalcParams || {},
            botCalcParams: def.bottomCalcParams || {}
        };
        if (def.topCalc) {
            switch(typeof def.topCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc]) config.topCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.topCalc);
                    break;
                case "function":
                    config.topCalc = def.topCalc;
                    break;
            }
            if (config.topCalc) {
                column.modules.columnCalcs = config;
                this.topCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeTopRow();
            }
        }
        if (def.bottomCalc) {
            switch(typeof def.bottomCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc]) config.botCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.bottomCalc);
                    break;
                case "function":
                    config.botCalc = def.bottomCalc;
                    break;
            }
            if (config.botCalc) {
                column.modules.columnCalcs = config;
                this.botCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeBottomRow();
            }
        }
    }
    //dummy functions to handle being mock column manager
    registerColumnField() {}
    removeCalcs() {
        var changed = false;
        if (this.topInitialized) {
            this.topInitialized = false;
            this.topElement.parentNode.removeChild(this.topElement);
            changed = true;
        }
        if (this.botInitialized) {
            this.botInitialized = false;
            this.footerRemove(this.botElement);
            changed = true;
        }
        if (changed) this.table.rowManager.adjustTableSize();
    }
    reinitializeCalcs() {
        if (this.topCalcs.length) this.initializeTopRow();
        if (this.botCalcs.length) this.initializeBottomRow();
    }
    initializeTopRow() {
        var fragment = document.createDocumentFragment();
        if (!this.topInitialized) {
            fragment.appendChild(document.createElement("br"));
            fragment.appendChild(this.topElement);
            this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
            this.topInitialized = true;
        }
    }
    initializeBottomRow() {
        if (!this.botInitialized) {
            this.footerPrepend(this.botElement);
            this.botInitialized = true;
        }
    }
    scrollHorizontal(left) {
        if (this.botInitialized && this.botRow) this.botElement.scrollLeft = left;
    }
    recalc(rows) {
        var data, row;
        if (!this.blockCheck()) {
            if (this.topInitialized || this.botInitialized) {
                data = this.rowsToData(rows);
                if (this.topInitialized) {
                    if (this.topRow) this.topRow.deleteCells();
                    row = this.generateRow("top", data);
                    this.topRow = row;
                    while(this.topElement.firstChild)this.topElement.removeChild(this.topElement.firstChild);
                    this.topElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                if (this.botInitialized) {
                    if (this.botRow) this.botRow.deleteCells();
                    row = this.generateRow("bottom", data);
                    this.botRow = row;
                    while(this.botElement.firstChild)this.botElement.removeChild(this.botElement.firstChild);
                    this.botElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                this.table.rowManager.adjustTableSize();
                //set resizable handles
                if (this.table.modExists("frozenColumns")) this.table.modules.frozenColumns.layout();
            }
        }
    }
    recalcRowGroup(row) {
        this.recalcGroup(this.table.modules.groupRows.getRowGroup(row));
    }
    recalcAll() {
        if (this.topCalcs.length || this.botCalcs.length) {
            if (this.table.options.columnCalcs !== "group") this.recalcActiveRows();
            if (this.table.options.groupBy && this.table.options.columnCalcs !== "table") {
                var groups = this.table.modules.groupRows.getChildGroups();
                groups.forEach((group)=>{
                    this.recalcGroup(group);
                });
            }
        }
    }
    recalcGroup(group) {
        var data, rowData;
        if (!this.blockCheck()) {
            if (group) {
                if (group.calcs) {
                    if (group.calcs.bottom) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("bottom", data);
                        group.calcs.bottom.updateData(rowData);
                        group.calcs.bottom.reinitialize();
                    }
                    if (group.calcs.top) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("top", data);
                        group.calcs.top.updateData(rowData);
                        group.calcs.top.reinitialize();
                    }
                }
            }
        }
    }
    //generate top stats row
    generateTopRow(rows) {
        return this.generateRow("top", this.rowsToData(rows));
    }
    //generate bottom stats row
    generateBottomRow(rows) {
        return this.generateRow("bottom", this.rowsToData(rows));
    }
    rowsToData(rows) {
        var data = [], hasDataTreeColumnCalcs = this.table.options.dataTree && this.table.options.dataTreeChildColumnCalcs, dataTree = this.table.modules.dataTree;
        rows.forEach((row)=>{
            data.push(row.getData());
            if (hasDataTreeColumnCalcs && row.modules.dataTree?.open) this.rowsToData(dataTree.getFilteredTreeChildren(row)).forEach((dataRow)=>{
                data.push(row);
            });
        });
        return data;
    }
    //generate stats row
    generateRow(pos, data) {
        var rowData = this.generateRowData(pos, data), row;
        if (this.table.modExists("mutator")) this.table.modules.mutator.disable();
        row = new $c2a9788f40f9c90a$var$Row(rowData, this, "calc");
        if (this.table.modExists("mutator")) this.table.modules.mutator.enable();
        row.getElement().classList.add("tabulator-calcs", "tabulator-calcs-" + pos);
        row.component = false;
        row.getComponent = ()=>{
            if (!row.component) row.component = new $c2a9788f40f9c90a$export$3ef2519bf7055551(row);
            return row.component;
        };
        row.generateCells = ()=>{
            var cells = [];
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                //set field name of mock column
                this.genColumn.setField(column.getField());
                this.genColumn.hozAlign = column.hozAlign;
                if (column.definition[pos + "CalcFormatter"] && this.table.modExists("format")) this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter(column.definition[pos + "CalcFormatter"]),
                    params: column.definition[pos + "CalcFormatterParams"] || {}
                };
                else this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter("plaintext"),
                    params: {}
                };
                //ensure css class definition is replicated to calculation cell
                this.genColumn.definition.cssClass = column.definition.cssClass;
                //generate cell and assign to correct column
                var cell = new $c2a9788f40f9c90a$var$Cell(this.genColumn, row);
                cell.getElement();
                cell.column = column;
                cell.setWidth();
                column.cells.push(cell);
                cells.push(cell);
                if (!column.visible) cell.hide();
            });
            row.cells = cells;
        };
        return row;
    }
    //generate stats row
    generateRowData(pos, data) {
        var rowData = {}, calcs = pos == "top" ? this.topCalcs : this.botCalcs, type = pos == "top" ? "topCalc" : "botCalc", params, paramKey;
        calcs.forEach(function(column) {
            var values = [];
            if (column.modules.columnCalcs && column.modules.columnCalcs[type]) {
                data.forEach(function(item) {
                    values.push(column.getFieldValue(item));
                });
                paramKey = type + "Params";
                params = typeof column.modules.columnCalcs[paramKey] === "function" ? column.modules.columnCalcs[paramKey](values, data) : column.modules.columnCalcs[paramKey];
                column.setFieldValue(rowData, column.modules.columnCalcs[type](values, data, params));
            }
        });
        return rowData;
    }
    hasTopCalcs() {
        return !!this.topCalcs.length;
    }
    hasBottomCalcs() {
        return !!this.botCalcs.length;
    }
    //handle table redraw
    redraw() {
        if (this.topRow) this.topRow.normalizeHeight(true);
        if (this.botRow) this.botRow.normalizeHeight(true);
    }
    //return the calculated
    getResults() {
        var results = {}, groups;
        if (this.table.options.groupBy && this.table.modExists("groupRows")) {
            groups = this.table.modules.groupRows.getGroups(true);
            groups.forEach((group)=>{
                results[group.getKey()] = this.getGroupResults(group);
            });
        } else results = {
            top: this.topRow ? this.topRow.getData() : {},
            bottom: this.botRow ? this.botRow.getData() : {}
        };
        return results;
    }
    //get results from a group
    getGroupResults(group) {
        var groupObj = group._getSelf(), subGroups = group.getSubGroups(), subGroupResults = {}, results = {};
        subGroups.forEach((subgroup)=>{
            subGroupResults[subgroup.getKey()] = this.getGroupResults(subgroup);
        });
        results = {
            top: groupObj.calcs.top ? groupObj.calcs.top.getData() : {},
            bottom: groupObj.calcs.bottom ? groupObj.calcs.bottom.getData() : {},
            groups: subGroupResults
        };
        return results;
    }
    adjustForScrollbar(width) {
        if (this.botRow) {
            if (this.table.rtl) this.botElement.style.paddingLeft = width + "px";
            else this.botElement.style.paddingRight = width + "px";
        }
    }
}
class $c2a9788f40f9c90a$export$a5a9878f12569c04 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "dataTree";
    constructor(table){
        super(table);
        this.indent = 10;
        this.field = "";
        this.collapseEl = null;
        this.expandEl = null;
        this.branchEl = null;
        this.elementField = false;
        this.startOpen = function() {};
        this.registerTableOption("dataTree", false); //enable data tree
        this.registerTableOption("dataTreeFilter", true); //filter child rows
        this.registerTableOption("dataTreeSort", true); //sort child rows
        this.registerTableOption("dataTreeElementColumn", false);
        this.registerTableOption("dataTreeBranchElement", true); //show data tree branch element
        this.registerTableOption("dataTreeChildIndent", 9); //data tree child indent in px
        this.registerTableOption("dataTreeChildField", "_children"); //data tre column field to look for child rows
        this.registerTableOption("dataTreeCollapseElement", false); //data tree row collapse element
        this.registerTableOption("dataTreeExpandElement", false); //data tree row expand element
        this.registerTableOption("dataTreeStartExpanded", false);
        this.registerTableOption("dataTreeChildColumnCalcs", false); //include visible data tree rows in column calculations
        this.registerTableOption("dataTreeSelectPropagate", false); //selecting a parent row selects its children
        //register component functions
        this.registerComponentFunction("row", "treeCollapse", this.collapseRow.bind(this));
        this.registerComponentFunction("row", "treeExpand", this.expandRow.bind(this));
        this.registerComponentFunction("row", "treeToggle", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "getTreeParent", this.getTreeParent.bind(this));
        this.registerComponentFunction("row", "getTreeChildren", this.getRowChildren.bind(this));
        this.registerComponentFunction("row", "addTreeChild", this.addTreeChildRow.bind(this));
        this.registerComponentFunction("row", "isTreeExpanded", this.isRowExpanded.bind(this));
    }
    initialize() {
        if (this.table.options.dataTree) {
            var dummyEl = null, options = this.table.options;
            this.field = options.dataTreeChildField;
            this.indent = options.dataTreeChildIndent;
            if (this.options("movableRows")) console.warn("The movableRows option is not available with dataTree enabled, moving of child rows could result in unpredictable behavior");
            if (options.dataTreeBranchElement) {
                if (options.dataTreeBranchElement === true) {
                    this.branchEl = document.createElement("div");
                    this.branchEl.classList.add("tabulator-data-tree-branch");
                } else if (typeof options.dataTreeBranchElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeBranchElement;
                    this.branchEl = dummyEl.firstChild;
                } else this.branchEl = options.dataTreeBranchElement;
            } else {
                this.branchEl = document.createElement("div");
                this.branchEl.classList.add("tabulator-data-tree-branch-empty");
            }
            if (options.dataTreeCollapseElement) {
                if (typeof options.dataTreeCollapseElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeCollapseElement;
                    this.collapseEl = dummyEl.firstChild;
                } else this.collapseEl = options.dataTreeCollapseElement;
            } else {
                this.collapseEl = document.createElement("div");
                this.collapseEl.classList.add("tabulator-data-tree-control");
                this.collapseEl.tabIndex = 0;
                this.collapseEl.innerHTML = "<div class='tabulator-data-tree-control-collapse'></div>";
            }
            if (options.dataTreeExpandElement) {
                if (typeof options.dataTreeExpandElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeExpandElement;
                    this.expandEl = dummyEl.firstChild;
                } else this.expandEl = options.dataTreeExpandElement;
            } else {
                this.expandEl = document.createElement("div");
                this.expandEl.classList.add("tabulator-data-tree-control");
                this.expandEl.tabIndex = 0;
                this.expandEl.innerHTML = "<div class='tabulator-data-tree-control-expand'></div>";
            }
            switch(typeof options.dataTreeStartExpanded){
                case "boolean":
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded;
                    };
                    break;
                case "function":
                    this.startOpen = options.dataTreeStartExpanded;
                    break;
                default:
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded[index];
                    };
                    break;
            }
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-layout-after", this.layoutRow.bind(this));
            this.subscribe("row-deleted", this.rowDelete.bind(this), 0);
            this.subscribe("row-data-changed", this.rowDataChanged.bind(this), 10);
            this.subscribe("cell-value-updated", this.cellValueChanged.bind(this));
            this.subscribe("edit-cancelled", this.cellValueChanged.bind(this));
            this.subscribe("column-moving-rows", this.columnMoving.bind(this));
            this.subscribe("table-built", this.initializeElementField.bind(this));
            this.subscribe("table-redrawing", this.tableRedrawing.bind(this));
            this.registerDisplayHandler(this.getRows.bind(this), 30);
        }
    }
    tableRedrawing(force) {
        var rows;
        if (force) {
            rows = this.table.rowManager.getRows();
            rows.forEach((row)=>{
                this.reinitializeRowChildren(row);
            });
        }
    }
    initializeElementField() {
        var firstCol = this.table.columnManager.getFirstVisibleColumn();
        this.elementField = this.table.options.dataTreeElementColumn || (firstCol ? firstCol.field : false);
    }
    getRowChildren(row) {
        return this.getTreeChildren(row, true);
    }
    columnMoving() {
        var rows = [];
        this.table.rowManager.rows.forEach((row)=>{
            rows = rows.concat(this.getTreeChildren(row, false, true));
        });
        return rows;
    }
    rowDataChanged(row, visible, updatedData) {
        if (this.redrawNeeded(updatedData)) {
            this.initializeRow(row);
            if (visible) {
                this.layoutRow(row);
                this.refreshData(true);
            }
        }
    }
    cellValueChanged(cell) {
        var field = cell.column.getField();
        if (field === this.elementField) this.layoutRow(cell.row);
    }
    initializeRow(row) {
        var childArray = row.getData()[this.field];
        var isArray = Array.isArray(childArray);
        var children = isArray || !isArray && typeof childArray === "object" && childArray !== null;
        if (!children && row.modules.dataTree && row.modules.dataTree.branchEl) row.modules.dataTree.branchEl.parentNode.removeChild(row.modules.dataTree.branchEl);
        if (!children && row.modules.dataTree && row.modules.dataTree.controlEl) row.modules.dataTree.controlEl.parentNode.removeChild(row.modules.dataTree.controlEl);
        row.modules.dataTree = {
            index: row.modules.dataTree ? row.modules.dataTree.index : 0,
            open: children ? row.modules.dataTree ? row.modules.dataTree.open : this.startOpen(row.getComponent(), 0) : false,
            controlEl: row.modules.dataTree && children ? row.modules.dataTree.controlEl : false,
            branchEl: row.modules.dataTree && children ? row.modules.dataTree.branchEl : false,
            parent: row.modules.dataTree ? row.modules.dataTree.parent : false,
            children: children
        };
    }
    reinitializeRowChildren(row) {
        var children = this.getTreeChildren(row, false, true);
        children.forEach(function(child) {
            child.reinitialize(true);
        });
    }
    layoutRow(row) {
        var cell = this.elementField ? row.getCell(this.elementField) : row.getCells()[0], el = cell.getElement(), config = row.modules.dataTree;
        if (config.branchEl) {
            if (config.branchEl.parentNode) config.branchEl.parentNode.removeChild(config.branchEl);
            config.branchEl = false;
        }
        if (config.controlEl) {
            if (config.controlEl.parentNode) config.controlEl.parentNode.removeChild(config.controlEl);
            config.controlEl = false;
        }
        this.generateControlElement(row, el);
        row.getElement().classList.add("tabulator-tree-level-" + config.index);
        if (config.index) {
            if (this.branchEl) {
                config.branchEl = this.branchEl.cloneNode(true);
                el.insertBefore(config.branchEl, el.firstChild);
                if (this.table.rtl) config.branchEl.style.marginRight = (config.branchEl.offsetWidth + config.branchEl.style.marginLeft) * (config.index - 1) + config.index * this.indent + "px";
                else config.branchEl.style.marginLeft = (config.branchEl.offsetWidth + config.branchEl.style.marginRight) * (config.index - 1) + config.index * this.indent + "px";
            } else if (this.table.rtl) el.style.paddingRight = parseInt(window.getComputedStyle(el, null).getPropertyValue("padding-right")) + config.index * this.indent + "px";
            else el.style.paddingLeft = parseInt(window.getComputedStyle(el, null).getPropertyValue("padding-left")) + config.index * this.indent + "px";
        }
    }
    generateControlElement(row, el) {
        var config = row.modules.dataTree, oldControl = config.controlEl;
        el = el || row.getCells()[0].getElement();
        if (config.children !== false) {
            if (config.open) {
                config.controlEl = this.collapseEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.collapseRow(row);
                });
            } else {
                config.controlEl = this.expandEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.expandRow(row);
                });
            }
            config.controlEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            if (oldControl && oldControl.parentNode === el) oldControl.parentNode.replaceChild(config.controlEl, oldControl);
            else el.insertBefore(config.controlEl, el.firstChild);
        }
    }
    getRows(rows) {
        var output = [];
        rows.forEach((row, i)=>{
            var config, children;
            output.push(row);
            if (row instanceof $c2a9788f40f9c90a$var$Row) {
                row.create();
                config = row.modules.dataTree;
                if (!config.index && config.children !== false) {
                    children = this.getChildren(row, false, true);
                    children.forEach((child)=>{
                        child.create();
                        output.push(child);
                    });
                }
            }
        });
        return output;
    }
    getChildren(row, allChildren, sortOnly) {
        var config = row.modules.dataTree, children = [], output = [];
        if (config.children !== false && (config.open || allChildren)) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            if (this.table.modExists("sort") && this.table.options.dataTreeSort) this.table.modules.sort.sort(children, sortOnly);
            children.forEach((child)=>{
                output.push(child);
                var subChildren = this.getChildren(child, false, true);
                subChildren.forEach((sub)=>{
                    output.push(sub);
                });
            });
        }
        return output;
    }
    generateChildren(row) {
        var children = [];
        var childArray = row.getData()[this.field];
        if (!Array.isArray(childArray)) childArray = [
            childArray
        ];
        childArray.forEach((childData)=>{
            var childRow = new $c2a9788f40f9c90a$var$Row(childData || {}, this.table.rowManager);
            childRow.create();
            childRow.modules.dataTree.index = row.modules.dataTree.index + 1;
            childRow.modules.dataTree.parent = row;
            if (childRow.modules.dataTree.children) childRow.modules.dataTree.open = this.startOpen(childRow.getComponent(), childRow.modules.dataTree.index);
            children.push(childRow);
        });
        return children;
    }
    expandRow(row, silent) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = true;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowExpanded", row.getComponent(), row.modules.dataTree.index);
        }
    }
    collapseRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = false;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowCollapsed", row.getComponent(), row.modules.dataTree.index);
        }
    }
    toggleRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            if (config.open) this.collapseRow(row);
            else this.expandRow(row);
        }
    }
    isRowExpanded(row) {
        return row.modules.dataTree.open;
    }
    getTreeParent(row) {
        return row.modules.dataTree.parent ? row.modules.dataTree.parent.getComponent() : false;
    }
    getTreeParentRoot(row) {
        return row.modules.dataTree && row.modules.dataTree.parent ? this.getTreeParentRoot(row.modules.dataTree.parent) : row;
    }
    getFilteredTreeChildren(row) {
        var config = row.modules.dataTree, output = [], children;
        if (config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) output.push(childRow);
            });
        }
        return output;
    }
    rowDelete(row) {
        var parent = row.modules.dataTree.parent, childIndex;
        if (parent) {
            childIndex = this.findChildIndex(row, parent);
            if (childIndex !== false) parent.data[this.field].splice(childIndex, 1);
            if (!parent.data[this.field].length) delete parent.data[this.field];
            this.initializeRow(parent);
            this.layoutRow(parent);
        }
        this.refreshData(true);
    }
    addTreeChildRow(row, data, top, index) {
        var childIndex = false;
        if (typeof data === "string") data = JSON.parse(data);
        if (!Array.isArray(row.data[this.field])) {
            row.data[this.field] = [];
            row.modules.dataTree.open = this.startOpen(row.getComponent(), row.modules.dataTree.index);
        }
        if (typeof index !== "undefined") {
            childIndex = this.findChildIndex(index, row);
            if (childIndex !== false) row.data[this.field].splice(top ? childIndex : childIndex + 1, 0, data);
        }
        if (childIndex === false) {
            if (top) row.data[this.field].unshift(data);
            else row.data[this.field].push(data);
        }
        this.initializeRow(row);
        this.layoutRow(row);
        this.refreshData(true);
    }
    findChildIndex(subject, parent) {
        var match = false;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            match = subject.data;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            match = subject._getSelf().data;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                if (parent.modules.dataTree) {
                    match = parent.modules.dataTree.children.find((childRow)=>{
                        return childRow instanceof $c2a9788f40f9c90a$var$Row ? childRow.element === subject : false;
                    });
                    if (match) match = match.data;
                }
            } else if (subject === null) match = false;
        } else if (typeof subject == "undefined") match = false;
        else //subject should be treated as the index of the row
        match = parent.data[this.field].find((row)=>{
            return row.data[this.table.options.index] == subject;
        });
        if (match) {
            if (Array.isArray(parent.data[this.field])) match = parent.data[this.field].indexOf(match);
            if (match == -1) match = false;
        }
        //catch all for any other type of input
        return match;
    }
    getTreeChildren(row, component, recurse) {
        var config = row.modules.dataTree, output = [];
        if (config && config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            config.children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) {
                    output.push(component ? childRow.getComponent() : childRow);
                    if (recurse) this.getTreeChildren(childRow, component, recurse).forEach((child)=>{
                        output.push(child);
                    });
                }
            });
        }
        return output;
    }
    getChildField() {
        return this.field;
    }
    redrawNeeded(data) {
        return (this.field ? typeof data[this.field] !== "undefined" : false) || (this.elementField ? typeof data[this.elementField] !== "undefined" : false);
    }
}
function $c2a9788f40f9c90a$var$csv$1(list, options = {}, setFileContents) {
    var delimiter = options.delimiter ? options.delimiter : ",", fileContents = [], headers = [];
    list.forEach((row)=>{
        var item = [];
        switch(row.type){
            case "group":
                console.warn("Download Warning - CSV downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - CSV downloader cannot process column calculations");
                break;
            case "header":
                row.columns.forEach((col, i)=>{
                    if (col && col.depth === 1) headers[i] = typeof col.value == "undefined" || col.value === null ? "" : '"' + String(col.value).split('"').join('""') + '"';
                });
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) {
                        switch(typeof col.value){
                            case "object":
                                col.value = col.value !== null ? JSON.stringify(col.value) : "";
                                break;
                            case "undefined":
                                col.value = "";
                                break;
                        }
                        item.push('"' + String(col.value).split('"').join('""') + '"');
                    }
                });
                fileContents.push(item.join(delimiter));
                break;
        }
    });
    if (headers.length) fileContents.unshift(headers.join(delimiter));
    fileContents = fileContents.join("\n");
    if (options.bom) fileContents = "\uFEFF" + fileContents;
    setFileContents(fileContents, "text/csv");
}
function $c2a9788f40f9c90a$var$json$2(list, options, setFileContents) {
    var fileContents = [];
    list.forEach((row)=>{
        var item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(item);
                break;
        }
    });
    fileContents = JSON.stringify(fileContents, null, "	");
    setFileContents(fileContents, "application/json");
}
function $c2a9788f40f9c90a$var$pdf(list, options = {}, setFileContents) {
    var header = [], body = [], autoTableParams = {}, rowGroupStyles = options.rowGroupStyles || {
        fontStyle: "bold",
        fontSize: 12,
        cellPadding: 6,
        fillColor: 220
    }, rowCalcStyles = options.rowCalcStyles || {
        fontStyle: "bold",
        fontSize: 10,
        cellPadding: 4,
        fillColor: 232
    }, jsPDFParams = options.jsPDF || {}, title = options.title ? options.title : "", jspdfLib, doc;
    if (!jsPDFParams.orientation) jsPDFParams.orientation = options.orientation || "landscape";
    if (!jsPDFParams.unit) jsPDFParams.unit = "pt";
    //parse row list
    list.forEach((row)=>{
        switch(row.type){
            case "header":
                header.push(parseRow(row));
                break;
            case "group":
                body.push(parseRow(row, rowGroupStyles));
                break;
            case "calc":
                body.push(parseRow(row, rowCalcStyles));
                break;
            case "row":
                body.push(parseRow(row));
                break;
        }
    });
    function parseRow(row, styles) {
        var rowData = [];
        row.columns.forEach((col)=>{
            var cell;
            if (col) {
                switch(typeof col.value){
                    case "object":
                        col.value = col.value !== null ? JSON.stringify(col.value) : "";
                        break;
                    case "undefined":
                        col.value = "";
                        break;
                }
                cell = {
                    content: col.value,
                    colSpan: col.width,
                    rowSpan: col.height
                };
                if (styles) cell.styles = styles;
                rowData.push(cell);
            }
        });
        return rowData;
    }
    //configure PDF
    jspdfLib = this.dependencyRegistry.lookup("jspdf", "jsPDF");
    doc = new jspdfLib(jsPDFParams); //set document to landscape, better for most tables
    if (options.autoTable) {
        if (typeof options.autoTable === "function") autoTableParams = options.autoTable(doc) || {};
        else autoTableParams = options.autoTable;
    }
    if (title) autoTableParams.didDrawPage = function(data) {
        doc.text(title, 40, 30);
    };
    autoTableParams.head = header;
    autoTableParams.body = body;
    doc.autoTable(autoTableParams);
    if (options.documentProcessing) options.documentProcessing(doc);
    setFileContents(doc.output("arraybuffer"), "application/pdf");
}
function $c2a9788f40f9c90a$var$xlsx$1(list, options, setFileContents) {
    var self = this, sheetName = options.sheetName || "Sheet1", XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook = XLSXLib.utils.book_new(), tableFeatures = new $c2a9788f40f9c90a$var$CoreFeature(this), compression = "compress" in options ? options.compress : true, writeOptions = options.writeOptions || {
        bookType: "xlsx",
        bookSST: true,
        compression: compression
    }, output;
    writeOptions.type = "binary";
    workbook.SheetNames = [];
    workbook.Sheets = {};
    function generateSheet() {
        var rows = [], merges = [], worksheet = {}, range = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: list[0] ? list[0].columns.reduce((a, b)=>a + (b && b.width ? b.width : 1), 0) : 0,
                r: list.length
            }
        };
        //parse row list
        list.forEach((row, i)=>{
            var rowData = [];
            row.columns.forEach(function(col, j) {
                if (col) {
                    rowData.push(!(col.value instanceof Date) && typeof col.value === "object" ? JSON.stringify(col.value) : col.value);
                    if (col.width > 1 || col.height > -1) {
                        if (col.height > 1 || col.width > 1) merges.push({
                            s: {
                                r: i,
                                c: j
                            },
                            e: {
                                r: i + col.height - 1,
                                c: j + col.width - 1
                            }
                        });
                    }
                } else rowData.push("");
            });
            rows.push(rowData);
        });
        //convert rows to worksheet
        XLSXLib.utils.sheet_add_aoa(worksheet, rows);
        worksheet["!ref"] = XLSXLib.utils.encode_range(range);
        if (merges.length) worksheet["!merges"] = merges;
        return worksheet;
    }
    if (options.sheetOnly) {
        setFileContents(generateSheet());
        return;
    }
    if (options.sheets) {
        for(var sheet in options.sheets)if (options.sheets[sheet] === true) {
            workbook.SheetNames.push(sheet);
            workbook.Sheets[sheet] = generateSheet();
        } else {
            workbook.SheetNames.push(sheet);
            tableFeatures.commsSend(options.sheets[sheet], "download", "intercept", {
                type: "xlsx",
                options: {
                    sheetOnly: true
                },
                active: self.active,
                intercept: function(data) {
                    workbook.Sheets[sheet] = data;
                }
            });
        }
    } else {
        workbook.SheetNames.push(sheetName);
        workbook.Sheets[sheetName] = generateSheet();
    }
    if (options.documentProcessing) workbook = options.documentProcessing(workbook);
    //convert workbook to binary array
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    output = XLSXLib.write(workbook, writeOptions);
    setFileContents(s2ab(output), "application/octet-stream");
}
function $c2a9788f40f9c90a$var$html$1(list, options, setFileContents) {
    if (this.modExists("export", true)) setFileContents(this.modules.export.generateHTMLTable(list), "text/html");
}
function $c2a9788f40f9c90a$var$jsonLines(list, options, setFileContents) {
    const fileContents = [];
    list.forEach((row)=>{
        const item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(JSON.stringify(item));
                break;
        }
    });
    setFileContents(fileContents.join("\n"), "application/x-ndjson");
}
var $c2a9788f40f9c90a$var$defaultDownloaders = {
    csv: $c2a9788f40f9c90a$var$csv$1,
    json: $c2a9788f40f9c90a$var$json$2,
    jsonLines: $c2a9788f40f9c90a$var$jsonLines,
    pdf: $c2a9788f40f9c90a$var$pdf,
    xlsx: $c2a9788f40f9c90a$var$xlsx$1,
    html: $c2a9788f40f9c90a$var$html$1
};
class $c2a9788f40f9c90a$export$6dd96c6d41f32a97 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "download";
    //load defaults
    static downloaders = $c2a9788f40f9c90a$var$defaultDownloaders;
    constructor(table){
        super(table);
        this.registerTableOption("downloadEncoder", function(data, mimeType) {
            return new Blob([
                data
            ], {
                type: mimeType
            });
        }); //function to manipulate download data
        // this.registerTableOption("downloadReady", undefined); //warn of function deprecation
        this.registerTableOption("downloadConfig", {}); //download config
        this.registerTableOption("downloadRowRange", "active"); //restrict download to active rows only
        this.registerColumnOption("download");
        this.registerColumnOption("titleDownload");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.registerTableFunction("download", this.download.bind(this));
        this.registerTableFunction("downloadToTab", this.downloadToTab.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("downloadReady", "downloadEncoder");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    downloadToTab(type, filename, options, active) {
        this.download(type, filename, options, active, true);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //trigger file download
    download(type, filename, options, range, interceptCallback) {
        var downloadFunc = false;
        function buildLink(data, mime) {
            if (interceptCallback) {
                if (interceptCallback === true) this.triggerDownload(data, mime, type, filename, true);
                else interceptCallback(data);
            } else this.triggerDownload(data, mime, type, filename);
        }
        if (typeof type == "function") downloadFunc = type;
        else if ($c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type]) downloadFunc = $c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type];
        else console.warn("Download Error - No such download type found: ", type);
        if (downloadFunc) {
            var list = this.generateExportList(range);
            downloadFunc.call(this.table, list, options || {}, buildLink.bind(this));
        }
    }
    generateExportList(range) {
        var list = this.table.modules.export.generateExportList(this.table.options.downloadConfig, false, range || this.table.options.downloadRowRange, "download");
        //assign group header formatter
        var groupHeader = this.table.options.groupHeaderDownload;
        if (groupHeader && !Array.isArray(groupHeader)) groupHeader = [
            groupHeader
        ];
        list.forEach((row)=>{
            var group;
            if (row.type === "group") {
                group = row.columns[0];
                if (groupHeader && groupHeader[row.indent]) group.value = groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
            }
        });
        return list;
    }
    triggerDownload(data, mime, type, filename, newTab) {
        var element = document.createElement("a"), blob = this.table.options.downloadEncoder(data, mime);
        if (blob) {
            if (newTab) window.open(window.URL.createObjectURL(blob));
            else {
                filename = filename || "Tabulator." + (typeof type === "function" ? "txt" : type);
                if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename);
                else {
                    element.setAttribute("href", window.URL.createObjectURL(blob));
                    //set file title
                    element.setAttribute("download", filename);
                    //trigger download
                    element.style.display = "none";
                    document.body.appendChild(element);
                    element.click();
                    //remove temporary link element
                    document.body.removeChild(element);
                }
            }
            this.dispatchExternal("downloadComplete");
        }
    }
    commsReceived(table, action, data) {
        switch(action){
            case "intercept":
                this.download(data.type, "", data.options, data.active, data.intercept);
                break;
        }
    }
}
function $c2a9788f40f9c90a$var$maskInput(el, options) {
    var mask = options.mask, maskLetter = typeof options.maskLetterChar !== "undefined" ? options.maskLetterChar : "A", maskNumber = typeof options.maskNumberChar !== "undefined" ? options.maskNumberChar : "9", maskWildcard = typeof options.maskWildcardChar !== "undefined" ? options.maskWildcardChar : "*";
    function fillSymbols(index) {
        var symbol = mask[index];
        if (typeof symbol !== "undefined" && symbol !== maskWildcard && symbol !== maskLetter && symbol !== maskNumber) {
            el.value = el.value + "" + symbol;
            fillSymbols(index + 1);
        }
    }
    el.addEventListener("keydown", (e)=>{
        var index = el.value.length, char = e.key;
        if (e.keyCode > 46 && !e.ctrlKey && !e.metaKey) {
            if (index >= mask.length) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            } else switch(mask[index]){
                case maskLetter:
                    if (char.toUpperCase() == char.toLowerCase()) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskNumber:
                    if (isNaN(char)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskWildcard:
                    break;
                default:
                    if (char !== mask[index]) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
            }
        }
        return;
    });
    el.addEventListener("keyup", (e)=>{
        if (e.keyCode > 46) {
            if (options.maskAutoFill) fillSymbols(el.value.length);
        }
    });
    if (!el.placeholder) el.placeholder = mask;
    if (options.maskAutoFill) fillSymbols(el.value.length);
}
//input element
function $c2a9788f40f9c90a$var$input(cell, onRendered, success, cancel, editorParams) {
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", editorParams.search ? "search" : "text");
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = typeof cellValue !== "undefined" ? cellValue : "";
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//resizable text area element
function $c2a9788f40f9c90a$var$textarea$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "hybrid", value = String(cellValue !== null && typeof cellValue !== "undefined" ? cellValue : ""), input = document.createElement("textarea"), scrollHeight = 0;
    //create and style input
    input.style.display = "block";
    input.style.padding = "2px";
    input.style.height = "100%";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.style.whiteSpace = "pre-wrap";
    input.style.resize = "none";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            input.scrollHeight;
            input.style.height = input.scrollHeight + "px";
            cell.getRow().normalizeHeight();
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
            setTimeout(function() {
                cell.getRow().normalizeHeight();
            }, 300);
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    input.addEventListener("keyup", function() {
        input.style.height = "";
        var heightNow = input.scrollHeight;
        input.style.height = heightNow + "px";
        if (heightNow != scrollHeight) {
            scrollHeight = heightNow;
            cell.getRow().normalizeHeight();
        }
    });
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                if (e.shiftKey && editorParams.shiftEnterSubmit) onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 40:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart !== input.value.length) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$number$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "editor", input = document.createElement("input");
    input.setAttribute("type", "number");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    var blurFunc = function(e) {
        onChange();
    };
    onRendered(function() {
        if (cell.getType() === "cell") {
            //submit new value on blur
            input.removeEventListener("blur", blurFunc);
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            //submit new value on blur
            input.addEventListener("blur", blurFunc);
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value !== cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$range(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", "range");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value != cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        onChange();
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$date$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    function convertDate(value) {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        return newDatetime.toFormat("yyyy-MM-dd");
    }
    input.type = "date";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.max) input.setAttribute("max", inputFormat ? convertDate(editorParams.max) : editorParams.max);
    if (editorParams.min) input.setAttribute("min", inputFormat ? convertDate(editorParams.min) : editorParams.min);
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) cellValue = convertDate(cellValue);
        else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDate;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDate = DT.fromFormat(String(value), "yyyy-MM-dd");
                switch(inputFormat){
                    case true:
                        value = luxDate;
                        break;
                    case "iso":
                        value = luxDate.toISO();
                        break;
                    default:
                        value = luxDate.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$time$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "time";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() == "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxTime = DT.fromFormat(String(value), "hh:mm");
                switch(inputFormat){
                    case true:
                        value = luxTime;
                        break;
                    case "iso":
                        value = luxTime.toISO();
                        break;
                    default:
                        value = luxTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$datetime$2(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime") : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "datetime-local";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("yyyy-MM-dd") + "T" + newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDateTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDateTime = DT.fromISO(String(value));
                switch(inputFormat){
                    case true:
                        value = luxDateTime;
                        break;
                    case "iso":
                        value = luxDateTime.toISO();
                        break;
                    default:
                        value = luxDateTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
let $c2a9788f40f9c90a$var$Edit$1 = class Edit {
    constructor(editor, cell, onRendered, success, cancel, editorParams){
        this.edit = editor;
        this.table = editor.table;
        this.cell = cell;
        this.params = this._initializeParams(editorParams);
        this.data = [];
        this.displayItems = [];
        this.currentItems = [];
        this.focusedItem = null;
        this.input = this._createInputElement();
        this.listEl = this._createListElement();
        this.initialValues = null;
        this.isFilter = cell.getType() === "header";
        this.filterTimeout = null;
        this.filtered = false;
        this.typing = false;
        this.values = [];
        this.popup = null;
        this.listIteration = 0;
        this.lastAction = "";
        this.filterTerm = "";
        this.blurable = true;
        this.actions = {
            success: success,
            cancel: cancel
        };
        this._deprecatedOptionsCheck();
        this._initializeValue();
        onRendered(this._onRendered.bind(this));
    }
    _deprecatedOptionsCheck() {
    // if(this.params.listItemFormatter){
    // 	this.cell.getTable().deprecationAdvisor.msg("The listItemFormatter editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.sortValuesList){
    // 	this.cell.getTable().deprecationAdvisor.msg("The sortValuesList editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchFunc){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchFunc editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchingPlaceholder){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchingPlaceholder editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    }
    _initializeValue() {
        var initialValue = this.cell.getValue();
        if (typeof initialValue === "undefined" && typeof this.params.defaultValue !== "undefined") initialValue = this.params.defaultValue;
        this.initialValues = this.params.multiselect ? initialValue : [
            initialValue
        ];
        if (this.isFilter) {
            this.input.value = this.initialValues ? this.initialValues.join(",") : "";
            this.headerFilterInitialListGen();
        }
    }
    _onRendered() {
        var cellEl = this.cell.getElement();
        function clickStop(e) {
            e.stopPropagation();
        }
        if (!this.isFilter) {
            this.input.style.height = "100%";
            this.input.focus({
                preventScroll: true
            });
        }
        cellEl.addEventListener("click", clickStop);
        setTimeout(()=>{
            cellEl.removeEventListener("click", clickStop);
        }, 1000);
        this.input.addEventListener("mousedown", this._preventPopupBlur.bind(this));
    }
    _createListElement() {
        var listEl = document.createElement("div");
        listEl.classList.add("tabulator-edit-list");
        listEl.addEventListener("mousedown", this._preventBlur.bind(this));
        listEl.addEventListener("keydown", this._inputKeyDown.bind(this));
        return listEl;
    }
    _setListWidth() {
        var element = this.isFilter ? this.input : this.cell.getElement();
        this.listEl.style.minWidth = element.offsetWidth + "px";
        if (this.params.maxWidth) {
            if (this.params.maxWidth === true) this.listEl.style.maxWidth = element.offsetWidth + "px";
            else if (typeof this.params.maxWidth === "number") this.listEl.style.maxWidth = this.params.maxWidth + "px";
            else this.listEl.style.maxWidth = this.params.maxWidth;
        }
    }
    _createInputElement() {
        var attribs = this.params.elementAttributes;
        var input = document.createElement("input");
        input.setAttribute("type", this.params.clearable ? "search" : "text");
        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";
        if (!this.params.autocomplete) {
            input.style.cursor = "default";
            input.style.caretColor = "transparent";
        // input.readOnly = (this.edit.currentCell != false);
        }
        if (attribs && typeof attribs == "object") {
            for(let key in attribs)if (key.charAt(0) == "+") {
                key = key.slice(1);
                input.setAttribute(key, input.getAttribute(key) + attribs["+" + key]);
            } else input.setAttribute(key, attribs[key]);
        }
        if (this.params.mask) $c2a9788f40f9c90a$var$maskInput(input, this.params);
        this._bindInputEvents(input);
        return input;
    }
    _initializeParams(params) {
        var valueKeys = [
            "values",
            "valuesURL",
            "valuesLookup"
        ], valueCheck;
        params = Object.assign({}, params);
        params.verticalNavigation = params.verticalNavigation || "editor";
        params.placeholderLoading = typeof params.placeholderLoading === "undefined" ? "Searching ..." : params.placeholderLoading;
        params.placeholderEmpty = typeof params.placeholderEmpty === "undefined" ? "No Results Found" : params.placeholderEmpty;
        params.filterDelay = typeof params.filterDelay === "undefined" ? 300 : params.filterDelay;
        params.emptyValue = Object.keys(params).includes("emptyValue") ? params.emptyValue : "";
        valueCheck = Object.keys(params).filter((key)=>valueKeys.includes(key)).length;
        if (!valueCheck) console.warn("list editor config error - either the values, valuesURL, or valuesLookup option must be set");
        else if (valueCheck > 1) console.warn("list editor config error - only one of the values, valuesURL, or valuesLookup options can be set on the same editor");
        if (params.autocomplete) {
            if (params.multiselect) {
                params.multiselect = false;
                console.warn("list editor config error - multiselect option is not available when autocomplete is enabled");
            }
        } else {
            if (params.freetext) {
                params.freetext = false;
                console.warn("list editor config error - freetext option is only available when autocomplete is enabled");
            }
            if (params.filterFunc) {
                params.filterFunc = false;
                console.warn("list editor config error - filterFunc option is only available when autocomplete is enabled");
            }
            if (params.filterRemote) {
                params.filterRemote = false;
                console.warn("list editor config error - filterRemote option is only available when autocomplete is enabled");
            }
            if (params.mask) {
                params.mask = false;
                console.warn("list editor config error - mask option is only available when autocomplete is enabled");
            }
            if (params.allowEmpty) {
                params.allowEmpty = false;
                console.warn("list editor config error - allowEmpty option is only available when autocomplete is enabled");
            }
            if (params.listOnEmpty) {
                params.listOnEmpty = false;
                console.warn("list editor config error - listOnEmpty option is only available when autocomplete is enabled");
            }
        }
        if (params.filterRemote && !(typeof params.valuesLookup === "function" || params.valuesURL)) {
            params.filterRemote = false;
            console.warn("list editor config error - filterRemote option should only be used when values list is populated from a remote source");
        }
        return params;
    }
    //////////////////////////////////////
    ////////// Event Handling ////////////
    //////////////////////////////////////
    _bindInputEvents(input) {
        input.addEventListener("focus", this._inputFocus.bind(this));
        input.addEventListener("click", this._inputClick.bind(this));
        input.addEventListener("blur", this._inputBlur.bind(this));
        input.addEventListener("keydown", this._inputKeyDown.bind(this));
        input.addEventListener("search", this._inputSearch.bind(this));
        if (this.params.autocomplete) input.addEventListener("keyup", this._inputKeyUp.bind(this));
    }
    _inputFocus(e) {
        this.rebuildOptionsList();
    }
    _filter() {
        if (this.params.filterRemote) {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(()=>{
                this.rebuildOptionsList();
            }, this.params.filterDelay);
        } else this._filterList();
    }
    _inputClick(e) {
        e.stopPropagation();
    }
    _inputBlur(e) {
        if (this.blurable) {
            if (this.popup) this.popup.hide();
            else this._resolveValue(true);
        }
    }
    _inputSearch() {
        this._clearChoices();
    }
    _inputKeyDown(e) {
        switch(e.keyCode){
            case 38:
                this._keyUp(e);
                break;
            case 40:
                this._keyDown(e);
                break;
            case 37:
            case 39:
                this._keySide(e);
                break;
            case 13:
                this._keyEnter();
                break;
            case 27:
                this._keyEsc();
                break;
            case 36:
            case 35:
                this._keyHomeEnd(e);
                break;
            case 9:
                this._keyTab(e);
                break;
            default:
                this._keySelectLetter(e);
        }
    }
    _inputKeyUp(e) {
        switch(e.keyCode){
            case 38:
            case 37:
            case 39:
            case 40:
            case 13:
            case 27:
                break;
            default:
                this._keyAutoCompLetter(e);
        }
    }
    _preventPopupBlur() {
        if (this.popup) this.popup.blockHide();
        setTimeout(()=>{
            if (this.popup) this.popup.restoreHide();
        }, 10);
    }
    _preventBlur() {
        this.blurable = false;
        setTimeout(()=>{
            this.blurable = true;
        }, 10);
    }
    //////////////////////////////////////
    //////// Keyboard Navigation /////////
    //////////////////////////////////////
    _keyTab(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem, true);
    }
    _keyUp(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index > 0) this._focusItem(this.displayItems[index - 1]);
        }
    }
    _keyDown(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index < this.displayItems.length - 1) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index < this.displayItems.length - 1) {
                if (index == -1) this._focusItem(this.displayItems[0]);
                else this._focusItem(this.displayItems[index + 1]);
            }
        }
    }
    _keySide(e) {
        if (!this.params.autocomplete) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
    }
    _keyEnter(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem);
    }
    _keyEsc(e) {
        this._cancel();
    }
    _keyHomeEnd(e) {
        if (this.params.autocomplete) //prevent table navigation while using input element
        e.stopImmediatePropagation();
    }
    _keySelectLetter(e) {
        if (!this.params.autocomplete) {
            // if(this.edit.currentCell === false){
            e.preventDefault();
            // }
            if (e.keyCode >= 38 && e.keyCode <= 90) this._scrollToValue(e.keyCode);
        }
    }
    _keyAutoCompLetter(e) {
        this._filter();
        this.lastAction = "typing";
        this.typing = true;
    }
    _scrollToValue(char) {
        clearTimeout(this.filterTimeout);
        var character = String.fromCharCode(char).toLowerCase();
        this.filterTerm += character.toLowerCase();
        var match = this.displayItems.find((item)=>{
            return typeof item.label !== "undefined" && item.label.toLowerCase().startsWith(this.filterTerm);
        });
        if (match) this._focusItem(match);
        this.filterTimeout = setTimeout(()=>{
            this.filterTerm = "";
        }, 800);
    }
    _focusItem(item) {
        this.lastAction = "focus";
        if (this.focusedItem && this.focusedItem.element) this.focusedItem.element.classList.remove("focused");
        this.focusedItem = item;
        if (item && item.element) {
            item.element.classList.add("focused");
            item.element.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
        }
    }
    //////////////////////////////////////
    /////// Data List Generation /////////
    //////////////////////////////////////
    headerFilterInitialListGen() {
        this._generateOptions(true);
    }
    rebuildOptionsList() {
        this._generateOptions().then(this._sortOptions.bind(this)).then(this._buildList.bind(this)).then(this._showList.bind(this)).catch((e)=>{
            if (!Number.isInteger(e)) console.error("List generation error", e);
        });
    }
    _filterList() {
        this._buildList(this._filterOptions());
        this._showList();
    }
    _generateOptions(silent) {
        var values = [];
        var iteration = ++this.listIteration;
        this.filtered = false;
        if (this.params.values) values = this.params.values;
        else if (this.params.valuesURL) values = this._ajaxRequest(this.params.valuesURL, this.input.value);
        else {
            if (typeof this.params.valuesLookup === "function") values = this.params.valuesLookup(this.cell, this.input.value);
            else if (this.params.valuesLookup) values = this._uniqueColumnValues(this.params.valuesLookupField);
        }
        if (values instanceof Promise) {
            if (!silent) this._addPlaceholder(this.params.placeholderLoading);
            return values.then().then((responseValues)=>{
                if (this.listIteration === iteration) return this._parseList(responseValues);
                else return Promise.reject(iteration);
            });
        } else return Promise.resolve(this._parseList(values));
    }
    _addPlaceholder(contents) {
        var placeholder = document.createElement("div");
        if (typeof contents === "function") contents = contents(this.cell.getComponent(), this.listEl);
        if (contents) {
            this._clearList();
            if (contents instanceof HTMLElement) placeholder = contents;
            else {
                placeholder.classList.add("tabulator-edit-list-placeholder");
                placeholder.innerHTML = contents;
            }
            this.listEl.appendChild(placeholder);
            this._showList();
        }
    }
    _ajaxRequest(url, term) {
        var params = this.params.filterRemote ? {
            term: term
        } : {};
        url = $c2a9788f40f9c90a$var$urlBuilder(url, {}, params);
        return fetch(url).then((response)=>{
            if (response.ok) return response.json().catch((error)=>{
                console.warn("List Ajax Load Error - Invalid JSON returned", error);
                return Promise.reject(error);
            });
            else {
                console.error("List Ajax Load Error - Connection Error: " + response.status, response.statusText);
                return Promise.reject(response);
            }
        }).catch((error)=>{
            console.error("List Ajax Load Error - Connection Error: ", error);
            return Promise.reject(error);
        });
    }
    _uniqueColumnValues(field) {
        var output = {}, data = this.table.getData(this.params.valuesLookup), column;
        if (field) column = this.table.columnManager.getColumnByField(field);
        else column = this.cell.getColumn()._getSelf();
        if (column) data.forEach((row)=>{
            var val = column.getFieldValue(row);
            if (!this._emptyValueCheck(val)) {
                if (this.params.multiselect && Array.isArray(val)) val.forEach((item)=>{
                    if (!this._emptyValueCheck(item)) output[item] = true;
                });
                else output[val] = true;
            }
        });
        else {
            console.warn("unable to find matching column to create select lookup list:", field);
            output = [];
        }
        return Object.keys(output);
    }
    _emptyValueCheck(value) {
        return value === null || typeof value === "undefined" || value === "";
    }
    _parseList(inputValues) {
        var data = [];
        if (!Array.isArray(inputValues)) inputValues = Object.entries(inputValues).map(([key, value])=>{
            return {
                label: value,
                value: key
            };
        });
        inputValues.forEach((value)=>{
            if (typeof value !== "object") value = {
                label: value,
                value: value
            };
            this._parseListItem(value, data, 0);
        });
        if (!this.currentItems.length && this.params.freetext) {
            this.input.value = this.initialValues;
            this.typing = true;
            this.lastAction = "typing";
        }
        this.data = data;
        return data;
    }
    _parseListItem(option, data, level) {
        var item = {};
        if (option.options) item = this._parseListGroup(option, level + 1);
        else {
            item = {
                label: option.label,
                value: option.value,
                itemParams: option.itemParams,
                elementAttributes: option.elementAttributes,
                element: false,
                selected: false,
                visible: true,
                level: level,
                original: option
            };
            if (this.initialValues && this.initialValues.indexOf(option.value) > -1) this._chooseItem(item, true);
        }
        data.push(item);
    }
    _parseListGroup(option, level) {
        var item = {
            label: option.label,
            group: true,
            itemParams: option.itemParams,
            elementAttributes: option.elementAttributes,
            element: false,
            visible: true,
            level: level,
            options: [],
            original: option
        };
        option.options.forEach((child)=>{
            this._parseListItem(child, item.options, level);
        });
        return item;
    }
    _sortOptions(options) {
        var sorter;
        if (this.params.sort) {
            sorter = typeof this.params.sort === "function" ? this.params.sort : this._defaultSortFunction.bind(this);
            this._sortGroup(sorter, options);
        }
        return options;
    }
    _sortGroup(sorter, options) {
        options.sort((a, b)=>{
            return sorter(a.label, b.label, a.value, b.value, a.original, b.original);
        });
        options.forEach((option)=>{
            if (option.group) this._sortGroup(sorter, option.options);
        });
    }
    _defaultSortFunction(as, bs) {
        var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
        var emptyAlign = 0;
        if (this.params.sort === "desc") [as, bs] = [
            bs,
            as
        ];
        //handle empty values
        if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
        else if (!bs && bs !== 0) emptyAlign = 1;
        else {
            if (isFinite(as) && isFinite(bs)) return as - bs;
            a = String(as).toLowerCase();
            b = String(bs).toLowerCase();
            if (a === b) return 0;
            if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
            a = a.match(rx);
            b = b.match(rx);
            L = a.length > b.length ? b.length : a.length;
            while(i < L){
                a1 = a[i];
                b1 = b[i++];
                if (a1 !== b1) {
                    if (isFinite(a1) && isFinite(b1)) {
                        if (a1.charAt(0) === "0") a1 = "." + a1;
                        if (b1.charAt(0) === "0") b1 = "." + b1;
                        return a1 - b1;
                    } else return a1 > b1 ? 1 : -1;
                }
            }
            return a.length > b.length;
        }
        return emptyAlign;
    }
    _filterOptions() {
        var filterFunc = this.params.filterFunc || this._defaultFilterFunc, term = this.input.value;
        if (term) {
            this.filtered = true;
            this.data.forEach((item)=>{
                this._filterItem(filterFunc, term, item);
            });
        } else this.filtered = false;
        return this.data;
    }
    _filterItem(func, term, item) {
        var matches = false;
        if (!item.group) item.visible = func(term, item.label, item.value, item.original);
        else {
            item.options.forEach((option)=>{
                if (this._filterItem(func, term, option)) matches = true;
            });
            item.visible = matches;
        }
        return item.visible;
    }
    _defaultFilterFunc(term, label, value, item) {
        term = String(term).toLowerCase();
        if (label !== null && typeof label !== "undefined") {
            if (String(label).toLowerCase().indexOf(term) > -1 || String(value).toLowerCase().indexOf(term) > -1) return true;
        }
        return false;
    }
    //////////////////////////////////////
    /////////// Display List /////////////
    //////////////////////////////////////
    _clearList() {
        while(this.listEl.firstChild)this.listEl.removeChild(this.listEl.firstChild);
        this.displayItems = [];
    }
    _buildList(data) {
        this._clearList();
        data.forEach((option)=>{
            this._buildItem(option);
        });
        if (!this.displayItems.length) this._addPlaceholder(this.params.placeholderEmpty);
    }
    _buildItem(item) {
        var el = item.element, contents;
        if (!this.filtered || item.visible) {
            if (!el) {
                el = document.createElement("div");
                el.tabIndex = 0;
                contents = this.params.itemFormatter ? this.params.itemFormatter(item.label, item.value, item.original, el) : item.label;
                if (contents instanceof HTMLElement) el.appendChild(contents);
                else el.innerHTML = contents;
                if (item.group) el.classList.add("tabulator-edit-list-group");
                else el.classList.add("tabulator-edit-list-item");
                el.classList.add("tabulator-edit-list-group-level-" + item.level);
                if (item.elementAttributes && typeof item.elementAttributes == "object") {
                    for(let key in item.elementAttributes)if (key.charAt(0) == "+") {
                        key = key.slice(1);
                        el.setAttribute(key, this.input.getAttribute(key) + item.elementAttributes["+" + key]);
                    } else el.setAttribute(key, item.elementAttributes[key]);
                }
                if (item.group) el.addEventListener("click", this._groupClick.bind(this, item));
                else el.addEventListener("click", this._itemClick.bind(this, item));
                el.addEventListener("mousedown", this._preventBlur.bind(this));
                item.element = el;
            }
            this._styleItem(item);
            this.listEl.appendChild(el);
            if (item.group) item.options.forEach((option)=>{
                this._buildItem(option);
            });
            else this.displayItems.push(item);
        }
    }
    _showList() {
        var startVis = this.popup && this.popup.isVisible();
        if (this.input.parentNode) {
            if (this.params.autocomplete && this.input.value === "" && !this.params.listOnEmpty) {
                if (this.popup) this.popup.hide(true);
                return;
            }
            this._setListWidth();
            if (!this.popup) this.popup = this.edit.popup(this.listEl);
            this.popup.show(this.cell.getElement(), "bottom");
            if (!startVis) setTimeout(()=>{
                this.popup.hideOnBlur(this._resolveValue.bind(this, true));
            }, 10);
        }
    }
    _styleItem(item) {
        if (item && item.element) {
            if (item.selected) item.element.classList.add("active");
            else item.element.classList.remove("active");
        }
    }
    //////////////////////////////////////
    ///////// User Interaction ///////////
    //////////////////////////////////////
    _itemClick(item, e) {
        e.stopPropagation();
        this._chooseItem(item);
    }
    _groupClick(item, e) {
        e.stopPropagation();
    }
    //////////////////////////////////////
    ////// Current Item Management ///////
    //////////////////////////////////////
    _cancel() {
        this.popup.hide(true);
        this.actions.cancel();
    }
    _clearChoices() {
        this.typing = true;
        this.currentItems.forEach((item)=>{
            item.selected = false;
            this._styleItem(item);
        });
        this.currentItems = [];
        this.focusedItem = null;
    }
    _chooseItem(item, silent) {
        var index;
        this.typing = false;
        if (this.params.multiselect) {
            index = this.currentItems.indexOf(item);
            if (index > -1) {
                this.currentItems.splice(index, 1);
                item.selected = false;
            } else {
                this.currentItems.push(item);
                item.selected = true;
            }
            this.input.value = this.currentItems.map((item)=>item.label).join(",");
            this._styleItem(item);
        } else {
            this.currentItems = [
                item
            ];
            item.selected = true;
            this.input.value = item.label;
            this._styleItem(item);
            if (!silent) this._resolveValue();
        }
        this._focusItem(item);
    }
    _resolveValue(blur) {
        var output, initialValue;
        if (this.popup) this.popup.hide(true);
        if (this.params.multiselect) output = this.currentItems.map((item)=>item.value);
        else {
            if (blur && this.params.autocomplete && this.typing) {
                if (this.params.freetext || this.params.allowEmpty && this.input.value === "") output = this.input.value;
                else {
                    this.actions.cancel();
                    return;
                }
            } else if (this.currentItems[0]) output = this.currentItems[0].value;
            else {
                initialValue = Array.isArray(this.initialValues) ? this.initialValues[0] : this.initialValues;
                if (initialValue === null || typeof initialValue === "undefined" || initialValue === "") output = initialValue;
                else output = this.params.emptyValue;
            }
        }
        if (output === "") output = this.params.emptyValue;
        this.actions.success(output);
        if (this.isFilter) {
            this.initialValues = output && !Array.isArray(output) ? [
                output
            ] : output;
            this.currentItems = [];
        }
    }
};
function $c2a9788f40f9c90a$var$list(cell, onRendered, success, cancel, editorParams) {
    var list = new $c2a9788f40f9c90a$var$Edit$1(this, cell, onRendered, success, cancel, editorParams);
    return list.input;
}
//star rating
function $c2a9788f40f9c90a$var$star$1(cell, onRendered, success, cancel, editorParams) {
    var self = this, element = cell.getElement(), value = cell.getValue(), maxStars = element.getElementsByTagName("svg").length || 5, size = element.getElementsByTagName("svg")[0] ? element.getElementsByTagName("svg")[0].getAttribute("width") : 14, stars = [], starsHolder = document.createElement("div"), star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    //change star type
    function starChange(val) {
        stars.forEach(function(star, i) {
            if (i < val) {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-active");
                else star.classList.replace("tabulator-star-inactive", "tabulator-star-active");
                star.innerHTML = '<polygon fill="#488CE9" stroke="#014AAE" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            } else {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-inactive");
                else star.classList.replace("tabulator-star-active", "tabulator-star-inactive");
                star.innerHTML = '<polygon fill="#010155" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            }
        });
    }
    //build stars
    function buildStar(i) {
        var starHolder = document.createElement("span");
        var nextStar = star.cloneNode(true);
        stars.push(nextStar);
        starHolder.addEventListener("mouseenter", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            starChange(i);
        });
        starHolder.addEventListener("mousemove", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
        starHolder.addEventListener("click", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            success(i);
            element.blur();
        });
        starHolder.appendChild(nextStar);
        starsHolder.appendChild(starHolder);
    }
    //handle keyboard navigation value change
    function changeValue(val) {
        value = val;
        starChange(val);
    }
    //style cell
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    //style holding element
    starsHolder.style.verticalAlign = "middle";
    starsHolder.style.display = "inline-block";
    starsHolder.style.padding = "4px";
    //style star
    star.setAttribute("width", size);
    star.setAttribute("height", size);
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            starsHolder.setAttribute(key, starsHolder.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else starsHolder.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //create correct number of stars
    for(var i = 1; i <= maxStars; i++)buildStar(i);
    //ensure value does not exceed number of stars
    value = Math.min(parseInt(value), maxStars);
    // set initial styling of stars
    starChange(value);
    starsHolder.addEventListener("mousemove", function(e) {
        starChange(0);
    });
    starsHolder.addEventListener("click", function(e) {
        success(0);
    });
    element.addEventListener("blur", function(e) {
        cancel();
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                changeValue(value + 1);
                break;
            case 37:
                changeValue(value - 1);
                break;
            case 13:
                success(value);
                break;
            case 27:
                cancel();
                break;
        }
    });
    return starsHolder;
}
//draggable progress bar
function $c2a9788f40f9c90a$var$progress$1(cell, onRendered, success, cancel, editorParams) {
    var element = cell.getElement(), max = typeof editorParams.max === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("max") || 100 : editorParams.max, min = typeof editorParams.min === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("min") || 0 : editorParams.min, percent = (max - min) / 100, value = cell.getValue() || 0, handle = document.createElement("div"), bar = document.createElement("div"), mouseDrag, mouseDragWidth;
    //set new value
    function updateValue() {
        var style = window.getComputedStyle(element, null);
        var calcVal = percent * Math.round(bar.offsetWidth / ((element.clientWidth - parseInt(style.getPropertyValue("padding-left")) - parseInt(style.getPropertyValue("padding-right"))) / 100)) + min;
        success(calcVal);
        element.setAttribute("aria-valuenow", calcVal);
        element.setAttribute("aria-label", value);
    }
    //style handle
    handle.style.position = "absolute";
    handle.style.right = "0";
    handle.style.top = "0";
    handle.style.bottom = "0";
    handle.style.width = "5px";
    handle.classList.add("tabulator-progress-handle");
    //style bar
    bar.style.display = "inline-block";
    bar.style.position = "relative";
    // bar.style.top = "8px";
    // bar.style.bottom = "8px";
    // bar.style.left = "4px";
    // bar.style.marginRight = "4px";
    bar.style.height = "100%";
    bar.style.backgroundColor = "#488CE9";
    bar.style.maxWidth = "100%";
    bar.style.minWidth = "0%";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            bar.setAttribute(key, bar.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else bar.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //style cell
    element.style.padding = "4px 4px";
    //make sure value is in range
    value = Math.min(parseFloat(value), max);
    value = Math.max(parseFloat(value), min);
    //workout percentage
    value = Math.round((value - min) / percent);
    // bar.style.right = value + "%";
    bar.style.width = value + "%";
    element.setAttribute("aria-valuemin", min);
    element.setAttribute("aria-valuemax", max);
    bar.appendChild(handle);
    handle.addEventListener("mousedown", function(e) {
        mouseDrag = e.screenX;
        mouseDragWidth = bar.offsetWidth;
    });
    handle.addEventListener("mouseover", function() {
        handle.style.cursor = "ew-resize";
    });
    element.addEventListener("mousemove", function(e) {
        if (mouseDrag) bar.style.width = mouseDragWidth + e.screenX - mouseDrag + "px";
    });
    element.addEventListener("mouseup", function(e) {
        if (mouseDrag) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            mouseDrag = false;
            mouseDragWidth = false;
            updateValue();
        }
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                e.preventDefault();
                bar.style.width = bar.clientWidth + element.clientWidth / 100 + "px";
                break;
            case 37:
                e.preventDefault();
                bar.style.width = bar.clientWidth - element.clientWidth / 100 + "px";
                break;
            case 9:
            case 13:
                updateValue();
                break;
            case 27:
                cancel();
                break;
        }
    });
    element.addEventListener("blur", function() {
        cancel();
    });
    return bar;
}
//checkbox
function $c2a9788f40f9c90a$var$tickCross$1(cell, onRendered, success, cancel, editorParams) {
    var value = cell.getValue(), input = document.createElement("input"), tristate = editorParams.tristate, indetermValue = typeof editorParams.indeterminateValue === "undefined" ? null : editorParams.indeterminateValue, indetermState = false, trueValueSet = Object.keys(editorParams).includes("trueValue"), falseValueSet = Object.keys(editorParams).includes("falseValue");
    input.setAttribute("type", "checkbox");
    input.style.marginTop = "5px";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    if (tristate && (typeof value === "undefined" || value === indetermValue || value === "")) {
        indetermState = true;
        input.indeterminate = true;
    }
    if (this.table.browser != "firefox" && this.table.browser != "safari") onRendered(function() {
        if (cell.getType() === "cell") input.focus({
            preventScroll: true
        });
    });
    input.checked = trueValueSet ? value === editorParams.trueValue : value === true || value === "true" || value === "True" || value === 1;
    function setValue(blur) {
        var checkedValue = input.checked;
        if (trueValueSet && checkedValue) checkedValue = editorParams.trueValue;
        else if (falseValueSet && !checkedValue) checkedValue = editorParams.falseValue;
        if (tristate) {
            if (!blur) {
                if (input.checked && !indetermState) {
                    input.checked = false;
                    input.indeterminate = true;
                    indetermState = true;
                    return indetermValue;
                } else {
                    indetermState = false;
                    return checkedValue;
                }
            } else {
                if (indetermState) return indetermValue;
                else return checkedValue;
            }
        } else return checkedValue;
    }
    //submit new value on blur
    input.addEventListener("change", function(e) {
        success(setValue());
    });
    input.addEventListener("blur", function(e) {
        success(setValue(true));
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        if (e.keyCode == 13) success(setValue());
        if (e.keyCode == 27) cancel();
    });
    return input;
}
function $c2a9788f40f9c90a$var$adaptable$1(cell, onRendered, success, cancel, params) {
    var column = cell._getSelf().column, lookup, editorFunc, editorParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), editor = "input";
        switch(typeof value){
            case "number":
                editor = "number";
                break;
            case "boolean":
                editor = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) editor = "textarea";
                break;
        }
        return editor;
    }
    lookup = params.editorLookup ? params.editorLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) editorParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    editorFunc = this.table.modules.edit.lookupEditor(lookup, column);
    return editorFunc.call(this, cell, onRendered, success, cancel, editorParams || {});
}
var $c2a9788f40f9c90a$var$defaultEditors = {
    input: $c2a9788f40f9c90a$var$input,
    textarea: $c2a9788f40f9c90a$var$textarea$1,
    number: $c2a9788f40f9c90a$var$number$1,
    range: $c2a9788f40f9c90a$var$range,
    date: $c2a9788f40f9c90a$var$date$1,
    time: $c2a9788f40f9c90a$var$time$1,
    datetime: $c2a9788f40f9c90a$var$datetime$2,
    list: $c2a9788f40f9c90a$var$list,
    star: $c2a9788f40f9c90a$var$star$1,
    progress: $c2a9788f40f9c90a$var$progress$1,
    tickCross: $c2a9788f40f9c90a$var$tickCross$1,
    adaptable: $c2a9788f40f9c90a$var$adaptable$1
};
class $c2a9788f40f9c90a$export$2394e2d3d2175314 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "edit";
    //load defaults
    static editors = $c2a9788f40f9c90a$var$defaultEditors;
    constructor(table){
        super(table);
        this.currentCell = false; //hold currently editing cell
        this.mouseClick = false; //hold mousedown state to prevent click binding being overridden by editor opening
        this.recursionBlock = false; //prevent focus recursion
        this.invalidEdit = false;
        this.editedCells = [];
        this.convertEmptyValues = false;
        this.editors = $c2a9788f40f9c90a$export$2394e2d3d2175314.editors;
        this.registerTableOption("editTriggerEvent", "focus");
        this.registerTableOption("editorEmptyValue");
        this.registerTableOption("editorEmptyValueFunc", this.emptyValueCheck.bind(this));
        this.registerColumnOption("editable");
        this.registerColumnOption("editor");
        this.registerColumnOption("editorParams");
        this.registerColumnOption("editorEmptyValue");
        this.registerColumnOption("editorEmptyValueFunc");
        this.registerColumnOption("cellEditing");
        this.registerColumnOption("cellEdited");
        this.registerColumnOption("cellEditCancelled");
        this.registerTableFunction("getEditedCells", this.getEditedCells.bind(this));
        this.registerTableFunction("clearCellEdited", this.clearCellEdited.bind(this));
        this.registerTableFunction("navigatePrev", this.navigatePrev.bind(this));
        this.registerTableFunction("navigateNext", this.navigateNext.bind(this));
        this.registerTableFunction("navigateLeft", this.navigateLeft.bind(this));
        this.registerTableFunction("navigateRight", this.navigateRight.bind(this));
        this.registerTableFunction("navigateUp", this.navigateUp.bind(this));
        this.registerTableFunction("navigateDown", this.navigateDown.bind(this));
        this.registerComponentFunction("cell", "isEdited", this.cellIsEdited.bind(this));
        this.registerComponentFunction("cell", "clearEdited", this.clearEdited.bind(this));
        this.registerComponentFunction("cell", "edit", this.editCell.bind(this));
        this.registerComponentFunction("cell", "cancelEdit", this.cellCancelEdit.bind(this));
        this.registerComponentFunction("cell", "navigatePrev", this.navigatePrev.bind(this));
        this.registerComponentFunction("cell", "navigateNext", this.navigateNext.bind(this));
        this.registerComponentFunction("cell", "navigateLeft", this.navigateLeft.bind(this));
        this.registerComponentFunction("cell", "navigateRight", this.navigateRight.bind(this));
        this.registerComponentFunction("cell", "navigateUp", this.navigateUp.bind(this));
        this.registerComponentFunction("cell", "navigateDown", this.navigateDown.bind(this));
    }
    initialize() {
        this.subscribe("cell-init", this.bindEditor.bind(this));
        this.subscribe("cell-delete", this.clearEdited.bind(this));
        this.subscribe("cell-value-changed", this.updateCellClass.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("column-delete", this.columnDeleteCheck.bind(this));
        this.subscribe("row-deleting", this.rowDeleteCheck.bind(this));
        this.subscribe("row-layout", this.rowEditableCheck.bind(this));
        this.subscribe("data-refreshing", this.cancelEdit.bind(this));
        this.subscribe("clipboard-paste", this.pasteBlocker.bind(this));
        this.subscribe("keybinding-nav-prev", this.navigatePrev.bind(this, undefined));
        this.subscribe("keybinding-nav-next", this.keybindingNavigateNext.bind(this));
        // this.subscribe("keybinding-nav-left", this.navigateLeft.bind(this, undefined));
        // this.subscribe("keybinding-nav-right", this.navigateRight.bind(this, undefined));
        this.subscribe("keybinding-nav-up", this.navigateUp.bind(this, undefined));
        this.subscribe("keybinding-nav-down", this.navigateDown.bind(this, undefined));
        if (Object.keys(this.table.options).includes("editorEmptyValue")) this.convertEmptyValues = true;
    }
    ///////////////////////////////////
    ///////// Paste Negation //////////
    ///////////////////////////////////
    pasteBlocker(e) {
        if (this.currentCell) return true;
    }
    ///////////////////////////////////
    ////// Keybinding Functions ///////
    ///////////////////////////////////
    keybindingNavigateNext(e) {
        var cell = this.currentCell, newRow = this.options("tabEndNewRow");
        if (cell) {
            if (!this.navigateNext(cell, e)) {
                if (newRow) {
                    cell.getElement().firstChild.blur();
                    if (!this.invalidEdit) {
                        if (newRow === true) newRow = this.table.addRow({});
                        else if (typeof newRow == "function") newRow = this.table.addRow(newRow(cell.row.getComponent()));
                        else newRow = this.table.addRow(Object.assign({}, newRow));
                        newRow.then(()=>{
                            setTimeout(()=>{
                                cell.getComponent().navigateNext();
                            });
                        });
                    }
                }
            }
        }
    }
    ///////////////////////////////////
    ///////// Cell Functions //////////
    ///////////////////////////////////
    cellIsEdited(cell) {
        return !!cell.modules.edit && cell.modules.edit.edited;
    }
    cellCancelEdit(cell) {
        if (cell === this.currentCell) this.table.modules.edit.cancelEdit();
        else console.warn("Cancel Editor Error - This cell is not currently being edited ");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    updateCellClass(cell) {
        if (this.allowEdit(cell)) cell.getElement().classList.add("tabulator-editable");
        else cell.getElement().classList.remove("tabulator-editable");
    }
    clearCellEdited(cells) {
        if (!cells) cells = this.table.modules.edit.getEditedCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.table.modules.edit.clearEdited(cell._getSelf());
        });
    }
    navigatePrev(cell = this.currentCell, e) {
        var nextCell, prevRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateLeft();
            if (nextCell) return true;
            else {
                prevRow = this.table.rowManager.prevDisplayRow(cell.row, true);
                if (prevRow) {
                    nextCell = this.findPrevEditableCell(prevRow, prevRow.cells.length);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateNext(cell = this.currentCell, e) {
        var nextCell, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateRight();
            if (nextCell) return true;
            else {
                nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
                if (nextRow) {
                    nextCell = this.findNextEditableCell(nextRow, -1);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateLeft(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findPrevEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateRight(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findNextEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateUp(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.prevDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateDown(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    findNextEditableCell(row, index) {
        var nextCell = false;
        if (index < row.cells.length - 1) for(var i = index + 1; i < row.cells.length; i++){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    nextCell = cell;
                    break;
                }
            }
        }
        return nextCell;
    }
    findPrevEditableCell(row, index) {
        var prevCell = false;
        if (index > 0) for(var i = index - 1; i >= 0; i--){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    prevCell = cell;
                    break;
                }
            }
        }
        return prevCell;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.editor !== "undefined") this.initializeColumn(column);
    }
    columnDeleteCheck(column) {
        if (this.currentCell && this.currentCell.column === column) this.cancelEdit();
    }
    rowDeleteCheck(row) {
        if (this.currentCell && this.currentCell.row === row) this.cancelEdit();
    }
    rowEditableCheck(row) {
        row.getCells().forEach((cell)=>{
            if (cell.column.modules.edit && typeof cell.column.modules.edit.check === "function") this.updateCellClass(cell);
        });
    }
    //initialize column editor
    initializeColumn(column) {
        var convertEmpty = Object.keys(column.definition).includes("editorEmptyValue");
        var config = {
            editor: false,
            blocked: false,
            check: column.definition.editable,
            params: column.definition.editorParams || {},
            convertEmptyValues: convertEmpty,
            editorEmptyValue: column.definition.editorEmptyValue,
            editorEmptyValueFunc: column.definition.editorEmptyValueFunc
        };
        //set column editor
        config.editor = this.lookupEditor(column.definition.editor, column);
        if (config.editor) column.modules.edit = config;
    }
    lookupEditor(editor, column) {
        var editorFunc;
        switch(typeof editor){
            case "string":
                if (this.editors[editor]) editorFunc = this.editors[editor];
                else console.warn("Editor Error - No such editor found: ", editor);
                break;
            case "function":
                editorFunc = editor;
                break;
            case "boolean":
                if (editor === true) {
                    if (typeof column.definition.formatter !== "function") {
                        if (this.editors[column.definition.formatter]) editorFunc = this.editors[column.definition.formatter];
                        else editorFunc = this.editors["input"];
                    } else console.warn("Editor Error - Cannot auto lookup editor for a custom formatter: ", column.definition.formatter);
                }
                break;
        }
        return editorFunc;
    }
    getCurrentCell() {
        return this.currentCell ? this.currentCell.getComponent() : false;
    }
    clearEditor(cancel) {
        var cell = this.currentCell, cellEl;
        this.invalidEdit = false;
        if (cell) {
            this.currentCell = false;
            cellEl = cell.getElement();
            this.dispatch("edit-editor-clear", cell, cancel);
            cellEl.classList.remove("tabulator-editing");
            while(cellEl.firstChild)cellEl.removeChild(cellEl.firstChild);
            cell.row.getElement().classList.remove("tabulator-editing");
            cell.table.element.classList.remove("tabulator-editing");
        }
    }
    cancelEdit() {
        if (this.currentCell) {
            var cell = this.currentCell;
            var component = this.currentCell.getComponent();
            this.clearEditor(true);
            cell.setValueActual(cell.getValue());
            cell.cellRendered();
            if (cell.column.definition.editor == "textarea" || cell.column.definition.variableHeight) cell.row.normalizeHeight(true);
            if (cell.column.definition.cellEditCancelled) cell.column.definition.cellEditCancelled.call(this.table, component);
            this.dispatch("edit-cancelled", cell);
            this.dispatchExternal("cellEditCancelled", component);
        }
    }
    //return a formatted value for a cell
    bindEditor(cell) {
        if (cell.column.modules.edit) {
            var self = this, element = cell.getElement(true);
            this.updateCellClass(cell);
            element.setAttribute("tabindex", 0);
            element.addEventListener("mousedown", function(e) {
                if (e.button === 2) e.preventDefault();
                else self.mouseClick = true;
            });
            if (this.options("editTriggerEvent") === "dblclick") element.addEventListener("dblclick", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus" || this.options("editTriggerEvent") === "click") element.addEventListener("click", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus") element.addEventListener("focus", function(e) {
                if (!self.recursionBlock) self.edit(cell, e, false);
            });
        }
    }
    focusCellNoEvent(cell, block) {
        this.recursionBlock = true;
        if (!(block && this.table.browser === "ie")) cell.getElement().focus({
            preventScroll: true
        });
        this.recursionBlock = false;
    }
    editCell(cell, forceEdit) {
        this.focusCellNoEvent(cell);
        this.edit(cell, false, forceEdit);
    }
    focusScrollAdjust(cell) {
        if (this.table.rowManager.getRenderMode() == "virtual") {
            var topEdge = this.table.rowManager.element.scrollTop, bottomEdge = this.table.rowManager.element.clientHeight + this.table.rowManager.element.scrollTop, rowEl = cell.row.getElement();
            if (rowEl.offsetTop < topEdge) this.table.rowManager.element.scrollTop -= topEdge - rowEl.offsetTop;
            else if (rowEl.offsetTop + rowEl.offsetHeight > bottomEdge) this.table.rowManager.element.scrollTop += rowEl.offsetTop + rowEl.offsetHeight - bottomEdge;
            var leftEdge = this.table.rowManager.element.scrollLeft, rightEdge = this.table.rowManager.element.clientWidth + this.table.rowManager.element.scrollLeft, cellEl = cell.getElement();
            if (this.table.modExists("frozenColumns")) {
                leftEdge += parseInt(this.table.modules.frozenColumns.leftMargin || 0);
                rightEdge -= parseInt(this.table.modules.frozenColumns.rightMargin || 0);
            }
            if (this.table.options.renderHorizontal === "virtual") {
                leftEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
                rightEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
            }
            if (cellEl.offsetLeft < leftEdge) this.table.rowManager.element.scrollLeft -= leftEdge - cellEl.offsetLeft;
            else if (cellEl.offsetLeft + cellEl.offsetWidth > rightEdge) this.table.rowManager.element.scrollLeft += cellEl.offsetLeft + cellEl.offsetWidth - rightEdge;
        }
    }
    allowEdit(cell) {
        var check = cell.column.modules.edit ? true : false;
        if (cell.column.modules.edit) switch(typeof cell.column.modules.edit.check){
            case "function":
                if (cell.row.initialized) check = cell.column.modules.edit.check(cell.getComponent());
                break;
            case "string":
                check = !!cell.row.data[cell.column.modules.edit.check];
                break;
            case "boolean":
                check = cell.column.modules.edit.check;
                break;
        }
        return check;
    }
    edit(cell, e, forceEdit) {
        var self = this, allowEdit = true, rendered = function() {}, element = cell.getElement(), editFinished = false, cellEditor, component, params;
        //prevent editing if another cell is refusing to leave focus (eg. validation fail)
        if (this.currentCell) {
            if (!this.invalidEdit && this.currentCell !== cell) this.cancelEdit();
            return;
        }
        //handle successful value change
        function success(value) {
            if (self.currentCell === cell && !editFinished) {
                var valid = self.chain("edit-success", [
                    cell,
                    value
                ], true, true);
                if (valid === true || self.table.options.validationMode === "highlight") {
                    editFinished = true;
                    self.clearEditor();
                    if (!cell.modules.edit) cell.modules.edit = {};
                    cell.modules.edit.edited = true;
                    if (self.editedCells.indexOf(cell) == -1) self.editedCells.push(cell);
                    value = self.transformEmptyValues(value, cell);
                    cell.setValue(value, true);
                    return valid === true;
                } else {
                    editFinished = true;
                    self.invalidEdit = true;
                    self.focusCellNoEvent(cell, true);
                    rendered();
                    setTimeout(()=>{
                        editFinished = false;
                    }, 10);
                    return false;
                }
            }
        }
        //handle aborted edit
        function cancel() {
            // editFinished = true;
            if (self.currentCell === cell && !editFinished) self.cancelEdit();
        }
        function onRendered(callback) {
            rendered = callback;
        }
        if (!cell.column.modules.edit.blocked) {
            if (e) e.stopPropagation();
            allowEdit = this.allowEdit(cell);
            if (allowEdit || forceEdit) {
                self.cancelEdit();
                self.currentCell = cell;
                this.focusScrollAdjust(cell);
                component = cell.getComponent();
                if (this.mouseClick) {
                    this.mouseClick = false;
                    if (cell.column.definition.cellClick) cell.column.definition.cellClick.call(this.table, e, component);
                }
                if (cell.column.definition.cellEditing) cell.column.definition.cellEditing.call(this.table, component);
                this.dispatch("cell-editing", cell);
                this.dispatchExternal("cellEditing", component);
                params = typeof cell.column.modules.edit.params === "function" ? cell.column.modules.edit.params(component) : cell.column.modules.edit.params;
                cellEditor = cell.column.modules.edit.editor.call(self, component, onRendered, success, cancel, params);
                //if editor returned, add to DOM, if false, abort edit
                if (this.currentCell && cellEditor !== false) {
                    if (cellEditor instanceof Node) {
                        element.classList.add("tabulator-editing");
                        cell.row.getElement().classList.add("tabulator-editing");
                        cell.table.element.classList.add("tabulator-editing");
                        while(element.firstChild)element.removeChild(element.firstChild);
                        element.appendChild(cellEditor);
                        //trigger onRendered Callback
                        rendered();
                        //prevent editing from triggering rowClick event
                        var children = element.children;
                        for(var i = 0; i < children.length; i++)children[i].addEventListener("click", function(e) {
                            e.stopPropagation();
                        });
                    } else {
                        console.warn("Edit Error - Editor should return an instance of Node, the editor returned:", cellEditor);
                        this.blur(element);
                        return false;
                    }
                } else {
                    this.blur(element);
                    return false;
                }
                return true;
            } else {
                this.mouseClick = false;
                this.blur(element);
                return false;
            }
        } else {
            this.mouseClick = false;
            this.blur(element);
            return false;
        }
    }
    emptyValueCheck(value) {
        return value === "" || value === null || typeof value === "undefined";
    }
    transformEmptyValues(value, cell) {
        var mod = cell.column.modules.edit, convert = mod.convertEmptyValues || this.convertEmptyValues, checkFunc;
        if (convert) {
            checkFunc = mod.editorEmptyValueFunc || this.options("editorEmptyValueFunc");
            if (checkFunc && checkFunc(value)) value = mod.convertEmptyValues ? mod.editorEmptyValue : this.options("editorEmptyValue");
        }
        return value;
    }
    blur(element) {
        if (!this.confirm("edit-blur", [
            element
        ])) element.blur();
    }
    getEditedCells() {
        var output = [];
        this.editedCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearEdited(cell) {
        var editIndex;
        if (cell.modules.edit && cell.modules.edit.edited) {
            cell.modules.edit.edited = false;
            this.dispatch("edit-edited-clear", cell);
        }
        editIndex = this.editedCells.indexOf(cell);
        if (editIndex > -1) this.editedCells.splice(editIndex, 1);
    }
}
class $c2a9788f40f9c90a$var$ExportRow {
    constructor(type, columns, component, indent){
        this.type = type;
        this.columns = columns;
        this.component = component || false;
        this.indent = indent || 0;
    }
}
class $c2a9788f40f9c90a$var$ExportColumn {
    constructor(value, component, width, height, depth){
        this.value = value;
        this.component = component || false;
        this.width = width;
        this.height = height;
        this.depth = depth;
    }
}
var $c2a9788f40f9c90a$var$columnLookups$1 = {};
var $c2a9788f40f9c90a$var$rowLookups$1 = {
    visible: function() {
        return this.rowManager.getVisibleRows(false, true);
    },
    all: function() {
        return this.rowManager.rows;
    },
    selected: function() {
        return this.modules.selectRow.selectedRows;
    },
    active: function() {
        if (this.options.pagination) return this.rowManager.getDisplayRows(this.rowManager.displayRows.length - 2);
        else return this.rowManager.getDisplayRows();
    }
};
class $c2a9788f40f9c90a$export$4e0f34fd9829977c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "export";
    static columnLookups = $c2a9788f40f9c90a$var$columnLookups$1;
    static rowLookups = $c2a9788f40f9c90a$var$rowLookups$1;
    constructor(table){
        super(table);
        this.config = {};
        this.cloneTableStyle = true;
        this.colVisProp = "";
        this.colVisPropAttach = "";
        this.registerTableOption("htmlOutputConfig", false); //html output config
        this.registerColumnOption("htmlOutput");
        this.registerColumnOption("titleHtmlOutput");
    }
    initialize() {
        this.registerTableFunction("getHtml", this.getHtml.bind(this));
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    generateExportList(config, style, range, colVisProp) {
        var headers, body, columns, colLookup;
        this.cloneTableStyle = style;
        this.config = config || {};
        this.colVisProp = colVisProp;
        this.colVisPropAttach = this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1);
        colLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.columnLookups[range];
        if (colLookup) {
            columns = colLookup.call(this.table);
            columns = columns.filter((col)=>this.columnVisCheck(col));
        }
        headers = this.config.columnHeaders !== false ? this.headersToExportRows(this.generateColumnGroupHeaders(columns)) : [];
        if (columns) columns = columns.map((col)=>col.getComponent());
        body = this.bodyToExportRows(this.rowLookup(range), columns);
        return headers.concat(body);
    }
    generateTable(config, style, range, colVisProp) {
        var list = this.generateExportList(config, style, range, colVisProp);
        return this.generateTableElement(list);
    }
    rowLookup(range) {
        var rows = [], rowLookup;
        if (typeof range == "function") range.call(this.table).forEach((row)=>{
            row = this.table.rowManager.findRow(row);
            if (row) rows.push(row);
        });
        else {
            rowLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups[range] || $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups["active"];
            rows = rowLookup.call(this.table);
        }
        return Object.assign([], rows);
    }
    generateColumnGroupHeaders(columns) {
        var output = [];
        if (!columns) columns = this.config.columnGroups !== false ? this.table.columnManager.columns : this.table.columnManager.columnsByIndex;
        columns.forEach((column)=>{
            var colData = this.processColumnGroup(column);
            if (colData) output.push(colData);
        });
        return output;
    }
    processColumnGroup(column) {
        var subGroups = column.columns, maxDepth = 0, title = column.definition["title" + this.colVisPropAttach] || column.definition.title;
        var groupData = {
            title: title,
            column: column,
            depth: 1
        };
        if (subGroups.length) {
            groupData.subGroups = [];
            groupData.width = 0;
            subGroups.forEach((subGroup)=>{
                var subGroupData = this.processColumnGroup(subGroup);
                if (subGroupData) {
                    groupData.width += subGroupData.width;
                    groupData.subGroups.push(subGroupData);
                    if (subGroupData.depth > maxDepth) maxDepth = subGroupData.depth;
                }
            });
            groupData.depth += maxDepth;
            if (!groupData.width) return false;
        } else {
            if (this.columnVisCheck(column)) groupData.width = 1;
            else return false;
        }
        return groupData;
    }
    columnVisCheck(column) {
        var visProp = column.definition[this.colVisProp];
        if (this.config.rowHeaders === false && column.isRowHeader) return false;
        if (typeof visProp === "function") visProp = visProp.call(this.table, column.getComponent());
        if (visProp === false || visProp === true) return visProp;
        return column.visible && column.field;
    }
    headersToExportRows(columns) {
        var headers = [], headerDepth = 0, exportRows = [];
        function parseColumnGroup(column, level) {
            var depth = headerDepth - level;
            if (typeof headers[level] === "undefined") headers[level] = [];
            column.height = column.subGroups ? 1 : depth - column.depth + 1;
            headers[level].push(column);
            if (column.height > 1) for(let i = 1; i < column.height; i++){
                if (typeof headers[level + i] === "undefined") headers[level + i] = [];
                headers[level + i].push(false);
            }
            if (column.width > 1) for(let i = 1; i < column.width; i++)headers[level].push(false);
            if (column.subGroups) column.subGroups.forEach(function(subGroup) {
                parseColumnGroup(subGroup, level + 1);
            });
        }
        //calculate maximum header depth
        columns.forEach(function(column) {
            if (column.depth > headerDepth) headerDepth = column.depth;
        });
        columns.forEach(function(column) {
            parseColumnGroup(column, 0);
        });
        headers.forEach((header)=>{
            var columns = [];
            header.forEach((col)=>{
                if (col) {
                    let title = typeof col.title === "undefined" ? "" : col.title;
                    columns.push(new $c2a9788f40f9c90a$var$ExportColumn(title, col.column.getComponent(), col.width, col.height, col.depth));
                } else columns.push(null);
            });
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow("header", columns));
        });
        return exportRows;
    }
    bodyToExportRows(rows, columns = []) {
        var exportRows = [];
        if (columns.length === 0) this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (this.columnVisCheck(column)) columns.push(column.getComponent());
        });
        if (this.config.columnCalcs !== false && this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized) rows.unshift(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized) rows.push(this.table.modules.columnCalcs.botRow);
        }
        rows = rows.filter((row)=>{
            switch(row.type){
                case "group":
                    return this.config.rowGroups !== false;
                case "calc":
                    return this.config.columnCalcs !== false;
                case "row":
                    return !(this.table.options.dataTree && this.config.dataTree === false && row.modules.dataTree.parent);
            }
            return true;
        });
        rows.forEach((row, i)=>{
            var rowData = row.getData(this.colVisProp);
            var exportCols = [];
            var indent = 0;
            switch(row.type){
                case "group":
                    indent = row.level;
                    exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(row.key, row.getComponent(), columns.length, 1));
                    break;
                case "calc":
                case "row":
                    columns.forEach((col)=>{
                        exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(col._column.getFieldValue(rowData), col, 1, 1));
                    });
                    if (this.table.options.dataTree && this.config.dataTree !== false) indent = row.modules.dataTree.index;
                    break;
            }
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow(row.type, exportCols, row.getComponent(), indent));
        });
        return exportRows;
    }
    generateTableElement(list) {
        var table = document.createElement("table"), headerEl = document.createElement("thead"), bodyEl = document.createElement("tbody"), styles = this.lookupTableStyles(), rowFormatter = this.table.options["rowFormatter" + this.colVisPropAttach], setup = {};
        setup.rowFormatter = rowFormatter !== null ? rowFormatter : this.table.options.rowFormatter;
        if (this.table.options.dataTree && this.config.dataTree !== false && this.table.modExists("columnCalcs")) setup.treeElementField = this.table.modules.dataTree.elementField;
        //assign group header formatter
        setup.groupHeader = this.table.options["groupHeader" + this.colVisPropAttach];
        if (setup.groupHeader && !Array.isArray(setup.groupHeader)) setup.groupHeader = [
            setup.groupHeader
        ];
        table.classList.add("tabulator-print-table");
        this.mapElementStyles(this.table.columnManager.getHeadersElement(), headerEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "background-color",
            "color",
            "font-weight",
            "font-family",
            "font-size"
        ]);
        if (list.length > 1000) console.warn("It may take a long time to render an HTML table with more than 1000 rows");
        list.forEach((row, i)=>{
            let rowEl;
            switch(row.type){
                case "header":
                    headerEl.appendChild(this.generateHeaderElement(row, setup, styles));
                    break;
                case "group":
                    bodyEl.appendChild(this.generateGroupElement(row, setup, styles));
                    break;
                case "calc":
                    bodyEl.appendChild(this.generateCalcElement(row, setup, styles));
                    break;
                case "row":
                    rowEl = this.generateRowElement(row, setup, styles);
                    this.mapElementStyles(i % 2 && styles.evenRow ? styles.evenRow : styles.oddRow, rowEl, [
                        "border-top",
                        "border-left",
                        "border-right",
                        "border-bottom",
                        "color",
                        "font-weight",
                        "font-family",
                        "font-size",
                        "background-color"
                    ]);
                    bodyEl.appendChild(rowEl);
                    break;
            }
        });
        if (headerEl.innerHTML) table.appendChild(headerEl);
        table.appendChild(bodyEl);
        this.mapElementStyles(this.table.element, table, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom"
        ]);
        return table;
    }
    lookupTableStyles() {
        var styles = {};
        //lookup row styles
        if (this.cloneTableStyle && window.getComputedStyle) {
            styles.oddRow = this.table.element.querySelector(".tabulator-row-odd:not(.tabulator-group):not(.tabulator-calcs)");
            styles.evenRow = this.table.element.querySelector(".tabulator-row-even:not(.tabulator-group):not(.tabulator-calcs)");
            styles.calcRow = this.table.element.querySelector(".tabulator-row.tabulator-calcs");
            styles.firstRow = this.table.element.querySelector(".tabulator-row:not(.tabulator-group):not(.tabulator-calcs)");
            styles.firstGroup = this.table.element.getElementsByClassName("tabulator-group")[0];
            if (styles.firstRow) {
                styles.styleCells = styles.firstRow.getElementsByClassName("tabulator-cell");
                styles.styleRowHeader = styles.firstRow.getElementsByClassName("tabulator-row-header")[0];
                styles.firstCell = styles.styleCells[0];
                styles.lastCell = styles.styleCells[styles.styleCells.length - 1];
            }
        }
        return styles;
    }
    generateHeaderElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        row.columns.forEach((column)=>{
            if (column) {
                var cellEl = document.createElement("th");
                var classNames = column.component._column.definition.cssClass ? column.component._column.definition.cssClass.split(" ") : [];
                cellEl.colSpan = column.width;
                cellEl.rowSpan = column.height;
                cellEl.innerHTML = column.value;
                if (this.cloneTableStyle) cellEl.style.boxSizing = "border-box";
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                this.mapElementStyles(column.component.getElement(), cellEl, [
                    "text-align",
                    "border-left",
                    "border-right",
                    "background-color",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size"
                ]);
                this.mapElementStyles(column.component._column.contentElement, cellEl, [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom"
                ]);
                if (column.component._column.visible) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "width"
                ]);
                else if (column.component._column.definition.width) cellEl.style.width = column.component._column.definition.width + "px";
                if (column.component._column.parent && column.component._column.parent.isGroup) this.mapElementStyles(column.component._column.parent.groupElement, cellEl, [
                    "border-top"
                ]);
                else this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-top"
                ]);
                if (column.component._column.isGroup) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-bottom"
                ]);
                else this.mapElementStyles(this.table.columnManager.getElement(), cellEl, [
                    "border-bottom"
                ]);
                rowEl.appendChild(cellEl);
            }
        });
        return rowEl;
    }
    generateGroupElement(row, setup, styles) {
        var rowEl = document.createElement("tr"), cellEl = document.createElement("td"), group = row.columns[0];
        rowEl.classList.add("tabulator-print-table-row");
        if (setup.groupHeader && setup.groupHeader[row.indent]) group.value = setup.groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        else if (setup.groupHeader !== false) group.value = row.component._group.generator(group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        cellEl.colSpan = group.width;
        cellEl.innerHTML = group.value;
        rowEl.classList.add("tabulator-print-table-group");
        rowEl.classList.add("tabulator-group-level-" + row.indent);
        if (group.component.isVisible()) rowEl.classList.add("tabulator-group-visible");
        this.mapElementStyles(styles.firstGroup, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        this.mapElementStyles(styles.firstGroup, cellEl, [
            "padding-top",
            "padding-left",
            "padding-right",
            "padding-bottom"
        ]);
        rowEl.appendChild(cellEl);
        return rowEl;
    }
    generateCalcElement(row, setup, styles) {
        var rowEl = this.generateRowElement(row, setup, styles);
        rowEl.classList.add("tabulator-print-table-calcs");
        this.mapElementStyles(styles.calcRow, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        return rowEl;
    }
    generateRowElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        rowEl.classList.add("tabulator-print-table-row");
        row.columns.forEach((col, i)=>{
            if (col) {
                var cellEl = document.createElement("td"), column = col.component._column, table = this.table, index = table.columnManager.findColumnIndex(column), value = col.value, cellStyle, styleProps;
                var cellWrapper = {
                    modules: {},
                    getValue: function() {
                        return value;
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return cellEl;
                    },
                    getType: function() {
                        return "cell";
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getData: function() {
                        return row.component.getData();
                    },
                    getRow: function() {
                        return row.component;
                    },
                    getTable: function() {
                        return table;
                    },
                    getComponent: function() {
                        return cellWrapper;
                    },
                    column: column
                };
                var classNames = column.definition.cssClass ? column.definition.cssClass.split(" ") : [];
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                if (this.table.modExists("format") && this.config.formatCells !== false) value = this.table.modules.format.formatExportValue(cellWrapper, this.colVisProp);
                else switch(typeof value){
                    case "object":
                        value = value !== null ? JSON.stringify(value) : "";
                        break;
                    case "undefined":
                        value = "";
                        break;
                }
                if (value instanceof Node) cellEl.appendChild(value);
                else cellEl.innerHTML = value;
                styleProps = [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom",
                    "border-top",
                    "border-left",
                    "border-right",
                    "border-bottom",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size",
                    "text-align"
                ];
                if (column.isRowHeader) {
                    cellStyle = styles.styleRowHeader;
                    styleProps.push("background-color");
                } else cellStyle = styles.styleCells && styles.styleCells[index] ? styles.styleCells[index] : styles.firstCell;
                if (cellStyle) {
                    this.mapElementStyles(cellStyle, cellEl, styleProps);
                    if (column.definition.align) cellEl.style.textAlign = column.definition.align;
                }
                if (this.table.options.dataTree && this.config.dataTree !== false) {
                    if (setup.treeElementField && setup.treeElementField == column.field || !setup.treeElementField && i == 0) {
                        if (row.component._row.modules.dataTree.controlEl) cellEl.insertBefore(row.component._row.modules.dataTree.controlEl.cloneNode(true), cellEl.firstChild);
                        if (row.component._row.modules.dataTree.branchEl) cellEl.insertBefore(row.component._row.modules.dataTree.branchEl.cloneNode(true), cellEl.firstChild);
                    }
                }
                rowEl.appendChild(cellEl);
                if (cellWrapper.modules.format && cellWrapper.modules.format.renderedCallback) cellWrapper.modules.format.renderedCallback();
            }
        });
        if (setup.rowFormatter && row.type === "row" && this.config.formatCells !== false) {
            let formatComponent = Object.assign(row.component);
            formatComponent.getElement = function() {
                return rowEl;
            };
            setup.rowFormatter(row.component);
        }
        return rowEl;
    }
    generateHTMLTable(list) {
        var holder = document.createElement("div");
        holder.appendChild(this.generateTableElement(list));
        return holder.innerHTML;
    }
    getHtml(visible, style, config, colVisProp) {
        var list = this.generateExportList(config || this.table.options.htmlOutputConfig, style, visible, colVisProp || "htmlOutput");
        return this.generateHTMLTable(list);
    }
    mapElementStyles(from, to, props) {
        if (this.cloneTableStyle && from && to) {
            var lookup = {
                "background-color": "backgroundColor",
                "color": "fontColor",
                "width": "width",
                "font-weight": "fontWeight",
                "font-family": "fontFamily",
                "font-size": "fontSize",
                "text-align": "textAlign",
                "border-top": "borderTop",
                "border-left": "borderLeft",
                "border-right": "borderRight",
                "border-bottom": "borderBottom",
                "padding-top": "paddingTop",
                "padding-left": "paddingLeft",
                "padding-right": "paddingRight",
                "padding-bottom": "paddingBottom"
            };
            if (window.getComputedStyle) {
                var fromStyle = window.getComputedStyle(from);
                props.forEach(function(prop) {
                    if (!to.style[lookup[prop]]) to.style[lookup[prop]] = fromStyle.getPropertyValue(prop);
                });
            }
        }
    }
}
var $c2a9788f40f9c90a$var$defaultFilters = {
    //equal to
    "=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal == filterVal ? true : false;
    },
    //less than
    "<": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal < filterVal ? true : false;
    },
    //less than or equal to
    "<=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal <= filterVal ? true : false;
    },
    //greater than
    ">": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal > filterVal ? true : false;
    },
    //greater than or equal to
    ">=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal >= filterVal ? true : false;
    },
    //not equal to
    "!=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal != filterVal ? true : false;
    },
    "regex": function(filterVal, rowVal, rowData, filterParams) {
        if (typeof filterVal == "string") filterVal = new RegExp(filterVal);
        return filterVal.test(rowVal);
    },
    //contains the string
    "like": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
            else return false;
        }
    },
    //contains the keywords
    "keywords": function(filterVal, rowVal, rowData, filterParams) {
        var keywords = filterVal.toLowerCase().split(typeof filterParams.separator === "undefined" ? " " : filterParams.separator), value = String(rowVal === null || typeof rowVal === "undefined" ? "" : rowVal).toLowerCase(), matches = [];
        keywords.forEach((keyword)=>{
            if (value.includes(keyword)) matches.push(true);
        });
        return filterParams.matchAll ? matches.length === keywords.length : !!matches.length;
    },
    //starts with the string
    "starts": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().startsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //ends with the string
    "ends": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().endsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //in array
    "in": function(filterVal, rowVal, rowData, filterParams) {
        if (Array.isArray(filterVal)) return filterVal.length ? filterVal.indexOf(rowVal) > -1 : true;
        else {
            console.warn("Filter Error - filter value is not an array:", filterVal);
            return false;
        }
    }
};
class $c2a9788f40f9c90a$export$2e3bebbdf3339a4e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "filter";
    //load defaults
    static filters = $c2a9788f40f9c90a$var$defaultFilters;
    constructor(table){
        super(table);
        this.filterList = []; //hold filter list
        this.headerFilters = {}; //hold column filters
        this.headerFilterColumns = []; //hold columns that use header filters
        this.prevHeaderFilterChangeCheck = "";
        this.prevHeaderFilterChangeCheck = "{}";
        this.changed = false; //has filtering changed since last render
        this.tableInitialized = false;
        this.registerTableOption("filterMode", "local"); //local or remote filtering
        this.registerTableOption("initialFilter", false); //initial filtering criteria
        this.registerTableOption("initialHeaderFilter", false); //initial header filtering criteria
        this.registerTableOption("headerFilterLiveFilterDelay", 300); //delay before updating column after user types in header filter
        this.registerTableOption("placeholderHeaderFilter", false); //placeholder when header filter is empty
        this.registerColumnOption("headerFilter");
        this.registerColumnOption("headerFilterPlaceholder");
        this.registerColumnOption("headerFilterParams");
        this.registerColumnOption("headerFilterEmptyCheck");
        this.registerColumnOption("headerFilterFunc");
        this.registerColumnOption("headerFilterFuncParams");
        this.registerColumnOption("headerFilterLiveFilter");
        this.registerTableFunction("searchRows", this.searchRows.bind(this));
        this.registerTableFunction("searchData", this.searchData.bind(this));
        this.registerTableFunction("setFilter", this.userSetFilter.bind(this));
        this.registerTableFunction("refreshFilter", this.userRefreshFilter.bind(this));
        this.registerTableFunction("addFilter", this.userAddFilter.bind(this));
        this.registerTableFunction("getFilters", this.getFilters.bind(this));
        this.registerTableFunction("setHeaderFilterFocus", this.userSetHeaderFilterFocus.bind(this));
        this.registerTableFunction("getHeaderFilterValue", this.userGetHeaderFilterValue.bind(this));
        this.registerTableFunction("setHeaderFilterValue", this.userSetHeaderFilterValue.bind(this));
        this.registerTableFunction("getHeaderFilters", this.getHeaderFilters.bind(this));
        this.registerTableFunction("removeFilter", this.userRemoveFilter.bind(this));
        this.registerTableFunction("clearFilter", this.userClearFilter.bind(this));
        this.registerTableFunction("clearHeaderFilter", this.userClearHeaderFilter.bind(this));
        this.registerComponentFunction("column", "headerFilterFocus", this.setHeaderFilterFocus.bind(this));
        this.registerComponentFunction("column", "reloadHeaderFilter", this.reloadHeaderFilter.bind(this));
        this.registerComponentFunction("column", "getHeaderFilterValue", this.getHeaderFilterValue.bind(this));
        this.registerComponentFunction("column", "setHeaderFilterValue", this.setHeaderFilterValue.bind(this));
    }
    initialize() {
        this.subscribe("column-init", this.initializeColumnHeaderFilter.bind(this));
        this.subscribe("column-width-fit-before", this.hideHeaderFilterElements.bind(this));
        this.subscribe("column-width-fit-after", this.showHeaderFilterElements.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.subscribe("placeholder", this.generatePlaceholder.bind(this));
        if (this.table.options.filterMode === "remote") this.subscribe("data-params", this.remoteFilterParams.bind(this));
        this.registerDataHandler(this.filter.bind(this), 10);
    }
    tableBuilt() {
        if (this.table.options.initialFilter) this.setFilter(this.table.options.initialFilter);
        if (this.table.options.initialHeaderFilter) this.table.options.initialHeaderFilter.forEach((item)=>{
            var column = this.table.columnManager.findColumn(item.field);
            if (column) this.setHeaderFilterValue(column, item.value);
            else {
                console.warn("Column Filter Error - No matching column found:", item.field);
                return false;
            }
        });
        this.tableInitialized = true;
    }
    remoteFilterParams(data, config, silent, params) {
        params.filter = this.getFilters(true, true);
        return params;
    }
    generatePlaceholder(text) {
        if (this.table.options.placeholderHeaderFilter && Object.keys(this.headerFilters).length) return this.table.options.placeholderHeaderFilter;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    //set standard filters
    userSetFilter(field, type, value, params) {
        this.setFilter(field, type, value, params);
        this.refreshFilter();
    }
    //set standard filters
    userRefreshFilter() {
        this.refreshFilter();
    }
    //add filter to array
    userAddFilter(field, type, value, params) {
        this.addFilter(field, type, value, params);
        this.refreshFilter();
    }
    userSetHeaderFilterFocus(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterFocus(column);
        else {
            console.warn("Column Filter Focus Error - No matching column found:", field);
            return false;
        }
    }
    userGetHeaderFilterValue(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) return this.getHeaderFilterValue(column);
        else console.warn("Column Filter Error - No matching column found:", field);
    }
    userSetHeaderFilterValue(field, value) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterValue(column, value);
        else {
            console.warn("Column Filter Error - No matching column found:", field);
            return false;
        }
    }
    //remove filter from array
    userRemoveFilter(field, type, value) {
        this.removeFilter(field, type, value);
        this.refreshFilter();
    }
    //clear filters
    userClearFilter(all) {
        this.clearFilter(all);
        this.refreshFilter();
    }
    //clear header filters
    userClearHeaderFilter() {
        this.clearHeaderFilter();
        this.refreshFilter();
    }
    //search for specific row components
    searchRows(field, type, value) {
        return this.search("rows", field, type, value);
    }
    //search for specific data
    searchData(field, type, value) {
        return this.search("data", field, type, value);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnHeaderFilter(column) {
        var def = column.definition;
        if (def.headerFilter) this.initializeColumn(column);
    }
    //initialize column header filter
    initializeColumn(column, value) {
        var self = this, field = column.getField();
        //handle successfully value change
        function success(value) {
            var filterType = column.modules.filter.tagType == "input" && column.modules.filter.attrType == "text" || column.modules.filter.tagType == "textarea" ? "partial" : "match", type = "", filterChangeCheck = "", filterFunc;
            if (typeof column.modules.filter.prevSuccess === "undefined" || column.modules.filter.prevSuccess !== value) {
                column.modules.filter.prevSuccess = value;
                if (!column.modules.filter.emptyFunc(value)) {
                    column.modules.filter.value = value;
                    switch(typeof column.definition.headerFilterFunc){
                        case "string":
                            if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc]) {
                                type = column.definition.headerFilterFunc;
                                filterFunc = function(data) {
                                    var params = column.definition.headerFilterFuncParams || {};
                                    var fieldVal = column.getFieldValue(data);
                                    params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                    return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc](value, fieldVal, data, params);
                                };
                            } else console.warn("Header Filter Error - Matching filter function not found: ", column.definition.headerFilterFunc);
                            break;
                        case "function":
                            filterFunc = function(data) {
                                var params = column.definition.headerFilterFuncParams || {};
                                var fieldVal = column.getFieldValue(data);
                                params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                return column.definition.headerFilterFunc(value, fieldVal, data, params);
                            };
                            type = filterFunc;
                            break;
                    }
                    if (!filterFunc) switch(filterType){
                        case "partial":
                            filterFunc = function(data) {
                                var colVal = column.getFieldValue(data);
                                if (typeof colVal !== "undefined" && colVal !== null) return String(colVal).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
                                else return false;
                            };
                            type = "like";
                            break;
                        default:
                            filterFunc = function(data) {
                                return column.getFieldValue(data) == value;
                            };
                            type = "=";
                    }
                    self.headerFilters[field] = {
                        value: value,
                        func: filterFunc,
                        type: type
                    };
                } else delete self.headerFilters[field];
                column.modules.filter.value = value;
                filterChangeCheck = JSON.stringify(self.headerFilters);
                if (self.prevHeaderFilterChangeCheck !== filterChangeCheck) {
                    self.prevHeaderFilterChangeCheck = filterChangeCheck;
                    self.trackChanges();
                    self.refreshFilter();
                }
            }
            return true;
        }
        column.modules.filter = {
            success: success,
            attrType: false,
            tagType: false,
            emptyFunc: false
        };
        this.generateHeaderFilterElement(column);
    }
    generateHeaderFilterElement(column, initialValue, reinitialize) {
        var self = this, success = column.modules.filter.success, field = column.getField(), filterElement, editor, editorElement, cellWrapper, typingTimer, searchTrigger, params, onRenderedCallback;
        column.modules.filter.value = initialValue;
        //handle aborted edit
        function cancel() {}
        function onRendered(callback) {
            onRenderedCallback = callback;
        }
        if (column.modules.filter.headerElement && column.modules.filter.headerElement.parentNode) column.contentElement.removeChild(column.modules.filter.headerElement.parentNode);
        if (field) {
            //set empty value function
            column.modules.filter.emptyFunc = column.definition.headerFilterEmptyCheck || function(value) {
                return !value && value !== 0;
            };
            filterElement = document.createElement("div");
            filterElement.classList.add("tabulator-header-filter");
            //set column editor
            switch(typeof column.definition.headerFilter){
                case "string":
                    if (self.table.modules.edit.editors[column.definition.headerFilter]) {
                        editor = self.table.modules.edit.editors[column.definition.headerFilter];
                        if ((column.definition.headerFilter === "tick" || column.definition.headerFilter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else console.warn("Filter Error - Cannot build header filter, No such editor found: ", column.definition.editor);
                    break;
                case "function":
                    editor = column.definition.headerFilter;
                    break;
                case "boolean":
                    if (column.modules.edit && column.modules.edit.editor) editor = column.modules.edit.editor;
                    else if (column.definition.formatter && self.table.modules.edit.editors[column.definition.formatter]) {
                        editor = self.table.modules.edit.editors[column.definition.formatter];
                        if ((column.definition.formatter === "tick" || column.definition.formatter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else editor = self.table.modules.edit.editors["input"];
                    break;
            }
            if (editor) {
                cellWrapper = {
                    getValue: function() {
                        return typeof initialValue !== "undefined" ? initialValue : "";
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return filterElement;
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getTable: ()=>{
                        return this.table;
                    },
                    getType: ()=>{
                        return "header";
                    },
                    getRow: function() {
                        return {
                            normalizeHeight: function() {}
                        };
                    }
                };
                params = column.definition.headerFilterParams || {};
                params = typeof params === "function" ? params.call(self.table, cellWrapper) : params;
                editorElement = editor.call(this.table.modules.edit, cellWrapper, onRendered, success, cancel, params);
                if (!editorElement) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor returned a value of false");
                    return;
                }
                if (!(editorElement instanceof Node)) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor should return an instance of Node, the editor returned:", editorElement);
                    return;
                }
                //set Placeholder Text
                self.langBind("headerFilters|columns|" + column.definition.field, function(value) {
                    editorElement.setAttribute("placeholder", typeof value !== "undefined" && value ? value : column.definition.headerFilterPlaceholder || self.langText("headerFilters|default"));
                });
                //focus on element on click
                editorElement.addEventListener("click", function(e) {
                    e.stopPropagation();
                    editorElement.focus();
                });
                editorElement.addEventListener("focus", (e)=>{
                    var left = this.table.columnManager.contentsElement.scrollLeft;
                    var headerPos = this.table.rowManager.element.scrollLeft;
                    if (left !== headerPos) {
                        this.table.rowManager.scrollHorizontal(left);
                        this.table.columnManager.scrollHorizontal(left);
                    }
                });
                //live update filters as user types
                typingTimer = false;
                searchTrigger = function(e) {
                    if (typingTimer) clearTimeout(typingTimer);
                    typingTimer = setTimeout(function() {
                        success(editorElement.value);
                    }, self.table.options.headerFilterLiveFilterDelay);
                };
                column.modules.filter.headerElement = editorElement;
                column.modules.filter.attrType = editorElement.hasAttribute("type") ? editorElement.getAttribute("type").toLowerCase() : "";
                column.modules.filter.tagType = editorElement.tagName.toLowerCase();
                if (column.definition.headerFilterLiveFilter !== false) {
                    if (!(column.definition.headerFilter === "autocomplete" || column.definition.headerFilter === "tickCross" || (column.definition.editor === "autocomplete" || column.definition.editor === "tickCross") && column.definition.headerFilter === true)) {
                        editorElement.addEventListener("keyup", searchTrigger);
                        editorElement.addEventListener("search", searchTrigger);
                        //update number filtered columns on change
                        if (column.modules.filter.attrType == "number") editorElement.addEventListener("change", function(e) {
                            success(editorElement.value);
                        });
                        //change text inputs to search inputs to allow for clearing of field
                        if (column.modules.filter.attrType == "text" && this.table.browser !== "ie") editorElement.setAttribute("type", "search");
                    }
                    //prevent input and select elements from propagating click to column sorters etc
                    if (column.modules.filter.tagType == "input" || column.modules.filter.tagType == "select" || column.modules.filter.tagType == "textarea") editorElement.addEventListener("mousedown", function(e) {
                        e.stopPropagation();
                    });
                }
                filterElement.appendChild(editorElement);
                column.contentElement.appendChild(filterElement);
                if (!reinitialize) self.headerFilterColumns.push(column);
                if (onRenderedCallback) onRenderedCallback();
            }
        } else console.warn("Filter Error - Cannot add header filter, column has no field set:", column.definition.title);
    }
    //hide all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    hideHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = "none";
        });
    }
    //show all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    showHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = "";
        });
    }
    //programmatically set focus of header filter
    setHeaderFilterFocus(column) {
        if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.focus();
        else console.warn("Column Filter Focus Error - No header filter set on column:", column.getField());
    }
    //programmatically get value of header filter
    getHeaderFilterValue(column) {
        if (column.modules.filter && column.modules.filter.headerElement) return column.modules.filter.value;
        else console.warn("Column Filter Error - No header filter set on column:", column.getField());
    }
    //programmatically set value of header filter
    setHeaderFilterValue(column, value) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) {
                this.generateHeaderFilterElement(column, value, true);
                column.modules.filter.success(value);
            } else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    reloadHeaderFilter(column) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) this.generateHeaderFilterElement(column, column.modules.filter.value, true);
            else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    refreshFilter() {
        if (this.tableInitialized) {
            if (this.table.options.filterMode === "remote") this.reloadData(null, false, false);
            else this.refreshData(true);
        }
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the filters has changed since last use
    trackChanges() {
        this.changed = true;
        this.dispatch("filter-changed");
    }
    //check if the filters has changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //set standard filters
    setFilter(field, type, value, params) {
        this.filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        this.addFilter(field);
    }
    //add filter to array
    addFilter(field, type, value, params) {
        var changed = false;
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) {
                this.filterList.push(filter);
                changed = true;
            }
        });
        if (changed) this.trackChanges();
    }
    findFilter(filter) {
        var column;
        if (Array.isArray(filter)) return this.findSubFilters(filter);
        var filterFunc = false;
        if (typeof filter.field == "function") filterFunc = function(data) {
            return filter.field(data, filter.type || {}); // pass params to custom filter function
        };
        else if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type]) {
            column = this.table.columnManager.getColumnByField(filter.field);
            if (column) filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, column.getFieldValue(data), data, filter.params || {});
            };
            else filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, data[filter.field], data, filter.params || {});
            };
        } else console.warn("Filter Error - No such filter type found, ignoring: ", filter.type);
        filter.func = filterFunc;
        return filter.func ? filter : false;
    }
    findSubFilters(filters) {
        var output = [];
        filters.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) output.push(filter);
        });
        return output.length ? output : false;
    }
    //get all filters
    getFilters(all, ajax) {
        var output = [];
        if (all) output = this.getHeaderFilters();
        if (ajax) output.forEach(function(item) {
            if (typeof item.type == "function") item.type = "function";
        });
        output = output.concat(this.filtersToArray(this.filterList, ajax));
        return output;
    }
    //filter to Object
    filtersToArray(filterList, ajax) {
        var output = [];
        filterList.forEach((filter)=>{
            var item;
            if (Array.isArray(filter)) output.push(this.filtersToArray(filter, ajax));
            else {
                item = {
                    field: filter.field,
                    type: filter.type,
                    value: filter.value
                };
                if (ajax) {
                    if (typeof item.type == "function") item.type = "function";
                }
                output.push(item);
            }
        });
        return output;
    }
    //get all filters
    getHeaderFilters() {
        var output = [];
        for(var key in this.headerFilters)output.push({
            field: key,
            type: this.headerFilters[key].type,
            value: this.headerFilters[key].value
        });
        return output;
    }
    //remove filter from array
    removeFilter(field, type, value) {
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            var index = -1;
            if (typeof filter.field == "object") index = this.filterList.findIndex((element)=>{
                return filter === element;
            });
            else index = this.filterList.findIndex((element)=>{
                return filter.field === element.field && filter.type === element.type && filter.value === element.value;
            });
            if (index > -1) this.filterList.splice(index, 1);
            else console.warn("Filter Error - No matching filter type found, ignoring: ", filter.type);
        });
        this.trackChanges();
    }
    //clear filters
    clearFilter(all) {
        this.filterList = [];
        if (all) this.clearHeaderFilter();
        this.trackChanges();
    }
    //clear header filters
    clearHeaderFilter() {
        this.headerFilters = {};
        this.prevHeaderFilterChangeCheck = "{}";
        this.headerFilterColumns.forEach((column)=>{
            if (typeof column.modules.filter.value !== "undefined") delete column.modules.filter.value;
            column.modules.filter.prevSuccess = undefined;
            this.reloadHeaderFilter(column);
        });
        this.trackChanges();
    }
    //search data and return matching rows
    search(searchType, field, type, value) {
        var activeRows = [], filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) filterList.push(filter);
        });
        this.table.rowManager.rows.forEach((row)=>{
            var match = true;
            filterList.forEach((filter)=>{
                if (!this.filterRecurse(filter, row.getData())) match = false;
            });
            if (match) activeRows.push(searchType === "data" ? row.getData("data") : row.getComponent());
        });
        return activeRows;
    }
    //filter row array
    filter(rowList, filters) {
        var activeRows = [], activeRowComponents = [];
        if (this.subscribedExternal("dataFiltering")) this.dispatchExternal("dataFiltering", this.getFilters(true));
        if (this.table.options.filterMode !== "remote" && (this.filterList.length || Object.keys(this.headerFilters).length)) rowList.forEach((row)=>{
            if (this.filterRow(row)) activeRows.push(row);
        });
        else activeRows = rowList.slice(0);
        if (this.subscribedExternal("dataFiltered")) {
            activeRows.forEach((row)=>{
                activeRowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataFiltered", this.getFilters(true), activeRowComponents);
        }
        return activeRows;
    }
    //filter individual row
    filterRow(row, filters) {
        var match = true, data = row.getData();
        this.filterList.forEach((filter)=>{
            if (!this.filterRecurse(filter, data)) match = false;
        });
        for(var field in this.headerFilters)if (!this.headerFilters[field].func(data)) match = false;
        return match;
    }
    filterRecurse(filter, data) {
        var match = false;
        if (Array.isArray(filter)) filter.forEach((subFilter)=>{
            if (this.filterRecurse(subFilter, data)) match = true;
        });
        else match = filter.func(data);
        return match;
    }
}
function $c2a9788f40f9c90a$var$plaintext(cell, formatterParams, onRendered) {
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$html(cell, formatterParams, onRendered) {
    return cell.getValue();
}
function $c2a9788f40f9c90a$var$textarea(cell, formatterParams, onRendered) {
    cell.getElement().style.whiteSpace = "pre-wrap";
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$money(cell, formatterParams, onRendered) {
    var floatVal = parseFloat(cell.getValue()), sign = "", number, integer, decimal, rgx, value;
    var decimalSym = formatterParams.decimal || ".";
    var thousandSym = formatterParams.thousand || ",";
    var negativeSign = formatterParams.negativeSign || "-";
    var symbol = formatterParams.symbol || "";
    var after = !!formatterParams.symbolAfter;
    var precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;
    if (isNaN(floatVal)) return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
    if (floatVal < 0) {
        floatVal = Math.abs(floatVal);
        sign = negativeSign;
    }
    number = precision !== false ? floatVal.toFixed(precision) : floatVal;
    number = String(number).split(".");
    integer = number[0];
    decimal = number.length > 1 ? decimalSym + number[1] : "";
    if (formatterParams.thousand !== false) {
        rgx = /(\d+)(\d{3})/;
        while(rgx.test(integer))integer = integer.replace(rgx, "$1" + thousandSym + "$2");
    }
    value = integer + decimal;
    if (sign === true) {
        value = "(" + value + ")";
        return after ? value + symbol : symbol + value;
    } else return after ? sign + value + symbol : sign + symbol + value;
}
function $c2a9788f40f9c90a$var$link(cell, formatterParams, onRendered) {
    var value = cell.getValue(), urlPrefix = formatterParams.urlPrefix || "", download = formatterParams.download, label = value, el = document.createElement("a"), data;
    function labelTraverse(path, data) {
        var item = path.shift(), value = data[item];
        if (path.length && typeof value === "object") return labelTraverse(path, value);
        return value;
    }
    if (formatterParams.labelField) {
        data = cell.getData();
        label = labelTraverse(formatterParams.labelField.split(this.table.options.nestedFieldSeparator), data);
    }
    if (formatterParams.label) switch(typeof formatterParams.label){
        case "string":
            label = formatterParams.label;
            break;
        case "function":
            label = formatterParams.label(cell);
            break;
    }
    if (label) {
        if (formatterParams.urlField) {
            data = cell.getData();
            value = $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(this.table.options.nestedFieldSeparator, formatterParams.urlField, data);
        }
        if (formatterParams.url) switch(typeof formatterParams.url){
            case "string":
                value = formatterParams.url;
                break;
            case "function":
                value = formatterParams.url(cell);
                break;
        }
        el.setAttribute("href", urlPrefix + value);
        if (formatterParams.target) el.setAttribute("target", formatterParams.target);
        if (formatterParams.download) {
            if (typeof download == "function") download = download(cell);
            else download = download === true ? "" : download;
            el.setAttribute("download", download);
        }
        el.innerHTML = this.emptyToSpace(this.sanitizeHTML(label));
        return el;
    } else return "&nbsp;";
}
function $c2a9788f40f9c90a$var$image(cell, formatterParams, onRendered) {
    var el = document.createElement("img"), src = cell.getValue();
    if (formatterParams.urlPrefix) src = formatterParams.urlPrefix + cell.getValue();
    if (formatterParams.urlSuffix) src = src + formatterParams.urlSuffix;
    el.setAttribute("src", src);
    switch(typeof formatterParams.height){
        case "number":
            el.style.height = formatterParams.height + "px";
            break;
        case "string":
            el.style.height = formatterParams.height;
            break;
    }
    switch(typeof formatterParams.width){
        case "number":
            el.style.width = formatterParams.width + "px";
            break;
        case "string":
            el.style.width = formatterParams.width;
            break;
    }
    el.addEventListener("load", function() {
        cell.getRow().normalizeHeight();
    });
    return el;
}
function $c2a9788f40f9c90a$var$tickCross(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), empty = formatterParams.allowEmpty, truthy = formatterParams.allowTruthy, trueValueSet = Object.keys(formatterParams).includes("trueValue"), tick = typeof formatterParams.tickElement !== "undefined" ? formatterParams.tickElement : '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>', cross = typeof formatterParams.crossElement !== "undefined" ? formatterParams.crossElement : '<svg enable-background="new 0 0 24 24" height="14" width="14"  viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
    if (trueValueSet && value === formatterParams.trueValue || !trueValueSet && (truthy && value || value === true || value === "true" || value === "True" || value === 1 || value === "1")) {
        element.setAttribute("aria-checked", true);
        return tick || "";
    } else if (empty && (value === "null" || value === "" || value === null || typeof value === "undefined")) {
        element.setAttribute("aria-checked", "mixed");
        return "";
    } else {
        element.setAttribute("aria-checked", false);
        return cross || "";
    }
}
function $c2a9788f40f9c90a$var$datetime$1(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var outputFormat = formatterParams.outputFormat || "dd/MM/yyyy HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (formatterParams.timezone) newDatetime = newDatetime.setZone(formatterParams.timezone);
            return newDatetime.toFormat(outputFormat);
        } else {
            if (invalid === true || !value) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetime' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$datetimediff(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var suffix = typeof formatterParams.suffix !== "undefined" ? formatterParams.suffix : false;
    var unit = typeof formatterParams.unit !== "undefined" ? formatterParams.unit : "days";
    var humanize = typeof formatterParams.humanize !== "undefined" ? formatterParams.humanize : false;
    var date = typeof formatterParams.date !== "undefined" ? formatterParams.date : DT.now();
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (humanize) return newDatetime.diff(date, unit).toHuman() + (suffix ? " " + suffix : "");
            else return parseInt(newDatetime.diff(date, unit)[unit]) + (suffix ? " " + suffix : "");
        } else {
            if (invalid === true) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetimediff' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$lookup(cell, formatterParams, onRendered) {
    var value = cell.getValue();
    if (typeof formatterParams[value] === "undefined") {
        console.warn("Missing display value for " + value);
        return value;
    }
    return formatterParams[value];
}
function $c2a9788f40f9c90a$var$star(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), maxStars = formatterParams && formatterParams.stars ? formatterParams.stars : 5, stars = document.createElement("span"), star = document.createElementNS("http://www.w3.org/2000/svg", "svg"), starActive = '<polygon fill="#FFEA00" stroke="#C1AB60" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>', starInactive = '<polygon fill="#D2D2D2" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
    //style stars holder
    stars.style.verticalAlign = "middle";
    //style star
    star.setAttribute("width", "14");
    star.setAttribute("height", "14");
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    value = value && !isNaN(value) ? parseInt(value) : 0;
    value = Math.max(0, Math.min(value, maxStars));
    for(var i = 1; i <= maxStars; i++){
        var nextStar = star.cloneNode(true);
        nextStar.innerHTML = i <= value ? starActive : starInactive;
        stars.appendChild(nextStar);
    }
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    element.setAttribute("aria-label", value);
    return stars;
}
function $c2a9788f40f9c90a$var$traffic(cell, formatterParams, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, el = document.createElement("span"), max = formatterParams && formatterParams.max ? formatterParams.max : 100, min = formatterParams && formatterParams.min ? formatterParams.min : 0, colors = formatterParams && typeof formatterParams.color !== "undefined" ? formatterParams.color : [
        "red",
        "orange",
        "green"
    ], color = "#666666", percent, percentValue;
    if (isNaN(value) || typeof cell.getValue() === "undefined") return;
    el.classList.add("tabulator-traffic-light");
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set color
    switch(typeof colors){
        case "string":
            color = colors;
            break;
        case "function":
            color = colors(value);
            break;
        case "object":
            if (Array.isArray(colors)) {
                var unit = 100 / colors.length;
                var index = Math.floor(percentValue / unit);
                index = Math.min(index, colors.length - 1);
                index = Math.max(index, 0);
                color = colors[index];
                break;
            }
    }
    el.style.backgroundColor = color;
    return el;
}
function $c2a9788f40f9c90a$var$progress(cell, formatterParams = {}, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, element = cell.getElement(), max = formatterParams.max ? formatterParams.max : 100, min = formatterParams.min ? formatterParams.min : 0, legendAlign = formatterParams.legendAlign ? formatterParams.legendAlign : "center", percent, percentValue, color, legend, legendColor;
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set bar color
    switch(typeof formatterParams.color){
        case "string":
            color = formatterParams.color;
            break;
        case "function":
            color = formatterParams.color(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.color)) {
                let unit = 100 / formatterParams.color.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.color.length - 1);
                index = Math.max(index, 0);
                color = formatterParams.color[index];
                break;
            }
        default:
            color = "#2DC214";
    }
    //generate legend
    switch(typeof formatterParams.legend){
        case "string":
            legend = formatterParams.legend;
            break;
        case "function":
            legend = formatterParams.legend(value);
            break;
        case "boolean":
            legend = value;
            break;
        default:
            legend = false;
    }
    //set legend color
    switch(typeof formatterParams.legendColor){
        case "string":
            legendColor = formatterParams.legendColor;
            break;
        case "function":
            legendColor = formatterParams.legendColor(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.legendColor)) {
                let unit = 100 / formatterParams.legendColor.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.legendColor.length - 1);
                index = Math.max(index, 0);
                legendColor = formatterParams.legendColor[index];
            }
            break;
        default:
            legendColor = "#000";
    }
    element.style.minWidth = "30px";
    element.style.position = "relative";
    element.setAttribute("aria-label", percentValue);
    var barEl = document.createElement("div");
    barEl.style.display = "inline-block";
    barEl.style.width = percentValue + "%";
    barEl.style.backgroundColor = color;
    barEl.style.height = "100%";
    barEl.setAttribute("data-max", max);
    barEl.setAttribute("data-min", min);
    var barContainer = document.createElement("div");
    barContainer.style.position = "relative";
    barContainer.style.width = "100%";
    barContainer.style.height = "100%";
    if (legend) {
        var legendEl = document.createElement("div");
        legendEl.style.position = "absolute";
        legendEl.style.top = 0;
        legendEl.style.left = 0;
        legendEl.style.textAlign = legendAlign;
        legendEl.style.width = "100%";
        legendEl.style.color = legendColor;
        legendEl.innerHTML = legend;
    }
    onRendered(function() {
        //handle custom element needed if formatter is to be included in printed/downloaded output
        if (!(cell instanceof $c2a9788f40f9c90a$export$1919f52c249c72c9)) {
            var holderEl = document.createElement("div");
            holderEl.style.position = "absolute";
            holderEl.style.top = "4px";
            holderEl.style.bottom = "4px";
            holderEl.style.left = "4px";
            holderEl.style.right = "4px";
            element.appendChild(holderEl);
            element = holderEl;
        }
        element.appendChild(barContainer);
        barContainer.appendChild(barEl);
        if (legend) barContainer.appendChild(legendEl);
    });
    return "";
}
function $c2a9788f40f9c90a$var$color(cell, formatterParams, onRendered) {
    cell.getElement().style.backgroundColor = this.sanitizeHTML(cell.getValue());
    return "";
}
function $c2a9788f40f9c90a$var$buttonTick(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>';
}
function $c2a9788f40f9c90a$var$buttonCross(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
}
function $c2a9788f40f9c90a$var$toggle(cell, formatterParams, onRendered) {
    var value = cell.getValue(), size = formatterParams.size || 15, sizePx = size + "px", containEl, switchEl, onValue = formatterParams.hasOwnProperty("onValue") ? formatterParams.onValue : true, offValue = formatterParams.hasOwnProperty("offValue") ? formatterParams.offValue : false, state = formatterParams.onTruthy ? value : value === onValue;
    containEl = document.createElement("div");
    containEl.classList.add("tabulator-toggle");
    if (state) {
        containEl.classList.add("tabulator-toggle-on");
        containEl.style.flexDirection = "row-reverse";
        if (formatterParams.onColor) containEl.style.background = formatterParams.onColor;
    } else if (formatterParams.offColor) containEl.style.background = formatterParams.offColor;
    containEl.style.width = 2.5 * size + "px";
    containEl.style.borderRadius = sizePx;
    if (formatterParams.clickable) containEl.addEventListener("click", (e)=>{
        cell.setValue(state ? offValue : onValue);
    });
    switchEl = document.createElement("div");
    switchEl.classList.add("tabulator-toggle-switch");
    switchEl.style.height = sizePx;
    switchEl.style.width = sizePx;
    switchEl.style.borderRadius = sizePx;
    containEl.appendChild(switchEl);
    return containEl;
}
function $c2a9788f40f9c90a$var$rownum(cell, formatterParams, onRendered) {
    var content = document.createElement("span");
    var row = cell.getRow();
    var table = cell.getTable();
    row.watchPosition((position)=>{
        if (formatterParams.relativeToPage) position += table.modules.page.getPageSize() * (table.modules.page.getPage() - 1);
        content.innerText = position;
    });
    return content;
}
function $c2a9788f40f9c90a$var$handle(cell, formatterParams, onRendered) {
    cell.getElement().classList.add("tabulator-row-handle");
    return "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
}
function $c2a9788f40f9c90a$var$adaptable(cell, params, onRendered) {
    var lookup, formatterFunc, formatterParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), formatter = "plaintext";
        switch(typeof value){
            case "boolean":
                formatter = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) formatter = "textarea";
                break;
        }
        return formatter;
    }
    lookup = params.formatterLookup ? params.formatterLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) formatterParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    formatterFunc = this.table.modules.format.lookupFormatter(lookup);
    return formatterFunc.call(this, cell, formatterParams || {}, onRendered);
}
function $c2a9788f40f9c90a$var$array$2(cell, formatterParams, onRendered) {
    var delimiter = formatterParams.delimiter || ",", value = cell.getValue(), table = this.table, valueMap;
    if (formatterParams.valueMap) {
        if (typeof formatterParams.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, formatterParams.valueMap, item);
            });
        };
        else valueMap = formatterParams.valueMap;
    }
    if (Array.isArray(value)) {
        if (valueMap) value = valueMap(value);
        return value.join(delimiter);
    } else return value;
}
function $c2a9788f40f9c90a$var$json$1(cell, formatterParams, onRendered) {
    var indent = formatterParams.indent || "	", multiline = typeof formatterParams.multiline === "undefined" ? true : formatterParams.multiline, replacer = formatterParams.replacer || null, value = cell.getValue();
    if (multiline) cell.getElement().style.whiteSpace = "pre-wrap";
    return JSON.stringify(value, replacer, indent);
}
var $c2a9788f40f9c90a$var$defaultFormatters = {
    plaintext: $c2a9788f40f9c90a$var$plaintext,
    html: $c2a9788f40f9c90a$var$html,
    textarea: $c2a9788f40f9c90a$var$textarea,
    money: $c2a9788f40f9c90a$var$money,
    link: $c2a9788f40f9c90a$var$link,
    image: $c2a9788f40f9c90a$var$image,
    tickCross: $c2a9788f40f9c90a$var$tickCross,
    datetime: $c2a9788f40f9c90a$var$datetime$1,
    datetimediff: $c2a9788f40f9c90a$var$datetimediff,
    lookup: $c2a9788f40f9c90a$var$lookup,
    star: $c2a9788f40f9c90a$var$star,
    traffic: $c2a9788f40f9c90a$var$traffic,
    progress: $c2a9788f40f9c90a$var$progress,
    color: $c2a9788f40f9c90a$var$color,
    buttonTick: $c2a9788f40f9c90a$var$buttonTick,
    buttonCross: $c2a9788f40f9c90a$var$buttonCross,
    toggle: $c2a9788f40f9c90a$var$toggle,
    rownum: $c2a9788f40f9c90a$var$rownum,
    handle: $c2a9788f40f9c90a$var$handle,
    adaptable: $c2a9788f40f9c90a$var$adaptable,
    array: $c2a9788f40f9c90a$var$array$2,
    json: $c2a9788f40f9c90a$var$json$1
};
class $c2a9788f40f9c90a$export$5634f967e02d772d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "format";
    //load defaults
    static formatters = $c2a9788f40f9c90a$var$defaultFormatters;
    constructor(table){
        super(table);
        this.registerColumnOption("formatter");
        this.registerColumnOption("formatterParams");
        this.registerColumnOption("formatterPrint");
        this.registerColumnOption("formatterPrintParams");
        this.registerColumnOption("formatterClipboard");
        this.registerColumnOption("formatterClipboardParams");
        this.registerColumnOption("formatterHtmlOutput");
        this.registerColumnOption("formatterHtmlOutputParams");
        this.registerColumnOption("titleFormatter");
        this.registerColumnOption("titleFormatterParams");
    }
    initialize() {
        this.subscribe("cell-format", this.formatValue.bind(this));
        this.subscribe("cell-rendered", this.cellRendered.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("column-format", this.formatHeader.bind(this));
    }
    //initialize column formatter
    initializeColumn(column) {
        column.modules.format = this.lookupTypeFormatter(column, "");
        if (typeof column.definition.formatterPrint !== "undefined") column.modules.format.print = this.lookupTypeFormatter(column, "Print");
        if (typeof column.definition.formatterClipboard !== "undefined") column.modules.format.clipboard = this.lookupTypeFormatter(column, "Clipboard");
        if (typeof column.definition.formatterHtmlOutput !== "undefined") column.modules.format.htmlOutput = this.lookupTypeFormatter(column, "HtmlOutput");
    }
    lookupTypeFormatter(column, type) {
        var config = {
            params: column.definition["formatter" + type + "Params"] || {}
        }, formatter = column.definition["formatter" + type];
        config.formatter = this.lookupFormatter(formatter);
        return config;
    }
    lookupFormatter(formatter) {
        var formatterFunc;
        //set column formatter
        switch(typeof formatter){
            case "string":
                if ($c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter]) formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter];
                else {
                    console.warn("Formatter Error - No such formatter found: ", formatter);
                    formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                }
                break;
            case "function":
                formatterFunc = formatter;
                break;
            default:
                formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                break;
        }
        return formatterFunc;
    }
    cellRendered(cell) {
        if (cell.modules.format && cell.modules.format.renderedCallback && !cell.modules.format.rendered) {
            cell.modules.format.renderedCallback();
            cell.modules.format.rendered = true;
        }
    }
    //return a formatted value for a column header
    formatHeader(column, title, el) {
        var formatter, params, onRendered, mockCell;
        if (column.definition.titleFormatter) {
            formatter = this.lookupFormatter(column.definition.titleFormatter);
            onRendered = (callback)=>{
                column.titleFormatterRendered = callback;
            };
            mockCell = {
                getValue: function() {
                    return title;
                },
                getElement: function() {
                    return el;
                },
                getType: function() {
                    return "header";
                },
                getColumn: function() {
                    return column.getComponent();
                },
                getTable: ()=>{
                    return this.table;
                }
            };
            params = column.definition.titleFormatterParams || {};
            params = typeof params === "function" ? params() : params;
            return formatter.call(this, mockCell, params, onRendered);
        } else return title;
    }
    //return a formatted value for a cell
    formatValue(cell) {
        var component = cell.getComponent(), params = typeof cell.column.modules.format.params === "function" ? cell.column.modules.format.params(component) : cell.column.modules.format.params;
        function onRendered(callback) {
            if (!cell.modules.format) cell.modules.format = {};
            cell.modules.format.renderedCallback = callback;
            cell.modules.format.rendered = false;
        }
        return cell.column.modules.format.formatter.call(this, component, params, onRendered);
    }
    formatExportValue(cell, type) {
        var formatter = cell.column.modules.format[type], params;
        if (formatter) {
            params = typeof formatter.params === "function" ? formatter.params(cell.getComponent()) : formatter.params;
            function onRendered(callback) {
                if (!cell.modules.format) cell.modules.format = {};
                cell.modules.format.renderedCallback = callback;
                cell.modules.format.rendered = false;
            }
            return formatter.formatter.call(this, cell.getComponent(), params, onRendered);
        } else return this.formatValue(cell);
    }
    sanitizeHTML(value) {
        if (value) {
            var entityMap = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
                "/": "&#x2F;",
                "`": "&#x60;",
                "=": "&#x3D;"
            };
            return String(value).replace(/[&<>"'`=/]/g, function(s) {
                return entityMap[s];
            });
        } else return value;
    }
    emptyToSpace(value) {
        return value === null || typeof value === "undefined" || value === "" ? "&nbsp;" : value;
    }
}
class $c2a9788f40f9c90a$export$c00c4e95a253fbf9 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenColumns";
    constructor(table){
        super(table);
        this.leftColumns = [];
        this.rightColumns = [];
        this.initializationMode = "left";
        this.active = false;
        this.blocked = true;
        this.registerColumnOption("frozen");
    }
    //reset initial state
    reset() {
        this.initializationMode = "left";
        this.leftColumns = [];
        this.rightColumns = [];
        this.active = false;
    }
    initialize() {
        this.subscribe("cell-layout", this.layoutCell.bind(this));
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-width", this.layout.bind(this));
        this.subscribe("row-layout-after", this.layoutRow.bind(this));
        this.subscribe("table-layout", this.layout.bind(this));
        this.subscribe("columns-loading", this.reset.bind(this));
        this.subscribe("column-add", this.reinitializeColumns.bind(this));
        this.subscribe("column-deleted", this.reinitializeColumns.bind(this));
        this.subscribe("column-hide", this.reinitializeColumns.bind(this));
        this.subscribe("column-show", this.reinitializeColumns.bind(this));
        this.subscribe("columns-loaded", this.reinitializeColumns.bind(this));
        this.subscribe("table-redraw", this.layout.bind(this));
        this.subscribe("layout-refreshing", this.blockLayout.bind(this));
        this.subscribe("layout-refreshed", this.unblockLayout.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
    }
    blockLayout() {
        this.blocked = true;
    }
    unblockLayout() {
        this.blocked = false;
    }
    layoutCell(cell) {
        this.layoutElement(cell.element, cell.column);
    }
    reinitializeColumns() {
        this.reset();
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            this.initializeColumn(column);
        });
        this.layout();
    }
    //initialize specific column
    initializeColumn(column) {
        var config = {
            margin: 0,
            edge: false
        };
        if (!column.isGroup) {
            if (this.frozenCheck(column)) {
                config.position = this.initializationMode;
                if (this.initializationMode == "left") this.leftColumns.push(column);
                else this.rightColumns.unshift(column);
                this.active = true;
                column.modules.frozen = config;
            } else this.initializationMode = "right";
        }
    }
    frozenCheck(column) {
        if (column.parent.isGroup && column.definition.frozen) console.warn("Frozen Column Error - Parent column group must be frozen, not individual columns or sub column groups");
        if (column.parent.isGroup) return this.frozenCheck(column.parent);
        else return column.definition.frozen;
    }
    //layout calculation rows
    layoutCalcRows() {
        if (this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized && this.table.modules.columnCalcs.topRow) this.layoutRow(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized && this.table.modules.columnCalcs.botRow) this.layoutRow(this.table.modules.columnCalcs.botRow);
            if (this.table.modExists("groupRows")) this.layoutGroupCalcs(this.table.modules.groupRows.getGroups());
        }
    }
    layoutGroupCalcs(groups) {
        groups.forEach((group)=>{
            if (group.calcs.top) this.layoutRow(group.calcs.top);
            if (group.calcs.bottom) this.layoutRow(group.calcs.bottom);
            if (group.groupList && group.groupList.length) this.layoutGroupCalcs(group.groupList);
        });
    }
    //calculate column positions and layout headers
    layoutColumnPosition(allCells) {
        var leftParents = [];
        var leftMargin = 0;
        var rightMargin = 0;
        this.leftColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = leftMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) leftMargin += column.getWidth();
            if (i == this.leftColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) {
                var parentEl = this.getColGroupParentElement(column);
                if (!leftParents.includes(parentEl)) {
                    this.layoutElement(parentEl, column);
                    leftParents.push(parentEl);
                }
                parentEl.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
                parentEl.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
            } else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
        this.rightColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = rightMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) rightMargin += column.getWidth();
            if (i == this.rightColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) this.layoutElement(this.getColGroupParentElement(column), column);
            else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
    }
    getColGroupParentElement(column) {
        return column.parent.isGroup ? this.getColGroupParentElement(column.parent) : column.getElement();
    }
    //layout columns appropriately
    layout() {
        if (this.active && !this.blocked) {
            //calculate left columns
            this.layoutColumnPosition();
            this.reinitializeRows();
            this.layoutCalcRows();
        }
    }
    reinitializeRows() {
        var visibleRows = this.table.rowManager.getVisibleRows(true);
        var otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
        visibleRows.forEach((row)=>{
            if (row.type === "row") this.layoutRow(row);
        });
    }
    layoutRow(row) {
        if (this.table.options.layout === "fitDataFill" && this.rightColumns.length) this.table.rowManager.getTableElement().style.minWidth = "calc(100% - " + this.rightMargin + ")";
        this.leftColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
        this.rightColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
    }
    layoutElement(element, column) {
        var position;
        if (column.modules.frozen && element) {
            element.style.position = "sticky";
            if (this.table.rtl) position = column.modules.frozen.position === "left" ? "right" : "left";
            else position = column.modules.frozen.position;
            element.style[position] = column.modules.frozen.margin;
            element.classList.add("tabulator-frozen");
            element.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
            element.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
        }
    }
    adjustForScrollbar(width) {
        if (this.rightColumns.length) this.table.columnManager.getContentsElement().style.width = "calc(100% - " + width + "px)";
    }
    getFrozenColumns() {
        return this.leftColumns.concat(this.rightColumns);
    }
    _calcSpace(columns, index) {
        var width = 0;
        for(let i = 0; i < index; i++)if (columns[i].visible) width += columns[i].getWidth();
        return width;
    }
}
class $c2a9788f40f9c90a$export$6e51ce5331c5fffa extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenRows";
    constructor(table){
        super(table);
        this.topElement = document.createElement("div");
        this.rows = [];
        //register component functions
        this.registerComponentFunction("row", "freeze", this.freezeRow.bind(this));
        this.registerComponentFunction("row", "unfreeze", this.unfreezeRow.bind(this));
        this.registerComponentFunction("row", "isFrozen", this.isRowFrozen.bind(this));
        //register table options
        this.registerTableOption("frozenRowsField", "id"); //field to choose frozen rows by
        this.registerTableOption("frozenRows", false); //holder for frozen row identifiers
    }
    initialize() {
        var fragment = document.createDocumentFragment();
        this.rows = [];
        this.topElement.classList.add("tabulator-frozen-rows-holder");
        fragment.appendChild(document.createElement("br"));
        fragment.appendChild(this.topElement);
        // this.table.columnManager.element.append(this.topElement);
        this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
        this.subscribe("row-deleting", this.detachRow.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.registerDisplayHandler(this.getRows.bind(this), 10);
        if (this.table.options.frozenRows) {
            this.subscribe("data-processed", this.initializeRows.bind(this));
            this.subscribe("row-added", this.initializeRow.bind(this));
            this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
            this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
            this.subscribe("column-show", this.resizeHolderWidth.bind(this));
            this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        }
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    initializeRows() {
        this.table.rowManager.getRows().forEach((row)=>{
            this.initializeRow(row);
        });
    }
    initializeRow(row) {
        var frozenRows = this.table.options.frozenRows, rowType = typeof frozenRows;
        if (rowType === "number") {
            if (row.getPosition() && row.getPosition() + this.rows.length <= frozenRows) this.freezeRow(row);
        } else if (rowType === "function") {
            if (frozenRows.call(this.table, row.getComponent())) this.freezeRow(row);
        } else if (Array.isArray(frozenRows)) {
            if (frozenRows.includes(row.data[this.options("frozenRowsField")])) this.freezeRow(row);
        }
    }
    isRowFrozen(row) {
        var index = this.rows.indexOf(row);
        return index > -1;
    }
    isFrozen() {
        return !!this.rows.length;
    }
    visibleRows(viewable, rows) {
        this.rows.forEach((row)=>{
            rows.push(row);
        });
        return rows;
    }
    //filter frozen rows out of display data
    getRows(rows) {
        var output = rows.slice(0);
        this.rows.forEach(function(row) {
            var index = output.indexOf(row);
            if (index > -1) output.splice(index, 1);
        });
        return output;
    }
    freezeRow(row) {
        if (!row.modules.frozen) {
            row.modules.frozen = true;
            this.topElement.appendChild(row.getElement());
            row.initialize();
            row.normalizeHeight();
            this.rows.push(row);
            this.refreshData(false, "display");
            this.table.rowManager.adjustTableSize();
            this.styleRows();
        } else console.warn("Freeze Error - Row is already frozen");
    }
    unfreezeRow(row) {
        if (row.modules.frozen) {
            row.modules.frozen = false;
            this.detachRow(row);
            this.table.rowManager.adjustTableSize();
            this.refreshData(false, "display");
            if (this.rows.length) this.styleRows();
        } else console.warn("Freeze Error - Row is already unfrozen");
    }
    detachRow(row) {
        var index = this.rows.indexOf(row);
        if (index > -1) {
            var rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
            this.rows.splice(index, 1);
        }
    }
    styleRows(row) {
        this.rows.forEach((row, i)=>{
            this.table.rowManager.styleRow(row, i);
        });
    }
}
//public group object
class $c2a9788f40f9c90a$export$450247cd99a94b80 {
    constructor(group){
        this._group = group;
        this.type = "GroupComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._group.groupManager.table.componentFunctionBinder.handle("group", target._group, name);
            }
        });
    }
    getKey() {
        return this._group.key;
    }
    getField() {
        return this._group.field;
    }
    getElement() {
        return this._group.element;
    }
    getRows() {
        return this._group.getRows(true);
    }
    getSubGroups() {
        return this._group.getSubGroups(true);
    }
    getParentGroup() {
        return this._group.parent ? this._group.parent.getComponent() : false;
    }
    isVisible() {
        return this._group.visible;
    }
    show() {
        this._group.show();
    }
    hide() {
        this._group.hide();
    }
    toggle() {
        this._group.toggleVisibility();
    }
    scrollTo(position, ifVisible) {
        return this._group.groupManager.table.rowManager.scrollToRow(this._group, position, ifVisible);
    }
    _getSelf() {
        return this._group;
    }
    getTable() {
        return this._group.groupManager.table;
    }
}
//Group functions
class $c2a9788f40f9c90a$var$Group {
    constructor(groupManager, parent, level, key, field, generator, oldGroup){
        this.groupManager = groupManager;
        this.parent = parent;
        this.key = key;
        this.level = level;
        this.field = field;
        this.hasSubGroups = level < groupManager.groupIDLookups.length - 1;
        this.addRow = this.hasSubGroups ? this._addRowToGroup : this._addRow;
        this.type = "group"; //type of element
        this.old = oldGroup;
        this.rows = [];
        this.groups = [];
        this.groupList = [];
        this.generator = generator;
        this.element = false;
        this.elementContents = false;
        this.height = 0;
        this.outerHeight = 0;
        this.initialized = false;
        this.calcs = {};
        this.initialized = false;
        this.modules = {};
        this.arrowElement = false;
        this.visible = oldGroup ? oldGroup.visible : typeof groupManager.startOpen[level] !== "undefined" ? groupManager.startOpen[level] : groupManager.startOpen[0];
        this.component = null;
        this.createElements();
        this.addBindings();
        this.createValueGroups();
    }
    wipe(elementsOnly) {
        if (!elementsOnly) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                group.wipe();
            });
            else this.rows.forEach((row)=>{
                if (row.modules) delete row.modules.group;
            });
        }
        this.element = false;
        this.arrowElement = false;
        this.elementContents = false;
    }
    createElements() {
        var arrow = document.createElement("div");
        arrow.classList.add("tabulator-arrow");
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-row");
        this.element.classList.add("tabulator-group");
        this.element.classList.add("tabulator-group-level-" + this.level);
        this.element.setAttribute("role", "rowgroup");
        this.arrowElement = document.createElement("div");
        this.arrowElement.classList.add("tabulator-group-toggle");
        this.arrowElement.appendChild(arrow);
        //setup movable rows
        if (this.groupManager.table.options.movableRows !== false && this.groupManager.table.modExists("moveRow")) this.groupManager.table.modules.moveRow.initializeGroupHeader(this);
    }
    createValueGroups() {
        var level = this.level + 1;
        if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) this.groupManager.allowedValues[level].forEach((value)=>{
            this._createGroup(value, level);
        });
    }
    addBindings() {
        var toggleElement;
        if (this.groupManager.table.options.groupToggleElement) {
            toggleElement = this.groupManager.table.options.groupToggleElement == "arrow" ? this.arrowElement : this.element;
            toggleElement.addEventListener("click", (e)=>{
                if (this.groupManager.table.options.groupToggleElement === "arrow") {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                //allow click event to propagate before toggling visibility
                setTimeout(()=>{
                    this.toggleVisibility();
                });
            });
        }
    }
    _createGroup(groupID, level) {
        var groupKey = level + "_" + groupID;
        var group = new $c2a9788f40f9c90a$var$Group(this.groupManager, this, level, groupID, this.groupManager.groupIDLookups[level].field, this.groupManager.headerGenerator[level] || this.groupManager.headerGenerator[0], this.old ? this.old.groups[groupKey] : false);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    _addRowToGroup(row) {
        var level = this.level + 1;
        if (this.hasSubGroups) {
            var groupID = this.groupManager.groupIDLookups[level].func(row.getData()), groupKey = level + "_" + groupID;
            if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) {
                if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
            } else {
                if (!this.groups[groupKey]) this._createGroup(groupID, level);
                this.groups[groupKey].addRow(row);
            }
        }
    }
    _addRow(row) {
        this.rows.push(row);
        row.modules.group = this;
    }
    insertRow(row, to, after) {
        var data = this.conformRowData({});
        row.updateData(data);
        var toIndex = this.rows.indexOf(to);
        if (toIndex > -1) {
            if (after) this.rows.splice(toIndex + 1, 0, row);
            else this.rows.splice(toIndex, 0, row);
        } else if (after) this.rows.push(row);
        else this.rows.unshift(row);
        row.modules.group = this;
        // this.generateGroupHeaderContents();
        if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
        this.groupManager.updateGroupRows(true);
    }
    scrollHeader(left) {
        if (this.arrowElement) {
            this.arrowElement.style.marginLeft = left;
            this.groupList.forEach(function(child) {
                child.scrollHeader(left);
            });
        }
    }
    getRowIndex(row) {}
    //update row data to match grouping constraints
    conformRowData(data) {
        if (this.field) data[this.field] = this.key;
        else console.warn("Data Conforming Error - Cannot conform row data to match new group as groupBy is a function");
        if (this.parent) data = this.parent.conformRowData(data);
        return data;
    }
    removeRow(row) {
        var index = this.rows.indexOf(row);
        var el = row.getElement();
        if (index > -1) this.rows.splice(index, 1);
        if (!this.groupManager.table.options.groupValues && !this.rows.length) {
            if (this.parent) this.parent.removeGroup(this);
            else this.groupManager.removeGroup(this);
            this.groupManager.updateGroupRows(true);
        } else {
            if (el.parentNode) el.parentNode.removeChild(el);
            if (!this.groupManager.blockRedraw) {
                this.generateGroupHeaderContents();
                if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
            }
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
            if (!this.groupList.length) {
                if (this.parent) this.parent.removeGroup(this);
                else this.groupManager.removeGroup(this);
            }
        }
    }
    getHeadersAndRows() {
        var output = [];
        output.push(this);
        this._visSet();
        if (this.calcs.top) {
            this.calcs.top.detachElement();
            this.calcs.top.deleteCells();
        }
        if (this.calcs.bottom) {
            this.calcs.bottom.detachElement();
            this.calcs.bottom.deleteCells();
        }
        if (this.visible) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                output = output.concat(group.getHeadersAndRows());
            });
            else {
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                    this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                    output.push(this.calcs.top);
                }
                output = output.concat(this.rows);
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                    this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                    output.push(this.calcs.bottom);
                }
            }
        } else {
            if (!this.groupList.length && this.groupManager.table.options.columnCalcs != "table") {
                if (this.groupManager.table.modExists("columnCalcs")) {
                    if (this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                            output.push(this.calcs.top);
                        }
                    }
                    if (this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                            output.push(this.calcs.bottom);
                        }
                    }
                }
            }
        }
        return output;
    }
    getData(visible, transform) {
        var output = [];
        this._visSet();
        if (!visible || visible && this.visible) this.rows.forEach((row)=>{
            output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getRowCount() {
        var count = 0;
        if (this.groupList.length) this.groupList.forEach((group)=>{
            count += group.getRowCount();
        });
        else count = this.rows.length;
        return count;
    }
    toggleVisibility() {
        if (this.visible) this.hide();
        else this.show();
    }
    hide() {
        this.visible = false;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.remove("tabulator-group-visible");
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    row.detachElement();
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                rowEl.parentNode.removeChild(rowEl);
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), false);
    }
    show() {
        this.visible = true;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.add("tabulator-group-visible");
            var prev = this.generateElement();
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    var rowEl = row.getElement();
                    prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                    row.initialize();
                    prev = rowEl;
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                row.initialize();
                prev = rowEl;
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), true);
    }
    _visSet() {
        var data = [];
        if (typeof this.visible == "function") {
            this.rows.forEach(function(row) {
                data.push(row.getData());
            });
            this.visible = this.visible(this.key, this.getRowCount(), data, this.getComponent());
        }
    }
    getRowGroup(row) {
        var match = false;
        if (this.groupList.length) this.groupList.forEach(function(group) {
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        else if (this.rows.find(function(item) {
            return item === row;
        })) match = this;
        return match;
    }
    getSubGroups(component) {
        var output = [];
        this.groupList.forEach(function(child) {
            output.push(component ? child.getComponent() : child);
        });
        return output;
    }
    getRows(component, includeChildren) {
        var output = [];
        if (includeChildren && this.groupList.length) this.groupList.forEach((group)=>{
            output = output.concat(group.getRows(component, includeChildren));
        });
        else this.rows.forEach(function(row) {
            output.push(component ? row.getComponent() : row);
        });
        return output;
    }
    generateGroupHeaderContents() {
        var data = [];
        var rows = this.getRows(false, true);
        rows.forEach(function(row) {
            data.push(row.getData());
        });
        this.elementContents = this.generator(this.key, this.getRowCount(), data, this.getComponent());
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (typeof this.elementContents === "string") this.element.innerHTML = this.elementContents;
        else this.element.appendChild(this.elementContents);
        this.element.insertBefore(this.arrowElement, this.element.firstChild);
    }
    getPath(path = []) {
        path.unshift(this.key);
        if (this.parent) this.parent.getPath(path);
        return path;
    }
    ////////////// Standard Row Functions //////////////
    getElement() {
        return this.elementContents ? this.element : this.generateElement();
    }
    generateElement() {
        this.addBindings = false;
        this._visSet();
        if (this.visible) this.element.classList.add("tabulator-group-visible");
        else this.element.classList.remove("tabulator-group-visible");
        for(var i = 0; i < this.element.childNodes.length; ++i)this.element.childNodes[i].parentNode.removeChild(this.element.childNodes[i]);
        this.generateGroupHeaderContents();
        // this.addBindings();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    //normalize the height of elements in the row
    normalizeHeight() {
        this.setHeight(this.element.clientHeight);
    }
    initialize(force) {
        if (!this.initialized || force) {
            this.normalizeHeight();
            this.initialized = true;
        }
    }
    reinitialize() {
        this.initialized = false;
        this.height = 0;
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.initialize(true);
    }
    setHeight(height) {
        if (this.height != height) {
            this.height = height;
            this.outerHeight = this.element.offsetHeight;
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    getGroup() {
        return this;
    }
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    deinitializeHeight() {}
    rendered() {}
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$450247cd99a94b80(this);
        return this.component;
    }
}
class $c2a9788f40f9c90a$export$41e6b6ec902cbe0a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "groupRows";
    constructor(table){
        super(table);
        this.groupIDLookups = false; //enable table grouping and set field to group by
        this.startOpen = [
            function() {
                return false;
            }
        ]; //starting state of group
        this.headerGenerator = [
            function() {
                return "";
            }
        ];
        this.groupList = []; //ordered list of groups
        this.allowedValues = false;
        this.groups = {}; //hold row groups
        this.displayHandler = this.getRows.bind(this);
        this.blockRedraw = false;
        //register table options
        this.registerTableOption("groupBy", false); //enable table grouping and set field to group by
        this.registerTableOption("groupStartOpen", true); //starting state of group
        this.registerTableOption("groupValues", false);
        this.registerTableOption("groupUpdateOnCellEdit", false);
        this.registerTableOption("groupHeader", false); //header generation function
        this.registerTableOption("groupHeaderPrint", null);
        this.registerTableOption("groupHeaderClipboard", null);
        this.registerTableOption("groupHeaderHtmlOutput", null);
        this.registerTableOption("groupHeaderDownload", null);
        this.registerTableOption("groupToggleElement", "arrow");
        this.registerTableOption("groupClosedShowCalcs", false);
        //register table functions
        this.registerTableFunction("setGroupBy", this.setGroupBy.bind(this));
        this.registerTableFunction("setGroupValues", this.setGroupValues.bind(this));
        this.registerTableFunction("setGroupStartOpen", this.setGroupStartOpen.bind(this));
        this.registerTableFunction("setGroupHeader", this.setGroupHeader.bind(this));
        this.registerTableFunction("getGroups", this.userGetGroups.bind(this));
        this.registerTableFunction("getGroupedData", this.userGetGroupedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "getGroup", this.rowGetGroup.bind(this));
    }
    //initialize group configuration
    initialize() {
        this.subscribe("table-destroy", this._blockRedrawing.bind(this));
        this.subscribe("rows-wipe", this._blockRedrawing.bind(this));
        this.subscribe("rows-wiped", this._restore_redrawing.bind(this));
        if (this.table.options.groupBy) {
            if (this.table.options.groupUpdateOnCellEdit) {
                this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
                this.subscribe("row-data-changed", this.reassignRowToGroup.bind(this), 0);
            }
            this.subscribe("table-built", this.configureGroupSetup.bind(this));
            this.subscribe("row-deleting", this.rowDeleting.bind(this));
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("scroll-horizontal", this.scrollHeaders.bind(this));
            this.subscribe("rows-wipe", this.wipe.bind(this));
            this.subscribe("rows-added", this.rowsUpdated.bind(this));
            this.subscribe("row-moving", this.rowMoving.bind(this));
            this.subscribe("row-adding-index", this.rowAddingIndex.bind(this));
            this.subscribe("rows-sample", this.rowSample.bind(this));
            this.subscribe("render-virtual-fill", this.virtualRenderFill.bind(this));
            this.registerDisplayHandler(this.displayHandler, 20);
            this.initialized = true;
        }
    }
    _blockRedrawing() {
        this.blockRedraw = true;
    }
    _restore_redrawing() {
        this.blockRedraw = false;
    }
    configureGroupSetup() {
        if (this.table.options.groupBy) {
            var groupBy = this.table.options.groupBy, startOpen = this.table.options.groupStartOpen, groupHeader = this.table.options.groupHeader;
            this.allowedValues = this.table.options.groupValues;
            if (Array.isArray(groupBy) && Array.isArray(groupHeader) && groupBy.length > groupHeader.length) console.warn("Error creating group headers, groupHeader array is shorter than groupBy array");
            this.headerGenerator = [
                function() {
                    return "";
                }
            ];
            this.startOpen = [
                function() {
                    return false;
                }
            ]; //starting state of group
            this.langBind("groups|item", (langValue, lang)=>{
                this.headerGenerator[0] = (value, count, data)=>{
                    return (typeof value === "undefined" ? "" : value) + "<span>(" + count + " " + (count === 1 ? langValue : lang.groups.items) + ")</span>";
                };
            });
            this.groupIDLookups = [];
            if (groupBy) {
                if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "table" && this.table.options.columnCalcs != "both") this.table.modules.columnCalcs.removeCalcs();
            } else if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "group") {
                var cols = this.table.columnManager.getRealColumns();
                cols.forEach((col)=>{
                    if (col.definition.topCalc) this.table.modules.columnCalcs.initializeTopRow();
                    if (col.definition.bottomCalc) this.table.modules.columnCalcs.initializeBottomRow();
                });
            }
            if (!Array.isArray(groupBy)) groupBy = [
                groupBy
            ];
            groupBy.forEach((group, i)=>{
                var lookupFunc, column;
                if (typeof group == "function") lookupFunc = group;
                else {
                    column = this.table.columnManager.getColumnByField(group);
                    if (column) lookupFunc = function(data) {
                        return column.getFieldValue(data);
                    };
                    else lookupFunc = function(data) {
                        return data[group];
                    };
                }
                this.groupIDLookups.push({
                    field: typeof group === "function" ? false : group,
                    func: lookupFunc,
                    values: this.allowedValues ? this.allowedValues[i] : false
                });
            });
            if (startOpen) {
                if (!Array.isArray(startOpen)) startOpen = [
                    startOpen
                ];
                startOpen.forEach((level)=>{});
                this.startOpen = startOpen;
            }
            if (groupHeader) this.headerGenerator = Array.isArray(groupHeader) ? groupHeader : [
                groupHeader
            ];
        } else {
            this.groupList = [];
            this.groups = {};
        }
    }
    rowSample(rows, prevValue) {
        if (this.table.options.groupBy) {
            var group = this.getGroups(false)[0];
            prevValue.push(group.getRows(false)[0]);
        }
        return prevValue;
    }
    virtualRenderFill() {
        var el = this.table.rowManager.tableElement;
        var rows = this.table.rowManager.getVisibleRows();
        if (this.table.options.groupBy) {
            rows = rows.filter((row)=>{
                return row.type !== "group";
            });
            el.style.minWidth = !rows.length ? this.table.columnManager.getWidth() + "px" : "";
        } else return rows;
    }
    rowAddingIndex(row, index, top) {
        if (this.table.options.groupBy) {
            this.assignRowToGroup(row);
            var groupRows = row.modules.group.rows;
            if (groupRows.length > 1) {
                if (!index || index && groupRows.indexOf(index) == -1) {
                    if (top) {
                        if (groupRows[0] !== row) {
                            index = groupRows[0];
                            this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                        }
                    } else if (groupRows[groupRows.length - 1] !== row) {
                        index = groupRows[groupRows.length - 1];
                        this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                    }
                } else this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
            }
            return index;
        }
    }
    trackChanges() {
        this.dispatch("group-changed");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    setGroupBy(groups) {
        this.table.options.groupBy = groups;
        if (!this.initialized) this.initialize();
        this.configureGroupSetup();
        if (!groups && this.table.modExists("columnCalcs") && this.table.options.columnCalcs === true) this.table.modules.columnCalcs.reinitializeCalcs();
        this.refreshData();
        this.trackChanges();
    }
    setGroupValues(groupValues) {
        this.table.options.groupValues = groupValues;
        this.configureGroupSetup();
        this.refreshData();
        this.trackChanges();
    }
    setGroupStartOpen(values) {
        this.table.options.groupStartOpen = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    setGroupHeader(values) {
        this.table.options.groupHeader = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    userGetGroups(values) {
        return this.getGroups(true);
    }
    // get grouped table data in the same format as getData()
    userGetGroupedData() {
        return this.table.options.groupBy ? this.getGroupedData() : this.getData();
    }
    ///////////////////////////////////////
    ///////// Component Functions /////////
    ///////////////////////////////////////
    rowGetGroup(row) {
        return row.modules.group ? row.modules.group.getComponent() : false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    rowMoving(from, to, after) {
        if (this.table.options.groupBy) {
            if (!after && to instanceof $c2a9788f40f9c90a$var$Group) to = this.table.rowManager.prevDisplayRow(from) || to;
            var toGroup = to instanceof $c2a9788f40f9c90a$var$Group ? to : to.modules.group;
            var fromGroup = from instanceof $c2a9788f40f9c90a$var$Group ? from : from.modules.group;
            if (toGroup === fromGroup) this.table.rowManager.moveRowInArray(toGroup.rows, from, to, after);
            else {
                if (fromGroup) fromGroup.removeRow(from);
                toGroup.insertRow(from, to, after);
            }
        }
    }
    rowDeleting(row) {
        //remove from group
        if (this.table.options.groupBy && row.modules.group) row.modules.group.removeRow(row);
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.updateGroupRows(true);
    }
    cellUpdated(cell) {
        if (this.table.options.groupBy) this.reassignRowToGroup(cell.row);
    }
    //return appropriate rows with group headers
    getRows(rows) {
        if (this.table.options.groupBy && this.groupIDLookups.length) {
            this.dispatchExternal("dataGrouping");
            this.generateGroups(rows);
            if (this.subscribedExternal("dataGrouped")) this.dispatchExternal("dataGrouped", this.getGroups(true));
            return this.updateGroupRows();
        } else return rows.slice(0);
    }
    getGroups(component) {
        var groupComponents = [];
        this.groupList.forEach(function(group) {
            groupComponents.push(component ? group.getComponent() : group);
        });
        return groupComponents;
    }
    getChildGroups(group) {
        var groupComponents = [];
        if (!group) group = this;
        group.groupList.forEach((child)=>{
            if (child.groupList.length) groupComponents = groupComponents.concat(this.getChildGroups(child));
            else groupComponents.push(child);
        });
        return groupComponents;
    }
    wipe() {
        if (this.table.options.groupBy) {
            this.groupList.forEach(function(group) {
                group.wipe();
            });
            this.groupList = [];
            this.groups = {};
        }
    }
    pullGroupListData(groupList) {
        var groupListData = [];
        groupList.forEach((group)=>{
            var groupHeader = {};
            groupHeader.level = 0;
            groupHeader.rowCount = 0;
            groupHeader.headerContent = "";
            var childData = [];
            if (group.hasSubGroups) {
                childData = this.pullGroupListData(group.groupList);
                groupHeader.level = group.level;
                groupHeader.rowCount = childData.length - group.groupList.length; // data length minus number of sub-headers
                groupHeader.headerContent = group.generator(group.key, groupHeader.rowCount, group.rows, group);
                groupListData.push(groupHeader);
                groupListData = groupListData.concat(childData);
            } else {
                groupHeader.level = group.level;
                groupHeader.headerContent = group.generator(group.key, group.rows.length, group.rows, group);
                groupHeader.rowCount = group.getRows().length;
                groupListData.push(groupHeader);
                group.getRows().forEach((row)=>{
                    groupListData.push(row.getData("data"));
                });
            }
        });
        return groupListData;
    }
    getGroupedData() {
        return this.pullGroupListData(this.groupList);
    }
    getRowGroup(row) {
        var match = false;
        if (this.options("dataTree")) row = this.table.modules.dataTree.getTreeParentRoot(row);
        this.groupList.forEach((group)=>{
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        return match;
    }
    countGroups() {
        return this.groupList.length;
    }
    generateGroups(rows) {
        var oldGroups = this.groups;
        this.groups = {};
        this.groupList = [];
        if (this.allowedValues && this.allowedValues[0]) {
            this.allowedValues[0].forEach((value)=>{
                this.createGroup(value, 0, oldGroups);
            });
            rows.forEach((row)=>{
                this.assignRowToExistingGroup(row, oldGroups);
            });
        } else rows.forEach((row)=>{
            this.assignRowToGroup(row, oldGroups);
        });
        Object.values(oldGroups).forEach((group)=>{
            group.wipe(true);
        });
    }
    createGroup(groupID, level, oldGroups) {
        var groupKey = level + "_" + groupID, group;
        oldGroups = oldGroups || [];
        group = new $c2a9788f40f9c90a$var$Group(this, false, level, groupID, this.groupIDLookups[0].field, this.headerGenerator[0], oldGroups[groupKey]);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    assignRowToExistingGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), groupKey = "0_" + groupID;
        if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
    }
    assignRowToGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), newGroupNeeded = !this.groups["0_" + groupID];
        if (newGroupNeeded) this.createGroup(groupID, 0, oldGroups);
        this.groups["0_" + groupID].addRow(row);
        return !newGroupNeeded;
    }
    reassignRowToGroup(row) {
        if (row.type === "row") {
            var oldRowGroup = row.modules.group, oldGroupPath = oldRowGroup.getPath(), newGroupPath = this.getExpectedPath(row), samePath;
            // figure out if new group path is the same as old group path
            samePath = oldGroupPath.length == newGroupPath.length && oldGroupPath.every((element, index)=>{
                return element === newGroupPath[index];
            });
            // refresh if they new path and old path aren't the same (aka the row's groupings have changed)
            if (!samePath) {
                oldRowGroup.removeRow(row);
                this.assignRowToGroup(row, this.groups);
                this.refreshData(true);
            }
        }
    }
    getExpectedPath(row) {
        var groupPath = [], rowData = row.getData();
        this.groupIDLookups.forEach((groupId)=>{
            groupPath.push(groupId.func(rowData));
        });
        return groupPath;
    }
    updateGroupRows(force) {
        var output = [];
        if (!this.blockRedraw) {
            this.groupList.forEach((group)=>{
                output = output.concat(group.getHeadersAndRows());
            });
            if (force) this.refreshData(true);
        }
        return output;
    }
    scrollHeaders(left) {
        if (this.table.options.groupBy) {
            if (this.table.options.renderHorizontal === "virtual") left -= this.table.columnManager.renderer.vDomPadLeft;
            left = left + "px";
            this.groupList.forEach((group)=>{
                group.scrollHeader(left);
            });
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
        }
    }
    checkBasicModeGroupHeaderWidth() {
        var element = this.table.rowManager.tableElement, onlyGroupHeaders = true;
        this.table.rowManager.getDisplayRows().forEach((row, index)=>{
            this.table.rowManager.styleRow(row, index);
            element.appendChild(row.getElement());
            row.initialize(true);
            if (row.type !== "group") onlyGroupHeaders = false;
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
}
var $c2a9788f40f9c90a$var$defaultUndoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.oldValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        var after = action.data.posFrom - action.data.posTo > 0;
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posFrom), after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$defaultRedoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.newValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posTo), action.data.after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$bindings$1 = {
    undo: [
        "ctrl + 90",
        "meta + 90"
    ],
    redo: [
        "ctrl + 89",
        "meta + 89"
    ]
};
var $c2a9788f40f9c90a$var$actions$1 = {
    undo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.undo();
            }
        }
    },
    redo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.redo();
            }
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$3 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$1,
        actions: $c2a9788f40f9c90a$var$actions$1
    }
};
class $c2a9788f40f9c90a$export$173658fc60691186 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "history";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$3;
    //load defaults
    static undoers = $c2a9788f40f9c90a$var$defaultUndoers;
    static redoers = $c2a9788f40f9c90a$var$defaultRedoers;
    constructor(table){
        super(table);
        this.history = [];
        this.index = -1;
        this.registerTableOption("history", false); //enable edit history
    }
    initialize() {
        if (this.table.options.history) {
            this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
            this.subscribe("cell-delete", this.clearComponentHistory.bind(this));
            this.subscribe("row-delete", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clear.bind(this));
            this.subscribe("row-added", this.rowAdded.bind(this));
            this.subscribe("row-move", this.rowMoved.bind(this));
        }
        this.registerTableFunction("undo", this.undo.bind(this));
        this.registerTableFunction("redo", this.redo.bind(this));
        this.registerTableFunction("getHistoryUndoSize", this.getHistoryUndoSize.bind(this));
        this.registerTableFunction("getHistoryRedoSize", this.getHistoryRedoSize.bind(this));
        this.registerTableFunction("clearHistory", this.clear.bind(this));
    }
    rowMoved(from, to, after) {
        this.action("rowMove", from, {
            posFrom: from.getPosition(),
            posTo: to.getPosition(),
            to: to,
            after: after
        });
    }
    rowAdded(row, data, pos, index) {
        this.action("rowAdd", row, {
            data: data,
            pos: pos,
            index: index
        });
    }
    rowDeleted(row) {
        var index, rows;
        if (this.table.options.groupBy) {
            rows = row.getComponent().getGroup()._getSelf().rows;
            index = rows.indexOf(row);
            if (index) index = rows[index - 1];
        } else {
            index = row.table.rowManager.getRowIndex(row);
            if (index) index = row.table.rowManager.rows[index - 1];
        }
        this.action("rowDelete", row, {
            data: row.getData(),
            pos: !index,
            index: index
        });
    }
    cellUpdated(cell) {
        this.action("cellEdit", cell, {
            oldValue: cell.oldValue,
            newValue: cell.value
        });
    }
    clear() {
        this.history = [];
        this.index = -1;
    }
    action(type, component, data) {
        this.history = this.history.slice(0, this.index + 1);
        this.history.push({
            type: type,
            component: component,
            data: data
        });
        this.index++;
    }
    getHistoryUndoSize() {
        return this.index + 1;
    }
    getHistoryRedoSize() {
        return this.history.length - (this.index + 1);
    }
    clearComponentHistory(component) {
        var index = this.history.findIndex(function(item) {
            return item.component === component;
        });
        if (index > -1) {
            this.history.splice(index, 1);
            if (index <= this.index) this.index--;
            this.clearComponentHistory(component);
        }
    }
    undo() {
        if (this.index > -1) {
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.undoers[action.type].call(this, action);
            this.index--;
            this.dispatchExternal("historyUndo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Undo Error - No more history to undo" : "History module not enabled");
            return false;
        }
    }
    redo() {
        if (this.history.length - 1 > this.index) {
            this.index++;
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.redoers[action.type].call(this, action);
            this.dispatchExternal("historyRedo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Redo Error - No more history to redo" : "History module not enabled");
            return false;
        }
    }
    //rebind rows to new element after deletion
    _rebindRow(oldRow, newRow) {
        this.history.forEach(function(action) {
            if (action.component instanceof $c2a9788f40f9c90a$var$Row) {
                if (action.component === oldRow) action.component = newRow;
            } else if (action.component instanceof $c2a9788f40f9c90a$var$Cell) {
                if (action.component.row === oldRow) {
                    var field = action.component.column.getField();
                    if (field) action.component = newRow.getCell(field);
                }
            }
        });
    }
}
class $c2a9788f40f9c90a$export$b0b448c470bac827 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "htmlTableImport";
    constructor(table){
        super(table);
        this.fieldIndex = [];
        this.hasIndex = false;
    }
    initialize() {
        this.tableElementCheck();
    }
    tableElementCheck() {
        if (this.table.originalElement && this.table.originalElement.tagName === "TABLE") {
            if (this.table.originalElement.childNodes.length) this.parseTable();
            else console.warn("Unable to parse data from empty table tag, Tabulator should be initialized on a div tag unless importing data from a table element.");
        }
    }
    parseTable() {
        var element = this.table.originalElement, options = this.table.options, headers = element.getElementsByTagName("th"), rows = element.getElementsByTagName("tbody")[0], data = [];
        this.hasIndex = false;
        this.dispatchExternal("htmlImporting");
        rows = rows ? rows.getElementsByTagName("tr") : [];
        //check for Tabulator inline options
        this._extractOptions(element, options);
        if (headers.length) this._extractHeaders(headers, rows);
        else this._generateBlankHeaders(headers, rows);
        //iterate through table rows and build data set
        for(var index = 0; index < rows.length; index++){
            var row = rows[index], cells = row.getElementsByTagName("td"), item = {};
            //create index if the don't exist in table
            if (!this.hasIndex) item[options.index] = index;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (typeof this.fieldIndex[i] !== "undefined") item[this.fieldIndex[i]] = cell.innerHTML;
            }
            //add row data to item
            data.push(item);
        }
        options.data = data;
        this.dispatchExternal("htmlImported");
    }
    //extract tabulator attribute options
    _extractOptions(element, options, defaultOptions) {
        var attributes = element.attributes;
        var optionsArr = defaultOptions ? Object.keys(defaultOptions) : Object.keys(options);
        var optionsList = {};
        optionsArr.forEach((item)=>{
            optionsList[item.toLowerCase()] = item;
        });
        for(var index in attributes){
            var attrib = attributes[index];
            var name;
            if (attrib && typeof attrib == "object" && attrib.name && attrib.name.indexOf("tabulator-") === 0) {
                name = attrib.name.replace("tabulator-", "");
                if (typeof optionsList[name] !== "undefined") options[optionsList[name]] = this._attribValue(attrib.value);
            }
        }
    }
    //get value of attribute
    _attribValue(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        return value;
    }
    //find column if it has already been defined
    _findCol(title) {
        var match = this.table.options.columns.find((column)=>{
            return column.title === title;
        });
        return match || false;
    }
    //extract column from headers
    _extractHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], exists = false, col = this._findCol(header.textContent), width;
            if (col) exists = true;
            else col = {
                title: header.textContent.trim()
            };
            if (!col.field) col.field = header.textContent.trim().toLowerCase().replaceAll(" ", "_");
            width = header.getAttribute("width");
            if (width && !col.width) col.width = width;
            //check for Tabulator inline options
            this._extractOptions(header, col, this.table.columnManager.optionsList.registeredDefaults);
            this.fieldIndex[index] = col.field;
            if (col.field == this.table.options.index) this.hasIndex = true;
            if (!exists) this.table.options.columns.push(col);
        }
    }
    //generate blank headers
    _generateBlankHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], col = {
                title: "",
                field: "col" + index
            };
            this.fieldIndex[index] = col.field;
            var width = header.getAttribute("width");
            if (width) col.width = width;
            this.table.options.columns.push(col);
        }
    }
}
function $c2a9788f40f9c90a$var$csv(input) {
    var data = [], row = 0, col = 0, inQuote = false;
    //Iterate over each character
    for(let index = 0; index < input.length; index++){
        let char = input[index], nextChar = input[index + 1];
        //Initialize empty row
        if (!data[row]) data[row] = [];
        //Initialize empty column
        if (!data[row][col]) data[row][col] = "";
        //Handle quotation mark inside string
        if (char == '"' && inQuote && nextChar == '"') {
            data[row][col] += char;
            index++;
            continue;
        }
        //Begin / End Quote
        if (char == '"') {
            inQuote = !inQuote;
            continue;
        }
        //Next column (if not in quote)
        if (char == "," && !inQuote) {
            col++;
            continue;
        }
        //New row if new line and not in quote (CRLF) 
        if (char == "\r" && nextChar == "\n" && !inQuote) {
            col = 0;
            row++;
            index++;
            continue;
        }
        //New row if new line and not in quote (CR or LF) 
        if ((char == "\r" || char == "\n") && !inQuote) {
            col = 0;
            row++;
            continue;
        }
        //Normal Character, append to column
        data[row][col] += char;
    }
    return data;
}
function $c2a9788f40f9c90a$var$json(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        console.warn("JSON Import Error - File contents is invalid JSON", e);
        return Promise.reject();
    }
}
function $c2a9788f40f9c90a$var$array$1(input) {
    return input;
}
function $c2a9788f40f9c90a$var$xlsx(input) {
    var XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook2 = XLSXLib.read(input), sheet = workbook2.Sheets[workbook2.SheetNames[0]];
    return XLSXLib.utils.sheet_to_json(sheet, {
        header: 1
    });
}
var $c2a9788f40f9c90a$var$defaultImporters = {
    csv: $c2a9788f40f9c90a$var$csv,
    json: $c2a9788f40f9c90a$var$json,
    array: $c2a9788f40f9c90a$var$array$1,
    xlsx: $c2a9788f40f9c90a$var$xlsx
};
class $c2a9788f40f9c90a$export$bceca318c211ca25 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "import";
    //load defaults
    static importers = $c2a9788f40f9c90a$var$defaultImporters;
    constructor(table){
        super(table);
        this.registerTableOption("importFormat");
        this.registerTableOption("importReader", "text");
        this.registerTableOption("importHeaderTransform");
        this.registerTableOption("importValueTransform");
        this.registerTableOption("importDataValidator");
        this.registerTableOption("importFileValidator");
    }
    initialize() {
        this.registerTableFunction("import", this.importFromFile.bind(this));
        if (this.table.options.importFormat) {
            this.subscribe("data-loading", this.loadDataCheck.bind(this), 10);
            this.subscribe("data-load", this.loadData.bind(this), 10);
        }
    }
    loadDataCheck(data) {
        return this.table.options.importFormat && (typeof data === "string" || Array.isArray(data) && data.length && Array.isArray(data));
    }
    loadData(data, params, config, silent, previousData) {
        return this.importData(this.lookupImporter(), data).then(this.structureData.bind(this)).catch((err)=>{
            console.error("Import Error:", err || "Unable to import data");
            return Promise.reject(err);
        });
    }
    lookupImporter(importFormat) {
        var importer;
        if (!importFormat) importFormat = this.table.options.importFormat;
        if (typeof importFormat === "string") importer = $c2a9788f40f9c90a$export$bceca318c211ca25.importers[importFormat];
        else importer = importFormat;
        if (!importer) console.error("Import Error - Importer not found:", importFormat);
        return importer;
    }
    importFromFile(importFormat, extension, importReader) {
        var importer = this.lookupImporter(importFormat);
        if (importer) return this.pickFile(extension, importReader).then(this.importData.bind(this, importer)).then(this.structureData.bind(this)).then(this.mutateData.bind(this)).then(this.validateData.bind(this)).then(this.setData.bind(this)).catch((err)=>{
            this.dispatch("import-error", err);
            this.dispatchExternal("importError", err);
            console.error("Import Error:", err || "Unable to import file");
            this.table.dataLoader.alertError();
            setTimeout(()=>{
                this.table.dataLoader.clearAlert();
            }, 3000);
            return Promise.reject(err);
        });
    }
    pickFile(extensions, importReader) {
        return new Promise((resolve, reject)=>{
            var input = document.createElement("input");
            input.type = "file";
            input.accept = extensions;
            input.addEventListener("change", (e)=>{
                var file = input.files[0], reader = new FileReader(), valid = this.validateFile(file);
                if (valid === true) {
                    this.dispatch("import-importing", input.files);
                    this.dispatchExternal("importImporting", input.files);
                    switch(importReader || this.table.options.importReader){
                        case "buffer":
                            reader.readAsArrayBuffer(file);
                            break;
                        case "binary":
                            reader.readAsBinaryString(file);
                            break;
                        case "url":
                            reader.readAsDataURL(file);
                            break;
                        case "text":
                        default:
                            reader.readAsText(file);
                    }
                    reader.onload = (e)=>{
                        resolve(reader.result);
                    };
                    reader.onerror = (e)=>{
                        console.warn("File Load Error - Unable to read file");
                        reject(e);
                    };
                } else reject(valid);
            });
            this.dispatch("import-choose");
            this.dispatchExternal("importChoose");
            input.click();
        });
    }
    importData(importer, fileContents) {
        var data;
        this.table.dataLoader.alertLoader();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                data = importer.call(this.table, fileContents);
                if (data instanceof Promise) resolve(data);
                else data ? resolve(data) : reject();
            }, 10);
        });
    }
    structureData(parsedData) {
        var data = [];
        if (Array.isArray(parsedData) && parsedData.length && Array.isArray(parsedData[0])) {
            if (this.table.options.autoColumns) data = this.structureArrayToObject(parsedData);
            else data = this.structureArrayToColumns(parsedData);
            return data;
        } else return parsedData;
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "import"));
        });
        else output = data;
        return output;
    }
    transformHeader(headers) {
        var output = [];
        if (this.table.options.importHeaderTransform) headers.forEach((item)=>{
            output.push(this.table.options.importHeaderTransform.call(this.table, item, headers));
        });
        else return headers;
        return output;
    }
    transformData(row) {
        var output = [];
        if (this.table.options.importValueTransform) row.forEach((item)=>{
            output.push(this.table.options.importValueTransform.call(this.table, item, row));
        });
        else return row;
        return output;
    }
    structureArrayToObject(parsedData) {
        var columns = this.transformHeader(parsedData.shift());
        var data = parsedData.map((values)=>{
            var row = {};
            values = this.transformData(values);
            columns.forEach((key, i)=>{
                row[key] = values[i];
            });
            return row;
        });
        return data;
    }
    structureArrayToColumns(parsedData) {
        var data = [], firstRow = this.transformHeader(parsedData[0]), columns = this.table.getColumns();
        //remove first row if it is the column names
        if (columns[0] && firstRow[0]) {
            if (columns[0].getDefinition().title === firstRow[0]) parsedData.shift();
        }
        //convert row arrays to objects
        parsedData.forEach((rowData)=>{
            var row = {};
            rowData = this.transformData(rowData);
            rowData.forEach((value, index)=>{
                var column = columns[index];
                if (column) row[column.getField()] = value;
            });
            data.push(row);
        });
        return data;
    }
    validateFile(file) {
        if (this.table.options.importFileValidator) return this.table.options.importFileValidator.call(this.table, file);
        return true;
    }
    validateData(data) {
        var result;
        if (this.table.options.importDataValidator) {
            result = this.table.options.importDataValidator.call(this.table, data);
            if (result === true) return data;
            else return Promise.reject(result);
        }
        return data;
    }
    setData(data) {
        this.dispatch("import-imported", data);
        this.dispatchExternal("importImported", data);
        this.table.dataLoader.clearAlert();
        return this.table.setData(data);
    }
}
class $c2a9788f40f9c90a$export$69fa60f71dd0541a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "interaction";
    constructor(table){
        super(table);
        this.eventMap = {
            //row events
            rowClick: "row-click",
            rowDblClick: "row-dblclick",
            rowContext: "row-contextmenu",
            rowMouseEnter: "row-mouseenter",
            rowMouseLeave: "row-mouseleave",
            rowMouseOver: "row-mouseover",
            rowMouseOut: "row-mouseout",
            rowMouseMove: "row-mousemove",
            rowMouseDown: "row-mousedown",
            rowMouseUp: "row-mouseup",
            rowTap: "row",
            rowDblTap: "row",
            rowTapHold: "row",
            //cell events
            cellClick: "cell-click",
            cellDblClick: "cell-dblclick",
            cellContext: "cell-contextmenu",
            cellMouseEnter: "cell-mouseenter",
            cellMouseLeave: "cell-mouseleave",
            cellMouseOver: "cell-mouseover",
            cellMouseOut: "cell-mouseout",
            cellMouseMove: "cell-mousemove",
            cellMouseDown: "cell-mousedown",
            cellMouseUp: "cell-mouseup",
            cellTap: "cell",
            cellDblTap: "cell",
            cellTapHold: "cell",
            //column header events
            headerClick: "column-click",
            headerDblClick: "column-dblclick",
            headerContext: "column-contextmenu",
            headerMouseEnter: "column-mouseenter",
            headerMouseLeave: "column-mouseleave",
            headerMouseOver: "column-mouseover",
            headerMouseOut: "column-mouseout",
            headerMouseMove: "column-mousemove",
            headerMouseDown: "column-mousedown",
            headerMouseUp: "column-mouseup",
            headerTap: "column",
            headerDblTap: "column",
            headerTapHold: "column",
            //group header
            groupClick: "group-click",
            groupDblClick: "group-dblclick",
            groupContext: "group-contextmenu",
            groupMouseEnter: "group-mouseenter",
            groupMouseLeave: "group-mouseleave",
            groupMouseOver: "group-mouseover",
            groupMouseOut: "group-mouseout",
            groupMouseMove: "group-mousemove",
            groupMouseDown: "group-mousedown",
            groupMouseUp: "group-mouseup",
            groupTap: "group",
            groupDblTap: "group",
            groupTapHold: "group"
        };
        this.subscribers = {};
        this.touchSubscribers = {};
        this.columnSubscribers = {};
        this.touchWatchers = {
            row: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            cell: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            column: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            group: {
                tap: null,
                tapDbl: null,
                tapHold: null
            }
        };
        this.registerColumnOption("headerClick");
        this.registerColumnOption("headerDblClick");
        this.registerColumnOption("headerContext");
        this.registerColumnOption("headerMouseEnter");
        this.registerColumnOption("headerMouseLeave");
        this.registerColumnOption("headerMouseOver");
        this.registerColumnOption("headerMouseOut");
        this.registerColumnOption("headerMouseMove");
        this.registerColumnOption("headerMouseDown");
        this.registerColumnOption("headerMouseUp");
        this.registerColumnOption("headerTap");
        this.registerColumnOption("headerDblTap");
        this.registerColumnOption("headerTapHold");
        this.registerColumnOption("cellClick");
        this.registerColumnOption("cellDblClick");
        this.registerColumnOption("cellContext");
        this.registerColumnOption("cellMouseEnter");
        this.registerColumnOption("cellMouseLeave");
        this.registerColumnOption("cellMouseOver");
        this.registerColumnOption("cellMouseOut");
        this.registerColumnOption("cellMouseMove");
        this.registerColumnOption("cellMouseDown");
        this.registerColumnOption("cellMouseUp");
        this.registerColumnOption("cellTap");
        this.registerColumnOption("cellDblTap");
        this.registerColumnOption("cellTapHold");
    }
    initialize() {
        this.initializeExternalEvents();
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("cell-dblclick", this.cellContentsSelectionFixer.bind(this));
        this.subscribe("scroll-horizontal", this.clearTouchWatchers.bind(this));
        this.subscribe("scroll-vertical", this.clearTouchWatchers.bind(this));
    }
    clearTouchWatchers() {
        var types = Object.values(this.touchWatchers);
        types.forEach((type)=>{
            for(let key in type)type[key] = null;
        });
    }
    cellContentsSelectionFixer(e, cell) {
        var range;
        if (this.table.modExists("edit")) {
            if (this.table.modules.edit.currentCell === cell) return; //prevent instant selection of editor content
        }
        e.preventDefault();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    initializeExternalEvents() {
        for(let key in this.eventMap)this.subscriptionChangeExternal(key, this.subscriptionChanged.bind(this, key));
    }
    subscriptionChanged(key, added) {
        if (added) {
            if (!this.subscribers[key]) {
                if (this.eventMap[key].includes("-")) {
                    this.subscribers[key] = this.handle.bind(this, key);
                    this.subscribe(this.eventMap[key], this.subscribers[key]);
                } else this.subscribeTouchEvents(key);
            }
        } else {
            if (this.eventMap[key].includes("-")) {
                if (this.subscribers[key] && !this.columnSubscribers[key] && !this.subscribedExternal(key)) {
                    this.unsubscribe(this.eventMap[key], this.subscribers[key]);
                    delete this.subscribers[key];
                }
            } else this.unsubscribeTouchEvents(key);
        }
    }
    subscribeTouchEvents(key) {
        var type = this.eventMap[key];
        if (!this.touchSubscribers[type + "-touchstart"]) {
            this.touchSubscribers[type + "-touchstart"] = this.handleTouch.bind(this, type, "start");
            this.touchSubscribers[type + "-touchend"] = this.handleTouch.bind(this, type, "end");
            this.subscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
            this.subscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
        }
        this.subscribers[key] = true;
    }
    unsubscribeTouchEvents(key) {
        var noTouch = true, type = this.eventMap[key];
        if (this.subscribers[key] && !this.subscribedExternal(key)) {
            delete this.subscribers[key];
            for(let i in this.eventMap){
                if (this.eventMap[i] === type) {
                    if (this.subscribers[i]) noTouch = false;
                }
            }
            if (noTouch) {
                this.unsubscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
                this.unsubscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
                delete this.touchSubscribers[type + "-touchstart"];
                delete this.touchSubscribers[type + "-touchend"];
            }
        }
    }
    initializeColumn(column) {
        var def = column.definition;
        for(let key in this.eventMap)if (def[key]) {
            this.subscriptionChanged(key, true);
            if (!this.columnSubscribers[key]) this.columnSubscribers[key] = [];
            this.columnSubscribers[key].push(column);
        }
    }
    handle(action, e, component) {
        this.dispatchEvent(action, e, component);
    }
    handleTouch(type, action, e, component) {
        var watchers = this.touchWatchers[type];
        if (type === "column") type = "header";
        switch(action){
            case "start":
                watchers.tap = true;
                clearTimeout(watchers.tapHold);
                watchers.tapHold = setTimeout(()=>{
                    clearTimeout(watchers.tapHold);
                    watchers.tapHold = null;
                    watchers.tap = null;
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "TapHold", e, component);
                }, 1000);
                break;
            case "end":
                if (watchers.tap) {
                    watchers.tap = null;
                    this.dispatchEvent(type + "Tap", e, component);
                }
                if (watchers.tapDbl) {
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "DblTap", e, component);
                } else watchers.tapDbl = setTimeout(()=>{
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                }, 300);
                clearTimeout(watchers.tapHold);
                watchers.tapHold = null;
                break;
        }
    }
    dispatchEvent(action, e, component) {
        var componentObj = component.getComponent(), callback;
        if (this.columnSubscribers[action]) {
            if (component instanceof $c2a9788f40f9c90a$var$Cell) callback = component.column.definition[action];
            else if (component instanceof $c2a9788f40f9c90a$var$Column) callback = component.definition[action];
            if (callback) callback(e, componentObj);
        }
        this.dispatchExternal(action, e, componentObj);
    }
}
var $c2a9788f40f9c90a$var$defaultBindings = {
    navPrev: "shift + 9",
    navNext: 9,
    navUp: 38,
    navDown: 40,
    navLeft: 37,
    navRight: 39,
    scrollPageUp: 33,
    scrollPageDown: 34,
    scrollToStart: 36,
    scrollToEnd: 35
};
var $c2a9788f40f9c90a$var$defaultActions = {
    keyBlock: function(e) {
        e.stopPropagation();
        e.preventDefault();
    },
    scrollPageUp: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop - rowManager.element.clientHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos >= 0) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        }
        this.table.element.focus();
    },
    scrollPageDown: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop + rowManager.element.clientHeight, scrollMax = rowManager.element.scrollHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos <= scrollMax) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        }
        this.table.element.focus();
    },
    scrollToStart: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        this.table.element.focus();
    },
    scrollToEnd: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        this.table.element.focus();
    },
    navPrev: function(e) {
        this.dispatch("keybinding-nav-prev", e);
    },
    navNext: function(e) {
        this.dispatch("keybinding-nav-next", e);
    },
    navLeft: function(e) {
        this.dispatch("keybinding-nav-left", e);
    },
    navRight: function(e) {
        this.dispatch("keybinding-nav-right", e);
    },
    navUp: function(e) {
        this.dispatch("keybinding-nav-up", e);
    },
    navDown: function(e) {
        this.dispatch("keybinding-nav-down", e);
    }
};
class $c2a9788f40f9c90a$export$a0ff4f1c226a7cef extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "keybindings";
    //load defaults
    static bindings = $c2a9788f40f9c90a$var$defaultBindings;
    static actions = $c2a9788f40f9c90a$var$defaultActions;
    constructor(table){
        super(table);
        this.watchKeys = null;
        this.pressedKeys = null;
        this.keyupBinding = false;
        this.keydownBinding = false;
        this.registerTableOption("keybindings", {}); //array for keybindings
        this.registerTableOption("tabEndNewRow", false); //create new row when tab to end of table
    }
    initialize() {
        var bindings = this.table.options.keybindings, mergedBindings = {};
        this.watchKeys = {};
        this.pressedKeys = [];
        if (bindings !== false) {
            Object.assign(mergedBindings, $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.bindings);
            Object.assign(mergedBindings, bindings);
            this.mapBindings(mergedBindings);
            this.bindEvents();
        }
        this.subscribe("table-destroy", this.clearBindings.bind(this));
    }
    mapBindings(bindings) {
        for(let key in bindings){
            if ($c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[key]) {
                if (bindings[key]) {
                    if (typeof bindings[key] !== "object") bindings[key] = [
                        bindings[key]
                    ];
                    bindings[key].forEach((binding)=>{
                        var bindingList = Array.isArray(binding) ? binding : [
                            binding
                        ];
                        bindingList.forEach((item)=>{
                            this.mapBinding(key, item);
                        });
                    });
                }
            } else console.warn("Key Binding Error - no such action:", key);
        }
    }
    mapBinding(action, symbolsList) {
        var binding = {
            action: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[action],
            keys: [],
            ctrl: false,
            shift: false,
            meta: false
        };
        var symbols = symbolsList.toString().toLowerCase().split(" ").join("").split("+");
        symbols.forEach((symbol)=>{
            switch(symbol){
                case "ctrl":
                    binding.ctrl = true;
                    break;
                case "shift":
                    binding.shift = true;
                    break;
                case "meta":
                    binding.meta = true;
                    break;
                default:
                    symbol = isNaN(symbol) ? symbol.toUpperCase().charCodeAt(0) : parseInt(symbol);
                    binding.keys.push(symbol);
                    if (!this.watchKeys[symbol]) this.watchKeys[symbol] = [];
                    this.watchKeys[symbol].push(binding);
            }
        });
    }
    bindEvents() {
        var self = this;
        this.keyupBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                self.pressedKeys.push(code);
                bindings.forEach(function(binding) {
                    self.checkBinding(e, binding);
                });
            }
        };
        this.keydownBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                var index = self.pressedKeys.indexOf(code);
                if (index > -1) self.pressedKeys.splice(index, 1);
            }
        };
        this.table.element.addEventListener("keydown", this.keyupBinding);
        this.table.element.addEventListener("keyup", this.keydownBinding);
    }
    clearBindings() {
        if (this.keyupBinding) this.table.element.removeEventListener("keydown", this.keyupBinding);
        if (this.keydownBinding) this.table.element.removeEventListener("keyup", this.keydownBinding);
    }
    checkBinding(e, binding) {
        var match = true;
        if (e.ctrlKey == binding.ctrl && e.shiftKey == binding.shift && e.metaKey == binding.meta) {
            binding.keys.forEach((key)=>{
                var index = this.pressedKeys.indexOf(key);
                if (index == -1) match = false;
            });
            if (match) binding.action.call(this, e);
            return true;
        }
        return false;
    }
}
class $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "menu";
    constructor(table){
        super(table);
        this.menuContainer = null;
        this.nestedMenuBlock = false;
        this.currentComponent = null;
        this.rootPopup = null;
        this.columnSubscribers = {};
        // this.registerTableOption("menuContainer", undefined); //deprecated
        this.registerTableOption("rowContextMenu", false);
        this.registerTableOption("rowClickMenu", false);
        this.registerTableOption("rowDblClickMenu", false);
        this.registerTableOption("groupContextMenu", false);
        this.registerTableOption("groupClickMenu", false);
        this.registerTableOption("groupDblClickMenu", false);
        this.registerColumnOption("headerContextMenu");
        this.registerColumnOption("headerClickMenu");
        this.registerColumnOption("headerDblClickMenu");
        this.registerColumnOption("headerMenu");
        this.registerColumnOption("headerMenuIcon");
        this.registerColumnOption("contextMenu");
        this.registerColumnOption("clickMenu");
        this.registerColumnOption("dblClickMenu");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // if(!this.deprecationCheck("menuContainer", "popupContainer")){
    // 	this.table.options.popupContainer = this.table.options.menuContainer;
    // }
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextMenu) {
            this.subscribe("row-contextmenu", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
            this.table.on("rowTapHold", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
        }
        if (this.table.options.rowClickMenu) this.subscribe("row-click", this.loadMenuEvent.bind(this, this.table.options.rowClickMenu));
        if (this.table.options.rowDblClickMenu) this.subscribe("row-dblclick", this.loadMenuEvent.bind(this, this.table.options.rowDblClickMenu));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextMenu) {
            this.subscribe("group-contextmenu", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
            this.table.on("groupTapHold", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
        }
        if (this.table.options.groupClickMenu) this.subscribe("group-click", this.loadMenuEvent.bind(this, this.table.options.groupClickMenu));
        if (this.table.options.groupDblClickMenu) this.subscribe("group-dblclick", this.loadMenuEvent.bind(this, this.table.options.groupDblClickMenu));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextMenu && !this.columnSubscribers.headerContextMenu) {
            this.columnSubscribers.headerContextMenu = this.loadMenuTableColumnEvent.bind(this, "headerContextMenu");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextMenu);
            this.table.on("headerTapHold", this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"));
        }
        if (def.headerClickMenu && !this.columnSubscribers.headerClickMenu) {
            this.columnSubscribers.headerClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerClickMenu");
            this.subscribe("column-click", this.columnSubscribers.headerClickMenu);
        }
        if (def.headerDblClickMenu && !this.columnSubscribers.headerDblClickMenu) {
            this.columnSubscribers.headerDblClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerDblClickMenu");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickMenu);
        }
        if (def.headerMenu) this.initializeColumnHeaderMenu(column);
        //handle cell events
        if (def.contextMenu && !this.columnSubscribers.contextMenu) {
            this.columnSubscribers.contextMenu = this.loadMenuTableCellEvent.bind(this, "contextMenu");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextMenu);
            this.table.on("cellTapHold", this.loadMenuTableCellEvent.bind(this, "contextMenu"));
        }
        if (def.clickMenu && !this.columnSubscribers.clickMenu) {
            this.columnSubscribers.clickMenu = this.loadMenuTableCellEvent.bind(this, "clickMenu");
            this.subscribe("cell-click", this.columnSubscribers.clickMenu);
        }
        if (def.dblClickMenu && !this.columnSubscribers.dblClickMenu) {
            this.columnSubscribers.dblClickMenu = this.loadMenuTableCellEvent.bind(this, "dblClickMenu");
            this.subscribe("cell-dblclick", this.columnSubscribers.dblClickMenu);
        }
    }
    initializeColumnHeaderMenu(column) {
        var icon = column.definition.headerMenuIcon, headerMenuEl;
        headerMenuEl = document.createElement("span");
        headerMenuEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerMenuEl.appendChild(icon);
            else headerMenuEl.innerHTML = icon;
        } else headerMenuEl.innerHTML = "&vellip;";
        headerMenuEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadMenuEvent(column.definition.headerMenu, e, column);
        });
        column.titleElement.insertBefore(headerMenuEl, column.titleElement.firstChild);
    }
    loadMenuTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadMenuEvent(cell.column.definition[option], e, cell);
    }
    loadMenuTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadMenuEvent(column.definition[option], e, column);
    }
    loadMenuEvent(menu, e, component) {
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        menu = typeof menu == "function" ? menu.call(this.table, e, component.getComponent()) : menu;
        this.loadMenu(e, component, menu);
    }
    loadMenu(e, component, menu, parentEl, parentPopup) {
        var touch = !(e instanceof MouseEvent), menuEl = document.createElement("div"), popup;
        menuEl.classList.add("tabulator-menu");
        if (!touch) e.preventDefault();
        //abort if no menu set
        if (!menu || !menu.length) return;
        if (!parentEl) {
            if (this.nestedMenuBlock) {
                //abort if child menu already open
                if (this.rootPopup) return;
            } else this.nestedMenuBlock = setTimeout(()=>{
                this.nestedMenuBlock = false;
            }, 100);
            if (this.rootPopup) this.rootPopup.hide();
            this.rootPopup = popup = this.popup(menuEl);
        } else popup = parentPopup.child(menuEl);
        menu.forEach((item)=>{
            var itemEl = document.createElement("div"), label = item.label, disabled = item.disabled;
            if (item.separator) itemEl.classList.add("tabulator-menu-separator");
            else {
                itemEl.classList.add("tabulator-menu-item");
                if (typeof label == "function") label = label.call(this.table, component.getComponent());
                if (label instanceof Node) itemEl.appendChild(label);
                else itemEl.innerHTML = label;
                if (typeof disabled == "function") disabled = disabled.call(this.table, component.getComponent());
                if (disabled) {
                    itemEl.classList.add("tabulator-menu-item-disabled");
                    itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                    });
                } else {
                    if (item.menu && item.menu.length) itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                        this.loadMenu(e, component, item.menu, itemEl, popup);
                    });
                    else if (item.action) itemEl.addEventListener("click", (e)=>{
                        item.action(e, component.getComponent());
                    });
                }
                if (item.menu && item.menu.length) itemEl.classList.add("tabulator-menu-item-submenu");
            }
            menuEl.appendChild(itemEl);
        });
        menuEl.addEventListener("click", (e)=>{
            if (this.rootPopup) this.rootPopup.hide();
        });
        popup.show(parentEl || e);
        if (popup === this.rootPopup) {
            this.rootPopup.hideOnBlur(()=>{
                this.rootPopup = null;
                if (this.currentComponent) {
                    this.dispatch("menu-closed", menu, popup);
                    this.dispatchExternal("menuClosed", this.currentComponent.getComponent());
                    this.currentComponent = null;
                }
            });
            this.currentComponent = component;
            this.dispatch("menu-opened", menu, popup);
            this.dispatchExternal("menuOpened", component.getComponent());
        }
    }
}
class $c2a9788f40f9c90a$export$9ab7496e9b38c128 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveColumn";
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating column header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 250; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving column
        this.toCol = false; //destination column
        this.toColAfter = false; //position of moving column relative to the destination column
        this.startX = 0; //starting position within header element
        this.autoScrollMargin = 40; //auto scroll on edge when within margin
        this.autoScrollStep = 5; //auto scroll distance in pixels
        this.autoScrollTimeout = false; //auto scroll timeout
        this.touchMove = false;
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.registerTableOption("movableColumns", false); //enable movable columns
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.classList.add("tabulator-col-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableColumns) {
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("alert-show", this.abortMove.bind(this));
        }
    }
    abortMove() {
        clearTimeout(this.checkTimeout);
    }
    initializeColumn(column) {
        var self = this, config = {}, colEl;
        if (!column.modules.frozen && !column.isGroup && !column.isRowHeader) {
            colEl = column.getElement();
            config.mousemove = (function(e) {
                if (column.parent === self.moving.parent) {
                    if ((self.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(colEl).left + self.table.columnManager.contentsElement.scrollLeft > column.getWidth() / 2) {
                        if (self.toCol !== column || !self.toColAfter) {
                            colEl.parentNode.insertBefore(self.placeholderElement, colEl.nextSibling);
                            self.moveColumn(column, true);
                        }
                    } else if (self.toCol !== column || self.toColAfter) {
                        colEl.parentNode.insertBefore(self.placeholderElement, colEl);
                        self.moveColumn(column, false);
                    }
                }
            }).bind(self);
            colEl.addEventListener("mousedown", function(e) {
                self.touchMove = false;
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, column);
                }, self.checkPeriod);
            });
            colEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            self.bindTouchEvents(column);
        }
        column.modules.moveColumn = config;
    }
    bindTouchEvents(column) {
        var colEl = column.getElement(), startXMove = false, nextCol, prevCol, nextColWidth, prevColWidth, nextColWidthLast, prevColWidthLast;
        colEl.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextCol = column.nextColumn();
                nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                prevCol = column.prevColumn();
                prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                nextColWidthLast = 0;
                prevColWidthLast = 0;
                startXMove = false;
                this.startMove(e, column);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        colEl.addEventListener("touchmove", (e)=>{
            var diff, moveToCol;
            if (this.moving) {
                this.moveHover(e);
                if (!startXMove) startXMove = e.touches[0].pageX;
                diff = e.touches[0].pageX - startXMove;
                if (diff > 0) {
                    if (nextCol && diff - nextColWidthLast > nextColWidth) {
                        moveToCol = nextCol;
                        if (moveToCol !== column) {
                            startXMove = e.touches[0].pageX;
                            moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement().nextSibling);
                            this.moveColumn(moveToCol, true);
                        }
                    }
                } else if (prevCol && -diff - prevColWidthLast > prevColWidth) {
                    moveToCol = prevCol;
                    if (moveToCol !== column) {
                        startXMove = e.touches[0].pageX;
                        moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement());
                        this.moveColumn(moveToCol, false);
                    }
                }
                if (moveToCol) {
                    nextCol = moveToCol.nextColumn();
                    nextColWidthLast = nextColWidth;
                    nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                    prevCol = moveToCol.prevColumn();
                    prevColWidthLast = prevColWidth;
                    prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                }
            }
        }, {
            passive: true
        });
        colEl.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) this.endMove(e);
        });
    }
    startMove(e, column) {
        var element = column.getElement(), headerElement = this.table.columnManager.getContentsElement(), headersElement = this.table.columnManager.getHeadersElement();
        //Prevent moving columns when range selection is active
        if (this.table.modules.selectRange && this.table.modules.selectRange.columnSelection) {
            if (this.table.modules.selectRange.mousedown && this.table.modules.selectRange.selecting === "column") return;
        }
        this.moving = column;
        this.startX = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(element).left;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = column.getWidth() + "px";
        this.placeholderElement.style.height = column.getHeight() + "px";
        element.parentNode.insertBefore(this.placeholderElement, element);
        element.parentNode.removeChild(element);
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        headerElement.appendChild(this.hoverElement);
        this.hoverElement.style.left = "0";
        this.hoverElement.style.bottom = headerElement.clientHeight - headersElement.offsetHeight + "px";
        if (!this.touchMove) {
            this._bindMouseMove();
            document.body.addEventListener("mousemove", this.moveHover);
            document.body.addEventListener("mouseup", this.endMove);
        }
        this.moveHover(e);
        this.dispatch("column-moving", e, this.moving);
    }
    _bindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().addEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().removeEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    moveColumn(column, after) {
        var movingCells = this.moving.getCells();
        this.toCol = column;
        this.toColAfter = after;
        if (after) column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl.nextSibling);
        });
        else column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl);
        });
    }
    endMove(e) {
        if (e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
            this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toCol) this.table.columnManager.moveColumnActual(this.moving, this.toCol, this.toColAfter);
            this.moving = false;
            this.toCol = false;
            this.toColAfter = false;
            if (!this.touchMove) {
                document.body.removeEventListener("mousemove", this.moveHover);
                document.body.removeEventListener("mouseup", this.endMove);
            }
        }
    }
    moveHover(e) {
        var columnHolder = this.table.columnManager.getContentsElement(), scrollLeft = columnHolder.scrollLeft, xPos = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(columnHolder).left + scrollLeft, scrollPos;
        this.hoverElement.style.left = xPos - this.startX + "px";
        if (xPos - scrollLeft < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.max(0, scrollLeft - 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
        if (scrollLeft + columnHolder.clientWidth - xPos < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.min(columnHolder.clientWidth, scrollLeft + 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultSenders = {
    delete: function(fromRow, toRow, toTable) {
        fromRow.delete();
    }
};
var $c2a9788f40f9c90a$var$defaultReceivers = {
    insert: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData(), undefined, toRow);
        return true;
    },
    add: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData());
        return true;
    },
    update: function(fromRow, toRow, fromTable) {
        if (toRow) {
            toRow.update(fromRow.getData());
            return true;
        }
        return false;
    },
    replace: function(fromRow, toRow, fromTable) {
        if (toRow) {
            this.table.addRow(fromRow.getData(), undefined, toRow);
            toRow.delete();
            return true;
        }
        return false;
    }
};
class $c2a9788f40f9c90a$export$7815d73158f0bb2d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveRow";
    //load defaults
    static senders = $c2a9788f40f9c90a$var$defaultSenders;
    static receivers = $c2a9788f40f9c90a$var$defaultReceivers;
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating row header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 150; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving row
        this.toRow = false; //destination row
        this.toRowAfter = false; //position of moving row relative to the destination row
        this.hasHandle = false; //row has handle instead of fully movable row
        this.startY = 0; //starting Y position within header element
        this.startX = 0; //starting X position within header element
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.tableRowDropEvent = false;
        this.touchMove = false;
        this.connection = false;
        this.connectionSelectorsTables = false;
        this.connectionSelectorsElements = false;
        this.connectionElements = [];
        this.connections = [];
        this.connectedTable = false;
        this.connectedRow = false;
        this.registerTableOption("movableRows", false); //enable movable rows
        this.registerTableOption("movableRowsConnectedTables", false); //tables for movable rows to be connected to
        this.registerTableOption("movableRowsConnectedElements", false); //other elements for movable rows to be connected to
        this.registerTableOption("movableRowsSender", false);
        this.registerTableOption("movableRowsReceiver", "insert");
        this.registerColumnOption("rowHandle");
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.classList.add("tabulator-row-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableRows) {
            this.connectionSelectorsTables = this.table.options.movableRowsConnectedTables;
            this.connectionSelectorsElements = this.table.options.movableRowsConnectedElements;
            this.connection = this.connectionSelectorsTables || this.connectionSelectorsElements;
            this.subscribe("cell-init", this.initializeCell.bind(this));
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("row-init", this.initializeRow.bind(this));
        }
    }
    initializeGroupHeader(group) {
        var self = this, config = {};
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, group);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl;
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(group.element).top + self.table.rowManager.element.scrollTop > group.getHeight() / 2) {
                if (self.toRow !== group || !self.toRowAfter) {
                    rowEl = group.getElement();
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(group, true);
                }
            } else if (self.toRow !== group || self.toRowAfter) {
                rowEl = group.getElement();
                if (rowEl.previousSibling) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                    self.moveRow(group, false);
                }
            }
        }).bind(self);
        group.modules.moveRow = config;
    }
    initializeRow(row) {
        var self = this, config = {}, rowEl;
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, row);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl = row.getElement();
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top + self.table.rowManager.element.scrollTop > row.getHeight() / 2) {
                if (self.toRow !== row || !self.toRowAfter) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(row, true);
                }
            } else if (self.toRow !== row || self.toRowAfter) {
                rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                self.moveRow(row, false);
            }
        }).bind(self);
        if (!this.hasHandle) {
            rowEl = row.getElement();
            rowEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, row);
                }, self.checkPeriod);
            });
            rowEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(row, row.getElement());
        }
        row.modules.moveRow = config;
    }
    initializeColumn(column) {
        if (column.definition.rowHandle && this.table.options.movableRows !== false) this.hasHandle = true;
    }
    initializeCell(cell) {
        if (cell.column.definition.rowHandle && this.table.options.movableRows !== false) {
            var self = this, cellEl = cell.getElement(true);
            cellEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, cell.row);
                }, self.checkPeriod);
            });
            cellEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(cell.row, cellEl);
        }
    }
    bindTouchEvents(row, element) {
        var startYMove = false, nextRow, prevRow, nextRowHeight, prevRowHeight, nextRowHeightLast, prevRowHeightLast;
        element.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextRow = row.nextRow();
                nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                prevRow = row.prevRow();
                prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                nextRowHeightLast = 0;
                prevRowHeightLast = 0;
                startYMove = false;
                this.startMove(e, row);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        this.moving, this.toRow, this.toRowAfter;
        element.addEventListener("touchmove", (e)=>{
            var diff, moveToRow;
            if (this.moving) {
                e.preventDefault();
                this.moveHover(e);
                if (!startYMove) startYMove = e.touches[0].pageY;
                diff = e.touches[0].pageY - startYMove;
                if (diff > 0) {
                    if (nextRow && diff - nextRowHeightLast > nextRowHeight) {
                        moveToRow = nextRow;
                        if (moveToRow !== row) {
                            startYMove = e.touches[0].pageY;
                            moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement().nextSibling);
                            this.moveRow(moveToRow, true);
                        }
                    }
                } else if (prevRow && -diff - prevRowHeightLast > prevRowHeight) {
                    moveToRow = prevRow;
                    if (moveToRow !== row) {
                        startYMove = e.touches[0].pageY;
                        moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement());
                        this.moveRow(moveToRow, false);
                    }
                }
                if (moveToRow) {
                    nextRow = moveToRow.nextRow();
                    nextRowHeightLast = nextRowHeight;
                    nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                    prevRow = moveToRow.prevRow();
                    prevRowHeightLast = prevRowHeight;
                    prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                }
            }
        });
        element.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) {
                this.endMove(e);
                this.touchMove = false;
            }
        });
    }
    _bindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().addEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().removeEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    startMove(e, row) {
        var element = row.getElement();
        this.setStartPosition(e, row);
        this.moving = row;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = row.getWidth() + "px";
        this.placeholderElement.style.height = row.getHeight() + "px";
        if (!this.connection) {
            element.parentNode.insertBefore(this.placeholderElement, element);
            element.parentNode.removeChild(element);
        } else {
            this.table.element.classList.add("tabulator-movingrow-sending");
            this.connectToTables(row);
        }
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        if (this.connection) {
            document.body.appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this.hoverElement.style.width = this.table.element.clientWidth + "px";
            this.hoverElement.style.whiteSpace = "nowrap";
            this.hoverElement.style.overflow = "hidden";
            this.hoverElement.style.pointerEvents = "none";
        } else {
            this.table.rowManager.getTableElement().appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this._bindMouseMove();
        }
        document.body.addEventListener("mousemove", this.moveHover);
        document.body.addEventListener("mouseup", this.endMove);
        this.dispatchExternal("rowMoving", row.getComponent());
        this.moveHover(e);
    }
    setStartPosition(e, row) {
        var pageX = this.touchMove ? e.touches[0].pageX : e.pageX, pageY = this.touchMove ? e.touches[0].pageY : e.pageY, element, position;
        element = row.getElement();
        if (this.connection) {
            position = element.getBoundingClientRect();
            this.startX = position.left - pageX + window.pageXOffset;
            this.startY = position.top - pageY + window.pageYOffset;
        } else this.startY = pageY - element.getBoundingClientRect().top;
    }
    endMove(e) {
        if (!e || e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            if (!this.connection) {
                this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
                this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            }
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toRow) this.table.rowManager.moveRow(this.moving, this.toRow, this.toRowAfter);
            else this.dispatchExternal("rowMoveCancelled", this.moving.getComponent());
            this.moving = false;
            this.toRow = false;
            this.toRowAfter = false;
            document.body.removeEventListener("mousemove", this.moveHover);
            document.body.removeEventListener("mouseup", this.endMove);
            if (this.connection) {
                this.table.element.classList.remove("tabulator-movingrow-sending");
                this.disconnectFromTables();
            }
        }
    }
    moveRow(row, after) {
        this.toRow = row;
        this.toRowAfter = after;
    }
    moveHover(e) {
        if (this.connection) this.moveHoverConnections.call(this, e);
        else this.moveHoverTable.call(this, e);
    }
    moveHoverTable(e) {
        var rowHolder = this.table.rowManager.getElement(), scrollTop = rowHolder.scrollTop, yPos = (this.touchMove ? e.touches[0].pageY : e.pageY) - rowHolder.getBoundingClientRect().top + scrollTop;
        this.hoverElement.style.top = Math.min(yPos - this.startY, this.table.rowManager.element.scrollHeight - this.hoverElement.offsetHeight) + "px";
    }
    moveHoverConnections(e) {
        this.hoverElement.style.left = this.startX + (this.touchMove ? e.touches[0].pageX : e.pageX) + "px";
        this.hoverElement.style.top = this.startY + (this.touchMove ? e.touches[0].pageY : e.pageY) + "px";
    }
    elementRowDrop(e, element, row) {
        this.dispatchExternal("movableRowsElementDrop", e, element, row ? row.getComponent() : false);
    }
    //establish connection with other tables
    connectToTables(row) {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStart", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "connect", {
                row: row
            });
        }
        if (this.connectionSelectorsElements) {
            this.connectionElements = [];
            if (!Array.isArray(this.connectionSelectorsElements)) this.connectionSelectorsElements = [
                this.connectionSelectorsElements
            ];
            this.connectionSelectorsElements.forEach((query)=>{
                if (typeof query === "string") this.connectionElements = this.connectionElements.concat(Array.prototype.slice.call(document.querySelectorAll(query)));
                else this.connectionElements.push(query);
            });
            this.connectionElements.forEach((element)=>{
                var dropEvent = (e)=>{
                    this.elementRowDrop(e, element, this.moving);
                };
                element.addEventListener("mouseup", dropEvent);
                element.tabulatorElementDropEvent = dropEvent;
                element.classList.add("tabulator-movingrow-receiving");
            });
        }
    }
    //disconnect from other tables
    disconnectFromTables() {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStop", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "disconnect");
        }
        this.connectionElements.forEach((element)=>{
            element.classList.remove("tabulator-movingrow-receiving");
            element.removeEventListener("mouseup", element.tabulatorElementDropEvent);
            delete element.tabulatorElementDropEvent;
        });
    }
    //accept incomming connection
    connect(table, row) {
        if (!this.connectedTable) {
            this.connectedTable = table;
            this.connectedRow = row;
            this.table.element.classList.add("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().addEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.tableRowDropEvent = this.tableRowDrop.bind(this);
            this.table.element.addEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStart", row, table);
            return true;
        } else {
            console.warn("Move Row Error - Table cannot accept connection, already connected to table:", this.connectedTable);
            return false;
        }
    }
    //close incoming connection
    disconnect(table) {
        if (table === this.connectedTable) {
            this.connectedTable = false;
            this.connectedRow = false;
            this.table.element.classList.remove("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().removeEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.table.element.removeEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStop", table);
        } else console.warn("Move Row Error - trying to disconnect from non connected table");
    }
    dropComplete(table, row, success) {
        var sender = false;
        if (success) {
            switch(typeof this.table.options.movableRowsSender){
                case "string":
                    sender = $c2a9788f40f9c90a$export$7815d73158f0bb2d.senders[this.table.options.movableRowsSender];
                    break;
                case "function":
                    sender = this.table.options.movableRowsSender;
                    break;
            }
            if (sender) sender.call(this, this.moving ? this.moving.getComponent() : undefined, row ? row.getComponent() : undefined, table);
            else if (this.table.options.movableRowsSender) console.warn("Mover Row Error - no matching sender found:", this.table.options.movableRowsSender);
            this.dispatchExternal("movableRowsSent", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        } else this.dispatchExternal("movableRowsSentFailed", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        this.endMove();
    }
    tableRowDrop(e, row) {
        var receiver = false, success = false;
        e.stopImmediatePropagation();
        switch(typeof this.table.options.movableRowsReceiver){
            case "string":
                receiver = $c2a9788f40f9c90a$export$7815d73158f0bb2d.receivers[this.table.options.movableRowsReceiver];
                break;
            case "function":
                receiver = this.table.options.movableRowsReceiver;
                break;
        }
        if (receiver) success = receiver.call(this, this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else console.warn("Mover Row Error - no matching receiver found:", this.table.options.movableRowsReceiver);
        if (success) this.dispatchExternal("movableRowsReceived", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else this.dispatchExternal("movableRowsReceivedFailed", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        this.commsSend(this.connectedTable, "moveRow", "dropcomplete", {
            row: row,
            success: success
        });
    }
    commsReceived(table, action, data) {
        switch(action){
            case "connect":
                return this.connect(table, data.row);
            case "disconnect":
                return this.disconnect(table);
            case "dropcomplete":
                return this.dropComplete(table, data.row, data.success);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultMutators = {};
class $c2a9788f40f9c90a$export$d0f669567356cabd extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "mutator";
    //load defaults
    static mutators = $c2a9788f40f9c90a$var$defaultMutators;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "edit",
            "clipboard",
            "import"
        ]; //list of mutation types
        this.enabled = true;
        this.registerColumnOption("mutator");
        this.registerColumnOption("mutatorParams");
        this.registerColumnOption("mutatorData");
        this.registerColumnOption("mutatorDataParams");
        this.registerColumnOption("mutatorEdit");
        this.registerColumnOption("mutatorEditParams");
        this.registerColumnOption("mutatorClipboard");
        this.registerColumnOption("mutatorClipboardParams");
        this.registerColumnOption("mutatorImport");
        this.registerColumnOption("mutatorImportParams");
        this.registerColumnOption("mutateLink");
    }
    initialize() {
        this.subscribe("cell-value-changing", this.transformCell.bind(this));
        this.subscribe("cell-value-changed", this.mutateLink.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-init-before", this.rowDataChanged.bind(this));
        this.subscribe("row-data-changing", this.rowDataChanged.bind(this));
    }
    rowDataChanged(row, tempData, updatedData) {
        return this.transformRow(tempData, "data", updatedData);
    }
    //initialize column mutator
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), mutator;
            if (column.definition[key]) {
                mutator = this.lookupMutator(column.definition[key]);
                if (mutator) {
                    match = true;
                    config[key] = {
                        mutator: mutator,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.mutate = config;
    }
    lookupMutator(value) {
        var mutator = false;
        //set column mutator
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value]) mutator = $c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value];
                else console.warn("Mutator Error - No such mutator found, ignoring: ", value);
                break;
            case "function":
                mutator = value;
                break;
        }
        return mutator;
    }
    //apply mutator to row
    transformRow(data, type, updatedData) {
        var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), value;
        // console.log("key", key)
        if (this.enabled) this.table.columnManager.traverse((column)=>{
            var mutator, params, component;
            if (column.modules.mutate) {
                mutator = column.modules.mutate[key] || column.modules.mutate.mutator || false;
                if (mutator) {
                    value = column.getFieldValue(typeof updatedData !== "undefined" ? updatedData : data);
                    if (type == "data" && !updatedData || typeof value !== "undefined") {
                        component = column.getComponent();
                        params = typeof mutator.params === "function" ? mutator.params(value, data, type, component) : mutator.params;
                        column.setFieldValue(data, mutator.mutator(value, data, type, params, component));
                    }
                }
            }
        });
        return data;
    }
    //apply mutator to new cell value
    transformCell(cell, value) {
        if (cell.column.modules.mutate) {
            var mutator = cell.column.modules.mutate.mutatorEdit || cell.column.modules.mutate.mutator || false, tempData = {};
            if (mutator) {
                tempData = Object.assign(tempData, cell.row.getData());
                cell.column.setFieldValue(tempData, value);
                return mutator.mutator(value, tempData, "edit", mutator.params, cell.getComponent());
            }
        }
        return value;
    }
    mutateLink(cell) {
        var links = cell.column.definition.mutateLink;
        if (links) {
            if (!Array.isArray(links)) links = [
                links
            ];
            links.forEach((link)=>{
                var linkCell = cell.row.getCell(link);
                if (linkCell) linkCell.setValue(linkCell.getValue(), true, true);
            });
        }
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
function $c2a9788f40f9c90a$var$rows(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|rows", (value)=>{
        rowsEl.innerHTML = value;
    });
    if (totalRows) {
        valueEl.innerHTML = " " + currentRow + "-" + Math.min(currentRow + pageSize - 1, totalRows) + " ";
        totalEl.innerHTML = " " + totalRows + " ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(ofEl);
        el.appendChild(totalEl);
        el.appendChild(rowsEl);
    } else {
        valueEl.innerHTML = " 0 ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(rowsEl);
    }
    return el;
}
function $c2a9788f40f9c90a$var$pages(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    valueEl.innerHTML = " " + currentPage + " ";
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    totalEl.innerHTML = " " + totalPages + " ";
    this.table.modules.localize.langBind("pagination|counter|pages", (value)=>{
        rowsEl.innerHTML = value;
    });
    el.appendChild(showingEl);
    el.appendChild(valueEl);
    el.appendChild(ofEl);
    el.appendChild(totalEl);
    el.appendChild(rowsEl);
    return el;
}
var $c2a9788f40f9c90a$var$defaultPageCounters = {
    rows: $c2a9788f40f9c90a$var$rows,
    pages: $c2a9788f40f9c90a$var$pages
};
class $c2a9788f40f9c90a$export$7eba6c45a494ceac extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "page";
    //load defaults
    static pageCounters = $c2a9788f40f9c90a$var$defaultPageCounters;
    constructor(table){
        super(table);
        this.mode = "local";
        this.progressiveLoad = false;
        this.element = null;
        this.pageCounterElement = null;
        this.pageCounter = null;
        this.size = 0;
        this.page = 1;
        this.count = 5;
        this.max = 1;
        this.remoteRowCountEstimate = null;
        this.initialLoad = true;
        this.dataChanging = false; //flag to check if data is being changed by this module
        this.pageSizes = [];
        this.registerTableOption("pagination", false); //set pagination type
        this.registerTableOption("paginationMode", "local"); //local or remote pagination
        this.registerTableOption("paginationSize", false); //set number of rows to a page
        this.registerTableOption("paginationInitialPage", 1); //initial page to show on load
        this.registerTableOption("paginationCounter", false); // set pagination counter
        this.registerTableOption("paginationCounterElement", false); // set pagination counter
        this.registerTableOption("paginationButtonCount", 5); // set count of page button
        this.registerTableOption("paginationSizeSelector", false); //add pagination size selector element
        this.registerTableOption("paginationElement", false); //element to hold pagination numbers
        // this.registerTableOption("paginationDataSent", {}); //pagination data sent to the server
        // this.registerTableOption("paginationDataReceived", {}); //pagination data received from the server
        this.registerTableOption("paginationAddRow", "page"); //add rows on table or page
        this.registerTableOption("paginationOutOfRange", false); //reset the current page when the last page < this.page, values: false|function|any value accepted by setPage()
        this.registerTableOption("progressiveLoad", false); //progressive loading
        this.registerTableOption("progressiveLoadDelay", 0); //delay between requests
        this.registerTableOption("progressiveLoadScrollMargin", 0); //margin before scroll begins
        this.registerTableFunction("setMaxPage", this.setMaxPage.bind(this));
        this.registerTableFunction("setPage", this.setPage.bind(this));
        this.registerTableFunction("setPageToRow", this.userSetPageToRow.bind(this));
        this.registerTableFunction("setPageSize", this.userSetPageSize.bind(this));
        this.registerTableFunction("getPageSize", this.getPageSize.bind(this));
        this.registerTableFunction("previousPage", this.previousPage.bind(this));
        this.registerTableFunction("nextPage", this.nextPage.bind(this));
        this.registerTableFunction("getPage", this.getPage.bind(this));
        this.registerTableFunction("getPageMax", this.getPageMax.bind(this));
        //register component functions
        this.registerComponentFunction("row", "pageTo", this.setPageToRow.bind(this));
    }
    initialize() {
        if (this.table.options.pagination) {
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("row-added", this.rowsUpdated.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("footer-redraw", this.footerRedraw.bind(this));
            if (this.table.options.paginationAddRow == "page") this.subscribe("row-adding-position", this.rowAddingPosition.bind(this));
            if (this.table.options.paginationMode === "remote") {
                this.subscribe("data-params", this.remotePageParams.bind(this));
                this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            }
            if (this.table.options.progressiveLoad) console.error("Progressive Load Error - Pagination and progressive load cannot be used at the same time");
            this.registerDisplayHandler(this.restOnRenderBefore.bind(this), 40);
            this.registerDisplayHandler(this.getRows.bind(this), 50);
            this.createElements();
            this.initializePageCounter();
            this.initializePaginator();
        } else if (this.table.options.progressiveLoad) {
            this.subscribe("data-params", this.remotePageParams.bind(this));
            this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.initializeProgressive(this.table.options.progressiveLoad);
            if (this.table.options.progressiveLoad === "scroll") this.subscribe("scroll-vertical", this.scrollVertical.bind(this));
        }
    }
    rowAddingPosition(row, top) {
        var rowManager = this.table.rowManager, displayRows = rowManager.getDisplayRows(), index;
        if (top) {
            if (displayRows.length) index = displayRows[0];
            else if (rowManager.activeRows.length) {
                index = rowManager.activeRows[rowManager.activeRows.length - 1];
                top = false;
            }
        } else if (displayRows.length) {
            index = displayRows[displayRows.length - 1];
            top = displayRows.length < this.size ? false : true;
        }
        return {
            index: index,
            top: top
        };
    }
    calculatePageSizes() {
        var testElRow, testElCell;
        if (this.table.options.paginationSize) this.size = this.table.options.paginationSize;
        else {
            testElRow = document.createElement("div");
            testElRow.classList.add("tabulator-row");
            testElRow.style.visibility = "hidden";
            testElCell = document.createElement("div");
            testElCell.classList.add("tabulator-cell");
            testElCell.innerHTML = "Page Row Test";
            testElRow.appendChild(testElCell);
            this.table.rowManager.getTableElement().appendChild(testElRow);
            this.size = Math.floor(this.table.rowManager.getElement().clientHeight / testElRow.offsetHeight);
            this.table.rowManager.getTableElement().removeChild(testElRow);
        }
        this.dispatchExternal("pageSizeChanged", this.size);
        this.generatePageSizeSelectList();
    }
    initialLoadComplete() {
        this.initialLoad = false;
    }
    remotePageParams(data, config, silent, params) {
        if (!this.initialLoad) {
            if (this.progressiveLoad && !silent || !this.progressiveLoad && !this.dataChanging) this.reset(true);
        }
        //configure request params
        params.page = this.page;
        //set page size if defined
        if (this.size) params.size = this.size;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetPageToRow(row) {
        if (this.table.options.pagination) {
            row = this.table.rowManager.findRow(row);
            if (row) return this.setPageToRow(row);
        }
        return Promise.reject();
    }
    userSetPageSize(size) {
        if (this.table.options.pagination) {
            this.setPageSize(size);
            return this.setPage(1);
        } else return false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    scrollVertical(top, dir) {
        var element, diff, margin;
        if (!dir && !this.table.dataLoader.loading) {
            element = this.table.rowManager.getElement();
            diff = element.scrollHeight - element.clientHeight - top;
            margin = this.table.options.progressiveLoadScrollMargin || element.clientHeight * 2;
            if (diff < margin) this.nextPage().catch(()=>{}); //consume the exception thrown when on the last page
        }
    }
    restOnRenderBefore(rows, renderInPosition) {
        if (!renderInPosition) {
            if (this.mode === "local") this.reset();
        }
        return rows;
    }
    rowsUpdated() {
        this.refreshData(true, "all");
    }
    createElements() {
        var button;
        this.element = document.createElement("span");
        this.element.classList.add("tabulator-paginator");
        this.pagesElement = document.createElement("span");
        this.pagesElement.classList.add("tabulator-pages");
        button = document.createElement("button");
        button.classList.add("tabulator-page");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "");
        button.setAttribute("title", "");
        this.firstBut = button.cloneNode(true);
        this.firstBut.setAttribute("data-page", "first");
        this.prevBut = button.cloneNode(true);
        this.prevBut.setAttribute("data-page", "prev");
        this.nextBut = button.cloneNode(true);
        this.nextBut.setAttribute("data-page", "next");
        this.lastBut = button.cloneNode(true);
        this.lastBut.setAttribute("data-page", "last");
        if (this.table.options.paginationSizeSelector) {
            this.pageSizeSelect = document.createElement("select");
            this.pageSizeSelect.classList.add("tabulator-page-size");
        }
    }
    generatePageSizeSelectList() {
        var pageSizes = [];
        if (this.pageSizeSelect) {
            if (Array.isArray(this.table.options.paginationSizeSelector)) {
                pageSizes = this.table.options.paginationSizeSelector;
                this.pageSizes = pageSizes;
                if (this.pageSizes.indexOf(this.size) == -1) pageSizes.unshift(this.size);
            } else if (this.pageSizes.indexOf(this.size) == -1) {
                pageSizes = [];
                for(let i = 1; i < 5; i++)pageSizes.push(this.size * i);
                this.pageSizes = pageSizes;
            } else pageSizes = this.pageSizes;
            while(this.pageSizeSelect.firstChild)this.pageSizeSelect.removeChild(this.pageSizeSelect.firstChild);
            pageSizes.forEach((item)=>{
                var itemEl = document.createElement("option");
                itemEl.value = item;
                if (item === true) this.langBind("pagination|all", function(value) {
                    itemEl.innerHTML = value;
                });
                else itemEl.innerHTML = item;
                this.pageSizeSelect.appendChild(itemEl);
            });
            this.pageSizeSelect.value = this.size;
        }
    }
    initializePageCounter() {
        var counter = this.table.options.paginationCounter, pageCounter = null;
        if (counter) {
            if (typeof counter === "function") pageCounter = counter;
            else pageCounter = $c2a9788f40f9c90a$export$7eba6c45a494ceac.pageCounters[counter];
            if (pageCounter) {
                this.pageCounter = pageCounter;
                this.pageCounterElement = document.createElement("span");
                this.pageCounterElement.classList.add("tabulator-page-counter");
            } else console.warn("Pagination Error - No such page counter found: ", counter);
        }
    }
    //setup pagination
    initializePaginator(hidden) {
        var pageSelectLabel, paginationCounterHolder;
        if (!hidden) {
            //build pagination element
            //bind localizations
            this.langBind("pagination|first", (value)=>{
                this.firstBut.innerHTML = value;
            });
            this.langBind("pagination|first_title", (value)=>{
                this.firstBut.setAttribute("aria-label", value);
                this.firstBut.setAttribute("title", value);
            });
            this.langBind("pagination|prev", (value)=>{
                this.prevBut.innerHTML = value;
            });
            this.langBind("pagination|prev_title", (value)=>{
                this.prevBut.setAttribute("aria-label", value);
                this.prevBut.setAttribute("title", value);
            });
            this.langBind("pagination|next", (value)=>{
                this.nextBut.innerHTML = value;
            });
            this.langBind("pagination|next_title", (value)=>{
                this.nextBut.setAttribute("aria-label", value);
                this.nextBut.setAttribute("title", value);
            });
            this.langBind("pagination|last", (value)=>{
                this.lastBut.innerHTML = value;
            });
            this.langBind("pagination|last_title", (value)=>{
                this.lastBut.setAttribute("aria-label", value);
                this.lastBut.setAttribute("title", value);
            });
            //click bindings
            this.firstBut.addEventListener("click", ()=>{
                this.setPage(1);
            });
            this.prevBut.addEventListener("click", ()=>{
                this.previousPage();
            });
            this.nextBut.addEventListener("click", ()=>{
                this.nextPage();
            });
            this.lastBut.addEventListener("click", ()=>{
                this.setPage(this.max);
            });
            if (this.table.options.paginationElement) this.element = this.table.options.paginationElement;
            if (this.pageSizeSelect) {
                pageSelectLabel = document.createElement("label");
                this.langBind("pagination|page_size", (value)=>{
                    this.pageSizeSelect.setAttribute("aria-label", value);
                    this.pageSizeSelect.setAttribute("title", value);
                    pageSelectLabel.innerHTML = value;
                });
                this.element.appendChild(pageSelectLabel);
                this.element.appendChild(this.pageSizeSelect);
                this.pageSizeSelect.addEventListener("change", (e)=>{
                    this.setPageSize(this.pageSizeSelect.value == "true" ? true : this.pageSizeSelect.value);
                    this.setPage(1);
                });
            }
            //append to DOM
            this.element.appendChild(this.firstBut);
            this.element.appendChild(this.prevBut);
            this.element.appendChild(this.pagesElement);
            this.element.appendChild(this.nextBut);
            this.element.appendChild(this.lastBut);
            if (!this.table.options.paginationElement) {
                if (this.table.options.paginationCounter) {
                    if (this.table.options.paginationCounterElement) {
                        if (this.table.options.paginationCounterElement instanceof HTMLElement) this.table.options.paginationCounterElement.appendChild(this.pageCounterElement);
                        else if (typeof this.table.options.paginationCounterElement === "string") {
                            paginationCounterHolder = document.querySelector(this.table.options.paginationCounterElement);
                            if (paginationCounterHolder) paginationCounterHolder.appendChild(this.pageCounterElement);
                            else console.warn("Pagination Error - Unable to find element matching paginationCounterElement selector:", this.table.options.paginationCounterElement);
                        }
                    } else this.footerAppend(this.pageCounterElement);
                }
                this.footerAppend(this.element);
            }
            this.page = this.table.options.paginationInitialPage;
            this.count = this.table.options.paginationButtonCount;
        }
        //set default values
        this.mode = this.table.options.paginationMode;
    }
    initializeProgressive(mode) {
        this.initializePaginator(true);
        this.mode = "progressive_" + mode;
        this.progressiveLoad = true;
    }
    trackChanges() {
        this.dispatch("page-changed");
    }
    //calculate maximum page from number of rows
    setMaxRows(rowCount) {
        if (!rowCount) this.max = 1;
        else this.max = this.size === true ? 1 : Math.ceil(rowCount / this.size);
        if (this.page > this.max) this.page = this.max;
    }
    //reset to first page without triggering action
    reset(force) {
        if (!this.initialLoad) {
            if (this.mode == "local" || force) {
                this.page = 1;
                this.trackChanges();
            }
        }
    }
    //set the maximum page
    setMaxPage(max) {
        max = parseInt(max);
        this.max = max || 1;
        if (this.page > this.max) {
            this.page = this.max;
            this.trigger();
        }
    }
    //set current page number
    setPage(page) {
        switch(page){
            case "first":
                return this.setPage(1);
            case "prev":
                return this.previousPage();
            case "next":
                return this.nextPage();
            case "last":
                return this.setPage(this.max);
        }
        page = parseInt(page);
        if (page > 0 && page <= this.max || this.mode !== "local") {
            this.page = page;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Requested page is out of range of 1 - " + this.max + ":", page);
            return Promise.reject();
        }
    }
    setPageToRow(row) {
        var rows = this.displayRows(-1);
        var index = rows.indexOf(row);
        if (index > -1) {
            var page = this.size === true ? 1 : Math.ceil((index + 1) / this.size);
            return this.setPage(page);
        } else {
            console.warn("Pagination Error - Requested row is not visible");
            return Promise.reject();
        }
    }
    setPageSize(size) {
        if (size !== true) size = parseInt(size);
        if (size > 0) {
            this.size = size;
            this.dispatchExternal("pageSizeChanged", size);
        }
        if (this.pageSizeSelect) // this.pageSizeSelect.value = size;
        this.generatePageSizeSelectList();
        this.trackChanges();
    }
    _setPageCounter(totalRows, size, currentRow) {
        var content;
        if (this.pageCounter) {
            if (this.mode === "remote") {
                size = this.size;
                currentRow = (this.page - 1) * this.size + 1;
                totalRows = this.remoteRowCountEstimate;
            }
            content = this.pageCounter.call(this, size, currentRow, this.page, totalRows, this.max);
            switch(typeof content){
                case "object":
                    if (content instanceof Node) {
                        //clear previous cell contents
                        while(this.pageCounterElement.firstChild)this.pageCounterElement.removeChild(this.pageCounterElement.firstChild);
                        this.pageCounterElement.appendChild(content);
                    } else {
                        this.pageCounterElement.innerHTML = "";
                        if (content != null) console.warn("Page Counter Error - Page Counter has returned a type of object, the only valid page counter object return is an instance of Node, the page counter returned:", content);
                    }
                    break;
                case "undefined":
                    this.pageCounterElement.innerHTML = "";
                    break;
                default:
                    this.pageCounterElement.innerHTML = content;
            }
        }
    }
    //setup the pagination buttons
    _setPageButtons() {
        let leftSize = Math.floor((this.count - 1) / 2);
        let rightSize = Math.ceil((this.count - 1) / 2);
        let min = this.max - this.page + leftSize + 1 < this.count ? this.max - this.count + 1 : Math.max(this.page - leftSize, 1);
        let max = this.page <= rightSize ? Math.min(this.count, this.max) : Math.min(this.page + rightSize, this.max);
        while(this.pagesElement.firstChild)this.pagesElement.removeChild(this.pagesElement.firstChild);
        if (this.page == 1) {
            this.firstBut.disabled = true;
            this.prevBut.disabled = true;
        } else {
            this.firstBut.disabled = false;
            this.prevBut.disabled = false;
        }
        if (this.page == this.max) {
            this.lastBut.disabled = true;
            this.nextBut.disabled = true;
        } else {
            this.lastBut.disabled = false;
            this.nextBut.disabled = false;
        }
        for(let i = min; i <= max; i++)if (i > 0 && i <= this.max) this.pagesElement.appendChild(this._generatePageButton(i));
        this.footerRedraw();
    }
    _generatePageButton(page) {
        var button = document.createElement("button");
        button.classList.add("tabulator-page");
        if (page == this.page) button.classList.add("active");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        this.langBind("pagination|page_title", (value)=>{
            button.setAttribute("aria-label", value + " " + page);
            button.setAttribute("title", value + " " + page);
        });
        button.setAttribute("data-page", page);
        button.textContent = page;
        button.addEventListener("click", (e)=>{
            this.setPage(page);
        });
        return button;
    }
    //previous page
    previousPage() {
        if (this.page > 1) {
            this.page--;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Previous page would be less than page 1:", 0);
            return Promise.reject();
        }
    }
    //next page
    nextPage() {
        if (this.page < this.max) {
            this.page++;
            this.trackChanges();
            return this.trigger();
        } else {
            if (!this.progressiveLoad) console.warn("Pagination Error - Next page would be greater than maximum page of " + this.max + ":", this.max + 1);
            return Promise.reject();
        }
    }
    //return current page number
    getPage() {
        return this.page;
    }
    //return max page number
    getPageMax() {
        return this.max;
    }
    getPageSize(size) {
        return this.size;
    }
    getMode() {
        return this.mode;
    }
    //return appropriate rows for current page
    getRows(data) {
        var actualRowPageSize = 0, output, start, end, actualStartRow;
        var actualRows = data.filter((row)=>{
            return row.type === "row";
        });
        if (this.mode == "local") {
            output = [];
            this.setMaxRows(data.length);
            if (this.size === true) {
                start = 0;
                end = data.length;
            } else {
                start = this.size * (this.page - 1);
                end = start + parseInt(this.size);
            }
            this._setPageButtons();
            for(let i = start; i < end; i++){
                let row = data[i];
                if (row) {
                    output.push(row);
                    if (row.type === "row") {
                        if (!actualStartRow) actualStartRow = row;
                        actualRowPageSize++;
                    }
                }
            }
            this._setPageCounter(actualRows.length, actualRowPageSize, actualStartRow ? actualRows.indexOf(actualStartRow) + 1 : 0);
            return output;
        } else {
            this._setPageButtons();
            this._setPageCounter(actualRows.length);
            return data.slice(0);
        }
    }
    trigger() {
        var left;
        switch(this.mode){
            case "local":
                left = this.table.rowManager.scrollLeft;
                this.refreshData();
                this.table.rowManager.scrollHorizontal(left);
                this.dispatchExternal("pageLoaded", this.getPage());
                return Promise.resolve();
            case "remote":
                this.dataChanging = true;
                return this.reloadData(null).finally(()=>{
                    this.dataChanging = false;
                });
            case "progressive_load":
            case "progressive_scroll":
                return this.reloadData(null, true);
            default:
                console.warn("Pagination Error - no such pagination mode:", this.mode);
                return Promise.reject();
        }
    }
    _parseRemoteData(data) {
        var margin, paginationOutOfRange;
        if (typeof data.last_page === "undefined") console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").last_page || "last_page") + "' property");
        if (data.data) {
            this.max = parseInt(data.last_page) || 1;
            this.remoteRowCountEstimate = typeof data.last_row !== "undefined" ? data.last_row : data.last_page * this.size - (this.page == data.last_page ? this.size - data.data.length : 0);
            if (this.progressiveLoad) {
                switch(this.mode){
                    case "progressive_load":
                        if (this.page == 1) this.table.rowManager.setData(data.data, false, this.page == 1);
                        else this.table.rowManager.addRows(data.data);
                        if (this.page < this.max) setTimeout(()=>{
                            this.nextPage();
                        }, this.table.options.progressiveLoadDelay);
                        break;
                    case "progressive_scroll":
                        data = this.page === 1 ? data.data : this.table.rowManager.getData().concat(data.data);
                        this.table.rowManager.setData(data, this.page !== 1, this.page == 1);
                        margin = this.table.options.progressiveLoadScrollMargin || this.table.rowManager.element.clientHeight * 2;
                        if (this.table.rowManager.element.scrollHeight <= this.table.rowManager.element.clientHeight + margin) {
                            if (this.page < this.max) setTimeout(()=>{
                                this.nextPage();
                            });
                        }
                        break;
                }
                return false;
            } else {
                if (this.page > this.max) {
                    console.warn("Remote Pagination Error - Server returned last page value lower than the current page");
                    paginationOutOfRange = this.options("paginationOutOfRange");
                    if (paginationOutOfRange) return this.setPage(typeof paginationOutOfRange === "function" ? paginationOutOfRange.call(this, this.page, this.max) : paginationOutOfRange);
                }
                // left = this.table.rowManager.scrollLeft;
                this.dispatchExternal("pageLoaded", this.getPage());
            // this.table.rowManager.scrollHorizontal(left);
            // this.table.columnManager.scrollHorizontal(left);
            }
        } else console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").data || "data") + "' property");
        return data.data;
    }
    //handle the footer element being redrawn
    footerRedraw() {
        var footer = this.table.footerManager.containerElement;
        if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = "none";
        else {
            this.pagesElement.style.display = "";
            if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = "none";
        }
    }
}
// read persistance information from storage
var $c2a9788f40f9c90a$var$defaultReaders = {
    local: function(id, type) {
        var data = localStorage.getItem(id + "-" + type);
        return data ? JSON.parse(data) : false;
    },
    cookie: function(id, type) {
        var cookie = document.cookie, key = id + "-" + type, cookiePos = cookie.indexOf(key + "="), end, data;
        //if cookie exists, decode and load column data into tabulator
        if (cookiePos > -1) {
            cookie = cookie.slice(cookiePos);
            end = cookie.indexOf(";");
            if (end > -1) cookie = cookie.slice(0, end);
            data = cookie.replace(key + "=", "");
        }
        return data ? JSON.parse(data) : false;
    }
};
//write persistence information to storage
var $c2a9788f40f9c90a$var$defaultWriters = {
    local: function(id, type, data) {
        localStorage.setItem(id + "-" + type, JSON.stringify(data));
    },
    cookie: function(id, type, data) {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 10000);
        document.cookie = id + "-" + type + "=" + JSON.stringify(data) + "; expires=" + expireDate.toUTCString();
    }
};
class $c2a9788f40f9c90a$export$6ce0215a06bec981 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "persistence";
    static moduleInitOrder = -10;
    //load defaults
    static readers = $c2a9788f40f9c90a$var$defaultReaders;
    static writers = $c2a9788f40f9c90a$var$defaultWriters;
    constructor(table){
        super(table);
        this.mode = "";
        this.id = "";
        // this.persistProps = ["field", "width", "visible"];
        this.defWatcherBlock = false;
        this.config = {};
        this.readFunc = false;
        this.writeFunc = false;
        this.registerTableOption("persistence", false);
        this.registerTableOption("persistenceID", ""); //key for persistent storage
        this.registerTableOption("persistenceMode", true); //mode for storing persistence information
        this.registerTableOption("persistenceReaderFunc", false); //function for handling persistence data reading
        this.registerTableOption("persistenceWriterFunc", false); //function for handling persistence data writing
    }
    // Test for whether localStorage is available for use.
    localStorageTest() {
        var testKey = "_tabulator_test";
        try {
            window.localStorage.setItem(testKey, testKey);
            window.localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    //setup parameters
    initialize() {
        if (this.table.options.persistence) {
            //determine persistent layout storage type
            var mode = this.table.options.persistenceMode, id = this.table.options.persistenceID, retrievedData;
            this.mode = mode !== true ? mode : this.localStorageTest() ? "local" : "cookie";
            if (this.table.options.persistenceReaderFunc) {
                if (typeof this.table.options.persistenceReaderFunc === "function") this.readFunc = this.table.options.persistenceReaderFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc];
                else console.warn("Persistence Read Error - invalid reader set", this.table.options.persistenceReaderFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode];
            else console.warn("Persistence Read Error - invalid reader set", this.mode);
            if (this.table.options.persistenceWriterFunc) {
                if (typeof this.table.options.persistenceWriterFunc === "function") this.writeFunc = this.table.options.persistenceWriterFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc];
                else console.warn("Persistence Write Error - invalid reader set", this.table.options.persistenceWriterFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode];
            else console.warn("Persistence Write Error - invalid writer set", this.mode);
            //set storage tag
            this.id = "tabulator-" + (id || this.table.element.getAttribute("id") || "");
            this.config = {
                sort: this.table.options.persistence === true || this.table.options.persistence.sort,
                filter: this.table.options.persistence === true || this.table.options.persistence.filter,
                headerFilter: this.table.options.persistence === true || this.table.options.persistence.headerFilter,
                group: this.table.options.persistence === true || this.table.options.persistence.group,
                page: this.table.options.persistence === true || this.table.options.persistence.page,
                columns: this.table.options.persistence === true ? [
                    "title",
                    "width",
                    "visible"
                ] : this.table.options.persistence.columns
            };
            //load pagination data if needed
            if (this.config.page) {
                retrievedData = this.retrieveData("page");
                if (retrievedData) {
                    if (typeof retrievedData.paginationSize !== "undefined" && (this.config.page === true || this.config.page.size)) this.table.options.paginationSize = retrievedData.paginationSize;
                    if (typeof retrievedData.paginationInitialPage !== "undefined" && (this.config.page === true || this.config.page.page)) this.table.options.paginationInitialPage = retrievedData.paginationInitialPage;
                }
            }
            //load group data if needed
            if (this.config.group) {
                retrievedData = this.retrieveData("group");
                if (retrievedData) {
                    if (typeof retrievedData.groupBy !== "undefined" && (this.config.group === true || this.config.group.groupBy)) this.table.options.groupBy = retrievedData.groupBy;
                    if (typeof retrievedData.groupStartOpen !== "undefined" && (this.config.group === true || this.config.group.groupStartOpen)) this.table.options.groupStartOpen = retrievedData.groupStartOpen;
                    if (typeof retrievedData.groupHeader !== "undefined" && (this.config.group === true || this.config.group.groupHeader)) this.table.options.groupHeader = retrievedData.groupHeader;
                }
            }
            if (this.config.columns) {
                this.table.options.columns = this.load("columns", this.table.options.columns);
                this.subscribe("column-init", this.initializeColumn.bind(this));
                this.subscribe("column-show", this.save.bind(this, "columns"));
                this.subscribe("column-hide", this.save.bind(this, "columns"));
                this.subscribe("column-moved", this.save.bind(this, "columns"));
            }
            this.subscribe("table-built", this.tableBuilt.bind(this), 0);
            this.subscribe("table-redraw", this.tableRedraw.bind(this));
            this.subscribe("filter-changed", this.eventSave.bind(this, "filter"));
            this.subscribe("filter-changed", this.eventSave.bind(this, "headerFilter"));
            this.subscribe("sort-changed", this.eventSave.bind(this, "sort"));
            this.subscribe("group-changed", this.eventSave.bind(this, "group"));
            this.subscribe("page-changed", this.eventSave.bind(this, "page"));
            this.subscribe("column-resized", this.eventSave.bind(this, "columns"));
            this.subscribe("column-width", this.eventSave.bind(this, "columns"));
            this.subscribe("layout-refreshed", this.eventSave.bind(this, "columns"));
        }
        this.registerTableFunction("getColumnLayout", this.getColumnLayout.bind(this));
        this.registerTableFunction("setColumnLayout", this.setColumnLayout.bind(this));
    }
    eventSave(type) {
        if (this.config[type]) this.save(type);
    }
    tableBuilt() {
        var sorters, filters, headerFilters;
        if (this.config.sort) {
            sorters = this.load("sort");
            if (!sorters === false) this.table.options.initialSort = sorters;
        }
        if (this.config.filter) {
            filters = this.load("filter");
            if (!filters === false) this.table.options.initialFilter = filters;
        }
        if (this.config.headerFilter) {
            headerFilters = this.load("headerFilter");
            if (!headerFilters === false) this.table.options.initialHeaderFilter = headerFilters;
        }
    }
    tableRedraw(force) {
        if (force && this.config.columns) this.save("columns");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    getColumnLayout() {
        return this.parseColumns(this.table.columnManager.getColumns());
    }
    setColumnLayout(layout) {
        this.table.columnManager.setColumns(this.mergeDefinition(this.table.options.columns, layout, true));
        return true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumn(column) {
        var def, keys;
        if (this.config.columns) {
            this.defWatcherBlock = true;
            def = column.getDefinition();
            keys = this.config.columns === true ? Object.keys(def) : this.config.columns;
            keys.forEach((key)=>{
                var props = Object.getOwnPropertyDescriptor(def, key);
                var value = def[key];
                if (props) Object.defineProperty(def, key, {
                    set: (newValue)=>{
                        value = newValue;
                        if (!this.defWatcherBlock) this.save("columns");
                        if (props.set) props.set(newValue);
                    },
                    get: ()=>{
                        if (props.get) props.get();
                        return value;
                    }
                });
            });
            this.defWatcherBlock = false;
        }
    }
    //load saved definitions
    load(type, current) {
        var data = this.retrieveData(type);
        if (current) data = data ? this.mergeDefinition(current, data) : current;
        return data;
    }
    //retrieve data from memory
    retrieveData(type) {
        return this.readFunc ? this.readFunc(this.id, type) : false;
    }
    //merge old and new column definitions
    mergeDefinition(oldCols, newCols, mergeAllNew) {
        var output = [];
        newCols = newCols || [];
        newCols.forEach((column, to)=>{
            var from = this._findColumn(oldCols, column), keys;
            if (from) {
                if (mergeAllNew) keys = Object.keys(column);
                else if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(from);
                    keys.push("width");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    if (key !== "columns" && typeof column[key] !== "undefined") from[key] = column[key];
                });
                if (from.columns) from.columns = this.mergeDefinition(from.columns, column.columns);
                output.push(from);
            }
        });
        oldCols.forEach((column, i)=>{
            var from = this._findColumn(newCols, column);
            if (!from) {
                if (output.length > i) output.splice(i, 0, column);
                else output.push(column);
            }
        });
        return output;
    }
    //find matching columns
    _findColumn(columns, subject) {
        var type = subject.columns ? "group" : subject.field ? "field" : "object";
        return columns.find(function(col) {
            switch(type){
                case "group":
                    return col.title === subject.title && col.columns.length === subject.columns.length;
                case "field":
                    return col.field === subject.field;
                case "object":
                    return col === subject;
            }
        });
    }
    //save data
    save(type) {
        var data = {};
        switch(type){
            case "columns":
                data = this.parseColumns(this.table.columnManager.getColumns());
                break;
            case "filter":
                data = this.table.modules.filter.getFilters();
                break;
            case "headerFilter":
                data = this.table.modules.filter.getHeaderFilters();
                break;
            case "sort":
                data = this.validateSorters(this.table.modules.sort.getSort());
                break;
            case "group":
                data = this.getGroupConfig();
                break;
            case "page":
                data = this.getPageConfig();
                break;
        }
        if (this.writeFunc) this.writeFunc(this.id, type, data);
    }
    //ensure sorters contain no function data
    validateSorters(data) {
        data.forEach(function(item) {
            item.column = item.field;
            delete item.field;
        });
        return data;
    }
    getGroupConfig() {
        var data = {};
        if (this.config.group) {
            if (this.config.group === true || this.config.group.groupBy) data.groupBy = this.table.options.groupBy;
            if (this.config.group === true || this.config.group.groupStartOpen) data.groupStartOpen = this.table.options.groupStartOpen;
            if (this.config.group === true || this.config.group.groupHeader) data.groupHeader = this.table.options.groupHeader;
        }
        return data;
    }
    getPageConfig() {
        var data = {};
        if (this.config.page) {
            if (this.config.page === true || this.config.page.size) data.paginationSize = this.table.modules.page.getPageSize();
            if (this.config.page === true || this.config.page.page) data.paginationInitialPage = this.table.modules.page.getPage();
        }
        return data;
    }
    //parse columns for data to store
    parseColumns(columns) {
        var definitions = [], excludedKeys = [
            "headerContextMenu",
            "headerMenu",
            "contextMenu",
            "clickMenu"
        ];
        columns.forEach((column)=>{
            var defStore = {}, colDef = column.getDefinition(), keys;
            if (column.isGroup) {
                defStore.title = colDef.title;
                defStore.columns = this.parseColumns(column.getColumns());
            } else {
                defStore.field = column.getField();
                if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(colDef);
                    keys.push("width");
                    keys.push("visible");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    switch(key){
                        case "width":
                            defStore.width = column.getWidth();
                            break;
                        case "visible":
                            defStore.visible = column.visible;
                            break;
                        default:
                            if (typeof colDef[key] !== "function" && excludedKeys.indexOf(key) === -1) defStore[key] = colDef[key];
                    }
                });
            }
            definitions.push(defStore);
        });
        return definitions;
    }
}
class $c2a9788f40f9c90a$export$5a0eb14a9c37d425 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "popup";
    constructor(table){
        super(table);
        this.columnSubscribers = {};
        this.registerTableOption("rowContextPopup", false);
        this.registerTableOption("rowClickPopup", false);
        this.registerTableOption("rowDblClickPopup", false);
        this.registerTableOption("groupContextPopup", false);
        this.registerTableOption("groupClickPopup", false);
        this.registerTableOption("groupDblClickPopup", false);
        this.registerColumnOption("headerContextPopup");
        this.registerColumnOption("headerClickPopup");
        this.registerColumnOption("headerDblClickPopup");
        this.registerColumnOption("headerPopup");
        this.registerColumnOption("headerPopupIcon");
        this.registerColumnOption("contextPopup");
        this.registerColumnOption("clickPopup");
        this.registerColumnOption("dblClickPopup");
        this.registerComponentFunction("cell", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("column", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("row", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("group", "popup", this._componentPopupCall.bind(this));
    }
    initialize() {
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    _componentPopupCall(component, contents, position) {
        this.loadPopupEvent(contents, null, component, position);
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextPopup) {
            this.subscribe("row-contextmenu", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
            this.table.on("rowTapHold", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
        }
        if (this.table.options.rowClickPopup) this.subscribe("row-click", this.loadPopupEvent.bind(this, this.table.options.rowClickPopup));
        if (this.table.options.rowDblClickPopup) this.subscribe("row-dblclick", this.loadPopupEvent.bind(this, this.table.options.rowDblClickPopup));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextPopup) {
            this.subscribe("group-contextmenu", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
            this.table.on("groupTapHold", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
        }
        if (this.table.options.groupClickPopup) this.subscribe("group-click", this.loadPopupEvent.bind(this, this.table.options.groupClickPopup));
        if (this.table.options.groupDblClickPopup) this.subscribe("group-dblclick", this.loadPopupEvent.bind(this, this.table.options.groupDblClickPopup));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextPopup && !this.columnSubscribers.headerContextPopup) {
            this.columnSubscribers.headerContextPopup = this.loadPopupTableColumnEvent.bind(this, "headerContextPopup");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextPopup);
            this.table.on("headerTapHold", this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"));
        }
        if (def.headerClickPopup && !this.columnSubscribers.headerClickPopup) {
            this.columnSubscribers.headerClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerClickPopup");
            this.subscribe("column-click", this.columnSubscribers.headerClickPopup);
        }
        if (def.headerDblClickPopup && !this.columnSubscribers.headerDblClickPopup) {
            this.columnSubscribers.headerDblClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerDblClickPopup");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickPopup);
        }
        if (def.headerPopup) this.initializeColumnHeaderPopup(column);
        //handle cell events
        if (def.contextPopup && !this.columnSubscribers.contextPopup) {
            this.columnSubscribers.contextPopup = this.loadPopupTableCellEvent.bind(this, "contextPopup");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextPopup);
            this.table.on("cellTapHold", this.loadPopupTableCellEvent.bind(this, "contextPopup"));
        }
        if (def.clickPopup && !this.columnSubscribers.clickPopup) {
            this.columnSubscribers.clickPopup = this.loadPopupTableCellEvent.bind(this, "clickPopup");
            this.subscribe("cell-click", this.columnSubscribers.clickPopup);
        }
        if (def.dblClickPopup && !this.columnSubscribers.dblClickPopup) {
            this.columnSubscribers.dblClickPopup = this.loadPopupTableCellEvent.bind(this, "dblClickPopup");
            this.subscribe("cell-click", this.columnSubscribers.dblClickPopup);
        }
    }
    initializeColumnHeaderPopup(column) {
        var icon = column.definition.headerPopupIcon, headerPopupEl;
        headerPopupEl = document.createElement("span");
        headerPopupEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerPopupEl.appendChild(icon);
            else headerPopupEl.innerHTML = icon;
        } else headerPopupEl.innerHTML = "&vellip;";
        headerPopupEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadPopupEvent(column.definition.headerPopup, e, column);
        });
        column.titleElement.insertBefore(headerPopupEl, column.titleElement.firstChild);
    }
    loadPopupTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadPopupEvent(cell.column.definition[option], e, cell);
    }
    loadPopupTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadPopupEvent(column.definition[option], e, column);
    }
    loadPopupEvent(contents, e, component, position) {
        var renderedCallback;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        contents = typeof contents == "function" ? contents.call(this.table, e, component.getComponent(), onRendered) : contents;
        this.loadPopup(e, component, contents, renderedCallback, position);
    }
    loadPopup(e, component, contents, renderedCallback, position) {
        var touch = !(e instanceof MouseEvent), contentsEl, popup;
        if (contents instanceof HTMLElement) contentsEl = contents;
        else {
            contentsEl = document.createElement("div");
            contentsEl.innerHTML = contents;
        }
        contentsEl.classList.add("tabulator-popup");
        contentsEl.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (!touch) e.preventDefault();
        popup = this.popup(contentsEl);
        if (typeof renderedCallback === "function") popup.renderCallback(renderedCallback);
        if (e) popup.show(e);
        else popup.show(component.getElement(), position || "center");
        popup.hideOnBlur(()=>{
            this.dispatchExternal("popupClosed", component.getComponent());
        });
        this.dispatchExternal("popupOpened", component.getComponent());
    }
}
class $c2a9788f40f9c90a$export$94fbe99c03f5a051 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "print";
    constructor(table){
        super(table);
        this.element = false;
        this.manualBlock = false;
        this.beforeprintEventHandler = null;
        this.afterprintEventHandler = null;
        this.registerTableOption("printAsHtml", false); //enable print as html
        this.registerTableOption("printFormatter", false); //printing page formatter
        this.registerTableOption("printHeader", false); //page header contents
        this.registerTableOption("printFooter", false); //page footer contents
        this.registerTableOption("printStyled", true); //enable print as html styling
        this.registerTableOption("printRowRange", "visible"); //restrict print to visible rows only
        this.registerTableOption("printConfig", {}); //print config options
        this.registerColumnOption("print");
        this.registerColumnOption("titlePrint");
    }
    initialize() {
        if (this.table.options.printAsHtml) {
            this.beforeprintEventHandler = this.replaceTable.bind(this);
            this.afterprintEventHandler = this.cleanup.bind(this);
            window.addEventListener("beforeprint", this.beforeprintEventHandler);
            window.addEventListener("afterprint", this.afterprintEventHandler);
            this.subscribe("table-destroy", this.destroy.bind(this));
        }
        this.registerTableFunction("print", this.printFullscreen.bind(this));
    }
    destroy() {
        if (this.table.options.printAsHtml) {
            window.removeEventListener("beforeprint", this.beforeprintEventHandler);
            window.removeEventListener("afterprint", this.afterprintEventHandler);
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    replaceTable() {
        if (!this.manualBlock) {
            this.element = document.createElement("div");
            this.element.classList.add("tabulator-print-table");
            this.element.appendChild(this.table.modules.export.generateTable(this.table.options.printConfig, this.table.options.printStyled, this.table.options.printRowRange, "print"));
            this.table.element.style.display = "none";
            this.table.element.parentNode.insertBefore(this.element, this.table.element);
        }
    }
    cleanup() {
        document.body.classList.remove("tabulator-print-fullscreen-hide");
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.table.element.style.display = "";
        }
    }
    printFullscreen(visible, style, config) {
        var scrollX = window.scrollX, scrollY = window.scrollY, headerEl = document.createElement("div"), footerEl = document.createElement("div"), tableEl = this.table.modules.export.generateTable(typeof config != "undefined" ? config : this.table.options.printConfig, typeof style != "undefined" ? style : this.table.options.printStyled, visible || this.table.options.printRowRange, "print"), headerContent, footerContent;
        this.manualBlock = true;
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-print-fullscreen");
        if (this.table.options.printHeader) {
            headerEl.classList.add("tabulator-print-header");
            headerContent = typeof this.table.options.printHeader == "function" ? this.table.options.printHeader.call(this.table) : this.table.options.printHeader;
            if (typeof headerContent == "string") headerEl.innerHTML = headerContent;
            else headerEl.appendChild(headerContent);
            this.element.appendChild(headerEl);
        }
        this.element.appendChild(tableEl);
        if (this.table.options.printFooter) {
            footerEl.classList.add("tabulator-print-footer");
            footerContent = typeof this.table.options.printFooter == "function" ? this.table.options.printFooter.call(this.table) : this.table.options.printFooter;
            if (typeof footerContent == "string") footerEl.innerHTML = footerContent;
            else footerEl.appendChild(footerContent);
            this.element.appendChild(footerEl);
        }
        document.body.classList.add("tabulator-print-fullscreen-hide");
        document.body.appendChild(this.element);
        if (this.table.options.printFormatter) this.table.options.printFormatter(this.element, tableEl);
        window.print();
        this.cleanup();
        window.scrollTo(scrollX, scrollY);
        this.manualBlock = false;
    }
}
class $c2a9788f40f9c90a$export$1806fba60a0e8399 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "reactiveData";
    constructor(table){
        super(table);
        this.data = false;
        this.blocked = false; //block reactivity while performing update
        this.origFuncs = {}; // hold original data array functions to allow replacement after data is done with
        this.currentVersion = 0;
        this.registerTableOption("reactiveData", false); //enable data reactivity
    }
    initialize() {
        if (this.table.options.reactiveData) {
            this.subscribe("cell-value-save-before", this.block.bind(this, "cellsave"));
            this.subscribe("cell-value-save-after", this.unblock.bind(this, "cellsave"));
            this.subscribe("row-data-save-before", this.block.bind(this, "rowsave"));
            this.subscribe("row-data-save-after", this.unblock.bind(this, "rowsave"));
            this.subscribe("row-data-init-after", this.watchRow.bind(this));
            this.subscribe("data-processing", this.watchData.bind(this));
            this.subscribe("table-destroy", this.unwatchData.bind(this));
        }
    }
    watchData(data) {
        var self = this, version;
        this.currentVersion++;
        version = this.currentVersion;
        this.unwatchData();
        this.data = data;
        //override array push function
        this.origFuncs.push = data.push;
        Object.defineProperty(this.data, "push", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-push");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, false);
                    });
                    result = self.origFuncs.push.apply(data, arguments);
                    self.unblock("data-push");
                }
                return result;
            }
        });
        //override array unshift function
        this.origFuncs.unshift = data.unshift;
        Object.defineProperty(this.data, "unshift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-unshift");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, true);
                    });
                    result = self.origFuncs.unshift.apply(data, arguments);
                    self.unblock("data-unshift");
                }
                return result;
            }
        });
        //override array shift function
        this.origFuncs.shift = data.shift;
        Object.defineProperty(this.data, "shift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-shift");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[0]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.shift.call(data);
                    self.unblock("data-shift");
                }
                return result;
            }
        });
        //override array pop function
        this.origFuncs.pop = data.pop;
        Object.defineProperty(this.data, "pop", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-pop");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[self.data.length - 1]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.pop.call(data);
                    self.unblock("data-pop");
                }
                return result;
            }
        });
        //override array splice function
        this.origFuncs.splice = data.splice;
        Object.defineProperty(this.data, "splice", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), start = args[0] < 0 ? data.length + args[0] : args[0], end = args[1], newRows = args[2] ? args.slice(2) : false, startRow, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-splice");
                    //add new rows
                    if (newRows) {
                        startRow = data[start] ? self.table.rowManager.getRowFromDataObject(data[start]) : false;
                        if (startRow) newRows.forEach((rowData)=>{
                            self.table.rowManager.addRowActual(rowData, true, startRow, true);
                        });
                        else {
                            newRows = newRows.slice().reverse();
                            newRows.forEach((rowData)=>{
                                self.table.rowManager.addRowActual(rowData, true, false, true);
                            });
                        }
                    }
                    //delete removed rows
                    if (end !== 0) {
                        var oldRows = data.slice(start, typeof args[1] === "undefined" ? args[1] : start + end);
                        oldRows.forEach((rowData, i)=>{
                            var row = self.table.rowManager.getRowFromDataObject(rowData);
                            if (row) row.deleteActual(i !== oldRows.length - 1);
                        });
                    }
                    if (newRows || end !== 0) self.table.rowManager.reRenderInPosition();
                    result = self.origFuncs.splice.apply(data, arguments);
                    self.unblock("data-splice");
                }
                return result;
            }
        });
    }
    unwatchData() {
        if (this.data !== false) for(var key in this.origFuncs)Object.defineProperty(this.data, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.origFuncs.key
        });
    }
    watchRow(row) {
        var data = row.getData();
        for(var key in data)this.watchKey(row, data, key);
        if (this.table.options.dataTree) this.watchTreeChildren(row);
    }
    watchTreeChildren(row) {
        var self = this, childField = row.getData()[this.table.options.dataTreeChildField], origFuncs = {};
        if (childField) {
            origFuncs.push = childField.push;
            Object.defineProperty(childField, "push", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-push");
                        var result = origFuncs.push.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-push");
                    }
                    return result;
                }
            });
            origFuncs.unshift = childField.unshift;
            Object.defineProperty(childField, "unshift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-unshift");
                        var result = origFuncs.unshift.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-unshift");
                    }
                    return result;
                }
            });
            origFuncs.shift = childField.shift;
            Object.defineProperty(childField, "shift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-shift");
                        var result = origFuncs.shift.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-shift");
                    }
                    return result;
                }
            });
            origFuncs.pop = childField.pop;
            Object.defineProperty(childField, "pop", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-pop");
                        var result = origFuncs.pop.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-pop");
                    }
                    return result;
                }
            });
            origFuncs.splice = childField.splice;
            Object.defineProperty(childField, "splice", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-splice");
                        var result = origFuncs.splice.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-splice");
                    }
                    return result;
                }
            });
        }
    }
    rebuildTree(row) {
        this.table.modules.dataTree.initializeRow(row);
        this.table.modules.dataTree.layoutRow(row);
        this.table.rowManager.refreshActiveData("tree", false, true);
    }
    watchKey(row, data, key) {
        var self = this, props = Object.getOwnPropertyDescriptor(data, key), value = data[key], version = this.currentVersion;
        Object.defineProperty(data, key, {
            set: (newValue)=>{
                value = newValue;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("key");
                    var update = {};
                    update[key] = newValue;
                    row.updateData(update);
                    self.unblock("key");
                }
                if (props.set) props.set(newValue);
            },
            get: ()=>{
                if (props.get) props.get();
                return value;
            }
        });
    }
    unwatchRow(row) {
        var data = row.getData();
        for(var key in data)Object.defineProperty(data, key, {
            value: data[key]
        });
    }
    block(key) {
        if (!this.blocked) this.blocked = key;
    }
    unblock(key) {
        if (this.blocked === key) this.blocked = false;
    }
}
class $c2a9788f40f9c90a$export$3a1ca422b395df54 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeColumns";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startX = false;
        this.startWidth = false;
        this.latestX = false;
        this.handle = null;
        this.initialNextColumn = null;
        this.nextColumn = null;
        this.initialized = false;
        this.registerColumnOption("resizable", true);
        this.registerTableOption("resizableColumnFit", false);
        this.registerTableOption("resizableColumnGuide", false);
    }
    initialize() {
        this.subscribe("column-rendered", this.layoutColumnHeader.bind(this));
    }
    initializeEventWatchers() {
        if (!this.initialized) {
            this.subscribe("cell-rendered", this.layoutCellHandles.bind(this));
            this.subscribe("cell-delete", this.deInitializeComponent.bind(this));
            this.subscribe("cell-height", this.resizeHandle.bind(this));
            this.subscribe("column-moved", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-hide", this.deInitializeColumn.bind(this));
            this.subscribe("column-show", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-width", this.columnWidthUpdated.bind(this));
            this.subscribe("column-delete", this.deInitializeComponent.bind(this));
            this.subscribe("column-height", this.resizeHandle.bind(this));
            this.initialized = true;
        }
    }
    layoutCellHandles(cell) {
        if (cell.row.type === "row") {
            this.deInitializeComponent(cell);
            this.initializeColumn("cell", cell, cell.column, cell.element);
        }
    }
    layoutColumnHeader(column) {
        if (column.definition.resizable) {
            this.initializeEventWatchers();
            this.deInitializeComponent(column);
            this.initializeColumn("header", column, column, column.element);
        }
    }
    columnLayoutUpdated(column) {
        var prev = column.prevColumn();
        this.reinitializeColumn(column);
        if (prev) this.reinitializeColumn(prev);
    }
    columnWidthUpdated(column) {
        if (column.modules.frozen) {
            if (this.table.modules.frozenColumns.leftColumns.includes(column)) this.table.modules.frozenColumns.leftColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
            else if (this.table.modules.frozenColumns.rightColumns.includes(column)) this.table.modules.frozenColumns.rightColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
        }
    }
    frozenColumnOffset(column) {
        var offset = false;
        if (column.modules.frozen) {
            offset = column.modules.frozen.marginValue;
            if (column.modules.frozen.position === "left") offset += column.getWidth() - 3;
            else if (offset) offset -= 3;
        }
        return offset !== false ? offset + "px" : false;
    }
    reinitializeColumn(column) {
        var frozenOffset = this.frozenColumnOffset(column);
        column.cells.forEach((cell)=>{
            if (cell.modules.resize && cell.modules.resize.handleEl) {
                if (frozenOffset) {
                    cell.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
                    cell.modules.resize.handleEl.style["z-index"] = 11;
                }
                cell.element.after(cell.modules.resize.handleEl);
            }
        });
        if (column.modules.resize && column.modules.resize.handleEl) {
            if (frozenOffset) column.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
            column.element.after(column.modules.resize.handleEl);
        }
    }
    initializeColumn(type, component, column, element) {
        var self = this, variableHeight = false, mode = column.definition.resizable, config = {}, nearestColumn = column.getLastColumn();
        //set column resize mode
        if (type === "header") {
            variableHeight = column.definition.formatter == "textarea" || column.definition.variableHeight;
            config = {
                variableHeight: variableHeight
            };
        }
        if ((mode === true || mode == type) && this._checkResizability(nearestColumn)) {
            var handle = document.createElement("span");
            handle.className = "tabulator-col-resize-handle";
            handle.addEventListener("click", function(e) {
                e.stopPropagation();
            });
            var handleDown = function(e) {
                self.startColumn = column;
                self.initialNextColumn = self.nextColumn = nearestColumn.nextColumn();
                self._mouseDown(e, nearestColumn, handle);
            };
            handle.addEventListener("mousedown", handleDown);
            handle.addEventListener("touchstart", handleDown, {
                passive: true
            });
            //resize column on  double click
            handle.addEventListener("dblclick", (e)=>{
                var oldWidth = nearestColumn.getWidth();
                e.stopPropagation();
                nearestColumn.reinitializeWidth(true);
                if (oldWidth !== nearestColumn.getWidth()) {
                    self.dispatch("column-resized", nearestColumn);
                    self.dispatchExternal("columnResized", nearestColumn.getComponent());
                }
            });
            if (column.modules.frozen) {
                handle.style.position = "sticky";
                handle.style[column.modules.frozen.position] = this.frozenColumnOffset(column);
            }
            config.handleEl = handle;
            if (element.parentNode && column.visible) element.after(handle);
        }
        component.modules.resize = config;
    }
    deInitializeColumn(column) {
        this.deInitializeComponent(column);
        column.cells.forEach((cell)=>{
            this.deInitializeComponent(cell);
        });
    }
    deInitializeComponent(component) {
        var handleEl;
        if (component.modules.resize) {
            handleEl = component.modules.resize.handleEl;
            if (handleEl && handleEl.parentElement) handleEl.parentElement.removeChild(handleEl);
        }
    }
    resizeHandle(component, height) {
        if (component.modules.resize && component.modules.resize.handleEl) component.modules.resize.handleEl.style.height = height;
    }
    resize(e, column) {
        var x = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, startDiff = x - this.startX, moveDiff = x - this.latestX, blockedBefore, blockedAfter;
        this.latestX = x;
        if (this.table.rtl) {
            startDiff = -startDiff;
            moveDiff = -moveDiff;
        }
        blockedBefore = column.width == column.minWidth || column.width == column.maxWidth;
        column.setWidth(this.startWidth + startDiff);
        blockedAfter = column.width == column.minWidth || column.width == column.maxWidth;
        if (moveDiff < 0) this.nextColumn = this.initialNextColumn;
        if (this.table.options.resizableColumnFit && this.nextColumn && !(blockedBefore && blockedAfter)) {
            let colWidth = this.nextColumn.getWidth();
            if (moveDiff > 0) {
                if (colWidth <= this.nextColumn.minWidth) this.nextColumn = this.nextColumn.nextColumn();
            }
            if (this.nextColumn) this.nextColumn.setWidth(this.nextColumn.getWidth() - moveDiff);
        }
        this.table.columnManager.rerenderColumns(true);
        if (!this.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
    }
    calcGuidePosition(e, column, handle) {
        var mouseX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, handleX = handle.getBoundingClientRect().x - this.table.element.getBoundingClientRect().x, tableX = this.table.element.getBoundingClientRect().x, columnX = column.element.getBoundingClientRect().left - tableX, mouseDiff = mouseX - this.startX, pos = Math.max(handleX + mouseDiff, columnX + column.minWidth);
        if (column.maxWidth) pos = Math.min(pos, columnX + column.maxWidth);
        return pos;
    }
    _checkResizability(column) {
        return column.definition.resizable;
    }
    _mouseDown(e, column, handle) {
        var self = this, guideEl;
        this.dispatchExternal("columnResizing", column.getComponent());
        if (self.table.options.resizableColumnGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add("tabulator-col-resize-guide");
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableColumnGuide) guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            else self.resize(e, column);
        }
        function mouseUp(e) {
            if (self.table.options.resizableColumnGuide) {
                self.resize(e, column);
                guideEl.remove();
            }
            //block editor from taking action while resizing is taking place
            if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = false;
            if (self.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
            document.body.removeEventListener("mouseup", mouseUp);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            if (self.startWidth !== column.getWidth()) {
                self.table.columnManager.verticalAlignHeaders();
                self.dispatch("column-resized", column);
                self.dispatchExternal("columnResized", column.getComponent());
            }
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = true;
        self.startX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX;
        self.latestX = self.startX;
        self.startWidth = column.getWidth();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$5651a6c35bd86023 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeRows";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startY = false;
        this.startHeight = false;
        this.handle = null;
        this.prevHandle = null;
        this.registerTableOption("resizableRows", false); //resizable rows
        this.registerTableOption("resizableRowGuide", false);
    }
    initialize() {
        if (this.table.options.resizableRows) this.subscribe("row-layout-after", this.initializeRow.bind(this));
    }
    initializeRow(row) {
        var self = this, rowEl = row.getElement();
        var handle = document.createElement("div");
        handle.className = "tabulator-row-resize-handle";
        var prevHandle = document.createElement("div");
        prevHandle.className = "tabulator-row-resize-handle prev";
        handle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var handleDown = function(e) {
            self.startRow = row;
            self._mouseDown(e, row, handle);
        };
        handle.addEventListener("mousedown", handleDown);
        handle.addEventListener("touchstart", handleDown, {
            passive: true
        });
        prevHandle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var prevHandleDown = function(e) {
            var prevRow = self.table.rowManager.prevDisplayRow(row);
            if (prevRow) {
                self.startRow = prevRow;
                self._mouseDown(e, prevRow, prevHandle);
            }
        };
        prevHandle.addEventListener("mousedown", prevHandleDown);
        prevHandle.addEventListener("touchstart", prevHandleDown, {
            passive: true
        });
        rowEl.appendChild(handle);
        rowEl.appendChild(prevHandle);
    }
    resize(e, row) {
        row.setHeight(this.startHeight + ((typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY) - this.startY));
    }
    calcGuidePosition(e, row, handle) {
        var mouseY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY, handleY = handle.getBoundingClientRect().y - this.table.element.getBoundingClientRect().y, tableY = this.table.element.getBoundingClientRect().y, rowY = row.element.getBoundingClientRect().top - tableY, mouseDiff = mouseY - this.startY;
        return Math.max(handleY + mouseDiff, rowY);
    }
    _mouseDown(e, row, handle) {
        var self = this, guideEl;
        self.dispatchExternal("rowResizing", row.getComponent());
        if (self.table.options.resizableRowGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add("tabulator-row-resize-guide");
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableRowGuide) guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            else self.resize(e, row);
        }
        function mouseUp(e) {
            if (self.table.options.resizableRowGuide) {
                self.resize(e, row);
                guideEl.remove();
            }
            // //block editor from taking action while resizing is taking place
            // if(self.startColumn.modules.edit){
            // 	self.startColumn.modules.edit.blocked = false;
            // }
            document.body.removeEventListener("mouseup", mouseMove);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            self.dispatchExternal("rowResized", row.getComponent());
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        // if(self.startColumn.modules.edit){
        // 	self.startColumn.modules.edit.blocked = true;
        // }
        self.startY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY;
        self.startHeight = row.getHeight();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$977e646a85a63aba extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeTable";
    constructor(table){
        super(table);
        this.binding = false;
        this.visibilityObserver = false;
        this.resizeObserver = false;
        this.containerObserver = false;
        this.tableHeight = 0;
        this.tableWidth = 0;
        this.containerHeight = 0;
        this.containerWidth = 0;
        this.autoResize = false;
        this.visible = false;
        this.initialized = false;
        this.initialRedraw = false;
        this.registerTableOption("autoResize", true); //auto resize table
    }
    initialize() {
        if (this.table.options.autoResize) {
            var table = this.table, tableStyle;
            this.tableHeight = table.element.clientHeight;
            this.tableWidth = table.element.clientWidth;
            if (table.element.parentNode) {
                this.containerHeight = table.element.parentNode.clientHeight;
                this.containerWidth = table.element.parentNode.clientWidth;
            }
            if (typeof IntersectionObserver !== "undefined" && typeof ResizeObserver !== "undefined" && table.rowManager.getRenderMode() === "virtual") {
                this.initializeVisibilityObserver();
                this.autoResize = true;
                this.resizeObserver = new ResizeObserver((entry)=>{
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        var nodeHeight = Math.floor(entry[0].contentRect.height);
                        var nodeWidth = Math.floor(entry[0].contentRect.width);
                        if (this.tableHeight != nodeHeight || this.tableWidth != nodeWidth) {
                            this.tableHeight = nodeHeight;
                            this.tableWidth = nodeWidth;
                            if (table.element.parentNode) {
                                this.containerHeight = table.element.parentNode.clientHeight;
                                this.containerWidth = table.element.parentNode.clientWidth;
                            }
                            this.redrawTable();
                        }
                    }
                });
                this.resizeObserver.observe(table.element);
                tableStyle = window.getComputedStyle(table.element);
                if (this.table.element.parentNode && !this.table.rowManager.fixedHeight && (tableStyle.getPropertyValue("max-height") || tableStyle.getPropertyValue("min-height"))) {
                    this.containerObserver = new ResizeObserver((entry)=>{
                        if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                            var nodeHeight = Math.floor(entry[0].contentRect.height);
                            var nodeWidth = Math.floor(entry[0].contentRect.width);
                            if (this.containerHeight != nodeHeight || this.containerWidth != nodeWidth) {
                                this.containerHeight = nodeHeight;
                                this.containerWidth = nodeWidth;
                                this.tableHeight = table.element.clientHeight;
                                this.tableWidth = table.element.clientWidth;
                            }
                            this.redrawTable();
                        }
                    });
                    this.containerObserver.observe(this.table.element.parentNode);
                }
                this.subscribe("table-resize", this.tableResized.bind(this));
            } else {
                this.binding = function() {
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        table.columnManager.rerenderColumns(true);
                        table.redraw();
                    }
                };
                window.addEventListener("resize", this.binding);
            }
            this.subscribe("table-destroy", this.clearBindings.bind(this));
        }
    }
    initializeVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver((entries)=>{
            this.visible = entries[0].isIntersecting;
            if (!this.initialized) {
                this.initialized = true;
                this.initialRedraw = !this.visible;
            } else if (this.visible) {
                this.redrawTable(this.initialRedraw);
                this.initialRedraw = false;
            }
        });
        this.visibilityObserver.observe(this.table.element);
    }
    redrawTable(force) {
        if (this.initialized && this.visible) {
            this.table.columnManager.rerenderColumns(true);
            this.table.redraw(force);
        }
    }
    tableResized() {
        this.table.rowManager.redraw();
    }
    clearBindings() {
        if (this.binding) window.removeEventListener("resize", this.binding);
        if (this.resizeObserver) this.resizeObserver.unobserve(this.table.element);
        if (this.visibilityObserver) this.visibilityObserver.unobserve(this.table.element);
        if (this.containerObserver) this.containerObserver.unobserve(this.table.element.parentNode);
    }
}
function $c2a9788f40f9c90a$var$responsiveCollapse(cell, formatterParams, onRendered) {
    var el = document.createElement("div"), config = cell.getRow()._row.modules.responsiveLayout;
    el.classList.add("tabulator-responsive-collapse-toggle");
    el.innerHTML = `<svg class='tabulator-responsive-collapse-toggle-open' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12" fill="none" stroke-width="3" stroke-linecap="round" />
  <line y1="7" x1="12" y2="17" x2="12" fill="none" stroke-width="3" stroke-linecap="round" />
</svg>

<svg class='tabulator-responsive-collapse-toggle-close' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12"  fill="none" stroke-width="3" stroke-linecap="round" />
</svg>`;
    cell.getElement().classList.add("tabulator-row-handle");
    function toggleList(isOpen) {
        var collapseEl = config.element;
        config.open = isOpen;
        if (collapseEl) {
            if (config.open) {
                el.classList.add("open");
                collapseEl.style.display = "";
            } else {
                el.classList.remove("open");
                collapseEl.style.display = "none";
            }
        }
    }
    el.addEventListener("click", function(e) {
        e.stopImmediatePropagation();
        toggleList(!config.open);
        cell.getTable().rowManager.adjustTableSize();
    });
    toggleList(config.open);
    return el;
}
var $c2a9788f40f9c90a$var$extensions$2 = {
    format: {
        formatters: {
            responsiveCollapse: $c2a9788f40f9c90a$var$responsiveCollapse
        }
    }
};
class $c2a9788f40f9c90a$export$cc8706005768c818 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "responsiveLayout";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$2;
    constructor(table){
        super(table);
        this.columns = [];
        this.hiddenColumns = [];
        this.mode = "";
        this.index = 0;
        this.collapseFormatter = [];
        this.collapseStartOpen = true;
        this.collapseHandleColumn = false;
        this.registerTableOption("responsiveLayout", false); //responsive layout flags
        this.registerTableOption("responsiveLayoutCollapseStartOpen", true); //start showing collapsed data
        this.registerTableOption("responsiveLayoutCollapseUseFormatters", true); //responsive layout collapse formatter
        this.registerTableOption("responsiveLayoutCollapseFormatter", false); //responsive layout collapse formatter
        this.registerColumnOption("responsive");
    }
    //generate responsive columns list
    initialize() {
        if (this.table.options.responsiveLayout) {
            this.subscribe("column-layout", this.initializeColumn.bind(this));
            this.subscribe("column-show", this.updateColumnVisibility.bind(this));
            this.subscribe("column-hide", this.updateColumnVisibility.bind(this));
            this.subscribe("columns-loaded", this.initializeResponsivity.bind(this));
            this.subscribe("column-moved", this.initializeResponsivity.bind(this));
            this.subscribe("column-add", this.initializeResponsivity.bind(this));
            this.subscribe("column-delete", this.initializeResponsivity.bind(this));
            this.subscribe("table-redrawing", this.tableRedraw.bind(this));
            if (this.table.options.responsiveLayout === "collapse") {
                this.subscribe("row-data-changed", this.generateCollapsedRowContent.bind(this));
                this.subscribe("row-init", this.initializeRow.bind(this));
                this.subscribe("row-layout", this.layoutRow.bind(this));
            }
        }
    }
    tableRedraw(force) {
        if ([
            "fitColumns",
            "fitDataStretch"
        ].indexOf(this.layoutMode()) === -1) {
            if (!force) this.update();
        }
    }
    initializeResponsivity() {
        var columns = [];
        this.mode = this.table.options.responsiveLayout;
        this.collapseFormatter = this.table.options.responsiveLayoutCollapseFormatter || this.formatCollapsedData;
        this.collapseStartOpen = this.table.options.responsiveLayoutCollapseStartOpen;
        this.hiddenColumns = [];
        if (this.collapseFormatter) this.collapseFormatter = this.collapseFormatter.bind(this.table);
        //determine level of responsivity for each column
        this.table.columnManager.columnsByIndex.forEach((column, i)=>{
            if (column.modules.responsive) {
                if (column.modules.responsive.order && column.modules.responsive.visible) {
                    column.modules.responsive.index = i;
                    columns.push(column);
                    if (!column.visible && this.mode === "collapse") this.hiddenColumns.push(column);
                }
            }
        });
        //sort list by responsivity
        columns = columns.reverse();
        columns = columns.sort((a, b)=>{
            var diff = b.modules.responsive.order - a.modules.responsive.order;
            return diff || b.modules.responsive.index - a.modules.responsive.index;
        });
        this.columns = columns;
        if (this.mode === "collapse") this.generateCollapsedContent();
        //assign collapse column
        for (let col of this.table.columnManager.columnsByIndex)if (col.definition.formatter == "responsiveCollapse") {
            this.collapseHandleColumn = col;
            break;
        }
        if (this.collapseHandleColumn) {
            if (this.hiddenColumns.length) this.collapseHandleColumn.show();
            else this.collapseHandleColumn.hide();
        }
    }
    //define layout information
    initializeColumn(column) {
        var def = column.getDefinition();
        column.modules.responsive = {
            order: typeof def.responsive === "undefined" ? 1 : def.responsive,
            visible: def.visible === false ? false : true
        };
    }
    initializeRow(row) {
        var el;
        if (row.type !== "calc") {
            el = document.createElement("div");
            el.classList.add("tabulator-responsive-collapse");
            row.modules.responsiveLayout = {
                element: el,
                open: this.collapseStartOpen
            };
            if (!this.collapseStartOpen) el.style.display = "none";
        }
    }
    layoutRow(row) {
        var rowEl = row.getElement();
        if (row.modules.responsiveLayout) {
            rowEl.appendChild(row.modules.responsiveLayout.element);
            this.generateCollapsedRowContent(row);
        }
    }
    //update column visibility
    updateColumnVisibility(column, responsiveToggle) {
        if (!responsiveToggle && column.modules.responsive) {
            column.modules.responsive.visible = column.visible;
            this.initializeResponsivity();
        }
    }
    hideColumn(column) {
        var colCount = this.hiddenColumns.length;
        column.hide(false, true);
        if (this.mode === "collapse") {
            this.hiddenColumns.unshift(column);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !colCount) this.collapseHandleColumn.show();
        }
    }
    showColumn(column) {
        var index;
        column.show(false, true);
        //set column width to prevent calculation loops on uninitialized columns
        column.setWidth(column.getWidth());
        if (this.mode === "collapse") {
            index = this.hiddenColumns.indexOf(column);
            if (index > -1) this.hiddenColumns.splice(index, 1);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !this.hiddenColumns.length) this.collapseHandleColumn.hide();
        }
    }
    //redraw columns to fit space
    update() {
        var working = true;
        while(working){
            let width = this.table.modules.layout.getMode() == "fitColumns" ? this.table.columnManager.getFlexBaseWidth() : this.table.columnManager.getWidth();
            let diff = (this.table.options.headerVisible ? this.table.columnManager.element.clientWidth : this.table.element.clientWidth) - width;
            if (diff < 0) {
                //table is too wide
                let column = this.columns[this.index];
                if (column) {
                    this.hideColumn(column);
                    this.index++;
                } else working = false;
            } else {
                //table has spare space
                let column = this.columns[this.index - 1];
                if (column) {
                    if (diff > 0) {
                        if (diff >= column.getWidth()) {
                            this.showColumn(column);
                            this.index--;
                        } else working = false;
                    } else working = false;
                } else working = false;
            }
            if (!this.table.rowManager.activeRowsCount) this.table.rowManager.renderEmptyScroll();
        }
    }
    generateCollapsedContent() {
        var rows = this.table.rowManager.getDisplayRows();
        rows.forEach((row)=>{
            this.generateCollapsedRowContent(row);
        });
    }
    generateCollapsedRowContent(row) {
        var el, contents;
        if (row.modules.responsiveLayout) {
            el = row.modules.responsiveLayout.element;
            while(el.firstChild)el.removeChild(el.firstChild);
            contents = this.collapseFormatter(this.generateCollapsedRowData(row));
            if (contents) el.appendChild(contents);
            row.calcHeight(true);
        }
    }
    generateCollapsedRowData(row) {
        var data = row.getData(), output = [], mockCellComponent;
        this.hiddenColumns.forEach((column)=>{
            var value = column.getFieldValue(data);
            if (column.definition.title && column.field) {
                if (column.modules.format && this.table.options.responsiveLayoutCollapseUseFormatters) {
                    mockCellComponent = {
                        value: false,
                        data: {},
                        getValue: function() {
                            return value;
                        },
                        getData: function() {
                            return data;
                        },
                        getType: function() {
                            return "cell";
                        },
                        getElement: function() {
                            return document.createElement("div");
                        },
                        getRow: function() {
                            return row.getComponent();
                        },
                        getColumn: function() {
                            return column.getComponent();
                        },
                        getTable: ()=>{
                            return this.table;
                        }
                    };
                    function onRendered(callback) {
                        callback();
                    }
                    output.push({
                        field: column.field,
                        title: column.definition.title,
                        value: column.modules.format.formatter.call(this.table.modules.format, mockCellComponent, column.modules.format.params, onRendered)
                    });
                } else output.push({
                    field: column.field,
                    title: column.definition.title,
                    value: value
                });
            }
        });
        return output;
    }
    formatCollapsedData(data) {
        var list = document.createElement("table");
        data.forEach((item)=>{
            var row = document.createElement("tr");
            var titleData = document.createElement("td");
            var valueData = document.createElement("td");
            var node_content;
            var titleHighlight = document.createElement("strong");
            titleData.appendChild(titleHighlight);
            this.modules.localize.bind("columns|" + item.field, function(text) {
                titleHighlight.innerHTML = text || item.title;
            });
            if (item.value instanceof Node) {
                node_content = document.createElement("div");
                node_content.appendChild(item.value);
                valueData.appendChild(node_content);
            } else valueData.innerHTML = item.value;
            row.appendChild(titleData);
            row.appendChild(valueData);
            list.appendChild(row);
        });
        return Object.keys(data).length ? list : "";
    }
}
function $c2a9788f40f9c90a$var$rowSelection(cell, formatterParams, onRendered) {
    var checkbox = document.createElement("input");
    var blocked = false;
    checkbox.type = "checkbox";
    checkbox.setAttribute("aria-label", "Select Row");
    if (this.table.modExists("selectRow", true)) {
        checkbox.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (typeof cell.getRow == "function") {
            var row = cell.getRow();
            if (row instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) {
                checkbox.addEventListener("change", (e)=>{
                    if (this.table.options.selectableRowsRangeMode === "click") {
                        if (!blocked) row.toggleSelect();
                        else blocked = false;
                    } else row.toggleSelect();
                });
                if (this.table.options.selectableRowsRangeMode === "click") checkbox.addEventListener("click", (e)=>{
                    blocked = true;
                    this.table.modules.selectRow.handleComplexRowClick(row._row, e);
                });
                checkbox.checked = row.isSelected && row.isSelected();
                this.table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
            } else checkbox = "";
        } else {
            checkbox.addEventListener("change", (e)=>{
                if (this.table.modules.selectRow.selectedRows.length) this.table.deselectRow();
                else this.table.selectRow(formatterParams.rowRange);
            });
            this.table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
        }
    }
    return checkbox;
}
var $c2a9788f40f9c90a$var$extensions$1 = {
    format: {
        formatters: {
            rowSelection: $c2a9788f40f9c90a$var$rowSelection
        }
    }
};
class $c2a9788f40f9c90a$export$2e4fadc5338e55f5 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRow";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$1;
    constructor(table){
        super(table);
        this.selecting = false; //flag selecting in progress
        this.lastClickedRow = false; //last clicked row
        this.selectPrev = []; //hold previously selected element for drag drop selection
        this.selectedRows = []; //hold selected rows
        this.headerCheckboxElement = null; // hold header select element
        this.registerTableOption("selectableRows", "highlight"); //highlight rows on hover
        this.registerTableOption("selectableRowsRangeMode", "drag"); //highlight rows on hover
        this.registerTableOption("selectableRowsRollingSelection", true); //roll selection once maximum number of selectable rows is reached
        this.registerTableOption("selectableRowsPersistence", true); // maintain selection when table view is updated
        this.registerTableOption("selectableRowsCheck", function(data, row) {
            return true;
        }); //check whether row is selectable
        this.registerTableFunction("selectRow", this.selectRows.bind(this));
        this.registerTableFunction("deselectRow", this.deselectRows.bind(this));
        this.registerTableFunction("toggleSelectRow", this.toggleRow.bind(this));
        this.registerTableFunction("getSelectedRows", this.getSelectedRows.bind(this));
        this.registerTableFunction("getSelectedData", this.getSelectedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "select", this.selectRows.bind(this));
        this.registerComponentFunction("row", "deselect", this.deselectRows.bind(this));
        this.registerComponentFunction("row", "toggleSelect", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "isSelected", this.isRowSelected.bind(this));
    }
    initialize() {
        this.deprecatedOptionsCheck();
        if (this.table.options.selectableRows === "highlight" && this.table.options.selectableRange) this.table.options.selectableRows = false;
        if (this.table.options.selectableRows !== false) {
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-deleting", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clearSelectionData.bind(this));
            this.subscribe("rows-retrieve", this.rowRetrieve.bind(this));
            if (this.table.options.selectableRows && !this.table.options.selectableRowsPersistence) this.subscribe("data-refreshing", this.deselectRows.bind(this));
        }
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("selectable", "selectableRows", true);
    // this.deprecationCheck("selectableRollingSelection", "selectableRowsRollingSelection", true);
    // this.deprecationCheck("selectableRangeMode", "selectableRowsRangeMode", true);
    // this.deprecationCheck("selectablePersistence", "selectableRowsPersistence", true);
    // this.deprecationCheck("selectableCheck", "selectableRowsCheck", true);
    }
    rowRetrieve(type, prevValue) {
        return type === "selected" ? this.selectedRows : prevValue;
    }
    rowDeleted(row) {
        this._deselectRow(row, true);
    }
    clearSelectionData(silent) {
        var prevSelected = this.selectedRows.length;
        this.selecting = false;
        this.lastClickedRow = false;
        this.selectPrev = [];
        this.selectedRows = [];
        if (prevSelected && silent !== true) this._rowSelectionChanged();
    }
    initializeRow(row) {
        var self = this, selectable = self.checkRowSelectability(row), element = row.getElement();
        // trigger end of row selection
        var endSelect = function() {
            setTimeout(function() {
                self.selecting = false;
            }, 50);
            document.body.removeEventListener("mouseup", endSelect);
        };
        row.modules.select = {
            selected: false
        };
        element.classList.toggle("tabulator-selectable", selectable);
        element.classList.toggle("tabulator-unselectable", !selectable);
        //set row selection class
        if (self.checkRowSelectability(row)) {
            if (self.table.options.selectableRows && self.table.options.selectableRows != "highlight") {
                if (self.table.options.selectableRowsRangeMode === "click") element.addEventListener("click", this.handleComplexRowClick.bind(this, row));
                else {
                    element.addEventListener("click", function(e) {
                        if (!self.table.modExists("edit") || !self.table.modules.edit.getCurrentCell()) self.table._clearSelection();
                        if (!self.selecting) self.toggleRow(row);
                    });
                    element.addEventListener("mousedown", function(e) {
                        if (e.shiftKey) {
                            self.table._clearSelection();
                            self.selecting = true;
                            self.selectPrev = [];
                            document.body.addEventListener("mouseup", endSelect);
                            document.body.addEventListener("keyup", endSelect);
                            self.toggleRow(row);
                            return false;
                        }
                    });
                    element.addEventListener("mouseenter", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.toggleRow(row);
                            if (self.selectPrev[1] == row) self.toggleRow(self.selectPrev[0]);
                        }
                    });
                    element.addEventListener("mouseout", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.selectPrev.unshift(row);
                        }
                    });
                }
            }
        }
    }
    handleComplexRowClick(row, e) {
        if (e.shiftKey) {
            this.table._clearSelection();
            this.lastClickedRow = this.lastClickedRow || row;
            var lastClickedRowIdx = this.table.rowManager.getDisplayRowIndex(this.lastClickedRow);
            var rowIdx = this.table.rowManager.getDisplayRowIndex(row);
            var fromRowIdx = lastClickedRowIdx <= rowIdx ? lastClickedRowIdx : rowIdx;
            var toRowIdx = lastClickedRowIdx >= rowIdx ? lastClickedRowIdx : rowIdx;
            var rows = this.table.rowManager.getDisplayRows().slice(0);
            var toggledRows = rows.splice(fromRowIdx, toRowIdx - fromRowIdx + 1);
            if (e.ctrlKey || e.metaKey) {
                toggledRows.forEach((toggledRow)=>{
                    if (toggledRow !== this.lastClickedRow) {
                        if (this.table.options.selectableRows !== true && !this.isRowSelected(row)) {
                            if (this.selectedRows.length < this.table.options.selectableRows) this.toggleRow(toggledRow);
                        } else this.toggleRow(toggledRow);
                    }
                });
                this.lastClickedRow = row;
            } else {
                this.deselectRows(undefined, true);
                if (this.table.options.selectableRows !== true) {
                    if (toggledRows.length > this.table.options.selectableRows) toggledRows = toggledRows.slice(0, this.table.options.selectableRows);
                }
                this.selectRows(toggledRows);
            }
            this.table._clearSelection();
        } else if (e.ctrlKey || e.metaKey) {
            this.toggleRow(row);
            this.lastClickedRow = row;
        } else {
            this.deselectRows(undefined, true);
            this.selectRows(row);
            this.lastClickedRow = row;
        }
    }
    checkRowSelectability(row) {
        if (row && row.type === "row") return this.table.options.selectableRowsCheck.call(this.table, row.getComponent());
        return false;
    }
    //toggle row selection
    toggleRow(row) {
        if (this.checkRowSelectability(row)) {
            if (row.modules.select && row.modules.select.selected) this._deselectRow(row);
            else this._selectRow(row);
        }
    }
    //select a number of rows
    selectRows(rows) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = this.table.rowManager.rows;
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._selectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(false, changes);
            }
        } else if (rowMatch) this._selectRow(rowMatch, false, true);
    }
    //select an individual row
    _selectRow(rowInfo, silent, force) {
        //handle max row count
        if (!isNaN(this.table.options.selectableRows) && this.table.options.selectableRows !== true && !force) {
            if (this.selectedRows.length >= this.table.options.selectableRows) {
                if (this.table.options.selectableRowsRollingSelection) this._deselectRow(this.selectedRows[0]);
                else return false;
            }
        }
        var row = this.table.rowManager.findRow(rowInfo);
        if (row) {
            if (this.selectedRows.indexOf(row) == -1) {
                row.getElement().classList.add("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = true;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = true;
                this.selectedRows.push(row);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, true);
                this.dispatchExternal("rowSelected", row.getComponent());
                this._rowSelectionChanged(silent, row);
                return row;
            }
        } else if (!silent) console.warn("Selection Error - No such row found, ignoring selection:" + rowInfo);
    }
    isRowSelected(row) {
        return this.selectedRows.indexOf(row) !== -1;
    }
    //deselect a number of rows
    deselectRows(rows, silent) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = Object.assign([], this.selectedRows);
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._deselectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(silent, [], changes);
            }
        } else if (rowMatch) this._deselectRow(rowMatch, silent, true);
    }
    //deselect an individual row
    _deselectRow(rowInfo, silent) {
        var self = this, row = self.table.rowManager.findRow(rowInfo), index, element;
        if (row) {
            index = self.selectedRows.findIndex(function(selectedRow) {
                return selectedRow == row;
            });
            if (index > -1) {
                element = row.getElement();
                if (element) element.classList.remove("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = false;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = false;
                self.selectedRows.splice(index, 1);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, false);
                this.dispatchExternal("rowDeselected", row.getComponent());
                self._rowSelectionChanged(silent, undefined, row);
                return row;
            }
        } else if (!silent) console.warn("Deselection Error - No such row found, ignoring selection:" + rowInfo);
    }
    getSelectedData() {
        var data = [];
        this.selectedRows.forEach(function(row) {
            data.push(row.getData());
        });
        return data;
    }
    getSelectedRows() {
        var rows = [];
        this.selectedRows.forEach(function(row) {
            rows.push(row.getComponent());
        });
        return rows;
    }
    _rowSelectionChanged(silent, selected = [], deselected = []) {
        if (this.headerCheckboxElement) {
            if (this.selectedRows.length === 0) {
                this.headerCheckboxElement.checked = false;
                this.headerCheckboxElement.indeterminate = false;
            } else if (this.table.rowManager.rows.length === this.selectedRows.length) {
                this.headerCheckboxElement.checked = true;
                this.headerCheckboxElement.indeterminate = false;
            } else {
                this.headerCheckboxElement.indeterminate = true;
                this.headerCheckboxElement.checked = false;
            }
        }
        if (!silent) {
            if (!Array.isArray(selected)) selected = [
                selected
            ];
            selected = selected.map((row)=>row.getComponent());
            if (!Array.isArray(deselected)) deselected = [
                deselected
            ];
            deselected = deselected.map((row)=>row.getComponent());
            this.dispatchExternal("rowSelectionChanged", this.getSelectedData(), this.getSelectedRows(), selected, deselected);
        }
    }
    registerRowSelectCheckbox(row, element) {
        if (!row._row.modules.select) row._row.modules.select = {};
        row._row.modules.select.checkboxEl = element;
    }
    registerHeaderSelectCheckbox(element) {
        this.headerCheckboxElement = element;
    }
    childRowSelection(row, select) {
        var children = this.table.modules.dataTree.getChildren(row, true, true);
        if (select) for (let child of children)this._selectRow(child, true);
        else for (let child of children)this._deselectRow(child, true);
    }
}
class $c2a9788f40f9c90a$export$433bfdbc52491af1 {
    constructor(range){
        this._range = range;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._range.table.componentFunctionBinder.handle("range", target._range, name);
            }
        });
    }
    getElement() {
        return this._range.element;
    }
    getData() {
        return this._range.getData();
    }
    getCells() {
        return this._range.getCells(true, true);
    }
    getStructuredCells() {
        return this._range.getStructuredCells();
    }
    getRows() {
        return this._range.getRows().map((row)=>row.getComponent());
    }
    getColumns() {
        return this._range.getColumns().map((column)=>column.getComponent());
    }
    getBounds() {
        return this._range.getBounds();
    }
    getTopEdge() {
        return this._range.top;
    }
    getBottomEdge() {
        return this._range.bottom;
    }
    getLeftEdge() {
        return this._range.left;
    }
    getRightEdge() {
        return this._range.right;
    }
    setBounds(start, end) {
        if (this._range.destroyedGuard("setBounds")) this._range.setBounds(start ? start._cell : start, end ? end._cell : end);
    }
    setStartBound(start) {
        if (this._range.destroyedGuard("setStartBound")) {
            this._range.setEndBound(start ? start._cell : start);
            this._range.rangeManager.layoutElement();
        }
    }
    setEndBound(end) {
        if (this._range.destroyedGuard("setEndBound")) {
            this._range.setEndBound(end ? end._cell : end);
            this._range.rangeManager.layoutElement();
        }
    }
    clearValues() {
        if (this._range.destroyedGuard("clearValues")) this._range.clearValues();
    }
    remove() {
        if (this._range.destroyedGuard("remove")) this._range.destroy(true);
    }
}
class $c2a9788f40f9c90a$var$Range extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, rangeManager, start, end){
        super(table);
        this.rangeManager = rangeManager;
        this.element = null;
        this.initialized = false;
        this.initializing = {
            start: false,
            end: false
        };
        this.destroyed = false;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
        this.table = table;
        this.start = {
            row: 0,
            col: 0
        };
        this.end = {
            row: 0,
            col: 0
        };
        if (this.rangeManager.rowHeader) {
            this.left = 1;
            this.right = 1;
            this.start.col = 1;
            this.end.col = 1;
        }
        this.initElement();
        setTimeout(()=>{
            this.initBounds(start, end);
        });
    }
    initElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-range");
    }
    initBounds(start, end) {
        this._updateMinMax();
        if (start) this.setBounds(start, end || start);
    }
    ///////////////////////////////////
    ///////   Boundary Setup    ///////
    ///////////////////////////////////
    setStart(row, col) {
        if (this.start.row !== row || this.start.col !== col) {
            this.start.row = row;
            this.start.col = col;
            this.initializing.start = true;
            this._updateMinMax();
        }
    }
    setEnd(row, col) {
        if (this.end.row !== row || this.end.col !== col) {
            this.end.row = row;
            this.end.col = col;
            this.initializing.end = true;
            this._updateMinMax();
        }
    }
    setBounds(start, end, visibleRows) {
        if (start) this.setStartBound(start);
        this.setEndBound(end || start);
        this.rangeManager.layoutElement(visibleRows);
    }
    setStartBound(element) {
        var row, col;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) this.setStart(0, element.getPosition() - 1);
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            if (element.column === this.rangeManager.rowHeader) this.setStart(row, 1);
            else this.setStart(row, col);
        }
    }
    setEndBound(element) {
        var rowsCount = this._getTableRows().length, row, col, isRowHeader;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) {
                if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, element.getPosition() - 1);
                else if (this.rangeManager.selecting === "cell") this.setEnd(0, element.getPosition() - 1);
            }
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            isRowHeader = element.column === this.rangeManager.rowHeader;
            if (this.rangeManager.selecting === "row") this.setEnd(row, this._getTableColumns().length - 1);
            else if (this.rangeManager.selecting !== "row" && isRowHeader) this.setEnd(row, 0);
            else if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, col);
            else this.setEnd(row, col);
        }
    }
    _updateMinMax() {
        this.top = Math.min(this.start.row, this.end.row);
        this.bottom = Math.max(this.start.row, this.end.row);
        this.left = Math.min(this.start.col, this.end.col);
        this.right = Math.max(this.start.col, this.end.col);
        if (this.initialized) this.dispatchExternal("rangeChanged", this.getComponent());
        else if (this.initializing.start && this.initializing.end) {
            this.initialized = true;
            this.dispatchExternal("rangeAdded", this.getComponent());
        }
    }
    _getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    _getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    ///////////////////////////////////
    ///////      Rendering      ///////
    ///////////////////////////////////
    layout() {
        var _vDomTop = this.table.rowManager.renderer.vDomTop, _vDomBottom = this.table.rowManager.renderer.vDomBottom, _vDomLeft = this.table.columnManager.renderer.leftCol, _vDomRight = this.table.columnManager.renderer.rightCol, top, bottom, left, right, topLeftCell, bottomRightCell, topLeftCellEl, bottomRightCellEl, topLeftRowEl, bottomRightRowEl;
        if (this.table.options.renderHorizontal === "virtual" && this.rangeManager.rowHeader) _vDomRight += 1;
        if (_vDomTop == null) _vDomTop = 0;
        if (_vDomBottom == null) _vDomBottom = Infinity;
        if (_vDomLeft == null) _vDomLeft = 0;
        if (_vDomRight == null) _vDomRight = Infinity;
        if (this.overlaps(_vDomLeft, _vDomTop, _vDomRight, _vDomBottom)) {
            top = Math.max(this.top, _vDomTop);
            bottom = Math.min(this.bottom, _vDomBottom);
            left = Math.max(this.left, _vDomLeft);
            right = Math.min(this.right, _vDomRight);
            topLeftCell = this.rangeManager.getCell(top, left);
            bottomRightCell = this.rangeManager.getCell(bottom, right);
            topLeftCellEl = topLeftCell.getElement();
            bottomRightCellEl = bottomRightCell.getElement();
            topLeftRowEl = topLeftCell.row.getElement();
            bottomRightRowEl = bottomRightCell.row.getElement();
            this.element.classList.add("tabulator-range-active");
            // this.element.classList.toggle("tabulator-range-active", this === this.rangeManager.activeRange);
            if (this.table.rtl) {
                this.element.style.right = topLeftRowEl.offsetWidth - topLeftCellEl.offsetLeft - topLeftCellEl.offsetWidth + "px";
                this.element.style.width = topLeftCellEl.offsetLeft + topLeftCellEl.offsetWidth - bottomRightCellEl.offsetLeft + "px";
            } else {
                this.element.style.left = topLeftRowEl.offsetLeft + topLeftCellEl.offsetLeft + "px";
                this.element.style.width = bottomRightCellEl.offsetLeft + bottomRightCellEl.offsetWidth - topLeftCellEl.offsetLeft + "px";
            }
            this.element.style.top = topLeftRowEl.offsetTop + "px";
            this.element.style.height = bottomRightRowEl.offsetTop + bottomRightRowEl.offsetHeight - topLeftRowEl.offsetTop + "px";
        }
    }
    atTopLeft(cell) {
        return cell.row.position - 1 === this.top && cell.column.getPosition() - 1 === this.left;
    }
    atBottomRight(cell) {
        return cell.row.position - 1 === this.bottom && cell.column.getPosition() - 1 === this.right;
    }
    occupies(cell) {
        return this.occupiesRow(cell.row) && this.occupiesColumn(cell.column);
    }
    occupiesRow(row) {
        return this.top <= row.position - 1 && row.position - 1 <= this.bottom;
    }
    occupiesColumn(col) {
        return this.left <= col.getPosition() - 1 && col.getPosition() - 1 <= this.right;
    }
    overlaps(left, top, right, bottom) {
        if (this.left > right || left > this.right || this.top > bottom || top > this.bottom) return false;
        return true;
    }
    getData() {
        var data = [], rows = this.getRows(), columns = this.getColumns();
        rows.forEach((row)=>{
            var rowData = row.getData(), result = {};
            columns.forEach((column)=>{
                result[column.field] = rowData[column.field];
            });
            data.push(result);
        });
        return data;
    }
    getCells(structured, component) {
        var cells = [], rows = this.getRows(), columns = this.getColumns();
        if (structured) cells = rows.map((row)=>{
            var arr = [];
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) arr.push(component ? cell.getComponent() : cell);
            });
            return arr;
        });
        else rows.forEach((row)=>{
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) cells.push(component ? cell.getComponent() : cell);
            });
        });
        return cells;
    }
    getStructuredCells() {
        return this.getCells(true, true);
    }
    getRows() {
        return this._getTableRows().slice(this.top, this.bottom + 1);
    }
    getColumns() {
        return this._getTableColumns().slice(this.left, this.right + 1);
    }
    clearValues() {
        var cells = this.getCells();
        var clearValue = this.table.options.selectableRangeClearCellsValue;
        this.table.blockRedraw();
        cells.forEach((cell)=>{
            cell.setValue(clearValue);
        });
        this.table.restoreRedraw();
    }
    getBounds(component) {
        var cells = this.getCells(false, component), output = {
            start: null,
            end: null
        };
        if (cells.length) {
            output.start = cells[0];
            output.end = cells[cells.length - 1];
        } else console.warn("No bounds defined on range");
        return output;
    }
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$433bfdbc52491af1(this);
        return this.component;
    }
    destroy(notify) {
        this.destroyed = true;
        this.element.remove();
        if (notify) this.rangeManager.rangeRemoved(this);
        if (this.initialized) this.dispatchExternal("rangeRemoved", this.getComponent());
    }
    destroyedGuard(func) {
        if (this.destroyed) console.warn("You cannot call the " + func + " function on a destroyed range");
        return !this.destroyed;
    }
}
var $c2a9788f40f9c90a$var$bindings = {
    rangeJumpUp: [
        "ctrl + 38",
        "meta + 38"
    ],
    rangeJumpDown: [
        "ctrl + 40",
        "meta + 40"
    ],
    rangeJumpLeft: [
        "ctrl + 37",
        "meta + 37"
    ],
    rangeJumpRight: [
        "ctrl + 39",
        "meta + 39"
    ],
    rangeExpandUp: "shift + 38",
    rangeExpandDown: "shift + 40",
    rangeExpandLeft: "shift + 37",
    rangeExpandRight: "shift + 39",
    rangeExpandJumpUp: [
        "ctrl + shift + 38",
        "meta + shift + 38"
    ],
    rangeExpandJumpDown: [
        "ctrl + shift + 40",
        "meta + shift + 40"
    ],
    rangeExpandJumpLeft: [
        "ctrl + shift + 37",
        "meta + shift + 37"
    ],
    rangeExpandJumpRight: [
        "ctrl + shift + 39",
        "meta + shift + 39"
    ]
};
var $c2a9788f40f9c90a$var$actions = {
    rangeJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, false);
    },
    rangeJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, false);
    },
    rangeJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, false);
    },
    rangeJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, false);
    },
    rangeExpandLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", false, true);
    },
    rangeExpandRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", false, true);
    },
    rangeExpandUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", false, true);
    },
    rangeExpandDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", false, true);
    },
    rangeExpandJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, true);
    },
    rangeExpandJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, true);
    },
    rangeExpandJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, true);
    },
    rangeExpandJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, true);
    }
};
var $c2a9788f40f9c90a$var$pasteActions = {
    range: function(data) {
        var rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, startRow, rowWidth, dataLength;
        dataLength = data.length;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                rows = this.table.rowManager.activeRows.slice();
                startRow = rows.indexOf(startCell.row);
                if (singleCell) rowWidth = data.length;
                else rowWidth = rows.indexOf(bounds.end.row) - startRow + 1;
                if (startRow > -1) {
                    this.table.blockRedraw();
                    rows = rows.slice(startRow, startRow + rowWidth);
                    rows.forEach((row, i)=>{
                        row.updateData(data[i % dataLength]);
                    });
                    this.table.restoreRedraw();
                }
            }
        }
        return rows;
    }
};
var $c2a9788f40f9c90a$var$pasteParsers = {
    range: function(clipboard) {
        var data = [], rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, colWidth, columnMap, startCol;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                //get data from clipboard into array of columns and rows.
                clipboard = clipboard.split("\n");
                clipboard.forEach(function(row) {
                    data.push(row.split("	"));
                });
                if (data.length) {
                    columnMap = this.table.columnManager.getVisibleColumnsByIndex();
                    startCol = columnMap.indexOf(startCell.column);
                    if (startCol > -1) {
                        if (singleCell) colWidth = data[0].length;
                        else colWidth = columnMap.indexOf(bounds.end.column) - startCol + 1;
                        columnMap = columnMap.slice(startCol, startCol + colWidth);
                        data.forEach((item)=>{
                            var row = {};
                            var itemLength = item.length;
                            columnMap.forEach(function(col, i) {
                                row[col.field] = item[i % itemLength];
                            });
                            rows.push(row);
                        });
                        return rows;
                    }
                }
            }
        }
        return false;
    }
};
var $c2a9788f40f9c90a$var$columnLookups = {
    range: function() {
        var columns = this.modules.selectRange.selectedColumns();
        if (this.columnManager.rowHeader) columns.unshift(this.columnManager.rowHeader);
        return columns;
    }
};
var $c2a9788f40f9c90a$var$rowLookups = {
    range: function() {
        return this.modules.selectRange.selectedRows();
    }
};
var $c2a9788f40f9c90a$var$extensions = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings,
        actions: $c2a9788f40f9c90a$var$actions
    },
    clipboard: {
        pasteActions: $c2a9788f40f9c90a$var$pasteActions,
        pasteParsers: $c2a9788f40f9c90a$var$pasteParsers
    },
    export: {
        columnLookups: $c2a9788f40f9c90a$var$columnLookups,
        rowLookups: $c2a9788f40f9c90a$var$rowLookups
    }
};
class $c2a9788f40f9c90a$export$cd9e469b2c8c819c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRange";
    static moduleInitOrder = 1;
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions;
    constructor(table){
        super(table);
        this.selecting = "cell";
        this.mousedown = false;
        this.ranges = [];
        this.overlay = null;
        this.rowHeader = null;
        this.layoutChangeTimeout = null;
        this.columnSelection = false;
        this.rowSelection = false;
        this.maxRanges = 0;
        this.activeRange = false;
        this.blockKeydown = false;
        this.keyDownEvent = this._handleKeyDown.bind(this);
        this.mouseUpEvent = this._handleMouseUp.bind(this);
        this.registerTableOption("selectableRange", false); //enable selectable range
        this.registerTableOption("selectableRangeColumns", false); //enable selectable range
        this.registerTableOption("selectableRangeRows", false); //enable selectable range
        this.registerTableOption("selectableRangeClearCells", false); //allow clearing of active range
        this.registerTableOption("selectableRangeClearCellsValue", undefined); //value for cleared active range
        this.registerTableOption("selectableRangeAutoFocus", true); //focus on a cell after resetRanges
        this.registerTableFunction("getRangesData", this.getRangesData.bind(this));
        this.registerTableFunction("getRanges", this.getRanges.bind(this));
        this.registerTableFunction("addRange", this.addRangeFromComponent.bind(this));
        this.registerComponentFunction("cell", "getRanges", this.cellGetRanges.bind(this));
        this.registerComponentFunction("row", "getRanges", this.rowGetRanges.bind(this));
        this.registerComponentFunction("column", "getRanges", this.colGetRanges.bind(this));
    }
    ///////////////////////////////////
    ///////    Initialization   ///////
    ///////////////////////////////////
    initialize() {
        if (this.options("selectableRange")) {
            if (!this.options("selectableRows")) {
                this.maxRanges = this.options("selectableRange");
                this.initializeTable();
                this.initializeWatchers();
            } else console.warn("SelectRange functionality cannot be used in conjunction with row selection");
            if (this.options("columns").findIndex((column)=>column.frozen) > 0) console.warn("Having frozen column in arbitrary position with selectRange option may result in unpredictable behavior.");
            if (this.options("columns").filter((column)=>column.frozen) > 1) console.warn("Having multiple frozen columns with selectRange option may result in unpredictable behavior.");
        }
    }
    initializeTable() {
        this.overlay = document.createElement("div");
        this.overlay.classList.add("tabulator-range-overlay");
        this.rangeContainer = document.createElement("div");
        this.rangeContainer.classList.add("tabulator-range-container");
        this.activeRangeCellElement = document.createElement("div");
        this.activeRangeCellElement.classList.add("tabulator-range-cell-active");
        this.overlay.appendChild(this.rangeContainer);
        this.overlay.appendChild(this.activeRangeCellElement);
        this.table.rowManager.element.addEventListener("keydown", this.keyDownEvent);
        this.resetRanges();
        this.table.rowManager.element.appendChild(this.overlay);
        this.table.columnManager.element.setAttribute("tabindex", 0);
        this.table.element.classList.add("tabulator-ranges");
    }
    initializeWatchers() {
        this.columnSelection = this.options("selectableRangeColumns");
        this.rowSelection = this.options("selectableRangeRows");
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-mousedown", this.handleColumnMouseDown.bind(this));
        this.subscribe("column-mousemove", this.handleColumnMouseMove.bind(this));
        this.subscribe("column-resized", this.handleColumnResized.bind(this));
        this.subscribe("column-moving", this.handleColumnMoving.bind(this));
        this.subscribe("column-moved", this.handleColumnMoved.bind(this));
        this.subscribe("column-width", this.layoutChange.bind(this));
        this.subscribe("column-height", this.layoutChange.bind(this));
        this.subscribe("column-resized", this.layoutChange.bind(this));
        this.subscribe("columns-loaded", this.updateHeaderColumn.bind(this));
        this.subscribe("cell-height", this.layoutChange.bind(this));
        this.subscribe("cell-rendered", this.renderCell.bind(this));
        this.subscribe("cell-mousedown", this.handleCellMouseDown.bind(this));
        this.subscribe("cell-mousemove", this.handleCellMouseMove.bind(this));
        this.subscribe("cell-click", this.handleCellClick.bind(this));
        this.subscribe("cell-editing", this.handleEditingCell.bind(this));
        this.subscribe("page-changed", this.redraw.bind(this));
        this.subscribe("scroll-vertical", this.layoutChange.bind(this));
        this.subscribe("scroll-horizontal", this.layoutChange.bind(this));
        this.subscribe("data-destroy", this.tableDestroyed.bind(this));
        this.subscribe("data-processed", this.resetRanges.bind(this));
        this.subscribe("table-layout", this.layoutElement.bind(this));
        this.subscribe("table-redraw", this.redraw.bind(this));
        this.subscribe("table-destroy", this.tableDestroyed.bind(this));
        this.subscribe("edit-editor-clear", this.finishEditingCell.bind(this));
        this.subscribe("edit-blur", this.restoreFocus.bind(this));
        this.subscribe("keybinding-nav-prev", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-next", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-left", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-right", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-up", this.keyNavigate.bind(this, "up"));
        this.subscribe("keybinding-nav-down", this.keyNavigate.bind(this, "down"));
        this.subscribe("keybinding-nav-range", this.keyNavigateRange.bind(this));
    }
    initializeColumn(column) {
        if (this.columnSelection && column.definition.headerSort && this.options("headerSortClickElement") !== "icon") console.warn("Using column headerSort with selectableRangeColumns option may result in unpredictable behavior. Consider using headerSortClickElement: 'icon'.");
        column.modules.edit;
    }
    updateHeaderColumn() {
        var frozenCols;
        if (this.rowSelection) {
            this.rowHeader = this.table.columnManager.getVisibleColumnsByIndex()[0];
            if (this.rowHeader) {
                this.rowHeader.definition.cssClass = this.rowHeader.definition.cssClass + " tabulator-range-row-header";
                if (this.rowHeader.definition.headerSort) console.warn("Using column headerSort with selectableRangeRows option may result in unpredictable behavior");
                if (this.rowHeader.definition.editor) console.warn("Using column editor with selectableRangeRows option may result in unpredictable behavior");
            }
        }
        //warn if invalid frozen column configuration detected
        if (this.table.modules.frozenColumns && this.table.modules.frozenColumns.active) {
            frozenCols = this.table.modules.frozenColumns.getFrozenColumns();
            if (frozenCols.length > 1 || frozenCols.length === 1 && frozenCols[0] !== this.rowHeader) console.warn("Using frozen columns that are not the range header in combination with the selectRange option may result in unpredictable behavior");
        }
    }
    ///////////////////////////////////
    ///////   Table Functions   ///////
    ///////////////////////////////////
    getRanges() {
        return this.ranges.map((range)=>range.getComponent());
    }
    getRangesData() {
        return this.ranges.map((range)=>range.getData());
    }
    addRangeFromComponent(start, end) {
        start = start ? start._cell : null;
        end = end ? end._cell : null;
        return this.addRange(start, end);
    }
    ///////////////////////////////////
    /////// Component Functions ///////
    ///////////////////////////////////
    cellGetRanges(cell) {
        var ranges = [];
        if (cell.column === this.rowHeader) ranges = this.ranges.filter((range)=>range.occupiesRow(cell.row));
        else ranges = this.ranges.filter((range)=>range.occupies(cell));
        return ranges.map((range)=>range.getComponent());
    }
    rowGetRanges(row) {
        var ranges = this.ranges.filter((range)=>range.occupiesRow(row));
        return ranges.map((range)=>range.getComponent());
    }
    colGetRanges(col) {
        var ranges = this.ranges.filter((range)=>range.occupiesColumn(col));
        return ranges.map((range)=>range.getComponent());
    }
    ///////////////////////////////////
    ////////// Event Handlers /////////
    ///////////////////////////////////
    _handleMouseUp(e) {
        this.mousedown = false;
        document.removeEventListener("mouseup", this.mouseUpEvent);
    }
    _handleKeyDown(e) {
        if (!this.blockKeydown && (!this.table.modules.edit || this.table.modules.edit && !this.table.modules.edit.currentCell)) {
            if (e.key === "Enter") {
                // is editing a cell?
                if (this.table.modules.edit && this.table.modules.edit.currentCell) return;
                this.table.modules.edit.editCell(this.getActiveCell());
                e.preventDefault();
            }
            if ((e.key === "Backspace" || e.key === "Delete") && this.options("selectableRangeClearCells")) {
                if (this.activeRange) this.activeRange.clearValues();
            }
        }
    }
    initializeFocus(cell) {
        var range;
        this.restoreFocus();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    restoreFocus(element) {
        this.table.rowManager.element.focus();
        return true;
    }
    ///////////////////////////////////
    ////// Column Functionality ///////
    ///////////////////////////////////
    handleColumnResized(column) {
        var selected;
        if (this.selecting !== "column" && this.selecting !== "all") return;
        selected = this.ranges.some((range)=>range.occupiesColumn(column));
        if (!selected) return;
        this.ranges.forEach((range)=>{
            var selectedColumns = range.getColumns(true);
            selectedColumns.forEach((selectedColumn)=>{
                if (selectedColumn !== column) selectedColumn.setWidth(column.width);
            });
        });
    }
    handleColumnMoving(_event, column) {
        this.resetRanges().setBounds(column);
        this.overlay.style.visibility = "hidden";
    }
    handleColumnMoved(from, _to, _after) {
        this.activeRange.setBounds(from);
        this.layoutElement();
    }
    handleColumnMouseDown(event, column) {
        if (event.button === 2 && (this.selecting === "column" || this.selecting === "all") && this.activeRange.occupiesColumn(column)) return;
        //If columns are movable, allow dragging columns only if they are not
        //selected. Dragging selected columns should move the columns instead.
        if (this.table.options.movableColumns && this.selecting === "column" && this.activeRange.occupiesColumn(column)) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, column);
    }
    handleColumnMouseMove(e, column) {
        if (column === this.rowHeader || !this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, column, true);
    }
    ///////////////////////////////////
    //////// Cell Functionality ///////
    ///////////////////////////////////
    renderCell(cell) {
        var el = cell.getElement(), rangeIdx = this.ranges.findIndex((range)=>range.occupies(cell));
        el.classList.toggle("tabulator-range-selected", rangeIdx !== -1);
        el.classList.toggle("tabulator-range-only-cell-selected", this.ranges.length === 1 && this.ranges[0].atTopLeft(cell) && this.ranges[0].atBottomRight(cell));
        el.dataset.range = rangeIdx;
    }
    handleCellMouseDown(event, cell) {
        if (event.button === 2 && (this.activeRange.occupies(cell) || (this.selecting === "row" || this.selecting === "all") && this.activeRange.occupiesRow(cell.row))) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, cell);
    }
    handleCellMouseMove(e, cell) {
        if (!this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, cell, true);
    }
    handleCellClick(e, cell) {
        this.initializeFocus(cell);
    }
    handleEditingCell(cell) {
        if (this.activeRange) this.activeRange.setBounds(cell);
    }
    finishEditingCell() {
        this.blockKeydown = true;
        this.table.rowManager.element.focus();
        setTimeout(()=>{
            this.blockKeydown = false;
        }, 10);
    }
    ///////////////////////////////////
    ///////     Navigation      ///////
    ///////////////////////////////////
    keyNavigate(dir, e) {
        this.navigate(false, false, dir);
        e.preventDefault();
    }
    keyNavigateRange(e, dir, jump, expand) {
        this.navigate(jump, expand, dir);
        e.preventDefault();
    }
    navigate(jump, expand, dir) {
        var moved = false, range, rangeEdge, prevRect, nextRow, nextCol, row, column, rowRect, rowManagerRect, columnRect, columnManagerRect;
        // Don't navigate while editing
        if (this.table.modules.edit && this.table.modules.edit.currentCell) return false;
        // If there are more than 1 range, use the active range and destroy the others
        if (this.ranges.length > 1) this.ranges = this.ranges.filter((range)=>{
            if (range === this.activeRange) {
                range.setEnd(range.start.row, range.start.col);
                return true;
            }
            range.destroy();
            return false;
        });
        range = this.activeRange;
        prevRect = {
            top: range.top,
            bottom: range.bottom,
            left: range.left,
            right: range.right
        };
        rangeEdge = expand ? range.end : range.start;
        nextRow = rangeEdge.row;
        nextCol = rangeEdge.col;
        if (jump) switch(dir){
            case "left":
                nextCol = this.findJumpCellLeft(range.start.row, rangeEdge.col);
                break;
            case "right":
                nextCol = this.findJumpCellRight(range.start.row, rangeEdge.col);
                break;
            case "up":
                nextRow = this.findJumpCellUp(rangeEdge.row, range.start.col);
                break;
            case "down":
                nextRow = this.findJumpCellDown(rangeEdge.row, range.start.col);
                break;
        }
        else {
            if (expand) {
                if (this.selecting === "row" && (dir === "left" || dir === "right") || this.selecting === "column" && (dir === "up" || dir === "down")) return;
            }
            switch(dir){
                case "left":
                    nextCol = Math.max(nextCol - 1, 0);
                    break;
                case "right":
                    nextCol = Math.min(nextCol + 1, this.getTableColumns().length - 1);
                    break;
                case "up":
                    nextRow = Math.max(nextRow - 1, 0);
                    break;
                case "down":
                    nextRow = Math.min(nextRow + 1, this.getTableRows().length - 1);
                    break;
            }
        }
        if (this.rowHeader && nextCol === 0) nextCol = 1;
        if (!expand) range.setStart(nextRow, nextCol);
        range.setEnd(nextRow, nextCol);
        if (!expand) this.selecting = "cell";
        moved = prevRect.top !== range.top || prevRect.bottom !== range.bottom || prevRect.left !== range.left || prevRect.right !== range.right;
        if (moved) {
            row = this.getRowByRangePos(range.end.row);
            column = this.getColumnByRangePos(range.end.col);
            rowRect = row.getElement().getBoundingClientRect();
            columnRect = column.getElement().getBoundingClientRect();
            rowManagerRect = this.table.rowManager.getElement().getBoundingClientRect();
            columnManagerRect = this.table.columnManager.getElement().getBoundingClientRect();
            if (!(rowRect.top >= rowManagerRect.top && rowRect.bottom <= rowManagerRect.bottom)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else row.getComponent().scrollTo(undefined, false);
            }
            if (!(columnRect.left >= columnManagerRect.left + this.getRowHeaderWidth() && columnRect.right <= columnManagerRect.right)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else column.getComponent().scrollTo(undefined, false);
            }
            this.layoutElement();
            return true;
        }
    }
    rangeRemoved(removed) {
        this.ranges = this.ranges.filter((range)=>range !== removed);
        if (this.activeRange === removed) {
            if (this.ranges.length) this.activeRange = this.ranges[this.ranges.length - 1];
            else this.addRange();
        }
        this.layoutElement();
    }
    findJumpRow(column, rows, reverse, emptyStart, emptySide) {
        if (reverse) rows = rows.reverse();
        return this.findJumpItem(emptyStart, emptySide, rows, function(row) {
            return row.getData()[column.getField()];
        });
    }
    findJumpCol(row, columns, reverse, emptyStart, emptySide) {
        if (reverse) columns = columns.reverse();
        return this.findJumpItem(emptyStart, emptySide, columns, function(column) {
            return row.getData()[column.getField()];
        });
    }
    findJumpItem(emptyStart, emptySide, items, valueResolver) {
        var nextItem;
        for (let currentItem of items){
            let currentValue = valueResolver(currentItem);
            if (emptyStart) {
                nextItem = currentItem;
                if (currentValue) break;
            } else if (emptySide) {
                nextItem = currentItem;
                if (currentValue) break;
            } else {
                if (currentValue) nextItem = currentItem;
                else break;
            }
        }
        return nextItem;
    }
    findJumpCellLeft(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isLeftOfStartingCellEmpty = columns[colPos - 1] ? this.isEmpty(row.getData()[columns[colPos - 1].getField()]) : false, targetCols = this.rowHeader ? columns.slice(1, colPos) : columns.slice(0, colPos), jumpCol = this.findJumpCol(row, targetCols, true, isStartingCellEmpty, isLeftOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellRight(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isRightOfStartingCellEmpty = columns[colPos + 1] ? this.isEmpty(row.getData()[columns[colPos + 1].getField()]) : false, jumpCol = this.findJumpCol(row, columns.slice(colPos + 1, columns.length), false, isStartingCellEmpty, isRightOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellUp(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isTopOfStartingCellEmpty = rows[rowPos - 1] ? this.isEmpty(rows[rowPos - 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(0, rowPos), true, isStartingCellEmpty, isTopOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    findJumpCellDown(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isBottomOfStartingCellEmpty = rows[rowPos + 1] ? this.isEmpty(rows[rowPos + 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(rowPos + 1, rows.length), false, isStartingCellEmpty, isBottomOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    ///////////////////////////////////
    ///////      Selection      ///////
    ///////////////////////////////////
    newSelection(event, element) {
        var range;
        if (element.type === "column") {
            if (!this.columnSelection) return;
            if (element === this.rowHeader) {
                range = this.resetRanges();
                this.selecting = "all";
                var topLeftCell, bottomRightCell = this.getCell(-1, -1);
                if (this.rowHeader) topLeftCell = this.getCell(0, 1);
                else topLeftCell = this.getCell(0, 0);
                range.setBounds(topLeftCell, bottomRightCell);
                return;
            } else this.selecting = "column";
        } else if (element.column === this.rowHeader) this.selecting = "row";
        else this.selecting = "cell";
        if (event.shiftKey) this.activeRange.setBounds(false, element);
        else if (event.ctrlKey) this.addRange().setBounds(element);
        else this.resetRanges().setBounds(element);
    }
    autoScroll(range, row, column) {
        var tableHolder = this.table.rowManager.element, rect, view, withinHorizontalView, withinVerticalView;
        if (typeof row === "undefined") row = this.getRowByRangePos(range.end.row).getElement();
        if (typeof column === "undefined") column = this.getColumnByRangePos(range.end.col).getElement();
        rect = {
            left: column.offsetLeft,
            right: column.offsetLeft + column.offsetWidth,
            top: row.offsetTop,
            bottom: row.offsetTop + row.offsetHeight
        };
        view = {
            left: tableHolder.scrollLeft + this.getRowHeaderWidth(),
            right: Math.ceil(tableHolder.scrollLeft + tableHolder.clientWidth),
            top: tableHolder.scrollTop,
            bottom: tableHolder.scrollTop + tableHolder.offsetHeight - this.table.rowManager.scrollbarWidth
        };
        withinHorizontalView = view.left < rect.left && rect.left < view.right && view.left < rect.right && rect.right < view.right;
        withinVerticalView = view.top < rect.top && rect.top < view.bottom && view.top < rect.bottom && rect.bottom < view.bottom;
        if (!withinHorizontalView) {
            if (rect.left < view.left) tableHolder.scrollLeft = rect.left - this.getRowHeaderWidth();
            else if (rect.right > view.right) tableHolder.scrollLeft = Math.min(rect.right - tableHolder.clientWidth, rect.left - this.getRowHeaderWidth());
        }
        if (!withinVerticalView) {
            if (rect.top < view.top) tableHolder.scrollTop = rect.top;
            else if (rect.bottom > view.bottom) tableHolder.scrollTop = rect.bottom - tableHolder.clientHeight;
        }
    }
    ///////////////////////////////////
    ///////       Layout        ///////
    ///////////////////////////////////
    layoutChange() {
        this.overlay.style.visibility = "hidden";
        clearTimeout(this.layoutChangeTimeout);
        this.layoutChangeTimeout = setTimeout(this.layoutRanges.bind(this), 200);
    }
    redraw(force) {
        if (force) {
            this.selecting = "cell";
            this.resetRanges();
            this.layoutElement();
        }
    }
    layoutElement(visibleRows) {
        var rows;
        if (visibleRows) rows = this.table.rowManager.getVisibleRows(true);
        else rows = this.table.rowManager.getRows();
        rows.forEach((row)=>{
            if (row.type === "row") {
                this.layoutRow(row);
                row.cells.forEach((cell)=>this.renderCell(cell));
            }
        });
        this.getTableColumns().forEach((column)=>{
            this.layoutColumn(column);
        });
        this.layoutRanges();
    }
    layoutRow(row) {
        var el = row.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesRow(row));
        if (this.selecting === "row") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutColumn(column) {
        var el = column.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesColumn(column));
        if (this.selecting === "column") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutRanges() {
        var activeCell, activeCellEl, activeRowEl;
        if (!this.table.initialized) return;
        activeCell = this.getActiveCell();
        if (!activeCell) return;
        activeCellEl = activeCell.getElement();
        activeRowEl = activeCell.row.getElement();
        if (this.table.rtl) this.activeRangeCellElement.style.right = activeRowEl.offsetWidth - activeCellEl.offsetLeft - activeCellEl.offsetWidth + "px";
        else this.activeRangeCellElement.style.left = activeRowEl.offsetLeft + activeCellEl.offsetLeft + "px";
        this.activeRangeCellElement.style.top = activeRowEl.offsetTop + "px";
        this.activeRangeCellElement.style.width = activeCellEl.offsetWidth + "px";
        this.activeRangeCellElement.style.height = activeRowEl.offsetHeight + "px";
        this.ranges.forEach((range)=>range.layout());
        this.overlay.style.visibility = "visible";
    }
    ///////////////////////////////////
    ///////  Helper Functions   ///////
    ///////////////////////////////////	
    getCell(rowIdx, colIdx) {
        var row;
        if (colIdx < 0) {
            colIdx = this.getTableColumns().length + colIdx;
            if (colIdx < 0) return null;
        }
        if (rowIdx < 0) rowIdx = this.getTableRows().length + rowIdx;
        row = this.table.rowManager.getRowFromPosition(rowIdx + 1);
        return row ? row.getCells(false, true).filter((cell)=>cell.column.visible)[colIdx] : null;
    }
    getActiveCell() {
        return this.getCell(this.activeRange.start.row, this.activeRange.start.col);
    }
    getRowByRangePos(pos) {
        return this.getTableRows()[pos];
    }
    getColumnByRangePos(pos) {
        return this.getTableColumns()[pos];
    }
    getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    addRange(start, end) {
        var range;
        if (this.maxRanges !== true && this.ranges.length >= this.maxRanges) this.ranges.shift().destroy();
        range = new $c2a9788f40f9c90a$var$Range(this.table, this, start, end);
        this.activeRange = range;
        this.ranges.push(range);
        this.rangeContainer.appendChild(range.element);
        return range;
    }
    resetRanges() {
        var range, cell, visibleCells;
        this.ranges.forEach((range)=>range.destroy());
        this.ranges = [];
        range = this.addRange();
        if (this.table.rowManager.activeRows.length) {
            visibleCells = this.table.rowManager.activeRows[0].cells.filter((cell)=>cell.column.visible);
            cell = visibleCells[this.rowHeader ? 1 : 0];
            if (cell) {
                range.setBounds(cell);
                if (this.options("selectableRangeAutoFocus")) this.initializeFocus(cell);
            }
        }
        return range;
    }
    tableDestroyed() {
        document.removeEventListener("mouseup", this.mouseUpEvent);
        this.table.rowManager.element.removeEventListener("keydown", this.keyDownEvent);
    }
    selectedRows(component) {
        return component ? this.activeRange.getRows().map((row)=>row.getComponent()) : this.activeRange.getRows();
    }
    selectedColumns(component) {
        return component ? this.activeRange.getColumns().map((col)=>col.getComponent()) : this.activeRange.getColumns();
    }
    getRowHeaderWidth() {
        if (!this.rowHeader) return 0;
        return this.rowHeader.getElement().offsetWidth;
    }
    isEmpty(value) {
        return value === null || value === undefined || value === "";
    }
}
//sort numbers
function $c2a9788f40f9c90a$var$number(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var decimal = params.decimalSeparator;
    var thousand = params.thousandSeparator;
    var emptyAlign = 0;
    a = String(a);
    b = String(b);
    if (thousand) {
        a = a.split(thousand).join("");
        b = b.split(thousand).join("");
    }
    if (decimal) {
        a = a.split(decimal).join(".");
        b = b.split(decimal).join(".");
    }
    a = parseFloat(a);
    b = parseFloat(b);
    //handle non numeric values
    if (isNaN(a)) emptyAlign = isNaN(b) ? 0 : -1;
    else if (isNaN(b)) emptyAlign = 1;
    else //compare valid values
    return a - b;
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort strings
function $c2a9788f40f9c90a$var$string(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    var locale;
    //handle empty values
    if (!a) emptyAlign = !b ? 0 : -1;
    else if (!b) emptyAlign = 1;
    else {
        //compare valid values
        switch(typeof params.locale){
            case "boolean":
                if (params.locale) locale = this.langLocale();
                break;
            case "string":
                locale = params.locale;
                break;
        }
        return String(a).toLowerCase().localeCompare(String(b).toLowerCase(), locale);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort datetime
function $c2a9788f40f9c90a$var$datetime(a, b, aRow, bRow, column, dir, params) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var format = params.format || "dd/MM/yyyy HH:mm:ss", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0;
    if (typeof DT != "undefined") {
        if (!DT.isDateTime(a)) {
            if (format === "iso") a = DT.fromISO(String(a));
            else a = DT.fromFormat(String(a), format);
        }
        if (!DT.isDateTime(b)) {
            if (format === "iso") b = DT.fromISO(String(b));
            else b = DT.fromFormat(String(b), format);
        }
        if (!a.isValid) emptyAlign = !b.isValid ? 0 : -1;
        else if (!b.isValid) emptyAlign = 1;
        else //compare valid values
        return a - b;
        //fix empty values in position
        if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
        return emptyAlign;
    } else console.error("Sort Error - 'datetime' sorter is dependant on luxon.js");
}
//sort date
function $c2a9788f40f9c90a$var$date(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "dd/MM/yyyy";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort times
function $c2a9788f40f9c90a$var$time(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "HH:mm";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort booleans
function $c2a9788f40f9c90a$var$boolean(a, b, aRow, bRow, column, dir, params) {
    var el1 = a === true || a === "true" || a === "True" || a === 1 ? 1 : 0;
    var el2 = b === true || b === "true" || b === "True" || b === 1 ? 1 : 0;
    return el1 - el2;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$array(a, b, aRow, bRow, column, dir, params) {
    var type = params.type || "length", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0, table = this.table, valueMap;
    if (params.valueMap) {
        if (typeof params.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, params.valueMap, item);
            });
        };
        else valueMap = params.valueMap;
    }
    function calc(value) {
        var result;
        if (valueMap) value = valueMap(value);
        switch(type){
            case "length":
                result = value.length;
                break;
            case "sum":
                result = value.reduce(function(c, d) {
                    return c + d;
                });
                break;
            case "max":
                result = Math.max.apply(null, value);
                break;
            case "min":
                result = Math.min.apply(null, value);
                break;
            case "avg":
                result = value.reduce(function(c, d) {
                    return c + d;
                }) / value.length;
                break;
            case "string":
                result = value.join("");
                break;
        }
        return result;
    }
    //handle non array values
    if (!Array.isArray(a)) emptyAlign = !Array.isArray(b) ? 0 : -1;
    else if (!Array.isArray(b)) emptyAlign = 1;
    else {
        if (type === "string") return String(calc(a)).toLowerCase().localeCompare(String(calc(b)).toLowerCase());
        else return calc(b) - calc(a);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$exists(a, b, aRow, bRow, column, dir, params) {
    var el1 = typeof a == "undefined" ? 0 : 1;
    var el2 = typeof b == "undefined" ? 0 : 1;
    return el1 - el2;
}
//sort alpha numeric strings
function $c2a9788f40f9c90a$var$alphanum(as, bs, aRow, bRow, column, dir, params) {
    var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    //handle empty values
    if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
    else if (!bs && bs !== 0) emptyAlign = 1;
    else {
        if (isFinite(as) && isFinite(bs)) return as - bs;
        a = String(as).toLowerCase();
        b = String(bs).toLowerCase();
        if (a === b) return 0;
        if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
        a = a.match(rx);
        b = b.match(rx);
        L = a.length > b.length ? b.length : a.length;
        while(i < L){
            a1 = a[i];
            b1 = b[i++];
            if (a1 !== b1) {
                if (isFinite(a1) && isFinite(b1)) {
                    if (a1.charAt(0) === "0") a1 = "." + a1;
                    if (b1.charAt(0) === "0") b1 = "." + b1;
                    return a1 - b1;
                } else return a1 > b1 ? 1 : -1;
            }
        }
        return a.length > b.length;
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
var $c2a9788f40f9c90a$var$defaultSorters = {
    number: $c2a9788f40f9c90a$var$number,
    string: $c2a9788f40f9c90a$var$string,
    date: $c2a9788f40f9c90a$var$date,
    time: $c2a9788f40f9c90a$var$time,
    datetime: $c2a9788f40f9c90a$var$datetime,
    boolean: $c2a9788f40f9c90a$var$boolean,
    array: $c2a9788f40f9c90a$var$array,
    exists: $c2a9788f40f9c90a$var$exists,
    alphanum: $c2a9788f40f9c90a$var$alphanum
};
class $c2a9788f40f9c90a$export$5b492eb49d632e3f extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "sort";
    //load defaults
    static sorters = $c2a9788f40f9c90a$var$defaultSorters;
    constructor(table){
        super(table);
        this.sortList = []; //holder current sort
        this.changed = false; //has the sort changed since last render
        this.registerTableOption("sortMode", "local"); //local or remote sorting
        this.registerTableOption("initialSort", false); //initial sorting criteria
        this.registerTableOption("columnHeaderSortMulti", true); //multiple or single column sorting
        this.registerTableOption("sortOrderReverse", false); //reverse internal sort ordering
        this.registerTableOption("headerSortElement", "<div class='tabulator-arrow'></div>"); //header sort element
        this.registerTableOption("headerSortClickElement", "header"); //element which triggers sort when clicked
        this.registerColumnOption("sorter");
        this.registerColumnOption("sorterParams");
        this.registerColumnOption("headerSort", true);
        this.registerColumnOption("headerSortStartingDir");
        this.registerColumnOption("headerSortTristate");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.registerDataHandler(this.sort.bind(this), 20);
        this.registerTableFunction("setSort", this.userSetSort.bind(this));
        this.registerTableFunction("getSorters", this.getSort.bind(this));
        this.registerTableFunction("clearSort", this.clearSort.bind(this));
        if (this.table.options.sortMode === "remote") this.subscribe("data-params", this.remoteSortParams.bind(this));
    }
    tableBuilt() {
        if (this.table.options.initialSort) this.setSort(this.table.options.initialSort);
    }
    remoteSortParams(data, config, silent, params) {
        var sorters = this.getSort();
        sorters.forEach((item)=>{
            delete item.column;
        });
        params.sort = sorters;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetSort(sortList, dir) {
        this.setSort(sortList, dir);
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    clearSort() {
        this.clear();
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //initialize column header for sorting
    initializeColumn(column) {
        var sorter = false, colEl, arrowEl;
        switch(typeof column.definition.sorter){
            case "string":
                if ($c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter]) sorter = $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter];
                else console.warn("Sort Error - No such sorter found: ", column.definition.sorter);
                break;
            case "function":
                sorter = column.definition.sorter;
                break;
        }
        column.modules.sort = {
            sorter: sorter,
            dir: "none",
            params: column.definition.sorterParams || {},
            startingDir: column.definition.headerSortStartingDir || "asc",
            tristate: column.definition.headerSortTristate
        };
        if (column.definition.headerSort !== false) {
            colEl = column.getElement();
            colEl.classList.add("tabulator-sortable");
            arrowEl = document.createElement("div");
            arrowEl.classList.add("tabulator-col-sorter");
            switch(this.table.options.headerSortClickElement){
                case "icon":
                    arrowEl.classList.add("tabulator-col-sorter-element");
                    break;
                case "header":
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
                default:
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
            }
            switch(this.table.options.headerSortElement){
                case "function":
                    break;
                case "object":
                    arrowEl.appendChild(this.table.options.headerSortElement);
                    break;
                default:
                    arrowEl.innerHTML = this.table.options.headerSortElement;
            }
            //create sorter arrow
            column.titleHolderElement.appendChild(arrowEl);
            column.modules.sort.element = arrowEl;
            this.setColumnHeaderSortIcon(column, "none");
            if (this.table.options.headerSortClickElement === "icon") arrowEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            //sort on click
            (this.table.options.headerSortClickElement === "icon" ? arrowEl : colEl).addEventListener("click", (e)=>{
                var dir = "", sorters = [], match = false;
                if (column.modules.sort) {
                    if (column.modules.sort.tristate) {
                        if (column.modules.sort.dir == "none") dir = column.modules.sort.startingDir;
                        else if (column.modules.sort.dir == column.modules.sort.startingDir) dir = column.modules.sort.dir == "asc" ? "desc" : "asc";
                        else dir = "none";
                    } else switch(column.modules.sort.dir){
                        case "asc":
                            dir = "desc";
                            break;
                        case "desc":
                            dir = "asc";
                            break;
                        default:
                            dir = column.modules.sort.startingDir;
                    }
                    if (this.table.options.columnHeaderSortMulti && (e.shiftKey || e.ctrlKey)) {
                        sorters = this.getSort();
                        match = sorters.findIndex((sorter)=>{
                            return sorter.field === column.getField();
                        });
                        if (match > -1) {
                            sorters[match].dir = dir;
                            match = sorters.splice(match, 1)[0];
                            if (dir != "none") sorters.push(match);
                        } else if (dir != "none") sorters.push({
                            column: column,
                            dir: dir
                        });
                        //add to existing sort
                        this.setSort(sorters);
                    } else if (dir == "none") this.clear();
                    else //sort by column only
                    this.setSort(column, dir);
                    // this.table.rowManager.sorterRefresh(!this.sortList.length);
                    this.refreshSort();
                }
            });
        }
    }
    refreshSort() {
        if (this.table.options.sortMode === "remote") this.reloadData(null, false, false);
        else this.refreshData(true);
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the sorters have changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //return current sorters
    getSort() {
        var self = this, sorters = [];
        self.sortList.forEach(function(item) {
            if (item.column) sorters.push({
                column: item.column.getComponent(),
                field: item.column.getField(),
                dir: item.dir
            });
        });
        return sorters;
    }
    //change sort list and trigger sort
    setSort(sortList, dir) {
        var self = this, newSortList = [];
        if (!Array.isArray(sortList)) sortList = [
            {
                column: sortList,
                dir: dir
            }
        ];
        sortList.forEach(function(item) {
            var column;
            column = self.table.columnManager.findColumn(item.column);
            if (column) {
                item.column = column;
                newSortList.push(item);
                self.changed = true;
            } else console.warn("Sort Warning - Sort field does not exist and is being ignored: ", item.column);
        });
        self.sortList = newSortList;
        this.dispatch("sort-changed");
    }
    //clear sorters
    clear() {
        this.setSort([]);
    }
    //find appropriate sorter for column
    findSorter(column) {
        var row = this.table.rowManager.activeRows[0], sorter = "string", field, value;
        if (row) {
            row = row.getData();
            field = column.getField();
            if (field) {
                value = column.getFieldValue(row);
                switch(typeof value){
                    case "undefined":
                        sorter = "string";
                        break;
                    case "boolean":
                        sorter = "boolean";
                        break;
                    default:
                        if (!isNaN(value) && value !== "") sorter = "number";
                        else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                        break;
                }
            }
        }
        return $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[sorter];
    }
    //work through sort list sorting data
    sort(data, sortOnly) {
        var self = this, sortList = this.table.options.sortOrderReverse ? self.sortList.slice().reverse() : self.sortList, sortListActual = [], rowComponents = [];
        if (this.subscribedExternal("dataSorting")) this.dispatchExternal("dataSorting", self.getSort());
        if (!sortOnly) self.clearColumnHeaders();
        if (this.table.options.sortMode !== "remote") {
            //build list of valid sorters and trigger column specific callbacks before sort begins
            sortList.forEach(function(item, i) {
                var sortObj;
                if (item.column) {
                    sortObj = item.column.modules.sort;
                    if (sortObj) {
                        //if no sorter has been defined, take a guess
                        if (!sortObj.sorter) sortObj.sorter = self.findSorter(item.column);
                        item.params = typeof sortObj.params === "function" ? sortObj.params(item.column.getComponent(), item.dir) : sortObj.params;
                        sortListActual.push(item);
                    }
                    if (!sortOnly) self.setColumnHeader(item.column, item.dir);
                }
            });
            //sort data
            if (sortListActual.length) self._sortItems(data, sortListActual);
        } else if (!sortOnly) sortList.forEach(function(item, i) {
            self.setColumnHeader(item.column, item.dir);
        });
        if (this.subscribedExternal("dataSorted")) {
            data.forEach((row)=>{
                rowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataSorted", self.getSort(), rowComponents);
        }
        return data;
    }
    //clear sort arrows on columns
    clearColumnHeaders() {
        this.table.columnManager.getRealColumns().forEach((column)=>{
            if (column.modules.sort) {
                column.modules.sort.dir = "none";
                column.getElement().setAttribute("aria-sort", "none");
                this.setColumnHeaderSortIcon(column, "none");
            }
        });
    }
    //set the column header sort direction
    setColumnHeader(column, dir) {
        column.modules.sort.dir = dir;
        column.getElement().setAttribute("aria-sort", dir === "asc" ? "ascending" : "descending");
        this.setColumnHeaderSortIcon(column, dir);
    }
    setColumnHeaderSortIcon(column, dir) {
        var sortEl = column.modules.sort.element, arrowEl;
        if (column.definition.headerSort && typeof this.table.options.headerSortElement === "function") {
            while(sortEl.firstChild)sortEl.removeChild(sortEl.firstChild);
            arrowEl = this.table.options.headerSortElement.call(this.table, column.getComponent(), dir);
            if (typeof arrowEl === "object") sortEl.appendChild(arrowEl);
            else sortEl.innerHTML = arrowEl;
        }
    }
    //sort each item in sort list
    _sortItems(data, sortList) {
        var sorterCount = sortList.length - 1;
        data.sort((a, b)=>{
            var result;
            for(var i = sorterCount; i >= 0; i--){
                let sortItem = sortList[i];
                result = this._sortRow(a, b, sortItem.column, sortItem.dir, sortItem.params);
                if (result !== 0) break;
            }
            return result;
        });
    }
    //process individual rows for a sort function on active data
    _sortRow(a, b, column, dir, params) {
        var el1Comp, el2Comp;
        //switch elements depending on search direction
        var el1 = dir == "asc" ? a : b;
        var el2 = dir == "asc" ? b : a;
        a = column.getFieldValue(el1.getData());
        b = column.getFieldValue(el2.getData());
        a = typeof a !== "undefined" ? a : "";
        b = typeof b !== "undefined" ? b : "";
        el1Comp = el1.getComponent();
        el2Comp = el2.getComponent();
        return column.modules.sort.sorter.call(this, a, b, el1Comp, el2Comp, column.getComponent(), dir, params);
    }
}
class $c2a9788f40f9c90a$var$GridCalculator {
    constructor(columns, rows){
        this.columnCount = columns;
        this.rowCount = rows;
        this.columnString = [];
        this.columns = [];
        this.rows = [];
    }
    genColumns(data) {
        var colCount = Math.max(this.columnCount, Math.max(...data.map((item)=>item.length)));
        this.columnString = [];
        this.columns = [];
        for(let i = 1; i <= colCount; i++){
            this.incrementChar(this.columnString.length - 1);
            this.columns.push(this.columnString.join(""));
        }
        return this.columns;
    }
    genRows(data) {
        var rowCount = Math.max(this.rowCount, data.length);
        this.rows = [];
        for(let i = 1; i <= rowCount; i++)this.rows.push(i);
        return this.rows;
    }
    incrementChar(i) {
        let char = this.columnString[i];
        if (char) {
            if (char !== "Z") this.columnString[i] = String.fromCharCode(this.columnString[i].charCodeAt(0) + 1);
            else {
                this.columnString[i] = "A";
                if (i) this.incrementChar(i - 1);
                else this.columnString.push("A");
            }
        } else this.columnString.push("A");
    }
    setRowCount(count) {
        this.rowCount = count;
    }
    setColumnCount(count) {
        this.columnCount = count;
    }
}
class $c2a9788f40f9c90a$export$bcf87d11d46ea94f {
    constructor(sheet){
        this._sheet = sheet;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._sheet.table.componentFunctionBinder.handle("sheet", target._sheet, name);
            }
        });
    }
    getTitle() {
        return this._sheet.title;
    }
    getKey() {
        return this._sheet.key;
    }
    getDefinition() {
        return this._sheet.getDefinition();
    }
    getData() {
        return this._sheet.getData();
    }
    setData(data) {
        return this._sheet.setData(data);
    }
    clear() {
        return this._sheet.clear();
    }
    remove() {
        return this._sheet.remove();
    }
    active() {
        return this._sheet.active();
    }
    setTitle(title) {
        return this._sheet.setTitle(title);
    }
    setRows(rows) {
        return this._sheet.setRows(rows);
    }
    setColumns(columns) {
        return this._sheet.setColumns(columns);
    }
}
class $c2a9788f40f9c90a$var$Sheet extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(spreadsheetManager, definition){
        super(spreadsheetManager.table);
        this.spreadsheetManager = spreadsheetManager;
        this.definition = definition;
        this.title = this.definition.title || "";
        this.key = this.definition.key || this.definition.title;
        this.rowCount = this.definition.rows;
        this.columnCount = this.definition.columns;
        this.data = this.definition.data || [];
        this.element = null;
        this.isActive = false;
        this.grid = new $c2a9788f40f9c90a$var$GridCalculator(this.columnCount, this.rowCount);
        this.defaultColumnDefinition = {
            width: 100,
            headerHozAlign: "center",
            headerSort: false
        };
        this.columnDefinition = Object.assign(this.defaultColumnDefinition, this.options("spreadsheetColumnDefinition"));
        this.columnDefs = [];
        this.rowDefs = [];
        this.columnFields = [];
        this.columns = [];
        this.rows = [];
        this.scrollTop = null;
        this.scrollLeft = null;
        this.initialize();
        this.dispatchExternal("sheetAdded", this.getComponent());
    }
    ///////////////////////////////////
    ///////// Initialization //////////
    ///////////////////////////////////
    initialize() {
        this.initializeElement();
        this.initializeColumns();
        this.initializeRows();
    }
    reinitialize() {
        this.initializeColumns();
        this.initializeRows();
    }
    initializeElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tab");
        this.element.innerText = this.title;
        this.element.addEventListener("click", ()=>{
            this.spreadsheetManager.loadSheet(this);
        });
    }
    initializeColumns() {
        this.grid.setColumnCount(this.columnCount);
        this.columnFields = this.grid.genColumns(this.data);
        this.columnDefs = [];
        this.columnFields.forEach((ref)=>{
            var def = Object.assign({}, this.columnDefinition);
            def.field = ref;
            def.title = ref;
            this.columnDefs.push(def);
        });
    }
    initializeRows() {
        var refs;
        this.grid.setRowCount(this.rowCount);
        refs = this.grid.genRows(this.data);
        this.rowDefs = [];
        refs.forEach((ref, i)=>{
            var def = {
                "_id": ref
            };
            var data = this.data[i];
            if (data) data.forEach((val, j)=>{
                var field = this.columnFields[j];
                if (field) def[field] = val;
            });
            this.rowDefs.push(def);
        });
    }
    unload() {
        this.isActive = false;
        this.scrollTop = this.table.rowManager.scrollTop;
        this.scrollLeft = this.table.rowManager.scrollLeft;
        this.data = this.getData(true);
        this.element.classList.remove("tabulator-spreadsheet-tab-active");
    }
    load() {
        var wasInactive = !this.isActive;
        this.isActive = true;
        this.table.blockRedraw();
        this.table.setData([]);
        this.table.setColumns(this.columnDefs);
        this.table.setData(this.rowDefs);
        this.table.restoreRedraw();
        if (wasInactive && this.scrollTop !== null) {
            this.table.rowManager.element.scrollLeft = this.scrollLeft;
            this.table.rowManager.element.scrollTop = this.scrollTop;
        }
        this.element.classList.add("tabulator-spreadsheet-tab-active");
        this.dispatchExternal("sheetLoaded", this.getComponent());
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    getComponent() {
        return new $c2a9788f40f9c90a$export$bcf87d11d46ea94f(this);
    }
    getDefinition() {
        return {
            title: this.title,
            key: this.key,
            rows: this.rowCount,
            columns: this.columnCount,
            data: this.getData()
        };
    }
    getData(full) {
        var output = [], rowWidths, outputWidth, outputHeight;
        //map data to array format
        this.rowDefs.forEach((rowData)=>{
            var row = [];
            this.columnFields.forEach((field)=>{
                row.push(rowData[field]);
            });
            output.push(row);
        });
        //trim output
        if (!full && !this.options("spreadsheetOutputFull")) {
            //calculate used area of data
            rowWidths = output.map((row)=>row.findLastIndex((val)=>typeof val !== "undefined") + 1);
            outputWidth = Math.max(...rowWidths);
            outputHeight = rowWidths.findLastIndex((width)=>width > 0) + 1;
            output = output.slice(0, outputHeight);
            output = output.map((row)=>row.slice(0, outputWidth));
        }
        return output;
    }
    setData(data) {
        this.data = data;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    clear() {
        this.setData([]);
    }
    setTitle(title) {
        this.title = title;
        this.element.innerText = title;
        this.dispatchExternal("sheetUpdated", this.getComponent());
    }
    setRows(rows) {
        this.rowCount = rows;
        this.initializeRows();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    setColumns(columns) {
        this.columnCount = columns;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    remove() {
        this.spreadsheetManager.removeSheet(this);
    }
    destroy() {
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.dispatchExternal("sheetRemoved", this.getComponent());
    }
    active() {
        this.spreadsheetManager.loadSheet(this);
    }
}
class $c2a9788f40f9c90a$export$bbb96e34680d7364 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "spreadsheet";
    constructor(table){
        super(table);
        this.sheets = [];
        this.element = null;
        this.registerTableOption("spreadsheet", false);
        this.registerTableOption("spreadsheetRows", 50);
        this.registerTableOption("spreadsheetColumns", 50);
        this.registerTableOption("spreadsheetColumnDefinition", {});
        this.registerTableOption("spreadsheetOutputFull", false);
        this.registerTableOption("spreadsheetData", false);
        this.registerTableOption("spreadsheetSheets", false);
        this.registerTableOption("spreadsheetSheetTabs", false);
        this.registerTableOption("spreadsheetSheetTabsElement", false);
        this.registerTableFunction("setSheets", this.setSheets.bind(this));
        this.registerTableFunction("addSheet", this.addSheet.bind(this));
        this.registerTableFunction("getSheets", this.getSheets.bind(this));
        this.registerTableFunction("getSheetDefinitions", this.getSheetDefinitions.bind(this));
        this.registerTableFunction("setSheetData", this.setSheetData.bind(this));
        this.registerTableFunction("getSheet", this.getSheet.bind(this));
        this.registerTableFunction("getSheetData", this.getSheetData.bind(this));
        this.registerTableFunction("clearSheet", this.clearSheet.bind(this));
        this.registerTableFunction("removeSheet", this.removeSheetFunc.bind(this));
        this.registerTableFunction("activeSheet", this.activeSheetFunc.bind(this));
    }
    ///////////////////////////////////
    ////// Module Initialization //////
    ///////////////////////////////////
    initialize() {
        if (this.options("spreadsheet")) {
            this.subscribe("table-initialized", this.tableInitialized.bind(this));
            this.subscribe("data-loaded", this.loadRemoteData.bind(this));
            this.table.options.index = "_id";
            if (this.options("spreadsheetData") && this.options("spreadsheetSheets")) {
                console.warn("You cannot use spreadsheetData and spreadsheetSheets at the same time, ignoring spreadsheetData");
                this.table.options.spreadsheetData = false;
            }
            this.compatibilityCheck();
            if (this.options("spreadsheetSheetTabs")) this.initializeTabset();
        }
    }
    compatibilityCheck() {
        if (this.options("data")) console.warn("Do not use the data option when working with spreadsheets, use either spreadsheetData or spreadsheetSheets to pass data into the table");
        if (this.options("pagination")) console.warn("The spreadsheet module is not compatible with the pagination module");
        if (this.options("groupBy")) console.warn("The spreadsheet module is not compatible with the row grouping module");
        if (this.options("responsiveCollapse")) console.warn("The spreadsheet module is not compatible with the responsive collapse module");
    }
    initializeTabset() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tabs");
        var altContainer = this.options("spreadsheetSheetTabsElement");
        if (altContainer && !(altContainer instanceof HTMLElement)) {
            altContainer = document.querySelector(altContainer);
            if (!altContainer) console.warn("Unable to find element matching spreadsheetSheetTabsElement selector:", this.options("spreadsheetSheetTabsElement"));
        }
        if (altContainer) altContainer.appendChild(this.element);
        else this.footerAppend(this.element);
    }
    tableInitialized() {
        if (this.sheets.length) this.loadSheet(this.sheets[0]);
        else {
            if (this.options("spreadsheetSheets")) this.loadSheets(this.options("spreadsheetSheets"));
            else if (this.options("spreadsheetData")) this.loadData(this.options("spreadsheetData"));
        }
    }
    ///////////////////////////////////
    /////////// Ajax Parsing //////////
    ///////////////////////////////////
    loadRemoteData(data, data1, data2) {
        console.log("data", data, data1, data2);
        if (Array.isArray(data)) {
            this.table.dataLoader.clearAlert();
            this.dispatchExternal("dataLoaded", data);
            if (!data.length || Array.isArray(data[0])) this.loadData(data);
            else this.loadSheets(data);
        } else console.error("Spreadsheet Loading Error - Unable to process remote data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
        return false;
    }
    ///////////////////////////////////
    ///////// Sheet Management ////////
    ///////////////////////////////////
    loadData(data) {
        var def = {
            data: data
        };
        this.loadSheet(this.newSheet(def));
    }
    destroySheets() {
        this.sheets.forEach((sheet)=>{
            sheet.destroy();
        });
        this.sheets = [];
        this.activeSheet = null;
    }
    loadSheets(sheets) {
        if (!Array.isArray(sheets)) sheets = [];
        this.destroySheets();
        sheets.forEach((def)=>{
            this.newSheet(def);
        });
        this.loadSheet(this.sheets[0]);
    }
    loadSheet(sheet) {
        if (this.activeSheet !== sheet) {
            if (this.activeSheet) this.activeSheet.unload();
            this.activeSheet = sheet;
            sheet.load();
        }
    }
    newSheet(definition = {}) {
        var sheet;
        if (!definition.rows) definition.rows = this.options("spreadsheetRows");
        if (!definition.columns) definition.columns = this.options("spreadsheetColumns");
        sheet = new $c2a9788f40f9c90a$var$Sheet(this, definition);
        this.sheets.push(sheet);
        if (this.element) this.element.appendChild(sheet.element);
        return sheet;
    }
    removeSheet(sheet) {
        var index = this.sheets.indexOf(sheet), prevSheet;
        if (this.sheets.length > 1) {
            if (index > -1) {
                this.sheets.splice(index, 1);
                sheet.destroy();
                if (this.activeSheet === sheet) {
                    prevSheet = this.sheets[index - 1] || this.sheets[0];
                    if (prevSheet) this.loadSheet(prevSheet);
                    else this.activeSheet = null;
                }
            }
        } else console.warn("Unable to remove sheet, at least one sheet must be active");
    }
    lookupSheet(key) {
        if (!key) return this.activeSheet;
        else if (key instanceof $c2a9788f40f9c90a$var$Sheet) return key;
        else if (key instanceof $c2a9788f40f9c90a$export$bcf87d11d46ea94f) return key._sheet;
        else return this.sheets.find((sheet)=>sheet.key === key) || false;
    }
    ///////////////////////////////////
    //////// Public Functions /////////
    ///////////////////////////////////
    setSheets(sheets) {
        this.loadSheets(sheets);
        return this.getSheets();
    }
    addSheet(sheet) {
        return this.newSheet(sheet).getComponent();
    }
    getSheetDefinitions() {
        return this.sheets.map((sheet)=>sheet.getDefinition());
    }
    getSheets() {
        return this.sheets.map((sheet)=>sheet.getComponent());
    }
    getSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getComponent() : false;
    }
    setSheetData(key, data) {
        if (key && !data) {
            data = key;
            key = false;
        }
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.setData(data) : false;
    }
    getSheetData(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getData() : false;
    }
    clearSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.clear() : false;
    }
    removeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        if (sheet) this.removeSheet(sheet);
    }
    activeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? this.loadSheet(sheet) : false;
    }
}
class $c2a9788f40f9c90a$export$d0c662c133b8814e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "tooltip";
    constructor(table){
        super(table);
        this.tooltipSubscriber = null, this.headerSubscriber = null, this.timeout = null;
        this.popupInstance = null;
        // this.registerTableOption("tooltipGenerationMode", undefined);  //deprecated
        this.registerTableOption("tooltipDelay", 300);
        this.registerColumnOption("tooltip");
        this.registerColumnOption("headerTooltip");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheckMsg("tooltipGenerationMode", "This option is no longer needed as tooltips are always generated on hover now");
    }
    initializeColumn(column) {
        if (column.definition.headerTooltip && !this.headerSubscriber) {
            this.headerSubscriber = true;
            this.subscribe("column-mousemove", this.mousemoveCheck.bind(this, "headerTooltip"));
            this.subscribe("column-mouseout", this.mouseoutCheck.bind(this, "headerTooltip"));
        }
        if (column.definition.tooltip && !this.tooltipSubscriber) {
            this.tooltipSubscriber = true;
            this.subscribe("cell-mousemove", this.mousemoveCheck.bind(this, "tooltip"));
            this.subscribe("cell-mouseout", this.mouseoutCheck.bind(this, "tooltip"));
        }
    }
    mousemoveCheck(action, e, component) {
        var tooltip = action === "tooltip" ? component.column.definition.tooltip : component.definition.headerTooltip;
        if (tooltip) {
            this.clearPopup();
            this.timeout = setTimeout(this.loadTooltip.bind(this, e, component, tooltip), this.table.options.tooltipDelay);
        }
    }
    mouseoutCheck(action, e, component) {
        if (!this.popupInstance) this.clearPopup();
    }
    clearPopup(action, e, component) {
        clearTimeout(this.timeout);
        this.timeout = null;
        if (this.popupInstance) this.popupInstance.hide();
    }
    loadTooltip(e, component, tooltip) {
        var contentsEl, renderedCallback, coords;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (typeof tooltip === "function") tooltip = tooltip(e, component.getComponent(), onRendered);
        if (tooltip instanceof HTMLElement) contentsEl = tooltip;
        else {
            contentsEl = document.createElement("div");
            if (tooltip === true) {
                if (component instanceof $c2a9788f40f9c90a$var$Cell) tooltip = component.value;
                else if (component.definition.field) this.langBind("columns|" + component.definition.field, (value)=>{
                    contentsEl.innerHTML = tooltip = value || component.definition.title;
                });
                else tooltip = component.definition.title;
            }
            contentsEl.innerHTML = tooltip;
        }
        if (tooltip || tooltip === 0 || tooltip === false) {
            contentsEl.classList.add("tabulator-tooltip");
            contentsEl.addEventListener("mousemove", (e)=>e.preventDefault());
            this.popupInstance = this.popup(contentsEl);
            if (typeof renderedCallback === "function") this.popupInstance.renderCallback(renderedCallback);
            coords = this.popupInstance.containerEventCoords(e);
            this.popupInstance.show(coords.x + 15, coords.y + 15).hideOnBlur(()=>{
                this.dispatchExternal("TooltipClosed", component.getComponent());
                this.popupInstance = null;
            });
            this.dispatchExternal("TooltipOpened", component.getComponent());
        }
    }
}
var $c2a9788f40f9c90a$var$defaultValidators = {
    //is integer
    integer: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && Math.floor(value) === value;
    },
    //is float
    float: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && value % 1 !== 0;
    },
    //must be a number
    numeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return !isNaN(value);
    },
    //must be a string
    string: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return isNaN(value);
    },
    //must be alphanumeric
    alphanumeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(/^[a-z0-9]+$/i);
        return reg.test(value);
    },
    //maximum value
    max: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) <= parameters;
    },
    //minimum value
    min: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) >= parameters;
    },
    //starts with  value
    starts: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().startsWith(String(parameters).toLowerCase());
    },
    //ends with  value
    ends: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().endsWith(String(parameters).toLowerCase());
    },
    //minimum string length
    minLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length >= parameters;
    },
    //maximum string length
    maxLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length <= parameters;
    },
    //in provided value list
    in: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        if (typeof parameters == "string") parameters = parameters.split("|");
        return parameters.indexOf(value) > -1;
    },
    //must match provided regex
    regex: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(parameters);
        return reg.test(value);
    },
    //value must be unique in this column
    unique: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var unique = true;
        var cellData = cell.getData();
        var column = cell.getColumn()._getSelf();
        this.table.rowManager.rows.forEach(function(row) {
            var data = row.getData();
            if (data !== cellData) {
                if (value == column.getFieldValue(data)) unique = false;
            }
        });
        return unique;
    },
    //must have a value
    required: function(cell, value, parameters) {
        return value !== "" && value !== null && typeof value !== "undefined";
    }
};
class $c2a9788f40f9c90a$export$db48c5a2fa1f03d4 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "validate";
    //load defaults
    static validators = $c2a9788f40f9c90a$var$defaultValidators;
    constructor(table){
        super(table);
        this.invalidCells = [];
        this.registerTableOption("validationMode", "blocking");
        this.registerColumnOption("validator");
        this.registerTableFunction("getInvalidCells", this.getInvalidCells.bind(this));
        this.registerTableFunction("clearCellValidation", this.userClearCellValidation.bind(this));
        this.registerTableFunction("validate", this.userValidate.bind(this));
        this.registerComponentFunction("cell", "isValid", this.cellIsValid.bind(this));
        this.registerComponentFunction("cell", "clearValidation", this.clearValidation.bind(this));
        this.registerComponentFunction("cell", "validate", this.cellValidate.bind(this));
        this.registerComponentFunction("column", "validate", this.columnValidate.bind(this));
        this.registerComponentFunction("row", "validate", this.rowValidate.bind(this));
    }
    initialize() {
        this.subscribe("cell-delete", this.clearValidation.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("edit-success", this.editValidate.bind(this));
        this.subscribe("edit-editor-clear", this.editorClear.bind(this));
        this.subscribe("edit-edited-clear", this.editedClear.bind(this));
    }
    ///////////////////////////////////
    ///////// Event Handling //////////
    ///////////////////////////////////
    editValidate(cell, value, previousValue) {
        var valid = this.table.options.validationMode !== "manual" ? this.validate(cell.column.modules.validate, cell, value) : true;
        // allow time for editor to make render changes then style cell
        if (valid !== true) setTimeout(()=>{
            cell.getElement().classList.add("tabulator-validation-fail");
            this.dispatchExternal("validationFailed", cell.getComponent(), value, valid);
        });
        return valid;
    }
    editorClear(cell, cancelled) {
        if (cancelled) {
            if (cell.column.modules.validate) this.cellValidate(cell);
        }
        cell.getElement().classList.remove("tabulator-validation-fail");
    }
    editedClear(cell) {
        if (cell.modules.validate) cell.modules.validate.invalid = false;
    }
    ///////////////////////////////////
    ////////// Cell Functions /////////
    ///////////////////////////////////
    cellIsValid(cell) {
        return cell.modules.validate ? cell.modules.validate.invalid || true : true;
    }
    cellValidate(cell) {
        return this.validate(cell.column.modules.validate, cell, cell.getValue());
    }
    ///////////////////////////////////
    ///////// Column Functions ////////
    ///////////////////////////////////
    columnValidate(column) {
        var invalid = [];
        column.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ////////// Row Functions //////////
    ///////////////////////////////////
    rowValidate(row) {
        var invalid = [];
        row.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userClearCellValidation(cells) {
        if (!cells) cells = this.getInvalidCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.clearValidation(cell._getSelf());
        });
    }
    userValidate(cells) {
        var output = [];
        //clear row data
        this.table.rowManager.rows.forEach((row)=>{
            row = row.getComponent();
            var valid = row.validate();
            if (valid !== true) output = output.concat(valid);
        });
        return output.length ? output : true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.validator !== "undefined") this.initializeColumn(column);
    }
    //validate
    initializeColumn(column) {
        var self = this, config = [], validator;
        if (column.definition.validator) {
            if (Array.isArray(column.definition.validator)) column.definition.validator.forEach((item)=>{
                validator = self._extractValidator(item);
                if (validator) config.push(validator);
            });
            else {
                validator = this._extractValidator(column.definition.validator);
                if (validator) config.push(validator);
            }
            column.modules.validate = config.length ? config : false;
        }
    }
    _extractValidator(value) {
        var type, params, pos;
        switch(typeof value){
            case "string":
                pos = value.indexOf(":");
                if (pos > -1) {
                    type = value.substring(0, pos);
                    params = value.substring(pos + 1);
                } else type = value;
                return this._buildValidator(type, params);
            case "function":
                return this._buildValidator(value);
            case "object":
                return this._buildValidator(value.type, value.parameters);
        }
    }
    _buildValidator(type, params) {
        var func = typeof type == "function" ? type : $c2a9788f40f9c90a$export$db48c5a2fa1f03d4.validators[type];
        if (!func) {
            console.warn("Validator Setup Error - No matching validator found:", type);
            return false;
        } else return {
            type: typeof type == "function" ? "function" : type,
            func: func,
            params: params
        };
    }
    validate(validators, cell, value) {
        var self = this, failedValidators = [], invalidIndex = this.invalidCells.indexOf(cell);
        if (validators) validators.forEach((item)=>{
            if (!item.func.call(self, cell.getComponent(), value, item.params)) failedValidators.push({
                type: item.type,
                parameters: item.params
            });
        });
        if (!cell.modules.validate) cell.modules.validate = {};
        if (!failedValidators.length) {
            cell.modules.validate.invalid = false;
            cell.getElement().classList.remove("tabulator-validation-fail");
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        } else {
            cell.modules.validate.invalid = failedValidators;
            if (this.table.options.validationMode !== "manual") cell.getElement().classList.add("tabulator-validation-fail");
            if (invalidIndex == -1) this.invalidCells.push(cell);
        }
        return failedValidators.length ? failedValidators : true;
    }
    getInvalidCells() {
        var output = [];
        this.invalidCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearValidation(cell) {
        var invalidIndex;
        if (cell.modules.validate && cell.modules.validate.invalid) {
            cell.getElement().classList.remove("tabulator-validation-fail");
            cell.modules.validate.invalid = false;
            invalidIndex = this.invalidCells.indexOf(cell);
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$allModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AccessorModule: $c2a9788f40f9c90a$export$bf9f5472bce61c69,
    AjaxModule: $c2a9788f40f9c90a$export$b25c9f93be571d3a,
    ClipboardModule: $c2a9788f40f9c90a$export$3a36bd45ca02edda,
    ColumnCalcsModule: $c2a9788f40f9c90a$export$840b3bc55b30dec6,
    DataTreeModule: $c2a9788f40f9c90a$export$a5a9878f12569c04,
    DownloadModule: $c2a9788f40f9c90a$export$6dd96c6d41f32a97,
    EditModule: $c2a9788f40f9c90a$export$2394e2d3d2175314,
    ExportModule: $c2a9788f40f9c90a$export$4e0f34fd9829977c,
    FilterModule: $c2a9788f40f9c90a$export$2e3bebbdf3339a4e,
    FormatModule: $c2a9788f40f9c90a$export$5634f967e02d772d,
    FrozenColumnsModule: $c2a9788f40f9c90a$export$c00c4e95a253fbf9,
    FrozenRowsModule: $c2a9788f40f9c90a$export$6e51ce5331c5fffa,
    GroupRowsModule: $c2a9788f40f9c90a$export$41e6b6ec902cbe0a,
    HistoryModule: $c2a9788f40f9c90a$export$173658fc60691186,
    HtmlTableImportModule: $c2a9788f40f9c90a$export$b0b448c470bac827,
    ImportModule: $c2a9788f40f9c90a$export$bceca318c211ca25,
    InteractionModule: $c2a9788f40f9c90a$export$69fa60f71dd0541a,
    KeybindingsModule: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef,
    MenuModule: $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0,
    MoveColumnsModule: $c2a9788f40f9c90a$export$9ab7496e9b38c128,
    MoveRowsModule: $c2a9788f40f9c90a$export$7815d73158f0bb2d,
    MutatorModule: $c2a9788f40f9c90a$export$d0f669567356cabd,
    PageModule: $c2a9788f40f9c90a$export$7eba6c45a494ceac,
    PersistenceModule: $c2a9788f40f9c90a$export$6ce0215a06bec981,
    PopupModule: $c2a9788f40f9c90a$export$5a0eb14a9c37d425,
    PrintModule: $c2a9788f40f9c90a$export$94fbe99c03f5a051,
    ReactiveDataModule: $c2a9788f40f9c90a$export$1806fba60a0e8399,
    ResizeColumnsModule: $c2a9788f40f9c90a$export$3a1ca422b395df54,
    ResizeRowsModule: $c2a9788f40f9c90a$export$5651a6c35bd86023,
    ResizeTableModule: $c2a9788f40f9c90a$export$977e646a85a63aba,
    ResponsiveLayoutModule: $c2a9788f40f9c90a$export$cc8706005768c818,
    SelectRangeModule: $c2a9788f40f9c90a$export$cd9e469b2c8c819c,
    SelectRowModule: $c2a9788f40f9c90a$export$2e4fadc5338e55f5,
    SortModule: $c2a9788f40f9c90a$export$5b492eb49d632e3f,
    SpreadsheetModule: $c2a9788f40f9c90a$export$bbb96e34680d7364,
    TooltipModule: $c2a9788f40f9c90a$export$d0c662c133b8814e,
    ValidateModule: $c2a9788f40f9c90a$export$db48c5a2fa1f03d4
});
var $c2a9788f40f9c90a$var$defaultOptions = {
    debugEventsExternal: false,
    debugEventsInternal: false,
    debugInvalidOptions: true,
    debugInvalidComponentFuncs: true,
    debugInitialization: true,
    debugDeprecation: true,
    height: false,
    minHeight: false,
    maxHeight: false,
    columnHeaderVertAlign: "top",
    popupContainer: false,
    columns: [],
    columnDefaults: {},
    rowHeader: false,
    data: false,
    autoColumns: false,
    autoColumnsDefinitions: false,
    nestedFieldSeparator: ".",
    footerElement: false,
    index: "id",
    textDirection: "auto",
    addRowPos: "bottom",
    headerVisible: true,
    renderVertical: "virtual",
    renderHorizontal: "basic",
    renderVerticalBuffer: 0,
    scrollToRowPosition: "top",
    scrollToRowIfVisible: true,
    scrollToColumnPosition: "left",
    scrollToColumnIfVisible: true,
    rowFormatter: false,
    rowFormatterPrint: null,
    rowFormatterClipboard: null,
    rowFormatterHtmlOutput: null,
    rowHeight: null,
    placeholder: false,
    dataLoader: true,
    dataLoaderLoading: false,
    dataLoaderError: false,
    dataLoaderErrorTimeout: 3000,
    dataSendParams: {},
    dataReceiveParams: {},
    dependencies: {}
};
class $c2a9788f40f9c90a$var$OptionsList {
    constructor(table, msgType, defaults = {}){
        this.table = table;
        this.msgType = msgType;
        this.registeredDefaults = Object.assign({}, defaults);
    }
    register(option, value) {
        this.registeredDefaults[option] = value;
    }
    generate(defaultOptions, userOptions = {}) {
        var output = Object.assign({}, this.registeredDefaults), warn = this.table.options.debugInvalidOptions || userOptions.debugInvalidOptions === true;
        Object.assign(output, defaultOptions);
        for(let key in userOptions)if (!output.hasOwnProperty(key)) {
            if (warn) console.warn("Invalid " + this.msgType + " option:", key);
            output[key] = userOptions.key;
        }
        for(let key in output)if (key in userOptions) output[key] = userOptions[key];
        else {
            if (Array.isArray(output[key])) output[key] = Object.assign([], output[key]);
            else if (typeof output[key] === "object" && output[key] !== null) output[key] = Object.assign({}, output[key]);
            else if (typeof output[key] === "undefined") delete output[key];
        }
        return output;
    }
}
class $c2a9788f40f9c90a$export$88530751e3977073 extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.elementVertical = table.rowManager.element;
        this.elementHorizontal = table.columnManager.element;
        this.tableElement = table.rowManager.tableElement;
        this.verticalFillMode = "fit"; // used by row manager to determine how to size the render area ("fit" - fits container to the contents, "fill" - fills the container without resizing it)
    }
    ///////////////////////////////////
    /////// Internal Bindings /////////
    ///////////////////////////////////
    initialize() {
    //initialize core functionality
    }
    clearRows() {
    //clear down existing rows layout
    }
    clearColumns() {
    //clear down existing columns layout
    }
    reinitializeColumnWidths(columns) {
    //resize columns to fit data
    }
    renderRows() {
    //render rows from a clean slate
    }
    renderColumns() {
    //render columns from a clean slate
    }
    rerenderRows(callback) {
        // rerender rows and keep position
        if (callback) callback();
    }
    rerenderColumns(update, blockRedraw) {
    //rerender columns
    }
    renderRowCells(row) {
    //render the cells in a row
    }
    rerenderRowCells(row, force) {
    //rerender the cells in a row
    }
    scrollColumns(left, dir) {
    //handle horizontal scrolling
    }
    scrollRows(top, dir) {
    //handle vertical scrolling
    }
    resize() {
    //container has resized, carry out any needed recalculations (DO NOT RERENDER IN THIS FUNCTION)
    }
    scrollToRow(row) {
    //scroll to a specific row
    }
    scrollToRowNearestTop(row) {
    //determine weather the row is nearest the top or bottom of the table, return true for top or false for bottom
    }
    visibleRows(includingBuffer) {
        //return the visible rows
        return [];
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    rows() {
        return this.table.rowManager.getDisplayRows();
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    ///////////////////////////////////
    /////// External Triggers /////////
    /////// (DO NOT OVERRIDE) /////////
    ///////////////////////////////////
    clear() {
        //clear down existing layout
        this.clearRows();
        this.clearColumns();
    }
    render() {
        //render from a clean slate
        this.renderRows();
        this.renderColumns();
    }
    rerender(callback) {
        // rerender and keep position
        this.rerenderRows();
        this.rerenderColumns();
    }
    scrollToRowPosition(row, position, ifVisible) {
        var rowIndex = this.rows().indexOf(row), rowEl = row.getElement(), offset = 0;
        return new Promise((resolve, reject)=>{
            if (rowIndex > -1) {
                if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToRowIfVisible;
                //check row visibility
                if (!ifVisible) {
                    if ($c2a9788f40f9c90a$var$Helpers.elVisible(rowEl)) {
                        offset = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top;
                        if (offset > 0 && offset < this.elementVertical.clientHeight - rowEl.offsetHeight) {
                            resolve();
                            return false;
                        }
                    }
                }
                if (typeof position === "undefined") position = this.table.options.scrollToRowPosition;
                if (position === "nearest") position = this.scrollToRowNearestTop(row) ? "top" : "bottom";
                //scroll to row
                this.scrollToRow(row);
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop + (rowEl.offsetTop - this.elementVertical.scrollTop) - (this.elementVertical.scrollHeight - rowEl.offsetTop) / 2;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight / 2;
                        break;
                    case "bottom":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop - (this.elementVertical.scrollHeight - rowEl.offsetTop) + rowEl.offsetHeight;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight + rowEl.offsetHeight;
                        break;
                    case "top":
                        this.elementVertical.scrollTop = rowEl.offsetTop;
                        break;
                }
                resolve();
            } else {
                console.warn("Scroll Error - Row not visible");
                reject("Scroll Error - Row not visible");
            }
        });
    }
}
class $c2a9788f40f9c90a$var$BasicHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
    }
    renderRowCells(row, inFragment) {
        const rowFrag = document.createDocumentFragment();
        row.cells.forEach((cell)=>{
            rowFrag.appendChild(cell.getElement());
        });
        row.element.appendChild(rowFrag);
        if (!inFragment) row.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeColumnWidths(columns) {
        columns.forEach(function(column) {
            column.reinitializeWidth();
        });
    }
}
class $c2a9788f40f9c90a$var$VirtualDomHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.leftCol = 0;
        this.rightCol = 0;
        this.scrollLeft = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
        this.fitDataColAvg = 0;
        this.windowBuffer = 200; //pixel margin to make column visible before it is shown on screen
        this.visibleRows = null;
        this.initialized = false;
        this.isFitData = false;
        this.columns = [];
    }
    initialize() {
        this.compatibilityCheck();
        this.layoutCheck();
        this.vertScrollListen();
    }
    compatibilityCheck() {
        if (this.options("layout") == "fitDataTable") console.warn("Horizontal Virtual DOM is not compatible with fitDataTable layout mode");
        if (this.options("responsiveLayout")) console.warn("Horizontal Virtual DOM is not compatible with responsive columns");
        if (this.options("rtl")) console.warn("Horizontal Virtual DOM is not currently compatible with RTL text direction");
    }
    layoutCheck() {
        this.isFitData = this.options("layout").startsWith("fitData");
    }
    vertScrollListen() {
        this.subscribe("scroll-vertical", this.clearVisRowCache.bind(this));
        this.subscribe("data-refreshed", this.clearVisRowCache.bind(this));
    }
    clearVisRowCache() {
        this.visibleRows = null;
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    renderColumns(row, force) {
        this.dataChange();
    }
    scrollColumns(left, dir) {
        if (this.scrollLeft != left) {
            this.scrollLeft = left;
            this.scroll(left - (this.vDomScrollPosLeft + this.windowBuffer));
        }
    }
    calcWindowBuffer() {
        var buffer = this.elementVertical.clientWidth;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (column.visible) {
                var width = column.getWidth();
                if (width > buffer) buffer = width;
            }
        });
        this.windowBuffer = buffer * 2;
    }
    rerenderColumns(update, blockRedraw) {
        var old = {
            cols: this.columns,
            leftCol: this.leftCol,
            rightCol: this.rightCol
        }, colPos = 0;
        if (update && !this.initialized) return;
        this.clear();
        this.calcWindowBuffer();
        this.scrollLeft = this.elementVertical.scrollLeft;
        this.vDomScrollPosLeft = this.scrollLeft - this.windowBuffer;
        this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            var config = {}, width;
            if (column.visible) {
                if (!column.modules.frozen) {
                    width = column.getWidth();
                    config.leftPos = colPos;
                    config.rightPos = colPos + width;
                    config.width = width;
                    if (this.isFitData) config.fitDataCheck = column.modules.vdomHoz ? column.modules.vdomHoz.fitDataCheck : true;
                    if (colPos + width > this.vDomScrollPosLeft && colPos < this.vDomScrollPosRight) {
                        //column is visible
                        if (this.leftCol == -1) {
                            this.leftCol = this.columns.length;
                            this.vDomPadLeft = colPos;
                        }
                        this.rightCol = this.columns.length;
                    } else // column is hidden
                    if (this.leftCol !== -1) this.vDomPadRight += width;
                    this.columns.push(column);
                    column.modules.vdomHoz = config;
                    colPos += width;
                }
            }
        });
        this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
        this.tableElement.style.paddingRight = this.vDomPadRight + "px";
        this.initialized = true;
        if (!blockRedraw) {
            if (!update || this.reinitChanged(old)) this.reinitializeRows();
        }
        this.elementVertical.scrollLeft = this.scrollLeft;
    }
    renderRowCells(row) {
        if (this.initialized) this.initializeRow(row);
        else {
            const rowFrag = document.createDocumentFragment();
            row.cells.forEach((cell)=>{
                rowFrag.appendChild(cell.getElement());
            });
            row.element.appendChild(rowFrag);
            row.cells.forEach((cell)=>{
                cell.cellRendered();
            });
        }
    }
    rerenderRowCells(row, force) {
        this.reinitializeRow(row, force);
    }
    reinitializeColumnWidths(columns) {
        for(let i = this.leftCol; i <= this.rightCol; i++)this.columns[i].reinitializeWidth();
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    deinitialize() {
        this.initialized = false;
    }
    clear() {
        this.columns = [];
        this.leftCol = -1;
        this.rightCol = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
    }
    dataChange() {
        var change = false, row, rowEl;
        if (this.isFitData) {
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                if (!column.definition.width && column.visible) change = true;
            });
            if (change && this.table.rowManager.getDisplayRows().length) {
                this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
                row = this.chain("rows-sample", [
                    1
                ], [], ()=>{
                    return this.table.rowManager.getDisplayRows();
                })[0];
                if (row) {
                    rowEl = row.getElement();
                    row.generateCells();
                    this.tableElement.appendChild(rowEl);
                    for(let colEnd = 0; colEnd < row.cells.length; colEnd++){
                        let cell = row.cells[colEnd];
                        rowEl.appendChild(cell.getElement());
                        cell.column.reinitializeWidth();
                    }
                    rowEl.parentNode.removeChild(rowEl);
                    this.rerenderColumns(false, true);
                }
            }
        } else if (this.options("layout") === "fitColumns") {
            this.layoutRefresh();
            this.rerenderColumns(false, true);
        }
    }
    reinitChanged(old) {
        var match = true;
        if (old.cols.length !== this.columns.length || old.leftCol !== this.leftCol || old.rightCol !== this.rightCol) return true;
        old.cols.forEach((col, i)=>{
            if (col !== this.columns[i]) match = false;
        });
        return !match;
    }
    reinitializeRows() {
        var visibleRows = this.getVisibleRows(), otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        visibleRows.forEach((row)=>{
            this.reinitializeRow(row, true);
        });
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
    }
    getVisibleRows() {
        if (!this.visibleRows) this.visibleRows = this.table.rowManager.getVisibleRows();
        return this.visibleRows;
    }
    scroll(diff) {
        this.vDomScrollPosLeft += diff;
        this.vDomScrollPosRight += diff;
        if (Math.abs(diff) > this.windowBuffer / 2) this.rerenderColumns();
        else if (diff > 0) {
            //scroll right
            this.addColRight();
            this.removeColLeft();
        } else {
            //scroll left
            this.addColLeft();
            this.removeColRight();
        }
    }
    colPositionAdjust(start, end, diff) {
        for(let i = start; i < end; i++){
            let column = this.columns[i];
            column.modules.vdomHoz.leftPos += diff;
            column.modules.vdomHoz.rightPos += diff;
        }
    }
    addColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol + 1];
            if (column) {
                if (column.modules.vdomHoz.leftPos <= this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.rightCol]).getElement().nextSibling);
                            cell.cellRendered();
                        }
                    });
                    this.fitDataColActualWidthCheck(column);
                    this.rightCol++; // Don't move this below the >= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                    if (this.rightCol >= this.columns.length - 1) this.vDomPadRight = 0;
                    else this.vDomPadRight -= column.getWidth();
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    addColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol - 1];
            if (column) {
                if (column.modules.vdomHoz.rightPos >= this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.leftCol]).getElement());
                            cell.cellRendered();
                        }
                    });
                    this.leftCol--; // don't move this below the <= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                    if (this.leftCol <= 0) this.vDomPadLeft = 0;
                    else this.vDomPadLeft -= column.getWidth();
                    let diff = this.fitDataColActualWidthCheck(column);
                    if (diff) {
                        this.scrollLeft = this.elementVertical.scrollLeft = this.elementVertical.scrollLeft + diff;
                        this.vDomPadRight -= diff;
                    }
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    removeColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol];
            if (column) {
                if (column.modules.vdomHoz.leftPos > this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColRight", ex.message);
                            }
                        }
                    });
                    this.vDomPadRight += column.getWidth();
                    this.rightCol--;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    removeColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol];
            if (column) {
                if (column.modules.vdomHoz.rightPos < this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColLeft", ex.message);
                            }
                        }
                    });
                    this.vDomPadLeft += column.getWidth();
                    this.leftCol++;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    fitDataColActualWidthCheck(column) {
        var newWidth, widthDiff;
        if (column.modules.vdomHoz.fitDataCheck) {
            column.reinitializeWidth();
            newWidth = column.getWidth();
            widthDiff = newWidth - column.modules.vdomHoz.width;
            if (widthDiff) {
                column.modules.vdomHoz.rightPos += widthDiff;
                column.modules.vdomHoz.width = newWidth;
                this.colPositionAdjust(this.columns.indexOf(column) + 1, this.columns.length, widthDiff);
            }
            column.modules.vdomHoz.fitDataCheck = false;
        }
        return widthDiff;
    }
    initializeRow(row) {
        if (row.type !== "group") {
            row.modules.vdomHoz = {
                leftCol: this.leftCol,
                rightCol: this.rightCol
            };
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.leftColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
            for(let i = this.leftCol; i <= this.rightCol; i++)this.appendCell(row, this.columns[i]);
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.rightColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
        }
    }
    appendCell(row, column) {
        if (column && column.visible) {
            let cell = row.getCell(column);
            row.getElement().appendChild(cell.getElement());
            cell.cellRendered();
        }
    }
    reinitializeRow(row, force) {
        if (row.type !== "group") {
            if (force || !row.modules.vdomHoz || row.modules.vdomHoz.leftCol !== this.leftCol || row.modules.vdomHoz.rightCol !== this.rightCol) {
                var rowEl = row.getElement();
                while(rowEl.firstChild)rowEl.removeChild(rowEl.firstChild);
                this.initializeRow(row);
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ColumnManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.blockHozScrollEvent = false;
        this.headersElement = null;
        this.contentsElement = null;
        this.rowHeader = null;
        this.element = null; //containing element
        this.columns = []; // column definition object
        this.columnsByIndex = []; //columns by index
        this.columnsByField = {}; //columns by field
        this.scrollLeft = 0;
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this.table, "column definition", $c2a9788f40f9c90a$var$defaultColumnOptions);
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockUpdate = null; //store latest redraw update only status
        this.renderer = null;
    }
    ////////////// Setup Functions /////////////////
    initialize() {
        this.initializeRenderer();
        this.headersElement = this.createHeadersElement();
        this.contentsElement = this.createHeaderContentsElement();
        this.element = this.createHeaderElement();
        this.contentsElement.insertBefore(this.headersElement, this.contentsElement.firstChild);
        this.element.insertBefore(this.contentsElement, this.element.firstChild);
        this.initializeScrollWheelWatcher();
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("scrollbar-vertical", this.padVerticalScrollbar.bind(this));
    }
    padVerticalScrollbar(width) {
        if (this.table.rtl) this.headersElement.style.marginLeft = width + "px";
        else this.headersElement.style.marginRight = width + "px";
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomHorizontal,
            "basic": $c2a9788f40f9c90a$var$BasicHorizontal
        };
        if (typeof this.table.options.renderHorizontal === "string") renderClass = renderers[this.table.options.renderHorizontal];
        else renderClass = this.table.options.renderHorizontal;
        if (renderClass) {
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
        } else console.error("Unable to find matching renderer:", this.table.options.renderHorizontal);
    }
    createHeadersElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-headers");
        el.setAttribute("role", "row");
        return el;
    }
    createHeaderContentsElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header-contents");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    createHeaderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header");
        el.setAttribute("role", "rowgroup");
        if (!this.table.options.headerVisible) el.classList.add("tabulator-header-hidden");
        return el;
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return containing contents element
    getContentsElement() {
        return this.contentsElement;
    }
    //return header containing element
    getHeadersElement() {
        return this.headersElement;
    }
    //scroll horizontally to match table body
    scrollHorizontal(left) {
        this.contentsElement.scrollLeft = left;
        this.scrollLeft = left;
        this.renderer.scrollColumns(left);
    }
    initializeScrollWheelWatcher() {
        this.contentsElement.addEventListener("wheel", (e)=>{
            var left;
            if (e.deltaX) {
                left = this.contentsElement.scrollLeft + e.deltaX;
                this.table.rowManager.scrollHorizontal(left);
                this.table.columnManager.scrollHorizontal(left);
            }
        });
    }
    ///////////// Column Setup Functions /////////////
    generateColumnsFromRowData(data) {
        var cols = [], collProgress = {}, rowSample = this.table.options.autoColumns === "full" ? data : [
            data[0]
        ], definitions = this.table.options.autoColumnsDefinitions;
        if (data && data.length) {
            rowSample.forEach((row)=>{
                Object.keys(row).forEach((key, index)=>{
                    let value = row[key], col;
                    if (!collProgress[key]) {
                        col = {
                            field: key,
                            title: key,
                            sorter: this.calculateSorterFromValue(value)
                        };
                        cols.splice(index, 0, col);
                        collProgress[key] = typeof value === "undefined" ? col : true;
                    } else if (collProgress[key] !== true) {
                        if (typeof value !== "undefined") {
                            collProgress[key].sorter = this.calculateSorterFromValue(value);
                            collProgress[key] = true;
                        }
                    }
                });
            });
            if (definitions) switch(typeof definitions){
                case "function":
                    this.table.options.columns = definitions.call(this.table, cols);
                    break;
                case "object":
                    if (Array.isArray(definitions)) cols.forEach((col)=>{
                        var match = definitions.find((def)=>{
                            return def.field === col.field;
                        });
                        if (match) Object.assign(col, match);
                    });
                    else cols.forEach((col)=>{
                        if (definitions[col.field]) Object.assign(col, definitions[col.field]);
                    });
                    this.table.options.columns = cols;
                    break;
            }
            else this.table.options.columns = cols;
            this.setColumns(this.table.options.columns);
        }
    }
    calculateSorterFromValue(value) {
        var sorter;
        switch(typeof value){
            case "undefined":
                sorter = "string";
                break;
            case "boolean":
                sorter = "boolean";
                break;
            case "number":
                sorter = "number";
                break;
            case "object":
                if (Array.isArray(value)) sorter = "array";
                else sorter = "string";
                break;
            default:
                if (!isNaN(value) && value !== "") sorter = "number";
                else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                else sorter = "string";
                break;
        }
        return sorter;
    }
    setColumns(cols, row) {
        while(this.headersElement.firstChild)this.headersElement.removeChild(this.headersElement.firstChild);
        this.columns = [];
        this.columnsByIndex = [];
        this.columnsByField = {};
        this.dispatch("columns-loading");
        this.dispatchExternal("columnsLoading");
        if (this.table.options.rowHeader) {
            this.rowHeader = new $c2a9788f40f9c90a$var$Column(this.table.options.rowHeader === true ? {} : this.table.options.rowHeader, this, true);
            this.columns.push(this.rowHeader);
            this.headersElement.appendChild(this.rowHeader.getElement());
            this.rowHeader.columnRendered();
        }
        cols.forEach((def, i)=>{
            this._addColumn(def);
        });
        this._reIndexColumns();
        this.dispatch("columns-loaded");
        if (this.subscribedExternal("columnsLoaded")) this.dispatchExternal("columnsLoaded", this.getComponents());
        this.rerenderColumns(false, true);
        this.redraw(true);
    }
    _addColumn(definition, before, nextToColumn) {
        var column = new $c2a9788f40f9c90a$var$Column(definition, this), colEl = column.getElement(), index = nextToColumn ? this.findColumnIndex(nextToColumn) : nextToColumn;
        //prevent adding of rows in front of row header
        if (before && this.rowHeader && (!nextToColumn || nextToColumn === this.rowHeader)) {
            before = false;
            nextToColumn = this.rowHeader;
            index = 0;
        }
        if (nextToColumn && index > -1) {
            var topColumn = nextToColumn.getTopColumn();
            var parentIndex = this.columns.indexOf(topColumn);
            var nextEl = topColumn.getElement();
            if (before) {
                this.columns.splice(parentIndex, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl);
            } else {
                this.columns.splice(parentIndex + 1, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl.nextSibling);
            }
        } else if (before) {
            this.columns.unshift(column);
            this.headersElement.insertBefore(column.getElement(), this.headersElement.firstChild);
        } else {
            this.columns.push(column);
            this.headersElement.appendChild(column.getElement());
        }
        column.columnRendered();
        return column;
    }
    registerColumnField(col) {
        if (col.definition.field) this.columnsByField[col.definition.field] = col;
    }
    registerColumnPosition(col) {
        this.columnsByIndex.push(col);
    }
    _reIndexColumns() {
        this.columnsByIndex = [];
        this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
    }
    //ensure column headers take up the correct amount of space in column groups
    verticalAlignHeaders() {
        var minHeight = 0;
        if (!this.redrawBlock) {
            this.headersElement.style.height = "";
            this.columns.forEach((column)=>{
                column.clearVerticalAlign();
            });
            this.columns.forEach((column)=>{
                var height = column.getHeight();
                if (height > minHeight) minHeight = height;
            });
            this.headersElement.style.height = minHeight + "px";
            this.columns.forEach((column)=>{
                column.verticalAlign(this.table.options.columnHeaderVertAlign, minHeight);
            });
            this.table.rowManager.adjustTableSize();
        }
    }
    //////////////// Column Details /////////////////
    findColumn(subject) {
        var columns;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Column) //subject is column element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$11bb209ad3a8e411) //subject is public column component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                columns = [];
                this.columns.forEach((column)=>{
                    columns.push(column);
                    columns = columns.concat(column.getColumns(true));
                });
                //subject is a HTML element of the column header
                let match = columns.find((column)=>{
                    return column.element === subject;
                });
                return match || false;
            }
        } else //subject should be treated as the field name of the column
        return this.columnsByField[subject] || false;
        //catch all for any other type of input
        return false;
    }
    getColumnByField(field) {
        return this.columnsByField[field];
    }
    getColumnsByFieldRoot(root) {
        var matches = [];
        Object.keys(this.columnsByField).forEach((field)=>{
            var fieldRoot = this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator)[0] : field;
            if (fieldRoot === root) matches.push(this.columnsByField[field]);
        });
        return matches;
    }
    getColumnByIndex(index) {
        return this.columnsByIndex[index];
    }
    getFirstVisibleColumn() {
        var index = this.columnsByIndex.findIndex((col)=>{
            return col.visible;
        });
        return index > -1 ? this.columnsByIndex[index] : false;
    }
    getVisibleColumnsByIndex() {
        return this.columnsByIndex.filter((col)=>col.visible);
    }
    getColumns() {
        return this.columns;
    }
    findColumnIndex(column) {
        return this.columnsByIndex.findIndex((col)=>{
            return column === col;
        });
    }
    //return all columns that are not groups
    getRealColumns() {
        return this.columnsByIndex;
    }
    //traverse across columns and call action
    traverse(callback) {
        this.columnsByIndex.forEach((column, i)=>{
            callback(column, i);
        });
    }
    //get definitions of actual columns
    getDefinitions(active) {
        var output = [];
        this.columnsByIndex.forEach((column)=>{
            if (!active || active && column.visible) output.push(column.getDefinition());
        });
        return output;
    }
    //get full nested definition tree
    getDefinitionTree() {
        var output = [];
        this.columns.forEach((column)=>{
            output.push(column.getDefinition(true));
        });
        return output;
    }
    getComponents(structured) {
        var output = [], columns = structured ? this.columns : this.columnsByIndex;
        columns.forEach((column)=>{
            output.push(column.getComponent());
        });
        return output;
    }
    getWidth() {
        var width = 0;
        this.columnsByIndex.forEach((column)=>{
            if (column.visible) width += column.getWidth();
        });
        return width;
    }
    moveColumn(from, to, after) {
        to.element.parentNode.insertBefore(from.element, to.element);
        if (after) to.element.parentNode.insertBefore(to.element, from.element);
        this.moveColumnActual(from, to, after);
        this.verticalAlignHeaders();
        this.table.rowManager.reinitialize();
    }
    moveColumnActual(from, to, after) {
        if (from.parent.isGroup) this._moveColumnInArray(from.parent.columns, from, to, after);
        else this._moveColumnInArray(this.columns, from, to, after);
        this._moveColumnInArray(this.columnsByIndex, from, to, after, true);
        this.rerenderColumns(true);
        this.dispatch("column-moved", from, to, after);
        if (this.subscribedExternal("columnMoved")) this.dispatchExternal("columnMoved", from.getComponent(), this.table.columnManager.getComponents());
    }
    _moveColumnInArray(columns, from, to, after, updateRows) {
        var fromIndex = columns.indexOf(from), toIndex, rows = [];
        if (fromIndex > -1) {
            columns.splice(fromIndex, 1);
            toIndex = columns.indexOf(to);
            if (toIndex > -1) {
                if (after) toIndex = toIndex + 1;
            } else toIndex = fromIndex;
            columns.splice(toIndex, 0, from);
            if (updateRows) {
                rows = this.chain("column-moving-rows", [
                    from,
                    to,
                    after
                ], null, []) || [];
                rows = rows.concat(this.table.rowManager.rows);
                rows.forEach(function(row) {
                    if (row.cells.length) {
                        var cell = row.cells.splice(fromIndex, 1)[0];
                        row.cells.splice(toIndex, 0, cell);
                    }
                });
            }
        }
    }
    scrollToColumn(column, position, ifVisible) {
        var left = 0, offset = column.getLeftOffset(), adjust = 0, colEl = column.getElement();
        return new Promise((resolve, reject)=>{
            if (typeof position === "undefined") position = this.table.options.scrollToColumnPosition;
            if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToColumnIfVisible;
            if (column.visible) {
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        adjust = -this.element.clientWidth / 2;
                        break;
                    case "right":
                        adjust = colEl.clientWidth - this.headersElement.clientWidth;
                        break;
                }
                //check column visibility
                if (!ifVisible) {
                    if (offset > 0 && offset + colEl.offsetWidth < this.element.clientWidth) return false;
                }
                //calculate scroll position
                left = offset + adjust;
                left = Math.max(Math.min(left, this.table.rowManager.element.scrollWidth - this.table.rowManager.element.clientWidth), 0);
                this.table.rowManager.scrollHorizontal(left);
                this.scrollHorizontal(left);
                resolve();
            } else {
                console.warn("Scroll Error - Column not visible");
                reject("Scroll Error - Column not visible");
            }
        });
    }
    //////////////// Cell Management /////////////////
    generateCells(row) {
        var cells = [];
        this.columnsByIndex.forEach((column)=>{
            cells.push(column.generateCell(row));
        });
        return cells;
    }
    //////////////// Column Management /////////////////
    getFlexBaseWidth() {
        var totalWidth = this.table.element.clientWidth, fixedWidth = 0;
        //adjust for vertical scrollbar if present
        if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
        this.columnsByIndex.forEach(function(column) {
            var width, minWidth, colWidth;
            if (column.visible) {
                width = column.definition.width || 0;
                minWidth = parseInt(column.minWidth);
                if (typeof width == "string") {
                    if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
                    else colWidth = parseInt(width);
                } else colWidth = width;
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
            }
        });
        return fixedWidth;
    }
    addColumn(definition, before, nextToColumn) {
        return new Promise((resolve, reject)=>{
            var column = this._addColumn(definition, before, nextToColumn);
            this._reIndexColumns();
            this.dispatch("column-add", definition, before, nextToColumn);
            if (this.layoutMode() != "fitColumns") column.reinitializeWidth();
            this.redraw(true);
            this.table.rowManager.reinitialize();
            this.rerenderColumns();
            resolve(column);
        });
    }
    //remove column from system
    deregisterColumn(column) {
        var field = column.getField(), index;
        //remove from field list
        if (field) delete this.columnsByField[field];
        //remove from index list
        index = this.columnsByIndex.indexOf(column);
        if (index > -1) this.columnsByIndex.splice(index, 1);
        //remove from column list
        index = this.columns.indexOf(column);
        if (index > -1) this.columns.splice(index, 1);
        this.verticalAlignHeaders();
        this.redraw();
    }
    rerenderColumns(update, silent) {
        if (!this.redrawBlock) this.renderer.rerenderColumns(update, silent);
        else if (update === false || update === true && this.redrawBlockUpdate === null) this.redrawBlockUpdate = update;
    }
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockUpdate = null;
    }
    restoreRedraw() {
        this.redrawBlock = false;
        this.verticalAlignHeaders();
        this.renderer.rerenderColumns(this.redrawBlockUpdate);
    }
    //redraw columns
    redraw(force) {
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.verticalAlignHeaders();
        if (force) {
            this.table.rowManager.resetScroll();
            this.table.rowManager.reinitialize();
        }
        if (!this.confirm("table-redrawing", force)) this.layoutRefresh(force);
        this.dispatch("table-redraw", force);
        this.table.footerManager.redraw();
    }
}
class $c2a9788f40f9c90a$var$BasicVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
    }
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.scrollTop = 0;
        element.scrollLeft = 0;
        element.style.minWidth = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
    }
    renderRows() {
        var element = this.tableElement, onlyGroupHeaders = true, tableFrag = document.createDocumentFragment(), rows = this.rows();
        rows.forEach((row, index)=>{
            this.styleRow(row, index);
            row.initialize(false, true);
            if (row.type !== "group") onlyGroupHeaders = false;
            tableFrag.appendChild(row.getElement());
        });
        element.appendChild(tableFrag);
        rows.forEach((row)=>{
            row.rendered();
            if (!row.heightInitialized) row.calcHeight(true);
        });
        rows.forEach((row)=>{
            if (!row.heightInitialized) row.setCellHeight();
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
    rerenderRows(callback) {
        this.clearRows();
        if (callback) callback();
        this.renderRows();
        if (!this.rows().length) this.table.rowManager.tableEmpty();
    }
    scrollToRowNearestTop(row) {
        var rowTop = $c2a9788f40f9c90a$var$Helpers.elOffset(row.getElement()).top;
        return !(Math.abs(this.elementVertical.scrollTop - rowTop) > Math.abs(this.elementVertical.scrollTop + this.elementVertical.clientHeight - rowTop));
    }
    scrollToRow(row) {
        var rowEl = row.getElement();
        this.elementVertical.scrollTop = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top + this.elementVertical.scrollTop;
    }
    visibleRows(includingBuffer) {
        return this.rows();
    }
}
class $c2a9788f40f9c90a$var$VirtualDomVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomRowHeight = 20; //approximation of row heights for padding
        this.vDomTop = 0; //hold position for first rendered row in the virtual DOM
        this.vDomBottom = 0; //hold position for last rendered row in the virtual DOM
        this.vDomScrollPosTop = 0; //last scroll position of the vDom top;
        this.vDomScrollPosBottom = 0; //last scroll position of the vDom bottom;
        this.vDomTopPad = 0; //hold value of padding for top of virtual DOM
        this.vDomBottomPad = 0; //hold value of padding for bottom of virtual DOM
        this.vDomMaxRenderChain = 90; //the maximum number of dom elements that can be rendered in 1 go
        this.vDomWindowBuffer = 0; //window row buffer before removing elements, to smooth scrolling
        this.vDomWindowMinTotalRows = 20; //minimum number of rows to be generated in virtual dom (prevent buffering issues on tables with tall rows)
        this.vDomWindowMinMarginRows = 5; //minimum number of rows to be generated in virtual dom margin
        this.vDomTopNewRows = []; //rows to normalize after appending to optimize render speed
        this.vDomBottomNewRows = []; //rows to normalize after appending to optimize render speed
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.style.paddingTop = "";
        element.style.paddingBottom = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
        this.elementVertical.scrollTop = 0;
        this.elementVertical.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomTop = 0;
        this.vDomBottom = 0;
        this.vDomTopPad = 0;
        this.vDomBottomPad = 0;
        this.vDomScrollPosTop = 0;
        this.vDomScrollPosBottom = 0;
    }
    renderRows() {
        this._virtualRenderFill();
    }
    rerenderRows(callback) {
        var scrollTop = this.elementVertical.scrollTop;
        var topRow = false;
        var topOffset = false;
        var left = this.table.rowManager.scrollLeft;
        var rows = this.rows();
        for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
            var diff = scrollTop - rows[i].getElement().offsetTop;
            if (topOffset === false || Math.abs(diff) < topOffset) {
                topOffset = diff;
                topRow = i;
            } else break;
        }
        rows.forEach((row)=>{
            row.deinitializeHeight();
        });
        if (callback) callback();
        if (this.rows().length) this._virtualRenderFill(topRow === false ? this.rows.length - 1 : topRow, true, topOffset || 0);
        else {
            this.clear();
            this.table.rowManager.tableEmpty();
        }
        this.scrollColumns(left);
    }
    scrollColumns(left) {
        this.table.rowManager.scrollHorizontal(left);
    }
    scrollRows(top, dir) {
        var topDiff = top - this.vDomScrollPosTop;
        var bottomDiff = top - this.vDomScrollPosBottom;
        var margin = this.vDomWindowBuffer * 2;
        var rows = this.rows();
        this.scrollTop = top;
        if (-topDiff > margin || bottomDiff > margin) {
            //if big scroll redraw table;
            var left = this.table.rowManager.scrollLeft;
            this._virtualRenderFill(Math.floor(this.elementVertical.scrollTop / this.elementVertical.scrollHeight * rows.length));
            this.scrollColumns(left);
        } else if (dir) {
            //scrolling up
            if (topDiff < 0) this._addTopRow(rows, -topDiff);
            if (bottomDiff < 0) {
                //hide bottom row if needed
                if (this.vDomScrollHeight - this.scrollTop > this.vDomWindowBuffer) this._removeBottomRow(rows, -bottomDiff);
                else this.vDomScrollPosBottom = this.scrollTop;
            }
        } else {
            if (bottomDiff >= 0) this._addBottomRow(rows, bottomDiff);
            //scrolling down
            if (topDiff >= 0) {
                //hide top row if needed
                if (this.scrollTop > this.vDomWindowBuffer) this._removeTopRow(rows, topDiff);
                else this.vDomScrollPosTop = this.scrollTop;
            }
        }
    }
    resize() {
        this.vDomWindowBuffer = this.table.options.renderVerticalBuffer || this.elementVertical.clientHeight;
    }
    scrollToRowNearestTop(row) {
        var rowIndex = this.rows().indexOf(row);
        return !(Math.abs(this.vDomTop - rowIndex) > Math.abs(this.vDomBottom - rowIndex));
    }
    scrollToRow(row) {
        var index = this.rows().indexOf(row);
        if (index > -1) this._virtualRenderFill(index, true);
    }
    visibleRows(includingBuffer) {
        var topEdge = this.elementVertical.scrollTop, bottomEdge = this.elementVertical.clientHeight + topEdge, topFound = false, topRow = 0, bottomRow = 0, rows = this.rows();
        if (includingBuffer) {
            topRow = this.vDomTop;
            bottomRow = this.vDomBottom;
        } else {
            for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
                if (!topFound) {
                    if (topEdge - rows[i].getElement().offsetTop >= 0) topRow = i;
                    else {
                        topFound = true;
                        if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                        else break;
                    }
                } else {
                    if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                    else break;
                }
            }
        }
        return rows.slice(topRow, bottomRow + 1);
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    //full virtual render
    _virtualRenderFill(position, forceMove, offset) {
        var element = this.tableElement, holder = this.elementVertical, topPad = 0, rowsHeight = 0, rowHeight = 0, heightOccupied = 0, topPadHeight = 0, i = 0, rows = this.rows(), rowsCount = rows.length, index = 0, row, rowFragment, renderedRows = [], totalRowsRendered = 0, rowsToRender = 0, fixedHeight = this.table.rowManager.fixedHeight, containerHeight = this.elementVertical.clientHeight, avgRowHeight = this.table.options.rowHeight, resized = true;
        position = position || 0;
        offset = offset || 0;
        if (!position) this.clear();
        else {
            while(element.firstChild)element.removeChild(element.firstChild);
            //check if position is too close to bottom of table
            heightOccupied = (rowsCount - position + 1) * this.vDomRowHeight;
            if (heightOccupied < containerHeight) {
                position -= Math.ceil((containerHeight - heightOccupied) / this.vDomRowHeight);
                if (position < 0) position = 0;
            }
            //calculate initial pad
            topPad = Math.min(Math.max(Math.floor(this.vDomWindowBuffer / this.vDomRowHeight), this.vDomWindowMinMarginRows), position);
            position -= topPad;
        }
        if (rowsCount && $c2a9788f40f9c90a$var$Helpers.elVisible(this.elementVertical)) {
            this.vDomTop = position;
            this.vDomBottom = position - 1;
            if (fixedHeight || this.table.options.maxHeight) {
                if (avgRowHeight) rowsToRender = containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight;
                rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(rowsToRender));
            } else rowsToRender = rowsCount;
            while((rowsToRender == rowsCount || rowsHeight <= containerHeight + this.vDomWindowBuffer || totalRowsRendered < this.vDomWindowMinTotalRows) && this.vDomBottom < rowsCount - 1){
                renderedRows = [];
                rowFragment = document.createDocumentFragment();
                i = 0;
                while(i < rowsToRender && this.vDomBottom < rowsCount - 1){
                    index = this.vDomBottom + 1, row = rows[index];
                    this.styleRow(row, index);
                    row.initialize(false, true);
                    if (!row.heightInitialized && !this.table.options.rowHeight) row.clearCellHeight();
                    rowFragment.appendChild(row.getElement());
                    renderedRows.push(row);
                    this.vDomBottom++;
                    i++;
                }
                if (!renderedRows.length) break;
                element.appendChild(rowFragment);
                // NOTE: The next 3 loops are separate on purpose
                // This is to batch up the dom writes and reads which drastically improves performance 
                renderedRows.forEach((row)=>{
                    row.rendered();
                    if (!row.heightInitialized) row.calcHeight(true);
                });
                renderedRows.forEach((row)=>{
                    if (!row.heightInitialized) row.setCellHeight();
                });
                renderedRows.forEach((row)=>{
                    rowHeight = row.getHeight();
                    if (totalRowsRendered < topPad) topPadHeight += rowHeight;
                    else rowsHeight += rowHeight;
                    if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    totalRowsRendered++;
                });
                resized = this.table.rowManager.adjustTableSize();
                containerHeight = this.elementVertical.clientHeight;
                if (resized && (fixedHeight || this.table.options.maxHeight)) {
                    avgRowHeight = rowsHeight / totalRowsRendered;
                    rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight));
                }
            }
            if (!position) {
                this.vDomTopPad = 0;
                //adjust row height to match average of rendered elements
                this.vDomRowHeight = Math.floor((rowsHeight + topPadHeight) / totalRowsRendered);
                this.vDomBottomPad = this.vDomRowHeight * (rowsCount - this.vDomBottom - 1);
                this.vDomScrollHeight = topPadHeight + rowsHeight + this.vDomBottomPad - containerHeight;
            } else {
                this.vDomTopPad = !forceMove ? this.scrollTop - topPadHeight : this.vDomRowHeight * this.vDomTop + offset;
                this.vDomBottomPad = this.vDomBottom == rowsCount - 1 ? 0 : Math.max(this.vDomScrollHeight - this.vDomTopPad - rowsHeight - topPadHeight, 0);
            }
            element.style.paddingTop = this.vDomTopPad + "px";
            element.style.paddingBottom = this.vDomBottomPad + "px";
            if (forceMove) this.scrollTop = this.vDomTopPad + topPadHeight + offset - (this.elementVertical.scrollWidth > this.elementVertical.clientWidth ? this.elementVertical.offsetHeight - containerHeight : 0);
            this.scrollTop = Math.min(this.scrollTop, this.elementVertical.scrollHeight - containerHeight);
            //adjust for horizontal scrollbar if present (and not at top of table)
            if (this.elementVertical.scrollWidth > this.elementVertical.clientWidth && forceMove) this.scrollTop += this.elementVertical.offsetHeight - containerHeight;
            this.vDomScrollPosTop = this.scrollTop;
            this.vDomScrollPosBottom = this.scrollTop;
            holder.scrollTop = this.scrollTop;
            this.dispatch("render-virtual-fill");
        }
    }
    _addTopRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomTop - 1, i = 0, working = true;
        while(working)if (this.vDomTop) {
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.insertBefore(row.getElement(), table.firstChild);
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomTop--;
                    index--;
                    i++;
                } else working = false;
            } else working = false;
        } else working = false;
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomTopPad -= paddingAdjust;
            if (this.vDomTopPad < 0) this.vDomTopPad = index * this.vDomRowHeight;
            if (index < 1) this.vDomTopPad = 0;
            table.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop -= paddingAdjust;
        }
    }
    _removeTopRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomTop], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomTop++;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomTopPad += paddingAdjust;
            this.tableElement.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop += this.vDomTop ? paddingAdjust : paddingAdjust + this.vDomWindowBuffer;
        }
    }
    _addBottomRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomBottom + 1, i = 0, working = true;
        while(working){
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.appendChild(row.getElement());
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomBottom++;
                    index++;
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomBottomPad -= paddingAdjust;
            if (this.vDomBottomPad < 0 || index == rows.length - 1) this.vDomBottomPad = 0;
            table.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom += paddingAdjust;
        }
    }
    _removeBottomRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomBottom], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomBottom--;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomBottomPad += paddingAdjust;
            if (this.vDomBottomPad < 0) this.vDomBottomPad = 0;
            this.tableElement.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom -= paddingAdjust;
        }
    }
    _quickNormalizeRowHeight(rows) {
        for (let row of rows)row.calcHeight();
        for (let row of rows)row.setCellHeight();
    }
}
class $c2a9788f40f9c90a$var$RowManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this.createHolderElement(); //containing element
        this.tableElement = this.createTableElement(); //table element
        this.heightFixer = this.createTableElement(); //table element
        this.placeholder = null; //placeholder element
        this.placeholderContents = null; //placeholder element
        this.firstRender = false; //handle first render
        this.renderMode = "virtual"; //current rendering mode
        this.fixedHeight = false; //current rendering mode
        this.rows = []; //hold row data objects
        this.activeRowsPipeline = []; //hold calculation of active rows
        this.activeRows = []; //rows currently available to on display in the table
        this.activeRowsCount = 0; //count of active rows
        this.displayRows = []; //rows currently on display in the table
        this.displayRowsCount = 0; //count of display rows
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockRestoreConfig = false; //store latest redraw function calls for when redraw is needed
        this.redrawBlockRenderInPosition = false; //store latest redraw function calls for when redraw is needed
        this.dataPipeline = []; //hold data pipeline tasks
        this.displayPipeline = []; //hold data display pipeline tasks
        this.scrollbarWidth = 0;
        this.renderer = null;
    }
    //////////////// Setup Functions /////////////////
    createHolderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-tableholder");
        el.setAttribute("tabindex", 0);
        // el.setAttribute("role", "rowgroup");
        return el;
    }
    createTableElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-table");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    initializePlaceholder() {
        var placeholder = this.table.options.placeholder;
        if (typeof placeholder === "function") placeholder = placeholder.call(this.table);
        placeholder = this.chain("placeholder", [
            placeholder
        ], placeholder, placeholder) || placeholder;
        //configure placeholder element
        if (placeholder) {
            let el = document.createElement("div");
            el.classList.add("tabulator-placeholder");
            if (typeof placeholder == "string") {
                let contents = document.createElement("div");
                contents.classList.add("tabulator-placeholder-contents");
                contents.innerHTML = placeholder;
                el.appendChild(contents);
                this.placeholderContents = contents;
            } else if (typeof HTMLElement !== "undefined" && placeholder instanceof HTMLElement) {
                el.appendChild(placeholder);
                this.placeholderContents = placeholder;
            } else {
                console.warn("Invalid placeholder provided, must be string or HTML Element", placeholder);
                this.el = null;
            }
            this.placeholder = el;
        }
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return table element
    getTableElement() {
        return this.tableElement;
    }
    initialize() {
        this.initializePlaceholder();
        this.initializeRenderer();
        //initialize manager
        this.element.appendChild(this.tableElement);
        this.firstRender = true;
        //scroll header along with table body
        this.element.addEventListener("scroll", ()=>{
            var left = this.element.scrollLeft, leftDir = this.scrollLeft > left, top = this.element.scrollTop, topDir = this.scrollTop > top;
            //handle horizontal scrolling
            if (this.scrollLeft != left) {
                this.scrollLeft = left;
                this.dispatch("scroll-horizontal", left, leftDir);
                this.dispatchExternal("scrollHorizontal", left, leftDir);
                this._positionPlaceholder();
            }
            //handle vertical scrolling
            if (this.scrollTop != top) {
                this.scrollTop = top;
                this.renderer.scrollRows(top, topDir);
                this.dispatch("scroll-vertical", top, topDir);
                this.dispatchExternal("scrollVertical", top, topDir);
            }
        });
    }
    ////////////////// Row Manipulation //////////////////
    findRow(subject) {
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                //subject is a HTML element of the row
                let match = this.rows.find((row)=>{
                    return row.getElement() === subject;
                });
                return match || false;
            } else if (subject === null) return false;
        } else if (typeof subject == "undefined") return false;
        else {
            //subject should be treated as the index of the row
            let match = this.rows.find((row)=>{
                return row.data[this.table.options.index] == subject;
            });
            return match || false;
        }
        //catch all for any other type of input
        return false;
    }
    getRowFromDataObject(data) {
        var match = this.rows.find((row)=>{
            return row.data === data;
        });
        return match || false;
    }
    getRowFromPosition(position) {
        return this.getDisplayRows().find((row)=>{
            return row.type === "row" && row.getPosition() === position && row.isDisplayed();
        });
    }
    scrollToRow(row, position, ifVisible) {
        return this.renderer.scrollToRowPosition(row, position, ifVisible);
    }
    ////////////////// Data Handling //////////////////
    setData(data, renderInPosition, columnsChanged) {
        return new Promise((resolve, reject)=>{
            if (renderInPosition && this.getDisplayRows().length) {
                if (this.table.options.pagination) this._setDataActual(data, true);
                else this.reRenderInPosition(()=>{
                    this._setDataActual(data);
                });
            } else {
                if (this.table.options.autoColumns && columnsChanged && this.table.initialized) this.table.columnManager.generateColumnsFromRowData(data);
                this.resetScroll();
                this._setDataActual(data);
            }
            resolve();
        });
    }
    _setDataActual(data, renderInPosition) {
        this.dispatchExternal("dataProcessing", data);
        this._wipeElements();
        if (Array.isArray(data)) {
            this.dispatch("data-processing", data);
            data.forEach((def, i)=>{
                if (def && typeof def === "object") {
                    var row = new $c2a9788f40f9c90a$var$Row(def, this);
                    this.rows.push(row);
                } else console.warn("Data Loading Warning - Invalid row data detected and ignored, expecting object but received:", def);
            });
            this.refreshActiveData(false, false, renderInPosition);
            this.dispatch("data-processed", data);
            this.dispatchExternal("dataProcessed", data);
        } else console.error("Data Loading Error - Unable to process data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
    }
    _wipeElements() {
        this.dispatch("rows-wipe");
        this.destroy();
        this.adjustTableSize();
        this.dispatch("rows-wiped");
    }
    destroy() {
        this.rows.forEach((row)=>{
            row.wipe();
        });
        this.rows = [];
        this.activeRows = [];
        this.activeRowsPipeline = [];
        this.activeRowsCount = 0;
        this.displayRows = [];
        this.displayRowsCount = 0;
    }
    deleteRow(row, blockRedraw) {
        var allIndex = this.rows.indexOf(row), activeIndex = this.activeRows.indexOf(row);
        if (activeIndex > -1) this.activeRows.splice(activeIndex, 1);
        if (allIndex > -1) this.rows.splice(allIndex, 1);
        this.setActiveRows(this.activeRows);
        this.displayRowIterator((rows)=>{
            var displayIndex = rows.indexOf(row);
            if (displayIndex > -1) rows.splice(displayIndex, 1);
        });
        if (!blockRedraw) this.reRenderInPosition();
        this.regenerateRowPositions();
        this.dispatchExternal("rowDeleted", row.getComponent());
        if (!this.displayRowsCount) this.tableEmpty();
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.getData());
    }
    addRow(data, pos, index, blockRedraw) {
        var row = this.addRowActual(data, pos, index, blockRedraw);
        return row;
    }
    //add multiple rows
    addRows(data, pos, index, refreshDisplayOnly) {
        var rows = [];
        return new Promise((resolve, reject)=>{
            pos = this.findAddRowPos(pos);
            if (!Array.isArray(data)) data = [
                data
            ];
            if (typeof index == "undefined" && pos || typeof index !== "undefined" && !pos) data.reverse();
            data.forEach((item, i)=>{
                var row = this.addRow(item, pos, index, true);
                rows.push(row);
                this.dispatch("row-added", row, item, pos, index);
            });
            this.refreshActiveData(refreshDisplayOnly ? "displayPipeline" : false, false, true);
            this.regenerateRowPositions();
            if (this.displayRowsCount) this._clearPlaceholder();
            resolve(rows);
        });
    }
    findAddRowPos(pos) {
        if (typeof pos === "undefined") pos = this.table.options.addRowPos;
        if (pos === "pos") pos = true;
        if (pos === "bottom") pos = false;
        return pos;
    }
    addRowActual(data, pos, index, blockRedraw) {
        var row = data instanceof $c2a9788f40f9c90a$var$Row ? data : new $c2a9788f40f9c90a$var$Row(data || {}, this), top = this.findAddRowPos(pos), allIndex = -1, activeIndex, chainResult;
        if (!index) {
            chainResult = this.chain("row-adding-position", [
                row,
                top
            ], null, {
                index: index,
                top: top
            });
            index = chainResult.index;
            top = chainResult.top;
        }
        if (typeof index !== "undefined") index = this.findRow(index);
        index = this.chain("row-adding-index", [
            row,
            index,
            top
        ], null, index);
        if (index) allIndex = this.rows.indexOf(index);
        if (index && allIndex > -1) {
            activeIndex = this.activeRows.indexOf(index);
            this.displayRowIterator(function(rows) {
                var displayIndex = rows.indexOf(index);
                if (displayIndex > -1) rows.splice(top ? displayIndex : displayIndex + 1, 0, row);
            });
            if (activeIndex > -1) this.activeRows.splice(top ? activeIndex : activeIndex + 1, 0, row);
            this.rows.splice(top ? allIndex : allIndex + 1, 0, row);
        } else if (top) {
            this.displayRowIterator(function(rows) {
                rows.unshift(row);
            });
            this.activeRows.unshift(row);
            this.rows.unshift(row);
        } else {
            this.displayRowIterator(function(rows) {
                rows.push(row);
            });
            this.activeRows.push(row);
            this.rows.push(row);
        }
        this.setActiveRows(this.activeRows);
        this.dispatchExternal("rowAdded", row.getComponent());
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        if (!blockRedraw) this.reRenderInPosition();
        return row;
    }
    moveRow(from, to, after) {
        this.dispatch("row-move", from, to, after);
        this.moveRowActual(from, to, after);
        this.regenerateRowPositions();
        this.dispatch("row-moved", from, to, after);
        this.dispatchExternal("rowMoved", from.getComponent());
    }
    moveRowActual(from, to, after) {
        this.moveRowInArray(this.rows, from, to, after);
        this.moveRowInArray(this.activeRows, from, to, after);
        this.displayRowIterator((rows)=>{
            this.moveRowInArray(rows, from, to, after);
        });
        this.dispatch("row-moving", from, to, after);
    }
    moveRowInArray(rows, from, to, after) {
        var fromIndex, toIndex, start, end;
        if (from !== to) {
            fromIndex = rows.indexOf(from);
            if (fromIndex > -1) {
                rows.splice(fromIndex, 1);
                toIndex = rows.indexOf(to);
                if (toIndex > -1) {
                    if (after) rows.splice(toIndex + 1, 0, from);
                    else rows.splice(toIndex, 0, from);
                } else rows.splice(fromIndex, 0, from);
            }
            //restyle rows
            if (rows === this.getDisplayRows()) {
                start = fromIndex < toIndex ? fromIndex : toIndex;
                end = toIndex > fromIndex ? toIndex : fromIndex + 1;
                for(let i = start; i <= end; i++)if (rows[i]) this.styleRow(rows[i], i);
            }
        }
    }
    clearData() {
        this.setData([]);
    }
    getRowIndex(row) {
        return this.findRowIndex(row, this.rows);
    }
    getDisplayRowIndex(row) {
        var index = this.getDisplayRows().indexOf(row);
        return index > -1 ? index : false;
    }
    nextDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), nextRow = false;
        if (index !== false && index < this.displayRowsCount - 1) nextRow = this.getDisplayRows()[index + 1];
        if (nextRow && (!(nextRow instanceof $c2a9788f40f9c90a$var$Row) || nextRow.type != "row")) return this.nextDisplayRow(nextRow, rowOnly);
        return nextRow;
    }
    prevDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), prevRow = false;
        if (index) prevRow = this.getDisplayRows()[index - 1];
        if (rowOnly && prevRow && (!(prevRow instanceof $c2a9788f40f9c90a$var$Row) || prevRow.type != "row")) return this.prevDisplayRow(prevRow, rowOnly);
        return prevRow;
    }
    findRowIndex(row, list) {
        var rowIndex;
        row = this.findRow(row);
        if (row) {
            rowIndex = list.indexOf(row);
            if (rowIndex > -1) return rowIndex;
        }
        return false;
    }
    getData(active, transform) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            if (row.type == "row") output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getComponents(active) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            output.push(row.getComponent());
        });
        return output;
    }
    getDataCount(active) {
        var rows = this.getRows(active);
        return rows.length;
    }
    scrollHorizontal(left) {
        this.scrollLeft = left;
        this.element.scrollLeft = left;
        this.dispatch("scroll-horizontal", left);
    }
    registerDataPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.dataPipeline.push({
                handler: handler,
                priority: priority
            });
            this.dataPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Data pipeline handlers must have a priority in order to be registered");
    }
    registerDisplayPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.displayPipeline.push({
                handler: handler,
                priority: priority
            });
            this.displayPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Display pipeline handlers must have a priority in order to be registered");
    }
    //set active data set
    refreshActiveData(handler, skipStage, renderInPosition) {
        var table = this.table, stage = "", index = 0, cascadeOrder = [
            "all",
            "dataPipeline",
            "display",
            "displayPipeline",
            "end"
        ];
        if (!this.table.destroyed) {
            if (typeof handler === "function") {
                index = this.dataPipeline.findIndex((item)=>{
                    return item.handler === handler;
                });
                if (index > -1) {
                    stage = "dataPipeline";
                    if (skipStage) {
                        if (index == this.dataPipeline.length - 1) stage = "display";
                        else index++;
                    }
                } else {
                    index = this.displayPipeline.findIndex((item)=>{
                        return item.handler === handler;
                    });
                    if (index > -1) {
                        stage = "displayPipeline";
                        if (skipStage) {
                            if (index == this.displayPipeline.length - 1) stage = "end";
                            else index++;
                        }
                    } else {
                        console.error("Unable to refresh data, invalid handler provided", handler);
                        return;
                    }
                }
            } else {
                stage = handler || "all";
                index = 0;
            }
            if (this.redrawBlock) {
                if (!this.redrawBlockRestoreConfig || this.redrawBlockRestoreConfig && (this.redrawBlockRestoreConfig.stage === stage && index < this.redrawBlockRestoreConfig.index || cascadeOrder.indexOf(stage) < cascadeOrder.indexOf(this.redrawBlockRestoreConfig.stage))) this.redrawBlockRestoreConfig = {
                    handler: handler,
                    skipStage: skipStage,
                    renderInPosition: renderInPosition,
                    stage: stage,
                    index: index
                };
                return;
            } else {
                if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) {
                    if (renderInPosition) this.reRenderInPosition(this.refreshPipelines.bind(this, handler, stage, index, renderInPosition));
                    else {
                        this.refreshPipelines(handler, stage, index, renderInPosition);
                        if (!handler) this.table.columnManager.renderer.renderColumns();
                        this.renderTable();
                        if (table.options.layoutColumnsOnNewData) this.table.columnManager.redraw(true);
                    }
                } else this.refreshPipelines(handler, stage, index, renderInPosition);
                this.dispatch("data-refreshed");
            }
        }
    }
    refreshPipelines(handler, stage, index, renderInPosition) {
        this.dispatch("data-refreshing");
        if (!handler || !this.activeRowsPipeline[0]) this.activeRowsPipeline[0] = this.rows.slice(0);
        //cascade through data refresh stages
        switch(stage){
            case "all":
            //handle case where all data needs refreshing
            case "dataPipeline":
                for(let i = index; i < this.dataPipeline.length; i++){
                    let result = this.dataPipeline[i].handler(this.activeRowsPipeline[i].slice(0));
                    this.activeRowsPipeline[i + 1] = result || this.activeRowsPipeline[i].slice(0);
                }
                this.setActiveRows(this.activeRowsPipeline[this.dataPipeline.length]);
            case "display":
                index = 0;
                this.resetDisplayRows();
            case "displayPipeline":
                for(let i = index; i < this.displayPipeline.length; i++){
                    let result = this.displayPipeline[i].handler((i ? this.getDisplayRows(i - 1) : this.activeRows).slice(0), renderInPosition);
                    this.setDisplayRows(result || this.getDisplayRows(i - 1).slice(0), i);
                }
            case "end":
                //case to handle scenario when trying to skip past end stage
                this.regenerateRowPositions();
        }
        if (this.getDisplayRows().length) this._clearPlaceholder();
    }
    //regenerate row positions
    regenerateRowPositions() {
        var rows = this.getDisplayRows();
        var index = 1;
        rows.forEach((row)=>{
            if (row.type === "row") {
                row.setPosition(index);
                index++;
            }
        });
    }
    setActiveRows(activeRows) {
        this.activeRows = this.activeRows = Object.assign([], activeRows);
        this.activeRowsCount = this.activeRows.length;
    }
    //reset display rows array
    resetDisplayRows() {
        this.displayRows = [];
        this.displayRows.push(this.activeRows.slice(0));
        this.displayRowsCount = this.displayRows[0].length;
    }
    //set display row pipeline data
    setDisplayRows(displayRows, index) {
        this.displayRows[index] = displayRows;
        if (index == this.displayRows.length - 1) this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    getDisplayRows(index) {
        if (typeof index == "undefined") return this.displayRows.length ? this.displayRows[this.displayRows.length - 1] : [];
        else return this.displayRows[index] || [];
    }
    getVisibleRows(chain, viewable) {
        var rows = Object.assign([], this.renderer.visibleRows(!viewable));
        if (chain) rows = this.chain("rows-visible", [
            viewable
        ], rows, rows);
        return rows;
    }
    //repeat action across display rows
    displayRowIterator(callback) {
        this.activeRowsPipeline.forEach(callback);
        this.displayRows.forEach(callback);
        this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    //return only actual rows (not group headers etc)
    getRows(type) {
        var rows = [];
        switch(type){
            case "active":
                rows = this.activeRows;
                break;
            case "display":
                rows = this.table.rowManager.getDisplayRows();
                break;
            case "visible":
                rows = this.getVisibleRows(false, true);
                break;
            default:
                rows = this.chain("rows-retrieve", type, null, this.rows) || this.rows;
        }
        return rows;
    }
    ///////////////// Table Rendering /////////////////
    //trigger rerender of table in current position
    reRenderInPosition(callback) {
        if (this.redrawBlock) {
            if (callback) callback();
            else this.redrawBlockRenderInPosition = true;
        } else {
            this.dispatchExternal("renderStarted");
            this.renderer.rerenderRows(callback);
            if (!this.fixedHeight) this.adjustTableSize();
            this.scrollBarCheck();
            this.dispatchExternal("renderComplete");
        }
    }
    scrollBarCheck() {
        var scrollbarWidth = 0;
        //adjust for vertical scrollbar moving table when present
        if (this.element.scrollHeight > this.element.clientHeight) scrollbarWidth = this.element.offsetWidth - this.element.clientWidth;
        if (scrollbarWidth !== this.scrollbarWidth) {
            this.scrollbarWidth = scrollbarWidth;
            this.dispatch("scrollbar-vertical", scrollbarWidth);
        }
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomVertical,
            "basic": $c2a9788f40f9c90a$var$BasicVertical
        };
        if (typeof this.table.options.renderVertical === "string") renderClass = renderers[this.table.options.renderVertical];
        else renderClass = this.table.options.renderVertical;
        if (renderClass) {
            this.renderMode = this.table.options.renderVertical;
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
            if ((this.table.element.clientHeight || this.table.options.height) && !(this.table.options.minHeight && this.table.options.maxHeight)) this.fixedHeight = true;
            else this.fixedHeight = false;
        } else console.error("Unable to find matching renderer:", this.table.options.renderVertical);
    }
    getRenderMode() {
        return this.renderMode;
    }
    renderTable() {
        this.dispatchExternal("renderStarted");
        this.element.scrollTop = 0;
        this._clearTable();
        if (this.displayRowsCount) {
            this.renderer.renderRows();
            if (this.firstRender) {
                this.firstRender = false;
                if (!this.fixedHeight) this.adjustTableSize();
                this.layoutRefresh(true);
            }
        } else this.renderEmptyScroll();
        if (!this.fixedHeight) this.adjustTableSize();
        this.dispatch("table-layout");
        if (!this.displayRowsCount) this._showPlaceholder();
        this.scrollBarCheck();
        this.dispatchExternal("renderComplete");
    }
    //show scrollbars on empty table div
    renderEmptyScroll() {
        if (this.placeholder) this.tableElement.style.display = "none";
        else this.tableElement.style.minWidth = this.table.columnManager.getWidth() + "px";
    }
    _clearTable() {
        this._clearPlaceholder();
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.renderer.clearRows();
    }
    tableEmpty() {
        this.renderEmptyScroll();
        this._showPlaceholder();
    }
    checkPlaceholder() {
        if (this.displayRowsCount) this._clearPlaceholder();
        else this.tableEmpty();
    }
    _showPlaceholder() {
        if (this.placeholder) {
            if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
            this.initializePlaceholder();
            this.placeholder.setAttribute("tabulator-render-mode", this.renderMode);
            this.getElement().appendChild(this.placeholder);
            this._positionPlaceholder();
            this.adjustTableSize();
        }
    }
    _clearPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
        // clear empty table placeholder min
        this.tableElement.style.minWidth = "";
        this.tableElement.style.display = "";
    }
    _positionPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) {
            this.placeholder.style.width = this.table.columnManager.getWidth() + "px";
            this.placeholderContents.style.width = this.table.rowManager.element.clientWidth + "px";
            this.placeholderContents.style.marginLeft = this.scrollLeft + "px";
        }
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    //normalize height of active rows
    normalizeHeight(force) {
        this.activeRows.forEach(function(row) {
            row.normalizeHeight(force);
        });
    }
    //adjust the height of the table holder to fit in the Tabulator element
    adjustTableSize() {
        let initialHeight = this.element.clientHeight, minHeight;
        let resized = false;
        if (this.renderer.verticalFillMode === "fill") {
            let otherHeight = Math.floor(this.table.columnManager.getElement().getBoundingClientRect().height + (this.table.footerManager && this.table.footerManager.active && !this.table.footerManager.external ? this.table.footerManager.getElement().getBoundingClientRect().height : 0));
            if (this.fixedHeight) {
                minHeight = isNaN(this.table.options.minHeight) ? this.table.options.minHeight : this.table.options.minHeight + "px";
                const height = "calc(100% - " + otherHeight + "px)";
                this.element.style.minHeight = minHeight || "calc(100% - " + otherHeight + "px)";
                this.element.style.height = height;
                this.element.style.maxHeight = height;
            } else {
                this.element.style.height = "";
                this.element.style.height = this.table.element.clientHeight - otherHeight + "px";
                this.element.scrollTop = this.scrollTop;
            }
            this.renderer.resize();
            //check if the table has changed size when dealing with variable height tables
            if (!this.fixedHeight && initialHeight != this.element.clientHeight) {
                resized = true;
                if (this.subscribed("table-resize")) this.dispatch("table-resize");
                else this.redraw();
            }
            this.scrollBarCheck();
        }
        this._positionPlaceholder();
        return resized;
    }
    //reinitialize all rows
    reinitialize() {
        this.rows.forEach(function(row) {
            row.reinitialize(true);
        });
    }
    //prevent table from being redrawn
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockRestoreConfig = false;
    }
    //restore table redrawing
    restoreRedraw() {
        this.redrawBlock = false;
        if (this.redrawBlockRestoreConfig) {
            this.refreshActiveData(this.redrawBlockRestoreConfig.handler, this.redrawBlockRestoreConfig.skipStage, this.redrawBlockRestoreConfig.renderInPosition);
            this.redrawBlockRestoreConfig = false;
        } else if (this.redrawBlockRenderInPosition) this.reRenderInPosition();
        this.redrawBlockRenderInPosition = false;
    }
    //redraw table
    redraw(force) {
        this.adjustTableSize();
        this.table.tableWidth = this.table.element.clientWidth;
        if (!force) {
            this.reRenderInPosition();
            this.scrollHorizontal(this.scrollLeft);
        } else this.renderTable();
    }
    resetScroll() {
        this.element.scrollLeft = 0;
        this.element.scrollTop = 0;
        if (this.table.browser === "ie") {
            var event = document.createEvent("Event");
            event.initEvent("scroll", false, true);
            this.element.dispatchEvent(event);
        } else this.element.dispatchEvent(new Event("scroll"));
    }
}
class $c2a9788f40f9c90a$var$FooterManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.active = false;
        this.element = this.createElement(); //containing element
        this.containerElement = this.createContainerElement(); //containing element
        this.external = false;
    }
    initialize() {
        this.initializeElement();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer");
        return el;
    }
    createContainerElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer-contents");
        this.element.appendChild(el);
        return el;
    }
    initializeElement() {
        if (this.table.options.footerElement) switch(typeof this.table.options.footerElement){
            case "string":
                if (this.table.options.footerElement[0] === "<") this.containerElement.innerHTML = this.table.options.footerElement;
                else {
                    this.external = true;
                    this.containerElement = document.querySelector(this.table.options.footerElement);
                }
                break;
            default:
                this.element = this.table.options.footerElement;
                break;
        }
    }
    getElement() {
        return this.element;
    }
    append(element) {
        this.activate();
        this.containerElement.appendChild(element);
        this.table.rowManager.adjustTableSize();
    }
    prepend(element) {
        this.activate();
        this.element.insertBefore(element, this.element.firstChild);
        this.table.rowManager.adjustTableSize();
    }
    remove(element) {
        element.parentNode.removeChild(element);
        this.deactivate();
    }
    deactivate(force) {
        if (!this.element.firstChild || force) {
            if (!this.external) this.element.parentNode.removeChild(this.element);
            this.active = false;
        }
    }
    activate() {
        if (!this.active) {
            this.active = true;
            if (!this.external) {
                this.table.element.appendChild(this.getElement());
                this.table.element.style.display = "";
            }
        }
    }
    redraw() {
        this.dispatch("footer-redraw");
    }
}
class $c2a9788f40f9c90a$var$InteractionManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.el = null;
        this.abortClasses = [
            "tabulator-headers",
            "tabulator-table"
        ];
        this.previousTargets = {};
        this.listeners = [
            "click",
            "dblclick",
            "contextmenu",
            "mouseenter",
            "mouseleave",
            "mouseover",
            "mouseout",
            "mousemove",
            "mouseup",
            "mousedown",
            "touchstart",
            "touchend"
        ];
        this.componentMap = {
            "tabulator-cell": "cell",
            "tabulator-row": "row",
            "tabulator-group": "group",
            "tabulator-col": "column"
        };
        this.pseudoTrackers = {
            "row": {
                subscriber: null,
                target: null
            },
            "cell": {
                subscriber: null,
                target: null
            },
            "group": {
                subscriber: null,
                target: null
            },
            "column": {
                subscriber: null,
                target: null
            }
        };
        this.pseudoTracking = false;
    }
    initialize() {
        this.el = this.table.element;
        this.buildListenerMap();
        this.bindSubscriptionWatchers();
    }
    buildListenerMap() {
        var listenerMap = {};
        this.listeners.forEach((listener)=>{
            listenerMap[listener] = {
                handler: null,
                components: []
            };
        });
        this.listeners = listenerMap;
    }
    bindPseudoEvents() {
        Object.keys(this.pseudoTrackers).forEach((key)=>{
            this.pseudoTrackers[key].subscriber = this.pseudoMouseEnter.bind(this, key);
            this.subscribe(key + "-mouseover", this.pseudoTrackers[key].subscriber);
        });
        this.pseudoTracking = true;
    }
    pseudoMouseEnter(key, e, target) {
        if (this.pseudoTrackers[key].target !== target) {
            if (this.pseudoTrackers[key].target) this.dispatch(key + "-mouseleave", e, this.pseudoTrackers[key].target);
            this.pseudoMouseLeave(key, e);
            this.pseudoTrackers[key].target = target;
            this.dispatch(key + "-mouseenter", e, target);
        }
    }
    pseudoMouseLeave(key, e) {
        var leaveList = Object.keys(this.pseudoTrackers), linkedKeys = {
            "row": [
                "cell"
            ],
            "cell": [
                "row"
            ]
        };
        leaveList = leaveList.filter((item)=>{
            var links = linkedKeys[key];
            return item !== key && (!links || links && !links.includes(item));
        });
        leaveList.forEach((key)=>{
            var target = this.pseudoTrackers[key].target;
            if (this.pseudoTrackers[key].target) {
                this.dispatch(key + "-mouseleave", e, target);
                this.pseudoTrackers[key].target = null;
            }
        });
    }
    bindSubscriptionWatchers() {
        var listeners = Object.keys(this.listeners), components = Object.values(this.componentMap);
        for (let comp of components)for (let listener of listeners){
            let key = comp + "-" + listener;
            this.subscriptionChange(key, this.subscriptionChanged.bind(this, comp, listener));
        }
        this.subscribe("table-destroy", this.clearWatchers.bind(this));
    }
    subscriptionChanged(component, key, added) {
        var listener = this.listeners[key].components, index = listener.indexOf(component), changed = false;
        if (added) {
            if (index === -1) {
                listener.push(component);
                changed = true;
            }
        } else {
            if (!this.subscribed(component + "-" + key)) {
                if (index > -1) {
                    listener.splice(index, 1);
                    changed = true;
                }
            }
        }
        if ((key === "mouseenter" || key === "mouseleave") && !this.pseudoTracking) this.bindPseudoEvents();
        if (changed) this.updateEventListeners();
    }
    updateEventListeners() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.components.length) {
                if (!listener.handler) {
                    listener.handler = this.track.bind(this, key);
                    this.el.addEventListener(key, listener.handler);
                // this.el.addEventListener(key, listener.handler, {passive: true})
                }
            } else if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
    track(type, e) {
        var path = e.composedPath && e.composedPath() || e.path;
        var targets = this.findTargets(path);
        targets = this.bindComponents(type, targets);
        this.triggerEvents(type, e, targets);
        if (this.pseudoTracking && (type == "mouseover" || type == "mouseleave") && !Object.keys(targets).length) this.pseudoMouseLeave("none", e);
    }
    findTargets(path) {
        var targets = {};
        let componentMap = Object.keys(this.componentMap);
        for (let el of path){
            let classList = el.classList ? [
                ...el.classList
            ] : [];
            let abort = classList.filter((item)=>{
                return this.abortClasses.includes(item);
            });
            if (abort.length) break;
            let elTargets = classList.filter((item)=>{
                return componentMap.includes(item);
            });
            for (let target of elTargets)if (!targets[this.componentMap[target]]) targets[this.componentMap[target]] = el;
        }
        if (targets.group && targets.group === targets.row) delete targets.row;
        return targets;
    }
    bindComponents(type, targets) {
        //ensure row component is looked up before cell
        var keys = Object.keys(targets).reverse(), listener = this.listeners[type], matches = {}, targetMatches = {};
        for (let key of keys){
            let component, target = targets[key], previousTarget = this.previousTargets[key];
            if (previousTarget && previousTarget.target === target) component = previousTarget.component;
            else switch(key){
                case "row":
                case "group":
                    if (listener.components.includes("row") || listener.components.includes("cell") || listener.components.includes("group")) {
                        let rows = this.table.rowManager.getVisibleRows(true);
                        component = rows.find((row)=>{
                            return row.getElement() === target;
                        });
                        if (targets["row"] && targets["row"].parentNode && targets["row"].parentNode.closest(".tabulator-row")) targets[key] = false;
                    }
                    break;
                case "column":
                    if (listener.components.includes("column")) component = this.table.columnManager.findColumn(target);
                    break;
                case "cell":
                    if (listener.components.includes("cell")) {
                        if (matches["row"] instanceof $c2a9788f40f9c90a$var$Row) component = matches["row"].findCell(target);
                        else if (targets["row"]) console.warn("Event Target Lookup Error - The row this cell is attached to cannot be found, has the table been reinitialized without being destroyed first?");
                    }
                    break;
            }
            if (component) {
                matches[key] = component;
                targetMatches[key] = {
                    target: target,
                    component: component
                };
            }
        }
        this.previousTargets = targetMatches;
        return matches;
    }
    triggerEvents(type, e, targets) {
        var listener = this.listeners[type];
        for(let key in targets)if (targets[key] && listener.components.includes(key)) this.dispatch(key + "-" + type, e, targets[key]);
    }
    clearWatchers() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ComponentFunctionBinder {
    constructor(table){
        this.table = table;
        this.bindings = {};
    }
    bind(type, funcName, handler) {
        if (!this.bindings[type]) this.bindings[type] = {};
        if (this.bindings[type][funcName]) console.warn("Unable to bind component handler, a matching function name is already bound", type, funcName, handler);
        else this.bindings[type][funcName] = handler;
    }
    handle(type, component, name) {
        if (this.bindings[type] && this.bindings[type][name] && typeof this.bindings[type][name].bind === "function") return this.bindings[type][name].bind(null, component);
        else {
            if (name !== "then" && typeof name === "string" && !name.startsWith("_")) {
                if (this.table.options.debugInvalidComponentFuncs) console.error("The " + type + " component does not have a " + name + " function, have you checked that you have the correct Tabulator module installed?");
            }
        }
    }
}
class $c2a9788f40f9c90a$var$DataLoader extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.requestOrder = 0; //prevent requests coming out of sequence if overridden by another load request
        this.loading = false;
    }
    initialize() {}
    load(data, params, config, replace, silent, columnsChanged) {
        var requestNo = ++this.requestOrder;
        if (this.table.destroyed) return Promise.resolve();
        this.dispatchExternal("dataLoading", data);
        //parse json data to array
        if (data && (data.indexOf("{") == 0 || data.indexOf("[") == 0)) data = JSON.parse(data);
        if (this.confirm("data-loading", [
            data,
            params,
            config,
            silent
        ])) {
            this.loading = true;
            if (!silent) this.alertLoader();
            //get params for request
            params = this.chain("data-params", [
                data,
                config,
                silent
            ], params || {}, params || {});
            params = this.mapParams(params, this.table.options.dataSendParams);
            var result = this.chain("data-load", [
                data,
                params,
                config,
                silent
            ], false, Promise.resolve([]));
            return result.then((response)=>{
                if (!this.table.destroyed) {
                    if (!Array.isArray(response) && typeof response == "object") response = this.mapParams(response, this.objectInvert(this.table.options.dataReceiveParams));
                    var rowData = this.chain("data-loaded", [
                        response
                    ], null, response);
                    if (requestNo == this.requestOrder) {
                        this.clearAlert();
                        if (rowData !== false) {
                            this.dispatchExternal("dataLoaded", rowData);
                            this.table.rowManager.setData(rowData, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
                        }
                    } else console.warn("Data Load Response Blocked - An active data load request was blocked by an attempt to change table data while the request was being made");
                } else console.warn("Data Load Response Blocked - Table has been destroyed");
            }).catch((error)=>{
                console.error("Data Load Error: ", error);
                this.dispatchExternal("dataLoadError", error);
                if (!silent) this.alertError();
                setTimeout(()=>{
                    this.clearAlert();
                }, this.table.options.dataLoaderErrorTimeout);
            }).finally(()=>{
                this.loading = false;
            });
        } else {
            this.dispatchExternal("dataLoaded", data);
            if (!data) data = [];
            this.table.rowManager.setData(data, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
            return Promise.resolve();
        }
    }
    mapParams(params, map) {
        var output = {};
        for(let key in params)output[map.hasOwnProperty(key) ? map[key] : key] = params[key];
        return output;
    }
    objectInvert(obj) {
        var output = {};
        for(let key in obj)output[obj[key]] = key;
        return output;
    }
    blockActiveLoad() {
        this.requestOrder++;
    }
    alertLoader() {
        var shouldLoad = typeof this.table.options.dataLoader === "function" ? this.table.options.dataLoader() : this.table.options.dataLoader;
        if (shouldLoad) this.table.alertManager.alert(this.table.options.dataLoaderLoading || this.langText("data|loading"));
    }
    alertError() {
        this.table.alertManager.alert(this.table.options.dataLoaderError || this.langText("data|error"), "error");
    }
    clearAlert() {
        this.table.alertManager.clear();
    }
}
class $c2a9788f40f9c90a$var$ExternalEventBus {
    constructor(table, optionsList, debug){
        this.table = table;
        this.events = {};
        this.optionsList = optionsList || {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push(callback);
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            } else delete this.events[key];
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift(), result;
        if (this.events[key]) this.events[key].forEach((callback, i)=>{
            let callResult = callback.apply(this.table, args);
            if (!i) result = callResult;
        });
        return result;
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "ExternalEvent:" + args[0];
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
}
class $c2a9788f40f9c90a$var$InternalEventBus {
    constructor(debug){
        this.events = {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.chain = debug ? this._debugChain.bind(this) : this._chain.bind(this);
        this.confirm = debug ? this._debugConfirm.bind(this) : this._confirm.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback, priority = 10000) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push({
            callback: callback,
            priority: priority
        });
        this.events[key].sort((a, b)=>{
            return a.priority - b.priority;
        });
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item.callback === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            }
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _chain(key, args, initialValue, fallback) {
        var value = initialValue;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) {
            this.events[key].forEach((subscriber, i)=>{
                value = subscriber.callback.apply(this, args.concat([
                    value
                ]));
            });
            return value;
        } else return typeof fallback === "function" ? fallback() : fallback;
    }
    _confirm(key, args) {
        var confirmed = false;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) this.events[key].forEach((subscriber, i)=>{
            if (subscriber.callback.apply(this, args)) confirmed = true;
        });
        return confirmed;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift();
        if (this.events[key]) this.events[key].forEach((subscriber)=>{
            subscriber.callback.apply(this, args);
        });
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
    _debugChain() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._chain(...arguments);
    }
    _debugConfirm() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._confirm(...arguments);
    }
}
class $c2a9788f40f9c90a$var$DeprecationAdvisor extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
    }
    _warnUser() {
        if (this.options("debugDeprecation")) console.warn(...arguments);
    }
    check(oldOption, newOption, convert) {
        var msg = "";
        if (typeof this.options(oldOption) !== "undefined") {
            msg = "Deprecated Setup Option - Use of the %c" + oldOption + "%c option is now deprecated";
            if (newOption) {
                msg = msg + ", Please use the %c" + newOption + "%c option instead";
                this._warnUser(msg, "font-weight: bold;", "font-weight: normal;", "font-weight: bold;", "font-weight: normal;");
                if (convert) this.table.options[newOption] = this.table.options[oldOption];
            } else this._warnUser(msg, "font-weight: bold;", "font-weight: normal;");
            return false;
        } else return true;
    }
    checkMsg(oldOption, msg) {
        if (typeof this.options(oldOption) !== "undefined") {
            this._warnUser("%cDeprecated Setup Option - Use of the %c" + oldOption + " %c option is now deprecated, " + msg, "font-weight: normal;", "font-weight: bold;", "font-weight: normal;");
            return false;
        } else return true;
    }
    msg(msg) {
        this._warnUser(msg);
    }
}
class $c2a9788f40f9c90a$var$DependencyRegistry extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.deps = {};
        this.props = {};
    }
    initialize() {
        this.deps = Object.assign({}, this.options("dependencies"));
    }
    lookup(key, prop, silent) {
        if (Array.isArray(key)) {
            for (const item of key){
                var match = this.lookup(item, prop, true);
                if (match) break;
            }
            if (match) return match;
            else this.error(key);
        } else {
            if (prop) return this.lookupProp(key, prop, silent);
            else return this.lookupKey(key, silent);
        }
    }
    lookupProp(key, prop, silent) {
        var dependency;
        if (this.props[key] && this.props[key][prop]) return this.props[key][prop];
        else {
            dependency = this.lookupKey(key, silent);
            if (dependency) {
                if (!this.props[key]) this.props[key] = {};
                this.props[key][prop] = dependency[prop] || dependency;
                return this.props[key][prop];
            }
        }
    }
    lookupKey(key, silent) {
        var dependency;
        if (this.deps[key]) dependency = this.deps[key];
        else if (window[key]) {
            this.deps[key] = window[key];
            dependency = this.deps[key];
        } else if (!silent) this.error(key);
        return dependency;
    }
    error(key) {
        console.error("Unable to find dependency", key, "Please check documentation and ensure you have imported the required library into your project");
    }
}
//resize columns to fit data they contain
function $c2a9788f40f9c90a$var$fitData(columns, forced) {
    if (forced) this.table.columnManager.renderer.reinitializeColumnWidths(columns);
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data they contain and stretch row to fill table, also used for fitDataTable
function $c2a9788f40f9c90a$var$fitDataGeneral(columns, forced) {
    columns.forEach(function(column) {
        column.reinitializeWidth();
    });
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data the contain and stretch last column to fill table
function $c2a9788f40f9c90a$var$fitDataStretch(columns, forced) {
    var colsWidth = 0, tableWidth = this.table.rowManager.element.clientWidth, gap = 0, lastCol = false;
    columns.forEach((column, i)=>{
        if (!column.widthFixed) column.reinitializeWidth();
        if (this.table.options.responsiveLayout ? column.modules.responsive.visible : column.visible) lastCol = column;
        if (column.visible) colsWidth += column.getWidth();
    });
    if (lastCol) {
        gap = tableWidth - colsWidth + lastCol.getWidth();
        if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) {
            lastCol.setWidth(0);
            this.table.modules.responsiveLayout.update();
        }
        if (gap > 0) lastCol.setWidth(gap);
        else lastCol.reinitializeWidth();
    } else if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit
function $c2a9788f40f9c90a$var$fitColumns(columns, forced) {
    var totalWidth = this.table.rowManager.element.getBoundingClientRect().width; //table element width
    var fixedWidth = 0; //total width of columns with a defined width
    var flexWidth = 0; //total width available to flexible columns
    var flexGrowUnits = 0; //total number of widthGrow blocks across all columns
    var flexColWidth = 0; //desired width of flexible columns
    var flexColumns = []; //array of flexible width columns
    var fixedShrinkColumns = []; //array of fixed width columns that can shrink
    var flexShrinkUnits = 0; //total number of widthShrink blocks across all columns
    var overflowWidth = 0; //horizontal overflow width
    var gapFill = 0; //number of pixels to be added to final column to close and half pixel gaps
    function calcWidth(width) {
        var colWidth;
        if (typeof width == "string") {
            if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
            else colWidth = parseInt(width);
        } else colWidth = width;
        return colWidth;
    }
    //ensure columns resize to take up the correct amount of space
    function scaleColumns(columns, freeSpace, colWidth, shrinkCols) {
        var oversizeCols = [], oversizeSpace = 0, remainingSpace = 0, nextColWidth = 0, remainingFlexGrowUnits = flexGrowUnits, gap = 0, changeUnits = 0, undersizeCols = [];
        function calcGrow(col) {
            return colWidth * (col.column.definition.widthGrow || 1);
        }
        function calcShrink(col) {
            return calcWidth(col.width) - colWidth * (col.column.definition.widthShrink || 0);
        }
        columns.forEach(function(col, i) {
            var width = shrinkCols ? calcShrink(col) : calcGrow(col);
            if (col.column.minWidth >= width) oversizeCols.push(col);
            else if (col.column.maxWidth && col.column.maxWidth < width) {
                col.width = col.column.maxWidth;
                freeSpace -= col.column.maxWidth;
                remainingFlexGrowUnits -= shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
                if (remainingFlexGrowUnits) colWidth = Math.floor(freeSpace / remainingFlexGrowUnits);
            } else {
                undersizeCols.push(col);
                changeUnits += shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
            }
        });
        if (oversizeCols.length) {
            oversizeCols.forEach(function(col) {
                oversizeSpace += shrinkCols ? col.width - col.column.minWidth : col.column.minWidth;
                col.width = col.column.minWidth;
            });
            remainingSpace = freeSpace - oversizeSpace;
            nextColWidth = changeUnits ? Math.floor(remainingSpace / changeUnits) : remainingSpace;
            gap = scaleColumns(undersizeCols, remainingSpace, nextColWidth, shrinkCols);
        } else {
            gap = changeUnits ? freeSpace - Math.floor(freeSpace / changeUnits) * changeUnits : freeSpace;
            undersizeCols.forEach(function(column) {
                column.width = shrinkCols ? calcShrink(column) : calcGrow(column);
            });
        }
        return gap;
    }
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
    //adjust for vertical scrollbar if present
    if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
    columns.forEach(function(column) {
        var width, minWidth, colWidth;
        if (column.visible) {
            width = column.definition.width;
            minWidth = parseInt(column.minWidth);
            if (width) {
                colWidth = calcWidth(width);
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
                if (column.definition.widthShrink) {
                    fixedShrinkColumns.push({
                        column: column,
                        width: colWidth > minWidth ? colWidth : minWidth
                    });
                    flexShrinkUnits += column.definition.widthShrink;
                }
            } else {
                flexColumns.push({
                    column: column,
                    width: 0
                });
                flexGrowUnits += column.definition.widthGrow || 1;
            }
        }
    });
    //calculate available space
    flexWidth = totalWidth - fixedWidth;
    //calculate correct column size
    flexColWidth = Math.floor(flexWidth / flexGrowUnits);
    //generate column widths
    gapFill = scaleColumns(flexColumns, flexWidth, flexColWidth, false);
    //increase width of last column to account for rounding errors
    if (flexColumns.length && gapFill > 0) flexColumns[flexColumns.length - 1].width += gapFill;
    //calculate space for columns to be shrunk into
    flexColumns.forEach(function(col) {
        flexWidth -= col.width;
    });
    overflowWidth = Math.abs(gapFill) + flexWidth;
    //shrink oversize columns if there is no available space
    if (overflowWidth > 0 && flexShrinkUnits) gapFill = scaleColumns(fixedShrinkColumns, overflowWidth, Math.floor(overflowWidth / flexShrinkUnits), true);
    //decrease width of last column to account for rounding errors
    if (gapFill && fixedShrinkColumns.length) fixedShrinkColumns[fixedShrinkColumns.length - 1].width -= gapFill;
    flexColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
    fixedShrinkColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
}
var $c2a9788f40f9c90a$var$defaultModes = {
    fitData: $c2a9788f40f9c90a$var$fitData,
    fitDataFill: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataTable: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataStretch: $c2a9788f40f9c90a$var$fitDataStretch,
    fitColumns: $c2a9788f40f9c90a$var$fitColumns
};
class $c2a9788f40f9c90a$var$Layout extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "layout";
    //load defaults
    static modes = $c2a9788f40f9c90a$var$defaultModes;
    constructor(table){
        super(table, "layout");
        this.mode = null;
        this.registerTableOption("layout", "fitData"); //layout type
        this.registerTableOption("layoutColumnsOnNewData", false); //update column widths on setData
        this.registerColumnOption("widthGrow");
        this.registerColumnOption("widthShrink");
    }
    //initialize layout system
    initialize() {
        var layout = this.table.options.layout;
        if ($c2a9788f40f9c90a$var$Layout.modes[layout]) this.mode = layout;
        else {
            console.warn("Layout Error - invalid mode set, defaulting to 'fitData' : " + layout);
            this.mode = "fitData";
        }
        this.table.element.setAttribute("tabulator-layout", this.mode);
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    initializeColumn(column) {
        if (column.definition.widthGrow) column.definition.widthGrow = Number(column.definition.widthGrow);
        if (column.definition.widthShrink) column.definition.widthShrink = Number(column.definition.widthShrink);
    }
    getMode() {
        return this.mode;
    }
    //trigger table layout
    layout(dataChanged) {
        var variableHeight = this.table.columnManager.columnsByIndex.find((column)=>column.definition.variableHeight || column.definition.formatter === "textarea");
        this.dispatch("layout-refreshing");
        $c2a9788f40f9c90a$var$Layout.modes[this.mode].call(this, this.table.columnManager.columnsByIndex, dataChanged);
        if (variableHeight) this.table.rowManager.normalizeHeight(true);
        this.dispatch("layout-refreshed");
    }
}
var $c2a9788f40f9c90a$var$defaultLangs = {
    "default": {
        "groups": {
            "item": "item",
            "items": "items"
        },
        "columns": {},
        "data": {
            "loading": "Loading",
            "error": "Error"
        },
        "pagination": {
            "page_size": "Page Size",
            "page_title": "Show Page",
            "first": "First",
            "first_title": "First Page",
            "last": "Last",
            "last_title": "Last Page",
            "prev": "Prev",
            "prev_title": "Prev Page",
            "next": "Next",
            "next_title": "Next Page",
            "all": "All",
            "counter": {
                "showing": "Showing",
                "of": "of",
                "rows": "rows",
                "pages": "pages"
            }
        },
        "headerFilters": {
            "default": "filter column...",
            "columns": {}
        }
    }
};
class $c2a9788f40f9c90a$var$Localize extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "localize";
    //load defaults
    static langs = $c2a9788f40f9c90a$var$defaultLangs;
    constructor(table){
        super(table);
        this.locale = "default"; //current locale
        this.lang = false; //current language
        this.bindings = {}; //update events to call when locale is changed
        this.langList = {};
        this.registerTableOption("locale", false); //current system language
        this.registerTableOption("langs", {});
    }
    initialize() {
        this.langList = $c2a9788f40f9c90a$var$Helpers.deepClone($c2a9788f40f9c90a$var$Localize.langs);
        if (this.table.options.columnDefaults.headerFilterPlaceholder !== false) this.setHeaderFilterPlaceholder(this.table.options.columnDefaults.headerFilterPlaceholder);
        for(let locale in this.table.options.langs)this.installLang(locale, this.table.options.langs[locale]);
        this.setLocale(this.table.options.locale);
        this.registerTableFunction("setLocale", this.setLocale.bind(this));
        this.registerTableFunction("getLocale", this.getLocale.bind(this));
        this.registerTableFunction("getLang", this.getLang.bind(this));
    }
    //set header placeholder
    setHeaderFilterPlaceholder(placeholder) {
        this.langList.default.headerFilters.default = placeholder;
    }
    //setup a lang description object
    installLang(locale, lang) {
        if (this.langList[locale]) this._setLangProp(this.langList[locale], lang);
        else this.langList[locale] = lang;
    }
    _setLangProp(lang, values) {
        for(let key in values)if (lang[key] && typeof lang[key] == "object") this._setLangProp(lang[key], values[key]);
        else lang[key] = values[key];
    }
    //set current locale
    setLocale(desiredLocale) {
        desiredLocale = desiredLocale || "default";
        //fill in any matching language values
        function traverseLang(trans, path) {
            for(var prop in trans)if (typeof trans[prop] == "object") {
                if (!path[prop]) path[prop] = {};
                traverseLang(trans[prop], path[prop]);
            } else path[prop] = trans[prop];
        }
        //determining correct locale to load
        if (desiredLocale === true && navigator.language) //get local from system
        desiredLocale = navigator.language.toLowerCase();
        if (desiredLocale) //if locale is not set, check for matching top level locale else use default
        {
            if (!this.langList[desiredLocale]) {
                let prefix = desiredLocale.split("-")[0];
                if (this.langList[prefix]) {
                    console.warn("Localization Error - Exact matching locale not found, using closest match: ", desiredLocale, prefix);
                    desiredLocale = prefix;
                } else {
                    console.warn("Localization Error - Matching locale not found, using default: ", desiredLocale);
                    desiredLocale = "default";
                }
            }
        }
        this.locale = desiredLocale;
        //load default lang template
        this.lang = $c2a9788f40f9c90a$var$Helpers.deepClone(this.langList.default || {});
        if (desiredLocale != "default") traverseLang(this.langList[desiredLocale], this.lang);
        this.dispatchExternal("localized", this.locale, this.lang);
        this._executeBindings();
    }
    //get current locale
    getLocale(locale) {
        return this.locale;
    }
    //get lang object for given local or current if none provided
    getLang(locale) {
        return locale ? this.langList[locale] : this.lang;
    }
    //get text for current locale
    getText(path, value) {
        var fillPath = value ? path + "|" + value : path, pathArray = fillPath.split("|"), text = this._getLangElement(pathArray, this.locale);
        // if(text === false){
        // 	console.warn("Localization Error - Matching localized text not found for given path: ", path);
        // }
        return text || "";
    }
    //traverse langs object and find localized copy
    _getLangElement(path, locale) {
        var root = this.lang;
        path.forEach(function(level) {
            var rootPath;
            if (root) {
                rootPath = root[level];
                if (typeof rootPath != "undefined") root = rootPath;
                else root = false;
            }
        });
        return root;
    }
    //set update binding
    bind(path, callback) {
        if (!this.bindings[path]) this.bindings[path] = [];
        this.bindings[path].push(callback);
        callback(this.getText(path), this.lang);
    }
    //iterate through bindings and trigger updates
    _executeBindings() {
        for(let path in this.bindings)this.bindings[path].forEach((binding)=>{
            binding(this.getText(path), this.lang);
        });
    }
}
class $c2a9788f40f9c90a$var$Comms extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "comms";
    constructor(table){
        super(table);
    }
    initialize() {
        this.registerTableFunction("tableComms", this.receive.bind(this));
    }
    getConnections(selectors) {
        var connections = [], connection;
        connection = this.table.constructor.registry.lookupTable(selectors);
        connection.forEach((con)=>{
            if (this.table !== con) connections.push(con);
        });
        return connections;
    }
    send(selectors, module, action, data) {
        var connections = this.getConnections(selectors);
        connections.forEach((connection)=>{
            connection.tableComms(this.table.element, module, action, data);
        });
        if (!connections.length && selectors) console.warn("Table Connection Error - No tables matching selector found", selectors);
    }
    receive(table, module, action, data) {
        if (this.table.modExists(module)) return this.table.modules[module].commsReceived(table, action, data);
        else console.warn("Inter-table Comms Error - no such module:", module);
    }
}
var $c2a9788f40f9c90a$var$coreModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CommsModule: $c2a9788f40f9c90a$var$Comms,
    LayoutModule: $c2a9788f40f9c90a$var$Layout,
    LocalizeModule: $c2a9788f40f9c90a$var$Localize
});
class $c2a9788f40f9c90a$var$TableRegistry {
    static registry = {
        tables: [],
        register (table) {
            $c2a9788f40f9c90a$var$TableRegistry.registry.tables.push(table);
        },
        deregister (table) {
            var index = $c2a9788f40f9c90a$var$TableRegistry.registry.tables.indexOf(table);
            if (index > -1) $c2a9788f40f9c90a$var$TableRegistry.registry.tables.splice(index, 1);
        },
        lookupTable (query, silent) {
            var results = [], matches, match;
            if (typeof query === "string") {
                matches = document.querySelectorAll(query);
                if (matches.length) for(var i = 0; i < matches.length; i++){
                    match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(matches[i]);
                    if (match) results.push(match);
                }
            } else if (typeof HTMLElement !== "undefined" && query instanceof HTMLElement || query instanceof $c2a9788f40f9c90a$var$TableRegistry) {
                match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(query);
                if (match) results.push(match);
            } else if (Array.isArray(query)) query.forEach(function(item) {
                results = results.concat($c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(item));
            });
            else if (!silent) console.warn("Table Connection Error - Invalid Selector", query);
            return results;
        },
        matchElement (element) {
            return $c2a9788f40f9c90a$var$TableRegistry.registry.tables.find(function(table) {
                return element instanceof $c2a9788f40f9c90a$var$TableRegistry ? table === element : table.element === element;
            });
        }
    };
    static findTable(query) {
        var results = $c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(query, true);
        return Array.isArray(results) && !results.length ? false : results;
    }
}
class $c2a9788f40f9c90a$var$ModuleBinder extends $c2a9788f40f9c90a$var$TableRegistry {
    static moduleBindings = {};
    static moduleExtensions = {};
    static modulesRegistered = false;
    static defaultModules = false;
    constructor(){
        super();
    }
    static initializeModuleBinder(defaultModules) {
        if (!$c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered) {
            $c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered = true;
            $c2a9788f40f9c90a$var$ModuleBinder._registerModules($c2a9788f40f9c90a$var$coreModules, true);
            if (defaultModules) $c2a9788f40f9c90a$var$ModuleBinder._registerModules(defaultModules);
        }
    }
    static _extendModule(name, property, values) {
        if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name]) {
            var source = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name][property];
            if (source) {
                if (typeof values == "object") for(let key in values)source[key] = values[key];
                else console.warn("Module Error - Invalid value type, it must be an object");
            } else console.warn("Module Error - property does not exist:", property);
        } else console.warn("Module Error - module does not exist:", name);
    }
    static _registerModules(modules, core) {
        var mods = Object.values(modules);
        if (core) mods.forEach((mod)=>{
            mod.prototype.moduleCore = true;
        });
        $c2a9788f40f9c90a$var$ModuleBinder._registerModule(mods);
    }
    static _registerModule(modules) {
        if (!Array.isArray(modules)) modules = [
            modules
        ];
        modules.forEach((mod)=>{
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleBinding(mod);
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleExtensions(mod);
        });
    }
    static _registerModuleBinding(mod) {
        if (mod.moduleName) $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[mod.moduleName] = mod;
        else console.error("Unable to bind module, no moduleName defined", mod.moduleName);
    }
    static _registerModuleExtensions(mod) {
        var extensions = mod.moduleExtensions;
        if (mod.moduleExtensions) for(let modKey in extensions){
            let ext = extensions[modKey];
            if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[modKey]) for(let propKey in ext)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(modKey, propKey, ext[propKey]);
            else {
                if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey] = {};
                for(let propKey in ext){
                    if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey] = {};
                    Object.assign($c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey], ext[propKey]);
                }
            }
        }
        $c2a9788f40f9c90a$var$ModuleBinder._extendModuleFromQueue(mod);
    }
    static _extendModuleFromQueue(mod) {
        var extensions = $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[mod.moduleName];
        if (extensions) for(let propKey in extensions)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(mod.moduleName, propKey, extensions[propKey]);
    }
    //ensure that module are bound to instantiated function
    _bindModules() {
        var orderedStartMods = [], orderedEndMods = [], unOrderedMods = [];
        this.modules = {};
        for(var name in $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings){
            let mod = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name];
            let module = new mod(this);
            this.modules[name] = module;
            if (mod.prototype.moduleCore) this.modulesCore.push(module);
            else if (mod.moduleInitOrder) {
                if (mod.moduleInitOrder < 0) orderedStartMods.push(module);
                else orderedEndMods.push(module);
            } else unOrderedMods.push(module);
        }
        orderedStartMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        orderedEndMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        this.modulesRegular = orderedStartMods.concat(unOrderedMods.concat(orderedEndMods));
    }
}
class $c2a9788f40f9c90a$var$Alert extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this._createAlertElement();
        this.msgElement = this._createMsgElement();
        this.type = null;
        this.element.appendChild(this.msgElement);
    }
    _createAlertElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert");
        return el;
    }
    _createMsgElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert-msg");
        el.setAttribute("role", "alert");
        return el;
    }
    _typeClass() {
        return "tabulator-alert-state-" + this.type;
    }
    alert(content, type = "msg") {
        if (content) {
            this.clear();
            this.dispatch("alert-show", type);
            this.type = type;
            while(this.msgElement.firstChild)this.msgElement.removeChild(this.msgElement.firstChild);
            this.msgElement.classList.add(this._typeClass());
            if (typeof content === "function") content = content();
            if (content instanceof HTMLElement) this.msgElement.appendChild(content);
            else this.msgElement.innerHTML = content;
            this.table.element.appendChild(this.element);
        }
    }
    clear() {
        this.dispatch("alert-hide", this.type);
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.msgElement.classList.remove(this._typeClass());
    }
}
class $c2a9788f40f9c90a$var$Tabulator extends $c2a9788f40f9c90a$var$ModuleBinder {
    //default setup options
    static defaultOptions = $c2a9788f40f9c90a$var$defaultOptions;
    static extendModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super();
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder(modules);
        this.options = {};
        this.columnManager = null; // hold Column Manager
        this.rowManager = null; //hold Row Manager
        this.footerManager = null; //holder Footer Manager
        this.alertManager = null; //hold Alert Manager
        this.vdomHoz = null; //holder horizontal virtual dom
        this.externalEvents = null; //handle external event messaging
        this.eventBus = null; //handle internal event messaging
        this.interactionMonitor = false; //track user interaction
        this.browser = ""; //hold current browser type
        this.browserSlow = false; //handle reduced functionality for slower browsers
        this.browserMobile = false; //check if running on mobile, prevent resize cancelling edit on keyboard appearance
        this.rtl = false; //check if the table is in RTL mode
        this.originalElement = null; //hold original table element if it has been replaced
        this.componentFunctionBinder = new $c2a9788f40f9c90a$var$ComponentFunctionBinder(this); //bind component functions
        this.dataLoader = false; //bind component functions
        this.modules = {}; //hold all modules bound to this table
        this.modulesCore = []; //hold core modules bound to this table (for initialization purposes)
        this.modulesRegular = []; //hold regular modules bound to this table (for initialization purposes)
        this.deprecationAdvisor = new $c2a9788f40f9c90a$var$DeprecationAdvisor(this);
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this, "table constructor");
        this.dependencyRegistry = new $c2a9788f40f9c90a$var$DependencyRegistry(this);
        this.initialized = false;
        this.destroyed = false;
        if (this.initializeElement(element)) {
            this.initializeCoreSystems(options);
            //delay table creation to allow event bindings immediately after the constructor
            setTimeout(()=>{
                this._create();
            });
        }
        this.constructor.registry.register(this); //register table for inter-device communication
    }
    initializeElement(element) {
        if (typeof HTMLElement !== "undefined" && element instanceof HTMLElement) {
            this.element = element;
            return true;
        } else if (typeof element === "string") {
            this.element = document.querySelector(element);
            if (this.element) return true;
            else {
                console.error("Tabulator Creation Error - no element found matching selector: ", element);
                return false;
            }
        } else {
            console.error("Tabulator Creation Error - Invalid element provided:", element);
            return false;
        }
    }
    initializeCoreSystems(options) {
        this.columnManager = new $c2a9788f40f9c90a$var$ColumnManager(this);
        this.rowManager = new $c2a9788f40f9c90a$var$RowManager(this);
        this.footerManager = new $c2a9788f40f9c90a$var$FooterManager(this);
        this.dataLoader = new $c2a9788f40f9c90a$var$DataLoader(this);
        this.alertManager = new $c2a9788f40f9c90a$var$Alert(this);
        this._bindModules();
        this.options = this.optionsList.generate($c2a9788f40f9c90a$var$Tabulator.defaultOptions, options);
        this._clearObjectPointers();
        this._mapDeprecatedFunctionality();
        this.externalEvents = new $c2a9788f40f9c90a$var$ExternalEventBus(this, this.options, this.options.debugEventsExternal);
        this.eventBus = new $c2a9788f40f9c90a$var$InternalEventBus(this.options.debugEventsInternal);
        this.interactionMonitor = new $c2a9788f40f9c90a$var$InteractionManager(this);
        this.dataLoader.initialize();
        this.footerManager.initialize();
        this.dependencyRegistry.initialize();
    }
    //convert deprecated functionality to new functions
    _mapDeprecatedFunctionality() {
    //all previously deprecated functionality removed in the 6.0 release
    }
    _clearSelection() {
        this.element.classList.add("tabulator-block-select");
        if (window.getSelection) {
            if (window.getSelection().empty) window.getSelection().empty();
            else if (window.getSelection().removeAllRanges) window.getSelection().removeAllRanges();
        } else if (document.selection) document.selection.empty();
        this.element.classList.remove("tabulator-block-select");
    }
    //create table
    _create() {
        this.externalEvents.dispatch("tableBuilding");
        this.eventBus.dispatch("table-building");
        this._rtlCheck();
        this._buildElement();
        this._initializeTable();
        this.initialized = true;
        this._loadInitialData().finally(()=>{
            this.eventBus.dispatch("table-initialized");
            this.externalEvents.dispatch("tableBuilt");
        });
    }
    _rtlCheck() {
        var style = window.getComputedStyle(this.element);
        switch(this.options.textDirection){
            case "auto":
                if (style.direction !== "rtl") break;
            case "rtl":
                this.element.classList.add("tabulator-rtl");
                this.rtl = true;
                break;
            case "ltr":
                this.element.classList.add("tabulator-ltr");
            default:
                this.rtl = false;
        }
    }
    //clear pointers to objects in default config object
    _clearObjectPointers() {
        this.options.columns = this.options.columns.slice(0);
        if (Array.isArray(this.options.data) && !this.options.reactiveData) this.options.data = this.options.data.slice(0);
    }
    //build tabulator element
    _buildElement() {
        var element = this.element, options = this.options, newElement;
        if (element.tagName === "TABLE") {
            this.originalElement = this.element;
            newElement = document.createElement("div");
            //transfer attributes to new element
            var attributes = element.attributes;
            // loop through attributes and apply them on div
            for(var i in attributes)if (typeof attributes[i] == "object") newElement.setAttribute(attributes[i].name, attributes[i].value);
            // replace table with div element
            element.parentNode.replaceChild(newElement, element);
            this.element = element = newElement;
        }
        element.classList.add("tabulator");
        element.setAttribute("role", "grid");
        //empty element
        while(element.firstChild)element.removeChild(element.firstChild);
        //set table height
        if (options.height) {
            options.height = isNaN(options.height) ? options.height : options.height + "px";
            element.style.height = options.height;
        }
        //set table min height
        if (options.minHeight !== false) {
            options.minHeight = isNaN(options.minHeight) ? options.minHeight : options.minHeight + "px";
            element.style.minHeight = options.minHeight;
        }
        //set table maxHeight
        if (options.maxHeight !== false) {
            options.maxHeight = isNaN(options.maxHeight) ? options.maxHeight : options.maxHeight + "px";
            element.style.maxHeight = options.maxHeight;
        }
    }
    //initialize core systems and modules
    _initializeTable() {
        var element = this.element, options = this.options;
        this.interactionMonitor.initialize();
        this.columnManager.initialize();
        this.rowManager.initialize();
        this._detectBrowser();
        //initialize core modules
        this.modulesCore.forEach((mod)=>{
            mod.initialize();
        });
        //build table elements
        element.appendChild(this.columnManager.getElement());
        element.appendChild(this.rowManager.getElement());
        if (options.footerElement) this.footerManager.activate();
        if (options.autoColumns && options.data) this.columnManager.generateColumnsFromRowData(this.options.data);
        //initialize regular modules
        this.modulesRegular.forEach((mod)=>{
            mod.initialize();
        });
        this.columnManager.setColumns(options.columns);
        this.eventBus.dispatch("table-built");
    }
    _loadInitialData() {
        return this.dataLoader.load(this.options.data).finally(()=>{
            this.columnManager.verticalAlignHeaders();
        });
    }
    //deconstructor
    destroy() {
        var element = this.element;
        this.destroyed = true;
        this.constructor.registry.deregister(this); //deregister table from inter-device communication
        this.eventBus.dispatch("table-destroy");
        //clear row data
        this.rowManager.destroy();
        //clear DOM
        while(element.firstChild)element.removeChild(element.firstChild);
        element.classList.remove("tabulator");
        this.externalEvents.dispatch("tableDestroyed");
    }
    _detectBrowser() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua.indexOf("Trident") > -1) {
            this.browser = "ie";
            this.browserSlow = true;
        } else if (ua.indexOf("Edge") > -1) {
            this.browser = "edge";
            this.browserSlow = true;
        } else if (ua.indexOf("Firefox") > -1) {
            this.browser = "firefox";
            this.browserSlow = false;
        } else if (ua.indexOf("Mac OS") > -1) {
            this.browser = "safari";
            this.browserSlow = false;
        } else {
            this.browser = "other";
            this.browserSlow = false;
        }
        this.browserMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ua.slice(0, 4));
    }
    initGuard(func, msg) {
        var stack, line;
        if (this.options.debugInitialization && !this.initialized) {
            if (!func) {
                stack = new Error().stack.split("\n");
                line = stack[0] == "Error" ? stack[2] : stack[1];
                if (line[0] == " ") func = line.trim().split(" ")[1].split(".")[1];
                else func = line.trim().split("@")[0];
            }
            console.warn("Table Not Initialized - Calling the " + func + " function before the table is initialized may result in inconsistent behavior, Please wait for the `tableBuilt` event before calling this function." + (msg ? " " + msg : ""));
        }
        return this.initialized;
    }
    ////////////////// Data Handling //////////////////
    //block table redrawing
    blockRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-blocking");
        this.rowManager.blockRedraw();
        this.columnManager.blockRedraw();
        this.eventBus.dispatch("redraw-blocked");
    }
    //restore table redrawing
    restoreRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-restoring");
        this.rowManager.restoreRedraw();
        this.columnManager.restoreRedraw();
        this.eventBus.dispatch("redraw-restored");
    }
    //load data
    setData(data, params, config) {
        this.initGuard(false, "To set initial data please use the 'data' property in the table constructor.");
        return this.dataLoader.load(data, params, config, false);
    }
    //clear data
    clearData() {
        this.initGuard();
        this.dataLoader.blockActiveLoad();
        this.rowManager.clearData();
    }
    //get table data array
    getData(active) {
        return this.rowManager.getData(active);
    }
    //get table data array count
    getDataCount(active) {
        return this.rowManager.getDataCount(active);
    }
    //replace data, keeping table in position with same sort
    replaceData(data, params, config) {
        this.initGuard();
        return this.dataLoader.load(data, params, config, true, true);
    }
    //update table data
    updateData(data) {
        var responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                if (row) {
                    responses++;
                    row.updateData(item).then(()=>{
                        responses--;
                        if (!responses) resolve();
                    }).catch((e)=>{
                        reject("Update Error - Unable to update row", item, e);
                    });
                } else reject("Update Error - Unable to find row", item);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    addData(data, pos, index) {
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data) this.rowManager.addRows(data, pos, index).then((rows)=>{
                var output = [];
                rows.forEach(function(row) {
                    output.push(row.getComponent());
                });
                resolve(output);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //update table data
    updateOrAddData(data) {
        var rows = [], responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                responses++;
                if (row) row.updateData(item).then(()=>{
                    responses--;
                    rows.push(row.getComponent());
                    if (!responses) resolve(rows);
                });
                else this.rowManager.addRows(item).then((newRows)=>{
                    responses--;
                    rows.push(newRows[0].getComponent());
                    if (!responses) resolve(rows);
                });
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //get row object
    getRow(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", index);
            return false;
        }
    }
    //get row object
    getRowFromPosition(position) {
        var row = this.rowManager.getRowFromPosition(position);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", position);
            return false;
        }
    }
    //delete row from table
    deleteRow(index) {
        var foundRows = [];
        this.initGuard();
        if (!Array.isArray(index)) index = [
            index
        ];
        //find matching rows
        for (let item of index){
            let row = this.rowManager.findRow(item, true);
            if (row) foundRows.push(row);
            else {
                console.error("Delete Error - No matching row found:", item);
                return Promise.reject("Delete Error - No matching row found");
            }
        }
        //sort rows into correct order to ensure smooth delete from table
        foundRows.sort((a, b)=>{
            return this.rowManager.rows.indexOf(a) > this.rowManager.rows.indexOf(b) ? 1 : -1;
        });
        //delete rows
        foundRows.forEach((row)=>{
            row.delete();
        });
        this.rowManager.reRenderInPosition();
        return Promise.resolve();
    }
    //add row to table
    addRow(data, pos, index) {
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        return this.rowManager.addRows(data, pos, index, true).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update a row if it exists otherwise create it
    updateOrAddRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return row.getComponent();
        });
        else return this.rowManager.addRows(data).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update row data
    updateRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return Promise.resolve(row.getComponent());
        });
        else {
            console.warn("Update Error - No matching row found:", index);
            return Promise.reject("Update Error - No matching row found");
        }
    }
    //scroll to row in DOM
    scrollToRow(index, position, ifVisible) {
        var row = this.rowManager.findRow(index);
        if (row) return this.rowManager.scrollToRow(row, position, ifVisible);
        else {
            console.warn("Scroll Error - No matching row found:", index);
            return Promise.reject("Scroll Error - No matching row found");
        }
    }
    moveRow(from, to, after) {
        var fromRow = this.rowManager.findRow(from);
        this.initGuard();
        if (fromRow) fromRow.moveToRow(to, after);
        else console.warn("Move Error - No matching row found:", from);
    }
    getRows(active) {
        return this.rowManager.getComponents(active);
    }
    //get position of row in table
    getRowPosition(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getPosition();
        else {
            console.warn("Position Error - No matching row found:", index);
            return false;
        }
    }
    /////////////// Column Functions  ///////////////
    setColumns(definition) {
        this.initGuard(false, "To set initial columns please use the 'columns' property in the table constructor");
        this.columnManager.setColumns(definition);
    }
    getColumns(structured) {
        return this.columnManager.getComponents(structured);
    }
    getColumn(field) {
        var column = this.columnManager.findColumn(field);
        if (column) return column.getComponent();
        else {
            console.warn("Find Error - No matching column found:", field);
            return false;
        }
    }
    getColumnDefinitions() {
        return this.columnManager.getDefinitionTree();
    }
    showColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.show();
        else {
            console.warn("Column Show Error - No matching column found:", field);
            return false;
        }
    }
    hideColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.hide();
        else {
            console.warn("Column Hide Error - No matching column found:", field);
            return false;
        }
    }
    toggleColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) {
            if (column.visible) column.hide();
            else column.show();
        } else {
            console.warn("Column Visibility Toggle Error - No matching column found:", field);
            return false;
        }
    }
    addColumn(definition, before, field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        return this.columnManager.addColumn(definition, before, column).then((column)=>{
            return column.getComponent();
        });
    }
    deleteColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.delete();
        else {
            console.warn("Column Delete Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    updateColumnDefinition(field, definition) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.updateDefinition(definition);
        else {
            console.warn("Column Update Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    moveColumn(from, to, after) {
        var fromColumn = this.columnManager.findColumn(from), toColumn = this.columnManager.findColumn(to);
        this.initGuard();
        if (fromColumn) {
            if (toColumn) this.columnManager.moveColumn(fromColumn, toColumn, after);
            else console.warn("Move Error - No matching column found:", toColumn);
        } else console.warn("Move Error - No matching column found:", from);
    }
    //scroll to column in DOM
    scrollToColumn(field, position, ifVisible) {
        return new Promise((resolve, reject)=>{
            var column = this.columnManager.findColumn(field);
            if (column) return this.columnManager.scrollToColumn(column, position, ifVisible);
            else {
                console.warn("Scroll Error - No matching column found:", field);
                return Promise.reject("Scroll Error - No matching column found");
            }
        });
    }
    //////////// General Public Functions ////////////
    //redraw list without updating data
    redraw(force) {
        this.initGuard();
        this.columnManager.redraw(force);
        this.rowManager.redraw(force);
    }
    setHeight(height) {
        this.options.height = isNaN(height) ? height : height + "px";
        this.element.style.height = this.options.height;
        this.rowManager.initializeRenderer();
        this.rowManager.redraw(true);
    }
    //////////////////// Event Bus ///////////////////
    on(key, callback) {
        this.externalEvents.subscribe(key, callback);
    }
    off(key, callback) {
        this.externalEvents.unsubscribe(key, callback);
    }
    dispatchEvent() {
        var args = Array.from(arguments);
        args.shift();
        this.externalEvents.dispatch(...arguments);
    }
    //////////////////// Alerts ///////////////////
    alert(contents, type) {
        this.initGuard();
        this.alertManager.alert(contents, type);
    }
    clearAlert() {
        this.initGuard();
        this.alertManager.clear();
    }
    ////////////// Extension Management //////////////
    modExists(plugin, required) {
        if (this.modules[plugin]) return true;
        else {
            if (required) console.error("Tabulator Module Not Installed: " + plugin);
            return false;
        }
    }
    module(key) {
        var mod = this.modules[key];
        if (!mod) console.error("Tabulator module not installed: " + key);
        return mod;
    }
}
var $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 = $c2a9788f40f9c90a$var$Tabulator;
//tabulator with all modules installed
class $c2a9788f40f9c90a$var$TabulatorFull extends $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 {
    static extendModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super(element, options, $c2a9788f40f9c90a$var$allModules);
    }
}
var $c2a9788f40f9c90a$export$62676a0a2827a643 = $c2a9788f40f9c90a$var$TabulatorFull;
class $c2a9788f40f9c90a$export$8d0cd4d1f07aaaa6 {
    constructor(type){
        this.type = type;
        this.element = this._createElement();
    }
    _createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        return el;
    }
    getElement() {
        return this.element;
    }
    getComponent() {
        return false;
    }
    getData() {
        return {};
    }
    getHeight() {
        return this.element.outerHeight;
    }
    initialize() {}
    reinitialize() {}
    normalizeHeight() {}
    generateCells() {}
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    rendered() {}
}

});

parcelRegister("dMkvN", function(module, exports) {

$parcel$export(module.exports, "createNoise2D", () => $a07fab4af3cbb7ce$export$9de79e9646a874e5);
/*
 * A fast javascript implementation of simplex noise by Jonas Wagner

Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
Better rank ordering method by Stefan Gustavson in 2012.

 Copyright (c) 2024 Jonas Wagner

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */ // these __PURE__ comments help uglifyjs with dead code removal
//
const $a07fab4af3cbb7ce$var$SQRT3 = /*#__PURE__*/ Math.sqrt(3.0);
const $a07fab4af3cbb7ce$var$SQRT5 = /*#__PURE__*/ Math.sqrt(5.0);
const $a07fab4af3cbb7ce$var$F2 = 0.5 * ($a07fab4af3cbb7ce$var$SQRT3 - 1.0);
const $a07fab4af3cbb7ce$var$G2 = (3.0 - $a07fab4af3cbb7ce$var$SQRT3) / 6.0;
const $a07fab4af3cbb7ce$var$F3 = 1.0 / 3.0;
const $a07fab4af3cbb7ce$var$G3 = 1.0 / 6.0;
const $a07fab4af3cbb7ce$var$F4 = ($a07fab4af3cbb7ce$var$SQRT5 - 1.0) / 4.0;
const $a07fab4af3cbb7ce$var$G4 = (5.0 - $a07fab4af3cbb7ce$var$SQRT5) / 20.0;
// I'm really not sure why this | 0 (basically a coercion to int)
// is making this faster but I get ~5 million ops/sec more on the
// benchmarks across the board or a ~10% speedup.
const $a07fab4af3cbb7ce$var$fastFloor = (x)=>Math.floor(x) | 0;
const $a07fab4af3cbb7ce$var$grad2 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]);
// double seems to be faster than single or int's
// probably because most operations are in double precision
const $a07fab4af3cbb7ce$var$grad3 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
// double is a bit quicker here as well
const $a07fab4af3cbb7ce$var$grad4 = /*#__PURE__*/ new Float64Array([
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0
]);
function $a07fab4af3cbb7ce$export$9de79e9646a874e5(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating this yields a little ~3% performance improvement.
    const permGrad2x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad2[v % 12 * 2]);
    const permGrad2y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad2[v % 12 * 2 + 1]);
    return function noise2D(x, y) {
        // if(!isFinite(x) || !isFinite(y)) return 0;
        let n0 = 0; // Noise contributions from the three corners
        let n1 = 0;
        let n2 = 0;
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y) * $a07fab4af3cbb7ce$var$F2; // Hairy factor for 2D
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const t = (i + j) * $a07fab4af3cbb7ce$var$G2;
        const X0 = i - t; // Unskew the cell origin back to (x,y) space
        const Y0 = j - t;
        const x0 = x - X0; // The x,y distances from the cell origin
        const y0 = y - Y0;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G2; // Offsets for middle corner in (x,y) unskewed coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G2;
        const x2 = x0 - 1.0 + 2.0 * $a07fab4af3cbb7ce$var$G2; // Offsets for last corner in (x,y) unskewed coords
        const y2 = y0 - 1.0 + 2.0 * $a07fab4af3cbb7ce$var$G2;
        // Work out the hashed gradient indices of the three simplex corners
        const ii = i & 255;
        const jj = j & 255;
        // Calculate the contribution from the three corners
        let t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 >= 0) {
            const gi0 = ii + perm[jj];
            const g0x = permGrad2x[gi0];
            const g0y = permGrad2y[gi0];
            t0 *= t0;
            // n0 = t0 * t0 * (grad2[gi0] * x0 + grad2[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            n0 = t0 * t0 * (g0x * x0 + g0y * y0);
        }
        let t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 >= 0) {
            const gi1 = ii + i1 + perm[jj + j1];
            const g1x = permGrad2x[gi1];
            const g1y = permGrad2y[gi1];
            t1 *= t1;
            // n1 = t1 * t1 * (grad2[gi1] * x1 + grad2[gi1 + 1] * y1);
            n1 = t1 * t1 * (g1x * x1 + g1y * y1);
        }
        let t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 >= 0) {
            const gi2 = ii + 1 + perm[jj + 1];
            const g2x = permGrad2x[gi2];
            const g2y = permGrad2y[gi2];
            t2 *= t2;
            // n2 = t2 * t2 * (grad2[gi2] * x2 + grad2[gi2 + 1] * y2);
            n2 = t2 * t2 * (g2x * x2 + g2y * y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70.0 * (n0 + n1 + n2);
    };
}
function $a07fab4af3cbb7ce$export$80cd39cae172f7fa(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating these seems to yield a speedup of over 15%
    const permGrad3x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3]);
    const permGrad3y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3 + 1]);
    const permGrad3z = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3 + 2]);
    return function noise3D(x, y, z) {
        let n0, n1, n2, n3; // Noise contributions from the four corners
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y + z) * $a07fab4af3cbb7ce$var$F3; // Very nice and simple skew factor for 3D
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const k = $a07fab4af3cbb7ce$var$fastFloor(z + s);
        const t = (i + j + k) * $a07fab4af3cbb7ce$var$G3;
        const X0 = i - t; // Unskew the cell origin back to (x,y,z) space
        const Y0 = j - t;
        const Z0 = k - t;
        const x0 = x - X0; // The x,y,z distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        let i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
        let i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } // Z X Y order
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } // Y X Z order
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G3; // Offsets for second corner in (x,y,z) coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G3;
        const z1 = z0 - k1 + $a07fab4af3cbb7ce$var$G3;
        const x2 = x0 - i2 + 2.0 * $a07fab4af3cbb7ce$var$G3; // Offsets for third corner in (x,y,z) coords
        const y2 = y0 - j2 + 2.0 * $a07fab4af3cbb7ce$var$G3;
        const z2 = z0 - k2 + 2.0 * $a07fab4af3cbb7ce$var$G3;
        const x3 = x0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3; // Offsets for last corner in (x,y,z) coords
        const y3 = y0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3;
        const z3 = z0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3;
        // Work out the hashed gradient indices of the four simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        // Calculate the contribution from the four corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad3x[gi0] * x0 + permGrad3y[gi0] * y0 + permGrad3z[gi0] * z0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad3x[gi1] * x1 + permGrad3y[gi1] * y1 + permGrad3z[gi1] * z1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad3x[gi2] * x2 + permGrad3y[gi2] * y2 + permGrad3z[gi2] * z2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + 1 + perm[jj + 1 + perm[kk + 1]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad3x[gi3] * x3 + permGrad3y[gi3] * y3 + permGrad3z[gi3] * z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to stay just inside [-1,1]
        return 32.0 * (n0 + n1 + n2 + n3);
    };
}
function $a07fab4af3cbb7ce$export$8ec263ee3d525d98(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating these leads to a ~10% speedup
    const permGrad4x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4]);
    const permGrad4y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 1]);
    const permGrad4z = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 2]);
    const permGrad4w = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 3]);
    return function noise4D(x, y, z, w) {
        let n0, n1, n2, n3, n4; // Noise contributions from the five corners
        // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
        const s = (x + y + z + w) * $a07fab4af3cbb7ce$var$F4; // Factor for 4D skewing
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const k = $a07fab4af3cbb7ce$var$fastFloor(z + s);
        const l = $a07fab4af3cbb7ce$var$fastFloor(w + s);
        const t = (i + j + k + l) * $a07fab4af3cbb7ce$var$G4; // Factor for 4D unskewing
        const X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
        const Y0 = j - t;
        const Z0 = k - t;
        const W0 = l - t;
        const x0 = x - X0; // The x,y,z,w distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        const w0 = w - W0;
        // For the 4D case, the simplex is a 4D shape I won't even try to describe.
        // To find out which of the 24 possible simplices we're in, we need to
        // determine the magnitude ordering of x0, y0, z0 and w0.
        // Six pair-wise comparisons are performed between each possible pair
        // of the four coordinates, and the results are used to rank the numbers.
        let rankx = 0;
        let ranky = 0;
        let rankz = 0;
        let rankw = 0;
        if (x0 > y0) rankx++;
        else ranky++;
        if (x0 > z0) rankx++;
        else rankz++;
        if (x0 > w0) rankx++;
        else rankw++;
        if (y0 > z0) ranky++;
        else rankz++;
        if (y0 > w0) ranky++;
        else rankw++;
        if (z0 > w0) rankz++;
        else rankw++;
        // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
        // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
        // impossible. Only the 24 indices which have non-zero entries make any sense.
        // We use a thresholding to set the coordinates in turn from the largest magnitude.
        // Rank 3 denotes the largest coordinate.
        // Rank 2 denotes the second largest coordinate.
        // Rank 1 denotes the second smallest coordinate.
        // The integer offsets for the second simplex corner
        const i1 = rankx >= 3 ? 1 : 0;
        const j1 = ranky >= 3 ? 1 : 0;
        const k1 = rankz >= 3 ? 1 : 0;
        const l1 = rankw >= 3 ? 1 : 0;
        // The integer offsets for the third simplex corner
        const i2 = rankx >= 2 ? 1 : 0;
        const j2 = ranky >= 2 ? 1 : 0;
        const k2 = rankz >= 2 ? 1 : 0;
        const l2 = rankw >= 2 ? 1 : 0;
        // The integer offsets for the fourth simplex corner
        const i3 = rankx >= 1 ? 1 : 0;
        const j3 = ranky >= 1 ? 1 : 0;
        const k3 = rankz >= 1 ? 1 : 0;
        const l3 = rankw >= 1 ? 1 : 0;
        // The fifth corner has all coordinate offsets = 1, so no need to compute that.
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G4; // Offsets for second corner in (x,y,z,w) coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G4;
        const z1 = z0 - k1 + $a07fab4af3cbb7ce$var$G4;
        const w1 = w0 - l1 + $a07fab4af3cbb7ce$var$G4;
        const x2 = x0 - i2 + 2.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for third corner in (x,y,z,w) coords
        const y2 = y0 - j2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const z2 = z0 - k2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const w2 = w0 - l2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const x3 = x0 - i3 + 3.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for fourth corner in (x,y,z,w) coords
        const y3 = y0 - j3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const z3 = z0 - k3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const w3 = w0 - l3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const x4 = x0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for last corner in (x,y,z,w) coords
        const y4 = y0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        const z4 = z0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        const w4 = w0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        // Work out the hashed gradient indices of the five simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        const ll = l & 255;
        // Calculate the contribution from the five corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk + perm[ll]]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad4x[gi0] * x0 + permGrad4y[gi0] * y0 + permGrad4z[gi0] * z0 + permGrad4w[gi0] * w0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad4x[gi1] * x1 + permGrad4y[gi1] * y1 + permGrad4z[gi1] * z1 + permGrad4w[gi1] * w1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad4x[gi2] * x2 + permGrad4y[gi2] * y2 + permGrad4z[gi2] * z2 + permGrad4w[gi2] * w2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad4x[gi3] * x3 + permGrad4y[gi3] * y3 + permGrad4z[gi3] * z3 + permGrad4w[gi3] * w3);
        }
        let t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
        if (t4 < 0) n4 = 0.0;
        else {
            const gi4 = ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]];
            t4 *= t4;
            n4 = t4 * t4 * (permGrad4x[gi4] * x4 + permGrad4y[gi4] * y4 + permGrad4z[gi4] * z4 + permGrad4w[gi4] * w4);
        }
        // Sum up and scale the result to cover the range [-1,1]
        return 27.0 * (n0 + n1 + n2 + n3 + n4);
    };
}
function $a07fab4af3cbb7ce$export$98cd52c6119fe283(random) {
    const tableSize = 512;
    const p = new Uint8Array(tableSize);
    for(let i = 0; i < tableSize / 2; i++)p[i] = i;
    for(let i = 0; i < tableSize / 2 - 1; i++){
        const r = i + ~~(random() * (256 - i));
        const aux = p[i];
        p[i] = p[r];
        p[r] = aux;
    }
    for(let i = 256; i < tableSize; i++)p[i] = p[i - 256];
    return p;
}

});

parcelRegister("298SR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91251bfc4450491$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");
class $b91251bfc4450491$var$CameraController extends (0, $3MXpL.Actor) {
    onInitialize(engine) {
        const camera = engine.currentScene.camera;
        // set up scroll to zoom
        engine.input.pointers.primary.on("wheel", (evt)=>{
            const zoom = camera.zoom - evt.deltaY / 1000;
            camera.zoom = Math.max(0.5, Math.min(2, zoom));
        });
        // move camera when dragging
        let lastPos = engine.input.pointers.primary.lastScreenPos.clone();
        let dragging = false;
        engine.input.pointers.primary.on("down", (evt)=>{
            dragging = true;
            lastPos = evt.screenPos.clone();
        });
        engine.input.pointers.primary.on("up", ()=>{
            dragging = false;
        });
        engine.input.pointers.primary.on("move", (evt)=>{
            if (dragging) {
                const delta = evt.screenPos.sub(lastPos);
                camera.pos = camera.pos.sub(delta);
                lastPos = evt.screenPos.clone();
            }
        });
        engine.input.keyboard.on("hold", (evt)=>{
            if (evt.key == (0, $3MXpL.Keys).KeyW || evt.key == (0, $3MXpL.Keys).ArrowUp) camera.pos.y -= 2;
            if (evt.key == (0, $3MXpL.Keys).KeyS || evt.key == (0, $3MXpL.Keys).ArrowDown) camera.pos.y += 2;
            if (evt.key == (0, $3MXpL.Keys).KeyA || evt.key == (0, $3MXpL.Keys).ArrowLeft) camera.pos.x -= 2;
            if (evt.key == (0, $3MXpL.Keys).KeyD || evt.key == (0, $3MXpL.Keys).ArrowRight) camera.pos.x += 2;
        });
    }
}
var $b91251bfc4450491$export$2e2bcd8739ae039 = $b91251bfc4450491$var$CameraController;

});

parcelRegister("1U10Z", function(module, exports) {

$parcel$export(module.exports, "spawner", () => $b14241511ea41ba4$export$ba03c13d43bbb32f);
$parcel$export(module.exports, "compute_iso_collider", () => $b14241511ea41ba4$export$2f3c915e200bc8b9);
$parcel$export(module.exports, "mark_tiles_as_solid", () => $b14241511ea41ba4$export$242472cfcae3b75);
$parcel$export(module.exports, "mark_tile_solid_single", () => $b14241511ea41ba4$export$9b457a9eafb9d1b);
$parcel$export(module.exports, "init_navgrid", () => $b14241511ea41ba4$export$8e464a75b08ca8ab);
$parcel$export(module.exports, "closest_entity", () => $b14241511ea41ba4$export$4485b736ca38975e);

var $3MXpL = parcelRequire("3MXpL");

var $64gHy = parcelRequire("64gHy");

var $cT3l2 = parcelRequire("cT3l2");
function $b14241511ea41ba4$export$ba03c13d43bbb32f(edge_threshold, number, isoMap, tileTagFilter) {
    // pick N random points on the map
    const points = new Set();
    const tileTagsArray = Array.isArray(tileTagFilter) ? tileTagFilter : [
        tileTagFilter
    ];
    // get all tiles with one of the tags
    const tiles = isoMap.tiles.filter((tile)=>{
        if (!tileTagsArray) return true;
        return tileTagsArray.some((tag)=>tile.tags.has(tag));
    });
    // filter out tiles that are solid
    let filteredTiles = tiles.filter((tile)=>!tile.solid);
    // filter out tiles that are too close to the edge
    filteredTiles = filteredTiles.filter((tile)=>tile.x > edge_threshold && tile.x < isoMap.columns - edge_threshold && tile.y > edge_threshold && tile.y < isoMap.rows - edge_threshold);
    if (filteredTiles.length === 0) {
        console.warn(`No valid tiles found for tag ${tileTagFilter}`);
        return [];
    }
    // pick "number" random tiles
    for(let i = 0; i < number; i++){
        const start = filteredTiles[Math.floor(Math.random() * filteredTiles.length)].pos;
        points.add(start);
    }
    return points;
}
function $b14241511ea41ba4$export$2f3c915e200bc8b9(img) {
    const offset = (0, $3MXpL.vec)(img.width / 2, img.height / 3);
    const heightScale = img.height / 4;
    const collider = (0, $3MXpL.Shape).Polygon([
        (0, $3MXpL.vec)(0, img.height / 2).sub(offset),
        (0, $3MXpL.vec)(img.width / 2, -heightScale + img.height / 2).sub(offset),
        (0, $3MXpL.vec)(img.width, img.height / 2).sub(offset),
        (0, $3MXpL.vec)(img.width / 2, heightScale + img.height / 2).sub(offset)
    ]);
    return collider;
}
function $b14241511ea41ba4$export$242472cfcae3b75(isoMap) {
    // get all colliders
    const colliders = (0, $64gHy.game).currentScene.actors.filter((actor)=>actor.collider);
    // get all tiles
    const tiles = isoMap.tiles;
    // for each tile, check if it intersects with any collider
    for (let tile of tiles){
        if (tile.hasTag("building")) tile.removeTag("building");
        // water is also -1
        if (tile.tags.has("water")) {
            (0, $64gHy.game).currentScene.navgrid[tile.y][tile.x] = -1;
            tile.solid = true;
            continue;
        }
        let isSolid = false;
        for (let collider of colliders){
            // get world position of tile
            const worldPos = tile.center;
            // check if the collider intersects with the tile
            if (collider.collider.get()?.contains(worldPos)) {
                isSolid = true;
                if (collider.tags.has("tree")) tile.addGraphic((0, $cT3l2.Tiles).Forest.toSprite());
                else if (collider.tags.has("rock")) tile.addGraphic((0, $cT3l2.Tiles).Sand.toSprite());
            }
        }
        if (isSolid) {
            tile.solid = true;
            (0, $64gHy.game).currentScene.navgrid[tile.y][tile.x] = -1;
        //tile.addGraphic(Tiles.Forest.toSprite());
        } else {
            tile.solid = false;
            (0, $64gHy.game).currentScene.navgrid[tile.y][tile.x] = 0;
        //tile.addGraphic(Tiles.Green.toSprite());
        }
    }
}
function $b14241511ea41ba4$export$9b457a9eafb9d1b(isoMap, actor, walkability) {
    // get all tiles
    const tiles = isoMap.tiles;
    // search in a radius around the actor
    const isoCoords = isoMap.worldToTile(actor.pos);
    const radius = 10;
    const tilesToMark = [];
    for(let x = -radius; x <= radius; x++)for(let y = -radius; y <= radius; y++){
        const tile = isoMap.getTile(isoCoords.x + x, isoCoords.y + y);
        if (!tile) continue;
        // check if the collider intersects with the tile
        if (actor.collider.get()?.contains(tile.pos)) tilesToMark.push(tile);
    }
    // if any of the tiles to mark are solid, return false
    for (let tile of tilesToMark){
        const bridgeCase = tile.tags.has("water") && actor.tags.has("bridge");
        // print tile tags
        if (tile.solid && !bridgeCase || tile.tags.has("building")) {
            console.log(`Can't place building because of the following state: ${tile.solid}, ${tile.tags.has("building")}, ${tile.tags.has("water")}`);
            return false;
        }
    }
    for (let tile of tilesToMark){
        tile.solid = walkability === -1;
        tile.addTag("building");
        // update navgrid
        (0, $64gHy.game).currentScene.navgrid[tile.y][tile.x] = walkability;
    //tile.addGraphic(Tiles.Red.toSprite());
    }
    return true;
}
function $b14241511ea41ba4$export$8e464a75b08ca8ab(isoMap) {
    const matrix = new Array(isoMap.columns).fill(0).map(()=>new Array(isoMap.rows).fill(0));
    return matrix;
}
function $b14241511ea41ba4$export$4485b736ca38975e(reference_entity, entities) {
    let closest_entity = null;
    let closest_distance = Number.MAX_VALUE;
    const reference_pos = reference_entity.get((0, $3MXpL.TransformComponent))?.pos;
    for (let entity of entities){
        const pos = entity.get((0, $3MXpL.TransformComponent))?.pos;
        if (!pos) continue;
        const distance = pos.distance(reference_pos);
        if (distance < closest_distance) {
            closest_distance = distance;
            closest_entity = entity;
        }
    }
    return closest_entity;
}

});

parcelRegister("e3Jww", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd258c3bec41346$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $64gHy = parcelRequire("64gHy");
class $5dd258c3bec41346$var$IdleSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        this.info_table = null;
        // Lower numbers mean higher priority
        this.priority = 150;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $8bz7c.VisionComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.query.entities){
            const character = entity;
            const characterComponent = character.get((0, $8bz7c.CharacterComponent));
            // make sure our state is IDLE
            if (characterComponent.state !== (0, $8bz7c.CharacterState).IDLE) continue;
            const isoMap = (0, $64gHy.game).currentScene.isoMap;
            // pick a random tile
            const randomTile = isoMap.getTile(Math.floor(Math.random() * isoMap.columns), Math.floor(Math.random() * isoMap.rows));
            // walk to the random tile
            character.walkTo(randomTile.pos);
        }
    }
}
var $5dd258c3bec41346$export$2e2bcd8739ae039 = $5dd258c3bec41346$var$IdleSystem;

});
parcelRegister("8bz7c", function(module, exports) {

$parcel$export(module.exports, "LivingComponent", () => $1ca1bd3e3bad7acd$export$c3719a460adc13b3);
$parcel$export(module.exports, "BrainComponent", () => $1ca1bd3e3bad7acd$export$f90188faf6ec7e99);
$parcel$export(module.exports, "CharacterState", () => $1ca1bd3e3bad7acd$export$f2e6b371e93925c7);
$parcel$export(module.exports, "CharacterRole", () => $1ca1bd3e3bad7acd$export$b12e6aaafc1e5875);
$parcel$export(module.exports, "CharacterComponent", () => $1ca1bd3e3bad7acd$export$38d7c7744bfc5ba7);
$parcel$export(module.exports, "VisionComponent", () => $1ca1bd3e3bad7acd$export$f8687f43426f042b);
$parcel$export(module.exports, "NeighborsComponent", () => $1ca1bd3e3bad7acd$export$6445b37460e11fdf);

var $3MXpL = parcelRequire("3MXpL");

var $5bnzG = parcelRequire("5bnzG");
class $1ca1bd3e3bad7acd$export$c3719a460adc13b3 extends (0, $3MXpL.Component) {
    isDead() {
        return this.health <= 0;
    }
    isHungry() {
        return this.food <= 50;
    }
    isStarving() {
        return this.food <= 0;
    }
    eat(amount) {
        if (this.food + amount > 100) this.food = 100;
        else this.food += amount;
    }
    starve(amount) {
        this.food -= amount;
        if (this.food < 0) this.food = 0;
    }
    takeDamage(damage) {
        this.health -= damage;
        if (this.health < 0) this.health = 0;
    }
    heal(amount) {
        this.health += amount;
        if (this.health > this.maxHealth) this.health = this.maxHealth;
    }
    onAdd() {}
    constructor(...args){
        super(...args);
        this.health = 100;
        this.maxHealth = 100;
        this.food = 100;
    }
}
class $1ca1bd3e3bad7acd$export$f90188faf6ec7e99 extends (0, $3MXpL.Component) {
    onAdd() {}
    think(thought) {
        this.thoughts.push(thought);
    }
    constructor(...args){
        super(...args);
        this.thoughts = [];
    }
}
var $1ca1bd3e3bad7acd$export$f2e6b371e93925c7;
(function(CharacterState) {
    CharacterState["WALKING"] = "walking";
    CharacterState["IDLE"] = "idle";
    CharacterState["HARVESTING"] = "harvesting";
    CharacterState["DEPOSITING"] = "depositing";
    CharacterState["DEAD"] = "dead";
    CharacterState["EATING"] = "eating";
})($1ca1bd3e3bad7acd$export$f2e6b371e93925c7 || ($1ca1bd3e3bad7acd$export$f2e6b371e93925c7 = {}));
var $1ca1bd3e3bad7acd$export$b12e6aaafc1e5875;
(function(CharacterRole) {
    CharacterRole["MINER"] = "miner";
    CharacterRole["FARMER"] = "farmer";
    CharacterRole["WOODCUTTER"] = "woodcutter";
})($1ca1bd3e3bad7acd$export$b12e6aaafc1e5875 || ($1ca1bd3e3bad7acd$export$b12e6aaafc1e5875 = {}));
class $1ca1bd3e3bad7acd$export$38d7c7744bfc5ba7 extends (0, $3MXpL.Component) {
    onAdd() {
        const all_names = [
            ...(0, $5bnzG.male_names),
            ...(0, $5bnzG.female_names)
        ];
        const random_name = all_names[Math.floor(Math.random() * all_names.length)];
        this.first_name = random_name;
        console.log(`Hello, my name is ${this.first_name}`);
    }
    constructor(...args){
        super(...args);
        this.role = "miner";
        this.state = "idle";
    }
}
class $1ca1bd3e3bad7acd$export$f8687f43426f042b extends (0, $3MXpL.Component) {
    // Gets all visible entities that have the given component
    getWithComponent(component) {
        return Array.from(this.visibleEntities).filter((e)=>e.has(component));
    }
    constructor(...args){
        super(...args);
        this.range = 200;
        this.visibleEntities = new Set();
    }
}
class $1ca1bd3e3bad7acd$export$6445b37460e11fdf extends (0, $3MXpL.Component) {
    // Gets all visible entities that have the given component
    getWithComponent(component) {
        return Array.from(this.neighbors).filter((e)=>e.has(component));
    }
    constructor(...args){
        super(...args);
        this.range = 50;
        this.neighbors = new Set();
    }
}

});
parcelRegister("5bnzG", function(module, exports) {

$parcel$export(module.exports, "male_names", () => $593d0eab0b06dc22$export$5ca8fdf5f8e4d45e);
$parcel$export(module.exports, "female_names", () => $593d0eab0b06dc22$export$589d4f58d745675f);
const $593d0eab0b06dc22$export$5ca8fdf5f8e4d45e = [
    "Alaric",
    "Aldous",
    "Archibald",
    "Arne",
    "Arthur",
    "Bahram",
    "Bard",
    "Bartholomew",
    "Benedict",
    "Bertram",
    "Bj\xf6rn",
    "Burchard",
    "Cassian",
    "Cathasarch",
    "Charibert",
    "Conrad",
    "Crispin",
    "Cyprian",
    "Daegal",
    "Drogo",
    "Drustan",
    "Dustin",
    "Elric",
    "Emil",
    "Finnian",
    "Florian",
    "Galileo",
    "Gandalf",
    "Gerold",
    "Godfrey",
    "Godwin",
    "Gomes",
    "Gregory",
    "Grimwald",
    "Hamlin",
    "Hawk",
    "Hildebald",
    "Jeremiah",
    "Kazamir",
    "Kenric",
    "Lancaster",
    "Leif",
    "Leoric",
    "Lothar",
    "Lunden",
    "Maurin",
    "Morcant",
    "Neville",
    "Njal",
    "Odel",
    "Orvyn",
    "Osric",
    "Pascal",
    "Piers",
    "Randolf",
    "Ricard",
    "Svend",
    "Theodoric",
    "Torsten",
    "Wilkin",
    "Wolf",
    "Wymond",
    "Zemislav"
];
const $593d0eab0b06dc22$export$589d4f58d745675f = [
    "Adelaide",
    "Ameila",
    "Anastasia",
    "Anika",
    "Annora",
    "Avice",
    "Berenice",
    "Bodil",
    "Bogdana",
    "Brenna",
    "Brunhilda",
    "Clotilda",
    "Desislava",
    "Edme",
    "Ella",
    "Erika",
    "Genevieve",
    "Georgia",
    "Gunnora",
    "Hawise",
    "Helena",
    "Hildegund",
    "Luthera",
    "Martine",
    "Mathilda",
    "Maude",
    "Mirabel",
    "Odelgarde",
    "Olive",
    "Petra",
    "Regina",
    "Winifred",
    "Zelda"
];

});



parcelRegister("bkNL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a128bb90fbe5216$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $aO4pr = parcelRequire("aO4pr");
class $8a128bb90fbe5216$var$VisionSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 80;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.visionQuery = world.query([
            (0, $8bz7c.VisionComponent)
        ]);
        this.visibleQuery = world.query([
            (0, $3MXpL.TransformComponent),
            (0, $aO4pr.VisibleComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.visionQuery.entities)for (let visibleEntity of this.visibleQuery.entities){
            const vision = entity.get((0, $8bz7c.VisionComponent));
            const visibleEntityTransform = visibleEntity.get((0, $3MXpL.TransformComponent));
            const visibleComponent = visibleEntity.get((0, $aO4pr.VisibleComponent));
            if (!visibleEntityTransform || !visibleComponent) continue;
            const distance = entity.get((0, $3MXpL.TransformComponent))?.pos.distance(visibleEntityTransform.pos);
            if (distance && distance < vision.range) vision.visibleEntities.add(visibleEntity);
            else vision.visibleEntities.delete(visibleEntity);
        }
    }
}
var $8a128bb90fbe5216$export$2e2bcd8739ae039 = $8a128bb90fbe5216$var$VisionSystem;

});
parcelRegister("aO4pr", function(module, exports) {

$parcel$export(module.exports, "VisibleComponent", () => $a9e1caf589690b0f$export$c6f299b852fbc595);

var $3MXpL = parcelRequire("3MXpL");
class $a9e1caf589690b0f$export$c6f299b852fbc595 extends (0, $3MXpL.Component) {
}

});


parcelRegister("hNuoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2ca92848295f62$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $8Nzak = parcelRequire("8Nzak");

var $1U10Z = parcelRequire("1U10Z");

var $8FWE7 = parcelRequire("8FWE7");
class $fe2ca92848295f62$var$HarvestSystem extends (0, $3MXpL.System) {
    static{
        this.harvestRate = 1;
    }
    constructor(world){
        super();
        this.info_table = null;
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 90;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $8bz7c.NeighborsComponent),
            (0, $8bz7c.VisionComponent)
        ]);
        this.harvestRateQuery = world.query([
            (0, $8FWE7.HarvestRateIncreaseComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.query.entities){
            const character = entity;
            const characterComponent = character.get((0, $8bz7c.CharacterComponent));
            const neighborsComponent = character.get((0, $8bz7c.NeighborsComponent));
            const visionComponent = character.get((0, $8bz7c.VisionComponent));
            const characterRole = character.get((0, $8bz7c.CharacterComponent)).role;
            if (![
                (0, $8bz7c.CharacterRole).FARMER,
                (0, $8bz7c.CharacterRole).MINER,
                (0, $8bz7c.CharacterRole).WOODCUTTER
            ].includes(characterRole)) continue;
            // make sure our state is IDLE
            if (characterComponent.state !== (0, $8bz7c.CharacterState).IDLE) continue;
            // make sure we have inventory space
            if (!character.get((0, $jXu4v.InventoryComponent)).hasCapacity()) continue;
            // check to see if we can see a harvestable resource
            const visisbleHarvestables = visionComponent.getWithComponent((0, $8Nzak.HarvestableResourceComponent)).filter((harvestable)=>{
                const harvestableComponent = harvestable.get((0, $8Nzak.HarvestableResourceComponent));
                return harvestableComponent.harvestableBy.includes(characterRole);
            });
            // return if we can't see any harvestable resources
            if (visisbleHarvestables.length === 0) continue;
            // check if any of these are in the neighbors
            const neighbors = Array.from(neighborsComponent.neighbors);
            const harvestables = visisbleHarvestables.filter((harvestable)=>neighbors.includes(harvestable));
            // if we don't have any harvestables in our neighbors, walk to the closest one
            if (harvestables.length === 0 && visisbleHarvestables.length > 0) {
                // if we can see a harvestable, get the closest one
                const closestVisibleHarvestable = (0, $1U10Z.closest_entity)(character, visisbleHarvestables);
                // walk to the closest harvestable
                if (closestVisibleHarvestable) character.walkTo(closestVisibleHarvestable.get((0, $3MXpL.TransformComponent)).pos);
            }
            const closestHarvestable = (0, $1U10Z.closest_entity)(character, harvestables);
            // if we found a harvestable, set our state to HARVESTING
            if (closestHarvestable) {
                characterComponent.state = (0, $8bz7c.CharacterState).HARVESTING;
                // add up the harvest rate increase
                const harvestRateIncrease = 100 * this.harvestRateQuery.entities.length;
                const baseDelay = 3000 * $fe2ca92848295f62$var$HarvestSystem.harvestRate;
                let harvestDelay = baseDelay - harvestRateIncrease;
                // set a minimum delay of 100ms
                if (harvestDelay < 100) harvestDelay = 100;
                // after the delay, harvest the resource
                character.actions.delay(harvestDelay).callMethod(()=>{
                    const inventory = character.get((0, $jXu4v.InventoryComponent));
                    const harvestable = closestHarvestable;
                    const harvestableComponent = harvestable.get((0, $8Nzak.HarvestableResourceComponent));
                    inventory.addItem(harvestableComponent.resourceType);
                    characterComponent.state = (0, $8bz7c.CharacterState).IDLE;
                });
            }
        }
    }
}
var $fe2ca92848295f62$export$2e2bcd8739ae039 = $fe2ca92848295f62$var$HarvestSystem;

});
parcelRegister("8Nzak", function(module, exports) {

$parcel$export(module.exports, "HarvestableResourceComponent", () => $bb5bb54787fc88df$export$b8359b2c357d0581);

var $3MXpL = parcelRequire("3MXpL");
class $bb5bb54787fc88df$export$b8359b2c357d0581 extends (0, $3MXpL.Component) {
    onInitialize() {}
    harvest(amount) {
        this.amount -= amount;
        if (this.amount < 0) this.amount = 0;
    }
    isEmpty() {
        return this.amount <= 0;
    }
    constructor(...args){
        super(...args);
        this.harvestableBy = [];
    }
}

});

parcelRegister("8FWE7", function(module, exports) {

$parcel$export(module.exports, "HarvestRateIncreaseComponent", () => $6628f691078eea73$export$3fcda8ce15abe55a);

var $3MXpL = parcelRequire("3MXpL");
class $6628f691078eea73$export$3fcda8ce15abe55a extends (0, $3MXpL.Component) {
}

});


parcelRegister("aOdfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $063302e9c6977316$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $eikyf = parcelRequire("eikyf");

var $1U10Z = parcelRequire("1U10Z");
class $063302e9c6977316$var$DepotSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        this.info_table = null;
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 90;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $8bz7c.NeighborsComponent)
        ]);
        this.buildingQuery = world.query([
            (0, $3MXpL.TransformComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $eikyf.BuildingComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.query.entities){
            const character = entity;
            const characterComponent = character.get((0, $8bz7c.CharacterComponent));
            const neighborsComponent = character.get((0, $8bz7c.NeighborsComponent));
            const inventoryComponent = character.get((0, $jXu4v.InventoryComponent));
            // make sure we're not already walking
            if (characterComponent.state !== (0, $8bz7c.CharacterState).IDLE) continue;
            // check if character has items to deposit
            if (inventoryComponent.getNumItems() === 0) continue;
            // get buildings that have capacity in the buildingQuery
            const buildingsWithCapacity = this.buildingQuery.entities.filter((building)=>{
                const buildingInventory = building.get((0, $jXu4v.InventoryComponent));
                return buildingInventory.hasCapacity();
            });
            // if any of these are in the neighbors, deposit resources
            const neighbors = Array.from(neighborsComponent.neighbors);
            const buildingsInNeighbors = buildingsWithCapacity.filter((building)=>neighbors.includes(building));
            if (buildingsInNeighbors.length > 0) {
                const building = buildingsInNeighbors[0];
                const inventory = character.get((0, $jXu4v.InventoryComponent));
                const buildingInventory = building.get((0, $jXu4v.InventoryComponent));
                characterComponent.state = (0, $8bz7c.CharacterState).DEPOSITING;
                // deposit resources
                character.actions.delay(1000).callMethod(()=>{
                    const item = inventory.removeItem();
                    if (!item) {
                        characterComponent.state = (0, $8bz7c.CharacterState).IDLE;
                        return;
                    }
                    buildingInventory.addItem(item);
                    console.log("Deposited", item);
                    characterComponent.state = (0, $8bz7c.CharacterState).IDLE;
                });
            } else {
                // if there are no buildings with capacity, we can't deposit resources
                if (buildingsWithCapacity.length === 0) continue;
                // move to the closest building with capacity
                const closestBuilding = (0, $1U10Z.closest_entity)(character, buildingsWithCapacity);
                if (!closestBuilding) continue;
                character.walkTo(closestBuilding.get((0, $3MXpL.TransformComponent)).pos);
            }
        }
    }
}
var $063302e9c6977316$export$2e2bcd8739ae039 = $063302e9c6977316$var$DepotSystem;

});
parcelRegister("eikyf", function(module, exports) {

$parcel$export(module.exports, "BuildingComponent", () => $4688bb0ac0cce836$export$6dedb722a10c81c0);

var $3MXpL = parcelRequire("3MXpL");
class $4688bb0ac0cce836$export$6dedb722a10c81c0 extends (0, $3MXpL.Component) {
}

});


parcelRegister("gQ5iS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced609d8383254f5$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");
class $ced609d8383254f5$var$NeighborSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 80;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.neighborsQuery = world.query([
            (0, $8bz7c.NeighborsComponent)
        ]);
        this.neighboringQuery = world.query([
            (0, $3MXpL.TransformComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.neighborsQuery.entities)for (let neighbor of this.neighboringQuery.entities){
            const neighborsComponent = entity.get((0, $8bz7c.NeighborsComponent));
            const transform = neighbor.get((0, $3MXpL.TransformComponent));
            if (!transform) continue;
            const distance = entity.get((0, $3MXpL.TransformComponent))?.pos.distance(transform.pos);
            if (distance && distance < neighborsComponent.range) neighborsComponent.neighbors.add(neighbor);
            else neighborsComponent.neighbors.delete(neighbor);
        }
    }
}
var $ced609d8383254f5$export$2e2bcd8739ae039 = $ced609d8383254f5$var$NeighborSystem;

});

parcelRegister("ciCQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b628087e311e7d6$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $h4y3h = parcelRequire("h4y3h");
class $5b628087e311e7d6$var$UIUpdateSystem {
    constructor(world){
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 200;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.obituary_table_html = "";
        this.world = world;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $8bz7c.VisionComponent),
            (0, $8bz7c.LivingComponent)
        ]);
    }
    static{
        this.table_built = false;
    }
    update(delta) {
        // update the storage display
        document.getElementById("storage").innerText = Array.from((0, $h4y3h.Storage).storage.entries()).map(([key, value])=>`${key}: ${value}`).join(", ");
        if (this.query.entities.length === 0) {
            console.log("No characters found in UIUpdateSystem");
            return;
        }
        // update tabulator table data in main scene
        const scene = this.query.entities[0].scene;
        // for each element in the building definitions, check if the player can afford it
        // if they can, update the UI to show that the building is available
        // if they can't, update the UI to show that the building is unavailable
        for (let item of scene.buildingDefinitions){
            const canAfford = (0, $h4y3h.Storage).canAfford(item.definition.cost);
            item.element.classList.toggle("unavailable", !canAfford);
        }
        const obituaryData = scene.deaths.map((death)=>{
            return `
            <tr>
                <td>${death.name}</td>
                <td>${death.cause}</td>
            </tr>
            `;
        });
        if (scene.deaths.length > 0) {
            const obituaryTable = document.getElementById("obituary");
            this.obituary_table_html = `
            <tr>
                <th>Name</th>
                <th>Cause</th>
            </tr>
            ${obituaryData.join("")}
        `;
            if (this.obituary_table_html !== obituaryTable.innerHTML) obituaryTable.innerHTML = this.obituary_table_html;
        }
        if (!$5b628087e311e7d6$var$UIUpdateSystem.table_built) {
            console.warn("Building table");
            return;
        }
        if (!scene.status_table) {
            console.log("No status_table found in UIUpdateSystem");
            return;
        }
        let newData = this.query.entities.map((entity, idx)=>{
            const character = entity;
            const characterComponent = character.get((0, $8bz7c.CharacterComponent));
            const inventoryComponent = character.get((0, $jXu4v.InventoryComponent));
            const visionComponent = character.get((0, $8bz7c.VisionComponent));
            const livingComponent = character.get((0, $8bz7c.LivingComponent));
            const invString = Array.from(inventoryComponent.items.keys()).filter((key)=>inventoryComponent.items.get(key) > 0).map((key)=>key.repeat(inventoryComponent.items.get(key) ?? 0)).join("");
            return {
                id: character.id,
                name: characterComponent.first_name,
                state: characterComponent.state,
                role: characterComponent.role,
                health: livingComponent.health,
                food: livingComponent.food,
                inventory: invString,
                vision: visionComponent.visibleEntities.size
            };
        });
        // if the table matches the data, don't update it
        if (scene.status_table.getData() === newData) {
            console.warn("Data matches, not updating table");
            return;
        }
        // if we can't find the entity ID in the table, add it
        for (let data of newData)// if the state is dead, remove the character from the table
        if (data.state === (0, $8bz7c.CharacterState).DEAD) scene.status_table.deleteRow(data.id);
        else scene.status_table.updateOrAddRow(data.id, data);
    }
}
var $5b628087e311e7d6$export$2e2bcd8739ae039 = $5b628087e311e7d6$var$UIUpdateSystem;

});

parcelRegister("ci50R", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eba4abdbd602dfc$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $hNuoF = parcelRequire("hNuoF");

var $jo53f = parcelRequire("jo53f");

var $cT3l2 = parcelRequire("cT3l2");

var $1U10Z = parcelRequire("1U10Z");
const $9eba4abdbd602dfc$var$random = new (0, $3MXpL.Random)();
const $9eba4abdbd602dfc$var$lightningSpriteSheet = (0, $3MXpL.SpriteSheet).fromImageSource({
    image: (0, $cT3l2.Effects).Lightning,
    grid: {
        rows: 2,
        columns: 3,
        spriteWidth: 128,
        spriteHeight: 128
    }
});
// display lightning animation
const $9eba4abdbd602dfc$var$lightningAnim = (0, $3MXpL.Animation).fromSpriteSheet($9eba4abdbd602dfc$var$lightningSpriteSheet, (0, $3MXpL.range)(0, 5), 100);
class $9eba4abdbd602dfc$var$DisasterSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent)
        ]);
        this.world = world;
        this.buildingQuery = world.queryTags([
            "buildingObject"
        ]);
        // start the timer that starts a disaster every minute
        const timer = new (0, $3MXpL.Timer)({
            fcn: ()=>this.startDisaster(),
            repeats: true,
            interval: 45000
        });
        world.scene.add(timer);
        timer.start();
    }
    update(delta) {}
    startDisaster() {
        switch($9eba4abdbd602dfc$var$random.d4()){
            // destroy a random building
            case 1:
                {
                    (0, $jo53f.default).showText("The creations of man shall fall by my hand!");
                    // filter out bridges
                    const buildings = this.buildingQuery.entities.filter((b)=>!b.hasTag("bridge"));
                    console.log(buildings);
                    if (buildings.length != 0) {
                        const building = buildings[$9eba4abdbd602dfc$var$random.integer(0, buildings.length - 1)];
                        const lightning = new (0, $3MXpL.Actor)({
                            pos: building.pos.add((0, $3MXpL.vec)(0, -20))
                        });
                        lightning.graphics.use($9eba4abdbd602dfc$var$lightningAnim);
                        this.world.scene.add(lightning);
                        lightning.z = 2000;
                        const isoMap = building.isoMap;
                        building.die();
                        lightning.actions.delay(1000).callMethod(()=>{
                            (0, $1U10Z.mark_tiles_as_solid)(isoMap);
                        }).die();
                    }
                    break;
                }
            // kill a random human
            case 2:
                {
                    (0, $jo53f.default).showText("My wrath smites your workers!");
                    const humans = this.query.entities;
                    if (humans.length != 0) {
                        const char = humans[$9eba4abdbd602dfc$var$random.integer(0, humans.length - 1)];
                        const lightning = new (0, $3MXpL.Actor)({
                            pos: char.pos.add((0, $3MXpL.vec)(0, -20))
                        });
                        lightning.graphics.use($9eba4abdbd602dfc$var$lightningAnim);
                        this.world.scene.add(lightning);
                        lightning.actions.delay(1000).die();
                        lightning.z = 2000;
                        char.die("lightning");
                    }
                    break;
                }
            // make humans take longer to gather things for 1 minute
            case 3:
                {
                    (0, $jo53f.default).showText("Your people grow tired from the slothful plague.");
                    (0, $hNuoF.default).harvestRate = 2;
                    const timer = new (0, $3MXpL.Timer)({
                        fcn: ()=>(0, $hNuoF.default).harvestRate = 0.75,
                        repeats: false,
                        interval: 30000
                    });
                    this.world.scene.add(timer);
                    timer.start();
                    break;
                }
            // make humans get hungry faster for 1 minute
            case 4:
                {
                    (0, $jo53f.default).showText("My famine descends upon your devotees. Have they prepared for this?");
                    for (let entity of this.query.entities){
                        const character = entity;
                        character.hungerRate = 2.5;
                    }
                    const timer = new (0, $3MXpL.Timer)({
                        fcn: ()=>{
                            for (let entity of this.query.entities){
                                const character = entity;
                                character.hungerRate = 1;
                            }
                        },
                        repeats: false,
                        interval: 30000
                    });
                    this.world.scene.add(timer);
                    timer.start();
                    break;
                }
        }
    }
}
var $9eba4abdbd602dfc$export$2e2bcd8739ae039 = $9eba4abdbd602dfc$var$DisasterSystem;

});
parcelRegister("jo53f", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ce596263c65c65$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");
class $b7ce596263c65c65$var$DialogueSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        this.systemType = (0, $3MXpL.SystemType).Update;
        $b7ce596263c65c65$var$DialogueSystem.world = world;
        $b7ce596263c65c65$var$DialogueSystem.showText("Welcome to my realm... Can your followers hope to survive here? I'll make sure they cannot.");
    }
    update(delta) {}
    static showText(message) {
        document.getElementById("dialogue").innerText = message;
        document.getElementById("dialogue-box").classList.remove("hidden-fade");
        const timer = new (0, $3MXpL.Timer)({
            fcn: ()=>document.getElementById("dialogue-box").classList.add("hidden-fade"),
            repeats: false,
            interval: 5000
        });
        $b7ce596263c65c65$var$DialogueSystem.world.scene.add(timer);
        timer.start();
    }
}
var $b7ce596263c65c65$export$2e2bcd8739ae039 = $b7ce596263c65c65$var$DialogueSystem;

});


parcelRegister("8DYOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a204e06d4c4ee904$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8bz7c = parcelRequire("8bz7c");

var $jXu4v = parcelRequire("jXu4v");

var $eikyf = parcelRequire("eikyf");

var $1U10Z = parcelRequire("1U10Z");
class $a204e06d4c4ee904$var$EatSystem extends (0, $3MXpL.System) {
    constructor(world){
        super();
        this.info_table = null;
        // Lower numbers mean higher priority
        // 99 is low priority
        this.priority = 40;
        // Run this system in the "update" phase
        this.systemType = (0, $3MXpL.SystemType).Update;
        this.query = world.query([
            (0, $8bz7c.CharacterComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $8bz7c.NeighborsComponent),
            (0, $8bz7c.LivingComponent)
        ]);
        this.buildingQuery = world.query([
            (0, $3MXpL.TransformComponent),
            (0, $jXu4v.InventoryComponent),
            (0, $eikyf.BuildingComponent)
        ]);
    }
    update(delta) {
        for (let entity of this.query.entities){
            const character = entity;
            const characterComponent = character.get((0, $8bz7c.CharacterComponent));
            const neighborsComponent = character.get((0, $8bz7c.NeighborsComponent));
            const livingComponent = character.get((0, $8bz7c.LivingComponent));
            // make sure we're actually hungry
            if (!livingComponent.isHungry()) continue;
            // make sure our state isn't WALKING
            if (characterComponent.state !== (0, $8bz7c.CharacterState).IDLE) continue;
            // if we have food in our inventory, eat it
            const inventoryComponent = character.get((0, $jXu4v.InventoryComponent));
            if (inventoryComponent.items.has("\uD83C\uDF3F")) {
                characterComponent.state = (0, $8bz7c.CharacterState).EATING;
                // after 1 second, eat the food
                character.actions.delay(1000).callMethod(()=>{
                    const item = inventoryComponent.removeItem("\uD83C\uDF3F");
                    if (item) livingComponent.eat(100);
                    characterComponent.state = (0, $8bz7c.CharacterState).IDLE;
                });
                continue;
            }
            // get buildings that have food
            const buildingsWithCapacity = this.buildingQuery.entities.filter((building)=>{
                const buildingInventory = building.get((0, $jXu4v.InventoryComponent));
                return buildingInventory.items.has("\uD83C\uDF3F");
            });
            // get the closest building
            const closestBuilding = (0, $1U10Z.closest_entity)(entity, buildingsWithCapacity);
            // if we have a building, walk to it
            if (closestBuilding) {
                // see if it's in our neighbors
                const isNeighbor = neighborsComponent.neighbors.has(closestBuilding);
                if (isNeighbor) {
                    // if we're next to the building, eat
                    characterComponent.state = (0, $8bz7c.CharacterState).EATING;
                    // after 1 second, eat the food
                    character.actions.delay(1000).callMethod(()=>{
                        const item = closestBuilding.get((0, $jXu4v.InventoryComponent)).removeItem("\uD83C\uDF3F");
                        if (item) livingComponent.eat(100);
                        characterComponent.state = (0, $8bz7c.CharacterState).IDLE;
                    });
                } else character.walkTo(closestBuilding.get((0, $3MXpL.TransformComponent)).pos);
            }
        }
    }
}
var $a204e06d4c4ee904$export$2e2bcd8739ae039 = $a204e06d4c4ee904$var$EatSystem;

});


parcelRegister("fARY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a41df6949ebd7b8$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $9qOxG = parcelRequire("9qOxG");
class $0a41df6949ebd7b8$var$PaletteShiftPostProcessor {
    initialize(gl) {
        this._shader = new (0, $3MXpL.ScreenShader)(gl, (0, (/*@__PURE__*/$parcel$interopDefault($9qOxG))));
    }
    getLayout() {
        return this._shader.getLayout();
    }
    getShader() {
        return this._shader.getShader();
    }
}
var $0a41df6949ebd7b8$export$2e2bcd8739ae039 = $0a41df6949ebd7b8$var$PaletteShiftPostProcessor;

});
parcelRegister("9qOxG", function(module, exports) {
module.exports = "#version 300 es\nprecision mediump float;\n#define GLSLIFY 1\n\n// our texture\nuniform sampler2D u_image;\n\n// the texCoords passed in from the vertex shader.\nin vec2 v_texcoord;\nout vec4 fragColor;\n\nvec3 rgb2hsv(vec3 c) {\n    vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n\n    float d = q.x - min(q.w, q.y);\n    float e = 1.0e-10;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\n\nvoid main() {\n    // Sample the texture\n    vec4 tex = texture(u_image, v_texcoord);\n\n    fragColor = tex;\n}";

});



parcelRegister("4TRBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $56eaeb2bbc43abee$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $cT3l2 = parcelRequire("cT3l2");
class $56eaeb2bbc43abee$var$ProgressIndicator extends (0, $3MXpL.Actor) {
    constructor(config){
        super(config);
        this.percent = 0;
        this.graphics.add("percent_text", new (0, $3MXpL.Text)({
            text: `${this.percent}`,
            font: (0, $cT3l2.spriteFont)
        }));
        this.graphics.use("percent_text");
        this.z = 1000;
    }
    setPercent(percent) {
        this.percent = Math.min(100, Math.max(0, percent));
        this.graphics.getGraphic("percent_text").text = `${this.percent}`;
    }
    onInitialize() {}
}
var $56eaeb2bbc43abee$export$2e2bcd8739ae039 = $56eaeb2bbc43abee$var$ProgressIndicator;

});



parcelRegister("ao44X", function(module, exports) {

$parcel$export(module.exports, "default", () => $d497e1ab21820b94$export$2e2bcd8739ae039);

var $f3ybE = parcelRequire("f3ybE");

var $8Nzak = parcelRequire("8Nzak");

var $8bz7c = parcelRequire("8bz7c");
class $d497e1ab21820b94$var$Rock extends (0, $f3ybE.default) {
    constructor(isoMap, config, img, resourceType){
        super(isoMap, config, img, resourceType);
        this.get((0, $8Nzak.HarvestableResourceComponent)).harvestableBy = [
            (0, $8bz7c.CharacterRole).MINER
        ];
        this.addTag("rock");
    }
}
var $d497e1ab21820b94$export$2e2bcd8739ae039 = $d497e1ab21820b94$var$Rock;

});
parcelRegister("f3ybE", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb12de2874cc2b72$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $8Nzak = parcelRequire("8Nzak");

var $1U10Z = parcelRequire("1U10Z");

var $aO4pr = parcelRequire("aO4pr");
class $eb12de2874cc2b72$var$Harvestable extends (0, $3MXpL.Actor) {
    constructor(isoMap, config, img, resourceType){
        super(config);
        this.isoMap = isoMap;
        this.addComponent(new (0, $3MXpL.IsometricEntityComponent)(this.isoMap));
        this.addComponent(new (0, $8Nzak.HarvestableResourceComponent)());
        this.addComponent(new (0, $aO4pr.VisibleComponent)());
        // set harvestable resource type
        this.get((0, $8Nzak.HarvestableResourceComponent)).resourceType = resourceType;
        this.graphics.use(img.toSprite());
        this.collider.set((0, $1U10Z.compute_iso_collider)(this.graphics.current));
    }
    onInitialize() {}
}
var $eb12de2874cc2b72$export$2e2bcd8739ae039 = $eb12de2874cc2b72$var$Harvestable;

});


parcelRegister("fux0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eee634efa6a0e50$export$2e2bcd8739ae039);

var $f3ybE = parcelRequire("f3ybE");

var $8Nzak = parcelRequire("8Nzak");

var $8bz7c = parcelRequire("8bz7c");
class $5eee634efa6a0e50$var$Tree extends (0, $f3ybE.default) {
    constructor(isoMap, config, img, resourceType){
        super(isoMap, config, img, resourceType);
        this.get((0, $8Nzak.HarvestableResourceComponent)).harvestableBy = [
            (0, $8bz7c.CharacterRole).WOODCUTTER
        ];
        this.addTag("tree");
    }
    onInitialize() {}
}
var $5eee634efa6a0e50$export$2e2bcd8739ae039 = $5eee634efa6a0e50$var$Tree;

});

parcelRegister("ibe6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74c5cfc8ac4e3bf$export$2e2bcd8739ae039);

var $8bz7c = parcelRequire("8bz7c");

var $7Hvm6 = parcelRequire("7Hvm6");

var $8Nzak = parcelRequire("8Nzak");

var $aO4pr = parcelRequire("aO4pr");
class $b74c5cfc8ac4e3bf$var$Farm extends (0, $7Hvm6.default) {
    constructor(isoMap, pos, img, walkability, cost){
        super(isoMap, pos, img, walkability, cost);
    }
    update(engine, delta) {
        super.update(engine, delta);
    }
    onConstructionDone() {
        super.onConstructionDone();
        // add HarvestableResourceComponent
        this.addComponent(new (0, $aO4pr.VisibleComponent)());
        this.addComponent(new (0, $8Nzak.HarvestableResourceComponent)());
        this.get((0, $8Nzak.HarvestableResourceComponent)).resourceType = "\uD83C\uDF3F";
        this.get((0, $8Nzak.HarvestableResourceComponent)).harvestableBy = [
            (0, $8bz7c.CharacterRole).FARMER
        ];
        // add to scene harvestables array
        this.scene.harvestables.push(this);
    }
}
var $b74c5cfc8ac4e3bf$export$2e2bcd8739ae039 = $b74c5cfc8ac4e3bf$var$Farm;

});

parcelRegister("8wp8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $2220d8e459cd7cab$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");

var $7Hvm6 = parcelRequire("7Hvm6");

var $8bz7c = parcelRequire("8bz7c");

class $2220d8e459cd7cab$var$Church extends (0, $7Hvm6.default) {
    constructor(isoMap, pos, img, walkability, cost){
        super(isoMap, pos, img, walkability, cost);
    }
    update(engine, delta) {
        super.update(engine, delta);
    }
    onConstructionDone() {
        super.onConstructionDone();
        const character = Promise.resolve((parcelRequire("1SJ76"))).then((module)=>{
            // when the church is constructed, spawn a new character
            // spawn humans in random locations
            const human = new module.default(this.isoMap, {
                pos: this.pos.add((0, $3MXpL.vec)(-40, 40))
            });
            human.get((0, $8bz7c.CharacterComponent)).role = (0, $8bz7c.CharacterRole).WOODCUTTER;
            this.scene.add(human);
        });
    }
}
var $2220d8e459cd7cab$export$2e2bcd8739ae039 = $2220d8e459cd7cab$var$Church;

});

parcelRegister("k99GN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0036fe8585b43b25$export$2e2bcd8739ae039);

var $7Hvm6 = parcelRequire("7Hvm6");
class $0036fe8585b43b25$var$Bridge extends (0, $7Hvm6.default) {
    constructor(isoMap, pos, img, walkability, cost){
        super(isoMap, pos, img, walkability, cost);
        // add bridge tag to the building
        this.tags.add("bridge");
    }
    update(engine, delta) {
        super.update(engine, delta);
    }
    onConstructionDone() {
        super.onConstructionDone();
    }
}
var $0036fe8585b43b25$export$2e2bcd8739ae039 = $0036fe8585b43b25$var$Bridge;

});


parcelRegister("hiwwY", function(module, exports) {

$parcel$export(module.exports, "search", () => $954cdbf259ae3a17$export$d76128d007d19019);
var $954cdbf259ae3a17$var$T = Object.defineProperty;
var $954cdbf259ae3a17$var$L = (e, n)=>{
    for(var t in n)$954cdbf259ae3a17$var$T(e, t, {
        get: n[t],
        enumerable: !0
    });
};
var $954cdbf259ae3a17$var$b = {};
$954cdbf259ae3a17$var$L($954cdbf259ae3a17$var$b, {
    diagonal: ()=>$954cdbf259ae3a17$var$D,
    manhattan: ()=>$954cdbf259ae3a17$var$B
});
var $954cdbf259ae3a17$var$B = (e, n)=>Math.abs(n[0] - e[0]) + Math.abs(n[1] - e[1]);
var $954cdbf259ae3a17$var$D = (e, n)=>{
    let t = Math.abs(n[0] - e[0]), o = Math.abs(n[1] - e[1]), g = Math.sqrt(2), f = 1;
    return f * (t + o) + (g - 2 * f) * Math.min(t, o);
};
function $954cdbf259ae3a17$export$d76128d007d19019(e) {
    let n = e.heuristic ?? "diagonal", t = e.cutCorners ?? !0, o = e.stepHeight ?? 1, g = e.diagonal ?? !1, f = [
        $954cdbf259ae3a17$export$9c486400755a1c55(e.from)
    ], w = $954cdbf259ae3a17$export$9c486400755a1c55(e.to), O = null, s = [];
    if (Array.isArray(e.grid)) {
        if (!e.grid.length || !Array.isArray(e.grid[0])) throw new Error("2 dimensional grid array required");
    } else throw new Error("non-array grid provided");
    let C = e.grid[0].length, H = e.grid.length, m = {};
    function h(r) {
        let a = $954cdbf259ae3a17$export$9c486400755a1c55(r);
        if (m[a]) return m[a];
        let i = e.grid[r[1]][r[0]], u;
        return typeof i == "number" ? u = {
            elevation: Math.max(0, i),
            isLegal: i !== -1
        } : u = {
            ...i,
            isLegal: i.isLegal ?? i.elevation !== -1
        }, m[a] = u, u;
    }
    function M([r, a], i) {
        return !x(r, i) && f.indexOf($954cdbf259ae3a17$export$9c486400755a1c55(r)) === -1 && (a === null || t || !x(a[0], i, 0) && !x(a[1], i, 0));
    }
    function x(r, a, i = o) {
        return r[0] < 0 || r[1] < 0 || r[0] >= C || r[1] >= H || !h(r).isLegal && (h(r).validAsDestination !== !0 || r[0] !== e.to[0] || r[1] !== e.to[1]) || !(a[0] === e.from[0] && a[1] === e.from[1] && !h(e.from).isLegal && !h(e.from).validAsDestination) && (h(r).elevation - h(a).elevation > i || h(r).elevation - h(a).elevation < -i);
    }
    function S(r) {
        let { tiles: a, total: i } = $954cdbf259ae3a17$export$f7ddecbb2cbec32c(r[0], g);
        for(let u = 0; u < i; u++){
            let c = a[u], A = $954cdbf259ae3a17$export$9c486400755a1c55(c[0]);
            if (M(c, r[0])) {
                let d = s.find((V)=>$954cdbf259ae3a17$export$9c486400755a1c55(V[0]) === A), y = $954cdbf259ae3a17$export$e55b6242cf16bbb8({
                    current: c[0],
                    parent: r,
                    goal: e.to,
                    heuristic: n
                });
                if (d && y.f < d[1].f) {
                    let V = $954cdbf259ae3a17$export$9c486400755a1c55(d[0]);
                    s = s.map((p)=>($954cdbf259ae3a17$export$9c486400755a1c55(p[0]) === V && (p[1] = y, p[2] = r), p));
                } else d || s.push([
                    c[0],
                    y,
                    r
                ]);
            }
        }
        s = s.sort((u, c)=>$954cdbf259ae3a17$export$debe6e778e0a6d32(u[1].f, c[1].f));
    }
    for(S([
        e.from,
        {
            g: 0,
            h: 0,
            f: 0
        },
        null
    ]); s.length > 0;){
        let r = s.shift();
        if (r) {
            let [a] = r, i = $954cdbf259ae3a17$export$9c486400755a1c55(a);
            if (f.push(i), i === w) {
                O = $954cdbf259ae3a17$export$91379b4aacd40c11(r), s = [];
                continue;
            }
            S(r);
        }
    }
    return O;
}
function $954cdbf259ae3a17$export$91379b4aacd40c11(e) {
    let n = e, t = [];
    for(; n !== null;)t.push(n[0]), n = n[2];
    return t.reverse(), t;
}
function $954cdbf259ae3a17$export$f7ddecbb2cbec32c(e, n = !1) {
    let t = [];
    return t.push([
        [
            e[0] - 1,
            e[1]
        ],
        null
    ]), t.push([
        [
            e[0] + 1,
            e[1]
        ],
        null
    ]), t.push([
        [
            e[0],
            e[1] - 1
        ],
        null
    ]), t.push([
        [
            e[0],
            e[1] + 1
        ],
        null
    ]), n && (t.push([
        [
            e[0] - 1,
            e[1] - 1
        ],
        [
            [
                e[0],
                e[1] - 1
            ],
            [
                e[0] - 1,
                e[1]
            ]
        ]
    ]), t.push([
        [
            e[0] + 1,
            e[1] + 1
        ],
        [
            [
                e[0],
                e[1] + 1
            ],
            [
                e[0] + 1,
                e[1]
            ]
        ]
    ]), t.push([
        [
            e[0] + 1,
            e[1] - 1
        ],
        [
            [
                e[0],
                e[1] - 1
            ],
            [
                e[0] + 1,
                e[1]
            ]
        ]
    ]), t.push([
        [
            e[0] - 1,
            e[1] + 1
        ],
        [
            [
                e[0],
                e[1] + 1
            ],
            [
                e[0] - 1,
                e[1]
            ]
        ]
    ])), {
        tiles: t,
        total: t.length
    };
}
function $954cdbf259ae3a17$export$e55b6242cf16bbb8(e) {
    let n = e.parent[1].g + 1, t = $954cdbf259ae3a17$var$b[e.heuristic](e.current, e.goal);
    return {
        g: n,
        h: t,
        f: n + t
    };
}
function $954cdbf259ae3a17$export$9c486400755a1c55(e) {
    return `${e[0]},${e[1]}`;
}
function $954cdbf259ae3a17$export$debe6e778e0a6d32(e, n) {
    return e > n ? 1 : e < n ? -1 : 0;
}

});

parcelRegister("5XQB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb95b0f2784522e8$export$2e2bcd8739ae039);

var $3MXpL = parcelRequire("3MXpL");
class $fb95b0f2784522e8$var$NameTag extends (0, $3MXpL.Actor) {
    constructor(config, text){
        super(config);
        this.text = "";
        this.text = text;
        this.graphics.add("name_text", new (0, $3MXpL.Text)({
            text: `${this.text}`,
            font: new (0, $3MXpL.Font)({
                size: 16,
                family: "alagard",
                color: (0, $3MXpL.Color).White
            }),
            scale: (0, $3MXpL.vec)(0.8, 0.8)
        }));
        this.graphics.use("name_text");
        this.z = 1000;
    }
    onInitialize() {}
}
var $fb95b0f2784522e8$export$2e2bcd8739ae039 = $fb95b0f2784522e8$var$NameTag;

});



parcelRequire("64gHy");

//# sourceMappingURL=index.8f5ae296.js.map
